// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/materialdesignicons-webfont.eot?v=5.8.55", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/materialdesignicons-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/materialdesignicons-webfont.woff2?v=5.8.55", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/materialdesignicons-webfont.woff?v=5.8.55", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/materialdesignicons-webfont.ttf?v=5.8.55", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/boxicons.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/boxicons.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/boxicons.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/boxicons.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/boxicons.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/fa-brands-400.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/fa-brands-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/fa-brands-400.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/fa-brands-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../fonts/fa-brands-400.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../fonts/fa-regular-400.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../fonts/fa-regular-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../fonts/fa-regular-400.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../fonts/fa-regular-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../fonts/fa-regular-400.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../fonts/fa-solid-900.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../fonts/fa-solid-900.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../fonts/fa-solid-900.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../fonts/fa-solid-900.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../fonts/fa-solid-900.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../fonts/dripicons-v2.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../fonts/dripicons-v2.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../fonts/dripicons-v2.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../fonts/dripicons-v2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23f6f6f6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgb%28210.9, 216.3, 221.7%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%2334c38f%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23f46a6a%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23f46a6a%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23495057%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgb%2881.9, 103.5, 208.8%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgb%28156.6, 171, 241.2%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@300;400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___, { hash: "?#iefix&v=5.8.55" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___, { hash: "?#boxicons" });
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___, { hash: "#fontawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___, { hash: "#fontawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___, { hash: "#fontawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___, { hash: "#dripicons-v2" });
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*
Template Name: Minible - Admin & Dashboard Template
Author: Themesbrand
Version: 2.1.0
Website: https://themesbrand.com/
Contact: themesbrand@gmail.com
File: Icons Css File
*/
/* MaterialDesignIcons.com */
@font-face {
  font-family: "Material Design Icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
.mdi:before,
.mdi-set {
  display: inline-block;
  font: normal normal normal 24px/1 "Material Design Icons";
  font-size: inherit;
  text-rendering: auto;
  line-height: inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.mdi-ab-testing::before {
  content: "\\f01c9";
}

.mdi-abjad-arabic::before {
  content: "\\f1328";
}

.mdi-abjad-hebrew::before {
  content: "\\f1329";
}

.mdi-abugida-devanagari::before {
  content: "\\f132a";
}

.mdi-abugida-thai::before {
  content: "\\f132b";
}

.mdi-access-point::before {
  content: "\\f0003";
}

.mdi-access-point-check::before {
  content: "\\f1538";
}

.mdi-access-point-minus::before {
  content: "\\f1539";
}

.mdi-access-point-network::before {
  content: "\\f0002";
}

.mdi-access-point-network-off::before {
  content: "\\f0be1";
}

.mdi-access-point-off::before {
  content: "\\f1511";
}

.mdi-access-point-plus::before {
  content: "\\f153a";
}

.mdi-access-point-remove::before {
  content: "\\f153b";
}

.mdi-account::before {
  content: "\\f0004";
}

.mdi-account-alert::before {
  content: "\\f0005";
}

.mdi-account-alert-outline::before {
  content: "\\f0b50";
}

.mdi-account-arrow-left::before {
  content: "\\f0b51";
}

.mdi-account-arrow-left-outline::before {
  content: "\\f0b52";
}

.mdi-account-arrow-right::before {
  content: "\\f0b53";
}

.mdi-account-arrow-right-outline::before {
  content: "\\f0b54";
}

.mdi-account-box::before {
  content: "\\f0006";
}

.mdi-account-box-multiple::before {
  content: "\\f0934";
}

.mdi-account-box-multiple-outline::before {
  content: "\\f100a";
}

.mdi-account-box-outline::before {
  content: "\\f0007";
}

.mdi-account-cancel::before {
  content: "\\f12df";
}

.mdi-account-cancel-outline::before {
  content: "\\f12e0";
}

.mdi-account-cash::before {
  content: "\\f1097";
}

.mdi-account-cash-outline::before {
  content: "\\f1098";
}

.mdi-account-check::before {
  content: "\\f0008";
}

.mdi-account-check-outline::before {
  content: "\\f0be2";
}

.mdi-account-child::before {
  content: "\\f0a89";
}

.mdi-account-child-circle::before {
  content: "\\f0a8a";
}

.mdi-account-child-outline::before {
  content: "\\f10c8";
}

.mdi-account-circle::before {
  content: "\\f0009";
}

.mdi-account-circle-outline::before {
  content: "\\f0b55";
}

.mdi-account-clock::before {
  content: "\\f0b56";
}

.mdi-account-clock-outline::before {
  content: "\\f0b57";
}

.mdi-account-cog::before {
  content: "\\f1370";
}

.mdi-account-cog-outline::before {
  content: "\\f1371";
}

.mdi-account-convert::before {
  content: "\\f000a";
}

.mdi-account-convert-outline::before {
  content: "\\f1301";
}

.mdi-account-cowboy-hat::before {
  content: "\\f0e9b";
}

.mdi-account-details::before {
  content: "\\f0631";
}

.mdi-account-details-outline::before {
  content: "\\f1372";
}

.mdi-account-edit::before {
  content: "\\f06bc";
}

.mdi-account-edit-outline::before {
  content: "\\f0ffb";
}

.mdi-account-group::before {
  content: "\\f0849";
}

.mdi-account-group-outline::before {
  content: "\\f0b58";
}

.mdi-account-hard-hat::before {
  content: "\\f05b5";
}

.mdi-account-heart::before {
  content: "\\f0899";
}

.mdi-account-heart-outline::before {
  content: "\\f0be3";
}

.mdi-account-key::before {
  content: "\\f000b";
}

.mdi-account-key-outline::before {
  content: "\\f0be4";
}

.mdi-account-lock::before {
  content: "\\f115e";
}

.mdi-account-lock-outline::before {
  content: "\\f115f";
}

.mdi-account-minus::before {
  content: "\\f000d";
}

.mdi-account-minus-outline::before {
  content: "\\f0aec";
}

.mdi-account-multiple::before {
  content: "\\f000e";
}

.mdi-account-multiple-check::before {
  content: "\\f08c5";
}

.mdi-account-multiple-check-outline::before {
  content: "\\f11fe";
}

.mdi-account-multiple-minus::before {
  content: "\\f05d3";
}

.mdi-account-multiple-minus-outline::before {
  content: "\\f0be5";
}

.mdi-account-multiple-outline::before {
  content: "\\f000f";
}

.mdi-account-multiple-plus::before {
  content: "\\f0010";
}

.mdi-account-multiple-plus-outline::before {
  content: "\\f0800";
}

.mdi-account-multiple-remove::before {
  content: "\\f120a";
}

.mdi-account-multiple-remove-outline::before {
  content: "\\f120b";
}

.mdi-account-music::before {
  content: "\\f0803";
}

.mdi-account-music-outline::before {
  content: "\\f0ce9";
}

.mdi-account-network::before {
  content: "\\f0011";
}

.mdi-account-network-outline::before {
  content: "\\f0be6";
}

.mdi-account-off::before {
  content: "\\f0012";
}

.mdi-account-off-outline::before {
  content: "\\f0be7";
}

.mdi-account-outline::before {
  content: "\\f0013";
}

.mdi-account-plus::before {
  content: "\\f0014";
}

.mdi-account-plus-outline::before {
  content: "\\f0801";
}

.mdi-account-question::before {
  content: "\\f0b59";
}

.mdi-account-question-outline::before {
  content: "\\f0b5a";
}

.mdi-account-reactivate::before {
  content: "\\f152b";
}

.mdi-account-reactivate-outline::before {
  content: "\\f152c";
}

.mdi-account-remove::before {
  content: "\\f0015";
}

.mdi-account-remove-outline::before {
  content: "\\f0aed";
}

.mdi-account-search::before {
  content: "\\f0016";
}

.mdi-account-search-outline::before {
  content: "\\f0935";
}

.mdi-account-settings::before {
  content: "\\f0630";
}

.mdi-account-settings-outline::before {
  content: "\\f10c9";
}

.mdi-account-star::before {
  content: "\\f0017";
}

.mdi-account-star-outline::before {
  content: "\\f0be8";
}

.mdi-account-supervisor::before {
  content: "\\f0a8b";
}

.mdi-account-supervisor-circle::before {
  content: "\\f0a8c";
}

.mdi-account-supervisor-circle-outline::before {
  content: "\\f14ec";
}

.mdi-account-supervisor-outline::before {
  content: "\\f112d";
}

.mdi-account-switch::before {
  content: "\\f0019";
}

.mdi-account-switch-outline::before {
  content: "\\f04cb";
}

.mdi-account-tie::before {
  content: "\\f0ce3";
}

.mdi-account-tie-outline::before {
  content: "\\f10ca";
}

.mdi-account-tie-voice::before {
  content: "\\f1308";
}

.mdi-account-tie-voice-off::before {
  content: "\\f130a";
}

.mdi-account-tie-voice-off-outline::before {
  content: "\\f130b";
}

.mdi-account-tie-voice-outline::before {
  content: "\\f1309";
}

.mdi-account-voice::before {
  content: "\\f05cb";
}

.mdi-adjust::before {
  content: "\\f001a";
}

.mdi-adobe::before {
  content: "\\f0936";
}

.mdi-adobe-acrobat::before {
  content: "\\f0f9d";
}

.mdi-air-conditioner::before {
  content: "\\f001b";
}

.mdi-air-filter::before {
  content: "\\f0d43";
}

.mdi-air-horn::before {
  content: "\\f0dac";
}

.mdi-air-humidifier::before {
  content: "\\f1099";
}

.mdi-air-humidifier-off::before {
  content: "\\f1466";
}

.mdi-air-purifier::before {
  content: "\\f0d44";
}

.mdi-airbag::before {
  content: "\\f0be9";
}

.mdi-airballoon::before {
  content: "\\f001c";
}

.mdi-airballoon-outline::before {
  content: "\\f100b";
}

.mdi-airplane::before {
  content: "\\f001d";
}

.mdi-airplane-landing::before {
  content: "\\f05d4";
}

.mdi-airplane-off::before {
  content: "\\f001e";
}

.mdi-airplane-takeoff::before {
  content: "\\f05d5";
}

.mdi-airport::before {
  content: "\\f084b";
}

.mdi-alarm::before {
  content: "\\f0020";
}

.mdi-alarm-bell::before {
  content: "\\f078e";
}

.mdi-alarm-check::before {
  content: "\\f0021";
}

.mdi-alarm-light::before {
  content: "\\f078f";
}

.mdi-alarm-light-outline::before {
  content: "\\f0bea";
}

.mdi-alarm-multiple::before {
  content: "\\f0022";
}

.mdi-alarm-note::before {
  content: "\\f0e71";
}

.mdi-alarm-note-off::before {
  content: "\\f0e72";
}

.mdi-alarm-off::before {
  content: "\\f0023";
}

.mdi-alarm-panel::before {
  content: "\\f15c4";
}

.mdi-alarm-panel-outline::before {
  content: "\\f15c5";
}

.mdi-alarm-plus::before {
  content: "\\f0024";
}

.mdi-alarm-snooze::before {
  content: "\\f068e";
}

.mdi-album::before {
  content: "\\f0025";
}

.mdi-alert::before {
  content: "\\f0026";
}

.mdi-alert-box::before {
  content: "\\f0027";
}

.mdi-alert-box-outline::before {
  content: "\\f0ce4";
}

.mdi-alert-circle::before {
  content: "\\f0028";
}

.mdi-alert-circle-check::before {
  content: "\\f11ed";
}

.mdi-alert-circle-check-outline::before {
  content: "\\f11ee";
}

.mdi-alert-circle-outline::before {
  content: "\\f05d6";
}

.mdi-alert-decagram::before {
  content: "\\f06bd";
}

.mdi-alert-decagram-outline::before {
  content: "\\f0ce5";
}

.mdi-alert-minus::before {
  content: "\\f14bb";
}

.mdi-alert-minus-outline::before {
  content: "\\f14be";
}

.mdi-alert-octagon::before {
  content: "\\f0029";
}

.mdi-alert-octagon-outline::before {
  content: "\\f0ce6";
}

.mdi-alert-octagram::before {
  content: "\\f0767";
}

.mdi-alert-octagram-outline::before {
  content: "\\f0ce7";
}

.mdi-alert-outline::before {
  content: "\\f002a";
}

.mdi-alert-plus::before {
  content: "\\f14ba";
}

.mdi-alert-plus-outline::before {
  content: "\\f14bd";
}

.mdi-alert-remove::before {
  content: "\\f14bc";
}

.mdi-alert-remove-outline::before {
  content: "\\f14bf";
}

.mdi-alert-rhombus::before {
  content: "\\f11ce";
}

.mdi-alert-rhombus-outline::before {
  content: "\\f11cf";
}

.mdi-alien::before {
  content: "\\f089a";
}

.mdi-alien-outline::before {
  content: "\\f10cb";
}

.mdi-align-horizontal-center::before {
  content: "\\f11c3";
}

.mdi-align-horizontal-left::before {
  content: "\\f11c2";
}

.mdi-align-horizontal-right::before {
  content: "\\f11c4";
}

.mdi-align-vertical-bottom::before {
  content: "\\f11c5";
}

.mdi-align-vertical-center::before {
  content: "\\f11c6";
}

.mdi-align-vertical-top::before {
  content: "\\f11c7";
}

.mdi-all-inclusive::before {
  content: "\\f06be";
}

.mdi-allergy::before {
  content: "\\f1258";
}

.mdi-alpha::before {
  content: "\\f002b";
}

.mdi-alpha-a::before {
  content: "\\f0aee";
}

.mdi-alpha-a-box::before {
  content: "\\f0b08";
}

.mdi-alpha-a-box-outline::before {
  content: "\\f0beb";
}

.mdi-alpha-a-circle::before {
  content: "\\f0bec";
}

.mdi-alpha-a-circle-outline::before {
  content: "\\f0bed";
}

.mdi-alpha-b::before {
  content: "\\f0aef";
}

.mdi-alpha-b-box::before {
  content: "\\f0b09";
}

.mdi-alpha-b-box-outline::before {
  content: "\\f0bee";
}

.mdi-alpha-b-circle::before {
  content: "\\f0bef";
}

.mdi-alpha-b-circle-outline::before {
  content: "\\f0bf0";
}

.mdi-alpha-c::before {
  content: "\\f0af0";
}

.mdi-alpha-c-box::before {
  content: "\\f0b0a";
}

.mdi-alpha-c-box-outline::before {
  content: "\\f0bf1";
}

.mdi-alpha-c-circle::before {
  content: "\\f0bf2";
}

.mdi-alpha-c-circle-outline::before {
  content: "\\f0bf3";
}

.mdi-alpha-d::before {
  content: "\\f0af1";
}

.mdi-alpha-d-box::before {
  content: "\\f0b0b";
}

.mdi-alpha-d-box-outline::before {
  content: "\\f0bf4";
}

.mdi-alpha-d-circle::before {
  content: "\\f0bf5";
}

.mdi-alpha-d-circle-outline::before {
  content: "\\f0bf6";
}

.mdi-alpha-e::before {
  content: "\\f0af2";
}

.mdi-alpha-e-box::before {
  content: "\\f0b0c";
}

.mdi-alpha-e-box-outline::before {
  content: "\\f0bf7";
}

.mdi-alpha-e-circle::before {
  content: "\\f0bf8";
}

.mdi-alpha-e-circle-outline::before {
  content: "\\f0bf9";
}

.mdi-alpha-f::before {
  content: "\\f0af3";
}

.mdi-alpha-f-box::before {
  content: "\\f0b0d";
}

.mdi-alpha-f-box-outline::before {
  content: "\\f0bfa";
}

.mdi-alpha-f-circle::before {
  content: "\\f0bfb";
}

.mdi-alpha-f-circle-outline::before {
  content: "\\f0bfc";
}

.mdi-alpha-g::before {
  content: "\\f0af4";
}

.mdi-alpha-g-box::before {
  content: "\\f0b0e";
}

.mdi-alpha-g-box-outline::before {
  content: "\\f0bfd";
}

.mdi-alpha-g-circle::before {
  content: "\\f0bfe";
}

.mdi-alpha-g-circle-outline::before {
  content: "\\f0bff";
}

.mdi-alpha-h::before {
  content: "\\f0af5";
}

.mdi-alpha-h-box::before {
  content: "\\f0b0f";
}

.mdi-alpha-h-box-outline::before {
  content: "\\f0c00";
}

.mdi-alpha-h-circle::before {
  content: "\\f0c01";
}

.mdi-alpha-h-circle-outline::before {
  content: "\\f0c02";
}

.mdi-alpha-i::before {
  content: "\\f0af6";
}

.mdi-alpha-i-box::before {
  content: "\\f0b10";
}

.mdi-alpha-i-box-outline::before {
  content: "\\f0c03";
}

.mdi-alpha-i-circle::before {
  content: "\\f0c04";
}

.mdi-alpha-i-circle-outline::before {
  content: "\\f0c05";
}

.mdi-alpha-j::before {
  content: "\\f0af7";
}

.mdi-alpha-j-box::before {
  content: "\\f0b11";
}

.mdi-alpha-j-box-outline::before {
  content: "\\f0c06";
}

.mdi-alpha-j-circle::before {
  content: "\\f0c07";
}

.mdi-alpha-j-circle-outline::before {
  content: "\\f0c08";
}

.mdi-alpha-k::before {
  content: "\\f0af8";
}

.mdi-alpha-k-box::before {
  content: "\\f0b12";
}

.mdi-alpha-k-box-outline::before {
  content: "\\f0c09";
}

.mdi-alpha-k-circle::before {
  content: "\\f0c0a";
}

.mdi-alpha-k-circle-outline::before {
  content: "\\f0c0b";
}

.mdi-alpha-l::before {
  content: "\\f0af9";
}

.mdi-alpha-l-box::before {
  content: "\\f0b13";
}

.mdi-alpha-l-box-outline::before {
  content: "\\f0c0c";
}

.mdi-alpha-l-circle::before {
  content: "\\f0c0d";
}

.mdi-alpha-l-circle-outline::before {
  content: "\\f0c0e";
}

.mdi-alpha-m::before {
  content: "\\f0afa";
}

.mdi-alpha-m-box::before {
  content: "\\f0b14";
}

.mdi-alpha-m-box-outline::before {
  content: "\\f0c0f";
}

.mdi-alpha-m-circle::before {
  content: "\\f0c10";
}

.mdi-alpha-m-circle-outline::before {
  content: "\\f0c11";
}

.mdi-alpha-n::before {
  content: "\\f0afb";
}

.mdi-alpha-n-box::before {
  content: "\\f0b15";
}

.mdi-alpha-n-box-outline::before {
  content: "\\f0c12";
}

.mdi-alpha-n-circle::before {
  content: "\\f0c13";
}

.mdi-alpha-n-circle-outline::before {
  content: "\\f0c14";
}

.mdi-alpha-o::before {
  content: "\\f0afc";
}

.mdi-alpha-o-box::before {
  content: "\\f0b16";
}

.mdi-alpha-o-box-outline::before {
  content: "\\f0c15";
}

.mdi-alpha-o-circle::before {
  content: "\\f0c16";
}

.mdi-alpha-o-circle-outline::before {
  content: "\\f0c17";
}

.mdi-alpha-p::before {
  content: "\\f0afd";
}

.mdi-alpha-p-box::before {
  content: "\\f0b17";
}

.mdi-alpha-p-box-outline::before {
  content: "\\f0c18";
}

.mdi-alpha-p-circle::before {
  content: "\\f0c19";
}

.mdi-alpha-p-circle-outline::before {
  content: "\\f0c1a";
}

.mdi-alpha-q::before {
  content: "\\f0afe";
}

.mdi-alpha-q-box::before {
  content: "\\f0b18";
}

.mdi-alpha-q-box-outline::before {
  content: "\\f0c1b";
}

.mdi-alpha-q-circle::before {
  content: "\\f0c1c";
}

.mdi-alpha-q-circle-outline::before {
  content: "\\f0c1d";
}

.mdi-alpha-r::before {
  content: "\\f0aff";
}

.mdi-alpha-r-box::before {
  content: "\\f0b19";
}

.mdi-alpha-r-box-outline::before {
  content: "\\f0c1e";
}

.mdi-alpha-r-circle::before {
  content: "\\f0c1f";
}

.mdi-alpha-r-circle-outline::before {
  content: "\\f0c20";
}

.mdi-alpha-s::before {
  content: "\\f0b00";
}

.mdi-alpha-s-box::before {
  content: "\\f0b1a";
}

.mdi-alpha-s-box-outline::before {
  content: "\\f0c21";
}

.mdi-alpha-s-circle::before {
  content: "\\f0c22";
}

.mdi-alpha-s-circle-outline::before {
  content: "\\f0c23";
}

.mdi-alpha-t::before {
  content: "\\f0b01";
}

.mdi-alpha-t-box::before {
  content: "\\f0b1b";
}

.mdi-alpha-t-box-outline::before {
  content: "\\f0c24";
}

.mdi-alpha-t-circle::before {
  content: "\\f0c25";
}

.mdi-alpha-t-circle-outline::before {
  content: "\\f0c26";
}

.mdi-alpha-u::before {
  content: "\\f0b02";
}

.mdi-alpha-u-box::before {
  content: "\\f0b1c";
}

.mdi-alpha-u-box-outline::before {
  content: "\\f0c27";
}

.mdi-alpha-u-circle::before {
  content: "\\f0c28";
}

.mdi-alpha-u-circle-outline::before {
  content: "\\f0c29";
}

.mdi-alpha-v::before {
  content: "\\f0b03";
}

.mdi-alpha-v-box::before {
  content: "\\f0b1d";
}

.mdi-alpha-v-box-outline::before {
  content: "\\f0c2a";
}

.mdi-alpha-v-circle::before {
  content: "\\f0c2b";
}

.mdi-alpha-v-circle-outline::before {
  content: "\\f0c2c";
}

.mdi-alpha-w::before {
  content: "\\f0b04";
}

.mdi-alpha-w-box::before {
  content: "\\f0b1e";
}

.mdi-alpha-w-box-outline::before {
  content: "\\f0c2d";
}

.mdi-alpha-w-circle::before {
  content: "\\f0c2e";
}

.mdi-alpha-w-circle-outline::before {
  content: "\\f0c2f";
}

.mdi-alpha-x::before {
  content: "\\f0b05";
}

.mdi-alpha-x-box::before {
  content: "\\f0b1f";
}

.mdi-alpha-x-box-outline::before {
  content: "\\f0c30";
}

.mdi-alpha-x-circle::before {
  content: "\\f0c31";
}

.mdi-alpha-x-circle-outline::before {
  content: "\\f0c32";
}

.mdi-alpha-y::before {
  content: "\\f0b06";
}

.mdi-alpha-y-box::before {
  content: "\\f0b20";
}

.mdi-alpha-y-box-outline::before {
  content: "\\f0c33";
}

.mdi-alpha-y-circle::before {
  content: "\\f0c34";
}

.mdi-alpha-y-circle-outline::before {
  content: "\\f0c35";
}

.mdi-alpha-z::before {
  content: "\\f0b07";
}

.mdi-alpha-z-box::before {
  content: "\\f0b21";
}

.mdi-alpha-z-box-outline::before {
  content: "\\f0c36";
}

.mdi-alpha-z-circle::before {
  content: "\\f0c37";
}

.mdi-alpha-z-circle-outline::before {
  content: "\\f0c38";
}

.mdi-alphabet-aurebesh::before {
  content: "\\f132c";
}

.mdi-alphabet-cyrillic::before {
  content: "\\f132d";
}

.mdi-alphabet-greek::before {
  content: "\\f132e";
}

.mdi-alphabet-latin::before {
  content: "\\f132f";
}

.mdi-alphabet-piqad::before {
  content: "\\f1330";
}

.mdi-alphabet-tengwar::before {
  content: "\\f1337";
}

.mdi-alphabetical::before {
  content: "\\f002c";
}

.mdi-alphabetical-off::before {
  content: "\\f100c";
}

.mdi-alphabetical-variant::before {
  content: "\\f100d";
}

.mdi-alphabetical-variant-off::before {
  content: "\\f100e";
}

.mdi-altimeter::before {
  content: "\\f05d7";
}

.mdi-amazon::before {
  content: "\\f002d";
}

.mdi-amazon-alexa::before {
  content: "\\f08c6";
}

.mdi-ambulance::before {
  content: "\\f002f";
}

.mdi-ammunition::before {
  content: "\\f0ce8";
}

.mdi-ampersand::before {
  content: "\\f0a8d";
}

.mdi-amplifier::before {
  content: "\\f0030";
}

.mdi-amplifier-off::before {
  content: "\\f11b5";
}

.mdi-anchor::before {
  content: "\\f0031";
}

.mdi-android::before {
  content: "\\f0032";
}

.mdi-android-auto::before {
  content: "\\f0a8e";
}

.mdi-android-debug-bridge::before {
  content: "\\f0033";
}

.mdi-android-messages::before {
  content: "\\f0d45";
}

.mdi-android-studio::before {
  content: "\\f0034";
}

.mdi-angle-acute::before {
  content: "\\f0937";
}

.mdi-angle-obtuse::before {
  content: "\\f0938";
}

.mdi-angle-right::before {
  content: "\\f0939";
}

.mdi-angular::before {
  content: "\\f06b2";
}

.mdi-angularjs::before {
  content: "\\f06bf";
}

.mdi-animation::before {
  content: "\\f05d8";
}

.mdi-animation-outline::before {
  content: "\\f0a8f";
}

.mdi-animation-play::before {
  content: "\\f093a";
}

.mdi-animation-play-outline::before {
  content: "\\f0a90";
}

.mdi-ansible::before {
  content: "\\f109a";
}

.mdi-antenna::before {
  content: "\\f1119";
}

.mdi-anvil::before {
  content: "\\f089b";
}

.mdi-apache-kafka::before {
  content: "\\f100f";
}

.mdi-api::before {
  content: "\\f109b";
}

.mdi-api-off::before {
  content: "\\f1257";
}

.mdi-apple::before {
  content: "\\f0035";
}

.mdi-apple-airplay::before {
  content: "\\f001f";
}

.mdi-apple-finder::before {
  content: "\\f0036";
}

.mdi-apple-icloud::before {
  content: "\\f0038";
}

.mdi-apple-ios::before {
  content: "\\f0037";
}

.mdi-apple-keyboard-caps::before {
  content: "\\f0632";
}

.mdi-apple-keyboard-command::before {
  content: "\\f0633";
}

.mdi-apple-keyboard-control::before {
  content: "\\f0634";
}

.mdi-apple-keyboard-option::before {
  content: "\\f0635";
}

.mdi-apple-keyboard-shift::before {
  content: "\\f0636";
}

.mdi-apple-safari::before {
  content: "\\f0039";
}

.mdi-application::before {
  content: "\\f0614";
}

.mdi-application-cog::before {
  content: "\\f1577";
}

.mdi-application-export::before {
  content: "\\f0dad";
}

.mdi-application-import::before {
  content: "\\f0dae";
}

.mdi-application-settings::before {
  content: "\\f1555";
}

.mdi-approximately-equal::before {
  content: "\\f0f9e";
}

.mdi-approximately-equal-box::before {
  content: "\\f0f9f";
}

.mdi-apps::before {
  content: "\\f003b";
}

.mdi-apps-box::before {
  content: "\\f0d46";
}

.mdi-arch::before {
  content: "\\f08c7";
}

.mdi-archive::before {
  content: "\\f003c";
}

.mdi-archive-alert::before {
  content: "\\f14fd";
}

.mdi-archive-alert-outline::before {
  content: "\\f14fe";
}

.mdi-archive-arrow-down::before {
  content: "\\f1259";
}

.mdi-archive-arrow-down-outline::before {
  content: "\\f125a";
}

.mdi-archive-arrow-up::before {
  content: "\\f125b";
}

.mdi-archive-arrow-up-outline::before {
  content: "\\f125c";
}

.mdi-archive-outline::before {
  content: "\\f120e";
}

.mdi-arm-flex::before {
  content: "\\f0fd7";
}

.mdi-arm-flex-outline::before {
  content: "\\f0fd6";
}

.mdi-arrange-bring-forward::before {
  content: "\\f003d";
}

.mdi-arrange-bring-to-front::before {
  content: "\\f003e";
}

.mdi-arrange-send-backward::before {
  content: "\\f003f";
}

.mdi-arrange-send-to-back::before {
  content: "\\f0040";
}

.mdi-arrow-all::before {
  content: "\\f0041";
}

.mdi-arrow-bottom-left::before {
  content: "\\f0042";
}

.mdi-arrow-bottom-left-bold-outline::before {
  content: "\\f09b7";
}

.mdi-arrow-bottom-left-thick::before {
  content: "\\f09b8";
}

.mdi-arrow-bottom-left-thin-circle-outline::before {
  content: "\\f1596";
}

.mdi-arrow-bottom-right::before {
  content: "\\f0043";
}

.mdi-arrow-bottom-right-bold-outline::before {
  content: "\\f09b9";
}

.mdi-arrow-bottom-right-thick::before {
  content: "\\f09ba";
}

.mdi-arrow-bottom-right-thin-circle-outline::before {
  content: "\\f1595";
}

.mdi-arrow-collapse::before {
  content: "\\f0615";
}

.mdi-arrow-collapse-all::before {
  content: "\\f0044";
}

.mdi-arrow-collapse-down::before {
  content: "\\f0792";
}

.mdi-arrow-collapse-horizontal::before {
  content: "\\f084c";
}

.mdi-arrow-collapse-left::before {
  content: "\\f0793";
}

.mdi-arrow-collapse-right::before {
  content: "\\f0794";
}

.mdi-arrow-collapse-up::before {
  content: "\\f0795";
}

.mdi-arrow-collapse-vertical::before {
  content: "\\f084d";
}

.mdi-arrow-decision::before {
  content: "\\f09bb";
}

.mdi-arrow-decision-auto::before {
  content: "\\f09bc";
}

.mdi-arrow-decision-auto-outline::before {
  content: "\\f09bd";
}

.mdi-arrow-decision-outline::before {
  content: "\\f09be";
}

.mdi-arrow-down::before {
  content: "\\f0045";
}

.mdi-arrow-down-bold::before {
  content: "\\f072e";
}

.mdi-arrow-down-bold-box::before {
  content: "\\f072f";
}

.mdi-arrow-down-bold-box-outline::before {
  content: "\\f0730";
}

.mdi-arrow-down-bold-circle::before {
  content: "\\f0047";
}

.mdi-arrow-down-bold-circle-outline::before {
  content: "\\f0048";
}

.mdi-arrow-down-bold-hexagon-outline::before {
  content: "\\f0049";
}

.mdi-arrow-down-bold-outline::before {
  content: "\\f09bf";
}

.mdi-arrow-down-box::before {
  content: "\\f06c0";
}

.mdi-arrow-down-circle::before {
  content: "\\f0cdb";
}

.mdi-arrow-down-circle-outline::before {
  content: "\\f0cdc";
}

.mdi-arrow-down-drop-circle::before {
  content: "\\f004a";
}

.mdi-arrow-down-drop-circle-outline::before {
  content: "\\f004b";
}

.mdi-arrow-down-thick::before {
  content: "\\f0046";
}

.mdi-arrow-down-thin-circle-outline::before {
  content: "\\f1599";
}

.mdi-arrow-expand::before {
  content: "\\f0616";
}

.mdi-arrow-expand-all::before {
  content: "\\f004c";
}

.mdi-arrow-expand-down::before {
  content: "\\f0796";
}

.mdi-arrow-expand-horizontal::before {
  content: "\\f084e";
}

.mdi-arrow-expand-left::before {
  content: "\\f0797";
}

.mdi-arrow-expand-right::before {
  content: "\\f0798";
}

.mdi-arrow-expand-up::before {
  content: "\\f0799";
}

.mdi-arrow-expand-vertical::before {
  content: "\\f084f";
}

.mdi-arrow-horizontal-lock::before {
  content: "\\f115b";
}

.mdi-arrow-left::before {
  content: "\\f004d";
}

.mdi-arrow-left-bold::before {
  content: "\\f0731";
}

.mdi-arrow-left-bold-box::before {
  content: "\\f0732";
}

.mdi-arrow-left-bold-box-outline::before {
  content: "\\f0733";
}

.mdi-arrow-left-bold-circle::before {
  content: "\\f004f";
}

.mdi-arrow-left-bold-circle-outline::before {
  content: "\\f0050";
}

.mdi-arrow-left-bold-hexagon-outline::before {
  content: "\\f0051";
}

.mdi-arrow-left-bold-outline::before {
  content: "\\f09c0";
}

.mdi-arrow-left-box::before {
  content: "\\f06c1";
}

.mdi-arrow-left-circle::before {
  content: "\\f0cdd";
}

.mdi-arrow-left-circle-outline::before {
  content: "\\f0cde";
}

.mdi-arrow-left-drop-circle::before {
  content: "\\f0052";
}

.mdi-arrow-left-drop-circle-outline::before {
  content: "\\f0053";
}

.mdi-arrow-left-right::before {
  content: "\\f0e73";
}

.mdi-arrow-left-right-bold::before {
  content: "\\f0e74";
}

.mdi-arrow-left-right-bold-outline::before {
  content: "\\f09c1";
}

.mdi-arrow-left-thick::before {
  content: "\\f004e";
}

.mdi-arrow-left-thin-circle-outline::before {
  content: "\\f159a";
}

.mdi-arrow-right::before {
  content: "\\f0054";
}

.mdi-arrow-right-bold::before {
  content: "\\f0734";
}

.mdi-arrow-right-bold-box::before {
  content: "\\f0735";
}

.mdi-arrow-right-bold-box-outline::before {
  content: "\\f0736";
}

.mdi-arrow-right-bold-circle::before {
  content: "\\f0056";
}

.mdi-arrow-right-bold-circle-outline::before {
  content: "\\f0057";
}

.mdi-arrow-right-bold-hexagon-outline::before {
  content: "\\f0058";
}

.mdi-arrow-right-bold-outline::before {
  content: "\\f09c2";
}

.mdi-arrow-right-box::before {
  content: "\\f06c2";
}

.mdi-arrow-right-circle::before {
  content: "\\f0cdf";
}

.mdi-arrow-right-circle-outline::before {
  content: "\\f0ce0";
}

.mdi-arrow-right-drop-circle::before {
  content: "\\f0059";
}

.mdi-arrow-right-drop-circle-outline::before {
  content: "\\f005a";
}

.mdi-arrow-right-thick::before {
  content: "\\f0055";
}

.mdi-arrow-right-thin-circle-outline::before {
  content: "\\f1598";
}

.mdi-arrow-split-horizontal::before {
  content: "\\f093b";
}

.mdi-arrow-split-vertical::before {
  content: "\\f093c";
}

.mdi-arrow-top-left::before {
  content: "\\f005b";
}

.mdi-arrow-top-left-bold-outline::before {
  content: "\\f09c3";
}

.mdi-arrow-top-left-bottom-right::before {
  content: "\\f0e75";
}

.mdi-arrow-top-left-bottom-right-bold::before {
  content: "\\f0e76";
}

.mdi-arrow-top-left-thick::before {
  content: "\\f09c4";
}

.mdi-arrow-top-left-thin-circle-outline::before {
  content: "\\f1593";
}

.mdi-arrow-top-right::before {
  content: "\\f005c";
}

.mdi-arrow-top-right-bold-outline::before {
  content: "\\f09c5";
}

.mdi-arrow-top-right-bottom-left::before {
  content: "\\f0e77";
}

.mdi-arrow-top-right-bottom-left-bold::before {
  content: "\\f0e78";
}

.mdi-arrow-top-right-thick::before {
  content: "\\f09c6";
}

.mdi-arrow-top-right-thin-circle-outline::before {
  content: "\\f1594";
}

.mdi-arrow-up::before {
  content: "\\f005d";
}

.mdi-arrow-up-bold::before {
  content: "\\f0737";
}

.mdi-arrow-up-bold-box::before {
  content: "\\f0738";
}

.mdi-arrow-up-bold-box-outline::before {
  content: "\\f0739";
}

.mdi-arrow-up-bold-circle::before {
  content: "\\f005f";
}

.mdi-arrow-up-bold-circle-outline::before {
  content: "\\f0060";
}

.mdi-arrow-up-bold-hexagon-outline::before {
  content: "\\f0061";
}

.mdi-arrow-up-bold-outline::before {
  content: "\\f09c7";
}

.mdi-arrow-up-box::before {
  content: "\\f06c3";
}

.mdi-arrow-up-circle::before {
  content: "\\f0ce1";
}

.mdi-arrow-up-circle-outline::before {
  content: "\\f0ce2";
}

.mdi-arrow-up-down::before {
  content: "\\f0e79";
}

.mdi-arrow-up-down-bold::before {
  content: "\\f0e7a";
}

.mdi-arrow-up-down-bold-outline::before {
  content: "\\f09c8";
}

.mdi-arrow-up-drop-circle::before {
  content: "\\f0062";
}

.mdi-arrow-up-drop-circle-outline::before {
  content: "\\f0063";
}

.mdi-arrow-up-thick::before {
  content: "\\f005e";
}

.mdi-arrow-up-thin-circle-outline::before {
  content: "\\f1597";
}

.mdi-arrow-vertical-lock::before {
  content: "\\f115c";
}

.mdi-artstation::before {
  content: "\\f0b5b";
}

.mdi-aspect-ratio::before {
  content: "\\f0a24";
}

.mdi-assistant::before {
  content: "\\f0064";
}

.mdi-asterisk::before {
  content: "\\f06c4";
}

.mdi-at::before {
  content: "\\f0065";
}

.mdi-atlassian::before {
  content: "\\f0804";
}

.mdi-atm::before {
  content: "\\f0d47";
}

.mdi-atom::before {
  content: "\\f0768";
}

.mdi-atom-variant::before {
  content: "\\f0e7b";
}

.mdi-attachment::before {
  content: "\\f0066";
}

.mdi-audio-video::before {
  content: "\\f093d";
}

.mdi-audio-video-off::before {
  content: "\\f11b6";
}

.mdi-augmented-reality::before {
  content: "\\f0850";
}

.mdi-auto-download::before {
  content: "\\f137e";
}

.mdi-auto-fix::before {
  content: "\\f0068";
}

.mdi-auto-upload::before {
  content: "\\f0069";
}

.mdi-autorenew::before {
  content: "\\f006a";
}

.mdi-av-timer::before {
  content: "\\f006b";
}

.mdi-aws::before {
  content: "\\f0e0f";
}

.mdi-axe::before {
  content: "\\f08c8";
}

.mdi-axis::before {
  content: "\\f0d48";
}

.mdi-axis-arrow::before {
  content: "\\f0d49";
}

.mdi-axis-arrow-info::before {
  content: "\\f140e";
}

.mdi-axis-arrow-lock::before {
  content: "\\f0d4a";
}

.mdi-axis-lock::before {
  content: "\\f0d4b";
}

.mdi-axis-x-arrow::before {
  content: "\\f0d4c";
}

.mdi-axis-x-arrow-lock::before {
  content: "\\f0d4d";
}

.mdi-axis-x-rotate-clockwise::before {
  content: "\\f0d4e";
}

.mdi-axis-x-rotate-counterclockwise::before {
  content: "\\f0d4f";
}

.mdi-axis-x-y-arrow-lock::before {
  content: "\\f0d50";
}

.mdi-axis-y-arrow::before {
  content: "\\f0d51";
}

.mdi-axis-y-arrow-lock::before {
  content: "\\f0d52";
}

.mdi-axis-y-rotate-clockwise::before {
  content: "\\f0d53";
}

.mdi-axis-y-rotate-counterclockwise::before {
  content: "\\f0d54";
}

.mdi-axis-z-arrow::before {
  content: "\\f0d55";
}

.mdi-axis-z-arrow-lock::before {
  content: "\\f0d56";
}

.mdi-axis-z-rotate-clockwise::before {
  content: "\\f0d57";
}

.mdi-axis-z-rotate-counterclockwise::before {
  content: "\\f0d58";
}

.mdi-babel::before {
  content: "\\f0a25";
}

.mdi-baby::before {
  content: "\\f006c";
}

.mdi-baby-bottle::before {
  content: "\\f0f39";
}

.mdi-baby-bottle-outline::before {
  content: "\\f0f3a";
}

.mdi-baby-buggy::before {
  content: "\\f13e0";
}

.mdi-baby-carriage::before {
  content: "\\f068f";
}

.mdi-baby-carriage-off::before {
  content: "\\f0fa0";
}

.mdi-baby-face::before {
  content: "\\f0e7c";
}

.mdi-baby-face-outline::before {
  content: "\\f0e7d";
}

.mdi-backburger::before {
  content: "\\f006d";
}

.mdi-backspace::before {
  content: "\\f006e";
}

.mdi-backspace-outline::before {
  content: "\\f0b5c";
}

.mdi-backspace-reverse::before {
  content: "\\f0e7e";
}

.mdi-backspace-reverse-outline::before {
  content: "\\f0e7f";
}

.mdi-backup-restore::before {
  content: "\\f006f";
}

.mdi-bacteria::before {
  content: "\\f0ed5";
}

.mdi-bacteria-outline::before {
  content: "\\f0ed6";
}

.mdi-badge-account::before {
  content: "\\f0da7";
}

.mdi-badge-account-alert::before {
  content: "\\f0da8";
}

.mdi-badge-account-alert-outline::before {
  content: "\\f0da9";
}

.mdi-badge-account-horizontal::before {
  content: "\\f0e0d";
}

.mdi-badge-account-horizontal-outline::before {
  content: "\\f0e0e";
}

.mdi-badge-account-outline::before {
  content: "\\f0daa";
}

.mdi-badminton::before {
  content: "\\f0851";
}

.mdi-bag-carry-on::before {
  content: "\\f0f3b";
}

.mdi-bag-carry-on-check::before {
  content: "\\f0d65";
}

.mdi-bag-carry-on-off::before {
  content: "\\f0f3c";
}

.mdi-bag-checked::before {
  content: "\\f0f3d";
}

.mdi-bag-personal::before {
  content: "\\f0e10";
}

.mdi-bag-personal-off::before {
  content: "\\f0e11";
}

.mdi-bag-personal-off-outline::before {
  content: "\\f0e12";
}

.mdi-bag-personal-outline::before {
  content: "\\f0e13";
}

.mdi-bag-suitcase::before {
  content: "\\f158b";
}

.mdi-bag-suitcase-off::before {
  content: "\\f158d";
}

.mdi-bag-suitcase-off-outline::before {
  content: "\\f158e";
}

.mdi-bag-suitcase-outline::before {
  content: "\\f158c";
}

.mdi-baguette::before {
  content: "\\f0f3e";
}

.mdi-balloon::before {
  content: "\\f0a26";
}

.mdi-ballot::before {
  content: "\\f09c9";
}

.mdi-ballot-outline::before {
  content: "\\f09ca";
}

.mdi-ballot-recount::before {
  content: "\\f0c39";
}

.mdi-ballot-recount-outline::before {
  content: "\\f0c3a";
}

.mdi-bandage::before {
  content: "\\f0daf";
}

.mdi-bandcamp::before {
  content: "\\f0675";
}

.mdi-bank::before {
  content: "\\f0070";
}

.mdi-bank-check::before {
  content: "\\f1655";
}

.mdi-bank-minus::before {
  content: "\\f0db0";
}

.mdi-bank-off::before {
  content: "\\f1656";
}

.mdi-bank-off-outline::before {
  content: "\\f1657";
}

.mdi-bank-outline::before {
  content: "\\f0e80";
}

.mdi-bank-plus::before {
  content: "\\f0db1";
}

.mdi-bank-remove::before {
  content: "\\f0db2";
}

.mdi-bank-transfer::before {
  content: "\\f0a27";
}

.mdi-bank-transfer-in::before {
  content: "\\f0a28";
}

.mdi-bank-transfer-out::before {
  content: "\\f0a29";
}

.mdi-barcode::before {
  content: "\\f0071";
}

.mdi-barcode-off::before {
  content: "\\f1236";
}

.mdi-barcode-scan::before {
  content: "\\f0072";
}

.mdi-barley::before {
  content: "\\f0073";
}

.mdi-barley-off::before {
  content: "\\f0b5d";
}

.mdi-barn::before {
  content: "\\f0b5e";
}

.mdi-barrel::before {
  content: "\\f0074";
}

.mdi-baseball::before {
  content: "\\f0852";
}

.mdi-baseball-bat::before {
  content: "\\f0853";
}

.mdi-baseball-diamond::before {
  content: "\\f15ec";
}

.mdi-baseball-diamond-outline::before {
  content: "\\f15ed";
}

.mdi-bash::before {
  content: "\\f1183";
}

.mdi-basket::before {
  content: "\\f0076";
}

.mdi-basket-fill::before {
  content: "\\f0077";
}

.mdi-basket-minus::before {
  content: "\\f1523";
}

.mdi-basket-minus-outline::before {
  content: "\\f1524";
}

.mdi-basket-off::before {
  content: "\\f1525";
}

.mdi-basket-off-outline::before {
  content: "\\f1526";
}

.mdi-basket-outline::before {
  content: "\\f1181";
}

.mdi-basket-plus::before {
  content: "\\f1527";
}

.mdi-basket-plus-outline::before {
  content: "\\f1528";
}

.mdi-basket-remove::before {
  content: "\\f1529";
}

.mdi-basket-remove-outline::before {
  content: "\\f152a";
}

.mdi-basket-unfill::before {
  content: "\\f0078";
}

.mdi-basketball::before {
  content: "\\f0806";
}

.mdi-basketball-hoop::before {
  content: "\\f0c3b";
}

.mdi-basketball-hoop-outline::before {
  content: "\\f0c3c";
}

.mdi-bat::before {
  content: "\\f0b5f";
}

.mdi-battery::before {
  content: "\\f0079";
}

.mdi-battery-10::before {
  content: "\\f007a";
}

.mdi-battery-10-bluetooth::before {
  content: "\\f093e";
}

.mdi-battery-20::before {
  content: "\\f007b";
}

.mdi-battery-20-bluetooth::before {
  content: "\\f093f";
}

.mdi-battery-30::before {
  content: "\\f007c";
}

.mdi-battery-30-bluetooth::before {
  content: "\\f0940";
}

.mdi-battery-40::before {
  content: "\\f007d";
}

.mdi-battery-40-bluetooth::before {
  content: "\\f0941";
}

.mdi-battery-50::before {
  content: "\\f007e";
}

.mdi-battery-50-bluetooth::before {
  content: "\\f0942";
}

.mdi-battery-60::before {
  content: "\\f007f";
}

.mdi-battery-60-bluetooth::before {
  content: "\\f0943";
}

.mdi-battery-70::before {
  content: "\\f0080";
}

.mdi-battery-70-bluetooth::before {
  content: "\\f0944";
}

.mdi-battery-80::before {
  content: "\\f0081";
}

.mdi-battery-80-bluetooth::before {
  content: "\\f0945";
}

.mdi-battery-90::before {
  content: "\\f0082";
}

.mdi-battery-90-bluetooth::before {
  content: "\\f0946";
}

.mdi-battery-alert::before {
  content: "\\f0083";
}

.mdi-battery-alert-bluetooth::before {
  content: "\\f0947";
}

.mdi-battery-alert-variant::before {
  content: "\\f10cc";
}

.mdi-battery-alert-variant-outline::before {
  content: "\\f10cd";
}

.mdi-battery-bluetooth::before {
  content: "\\f0948";
}

.mdi-battery-bluetooth-variant::before {
  content: "\\f0949";
}

.mdi-battery-charging::before {
  content: "\\f0084";
}

.mdi-battery-charging-10::before {
  content: "\\f089c";
}

.mdi-battery-charging-100::before {
  content: "\\f0085";
}

.mdi-battery-charging-20::before {
  content: "\\f0086";
}

.mdi-battery-charging-30::before {
  content: "\\f0087";
}

.mdi-battery-charging-40::before {
  content: "\\f0088";
}

.mdi-battery-charging-50::before {
  content: "\\f089d";
}

.mdi-battery-charging-60::before {
  content: "\\f0089";
}

.mdi-battery-charging-70::before {
  content: "\\f089e";
}

.mdi-battery-charging-80::before {
  content: "\\f008a";
}

.mdi-battery-charging-90::before {
  content: "\\f008b";
}

.mdi-battery-charging-high::before {
  content: "\\f12a6";
}

.mdi-battery-charging-low::before {
  content: "\\f12a4";
}

.mdi-battery-charging-medium::before {
  content: "\\f12a5";
}

.mdi-battery-charging-outline::before {
  content: "\\f089f";
}

.mdi-battery-charging-wireless::before {
  content: "\\f0807";
}

.mdi-battery-charging-wireless-10::before {
  content: "\\f0808";
}

.mdi-battery-charging-wireless-20::before {
  content: "\\f0809";
}

.mdi-battery-charging-wireless-30::before {
  content: "\\f080a";
}

.mdi-battery-charging-wireless-40::before {
  content: "\\f080b";
}

.mdi-battery-charging-wireless-50::before {
  content: "\\f080c";
}

.mdi-battery-charging-wireless-60::before {
  content: "\\f080d";
}

.mdi-battery-charging-wireless-70::before {
  content: "\\f080e";
}

.mdi-battery-charging-wireless-80::before {
  content: "\\f080f";
}

.mdi-battery-charging-wireless-90::before {
  content: "\\f0810";
}

.mdi-battery-charging-wireless-alert::before {
  content: "\\f0811";
}

.mdi-battery-charging-wireless-outline::before {
  content: "\\f0812";
}

.mdi-battery-heart::before {
  content: "\\f120f";
}

.mdi-battery-heart-outline::before {
  content: "\\f1210";
}

.mdi-battery-heart-variant::before {
  content: "\\f1211";
}

.mdi-battery-high::before {
  content: "\\f12a3";
}

.mdi-battery-low::before {
  content: "\\f12a1";
}

.mdi-battery-medium::before {
  content: "\\f12a2";
}

.mdi-battery-minus::before {
  content: "\\f008c";
}

.mdi-battery-negative::before {
  content: "\\f008d";
}

.mdi-battery-off::before {
  content: "\\f125d";
}

.mdi-battery-off-outline::before {
  content: "\\f125e";
}

.mdi-battery-outline::before {
  content: "\\f008e";
}

.mdi-battery-plus::before {
  content: "\\f008f";
}

.mdi-battery-positive::before {
  content: "\\f0090";
}

.mdi-battery-unknown::before {
  content: "\\f0091";
}

.mdi-battery-unknown-bluetooth::before {
  content: "\\f094a";
}

.mdi-battlenet::before {
  content: "\\f0b60";
}

.mdi-beach::before {
  content: "\\f0092";
}

.mdi-beaker::before {
  content: "\\f0cea";
}

.mdi-beaker-alert::before {
  content: "\\f1229";
}

.mdi-beaker-alert-outline::before {
  content: "\\f122a";
}

.mdi-beaker-check::before {
  content: "\\f122b";
}

.mdi-beaker-check-outline::before {
  content: "\\f122c";
}

.mdi-beaker-minus::before {
  content: "\\f122d";
}

.mdi-beaker-minus-outline::before {
  content: "\\f122e";
}

.mdi-beaker-outline::before {
  content: "\\f0690";
}

.mdi-beaker-plus::before {
  content: "\\f122f";
}

.mdi-beaker-plus-outline::before {
  content: "\\f1230";
}

.mdi-beaker-question::before {
  content: "\\f1231";
}

.mdi-beaker-question-outline::before {
  content: "\\f1232";
}

.mdi-beaker-remove::before {
  content: "\\f1233";
}

.mdi-beaker-remove-outline::before {
  content: "\\f1234";
}

.mdi-bed::before {
  content: "\\f02e3";
}

.mdi-bed-double::before {
  content: "\\f0fd4";
}

.mdi-bed-double-outline::before {
  content: "\\f0fd3";
}

.mdi-bed-empty::before {
  content: "\\f08a0";
}

.mdi-bed-king::before {
  content: "\\f0fd2";
}

.mdi-bed-king-outline::before {
  content: "\\f0fd1";
}

.mdi-bed-outline::before {
  content: "\\f0099";
}

.mdi-bed-queen::before {
  content: "\\f0fd0";
}

.mdi-bed-queen-outline::before {
  content: "\\f0fdb";
}

.mdi-bed-single::before {
  content: "\\f106d";
}

.mdi-bed-single-outline::before {
  content: "\\f106e";
}

.mdi-bee::before {
  content: "\\f0fa1";
}

.mdi-bee-flower::before {
  content: "\\f0fa2";
}

.mdi-beehive-off-outline::before {
  content: "\\f13ed";
}

.mdi-beehive-outline::before {
  content: "\\f10ce";
}

.mdi-beekeeper::before {
  content: "\\f14e2";
}

.mdi-beer::before {
  content: "\\f0098";
}

.mdi-beer-outline::before {
  content: "\\f130c";
}

.mdi-bell::before {
  content: "\\f009a";
}

.mdi-bell-alert::before {
  content: "\\f0d59";
}

.mdi-bell-alert-outline::before {
  content: "\\f0e81";
}

.mdi-bell-cancel::before {
  content: "\\f13e7";
}

.mdi-bell-cancel-outline::before {
  content: "\\f13e8";
}

.mdi-bell-check::before {
  content: "\\f11e5";
}

.mdi-bell-check-outline::before {
  content: "\\f11e6";
}

.mdi-bell-circle::before {
  content: "\\f0d5a";
}

.mdi-bell-circle-outline::before {
  content: "\\f0d5b";
}

.mdi-bell-minus::before {
  content: "\\f13e9";
}

.mdi-bell-minus-outline::before {
  content: "\\f13ea";
}

.mdi-bell-off::before {
  content: "\\f009b";
}

.mdi-bell-off-outline::before {
  content: "\\f0a91";
}

.mdi-bell-outline::before {
  content: "\\f009c";
}

.mdi-bell-plus::before {
  content: "\\f009d";
}

.mdi-bell-plus-outline::before {
  content: "\\f0a92";
}

.mdi-bell-remove::before {
  content: "\\f13eb";
}

.mdi-bell-remove-outline::before {
  content: "\\f13ec";
}

.mdi-bell-ring::before {
  content: "\\f009e";
}

.mdi-bell-ring-outline::before {
  content: "\\f009f";
}

.mdi-bell-sleep::before {
  content: "\\f00a0";
}

.mdi-bell-sleep-outline::before {
  content: "\\f0a93";
}

.mdi-beta::before {
  content: "\\f00a1";
}

.mdi-betamax::before {
  content: "\\f09cb";
}

.mdi-biathlon::before {
  content: "\\f0e14";
}

.mdi-bicycle::before {
  content: "\\f109c";
}

.mdi-bicycle-basket::before {
  content: "\\f1235";
}

.mdi-bicycle-electric::before {
  content: "\\f15b4";
}

.mdi-bicycle-penny-farthing::before {
  content: "\\f15e9";
}

.mdi-bike::before {
  content: "\\f00a3";
}

.mdi-bike-fast::before {
  content: "\\f111f";
}

.mdi-billboard::before {
  content: "\\f1010";
}

.mdi-billiards::before {
  content: "\\f0b61";
}

.mdi-billiards-rack::before {
  content: "\\f0b62";
}

.mdi-binoculars::before {
  content: "\\f00a5";
}

.mdi-bio::before {
  content: "\\f00a6";
}

.mdi-biohazard::before {
  content: "\\f00a7";
}

.mdi-bird::before {
  content: "\\f15c6";
}

.mdi-bitbucket::before {
  content: "\\f00a8";
}

.mdi-bitcoin::before {
  content: "\\f0813";
}

.mdi-black-mesa::before {
  content: "\\f00a9";
}

.mdi-blender::before {
  content: "\\f0ceb";
}

.mdi-blender-software::before {
  content: "\\f00ab";
}

.mdi-blinds::before {
  content: "\\f00ac";
}

.mdi-blinds-open::before {
  content: "\\f1011";
}

.mdi-block-helper::before {
  content: "\\f00ad";
}

.mdi-blogger::before {
  content: "\\f00ae";
}

.mdi-blood-bag::before {
  content: "\\f0cec";
}

.mdi-bluetooth::before {
  content: "\\f00af";
}

.mdi-bluetooth-audio::before {
  content: "\\f00b0";
}

.mdi-bluetooth-connect::before {
  content: "\\f00b1";
}

.mdi-bluetooth-off::before {
  content: "\\f00b2";
}

.mdi-bluetooth-settings::before {
  content: "\\f00b3";
}

.mdi-bluetooth-transfer::before {
  content: "\\f00b4";
}

.mdi-blur::before {
  content: "\\f00b5";
}

.mdi-blur-linear::before {
  content: "\\f00b6";
}

.mdi-blur-off::before {
  content: "\\f00b7";
}

.mdi-blur-radial::before {
  content: "\\f00b8";
}

.mdi-bolnisi-cross::before {
  content: "\\f0ced";
}

.mdi-bolt::before {
  content: "\\f0db3";
}

.mdi-bomb::before {
  content: "\\f0691";
}

.mdi-bomb-off::before {
  content: "\\f06c5";
}

.mdi-bone::before {
  content: "\\f00b9";
}

.mdi-book::before {
  content: "\\f00ba";
}

.mdi-book-account::before {
  content: "\\f13ad";
}

.mdi-book-account-outline::before {
  content: "\\f13ae";
}

.mdi-book-alert::before {
  content: "\\f167c";
}

.mdi-book-alert-outline::before {
  content: "\\f167d";
}

.mdi-book-alphabet::before {
  content: "\\f061d";
}

.mdi-book-arrow-down::before {
  content: "\\f167e";
}

.mdi-book-arrow-down-outline::before {
  content: "\\f167f";
}

.mdi-book-arrow-left::before {
  content: "\\f1680";
}

.mdi-book-arrow-left-outline::before {
  content: "\\f1681";
}

.mdi-book-arrow-right::before {
  content: "\\f1682";
}

.mdi-book-arrow-right-outline::before {
  content: "\\f1683";
}

.mdi-book-arrow-up::before {
  content: "\\f1684";
}

.mdi-book-arrow-up-outline::before {
  content: "\\f1685";
}

.mdi-book-cancel::before {
  content: "\\f1686";
}

.mdi-book-cancel-outline::before {
  content: "\\f1687";
}

.mdi-book-check::before {
  content: "\\f14f3";
}

.mdi-book-check-outline::before {
  content: "\\f14f4";
}

.mdi-book-clock::before {
  content: "\\f1688";
}

.mdi-book-clock-outline::before {
  content: "\\f1689";
}

.mdi-book-cog::before {
  content: "\\f168a";
}

.mdi-book-cog-outline::before {
  content: "\\f168b";
}

.mdi-book-cross::before {
  content: "\\f00a2";
}

.mdi-book-edit::before {
  content: "\\f168c";
}

.mdi-book-edit-outline::before {
  content: "\\f168d";
}

.mdi-book-education::before {
  content: "\\f16c9";
}

.mdi-book-education-outline::before {
  content: "\\f16ca";
}

.mdi-book-information-variant::before {
  content: "\\f106f";
}

.mdi-book-lock::before {
  content: "\\f079a";
}

.mdi-book-lock-open::before {
  content: "\\f079b";
}

.mdi-book-lock-open-outline::before {
  content: "\\f168e";
}

.mdi-book-lock-outline::before {
  content: "\\f168f";
}

.mdi-book-marker::before {
  content: "\\f1690";
}

.mdi-book-marker-outline::before {
  content: "\\f1691";
}

.mdi-book-minus::before {
  content: "\\f05d9";
}

.mdi-book-minus-multiple::before {
  content: "\\f0a94";
}

.mdi-book-minus-multiple-outline::before {
  content: "\\f090b";
}

.mdi-book-minus-outline::before {
  content: "\\f1692";
}

.mdi-book-multiple::before {
  content: "\\f00bb";
}

.mdi-book-multiple-outline::before {
  content: "\\f0436";
}

.mdi-book-music::before {
  content: "\\f0067";
}

.mdi-book-music-outline::before {
  content: "\\f1693";
}

.mdi-book-off::before {
  content: "\\f1694";
}

.mdi-book-off-outline::before {
  content: "\\f1695";
}

.mdi-book-open::before {
  content: "\\f00bd";
}

.mdi-book-open-blank-variant::before {
  content: "\\f00be";
}

.mdi-book-open-outline::before {
  content: "\\f0b63";
}

.mdi-book-open-page-variant::before {
  content: "\\f05da";
}

.mdi-book-open-page-variant-outline::before {
  content: "\\f15d6";
}

.mdi-book-open-variant::before {
  content: "\\f14f7";
}

.mdi-book-outline::before {
  content: "\\f0b64";
}

.mdi-book-play::before {
  content: "\\f0e82";
}

.mdi-book-play-outline::before {
  content: "\\f0e83";
}

.mdi-book-plus::before {
  content: "\\f05db";
}

.mdi-book-plus-multiple::before {
  content: "\\f0a95";
}

.mdi-book-plus-multiple-outline::before {
  content: "\\f0ade";
}

.mdi-book-plus-outline::before {
  content: "\\f1696";
}

.mdi-book-refresh::before {
  content: "\\f1697";
}

.mdi-book-refresh-outline::before {
  content: "\\f1698";
}

.mdi-book-remove::before {
  content: "\\f0a97";
}

.mdi-book-remove-multiple::before {
  content: "\\f0a96";
}

.mdi-book-remove-multiple-outline::before {
  content: "\\f04ca";
}

.mdi-book-remove-outline::before {
  content: "\\f1699";
}

.mdi-book-search::before {
  content: "\\f0e84";
}

.mdi-book-search-outline::before {
  content: "\\f0e85";
}

.mdi-book-settings::before {
  content: "\\f169a";
}

.mdi-book-settings-outline::before {
  content: "\\f169b";
}

.mdi-book-sync::before {
  content: "\\f169c";
}

.mdi-book-sync-outline::before {
  content: "\\f16c8";
}

.mdi-book-variant::before {
  content: "\\f00bf";
}

.mdi-book-variant-multiple::before {
  content: "\\f00bc";
}

.mdi-bookmark::before {
  content: "\\f00c0";
}

.mdi-bookmark-check::before {
  content: "\\f00c1";
}

.mdi-bookmark-check-outline::before {
  content: "\\f137b";
}

.mdi-bookmark-minus::before {
  content: "\\f09cc";
}

.mdi-bookmark-minus-outline::before {
  content: "\\f09cd";
}

.mdi-bookmark-multiple::before {
  content: "\\f0e15";
}

.mdi-bookmark-multiple-outline::before {
  content: "\\f0e16";
}

.mdi-bookmark-music::before {
  content: "\\f00c2";
}

.mdi-bookmark-music-outline::before {
  content: "\\f1379";
}

.mdi-bookmark-off::before {
  content: "\\f09ce";
}

.mdi-bookmark-off-outline::before {
  content: "\\f09cf";
}

.mdi-bookmark-outline::before {
  content: "\\f00c3";
}

.mdi-bookmark-plus::before {
  content: "\\f00c5";
}

.mdi-bookmark-plus-outline::before {
  content: "\\f00c4";
}

.mdi-bookmark-remove::before {
  content: "\\f00c6";
}

.mdi-bookmark-remove-outline::before {
  content: "\\f137a";
}

.mdi-bookshelf::before {
  content: "\\f125f";
}

.mdi-boom-gate::before {
  content: "\\f0e86";
}

.mdi-boom-gate-alert::before {
  content: "\\f0e87";
}

.mdi-boom-gate-alert-outline::before {
  content: "\\f0e88";
}

.mdi-boom-gate-down::before {
  content: "\\f0e89";
}

.mdi-boom-gate-down-outline::before {
  content: "\\f0e8a";
}

.mdi-boom-gate-outline::before {
  content: "\\f0e8b";
}

.mdi-boom-gate-up::before {
  content: "\\f0e8c";
}

.mdi-boom-gate-up-outline::before {
  content: "\\f0e8d";
}

.mdi-boombox::before {
  content: "\\f05dc";
}

.mdi-boomerang::before {
  content: "\\f10cf";
}

.mdi-bootstrap::before {
  content: "\\f06c6";
}

.mdi-border-all::before {
  content: "\\f00c7";
}

.mdi-border-all-variant::before {
  content: "\\f08a1";
}

.mdi-border-bottom::before {
  content: "\\f00c8";
}

.mdi-border-bottom-variant::before {
  content: "\\f08a2";
}

.mdi-border-color::before {
  content: "\\f00c9";
}

.mdi-border-horizontal::before {
  content: "\\f00ca";
}

.mdi-border-inside::before {
  content: "\\f00cb";
}

.mdi-border-left::before {
  content: "\\f00cc";
}

.mdi-border-left-variant::before {
  content: "\\f08a3";
}

.mdi-border-none::before {
  content: "\\f00cd";
}

.mdi-border-none-variant::before {
  content: "\\f08a4";
}

.mdi-border-outside::before {
  content: "\\f00ce";
}

.mdi-border-right::before {
  content: "\\f00cf";
}

.mdi-border-right-variant::before {
  content: "\\f08a5";
}

.mdi-border-style::before {
  content: "\\f00d0";
}

.mdi-border-top::before {
  content: "\\f00d1";
}

.mdi-border-top-variant::before {
  content: "\\f08a6";
}

.mdi-border-vertical::before {
  content: "\\f00d2";
}

.mdi-bottle-soda::before {
  content: "\\f1070";
}

.mdi-bottle-soda-classic::before {
  content: "\\f1071";
}

.mdi-bottle-soda-classic-outline::before {
  content: "\\f1363";
}

.mdi-bottle-soda-outline::before {
  content: "\\f1072";
}

.mdi-bottle-tonic::before {
  content: "\\f112e";
}

.mdi-bottle-tonic-outline::before {
  content: "\\f112f";
}

.mdi-bottle-tonic-plus::before {
  content: "\\f1130";
}

.mdi-bottle-tonic-plus-outline::before {
  content: "\\f1131";
}

.mdi-bottle-tonic-skull::before {
  content: "\\f1132";
}

.mdi-bottle-tonic-skull-outline::before {
  content: "\\f1133";
}

.mdi-bottle-wine::before {
  content: "\\f0854";
}

.mdi-bottle-wine-outline::before {
  content: "\\f1310";
}

.mdi-bow-tie::before {
  content: "\\f0678";
}

.mdi-bowl::before {
  content: "\\f028e";
}

.mdi-bowl-mix::before {
  content: "\\f0617";
}

.mdi-bowl-mix-outline::before {
  content: "\\f02e4";
}

.mdi-bowl-outline::before {
  content: "\\f02a9";
}

.mdi-bowling::before {
  content: "\\f00d3";
}

.mdi-box::before {
  content: "\\f00d4";
}

.mdi-box-cutter::before {
  content: "\\f00d5";
}

.mdi-box-cutter-off::before {
  content: "\\f0b4a";
}

.mdi-box-shadow::before {
  content: "\\f0637";
}

.mdi-boxing-glove::before {
  content: "\\f0b65";
}

.mdi-braille::before {
  content: "\\f09d0";
}

.mdi-brain::before {
  content: "\\f09d1";
}

.mdi-bread-slice::before {
  content: "\\f0cee";
}

.mdi-bread-slice-outline::before {
  content: "\\f0cef";
}

.mdi-bridge::before {
  content: "\\f0618";
}

.mdi-briefcase::before {
  content: "\\f00d6";
}

.mdi-briefcase-account::before {
  content: "\\f0cf0";
}

.mdi-briefcase-account-outline::before {
  content: "\\f0cf1";
}

.mdi-briefcase-check::before {
  content: "\\f00d7";
}

.mdi-briefcase-check-outline::before {
  content: "\\f131e";
}

.mdi-briefcase-clock::before {
  content: "\\f10d0";
}

.mdi-briefcase-clock-outline::before {
  content: "\\f10d1";
}

.mdi-briefcase-download::before {
  content: "\\f00d8";
}

.mdi-briefcase-download-outline::before {
  content: "\\f0c3d";
}

.mdi-briefcase-edit::before {
  content: "\\f0a98";
}

.mdi-briefcase-edit-outline::before {
  content: "\\f0c3e";
}

.mdi-briefcase-minus::before {
  content: "\\f0a2a";
}

.mdi-briefcase-minus-outline::before {
  content: "\\f0c3f";
}

.mdi-briefcase-off::before {
  content: "\\f1658";
}

.mdi-briefcase-off-outline::before {
  content: "\\f1659";
}

.mdi-briefcase-outline::before {
  content: "\\f0814";
}

.mdi-briefcase-plus::before {
  content: "\\f0a2b";
}

.mdi-briefcase-plus-outline::before {
  content: "\\f0c40";
}

.mdi-briefcase-remove::before {
  content: "\\f0a2c";
}

.mdi-briefcase-remove-outline::before {
  content: "\\f0c41";
}

.mdi-briefcase-search::before {
  content: "\\f0a2d";
}

.mdi-briefcase-search-outline::before {
  content: "\\f0c42";
}

.mdi-briefcase-upload::before {
  content: "\\f00d9";
}

.mdi-briefcase-upload-outline::before {
  content: "\\f0c43";
}

.mdi-briefcase-variant::before {
  content: "\\f1494";
}

.mdi-briefcase-variant-off::before {
  content: "\\f165a";
}

.mdi-briefcase-variant-off-outline::before {
  content: "\\f165b";
}

.mdi-briefcase-variant-outline::before {
  content: "\\f1495";
}

.mdi-brightness-1::before {
  content: "\\f00da";
}

.mdi-brightness-2::before {
  content: "\\f00db";
}

.mdi-brightness-3::before {
  content: "\\f00dc";
}

.mdi-brightness-4::before {
  content: "\\f00dd";
}

.mdi-brightness-5::before {
  content: "\\f00de";
}

.mdi-brightness-6::before {
  content: "\\f00df";
}

.mdi-brightness-7::before {
  content: "\\f00e0";
}

.mdi-brightness-auto::before {
  content: "\\f00e1";
}

.mdi-brightness-percent::before {
  content: "\\f0cf2";
}

.mdi-broom::before {
  content: "\\f00e2";
}

.mdi-brush::before {
  content: "\\f00e3";
}

.mdi-bucket::before {
  content: "\\f1415";
}

.mdi-bucket-outline::before {
  content: "\\f1416";
}

.mdi-buddhism::before {
  content: "\\f094b";
}

.mdi-buffer::before {
  content: "\\f0619";
}

.mdi-buffet::before {
  content: "\\f0578";
}

.mdi-bug::before {
  content: "\\f00e4";
}

.mdi-bug-check::before {
  content: "\\f0a2e";
}

.mdi-bug-check-outline::before {
  content: "\\f0a2f";
}

.mdi-bug-outline::before {
  content: "\\f0a30";
}

.mdi-bugle::before {
  content: "\\f0db4";
}

.mdi-bulldozer::before {
  content: "\\f0b22";
}

.mdi-bullet::before {
  content: "\\f0cf3";
}

.mdi-bulletin-board::before {
  content: "\\f00e5";
}

.mdi-bullhorn::before {
  content: "\\f00e6";
}

.mdi-bullhorn-outline::before {
  content: "\\f0b23";
}

.mdi-bullseye::before {
  content: "\\f05dd";
}

.mdi-bullseye-arrow::before {
  content: "\\f08c9";
}

.mdi-bulma::before {
  content: "\\f12e7";
}

.mdi-bunk-bed::before {
  content: "\\f1302";
}

.mdi-bunk-bed-outline::before {
  content: "\\f0097";
}

.mdi-bus::before {
  content: "\\f00e7";
}

.mdi-bus-alert::before {
  content: "\\f0a99";
}

.mdi-bus-articulated-end::before {
  content: "\\f079c";
}

.mdi-bus-articulated-front::before {
  content: "\\f079d";
}

.mdi-bus-clock::before {
  content: "\\f08ca";
}

.mdi-bus-double-decker::before {
  content: "\\f079e";
}

.mdi-bus-marker::before {
  content: "\\f1212";
}

.mdi-bus-multiple::before {
  content: "\\f0f3f";
}

.mdi-bus-school::before {
  content: "\\f079f";
}

.mdi-bus-side::before {
  content: "\\f07a0";
}

.mdi-bus-stop::before {
  content: "\\f1012";
}

.mdi-bus-stop-covered::before {
  content: "\\f1013";
}

.mdi-bus-stop-uncovered::before {
  content: "\\f1014";
}

.mdi-butterfly::before {
  content: "\\f1589";
}

.mdi-butterfly-outline::before {
  content: "\\f158a";
}

.mdi-cable-data::before {
  content: "\\f1394";
}

.mdi-cached::before {
  content: "\\f00e8";
}

.mdi-cactus::before {
  content: "\\f0db5";
}

.mdi-cake::before {
  content: "\\f00e9";
}

.mdi-cake-layered::before {
  content: "\\f00ea";
}

.mdi-cake-variant::before {
  content: "\\f00eb";
}

.mdi-calculator::before {
  content: "\\f00ec";
}

.mdi-calculator-variant::before {
  content: "\\f0a9a";
}

.mdi-calculator-variant-outline::before {
  content: "\\f15a6";
}

.mdi-calendar::before {
  content: "\\f00ed";
}

.mdi-calendar-account::before {
  content: "\\f0ed7";
}

.mdi-calendar-account-outline::before {
  content: "\\f0ed8";
}

.mdi-calendar-alert::before {
  content: "\\f0a31";
}

.mdi-calendar-arrow-left::before {
  content: "\\f1134";
}

.mdi-calendar-arrow-right::before {
  content: "\\f1135";
}

.mdi-calendar-blank::before {
  content: "\\f00ee";
}

.mdi-calendar-blank-multiple::before {
  content: "\\f1073";
}

.mdi-calendar-blank-outline::before {
  content: "\\f0b66";
}

.mdi-calendar-check::before {
  content: "\\f00ef";
}

.mdi-calendar-check-outline::before {
  content: "\\f0c44";
}

.mdi-calendar-clock::before {
  content: "\\f00f0";
}

.mdi-calendar-cursor::before {
  content: "\\f157b";
}

.mdi-calendar-edit::before {
  content: "\\f08a7";
}

.mdi-calendar-end::before {
  content: "\\f166c";
}

.mdi-calendar-export::before {
  content: "\\f0b24";
}

.mdi-calendar-heart::before {
  content: "\\f09d2";
}

.mdi-calendar-import::before {
  content: "\\f0b25";
}

.mdi-calendar-lock::before {
  content: "\\f1641";
}

.mdi-calendar-lock-outline::before {
  content: "\\f1642";
}

.mdi-calendar-minus::before {
  content: "\\f0d5c";
}

.mdi-calendar-month::before {
  content: "\\f0e17";
}

.mdi-calendar-month-outline::before {
  content: "\\f0e18";
}

.mdi-calendar-multiple::before {
  content: "\\f00f1";
}

.mdi-calendar-multiple-check::before {
  content: "\\f00f2";
}

.mdi-calendar-multiselect::before {
  content: "\\f0a32";
}

.mdi-calendar-outline::before {
  content: "\\f0b67";
}

.mdi-calendar-plus::before {
  content: "\\f00f3";
}

.mdi-calendar-question::before {
  content: "\\f0692";
}

.mdi-calendar-range::before {
  content: "\\f0679";
}

.mdi-calendar-range-outline::before {
  content: "\\f0b68";
}

.mdi-calendar-refresh::before {
  content: "\\f01e1";
}

.mdi-calendar-refresh-outline::before {
  content: "\\f0203";
}

.mdi-calendar-remove::before {
  content: "\\f00f4";
}

.mdi-calendar-remove-outline::before {
  content: "\\f0c45";
}

.mdi-calendar-search::before {
  content: "\\f094c";
}

.mdi-calendar-star::before {
  content: "\\f09d3";
}

.mdi-calendar-start::before {
  content: "\\f166d";
}

.mdi-calendar-sync::before {
  content: "\\f0e8e";
}

.mdi-calendar-sync-outline::before {
  content: "\\f0e8f";
}

.mdi-calendar-text::before {
  content: "\\f00f5";
}

.mdi-calendar-text-outline::before {
  content: "\\f0c46";
}

.mdi-calendar-today::before {
  content: "\\f00f6";
}

.mdi-calendar-week::before {
  content: "\\f0a33";
}

.mdi-calendar-week-begin::before {
  content: "\\f0a34";
}

.mdi-calendar-weekend::before {
  content: "\\f0ed9";
}

.mdi-calendar-weekend-outline::before {
  content: "\\f0eda";
}

.mdi-call-made::before {
  content: "\\f00f7";
}

.mdi-call-merge::before {
  content: "\\f00f8";
}

.mdi-call-missed::before {
  content: "\\f00f9";
}

.mdi-call-received::before {
  content: "\\f00fa";
}

.mdi-call-split::before {
  content: "\\f00fb";
}

.mdi-camcorder::before {
  content: "\\f00fc";
}

.mdi-camcorder-off::before {
  content: "\\f00ff";
}

.mdi-camera::before {
  content: "\\f0100";
}

.mdi-camera-account::before {
  content: "\\f08cb";
}

.mdi-camera-burst::before {
  content: "\\f0693";
}

.mdi-camera-control::before {
  content: "\\f0b69";
}

.mdi-camera-enhance::before {
  content: "\\f0101";
}

.mdi-camera-enhance-outline::before {
  content: "\\f0b6a";
}

.mdi-camera-flip::before {
  content: "\\f15d9";
}

.mdi-camera-flip-outline::before {
  content: "\\f15da";
}

.mdi-camera-front::before {
  content: "\\f0102";
}

.mdi-camera-front-variant::before {
  content: "\\f0103";
}

.mdi-camera-gopro::before {
  content: "\\f07a1";
}

.mdi-camera-image::before {
  content: "\\f08cc";
}

.mdi-camera-iris::before {
  content: "\\f0104";
}

.mdi-camera-metering-center::before {
  content: "\\f07a2";
}

.mdi-camera-metering-matrix::before {
  content: "\\f07a3";
}

.mdi-camera-metering-partial::before {
  content: "\\f07a4";
}

.mdi-camera-metering-spot::before {
  content: "\\f07a5";
}

.mdi-camera-off::before {
  content: "\\f05df";
}

.mdi-camera-outline::before {
  content: "\\f0d5d";
}

.mdi-camera-party-mode::before {
  content: "\\f0105";
}

.mdi-camera-plus::before {
  content: "\\f0edb";
}

.mdi-camera-plus-outline::before {
  content: "\\f0edc";
}

.mdi-camera-rear::before {
  content: "\\f0106";
}

.mdi-camera-rear-variant::before {
  content: "\\f0107";
}

.mdi-camera-retake::before {
  content: "\\f0e19";
}

.mdi-camera-retake-outline::before {
  content: "\\f0e1a";
}

.mdi-camera-switch::before {
  content: "\\f0108";
}

.mdi-camera-switch-outline::before {
  content: "\\f084a";
}

.mdi-camera-timer::before {
  content: "\\f0109";
}

.mdi-camera-wireless::before {
  content: "\\f0db6";
}

.mdi-camera-wireless-outline::before {
  content: "\\f0db7";
}

.mdi-campfire::before {
  content: "\\f0edd";
}

.mdi-cancel::before {
  content: "\\f073a";
}

.mdi-candle::before {
  content: "\\f05e2";
}

.mdi-candycane::before {
  content: "\\f010a";
}

.mdi-cannabis::before {
  content: "\\f07a6";
}

.mdi-cannabis-off::before {
  content: "\\f166e";
}

.mdi-caps-lock::before {
  content: "\\f0a9b";
}

.mdi-car::before {
  content: "\\f010b";
}

.mdi-car-2-plus::before {
  content: "\\f1015";
}

.mdi-car-3-plus::before {
  content: "\\f1016";
}

.mdi-car-arrow-left::before {
  content: "\\f13b2";
}

.mdi-car-arrow-right::before {
  content: "\\f13b3";
}

.mdi-car-back::before {
  content: "\\f0e1b";
}

.mdi-car-battery::before {
  content: "\\f010c";
}

.mdi-car-brake-abs::before {
  content: "\\f0c47";
}

.mdi-car-brake-alert::before {
  content: "\\f0c48";
}

.mdi-car-brake-hold::before {
  content: "\\f0d5e";
}

.mdi-car-brake-parking::before {
  content: "\\f0d5f";
}

.mdi-car-brake-retarder::before {
  content: "\\f1017";
}

.mdi-car-child-seat::before {
  content: "\\f0fa3";
}

.mdi-car-clutch::before {
  content: "\\f1018";
}

.mdi-car-cog::before {
  content: "\\f13cc";
}

.mdi-car-connected::before {
  content: "\\f010d";
}

.mdi-car-convertible::before {
  content: "\\f07a7";
}

.mdi-car-coolant-level::before {
  content: "\\f1019";
}

.mdi-car-cruise-control::before {
  content: "\\f0d60";
}

.mdi-car-defrost-front::before {
  content: "\\f0d61";
}

.mdi-car-defrost-rear::before {
  content: "\\f0d62";
}

.mdi-car-door::before {
  content: "\\f0b6b";
}

.mdi-car-door-lock::before {
  content: "\\f109d";
}

.mdi-car-electric::before {
  content: "\\f0b6c";
}

.mdi-car-electric-outline::before {
  content: "\\f15b5";
}

.mdi-car-emergency::before {
  content: "\\f160f";
}

.mdi-car-esp::before {
  content: "\\f0c49";
}

.mdi-car-estate::before {
  content: "\\f07a8";
}

.mdi-car-hatchback::before {
  content: "\\f07a9";
}

.mdi-car-info::before {
  content: "\\f11be";
}

.mdi-car-key::before {
  content: "\\f0b6d";
}

.mdi-car-lifted-pickup::before {
  content: "\\f152d";
}

.mdi-car-light-dimmed::before {
  content: "\\f0c4a";
}

.mdi-car-light-fog::before {
  content: "\\f0c4b";
}

.mdi-car-light-high::before {
  content: "\\f0c4c";
}

.mdi-car-limousine::before {
  content: "\\f08cd";
}

.mdi-car-multiple::before {
  content: "\\f0b6e";
}

.mdi-car-off::before {
  content: "\\f0e1c";
}

.mdi-car-outline::before {
  content: "\\f14ed";
}

.mdi-car-parking-lights::before {
  content: "\\f0d63";
}

.mdi-car-pickup::before {
  content: "\\f07aa";
}

.mdi-car-seat::before {
  content: "\\f0fa4";
}

.mdi-car-seat-cooler::before {
  content: "\\f0fa5";
}

.mdi-car-seat-heater::before {
  content: "\\f0fa6";
}

.mdi-car-settings::before {
  content: "\\f13cd";
}

.mdi-car-shift-pattern::before {
  content: "\\f0f40";
}

.mdi-car-side::before {
  content: "\\f07ab";
}

.mdi-car-sports::before {
  content: "\\f07ac";
}

.mdi-car-tire-alert::before {
  content: "\\f0c4d";
}

.mdi-car-traction-control::before {
  content: "\\f0d64";
}

.mdi-car-turbocharger::before {
  content: "\\f101a";
}

.mdi-car-wash::before {
  content: "\\f010e";
}

.mdi-car-windshield::before {
  content: "\\f101b";
}

.mdi-car-windshield-outline::before {
  content: "\\f101c";
}

.mdi-carabiner::before {
  content: "\\f14c0";
}

.mdi-caravan::before {
  content: "\\f07ad";
}

.mdi-card::before {
  content: "\\f0b6f";
}

.mdi-card-account-details::before {
  content: "\\f05d2";
}

.mdi-card-account-details-outline::before {
  content: "\\f0dab";
}

.mdi-card-account-details-star::before {
  content: "\\f02a3";
}

.mdi-card-account-details-star-outline::before {
  content: "\\f06db";
}

.mdi-card-account-mail::before {
  content: "\\f018e";
}

.mdi-card-account-mail-outline::before {
  content: "\\f0e98";
}

.mdi-card-account-phone::before {
  content: "\\f0e99";
}

.mdi-card-account-phone-outline::before {
  content: "\\f0e9a";
}

.mdi-card-bulleted::before {
  content: "\\f0b70";
}

.mdi-card-bulleted-off::before {
  content: "\\f0b71";
}

.mdi-card-bulleted-off-outline::before {
  content: "\\f0b72";
}

.mdi-card-bulleted-outline::before {
  content: "\\f0b73";
}

.mdi-card-bulleted-settings::before {
  content: "\\f0b74";
}

.mdi-card-bulleted-settings-outline::before {
  content: "\\f0b75";
}

.mdi-card-minus::before {
  content: "\\f1600";
}

.mdi-card-minus-outline::before {
  content: "\\f1601";
}

.mdi-card-off::before {
  content: "\\f1602";
}

.mdi-card-off-outline::before {
  content: "\\f1603";
}

.mdi-card-outline::before {
  content: "\\f0b76";
}

.mdi-card-plus::before {
  content: "\\f11ff";
}

.mdi-card-plus-outline::before {
  content: "\\f1200";
}

.mdi-card-remove::before {
  content: "\\f1604";
}

.mdi-card-remove-outline::before {
  content: "\\f1605";
}

.mdi-card-search::before {
  content: "\\f1074";
}

.mdi-card-search-outline::before {
  content: "\\f1075";
}

.mdi-card-text::before {
  content: "\\f0b77";
}

.mdi-card-text-outline::before {
  content: "\\f0b78";
}

.mdi-cards::before {
  content: "\\f0638";
}

.mdi-cards-club::before {
  content: "\\f08ce";
}

.mdi-cards-diamond::before {
  content: "\\f08cf";
}

.mdi-cards-diamond-outline::before {
  content: "\\f101d";
}

.mdi-cards-heart::before {
  content: "\\f08d0";
}

.mdi-cards-outline::before {
  content: "\\f0639";
}

.mdi-cards-playing-outline::before {
  content: "\\f063a";
}

.mdi-cards-spade::before {
  content: "\\f08d1";
}

.mdi-cards-variant::before {
  content: "\\f06c7";
}

.mdi-carrot::before {
  content: "\\f010f";
}

.mdi-cart::before {
  content: "\\f0110";
}

.mdi-cart-arrow-down::before {
  content: "\\f0d66";
}

.mdi-cart-arrow-right::before {
  content: "\\f0c4e";
}

.mdi-cart-arrow-up::before {
  content: "\\f0d67";
}

.mdi-cart-check::before {
  content: "\\f15ea";
}

.mdi-cart-minus::before {
  content: "\\f0d68";
}

.mdi-cart-off::before {
  content: "\\f066b";
}

.mdi-cart-outline::before {
  content: "\\f0111";
}

.mdi-cart-plus::before {
  content: "\\f0112";
}

.mdi-cart-remove::before {
  content: "\\f0d69";
}

.mdi-cart-variant::before {
  content: "\\f15eb";
}

.mdi-case-sensitive-alt::before {
  content: "\\f0113";
}

.mdi-cash::before {
  content: "\\f0114";
}

.mdi-cash-100::before {
  content: "\\f0115";
}

.mdi-cash-check::before {
  content: "\\f14ee";
}

.mdi-cash-lock::before {
  content: "\\f14ea";
}

.mdi-cash-lock-open::before {
  content: "\\f14eb";
}

.mdi-cash-marker::before {
  content: "\\f0db8";
}

.mdi-cash-minus::before {
  content: "\\f1260";
}

.mdi-cash-multiple::before {
  content: "\\f0116";
}

.mdi-cash-plus::before {
  content: "\\f1261";
}

.mdi-cash-refund::before {
  content: "\\f0a9c";
}

.mdi-cash-register::before {
  content: "\\f0cf4";
}

.mdi-cash-remove::before {
  content: "\\f1262";
}

.mdi-cash-usd::before {
  content: "\\f1176";
}

.mdi-cash-usd-outline::before {
  content: "\\f0117";
}

.mdi-cassette::before {
  content: "\\f09d4";
}

.mdi-cast::before {
  content: "\\f0118";
}

.mdi-cast-audio::before {
  content: "\\f101e";
}

.mdi-cast-connected::before {
  content: "\\f0119";
}

.mdi-cast-education::before {
  content: "\\f0e1d";
}

.mdi-cast-off::before {
  content: "\\f078a";
}

.mdi-castle::before {
  content: "\\f011a";
}

.mdi-cat::before {
  content: "\\f011b";
}

.mdi-cctv::before {
  content: "\\f07ae";
}

.mdi-ceiling-light::before {
  content: "\\f0769";
}

.mdi-cellphone::before {
  content: "\\f011c";
}

.mdi-cellphone-android::before {
  content: "\\f011d";
}

.mdi-cellphone-arrow-down::before {
  content: "\\f09d5";
}

.mdi-cellphone-basic::before {
  content: "\\f011e";
}

.mdi-cellphone-charging::before {
  content: "\\f1397";
}

.mdi-cellphone-cog::before {
  content: "\\f0951";
}

.mdi-cellphone-dock::before {
  content: "\\f011f";
}

.mdi-cellphone-erase::before {
  content: "\\f094d";
}

.mdi-cellphone-information::before {
  content: "\\f0f41";
}

.mdi-cellphone-iphone::before {
  content: "\\f0120";
}

.mdi-cellphone-key::before {
  content: "\\f094e";
}

.mdi-cellphone-link::before {
  content: "\\f0121";
}

.mdi-cellphone-link-off::before {
  content: "\\f0122";
}

.mdi-cellphone-lock::before {
  content: "\\f094f";
}

.mdi-cellphone-message::before {
  content: "\\f08d3";
}

.mdi-cellphone-message-off::before {
  content: "\\f10d2";
}

.mdi-cellphone-nfc::before {
  content: "\\f0e90";
}

.mdi-cellphone-nfc-off::before {
  content: "\\f12d8";
}

.mdi-cellphone-off::before {
  content: "\\f0950";
}

.mdi-cellphone-play::before {
  content: "\\f101f";
}

.mdi-cellphone-screenshot::before {
  content: "\\f0a35";
}

.mdi-cellphone-settings::before {
  content: "\\f0123";
}

.mdi-cellphone-sound::before {
  content: "\\f0952";
}

.mdi-cellphone-text::before {
  content: "\\f08d2";
}

.mdi-cellphone-wireless::before {
  content: "\\f0815";
}

.mdi-celtic-cross::before {
  content: "\\f0cf5";
}

.mdi-centos::before {
  content: "\\f111a";
}

.mdi-certificate::before {
  content: "\\f0124";
}

.mdi-certificate-outline::before {
  content: "\\f1188";
}

.mdi-chair-rolling::before {
  content: "\\f0f48";
}

.mdi-chair-school::before {
  content: "\\f0125";
}

.mdi-charity::before {
  content: "\\f0c4f";
}

.mdi-chart-arc::before {
  content: "\\f0126";
}

.mdi-chart-areaspline::before {
  content: "\\f0127";
}

.mdi-chart-areaspline-variant::before {
  content: "\\f0e91";
}

.mdi-chart-bar::before {
  content: "\\f0128";
}

.mdi-chart-bar-stacked::before {
  content: "\\f076a";
}

.mdi-chart-bell-curve::before {
  content: "\\f0c50";
}

.mdi-chart-bell-curve-cumulative::before {
  content: "\\f0fa7";
}

.mdi-chart-box::before {
  content: "\\f154d";
}

.mdi-chart-box-outline::before {
  content: "\\f154e";
}

.mdi-chart-box-plus-outline::before {
  content: "\\f154f";
}

.mdi-chart-bubble::before {
  content: "\\f05e3";
}

.mdi-chart-donut::before {
  content: "\\f07af";
}

.mdi-chart-donut-variant::before {
  content: "\\f07b0";
}

.mdi-chart-gantt::before {
  content: "\\f066c";
}

.mdi-chart-histogram::before {
  content: "\\f0129";
}

.mdi-chart-line::before {
  content: "\\f012a";
}

.mdi-chart-line-stacked::before {
  content: "\\f076b";
}

.mdi-chart-line-variant::before {
  content: "\\f07b1";
}

.mdi-chart-multiline::before {
  content: "\\f08d4";
}

.mdi-chart-multiple::before {
  content: "\\f1213";
}

.mdi-chart-pie::before {
  content: "\\f012b";
}

.mdi-chart-ppf::before {
  content: "\\f1380";
}

.mdi-chart-sankey::before {
  content: "\\f11df";
}

.mdi-chart-sankey-variant::before {
  content: "\\f11e0";
}

.mdi-chart-scatter-plot::before {
  content: "\\f0e92";
}

.mdi-chart-scatter-plot-hexbin::before {
  content: "\\f066d";
}

.mdi-chart-timeline::before {
  content: "\\f066e";
}

.mdi-chart-timeline-variant::before {
  content: "\\f0e93";
}

.mdi-chart-timeline-variant-shimmer::before {
  content: "\\f15b6";
}

.mdi-chart-tree::before {
  content: "\\f0e94";
}

.mdi-chat::before {
  content: "\\f0b79";
}

.mdi-chat-alert::before {
  content: "\\f0b7a";
}

.mdi-chat-alert-outline::before {
  content: "\\f12c9";
}

.mdi-chat-minus::before {
  content: "\\f1410";
}

.mdi-chat-minus-outline::before {
  content: "\\f1413";
}

.mdi-chat-outline::before {
  content: "\\f0ede";
}

.mdi-chat-plus::before {
  content: "\\f140f";
}

.mdi-chat-plus-outline::before {
  content: "\\f1412";
}

.mdi-chat-processing::before {
  content: "\\f0b7b";
}

.mdi-chat-processing-outline::before {
  content: "\\f12ca";
}

.mdi-chat-remove::before {
  content: "\\f1411";
}

.mdi-chat-remove-outline::before {
  content: "\\f1414";
}

.mdi-chat-sleep::before {
  content: "\\f12d1";
}

.mdi-chat-sleep-outline::before {
  content: "\\f12d2";
}

.mdi-check::before {
  content: "\\f012c";
}

.mdi-check-all::before {
  content: "\\f012d";
}

.mdi-check-bold::before {
  content: "\\f0e1e";
}

.mdi-check-box-multiple-outline::before {
  content: "\\f0c51";
}

.mdi-check-box-outline::before {
  content: "\\f0c52";
}

.mdi-check-circle::before {
  content: "\\f05e0";
}

.mdi-check-circle-outline::before {
  content: "\\f05e1";
}

.mdi-check-decagram::before {
  content: "\\f0791";
}

.mdi-check-network::before {
  content: "\\f0c53";
}

.mdi-check-network-outline::before {
  content: "\\f0c54";
}

.mdi-check-outline::before {
  content: "\\f0855";
}

.mdi-check-underline::before {
  content: "\\f0e1f";
}

.mdi-check-underline-circle::before {
  content: "\\f0e20";
}

.mdi-check-underline-circle-outline::before {
  content: "\\f0e21";
}

.mdi-checkbook::before {
  content: "\\f0a9d";
}

.mdi-checkbox-blank::before {
  content: "\\f012e";
}

.mdi-checkbox-blank-circle::before {
  content: "\\f012f";
}

.mdi-checkbox-blank-circle-outline::before {
  content: "\\f0130";
}

.mdi-checkbox-blank-off::before {
  content: "\\f12ec";
}

.mdi-checkbox-blank-off-outline::before {
  content: "\\f12ed";
}

.mdi-checkbox-blank-outline::before {
  content: "\\f0131";
}

.mdi-checkbox-intermediate::before {
  content: "\\f0856";
}

.mdi-checkbox-marked::before {
  content: "\\f0132";
}

.mdi-checkbox-marked-circle::before {
  content: "\\f0133";
}

.mdi-checkbox-marked-circle-outline::before {
  content: "\\f0134";
}

.mdi-checkbox-marked-outline::before {
  content: "\\f0135";
}

.mdi-checkbox-multiple-blank::before {
  content: "\\f0136";
}

.mdi-checkbox-multiple-blank-circle::before {
  content: "\\f063b";
}

.mdi-checkbox-multiple-blank-circle-outline::before {
  content: "\\f063c";
}

.mdi-checkbox-multiple-blank-outline::before {
  content: "\\f0137";
}

.mdi-checkbox-multiple-marked::before {
  content: "\\f0138";
}

.mdi-checkbox-multiple-marked-circle::before {
  content: "\\f063d";
}

.mdi-checkbox-multiple-marked-circle-outline::before {
  content: "\\f063e";
}

.mdi-checkbox-multiple-marked-outline::before {
  content: "\\f0139";
}

.mdi-checkerboard::before {
  content: "\\f013a";
}

.mdi-checkerboard-minus::before {
  content: "\\f1202";
}

.mdi-checkerboard-plus::before {
  content: "\\f1201";
}

.mdi-checkerboard-remove::before {
  content: "\\f1203";
}

.mdi-cheese::before {
  content: "\\f12b9";
}

.mdi-cheese-off::before {
  content: "\\f13ee";
}

.mdi-chef-hat::before {
  content: "\\f0b7c";
}

.mdi-chemical-weapon::before {
  content: "\\f013b";
}

.mdi-chess-bishop::before {
  content: "\\f085c";
}

.mdi-chess-king::before {
  content: "\\f0857";
}

.mdi-chess-knight::before {
  content: "\\f0858";
}

.mdi-chess-pawn::before {
  content: "\\f0859";
}

.mdi-chess-queen::before {
  content: "\\f085a";
}

.mdi-chess-rook::before {
  content: "\\f085b";
}

.mdi-chevron-double-down::before {
  content: "\\f013c";
}

.mdi-chevron-double-left::before {
  content: "\\f013d";
}

.mdi-chevron-double-right::before {
  content: "\\f013e";
}

.mdi-chevron-double-up::before {
  content: "\\f013f";
}

.mdi-chevron-down::before {
  content: "\\f0140";
}

.mdi-chevron-down-box::before {
  content: "\\f09d6";
}

.mdi-chevron-down-box-outline::before {
  content: "\\f09d7";
}

.mdi-chevron-down-circle::before {
  content: "\\f0b26";
}

.mdi-chevron-down-circle-outline::before {
  content: "\\f0b27";
}

.mdi-chevron-left::before {
  content: "\\f0141";
}

.mdi-chevron-left-box::before {
  content: "\\f09d8";
}

.mdi-chevron-left-box-outline::before {
  content: "\\f09d9";
}

.mdi-chevron-left-circle::before {
  content: "\\f0b28";
}

.mdi-chevron-left-circle-outline::before {
  content: "\\f0b29";
}

.mdi-chevron-right::before {
  content: "\\f0142";
}

.mdi-chevron-right-box::before {
  content: "\\f09da";
}

.mdi-chevron-right-box-outline::before {
  content: "\\f09db";
}

.mdi-chevron-right-circle::before {
  content: "\\f0b2a";
}

.mdi-chevron-right-circle-outline::before {
  content: "\\f0b2b";
}

.mdi-chevron-triple-down::before {
  content: "\\f0db9";
}

.mdi-chevron-triple-left::before {
  content: "\\f0dba";
}

.mdi-chevron-triple-right::before {
  content: "\\f0dbb";
}

.mdi-chevron-triple-up::before {
  content: "\\f0dbc";
}

.mdi-chevron-up::before {
  content: "\\f0143";
}

.mdi-chevron-up-box::before {
  content: "\\f09dc";
}

.mdi-chevron-up-box-outline::before {
  content: "\\f09dd";
}

.mdi-chevron-up-circle::before {
  content: "\\f0b2c";
}

.mdi-chevron-up-circle-outline::before {
  content: "\\f0b2d";
}

.mdi-chili-hot::before {
  content: "\\f07b2";
}

.mdi-chili-medium::before {
  content: "\\f07b3";
}

.mdi-chili-mild::before {
  content: "\\f07b4";
}

.mdi-chili-off::before {
  content: "\\f1467";
}

.mdi-chip::before {
  content: "\\f061a";
}

.mdi-christianity::before {
  content: "\\f0953";
}

.mdi-christianity-outline::before {
  content: "\\f0cf6";
}

.mdi-church::before {
  content: "\\f0144";
}

.mdi-cigar::before {
  content: "\\f1189";
}

.mdi-cigar-off::before {
  content: "\\f141b";
}

.mdi-circle::before {
  content: "\\f0765";
}

.mdi-circle-box::before {
  content: "\\f15dc";
}

.mdi-circle-box-outline::before {
  content: "\\f15dd";
}

.mdi-circle-double::before {
  content: "\\f0e95";
}

.mdi-circle-edit-outline::before {
  content: "\\f08d5";
}

.mdi-circle-expand::before {
  content: "\\f0e96";
}

.mdi-circle-half::before {
  content: "\\f1395";
}

.mdi-circle-half-full::before {
  content: "\\f1396";
}

.mdi-circle-medium::before {
  content: "\\f09de";
}

.mdi-circle-multiple::before {
  content: "\\f0b38";
}

.mdi-circle-multiple-outline::before {
  content: "\\f0695";
}

.mdi-circle-off-outline::before {
  content: "\\f10d3";
}

.mdi-circle-outline::before {
  content: "\\f0766";
}

.mdi-circle-slice-1::before {
  content: "\\f0a9e";
}

.mdi-circle-slice-2::before {
  content: "\\f0a9f";
}

.mdi-circle-slice-3::before {
  content: "\\f0aa0";
}

.mdi-circle-slice-4::before {
  content: "\\f0aa1";
}

.mdi-circle-slice-5::before {
  content: "\\f0aa2";
}

.mdi-circle-slice-6::before {
  content: "\\f0aa3";
}

.mdi-circle-slice-7::before {
  content: "\\f0aa4";
}

.mdi-circle-slice-8::before {
  content: "\\f0aa5";
}

.mdi-circle-small::before {
  content: "\\f09df";
}

.mdi-circular-saw::before {
  content: "\\f0e22";
}

.mdi-city::before {
  content: "\\f0146";
}

.mdi-city-variant::before {
  content: "\\f0a36";
}

.mdi-city-variant-outline::before {
  content: "\\f0a37";
}

.mdi-clipboard::before {
  content: "\\f0147";
}

.mdi-clipboard-account::before {
  content: "\\f0148";
}

.mdi-clipboard-account-outline::before {
  content: "\\f0c55";
}

.mdi-clipboard-alert::before {
  content: "\\f0149";
}

.mdi-clipboard-alert-outline::before {
  content: "\\f0cf7";
}

.mdi-clipboard-arrow-down::before {
  content: "\\f014a";
}

.mdi-clipboard-arrow-down-outline::before {
  content: "\\f0c56";
}

.mdi-clipboard-arrow-left::before {
  content: "\\f014b";
}

.mdi-clipboard-arrow-left-outline::before {
  content: "\\f0cf8";
}

.mdi-clipboard-arrow-right::before {
  content: "\\f0cf9";
}

.mdi-clipboard-arrow-right-outline::before {
  content: "\\f0cfa";
}

.mdi-clipboard-arrow-up::before {
  content: "\\f0c57";
}

.mdi-clipboard-arrow-up-outline::before {
  content: "\\f0c58";
}

.mdi-clipboard-check::before {
  content: "\\f014e";
}

.mdi-clipboard-check-multiple::before {
  content: "\\f1263";
}

.mdi-clipboard-check-multiple-outline::before {
  content: "\\f1264";
}

.mdi-clipboard-check-outline::before {
  content: "\\f08a8";
}

.mdi-clipboard-edit::before {
  content: "\\f14e5";
}

.mdi-clipboard-edit-outline::before {
  content: "\\f14e6";
}

.mdi-clipboard-file::before {
  content: "\\f1265";
}

.mdi-clipboard-file-outline::before {
  content: "\\f1266";
}

.mdi-clipboard-flow::before {
  content: "\\f06c8";
}

.mdi-clipboard-flow-outline::before {
  content: "\\f1117";
}

.mdi-clipboard-list::before {
  content: "\\f10d4";
}

.mdi-clipboard-list-outline::before {
  content: "\\f10d5";
}

.mdi-clipboard-minus::before {
  content: "\\f1618";
}

.mdi-clipboard-minus-outline::before {
  content: "\\f1619";
}

.mdi-clipboard-multiple::before {
  content: "\\f1267";
}

.mdi-clipboard-multiple-outline::before {
  content: "\\f1268";
}

.mdi-clipboard-off::before {
  content: "\\f161a";
}

.mdi-clipboard-off-outline::before {
  content: "\\f161b";
}

.mdi-clipboard-outline::before {
  content: "\\f014c";
}

.mdi-clipboard-play::before {
  content: "\\f0c59";
}

.mdi-clipboard-play-multiple::before {
  content: "\\f1269";
}

.mdi-clipboard-play-multiple-outline::before {
  content: "\\f126a";
}

.mdi-clipboard-play-outline::before {
  content: "\\f0c5a";
}

.mdi-clipboard-plus::before {
  content: "\\f0751";
}

.mdi-clipboard-plus-outline::before {
  content: "\\f131f";
}

.mdi-clipboard-pulse::before {
  content: "\\f085d";
}

.mdi-clipboard-pulse-outline::before {
  content: "\\f085e";
}

.mdi-clipboard-remove::before {
  content: "\\f161c";
}

.mdi-clipboard-remove-outline::before {
  content: "\\f161d";
}

.mdi-clipboard-search::before {
  content: "\\f161e";
}

.mdi-clipboard-search-outline::before {
  content: "\\f161f";
}

.mdi-clipboard-text::before {
  content: "\\f014d";
}

.mdi-clipboard-text-multiple::before {
  content: "\\f126b";
}

.mdi-clipboard-text-multiple-outline::before {
  content: "\\f126c";
}

.mdi-clipboard-text-off::before {
  content: "\\f1620";
}

.mdi-clipboard-text-off-outline::before {
  content: "\\f1621";
}

.mdi-clipboard-text-outline::before {
  content: "\\f0a38";
}

.mdi-clipboard-text-play::before {
  content: "\\f0c5b";
}

.mdi-clipboard-text-play-outline::before {
  content: "\\f0c5c";
}

.mdi-clipboard-text-search::before {
  content: "\\f1622";
}

.mdi-clipboard-text-search-outline::before {
  content: "\\f1623";
}

.mdi-clippy::before {
  content: "\\f014f";
}

.mdi-clock::before {
  content: "\\f0954";
}

.mdi-clock-alert::before {
  content: "\\f0955";
}

.mdi-clock-alert-outline::before {
  content: "\\f05ce";
}

.mdi-clock-check::before {
  content: "\\f0fa8";
}

.mdi-clock-check-outline::before {
  content: "\\f0fa9";
}

.mdi-clock-digital::before {
  content: "\\f0e97";
}

.mdi-clock-end::before {
  content: "\\f0151";
}

.mdi-clock-fast::before {
  content: "\\f0152";
}

.mdi-clock-in::before {
  content: "\\f0153";
}

.mdi-clock-out::before {
  content: "\\f0154";
}

.mdi-clock-outline::before {
  content: "\\f0150";
}

.mdi-clock-start::before {
  content: "\\f0155";
}

.mdi-clock-time-eight::before {
  content: "\\f1446";
}

.mdi-clock-time-eight-outline::before {
  content: "\\f1452";
}

.mdi-clock-time-eleven::before {
  content: "\\f1449";
}

.mdi-clock-time-eleven-outline::before {
  content: "\\f1455";
}

.mdi-clock-time-five::before {
  content: "\\f1443";
}

.mdi-clock-time-five-outline::before {
  content: "\\f144f";
}

.mdi-clock-time-four::before {
  content: "\\f1442";
}

.mdi-clock-time-four-outline::before {
  content: "\\f144e";
}

.mdi-clock-time-nine::before {
  content: "\\f1447";
}

.mdi-clock-time-nine-outline::before {
  content: "\\f1453";
}

.mdi-clock-time-one::before {
  content: "\\f143f";
}

.mdi-clock-time-one-outline::before {
  content: "\\f144b";
}

.mdi-clock-time-seven::before {
  content: "\\f1445";
}

.mdi-clock-time-seven-outline::before {
  content: "\\f1451";
}

.mdi-clock-time-six::before {
  content: "\\f1444";
}

.mdi-clock-time-six-outline::before {
  content: "\\f1450";
}

.mdi-clock-time-ten::before {
  content: "\\f1448";
}

.mdi-clock-time-ten-outline::before {
  content: "\\f1454";
}

.mdi-clock-time-three::before {
  content: "\\f1441";
}

.mdi-clock-time-three-outline::before {
  content: "\\f144d";
}

.mdi-clock-time-twelve::before {
  content: "\\f144a";
}

.mdi-clock-time-twelve-outline::before {
  content: "\\f1456";
}

.mdi-clock-time-two::before {
  content: "\\f1440";
}

.mdi-clock-time-two-outline::before {
  content: "\\f144c";
}

.mdi-close::before {
  content: "\\f0156";
}

.mdi-close-box::before {
  content: "\\f0157";
}

.mdi-close-box-multiple::before {
  content: "\\f0c5d";
}

.mdi-close-box-multiple-outline::before {
  content: "\\f0c5e";
}

.mdi-close-box-outline::before {
  content: "\\f0158";
}

.mdi-close-circle::before {
  content: "\\f0159";
}

.mdi-close-circle-multiple::before {
  content: "\\f062a";
}

.mdi-close-circle-multiple-outline::before {
  content: "\\f0883";
}

.mdi-close-circle-outline::before {
  content: "\\f015a";
}

.mdi-close-network::before {
  content: "\\f015b";
}

.mdi-close-network-outline::before {
  content: "\\f0c5f";
}

.mdi-close-octagon::before {
  content: "\\f015c";
}

.mdi-close-octagon-outline::before {
  content: "\\f015d";
}

.mdi-close-outline::before {
  content: "\\f06c9";
}

.mdi-close-thick::before {
  content: "\\f1398";
}

.mdi-closed-caption::before {
  content: "\\f015e";
}

.mdi-closed-caption-outline::before {
  content: "\\f0dbd";
}

.mdi-cloud::before {
  content: "\\f015f";
}

.mdi-cloud-alert::before {
  content: "\\f09e0";
}

.mdi-cloud-braces::before {
  content: "\\f07b5";
}

.mdi-cloud-check::before {
  content: "\\f0160";
}

.mdi-cloud-check-outline::before {
  content: "\\f12cc";
}

.mdi-cloud-circle::before {
  content: "\\f0161";
}

.mdi-cloud-download::before {
  content: "\\f0162";
}

.mdi-cloud-download-outline::before {
  content: "\\f0b7d";
}

.mdi-cloud-lock::before {
  content: "\\f11f1";
}

.mdi-cloud-lock-outline::before {
  content: "\\f11f2";
}

.mdi-cloud-off-outline::before {
  content: "\\f0164";
}

.mdi-cloud-outline::before {
  content: "\\f0163";
}

.mdi-cloud-print::before {
  content: "\\f0165";
}

.mdi-cloud-print-outline::before {
  content: "\\f0166";
}

.mdi-cloud-question::before {
  content: "\\f0a39";
}

.mdi-cloud-refresh::before {
  content: "\\f052a";
}

.mdi-cloud-search::before {
  content: "\\f0956";
}

.mdi-cloud-search-outline::before {
  content: "\\f0957";
}

.mdi-cloud-sync::before {
  content: "\\f063f";
}

.mdi-cloud-sync-outline::before {
  content: "\\f12d6";
}

.mdi-cloud-tags::before {
  content: "\\f07b6";
}

.mdi-cloud-upload::before {
  content: "\\f0167";
}

.mdi-cloud-upload-outline::before {
  content: "\\f0b7e";
}

.mdi-clover::before {
  content: "\\f0816";
}

.mdi-coach-lamp::before {
  content: "\\f1020";
}

.mdi-coat-rack::before {
  content: "\\f109e";
}

.mdi-code-array::before {
  content: "\\f0168";
}

.mdi-code-braces::before {
  content: "\\f0169";
}

.mdi-code-braces-box::before {
  content: "\\f10d6";
}

.mdi-code-brackets::before {
  content: "\\f016a";
}

.mdi-code-equal::before {
  content: "\\f016b";
}

.mdi-code-greater-than::before {
  content: "\\f016c";
}

.mdi-code-greater-than-or-equal::before {
  content: "\\f016d";
}

.mdi-code-json::before {
  content: "\\f0626";
}

.mdi-code-less-than::before {
  content: "\\f016e";
}

.mdi-code-less-than-or-equal::before {
  content: "\\f016f";
}

.mdi-code-not-equal::before {
  content: "\\f0170";
}

.mdi-code-not-equal-variant::before {
  content: "\\f0171";
}

.mdi-code-parentheses::before {
  content: "\\f0172";
}

.mdi-code-parentheses-box::before {
  content: "\\f10d7";
}

.mdi-code-string::before {
  content: "\\f0173";
}

.mdi-code-tags::before {
  content: "\\f0174";
}

.mdi-code-tags-check::before {
  content: "\\f0694";
}

.mdi-codepen::before {
  content: "\\f0175";
}

.mdi-coffee::before {
  content: "\\f0176";
}

.mdi-coffee-maker::before {
  content: "\\f109f";
}

.mdi-coffee-off::before {
  content: "\\f0faa";
}

.mdi-coffee-off-outline::before {
  content: "\\f0fab";
}

.mdi-coffee-outline::before {
  content: "\\f06ca";
}

.mdi-coffee-to-go::before {
  content: "\\f0177";
}

.mdi-coffee-to-go-outline::before {
  content: "\\f130e";
}

.mdi-coffin::before {
  content: "\\f0b7f";
}

.mdi-cog::before {
  content: "\\f0493";
}

.mdi-cog-box::before {
  content: "\\f0494";
}

.mdi-cog-clockwise::before {
  content: "\\f11dd";
}

.mdi-cog-counterclockwise::before {
  content: "\\f11de";
}

.mdi-cog-off::before {
  content: "\\f13ce";
}

.mdi-cog-off-outline::before {
  content: "\\f13cf";
}

.mdi-cog-outline::before {
  content: "\\f08bb";
}

.mdi-cog-refresh::before {
  content: "\\f145e";
}

.mdi-cog-refresh-outline::before {
  content: "\\f145f";
}

.mdi-cog-sync::before {
  content: "\\f1460";
}

.mdi-cog-sync-outline::before {
  content: "\\f1461";
}

.mdi-cog-transfer::before {
  content: "\\f105b";
}

.mdi-cog-transfer-outline::before {
  content: "\\f105c";
}

.mdi-cogs::before {
  content: "\\f08d6";
}

.mdi-collage::before {
  content: "\\f0640";
}

.mdi-collapse-all::before {
  content: "\\f0aa6";
}

.mdi-collapse-all-outline::before {
  content: "\\f0aa7";
}

.mdi-color-helper::before {
  content: "\\f0179";
}

.mdi-comma::before {
  content: "\\f0e23";
}

.mdi-comma-box::before {
  content: "\\f0e2b";
}

.mdi-comma-box-outline::before {
  content: "\\f0e24";
}

.mdi-comma-circle::before {
  content: "\\f0e25";
}

.mdi-comma-circle-outline::before {
  content: "\\f0e26";
}

.mdi-comment::before {
  content: "\\f017a";
}

.mdi-comment-account::before {
  content: "\\f017b";
}

.mdi-comment-account-outline::before {
  content: "\\f017c";
}

.mdi-comment-alert::before {
  content: "\\f017d";
}

.mdi-comment-alert-outline::before {
  content: "\\f017e";
}

.mdi-comment-arrow-left::before {
  content: "\\f09e1";
}

.mdi-comment-arrow-left-outline::before {
  content: "\\f09e2";
}

.mdi-comment-arrow-right::before {
  content: "\\f09e3";
}

.mdi-comment-arrow-right-outline::before {
  content: "\\f09e4";
}

.mdi-comment-bookmark::before {
  content: "\\f15ae";
}

.mdi-comment-bookmark-outline::before {
  content: "\\f15af";
}

.mdi-comment-check::before {
  content: "\\f017f";
}

.mdi-comment-check-outline::before {
  content: "\\f0180";
}

.mdi-comment-edit::before {
  content: "\\f11bf";
}

.mdi-comment-edit-outline::before {
  content: "\\f12c4";
}

.mdi-comment-eye::before {
  content: "\\f0a3a";
}

.mdi-comment-eye-outline::before {
  content: "\\f0a3b";
}

.mdi-comment-flash::before {
  content: "\\f15b0";
}

.mdi-comment-flash-outline::before {
  content: "\\f15b1";
}

.mdi-comment-minus::before {
  content: "\\f15df";
}

.mdi-comment-minus-outline::before {
  content: "\\f15e0";
}

.mdi-comment-multiple::before {
  content: "\\f085f";
}

.mdi-comment-multiple-outline::before {
  content: "\\f0181";
}

.mdi-comment-off::before {
  content: "\\f15e1";
}

.mdi-comment-off-outline::before {
  content: "\\f15e2";
}

.mdi-comment-outline::before {
  content: "\\f0182";
}

.mdi-comment-plus::before {
  content: "\\f09e5";
}

.mdi-comment-plus-outline::before {
  content: "\\f0183";
}

.mdi-comment-processing::before {
  content: "\\f0184";
}

.mdi-comment-processing-outline::before {
  content: "\\f0185";
}

.mdi-comment-question::before {
  content: "\\f0817";
}

.mdi-comment-question-outline::before {
  content: "\\f0186";
}

.mdi-comment-quote::before {
  content: "\\f1021";
}

.mdi-comment-quote-outline::before {
  content: "\\f1022";
}

.mdi-comment-remove::before {
  content: "\\f05de";
}

.mdi-comment-remove-outline::before {
  content: "\\f0187";
}

.mdi-comment-search::before {
  content: "\\f0a3c";
}

.mdi-comment-search-outline::before {
  content: "\\f0a3d";
}

.mdi-comment-text::before {
  content: "\\f0188";
}

.mdi-comment-text-multiple::before {
  content: "\\f0860";
}

.mdi-comment-text-multiple-outline::before {
  content: "\\f0861";
}

.mdi-comment-text-outline::before {
  content: "\\f0189";
}

.mdi-compare::before {
  content: "\\f018a";
}

.mdi-compare-horizontal::before {
  content: "\\f1492";
}

.mdi-compare-vertical::before {
  content: "\\f1493";
}

.mdi-compass::before {
  content: "\\f018b";
}

.mdi-compass-off::before {
  content: "\\f0b80";
}

.mdi-compass-off-outline::before {
  content: "\\f0b81";
}

.mdi-compass-outline::before {
  content: "\\f018c";
}

.mdi-compass-rose::before {
  content: "\\f1382";
}

.mdi-concourse-ci::before {
  content: "\\f10a0";
}

.mdi-connection::before {
  content: "\\f1616";
}

.mdi-console::before {
  content: "\\f018d";
}

.mdi-console-line::before {
  content: "\\f07b7";
}

.mdi-console-network::before {
  content: "\\f08a9";
}

.mdi-console-network-outline::before {
  content: "\\f0c60";
}

.mdi-consolidate::before {
  content: "\\f10d8";
}

.mdi-contactless-payment::before {
  content: "\\f0d6a";
}

.mdi-contactless-payment-circle::before {
  content: "\\f0321";
}

.mdi-contactless-payment-circle-outline::before {
  content: "\\f0408";
}

.mdi-contacts::before {
  content: "\\f06cb";
}

.mdi-contacts-outline::before {
  content: "\\f05b8";
}

.mdi-contain::before {
  content: "\\f0a3e";
}

.mdi-contain-end::before {
  content: "\\f0a3f";
}

.mdi-contain-start::before {
  content: "\\f0a40";
}

.mdi-content-copy::before {
  content: "\\f018f";
}

.mdi-content-cut::before {
  content: "\\f0190";
}

.mdi-content-duplicate::before {
  content: "\\f0191";
}

.mdi-content-paste::before {
  content: "\\f0192";
}

.mdi-content-save::before {
  content: "\\f0193";
}

.mdi-content-save-alert::before {
  content: "\\f0f42";
}

.mdi-content-save-alert-outline::before {
  content: "\\f0f43";
}

.mdi-content-save-all::before {
  content: "\\f0194";
}

.mdi-content-save-all-outline::before {
  content: "\\f0f44";
}

.mdi-content-save-cog::before {
  content: "\\f145b";
}

.mdi-content-save-cog-outline::before {
  content: "\\f145c";
}

.mdi-content-save-edit::before {
  content: "\\f0cfb";
}

.mdi-content-save-edit-outline::before {
  content: "\\f0cfc";
}

.mdi-content-save-move::before {
  content: "\\f0e27";
}

.mdi-content-save-move-outline::before {
  content: "\\f0e28";
}

.mdi-content-save-off::before {
  content: "\\f1643";
}

.mdi-content-save-off-outline::before {
  content: "\\f1644";
}

.mdi-content-save-outline::before {
  content: "\\f0818";
}

.mdi-content-save-settings::before {
  content: "\\f061b";
}

.mdi-content-save-settings-outline::before {
  content: "\\f0b2e";
}

.mdi-contrast::before {
  content: "\\f0195";
}

.mdi-contrast-box::before {
  content: "\\f0196";
}

.mdi-contrast-circle::before {
  content: "\\f0197";
}

.mdi-controller-classic::before {
  content: "\\f0b82";
}

.mdi-controller-classic-outline::before {
  content: "\\f0b83";
}

.mdi-cookie::before {
  content: "\\f0198";
}

.mdi-cookie-alert::before {
  content: "\\f16d0";
}

.mdi-cookie-alert-outline::before {
  content: "\\f16d1";
}

.mdi-cookie-check::before {
  content: "\\f16d2";
}

.mdi-cookie-check-outline::before {
  content: "\\f16d3";
}

.mdi-cookie-cog::before {
  content: "\\f16d4";
}

.mdi-cookie-cog-outline::before {
  content: "\\f16d5";
}

.mdi-cookie-minus::before {
  content: "\\f16da";
}

.mdi-cookie-minus-outline::before {
  content: "\\f16db";
}

.mdi-cookie-outline::before {
  content: "\\f16de";
}

.mdi-cookie-plus::before {
  content: "\\f16d6";
}

.mdi-cookie-plus-outline::before {
  content: "\\f16d7";
}

.mdi-cookie-remove::before {
  content: "\\f16d8";
}

.mdi-cookie-remove-outline::before {
  content: "\\f16d9";
}

.mdi-cookie-settings::before {
  content: "\\f16dc";
}

.mdi-cookie-settings-outline::before {
  content: "\\f16dd";
}

.mdi-coolant-temperature::before {
  content: "\\f03c8";
}

.mdi-copyright::before {
  content: "\\f05e6";
}

.mdi-cordova::before {
  content: "\\f0958";
}

.mdi-corn::before {
  content: "\\f07b8";
}

.mdi-corn-off::before {
  content: "\\f13ef";
}

.mdi-cosine-wave::before {
  content: "\\f1479";
}

.mdi-counter::before {
  content: "\\f0199";
}

.mdi-cow::before {
  content: "\\f019a";
}

.mdi-cpu-32-bit::before {
  content: "\\f0edf";
}

.mdi-cpu-64-bit::before {
  content: "\\f0ee0";
}

.mdi-crane::before {
  content: "\\f0862";
}

.mdi-creation::before {
  content: "\\f0674";
}

.mdi-creative-commons::before {
  content: "\\f0d6b";
}

.mdi-credit-card::before {
  content: "\\f0fef";
}

.mdi-credit-card-check::before {
  content: "\\f13d0";
}

.mdi-credit-card-check-outline::before {
  content: "\\f13d1";
}

.mdi-credit-card-clock::before {
  content: "\\f0ee1";
}

.mdi-credit-card-clock-outline::before {
  content: "\\f0ee2";
}

.mdi-credit-card-marker::before {
  content: "\\f06a8";
}

.mdi-credit-card-marker-outline::before {
  content: "\\f0dbe";
}

.mdi-credit-card-minus::before {
  content: "\\f0fac";
}

.mdi-credit-card-minus-outline::before {
  content: "\\f0fad";
}

.mdi-credit-card-multiple::before {
  content: "\\f0ff0";
}

.mdi-credit-card-multiple-outline::before {
  content: "\\f019c";
}

.mdi-credit-card-off::before {
  content: "\\f0ff1";
}

.mdi-credit-card-off-outline::before {
  content: "\\f05e4";
}

.mdi-credit-card-outline::before {
  content: "\\f019b";
}

.mdi-credit-card-plus::before {
  content: "\\f0ff2";
}

.mdi-credit-card-plus-outline::before {
  content: "\\f0676";
}

.mdi-credit-card-refresh::before {
  content: "\\f1645";
}

.mdi-credit-card-refresh-outline::before {
  content: "\\f1646";
}

.mdi-credit-card-refund::before {
  content: "\\f0ff3";
}

.mdi-credit-card-refund-outline::before {
  content: "\\f0aa8";
}

.mdi-credit-card-remove::before {
  content: "\\f0fae";
}

.mdi-credit-card-remove-outline::before {
  content: "\\f0faf";
}

.mdi-credit-card-scan::before {
  content: "\\f0ff4";
}

.mdi-credit-card-scan-outline::before {
  content: "\\f019d";
}

.mdi-credit-card-search::before {
  content: "\\f1647";
}

.mdi-credit-card-search-outline::before {
  content: "\\f1648";
}

.mdi-credit-card-settings::before {
  content: "\\f0ff5";
}

.mdi-credit-card-settings-outline::before {
  content: "\\f08d7";
}

.mdi-credit-card-sync::before {
  content: "\\f1649";
}

.mdi-credit-card-sync-outline::before {
  content: "\\f164a";
}

.mdi-credit-card-wireless::before {
  content: "\\f0802";
}

.mdi-credit-card-wireless-off::before {
  content: "\\f057a";
}

.mdi-credit-card-wireless-off-outline::before {
  content: "\\f057b";
}

.mdi-credit-card-wireless-outline::before {
  content: "\\f0d6c";
}

.mdi-cricket::before {
  content: "\\f0d6d";
}

.mdi-crop::before {
  content: "\\f019e";
}

.mdi-crop-free::before {
  content: "\\f019f";
}

.mdi-crop-landscape::before {
  content: "\\f01a0";
}

.mdi-crop-portrait::before {
  content: "\\f01a1";
}

.mdi-crop-rotate::before {
  content: "\\f0696";
}

.mdi-crop-square::before {
  content: "\\f01a2";
}

.mdi-crosshairs::before {
  content: "\\f01a3";
}

.mdi-crosshairs-gps::before {
  content: "\\f01a4";
}

.mdi-crosshairs-off::before {
  content: "\\f0f45";
}

.mdi-crosshairs-question::before {
  content: "\\f1136";
}

.mdi-crown::before {
  content: "\\f01a5";
}

.mdi-crown-outline::before {
  content: "\\f11d0";
}

.mdi-cryengine::before {
  content: "\\f0959";
}

.mdi-crystal-ball::before {
  content: "\\f0b2f";
}

.mdi-cube::before {
  content: "\\f01a6";
}

.mdi-cube-off::before {
  content: "\\f141c";
}

.mdi-cube-off-outline::before {
  content: "\\f141d";
}

.mdi-cube-outline::before {
  content: "\\f01a7";
}

.mdi-cube-scan::before {
  content: "\\f0b84";
}

.mdi-cube-send::before {
  content: "\\f01a8";
}

.mdi-cube-unfolded::before {
  content: "\\f01a9";
}

.mdi-cup::before {
  content: "\\f01aa";
}

.mdi-cup-off::before {
  content: "\\f05e5";
}

.mdi-cup-off-outline::before {
  content: "\\f137d";
}

.mdi-cup-outline::before {
  content: "\\f130f";
}

.mdi-cup-water::before {
  content: "\\f01ab";
}

.mdi-cupboard::before {
  content: "\\f0f46";
}

.mdi-cupboard-outline::before {
  content: "\\f0f47";
}

.mdi-cupcake::before {
  content: "\\f095a";
}

.mdi-curling::before {
  content: "\\f0863";
}

.mdi-currency-bdt::before {
  content: "\\f0864";
}

.mdi-currency-brl::before {
  content: "\\f0b85";
}

.mdi-currency-btc::before {
  content: "\\f01ac";
}

.mdi-currency-cny::before {
  content: "\\f07ba";
}

.mdi-currency-eth::before {
  content: "\\f07bb";
}

.mdi-currency-eur::before {
  content: "\\f01ad";
}

.mdi-currency-eur-off::before {
  content: "\\f1315";
}

.mdi-currency-gbp::before {
  content: "\\f01ae";
}

.mdi-currency-ils::before {
  content: "\\f0c61";
}

.mdi-currency-inr::before {
  content: "\\f01af";
}

.mdi-currency-jpy::before {
  content: "\\f07bc";
}

.mdi-currency-krw::before {
  content: "\\f07bd";
}

.mdi-currency-kzt::before {
  content: "\\f0865";
}

.mdi-currency-mnt::before {
  content: "\\f1512";
}

.mdi-currency-ngn::before {
  content: "\\f01b0";
}

.mdi-currency-php::before {
  content: "\\f09e6";
}

.mdi-currency-rial::before {
  content: "\\f0e9c";
}

.mdi-currency-rub::before {
  content: "\\f01b1";
}

.mdi-currency-sign::before {
  content: "\\f07be";
}

.mdi-currency-try::before {
  content: "\\f01b2";
}

.mdi-currency-twd::before {
  content: "\\f07bf";
}

.mdi-currency-usd::before {
  content: "\\f01c1";
}

.mdi-currency-usd-circle::before {
  content: "\\f116b";
}

.mdi-currency-usd-circle-outline::before {
  content: "\\f0178";
}

.mdi-currency-usd-off::before {
  content: "\\f067a";
}

.mdi-current-ac::before {
  content: "\\f1480";
}

.mdi-current-dc::before {
  content: "\\f095c";
}

.mdi-cursor-default::before {
  content: "\\f01c0";
}

.mdi-cursor-default-click::before {
  content: "\\f0cfd";
}

.mdi-cursor-default-click-outline::before {
  content: "\\f0cfe";
}

.mdi-cursor-default-gesture::before {
  content: "\\f1127";
}

.mdi-cursor-default-gesture-outline::before {
  content: "\\f1128";
}

.mdi-cursor-default-outline::before {
  content: "\\f01bf";
}

.mdi-cursor-move::before {
  content: "\\f01be";
}

.mdi-cursor-pointer::before {
  content: "\\f01bd";
}

.mdi-cursor-text::before {
  content: "\\f05e7";
}

.mdi-dance-ballroom::before {
  content: "\\f15fb";
}

.mdi-dance-pole::before {
  content: "\\f1578";
}

.mdi-data-matrix::before {
  content: "\\f153c";
}

.mdi-data-matrix-edit::before {
  content: "\\f153d";
}

.mdi-data-matrix-minus::before {
  content: "\\f153e";
}

.mdi-data-matrix-plus::before {
  content: "\\f153f";
}

.mdi-data-matrix-remove::before {
  content: "\\f1540";
}

.mdi-data-matrix-scan::before {
  content: "\\f1541";
}

.mdi-database::before {
  content: "\\f01bc";
}

.mdi-database-alert::before {
  content: "\\f163a";
}

.mdi-database-alert-outline::before {
  content: "\\f1624";
}

.mdi-database-arrow-down::before {
  content: "\\f163b";
}

.mdi-database-arrow-down-outline::before {
  content: "\\f1625";
}

.mdi-database-arrow-left::before {
  content: "\\f163c";
}

.mdi-database-arrow-left-outline::before {
  content: "\\f1626";
}

.mdi-database-arrow-right::before {
  content: "\\f163d";
}

.mdi-database-arrow-right-outline::before {
  content: "\\f1627";
}

.mdi-database-arrow-up::before {
  content: "\\f163e";
}

.mdi-database-arrow-up-outline::before {
  content: "\\f1628";
}

.mdi-database-check::before {
  content: "\\f0aa9";
}

.mdi-database-check-outline::before {
  content: "\\f1629";
}

.mdi-database-clock::before {
  content: "\\f163f";
}

.mdi-database-clock-outline::before {
  content: "\\f162a";
}

.mdi-database-cog::before {
  content: "\\f164b";
}

.mdi-database-cog-outline::before {
  content: "\\f164c";
}

.mdi-database-edit::before {
  content: "\\f0b86";
}

.mdi-database-edit-outline::before {
  content: "\\f162b";
}

.mdi-database-export::before {
  content: "\\f095e";
}

.mdi-database-export-outline::before {
  content: "\\f162c";
}

.mdi-database-import::before {
  content: "\\f095d";
}

.mdi-database-import-outline::before {
  content: "\\f162d";
}

.mdi-database-lock::before {
  content: "\\f0aaa";
}

.mdi-database-lock-outline::before {
  content: "\\f162e";
}

.mdi-database-marker::before {
  content: "\\f12f6";
}

.mdi-database-marker-outline::before {
  content: "\\f162f";
}

.mdi-database-minus::before {
  content: "\\f01bb";
}

.mdi-database-minus-outline::before {
  content: "\\f1630";
}

.mdi-database-off::before {
  content: "\\f1640";
}

.mdi-database-off-outline::before {
  content: "\\f1631";
}

.mdi-database-outline::before {
  content: "\\f1632";
}

.mdi-database-plus::before {
  content: "\\f01ba";
}

.mdi-database-plus-outline::before {
  content: "\\f1633";
}

.mdi-database-refresh::before {
  content: "\\f05c2";
}

.mdi-database-refresh-outline::before {
  content: "\\f1634";
}

.mdi-database-remove::before {
  content: "\\f0d00";
}

.mdi-database-remove-outline::before {
  content: "\\f1635";
}

.mdi-database-search::before {
  content: "\\f0866";
}

.mdi-database-search-outline::before {
  content: "\\f1636";
}

.mdi-database-settings::before {
  content: "\\f0d01";
}

.mdi-database-settings-outline::before {
  content: "\\f1637";
}

.mdi-database-sync::before {
  content: "\\f0cff";
}

.mdi-database-sync-outline::before {
  content: "\\f1638";
}

.mdi-death-star::before {
  content: "\\f08d8";
}

.mdi-death-star-variant::before {
  content: "\\f08d9";
}

.mdi-deathly-hallows::before {
  content: "\\f0b87";
}

.mdi-debian::before {
  content: "\\f08da";
}

.mdi-debug-step-into::before {
  content: "\\f01b9";
}

.mdi-debug-step-out::before {
  content: "\\f01b8";
}

.mdi-debug-step-over::before {
  content: "\\f01b7";
}

.mdi-decagram::before {
  content: "\\f076c";
}

.mdi-decagram-outline::before {
  content: "\\f076d";
}

.mdi-decimal::before {
  content: "\\f10a1";
}

.mdi-decimal-comma::before {
  content: "\\f10a2";
}

.mdi-decimal-comma-decrease::before {
  content: "\\f10a3";
}

.mdi-decimal-comma-increase::before {
  content: "\\f10a4";
}

.mdi-decimal-decrease::before {
  content: "\\f01b6";
}

.mdi-decimal-increase::before {
  content: "\\f01b5";
}

.mdi-delete::before {
  content: "\\f01b4";
}

.mdi-delete-alert::before {
  content: "\\f10a5";
}

.mdi-delete-alert-outline::before {
  content: "\\f10a6";
}

.mdi-delete-circle::before {
  content: "\\f0683";
}

.mdi-delete-circle-outline::before {
  content: "\\f0b88";
}

.mdi-delete-clock::before {
  content: "\\f1556";
}

.mdi-delete-clock-outline::before {
  content: "\\f1557";
}

.mdi-delete-empty::before {
  content: "\\f06cc";
}

.mdi-delete-empty-outline::before {
  content: "\\f0e9d";
}

.mdi-delete-forever::before {
  content: "\\f05e8";
}

.mdi-delete-forever-outline::before {
  content: "\\f0b89";
}

.mdi-delete-off::before {
  content: "\\f10a7";
}

.mdi-delete-off-outline::before {
  content: "\\f10a8";
}

.mdi-delete-outline::before {
  content: "\\f09e7";
}

.mdi-delete-restore::before {
  content: "\\f0819";
}

.mdi-delete-sweep::before {
  content: "\\f05e9";
}

.mdi-delete-sweep-outline::before {
  content: "\\f0c62";
}

.mdi-delete-variant::before {
  content: "\\f01b3";
}

.mdi-delta::before {
  content: "\\f01c2";
}

.mdi-desk::before {
  content: "\\f1239";
}

.mdi-desk-lamp::before {
  content: "\\f095f";
}

.mdi-deskphone::before {
  content: "\\f01c3";
}

.mdi-desktop-classic::before {
  content: "\\f07c0";
}

.mdi-desktop-mac::before {
  content: "\\f01c4";
}

.mdi-desktop-mac-dashboard::before {
  content: "\\f09e8";
}

.mdi-desktop-tower::before {
  content: "\\f01c5";
}

.mdi-desktop-tower-monitor::before {
  content: "\\f0aab";
}

.mdi-details::before {
  content: "\\f01c6";
}

.mdi-dev-to::before {
  content: "\\f0d6e";
}

.mdi-developer-board::before {
  content: "\\f0697";
}

.mdi-deviantart::before {
  content: "\\f01c7";
}

.mdi-devices::before {
  content: "\\f0fb0";
}

.mdi-diabetes::before {
  content: "\\f1126";
}

.mdi-dialpad::before {
  content: "\\f061c";
}

.mdi-diameter::before {
  content: "\\f0c63";
}

.mdi-diameter-outline::before {
  content: "\\f0c64";
}

.mdi-diameter-variant::before {
  content: "\\f0c65";
}

.mdi-diamond::before {
  content: "\\f0b8a";
}

.mdi-diamond-outline::before {
  content: "\\f0b8b";
}

.mdi-diamond-stone::before {
  content: "\\f01c8";
}

.mdi-dice-1::before {
  content: "\\f01ca";
}

.mdi-dice-1-outline::before {
  content: "\\f114a";
}

.mdi-dice-2::before {
  content: "\\f01cb";
}

.mdi-dice-2-outline::before {
  content: "\\f114b";
}

.mdi-dice-3::before {
  content: "\\f01cc";
}

.mdi-dice-3-outline::before {
  content: "\\f114c";
}

.mdi-dice-4::before {
  content: "\\f01cd";
}

.mdi-dice-4-outline::before {
  content: "\\f114d";
}

.mdi-dice-5::before {
  content: "\\f01ce";
}

.mdi-dice-5-outline::before {
  content: "\\f114e";
}

.mdi-dice-6::before {
  content: "\\f01cf";
}

.mdi-dice-6-outline::before {
  content: "\\f114f";
}

.mdi-dice-d10::before {
  content: "\\f1153";
}

.mdi-dice-d10-outline::before {
  content: "\\f076f";
}

.mdi-dice-d12::before {
  content: "\\f1154";
}

.mdi-dice-d12-outline::before {
  content: "\\f0867";
}

.mdi-dice-d20::before {
  content: "\\f1155";
}

.mdi-dice-d20-outline::before {
  content: "\\f05ea";
}

.mdi-dice-d4::before {
  content: "\\f1150";
}

.mdi-dice-d4-outline::before {
  content: "\\f05eb";
}

.mdi-dice-d6::before {
  content: "\\f1151";
}

.mdi-dice-d6-outline::before {
  content: "\\f05ed";
}

.mdi-dice-d8::before {
  content: "\\f1152";
}

.mdi-dice-d8-outline::before {
  content: "\\f05ec";
}

.mdi-dice-multiple::before {
  content: "\\f076e";
}

.mdi-dice-multiple-outline::before {
  content: "\\f1156";
}

.mdi-digital-ocean::before {
  content: "\\f1237";
}

.mdi-dip-switch::before {
  content: "\\f07c1";
}

.mdi-directions::before {
  content: "\\f01d0";
}

.mdi-directions-fork::before {
  content: "\\f0641";
}

.mdi-disc::before {
  content: "\\f05ee";
}

.mdi-disc-alert::before {
  content: "\\f01d1";
}

.mdi-disc-player::before {
  content: "\\f0960";
}

.mdi-discord::before {
  content: "\\f066f";
}

.mdi-dishwasher::before {
  content: "\\f0aac";
}

.mdi-dishwasher-alert::before {
  content: "\\f11b8";
}

.mdi-dishwasher-off::before {
  content: "\\f11b9";
}

.mdi-disqus::before {
  content: "\\f01d2";
}

.mdi-distribute-horizontal-center::before {
  content: "\\f11c9";
}

.mdi-distribute-horizontal-left::before {
  content: "\\f11c8";
}

.mdi-distribute-horizontal-right::before {
  content: "\\f11ca";
}

.mdi-distribute-vertical-bottom::before {
  content: "\\f11cb";
}

.mdi-distribute-vertical-center::before {
  content: "\\f11cc";
}

.mdi-distribute-vertical-top::before {
  content: "\\f11cd";
}

.mdi-diving-flippers::before {
  content: "\\f0dbf";
}

.mdi-diving-helmet::before {
  content: "\\f0dc0";
}

.mdi-diving-scuba::before {
  content: "\\f0dc1";
}

.mdi-diving-scuba-flag::before {
  content: "\\f0dc2";
}

.mdi-diving-scuba-tank::before {
  content: "\\f0dc3";
}

.mdi-diving-scuba-tank-multiple::before {
  content: "\\f0dc4";
}

.mdi-diving-snorkel::before {
  content: "\\f0dc5";
}

.mdi-division::before {
  content: "\\f01d4";
}

.mdi-division-box::before {
  content: "\\f01d5";
}

.mdi-dlna::before {
  content: "\\f0a41";
}

.mdi-dna::before {
  content: "\\f0684";
}

.mdi-dns::before {
  content: "\\f01d6";
}

.mdi-dns-outline::before {
  content: "\\f0b8c";
}

.mdi-do-not-disturb::before {
  content: "\\f0698";
}

.mdi-do-not-disturb-off::before {
  content: "\\f0699";
}

.mdi-dock-bottom::before {
  content: "\\f10a9";
}

.mdi-dock-left::before {
  content: "\\f10aa";
}

.mdi-dock-right::before {
  content: "\\f10ab";
}

.mdi-dock-top::before {
  content: "\\f1513";
}

.mdi-dock-window::before {
  content: "\\f10ac";
}

.mdi-docker::before {
  content: "\\f0868";
}

.mdi-doctor::before {
  content: "\\f0a42";
}

.mdi-dog::before {
  content: "\\f0a43";
}

.mdi-dog-service::before {
  content: "\\f0aad";
}

.mdi-dog-side::before {
  content: "\\f0a44";
}

.mdi-dolby::before {
  content: "\\f06b3";
}

.mdi-dolly::before {
  content: "\\f0e9e";
}

.mdi-domain::before {
  content: "\\f01d7";
}

.mdi-domain-off::before {
  content: "\\f0d6f";
}

.mdi-domain-plus::before {
  content: "\\f10ad";
}

.mdi-domain-remove::before {
  content: "\\f10ae";
}

.mdi-dome-light::before {
  content: "\\f141e";
}

.mdi-domino-mask::before {
  content: "\\f1023";
}

.mdi-donkey::before {
  content: "\\f07c2";
}

.mdi-door::before {
  content: "\\f081a";
}

.mdi-door-closed::before {
  content: "\\f081b";
}

.mdi-door-closed-lock::before {
  content: "\\f10af";
}

.mdi-door-open::before {
  content: "\\f081c";
}

.mdi-doorbell::before {
  content: "\\f12e6";
}

.mdi-doorbell-video::before {
  content: "\\f0869";
}

.mdi-dot-net::before {
  content: "\\f0aae";
}

.mdi-dots-grid::before {
  content: "\\f15fc";
}

.mdi-dots-hexagon::before {
  content: "\\f15ff";
}

.mdi-dots-horizontal::before {
  content: "\\f01d8";
}

.mdi-dots-horizontal-circle::before {
  content: "\\f07c3";
}

.mdi-dots-horizontal-circle-outline::before {
  content: "\\f0b8d";
}

.mdi-dots-square::before {
  content: "\\f15fd";
}

.mdi-dots-triangle::before {
  content: "\\f15fe";
}

.mdi-dots-vertical::before {
  content: "\\f01d9";
}

.mdi-dots-vertical-circle::before {
  content: "\\f07c4";
}

.mdi-dots-vertical-circle-outline::before {
  content: "\\f0b8e";
}

.mdi-douban::before {
  content: "\\f069a";
}

.mdi-download::before {
  content: "\\f01da";
}

.mdi-download-box::before {
  content: "\\f1462";
}

.mdi-download-box-outline::before {
  content: "\\f1463";
}

.mdi-download-circle::before {
  content: "\\f1464";
}

.mdi-download-circle-outline::before {
  content: "\\f1465";
}

.mdi-download-lock::before {
  content: "\\f1320";
}

.mdi-download-lock-outline::before {
  content: "\\f1321";
}

.mdi-download-multiple::before {
  content: "\\f09e9";
}

.mdi-download-network::before {
  content: "\\f06f4";
}

.mdi-download-network-outline::before {
  content: "\\f0c66";
}

.mdi-download-off::before {
  content: "\\f10b0";
}

.mdi-download-off-outline::before {
  content: "\\f10b1";
}

.mdi-download-outline::before {
  content: "\\f0b8f";
}

.mdi-drag::before {
  content: "\\f01db";
}

.mdi-drag-horizontal::before {
  content: "\\f01dc";
}

.mdi-drag-horizontal-variant::before {
  content: "\\f12f0";
}

.mdi-drag-variant::before {
  content: "\\f0b90";
}

.mdi-drag-vertical::before {
  content: "\\f01dd";
}

.mdi-drag-vertical-variant::before {
  content: "\\f12f1";
}

.mdi-drama-masks::before {
  content: "\\f0d02";
}

.mdi-draw::before {
  content: "\\f0f49";
}

.mdi-drawing::before {
  content: "\\f01de";
}

.mdi-drawing-box::before {
  content: "\\f01df";
}

.mdi-dresser::before {
  content: "\\f0f4a";
}

.mdi-dresser-outline::before {
  content: "\\f0f4b";
}

.mdi-drone::before {
  content: "\\f01e2";
}

.mdi-dropbox::before {
  content: "\\f01e3";
}

.mdi-drupal::before {
  content: "\\f01e4";
}

.mdi-duck::before {
  content: "\\f01e5";
}

.mdi-dumbbell::before {
  content: "\\f01e6";
}

.mdi-dump-truck::before {
  content: "\\f0c67";
}

.mdi-ear-hearing::before {
  content: "\\f07c5";
}

.mdi-ear-hearing-off::before {
  content: "\\f0a45";
}

.mdi-earth::before {
  content: "\\f01e7";
}

.mdi-earth-arrow-right::before {
  content: "\\f1311";
}

.mdi-earth-box::before {
  content: "\\f06cd";
}

.mdi-earth-box-minus::before {
  content: "\\f1407";
}

.mdi-earth-box-off::before {
  content: "\\f06ce";
}

.mdi-earth-box-plus::before {
  content: "\\f1406";
}

.mdi-earth-box-remove::before {
  content: "\\f1408";
}

.mdi-earth-minus::before {
  content: "\\f1404";
}

.mdi-earth-off::before {
  content: "\\f01e8";
}

.mdi-earth-plus::before {
  content: "\\f1403";
}

.mdi-earth-remove::before {
  content: "\\f1405";
}

.mdi-egg::before {
  content: "\\f0aaf";
}

.mdi-egg-easter::before {
  content: "\\f0ab0";
}

.mdi-egg-off::before {
  content: "\\f13f0";
}

.mdi-egg-off-outline::before {
  content: "\\f13f1";
}

.mdi-egg-outline::before {
  content: "\\f13f2";
}

.mdi-eiffel-tower::before {
  content: "\\f156b";
}

.mdi-eight-track::before {
  content: "\\f09ea";
}

.mdi-eject::before {
  content: "\\f01ea";
}

.mdi-eject-outline::before {
  content: "\\f0b91";
}

.mdi-electric-switch::before {
  content: "\\f0e9f";
}

.mdi-electric-switch-closed::before {
  content: "\\f10d9";
}

.mdi-electron-framework::before {
  content: "\\f1024";
}

.mdi-elephant::before {
  content: "\\f07c6";
}

.mdi-elevation-decline::before {
  content: "\\f01eb";
}

.mdi-elevation-rise::before {
  content: "\\f01ec";
}

.mdi-elevator::before {
  content: "\\f01ed";
}

.mdi-elevator-down::before {
  content: "\\f12c2";
}

.mdi-elevator-passenger::before {
  content: "\\f1381";
}

.mdi-elevator-up::before {
  content: "\\f12c1";
}

.mdi-ellipse::before {
  content: "\\f0ea0";
}

.mdi-ellipse-outline::before {
  content: "\\f0ea1";
}

.mdi-email::before {
  content: "\\f01ee";
}

.mdi-email-alert::before {
  content: "\\f06cf";
}

.mdi-email-alert-outline::before {
  content: "\\f0d42";
}

.mdi-email-box::before {
  content: "\\f0d03";
}

.mdi-email-check::before {
  content: "\\f0ab1";
}

.mdi-email-check-outline::before {
  content: "\\f0ab2";
}

.mdi-email-edit::before {
  content: "\\f0ee3";
}

.mdi-email-edit-outline::before {
  content: "\\f0ee4";
}

.mdi-email-lock::before {
  content: "\\f01f1";
}

.mdi-email-mark-as-unread::before {
  content: "\\f0b92";
}

.mdi-email-minus::before {
  content: "\\f0ee5";
}

.mdi-email-minus-outline::before {
  content: "\\f0ee6";
}

.mdi-email-multiple::before {
  content: "\\f0ee7";
}

.mdi-email-multiple-outline::before {
  content: "\\f0ee8";
}

.mdi-email-newsletter::before {
  content: "\\f0fb1";
}

.mdi-email-off::before {
  content: "\\f13e3";
}

.mdi-email-off-outline::before {
  content: "\\f13e4";
}

.mdi-email-open::before {
  content: "\\f01ef";
}

.mdi-email-open-multiple::before {
  content: "\\f0ee9";
}

.mdi-email-open-multiple-outline::before {
  content: "\\f0eea";
}

.mdi-email-open-outline::before {
  content: "\\f05ef";
}

.mdi-email-outline::before {
  content: "\\f01f0";
}

.mdi-email-plus::before {
  content: "\\f09eb";
}

.mdi-email-plus-outline::before {
  content: "\\f09ec";
}

.mdi-email-receive::before {
  content: "\\f10da";
}

.mdi-email-receive-outline::before {
  content: "\\f10db";
}

.mdi-email-remove::before {
  content: "\\f1661";
}

.mdi-email-remove-outline::before {
  content: "\\f1662";
}

.mdi-email-search::before {
  content: "\\f0961";
}

.mdi-email-search-outline::before {
  content: "\\f0962";
}

.mdi-email-send::before {
  content: "\\f10dc";
}

.mdi-email-send-outline::before {
  content: "\\f10dd";
}

.mdi-email-sync::before {
  content: "\\f12c7";
}

.mdi-email-sync-outline::before {
  content: "\\f12c8";
}

.mdi-email-variant::before {
  content: "\\f05f0";
}

.mdi-ember::before {
  content: "\\f0b30";
}

.mdi-emby::before {
  content: "\\f06b4";
}

.mdi-emoticon::before {
  content: "\\f0c68";
}

.mdi-emoticon-angry::before {
  content: "\\f0c69";
}

.mdi-emoticon-angry-outline::before {
  content: "\\f0c6a";
}

.mdi-emoticon-confused::before {
  content: "\\f10de";
}

.mdi-emoticon-confused-outline::before {
  content: "\\f10df";
}

.mdi-emoticon-cool::before {
  content: "\\f0c6b";
}

.mdi-emoticon-cool-outline::before {
  content: "\\f01f3";
}

.mdi-emoticon-cry::before {
  content: "\\f0c6c";
}

.mdi-emoticon-cry-outline::before {
  content: "\\f0c6d";
}

.mdi-emoticon-dead::before {
  content: "\\f0c6e";
}

.mdi-emoticon-dead-outline::before {
  content: "\\f069b";
}

.mdi-emoticon-devil::before {
  content: "\\f0c6f";
}

.mdi-emoticon-devil-outline::before {
  content: "\\f01f4";
}

.mdi-emoticon-excited::before {
  content: "\\f0c70";
}

.mdi-emoticon-excited-outline::before {
  content: "\\f069c";
}

.mdi-emoticon-frown::before {
  content: "\\f0f4c";
}

.mdi-emoticon-frown-outline::before {
  content: "\\f0f4d";
}

.mdi-emoticon-happy::before {
  content: "\\f0c71";
}

.mdi-emoticon-happy-outline::before {
  content: "\\f01f5";
}

.mdi-emoticon-kiss::before {
  content: "\\f0c72";
}

.mdi-emoticon-kiss-outline::before {
  content: "\\f0c73";
}

.mdi-emoticon-lol::before {
  content: "\\f1214";
}

.mdi-emoticon-lol-outline::before {
  content: "\\f1215";
}

.mdi-emoticon-neutral::before {
  content: "\\f0c74";
}

.mdi-emoticon-neutral-outline::before {
  content: "\\f01f6";
}

.mdi-emoticon-outline::before {
  content: "\\f01f2";
}

.mdi-emoticon-poop::before {
  content: "\\f01f7";
}

.mdi-emoticon-poop-outline::before {
  content: "\\f0c75";
}

.mdi-emoticon-sad::before {
  content: "\\f0c76";
}

.mdi-emoticon-sad-outline::before {
  content: "\\f01f8";
}

.mdi-emoticon-sick::before {
  content: "\\f157c";
}

.mdi-emoticon-sick-outline::before {
  content: "\\f157d";
}

.mdi-emoticon-tongue::before {
  content: "\\f01f9";
}

.mdi-emoticon-tongue-outline::before {
  content: "\\f0c77";
}

.mdi-emoticon-wink::before {
  content: "\\f0c78";
}

.mdi-emoticon-wink-outline::before {
  content: "\\f0c79";
}

.mdi-engine::before {
  content: "\\f01fa";
}

.mdi-engine-off::before {
  content: "\\f0a46";
}

.mdi-engine-off-outline::before {
  content: "\\f0a47";
}

.mdi-engine-outline::before {
  content: "\\f01fb";
}

.mdi-epsilon::before {
  content: "\\f10e0";
}

.mdi-equal::before {
  content: "\\f01fc";
}

.mdi-equal-box::before {
  content: "\\f01fd";
}

.mdi-equalizer::before {
  content: "\\f0ea2";
}

.mdi-equalizer-outline::before {
  content: "\\f0ea3";
}

.mdi-eraser::before {
  content: "\\f01fe";
}

.mdi-eraser-variant::before {
  content: "\\f0642";
}

.mdi-escalator::before {
  content: "\\f01ff";
}

.mdi-escalator-box::before {
  content: "\\f1399";
}

.mdi-escalator-down::before {
  content: "\\f12c0";
}

.mdi-escalator-up::before {
  content: "\\f12bf";
}

.mdi-eslint::before {
  content: "\\f0c7a";
}

.mdi-et::before {
  content: "\\f0ab3";
}

.mdi-ethereum::before {
  content: "\\f086a";
}

.mdi-ethernet::before {
  content: "\\f0200";
}

.mdi-ethernet-cable::before {
  content: "\\f0201";
}

.mdi-ethernet-cable-off::before {
  content: "\\f0202";
}

.mdi-ev-plug-ccs1::before {
  content: "\\f1519";
}

.mdi-ev-plug-ccs2::before {
  content: "\\f151a";
}

.mdi-ev-plug-chademo::before {
  content: "\\f151b";
}

.mdi-ev-plug-tesla::before {
  content: "\\f151c";
}

.mdi-ev-plug-type1::before {
  content: "\\f151d";
}

.mdi-ev-plug-type2::before {
  content: "\\f151e";
}

.mdi-ev-station::before {
  content: "\\f05f1";
}

.mdi-evernote::before {
  content: "\\f0204";
}

.mdi-excavator::before {
  content: "\\f1025";
}

.mdi-exclamation::before {
  content: "\\f0205";
}

.mdi-exclamation-thick::before {
  content: "\\f1238";
}

.mdi-exit-run::before {
  content: "\\f0a48";
}

.mdi-exit-to-app::before {
  content: "\\f0206";
}

.mdi-expand-all::before {
  content: "\\f0ab4";
}

.mdi-expand-all-outline::before {
  content: "\\f0ab5";
}

.mdi-expansion-card::before {
  content: "\\f08ae";
}

.mdi-expansion-card-variant::before {
  content: "\\f0fb2";
}

.mdi-exponent::before {
  content: "\\f0963";
}

.mdi-exponent-box::before {
  content: "\\f0964";
}

.mdi-export::before {
  content: "\\f0207";
}

.mdi-export-variant::before {
  content: "\\f0b93";
}

.mdi-eye::before {
  content: "\\f0208";
}

.mdi-eye-check::before {
  content: "\\f0d04";
}

.mdi-eye-check-outline::before {
  content: "\\f0d05";
}

.mdi-eye-circle::before {
  content: "\\f0b94";
}

.mdi-eye-circle-outline::before {
  content: "\\f0b95";
}

.mdi-eye-minus::before {
  content: "\\f1026";
}

.mdi-eye-minus-outline::before {
  content: "\\f1027";
}

.mdi-eye-off::before {
  content: "\\f0209";
}

.mdi-eye-off-outline::before {
  content: "\\f06d1";
}

.mdi-eye-outline::before {
  content: "\\f06d0";
}

.mdi-eye-plus::before {
  content: "\\f086b";
}

.mdi-eye-plus-outline::before {
  content: "\\f086c";
}

.mdi-eye-remove::before {
  content: "\\f15e3";
}

.mdi-eye-remove-outline::before {
  content: "\\f15e4";
}

.mdi-eye-settings::before {
  content: "\\f086d";
}

.mdi-eye-settings-outline::before {
  content: "\\f086e";
}

.mdi-eyedropper::before {
  content: "\\f020a";
}

.mdi-eyedropper-minus::before {
  content: "\\f13dd";
}

.mdi-eyedropper-off::before {
  content: "\\f13df";
}

.mdi-eyedropper-plus::before {
  content: "\\f13dc";
}

.mdi-eyedropper-remove::before {
  content: "\\f13de";
}

.mdi-eyedropper-variant::before {
  content: "\\f020b";
}

.mdi-face::before {
  content: "\\f0643";
}

.mdi-face-agent::before {
  content: "\\f0d70";
}

.mdi-face-mask::before {
  content: "\\f1586";
}

.mdi-face-mask-outline::before {
  content: "\\f1587";
}

.mdi-face-outline::before {
  content: "\\f0b96";
}

.mdi-face-profile::before {
  content: "\\f0644";
}

.mdi-face-profile-woman::before {
  content: "\\f1076";
}

.mdi-face-recognition::before {
  content: "\\f0c7b";
}

.mdi-face-shimmer::before {
  content: "\\f15cc";
}

.mdi-face-shimmer-outline::before {
  content: "\\f15cd";
}

.mdi-face-woman::before {
  content: "\\f1077";
}

.mdi-face-woman-outline::before {
  content: "\\f1078";
}

.mdi-face-woman-shimmer::before {
  content: "\\f15ce";
}

.mdi-face-woman-shimmer-outline::before {
  content: "\\f15cf";
}

.mdi-facebook::before {
  content: "\\f020c";
}

.mdi-facebook-gaming::before {
  content: "\\f07dd";
}

.mdi-facebook-messenger::before {
  content: "\\f020e";
}

.mdi-facebook-workplace::before {
  content: "\\f0b31";
}

.mdi-factory::before {
  content: "\\f020f";
}

.mdi-family-tree::before {
  content: "\\f160e";
}

.mdi-fan::before {
  content: "\\f0210";
}

.mdi-fan-alert::before {
  content: "\\f146c";
}

.mdi-fan-chevron-down::before {
  content: "\\f146d";
}

.mdi-fan-chevron-up::before {
  content: "\\f146e";
}

.mdi-fan-minus::before {
  content: "\\f1470";
}

.mdi-fan-off::before {
  content: "\\f081d";
}

.mdi-fan-plus::before {
  content: "\\f146f";
}

.mdi-fan-remove::before {
  content: "\\f1471";
}

.mdi-fan-speed-1::before {
  content: "\\f1472";
}

.mdi-fan-speed-2::before {
  content: "\\f1473";
}

.mdi-fan-speed-3::before {
  content: "\\f1474";
}

.mdi-fast-forward::before {
  content: "\\f0211";
}

.mdi-fast-forward-10::before {
  content: "\\f0d71";
}

.mdi-fast-forward-30::before {
  content: "\\f0d06";
}

.mdi-fast-forward-5::before {
  content: "\\f11f8";
}

.mdi-fast-forward-60::before {
  content: "\\f160b";
}

.mdi-fast-forward-outline::before {
  content: "\\f06d2";
}

.mdi-fax::before {
  content: "\\f0212";
}

.mdi-feather::before {
  content: "\\f06d3";
}

.mdi-feature-search::before {
  content: "\\f0a49";
}

.mdi-feature-search-outline::before {
  content: "\\f0a4a";
}

.mdi-fedora::before {
  content: "\\f08db";
}

.mdi-fencing::before {
  content: "\\f14c1";
}

.mdi-ferris-wheel::before {
  content: "\\f0ea4";
}

.mdi-ferry::before {
  content: "\\f0213";
}

.mdi-file::before {
  content: "\\f0214";
}

.mdi-file-account::before {
  content: "\\f073b";
}

.mdi-file-account-outline::before {
  content: "\\f1028";
}

.mdi-file-alert::before {
  content: "\\f0a4b";
}

.mdi-file-alert-outline::before {
  content: "\\f0a4c";
}

.mdi-file-cabinet::before {
  content: "\\f0ab6";
}

.mdi-file-cad::before {
  content: "\\f0eeb";
}

.mdi-file-cad-box::before {
  content: "\\f0eec";
}

.mdi-file-cancel::before {
  content: "\\f0dc6";
}

.mdi-file-cancel-outline::before {
  content: "\\f0dc7";
}

.mdi-file-certificate::before {
  content: "\\f1186";
}

.mdi-file-certificate-outline::before {
  content: "\\f1187";
}

.mdi-file-chart::before {
  content: "\\f0215";
}

.mdi-file-chart-outline::before {
  content: "\\f1029";
}

.mdi-file-check::before {
  content: "\\f0216";
}

.mdi-file-check-outline::before {
  content: "\\f0e29";
}

.mdi-file-clock::before {
  content: "\\f12e1";
}

.mdi-file-clock-outline::before {
  content: "\\f12e2";
}

.mdi-file-cloud::before {
  content: "\\f0217";
}

.mdi-file-cloud-outline::before {
  content: "\\f102a";
}

.mdi-file-code::before {
  content: "\\f022e";
}

.mdi-file-code-outline::before {
  content: "\\f102b";
}

.mdi-file-cog::before {
  content: "\\f107b";
}

.mdi-file-cog-outline::before {
  content: "\\f107c";
}

.mdi-file-compare::before {
  content: "\\f08aa";
}

.mdi-file-delimited::before {
  content: "\\f0218";
}

.mdi-file-delimited-outline::before {
  content: "\\f0ea5";
}

.mdi-file-document::before {
  content: "\\f0219";
}

.mdi-file-document-edit::before {
  content: "\\f0dc8";
}

.mdi-file-document-edit-outline::before {
  content: "\\f0dc9";
}

.mdi-file-document-multiple::before {
  content: "\\f1517";
}

.mdi-file-document-multiple-outline::before {
  content: "\\f1518";
}

.mdi-file-document-outline::before {
  content: "\\f09ee";
}

.mdi-file-download::before {
  content: "\\f0965";
}

.mdi-file-download-outline::before {
  content: "\\f0966";
}

.mdi-file-edit::before {
  content: "\\f11e7";
}

.mdi-file-edit-outline::before {
  content: "\\f11e8";
}

.mdi-file-excel::before {
  content: "\\f021b";
}

.mdi-file-excel-box::before {
  content: "\\f021c";
}

.mdi-file-excel-box-outline::before {
  content: "\\f102c";
}

.mdi-file-excel-outline::before {
  content: "\\f102d";
}

.mdi-file-export::before {
  content: "\\f021d";
}

.mdi-file-export-outline::before {
  content: "\\f102e";
}

.mdi-file-eye::before {
  content: "\\f0dca";
}

.mdi-file-eye-outline::before {
  content: "\\f0dcb";
}

.mdi-file-find::before {
  content: "\\f021e";
}

.mdi-file-find-outline::before {
  content: "\\f0b97";
}

.mdi-file-hidden::before {
  content: "\\f0613";
}

.mdi-file-image::before {
  content: "\\f021f";
}

.mdi-file-image-outline::before {
  content: "\\f0eb0";
}

.mdi-file-import::before {
  content: "\\f0220";
}

.mdi-file-import-outline::before {
  content: "\\f102f";
}

.mdi-file-key::before {
  content: "\\f1184";
}

.mdi-file-key-outline::before {
  content: "\\f1185";
}

.mdi-file-link::before {
  content: "\\f1177";
}

.mdi-file-link-outline::before {
  content: "\\f1178";
}

.mdi-file-lock::before {
  content: "\\f0221";
}

.mdi-file-lock-outline::before {
  content: "\\f1030";
}

.mdi-file-move::before {
  content: "\\f0ab9";
}

.mdi-file-move-outline::before {
  content: "\\f1031";
}

.mdi-file-multiple::before {
  content: "\\f0222";
}

.mdi-file-multiple-outline::before {
  content: "\\f1032";
}

.mdi-file-music::before {
  content: "\\f0223";
}

.mdi-file-music-outline::before {
  content: "\\f0e2a";
}

.mdi-file-outline::before {
  content: "\\f0224";
}

.mdi-file-pdf::before {
  content: "\\f0225";
}

.mdi-file-pdf-box::before {
  content: "\\f0226";
}

.mdi-file-pdf-box-outline::before {
  content: "\\f0fb3";
}

.mdi-file-pdf-outline::before {
  content: "\\f0e2d";
}

.mdi-file-percent::before {
  content: "\\f081e";
}

.mdi-file-percent-outline::before {
  content: "\\f1033";
}

.mdi-file-phone::before {
  content: "\\f1179";
}

.mdi-file-phone-outline::before {
  content: "\\f117a";
}

.mdi-file-plus::before {
  content: "\\f0752";
}

.mdi-file-plus-outline::before {
  content: "\\f0eed";
}

.mdi-file-powerpoint::before {
  content: "\\f0227";
}

.mdi-file-powerpoint-box::before {
  content: "\\f0228";
}

.mdi-file-powerpoint-box-outline::before {
  content: "\\f1034";
}

.mdi-file-powerpoint-outline::before {
  content: "\\f1035";
}

.mdi-file-presentation-box::before {
  content: "\\f0229";
}

.mdi-file-question::before {
  content: "\\f086f";
}

.mdi-file-question-outline::before {
  content: "\\f1036";
}

.mdi-file-refresh::before {
  content: "\\f0918";
}

.mdi-file-refresh-outline::before {
  content: "\\f0541";
}

.mdi-file-remove::before {
  content: "\\f0b98";
}

.mdi-file-remove-outline::before {
  content: "\\f1037";
}

.mdi-file-replace::before {
  content: "\\f0b32";
}

.mdi-file-replace-outline::before {
  content: "\\f0b33";
}

.mdi-file-restore::before {
  content: "\\f0670";
}

.mdi-file-restore-outline::before {
  content: "\\f1038";
}

.mdi-file-search::before {
  content: "\\f0c7c";
}

.mdi-file-search-outline::before {
  content: "\\f0c7d";
}

.mdi-file-send::before {
  content: "\\f022a";
}

.mdi-file-send-outline::before {
  content: "\\f1039";
}

.mdi-file-settings::before {
  content: "\\f1079";
}

.mdi-file-settings-outline::before {
  content: "\\f107a";
}

.mdi-file-star::before {
  content: "\\f103a";
}

.mdi-file-star-outline::before {
  content: "\\f103b";
}

.mdi-file-swap::before {
  content: "\\f0fb4";
}

.mdi-file-swap-outline::before {
  content: "\\f0fb5";
}

.mdi-file-sync::before {
  content: "\\f1216";
}

.mdi-file-sync-outline::before {
  content: "\\f1217";
}

.mdi-file-table::before {
  content: "\\f0c7e";
}

.mdi-file-table-box::before {
  content: "\\f10e1";
}

.mdi-file-table-box-multiple::before {
  content: "\\f10e2";
}

.mdi-file-table-box-multiple-outline::before {
  content: "\\f10e3";
}

.mdi-file-table-box-outline::before {
  content: "\\f10e4";
}

.mdi-file-table-outline::before {
  content: "\\f0c7f";
}

.mdi-file-tree::before {
  content: "\\f0645";
}

.mdi-file-tree-outline::before {
  content: "\\f13d2";
}

.mdi-file-undo::before {
  content: "\\f08dc";
}

.mdi-file-undo-outline::before {
  content: "\\f103c";
}

.mdi-file-upload::before {
  content: "\\f0a4d";
}

.mdi-file-upload-outline::before {
  content: "\\f0a4e";
}

.mdi-file-video::before {
  content: "\\f022b";
}

.mdi-file-video-outline::before {
  content: "\\f0e2c";
}

.mdi-file-word::before {
  content: "\\f022c";
}

.mdi-file-word-box::before {
  content: "\\f022d";
}

.mdi-file-word-box-outline::before {
  content: "\\f103d";
}

.mdi-file-word-outline::before {
  content: "\\f103e";
}

.mdi-film::before {
  content: "\\f022f";
}

.mdi-filmstrip::before {
  content: "\\f0230";
}

.mdi-filmstrip-box::before {
  content: "\\f0332";
}

.mdi-filmstrip-box-multiple::before {
  content: "\\f0d18";
}

.mdi-filmstrip-off::before {
  content: "\\f0231";
}

.mdi-filter::before {
  content: "\\f0232";
}

.mdi-filter-menu::before {
  content: "\\f10e5";
}

.mdi-filter-menu-outline::before {
  content: "\\f10e6";
}

.mdi-filter-minus::before {
  content: "\\f0eee";
}

.mdi-filter-minus-outline::before {
  content: "\\f0eef";
}

.mdi-filter-off::before {
  content: "\\f14ef";
}

.mdi-filter-off-outline::before {
  content: "\\f14f0";
}

.mdi-filter-outline::before {
  content: "\\f0233";
}

.mdi-filter-plus::before {
  content: "\\f0ef0";
}

.mdi-filter-plus-outline::before {
  content: "\\f0ef1";
}

.mdi-filter-remove::before {
  content: "\\f0234";
}

.mdi-filter-remove-outline::before {
  content: "\\f0235";
}

.mdi-filter-variant::before {
  content: "\\f0236";
}

.mdi-filter-variant-minus::before {
  content: "\\f1112";
}

.mdi-filter-variant-plus::before {
  content: "\\f1113";
}

.mdi-filter-variant-remove::before {
  content: "\\f103f";
}

.mdi-finance::before {
  content: "\\f081f";
}

.mdi-find-replace::before {
  content: "\\f06d4";
}

.mdi-fingerprint::before {
  content: "\\f0237";
}

.mdi-fingerprint-off::before {
  content: "\\f0eb1";
}

.mdi-fire::before {
  content: "\\f0238";
}

.mdi-fire-alert::before {
  content: "\\f15d7";
}

.mdi-fire-extinguisher::before {
  content: "\\f0ef2";
}

.mdi-fire-hydrant::before {
  content: "\\f1137";
}

.mdi-fire-hydrant-alert::before {
  content: "\\f1138";
}

.mdi-fire-hydrant-off::before {
  content: "\\f1139";
}

.mdi-fire-truck::before {
  content: "\\f08ab";
}

.mdi-firebase::before {
  content: "\\f0967";
}

.mdi-firefox::before {
  content: "\\f0239";
}

.mdi-fireplace::before {
  content: "\\f0e2e";
}

.mdi-fireplace-off::before {
  content: "\\f0e2f";
}

.mdi-firework::before {
  content: "\\f0e30";
}

.mdi-fish::before {
  content: "\\f023a";
}

.mdi-fish-off::before {
  content: "\\f13f3";
}

.mdi-fishbowl::before {
  content: "\\f0ef3";
}

.mdi-fishbowl-outline::before {
  content: "\\f0ef4";
}

.mdi-fit-to-page::before {
  content: "\\f0ef5";
}

.mdi-fit-to-page-outline::before {
  content: "\\f0ef6";
}

.mdi-flag::before {
  content: "\\f023b";
}

.mdi-flag-checkered::before {
  content: "\\f023c";
}

.mdi-flag-minus::before {
  content: "\\f0b99";
}

.mdi-flag-minus-outline::before {
  content: "\\f10b2";
}

.mdi-flag-outline::before {
  content: "\\f023d";
}

.mdi-flag-plus::before {
  content: "\\f0b9a";
}

.mdi-flag-plus-outline::before {
  content: "\\f10b3";
}

.mdi-flag-remove::before {
  content: "\\f0b9b";
}

.mdi-flag-remove-outline::before {
  content: "\\f10b4";
}

.mdi-flag-triangle::before {
  content: "\\f023f";
}

.mdi-flag-variant::before {
  content: "\\f0240";
}

.mdi-flag-variant-outline::before {
  content: "\\f023e";
}

.mdi-flare::before {
  content: "\\f0d72";
}

.mdi-flash::before {
  content: "\\f0241";
}

.mdi-flash-alert::before {
  content: "\\f0ef7";
}

.mdi-flash-alert-outline::before {
  content: "\\f0ef8";
}

.mdi-flash-auto::before {
  content: "\\f0242";
}

.mdi-flash-circle::before {
  content: "\\f0820";
}

.mdi-flash-off::before {
  content: "\\f0243";
}

.mdi-flash-outline::before {
  content: "\\f06d5";
}

.mdi-flash-red-eye::before {
  content: "\\f067b";
}

.mdi-flashlight::before {
  content: "\\f0244";
}

.mdi-flashlight-off::before {
  content: "\\f0245";
}

.mdi-flask::before {
  content: "\\f0093";
}

.mdi-flask-empty::before {
  content: "\\f0094";
}

.mdi-flask-empty-minus::before {
  content: "\\f123a";
}

.mdi-flask-empty-minus-outline::before {
  content: "\\f123b";
}

.mdi-flask-empty-off::before {
  content: "\\f13f4";
}

.mdi-flask-empty-off-outline::before {
  content: "\\f13f5";
}

.mdi-flask-empty-outline::before {
  content: "\\f0095";
}

.mdi-flask-empty-plus::before {
  content: "\\f123c";
}

.mdi-flask-empty-plus-outline::before {
  content: "\\f123d";
}

.mdi-flask-empty-remove::before {
  content: "\\f123e";
}

.mdi-flask-empty-remove-outline::before {
  content: "\\f123f";
}

.mdi-flask-minus::before {
  content: "\\f1240";
}

.mdi-flask-minus-outline::before {
  content: "\\f1241";
}

.mdi-flask-off::before {
  content: "\\f13f6";
}

.mdi-flask-off-outline::before {
  content: "\\f13f7";
}

.mdi-flask-outline::before {
  content: "\\f0096";
}

.mdi-flask-plus::before {
  content: "\\f1242";
}

.mdi-flask-plus-outline::before {
  content: "\\f1243";
}

.mdi-flask-remove::before {
  content: "\\f1244";
}

.mdi-flask-remove-outline::before {
  content: "\\f1245";
}

.mdi-flask-round-bottom::before {
  content: "\\f124b";
}

.mdi-flask-round-bottom-empty::before {
  content: "\\f124c";
}

.mdi-flask-round-bottom-empty-outline::before {
  content: "\\f124d";
}

.mdi-flask-round-bottom-outline::before {
  content: "\\f124e";
}

.mdi-fleur-de-lis::before {
  content: "\\f1303";
}

.mdi-flip-horizontal::before {
  content: "\\f10e7";
}

.mdi-flip-to-back::before {
  content: "\\f0247";
}

.mdi-flip-to-front::before {
  content: "\\f0248";
}

.mdi-flip-vertical::before {
  content: "\\f10e8";
}

.mdi-floor-lamp::before {
  content: "\\f08dd";
}

.mdi-floor-lamp-dual::before {
  content: "\\f1040";
}

.mdi-floor-lamp-variant::before {
  content: "\\f1041";
}

.mdi-floor-plan::before {
  content: "\\f0821";
}

.mdi-floppy::before {
  content: "\\f0249";
}

.mdi-floppy-variant::before {
  content: "\\f09ef";
}

.mdi-flower::before {
  content: "\\f024a";
}

.mdi-flower-outline::before {
  content: "\\f09f0";
}

.mdi-flower-poppy::before {
  content: "\\f0d08";
}

.mdi-flower-tulip::before {
  content: "\\f09f1";
}

.mdi-flower-tulip-outline::before {
  content: "\\f09f2";
}

.mdi-focus-auto::before {
  content: "\\f0f4e";
}

.mdi-focus-field::before {
  content: "\\f0f4f";
}

.mdi-focus-field-horizontal::before {
  content: "\\f0f50";
}

.mdi-focus-field-vertical::before {
  content: "\\f0f51";
}

.mdi-folder::before {
  content: "\\f024b";
}

.mdi-folder-account::before {
  content: "\\f024c";
}

.mdi-folder-account-outline::before {
  content: "\\f0b9c";
}

.mdi-folder-alert::before {
  content: "\\f0dcc";
}

.mdi-folder-alert-outline::before {
  content: "\\f0dcd";
}

.mdi-folder-clock::before {
  content: "\\f0aba";
}

.mdi-folder-clock-outline::before {
  content: "\\f0abb";
}

.mdi-folder-cog::before {
  content: "\\f107f";
}

.mdi-folder-cog-outline::before {
  content: "\\f1080";
}

.mdi-folder-download::before {
  content: "\\f024d";
}

.mdi-folder-download-outline::before {
  content: "\\f10e9";
}

.mdi-folder-edit::before {
  content: "\\f08de";
}

.mdi-folder-edit-outline::before {
  content: "\\f0dce";
}

.mdi-folder-google-drive::before {
  content: "\\f024e";
}

.mdi-folder-heart::before {
  content: "\\f10ea";
}

.mdi-folder-heart-outline::before {
  content: "\\f10eb";
}

.mdi-folder-home::before {
  content: "\\f10b5";
}

.mdi-folder-home-outline::before {
  content: "\\f10b6";
}

.mdi-folder-image::before {
  content: "\\f024f";
}

.mdi-folder-information::before {
  content: "\\f10b7";
}

.mdi-folder-information-outline::before {
  content: "\\f10b8";
}

.mdi-folder-key::before {
  content: "\\f08ac";
}

.mdi-folder-key-network::before {
  content: "\\f08ad";
}

.mdi-folder-key-network-outline::before {
  content: "\\f0c80";
}

.mdi-folder-key-outline::before {
  content: "\\f10ec";
}

.mdi-folder-lock::before {
  content: "\\f0250";
}

.mdi-folder-lock-open::before {
  content: "\\f0251";
}

.mdi-folder-marker::before {
  content: "\\f126d";
}

.mdi-folder-marker-outline::before {
  content: "\\f126e";
}

.mdi-folder-move::before {
  content: "\\f0252";
}

.mdi-folder-move-outline::before {
  content: "\\f1246";
}

.mdi-folder-multiple::before {
  content: "\\f0253";
}

.mdi-folder-multiple-image::before {
  content: "\\f0254";
}

.mdi-folder-multiple-outline::before {
  content: "\\f0255";
}

.mdi-folder-multiple-plus::before {
  content: "\\f147e";
}

.mdi-folder-multiple-plus-outline::before {
  content: "\\f147f";
}

.mdi-folder-music::before {
  content: "\\f1359";
}

.mdi-folder-music-outline::before {
  content: "\\f135a";
}

.mdi-folder-network::before {
  content: "\\f0870";
}

.mdi-folder-network-outline::before {
  content: "\\f0c81";
}

.mdi-folder-open::before {
  content: "\\f0770";
}

.mdi-folder-open-outline::before {
  content: "\\f0dcf";
}

.mdi-folder-outline::before {
  content: "\\f0256";
}

.mdi-folder-plus::before {
  content: "\\f0257";
}

.mdi-folder-plus-outline::before {
  content: "\\f0b9d";
}

.mdi-folder-pound::before {
  content: "\\f0d09";
}

.mdi-folder-pound-outline::before {
  content: "\\f0d0a";
}

.mdi-folder-refresh::before {
  content: "\\f0749";
}

.mdi-folder-refresh-outline::before {
  content: "\\f0542";
}

.mdi-folder-remove::before {
  content: "\\f0258";
}

.mdi-folder-remove-outline::before {
  content: "\\f0b9e";
}

.mdi-folder-search::before {
  content: "\\f0968";
}

.mdi-folder-search-outline::before {
  content: "\\f0969";
}

.mdi-folder-settings::before {
  content: "\\f107d";
}

.mdi-folder-settings-outline::before {
  content: "\\f107e";
}

.mdi-folder-star::before {
  content: "\\f069d";
}

.mdi-folder-star-multiple::before {
  content: "\\f13d3";
}

.mdi-folder-star-multiple-outline::before {
  content: "\\f13d4";
}

.mdi-folder-star-outline::before {
  content: "\\f0b9f";
}

.mdi-folder-swap::before {
  content: "\\f0fb6";
}

.mdi-folder-swap-outline::before {
  content: "\\f0fb7";
}

.mdi-folder-sync::before {
  content: "\\f0d0b";
}

.mdi-folder-sync-outline::before {
  content: "\\f0d0c";
}

.mdi-folder-table::before {
  content: "\\f12e3";
}

.mdi-folder-table-outline::before {
  content: "\\f12e4";
}

.mdi-folder-text::before {
  content: "\\f0c82";
}

.mdi-folder-text-outline::before {
  content: "\\f0c83";
}

.mdi-folder-upload::before {
  content: "\\f0259";
}

.mdi-folder-upload-outline::before {
  content: "\\f10ed";
}

.mdi-folder-zip::before {
  content: "\\f06eb";
}

.mdi-folder-zip-outline::before {
  content: "\\f07b9";
}

.mdi-font-awesome::before {
  content: "\\f003a";
}

.mdi-food::before {
  content: "\\f025a";
}

.mdi-food-apple::before {
  content: "\\f025b";
}

.mdi-food-apple-outline::before {
  content: "\\f0c84";
}

.mdi-food-croissant::before {
  content: "\\f07c8";
}

.mdi-food-drumstick::before {
  content: "\\f141f";
}

.mdi-food-drumstick-off::before {
  content: "\\f1468";
}

.mdi-food-drumstick-off-outline::before {
  content: "\\f1469";
}

.mdi-food-drumstick-outline::before {
  content: "\\f1420";
}

.mdi-food-fork-drink::before {
  content: "\\f05f2";
}

.mdi-food-halal::before {
  content: "\\f1572";
}

.mdi-food-kosher::before {
  content: "\\f1573";
}

.mdi-food-off::before {
  content: "\\f05f3";
}

.mdi-food-steak::before {
  content: "\\f146a";
}

.mdi-food-steak-off::before {
  content: "\\f146b";
}

.mdi-food-variant::before {
  content: "\\f025c";
}

.mdi-food-variant-off::before {
  content: "\\f13e5";
}

.mdi-foot-print::before {
  content: "\\f0f52";
}

.mdi-football::before {
  content: "\\f025d";
}

.mdi-football-australian::before {
  content: "\\f025e";
}

.mdi-football-helmet::before {
  content: "\\f025f";
}

.mdi-forklift::before {
  content: "\\f07c9";
}

.mdi-form-dropdown::before {
  content: "\\f1400";
}

.mdi-form-select::before {
  content: "\\f1401";
}

.mdi-form-textarea::before {
  content: "\\f1095";
}

.mdi-form-textbox::before {
  content: "\\f060e";
}

.mdi-form-textbox-lock::before {
  content: "\\f135d";
}

.mdi-form-textbox-password::before {
  content: "\\f07f5";
}

.mdi-format-align-bottom::before {
  content: "\\f0753";
}

.mdi-format-align-center::before {
  content: "\\f0260";
}

.mdi-format-align-justify::before {
  content: "\\f0261";
}

.mdi-format-align-left::before {
  content: "\\f0262";
}

.mdi-format-align-middle::before {
  content: "\\f0754";
}

.mdi-format-align-right::before {
  content: "\\f0263";
}

.mdi-format-align-top::before {
  content: "\\f0755";
}

.mdi-format-annotation-minus::before {
  content: "\\f0abc";
}

.mdi-format-annotation-plus::before {
  content: "\\f0646";
}

.mdi-format-bold::before {
  content: "\\f0264";
}

.mdi-format-clear::before {
  content: "\\f0265";
}

.mdi-format-color-fill::before {
  content: "\\f0266";
}

.mdi-format-color-highlight::before {
  content: "\\f0e31";
}

.mdi-format-color-marker-cancel::before {
  content: "\\f1313";
}

.mdi-format-color-text::before {
  content: "\\f069e";
}

.mdi-format-columns::before {
  content: "\\f08df";
}

.mdi-format-float-center::before {
  content: "\\f0267";
}

.mdi-format-float-left::before {
  content: "\\f0268";
}

.mdi-format-float-none::before {
  content: "\\f0269";
}

.mdi-format-float-right::before {
  content: "\\f026a";
}

.mdi-format-font::before {
  content: "\\f06d6";
}

.mdi-format-font-size-decrease::before {
  content: "\\f09f3";
}

.mdi-format-font-size-increase::before {
  content: "\\f09f4";
}

.mdi-format-header-1::before {
  content: "\\f026b";
}

.mdi-format-header-2::before {
  content: "\\f026c";
}

.mdi-format-header-3::before {
  content: "\\f026d";
}

.mdi-format-header-4::before {
  content: "\\f026e";
}

.mdi-format-header-5::before {
  content: "\\f026f";
}

.mdi-format-header-6::before {
  content: "\\f0270";
}

.mdi-format-header-decrease::before {
  content: "\\f0271";
}

.mdi-format-header-equal::before {
  content: "\\f0272";
}

.mdi-format-header-increase::before {
  content: "\\f0273";
}

.mdi-format-header-pound::before {
  content: "\\f0274";
}

.mdi-format-horizontal-align-center::before {
  content: "\\f061e";
}

.mdi-format-horizontal-align-left::before {
  content: "\\f061f";
}

.mdi-format-horizontal-align-right::before {
  content: "\\f0620";
}

.mdi-format-indent-decrease::before {
  content: "\\f0275";
}

.mdi-format-indent-increase::before {
  content: "\\f0276";
}

.mdi-format-italic::before {
  content: "\\f0277";
}

.mdi-format-letter-case::before {
  content: "\\f0b34";
}

.mdi-format-letter-case-lower::before {
  content: "\\f0b35";
}

.mdi-format-letter-case-upper::before {
  content: "\\f0b36";
}

.mdi-format-letter-ends-with::before {
  content: "\\f0fb8";
}

.mdi-format-letter-matches::before {
  content: "\\f0fb9";
}

.mdi-format-letter-starts-with::before {
  content: "\\f0fba";
}

.mdi-format-line-spacing::before {
  content: "\\f0278";
}

.mdi-format-line-style::before {
  content: "\\f05c8";
}

.mdi-format-line-weight::before {
  content: "\\f05c9";
}

.mdi-format-list-bulleted::before {
  content: "\\f0279";
}

.mdi-format-list-bulleted-square::before {
  content: "\\f0dd0";
}

.mdi-format-list-bulleted-triangle::before {
  content: "\\f0eb2";
}

.mdi-format-list-bulleted-type::before {
  content: "\\f027a";
}

.mdi-format-list-checkbox::before {
  content: "\\f096a";
}

.mdi-format-list-checks::before {
  content: "\\f0756";
}

.mdi-format-list-numbered::before {
  content: "\\f027b";
}

.mdi-format-list-numbered-rtl::before {
  content: "\\f0d0d";
}

.mdi-format-list-text::before {
  content: "\\f126f";
}

.mdi-format-overline::before {
  content: "\\f0eb3";
}

.mdi-format-page-break::before {
  content: "\\f06d7";
}

.mdi-format-paint::before {
  content: "\\f027c";
}

.mdi-format-paragraph::before {
  content: "\\f027d";
}

.mdi-format-pilcrow::before {
  content: "\\f06d8";
}

.mdi-format-quote-close::before {
  content: "\\f027e";
}

.mdi-format-quote-close-outline::before {
  content: "\\f11a8";
}

.mdi-format-quote-open::before {
  content: "\\f0757";
}

.mdi-format-quote-open-outline::before {
  content: "\\f11a7";
}

.mdi-format-rotate-90::before {
  content: "\\f06aa";
}

.mdi-format-section::before {
  content: "\\f069f";
}

.mdi-format-size::before {
  content: "\\f027f";
}

.mdi-format-strikethrough::before {
  content: "\\f0280";
}

.mdi-format-strikethrough-variant::before {
  content: "\\f0281";
}

.mdi-format-subscript::before {
  content: "\\f0282";
}

.mdi-format-superscript::before {
  content: "\\f0283";
}

.mdi-format-text::before {
  content: "\\f0284";
}

.mdi-format-text-rotation-angle-down::before {
  content: "\\f0fbb";
}

.mdi-format-text-rotation-angle-up::before {
  content: "\\f0fbc";
}

.mdi-format-text-rotation-down::before {
  content: "\\f0d73";
}

.mdi-format-text-rotation-down-vertical::before {
  content: "\\f0fbd";
}

.mdi-format-text-rotation-none::before {
  content: "\\f0d74";
}

.mdi-format-text-rotation-up::before {
  content: "\\f0fbe";
}

.mdi-format-text-rotation-vertical::before {
  content: "\\f0fbf";
}

.mdi-format-text-variant::before {
  content: "\\f0e32";
}

.mdi-format-text-variant-outline::before {
  content: "\\f150f";
}

.mdi-format-text-wrapping-clip::before {
  content: "\\f0d0e";
}

.mdi-format-text-wrapping-overflow::before {
  content: "\\f0d0f";
}

.mdi-format-text-wrapping-wrap::before {
  content: "\\f0d10";
}

.mdi-format-textbox::before {
  content: "\\f0d11";
}

.mdi-format-textdirection-l-to-r::before {
  content: "\\f0285";
}

.mdi-format-textdirection-r-to-l::before {
  content: "\\f0286";
}

.mdi-format-title::before {
  content: "\\f05f4";
}

.mdi-format-underline::before {
  content: "\\f0287";
}

.mdi-format-vertical-align-bottom::before {
  content: "\\f0621";
}

.mdi-format-vertical-align-center::before {
  content: "\\f0622";
}

.mdi-format-vertical-align-top::before {
  content: "\\f0623";
}

.mdi-format-wrap-inline::before {
  content: "\\f0288";
}

.mdi-format-wrap-square::before {
  content: "\\f0289";
}

.mdi-format-wrap-tight::before {
  content: "\\f028a";
}

.mdi-format-wrap-top-bottom::before {
  content: "\\f028b";
}

.mdi-forum::before {
  content: "\\f028c";
}

.mdi-forum-outline::before {
  content: "\\f0822";
}

.mdi-forward::before {
  content: "\\f028d";
}

.mdi-forwardburger::before {
  content: "\\f0d75";
}

.mdi-fountain::before {
  content: "\\f096b";
}

.mdi-fountain-pen::before {
  content: "\\f0d12";
}

.mdi-fountain-pen-tip::before {
  content: "\\f0d13";
}

.mdi-freebsd::before {
  content: "\\f08e0";
}

.mdi-frequently-asked-questions::before {
  content: "\\f0eb4";
}

.mdi-fridge::before {
  content: "\\f0290";
}

.mdi-fridge-alert::before {
  content: "\\f11b1";
}

.mdi-fridge-alert-outline::before {
  content: "\\f11b2";
}

.mdi-fridge-bottom::before {
  content: "\\f0292";
}

.mdi-fridge-industrial::before {
  content: "\\f15ee";
}

.mdi-fridge-industrial-alert::before {
  content: "\\f15ef";
}

.mdi-fridge-industrial-alert-outline::before {
  content: "\\f15f0";
}

.mdi-fridge-industrial-off::before {
  content: "\\f15f1";
}

.mdi-fridge-industrial-off-outline::before {
  content: "\\f15f2";
}

.mdi-fridge-industrial-outline::before {
  content: "\\f15f3";
}

.mdi-fridge-off::before {
  content: "\\f11af";
}

.mdi-fridge-off-outline::before {
  content: "\\f11b0";
}

.mdi-fridge-outline::before {
  content: "\\f028f";
}

.mdi-fridge-top::before {
  content: "\\f0291";
}

.mdi-fridge-variant::before {
  content: "\\f15f4";
}

.mdi-fridge-variant-alert::before {
  content: "\\f15f5";
}

.mdi-fridge-variant-alert-outline::before {
  content: "\\f15f6";
}

.mdi-fridge-variant-off::before {
  content: "\\f15f7";
}

.mdi-fridge-variant-off-outline::before {
  content: "\\f15f8";
}

.mdi-fridge-variant-outline::before {
  content: "\\f15f9";
}

.mdi-fruit-cherries::before {
  content: "\\f1042";
}

.mdi-fruit-cherries-off::before {
  content: "\\f13f8";
}

.mdi-fruit-citrus::before {
  content: "\\f1043";
}

.mdi-fruit-citrus-off::before {
  content: "\\f13f9";
}

.mdi-fruit-grapes::before {
  content: "\\f1044";
}

.mdi-fruit-grapes-outline::before {
  content: "\\f1045";
}

.mdi-fruit-pineapple::before {
  content: "\\f1046";
}

.mdi-fruit-watermelon::before {
  content: "\\f1047";
}

.mdi-fuel::before {
  content: "\\f07ca";
}

.mdi-fullscreen::before {
  content: "\\f0293";
}

.mdi-fullscreen-exit::before {
  content: "\\f0294";
}

.mdi-function::before {
  content: "\\f0295";
}

.mdi-function-variant::before {
  content: "\\f0871";
}

.mdi-furigana-horizontal::before {
  content: "\\f1081";
}

.mdi-furigana-vertical::before {
  content: "\\f1082";
}

.mdi-fuse::before {
  content: "\\f0c85";
}

.mdi-fuse-alert::before {
  content: "\\f142d";
}

.mdi-fuse-blade::before {
  content: "\\f0c86";
}

.mdi-fuse-off::before {
  content: "\\f142c";
}

.mdi-gamepad::before {
  content: "\\f0296";
}

.mdi-gamepad-circle::before {
  content: "\\f0e33";
}

.mdi-gamepad-circle-down::before {
  content: "\\f0e34";
}

.mdi-gamepad-circle-left::before {
  content: "\\f0e35";
}

.mdi-gamepad-circle-outline::before {
  content: "\\f0e36";
}

.mdi-gamepad-circle-right::before {
  content: "\\f0e37";
}

.mdi-gamepad-circle-up::before {
  content: "\\f0e38";
}

.mdi-gamepad-down::before {
  content: "\\f0e39";
}

.mdi-gamepad-left::before {
  content: "\\f0e3a";
}

.mdi-gamepad-right::before {
  content: "\\f0e3b";
}

.mdi-gamepad-round::before {
  content: "\\f0e3c";
}

.mdi-gamepad-round-down::before {
  content: "\\f0e3d";
}

.mdi-gamepad-round-left::before {
  content: "\\f0e3e";
}

.mdi-gamepad-round-outline::before {
  content: "\\f0e3f";
}

.mdi-gamepad-round-right::before {
  content: "\\f0e40";
}

.mdi-gamepad-round-up::before {
  content: "\\f0e41";
}

.mdi-gamepad-square::before {
  content: "\\f0eb5";
}

.mdi-gamepad-square-outline::before {
  content: "\\f0eb6";
}

.mdi-gamepad-up::before {
  content: "\\f0e42";
}

.mdi-gamepad-variant::before {
  content: "\\f0297";
}

.mdi-gamepad-variant-outline::before {
  content: "\\f0eb7";
}

.mdi-gamma::before {
  content: "\\f10ee";
}

.mdi-gantry-crane::before {
  content: "\\f0dd1";
}

.mdi-garage::before {
  content: "\\f06d9";
}

.mdi-garage-alert::before {
  content: "\\f0872";
}

.mdi-garage-alert-variant::before {
  content: "\\f12d5";
}

.mdi-garage-open::before {
  content: "\\f06da";
}

.mdi-garage-open-variant::before {
  content: "\\f12d4";
}

.mdi-garage-variant::before {
  content: "\\f12d3";
}

.mdi-gas-cylinder::before {
  content: "\\f0647";
}

.mdi-gas-station::before {
  content: "\\f0298";
}

.mdi-gas-station-off::before {
  content: "\\f1409";
}

.mdi-gas-station-off-outline::before {
  content: "\\f140a";
}

.mdi-gas-station-outline::before {
  content: "\\f0eb8";
}

.mdi-gate::before {
  content: "\\f0299";
}

.mdi-gate-and::before {
  content: "\\f08e1";
}

.mdi-gate-arrow-right::before {
  content: "\\f1169";
}

.mdi-gate-nand::before {
  content: "\\f08e2";
}

.mdi-gate-nor::before {
  content: "\\f08e3";
}

.mdi-gate-not::before {
  content: "\\f08e4";
}

.mdi-gate-open::before {
  content: "\\f116a";
}

.mdi-gate-or::before {
  content: "\\f08e5";
}

.mdi-gate-xnor::before {
  content: "\\f08e6";
}

.mdi-gate-xor::before {
  content: "\\f08e7";
}

.mdi-gatsby::before {
  content: "\\f0e43";
}

.mdi-gauge::before {
  content: "\\f029a";
}

.mdi-gauge-empty::before {
  content: "\\f0873";
}

.mdi-gauge-full::before {
  content: "\\f0874";
}

.mdi-gauge-low::before {
  content: "\\f0875";
}

.mdi-gavel::before {
  content: "\\f029b";
}

.mdi-gender-female::before {
  content: "\\f029c";
}

.mdi-gender-male::before {
  content: "\\f029d";
}

.mdi-gender-male-female::before {
  content: "\\f029e";
}

.mdi-gender-male-female-variant::before {
  content: "\\f113f";
}

.mdi-gender-non-binary::before {
  content: "\\f1140";
}

.mdi-gender-transgender::before {
  content: "\\f029f";
}

.mdi-gentoo::before {
  content: "\\f08e8";
}

.mdi-gesture::before {
  content: "\\f07cb";
}

.mdi-gesture-double-tap::before {
  content: "\\f073c";
}

.mdi-gesture-pinch::before {
  content: "\\f0abd";
}

.mdi-gesture-spread::before {
  content: "\\f0abe";
}

.mdi-gesture-swipe::before {
  content: "\\f0d76";
}

.mdi-gesture-swipe-down::before {
  content: "\\f073d";
}

.mdi-gesture-swipe-horizontal::before {
  content: "\\f0abf";
}

.mdi-gesture-swipe-left::before {
  content: "\\f073e";
}

.mdi-gesture-swipe-right::before {
  content: "\\f073f";
}

.mdi-gesture-swipe-up::before {
  content: "\\f0740";
}

.mdi-gesture-swipe-vertical::before {
  content: "\\f0ac0";
}

.mdi-gesture-tap::before {
  content: "\\f0741";
}

.mdi-gesture-tap-box::before {
  content: "\\f12a9";
}

.mdi-gesture-tap-button::before {
  content: "\\f12a8";
}

.mdi-gesture-tap-hold::before {
  content: "\\f0d77";
}

.mdi-gesture-two-double-tap::before {
  content: "\\f0742";
}

.mdi-gesture-two-tap::before {
  content: "\\f0743";
}

.mdi-ghost::before {
  content: "\\f02a0";
}

.mdi-ghost-off::before {
  content: "\\f09f5";
}

.mdi-ghost-off-outline::before {
  content: "\\f165c";
}

.mdi-ghost-outline::before {
  content: "\\f165d";
}

.mdi-gif::before {
  content: "\\f0d78";
}

.mdi-gift::before {
  content: "\\f0e44";
}

.mdi-gift-outline::before {
  content: "\\f02a1";
}

.mdi-git::before {
  content: "\\f02a2";
}

.mdi-github::before {
  content: "\\f02a4";
}

.mdi-gitlab::before {
  content: "\\f0ba0";
}

.mdi-glass-cocktail::before {
  content: "\\f0356";
}

.mdi-glass-cocktail-off::before {
  content: "\\f15e6";
}

.mdi-glass-flute::before {
  content: "\\f02a5";
}

.mdi-glass-mug::before {
  content: "\\f02a6";
}

.mdi-glass-mug-off::before {
  content: "\\f15e7";
}

.mdi-glass-mug-variant::before {
  content: "\\f1116";
}

.mdi-glass-mug-variant-off::before {
  content: "\\f15e8";
}

.mdi-glass-pint-outline::before {
  content: "\\f130d";
}

.mdi-glass-stange::before {
  content: "\\f02a7";
}

.mdi-glass-tulip::before {
  content: "\\f02a8";
}

.mdi-glass-wine::before {
  content: "\\f0876";
}

.mdi-glasses::before {
  content: "\\f02aa";
}

.mdi-globe-light::before {
  content: "\\f12d7";
}

.mdi-globe-model::before {
  content: "\\f08e9";
}

.mdi-gmail::before {
  content: "\\f02ab";
}

.mdi-gnome::before {
  content: "\\f02ac";
}

.mdi-go-kart::before {
  content: "\\f0d79";
}

.mdi-go-kart-track::before {
  content: "\\f0d7a";
}

.mdi-gog::before {
  content: "\\f0ba1";
}

.mdi-gold::before {
  content: "\\f124f";
}

.mdi-golf::before {
  content: "\\f0823";
}

.mdi-golf-cart::before {
  content: "\\f11a4";
}

.mdi-golf-tee::before {
  content: "\\f1083";
}

.mdi-gondola::before {
  content: "\\f0686";
}

.mdi-goodreads::before {
  content: "\\f0d7b";
}

.mdi-google::before {
  content: "\\f02ad";
}

.mdi-google-ads::before {
  content: "\\f0c87";
}

.mdi-google-analytics::before {
  content: "\\f07cc";
}

.mdi-google-assistant::before {
  content: "\\f07cd";
}

.mdi-google-cardboard::before {
  content: "\\f02ae";
}

.mdi-google-chrome::before {
  content: "\\f02af";
}

.mdi-google-circles::before {
  content: "\\f02b0";
}

.mdi-google-circles-communities::before {
  content: "\\f02b1";
}

.mdi-google-circles-extended::before {
  content: "\\f02b2";
}

.mdi-google-circles-group::before {
  content: "\\f02b3";
}

.mdi-google-classroom::before {
  content: "\\f02c0";
}

.mdi-google-cloud::before {
  content: "\\f11f6";
}

.mdi-google-controller::before {
  content: "\\f02b4";
}

.mdi-google-controller-off::before {
  content: "\\f02b5";
}

.mdi-google-downasaur::before {
  content: "\\f1362";
}

.mdi-google-drive::before {
  content: "\\f02b6";
}

.mdi-google-earth::before {
  content: "\\f02b7";
}

.mdi-google-fit::before {
  content: "\\f096c";
}

.mdi-google-glass::before {
  content: "\\f02b8";
}

.mdi-google-hangouts::before {
  content: "\\f02c9";
}

.mdi-google-home::before {
  content: "\\f0824";
}

.mdi-google-keep::before {
  content: "\\f06dc";
}

.mdi-google-lens::before {
  content: "\\f09f6";
}

.mdi-google-maps::before {
  content: "\\f05f5";
}

.mdi-google-my-business::before {
  content: "\\f1048";
}

.mdi-google-nearby::before {
  content: "\\f02b9";
}

.mdi-google-photos::before {
  content: "\\f06dd";
}

.mdi-google-play::before {
  content: "\\f02bc";
}

.mdi-google-plus::before {
  content: "\\f02bd";
}

.mdi-google-podcast::before {
  content: "\\f0eb9";
}

.mdi-google-spreadsheet::before {
  content: "\\f09f7";
}

.mdi-google-street-view::before {
  content: "\\f0c88";
}

.mdi-google-translate::before {
  content: "\\f02bf";
}

.mdi-gradient::before {
  content: "\\f06a0";
}

.mdi-grain::before {
  content: "\\f0d7c";
}

.mdi-graph::before {
  content: "\\f1049";
}

.mdi-graph-outline::before {
  content: "\\f104a";
}

.mdi-graphql::before {
  content: "\\f0877";
}

.mdi-grass::before {
  content: "\\f1510";
}

.mdi-grave-stone::before {
  content: "\\f0ba2";
}

.mdi-grease-pencil::before {
  content: "\\f0648";
}

.mdi-greater-than::before {
  content: "\\f096d";
}

.mdi-greater-than-or-equal::before {
  content: "\\f096e";
}

.mdi-grid::before {
  content: "\\f02c1";
}

.mdi-grid-large::before {
  content: "\\f0758";
}

.mdi-grid-off::before {
  content: "\\f02c2";
}

.mdi-grill::before {
  content: "\\f0e45";
}

.mdi-grill-outline::before {
  content: "\\f118a";
}

.mdi-group::before {
  content: "\\f02c3";
}

.mdi-guitar-acoustic::before {
  content: "\\f0771";
}

.mdi-guitar-electric::before {
  content: "\\f02c4";
}

.mdi-guitar-pick::before {
  content: "\\f02c5";
}

.mdi-guitar-pick-outline::before {
  content: "\\f02c6";
}

.mdi-guy-fawkes-mask::before {
  content: "\\f0825";
}

.mdi-hail::before {
  content: "\\f0ac1";
}

.mdi-hair-dryer::before {
  content: "\\f10ef";
}

.mdi-hair-dryer-outline::before {
  content: "\\f10f0";
}

.mdi-halloween::before {
  content: "\\f0ba3";
}

.mdi-hamburger::before {
  content: "\\f0685";
}

.mdi-hammer::before {
  content: "\\f08ea";
}

.mdi-hammer-screwdriver::before {
  content: "\\f1322";
}

.mdi-hammer-wrench::before {
  content: "\\f1323";
}

.mdi-hand::before {
  content: "\\f0a4f";
}

.mdi-hand-heart::before {
  content: "\\f10f1";
}

.mdi-hand-heart-outline::before {
  content: "\\f157e";
}

.mdi-hand-left::before {
  content: "\\f0e46";
}

.mdi-hand-okay::before {
  content: "\\f0a50";
}

.mdi-hand-peace::before {
  content: "\\f0a51";
}

.mdi-hand-peace-variant::before {
  content: "\\f0a52";
}

.mdi-hand-pointing-down::before {
  content: "\\f0a53";
}

.mdi-hand-pointing-left::before {
  content: "\\f0a54";
}

.mdi-hand-pointing-right::before {
  content: "\\f02c7";
}

.mdi-hand-pointing-up::before {
  content: "\\f0a55";
}

.mdi-hand-right::before {
  content: "\\f0e47";
}

.mdi-hand-saw::before {
  content: "\\f0e48";
}

.mdi-hand-wash::before {
  content: "\\f157f";
}

.mdi-hand-wash-outline::before {
  content: "\\f1580";
}

.mdi-hand-water::before {
  content: "\\f139f";
}

.mdi-handball::before {
  content: "\\f0f53";
}

.mdi-handcuffs::before {
  content: "\\f113e";
}

.mdi-handshake::before {
  content: "\\f1218";
}

.mdi-handshake-outline::before {
  content: "\\f15a1";
}

.mdi-hanger::before {
  content: "\\f02c8";
}

.mdi-hard-hat::before {
  content: "\\f096f";
}

.mdi-harddisk::before {
  content: "\\f02ca";
}

.mdi-harddisk-plus::before {
  content: "\\f104b";
}

.mdi-harddisk-remove::before {
  content: "\\f104c";
}

.mdi-hat-fedora::before {
  content: "\\f0ba4";
}

.mdi-hazard-lights::before {
  content: "\\f0c89";
}

.mdi-hdr::before {
  content: "\\f0d7d";
}

.mdi-hdr-off::before {
  content: "\\f0d7e";
}

.mdi-head::before {
  content: "\\f135e";
}

.mdi-head-alert::before {
  content: "\\f1338";
}

.mdi-head-alert-outline::before {
  content: "\\f1339";
}

.mdi-head-check::before {
  content: "\\f133a";
}

.mdi-head-check-outline::before {
  content: "\\f133b";
}

.mdi-head-cog::before {
  content: "\\f133c";
}

.mdi-head-cog-outline::before {
  content: "\\f133d";
}

.mdi-head-dots-horizontal::before {
  content: "\\f133e";
}

.mdi-head-dots-horizontal-outline::before {
  content: "\\f133f";
}

.mdi-head-flash::before {
  content: "\\f1340";
}

.mdi-head-flash-outline::before {
  content: "\\f1341";
}

.mdi-head-heart::before {
  content: "\\f1342";
}

.mdi-head-heart-outline::before {
  content: "\\f1343";
}

.mdi-head-lightbulb::before {
  content: "\\f1344";
}

.mdi-head-lightbulb-outline::before {
  content: "\\f1345";
}

.mdi-head-minus::before {
  content: "\\f1346";
}

.mdi-head-minus-outline::before {
  content: "\\f1347";
}

.mdi-head-outline::before {
  content: "\\f135f";
}

.mdi-head-plus::before {
  content: "\\f1348";
}

.mdi-head-plus-outline::before {
  content: "\\f1349";
}

.mdi-head-question::before {
  content: "\\f134a";
}

.mdi-head-question-outline::before {
  content: "\\f134b";
}

.mdi-head-remove::before {
  content: "\\f134c";
}

.mdi-head-remove-outline::before {
  content: "\\f134d";
}

.mdi-head-snowflake::before {
  content: "\\f134e";
}

.mdi-head-snowflake-outline::before {
  content: "\\f134f";
}

.mdi-head-sync::before {
  content: "\\f1350";
}

.mdi-head-sync-outline::before {
  content: "\\f1351";
}

.mdi-headphones::before {
  content: "\\f02cb";
}

.mdi-headphones-bluetooth::before {
  content: "\\f0970";
}

.mdi-headphones-box::before {
  content: "\\f02cc";
}

.mdi-headphones-off::before {
  content: "\\f07ce";
}

.mdi-headphones-settings::before {
  content: "\\f02cd";
}

.mdi-headset::before {
  content: "\\f02ce";
}

.mdi-headset-dock::before {
  content: "\\f02cf";
}

.mdi-headset-off::before {
  content: "\\f02d0";
}

.mdi-heart::before {
  content: "\\f02d1";
}

.mdi-heart-box::before {
  content: "\\f02d2";
}

.mdi-heart-box-outline::before {
  content: "\\f02d3";
}

.mdi-heart-broken::before {
  content: "\\f02d4";
}

.mdi-heart-broken-outline::before {
  content: "\\f0d14";
}

.mdi-heart-circle::before {
  content: "\\f0971";
}

.mdi-heart-circle-outline::before {
  content: "\\f0972";
}

.mdi-heart-cog::before {
  content: "\\f1663";
}

.mdi-heart-cog-outline::before {
  content: "\\f1664";
}

.mdi-heart-flash::before {
  content: "\\f0ef9";
}

.mdi-heart-half::before {
  content: "\\f06df";
}

.mdi-heart-half-full::before {
  content: "\\f06de";
}

.mdi-heart-half-outline::before {
  content: "\\f06e0";
}

.mdi-heart-minus::before {
  content: "\\f142f";
}

.mdi-heart-minus-outline::before {
  content: "\\f1432";
}

.mdi-heart-multiple::before {
  content: "\\f0a56";
}

.mdi-heart-multiple-outline::before {
  content: "\\f0a57";
}

.mdi-heart-off::before {
  content: "\\f0759";
}

.mdi-heart-off-outline::before {
  content: "\\f1434";
}

.mdi-heart-outline::before {
  content: "\\f02d5";
}

.mdi-heart-plus::before {
  content: "\\f142e";
}

.mdi-heart-plus-outline::before {
  content: "\\f1431";
}

.mdi-heart-pulse::before {
  content: "\\f05f6";
}

.mdi-heart-remove::before {
  content: "\\f1430";
}

.mdi-heart-remove-outline::before {
  content: "\\f1433";
}

.mdi-heart-settings::before {
  content: "\\f1665";
}

.mdi-heart-settings-outline::before {
  content: "\\f1666";
}

.mdi-helicopter::before {
  content: "\\f0ac2";
}

.mdi-help::before {
  content: "\\f02d6";
}

.mdi-help-box::before {
  content: "\\f078b";
}

.mdi-help-circle::before {
  content: "\\f02d7";
}

.mdi-help-circle-outline::before {
  content: "\\f0625";
}

.mdi-help-network::before {
  content: "\\f06f5";
}

.mdi-help-network-outline::before {
  content: "\\f0c8a";
}

.mdi-help-rhombus::before {
  content: "\\f0ba5";
}

.mdi-help-rhombus-outline::before {
  content: "\\f0ba6";
}

.mdi-hexadecimal::before {
  content: "\\f12a7";
}

.mdi-hexagon::before {
  content: "\\f02d8";
}

.mdi-hexagon-multiple::before {
  content: "\\f06e1";
}

.mdi-hexagon-multiple-outline::before {
  content: "\\f10f2";
}

.mdi-hexagon-outline::before {
  content: "\\f02d9";
}

.mdi-hexagon-slice-1::before {
  content: "\\f0ac3";
}

.mdi-hexagon-slice-2::before {
  content: "\\f0ac4";
}

.mdi-hexagon-slice-3::before {
  content: "\\f0ac5";
}

.mdi-hexagon-slice-4::before {
  content: "\\f0ac6";
}

.mdi-hexagon-slice-5::before {
  content: "\\f0ac7";
}

.mdi-hexagon-slice-6::before {
  content: "\\f0ac8";
}

.mdi-hexagram::before {
  content: "\\f0ac9";
}

.mdi-hexagram-outline::before {
  content: "\\f0aca";
}

.mdi-high-definition::before {
  content: "\\f07cf";
}

.mdi-high-definition-box::before {
  content: "\\f0878";
}

.mdi-highway::before {
  content: "\\f05f7";
}

.mdi-hiking::before {
  content: "\\f0d7f";
}

.mdi-hinduism::before {
  content: "\\f0973";
}

.mdi-history::before {
  content: "\\f02da";
}

.mdi-hockey-puck::before {
  content: "\\f0879";
}

.mdi-hockey-sticks::before {
  content: "\\f087a";
}

.mdi-hololens::before {
  content: "\\f02db";
}

.mdi-home::before {
  content: "\\f02dc";
}

.mdi-home-account::before {
  content: "\\f0826";
}

.mdi-home-alert::before {
  content: "\\f087b";
}

.mdi-home-alert-outline::before {
  content: "\\f15d0";
}

.mdi-home-analytics::before {
  content: "\\f0eba";
}

.mdi-home-assistant::before {
  content: "\\f07d0";
}

.mdi-home-automation::before {
  content: "\\f07d1";
}

.mdi-home-circle::before {
  content: "\\f07d2";
}

.mdi-home-circle-outline::before {
  content: "\\f104d";
}

.mdi-home-city::before {
  content: "\\f0d15";
}

.mdi-home-city-outline::before {
  content: "\\f0d16";
}

.mdi-home-currency-usd::before {
  content: "\\f08af";
}

.mdi-home-edit::before {
  content: "\\f1159";
}

.mdi-home-edit-outline::before {
  content: "\\f115a";
}

.mdi-home-export-outline::before {
  content: "\\f0f9b";
}

.mdi-home-flood::before {
  content: "\\f0efa";
}

.mdi-home-floor-0::before {
  content: "\\f0dd2";
}

.mdi-home-floor-1::before {
  content: "\\f0d80";
}

.mdi-home-floor-2::before {
  content: "\\f0d81";
}

.mdi-home-floor-3::before {
  content: "\\f0d82";
}

.mdi-home-floor-a::before {
  content: "\\f0d83";
}

.mdi-home-floor-b::before {
  content: "\\f0d84";
}

.mdi-home-floor-g::before {
  content: "\\f0d85";
}

.mdi-home-floor-l::before {
  content: "\\f0d86";
}

.mdi-home-floor-negative-1::before {
  content: "\\f0dd3";
}

.mdi-home-group::before {
  content: "\\f0dd4";
}

.mdi-home-heart::before {
  content: "\\f0827";
}

.mdi-home-import-outline::before {
  content: "\\f0f9c";
}

.mdi-home-lightbulb::before {
  content: "\\f1251";
}

.mdi-home-lightbulb-outline::before {
  content: "\\f1252";
}

.mdi-home-lock::before {
  content: "\\f08eb";
}

.mdi-home-lock-open::before {
  content: "\\f08ec";
}

.mdi-home-map-marker::before {
  content: "\\f05f8";
}

.mdi-home-minus::before {
  content: "\\f0974";
}

.mdi-home-minus-outline::before {
  content: "\\f13d5";
}

.mdi-home-modern::before {
  content: "\\f02dd";
}

.mdi-home-outline::before {
  content: "\\f06a1";
}

.mdi-home-plus::before {
  content: "\\f0975";
}

.mdi-home-plus-outline::before {
  content: "\\f13d6";
}

.mdi-home-remove::before {
  content: "\\f1247";
}

.mdi-home-remove-outline::before {
  content: "\\f13d7";
}

.mdi-home-roof::before {
  content: "\\f112b";
}

.mdi-home-search::before {
  content: "\\f13b0";
}

.mdi-home-search-outline::before {
  content: "\\f13b1";
}

.mdi-home-thermometer::before {
  content: "\\f0f54";
}

.mdi-home-thermometer-outline::before {
  content: "\\f0f55";
}

.mdi-home-variant::before {
  content: "\\f02de";
}

.mdi-home-variant-outline::before {
  content: "\\f0ba7";
}

.mdi-hook::before {
  content: "\\f06e2";
}

.mdi-hook-off::before {
  content: "\\f06e3";
}

.mdi-hops::before {
  content: "\\f02df";
}

.mdi-horizontal-rotate-clockwise::before {
  content: "\\f10f3";
}

.mdi-horizontal-rotate-counterclockwise::before {
  content: "\\f10f4";
}

.mdi-horse::before {
  content: "\\f15bf";
}

.mdi-horse-human::before {
  content: "\\f15c0";
}

.mdi-horse-variant::before {
  content: "\\f15c1";
}

.mdi-horseshoe::before {
  content: "\\f0a58";
}

.mdi-hospital::before {
  content: "\\f0ff6";
}

.mdi-hospital-box::before {
  content: "\\f02e0";
}

.mdi-hospital-box-outline::before {
  content: "\\f0ff7";
}

.mdi-hospital-building::before {
  content: "\\f02e1";
}

.mdi-hospital-marker::before {
  content: "\\f02e2";
}

.mdi-hot-tub::before {
  content: "\\f0828";
}

.mdi-hours-24::before {
  content: "\\f1478";
}

.mdi-hubspot::before {
  content: "\\f0d17";
}

.mdi-hulu::before {
  content: "\\f0829";
}

.mdi-human::before {
  content: "\\f02e6";
}

.mdi-human-baby-changing-table::before {
  content: "\\f138b";
}

.mdi-human-cane::before {
  content: "\\f1581";
}

.mdi-human-capacity-decrease::before {
  content: "\\f159b";
}

.mdi-human-capacity-increase::before {
  content: "\\f159c";
}

.mdi-human-child::before {
  content: "\\f02e7";
}

.mdi-human-edit::before {
  content: "\\f14e8";
}

.mdi-human-female::before {
  content: "\\f0649";
}

.mdi-human-female-boy::before {
  content: "\\f0a59";
}

.mdi-human-female-dance::before {
  content: "\\f15c9";
}

.mdi-human-female-female::before {
  content: "\\f0a5a";
}

.mdi-human-female-girl::before {
  content: "\\f0a5b";
}

.mdi-human-greeting::before {
  content: "\\f064a";
}

.mdi-human-greeting-proximity::before {
  content: "\\f159d";
}

.mdi-human-handsdown::before {
  content: "\\f064b";
}

.mdi-human-handsup::before {
  content: "\\f064c";
}

.mdi-human-male::before {
  content: "\\f064d";
}

.mdi-human-male-boy::before {
  content: "\\f0a5c";
}

.mdi-human-male-child::before {
  content: "\\f138c";
}

.mdi-human-male-female::before {
  content: "\\f02e8";
}

.mdi-human-male-girl::before {
  content: "\\f0a5d";
}

.mdi-human-male-height::before {
  content: "\\f0efb";
}

.mdi-human-male-height-variant::before {
  content: "\\f0efc";
}

.mdi-human-male-male::before {
  content: "\\f0a5e";
}

.mdi-human-pregnant::before {
  content: "\\f05cf";
}

.mdi-human-queue::before {
  content: "\\f1571";
}

.mdi-human-scooter::before {
  content: "\\f11e9";
}

.mdi-human-wheelchair::before {
  content: "\\f138d";
}

.mdi-humble-bundle::before {
  content: "\\f0744";
}

.mdi-hvac::before {
  content: "\\f1352";
}

.mdi-hvac-off::before {
  content: "\\f159e";
}

.mdi-hydraulic-oil-level::before {
  content: "\\f1324";
}

.mdi-hydraulic-oil-temperature::before {
  content: "\\f1325";
}

.mdi-hydro-power::before {
  content: "\\f12e5";
}

.mdi-ice-cream::before {
  content: "\\f082a";
}

.mdi-ice-cream-off::before {
  content: "\\f0e52";
}

.mdi-ice-pop::before {
  content: "\\f0efd";
}

.mdi-id-card::before {
  content: "\\f0fc0";
}

.mdi-identifier::before {
  content: "\\f0efe";
}

.mdi-ideogram-cjk::before {
  content: "\\f1331";
}

.mdi-ideogram-cjk-variant::before {
  content: "\\f1332";
}

.mdi-iframe::before {
  content: "\\f0c8b";
}

.mdi-iframe-array::before {
  content: "\\f10f5";
}

.mdi-iframe-array-outline::before {
  content: "\\f10f6";
}

.mdi-iframe-braces::before {
  content: "\\f10f7";
}

.mdi-iframe-braces-outline::before {
  content: "\\f10f8";
}

.mdi-iframe-outline::before {
  content: "\\f0c8c";
}

.mdi-iframe-parentheses::before {
  content: "\\f10f9";
}

.mdi-iframe-parentheses-outline::before {
  content: "\\f10fa";
}

.mdi-iframe-variable::before {
  content: "\\f10fb";
}

.mdi-iframe-variable-outline::before {
  content: "\\f10fc";
}

.mdi-image::before {
  content: "\\f02e9";
}

.mdi-image-album::before {
  content: "\\f02ea";
}

.mdi-image-area::before {
  content: "\\f02eb";
}

.mdi-image-area-close::before {
  content: "\\f02ec";
}

.mdi-image-auto-adjust::before {
  content: "\\f0fc1";
}

.mdi-image-broken::before {
  content: "\\f02ed";
}

.mdi-image-broken-variant::before {
  content: "\\f02ee";
}

.mdi-image-edit::before {
  content: "\\f11e3";
}

.mdi-image-edit-outline::before {
  content: "\\f11e4";
}

.mdi-image-filter-black-white::before {
  content: "\\f02f0";
}

.mdi-image-filter-center-focus::before {
  content: "\\f02f1";
}

.mdi-image-filter-center-focus-strong::before {
  content: "\\f0eff";
}

.mdi-image-filter-center-focus-strong-outline::before {
  content: "\\f0f00";
}

.mdi-image-filter-center-focus-weak::before {
  content: "\\f02f2";
}

.mdi-image-filter-drama::before {
  content: "\\f02f3";
}

.mdi-image-filter-frames::before {
  content: "\\f02f4";
}

.mdi-image-filter-hdr::before {
  content: "\\f02f5";
}

.mdi-image-filter-none::before {
  content: "\\f02f6";
}

.mdi-image-filter-tilt-shift::before {
  content: "\\f02f7";
}

.mdi-image-filter-vintage::before {
  content: "\\f02f8";
}

.mdi-image-frame::before {
  content: "\\f0e49";
}

.mdi-image-minus::before {
  content: "\\f1419";
}

.mdi-image-move::before {
  content: "\\f09f8";
}

.mdi-image-multiple::before {
  content: "\\f02f9";
}

.mdi-image-multiple-outline::before {
  content: "\\f02ef";
}

.mdi-image-off::before {
  content: "\\f082b";
}

.mdi-image-off-outline::before {
  content: "\\f11d1";
}

.mdi-image-outline::before {
  content: "\\f0976";
}

.mdi-image-plus::before {
  content: "\\f087c";
}

.mdi-image-remove::before {
  content: "\\f1418";
}

.mdi-image-search::before {
  content: "\\f0977";
}

.mdi-image-search-outline::before {
  content: "\\f0978";
}

.mdi-image-size-select-actual::before {
  content: "\\f0c8d";
}

.mdi-image-size-select-large::before {
  content: "\\f0c8e";
}

.mdi-image-size-select-small::before {
  content: "\\f0c8f";
}

.mdi-image-text::before {
  content: "\\f160d";
}

.mdi-import::before {
  content: "\\f02fa";
}

.mdi-inbox::before {
  content: "\\f0687";
}

.mdi-inbox-arrow-down::before {
  content: "\\f02fb";
}

.mdi-inbox-arrow-down-outline::before {
  content: "\\f1270";
}

.mdi-inbox-arrow-up::before {
  content: "\\f03d1";
}

.mdi-inbox-arrow-up-outline::before {
  content: "\\f1271";
}

.mdi-inbox-full::before {
  content: "\\f1272";
}

.mdi-inbox-full-outline::before {
  content: "\\f1273";
}

.mdi-inbox-multiple::before {
  content: "\\f08b0";
}

.mdi-inbox-multiple-outline::before {
  content: "\\f0ba8";
}

.mdi-inbox-outline::before {
  content: "\\f1274";
}

.mdi-inbox-remove::before {
  content: "\\f159f";
}

.mdi-inbox-remove-outline::before {
  content: "\\f15a0";
}

.mdi-incognito::before {
  content: "\\f05f9";
}

.mdi-incognito-circle::before {
  content: "\\f1421";
}

.mdi-incognito-circle-off::before {
  content: "\\f1422";
}

.mdi-incognito-off::before {
  content: "\\f0075";
}

.mdi-infinity::before {
  content: "\\f06e4";
}

.mdi-information::before {
  content: "\\f02fc";
}

.mdi-information-outline::before {
  content: "\\f02fd";
}

.mdi-information-variant::before {
  content: "\\f064e";
}

.mdi-instagram::before {
  content: "\\f02fe";
}

.mdi-instrument-triangle::before {
  content: "\\f104e";
}

.mdi-invert-colors::before {
  content: "\\f0301";
}

.mdi-invert-colors-off::before {
  content: "\\f0e4a";
}

.mdi-iobroker::before {
  content: "\\f12e8";
}

.mdi-ip::before {
  content: "\\f0a5f";
}

.mdi-ip-network::before {
  content: "\\f0a60";
}

.mdi-ip-network-outline::before {
  content: "\\f0c90";
}

.mdi-ipod::before {
  content: "\\f0c91";
}

.mdi-islam::before {
  content: "\\f0979";
}

.mdi-island::before {
  content: "\\f104f";
}

.mdi-iv-bag::before {
  content: "\\f10b9";
}

.mdi-jabber::before {
  content: "\\f0dd5";
}

.mdi-jeepney::before {
  content: "\\f0302";
}

.mdi-jellyfish::before {
  content: "\\f0f01";
}

.mdi-jellyfish-outline::before {
  content: "\\f0f02";
}

.mdi-jira::before {
  content: "\\f0303";
}

.mdi-jquery::before {
  content: "\\f087d";
}

.mdi-jsfiddle::before {
  content: "\\f0304";
}

.mdi-judaism::before {
  content: "\\f097a";
}

.mdi-jump-rope::before {
  content: "\\f12ff";
}

.mdi-kabaddi::before {
  content: "\\f0d87";
}

.mdi-kangaroo::before {
  content: "\\f1558";
}

.mdi-karate::before {
  content: "\\f082c";
}

.mdi-keg::before {
  content: "\\f0305";
}

.mdi-kettle::before {
  content: "\\f05fa";
}

.mdi-kettle-alert::before {
  content: "\\f1317";
}

.mdi-kettle-alert-outline::before {
  content: "\\f1318";
}

.mdi-kettle-off::before {
  content: "\\f131b";
}

.mdi-kettle-off-outline::before {
  content: "\\f131c";
}

.mdi-kettle-outline::before {
  content: "\\f0f56";
}

.mdi-kettle-steam::before {
  content: "\\f1319";
}

.mdi-kettle-steam-outline::before {
  content: "\\f131a";
}

.mdi-kettlebell::before {
  content: "\\f1300";
}

.mdi-key::before {
  content: "\\f0306";
}

.mdi-key-arrow-right::before {
  content: "\\f1312";
}

.mdi-key-chain::before {
  content: "\\f1574";
}

.mdi-key-chain-variant::before {
  content: "\\f1575";
}

.mdi-key-change::before {
  content: "\\f0307";
}

.mdi-key-link::before {
  content: "\\f119f";
}

.mdi-key-minus::before {
  content: "\\f0308";
}

.mdi-key-outline::before {
  content: "\\f0dd6";
}

.mdi-key-plus::before {
  content: "\\f0309";
}

.mdi-key-remove::before {
  content: "\\f030a";
}

.mdi-key-star::before {
  content: "\\f119e";
}

.mdi-key-variant::before {
  content: "\\f030b";
}

.mdi-key-wireless::before {
  content: "\\f0fc2";
}

.mdi-keyboard::before {
  content: "\\f030c";
}

.mdi-keyboard-backspace::before {
  content: "\\f030d";
}

.mdi-keyboard-caps::before {
  content: "\\f030e";
}

.mdi-keyboard-close::before {
  content: "\\f030f";
}

.mdi-keyboard-esc::before {
  content: "\\f12b7";
}

.mdi-keyboard-f1::before {
  content: "\\f12ab";
}

.mdi-keyboard-f10::before {
  content: "\\f12b4";
}

.mdi-keyboard-f11::before {
  content: "\\f12b5";
}

.mdi-keyboard-f12::before {
  content: "\\f12b6";
}

.mdi-keyboard-f2::before {
  content: "\\f12ac";
}

.mdi-keyboard-f3::before {
  content: "\\f12ad";
}

.mdi-keyboard-f4::before {
  content: "\\f12ae";
}

.mdi-keyboard-f5::before {
  content: "\\f12af";
}

.mdi-keyboard-f6::before {
  content: "\\f12b0";
}

.mdi-keyboard-f7::before {
  content: "\\f12b1";
}

.mdi-keyboard-f8::before {
  content: "\\f12b2";
}

.mdi-keyboard-f9::before {
  content: "\\f12b3";
}

.mdi-keyboard-off::before {
  content: "\\f0310";
}

.mdi-keyboard-off-outline::before {
  content: "\\f0e4b";
}

.mdi-keyboard-outline::before {
  content: "\\f097b";
}

.mdi-keyboard-return::before {
  content: "\\f0311";
}

.mdi-keyboard-settings::before {
  content: "\\f09f9";
}

.mdi-keyboard-settings-outline::before {
  content: "\\f09fa";
}

.mdi-keyboard-space::before {
  content: "\\f1050";
}

.mdi-keyboard-tab::before {
  content: "\\f0312";
}

.mdi-keyboard-variant::before {
  content: "\\f0313";
}

.mdi-khanda::before {
  content: "\\f10fd";
}

.mdi-kickstarter::before {
  content: "\\f0745";
}

.mdi-klingon::before {
  content: "\\f135b";
}

.mdi-knife::before {
  content: "\\f09fb";
}

.mdi-knife-military::before {
  content: "\\f09fc";
}

.mdi-kodi::before {
  content: "\\f0314";
}

.mdi-kubernetes::before {
  content: "\\f10fe";
}

.mdi-label::before {
  content: "\\f0315";
}

.mdi-label-multiple::before {
  content: "\\f1375";
}

.mdi-label-multiple-outline::before {
  content: "\\f1376";
}

.mdi-label-off::before {
  content: "\\f0acb";
}

.mdi-label-off-outline::before {
  content: "\\f0acc";
}

.mdi-label-outline::before {
  content: "\\f0316";
}

.mdi-label-percent::before {
  content: "\\f12ea";
}

.mdi-label-percent-outline::before {
  content: "\\f12eb";
}

.mdi-label-variant::before {
  content: "\\f0acd";
}

.mdi-label-variant-outline::before {
  content: "\\f0ace";
}

.mdi-ladder::before {
  content: "\\f15a2";
}

.mdi-ladybug::before {
  content: "\\f082d";
}

.mdi-lambda::before {
  content: "\\f0627";
}

.mdi-lamp::before {
  content: "\\f06b5";
}

.mdi-lamps::before {
  content: "\\f1576";
}

.mdi-lan::before {
  content: "\\f0317";
}

.mdi-lan-check::before {
  content: "\\f12aa";
}

.mdi-lan-connect::before {
  content: "\\f0318";
}

.mdi-lan-disconnect::before {
  content: "\\f0319";
}

.mdi-lan-pending::before {
  content: "\\f031a";
}

.mdi-language-c::before {
  content: "\\f0671";
}

.mdi-language-cpp::before {
  content: "\\f0672";
}

.mdi-language-csharp::before {
  content: "\\f031b";
}

.mdi-language-css3::before {
  content: "\\f031c";
}

.mdi-language-fortran::before {
  content: "\\f121a";
}

.mdi-language-go::before {
  content: "\\f07d3";
}

.mdi-language-haskell::before {
  content: "\\f0c92";
}

.mdi-language-html5::before {
  content: "\\f031d";
}

.mdi-language-java::before {
  content: "\\f0b37";
}

.mdi-language-javascript::before {
  content: "\\f031e";
}

.mdi-language-kotlin::before {
  content: "\\f1219";
}

.mdi-language-lua::before {
  content: "\\f08b1";
}

.mdi-language-markdown::before {
  content: "\\f0354";
}

.mdi-language-markdown-outline::before {
  content: "\\f0f5b";
}

.mdi-language-php::before {
  content: "\\f031f";
}

.mdi-language-python::before {
  content: "\\f0320";
}

.mdi-language-r::before {
  content: "\\f07d4";
}

.mdi-language-ruby::before {
  content: "\\f0d2d";
}

.mdi-language-ruby-on-rails::before {
  content: "\\f0acf";
}

.mdi-language-rust::before {
  content: "\\f1617";
}

.mdi-language-swift::before {
  content: "\\f06e5";
}

.mdi-language-typescript::before {
  content: "\\f06e6";
}

.mdi-language-xaml::before {
  content: "\\f0673";
}

.mdi-laptop::before {
  content: "\\f0322";
}

.mdi-laptop-chromebook::before {
  content: "\\f0323";
}

.mdi-laptop-mac::before {
  content: "\\f0324";
}

.mdi-laptop-off::before {
  content: "\\f06e7";
}

.mdi-laptop-windows::before {
  content: "\\f0325";
}

.mdi-laravel::before {
  content: "\\f0ad0";
}

.mdi-laser-pointer::before {
  content: "\\f1484";
}

.mdi-lasso::before {
  content: "\\f0f03";
}

.mdi-lastpass::before {
  content: "\\f0446";
}

.mdi-latitude::before {
  content: "\\f0f57";
}

.mdi-launch::before {
  content: "\\f0327";
}

.mdi-lava-lamp::before {
  content: "\\f07d5";
}

.mdi-layers::before {
  content: "\\f0328";
}

.mdi-layers-minus::before {
  content: "\\f0e4c";
}

.mdi-layers-off::before {
  content: "\\f0329";
}

.mdi-layers-off-outline::before {
  content: "\\f09fd";
}

.mdi-layers-outline::before {
  content: "\\f09fe";
}

.mdi-layers-plus::before {
  content: "\\f0e4d";
}

.mdi-layers-remove::before {
  content: "\\f0e4e";
}

.mdi-layers-search::before {
  content: "\\f1206";
}

.mdi-layers-search-outline::before {
  content: "\\f1207";
}

.mdi-layers-triple::before {
  content: "\\f0f58";
}

.mdi-layers-triple-outline::before {
  content: "\\f0f59";
}

.mdi-lead-pencil::before {
  content: "\\f064f";
}

.mdi-leaf::before {
  content: "\\f032a";
}

.mdi-leaf-maple::before {
  content: "\\f0c93";
}

.mdi-leaf-maple-off::before {
  content: "\\f12da";
}

.mdi-leaf-off::before {
  content: "\\f12d9";
}

.mdi-leak::before {
  content: "\\f0dd7";
}

.mdi-leak-off::before {
  content: "\\f0dd8";
}

.mdi-led-off::before {
  content: "\\f032b";
}

.mdi-led-on::before {
  content: "\\f032c";
}

.mdi-led-outline::before {
  content: "\\f032d";
}

.mdi-led-strip::before {
  content: "\\f07d6";
}

.mdi-led-strip-variant::before {
  content: "\\f1051";
}

.mdi-led-variant-off::before {
  content: "\\f032e";
}

.mdi-led-variant-on::before {
  content: "\\f032f";
}

.mdi-led-variant-outline::before {
  content: "\\f0330";
}

.mdi-leek::before {
  content: "\\f117d";
}

.mdi-less-than::before {
  content: "\\f097c";
}

.mdi-less-than-or-equal::before {
  content: "\\f097d";
}

.mdi-library::before {
  content: "\\f0331";
}

.mdi-library-shelves::before {
  content: "\\f0ba9";
}

.mdi-license::before {
  content: "\\f0fc3";
}

.mdi-lifebuoy::before {
  content: "\\f087e";
}

.mdi-light-switch::before {
  content: "\\f097e";
}

.mdi-lightbulb::before {
  content: "\\f0335";
}

.mdi-lightbulb-cfl::before {
  content: "\\f1208";
}

.mdi-lightbulb-cfl-off::before {
  content: "\\f1209";
}

.mdi-lightbulb-cfl-spiral::before {
  content: "\\f1275";
}

.mdi-lightbulb-cfl-spiral-off::before {
  content: "\\f12c3";
}

.mdi-lightbulb-group::before {
  content: "\\f1253";
}

.mdi-lightbulb-group-off::before {
  content: "\\f12cd";
}

.mdi-lightbulb-group-off-outline::before {
  content: "\\f12ce";
}

.mdi-lightbulb-group-outline::before {
  content: "\\f1254";
}

.mdi-lightbulb-multiple::before {
  content: "\\f1255";
}

.mdi-lightbulb-multiple-off::before {
  content: "\\f12cf";
}

.mdi-lightbulb-multiple-off-outline::before {
  content: "\\f12d0";
}

.mdi-lightbulb-multiple-outline::before {
  content: "\\f1256";
}

.mdi-lightbulb-off::before {
  content: "\\f0e4f";
}

.mdi-lightbulb-off-outline::before {
  content: "\\f0e50";
}

.mdi-lightbulb-on::before {
  content: "\\f06e8";
}

.mdi-lightbulb-on-outline::before {
  content: "\\f06e9";
}

.mdi-lightbulb-outline::before {
  content: "\\f0336";
}

.mdi-lighthouse::before {
  content: "\\f09ff";
}

.mdi-lighthouse-on::before {
  content: "\\f0a00";
}

.mdi-lightning-bolt::before {
  content: "\\f140b";
}

.mdi-lightning-bolt-outline::before {
  content: "\\f140c";
}

.mdi-lingerie::before {
  content: "\\f1476";
}

.mdi-link::before {
  content: "\\f0337";
}

.mdi-link-box::before {
  content: "\\f0d1a";
}

.mdi-link-box-outline::before {
  content: "\\f0d1b";
}

.mdi-link-box-variant::before {
  content: "\\f0d1c";
}

.mdi-link-box-variant-outline::before {
  content: "\\f0d1d";
}

.mdi-link-lock::before {
  content: "\\f10ba";
}

.mdi-link-off::before {
  content: "\\f0338";
}

.mdi-link-plus::before {
  content: "\\f0c94";
}

.mdi-link-variant::before {
  content: "\\f0339";
}

.mdi-link-variant-minus::before {
  content: "\\f10ff";
}

.mdi-link-variant-off::before {
  content: "\\f033a";
}

.mdi-link-variant-plus::before {
  content: "\\f1100";
}

.mdi-link-variant-remove::before {
  content: "\\f1101";
}

.mdi-linkedin::before {
  content: "\\f033b";
}

.mdi-linux::before {
  content: "\\f033d";
}

.mdi-linux-mint::before {
  content: "\\f08ed";
}

.mdi-lipstick::before {
  content: "\\f13b5";
}

.mdi-list-status::before {
  content: "\\f15ab";
}

.mdi-litecoin::before {
  content: "\\f0a61";
}

.mdi-loading::before {
  content: "\\f0772";
}

.mdi-location-enter::before {
  content: "\\f0fc4";
}

.mdi-location-exit::before {
  content: "\\f0fc5";
}

.mdi-lock::before {
  content: "\\f033e";
}

.mdi-lock-alert::before {
  content: "\\f08ee";
}

.mdi-lock-alert-outline::before {
  content: "\\f15d1";
}

.mdi-lock-check::before {
  content: "\\f139a";
}

.mdi-lock-check-outline::before {
  content: "\\f16a8";
}

.mdi-lock-clock::before {
  content: "\\f097f";
}

.mdi-lock-minus::before {
  content: "\\f16a9";
}

.mdi-lock-minus-outline::before {
  content: "\\f16aa";
}

.mdi-lock-off::before {
  content: "\\f1671";
}

.mdi-lock-off-outline::before {
  content: "\\f1672";
}

.mdi-lock-open::before {
  content: "\\f033f";
}

.mdi-lock-open-alert::before {
  content: "\\f139b";
}

.mdi-lock-open-alert-outline::before {
  content: "\\f15d2";
}

.mdi-lock-open-check::before {
  content: "\\f139c";
}

.mdi-lock-open-check-outline::before {
  content: "\\f16ab";
}

.mdi-lock-open-minus::before {
  content: "\\f16ac";
}

.mdi-lock-open-minus-outline::before {
  content: "\\f16ad";
}

.mdi-lock-open-outline::before {
  content: "\\f0340";
}

.mdi-lock-open-plus::before {
  content: "\\f16ae";
}

.mdi-lock-open-plus-outline::before {
  content: "\\f16af";
}

.mdi-lock-open-remove::before {
  content: "\\f16b0";
}

.mdi-lock-open-remove-outline::before {
  content: "\\f16b1";
}

.mdi-lock-open-variant::before {
  content: "\\f0fc6";
}

.mdi-lock-open-variant-outline::before {
  content: "\\f0fc7";
}

.mdi-lock-outline::before {
  content: "\\f0341";
}

.mdi-lock-pattern::before {
  content: "\\f06ea";
}

.mdi-lock-plus::before {
  content: "\\f05fb";
}

.mdi-lock-plus-outline::before {
  content: "\\f16b2";
}

.mdi-lock-question::before {
  content: "\\f08ef";
}

.mdi-lock-remove::before {
  content: "\\f16b3";
}

.mdi-lock-remove-outline::before {
  content: "\\f16b4";
}

.mdi-lock-reset::before {
  content: "\\f0773";
}

.mdi-lock-smart::before {
  content: "\\f08b2";
}

.mdi-locker::before {
  content: "\\f07d7";
}

.mdi-locker-multiple::before {
  content: "\\f07d8";
}

.mdi-login::before {
  content: "\\f0342";
}

.mdi-login-variant::before {
  content: "\\f05fc";
}

.mdi-logout::before {
  content: "\\f0343";
}

.mdi-logout-variant::before {
  content: "\\f05fd";
}

.mdi-longitude::before {
  content: "\\f0f5a";
}

.mdi-looks::before {
  content: "\\f0344";
}

.mdi-lotion::before {
  content: "\\f1582";
}

.mdi-lotion-outline::before {
  content: "\\f1583";
}

.mdi-lotion-plus::before {
  content: "\\f1584";
}

.mdi-lotion-plus-outline::before {
  content: "\\f1585";
}

.mdi-loupe::before {
  content: "\\f0345";
}

.mdi-lumx::before {
  content: "\\f0346";
}

.mdi-lungs::before {
  content: "\\f1084";
}

.mdi-magnet::before {
  content: "\\f0347";
}

.mdi-magnet-on::before {
  content: "\\f0348";
}

.mdi-magnify::before {
  content: "\\f0349";
}

.mdi-magnify-close::before {
  content: "\\f0980";
}

.mdi-magnify-minus::before {
  content: "\\f034a";
}

.mdi-magnify-minus-cursor::before {
  content: "\\f0a62";
}

.mdi-magnify-minus-outline::before {
  content: "\\f06ec";
}

.mdi-magnify-plus::before {
  content: "\\f034b";
}

.mdi-magnify-plus-cursor::before {
  content: "\\f0a63";
}

.mdi-magnify-plus-outline::before {
  content: "\\f06ed";
}

.mdi-magnify-remove-cursor::before {
  content: "\\f120c";
}

.mdi-magnify-remove-outline::before {
  content: "\\f120d";
}

.mdi-magnify-scan::before {
  content: "\\f1276";
}

.mdi-mail::before {
  content: "\\f0ebb";
}

.mdi-mailbox::before {
  content: "\\f06ee";
}

.mdi-mailbox-open::before {
  content: "\\f0d88";
}

.mdi-mailbox-open-outline::before {
  content: "\\f0d89";
}

.mdi-mailbox-open-up::before {
  content: "\\f0d8a";
}

.mdi-mailbox-open-up-outline::before {
  content: "\\f0d8b";
}

.mdi-mailbox-outline::before {
  content: "\\f0d8c";
}

.mdi-mailbox-up::before {
  content: "\\f0d8d";
}

.mdi-mailbox-up-outline::before {
  content: "\\f0d8e";
}

.mdi-manjaro::before {
  content: "\\f160a";
}

.mdi-map::before {
  content: "\\f034d";
}

.mdi-map-check::before {
  content: "\\f0ebc";
}

.mdi-map-check-outline::before {
  content: "\\f0ebd";
}

.mdi-map-clock::before {
  content: "\\f0d1e";
}

.mdi-map-clock-outline::before {
  content: "\\f0d1f";
}

.mdi-map-legend::before {
  content: "\\f0a01";
}

.mdi-map-marker::before {
  content: "\\f034e";
}

.mdi-map-marker-alert::before {
  content: "\\f0f05";
}

.mdi-map-marker-alert-outline::before {
  content: "\\f0f06";
}

.mdi-map-marker-check::before {
  content: "\\f0c95";
}

.mdi-map-marker-check-outline::before {
  content: "\\f12fb";
}

.mdi-map-marker-circle::before {
  content: "\\f034f";
}

.mdi-map-marker-distance::before {
  content: "\\f08f0";
}

.mdi-map-marker-down::before {
  content: "\\f1102";
}

.mdi-map-marker-left::before {
  content: "\\f12db";
}

.mdi-map-marker-left-outline::before {
  content: "\\f12dd";
}

.mdi-map-marker-minus::before {
  content: "\\f0650";
}

.mdi-map-marker-minus-outline::before {
  content: "\\f12f9";
}

.mdi-map-marker-multiple::before {
  content: "\\f0350";
}

.mdi-map-marker-multiple-outline::before {
  content: "\\f1277";
}

.mdi-map-marker-off::before {
  content: "\\f0351";
}

.mdi-map-marker-off-outline::before {
  content: "\\f12fd";
}

.mdi-map-marker-outline::before {
  content: "\\f07d9";
}

.mdi-map-marker-path::before {
  content: "\\f0d20";
}

.mdi-map-marker-plus::before {
  content: "\\f0651";
}

.mdi-map-marker-plus-outline::before {
  content: "\\f12f8";
}

.mdi-map-marker-question::before {
  content: "\\f0f07";
}

.mdi-map-marker-question-outline::before {
  content: "\\f0f08";
}

.mdi-map-marker-radius::before {
  content: "\\f0352";
}

.mdi-map-marker-radius-outline::before {
  content: "\\f12fc";
}

.mdi-map-marker-remove::before {
  content: "\\f0f09";
}

.mdi-map-marker-remove-outline::before {
  content: "\\f12fa";
}

.mdi-map-marker-remove-variant::before {
  content: "\\f0f0a";
}

.mdi-map-marker-right::before {
  content: "\\f12dc";
}

.mdi-map-marker-right-outline::before {
  content: "\\f12de";
}

.mdi-map-marker-star::before {
  content: "\\f1608";
}

.mdi-map-marker-star-outline::before {
  content: "\\f1609";
}

.mdi-map-marker-up::before {
  content: "\\f1103";
}

.mdi-map-minus::before {
  content: "\\f0981";
}

.mdi-map-outline::before {
  content: "\\f0982";
}

.mdi-map-plus::before {
  content: "\\f0983";
}

.mdi-map-search::before {
  content: "\\f0984";
}

.mdi-map-search-outline::before {
  content: "\\f0985";
}

.mdi-mapbox::before {
  content: "\\f0baa";
}

.mdi-margin::before {
  content: "\\f0353";
}

.mdi-marker::before {
  content: "\\f0652";
}

.mdi-marker-cancel::before {
  content: "\\f0dd9";
}

.mdi-marker-check::before {
  content: "\\f0355";
}

.mdi-mastodon::before {
  content: "\\f0ad1";
}

.mdi-material-design::before {
  content: "\\f0986";
}

.mdi-material-ui::before {
  content: "\\f0357";
}

.mdi-math-compass::before {
  content: "\\f0358";
}

.mdi-math-cos::before {
  content: "\\f0c96";
}

.mdi-math-integral::before {
  content: "\\f0fc8";
}

.mdi-math-integral-box::before {
  content: "\\f0fc9";
}

.mdi-math-log::before {
  content: "\\f1085";
}

.mdi-math-norm::before {
  content: "\\f0fca";
}

.mdi-math-norm-box::before {
  content: "\\f0fcb";
}

.mdi-math-sin::before {
  content: "\\f0c97";
}

.mdi-math-tan::before {
  content: "\\f0c98";
}

.mdi-matrix::before {
  content: "\\f0628";
}

.mdi-medal::before {
  content: "\\f0987";
}

.mdi-medal-outline::before {
  content: "\\f1326";
}

.mdi-medical-bag::before {
  content: "\\f06ef";
}

.mdi-meditation::before {
  content: "\\f117b";
}

.mdi-memory::before {
  content: "\\f035b";
}

.mdi-menu::before {
  content: "\\f035c";
}

.mdi-menu-down::before {
  content: "\\f035d";
}

.mdi-menu-down-outline::before {
  content: "\\f06b6";
}

.mdi-menu-left::before {
  content: "\\f035e";
}

.mdi-menu-left-outline::before {
  content: "\\f0a02";
}

.mdi-menu-open::before {
  content: "\\f0bab";
}

.mdi-menu-right::before {
  content: "\\f035f";
}

.mdi-menu-right-outline::before {
  content: "\\f0a03";
}

.mdi-menu-swap::before {
  content: "\\f0a64";
}

.mdi-menu-swap-outline::before {
  content: "\\f0a65";
}

.mdi-menu-up::before {
  content: "\\f0360";
}

.mdi-menu-up-outline::before {
  content: "\\f06b7";
}

.mdi-merge::before {
  content: "\\f0f5c";
}

.mdi-message::before {
  content: "\\f0361";
}

.mdi-message-alert::before {
  content: "\\f0362";
}

.mdi-message-alert-outline::before {
  content: "\\f0a04";
}

.mdi-message-arrow-left::before {
  content: "\\f12f2";
}

.mdi-message-arrow-left-outline::before {
  content: "\\f12f3";
}

.mdi-message-arrow-right::before {
  content: "\\f12f4";
}

.mdi-message-arrow-right-outline::before {
  content: "\\f12f5";
}

.mdi-message-bookmark::before {
  content: "\\f15ac";
}

.mdi-message-bookmark-outline::before {
  content: "\\f15ad";
}

.mdi-message-bulleted::before {
  content: "\\f06a2";
}

.mdi-message-bulleted-off::before {
  content: "\\f06a3";
}

.mdi-message-cog::before {
  content: "\\f06f1";
}

.mdi-message-cog-outline::before {
  content: "\\f1172";
}

.mdi-message-draw::before {
  content: "\\f0363";
}

.mdi-message-flash::before {
  content: "\\f15a9";
}

.mdi-message-flash-outline::before {
  content: "\\f15aa";
}

.mdi-message-image::before {
  content: "\\f0364";
}

.mdi-message-image-outline::before {
  content: "\\f116c";
}

.mdi-message-lock::before {
  content: "\\f0fcc";
}

.mdi-message-lock-outline::before {
  content: "\\f116d";
}

.mdi-message-minus::before {
  content: "\\f116e";
}

.mdi-message-minus-outline::before {
  content: "\\f116f";
}

.mdi-message-off::before {
  content: "\\f164d";
}

.mdi-message-off-outline::before {
  content: "\\f164e";
}

.mdi-message-outline::before {
  content: "\\f0365";
}

.mdi-message-plus::before {
  content: "\\f0653";
}

.mdi-message-plus-outline::before {
  content: "\\f10bb";
}

.mdi-message-processing::before {
  content: "\\f0366";
}

.mdi-message-processing-outline::before {
  content: "\\f1170";
}

.mdi-message-reply::before {
  content: "\\f0367";
}

.mdi-message-reply-text::before {
  content: "\\f0368";
}

.mdi-message-settings::before {
  content: "\\f06f0";
}

.mdi-message-settings-outline::before {
  content: "\\f1171";
}

.mdi-message-text::before {
  content: "\\f0369";
}

.mdi-message-text-clock::before {
  content: "\\f1173";
}

.mdi-message-text-clock-outline::before {
  content: "\\f1174";
}

.mdi-message-text-lock::before {
  content: "\\f0fcd";
}

.mdi-message-text-lock-outline::before {
  content: "\\f1175";
}

.mdi-message-text-outline::before {
  content: "\\f036a";
}

.mdi-message-video::before {
  content: "\\f036b";
}

.mdi-meteor::before {
  content: "\\f0629";
}

.mdi-metronome::before {
  content: "\\f07da";
}

.mdi-metronome-tick::before {
  content: "\\f07db";
}

.mdi-micro-sd::before {
  content: "\\f07dc";
}

.mdi-microphone::before {
  content: "\\f036c";
}

.mdi-microphone-minus::before {
  content: "\\f08b3";
}

.mdi-microphone-off::before {
  content: "\\f036d";
}

.mdi-microphone-outline::before {
  content: "\\f036e";
}

.mdi-microphone-plus::before {
  content: "\\f08b4";
}

.mdi-microphone-settings::before {
  content: "\\f036f";
}

.mdi-microphone-variant::before {
  content: "\\f0370";
}

.mdi-microphone-variant-off::before {
  content: "\\f0371";
}

.mdi-microscope::before {
  content: "\\f0654";
}

.mdi-microsoft::before {
  content: "\\f0372";
}

.mdi-microsoft-access::before {
  content: "\\f138e";
}

.mdi-microsoft-azure::before {
  content: "\\f0805";
}

.mdi-microsoft-azure-devops::before {
  content: "\\f0fd5";
}

.mdi-microsoft-bing::before {
  content: "\\f00a4";
}

.mdi-microsoft-dynamics-365::before {
  content: "\\f0988";
}

.mdi-microsoft-edge::before {
  content: "\\f01e9";
}

.mdi-microsoft-edge-legacy::before {
  content: "\\f1250";
}

.mdi-microsoft-excel::before {
  content: "\\f138f";
}

.mdi-microsoft-internet-explorer::before {
  content: "\\f0300";
}

.mdi-microsoft-office::before {
  content: "\\f03c6";
}

.mdi-microsoft-onedrive::before {
  content: "\\f03ca";
}

.mdi-microsoft-onenote::before {
  content: "\\f0747";
}

.mdi-microsoft-outlook::before {
  content: "\\f0d22";
}

.mdi-microsoft-powerpoint::before {
  content: "\\f1390";
}

.mdi-microsoft-sharepoint::before {
  content: "\\f1391";
}

.mdi-microsoft-teams::before {
  content: "\\f02bb";
}

.mdi-microsoft-visual-studio::before {
  content: "\\f0610";
}

.mdi-microsoft-visual-studio-code::before {
  content: "\\f0a1e";
}

.mdi-microsoft-windows::before {
  content: "\\f05b3";
}

.mdi-microsoft-windows-classic::before {
  content: "\\f0a21";
}

.mdi-microsoft-word::before {
  content: "\\f1392";
}

.mdi-microsoft-xbox::before {
  content: "\\f05b9";
}

.mdi-microsoft-xbox-controller::before {
  content: "\\f05ba";
}

.mdi-microsoft-xbox-controller-battery-alert::before {
  content: "\\f074b";
}

.mdi-microsoft-xbox-controller-battery-charging::before {
  content: "\\f0a22";
}

.mdi-microsoft-xbox-controller-battery-empty::before {
  content: "\\f074c";
}

.mdi-microsoft-xbox-controller-battery-full::before {
  content: "\\f074d";
}

.mdi-microsoft-xbox-controller-battery-low::before {
  content: "\\f074e";
}

.mdi-microsoft-xbox-controller-battery-medium::before {
  content: "\\f074f";
}

.mdi-microsoft-xbox-controller-battery-unknown::before {
  content: "\\f0750";
}

.mdi-microsoft-xbox-controller-menu::before {
  content: "\\f0e6f";
}

.mdi-microsoft-xbox-controller-off::before {
  content: "\\f05bb";
}

.mdi-microsoft-xbox-controller-view::before {
  content: "\\f0e70";
}

.mdi-microsoft-yammer::before {
  content: "\\f0789";
}

.mdi-microwave::before {
  content: "\\f0c99";
}

.mdi-microwave-off::before {
  content: "\\f1423";
}

.mdi-middleware::before {
  content: "\\f0f5d";
}

.mdi-middleware-outline::before {
  content: "\\f0f5e";
}

.mdi-midi::before {
  content: "\\f08f1";
}

.mdi-midi-port::before {
  content: "\\f08f2";
}

.mdi-mine::before {
  content: "\\f0dda";
}

.mdi-minecraft::before {
  content: "\\f0373";
}

.mdi-mini-sd::before {
  content: "\\f0a05";
}

.mdi-minidisc::before {
  content: "\\f0a06";
}

.mdi-minus::before {
  content: "\\f0374";
}

.mdi-minus-box::before {
  content: "\\f0375";
}

.mdi-minus-box-multiple::before {
  content: "\\f1141";
}

.mdi-minus-box-multiple-outline::before {
  content: "\\f1142";
}

.mdi-minus-box-outline::before {
  content: "\\f06f2";
}

.mdi-minus-circle::before {
  content: "\\f0376";
}

.mdi-minus-circle-multiple::before {
  content: "\\f035a";
}

.mdi-minus-circle-multiple-outline::before {
  content: "\\f0ad3";
}

.mdi-minus-circle-off::before {
  content: "\\f1459";
}

.mdi-minus-circle-off-outline::before {
  content: "\\f145a";
}

.mdi-minus-circle-outline::before {
  content: "\\f0377";
}

.mdi-minus-network::before {
  content: "\\f0378";
}

.mdi-minus-network-outline::before {
  content: "\\f0c9a";
}

.mdi-minus-thick::before {
  content: "\\f1639";
}

.mdi-mirror::before {
  content: "\\f11fd";
}

.mdi-mixed-martial-arts::before {
  content: "\\f0d8f";
}

.mdi-mixed-reality::before {
  content: "\\f087f";
}

.mdi-molecule::before {
  content: "\\f0bac";
}

.mdi-molecule-co::before {
  content: "\\f12fe";
}

.mdi-molecule-co2::before {
  content: "\\f07e4";
}

.mdi-monitor::before {
  content: "\\f0379";
}

.mdi-monitor-cellphone::before {
  content: "\\f0989";
}

.mdi-monitor-cellphone-star::before {
  content: "\\f098a";
}

.mdi-monitor-clean::before {
  content: "\\f1104";
}

.mdi-monitor-dashboard::before {
  content: "\\f0a07";
}

.mdi-monitor-edit::before {
  content: "\\f12c6";
}

.mdi-monitor-eye::before {
  content: "\\f13b4";
}

.mdi-monitor-lock::before {
  content: "\\f0ddb";
}

.mdi-monitor-multiple::before {
  content: "\\f037a";
}

.mdi-monitor-off::before {
  content: "\\f0d90";
}

.mdi-monitor-screenshot::before {
  content: "\\f0e51";
}

.mdi-monitor-share::before {
  content: "\\f1483";
}

.mdi-monitor-speaker::before {
  content: "\\f0f5f";
}

.mdi-monitor-speaker-off::before {
  content: "\\f0f60";
}

.mdi-monitor-star::before {
  content: "\\f0ddc";
}

.mdi-moon-first-quarter::before {
  content: "\\f0f61";
}

.mdi-moon-full::before {
  content: "\\f0f62";
}

.mdi-moon-last-quarter::before {
  content: "\\f0f63";
}

.mdi-moon-new::before {
  content: "\\f0f64";
}

.mdi-moon-waning-crescent::before {
  content: "\\f0f65";
}

.mdi-moon-waning-gibbous::before {
  content: "\\f0f66";
}

.mdi-moon-waxing-crescent::before {
  content: "\\f0f67";
}

.mdi-moon-waxing-gibbous::before {
  content: "\\f0f68";
}

.mdi-moped::before {
  content: "\\f1086";
}

.mdi-moped-electric::before {
  content: "\\f15b7";
}

.mdi-moped-electric-outline::before {
  content: "\\f15b8";
}

.mdi-moped-outline::before {
  content: "\\f15b9";
}

.mdi-more::before {
  content: "\\f037b";
}

.mdi-mother-heart::before {
  content: "\\f1314";
}

.mdi-mother-nurse::before {
  content: "\\f0d21";
}

.mdi-motion::before {
  content: "\\f15b2";
}

.mdi-motion-outline::before {
  content: "\\f15b3";
}

.mdi-motion-pause::before {
  content: "\\f1590";
}

.mdi-motion-pause-outline::before {
  content: "\\f1592";
}

.mdi-motion-play::before {
  content: "\\f158f";
}

.mdi-motion-play-outline::before {
  content: "\\f1591";
}

.mdi-motion-sensor::before {
  content: "\\f0d91";
}

.mdi-motion-sensor-off::before {
  content: "\\f1435";
}

.mdi-motorbike::before {
  content: "\\f037c";
}

.mdi-motorbike-electric::before {
  content: "\\f15ba";
}

.mdi-mouse::before {
  content: "\\f037d";
}

.mdi-mouse-bluetooth::before {
  content: "\\f098b";
}

.mdi-mouse-move-down::before {
  content: "\\f1550";
}

.mdi-mouse-move-up::before {
  content: "\\f1551";
}

.mdi-mouse-move-vertical::before {
  content: "\\f1552";
}

.mdi-mouse-off::before {
  content: "\\f037e";
}

.mdi-mouse-variant::before {
  content: "\\f037f";
}

.mdi-mouse-variant-off::before {
  content: "\\f0380";
}

.mdi-move-resize::before {
  content: "\\f0655";
}

.mdi-move-resize-variant::before {
  content: "\\f0656";
}

.mdi-movie::before {
  content: "\\f0381";
}

.mdi-movie-edit::before {
  content: "\\f1122";
}

.mdi-movie-edit-outline::before {
  content: "\\f1123";
}

.mdi-movie-filter::before {
  content: "\\f1124";
}

.mdi-movie-filter-outline::before {
  content: "\\f1125";
}

.mdi-movie-open::before {
  content: "\\f0fce";
}

.mdi-movie-open-outline::before {
  content: "\\f0fcf";
}

.mdi-movie-outline::before {
  content: "\\f0ddd";
}

.mdi-movie-roll::before {
  content: "\\f07de";
}

.mdi-movie-search::before {
  content: "\\f11d2";
}

.mdi-movie-search-outline::before {
  content: "\\f11d3";
}

.mdi-mower::before {
  content: "\\f166f";
}

.mdi-mower-bag::before {
  content: "\\f1670";
}

.mdi-muffin::before {
  content: "\\f098c";
}

.mdi-multiplication::before {
  content: "\\f0382";
}

.mdi-multiplication-box::before {
  content: "\\f0383";
}

.mdi-mushroom::before {
  content: "\\f07df";
}

.mdi-mushroom-off::before {
  content: "\\f13fa";
}

.mdi-mushroom-off-outline::before {
  content: "\\f13fb";
}

.mdi-mushroom-outline::before {
  content: "\\f07e0";
}

.mdi-music::before {
  content: "\\f075a";
}

.mdi-music-accidental-double-flat::before {
  content: "\\f0f69";
}

.mdi-music-accidental-double-sharp::before {
  content: "\\f0f6a";
}

.mdi-music-accidental-flat::before {
  content: "\\f0f6b";
}

.mdi-music-accidental-natural::before {
  content: "\\f0f6c";
}

.mdi-music-accidental-sharp::before {
  content: "\\f0f6d";
}

.mdi-music-box::before {
  content: "\\f0384";
}

.mdi-music-box-multiple::before {
  content: "\\f0333";
}

.mdi-music-box-multiple-outline::before {
  content: "\\f0f04";
}

.mdi-music-box-outline::before {
  content: "\\f0385";
}

.mdi-music-circle::before {
  content: "\\f0386";
}

.mdi-music-circle-outline::before {
  content: "\\f0ad4";
}

.mdi-music-clef-alto::before {
  content: "\\f0f6e";
}

.mdi-music-clef-bass::before {
  content: "\\f0f6f";
}

.mdi-music-clef-treble::before {
  content: "\\f0f70";
}

.mdi-music-note::before {
  content: "\\f0387";
}

.mdi-music-note-bluetooth::before {
  content: "\\f05fe";
}

.mdi-music-note-bluetooth-off::before {
  content: "\\f05ff";
}

.mdi-music-note-eighth::before {
  content: "\\f0388";
}

.mdi-music-note-eighth-dotted::before {
  content: "\\f0f71";
}

.mdi-music-note-half::before {
  content: "\\f0389";
}

.mdi-music-note-half-dotted::before {
  content: "\\f0f72";
}

.mdi-music-note-off::before {
  content: "\\f038a";
}

.mdi-music-note-off-outline::before {
  content: "\\f0f73";
}

.mdi-music-note-outline::before {
  content: "\\f0f74";
}

.mdi-music-note-plus::before {
  content: "\\f0dde";
}

.mdi-music-note-quarter::before {
  content: "\\f038b";
}

.mdi-music-note-quarter-dotted::before {
  content: "\\f0f75";
}

.mdi-music-note-sixteenth::before {
  content: "\\f038c";
}

.mdi-music-note-sixteenth-dotted::before {
  content: "\\f0f76";
}

.mdi-music-note-whole::before {
  content: "\\f038d";
}

.mdi-music-note-whole-dotted::before {
  content: "\\f0f77";
}

.mdi-music-off::before {
  content: "\\f075b";
}

.mdi-music-rest-eighth::before {
  content: "\\f0f78";
}

.mdi-music-rest-half::before {
  content: "\\f0f79";
}

.mdi-music-rest-quarter::before {
  content: "\\f0f7a";
}

.mdi-music-rest-sixteenth::before {
  content: "\\f0f7b";
}

.mdi-music-rest-whole::before {
  content: "\\f0f7c";
}

.mdi-mustache::before {
  content: "\\f15de";
}

.mdi-nail::before {
  content: "\\f0ddf";
}

.mdi-nas::before {
  content: "\\f08f3";
}

.mdi-nativescript::before {
  content: "\\f0880";
}

.mdi-nature::before {
  content: "\\f038e";
}

.mdi-nature-people::before {
  content: "\\f038f";
}

.mdi-navigation::before {
  content: "\\f0390";
}

.mdi-navigation-outline::before {
  content: "\\f1607";
}

.mdi-near-me::before {
  content: "\\f05cd";
}

.mdi-necklace::before {
  content: "\\f0f0b";
}

.mdi-needle::before {
  content: "\\f0391";
}

.mdi-netflix::before {
  content: "\\f0746";
}

.mdi-network::before {
  content: "\\f06f3";
}

.mdi-network-off::before {
  content: "\\f0c9b";
}

.mdi-network-off-outline::before {
  content: "\\f0c9c";
}

.mdi-network-outline::before {
  content: "\\f0c9d";
}

.mdi-network-strength-1::before {
  content: "\\f08f4";
}

.mdi-network-strength-1-alert::before {
  content: "\\f08f5";
}

.mdi-network-strength-2::before {
  content: "\\f08f6";
}

.mdi-network-strength-2-alert::before {
  content: "\\f08f7";
}

.mdi-network-strength-3::before {
  content: "\\f08f8";
}

.mdi-network-strength-3-alert::before {
  content: "\\f08f9";
}

.mdi-network-strength-4::before {
  content: "\\f08fa";
}

.mdi-network-strength-4-alert::before {
  content: "\\f08fb";
}

.mdi-network-strength-off::before {
  content: "\\f08fc";
}

.mdi-network-strength-off-outline::before {
  content: "\\f08fd";
}

.mdi-network-strength-outline::before {
  content: "\\f08fe";
}

.mdi-new-box::before {
  content: "\\f0394";
}

.mdi-newspaper::before {
  content: "\\f0395";
}

.mdi-newspaper-minus::before {
  content: "\\f0f0c";
}

.mdi-newspaper-plus::before {
  content: "\\f0f0d";
}

.mdi-newspaper-variant::before {
  content: "\\f1001";
}

.mdi-newspaper-variant-multiple::before {
  content: "\\f1002";
}

.mdi-newspaper-variant-multiple-outline::before {
  content: "\\f1003";
}

.mdi-newspaper-variant-outline::before {
  content: "\\f1004";
}

.mdi-nfc::before {
  content: "\\f0396";
}

.mdi-nfc-search-variant::before {
  content: "\\f0e53";
}

.mdi-nfc-tap::before {
  content: "\\f0397";
}

.mdi-nfc-variant::before {
  content: "\\f0398";
}

.mdi-nfc-variant-off::before {
  content: "\\f0e54";
}

.mdi-ninja::before {
  content: "\\f0774";
}

.mdi-nintendo-game-boy::before {
  content: "\\f1393";
}

.mdi-nintendo-switch::before {
  content: "\\f07e1";
}

.mdi-nintendo-wii::before {
  content: "\\f05ab";
}

.mdi-nintendo-wiiu::before {
  content: "\\f072d";
}

.mdi-nix::before {
  content: "\\f1105";
}

.mdi-nodejs::before {
  content: "\\f0399";
}

.mdi-noodles::before {
  content: "\\f117e";
}

.mdi-not-equal::before {
  content: "\\f098d";
}

.mdi-not-equal-variant::before {
  content: "\\f098e";
}

.mdi-note::before {
  content: "\\f039a";
}

.mdi-note-minus::before {
  content: "\\f164f";
}

.mdi-note-minus-outline::before {
  content: "\\f1650";
}

.mdi-note-multiple::before {
  content: "\\f06b8";
}

.mdi-note-multiple-outline::before {
  content: "\\f06b9";
}

.mdi-note-outline::before {
  content: "\\f039b";
}

.mdi-note-plus::before {
  content: "\\f039c";
}

.mdi-note-plus-outline::before {
  content: "\\f039d";
}

.mdi-note-remove::before {
  content: "\\f1651";
}

.mdi-note-remove-outline::before {
  content: "\\f1652";
}

.mdi-note-search::before {
  content: "\\f1653";
}

.mdi-note-search-outline::before {
  content: "\\f1654";
}

.mdi-note-text::before {
  content: "\\f039e";
}

.mdi-note-text-outline::before {
  content: "\\f11d7";
}

.mdi-notebook::before {
  content: "\\f082e";
}

.mdi-notebook-check::before {
  content: "\\f14f5";
}

.mdi-notebook-check-outline::before {
  content: "\\f14f6";
}

.mdi-notebook-edit::before {
  content: "\\f14e7";
}

.mdi-notebook-edit-outline::before {
  content: "\\f14e9";
}

.mdi-notebook-minus::before {
  content: "\\f1610";
}

.mdi-notebook-minus-outline::before {
  content: "\\f1611";
}

.mdi-notebook-multiple::before {
  content: "\\f0e55";
}

.mdi-notebook-outline::before {
  content: "\\f0ebf";
}

.mdi-notebook-plus::before {
  content: "\\f1612";
}

.mdi-notebook-plus-outline::before {
  content: "\\f1613";
}

.mdi-notebook-remove::before {
  content: "\\f1614";
}

.mdi-notebook-remove-outline::before {
  content: "\\f1615";
}

.mdi-notification-clear-all::before {
  content: "\\f039f";
}

.mdi-npm::before {
  content: "\\f06f7";
}

.mdi-nuke::before {
  content: "\\f06a4";
}

.mdi-null::before {
  content: "\\f07e2";
}

.mdi-numeric::before {
  content: "\\f03a0";
}

.mdi-numeric-0::before {
  content: "\\f0b39";
}

.mdi-numeric-0-box::before {
  content: "\\f03a1";
}

.mdi-numeric-0-box-multiple::before {
  content: "\\f0f0e";
}

.mdi-numeric-0-box-multiple-outline::before {
  content: "\\f03a2";
}

.mdi-numeric-0-box-outline::before {
  content: "\\f03a3";
}

.mdi-numeric-0-circle::before {
  content: "\\f0c9e";
}

.mdi-numeric-0-circle-outline::before {
  content: "\\f0c9f";
}

.mdi-numeric-1::before {
  content: "\\f0b3a";
}

.mdi-numeric-1-box::before {
  content: "\\f03a4";
}

.mdi-numeric-1-box-multiple::before {
  content: "\\f0f0f";
}

.mdi-numeric-1-box-multiple-outline::before {
  content: "\\f03a5";
}

.mdi-numeric-1-box-outline::before {
  content: "\\f03a6";
}

.mdi-numeric-1-circle::before {
  content: "\\f0ca0";
}

.mdi-numeric-1-circle-outline::before {
  content: "\\f0ca1";
}

.mdi-numeric-10::before {
  content: "\\f0fe9";
}

.mdi-numeric-10-box::before {
  content: "\\f0f7d";
}

.mdi-numeric-10-box-multiple::before {
  content: "\\f0fea";
}

.mdi-numeric-10-box-multiple-outline::before {
  content: "\\f0feb";
}

.mdi-numeric-10-box-outline::before {
  content: "\\f0f7e";
}

.mdi-numeric-10-circle::before {
  content: "\\f0fec";
}

.mdi-numeric-10-circle-outline::before {
  content: "\\f0fed";
}

.mdi-numeric-2::before {
  content: "\\f0b3b";
}

.mdi-numeric-2-box::before {
  content: "\\f03a7";
}

.mdi-numeric-2-box-multiple::before {
  content: "\\f0f10";
}

.mdi-numeric-2-box-multiple-outline::before {
  content: "\\f03a8";
}

.mdi-numeric-2-box-outline::before {
  content: "\\f03a9";
}

.mdi-numeric-2-circle::before {
  content: "\\f0ca2";
}

.mdi-numeric-2-circle-outline::before {
  content: "\\f0ca3";
}

.mdi-numeric-3::before {
  content: "\\f0b3c";
}

.mdi-numeric-3-box::before {
  content: "\\f03aa";
}

.mdi-numeric-3-box-multiple::before {
  content: "\\f0f11";
}

.mdi-numeric-3-box-multiple-outline::before {
  content: "\\f03ab";
}

.mdi-numeric-3-box-outline::before {
  content: "\\f03ac";
}

.mdi-numeric-3-circle::before {
  content: "\\f0ca4";
}

.mdi-numeric-3-circle-outline::before {
  content: "\\f0ca5";
}

.mdi-numeric-4::before {
  content: "\\f0b3d";
}

.mdi-numeric-4-box::before {
  content: "\\f03ad";
}

.mdi-numeric-4-box-multiple::before {
  content: "\\f0f12";
}

.mdi-numeric-4-box-multiple-outline::before {
  content: "\\f03b2";
}

.mdi-numeric-4-box-outline::before {
  content: "\\f03ae";
}

.mdi-numeric-4-circle::before {
  content: "\\f0ca6";
}

.mdi-numeric-4-circle-outline::before {
  content: "\\f0ca7";
}

.mdi-numeric-5::before {
  content: "\\f0b3e";
}

.mdi-numeric-5-box::before {
  content: "\\f03b1";
}

.mdi-numeric-5-box-multiple::before {
  content: "\\f0f13";
}

.mdi-numeric-5-box-multiple-outline::before {
  content: "\\f03af";
}

.mdi-numeric-5-box-outline::before {
  content: "\\f03b0";
}

.mdi-numeric-5-circle::before {
  content: "\\f0ca8";
}

.mdi-numeric-5-circle-outline::before {
  content: "\\f0ca9";
}

.mdi-numeric-6::before {
  content: "\\f0b3f";
}

.mdi-numeric-6-box::before {
  content: "\\f03b3";
}

.mdi-numeric-6-box-multiple::before {
  content: "\\f0f14";
}

.mdi-numeric-6-box-multiple-outline::before {
  content: "\\f03b4";
}

.mdi-numeric-6-box-outline::before {
  content: "\\f03b5";
}

.mdi-numeric-6-circle::before {
  content: "\\f0caa";
}

.mdi-numeric-6-circle-outline::before {
  content: "\\f0cab";
}

.mdi-numeric-7::before {
  content: "\\f0b40";
}

.mdi-numeric-7-box::before {
  content: "\\f03b6";
}

.mdi-numeric-7-box-multiple::before {
  content: "\\f0f15";
}

.mdi-numeric-7-box-multiple-outline::before {
  content: "\\f03b7";
}

.mdi-numeric-7-box-outline::before {
  content: "\\f03b8";
}

.mdi-numeric-7-circle::before {
  content: "\\f0cac";
}

.mdi-numeric-7-circle-outline::before {
  content: "\\f0cad";
}

.mdi-numeric-8::before {
  content: "\\f0b41";
}

.mdi-numeric-8-box::before {
  content: "\\f03b9";
}

.mdi-numeric-8-box-multiple::before {
  content: "\\f0f16";
}

.mdi-numeric-8-box-multiple-outline::before {
  content: "\\f03ba";
}

.mdi-numeric-8-box-outline::before {
  content: "\\f03bb";
}

.mdi-numeric-8-circle::before {
  content: "\\f0cae";
}

.mdi-numeric-8-circle-outline::before {
  content: "\\f0caf";
}

.mdi-numeric-9::before {
  content: "\\f0b42";
}

.mdi-numeric-9-box::before {
  content: "\\f03bc";
}

.mdi-numeric-9-box-multiple::before {
  content: "\\f0f17";
}

.mdi-numeric-9-box-multiple-outline::before {
  content: "\\f03bd";
}

.mdi-numeric-9-box-outline::before {
  content: "\\f03be";
}

.mdi-numeric-9-circle::before {
  content: "\\f0cb0";
}

.mdi-numeric-9-circle-outline::before {
  content: "\\f0cb1";
}

.mdi-numeric-9-plus::before {
  content: "\\f0fee";
}

.mdi-numeric-9-plus-box::before {
  content: "\\f03bf";
}

.mdi-numeric-9-plus-box-multiple::before {
  content: "\\f0f18";
}

.mdi-numeric-9-plus-box-multiple-outline::before {
  content: "\\f03c0";
}

.mdi-numeric-9-plus-box-outline::before {
  content: "\\f03c1";
}

.mdi-numeric-9-plus-circle::before {
  content: "\\f0cb2";
}

.mdi-numeric-9-plus-circle-outline::before {
  content: "\\f0cb3";
}

.mdi-numeric-negative-1::before {
  content: "\\f1052";
}

.mdi-numeric-positive-1::before {
  content: "\\f15cb";
}

.mdi-nut::before {
  content: "\\f06f8";
}

.mdi-nutrition::before {
  content: "\\f03c2";
}

.mdi-nuxt::before {
  content: "\\f1106";
}

.mdi-oar::before {
  content: "\\f067c";
}

.mdi-ocarina::before {
  content: "\\f0de0";
}

.mdi-oci::before {
  content: "\\f12e9";
}

.mdi-ocr::before {
  content: "\\f113a";
}

.mdi-octagon::before {
  content: "\\f03c3";
}

.mdi-octagon-outline::before {
  content: "\\f03c4";
}

.mdi-octagram::before {
  content: "\\f06f9";
}

.mdi-octagram-outline::before {
  content: "\\f0775";
}

.mdi-odnoklassniki::before {
  content: "\\f03c5";
}

.mdi-offer::before {
  content: "\\f121b";
}

.mdi-office-building::before {
  content: "\\f0991";
}

.mdi-office-building-marker::before {
  content: "\\f1520";
}

.mdi-office-building-marker-outline::before {
  content: "\\f1521";
}

.mdi-office-building-outline::before {
  content: "\\f151f";
}

.mdi-oil::before {
  content: "\\f03c7";
}

.mdi-oil-lamp::before {
  content: "\\f0f19";
}

.mdi-oil-level::before {
  content: "\\f1053";
}

.mdi-oil-temperature::before {
  content: "\\f0ff8";
}

.mdi-omega::before {
  content: "\\f03c9";
}

.mdi-one-up::before {
  content: "\\f0bad";
}

.mdi-onepassword::before {
  content: "\\f0881";
}

.mdi-opacity::before {
  content: "\\f05cc";
}

.mdi-open-in-app::before {
  content: "\\f03cb";
}

.mdi-open-in-new::before {
  content: "\\f03cc";
}

.mdi-open-source-initiative::before {
  content: "\\f0bae";
}

.mdi-openid::before {
  content: "\\f03cd";
}

.mdi-opera::before {
  content: "\\f03ce";
}

.mdi-orbit::before {
  content: "\\f0018";
}

.mdi-orbit-variant::before {
  content: "\\f15db";
}

.mdi-order-alphabetical-ascending::before {
  content: "\\f020d";
}

.mdi-order-alphabetical-descending::before {
  content: "\\f0d07";
}

.mdi-order-bool-ascending::before {
  content: "\\f02be";
}

.mdi-order-bool-ascending-variant::before {
  content: "\\f098f";
}

.mdi-order-bool-descending::before {
  content: "\\f1384";
}

.mdi-order-bool-descending-variant::before {
  content: "\\f0990";
}

.mdi-order-numeric-ascending::before {
  content: "\\f0545";
}

.mdi-order-numeric-descending::before {
  content: "\\f0546";
}

.mdi-origin::before {
  content: "\\f0b43";
}

.mdi-ornament::before {
  content: "\\f03cf";
}

.mdi-ornament-variant::before {
  content: "\\f03d0";
}

.mdi-outdoor-lamp::before {
  content: "\\f1054";
}

.mdi-overscan::before {
  content: "\\f1005";
}

.mdi-owl::before {
  content: "\\f03d2";
}

.mdi-pac-man::before {
  content: "\\f0baf";
}

.mdi-package::before {
  content: "\\f03d3";
}

.mdi-package-down::before {
  content: "\\f03d4";
}

.mdi-package-up::before {
  content: "\\f03d5";
}

.mdi-package-variant::before {
  content: "\\f03d6";
}

.mdi-package-variant-closed::before {
  content: "\\f03d7";
}

.mdi-page-first::before {
  content: "\\f0600";
}

.mdi-page-last::before {
  content: "\\f0601";
}

.mdi-page-layout-body::before {
  content: "\\f06fa";
}

.mdi-page-layout-footer::before {
  content: "\\f06fb";
}

.mdi-page-layout-header::before {
  content: "\\f06fc";
}

.mdi-page-layout-header-footer::before {
  content: "\\f0f7f";
}

.mdi-page-layout-sidebar-left::before {
  content: "\\f06fd";
}

.mdi-page-layout-sidebar-right::before {
  content: "\\f06fe";
}

.mdi-page-next::before {
  content: "\\f0bb0";
}

.mdi-page-next-outline::before {
  content: "\\f0bb1";
}

.mdi-page-previous::before {
  content: "\\f0bb2";
}

.mdi-page-previous-outline::before {
  content: "\\f0bb3";
}

.mdi-pail::before {
  content: "\\f1417";
}

.mdi-pail-minus::before {
  content: "\\f1437";
}

.mdi-pail-minus-outline::before {
  content: "\\f143c";
}

.mdi-pail-off::before {
  content: "\\f1439";
}

.mdi-pail-off-outline::before {
  content: "\\f143e";
}

.mdi-pail-outline::before {
  content: "\\f143a";
}

.mdi-pail-plus::before {
  content: "\\f1436";
}

.mdi-pail-plus-outline::before {
  content: "\\f143b";
}

.mdi-pail-remove::before {
  content: "\\f1438";
}

.mdi-pail-remove-outline::before {
  content: "\\f143d";
}

.mdi-palette::before {
  content: "\\f03d8";
}

.mdi-palette-advanced::before {
  content: "\\f03d9";
}

.mdi-palette-outline::before {
  content: "\\f0e0c";
}

.mdi-palette-swatch::before {
  content: "\\f08b5";
}

.mdi-palette-swatch-outline::before {
  content: "\\f135c";
}

.mdi-palm-tree::before {
  content: "\\f1055";
}

.mdi-pan::before {
  content: "\\f0bb4";
}

.mdi-pan-bottom-left::before {
  content: "\\f0bb5";
}

.mdi-pan-bottom-right::before {
  content: "\\f0bb6";
}

.mdi-pan-down::before {
  content: "\\f0bb7";
}

.mdi-pan-horizontal::before {
  content: "\\f0bb8";
}

.mdi-pan-left::before {
  content: "\\f0bb9";
}

.mdi-pan-right::before {
  content: "\\f0bba";
}

.mdi-pan-top-left::before {
  content: "\\f0bbb";
}

.mdi-pan-top-right::before {
  content: "\\f0bbc";
}

.mdi-pan-up::before {
  content: "\\f0bbd";
}

.mdi-pan-vertical::before {
  content: "\\f0bbe";
}

.mdi-panda::before {
  content: "\\f03da";
}

.mdi-pandora::before {
  content: "\\f03db";
}

.mdi-panorama::before {
  content: "\\f03dc";
}

.mdi-panorama-fisheye::before {
  content: "\\f03dd";
}

.mdi-panorama-horizontal::before {
  content: "\\f03de";
}

.mdi-panorama-vertical::before {
  content: "\\f03df";
}

.mdi-panorama-wide-angle::before {
  content: "\\f03e0";
}

.mdi-paper-cut-vertical::before {
  content: "\\f03e1";
}

.mdi-paper-roll::before {
  content: "\\f1157";
}

.mdi-paper-roll-outline::before {
  content: "\\f1158";
}

.mdi-paperclip::before {
  content: "\\f03e2";
}

.mdi-parachute::before {
  content: "\\f0cb4";
}

.mdi-parachute-outline::before {
  content: "\\f0cb5";
}

.mdi-parking::before {
  content: "\\f03e3";
}

.mdi-party-popper::before {
  content: "\\f1056";
}

.mdi-passport::before {
  content: "\\f07e3";
}

.mdi-passport-biometric::before {
  content: "\\f0de1";
}

.mdi-pasta::before {
  content: "\\f1160";
}

.mdi-patio-heater::before {
  content: "\\f0f80";
}

.mdi-patreon::before {
  content: "\\f0882";
}

.mdi-pause::before {
  content: "\\f03e4";
}

.mdi-pause-circle::before {
  content: "\\f03e5";
}

.mdi-pause-circle-outline::before {
  content: "\\f03e6";
}

.mdi-pause-octagon::before {
  content: "\\f03e7";
}

.mdi-pause-octagon-outline::before {
  content: "\\f03e8";
}

.mdi-paw::before {
  content: "\\f03e9";
}

.mdi-paw-off::before {
  content: "\\f0657";
}

.mdi-paw-off-outline::before {
  content: "\\f1676";
}

.mdi-paw-outline::before {
  content: "\\f1675";
}

.mdi-pdf-box::before {
  content: "\\f0e56";
}

.mdi-peace::before {
  content: "\\f0884";
}

.mdi-peanut::before {
  content: "\\f0ffc";
}

.mdi-peanut-off::before {
  content: "\\f0ffd";
}

.mdi-peanut-off-outline::before {
  content: "\\f0fff";
}

.mdi-peanut-outline::before {
  content: "\\f0ffe";
}

.mdi-pen::before {
  content: "\\f03ea";
}

.mdi-pen-lock::before {
  content: "\\f0de2";
}

.mdi-pen-minus::before {
  content: "\\f0de3";
}

.mdi-pen-off::before {
  content: "\\f0de4";
}

.mdi-pen-plus::before {
  content: "\\f0de5";
}

.mdi-pen-remove::before {
  content: "\\f0de6";
}

.mdi-pencil::before {
  content: "\\f03eb";
}

.mdi-pencil-box::before {
  content: "\\f03ec";
}

.mdi-pencil-box-multiple::before {
  content: "\\f1144";
}

.mdi-pencil-box-multiple-outline::before {
  content: "\\f1145";
}

.mdi-pencil-box-outline::before {
  content: "\\f03ed";
}

.mdi-pencil-circle::before {
  content: "\\f06ff";
}

.mdi-pencil-circle-outline::before {
  content: "\\f0776";
}

.mdi-pencil-lock::before {
  content: "\\f03ee";
}

.mdi-pencil-lock-outline::before {
  content: "\\f0de7";
}

.mdi-pencil-minus::before {
  content: "\\f0de8";
}

.mdi-pencil-minus-outline::before {
  content: "\\f0de9";
}

.mdi-pencil-off::before {
  content: "\\f03ef";
}

.mdi-pencil-off-outline::before {
  content: "\\f0dea";
}

.mdi-pencil-outline::before {
  content: "\\f0cb6";
}

.mdi-pencil-plus::before {
  content: "\\f0deb";
}

.mdi-pencil-plus-outline::before {
  content: "\\f0dec";
}

.mdi-pencil-remove::before {
  content: "\\f0ded";
}

.mdi-pencil-remove-outline::before {
  content: "\\f0dee";
}

.mdi-pencil-ruler::before {
  content: "\\f1353";
}

.mdi-penguin::before {
  content: "\\f0ec0";
}

.mdi-pentagon::before {
  content: "\\f0701";
}

.mdi-pentagon-outline::before {
  content: "\\f0700";
}

.mdi-pentagram::before {
  content: "\\f1667";
}

.mdi-percent::before {
  content: "\\f03f0";
}

.mdi-percent-outline::before {
  content: "\\f1278";
}

.mdi-periodic-table::before {
  content: "\\f08b6";
}

.mdi-perspective-less::before {
  content: "\\f0d23";
}

.mdi-perspective-more::before {
  content: "\\f0d24";
}

.mdi-pharmacy::before {
  content: "\\f03f1";
}

.mdi-phone::before {
  content: "\\f03f2";
}

.mdi-phone-alert::before {
  content: "\\f0f1a";
}

.mdi-phone-alert-outline::before {
  content: "\\f118e";
}

.mdi-phone-bluetooth::before {
  content: "\\f03f3";
}

.mdi-phone-bluetooth-outline::before {
  content: "\\f118f";
}

.mdi-phone-cancel::before {
  content: "\\f10bc";
}

.mdi-phone-cancel-outline::before {
  content: "\\f1190";
}

.mdi-phone-check::before {
  content: "\\f11a9";
}

.mdi-phone-check-outline::before {
  content: "\\f11aa";
}

.mdi-phone-classic::before {
  content: "\\f0602";
}

.mdi-phone-classic-off::before {
  content: "\\f1279";
}

.mdi-phone-dial::before {
  content: "\\f1559";
}

.mdi-phone-dial-outline::before {
  content: "\\f155a";
}

.mdi-phone-forward::before {
  content: "\\f03f4";
}

.mdi-phone-forward-outline::before {
  content: "\\f1191";
}

.mdi-phone-hangup::before {
  content: "\\f03f5";
}

.mdi-phone-hangup-outline::before {
  content: "\\f1192";
}

.mdi-phone-in-talk::before {
  content: "\\f03f6";
}

.mdi-phone-in-talk-outline::before {
  content: "\\f1182";
}

.mdi-phone-incoming::before {
  content: "\\f03f7";
}

.mdi-phone-incoming-outline::before {
  content: "\\f1193";
}

.mdi-phone-lock::before {
  content: "\\f03f8";
}

.mdi-phone-lock-outline::before {
  content: "\\f1194";
}

.mdi-phone-log::before {
  content: "\\f03f9";
}

.mdi-phone-log-outline::before {
  content: "\\f1195";
}

.mdi-phone-message::before {
  content: "\\f1196";
}

.mdi-phone-message-outline::before {
  content: "\\f1197";
}

.mdi-phone-minus::before {
  content: "\\f0658";
}

.mdi-phone-minus-outline::before {
  content: "\\f1198";
}

.mdi-phone-missed::before {
  content: "\\f03fa";
}

.mdi-phone-missed-outline::before {
  content: "\\f11a5";
}

.mdi-phone-off::before {
  content: "\\f0def";
}

.mdi-phone-off-outline::before {
  content: "\\f11a6";
}

.mdi-phone-outgoing::before {
  content: "\\f03fb";
}

.mdi-phone-outgoing-outline::before {
  content: "\\f1199";
}

.mdi-phone-outline::before {
  content: "\\f0df0";
}

.mdi-phone-paused::before {
  content: "\\f03fc";
}

.mdi-phone-paused-outline::before {
  content: "\\f119a";
}

.mdi-phone-plus::before {
  content: "\\f0659";
}

.mdi-phone-plus-outline::before {
  content: "\\f119b";
}

.mdi-phone-remove::before {
  content: "\\f152f";
}

.mdi-phone-remove-outline::before {
  content: "\\f1530";
}

.mdi-phone-return::before {
  content: "\\f082f";
}

.mdi-phone-return-outline::before {
  content: "\\f119c";
}

.mdi-phone-ring::before {
  content: "\\f11ab";
}

.mdi-phone-ring-outline::before {
  content: "\\f11ac";
}

.mdi-phone-rotate-landscape::before {
  content: "\\f0885";
}

.mdi-phone-rotate-portrait::before {
  content: "\\f0886";
}

.mdi-phone-settings::before {
  content: "\\f03fd";
}

.mdi-phone-settings-outline::before {
  content: "\\f119d";
}

.mdi-phone-voip::before {
  content: "\\f03fe";
}

.mdi-pi::before {
  content: "\\f03ff";
}

.mdi-pi-box::before {
  content: "\\f0400";
}

.mdi-pi-hole::before {
  content: "\\f0df1";
}

.mdi-piano::before {
  content: "\\f067d";
}

.mdi-pickaxe::before {
  content: "\\f08b7";
}

.mdi-picture-in-picture-bottom-right::before {
  content: "\\f0e57";
}

.mdi-picture-in-picture-bottom-right-outline::before {
  content: "\\f0e58";
}

.mdi-picture-in-picture-top-right::before {
  content: "\\f0e59";
}

.mdi-picture-in-picture-top-right-outline::before {
  content: "\\f0e5a";
}

.mdi-pier::before {
  content: "\\f0887";
}

.mdi-pier-crane::before {
  content: "\\f0888";
}

.mdi-pig::before {
  content: "\\f0401";
}

.mdi-pig-variant::before {
  content: "\\f1006";
}

.mdi-pig-variant-outline::before {
  content: "\\f1678";
}

.mdi-piggy-bank::before {
  content: "\\f1007";
}

.mdi-piggy-bank-outline::before {
  content: "\\f1679";
}

.mdi-pill::before {
  content: "\\f0402";
}

.mdi-pillar::before {
  content: "\\f0702";
}

.mdi-pin::before {
  content: "\\f0403";
}

.mdi-pin-off::before {
  content: "\\f0404";
}

.mdi-pin-off-outline::before {
  content: "\\f0930";
}

.mdi-pin-outline::before {
  content: "\\f0931";
}

.mdi-pine-tree::before {
  content: "\\f0405";
}

.mdi-pine-tree-box::before {
  content: "\\f0406";
}

.mdi-pine-tree-fire::before {
  content: "\\f141a";
}

.mdi-pinterest::before {
  content: "\\f0407";
}

.mdi-pinwheel::before {
  content: "\\f0ad5";
}

.mdi-pinwheel-outline::before {
  content: "\\f0ad6";
}

.mdi-pipe::before {
  content: "\\f07e5";
}

.mdi-pipe-disconnected::before {
  content: "\\f07e6";
}

.mdi-pipe-leak::before {
  content: "\\f0889";
}

.mdi-pipe-wrench::before {
  content: "\\f1354";
}

.mdi-pirate::before {
  content: "\\f0a08";
}

.mdi-pistol::before {
  content: "\\f0703";
}

.mdi-piston::before {
  content: "\\f088a";
}

.mdi-pitchfork::before {
  content: "\\f1553";
}

.mdi-pizza::before {
  content: "\\f0409";
}

.mdi-play::before {
  content: "\\f040a";
}

.mdi-play-box::before {
  content: "\\f127a";
}

.mdi-play-box-multiple::before {
  content: "\\f0d19";
}

.mdi-play-box-multiple-outline::before {
  content: "\\f13e6";
}

.mdi-play-box-outline::before {
  content: "\\f040b";
}

.mdi-play-circle::before {
  content: "\\f040c";
}

.mdi-play-circle-outline::before {
  content: "\\f040d";
}

.mdi-play-network::before {
  content: "\\f088b";
}

.mdi-play-network-outline::before {
  content: "\\f0cb7";
}

.mdi-play-outline::before {
  content: "\\f0f1b";
}

.mdi-play-pause::before {
  content: "\\f040e";
}

.mdi-play-protected-content::before {
  content: "\\f040f";
}

.mdi-play-speed::before {
  content: "\\f08ff";
}

.mdi-playlist-check::before {
  content: "\\f05c7";
}

.mdi-playlist-edit::before {
  content: "\\f0900";
}

.mdi-playlist-minus::before {
  content: "\\f0410";
}

.mdi-playlist-music::before {
  content: "\\f0cb8";
}

.mdi-playlist-music-outline::before {
  content: "\\f0cb9";
}

.mdi-playlist-play::before {
  content: "\\f0411";
}

.mdi-playlist-plus::before {
  content: "\\f0412";
}

.mdi-playlist-remove::before {
  content: "\\f0413";
}

.mdi-playlist-star::before {
  content: "\\f0df2";
}

.mdi-plex::before {
  content: "\\f06ba";
}

.mdi-plus::before {
  content: "\\f0415";
}

.mdi-plus-box::before {
  content: "\\f0416";
}

.mdi-plus-box-multiple::before {
  content: "\\f0334";
}

.mdi-plus-box-multiple-outline::before {
  content: "\\f1143";
}

.mdi-plus-box-outline::before {
  content: "\\f0704";
}

.mdi-plus-circle::before {
  content: "\\f0417";
}

.mdi-plus-circle-multiple::before {
  content: "\\f034c";
}

.mdi-plus-circle-multiple-outline::before {
  content: "\\f0418";
}

.mdi-plus-circle-outline::before {
  content: "\\f0419";
}

.mdi-plus-minus::before {
  content: "\\f0992";
}

.mdi-plus-minus-box::before {
  content: "\\f0993";
}

.mdi-plus-minus-variant::before {
  content: "\\f14c9";
}

.mdi-plus-network::before {
  content: "\\f041a";
}

.mdi-plus-network-outline::before {
  content: "\\f0cba";
}

.mdi-plus-one::before {
  content: "\\f041b";
}

.mdi-plus-outline::before {
  content: "\\f0705";
}

.mdi-plus-thick::before {
  content: "\\f11ec";
}

.mdi-podcast::before {
  content: "\\f0994";
}

.mdi-podium::before {
  content: "\\f0d25";
}

.mdi-podium-bronze::before {
  content: "\\f0d26";
}

.mdi-podium-gold::before {
  content: "\\f0d27";
}

.mdi-podium-silver::before {
  content: "\\f0d28";
}

.mdi-point-of-sale::before {
  content: "\\f0d92";
}

.mdi-pokeball::before {
  content: "\\f041d";
}

.mdi-pokemon-go::before {
  content: "\\f0a09";
}

.mdi-poker-chip::before {
  content: "\\f0830";
}

.mdi-polaroid::before {
  content: "\\f041e";
}

.mdi-police-badge::before {
  content: "\\f1167";
}

.mdi-police-badge-outline::before {
  content: "\\f1168";
}

.mdi-poll::before {
  content: "\\f041f";
}

.mdi-poll-box::before {
  content: "\\f0420";
}

.mdi-poll-box-outline::before {
  content: "\\f127b";
}

.mdi-polo::before {
  content: "\\f14c3";
}

.mdi-polymer::before {
  content: "\\f0421";
}

.mdi-pool::before {
  content: "\\f0606";
}

.mdi-popcorn::before {
  content: "\\f0422";
}

.mdi-post::before {
  content: "\\f1008";
}

.mdi-post-outline::before {
  content: "\\f1009";
}

.mdi-postage-stamp::before {
  content: "\\f0cbb";
}

.mdi-pot::before {
  content: "\\f02e5";
}

.mdi-pot-mix::before {
  content: "\\f065b";
}

.mdi-pot-mix-outline::before {
  content: "\\f0677";
}

.mdi-pot-outline::before {
  content: "\\f02ff";
}

.mdi-pot-steam::before {
  content: "\\f065a";
}

.mdi-pot-steam-outline::before {
  content: "\\f0326";
}

.mdi-pound::before {
  content: "\\f0423";
}

.mdi-pound-box::before {
  content: "\\f0424";
}

.mdi-pound-box-outline::before {
  content: "\\f117f";
}

.mdi-power::before {
  content: "\\f0425";
}

.mdi-power-cycle::before {
  content: "\\f0901";
}

.mdi-power-off::before {
  content: "\\f0902";
}

.mdi-power-on::before {
  content: "\\f0903";
}

.mdi-power-plug::before {
  content: "\\f06a5";
}

.mdi-power-plug-off::before {
  content: "\\f06a6";
}

.mdi-power-plug-off-outline::before {
  content: "\\f1424";
}

.mdi-power-plug-outline::before {
  content: "\\f1425";
}

.mdi-power-settings::before {
  content: "\\f0426";
}

.mdi-power-sleep::before {
  content: "\\f0904";
}

.mdi-power-socket::before {
  content: "\\f0427";
}

.mdi-power-socket-au::before {
  content: "\\f0905";
}

.mdi-power-socket-de::before {
  content: "\\f1107";
}

.mdi-power-socket-eu::before {
  content: "\\f07e7";
}

.mdi-power-socket-fr::before {
  content: "\\f1108";
}

.mdi-power-socket-it::before {
  content: "\\f14ff";
}

.mdi-power-socket-jp::before {
  content: "\\f1109";
}

.mdi-power-socket-uk::before {
  content: "\\f07e8";
}

.mdi-power-socket-us::before {
  content: "\\f07e9";
}

.mdi-power-standby::before {
  content: "\\f0906";
}

.mdi-powershell::before {
  content: "\\f0a0a";
}

.mdi-prescription::before {
  content: "\\f0706";
}

.mdi-presentation::before {
  content: "\\f0428";
}

.mdi-presentation-play::before {
  content: "\\f0429";
}

.mdi-pretzel::before {
  content: "\\f1562";
}

.mdi-printer::before {
  content: "\\f042a";
}

.mdi-printer-3d::before {
  content: "\\f042b";
}

.mdi-printer-3d-nozzle::before {
  content: "\\f0e5b";
}

.mdi-printer-3d-nozzle-alert::before {
  content: "\\f11c0";
}

.mdi-printer-3d-nozzle-alert-outline::before {
  content: "\\f11c1";
}

.mdi-printer-3d-nozzle-outline::before {
  content: "\\f0e5c";
}

.mdi-printer-alert::before {
  content: "\\f042c";
}

.mdi-printer-check::before {
  content: "\\f1146";
}

.mdi-printer-eye::before {
  content: "\\f1458";
}

.mdi-printer-off::before {
  content: "\\f0e5d";
}

.mdi-printer-pos::before {
  content: "\\f1057";
}

.mdi-printer-search::before {
  content: "\\f1457";
}

.mdi-printer-settings::before {
  content: "\\f0707";
}

.mdi-printer-wireless::before {
  content: "\\f0a0b";
}

.mdi-priority-high::before {
  content: "\\f0603";
}

.mdi-priority-low::before {
  content: "\\f0604";
}

.mdi-professional-hexagon::before {
  content: "\\f042d";
}

.mdi-progress-alert::before {
  content: "\\f0cbc";
}

.mdi-progress-check::before {
  content: "\\f0995";
}

.mdi-progress-clock::before {
  content: "\\f0996";
}

.mdi-progress-close::before {
  content: "\\f110a";
}

.mdi-progress-download::before {
  content: "\\f0997";
}

.mdi-progress-question::before {
  content: "\\f1522";
}

.mdi-progress-upload::before {
  content: "\\f0998";
}

.mdi-progress-wrench::before {
  content: "\\f0cbd";
}

.mdi-projector::before {
  content: "\\f042e";
}

.mdi-projector-screen::before {
  content: "\\f042f";
}

.mdi-propane-tank::before {
  content: "\\f1357";
}

.mdi-propane-tank-outline::before {
  content: "\\f1358";
}

.mdi-protocol::before {
  content: "\\f0fd8";
}

.mdi-publish::before {
  content: "\\f06a7";
}

.mdi-pulse::before {
  content: "\\f0430";
}

.mdi-pump::before {
  content: "\\f1402";
}

.mdi-pumpkin::before {
  content: "\\f0bbf";
}

.mdi-purse::before {
  content: "\\f0f1c";
}

.mdi-purse-outline::before {
  content: "\\f0f1d";
}

.mdi-puzzle::before {
  content: "\\f0431";
}

.mdi-puzzle-check::before {
  content: "\\f1426";
}

.mdi-puzzle-check-outline::before {
  content: "\\f1427";
}

.mdi-puzzle-edit::before {
  content: "\\f14d3";
}

.mdi-puzzle-edit-outline::before {
  content: "\\f14d9";
}

.mdi-puzzle-heart::before {
  content: "\\f14d4";
}

.mdi-puzzle-heart-outline::before {
  content: "\\f14da";
}

.mdi-puzzle-minus::before {
  content: "\\f14d1";
}

.mdi-puzzle-minus-outline::before {
  content: "\\f14d7";
}

.mdi-puzzle-outline::before {
  content: "\\f0a66";
}

.mdi-puzzle-plus::before {
  content: "\\f14d0";
}

.mdi-puzzle-plus-outline::before {
  content: "\\f14d6";
}

.mdi-puzzle-remove::before {
  content: "\\f14d2";
}

.mdi-puzzle-remove-outline::before {
  content: "\\f14d8";
}

.mdi-puzzle-star::before {
  content: "\\f14d5";
}

.mdi-puzzle-star-outline::before {
  content: "\\f14db";
}

.mdi-qi::before {
  content: "\\f0999";
}

.mdi-qqchat::before {
  content: "\\f0605";
}

.mdi-qrcode::before {
  content: "\\f0432";
}

.mdi-qrcode-edit::before {
  content: "\\f08b8";
}

.mdi-qrcode-minus::before {
  content: "\\f118c";
}

.mdi-qrcode-plus::before {
  content: "\\f118b";
}

.mdi-qrcode-remove::before {
  content: "\\f118d";
}

.mdi-qrcode-scan::before {
  content: "\\f0433";
}

.mdi-quadcopter::before {
  content: "\\f0434";
}

.mdi-quality-high::before {
  content: "\\f0435";
}

.mdi-quality-low::before {
  content: "\\f0a0c";
}

.mdi-quality-medium::before {
  content: "\\f0a0d";
}

.mdi-quora::before {
  content: "\\f0d29";
}

.mdi-rabbit::before {
  content: "\\f0907";
}

.mdi-racing-helmet::before {
  content: "\\f0d93";
}

.mdi-racquetball::before {
  content: "\\f0d94";
}

.mdi-radar::before {
  content: "\\f0437";
}

.mdi-radiator::before {
  content: "\\f0438";
}

.mdi-radiator-disabled::before {
  content: "\\f0ad7";
}

.mdi-radiator-off::before {
  content: "\\f0ad8";
}

.mdi-radio::before {
  content: "\\f0439";
}

.mdi-radio-am::before {
  content: "\\f0cbe";
}

.mdi-radio-fm::before {
  content: "\\f0cbf";
}

.mdi-radio-handheld::before {
  content: "\\f043a";
}

.mdi-radio-off::before {
  content: "\\f121c";
}

.mdi-radio-tower::before {
  content: "\\f043b";
}

.mdi-radioactive::before {
  content: "\\f043c";
}

.mdi-radioactive-off::before {
  content: "\\f0ec1";
}

.mdi-radiobox-blank::before {
  content: "\\f043d";
}

.mdi-radiobox-marked::before {
  content: "\\f043e";
}

.mdi-radiology-box::before {
  content: "\\f14c5";
}

.mdi-radiology-box-outline::before {
  content: "\\f14c6";
}

.mdi-radius::before {
  content: "\\f0cc0";
}

.mdi-radius-outline::before {
  content: "\\f0cc1";
}

.mdi-railroad-light::before {
  content: "\\f0f1e";
}

.mdi-rake::before {
  content: "\\f1544";
}

.mdi-raspberry-pi::before {
  content: "\\f043f";
}

.mdi-ray-end::before {
  content: "\\f0440";
}

.mdi-ray-end-arrow::before {
  content: "\\f0441";
}

.mdi-ray-start::before {
  content: "\\f0442";
}

.mdi-ray-start-arrow::before {
  content: "\\f0443";
}

.mdi-ray-start-end::before {
  content: "\\f0444";
}

.mdi-ray-start-vertex-end::before {
  content: "\\f15d8";
}

.mdi-ray-vertex::before {
  content: "\\f0445";
}

.mdi-react::before {
  content: "\\f0708";
}

.mdi-read::before {
  content: "\\f0447";
}

.mdi-receipt::before {
  content: "\\f0449";
}

.mdi-record::before {
  content: "\\f044a";
}

.mdi-record-circle::before {
  content: "\\f0ec2";
}

.mdi-record-circle-outline::before {
  content: "\\f0ec3";
}

.mdi-record-player::before {
  content: "\\f099a";
}

.mdi-record-rec::before {
  content: "\\f044b";
}

.mdi-rectangle::before {
  content: "\\f0e5e";
}

.mdi-rectangle-outline::before {
  content: "\\f0e5f";
}

.mdi-recycle::before {
  content: "\\f044c";
}

.mdi-recycle-variant::before {
  content: "\\f139d";
}

.mdi-reddit::before {
  content: "\\f044d";
}

.mdi-redhat::before {
  content: "\\f111b";
}

.mdi-redo::before {
  content: "\\f044e";
}

.mdi-redo-variant::before {
  content: "\\f044f";
}

.mdi-reflect-horizontal::before {
  content: "\\f0a0e";
}

.mdi-reflect-vertical::before {
  content: "\\f0a0f";
}

.mdi-refresh::before {
  content: "\\f0450";
}

.mdi-refresh-circle::before {
  content: "\\f1377";
}

.mdi-regex::before {
  content: "\\f0451";
}

.mdi-registered-trademark::before {
  content: "\\f0a67";
}

.mdi-reiterate::before {
  content: "\\f1588";
}

.mdi-relation-many-to-many::before {
  content: "\\f1496";
}

.mdi-relation-many-to-one::before {
  content: "\\f1497";
}

.mdi-relation-many-to-one-or-many::before {
  content: "\\f1498";
}

.mdi-relation-many-to-only-one::before {
  content: "\\f1499";
}

.mdi-relation-many-to-zero-or-many::before {
  content: "\\f149a";
}

.mdi-relation-many-to-zero-or-one::before {
  content: "\\f149b";
}

.mdi-relation-one-or-many-to-many::before {
  content: "\\f149c";
}

.mdi-relation-one-or-many-to-one::before {
  content: "\\f149d";
}

.mdi-relation-one-or-many-to-one-or-many::before {
  content: "\\f149e";
}

.mdi-relation-one-or-many-to-only-one::before {
  content: "\\f149f";
}

.mdi-relation-one-or-many-to-zero-or-many::before {
  content: "\\f14a0";
}

.mdi-relation-one-or-many-to-zero-or-one::before {
  content: "\\f14a1";
}

.mdi-relation-one-to-many::before {
  content: "\\f14a2";
}

.mdi-relation-one-to-one::before {
  content: "\\f14a3";
}

.mdi-relation-one-to-one-or-many::before {
  content: "\\f14a4";
}

.mdi-relation-one-to-only-one::before {
  content: "\\f14a5";
}

.mdi-relation-one-to-zero-or-many::before {
  content: "\\f14a6";
}

.mdi-relation-one-to-zero-or-one::before {
  content: "\\f14a7";
}

.mdi-relation-only-one-to-many::before {
  content: "\\f14a8";
}

.mdi-relation-only-one-to-one::before {
  content: "\\f14a9";
}

.mdi-relation-only-one-to-one-or-many::before {
  content: "\\f14aa";
}

.mdi-relation-only-one-to-only-one::before {
  content: "\\f14ab";
}

.mdi-relation-only-one-to-zero-or-many::before {
  content: "\\f14ac";
}

.mdi-relation-only-one-to-zero-or-one::before {
  content: "\\f14ad";
}

.mdi-relation-zero-or-many-to-many::before {
  content: "\\f14ae";
}

.mdi-relation-zero-or-many-to-one::before {
  content: "\\f14af";
}

.mdi-relation-zero-or-many-to-one-or-many::before {
  content: "\\f14b0";
}

.mdi-relation-zero-or-many-to-only-one::before {
  content: "\\f14b1";
}

.mdi-relation-zero-or-many-to-zero-or-many::before {
  content: "\\f14b2";
}

.mdi-relation-zero-or-many-to-zero-or-one::before {
  content: "\\f14b3";
}

.mdi-relation-zero-or-one-to-many::before {
  content: "\\f14b4";
}

.mdi-relation-zero-or-one-to-one::before {
  content: "\\f14b5";
}

.mdi-relation-zero-or-one-to-one-or-many::before {
  content: "\\f14b6";
}

.mdi-relation-zero-or-one-to-only-one::before {
  content: "\\f14b7";
}

.mdi-relation-zero-or-one-to-zero-or-many::before {
  content: "\\f14b8";
}

.mdi-relation-zero-or-one-to-zero-or-one::before {
  content: "\\f14b9";
}

.mdi-relative-scale::before {
  content: "\\f0452";
}

.mdi-reload::before {
  content: "\\f0453";
}

.mdi-reload-alert::before {
  content: "\\f110b";
}

.mdi-reminder::before {
  content: "\\f088c";
}

.mdi-remote::before {
  content: "\\f0454";
}

.mdi-remote-desktop::before {
  content: "\\f08b9";
}

.mdi-remote-off::before {
  content: "\\f0ec4";
}

.mdi-remote-tv::before {
  content: "\\f0ec5";
}

.mdi-remote-tv-off::before {
  content: "\\f0ec6";
}

.mdi-rename-box::before {
  content: "\\f0455";
}

.mdi-reorder-horizontal::before {
  content: "\\f0688";
}

.mdi-reorder-vertical::before {
  content: "\\f0689";
}

.mdi-repeat::before {
  content: "\\f0456";
}

.mdi-repeat-off::before {
  content: "\\f0457";
}

.mdi-repeat-once::before {
  content: "\\f0458";
}

.mdi-replay::before {
  content: "\\f0459";
}

.mdi-reply::before {
  content: "\\f045a";
}

.mdi-reply-all::before {
  content: "\\f045b";
}

.mdi-reply-all-outline::before {
  content: "\\f0f1f";
}

.mdi-reply-circle::before {
  content: "\\f11ae";
}

.mdi-reply-outline::before {
  content: "\\f0f20";
}

.mdi-reproduction::before {
  content: "\\f045c";
}

.mdi-resistor::before {
  content: "\\f0b44";
}

.mdi-resistor-nodes::before {
  content: "\\f0b45";
}

.mdi-resize::before {
  content: "\\f0a68";
}

.mdi-resize-bottom-right::before {
  content: "\\f045d";
}

.mdi-responsive::before {
  content: "\\f045e";
}

.mdi-restart::before {
  content: "\\f0709";
}

.mdi-restart-alert::before {
  content: "\\f110c";
}

.mdi-restart-off::before {
  content: "\\f0d95";
}

.mdi-restore::before {
  content: "\\f099b";
}

.mdi-restore-alert::before {
  content: "\\f110d";
}

.mdi-rewind::before {
  content: "\\f045f";
}

.mdi-rewind-10::before {
  content: "\\f0d2a";
}

.mdi-rewind-30::before {
  content: "\\f0d96";
}

.mdi-rewind-5::before {
  content: "\\f11f9";
}

.mdi-rewind-60::before {
  content: "\\f160c";
}

.mdi-rewind-outline::before {
  content: "\\f070a";
}

.mdi-rhombus::before {
  content: "\\f070b";
}

.mdi-rhombus-medium::before {
  content: "\\f0a10";
}

.mdi-rhombus-medium-outline::before {
  content: "\\f14dc";
}

.mdi-rhombus-outline::before {
  content: "\\f070c";
}

.mdi-rhombus-split::before {
  content: "\\f0a11";
}

.mdi-rhombus-split-outline::before {
  content: "\\f14dd";
}

.mdi-ribbon::before {
  content: "\\f0460";
}

.mdi-rice::before {
  content: "\\f07ea";
}

.mdi-rickshaw::before {
  content: "\\f15bb";
}

.mdi-rickshaw-electric::before {
  content: "\\f15bc";
}

.mdi-ring::before {
  content: "\\f07eb";
}

.mdi-rivet::before {
  content: "\\f0e60";
}

.mdi-road::before {
  content: "\\f0461";
}

.mdi-road-variant::before {
  content: "\\f0462";
}

.mdi-robber::before {
  content: "\\f1058";
}

.mdi-robot::before {
  content: "\\f06a9";
}

.mdi-robot-angry::before {
  content: "\\f169d";
}

.mdi-robot-angry-outline::before {
  content: "\\f169e";
}

.mdi-robot-confused::before {
  content: "\\f169f";
}

.mdi-robot-confused-outline::before {
  content: "\\f16a0";
}

.mdi-robot-dead::before {
  content: "\\f16a1";
}

.mdi-robot-dead-outline::before {
  content: "\\f16a2";
}

.mdi-robot-excited::before {
  content: "\\f16a3";
}

.mdi-robot-excited-outline::before {
  content: "\\f16a4";
}

.mdi-robot-industrial::before {
  content: "\\f0b46";
}

.mdi-robot-love::before {
  content: "\\f16a5";
}

.mdi-robot-love-outline::before {
  content: "\\f16a6";
}

.mdi-robot-mower::before {
  content: "\\f11f7";
}

.mdi-robot-mower-outline::before {
  content: "\\f11f3";
}

.mdi-robot-off::before {
  content: "\\f16a7";
}

.mdi-robot-off-outline::before {
  content: "\\f167b";
}

.mdi-robot-outline::before {
  content: "\\f167a";
}

.mdi-robot-vacuum::before {
  content: "\\f070d";
}

.mdi-robot-vacuum-variant::before {
  content: "\\f0908";
}

.mdi-rocket::before {
  content: "\\f0463";
}

.mdi-rocket-launch::before {
  content: "\\f14de";
}

.mdi-rocket-launch-outline::before {
  content: "\\f14df";
}

.mdi-rocket-outline::before {
  content: "\\f13af";
}

.mdi-rodent::before {
  content: "\\f1327";
}

.mdi-roller-skate::before {
  content: "\\f0d2b";
}

.mdi-roller-skate-off::before {
  content: "\\f0145";
}

.mdi-rollerblade::before {
  content: "\\f0d2c";
}

.mdi-rollerblade-off::before {
  content: "\\f002e";
}

.mdi-rollupjs::before {
  content: "\\f0bc0";
}

.mdi-roman-numeral-1::before {
  content: "\\f1088";
}

.mdi-roman-numeral-10::before {
  content: "\\f1091";
}

.mdi-roman-numeral-2::before {
  content: "\\f1089";
}

.mdi-roman-numeral-3::before {
  content: "\\f108a";
}

.mdi-roman-numeral-4::before {
  content: "\\f108b";
}

.mdi-roman-numeral-5::before {
  content: "\\f108c";
}

.mdi-roman-numeral-6::before {
  content: "\\f108d";
}

.mdi-roman-numeral-7::before {
  content: "\\f108e";
}

.mdi-roman-numeral-8::before {
  content: "\\f108f";
}

.mdi-roman-numeral-9::before {
  content: "\\f1090";
}

.mdi-room-service::before {
  content: "\\f088d";
}

.mdi-room-service-outline::before {
  content: "\\f0d97";
}

.mdi-rotate-3d::before {
  content: "\\f0ec7";
}

.mdi-rotate-3d-variant::before {
  content: "\\f0464";
}

.mdi-rotate-left::before {
  content: "\\f0465";
}

.mdi-rotate-left-variant::before {
  content: "\\f0466";
}

.mdi-rotate-orbit::before {
  content: "\\f0d98";
}

.mdi-rotate-right::before {
  content: "\\f0467";
}

.mdi-rotate-right-variant::before {
  content: "\\f0468";
}

.mdi-rounded-corner::before {
  content: "\\f0607";
}

.mdi-router::before {
  content: "\\f11e2";
}

.mdi-router-network::before {
  content: "\\f1087";
}

.mdi-router-wireless::before {
  content: "\\f0469";
}

.mdi-router-wireless-off::before {
  content: "\\f15a3";
}

.mdi-router-wireless-settings::before {
  content: "\\f0a69";
}

.mdi-routes::before {
  content: "\\f046a";
}

.mdi-routes-clock::before {
  content: "\\f1059";
}

.mdi-rowing::before {
  content: "\\f0608";
}

.mdi-rss::before {
  content: "\\f046b";
}

.mdi-rss-box::before {
  content: "\\f046c";
}

.mdi-rss-off::before {
  content: "\\f0f21";
}

.mdi-rug::before {
  content: "\\f1475";
}

.mdi-rugby::before {
  content: "\\f0d99";
}

.mdi-ruler::before {
  content: "\\f046d";
}

.mdi-ruler-square::before {
  content: "\\f0cc2";
}

.mdi-ruler-square-compass::before {
  content: "\\f0ebe";
}

.mdi-run::before {
  content: "\\f070e";
}

.mdi-run-fast::before {
  content: "\\f046e";
}

.mdi-rv-truck::before {
  content: "\\f11d4";
}

.mdi-sack::before {
  content: "\\f0d2e";
}

.mdi-sack-percent::before {
  content: "\\f0d2f";
}

.mdi-safe::before {
  content: "\\f0a6a";
}

.mdi-safe-square::before {
  content: "\\f127c";
}

.mdi-safe-square-outline::before {
  content: "\\f127d";
}

.mdi-safety-goggles::before {
  content: "\\f0d30";
}

.mdi-sail-boat::before {
  content: "\\f0ec8";
}

.mdi-sale::before {
  content: "\\f046f";
}

.mdi-salesforce::before {
  content: "\\f088e";
}

.mdi-sass::before {
  content: "\\f07ec";
}

.mdi-satellite::before {
  content: "\\f0470";
}

.mdi-satellite-uplink::before {
  content: "\\f0909";
}

.mdi-satellite-variant::before {
  content: "\\f0471";
}

.mdi-sausage::before {
  content: "\\f08ba";
}

.mdi-saw-blade::before {
  content: "\\f0e61";
}

.mdi-sawtooth-wave::before {
  content: "\\f147a";
}

.mdi-saxophone::before {
  content: "\\f0609";
}

.mdi-scale::before {
  content: "\\f0472";
}

.mdi-scale-balance::before {
  content: "\\f05d1";
}

.mdi-scale-bathroom::before {
  content: "\\f0473";
}

.mdi-scale-off::before {
  content: "\\f105a";
}

.mdi-scan-helper::before {
  content: "\\f13d8";
}

.mdi-scanner::before {
  content: "\\f06ab";
}

.mdi-scanner-off::before {
  content: "\\f090a";
}

.mdi-scatter-plot::before {
  content: "\\f0ec9";
}

.mdi-scatter-plot-outline::before {
  content: "\\f0eca";
}

.mdi-school::before {
  content: "\\f0474";
}

.mdi-school-outline::before {
  content: "\\f1180";
}

.mdi-scissors-cutting::before {
  content: "\\f0a6b";
}

.mdi-scooter::before {
  content: "\\f15bd";
}

.mdi-scooter-electric::before {
  content: "\\f15be";
}

.mdi-scoreboard::before {
  content: "\\f127e";
}

.mdi-scoreboard-outline::before {
  content: "\\f127f";
}

.mdi-screen-rotation::before {
  content: "\\f0475";
}

.mdi-screen-rotation-lock::before {
  content: "\\f0478";
}

.mdi-screw-flat-top::before {
  content: "\\f0df3";
}

.mdi-screw-lag::before {
  content: "\\f0df4";
}

.mdi-screw-machine-flat-top::before {
  content: "\\f0df5";
}

.mdi-screw-machine-round-top::before {
  content: "\\f0df6";
}

.mdi-screw-round-top::before {
  content: "\\f0df7";
}

.mdi-screwdriver::before {
  content: "\\f0476";
}

.mdi-script::before {
  content: "\\f0bc1";
}

.mdi-script-outline::before {
  content: "\\f0477";
}

.mdi-script-text::before {
  content: "\\f0bc2";
}

.mdi-script-text-outline::before {
  content: "\\f0bc3";
}

.mdi-sd::before {
  content: "\\f0479";
}

.mdi-seal::before {
  content: "\\f047a";
}

.mdi-seal-variant::before {
  content: "\\f0fd9";
}

.mdi-search-web::before {
  content: "\\f070f";
}

.mdi-seat::before {
  content: "\\f0cc3";
}

.mdi-seat-flat::before {
  content: "\\f047b";
}

.mdi-seat-flat-angled::before {
  content: "\\f047c";
}

.mdi-seat-individual-suite::before {
  content: "\\f047d";
}

.mdi-seat-legroom-extra::before {
  content: "\\f047e";
}

.mdi-seat-legroom-normal::before {
  content: "\\f047f";
}

.mdi-seat-legroom-reduced::before {
  content: "\\f0480";
}

.mdi-seat-outline::before {
  content: "\\f0cc4";
}

.mdi-seat-passenger::before {
  content: "\\f1249";
}

.mdi-seat-recline-extra::before {
  content: "\\f0481";
}

.mdi-seat-recline-normal::before {
  content: "\\f0482";
}

.mdi-seatbelt::before {
  content: "\\f0cc5";
}

.mdi-security::before {
  content: "\\f0483";
}

.mdi-security-network::before {
  content: "\\f0484";
}

.mdi-seed::before {
  content: "\\f0e62";
}

.mdi-seed-off::before {
  content: "\\f13fd";
}

.mdi-seed-off-outline::before {
  content: "\\f13fe";
}

.mdi-seed-outline::before {
  content: "\\f0e63";
}

.mdi-seesaw::before {
  content: "\\f15a4";
}

.mdi-segment::before {
  content: "\\f0ecb";
}

.mdi-select::before {
  content: "\\f0485";
}

.mdi-select-all::before {
  content: "\\f0486";
}

.mdi-select-color::before {
  content: "\\f0d31";
}

.mdi-select-compare::before {
  content: "\\f0ad9";
}

.mdi-select-drag::before {
  content: "\\f0a6c";
}

.mdi-select-group::before {
  content: "\\f0f82";
}

.mdi-select-inverse::before {
  content: "\\f0487";
}

.mdi-select-marker::before {
  content: "\\f1280";
}

.mdi-select-multiple::before {
  content: "\\f1281";
}

.mdi-select-multiple-marker::before {
  content: "\\f1282";
}

.mdi-select-off::before {
  content: "\\f0488";
}

.mdi-select-place::before {
  content: "\\f0fda";
}

.mdi-select-search::before {
  content: "\\f1204";
}

.mdi-selection::before {
  content: "\\f0489";
}

.mdi-selection-drag::before {
  content: "\\f0a6d";
}

.mdi-selection-ellipse::before {
  content: "\\f0d32";
}

.mdi-selection-ellipse-arrow-inside::before {
  content: "\\f0f22";
}

.mdi-selection-marker::before {
  content: "\\f1283";
}

.mdi-selection-multiple::before {
  content: "\\f1285";
}

.mdi-selection-multiple-marker::before {
  content: "\\f1284";
}

.mdi-selection-off::before {
  content: "\\f0777";
}

.mdi-selection-search::before {
  content: "\\f1205";
}

.mdi-semantic-web::before {
  content: "\\f1316";
}

.mdi-send::before {
  content: "\\f048a";
}

.mdi-send-check::before {
  content: "\\f1161";
}

.mdi-send-check-outline::before {
  content: "\\f1162";
}

.mdi-send-circle::before {
  content: "\\f0df8";
}

.mdi-send-circle-outline::before {
  content: "\\f0df9";
}

.mdi-send-clock::before {
  content: "\\f1163";
}

.mdi-send-clock-outline::before {
  content: "\\f1164";
}

.mdi-send-lock::before {
  content: "\\f07ed";
}

.mdi-send-lock-outline::before {
  content: "\\f1166";
}

.mdi-send-outline::before {
  content: "\\f1165";
}

.mdi-serial-port::before {
  content: "\\f065c";
}

.mdi-server::before {
  content: "\\f048b";
}

.mdi-server-minus::before {
  content: "\\f048c";
}

.mdi-server-network::before {
  content: "\\f048d";
}

.mdi-server-network-off::before {
  content: "\\f048e";
}

.mdi-server-off::before {
  content: "\\f048f";
}

.mdi-server-plus::before {
  content: "\\f0490";
}

.mdi-server-remove::before {
  content: "\\f0491";
}

.mdi-server-security::before {
  content: "\\f0492";
}

.mdi-set-all::before {
  content: "\\f0778";
}

.mdi-set-center::before {
  content: "\\f0779";
}

.mdi-set-center-right::before {
  content: "\\f077a";
}

.mdi-set-left::before {
  content: "\\f077b";
}

.mdi-set-left-center::before {
  content: "\\f077c";
}

.mdi-set-left-right::before {
  content: "\\f077d";
}

.mdi-set-merge::before {
  content: "\\f14e0";
}

.mdi-set-none::before {
  content: "\\f077e";
}

.mdi-set-right::before {
  content: "\\f077f";
}

.mdi-set-split::before {
  content: "\\f14e1";
}

.mdi-set-square::before {
  content: "\\f145d";
}

.mdi-set-top-box::before {
  content: "\\f099f";
}

.mdi-settings-helper::before {
  content: "\\f0a6e";
}

.mdi-shaker::before {
  content: "\\f110e";
}

.mdi-shaker-outline::before {
  content: "\\f110f";
}

.mdi-shape::before {
  content: "\\f0831";
}

.mdi-shape-circle-plus::before {
  content: "\\f065d";
}

.mdi-shape-outline::before {
  content: "\\f0832";
}

.mdi-shape-oval-plus::before {
  content: "\\f11fa";
}

.mdi-shape-plus::before {
  content: "\\f0495";
}

.mdi-shape-polygon-plus::before {
  content: "\\f065e";
}

.mdi-shape-rectangle-plus::before {
  content: "\\f065f";
}

.mdi-shape-square-plus::before {
  content: "\\f0660";
}

.mdi-shape-square-rounded-plus::before {
  content: "\\f14fa";
}

.mdi-share::before {
  content: "\\f0496";
}

.mdi-share-all::before {
  content: "\\f11f4";
}

.mdi-share-all-outline::before {
  content: "\\f11f5";
}

.mdi-share-circle::before {
  content: "\\f11ad";
}

.mdi-share-off::before {
  content: "\\f0f23";
}

.mdi-share-off-outline::before {
  content: "\\f0f24";
}

.mdi-share-outline::before {
  content: "\\f0932";
}

.mdi-share-variant::before {
  content: "\\f0497";
}

.mdi-share-variant-outline::before {
  content: "\\f1514";
}

.mdi-shark-fin::before {
  content: "\\f1673";
}

.mdi-shark-fin-outline::before {
  content: "\\f1674";
}

.mdi-sheep::before {
  content: "\\f0cc6";
}

.mdi-shield::before {
  content: "\\f0498";
}

.mdi-shield-account::before {
  content: "\\f088f";
}

.mdi-shield-account-outline::before {
  content: "\\f0a12";
}

.mdi-shield-account-variant::before {
  content: "\\f15a7";
}

.mdi-shield-account-variant-outline::before {
  content: "\\f15a8";
}

.mdi-shield-airplane::before {
  content: "\\f06bb";
}

.mdi-shield-airplane-outline::before {
  content: "\\f0cc7";
}

.mdi-shield-alert::before {
  content: "\\f0ecc";
}

.mdi-shield-alert-outline::before {
  content: "\\f0ecd";
}

.mdi-shield-bug::before {
  content: "\\f13da";
}

.mdi-shield-bug-outline::before {
  content: "\\f13db";
}

.mdi-shield-car::before {
  content: "\\f0f83";
}

.mdi-shield-check::before {
  content: "\\f0565";
}

.mdi-shield-check-outline::before {
  content: "\\f0cc8";
}

.mdi-shield-cross::before {
  content: "\\f0cc9";
}

.mdi-shield-cross-outline::before {
  content: "\\f0cca";
}

.mdi-shield-edit::before {
  content: "\\f11a0";
}

.mdi-shield-edit-outline::before {
  content: "\\f11a1";
}

.mdi-shield-half::before {
  content: "\\f1360";
}

.mdi-shield-half-full::before {
  content: "\\f0780";
}

.mdi-shield-home::before {
  content: "\\f068a";
}

.mdi-shield-home-outline::before {
  content: "\\f0ccb";
}

.mdi-shield-key::before {
  content: "\\f0bc4";
}

.mdi-shield-key-outline::before {
  content: "\\f0bc5";
}

.mdi-shield-link-variant::before {
  content: "\\f0d33";
}

.mdi-shield-link-variant-outline::before {
  content: "\\f0d34";
}

.mdi-shield-lock::before {
  content: "\\f099d";
}

.mdi-shield-lock-outline::before {
  content: "\\f0ccc";
}

.mdi-shield-off::before {
  content: "\\f099e";
}

.mdi-shield-off-outline::before {
  content: "\\f099c";
}

.mdi-shield-outline::before {
  content: "\\f0499";
}

.mdi-shield-plus::before {
  content: "\\f0ada";
}

.mdi-shield-plus-outline::before {
  content: "\\f0adb";
}

.mdi-shield-refresh::before {
  content: "\\f00aa";
}

.mdi-shield-refresh-outline::before {
  content: "\\f01e0";
}

.mdi-shield-remove::before {
  content: "\\f0adc";
}

.mdi-shield-remove-outline::before {
  content: "\\f0add";
}

.mdi-shield-search::before {
  content: "\\f0d9a";
}

.mdi-shield-star::before {
  content: "\\f113b";
}

.mdi-shield-star-outline::before {
  content: "\\f113c";
}

.mdi-shield-sun::before {
  content: "\\f105d";
}

.mdi-shield-sun-outline::before {
  content: "\\f105e";
}

.mdi-shield-sync::before {
  content: "\\f11a2";
}

.mdi-shield-sync-outline::before {
  content: "\\f11a3";
}

.mdi-ship-wheel::before {
  content: "\\f0833";
}

.mdi-shoe-ballet::before {
  content: "\\f15ca";
}

.mdi-shoe-cleat::before {
  content: "\\f15c7";
}

.mdi-shoe-formal::before {
  content: "\\f0b47";
}

.mdi-shoe-heel::before {
  content: "\\f0b48";
}

.mdi-shoe-print::before {
  content: "\\f0dfa";
}

.mdi-shoe-sneaker::before {
  content: "\\f15c8";
}

.mdi-shopping::before {
  content: "\\f049a";
}

.mdi-shopping-music::before {
  content: "\\f049b";
}

.mdi-shopping-outline::before {
  content: "\\f11d5";
}

.mdi-shopping-search::before {
  content: "\\f0f84";
}

.mdi-shore::before {
  content: "\\f14f9";
}

.mdi-shovel::before {
  content: "\\f0710";
}

.mdi-shovel-off::before {
  content: "\\f0711";
}

.mdi-shower::before {
  content: "\\f09a0";
}

.mdi-shower-head::before {
  content: "\\f09a1";
}

.mdi-shredder::before {
  content: "\\f049c";
}

.mdi-shuffle::before {
  content: "\\f049d";
}

.mdi-shuffle-disabled::before {
  content: "\\f049e";
}

.mdi-shuffle-variant::before {
  content: "\\f049f";
}

.mdi-shuriken::before {
  content: "\\f137f";
}

.mdi-sigma::before {
  content: "\\f04a0";
}

.mdi-sigma-lower::before {
  content: "\\f062b";
}

.mdi-sign-caution::before {
  content: "\\f04a1";
}

.mdi-sign-direction::before {
  content: "\\f0781";
}

.mdi-sign-direction-minus::before {
  content: "\\f1000";
}

.mdi-sign-direction-plus::before {
  content: "\\f0fdc";
}

.mdi-sign-direction-remove::before {
  content: "\\f0fdd";
}

.mdi-sign-pole::before {
  content: "\\f14f8";
}

.mdi-sign-real-estate::before {
  content: "\\f1118";
}

.mdi-sign-text::before {
  content: "\\f0782";
}

.mdi-signal::before {
  content: "\\f04a2";
}

.mdi-signal-2g::before {
  content: "\\f0712";
}

.mdi-signal-3g::before {
  content: "\\f0713";
}

.mdi-signal-4g::before {
  content: "\\f0714";
}

.mdi-signal-5g::before {
  content: "\\f0a6f";
}

.mdi-signal-cellular-1::before {
  content: "\\f08bc";
}

.mdi-signal-cellular-2::before {
  content: "\\f08bd";
}

.mdi-signal-cellular-3::before {
  content: "\\f08be";
}

.mdi-signal-cellular-outline::before {
  content: "\\f08bf";
}

.mdi-signal-distance-variant::before {
  content: "\\f0e64";
}

.mdi-signal-hspa::before {
  content: "\\f0715";
}

.mdi-signal-hspa-plus::before {
  content: "\\f0716";
}

.mdi-signal-off::before {
  content: "\\f0783";
}

.mdi-signal-variant::before {
  content: "\\f060a";
}

.mdi-signature::before {
  content: "\\f0dfb";
}

.mdi-signature-freehand::before {
  content: "\\f0dfc";
}

.mdi-signature-image::before {
  content: "\\f0dfd";
}

.mdi-signature-text::before {
  content: "\\f0dfe";
}

.mdi-silo::before {
  content: "\\f0b49";
}

.mdi-silverware::before {
  content: "\\f04a3";
}

.mdi-silverware-clean::before {
  content: "\\f0fde";
}

.mdi-silverware-fork::before {
  content: "\\f04a4";
}

.mdi-silverware-fork-knife::before {
  content: "\\f0a70";
}

.mdi-silverware-spoon::before {
  content: "\\f04a5";
}

.mdi-silverware-variant::before {
  content: "\\f04a6";
}

.mdi-sim::before {
  content: "\\f04a7";
}

.mdi-sim-alert::before {
  content: "\\f04a8";
}

.mdi-sim-alert-outline::before {
  content: "\\f15d3";
}

.mdi-sim-off::before {
  content: "\\f04a9";
}

.mdi-sim-off-outline::before {
  content: "\\f15d4";
}

.mdi-sim-outline::before {
  content: "\\f15d5";
}

.mdi-simple-icons::before {
  content: "\\f131d";
}

.mdi-sina-weibo::before {
  content: "\\f0adf";
}

.mdi-sine-wave::before {
  content: "\\f095b";
}

.mdi-sitemap::before {
  content: "\\f04aa";
}

.mdi-size-l::before {
  content: "\\f13a6";
}

.mdi-size-m::before {
  content: "\\f13a5";
}

.mdi-size-s::before {
  content: "\\f13a4";
}

.mdi-size-xl::before {
  content: "\\f13a7";
}

.mdi-size-xs::before {
  content: "\\f13a3";
}

.mdi-size-xxl::before {
  content: "\\f13a8";
}

.mdi-size-xxs::before {
  content: "\\f13a2";
}

.mdi-size-xxxl::before {
  content: "\\f13a9";
}

.mdi-skate::before {
  content: "\\f0d35";
}

.mdi-skateboard::before {
  content: "\\f14c2";
}

.mdi-skew-less::before {
  content: "\\f0d36";
}

.mdi-skew-more::before {
  content: "\\f0d37";
}

.mdi-ski::before {
  content: "\\f1304";
}

.mdi-ski-cross-country::before {
  content: "\\f1305";
}

.mdi-ski-water::before {
  content: "\\f1306";
}

.mdi-skip-backward::before {
  content: "\\f04ab";
}

.mdi-skip-backward-outline::before {
  content: "\\f0f25";
}

.mdi-skip-forward::before {
  content: "\\f04ac";
}

.mdi-skip-forward-outline::before {
  content: "\\f0f26";
}

.mdi-skip-next::before {
  content: "\\f04ad";
}

.mdi-skip-next-circle::before {
  content: "\\f0661";
}

.mdi-skip-next-circle-outline::before {
  content: "\\f0662";
}

.mdi-skip-next-outline::before {
  content: "\\f0f27";
}

.mdi-skip-previous::before {
  content: "\\f04ae";
}

.mdi-skip-previous-circle::before {
  content: "\\f0663";
}

.mdi-skip-previous-circle-outline::before {
  content: "\\f0664";
}

.mdi-skip-previous-outline::before {
  content: "\\f0f28";
}

.mdi-skull::before {
  content: "\\f068c";
}

.mdi-skull-crossbones::before {
  content: "\\f0bc6";
}

.mdi-skull-crossbones-outline::before {
  content: "\\f0bc7";
}

.mdi-skull-outline::before {
  content: "\\f0bc8";
}

.mdi-skull-scan::before {
  content: "\\f14c7";
}

.mdi-skull-scan-outline::before {
  content: "\\f14c8";
}

.mdi-skype::before {
  content: "\\f04af";
}

.mdi-skype-business::before {
  content: "\\f04b0";
}

.mdi-slack::before {
  content: "\\f04b1";
}

.mdi-slash-forward::before {
  content: "\\f0fdf";
}

.mdi-slash-forward-box::before {
  content: "\\f0fe0";
}

.mdi-sleep::before {
  content: "\\f04b2";
}

.mdi-sleep-off::before {
  content: "\\f04b3";
}

.mdi-slide::before {
  content: "\\f15a5";
}

.mdi-slope-downhill::before {
  content: "\\f0dff";
}

.mdi-slope-uphill::before {
  content: "\\f0e00";
}

.mdi-slot-machine::before {
  content: "\\f1114";
}

.mdi-slot-machine-outline::before {
  content: "\\f1115";
}

.mdi-smart-card::before {
  content: "\\f10bd";
}

.mdi-smart-card-outline::before {
  content: "\\f10be";
}

.mdi-smart-card-reader::before {
  content: "\\f10bf";
}

.mdi-smart-card-reader-outline::before {
  content: "\\f10c0";
}

.mdi-smog::before {
  content: "\\f0a71";
}

.mdi-smoke-detector::before {
  content: "\\f0392";
}

.mdi-smoking::before {
  content: "\\f04b4";
}

.mdi-smoking-off::before {
  content: "\\f04b5";
}

.mdi-smoking-pipe::before {
  content: "\\f140d";
}

.mdi-smoking-pipe-off::before {
  content: "\\f1428";
}

.mdi-snail::before {
  content: "\\f1677";
}

.mdi-snake::before {
  content: "\\f150e";
}

.mdi-snapchat::before {
  content: "\\f04b6";
}

.mdi-snowboard::before {
  content: "\\f1307";
}

.mdi-snowflake::before {
  content: "\\f0717";
}

.mdi-snowflake-alert::before {
  content: "\\f0f29";
}

.mdi-snowflake-melt::before {
  content: "\\f12cb";
}

.mdi-snowflake-off::before {
  content: "\\f14e3";
}

.mdi-snowflake-variant::before {
  content: "\\f0f2a";
}

.mdi-snowman::before {
  content: "\\f04b7";
}

.mdi-soccer::before {
  content: "\\f04b8";
}

.mdi-soccer-field::before {
  content: "\\f0834";
}

.mdi-social-distance-2-meters::before {
  content: "\\f1579";
}

.mdi-social-distance-6-feet::before {
  content: "\\f157a";
}

.mdi-sofa::before {
  content: "\\f04b9";
}

.mdi-sofa-outline::before {
  content: "\\f156d";
}

.mdi-sofa-single::before {
  content: "\\f156e";
}

.mdi-sofa-single-outline::before {
  content: "\\f156f";
}

.mdi-solar-panel::before {
  content: "\\f0d9b";
}

.mdi-solar-panel-large::before {
  content: "\\f0d9c";
}

.mdi-solar-power::before {
  content: "\\f0a72";
}

.mdi-soldering-iron::before {
  content: "\\f1092";
}

.mdi-solid::before {
  content: "\\f068d";
}

.mdi-sony-playstation::before {
  content: "\\f0414";
}

.mdi-sort::before {
  content: "\\f04ba";
}

.mdi-sort-alphabetical-ascending::before {
  content: "\\f05bd";
}

.mdi-sort-alphabetical-ascending-variant::before {
  content: "\\f1148";
}

.mdi-sort-alphabetical-descending::before {
  content: "\\f05bf";
}

.mdi-sort-alphabetical-descending-variant::before {
  content: "\\f1149";
}

.mdi-sort-alphabetical-variant::before {
  content: "\\f04bb";
}

.mdi-sort-ascending::before {
  content: "\\f04bc";
}

.mdi-sort-bool-ascending::before {
  content: "\\f1385";
}

.mdi-sort-bool-ascending-variant::before {
  content: "\\f1386";
}

.mdi-sort-bool-descending::before {
  content: "\\f1387";
}

.mdi-sort-bool-descending-variant::before {
  content: "\\f1388";
}

.mdi-sort-calendar-ascending::before {
  content: "\\f1547";
}

.mdi-sort-calendar-descending::before {
  content: "\\f1548";
}

.mdi-sort-clock-ascending::before {
  content: "\\f1549";
}

.mdi-sort-clock-ascending-outline::before {
  content: "\\f154a";
}

.mdi-sort-clock-descending::before {
  content: "\\f154b";
}

.mdi-sort-clock-descending-outline::before {
  content: "\\f154c";
}

.mdi-sort-descending::before {
  content: "\\f04bd";
}

.mdi-sort-numeric-ascending::before {
  content: "\\f1389";
}

.mdi-sort-numeric-ascending-variant::before {
  content: "\\f090d";
}

.mdi-sort-numeric-descending::before {
  content: "\\f138a";
}

.mdi-sort-numeric-descending-variant::before {
  content: "\\f0ad2";
}

.mdi-sort-numeric-variant::before {
  content: "\\f04be";
}

.mdi-sort-reverse-variant::before {
  content: "\\f033c";
}

.mdi-sort-variant::before {
  content: "\\f04bf";
}

.mdi-sort-variant-lock::before {
  content: "\\f0ccd";
}

.mdi-sort-variant-lock-open::before {
  content: "\\f0cce";
}

.mdi-sort-variant-remove::before {
  content: "\\f1147";
}

.mdi-soundcloud::before {
  content: "\\f04c0";
}

.mdi-source-branch::before {
  content: "\\f062c";
}

.mdi-source-branch-check::before {
  content: "\\f14cf";
}

.mdi-source-branch-minus::before {
  content: "\\f14cb";
}

.mdi-source-branch-plus::before {
  content: "\\f14ca";
}

.mdi-source-branch-refresh::before {
  content: "\\f14cd";
}

.mdi-source-branch-remove::before {
  content: "\\f14cc";
}

.mdi-source-branch-sync::before {
  content: "\\f14ce";
}

.mdi-source-commit::before {
  content: "\\f0718";
}

.mdi-source-commit-end::before {
  content: "\\f0719";
}

.mdi-source-commit-end-local::before {
  content: "\\f071a";
}

.mdi-source-commit-local::before {
  content: "\\f071b";
}

.mdi-source-commit-next-local::before {
  content: "\\f071c";
}

.mdi-source-commit-start::before {
  content: "\\f071d";
}

.mdi-source-commit-start-next-local::before {
  content: "\\f071e";
}

.mdi-source-fork::before {
  content: "\\f04c1";
}

.mdi-source-merge::before {
  content: "\\f062d";
}

.mdi-source-pull::before {
  content: "\\f04c2";
}

.mdi-source-repository::before {
  content: "\\f0ccf";
}

.mdi-source-repository-multiple::before {
  content: "\\f0cd0";
}

.mdi-soy-sauce::before {
  content: "\\f07ee";
}

.mdi-soy-sauce-off::before {
  content: "\\f13fc";
}

.mdi-spa::before {
  content: "\\f0cd1";
}

.mdi-spa-outline::before {
  content: "\\f0cd2";
}

.mdi-space-invaders::before {
  content: "\\f0bc9";
}

.mdi-space-station::before {
  content: "\\f1383";
}

.mdi-spade::before {
  content: "\\f0e65";
}

.mdi-sparkles::before {
  content: "\\f1545";
}

.mdi-speaker::before {
  content: "\\f04c3";
}

.mdi-speaker-bluetooth::before {
  content: "\\f09a2";
}

.mdi-speaker-multiple::before {
  content: "\\f0d38";
}

.mdi-speaker-off::before {
  content: "\\f04c4";
}

.mdi-speaker-wireless::before {
  content: "\\f071f";
}

.mdi-speedometer::before {
  content: "\\f04c5";
}

.mdi-speedometer-medium::before {
  content: "\\f0f85";
}

.mdi-speedometer-slow::before {
  content: "\\f0f86";
}

.mdi-spellcheck::before {
  content: "\\f04c6";
}

.mdi-spider::before {
  content: "\\f11ea";
}

.mdi-spider-thread::before {
  content: "\\f11eb";
}

.mdi-spider-web::before {
  content: "\\f0bca";
}

.mdi-spirit-level::before {
  content: "\\f14f1";
}

.mdi-spoon-sugar::before {
  content: "\\f1429";
}

.mdi-spotify::before {
  content: "\\f04c7";
}

.mdi-spotlight::before {
  content: "\\f04c8";
}

.mdi-spotlight-beam::before {
  content: "\\f04c9";
}

.mdi-spray::before {
  content: "\\f0665";
}

.mdi-spray-bottle::before {
  content: "\\f0ae0";
}

.mdi-sprinkler::before {
  content: "\\f105f";
}

.mdi-sprinkler-variant::before {
  content: "\\f1060";
}

.mdi-sprout::before {
  content: "\\f0e66";
}

.mdi-sprout-outline::before {
  content: "\\f0e67";
}

.mdi-square::before {
  content: "\\f0764";
}

.mdi-square-circle::before {
  content: "\\f1500";
}

.mdi-square-edit-outline::before {
  content: "\\f090c";
}

.mdi-square-medium::before {
  content: "\\f0a13";
}

.mdi-square-medium-outline::before {
  content: "\\f0a14";
}

.mdi-square-off::before {
  content: "\\f12ee";
}

.mdi-square-off-outline::before {
  content: "\\f12ef";
}

.mdi-square-outline::before {
  content: "\\f0763";
}

.mdi-square-root::before {
  content: "\\f0784";
}

.mdi-square-root-box::before {
  content: "\\f09a3";
}

.mdi-square-rounded::before {
  content: "\\f14fb";
}

.mdi-square-rounded-outline::before {
  content: "\\f14fc";
}

.mdi-square-small::before {
  content: "\\f0a15";
}

.mdi-square-wave::before {
  content: "\\f147b";
}

.mdi-squeegee::before {
  content: "\\f0ae1";
}

.mdi-ssh::before {
  content: "\\f08c0";
}

.mdi-stack-exchange::before {
  content: "\\f060b";
}

.mdi-stack-overflow::before {
  content: "\\f04cc";
}

.mdi-stackpath::before {
  content: "\\f0359";
}

.mdi-stadium::before {
  content: "\\f0ff9";
}

.mdi-stadium-variant::before {
  content: "\\f0720";
}

.mdi-stairs::before {
  content: "\\f04cd";
}

.mdi-stairs-box::before {
  content: "\\f139e";
}

.mdi-stairs-down::before {
  content: "\\f12be";
}

.mdi-stairs-up::before {
  content: "\\f12bd";
}

.mdi-stamper::before {
  content: "\\f0d39";
}

.mdi-standard-definition::before {
  content: "\\f07ef";
}

.mdi-star::before {
  content: "\\f04ce";
}

.mdi-star-box::before {
  content: "\\f0a73";
}

.mdi-star-box-multiple::before {
  content: "\\f1286";
}

.mdi-star-box-multiple-outline::before {
  content: "\\f1287";
}

.mdi-star-box-outline::before {
  content: "\\f0a74";
}

.mdi-star-check::before {
  content: "\\f1566";
}

.mdi-star-check-outline::before {
  content: "\\f156a";
}

.mdi-star-circle::before {
  content: "\\f04cf";
}

.mdi-star-circle-outline::before {
  content: "\\f09a4";
}

.mdi-star-cog::before {
  content: "\\f1668";
}

.mdi-star-cog-outline::before {
  content: "\\f1669";
}

.mdi-star-face::before {
  content: "\\f09a5";
}

.mdi-star-four-points::before {
  content: "\\f0ae2";
}

.mdi-star-four-points-outline::before {
  content: "\\f0ae3";
}

.mdi-star-half::before {
  content: "\\f0246";
}

.mdi-star-half-full::before {
  content: "\\f04d0";
}

.mdi-star-minus::before {
  content: "\\f1564";
}

.mdi-star-minus-outline::before {
  content: "\\f1568";
}

.mdi-star-off::before {
  content: "\\f04d1";
}

.mdi-star-off-outline::before {
  content: "\\f155b";
}

.mdi-star-outline::before {
  content: "\\f04d2";
}

.mdi-star-plus::before {
  content: "\\f1563";
}

.mdi-star-plus-outline::before {
  content: "\\f1567";
}

.mdi-star-remove::before {
  content: "\\f1565";
}

.mdi-star-remove-outline::before {
  content: "\\f1569";
}

.mdi-star-settings::before {
  content: "\\f166a";
}

.mdi-star-settings-outline::before {
  content: "\\f166b";
}

.mdi-star-three-points::before {
  content: "\\f0ae4";
}

.mdi-star-three-points-outline::before {
  content: "\\f0ae5";
}

.mdi-state-machine::before {
  content: "\\f11ef";
}

.mdi-steam::before {
  content: "\\f04d3";
}

.mdi-steering::before {
  content: "\\f04d4";
}

.mdi-steering-off::before {
  content: "\\f090e";
}

.mdi-step-backward::before {
  content: "\\f04d5";
}

.mdi-step-backward-2::before {
  content: "\\f04d6";
}

.mdi-step-forward::before {
  content: "\\f04d7";
}

.mdi-step-forward-2::before {
  content: "\\f04d8";
}

.mdi-stethoscope::before {
  content: "\\f04d9";
}

.mdi-sticker::before {
  content: "\\f1364";
}

.mdi-sticker-alert::before {
  content: "\\f1365";
}

.mdi-sticker-alert-outline::before {
  content: "\\f1366";
}

.mdi-sticker-check::before {
  content: "\\f1367";
}

.mdi-sticker-check-outline::before {
  content: "\\f1368";
}

.mdi-sticker-circle-outline::before {
  content: "\\f05d0";
}

.mdi-sticker-emoji::before {
  content: "\\f0785";
}

.mdi-sticker-minus::before {
  content: "\\f1369";
}

.mdi-sticker-minus-outline::before {
  content: "\\f136a";
}

.mdi-sticker-outline::before {
  content: "\\f136b";
}

.mdi-sticker-plus::before {
  content: "\\f136c";
}

.mdi-sticker-plus-outline::before {
  content: "\\f136d";
}

.mdi-sticker-remove::before {
  content: "\\f136e";
}

.mdi-sticker-remove-outline::before {
  content: "\\f136f";
}

.mdi-stocking::before {
  content: "\\f04da";
}

.mdi-stomach::before {
  content: "\\f1093";
}

.mdi-stop::before {
  content: "\\f04db";
}

.mdi-stop-circle::before {
  content: "\\f0666";
}

.mdi-stop-circle-outline::before {
  content: "\\f0667";
}

.mdi-store::before {
  content: "\\f04dc";
}

.mdi-store-24-hour::before {
  content: "\\f04dd";
}

.mdi-store-minus::before {
  content: "\\f165e";
}

.mdi-store-outline::before {
  content: "\\f1361";
}

.mdi-store-plus::before {
  content: "\\f165f";
}

.mdi-store-remove::before {
  content: "\\f1660";
}

.mdi-storefront::before {
  content: "\\f07c7";
}

.mdi-storefront-outline::before {
  content: "\\f10c1";
}

.mdi-stove::before {
  content: "\\f04de";
}

.mdi-strategy::before {
  content: "\\f11d6";
}

.mdi-stretch-to-page::before {
  content: "\\f0f2b";
}

.mdi-stretch-to-page-outline::before {
  content: "\\f0f2c";
}

.mdi-string-lights::before {
  content: "\\f12ba";
}

.mdi-string-lights-off::before {
  content: "\\f12bb";
}

.mdi-subdirectory-arrow-left::before {
  content: "\\f060c";
}

.mdi-subdirectory-arrow-right::before {
  content: "\\f060d";
}

.mdi-submarine::before {
  content: "\\f156c";
}

.mdi-subtitles::before {
  content: "\\f0a16";
}

.mdi-subtitles-outline::before {
  content: "\\f0a17";
}

.mdi-subway::before {
  content: "\\f06ac";
}

.mdi-subway-alert-variant::before {
  content: "\\f0d9d";
}

.mdi-subway-variant::before {
  content: "\\f04df";
}

.mdi-summit::before {
  content: "\\f0786";
}

.mdi-sunglasses::before {
  content: "\\f04e0";
}

.mdi-surround-sound::before {
  content: "\\f05c5";
}

.mdi-surround-sound-2-0::before {
  content: "\\f07f0";
}

.mdi-surround-sound-3-1::before {
  content: "\\f07f1";
}

.mdi-surround-sound-5-1::before {
  content: "\\f07f2";
}

.mdi-surround-sound-7-1::before {
  content: "\\f07f3";
}

.mdi-svg::before {
  content: "\\f0721";
}

.mdi-swap-horizontal::before {
  content: "\\f04e1";
}

.mdi-swap-horizontal-bold::before {
  content: "\\f0bcd";
}

.mdi-swap-horizontal-circle::before {
  content: "\\f0fe1";
}

.mdi-swap-horizontal-circle-outline::before {
  content: "\\f0fe2";
}

.mdi-swap-horizontal-variant::before {
  content: "\\f08c1";
}

.mdi-swap-vertical::before {
  content: "\\f04e2";
}

.mdi-swap-vertical-bold::before {
  content: "\\f0bce";
}

.mdi-swap-vertical-circle::before {
  content: "\\f0fe3";
}

.mdi-swap-vertical-circle-outline::before {
  content: "\\f0fe4";
}

.mdi-swap-vertical-variant::before {
  content: "\\f08c2";
}

.mdi-swim::before {
  content: "\\f04e3";
}

.mdi-switch::before {
  content: "\\f04e4";
}

.mdi-sword::before {
  content: "\\f04e5";
}

.mdi-sword-cross::before {
  content: "\\f0787";
}

.mdi-syllabary-hangul::before {
  content: "\\f1333";
}

.mdi-syllabary-hiragana::before {
  content: "\\f1334";
}

.mdi-syllabary-katakana::before {
  content: "\\f1335";
}

.mdi-syllabary-katakana-halfwidth::before {
  content: "\\f1336";
}

.mdi-symbol::before {
  content: "\\f1501";
}

.mdi-symfony::before {
  content: "\\f0ae6";
}

.mdi-sync::before {
  content: "\\f04e6";
}

.mdi-sync-alert::before {
  content: "\\f04e7";
}

.mdi-sync-circle::before {
  content: "\\f1378";
}

.mdi-sync-off::before {
  content: "\\f04e8";
}

.mdi-tab::before {
  content: "\\f04e9";
}

.mdi-tab-minus::before {
  content: "\\f0b4b";
}

.mdi-tab-plus::before {
  content: "\\f075c";
}

.mdi-tab-remove::before {
  content: "\\f0b4c";
}

.mdi-tab-unselected::before {
  content: "\\f04ea";
}

.mdi-table::before {
  content: "\\f04eb";
}

.mdi-table-account::before {
  content: "\\f13b9";
}

.mdi-table-alert::before {
  content: "\\f13ba";
}

.mdi-table-arrow-down::before {
  content: "\\f13bb";
}

.mdi-table-arrow-left::before {
  content: "\\f13bc";
}

.mdi-table-arrow-right::before {
  content: "\\f13bd";
}

.mdi-table-arrow-up::before {
  content: "\\f13be";
}

.mdi-table-border::before {
  content: "\\f0a18";
}

.mdi-table-cancel::before {
  content: "\\f13bf";
}

.mdi-table-chair::before {
  content: "\\f1061";
}

.mdi-table-check::before {
  content: "\\f13c0";
}

.mdi-table-clock::before {
  content: "\\f13c1";
}

.mdi-table-cog::before {
  content: "\\f13c2";
}

.mdi-table-column::before {
  content: "\\f0835";
}

.mdi-table-column-plus-after::before {
  content: "\\f04ec";
}

.mdi-table-column-plus-before::before {
  content: "\\f04ed";
}

.mdi-table-column-remove::before {
  content: "\\f04ee";
}

.mdi-table-column-width::before {
  content: "\\f04ef";
}

.mdi-table-edit::before {
  content: "\\f04f0";
}

.mdi-table-eye::before {
  content: "\\f1094";
}

.mdi-table-eye-off::before {
  content: "\\f13c3";
}

.mdi-table-furniture::before {
  content: "\\f05bc";
}

.mdi-table-headers-eye::before {
  content: "\\f121d";
}

.mdi-table-headers-eye-off::before {
  content: "\\f121e";
}

.mdi-table-heart::before {
  content: "\\f13c4";
}

.mdi-table-key::before {
  content: "\\f13c5";
}

.mdi-table-large::before {
  content: "\\f04f1";
}

.mdi-table-large-plus::before {
  content: "\\f0f87";
}

.mdi-table-large-remove::before {
  content: "\\f0f88";
}

.mdi-table-lock::before {
  content: "\\f13c6";
}

.mdi-table-merge-cells::before {
  content: "\\f09a6";
}

.mdi-table-minus::before {
  content: "\\f13c7";
}

.mdi-table-multiple::before {
  content: "\\f13c8";
}

.mdi-table-network::before {
  content: "\\f13c9";
}

.mdi-table-of-contents::before {
  content: "\\f0836";
}

.mdi-table-off::before {
  content: "\\f13ca";
}

.mdi-table-plus::before {
  content: "\\f0a75";
}

.mdi-table-refresh::before {
  content: "\\f13a0";
}

.mdi-table-remove::before {
  content: "\\f0a76";
}

.mdi-table-row::before {
  content: "\\f0837";
}

.mdi-table-row-height::before {
  content: "\\f04f2";
}

.mdi-table-row-plus-after::before {
  content: "\\f04f3";
}

.mdi-table-row-plus-before::before {
  content: "\\f04f4";
}

.mdi-table-row-remove::before {
  content: "\\f04f5";
}

.mdi-table-search::before {
  content: "\\f090f";
}

.mdi-table-settings::before {
  content: "\\f0838";
}

.mdi-table-split-cell::before {
  content: "\\f142a";
}

.mdi-table-star::before {
  content: "\\f13cb";
}

.mdi-table-sync::before {
  content: "\\f13a1";
}

.mdi-table-tennis::before {
  content: "\\f0e68";
}

.mdi-tablet::before {
  content: "\\f04f6";
}

.mdi-tablet-android::before {
  content: "\\f04f7";
}

.mdi-tablet-cellphone::before {
  content: "\\f09a7";
}

.mdi-tablet-dashboard::before {
  content: "\\f0ece";
}

.mdi-tablet-ipad::before {
  content: "\\f04f8";
}

.mdi-taco::before {
  content: "\\f0762";
}

.mdi-tag::before {
  content: "\\f04f9";
}

.mdi-tag-faces::before {
  content: "\\f04fa";
}

.mdi-tag-heart::before {
  content: "\\f068b";
}

.mdi-tag-heart-outline::before {
  content: "\\f0bcf";
}

.mdi-tag-minus::before {
  content: "\\f0910";
}

.mdi-tag-minus-outline::before {
  content: "\\f121f";
}

.mdi-tag-multiple::before {
  content: "\\f04fb";
}

.mdi-tag-multiple-outline::before {
  content: "\\f12f7";
}

.mdi-tag-off::before {
  content: "\\f1220";
}

.mdi-tag-off-outline::before {
  content: "\\f1221";
}

.mdi-tag-outline::before {
  content: "\\f04fc";
}

.mdi-tag-plus::before {
  content: "\\f0722";
}

.mdi-tag-plus-outline::before {
  content: "\\f1222";
}

.mdi-tag-remove::before {
  content: "\\f0723";
}

.mdi-tag-remove-outline::before {
  content: "\\f1223";
}

.mdi-tag-text::before {
  content: "\\f1224";
}

.mdi-tag-text-outline::before {
  content: "\\f04fd";
}

.mdi-tailwind::before {
  content: "\\f13ff";
}

.mdi-tank::before {
  content: "\\f0d3a";
}

.mdi-tanker-truck::before {
  content: "\\f0fe5";
}

.mdi-tape-drive::before {
  content: "\\f16df";
}

.mdi-tape-measure::before {
  content: "\\f0b4d";
}

.mdi-target::before {
  content: "\\f04fe";
}

.mdi-target-account::before {
  content: "\\f0bd0";
}

.mdi-target-variant::before {
  content: "\\f0a77";
}

.mdi-taxi::before {
  content: "\\f04ff";
}

.mdi-tea::before {
  content: "\\f0d9e";
}

.mdi-tea-outline::before {
  content: "\\f0d9f";
}

.mdi-teach::before {
  content: "\\f0890";
}

.mdi-teamviewer::before {
  content: "\\f0500";
}

.mdi-telegram::before {
  content: "\\f0501";
}

.mdi-telescope::before {
  content: "\\f0b4e";
}

.mdi-television::before {
  content: "\\f0502";
}

.mdi-television-ambient-light::before {
  content: "\\f1356";
}

.mdi-television-box::before {
  content: "\\f0839";
}

.mdi-television-classic::before {
  content: "\\f07f4";
}

.mdi-television-classic-off::before {
  content: "\\f083a";
}

.mdi-television-clean::before {
  content: "\\f1110";
}

.mdi-television-guide::before {
  content: "\\f0503";
}

.mdi-television-off::before {
  content: "\\f083b";
}

.mdi-television-pause::before {
  content: "\\f0f89";
}

.mdi-television-play::before {
  content: "\\f0ecf";
}

.mdi-television-stop::before {
  content: "\\f0f8a";
}

.mdi-temperature-celsius::before {
  content: "\\f0504";
}

.mdi-temperature-fahrenheit::before {
  content: "\\f0505";
}

.mdi-temperature-kelvin::before {
  content: "\\f0506";
}

.mdi-tennis::before {
  content: "\\f0da0";
}

.mdi-tennis-ball::before {
  content: "\\f0507";
}

.mdi-tent::before {
  content: "\\f0508";
}

.mdi-terraform::before {
  content: "\\f1062";
}

.mdi-terrain::before {
  content: "\\f0509";
}

.mdi-test-tube::before {
  content: "\\f0668";
}

.mdi-test-tube-empty::before {
  content: "\\f0911";
}

.mdi-test-tube-off::before {
  content: "\\f0912";
}

.mdi-text::before {
  content: "\\f09a8";
}

.mdi-text-account::before {
  content: "\\f1570";
}

.mdi-text-box::before {
  content: "\\f021a";
}

.mdi-text-box-check::before {
  content: "\\f0ea6";
}

.mdi-text-box-check-outline::before {
  content: "\\f0ea7";
}

.mdi-text-box-minus::before {
  content: "\\f0ea8";
}

.mdi-text-box-minus-outline::before {
  content: "\\f0ea9";
}

.mdi-text-box-multiple::before {
  content: "\\f0ab7";
}

.mdi-text-box-multiple-outline::before {
  content: "\\f0ab8";
}

.mdi-text-box-outline::before {
  content: "\\f09ed";
}

.mdi-text-box-plus::before {
  content: "\\f0eaa";
}

.mdi-text-box-plus-outline::before {
  content: "\\f0eab";
}

.mdi-text-box-remove::before {
  content: "\\f0eac";
}

.mdi-text-box-remove-outline::before {
  content: "\\f0ead";
}

.mdi-text-box-search::before {
  content: "\\f0eae";
}

.mdi-text-box-search-outline::before {
  content: "\\f0eaf";
}

.mdi-text-recognition::before {
  content: "\\f113d";
}

.mdi-text-search::before {
  content: "\\f13b8";
}

.mdi-text-shadow::before {
  content: "\\f0669";
}

.mdi-text-short::before {
  content: "\\f09a9";
}

.mdi-text-subject::before {
  content: "\\f09aa";
}

.mdi-text-to-speech::before {
  content: "\\f050a";
}

.mdi-text-to-speech-off::before {
  content: "\\f050b";
}

.mdi-texture::before {
  content: "\\f050c";
}

.mdi-texture-box::before {
  content: "\\f0fe6";
}

.mdi-theater::before {
  content: "\\f050d";
}

.mdi-theme-light-dark::before {
  content: "\\f050e";
}

.mdi-thermometer::before {
  content: "\\f050f";
}

.mdi-thermometer-alert::before {
  content: "\\f0e01";
}

.mdi-thermometer-chevron-down::before {
  content: "\\f0e02";
}

.mdi-thermometer-chevron-up::before {
  content: "\\f0e03";
}

.mdi-thermometer-high::before {
  content: "\\f10c2";
}

.mdi-thermometer-lines::before {
  content: "\\f0510";
}

.mdi-thermometer-low::before {
  content: "\\f10c3";
}

.mdi-thermometer-minus::before {
  content: "\\f0e04";
}

.mdi-thermometer-off::before {
  content: "\\f1531";
}

.mdi-thermometer-plus::before {
  content: "\\f0e05";
}

.mdi-thermostat::before {
  content: "\\f0393";
}

.mdi-thermostat-box::before {
  content: "\\f0891";
}

.mdi-thought-bubble::before {
  content: "\\f07f6";
}

.mdi-thought-bubble-outline::before {
  content: "\\f07f7";
}

.mdi-thumb-down::before {
  content: "\\f0511";
}

.mdi-thumb-down-outline::before {
  content: "\\f0512";
}

.mdi-thumb-up::before {
  content: "\\f0513";
}

.mdi-thumb-up-outline::before {
  content: "\\f0514";
}

.mdi-thumbs-up-down::before {
  content: "\\f0515";
}

.mdi-ticket::before {
  content: "\\f0516";
}

.mdi-ticket-account::before {
  content: "\\f0517";
}

.mdi-ticket-confirmation::before {
  content: "\\f0518";
}

.mdi-ticket-confirmation-outline::before {
  content: "\\f13aa";
}

.mdi-ticket-outline::before {
  content: "\\f0913";
}

.mdi-ticket-percent::before {
  content: "\\f0724";
}

.mdi-ticket-percent-outline::before {
  content: "\\f142b";
}

.mdi-tie::before {
  content: "\\f0519";
}

.mdi-tilde::before {
  content: "\\f0725";
}

.mdi-timelapse::before {
  content: "\\f051a";
}

.mdi-timeline::before {
  content: "\\f0bd1";
}

.mdi-timeline-alert::before {
  content: "\\f0f95";
}

.mdi-timeline-alert-outline::before {
  content: "\\f0f98";
}

.mdi-timeline-check::before {
  content: "\\f1532";
}

.mdi-timeline-check-outline::before {
  content: "\\f1533";
}

.mdi-timeline-clock::before {
  content: "\\f11fb";
}

.mdi-timeline-clock-outline::before {
  content: "\\f11fc";
}

.mdi-timeline-help::before {
  content: "\\f0f99";
}

.mdi-timeline-help-outline::before {
  content: "\\f0f9a";
}

.mdi-timeline-minus::before {
  content: "\\f1534";
}

.mdi-timeline-minus-outline::before {
  content: "\\f1535";
}

.mdi-timeline-outline::before {
  content: "\\f0bd2";
}

.mdi-timeline-plus::before {
  content: "\\f0f96";
}

.mdi-timeline-plus-outline::before {
  content: "\\f0f97";
}

.mdi-timeline-remove::before {
  content: "\\f1536";
}

.mdi-timeline-remove-outline::before {
  content: "\\f1537";
}

.mdi-timeline-text::before {
  content: "\\f0bd3";
}

.mdi-timeline-text-outline::before {
  content: "\\f0bd4";
}

.mdi-timer::before {
  content: "\\f13ab";
}

.mdi-timer-10::before {
  content: "\\f051c";
}

.mdi-timer-3::before {
  content: "\\f051d";
}

.mdi-timer-off::before {
  content: "\\f13ac";
}

.mdi-timer-off-outline::before {
  content: "\\f051e";
}

.mdi-timer-outline::before {
  content: "\\f051b";
}

.mdi-timer-sand::before {
  content: "\\f051f";
}

.mdi-timer-sand-empty::before {
  content: "\\f06ad";
}

.mdi-timer-sand-full::before {
  content: "\\f078c";
}

.mdi-timetable::before {
  content: "\\f0520";
}

.mdi-toaster::before {
  content: "\\f1063";
}

.mdi-toaster-off::before {
  content: "\\f11b7";
}

.mdi-toaster-oven::before {
  content: "\\f0cd3";
}

.mdi-toggle-switch::before {
  content: "\\f0521";
}

.mdi-toggle-switch-off::before {
  content: "\\f0522";
}

.mdi-toggle-switch-off-outline::before {
  content: "\\f0a19";
}

.mdi-toggle-switch-outline::before {
  content: "\\f0a1a";
}

.mdi-toilet::before {
  content: "\\f09ab";
}

.mdi-toolbox::before {
  content: "\\f09ac";
}

.mdi-toolbox-outline::before {
  content: "\\f09ad";
}

.mdi-tools::before {
  content: "\\f1064";
}

.mdi-tooltip::before {
  content: "\\f0523";
}

.mdi-tooltip-account::before {
  content: "\\f000c";
}

.mdi-tooltip-check::before {
  content: "\\f155c";
}

.mdi-tooltip-check-outline::before {
  content: "\\f155d";
}

.mdi-tooltip-edit::before {
  content: "\\f0524";
}

.mdi-tooltip-edit-outline::before {
  content: "\\f12c5";
}

.mdi-tooltip-image::before {
  content: "\\f0525";
}

.mdi-tooltip-image-outline::before {
  content: "\\f0bd5";
}

.mdi-tooltip-minus::before {
  content: "\\f155e";
}

.mdi-tooltip-minus-outline::before {
  content: "\\f155f";
}

.mdi-tooltip-outline::before {
  content: "\\f0526";
}

.mdi-tooltip-plus::before {
  content: "\\f0bd6";
}

.mdi-tooltip-plus-outline::before {
  content: "\\f0527";
}

.mdi-tooltip-remove::before {
  content: "\\f1560";
}

.mdi-tooltip-remove-outline::before {
  content: "\\f1561";
}

.mdi-tooltip-text::before {
  content: "\\f0528";
}

.mdi-tooltip-text-outline::before {
  content: "\\f0bd7";
}

.mdi-tooth::before {
  content: "\\f08c3";
}

.mdi-tooth-outline::before {
  content: "\\f0529";
}

.mdi-toothbrush::before {
  content: "\\f1129";
}

.mdi-toothbrush-electric::before {
  content: "\\f112c";
}

.mdi-toothbrush-paste::before {
  content: "\\f112a";
}

.mdi-torch::before {
  content: "\\f1606";
}

.mdi-tortoise::before {
  content: "\\f0d3b";
}

.mdi-toslink::before {
  content: "\\f12b8";
}

.mdi-tournament::before {
  content: "\\f09ae";
}

.mdi-tow-truck::before {
  content: "\\f083c";
}

.mdi-tower-beach::before {
  content: "\\f0681";
}

.mdi-tower-fire::before {
  content: "\\f0682";
}

.mdi-toy-brick::before {
  content: "\\f1288";
}

.mdi-toy-brick-marker::before {
  content: "\\f1289";
}

.mdi-toy-brick-marker-outline::before {
  content: "\\f128a";
}

.mdi-toy-brick-minus::before {
  content: "\\f128b";
}

.mdi-toy-brick-minus-outline::before {
  content: "\\f128c";
}

.mdi-toy-brick-outline::before {
  content: "\\f128d";
}

.mdi-toy-brick-plus::before {
  content: "\\f128e";
}

.mdi-toy-brick-plus-outline::before {
  content: "\\f128f";
}

.mdi-toy-brick-remove::before {
  content: "\\f1290";
}

.mdi-toy-brick-remove-outline::before {
  content: "\\f1291";
}

.mdi-toy-brick-search::before {
  content: "\\f1292";
}

.mdi-toy-brick-search-outline::before {
  content: "\\f1293";
}

.mdi-track-light::before {
  content: "\\f0914";
}

.mdi-trackpad::before {
  content: "\\f07f8";
}

.mdi-trackpad-lock::before {
  content: "\\f0933";
}

.mdi-tractor::before {
  content: "\\f0892";
}

.mdi-tractor-variant::before {
  content: "\\f14c4";
}

.mdi-trademark::before {
  content: "\\f0a78";
}

.mdi-traffic-cone::before {
  content: "\\f137c";
}

.mdi-traffic-light::before {
  content: "\\f052b";
}

.mdi-train::before {
  content: "\\f052c";
}

.mdi-train-car::before {
  content: "\\f0bd8";
}

.mdi-train-variant::before {
  content: "\\f08c4";
}

.mdi-tram::before {
  content: "\\f052d";
}

.mdi-tram-side::before {
  content: "\\f0fe7";
}

.mdi-transcribe::before {
  content: "\\f052e";
}

.mdi-transcribe-close::before {
  content: "\\f052f";
}

.mdi-transfer::before {
  content: "\\f1065";
}

.mdi-transfer-down::before {
  content: "\\f0da1";
}

.mdi-transfer-left::before {
  content: "\\f0da2";
}

.mdi-transfer-right::before {
  content: "\\f0530";
}

.mdi-transfer-up::before {
  content: "\\f0da3";
}

.mdi-transit-connection::before {
  content: "\\f0d3c";
}

.mdi-transit-connection-horizontal::before {
  content: "\\f1546";
}

.mdi-transit-connection-variant::before {
  content: "\\f0d3d";
}

.mdi-transit-detour::before {
  content: "\\f0f8b";
}

.mdi-transit-skip::before {
  content: "\\f1515";
}

.mdi-transit-transfer::before {
  content: "\\f06ae";
}

.mdi-transition::before {
  content: "\\f0915";
}

.mdi-transition-masked::before {
  content: "\\f0916";
}

.mdi-translate::before {
  content: "\\f05ca";
}

.mdi-translate-off::before {
  content: "\\f0e06";
}

.mdi-transmission-tower::before {
  content: "\\f0d3e";
}

.mdi-trash-can::before {
  content: "\\f0a79";
}

.mdi-trash-can-outline::before {
  content: "\\f0a7a";
}

.mdi-tray::before {
  content: "\\f1294";
}

.mdi-tray-alert::before {
  content: "\\f1295";
}

.mdi-tray-full::before {
  content: "\\f1296";
}

.mdi-tray-minus::before {
  content: "\\f1297";
}

.mdi-tray-plus::before {
  content: "\\f1298";
}

.mdi-tray-remove::before {
  content: "\\f1299";
}

.mdi-treasure-chest::before {
  content: "\\f0726";
}

.mdi-tree::before {
  content: "\\f0531";
}

.mdi-tree-outline::before {
  content: "\\f0e69";
}

.mdi-trello::before {
  content: "\\f0532";
}

.mdi-trending-down::before {
  content: "\\f0533";
}

.mdi-trending-neutral::before {
  content: "\\f0534";
}

.mdi-trending-up::before {
  content: "\\f0535";
}

.mdi-triangle::before {
  content: "\\f0536";
}

.mdi-triangle-outline::before {
  content: "\\f0537";
}

.mdi-triangle-wave::before {
  content: "\\f147c";
}

.mdi-triforce::before {
  content: "\\f0bd9";
}

.mdi-trophy::before {
  content: "\\f0538";
}

.mdi-trophy-award::before {
  content: "\\f0539";
}

.mdi-trophy-broken::before {
  content: "\\f0da4";
}

.mdi-trophy-outline::before {
  content: "\\f053a";
}

.mdi-trophy-variant::before {
  content: "\\f053b";
}

.mdi-trophy-variant-outline::before {
  content: "\\f053c";
}

.mdi-truck::before {
  content: "\\f053d";
}

.mdi-truck-check::before {
  content: "\\f0cd4";
}

.mdi-truck-check-outline::before {
  content: "\\f129a";
}

.mdi-truck-delivery::before {
  content: "\\f053e";
}

.mdi-truck-delivery-outline::before {
  content: "\\f129b";
}

.mdi-truck-fast::before {
  content: "\\f0788";
}

.mdi-truck-fast-outline::before {
  content: "\\f129c";
}

.mdi-truck-outline::before {
  content: "\\f129d";
}

.mdi-truck-trailer::before {
  content: "\\f0727";
}

.mdi-trumpet::before {
  content: "\\f1096";
}

.mdi-tshirt-crew::before {
  content: "\\f0a7b";
}

.mdi-tshirt-crew-outline::before {
  content: "\\f053f";
}

.mdi-tshirt-v::before {
  content: "\\f0a7c";
}

.mdi-tshirt-v-outline::before {
  content: "\\f0540";
}

.mdi-tumble-dryer::before {
  content: "\\f0917";
}

.mdi-tumble-dryer-alert::before {
  content: "\\f11ba";
}

.mdi-tumble-dryer-off::before {
  content: "\\f11bb";
}

.mdi-tune::before {
  content: "\\f062e";
}

.mdi-tune-variant::before {
  content: "\\f1542";
}

.mdi-tune-vertical::before {
  content: "\\f066a";
}

.mdi-tune-vertical-variant::before {
  content: "\\f1543";
}

.mdi-turnstile::before {
  content: "\\f0cd5";
}

.mdi-turnstile-outline::before {
  content: "\\f0cd6";
}

.mdi-turtle::before {
  content: "\\f0cd7";
}

.mdi-twitch::before {
  content: "\\f0543";
}

.mdi-twitter::before {
  content: "\\f0544";
}

.mdi-twitter-retweet::before {
  content: "\\f0547";
}

.mdi-two-factor-authentication::before {
  content: "\\f09af";
}

.mdi-typewriter::before {
  content: "\\f0f2d";
}

.mdi-ubisoft::before {
  content: "\\f0bda";
}

.mdi-ubuntu::before {
  content: "\\f0548";
}

.mdi-ufo::before {
  content: "\\f10c4";
}

.mdi-ufo-outline::before {
  content: "\\f10c5";
}

.mdi-ultra-high-definition::before {
  content: "\\f07f9";
}

.mdi-umbraco::before {
  content: "\\f0549";
}

.mdi-umbrella::before {
  content: "\\f054a";
}

.mdi-umbrella-closed::before {
  content: "\\f09b0";
}

.mdi-umbrella-closed-outline::before {
  content: "\\f13e2";
}

.mdi-umbrella-closed-variant::before {
  content: "\\f13e1";
}

.mdi-umbrella-outline::before {
  content: "\\f054b";
}

.mdi-undo::before {
  content: "\\f054c";
}

.mdi-undo-variant::before {
  content: "\\f054d";
}

.mdi-unfold-less-horizontal::before {
  content: "\\f054e";
}

.mdi-unfold-less-vertical::before {
  content: "\\f0760";
}

.mdi-unfold-more-horizontal::before {
  content: "\\f054f";
}

.mdi-unfold-more-vertical::before {
  content: "\\f0761";
}

.mdi-ungroup::before {
  content: "\\f0550";
}

.mdi-unicode::before {
  content: "\\f0ed0";
}

.mdi-unicorn::before {
  content: "\\f15c2";
}

.mdi-unicorn-variant::before {
  content: "\\f15c3";
}

.mdi-unicycle::before {
  content: "\\f15e5";
}

.mdi-unity::before {
  content: "\\f06af";
}

.mdi-unreal::before {
  content: "\\f09b1";
}

.mdi-untappd::before {
  content: "\\f0551";
}

.mdi-update::before {
  content: "\\f06b0";
}

.mdi-upload::before {
  content: "\\f0552";
}

.mdi-upload-lock::before {
  content: "\\f1373";
}

.mdi-upload-lock-outline::before {
  content: "\\f1374";
}

.mdi-upload-multiple::before {
  content: "\\f083d";
}

.mdi-upload-network::before {
  content: "\\f06f6";
}

.mdi-upload-network-outline::before {
  content: "\\f0cd8";
}

.mdi-upload-off::before {
  content: "\\f10c6";
}

.mdi-upload-off-outline::before {
  content: "\\f10c7";
}

.mdi-upload-outline::before {
  content: "\\f0e07";
}

.mdi-usb::before {
  content: "\\f0553";
}

.mdi-usb-flash-drive::before {
  content: "\\f129e";
}

.mdi-usb-flash-drive-outline::before {
  content: "\\f129f";
}

.mdi-usb-port::before {
  content: "\\f11f0";
}

.mdi-valve::before {
  content: "\\f1066";
}

.mdi-valve-closed::before {
  content: "\\f1067";
}

.mdi-valve-open::before {
  content: "\\f1068";
}

.mdi-van-passenger::before {
  content: "\\f07fa";
}

.mdi-van-utility::before {
  content: "\\f07fb";
}

.mdi-vanish::before {
  content: "\\f07fc";
}

.mdi-vanish-quarter::before {
  content: "\\f1554";
}

.mdi-vanity-light::before {
  content: "\\f11e1";
}

.mdi-variable::before {
  content: "\\f0ae7";
}

.mdi-variable-box::before {
  content: "\\f1111";
}

.mdi-vector-arrange-above::before {
  content: "\\f0554";
}

.mdi-vector-arrange-below::before {
  content: "\\f0555";
}

.mdi-vector-bezier::before {
  content: "\\f0ae8";
}

.mdi-vector-circle::before {
  content: "\\f0556";
}

.mdi-vector-circle-variant::before {
  content: "\\f0557";
}

.mdi-vector-combine::before {
  content: "\\f0558";
}

.mdi-vector-curve::before {
  content: "\\f0559";
}

.mdi-vector-difference::before {
  content: "\\f055a";
}

.mdi-vector-difference-ab::before {
  content: "\\f055b";
}

.mdi-vector-difference-ba::before {
  content: "\\f055c";
}

.mdi-vector-ellipse::before {
  content: "\\f0893";
}

.mdi-vector-intersection::before {
  content: "\\f055d";
}

.mdi-vector-line::before {
  content: "\\f055e";
}

.mdi-vector-link::before {
  content: "\\f0fe8";
}

.mdi-vector-point::before {
  content: "\\f055f";
}

.mdi-vector-polygon::before {
  content: "\\f0560";
}

.mdi-vector-polyline::before {
  content: "\\f0561";
}

.mdi-vector-polyline-edit::before {
  content: "\\f1225";
}

.mdi-vector-polyline-minus::before {
  content: "\\f1226";
}

.mdi-vector-polyline-plus::before {
  content: "\\f1227";
}

.mdi-vector-polyline-remove::before {
  content: "\\f1228";
}

.mdi-vector-radius::before {
  content: "\\f074a";
}

.mdi-vector-rectangle::before {
  content: "\\f05c6";
}

.mdi-vector-selection::before {
  content: "\\f0562";
}

.mdi-vector-square::before {
  content: "\\f0001";
}

.mdi-vector-triangle::before {
  content: "\\f0563";
}

.mdi-vector-union::before {
  content: "\\f0564";
}

.mdi-vhs::before {
  content: "\\f0a1b";
}

.mdi-vibrate::before {
  content: "\\f0566";
}

.mdi-vibrate-off::before {
  content: "\\f0cd9";
}

.mdi-video::before {
  content: "\\f0567";
}

.mdi-video-3d::before {
  content: "\\f07fd";
}

.mdi-video-3d-off::before {
  content: "\\f13d9";
}

.mdi-video-3d-variant::before {
  content: "\\f0ed1";
}

.mdi-video-4k-box::before {
  content: "\\f083e";
}

.mdi-video-account::before {
  content: "\\f0919";
}

.mdi-video-box::before {
  content: "\\f00fd";
}

.mdi-video-box-off::before {
  content: "\\f00fe";
}

.mdi-video-check::before {
  content: "\\f1069";
}

.mdi-video-check-outline::before {
  content: "\\f106a";
}

.mdi-video-high-definition::before {
  content: "\\f152e";
}

.mdi-video-image::before {
  content: "\\f091a";
}

.mdi-video-input-antenna::before {
  content: "\\f083f";
}

.mdi-video-input-component::before {
  content: "\\f0840";
}

.mdi-video-input-hdmi::before {
  content: "\\f0841";
}

.mdi-video-input-scart::before {
  content: "\\f0f8c";
}

.mdi-video-input-svideo::before {
  content: "\\f0842";
}

.mdi-video-minus::before {
  content: "\\f09b2";
}

.mdi-video-minus-outline::before {
  content: "\\f02ba";
}

.mdi-video-off::before {
  content: "\\f0568";
}

.mdi-video-off-outline::before {
  content: "\\f0bdb";
}

.mdi-video-outline::before {
  content: "\\f0bdc";
}

.mdi-video-plus::before {
  content: "\\f09b3";
}

.mdi-video-plus-outline::before {
  content: "\\f01d3";
}

.mdi-video-stabilization::before {
  content: "\\f091b";
}

.mdi-video-switch::before {
  content: "\\f0569";
}

.mdi-video-switch-outline::before {
  content: "\\f0790";
}

.mdi-video-vintage::before {
  content: "\\f0a1c";
}

.mdi-video-wireless::before {
  content: "\\f0ed2";
}

.mdi-video-wireless-outline::before {
  content: "\\f0ed3";
}

.mdi-view-agenda::before {
  content: "\\f056a";
}

.mdi-view-agenda-outline::before {
  content: "\\f11d8";
}

.mdi-view-array::before {
  content: "\\f056b";
}

.mdi-view-array-outline::before {
  content: "\\f1485";
}

.mdi-view-carousel::before {
  content: "\\f056c";
}

.mdi-view-carousel-outline::before {
  content: "\\f1486";
}

.mdi-view-column::before {
  content: "\\f056d";
}

.mdi-view-column-outline::before {
  content: "\\f1487";
}

.mdi-view-comfy::before {
  content: "\\f0e6a";
}

.mdi-view-comfy-outline::before {
  content: "\\f1488";
}

.mdi-view-compact::before {
  content: "\\f0e6b";
}

.mdi-view-compact-outline::before {
  content: "\\f0e6c";
}

.mdi-view-dashboard::before {
  content: "\\f056e";
}

.mdi-view-dashboard-outline::before {
  content: "\\f0a1d";
}

.mdi-view-dashboard-variant::before {
  content: "\\f0843";
}

.mdi-view-dashboard-variant-outline::before {
  content: "\\f1489";
}

.mdi-view-day::before {
  content: "\\f056f";
}

.mdi-view-day-outline::before {
  content: "\\f148a";
}

.mdi-view-grid::before {
  content: "\\f0570";
}

.mdi-view-grid-outline::before {
  content: "\\f11d9";
}

.mdi-view-grid-plus::before {
  content: "\\f0f8d";
}

.mdi-view-grid-plus-outline::before {
  content: "\\f11da";
}

.mdi-view-headline::before {
  content: "\\f0571";
}

.mdi-view-list::before {
  content: "\\f0572";
}

.mdi-view-list-outline::before {
  content: "\\f148b";
}

.mdi-view-module::before {
  content: "\\f0573";
}

.mdi-view-module-outline::before {
  content: "\\f148c";
}

.mdi-view-parallel::before {
  content: "\\f0728";
}

.mdi-view-parallel-outline::before {
  content: "\\f148d";
}

.mdi-view-quilt::before {
  content: "\\f0574";
}

.mdi-view-quilt-outline::before {
  content: "\\f148e";
}

.mdi-view-sequential::before {
  content: "\\f0729";
}

.mdi-view-sequential-outline::before {
  content: "\\f148f";
}

.mdi-view-split-horizontal::before {
  content: "\\f0bcb";
}

.mdi-view-split-vertical::before {
  content: "\\f0bcc";
}

.mdi-view-stream::before {
  content: "\\f0575";
}

.mdi-view-stream-outline::before {
  content: "\\f1490";
}

.mdi-view-week::before {
  content: "\\f0576";
}

.mdi-view-week-outline::before {
  content: "\\f1491";
}

.mdi-vimeo::before {
  content: "\\f0577";
}

.mdi-violin::before {
  content: "\\f060f";
}

.mdi-virtual-reality::before {
  content: "\\f0894";
}

.mdi-virus::before {
  content: "\\f13b6";
}

.mdi-virus-outline::before {
  content: "\\f13b7";
}

.mdi-vk::before {
  content: "\\f0579";
}

.mdi-vlc::before {
  content: "\\f057c";
}

.mdi-voice-off::before {
  content: "\\f0ed4";
}

.mdi-voicemail::before {
  content: "\\f057d";
}

.mdi-volleyball::before {
  content: "\\f09b4";
}

.mdi-volume-high::before {
  content: "\\f057e";
}

.mdi-volume-low::before {
  content: "\\f057f";
}

.mdi-volume-medium::before {
  content: "\\f0580";
}

.mdi-volume-minus::before {
  content: "\\f075e";
}

.mdi-volume-mute::before {
  content: "\\f075f";
}

.mdi-volume-off::before {
  content: "\\f0581";
}

.mdi-volume-plus::before {
  content: "\\f075d";
}

.mdi-volume-source::before {
  content: "\\f1120";
}

.mdi-volume-variant-off::before {
  content: "\\f0e08";
}

.mdi-volume-vibrate::before {
  content: "\\f1121";
}

.mdi-vote::before {
  content: "\\f0a1f";
}

.mdi-vote-outline::before {
  content: "\\f0a20";
}

.mdi-vpn::before {
  content: "\\f0582";
}

.mdi-vuejs::before {
  content: "\\f0844";
}

.mdi-vuetify::before {
  content: "\\f0e6d";
}

.mdi-walk::before {
  content: "\\f0583";
}

.mdi-wall::before {
  content: "\\f07fe";
}

.mdi-wall-sconce::before {
  content: "\\f091c";
}

.mdi-wall-sconce-flat::before {
  content: "\\f091d";
}

.mdi-wall-sconce-flat-variant::before {
  content: "\\f041c";
}

.mdi-wall-sconce-round::before {
  content: "\\f0748";
}

.mdi-wall-sconce-round-variant::before {
  content: "\\f091e";
}

.mdi-wallet::before {
  content: "\\f0584";
}

.mdi-wallet-giftcard::before {
  content: "\\f0585";
}

.mdi-wallet-membership::before {
  content: "\\f0586";
}

.mdi-wallet-outline::before {
  content: "\\f0bdd";
}

.mdi-wallet-plus::before {
  content: "\\f0f8e";
}

.mdi-wallet-plus-outline::before {
  content: "\\f0f8f";
}

.mdi-wallet-travel::before {
  content: "\\f0587";
}

.mdi-wallpaper::before {
  content: "\\f0e09";
}

.mdi-wan::before {
  content: "\\f0588";
}

.mdi-wardrobe::before {
  content: "\\f0f90";
}

.mdi-wardrobe-outline::before {
  content: "\\f0f91";
}

.mdi-warehouse::before {
  content: "\\f0f81";
}

.mdi-washing-machine::before {
  content: "\\f072a";
}

.mdi-washing-machine-alert::before {
  content: "\\f11bc";
}

.mdi-washing-machine-off::before {
  content: "\\f11bd";
}

.mdi-watch::before {
  content: "\\f0589";
}

.mdi-watch-export::before {
  content: "\\f058a";
}

.mdi-watch-export-variant::before {
  content: "\\f0895";
}

.mdi-watch-import::before {
  content: "\\f058b";
}

.mdi-watch-import-variant::before {
  content: "\\f0896";
}

.mdi-watch-variant::before {
  content: "\\f0897";
}

.mdi-watch-vibrate::before {
  content: "\\f06b1";
}

.mdi-watch-vibrate-off::before {
  content: "\\f0cda";
}

.mdi-water::before {
  content: "\\f058c";
}

.mdi-water-alert::before {
  content: "\\f1502";
}

.mdi-water-alert-outline::before {
  content: "\\f1503";
}

.mdi-water-boiler::before {
  content: "\\f0f92";
}

.mdi-water-boiler-alert::before {
  content: "\\f11b3";
}

.mdi-water-boiler-off::before {
  content: "\\f11b4";
}

.mdi-water-check::before {
  content: "\\f1504";
}

.mdi-water-check-outline::before {
  content: "\\f1505";
}

.mdi-water-minus::before {
  content: "\\f1506";
}

.mdi-water-minus-outline::before {
  content: "\\f1507";
}

.mdi-water-off::before {
  content: "\\f058d";
}

.mdi-water-off-outline::before {
  content: "\\f1508";
}

.mdi-water-outline::before {
  content: "\\f0e0a";
}

.mdi-water-percent::before {
  content: "\\f058e";
}

.mdi-water-percent-alert::before {
  content: "\\f1509";
}

.mdi-water-plus::before {
  content: "\\f150a";
}

.mdi-water-plus-outline::before {
  content: "\\f150b";
}

.mdi-water-polo::before {
  content: "\\f12a0";
}

.mdi-water-pump::before {
  content: "\\f058f";
}

.mdi-water-pump-off::before {
  content: "\\f0f93";
}

.mdi-water-remove::before {
  content: "\\f150c";
}

.mdi-water-remove-outline::before {
  content: "\\f150d";
}

.mdi-water-well::before {
  content: "\\f106b";
}

.mdi-water-well-outline::before {
  content: "\\f106c";
}

.mdi-watering-can::before {
  content: "\\f1481";
}

.mdi-watering-can-outline::before {
  content: "\\f1482";
}

.mdi-watermark::before {
  content: "\\f0612";
}

.mdi-wave::before {
  content: "\\f0f2e";
}

.mdi-waveform::before {
  content: "\\f147d";
}

.mdi-waves::before {
  content: "\\f078d";
}

.mdi-waze::before {
  content: "\\f0bde";
}

.mdi-weather-cloudy::before {
  content: "\\f0590";
}

.mdi-weather-cloudy-alert::before {
  content: "\\f0f2f";
}

.mdi-weather-cloudy-arrow-right::before {
  content: "\\f0e6e";
}

.mdi-weather-fog::before {
  content: "\\f0591";
}

.mdi-weather-hail::before {
  content: "\\f0592";
}

.mdi-weather-hazy::before {
  content: "\\f0f30";
}

.mdi-weather-hurricane::before {
  content: "\\f0898";
}

.mdi-weather-lightning::before {
  content: "\\f0593";
}

.mdi-weather-lightning-rainy::before {
  content: "\\f067e";
}

.mdi-weather-night::before {
  content: "\\f0594";
}

.mdi-weather-night-partly-cloudy::before {
  content: "\\f0f31";
}

.mdi-weather-partly-cloudy::before {
  content: "\\f0595";
}

.mdi-weather-partly-lightning::before {
  content: "\\f0f32";
}

.mdi-weather-partly-rainy::before {
  content: "\\f0f33";
}

.mdi-weather-partly-snowy::before {
  content: "\\f0f34";
}

.mdi-weather-partly-snowy-rainy::before {
  content: "\\f0f35";
}

.mdi-weather-pouring::before {
  content: "\\f0596";
}

.mdi-weather-rainy::before {
  content: "\\f0597";
}

.mdi-weather-snowy::before {
  content: "\\f0598";
}

.mdi-weather-snowy-heavy::before {
  content: "\\f0f36";
}

.mdi-weather-snowy-rainy::before {
  content: "\\f067f";
}

.mdi-weather-sunny::before {
  content: "\\f0599";
}

.mdi-weather-sunny-alert::before {
  content: "\\f0f37";
}

.mdi-weather-sunny-off::before {
  content: "\\f14e4";
}

.mdi-weather-sunset::before {
  content: "\\f059a";
}

.mdi-weather-sunset-down::before {
  content: "\\f059b";
}

.mdi-weather-sunset-up::before {
  content: "\\f059c";
}

.mdi-weather-tornado::before {
  content: "\\f0f38";
}

.mdi-weather-windy::before {
  content: "\\f059d";
}

.mdi-weather-windy-variant::before {
  content: "\\f059e";
}

.mdi-web::before {
  content: "\\f059f";
}

.mdi-web-box::before {
  content: "\\f0f94";
}

.mdi-web-clock::before {
  content: "\\f124a";
}

.mdi-webcam::before {
  content: "\\f05a0";
}

.mdi-webhook::before {
  content: "\\f062f";
}

.mdi-webpack::before {
  content: "\\f072b";
}

.mdi-webrtc::before {
  content: "\\f1248";
}

.mdi-wechat::before {
  content: "\\f0611";
}

.mdi-weight::before {
  content: "\\f05a1";
}

.mdi-weight-gram::before {
  content: "\\f0d3f";
}

.mdi-weight-kilogram::before {
  content: "\\f05a2";
}

.mdi-weight-lifter::before {
  content: "\\f115d";
}

.mdi-weight-pound::before {
  content: "\\f09b5";
}

.mdi-whatsapp::before {
  content: "\\f05a3";
}

.mdi-wheel-barrow::before {
  content: "\\f14f2";
}

.mdi-wheelchair-accessibility::before {
  content: "\\f05a4";
}

.mdi-whistle::before {
  content: "\\f09b6";
}

.mdi-whistle-outline::before {
  content: "\\f12bc";
}

.mdi-white-balance-auto::before {
  content: "\\f05a5";
}

.mdi-white-balance-incandescent::before {
  content: "\\f05a6";
}

.mdi-white-balance-iridescent::before {
  content: "\\f05a7";
}

.mdi-white-balance-sunny::before {
  content: "\\f05a8";
}

.mdi-widgets::before {
  content: "\\f072c";
}

.mdi-widgets-outline::before {
  content: "\\f1355";
}

.mdi-wifi::before {
  content: "\\f05a9";
}

.mdi-wifi-alert::before {
  content: "\\f16b5";
}

.mdi-wifi-arrow-down::before {
  content: "\\f16b6";
}

.mdi-wifi-arrow-left::before {
  content: "\\f16b7";
}

.mdi-wifi-arrow-left-right::before {
  content: "\\f16b8";
}

.mdi-wifi-arrow-right::before {
  content: "\\f16b9";
}

.mdi-wifi-arrow-up::before {
  content: "\\f16ba";
}

.mdi-wifi-arrow-up-down::before {
  content: "\\f16bb";
}

.mdi-wifi-cancel::before {
  content: "\\f16bc";
}

.mdi-wifi-check::before {
  content: "\\f16bd";
}

.mdi-wifi-cog::before {
  content: "\\f16be";
}

.mdi-wifi-lock::before {
  content: "\\f16bf";
}

.mdi-wifi-lock-open::before {
  content: "\\f16c0";
}

.mdi-wifi-marker::before {
  content: "\\f16c1";
}

.mdi-wifi-minus::before {
  content: "\\f16c2";
}

.mdi-wifi-off::before {
  content: "\\f05aa";
}

.mdi-wifi-plus::before {
  content: "\\f16c3";
}

.mdi-wifi-refresh::before {
  content: "\\f16c4";
}

.mdi-wifi-remove::before {
  content: "\\f16c5";
}

.mdi-wifi-settings::before {
  content: "\\f16c6";
}

.mdi-wifi-star::before {
  content: "\\f0e0b";
}

.mdi-wifi-strength-1::before {
  content: "\\f091f";
}

.mdi-wifi-strength-1-alert::before {
  content: "\\f0920";
}

.mdi-wifi-strength-1-lock::before {
  content: "\\f0921";
}

.mdi-wifi-strength-1-lock-open::before {
  content: "\\f16cb";
}

.mdi-wifi-strength-2::before {
  content: "\\f0922";
}

.mdi-wifi-strength-2-alert::before {
  content: "\\f0923";
}

.mdi-wifi-strength-2-lock::before {
  content: "\\f0924";
}

.mdi-wifi-strength-2-lock-open::before {
  content: "\\f16cc";
}

.mdi-wifi-strength-3::before {
  content: "\\f0925";
}

.mdi-wifi-strength-3-alert::before {
  content: "\\f0926";
}

.mdi-wifi-strength-3-lock::before {
  content: "\\f0927";
}

.mdi-wifi-strength-3-lock-open::before {
  content: "\\f16cd";
}

.mdi-wifi-strength-4::before {
  content: "\\f0928";
}

.mdi-wifi-strength-4-alert::before {
  content: "\\f0929";
}

.mdi-wifi-strength-4-lock::before {
  content: "\\f092a";
}

.mdi-wifi-strength-4-lock-open::before {
  content: "\\f16ce";
}

.mdi-wifi-strength-alert-outline::before {
  content: "\\f092b";
}

.mdi-wifi-strength-lock-open-outline::before {
  content: "\\f16cf";
}

.mdi-wifi-strength-lock-outline::before {
  content: "\\f092c";
}

.mdi-wifi-strength-off::before {
  content: "\\f092d";
}

.mdi-wifi-strength-off-outline::before {
  content: "\\f092e";
}

.mdi-wifi-strength-outline::before {
  content: "\\f092f";
}

.mdi-wifi-sync::before {
  content: "\\f16c7";
}

.mdi-wikipedia::before {
  content: "\\f05ac";
}

.mdi-wind-turbine::before {
  content: "\\f0da5";
}

.mdi-window-close::before {
  content: "\\f05ad";
}

.mdi-window-closed::before {
  content: "\\f05ae";
}

.mdi-window-closed-variant::before {
  content: "\\f11db";
}

.mdi-window-maximize::before {
  content: "\\f05af";
}

.mdi-window-minimize::before {
  content: "\\f05b0";
}

.mdi-window-open::before {
  content: "\\f05b1";
}

.mdi-window-open-variant::before {
  content: "\\f11dc";
}

.mdi-window-restore::before {
  content: "\\f05b2";
}

.mdi-window-shutter::before {
  content: "\\f111c";
}

.mdi-window-shutter-alert::before {
  content: "\\f111d";
}

.mdi-window-shutter-open::before {
  content: "\\f111e";
}

.mdi-windsock::before {
  content: "\\f15fa";
}

.mdi-wiper::before {
  content: "\\f0ae9";
}

.mdi-wiper-wash::before {
  content: "\\f0da6";
}

.mdi-wizard-hat::before {
  content: "\\f1477";
}

.mdi-wordpress::before {
  content: "\\f05b4";
}

.mdi-wrap::before {
  content: "\\f05b6";
}

.mdi-wrap-disabled::before {
  content: "\\f0bdf";
}

.mdi-wrench::before {
  content: "\\f05b7";
}

.mdi-wrench-outline::before {
  content: "\\f0be0";
}

.mdi-xamarin::before {
  content: "\\f0845";
}

.mdi-xamarin-outline::before {
  content: "\\f0846";
}

.mdi-xing::before {
  content: "\\f05be";
}

.mdi-xml::before {
  content: "\\f05c0";
}

.mdi-xmpp::before {
  content: "\\f07ff";
}

.mdi-y-combinator::before {
  content: "\\f0624";
}

.mdi-yahoo::before {
  content: "\\f0b4f";
}

.mdi-yeast::before {
  content: "\\f05c1";
}

.mdi-yin-yang::before {
  content: "\\f0680";
}

.mdi-yoga::before {
  content: "\\f117c";
}

.mdi-youtube::before {
  content: "\\f05c3";
}

.mdi-youtube-gaming::before {
  content: "\\f0848";
}

.mdi-youtube-studio::before {
  content: "\\f0847";
}

.mdi-youtube-subscription::before {
  content: "\\f0d40";
}

.mdi-youtube-tv::before {
  content: "\\f0448";
}

.mdi-yurt::before {
  content: "\\f1516";
}

.mdi-z-wave::before {
  content: "\\f0aea";
}

.mdi-zend::before {
  content: "\\f0aeb";
}

.mdi-zigbee::before {
  content: "\\f0d41";
}

.mdi-zip-box::before {
  content: "\\f05c4";
}

.mdi-zip-box-outline::before {
  content: "\\f0ffa";
}

.mdi-zip-disk::before {
  content: "\\f0a23";
}

.mdi-zodiac-aquarius::before {
  content: "\\f0a7d";
}

.mdi-zodiac-aries::before {
  content: "\\f0a7e";
}

.mdi-zodiac-cancer::before {
  content: "\\f0a7f";
}

.mdi-zodiac-capricorn::before {
  content: "\\f0a80";
}

.mdi-zodiac-gemini::before {
  content: "\\f0a81";
}

.mdi-zodiac-leo::before {
  content: "\\f0a82";
}

.mdi-zodiac-libra::before {
  content: "\\f0a83";
}

.mdi-zodiac-pisces::before {
  content: "\\f0a84";
}

.mdi-zodiac-sagittarius::before {
  content: "\\f0a85";
}

.mdi-zodiac-scorpio::before {
  content: "\\f0a86";
}

.mdi-zodiac-taurus::before {
  content: "\\f0a87";
}

.mdi-zodiac-virgo::before {
  content: "\\f0a88";
}

.mdi-blank::before {
  content: "\\f68c";
  visibility: hidden;
}

.mdi-18px.mdi-set,
.mdi-18px.mdi:before {
  font-size: 18px;
}

.mdi-24px.mdi-set,
.mdi-24px.mdi:before {
  font-size: 24px;
}

.mdi-36px.mdi-set,
.mdi-36px.mdi:before {
  font-size: 36px;
}

.mdi-48px.mdi-set,
.mdi-48px.mdi:before {
  font-size: 48px;
}

.mdi-dark:before {
  color: rgba(0, 0, 0, 0.54);
}

.mdi-dark.mdi-inactive:before {
  color: rgba(0, 0, 0, 0.26);
}

.mdi-light:before {
  color: white;
}

.mdi-light.mdi-inactive:before {
  color: rgba(255, 255, 255, 0.3);
}

.mdi-rotate-45 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(45deg);
            transform: scaleX(-1) rotate(45deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(45deg);
            -ms-transform: rotate(45deg);
            transform: scaleY(-1) rotate(45deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-45:before {
  transform: rotate(45deg);
}

.mdi-rotate-90 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(90deg);
            transform: scaleX(-1) rotate(90deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(90deg);
            -ms-transform: rotate(90deg);
            transform: scaleY(-1) rotate(90deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-90:before {
  transform: rotate(90deg);
}

.mdi-rotate-135 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(135deg);
            transform: scaleX(-1) rotate(135deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(135deg);
            -ms-transform: rotate(135deg);
            transform: scaleY(-1) rotate(135deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-135:before {
  transform: rotate(135deg);
}

.mdi-rotate-180 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(180deg);
            transform: scaleX(-1) rotate(180deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(180deg);
            -ms-transform: rotate(180deg);
            transform: scaleY(-1) rotate(180deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-180:before {
  transform: rotate(180deg);
}

.mdi-rotate-225 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(225deg);
            transform: scaleX(-1) rotate(225deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(225deg);
            -ms-transform: rotate(225deg);
            transform: scaleY(-1) rotate(225deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-225:before {
  transform: rotate(225deg);
}

.mdi-rotate-270 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(270deg);
            transform: scaleX(-1) rotate(270deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(270deg);
            -ms-transform: rotate(270deg);
            transform: scaleY(-1) rotate(270deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-270:before {
  transform: rotate(270deg);
}

.mdi-rotate-315 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(315deg);
            transform: scaleX(-1) rotate(315deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(315deg);
            -ms-transform: rotate(315deg);
            transform: scaleY(-1) rotate(315deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-315:before {
  transform: rotate(315deg);
}

.mdi-flip-h:before {
  transform: scaleX(-1);
  filter: FlipH;
  -ms-filter: "FlipH";
}

.mdi-flip-v:before {
  transform: scaleY(-1);
  filter: FlipV;
  -ms-filter: "FlipV";
}

.mdi-spin:before {
  animation: mdi-spin 2s infinite linear;
}
@keyframes mdi-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}

@font-face {
  font-family: "boxicons";
  font-weight: normal;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("svg");
}
.bx {
  font-family: "boxicons" !important;
  font-weight: normal;
  font-style: normal;
  font-variant: normal;
  line-height: 1;
  display: inline-block;
  text-transform: none;
  speak: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.bx-ul {
  margin-left: 2em;
  padding-left: 0;
  list-style: none;
}

.bx-ul > li {
  position: relative;
}

.bx-ul .bx {
  font-size: inherit;
  line-height: inherit;
  position: absolute;
  left: -2em;
  width: 2em;
  text-align: center;
}
@keyframes spin {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(359deg);
  }
}
@keyframes burst {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  90% {
    transform: scale(1.5);
    opacity: 0;
  }
}
@keyframes flashing {
  0% {
    opacity: 1;
  }
  45% {
    opacity: 0;
  }
  90% {
    opacity: 1;
  }
}
@keyframes fade-left {
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  75% {
    transform: translateX(-20px);
    opacity: 0;
  }
}
@keyframes fade-right {
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  75% {
    transform: translateX(20px);
    opacity: 0;
  }
}
@keyframes fade-up {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  75% {
    transform: translateY(-20px);
    opacity: 0;
  }
}
@keyframes fade-down {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  75% {
    transform: translateY(20px);
    opacity: 0;
  }
}
@keyframes tada {
  from {
    transform: scale3d(1, 1, 1);
  }
  10%, 20% {
    transform: scale3d(0.95, 0.95, 0.95) rotate3d(0, 0, 1, -10deg);
  }
  30%, 50%, 70%, 90% {
    transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);
  }
  40%, 60%, 80% {
    transform: rotate3d(0, 0, 1, -10deg);
  }
  to {
    transform: scale3d(1, 1, 1);
  }
}
.bx-spin {
  animation: spin 2s linear infinite;
}

.bx-spin-hover:hover {
  animation: spin 2s linear infinite;
}

.bx-tada {
  animation: tada 1.5s ease infinite;
}

.bx-tada-hover:hover {
  animation: tada 1.5s ease infinite;
}

.bx-flashing {
  animation: flashing 1.5s infinite linear;
}

.bx-flashing-hover:hover {
  animation: flashing 1.5s infinite linear;
}

.bx-burst {
  animation: burst 1.5s infinite linear;
}

.bx-burst-hover:hover {
  animation: burst 1.5s infinite linear;
}

.bx-fade-up {
  animation: fade-up 1.5s infinite linear;
}

.bx-fade-up-hover:hover {
  animation: fade-up 1.5s infinite linear;
}

.bx-fade-down {
  animation: fade-down 1.5s infinite linear;
}

.bx-fade-down-hover:hover {
  animation: fade-down 1.5s infinite linear;
}

.bx-fade-left {
  animation: fade-left 1.5s infinite linear;
}

.bx-fade-left-hover:hover {
  animation: fade-left 1.5s infinite linear;
}

.bx-fade-right {
  animation: fade-right 1.5s infinite linear;
}

.bx-fade-right-hover:hover {
  animation: fade-right 1.5s infinite linear;
}

.bx-xs {
  font-size: 1rem !important;
}

.bx-sm {
  font-size: 1.55rem !important;
}

.bx-md {
  font-size: 2.25rem !important;
}

.bx-fw {
  font-size: 1.2857142857em;
  line-height: 0.8em;
  width: 1.2857142857em;
  height: 0.8em;
  margin-top: -0.2em !important;
  vertical-align: middle;
}

.bx-lg {
  font-size: 3rem !important;
}

.bx-pull-left {
  float: left;
  margin-right: 0.3em !important;
}

.bx-pull-right {
  float: right;
  margin-left: 0.3em !important;
}

.bx-rotate-90 {
  transform: rotate(90deg);
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";
}

.bx-rotate-180 {
  transform: rotate(180deg);
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";
}

.bx-rotate-270 {
  transform: rotate(270deg);
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";
}

.bx-flip-horizontal {
  transform: scaleX(-1);
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";
}

.bx-flip-vertical {
  transform: scaleY(-1);
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
}

.bx-border {
  padding: 0.25em;
  border: 0.07em solid rgba(0, 0, 0, 0.1);
  border-radius: 0.25em;
}

.bx-border-circle {
  padding: 0.25em;
  border: 0.07em solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
}

.bxl-adobe:before {
  content: "\\e900";
}

.bxl-algolia:before {
  content: "\\e901";
}

.bxl-audible:before {
  content: "\\e902";
}

.bxl-figma:before {
  content: "\\e903";
}

.bxl-redbubble:before {
  content: "\\e904";
}

.bxl-etsy:before {
  content: "\\e905";
}

.bxl-gitlab:before {
  content: "\\e906";
}

.bxl-patreon:before {
  content: "\\e907";
}

.bxl-facebook-circle:before {
  content: "\\e908";
}

.bxl-imdb:before {
  content: "\\e909";
}

.bxl-jquery:before {
  content: "\\e90a";
}

.bxl-pinterest-alt:before {
  content: "\\e90b";
}

.bxl-500px:before {
  content: "\\e90c";
}

.bxl-airbnb:before {
  content: "\\e90d";
}

.bxl-amazon:before {
  content: "\\e90e";
}

.bxl-android:before {
  content: "\\e90f";
}

.bxl-angular:before {
  content: "\\e910";
}

.bxl-apple:before {
  content: "\\e911";
}

.bxl-baidu:before {
  content: "\\e912";
}

.bxl-behance:before {
  content: "\\e913";
}

.bxl-bing:before {
  content: "\\e914";
}

.bxl-bitcoin:before {
  content: "\\e915";
}

.bxl-blogger:before {
  content: "\\e916";
}

.bxl-bootstrap:before {
  content: "\\e917";
}

.bxl-chrome:before {
  content: "\\e918";
}

.bxl-codepen:before {
  content: "\\e919";
}

.bxl-creative-commons:before {
  content: "\\e91a";
}

.bxl-css3:before {
  content: "\\e91b";
}

.bxl-dailymotion:before {
  content: "\\e91c";
}

.bxl-deviantart:before {
  content: "\\e91d";
}

.bxl-digg:before {
  content: "\\e91e";
}

.bxl-digitalocean:before {
  content: "\\e91f";
}

.bxl-discord:before {
  content: "\\e920";
}

.bxl-discourse:before {
  content: "\\e921";
}

.bxl-dribbble:before {
  content: "\\e922";
}

.bxl-dropbox:before {
  content: "\\e923";
}

.bxl-drupal:before {
  content: "\\e924";
}

.bxl-ebay:before {
  content: "\\e925";
}

.bxl-edge:before {
  content: "\\e926";
}

.bxl-facebook:before {
  content: "\\e927";
}

.bxl-facebook-square:before {
  content: "\\e928";
}

.bxl-firefox:before {
  content: "\\e929";
}

.bxl-flickr:before {
  content: "\\e92a";
}

.bxl-flickr-square:before {
  content: "\\e92b";
}

.bxl-foursquare:before {
  content: "\\e92c";
}

.bxl-git:before {
  content: "\\e92d";
}

.bxl-github:before {
  content: "\\e92e";
}

.bxl-google:before {
  content: "\\e92f";
}

.bxl-google-plus:before {
  content: "\\e930";
}

.bxl-google-plus-circle:before {
  content: "\\e931";
}

.bxl-html5:before {
  content: "\\e932";
}

.bxl-instagram:before {
  content: "\\e933";
}

.bxl-instagram-alt:before {
  content: "\\e934";
}

.bxl-internet-explorer:before {
  content: "\\e935";
}

.bxl-invision:before {
  content: "\\e936";
}

.bxl-javascript:before {
  content: "\\e937";
}

.bxl-joomla:before {
  content: "\\e938";
}

.bxl-jsfiddle:before {
  content: "\\e939";
}

.bxl-kickstarter:before {
  content: "\\e93a";
}

.bxl-less:before {
  content: "\\e93b";
}

.bxl-linkedin:before {
  content: "\\e93c";
}

.bxl-linkedin-square:before {
  content: "\\e93d";
}

.bxl-magento:before {
  content: "\\e93e";
}

.bxl-mailchimp:before {
  content: "\\e93f";
}

.bxl-mastercard:before {
  content: "\\e940";
}

.bxl-medium:before {
  content: "\\e941";
}

.bxl-medium-old:before {
  content: "\\e942";
}

.bxl-medium-square:before {
  content: "\\e943";
}

.bxl-messenger:before {
  content: "\\e944";
}

.bxl-microsoft:before {
  content: "\\e945";
}

.bxl-nodejs:before {
  content: "\\e946";
}

.bxl-opera:before {
  content: "\\e947";
}

.bxl-paypal:before {
  content: "\\e948";
}

.bxl-periscope:before {
  content: "\\e949";
}

.bxl-pinterest:before {
  content: "\\e94a";
}

.bxl-play-store:before {
  content: "\\e94b";
}

.bxl-pocket:before {
  content: "\\e94c";
}

.bxl-product-hunt:before {
  content: "\\e94d";
}

.bxl-quora:before {
  content: "\\e94e";
}

.bxl-react:before {
  content: "\\e94f";
}

.bxl-reddit:before {
  content: "\\e950";
}

.bxl-redux:before {
  content: "\\e951";
}

.bxl-sass:before {
  content: "\\e952";
}

.bxl-shopify:before {
  content: "\\e953";
}

.bxl-skype:before {
  content: "\\e954";
}

.bxl-slack:before {
  content: "\\e955";
}

.bxl-slack-old:before {
  content: "\\e956";
}

.bxl-snapchat:before {
  content: "\\e957";
}

.bxl-soundcloud:before {
  content: "\\e958";
}

.bxl-spotify:before {
  content: "\\e959";
}

.bxl-squarespace:before {
  content: "\\e95a";
}

.bxl-stack-overflow:before {
  content: "\\e95b";
}

.bxl-stripe:before {
  content: "\\e95c";
}

.bxl-telegram:before {
  content: "\\e95d";
}

.bxl-trello:before {
  content: "\\e95e";
}

.bxl-tumblr:before {
  content: "\\e95f";
}

.bxl-twitch:before {
  content: "\\e960";
}

.bxl-twitter:before {
  content: "\\e961";
}

.bxl-unsplash:before {
  content: "\\e962";
}

.bxl-vimeo:before {
  content: "\\e963";
}

.bxl-visa:before {
  content: "\\e964";
}

.bxl-vk:before {
  content: "\\e965";
}

.bxl-vuejs:before {
  content: "\\e966";
}

.bxl-whatsapp:before {
  content: "\\e967";
}

.bxl-whatsapp-square:before {
  content: "\\e968";
}

.bxl-wikipedia:before {
  content: "\\e969";
}

.bxl-windows:before {
  content: "\\e96a";
}

.bxl-wix:before {
  content: "\\e96b";
}

.bxl-wordpress:before {
  content: "\\e96c";
}

.bxl-yahoo:before {
  content: "\\e96d";
}

.bxl-yelp:before {
  content: "\\e96e";
}

.bxl-youtube:before {
  content: "\\e96f";
}

.bx-accessibility:before {
  content: "\\e970";
}

.bx-add-to-queue:before {
  content: "\\e971";
}

.bx-adjust:before {
  content: "\\e972";
}

.bx-alarm:before {
  content: "\\e973";
}

.bx-alarm-add:before {
  content: "\\e974";
}

.bx-alarm-off:before {
  content: "\\e975";
}

.bx-album:before {
  content: "\\e976";
}

.bx-align-justify:before {
  content: "\\e977";
}

.bx-align-left:before {
  content: "\\e978";
}

.bx-align-middle:before {
  content: "\\e979";
}

.bx-align-right:before {
  content: "\\e97a";
}

.bx-analyse:before {
  content: "\\e97b";
}

.bx-anchor:before {
  content: "\\e97c";
}

.bx-angry:before {
  content: "\\e97d";
}

.bx-aperture:before {
  content: "\\e97e";
}

.bx-archive:before {
  content: "\\e97f";
}

.bx-archive-in:before {
  content: "\\e980";
}

.bx-archive-out:before {
  content: "\\e981";
}

.bx-area:before {
  content: "\\e982";
}

.bx-arrow-back:before {
  content: "\\e983";
}

.bx-at:before {
  content: "\\e984";
}

.bx-award:before {
  content: "\\e985";
}

.bx-badge:before {
  content: "\\e986";
}

.bx-badge-check:before {
  content: "\\e987";
}

.bx-ball:before {
  content: "\\e988";
}

.bx-band-aid:before {
  content: "\\e989";
}

.bx-bar-chart:before {
  content: "\\e98a";
}

.bx-bar-chart-alt:before {
  content: "\\e98b";
}

.bx-bar-chart-alt-2:before {
  content: "\\e98c";
}

.bx-bar-chart-square:before {
  content: "\\e98d";
}

.bx-barcode:before {
  content: "\\e98e";
}

.bx-basket:before {
  content: "\\e98f";
}

.bx-basketball:before {
  content: "\\e990";
}

.bx-bath:before {
  content: "\\e991";
}

.bx-battery:before {
  content: "\\e992";
}

.bx-bed:before {
  content: "\\e993";
}

.bx-bell:before {
  content: "\\e994";
}

.bx-bell-minus:before {
  content: "\\e995";
}

.bx-bell-off:before {
  content: "\\e996";
}

.bx-bell-plus:before {
  content: "\\e997";
}

.bx-bitcoin:before {
  content: "\\e998";
}

.bx-block:before {
  content: "\\e999";
}

.bx-bluetooth:before {
  content: "\\e99a";
}

.bx-body:before {
  content: "\\e99b";
}

.bx-bold:before {
  content: "\\e99c";
}

.bx-bolt-circle:before {
  content: "\\e99d";
}

.bx-book:before {
  content: "\\e99e";
}

.bx-book-bookmark:before {
  content: "\\e99f";
}

.bx-book-content:before {
  content: "\\e9a0";
}

.bx-bookmark:before {
  content: "\\e9a1";
}

.bx-bookmark-minus:before {
  content: "\\e9a2";
}

.bx-bookmark-plus:before {
  content: "\\e9a3";
}

.bx-bookmarks:before {
  content: "\\e9a4";
}

.bx-book-open:before {
  content: "\\e9a5";
}

.bx-border-all:before {
  content: "\\e9a6";
}

.bx-border-bottom:before {
  content: "\\e9a7";
}

.bx-border-left:before {
  content: "\\e9a8";
}

.bx-border-radius:before {
  content: "\\e9a9";
}

.bx-border-right:before {
  content: "\\e9aa";
}

.bx-border-top:before {
  content: "\\e9ab";
}

.bx-bot:before {
  content: "\\e9ac";
}

.bx-bowling-ball:before {
  content: "\\e9ad";
}

.bx-box:before {
  content: "\\e9ae";
}

.bx-briefcase:before {
  content: "\\e9af";
}

.bx-briefcase-alt:before {
  content: "\\e9b0";
}

.bx-briefcase-alt-2:before {
  content: "\\e9b1";
}

.bx-brightness:before {
  content: "\\e9b2";
}

.bx-brightness-half:before {
  content: "\\e9b3";
}

.bx-broadcast:before {
  content: "\\e9b4";
}

.bx-brush:before {
  content: "\\e9b5";
}

.bx-brush-alt:before {
  content: "\\e9b6";
}

.bx-bug:before {
  content: "\\e9b7";
}

.bx-bug-alt:before {
  content: "\\e9b8";
}

.bx-building:before {
  content: "\\e9b9";
}

.bx-building-house:before {
  content: "\\e9ba";
}

.bx-buildings:before {
  content: "\\e9bb";
}

.bx-bulb:before {
  content: "\\e9bc";
}

.bx-bullseye:before {
  content: "\\e9bd";
}

.bx-buoy:before {
  content: "\\e9be";
}

.bx-bus:before {
  content: "\\e9bf";
}

.bx-cake:before {
  content: "\\e9c0";
}

.bx-calculator:before {
  content: "\\e9c1";
}

.bx-calendar:before {
  content: "\\e9c2";
}

.bx-calendar-alt:before {
  content: "\\e9c3";
}

.bx-calendar-check:before {
  content: "\\e9c4";
}

.bx-calendar-event:before {
  content: "\\e9c5";
}

.bx-calendar-minus:before {
  content: "\\e9c6";
}

.bx-calendar-plus:before {
  content: "\\e9c7";
}

.bx-calendar-x:before {
  content: "\\e9c8";
}

.bx-camera:before {
  content: "\\e9c9";
}

.bx-camera-off:before {
  content: "\\e9ca";
}

.bx-captions:before {
  content: "\\e9cb";
}

.bx-car:before {
  content: "\\e9cc";
}

.bx-card:before {
  content: "\\e9cd";
}

.bx-caret-down:before {
  content: "\\e9ce";
}

.bx-caret-left:before {
  content: "\\e9cf";
}

.bx-caret-right:before {
  content: "\\e9d0";
}

.bx-caret-up:before {
  content: "\\e9d1";
}

.bx-carousel:before {
  content: "\\e9d2";
}

.bx-cart:before {
  content: "\\e9d3";
}

.bx-cart-alt:before {
  content: "\\e9d4";
}

.bx-cast:before {
  content: "\\e9d5";
}

.bx-certification:before {
  content: "\\e9d6";
}

.bx-chalkboard:before {
  content: "\\e9d7";
}

.bx-chart:before {
  content: "\\e9d8";
}

.bx-chat:before {
  content: "\\e9d9";
}

.bx-check:before {
  content: "\\e9da";
}

.bx-checkbox:before {
  content: "\\e9db";
}

.bx-checkbox-checked:before {
  content: "\\e9dc";
}

.bx-checkbox-square:before {
  content: "\\e9dd";
}

.bx-check-circle:before {
  content: "\\e9de";
}

.bx-check-double:before {
  content: "\\e9df";
}

.bx-check-shield:before {
  content: "\\e9e0";
}

.bx-check-square:before {
  content: "\\e9e1";
}

.bx-chevron-down:before {
  content: "\\e9e2";
}

.bx-chevron-left:before {
  content: "\\e9e3";
}

.bx-chevron-right:before {
  content: "\\e9e4";
}

.bx-chevrons-down:before {
  content: "\\e9e5";
}

.bx-chevrons-left:before {
  content: "\\e9e6";
}

.bx-chevrons-right:before {
  content: "\\e9e7";
}

.bx-chevrons-up:before {
  content: "\\e9e8";
}

.bx-chevron-up:before {
  content: "\\e9e9";
}

.bx-chip:before {
  content: "\\e9ea";
}

.bx-circle:before {
  content: "\\e9eb";
}

.bx-clinic:before {
  content: "\\e9ec";
}

.bx-clipboard:before {
  content: "\\e9ed";
}

.bx-closet:before {
  content: "\\e9ee";
}

.bx-cloud:before {
  content: "\\e9ef";
}

.bx-cloud-download:before {
  content: "\\e9f0";
}

.bx-cloud-drizzle:before {
  content: "\\e9f1";
}

.bx-cloud-lightning:before {
  content: "\\e9f2";
}

.bx-cloud-light-rain:before {
  content: "\\e9f3";
}

.bx-cloud-rain:before {
  content: "\\e9f4";
}

.bx-cloud-snow:before {
  content: "\\e9f5";
}

.bx-cloud-upload:before {
  content: "\\e9f6";
}

.bx-code:before {
  content: "\\e9f7";
}

.bx-code-alt:before {
  content: "\\e9f8";
}

.bx-code-block:before {
  content: "\\e9f9";
}

.bx-code-curly:before {
  content: "\\e9fa";
}

.bx-coffee:before {
  content: "\\e9fb";
}

.bx-cog:before {
  content: "\\e9fc";
}

.bx-collapse:before {
  content: "\\e9fd";
}

.bx-collection:before {
  content: "\\e9fe";
}

.bx-columns:before {
  content: "\\e9ff";
}

.bx-command:before {
  content: "\\ea00";
}

.bx-comment:before {
  content: "\\ea01";
}

.bx-comment-dots:before {
  content: "\\ea02";
}

.bx-compass:before {
  content: "\\ea03";
}

.bx-confused:before {
  content: "\\ea04";
}

.bx-conversation:before {
  content: "\\ea05";
}

.bx-cool:before {
  content: "\\ea06";
}

.bx-copy:before {
  content: "\\ea07";
}

.bx-copy-alt:before {
  content: "\\ea08";
}

.bx-copyright:before {
  content: "\\ea09";
}

.bx-credit-card:before {
  content: "\\ea0a";
}

.bx-credit-card-alt:before {
  content: "\\ea0b";
}

.bx-crop:before {
  content: "\\ea0c";
}

.bx-crosshair:before {
  content: "\\ea0d";
}

.bx-crown:before {
  content: "\\ea0e";
}

.bx-cube:before {
  content: "\\ea0f";
}

.bx-cube-alt:before {
  content: "\\ea10";
}

.bx-cuboid:before {
  content: "\\ea11";
}

.bx-customize:before {
  content: "\\ea12";
}

.bx-cut:before {
  content: "\\ea13";
}

.bx-cycling:before {
  content: "\\ea14";
}

.bx-cylinder:before {
  content: "\\ea15";
}

.bx-data:before {
  content: "\\ea16";
}

.bx-desktop:before {
  content: "\\ea17";
}

.bx-detail:before {
  content: "\\ea18";
}

.bx-devices:before {
  content: "\\ea19";
}

.bx-dialpad:before {
  content: "\\ea1a";
}

.bx-dialpad-alt:before {
  content: "\\ea1b";
}

.bx-diamond:before {
  content: "\\ea1c";
}

.bx-directions:before {
  content: "\\ea1d";
}

.bx-disc:before {
  content: "\\ea1e";
}

.bx-dish:before {
  content: "\\ea1f";
}

.bx-dislike:before {
  content: "\\ea20";
}

.bx-dizzy:before {
  content: "\\ea21";
}

.bx-dna:before {
  content: "\\ea22";
}

.bx-dock-bottom:before {
  content: "\\ea23";
}

.bx-dock-left:before {
  content: "\\ea24";
}

.bx-dock-right:before {
  content: "\\ea25";
}

.bx-dock-top:before {
  content: "\\ea26";
}

.bx-dollar:before {
  content: "\\ea27";
}

.bx-dollar-circle:before {
  content: "\\ea28";
}

.bx-dots-horizontal:before {
  content: "\\ea29";
}

.bx-dots-horizontal-rounded:before {
  content: "\\ea2a";
}

.bx-dots-vertical:before {
  content: "\\ea2b";
}

.bx-dots-vertical-rounded:before {
  content: "\\ea2c";
}

.bx-doughnut-chart:before {
  content: "\\ea2d";
}

.bx-down-arrow:before {
  content: "\\ea2e";
}

.bx-down-arrow-alt:before {
  content: "\\ea2f";
}

.bx-down-arrow-circle:before {
  content: "\\ea30";
}

.bx-download:before {
  content: "\\ea31";
}

.bx-downvote:before {
  content: "\\ea32";
}

.bx-droplet:before {
  content: "\\ea33";
}

.bx-dumbbell:before {
  content: "\\ea34";
}

.bx-duplicate:before {
  content: "\\ea35";
}

.bx-edit:before {
  content: "\\ea36";
}

.bx-edit-alt:before {
  content: "\\ea37";
}

.bx-envelope:before {
  content: "\\ea38";
}

.bx-equalizer:before {
  content: "\\ea39";
}

.bx-error:before {
  content: "\\ea3a";
}

.bx-error-alt:before {
  content: "\\ea3b";
}

.bx-error-circle:before {
  content: "\\ea3c";
}

.bx-euro:before {
  content: "\\ea3d";
}

.bx-exit:before {
  content: "\\ea3e";
}

.bx-exit-fullscreen:before {
  content: "\\ea3f";
}

.bx-expand:before {
  content: "\\ea40";
}

.bx-export:before {
  content: "\\ea41";
}

.bx-extension:before {
  content: "\\ea42";
}

.bx-face:before {
  content: "\\ea43";
}

.bx-fast-forward:before {
  content: "\\ea44";
}

.bx-fast-forward-circle:before {
  content: "\\ea45";
}

.bx-female:before {
  content: "\\ea46";
}

.bx-female-sign:before {
  content: "\\ea47";
}

.bx-file:before {
  content: "\\ea48";
}

.bx-file-blank:before {
  content: "\\ea49";
}

.bx-file-find:before {
  content: "\\ea4a";
}

.bx-film:before {
  content: "\\ea4b";
}

.bx-filter:before {
  content: "\\ea4c";
}

.bx-filter-alt:before {
  content: "\\ea4d";
}

.bx-fingerprint:before {
  content: "\\ea4e";
}

.bx-first-aid:before {
  content: "\\ea4f";
}

.bx-first-page:before {
  content: "\\ea50";
}

.bx-flag:before {
  content: "\\ea51";
}

.bx-folder:before {
  content: "\\ea52";
}

.bx-folder-minus:before {
  content: "\\ea53";
}

.bx-folder-open:before {
  content: "\\ea54";
}

.bx-folder-plus:before {
  content: "\\ea55";
}

.bx-font:before {
  content: "\\ea56";
}

.bx-font-color:before {
  content: "\\ea57";
}

.bx-font-family:before {
  content: "\\ea58";
}

.bx-font-size:before {
  content: "\\ea59";
}

.bx-food-menu:before {
  content: "\\ea5a";
}

.bx-food-tag:before {
  content: "\\ea5b";
}

.bx-football:before {
  content: "\\ea5c";
}

.bx-fridge:before {
  content: "\\ea5d";
}

.bx-fullscreen:before {
  content: "\\ea5e";
}

.bx-gas-pump:before {
  content: "\\ea5f";
}

.bx-ghost:before {
  content: "\\ea60";
}

.bx-gift:before {
  content: "\\ea61";
}

.bx-git-branch:before {
  content: "\\ea62";
}

.bx-git-commit:before {
  content: "\\ea63";
}

.bx-git-compare:before {
  content: "\\ea64";
}

.bx-git-merge:before {
  content: "\\ea65";
}

.bx-git-pull-request:before {
  content: "\\ea66";
}

.bx-git-repo-forked:before {
  content: "\\ea67";
}

.bx-globe:before {
  content: "\\ea68";
}

.bx-globe-alt:before {
  content: "\\ea69";
}

.bx-grid:before {
  content: "\\ea6a";
}

.bx-grid-alt:before {
  content: "\\ea6b";
}

.bx-grid-horizontal:before {
  content: "\\ea6c";
}

.bx-grid-small:before {
  content: "\\ea6d";
}

.bx-grid-vertical:before {
  content: "\\ea6e";
}

.bx-group:before {
  content: "\\ea6f";
}

.bx-handicap:before {
  content: "\\ea70";
}

.bx-happy:before {
  content: "\\ea71";
}

.bx-happy-alt:before {
  content: "\\ea72";
}

.bx-happy-beaming:before {
  content: "\\ea73";
}

.bx-happy-heart-eyes:before {
  content: "\\ea74";
}

.bx-hash:before {
  content: "\\ea75";
}

.bx-hdd:before {
  content: "\\ea76";
}

.bx-heading:before {
  content: "\\ea77";
}

.bx-headphone:before {
  content: "\\ea78";
}

.bx-health:before {
  content: "\\ea79";
}

.bx-heart:before {
  content: "\\ea7a";
}

.bx-help-circle:before {
  content: "\\ea7b";
}

.bx-hide:before {
  content: "\\ea7c";
}

.bx-highlight:before {
  content: "\\ea7d";
}

.bx-history:before {
  content: "\\ea7e";
}

.bx-hive:before {
  content: "\\ea7f";
}

.bx-home:before {
  content: "\\ea80";
}

.bx-home-alt:before {
  content: "\\ea81";
}

.bx-home-circle:before {
  content: "\\ea82";
}

.bx-horizontal-center:before {
  content: "\\ea83";
}

.bx-hotel:before {
  content: "\\ea84";
}

.bx-hourglass:before {
  content: "\\ea85";
}

.bx-id-card:before {
  content: "\\ea86";
}

.bx-image:before {
  content: "\\ea87";
}

.bx-image-add:before {
  content: "\\ea88";
}

.bx-image-alt:before {
  content: "\\ea89";
}

.bx-images:before {
  content: "\\ea8a";
}

.bx-import:before {
  content: "\\ea8b";
}

.bx-infinite:before {
  content: "\\ea8c";
}

.bx-info-circle:before {
  content: "\\ea8d";
}

.bx-italic:before {
  content: "\\ea8e";
}

.bx-joystick:before {
  content: "\\ea8f";
}

.bx-joystick-alt:before {
  content: "\\ea90";
}

.bx-joystick-button:before {
  content: "\\ea91";
}

.bx-key:before {
  content: "\\ea92";
}

.bx-label:before {
  content: "\\ea93";
}

.bx-landscape:before {
  content: "\\ea94";
}

.bx-laptop:before {
  content: "\\ea95";
}

.bx-last-page:before {
  content: "\\ea96";
}

.bx-laugh:before {
  content: "\\ea97";
}

.bx-layer:before {
  content: "\\ea98";
}

.bx-layout:before {
  content: "\\ea99";
}

.bx-left-arrow:before {
  content: "\\ea9a";
}

.bx-left-arrow-alt:before {
  content: "\\ea9b";
}

.bx-left-arrow-circle:before {
  content: "\\ea9c";
}

.bx-left-down-arrow-circle:before {
  content: "\\ea9d";
}

.bx-left-indent:before {
  content: "\\ea9e";
}

.bx-left-top-arrow-circle:before {
  content: "\\ea9f";
}

.bx-like:before {
  content: "\\eaa0";
}

.bx-line-chart:before {
  content: "\\eaa1";
}

.bx-link:before {
  content: "\\eaa2";
}

.bx-link-alt:before {
  content: "\\eaa3";
}

.bx-link-external:before {
  content: "\\eaa4";
}

.bx-lira:before {
  content: "\\eaa5";
}

.bx-list-check:before {
  content: "\\eaa6";
}

.bx-list-minus:before {
  content: "\\eaa7";
}

.bx-list-ol:before {
  content: "\\eaa8";
}

.bx-list-plus:before {
  content: "\\eaa9";
}

.bx-list-ul:before {
  content: "\\eaaa";
}

.bx-loader:before {
  content: "\\eaab";
}

.bx-loader-alt:before {
  content: "\\eaac";
}

.bx-loader-circle:before {
  content: "\\eaad";
}

.bx-lock:before {
  content: "\\eaae";
}

.bx-lock-alt:before {
  content: "\\eaaf";
}

.bx-lock-open:before {
  content: "\\eab0";
}

.bx-lock-open-alt:before {
  content: "\\eab1";
}

.bx-log-in:before {
  content: "\\eab2";
}

.bx-log-in-circle:before {
  content: "\\eab3";
}

.bx-log-out:before {
  content: "\\eab4";
}

.bx-log-out-circle:before {
  content: "\\eab5";
}

.bx-magnet:before {
  content: "\\eab6";
}

.bx-mail-send:before {
  content: "\\eab7";
}

.bx-male:before {
  content: "\\eab8";
}

.bx-male-sign:before {
  content: "\\eab9";
}

.bx-map:before {
  content: "\\eaba";
}

.bx-map-alt:before {
  content: "\\eabb";
}

.bx-map-pin:before {
  content: "\\eabc";
}

.bx-meh:before {
  content: "\\eabd";
}

.bx-meh-alt:before {
  content: "\\eabe";
}

.bx-meh-blank:before {
  content: "\\eabf";
}

.bx-memory-card:before {
  content: "\\eac0";
}

.bx-menu:before {
  content: "\\eac1";
}

.bx-menu-alt-left:before {
  content: "\\eac2";
}

.bx-menu-alt-right:before {
  content: "\\eac3";
}

.bx-message:before {
  content: "\\eac4";
}

.bx-message-alt:before {
  content: "\\eac5";
}

.bx-message-alt-dots:before {
  content: "\\eac6";
}

.bx-message-dots:before {
  content: "\\eac7";
}

.bx-message-rounded:before {
  content: "\\eac8";
}

.bx-message-rounded-dots:before {
  content: "\\eac9";
}

.bx-message-square:before {
  content: "\\eaca";
}

.bx-message-square-dots:before {
  content: "\\eacb";
}

.bx-microphone:before {
  content: "\\eacc";
}

.bx-microphone-off:before {
  content: "\\eacd";
}

.bx-minus:before {
  content: "\\eace";
}

.bx-minus-circle:before {
  content: "\\eacf";
}

.bx-mobile:before {
  content: "\\ead0";
}

.bx-mobile-alt:before {
  content: "\\ead1";
}

.bx-mobile-landscape:before {
  content: "\\ead2";
}

.bx-mobile-vibration:before {
  content: "\\ead3";
}

.bx-money:before {
  content: "\\ead4";
}

.bx-moon:before {
  content: "\\ead5";
}

.bx-mouse:before {
  content: "\\ead6";
}

.bx-mouse-alt:before {
  content: "\\ead7";
}

.bx-move:before {
  content: "\\ead8";
}

.bx-move-horizontal:before {
  content: "\\ead9";
}

.bx-move-vertical:before {
  content: "\\eada";
}

.bx-movie:before {
  content: "\\eadb";
}

.bx-music:before {
  content: "\\eadc";
}

.bx-navigation:before {
  content: "\\eadd";
}

.bx-news:before {
  content: "\\eade";
}

.bx-no-entry:before {
  content: "\\eadf";
}

.bx-note:before {
  content: "\\eae0";
}

.bx-notepad:before {
  content: "\\eae1";
}

.bx-notification:before {
  content: "\\eae2";
}

.bx-notification-off:before {
  content: "\\eae3";
}

.bx-package:before {
  content: "\\eae4";
}

.bx-paint:before {
  content: "\\eae5";
}

.bx-paint-roll:before {
  content: "\\eae6";
}

.bx-palette:before {
  content: "\\eae7";
}

.bx-paperclip:before {
  content: "\\eae8";
}

.bx-paper-plane:before {
  content: "\\eae9";
}

.bx-paragraph:before {
  content: "\\eaea";
}

.bx-paste:before {
  content: "\\eaeb";
}

.bx-pause:before {
  content: "\\eaec";
}

.bx-pause-circle:before {
  content: "\\eaed";
}

.bx-pen:before {
  content: "\\eaee";
}

.bx-pencil:before {
  content: "\\eaef";
}

.bx-phone:before {
  content: "\\eaf0";
}

.bx-phone-call:before {
  content: "\\eaf1";
}

.bx-phone-incoming:before {
  content: "\\eaf2";
}

.bx-phone-outgoing:before {
  content: "\\eaf3";
}

.bx-photo-album:before {
  content: "\\eaf4";
}

.bx-pie-chart:before {
  content: "\\eaf5";
}

.bx-pie-chart-alt:before {
  content: "\\eaf6";
}

.bx-pie-chart-alt-2:before {
  content: "\\eaf7";
}

.bx-pin:before {
  content: "\\eaf8";
}

.bx-planet:before {
  content: "\\eaf9";
}

.bx-play:before {
  content: "\\eafa";
}

.bx-play-circle:before {
  content: "\\eafb";
}

.bx-plug:before {
  content: "\\eafc";
}

.bx-plus:before {
  content: "\\eafd";
}

.bx-plus-circle:before {
  content: "\\eafe";
}

.bx-plus-medical:before {
  content: "\\eaff";
}

.bx-poll:before {
  content: "\\eb00";
}

.bx-polygon:before {
  content: "\\eb01";
}

.bx-pound:before {
  content: "\\eb02";
}

.bx-power-off:before {
  content: "\\eb03";
}

.bx-printer:before {
  content: "\\eb04";
}

.bx-pulse:before {
  content: "\\eb05";
}

.bx-purchase-tag:before {
  content: "\\eb06";
}

.bx-purchase-tag-alt:before {
  content: "\\eb07";
}

.bx-pyramid:before {
  content: "\\eb08";
}

.bx-question-mark:before {
  content: "\\eb09";
}

.bx-radar:before {
  content: "\\eb0a";
}

.bx-radio:before {
  content: "\\eb0b";
}

.bx-radio-circle:before {
  content: "\\eb0c";
}

.bx-radio-circle-marked:before {
  content: "\\eb0d";
}

.bx-receipt:before {
  content: "\\eb0e";
}

.bx-rectangle:before {
  content: "\\eb0f";
}

.bx-redo:before {
  content: "\\eb10";
}

.bx-rename:before {
  content: "\\eb11";
}

.bx-repeat:before {
  content: "\\eb12";
}

.bx-reply:before {
  content: "\\eb13";
}

.bx-reply-all:before {
  content: "\\eb14";
}

.bx-repost:before {
  content: "\\eb15";
}

.bx-reset:before {
  content: "\\eb16";
}

.bx-restaurant:before {
  content: "\\eb17";
}

.bx-revision:before {
  content: "\\eb18";
}

.bx-rewind:before {
  content: "\\eb19";
}

.bx-rewind-circle:before {
  content: "\\eb1a";
}

.bx-right-arrow:before {
  content: "\\eb1b";
}

.bx-right-arrow-alt:before {
  content: "\\eb1c";
}

.bx-right-arrow-circle:before {
  content: "\\eb1d";
}

.bx-right-down-arrow-circle:before {
  content: "\\eb1e";
}

.bx-right-indent:before {
  content: "\\eb1f";
}

.bx-right-top-arrow-circle:before {
  content: "\\eb20";
}

.bx-rocket:before {
  content: "\\eb21";
}

.bx-rotate-left:before {
  content: "\\eb22";
}

.bx-rotate-right:before {
  content: "\\eb23";
}

.bx-rss:before {
  content: "\\eb24";
}

.bx-ruble:before {
  content: "\\eb25";
}

.bx-ruler:before {
  content: "\\eb26";
}

.bx-run:before {
  content: "\\eb27";
}

.bx-rupee:before {
  content: "\\eb28";
}

.bx-sad:before {
  content: "\\eb29";
}

.bx-save:before {
  content: "\\eb2a";
}

.bx-screenshot:before {
  content: "\\eb2b";
}

.bx-search:before {
  content: "\\eb2c";
}

.bx-search-alt:before {
  content: "\\eb2d";
}

.bx-search-alt-2:before {
  content: "\\eb2e";
}

.bx-selection:before {
  content: "\\eb2f";
}

.bx-select-multiple:before {
  content: "\\eb30";
}

.bx-send:before {
  content: "\\eb31";
}

.bx-server:before {
  content: "\\eb32";
}

.bx-shape-circle:before {
  content: "\\eb33";
}

.bx-shape-square:before {
  content: "\\eb34";
}

.bx-shape-triangle:before {
  content: "\\eb35";
}

.bx-share:before {
  content: "\\eb36";
}

.bx-share-alt:before {
  content: "\\eb37";
}

.bx-shekel:before {
  content: "\\eb38";
}

.bx-shield:before {
  content: "\\eb39";
}

.bx-shield-alt:before {
  content: "\\eb3a";
}

.bx-shield-alt-2:before {
  content: "\\eb3b";
}

.bx-shield-quarter:before {
  content: "\\eb3c";
}

.bx-shocked:before {
  content: "\\eb3d";
}

.bx-shopping-bag:before {
  content: "\\eb3e";
}

.bx-show:before {
  content: "\\eb3f";
}

.bx-show-alt:before {
  content: "\\eb40";
}

.bx-shuffle:before {
  content: "\\eb41";
}

.bx-sidebar:before {
  content: "\\eb42";
}

.bx-sitemap:before {
  content: "\\eb43";
}

.bx-skip-next:before {
  content: "\\eb44";
}

.bx-skip-next-circle:before {
  content: "\\eb45";
}

.bx-skip-previous:before {
  content: "\\eb46";
}

.bx-skip-previous-circle:before {
  content: "\\eb47";
}

.bx-sleepy:before {
  content: "\\eb48";
}

.bx-slider:before {
  content: "\\eb49";
}

.bx-slider-alt:before {
  content: "\\eb4a";
}

.bx-slideshow:before {
  content: "\\eb4b";
}

.bx-smile:before {
  content: "\\eb4c";
}

.bx-sort:before {
  content: "\\eb4d";
}

.bx-sort-a-z:before {
  content: "\\eb4e";
}

.bx-sort-down:before {
  content: "\\eb4f";
}

.bx-sort-up:before {
  content: "\\eb50";
}

.bx-sort-z-a:before {
  content: "\\eb51";
}

.bx-spa:before {
  content: "\\eb52";
}

.bx-space-bar:before {
  content: "\\eb53";
}

.bx-spreadsheet:before {
  content: "\\eb54";
}

.bx-square:before {
  content: "\\eb55";
}

.bx-square-rounded:before {
  content: "\\eb56";
}

.bx-star:before {
  content: "\\eb57";
}

.bx-station:before {
  content: "\\eb58";
}

.bx-stats:before {
  content: "\\eb59";
}

.bx-sticker:before {
  content: "\\eb5a";
}

.bx-stop:before {
  content: "\\eb5b";
}

.bx-stop-circle:before {
  content: "\\eb5c";
}

.bx-stopwatch:before {
  content: "\\eb5d";
}

.bx-store:before {
  content: "\\eb5e";
}

.bx-store-alt:before {
  content: "\\eb5f";
}

.bx-street-view:before {
  content: "\\eb60";
}

.bx-strikethrough:before {
  content: "\\eb61";
}

.bx-subdirectory-left:before {
  content: "\\eb62";
}

.bx-subdirectory-right:before {
  content: "\\eb63";
}

.bx-sun:before {
  content: "\\eb64";
}

.bx-support:before {
  content: "\\eb65";
}

.bx-swim:before {
  content: "\\eb66";
}

.bx-sync:before {
  content: "\\eb67";
}

.bx-tab:before {
  content: "\\eb68";
}

.bx-table:before {
  content: "\\eb69";
}

.bx-tag:before {
  content: "\\eb6a";
}

.bx-target-lock:before {
  content: "\\eb6b";
}

.bx-task:before {
  content: "\\eb6c";
}

.bx-taxi:before {
  content: "\\eb6d";
}

.bx-tennis-ball:before {
  content: "\\eb6e";
}

.bx-terminal:before {
  content: "\\eb6f";
}

.bx-test-tube:before {
  content: "\\eb70";
}

.bx-text:before {
  content: "\\eb71";
}

.bx-time:before {
  content: "\\eb72";
}

.bx-time-five:before {
  content: "\\eb73";
}

.bx-timer:before {
  content: "\\eb74";
}

.bx-tired:before {
  content: "\\eb75";
}

.bx-toggle-left:before {
  content: "\\eb76";
}

.bx-toggle-right:before {
  content: "\\eb77";
}

.bx-tone:before {
  content: "\\eb78";
}

.bx-train:before {
  content: "\\eb79";
}

.bx-transfer:before {
  content: "\\eb7a";
}

.bx-transfer-alt:before {
  content: "\\eb7b";
}

.bx-trash:before {
  content: "\\eb7c";
}

.bx-trash-alt:before {
  content: "\\eb7d";
}

.bx-trending-down:before {
  content: "\\eb7e";
}

.bx-trending-up:before {
  content: "\\eb7f";
}

.bx-trophy:before {
  content: "\\eb80";
}

.bx-tv:before {
  content: "\\eb81";
}

.bx-underline:before {
  content: "\\eb82";
}

.bx-undo:before {
  content: "\\eb83";
}

.bx-unlink:before {
  content: "\\eb84";
}

.bx-up-arrow:before {
  content: "\\eb85";
}

.bx-up-arrow-alt:before {
  content: "\\eb86";
}

.bx-up-arrow-circle:before {
  content: "\\eb87";
}

.bx-upload:before {
  content: "\\eb88";
}

.bx-upside-down:before {
  content: "\\eb89";
}

.bx-upvote:before {
  content: "\\eb8a";
}

.bx-usb:before {
  content: "\\eb8b";
}

.bx-user:before {
  content: "\\eb8c";
}

.bx-user-check:before {
  content: "\\eb8d";
}

.bx-user-circle:before {
  content: "\\eb8e";
}

.bx-user-minus:before {
  content: "\\eb8f";
}

.bx-user-pin:before {
  content: "\\eb90";
}

.bx-user-plus:before {
  content: "\\eb91";
}

.bx-user-voice:before {
  content: "\\eb92";
}

.bx-user-x:before {
  content: "\\eb93";
}

.bx-vertical-center:before {
  content: "\\eb94";
}

.bx-video:before {
  content: "\\eb95";
}

.bx-video-off:before {
  content: "\\eb96";
}

.bx-video-plus:before {
  content: "\\eb97";
}

.bx-video-recording:before {
  content: "\\eb98";
}

.bx-voicemail:before {
  content: "\\eb99";
}

.bx-volume:before {
  content: "\\eb9a";
}

.bx-volume-full:before {
  content: "\\eb9b";
}

.bx-volume-low:before {
  content: "\\eb9c";
}

.bx-volume-mute:before {
  content: "\\eb9d";
}

.bx-walk:before {
  content: "\\eb9e";
}

.bx-wallet:before {
  content: "\\eb9f";
}

.bx-wallet-alt:before {
  content: "\\eba0";
}

.bx-water:before {
  content: "\\eba1";
}

.bx-wifi:before {
  content: "\\eba2";
}

.bx-wifi-off:before {
  content: "\\eba3";
}

.bx-wind:before {
  content: "\\eba4";
}

.bx-window:before {
  content: "\\eba5";
}

.bx-window-close:before {
  content: "\\eba6";
}

.bx-window-open:before {
  content: "\\eba7";
}

.bx-windows:before {
  content: "\\eba8";
}

.bx-wink-smile:before {
  content: "\\eba9";
}

.bx-wink-tongue:before {
  content: "\\ebaa";
}

.bx-won:before {
  content: "\\ebab";
}

.bx-world:before {
  content: "\\ebac";
}

.bx-wrench:before {
  content: "\\ebad";
}

.bx-x:before {
  content: "\\ebae";
}

.bx-x-circle:before {
  content: "\\ebaf";
}

.bx-yen:before {
  content: "\\ebb0";
}

.bx-zoom-in:before {
  content: "\\ebb1";
}

.bx-zoom-out:before {
  content: "\\ebb2";
}

.bxs-add-to-queue:before {
  content: "\\ebb3";
}

.bxs-adjust:before {
  content: "\\ebb4";
}

.bxs-adjust-alt:before {
  content: "\\ebb5";
}

.bxs-alarm:before {
  content: "\\ebb6";
}

.bxs-alarm-add:before {
  content: "\\ebb7";
}

.bxs-alarm-off:before {
  content: "\\ebb8";
}

.bxs-album:before {
  content: "\\ebb9";
}

.bxs-ambulance:before {
  content: "\\ebba";
}

.bxs-analyse:before {
  content: "\\ebbb";
}

.bxs-angry:before {
  content: "\\ebbc";
}

.bxs-archive:before {
  content: "\\ebbd";
}

.bxs-archive-in:before {
  content: "\\ebbe";
}

.bxs-archive-out:before {
  content: "\\ebbf";
}

.bxs-area:before {
  content: "\\ebc0";
}

.bxs-award:before {
  content: "\\ebc1";
}

.bxs-baby-carriage:before {
  content: "\\ebc2";
}

.bxs-badge:before {
  content: "\\ebc3";
}

.bxs-badge-check:before {
  content: "\\ebc4";
}

.bxs-ball:before {
  content: "\\ebc5";
}

.bxs-band-aid:before {
  content: "\\ebc6";
}

.bxs-bank:before {
  content: "\\ebc7";
}

.bxs-bar-chart-alt-2:before {
  content: "\\ebc8";
}

.bxs-bar-chart-square:before {
  content: "\\ebc9";
}

.bxs-barcode:before {
  content: "\\ebca";
}

.bxs-basket:before {
  content: "\\ebcb";
}

.bxs-bath:before {
  content: "\\ebcc";
}

.bxs-battery:before {
  content: "\\ebcd";
}

.bxs-battery-charging:before {
  content: "\\ebce";
}

.bxs-battery-full:before {
  content: "\\ebcf";
}

.bxs-battery-low:before {
  content: "\\ebd0";
}

.bxs-bed:before {
  content: "\\ebd1";
}

.bxs-bell:before {
  content: "\\ebd2";
}

.bxs-bell-minus:before {
  content: "\\ebd3";
}

.bxs-bell-off:before {
  content: "\\ebd4";
}

.bxs-bell-plus:before {
  content: "\\ebd5";
}

.bxs-bell-ring:before {
  content: "\\ebd6";
}

.bxs-bolt:before {
  content: "\\ebd7";
}

.bxs-bolt-circle:before {
  content: "\\ebd8";
}

.bxs-book:before {
  content: "\\ebd9";
}

.bxs-book-bookmark:before {
  content: "\\ebda";
}

.bxs-book-content:before {
  content: "\\ebdb";
}

.bxs-bookmark:before {
  content: "\\ebdc";
}

.bxs-bookmark-minus:before {
  content: "\\ebdd";
}

.bxs-bookmark-plus:before {
  content: "\\ebde";
}

.bxs-bookmarks:before {
  content: "\\ebdf";
}

.bxs-bookmark-star:before {
  content: "\\ebe0";
}

.bxs-book-open:before {
  content: "\\ebe1";
}

.bxs-bot:before {
  content: "\\ebe2";
}

.bxs-bowling-ball:before {
  content: "\\ebe3";
}

.bxs-box:before {
  content: "\\ebe4";
}

.bxs-briefcase:before {
  content: "\\ebe5";
}

.bxs-briefcase-alt:before {
  content: "\\ebe6";
}

.bxs-briefcase-alt-2:before {
  content: "\\ebe7";
}

.bxs-brightness:before {
  content: "\\ebe8";
}

.bxs-brightness-half:before {
  content: "\\ebe9";
}

.bxs-brush:before {
  content: "\\ebea";
}

.bxs-brush-alt:before {
  content: "\\ebeb";
}

.bxs-bug:before {
  content: "\\ebec";
}

.bxs-bug-alt:before {
  content: "\\ebed";
}

.bxs-building:before {
  content: "\\ebee";
}

.bxs-building-house:before {
  content: "\\ebef";
}

.bxs-buildings:before {
  content: "\\ebf0";
}

.bxs-bulb:before {
  content: "\\ebf1";
}

.bxs-buoy:before {
  content: "\\ebf2";
}

.bxs-bus:before {
  content: "\\ebf3";
}

.bxs-business:before {
  content: "\\ebf4";
}

.bxs-cake:before {
  content: "\\ebf5";
}

.bxs-calculator:before {
  content: "\\ebf6";
}

.bxs-calendar:before {
  content: "\\ebf7";
}

.bxs-calendar-alt:before {
  content: "\\ebf8";
}

.bxs-calendar-check:before {
  content: "\\ebf9";
}

.bxs-calendar-event:before {
  content: "\\ebfa";
}

.bxs-calendar-minus:before {
  content: "\\ebfb";
}

.bxs-calendar-plus:before {
  content: "\\ebfc";
}

.bxs-calendar-x:before {
  content: "\\ebfd";
}

.bxs-camera:before {
  content: "\\ebfe";
}

.bxs-camera-off:before {
  content: "\\ebff";
}

.bxs-camera-plus:before {
  content: "\\ec00";
}

.bxs-capsule:before {
  content: "\\ec01";
}

.bxs-captions:before {
  content: "\\ec02";
}

.bxs-car:before {
  content: "\\ec03";
}

.bxs-card:before {
  content: "\\ec04";
}

.bxs-caret-down-circle:before {
  content: "\\ec05";
}

.bxs-caret-left-circle:before {
  content: "\\ec06";
}

.bxs-caret-right-circle:before {
  content: "\\ec07";
}

.bxs-caret-up-circle:before {
  content: "\\ec08";
}

.bxs-carousel:before {
  content: "\\ec09";
}

.bxs-cart:before {
  content: "\\ec0a";
}

.bxs-cart-alt:before {
  content: "\\ec0b";
}

.bxs-certification:before {
  content: "\\ec0c";
}

.bxs-chalkboard:before {
  content: "\\ec0d";
}

.bxs-chart:before {
  content: "\\ec0e";
}

.bxs-chat:before {
  content: "\\ec0f";
}

.bxs-checkbox:before {
  content: "\\ec10";
}

.bxs-checkbox-checked:before {
  content: "\\ec11";
}

.bxs-check-circle:before {
  content: "\\ec12";
}

.bxs-check-shield:before {
  content: "\\ec13";
}

.bxs-check-square:before {
  content: "\\ec14";
}

.bxs-chip:before {
  content: "\\ec15";
}

.bxs-circle:before {
  content: "\\ec16";
}

.bxs-city:before {
  content: "\\ec17";
}

.bxs-clinic:before {
  content: "\\ec18";
}

.bxs-cloud:before {
  content: "\\ec19";
}

.bxs-cloud-download:before {
  content: "\\ec1a";
}

.bxs-cloud-lightning:before {
  content: "\\ec1b";
}

.bxs-cloud-rain:before {
  content: "\\ec1c";
}

.bxs-cloud-upload:before {
  content: "\\ec1d";
}

.bxs-coffee:before {
  content: "\\ec1e";
}

.bxs-coffee-alt:before {
  content: "\\ec1f";
}

.bxs-cog:before {
  content: "\\ec20";
}

.bxs-collection:before {
  content: "\\ec21";
}

.bxs-color-fill:before {
  content: "\\ec22";
}

.bxs-comment:before {
  content: "\\ec23";
}

.bxs-comment-add:before {
  content: "\\ec24";
}

.bxs-comment-detail:before {
  content: "\\ec25";
}

.bxs-comment-dots:before {
  content: "\\ec26";
}

.bxs-comment-error:before {
  content: "\\ec27";
}

.bxs-compass:before {
  content: "\\ec28";
}

.bxs-component:before {
  content: "\\ec29";
}

.bxs-confused:before {
  content: "\\ec2a";
}

.bxs-contact:before {
  content: "\\ec2b";
}

.bxs-conversation:before {
  content: "\\ec2c";
}

.bxs-cool:before {
  content: "\\ec2d";
}

.bxs-copy:before {
  content: "\\ec2e";
}

.bxs-copy-alt:before {
  content: "\\ec2f";
}

.bxs-coupon:before {
  content: "\\ec30";
}

.bxs-credit-card:before {
  content: "\\ec31";
}

.bxs-credit-card-alt:before {
  content: "\\ec32";
}

.bxs-crown:before {
  content: "\\ec33";
}

.bxs-cube:before {
  content: "\\ec34";
}

.bxs-cube-alt:before {
  content: "\\ec35";
}

.bxs-cuboid:before {
  content: "\\ec36";
}

.bxs-customize:before {
  content: "\\ec37";
}

.bxs-cylinder:before {
  content: "\\ec38";
}

.bxs-dashboard:before {
  content: "\\ec39";
}

.bxs-data:before {
  content: "\\ec3a";
}

.bxs-detail:before {
  content: "\\ec3b";
}

.bxs-devices:before {
  content: "\\ec3c";
}

.bxs-direction-left:before {
  content: "\\ec3d";
}

.bxs-direction-right:before {
  content: "\\ec3e";
}

.bxs-directions:before {
  content: "\\ec3f";
}

.bxs-disc:before {
  content: "\\ec40";
}

.bxs-discount:before {
  content: "\\ec41";
}

.bxs-dish:before {
  content: "\\ec42";
}

.bxs-dislike:before {
  content: "\\ec43";
}

.bxs-dizzy:before {
  content: "\\ec44";
}

.bxs-dock-bottom:before {
  content: "\\ec45";
}

.bxs-dock-left:before {
  content: "\\ec46";
}

.bxs-dock-right:before {
  content: "\\ec47";
}

.bxs-dock-top:before {
  content: "\\ec48";
}

.bxs-dollar-circle:before {
  content: "\\ec49";
}

.bxs-doughnut-chart:before {
  content: "\\ec4a";
}

.bxs-down-arrow:before {
  content: "\\ec4b";
}

.bxs-down-arrow-circle:before {
  content: "\\ec4c";
}

.bxs-down-arrow-square:before {
  content: "\\ec4d";
}

.bxs-download:before {
  content: "\\ec4e";
}

.bxs-downvote:before {
  content: "\\ec4f";
}

.bxs-drink:before {
  content: "\\ec50";
}

.bxs-droplet:before {
  content: "\\ec51";
}

.bxs-droplet-half:before {
  content: "\\ec52";
}

.bxs-duplicate:before {
  content: "\\ec53";
}

.bxs-edit:before {
  content: "\\ec54";
}

.bxs-edit-alt:before {
  content: "\\ec55";
}

.bxs-eject:before {
  content: "\\ec56";
}

.bxs-envelope:before {
  content: "\\ec57";
}

.bxs-eraser:before {
  content: "\\ec58";
}

.bxs-error:before {
  content: "\\ec59";
}

.bxs-error-alt:before {
  content: "\\ec5a";
}

.bxs-error-circle:before {
  content: "\\ec5b";
}

.bxs-exit:before {
  content: "\\ec5c";
}

.bxs-extension:before {
  content: "\\ec5d";
}

.bxs-eyedropper:before {
  content: "\\ec5e";
}

.bxs-face:before {
  content: "\\ec5f";
}

.bxs-factory:before {
  content: "\\ec60";
}

.bxs-fast-forward-circle:before {
  content: "\\ec61";
}

.bxs-file:before {
  content: "\\ec62";
}

.bxs-file-blank:before {
  content: "\\ec63";
}

.bxs-file-css:before {
  content: "\\ec64";
}

.bxs-file-doc:before {
  content: "\\ec65";
}

.bxs-file-find:before {
  content: "\\ec66";
}

.bxs-file-gif:before {
  content: "\\ec67";
}

.bxs-file-html:before {
  content: "\\ec68";
}

.bxs-file-image:before {
  content: "\\ec69";
}

.bxs-file-jpg:before {
  content: "\\ec6a";
}

.bxs-file-js:before {
  content: "\\ec6b";
}

.bxs-file-json:before {
  content: "\\ec6c";
}

.bxs-file-md:before {
  content: "\\ec6d";
}

.bxs-file-pdf:before {
  content: "\\ec6e";
}

.bxs-file-plus:before {
  content: "\\ec6f";
}

.bxs-file-png:before {
  content: "\\ec70";
}

.bxs-file-txt:before {
  content: "\\ec71";
}

.bxs-film:before {
  content: "\\ec72";
}

.bxs-filter-alt:before {
  content: "\\ec73";
}

.bxs-first-aid:before {
  content: "\\ec74";
}

.bxs-flag:before {
  content: "\\ec75";
}

.bxs-flag-alt:before {
  content: "\\ec76";
}

.bxs-flame:before {
  content: "\\ec77";
}

.bxs-flask:before {
  content: "\\ec78";
}

.bxs-folder:before {
  content: "\\ec79";
}

.bxs-folder-minus:before {
  content: "\\ec7a";
}

.bxs-folder-open:before {
  content: "\\ec7b";
}

.bxs-folder-plus:before {
  content: "\\ec7c";
}

.bxs-food-menu:before {
  content: "\\ec7d";
}

.bxs-fridge:before {
  content: "\\ec7e";
}

.bxs-gas-pump:before {
  content: "\\ec7f";
}

.bxs-ghost:before {
  content: "\\ec80";
}

.bxs-gift:before {
  content: "\\ec81";
}

.bxs-graduation:before {
  content: "\\ec82";
}

.bxs-grid:before {
  content: "\\ec83";
}

.bxs-grid-alt:before {
  content: "\\ec84";
}

.bxs-group:before {
  content: "\\ec85";
}

.bxs-hand-down:before {
  content: "\\ec86";
}

.bxs-hand-left:before {
  content: "\\ec87";
}

.bxs-hand-right:before {
  content: "\\ec88";
}

.bxs-hand-up:before {
  content: "\\ec89";
}

.bxs-happy:before {
  content: "\\ec8a";
}

.bxs-happy-alt:before {
  content: "\\ec8b";
}

.bxs-happy-beaming:before {
  content: "\\ec8c";
}

.bxs-happy-heart-eyes:before {
  content: "\\ec8d";
}

.bxs-hdd:before {
  content: "\\ec8e";
}

.bxs-heart:before {
  content: "\\ec8f";
}

.bxs-help-circle:before {
  content: "\\ec90";
}

.bxs-hide:before {
  content: "\\ec91";
}

.bxs-home:before {
  content: "\\ec92";
}

.bxs-home-circle:before {
  content: "\\ec93";
}

.bxs-hot:before {
  content: "\\ec94";
}

.bxs-hotel:before {
  content: "\\ec95";
}

.bxs-hourglass:before {
  content: "\\ec96";
}

.bxs-hourglass-bottom:before {
  content: "\\ec97";
}

.bxs-hourglass-top:before {
  content: "\\ec98";
}

.bxs-id-card:before {
  content: "\\ec99";
}

.bxs-image:before {
  content: "\\ec9a";
}

.bxs-image-add:before {
  content: "\\ec9b";
}

.bxs-image-alt:before {
  content: "\\ec9c";
}

.bxs-inbox:before {
  content: "\\ec9d";
}

.bxs-info-circle:before {
  content: "\\ec9e";
}

.bxs-institution:before {
  content: "\\ec9f";
}

.bxs-joystick:before {
  content: "\\eca0";
}

.bxs-joystick-alt:before {
  content: "\\eca1";
}

.bxs-joystick-button:before {
  content: "\\eca2";
}

.bxs-key:before {
  content: "\\eca3";
}

.bxs-keyboard:before {
  content: "\\eca4";
}

.bxs-label:before {
  content: "\\eca5";
}

.bxs-landmark:before {
  content: "\\eca6";
}

.bxs-landscape:before {
  content: "\\eca7";
}

.bxs-laugh:before {
  content: "\\eca8";
}

.bxs-layer:before {
  content: "\\eca9";
}

.bxs-layout:before {
  content: "\\ecaa";
}

.bxs-left-arrow:before {
  content: "\\ecab";
}

.bxs-left-arrow-circle:before {
  content: "\\ecac";
}

.bxs-left-arrow-square:before {
  content: "\\ecad";
}

.bxs-left-down-arrow-circle:before {
  content: "\\ecae";
}

.bxs-left-top-arrow-circle:before {
  content: "\\ecaf";
}

.bxs-like:before {
  content: "\\ecb0";
}

.bxs-lock:before {
  content: "\\ecb1";
}

.bxs-lock-alt:before {
  content: "\\ecb2";
}

.bxs-lock-open:before {
  content: "\\ecb3";
}

.bxs-lock-open-alt:before {
  content: "\\ecb4";
}

.bxs-log-in:before {
  content: "\\ecb5";
}

.bxs-log-in-circle:before {
  content: "\\ecb6";
}

.bxs-log-out:before {
  content: "\\ecb7";
}

.bxs-log-out-circle:before {
  content: "\\ecb8";
}

.bxs-magic-wand:before {
  content: "\\ecb9";
}

.bxs-magnet:before {
  content: "\\ecba";
}

.bxs-map:before {
  content: "\\ecbb";
}

.bxs-map-alt:before {
  content: "\\ecbc";
}

.bxs-map-pin:before {
  content: "\\ecbd";
}

.bxs-megaphone:before {
  content: "\\ecbe";
}

.bxs-meh:before {
  content: "\\ecbf";
}

.bxs-meh-alt:before {
  content: "\\ecc0";
}

.bxs-meh-blank:before {
  content: "\\ecc1";
}

.bxs-memory-card:before {
  content: "\\ecc2";
}

.bxs-message:before {
  content: "\\ecc3";
}

.bxs-message-alt:before {
  content: "\\ecc4";
}

.bxs-message-alt-dots:before {
  content: "\\ecc5";
}

.bxs-message-dots:before {
  content: "\\ecc6";
}

.bxs-message-rounded:before {
  content: "\\ecc7";
}

.bxs-message-rounded-dots:before {
  content: "\\ecc8";
}

.bxs-message-square:before {
  content: "\\ecc9";
}

.bxs-message-square-dots:before {
  content: "\\ecca";
}

.bxs-microphone:before {
  content: "\\eccb";
}

.bxs-microphone-alt:before {
  content: "\\eccc";
}

.bxs-microphone-off:before {
  content: "\\eccd";
}

.bxs-minus-circle:before {
  content: "\\ecce";
}

.bxs-minus-square:before {
  content: "\\eccf";
}

.bxs-mobile:before {
  content: "\\ecd0";
}

.bxs-mobile-vibration:before {
  content: "\\ecd1";
}

.bxs-moon:before {
  content: "\\ecd2";
}

.bxs-mouse:before {
  content: "\\ecd3";
}

.bxs-mouse-alt:before {
  content: "\\ecd4";
}

.bxs-movie:before {
  content: "\\ecd5";
}

.bxs-music:before {
  content: "\\ecd6";
}

.bxs-navigation:before {
  content: "\\ecd7";
}

.bxs-news:before {
  content: "\\ecd8";
}

.bxs-no-entry:before {
  content: "\\ecd9";
}

.bxs-note:before {
  content: "\\ecda";
}

.bxs-notepad:before {
  content: "\\ecdb";
}

.bxs-notification:before {
  content: "\\ecdc";
}

.bxs-notification-off:before {
  content: "\\ecdd";
}

.bxs-offer:before {
  content: "\\ecde";
}

.bxs-package:before {
  content: "\\ecdf";
}

.bxs-paint:before {
  content: "\\ece0";
}

.bxs-paint-roll:before {
  content: "\\ece1";
}

.bxs-palette:before {
  content: "\\ece2";
}

.bxs-paper-plane:before {
  content: "\\ece3";
}

.bxs-parking:before {
  content: "\\ece4";
}

.bxs-paste:before {
  content: "\\ece5";
}

.bxs-pen:before {
  content: "\\ece6";
}

.bxs-pencil:before {
  content: "\\ece7";
}

.bxs-phone:before {
  content: "\\ece8";
}

.bxs-phone-call:before {
  content: "\\ece9";
}

.bxs-phone-incoming:before {
  content: "\\ecea";
}

.bxs-phone-outgoing:before {
  content: "\\eceb";
}

.bxs-photo-album:before {
  content: "\\ecec";
}

.bxs-pie-chart:before {
  content: "\\eced";
}

.bxs-pie-chart-alt:before {
  content: "\\ecee";
}

.bxs-pie-chart-alt-2:before {
  content: "\\ecef";
}

.bxs-pin:before {
  content: "\\ecf0";
}

.bxs-plane:before {
  content: "\\ecf1";
}

.bxs-plane-alt:before {
  content: "\\ecf2";
}

.bxs-plane-land:before {
  content: "\\ecf3";
}

.bxs-planet:before {
  content: "\\ecf4";
}

.bxs-plane-take-off:before {
  content: "\\ecf5";
}

.bxs-playlist:before {
  content: "\\ecf6";
}

.bxs-plug:before {
  content: "\\ecf7";
}

.bxs-plus-circle:before {
  content: "\\ecf8";
}

.bxs-plus-square:before {
  content: "\\ecf9";
}

.bxs-polygon:before {
  content: "\\ecfa";
}

.bxs-printer:before {
  content: "\\ecfb";
}

.bxs-purchase-tag:before {
  content: "\\ecfc";
}

.bxs-purchase-tag-alt:before {
  content: "\\ecfd";
}

.bxs-pyramid:before {
  content: "\\ecfe";
}

.bxs-quote-alt-left:before {
  content: "\\ecff";
}

.bxs-quote-alt-right:before {
  content: "\\ed00";
}

.bxs-quote-left:before {
  content: "\\ed01";
}

.bxs-quote-right:before {
  content: "\\ed02";
}

.bxs-quote-single-left:before {
  content: "\\ed03";
}

.bxs-quote-single-right:before {
  content: "\\ed04";
}

.bxs-radio:before {
  content: "\\ed05";
}

.bxs-receipt:before {
  content: "\\ed06";
}

.bxs-rectangle:before {
  content: "\\ed07";
}

.bxs-rename:before {
  content: "\\ed08";
}

.bxs-report:before {
  content: "\\ed09";
}

.bxs-rewind-circle:before {
  content: "\\ed0a";
}

.bxs-right-arrow:before {
  content: "\\ed0b";
}

.bxs-right-arrow-circle:before {
  content: "\\ed0c";
}

.bxs-right-arrow-square:before {
  content: "\\ed0d";
}

.bxs-right-down-arrow-circle:before {
  content: "\\ed0e";
}

.bxs-right-top-arrow-circle:before {
  content: "\\ed0f";
}

.bxs-rocket:before {
  content: "\\ed10";
}

.bxs-ruler:before {
  content: "\\ed11";
}

.bxs-sad:before {
  content: "\\ed12";
}

.bxs-save:before {
  content: "\\ed13";
}

.bxs-school:before {
  content: "\\ed14";
}

.bxs-search:before {
  content: "\\ed15";
}

.bxs-search-alt-2:before {
  content: "\\ed16";
}

.bxs-select-multiple:before {
  content: "\\ed17";
}

.bxs-send:before {
  content: "\\ed18";
}

.bxs-server:before {
  content: "\\ed19";
}

.bxs-share:before {
  content: "\\ed1a";
}

.bxs-share-alt:before {
  content: "\\ed1b";
}

.bxs-shield:before {
  content: "\\ed1c";
}

.bxs-shield-alt-2:before {
  content: "\\ed1d";
}

.bxs-ship:before {
  content: "\\ed1e";
}

.bxs-shocked:before {
  content: "\\ed1f";
}

.bxs-shopping-bag:before {
  content: "\\ed20";
}

.bxs-shopping-bag-alt:before {
  content: "\\ed21";
}

.bxs-show:before {
  content: "\\ed22";
}

.bxs-skip-next-circle:before {
  content: "\\ed23";
}

.bxs-skip-previous-circle:before {
  content: "\\ed24";
}

.bxs-skull:before {
  content: "\\ed25";
}

.bxs-sleepy:before {
  content: "\\ed26";
}

.bxs-slideshow:before {
  content: "\\ed27";
}

.bxs-smile:before {
  content: "\\ed28";
}

.bxs-sort-alt:before {
  content: "\\ed29";
}

.bxs-spa:before {
  content: "\\ed2a";
}

.bxs-spreadsheet:before {
  content: "\\ed2b";
}

.bxs-square:before {
  content: "\\ed2c";
}

.bxs-square-rounded:before {
  content: "\\ed2d";
}

.bxs-star:before {
  content: "\\ed2e";
}

.bxs-star-half:before {
  content: "\\ed2f";
}

.bxs-stopwatch:before {
  content: "\\ed30";
}

.bxs-store:before {
  content: "\\ed31";
}

.bxs-store-alt:before {
  content: "\\ed32";
}

.bxs-sun:before {
  content: "\\ed33";
}

.bxs-tag:before {
  content: "\\ed34";
}

.bxs-tag-x:before {
  content: "\\ed35";
}

.bxs-taxi:before {
  content: "\\ed36";
}

.bxs-tennis-ball:before {
  content: "\\ed37";
}

.bxs-terminal:before {
  content: "\\ed38";
}

.bxs-time:before {
  content: "\\ed39";
}

.bxs-time-five:before {
  content: "\\ed3a";
}

.bxs-timer:before {
  content: "\\ed3b";
}

.bxs-tired:before {
  content: "\\ed3c";
}

.bxs-toggle-left:before {
  content: "\\ed3d";
}

.bxs-toggle-right:before {
  content: "\\ed3e";
}

.bxs-tone:before {
  content: "\\ed3f";
}

.bxs-torch:before {
  content: "\\ed40";
}

.bxs-to-top:before {
  content: "\\ed41";
}

.bxs-traffic:before {
  content: "\\ed42";
}

.bxs-traffic-barrier:before {
  content: "\\ed43";
}

.bxs-train:before {
  content: "\\ed44";
}

.bxs-trash:before {
  content: "\\ed45";
}

.bxs-trash-alt:before {
  content: "\\ed46";
}

.bxs-tree:before {
  content: "\\ed47";
}

.bxs-trophy:before {
  content: "\\ed48";
}

.bxs-truck:before {
  content: "\\ed49";
}

.bxs-t-shirt:before {
  content: "\\ed4a";
}

.bxs-up-arrow:before {
  content: "\\ed4b";
}

.bxs-up-arrow-circle:before {
  content: "\\ed4c";
}

.bxs-up-arrow-square:before {
  content: "\\ed4d";
}

.bxs-upside-down:before {
  content: "\\ed4e";
}

.bxs-upvote:before {
  content: "\\ed4f";
}

.bxs-user:before {
  content: "\\ed50";
}

.bxs-user-badge:before {
  content: "\\ed51";
}

.bxs-user-check:before {
  content: "\\ed52";
}

.bxs-user-circle:before {
  content: "\\ed53";
}

.bxs-user-detail:before {
  content: "\\ed54";
}

.bxs-user-minus:before {
  content: "\\ed55";
}

.bxs-user-pin:before {
  content: "\\ed56";
}

.bxs-user-plus:before {
  content: "\\ed57";
}

.bxs-user-rectangle:before {
  content: "\\ed58";
}

.bxs-user-voice:before {
  content: "\\ed59";
}

.bxs-user-x:before {
  content: "\\ed5a";
}

.bxs-vial:before {
  content: "\\ed5b";
}

.bxs-video:before {
  content: "\\ed5c";
}

.bxs-video-off:before {
  content: "\\ed5d";
}

.bxs-video-plus:before {
  content: "\\ed5e";
}

.bxs-video-recording:before {
  content: "\\ed5f";
}

.bxs-videos:before {
  content: "\\ed60";
}

.bxs-volume:before {
  content: "\\ed61";
}

.bxs-volume-full:before {
  content: "\\ed62";
}

.bxs-volume-low:before {
  content: "\\ed63";
}

.bxs-volume-mute:before {
  content: "\\ed64";
}

.bxs-wallet:before {
  content: "\\ed65";
}

.bxs-wallet-alt:before {
  content: "\\ed66";
}

.bxs-watch:before {
  content: "\\ed67";
}

.bxs-watch-alt:before {
  content: "\\ed68";
}

.bxs-widget:before {
  content: "\\ed69";
}

.bxs-wine:before {
  content: "\\ed6a";
}

.bxs-wink-smile:before {
  content: "\\ed6b";
}

.bxs-wink-tongue:before {
  content: "\\ed6c";
}

.bxs-wrench:before {
  content: "\\ed6d";
}

.bxs-x-circle:before {
  content: "\\ed6e";
}

.bxs-x-square:before {
  content: "\\ed6f";
}

.bxs-yin-yang:before {
  content: "\\ed70";
}

.bxs-zap:before {
  content: "\\ed71";
}

.bxs-zoom-in:before {
  content: "\\ed72";
}

.bxs-zoom-out:before {
  content: "\\ed73";
}

/*!
 * Font Awesome Free 5.13.0 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */
.fa,
.fas,
.far,
.fal,
.fad,
.fab {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
}

.fa-lg {
  font-size: 1.33333em;
  line-height: 0.75em;
  vertical-align: -0.0667em;
}

.fa-xs {
  font-size: 0.75em;
}

.fa-sm {
  font-size: 0.875em;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: 2.5em;
  padding-left: 0;
}

.fa-ul > li {
  position: relative;
}

.fa-li {
  left: -2em;
  position: absolute;
  text-align: center;
  width: 2em;
  line-height: inherit;
}

.fa-border {
  border: solid 0.08em #eee;
  border-radius: 0.1em;
  padding: 0.2em 0.25em 0.15em;
}

.fa-pull-left {
  float: left;
}

.fa-pull-right {
  float: right;
}

.fa.fa-pull-left,
.fas.fa-pull-left,
.far.fa-pull-left,
.fal.fa-pull-left,
.fab.fa-pull-left {
  margin-right: 0.3em;
}

.fa.fa-pull-right,
.fas.fa-pull-right,
.far.fa-pull-right,
.fal.fa-pull-right,
.fab.fa-pull-right {
  margin-left: 0.3em;
}

.fa-spin {
  animation: fa-spin 2s infinite linear;
}

.fa-pulse {
  animation: fa-spin 1s infinite steps(8);
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";
  transform: rotate(90deg);
}

.fa-rotate-180 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";
  transform: rotate(180deg);
}

.fa-rotate-270 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
  transform: scale(-1, -1);
}

:root .fa-rotate-90,
:root .fa-rotate-180,
:root .fa-rotate-270,
:root .fa-flip-horizontal,
:root .fa-flip-vertical,
:root .fa-flip-both {
  filter: none;
}

.fa-stack {
  display: inline-block;
  height: 2em;
  line-height: 2em;
  position: relative;
  vertical-align: middle;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  left: 0;
  position: absolute;
  text-align: center;
  width: 100%;
}

.fa-stack-1x {
  line-height: inherit;
}

.fa-stack-2x {
  font-size: 2em;
}

.fa-inverse {
  color: #fff;
}

/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen
readers do not read off random characters that represent icons */
.fa-500px:before {
  content: "\\f26e";
}

.fa-accessible-icon:before {
  content: "\\f368";
}

.fa-accusoft:before {
  content: "\\f369";
}

.fa-acquisitions-incorporated:before {
  content: "\\f6af";
}

.fa-ad:before {
  content: "\\f641";
}

.fa-address-book:before {
  content: "\\f2b9";
}

.fa-address-card:before {
  content: "\\f2bb";
}

.fa-adjust:before {
  content: "\\f042";
}

.fa-adn:before {
  content: "\\f170";
}

.fa-adobe:before {
  content: "\\f778";
}

.fa-adversal:before {
  content: "\\f36a";
}

.fa-affiliatetheme:before {
  content: "\\f36b";
}

.fa-air-freshener:before {
  content: "\\f5d0";
}

.fa-airbnb:before {
  content: "\\f834";
}

.fa-algolia:before {
  content: "\\f36c";
}

.fa-align-center:before {
  content: "\\f037";
}

.fa-align-justify:before {
  content: "\\f039";
}

.fa-align-left:before {
  content: "\\f036";
}

.fa-align-right:before {
  content: "\\f038";
}

.fa-alipay:before {
  content: "\\f642";
}

.fa-allergies:before {
  content: "\\f461";
}

.fa-amazon:before {
  content: "\\f270";
}

.fa-amazon-pay:before {
  content: "\\f42c";
}

.fa-ambulance:before {
  content: "\\f0f9";
}

.fa-american-sign-language-interpreting:before {
  content: "\\f2a3";
}

.fa-amilia:before {
  content: "\\f36d";
}

.fa-anchor:before {
  content: "\\f13d";
}

.fa-android:before {
  content: "\\f17b";
}

.fa-angellist:before {
  content: "\\f209";
}

.fa-angle-double-down:before {
  content: "\\f103";
}

.fa-angle-double-left:before {
  content: "\\f100";
}

.fa-angle-double-right:before {
  content: "\\f101";
}

.fa-angle-double-up:before {
  content: "\\f102";
}

.fa-angle-down:before {
  content: "\\f107";
}

.fa-angle-left:before {
  content: "\\f104";
}

.fa-angle-right:before {
  content: "\\f105";
}

.fa-angle-up:before {
  content: "\\f106";
}

.fa-angry:before {
  content: "\\f556";
}

.fa-angrycreative:before {
  content: "\\f36e";
}

.fa-angular:before {
  content: "\\f420";
}

.fa-ankh:before {
  content: "\\f644";
}

.fa-app-store:before {
  content: "\\f36f";
}

.fa-app-store-ios:before {
  content: "\\f370";
}

.fa-apper:before {
  content: "\\f371";
}

.fa-apple:before {
  content: "\\f179";
}

.fa-apple-alt:before {
  content: "\\f5d1";
}

.fa-apple-pay:before {
  content: "\\f415";
}

.fa-archive:before {
  content: "\\f187";
}

.fa-archway:before {
  content: "\\f557";
}

.fa-arrow-alt-circle-down:before {
  content: "\\f358";
}

.fa-arrow-alt-circle-left:before {
  content: "\\f359";
}

.fa-arrow-alt-circle-right:before {
  content: "\\f35a";
}

.fa-arrow-alt-circle-up:before {
  content: "\\f35b";
}

.fa-arrow-circle-down:before {
  content: "\\f0ab";
}

.fa-arrow-circle-left:before {
  content: "\\f0a8";
}

.fa-arrow-circle-right:before {
  content: "\\f0a9";
}

.fa-arrow-circle-up:before {
  content: "\\f0aa";
}

.fa-arrow-down:before {
  content: "\\f063";
}

.fa-arrow-left:before {
  content: "\\f060";
}

.fa-arrow-right:before {
  content: "\\f061";
}

.fa-arrow-up:before {
  content: "\\f062";
}

.fa-arrows-alt:before {
  content: "\\f0b2";
}

.fa-arrows-alt-h:before {
  content: "\\f337";
}

.fa-arrows-alt-v:before {
  content: "\\f338";
}

.fa-artstation:before {
  content: "\\f77a";
}

.fa-assistive-listening-systems:before {
  content: "\\f2a2";
}

.fa-asterisk:before {
  content: "\\f069";
}

.fa-asymmetrik:before {
  content: "\\f372";
}

.fa-at:before {
  content: "\\f1fa";
}

.fa-atlas:before {
  content: "\\f558";
}

.fa-atlassian:before {
  content: "\\f77b";
}

.fa-atom:before {
  content: "\\f5d2";
}

.fa-audible:before {
  content: "\\f373";
}

.fa-audio-description:before {
  content: "\\f29e";
}

.fa-autoprefixer:before {
  content: "\\f41c";
}

.fa-avianex:before {
  content: "\\f374";
}

.fa-aviato:before {
  content: "\\f421";
}

.fa-award:before {
  content: "\\f559";
}

.fa-aws:before {
  content: "\\f375";
}

.fa-baby:before {
  content: "\\f77c";
}

.fa-baby-carriage:before {
  content: "\\f77d";
}

.fa-backspace:before {
  content: "\\f55a";
}

.fa-backward:before {
  content: "\\f04a";
}

.fa-bacon:before {
  content: "\\f7e5";
}

.fa-bahai:before {
  content: "\\f666";
}

.fa-balance-scale:before {
  content: "\\f24e";
}

.fa-balance-scale-left:before {
  content: "\\f515";
}

.fa-balance-scale-right:before {
  content: "\\f516";
}

.fa-ban:before {
  content: "\\f05e";
}

.fa-band-aid:before {
  content: "\\f462";
}

.fa-bandcamp:before {
  content: "\\f2d5";
}

.fa-barcode:before {
  content: "\\f02a";
}

.fa-bars:before {
  content: "\\f0c9";
}

.fa-baseball-ball:before {
  content: "\\f433";
}

.fa-basketball-ball:before {
  content: "\\f434";
}

.fa-bath:before {
  content: "\\f2cd";
}

.fa-battery-empty:before {
  content: "\\f244";
}

.fa-battery-full:before {
  content: "\\f240";
}

.fa-battery-half:before {
  content: "\\f242";
}

.fa-battery-quarter:before {
  content: "\\f243";
}

.fa-battery-three-quarters:before {
  content: "\\f241";
}

.fa-battle-net:before {
  content: "\\f835";
}

.fa-bed:before {
  content: "\\f236";
}

.fa-beer:before {
  content: "\\f0fc";
}

.fa-behance:before {
  content: "\\f1b4";
}

.fa-behance-square:before {
  content: "\\f1b5";
}

.fa-bell:before {
  content: "\\f0f3";
}

.fa-bell-slash:before {
  content: "\\f1f6";
}

.fa-bezier-curve:before {
  content: "\\f55b";
}

.fa-bible:before {
  content: "\\f647";
}

.fa-bicycle:before {
  content: "\\f206";
}

.fa-biking:before {
  content: "\\f84a";
}

.fa-bimobject:before {
  content: "\\f378";
}

.fa-binoculars:before {
  content: "\\f1e5";
}

.fa-biohazard:before {
  content: "\\f780";
}

.fa-birthday-cake:before {
  content: "\\f1fd";
}

.fa-bitbucket:before {
  content: "\\f171";
}

.fa-bitcoin:before {
  content: "\\f379";
}

.fa-bity:before {
  content: "\\f37a";
}

.fa-black-tie:before {
  content: "\\f27e";
}

.fa-blackberry:before {
  content: "\\f37b";
}

.fa-blender:before {
  content: "\\f517";
}

.fa-blender-phone:before {
  content: "\\f6b6";
}

.fa-blind:before {
  content: "\\f29d";
}

.fa-blog:before {
  content: "\\f781";
}

.fa-blogger:before {
  content: "\\f37c";
}

.fa-blogger-b:before {
  content: "\\f37d";
}

.fa-bluetooth:before {
  content: "\\f293";
}

.fa-bluetooth-b:before {
  content: "\\f294";
}

.fa-bold:before {
  content: "\\f032";
}

.fa-bolt:before {
  content: "\\f0e7";
}

.fa-bomb:before {
  content: "\\f1e2";
}

.fa-bone:before {
  content: "\\f5d7";
}

.fa-bong:before {
  content: "\\f55c";
}

.fa-book:before {
  content: "\\f02d";
}

.fa-book-dead:before {
  content: "\\f6b7";
}

.fa-book-medical:before {
  content: "\\f7e6";
}

.fa-book-open:before {
  content: "\\f518";
}

.fa-book-reader:before {
  content: "\\f5da";
}

.fa-bookmark:before {
  content: "\\f02e";
}

.fa-bootstrap:before {
  content: "\\f836";
}

.fa-border-all:before {
  content: "\\f84c";
}

.fa-border-none:before {
  content: "\\f850";
}

.fa-border-style:before {
  content: "\\f853";
}

.fa-bowling-ball:before {
  content: "\\f436";
}

.fa-box:before {
  content: "\\f466";
}

.fa-box-open:before {
  content: "\\f49e";
}

.fa-box-tissue:before {
  content: "拏";
}

.fa-boxes:before {
  content: "\\f468";
}

.fa-braille:before {
  content: "\\f2a1";
}

.fa-brain:before {
  content: "\\f5dc";
}

.fa-bread-slice:before {
  content: "\\f7ec";
}

.fa-briefcase:before {
  content: "\\f0b1";
}

.fa-briefcase-medical:before {
  content: "\\f469";
}

.fa-broadcast-tower:before {
  content: "\\f519";
}

.fa-broom:before {
  content: "\\f51a";
}

.fa-brush:before {
  content: "\\f55d";
}

.fa-btc:before {
  content: "\\f15a";
}

.fa-buffer:before {
  content: "\\f837";
}

.fa-bug:before {
  content: "\\f188";
}

.fa-building:before {
  content: "\\f1ad";
}

.fa-bullhorn:before {
  content: "\\f0a1";
}

.fa-bullseye:before {
  content: "\\f140";
}

.fa-burn:before {
  content: "\\f46a";
}

.fa-buromobelexperte:before {
  content: "\\f37f";
}

.fa-bus:before {
  content: "\\f207";
}

.fa-bus-alt:before {
  content: "\\f55e";
}

.fa-business-time:before {
  content: "\\f64a";
}

.fa-buy-n-large:before {
  content: "\\f8a6";
}

.fa-buysellads:before {
  content: "\\f20d";
}

.fa-calculator:before {
  content: "\\f1ec";
}

.fa-calendar:before {
  content: "\\f133";
}

.fa-calendar-alt:before {
  content: "\\f073";
}

.fa-calendar-check:before {
  content: "\\f274";
}

.fa-calendar-day:before {
  content: "\\f783";
}

.fa-calendar-minus:before {
  content: "\\f272";
}

.fa-calendar-plus:before {
  content: "\\f271";
}

.fa-calendar-times:before {
  content: "\\f273";
}

.fa-calendar-week:before {
  content: "\\f784";
}

.fa-camera:before {
  content: "\\f030";
}

.fa-camera-retro:before {
  content: "\\f083";
}

.fa-campground:before {
  content: "\\f6bb";
}

.fa-canadian-maple-leaf:before {
  content: "\\f785";
}

.fa-candy-cane:before {
  content: "\\f786";
}

.fa-cannabis:before {
  content: "\\f55f";
}

.fa-capsules:before {
  content: "\\f46b";
}

.fa-car:before {
  content: "\\f1b9";
}

.fa-car-alt:before {
  content: "\\f5de";
}

.fa-car-battery:before {
  content: "\\f5df";
}

.fa-car-crash:before {
  content: "\\f5e1";
}

.fa-car-side:before {
  content: "\\f5e4";
}

.fa-caravan:before {
  content: "\\f8ff";
}

.fa-caret-down:before {
  content: "\\f0d7";
}

.fa-caret-left:before {
  content: "\\f0d9";
}

.fa-caret-right:before {
  content: "\\f0da";
}

.fa-caret-square-down:before {
  content: "\\f150";
}

.fa-caret-square-left:before {
  content: "\\f191";
}

.fa-caret-square-right:before {
  content: "\\f152";
}

.fa-caret-square-up:before {
  content: "\\f151";
}

.fa-caret-up:before {
  content: "\\f0d8";
}

.fa-carrot:before {
  content: "\\f787";
}

.fa-cart-arrow-down:before {
  content: "\\f218";
}

.fa-cart-plus:before {
  content: "\\f217";
}

.fa-cash-register:before {
  content: "\\f788";
}

.fa-cat:before {
  content: "\\f6be";
}

.fa-cc-amazon-pay:before {
  content: "\\f42d";
}

.fa-cc-amex:before {
  content: "\\f1f3";
}

.fa-cc-apple-pay:before {
  content: "\\f416";
}

.fa-cc-diners-club:before {
  content: "\\f24c";
}

.fa-cc-discover:before {
  content: "\\f1f2";
}

.fa-cc-jcb:before {
  content: "\\f24b";
}

.fa-cc-mastercard:before {
  content: "\\f1f1";
}

.fa-cc-paypal:before {
  content: "\\f1f4";
}

.fa-cc-stripe:before {
  content: "\\f1f5";
}

.fa-cc-visa:before {
  content: "\\f1f0";
}

.fa-centercode:before {
  content: "\\f380";
}

.fa-centos:before {
  content: "\\f789";
}

.fa-certificate:before {
  content: "\\f0a3";
}

.fa-chair:before {
  content: "\\f6c0";
}

.fa-chalkboard:before {
  content: "\\f51b";
}

.fa-chalkboard-teacher:before {
  content: "\\f51c";
}

.fa-charging-station:before {
  content: "\\f5e7";
}

.fa-chart-area:before {
  content: "\\f1fe";
}

.fa-chart-bar:before {
  content: "\\f080";
}

.fa-chart-line:before {
  content: "\\f201";
}

.fa-chart-pie:before {
  content: "\\f200";
}

.fa-check:before {
  content: "\\f00c";
}

.fa-check-circle:before {
  content: "\\f058";
}

.fa-check-double:before {
  content: "\\f560";
}

.fa-check-square:before {
  content: "\\f14a";
}

.fa-cheese:before {
  content: "\\f7ef";
}

.fa-chess:before {
  content: "\\f439";
}

.fa-chess-bishop:before {
  content: "\\f43a";
}

.fa-chess-board:before {
  content: "\\f43c";
}

.fa-chess-king:before {
  content: "\\f43f";
}

.fa-chess-knight:before {
  content: "\\f441";
}

.fa-chess-pawn:before {
  content: "\\f443";
}

.fa-chess-queen:before {
  content: "\\f445";
}

.fa-chess-rook:before {
  content: "\\f447";
}

.fa-chevron-circle-down:before {
  content: "\\f13a";
}

.fa-chevron-circle-left:before {
  content: "\\f137";
}

.fa-chevron-circle-right:before {
  content: "\\f138";
}

.fa-chevron-circle-up:before {
  content: "\\f139";
}

.fa-chevron-down:before {
  content: "\\f078";
}

.fa-chevron-left:before {
  content: "\\f053";
}

.fa-chevron-right:before {
  content: "\\f054";
}

.fa-chevron-up:before {
  content: "\\f077";
}

.fa-child:before {
  content: "\\f1ae";
}

.fa-chrome:before {
  content: "\\f268";
}

.fa-chromecast:before {
  content: "\\f838";
}

.fa-church:before {
  content: "\\f51d";
}

.fa-circle:before {
  content: "\\f111";
}

.fa-circle-notch:before {
  content: "\\f1ce";
}

.fa-city:before {
  content: "\\f64f";
}

.fa-clinic-medical:before {
  content: "\\f7f2";
}

.fa-clipboard:before {
  content: "\\f328";
}

.fa-clipboard-check:before {
  content: "\\f46c";
}

.fa-clipboard-list:before {
  content: "\\f46d";
}

.fa-clock:before {
  content: "\\f017";
}

.fa-clone:before {
  content: "\\f24d";
}

.fa-closed-captioning:before {
  content: "\\f20a";
}

.fa-cloud:before {
  content: "\\f0c2";
}

.fa-cloud-download-alt:before {
  content: "\\f381";
}

.fa-cloud-meatball:before {
  content: "\\f73b";
}

.fa-cloud-moon:before {
  content: "\\f6c3";
}

.fa-cloud-moon-rain:before {
  content: "\\f73c";
}

.fa-cloud-rain:before {
  content: "\\f73d";
}

.fa-cloud-showers-heavy:before {
  content: "\\f740";
}

.fa-cloud-sun:before {
  content: "\\f6c4";
}

.fa-cloud-sun-rain:before {
  content: "\\f743";
}

.fa-cloud-upload-alt:before {
  content: "\\f382";
}

.fa-cloudscale:before {
  content: "\\f383";
}

.fa-cloudsmith:before {
  content: "\\f384";
}

.fa-cloudversify:before {
  content: "\\f385";
}

.fa-cocktail:before {
  content: "\\f561";
}

.fa-code:before {
  content: "\\f121";
}

.fa-code-branch:before {
  content: "\\f126";
}

.fa-codepen:before {
  content: "\\f1cb";
}

.fa-codiepie:before {
  content: "\\f284";
}

.fa-coffee:before {
  content: "\\f0f4";
}

.fa-cog:before {
  content: "\\f013";
}

.fa-cogs:before {
  content: "\\f085";
}

.fa-coins:before {
  content: "\\f51e";
}

.fa-columns:before {
  content: "\\f0db";
}

.fa-comment:before {
  content: "\\f075";
}

.fa-comment-alt:before {
  content: "\\f27a";
}

.fa-comment-dollar:before {
  content: "\\f651";
}

.fa-comment-dots:before {
  content: "\\f4ad";
}

.fa-comment-medical:before {
  content: "\\f7f5";
}

.fa-comment-slash:before {
  content: "\\f4b3";
}

.fa-comments:before {
  content: "\\f086";
}

.fa-comments-dollar:before {
  content: "\\f653";
}

.fa-compact-disc:before {
  content: "\\f51f";
}

.fa-compass:before {
  content: "\\f14e";
}

.fa-compress:before {
  content: "\\f066";
}

.fa-compress-alt:before {
  content: "\\f422";
}

.fa-compress-arrows-alt:before {
  content: "\\f78c";
}

.fa-concierge-bell:before {
  content: "\\f562";
}

.fa-confluence:before {
  content: "\\f78d";
}

.fa-connectdevelop:before {
  content: "\\f20e";
}

.fa-contao:before {
  content: "\\f26d";
}

.fa-cookie:before {
  content: "\\f563";
}

.fa-cookie-bite:before {
  content: "\\f564";
}

.fa-copy:before {
  content: "\\f0c5";
}

.fa-copyright:before {
  content: "\\f1f9";
}

.fa-cotton-bureau:before {
  content: "\\f89e";
}

.fa-couch:before {
  content: "\\f4b8";
}

.fa-cpanel:before {
  content: "\\f388";
}

.fa-creative-commons:before {
  content: "\\f25e";
}

.fa-creative-commons-by:before {
  content: "\\f4e7";
}

.fa-creative-commons-nc:before {
  content: "\\f4e8";
}

.fa-creative-commons-nc-eu:before {
  content: "\\f4e9";
}

.fa-creative-commons-nc-jp:before {
  content: "\\f4ea";
}

.fa-creative-commons-nd:before {
  content: "\\f4eb";
}

.fa-creative-commons-pd:before {
  content: "\\f4ec";
}

.fa-creative-commons-pd-alt:before {
  content: "\\f4ed";
}

.fa-creative-commons-remix:before {
  content: "\\f4ee";
}

.fa-creative-commons-sa:before {
  content: "\\f4ef";
}

.fa-creative-commons-sampling:before {
  content: "\\f4f0";
}

.fa-creative-commons-sampling-plus:before {
  content: "\\f4f1";
}

.fa-creative-commons-share:before {
  content: "\\f4f2";
}

.fa-creative-commons-zero:before {
  content: "\\f4f3";
}

.fa-credit-card:before {
  content: "\\f09d";
}

.fa-critical-role:before {
  content: "\\f6c9";
}

.fa-crop:before {
  content: "\\f125";
}

.fa-crop-alt:before {
  content: "\\f565";
}

.fa-cross:before {
  content: "\\f654";
}

.fa-crosshairs:before {
  content: "\\f05b";
}

.fa-crow:before {
  content: "\\f520";
}

.fa-crown:before {
  content: "\\f521";
}

.fa-crutch:before {
  content: "\\f7f7";
}

.fa-css3:before {
  content: "\\f13c";
}

.fa-css3-alt:before {
  content: "\\f38b";
}

.fa-cube:before {
  content: "\\f1b2";
}

.fa-cubes:before {
  content: "\\f1b3";
}

.fa-cut:before {
  content: "\\f0c4";
}

.fa-cuttlefish:before {
  content: "\\f38c";
}

.fa-d-and-d:before {
  content: "\\f38d";
}

.fa-d-and-d-beyond:before {
  content: "\\f6ca";
}

.fa-dailymotion:before {
  content: "勒";
}

.fa-dashcube:before {
  content: "\\f210";
}

.fa-database:before {
  content: "\\f1c0";
}

.fa-deaf:before {
  content: "\\f2a4";
}

.fa-delicious:before {
  content: "\\f1a5";
}

.fa-democrat:before {
  content: "\\f747";
}

.fa-deploydog:before {
  content: "\\f38e";
}

.fa-deskpro:before {
  content: "\\f38f";
}

.fa-desktop:before {
  content: "\\f108";
}

.fa-dev:before {
  content: "\\f6cc";
}

.fa-deviantart:before {
  content: "\\f1bd";
}

.fa-dharmachakra:before {
  content: "\\f655";
}

.fa-dhl:before {
  content: "\\f790";
}

.fa-diagnoses:before {
  content: "\\f470";
}

.fa-diaspora:before {
  content: "\\f791";
}

.fa-dice:before {
  content: "\\f522";
}

.fa-dice-d20:before {
  content: "\\f6cf";
}

.fa-dice-d6:before {
  content: "\\f6d1";
}

.fa-dice-five:before {
  content: "\\f523";
}

.fa-dice-four:before {
  content: "\\f524";
}

.fa-dice-one:before {
  content: "\\f525";
}

.fa-dice-six:before {
  content: "\\f526";
}

.fa-dice-three:before {
  content: "\\f527";
}

.fa-dice-two:before {
  content: "\\f528";
}

.fa-digg:before {
  content: "\\f1a6";
}

.fa-digital-ocean:before {
  content: "\\f391";
}

.fa-digital-tachograph:before {
  content: "\\f566";
}

.fa-directions:before {
  content: "\\f5eb";
}

.fa-discord:before {
  content: "\\f392";
}

.fa-discourse:before {
  content: "\\f393";
}

.fa-disease:before {
  content: "\\f7fa";
}

.fa-divide:before {
  content: "\\f529";
}

.fa-dizzy:before {
  content: "\\f567";
}

.fa-dna:before {
  content: "\\f471";
}

.fa-dochub:before {
  content: "\\f394";
}

.fa-docker:before {
  content: "\\f395";
}

.fa-dog:before {
  content: "\\f6d3";
}

.fa-dollar-sign:before {
  content: "\\f155";
}

.fa-dolly:before {
  content: "\\f472";
}

.fa-dolly-flatbed:before {
  content: "\\f474";
}

.fa-donate:before {
  content: "\\f4b9";
}

.fa-door-closed:before {
  content: "\\f52a";
}

.fa-door-open:before {
  content: "\\f52b";
}

.fa-dot-circle:before {
  content: "\\f192";
}

.fa-dove:before {
  content: "\\f4ba";
}

.fa-download:before {
  content: "\\f019";
}

.fa-draft2digital:before {
  content: "\\f396";
}

.fa-drafting-compass:before {
  content: "\\f568";
}

.fa-dragon:before {
  content: "\\f6d5";
}

.fa-draw-polygon:before {
  content: "\\f5ee";
}

.fa-dribbble:before {
  content: "\\f17d";
}

.fa-dribbble-square:before {
  content: "\\f397";
}

.fa-dropbox:before {
  content: "\\f16b";
}

.fa-drum:before {
  content: "\\f569";
}

.fa-drum-steelpan:before {
  content: "\\f56a";
}

.fa-drumstick-bite:before {
  content: "\\f6d7";
}

.fa-drupal:before {
  content: "\\f1a9";
}

.fa-dumbbell:before {
  content: "\\f44b";
}

.fa-dumpster:before {
  content: "\\f793";
}

.fa-dumpster-fire:before {
  content: "\\f794";
}

.fa-dungeon:before {
  content: "\\f6d9";
}

.fa-dyalog:before {
  content: "\\f399";
}

.fa-earlybirds:before {
  content: "\\f39a";
}

.fa-ebay:before {
  content: "\\f4f4";
}

.fa-edge:before {
  content: "\\f282";
}

.fa-edit:before {
  content: "\\f044";
}

.fa-egg:before {
  content: "\\f7fb";
}

.fa-eject:before {
  content: "\\f052";
}

.fa-elementor:before {
  content: "\\f430";
}

.fa-ellipsis-h:before {
  content: "\\f141";
}

.fa-ellipsis-v:before {
  content: "\\f142";
}

.fa-ello:before {
  content: "\\f5f1";
}

.fa-ember:before {
  content: "\\f423";
}

.fa-empire:before {
  content: "\\f1d1";
}

.fa-envelope:before {
  content: "\\f0e0";
}

.fa-envelope-open:before {
  content: "\\f2b6";
}

.fa-envelope-open-text:before {
  content: "\\f658";
}

.fa-envelope-square:before {
  content: "\\f199";
}

.fa-envira:before {
  content: "\\f299";
}

.fa-equals:before {
  content: "\\f52c";
}

.fa-eraser:before {
  content: "\\f12d";
}

.fa-erlang:before {
  content: "\\f39d";
}

.fa-ethereum:before {
  content: "\\f42e";
}

.fa-ethernet:before {
  content: "\\f796";
}

.fa-etsy:before {
  content: "\\f2d7";
}

.fa-euro-sign:before {
  content: "\\f153";
}

.fa-evernote:before {
  content: "\\f839";
}

.fa-exchange-alt:before {
  content: "\\f362";
}

.fa-exclamation:before {
  content: "\\f12a";
}

.fa-exclamation-circle:before {
  content: "\\f06a";
}

.fa-exclamation-triangle:before {
  content: "\\f071";
}

.fa-expand:before {
  content: "\\f065";
}

.fa-expand-alt:before {
  content: "\\f424";
}

.fa-expand-arrows-alt:before {
  content: "\\f31e";
}

.fa-expeditedssl:before {
  content: "\\f23e";
}

.fa-external-link-alt:before {
  content: "\\f35d";
}

.fa-external-link-square-alt:before {
  content: "\\f360";
}

.fa-eye:before {
  content: "\\f06e";
}

.fa-eye-dropper:before {
  content: "\\f1fb";
}

.fa-eye-slash:before {
  content: "\\f070";
}

.fa-facebook:before {
  content: "\\f09a";
}

.fa-facebook-f:before {
  content: "\\f39e";
}

.fa-facebook-messenger:before {
  content: "\\f39f";
}

.fa-facebook-square:before {
  content: "\\f082";
}

.fa-fan:before {
  content: "\\f863";
}

.fa-fantasy-flight-games:before {
  content: "\\f6dc";
}

.fa-fast-backward:before {
  content: "\\f049";
}

.fa-fast-forward:before {
  content: "\\f050";
}

.fa-faucet:before {
  content: "串";
}

.fa-fax:before {
  content: "\\f1ac";
}

.fa-feather:before {
  content: "\\f52d";
}

.fa-feather-alt:before {
  content: "\\f56b";
}

.fa-fedex:before {
  content: "\\f797";
}

.fa-fedora:before {
  content: "\\f798";
}

.fa-female:before {
  content: "\\f182";
}

.fa-fighter-jet:before {
  content: "\\f0fb";
}

.fa-figma:before {
  content: "\\f799";
}

.fa-file:before {
  content: "\\f15b";
}

.fa-file-alt:before {
  content: "\\f15c";
}

.fa-file-archive:before {
  content: "\\f1c6";
}

.fa-file-audio:before {
  content: "\\f1c7";
}

.fa-file-code:before {
  content: "\\f1c9";
}

.fa-file-contract:before {
  content: "\\f56c";
}

.fa-file-csv:before {
  content: "\\f6dd";
}

.fa-file-download:before {
  content: "\\f56d";
}

.fa-file-excel:before {
  content: "\\f1c3";
}

.fa-file-export:before {
  content: "\\f56e";
}

.fa-file-image:before {
  content: "\\f1c5";
}

.fa-file-import:before {
  content: "\\f56f";
}

.fa-file-invoice:before {
  content: "\\f570";
}

.fa-file-invoice-dollar:before {
  content: "\\f571";
}

.fa-file-medical:before {
  content: "\\f477";
}

.fa-file-medical-alt:before {
  content: "\\f478";
}

.fa-file-pdf:before {
  content: "\\f1c1";
}

.fa-file-powerpoint:before {
  content: "\\f1c4";
}

.fa-file-prescription:before {
  content: "\\f572";
}

.fa-file-signature:before {
  content: "\\f573";
}

.fa-file-upload:before {
  content: "\\f574";
}

.fa-file-video:before {
  content: "\\f1c8";
}

.fa-file-word:before {
  content: "\\f1c2";
}

.fa-fill:before {
  content: "\\f575";
}

.fa-fill-drip:before {
  content: "\\f576";
}

.fa-film:before {
  content: "\\f008";
}

.fa-filter:before {
  content: "\\f0b0";
}

.fa-fingerprint:before {
  content: "\\f577";
}

.fa-fire:before {
  content: "\\f06d";
}

.fa-fire-alt:before {
  content: "\\f7e4";
}

.fa-fire-extinguisher:before {
  content: "\\f134";
}

.fa-firefox:before {
  content: "\\f269";
}

.fa-firefox-browser:before {
  content: "龜";
}

.fa-first-aid:before {
  content: "\\f479";
}

.fa-first-order:before {
  content: "\\f2b0";
}

.fa-first-order-alt:before {
  content: "\\f50a";
}

.fa-firstdraft:before {
  content: "\\f3a1";
}

.fa-fish:before {
  content: "\\f578";
}

.fa-fist-raised:before {
  content: "\\f6de";
}

.fa-flag:before {
  content: "\\f024";
}

.fa-flag-checkered:before {
  content: "\\f11e";
}

.fa-flag-usa:before {
  content: "\\f74d";
}

.fa-flask:before {
  content: "\\f0c3";
}

.fa-flickr:before {
  content: "\\f16e";
}

.fa-flipboard:before {
  content: "\\f44d";
}

.fa-flushed:before {
  content: "\\f579";
}

.fa-fly:before {
  content: "\\f417";
}

.fa-folder:before {
  content: "\\f07b";
}

.fa-folder-minus:before {
  content: "\\f65d";
}

.fa-folder-open:before {
  content: "\\f07c";
}

.fa-folder-plus:before {
  content: "\\f65e";
}

.fa-font:before {
  content: "\\f031";
}

.fa-font-awesome:before {
  content: "\\f2b4";
}

.fa-font-awesome-alt:before {
  content: "\\f35c";
}

.fa-font-awesome-flag:before {
  content: "\\f425";
}

.fa-font-awesome-logo-full:before {
  content: "\\f4e6";
}

.fa-fonticons:before {
  content: "\\f280";
}

.fa-fonticons-fi:before {
  content: "\\f3a2";
}

.fa-football-ball:before {
  content: "\\f44e";
}

.fa-fort-awesome:before {
  content: "\\f286";
}

.fa-fort-awesome-alt:before {
  content: "\\f3a3";
}

.fa-forumbee:before {
  content: "\\f211";
}

.fa-forward:before {
  content: "\\f04e";
}

.fa-foursquare:before {
  content: "\\f180";
}

.fa-free-code-camp:before {
  content: "\\f2c5";
}

.fa-freebsd:before {
  content: "\\f3a4";
}

.fa-frog:before {
  content: "\\f52e";
}

.fa-frown:before {
  content: "\\f119";
}

.fa-frown-open:before {
  content: "\\f57a";
}

.fa-fulcrum:before {
  content: "\\f50b";
}

.fa-funnel-dollar:before {
  content: "\\f662";
}

.fa-futbol:before {
  content: "\\f1e3";
}

.fa-galactic-republic:before {
  content: "\\f50c";
}

.fa-galactic-senate:before {
  content: "\\f50d";
}

.fa-gamepad:before {
  content: "\\f11b";
}

.fa-gas-pump:before {
  content: "\\f52f";
}

.fa-gavel:before {
  content: "\\f0e3";
}

.fa-gem:before {
  content: "\\f3a5";
}

.fa-genderless:before {
  content: "\\f22d";
}

.fa-get-pocket:before {
  content: "\\f265";
}

.fa-gg:before {
  content: "\\f260";
}

.fa-gg-circle:before {
  content: "\\f261";
}

.fa-ghost:before {
  content: "\\f6e2";
}

.fa-gift:before {
  content: "\\f06b";
}

.fa-gifts:before {
  content: "\\f79c";
}

.fa-git:before {
  content: "\\f1d3";
}

.fa-git-alt:before {
  content: "\\f841";
}

.fa-git-square:before {
  content: "\\f1d2";
}

.fa-github:before {
  content: "\\f09b";
}

.fa-github-alt:before {
  content: "\\f113";
}

.fa-github-square:before {
  content: "\\f092";
}

.fa-gitkraken:before {
  content: "\\f3a6";
}

.fa-gitlab:before {
  content: "\\f296";
}

.fa-gitter:before {
  content: "\\f426";
}

.fa-glass-cheers:before {
  content: "\\f79f";
}

.fa-glass-martini:before {
  content: "\\f000";
}

.fa-glass-martini-alt:before {
  content: "\\f57b";
}

.fa-glass-whiskey:before {
  content: "\\f7a0";
}

.fa-glasses:before {
  content: "\\f530";
}

.fa-glide:before {
  content: "\\f2a5";
}

.fa-glide-g:before {
  content: "\\f2a6";
}

.fa-globe:before {
  content: "\\f0ac";
}

.fa-globe-africa:before {
  content: "\\f57c";
}

.fa-globe-americas:before {
  content: "\\f57d";
}

.fa-globe-asia:before {
  content: "\\f57e";
}

.fa-globe-europe:before {
  content: "\\f7a2";
}

.fa-gofore:before {
  content: "\\f3a7";
}

.fa-golf-ball:before {
  content: "\\f450";
}

.fa-goodreads:before {
  content: "\\f3a8";
}

.fa-goodreads-g:before {
  content: "\\f3a9";
}

.fa-google:before {
  content: "\\f1a0";
}

.fa-google-drive:before {
  content: "\\f3aa";
}

.fa-google-play:before {
  content: "\\f3ab";
}

.fa-google-plus:before {
  content: "\\f2b3";
}

.fa-google-plus-g:before {
  content: "\\f0d5";
}

.fa-google-plus-square:before {
  content: "\\f0d4";
}

.fa-google-wallet:before {
  content: "\\f1ee";
}

.fa-gopuram:before {
  content: "\\f664";
}

.fa-graduation-cap:before {
  content: "\\f19d";
}

.fa-gratipay:before {
  content: "\\f184";
}

.fa-grav:before {
  content: "\\f2d6";
}

.fa-greater-than:before {
  content: "\\f531";
}

.fa-greater-than-equal:before {
  content: "\\f532";
}

.fa-grimace:before {
  content: "\\f57f";
}

.fa-grin:before {
  content: "\\f580";
}

.fa-grin-alt:before {
  content: "\\f581";
}

.fa-grin-beam:before {
  content: "\\f582";
}

.fa-grin-beam-sweat:before {
  content: "\\f583";
}

.fa-grin-hearts:before {
  content: "\\f584";
}

.fa-grin-squint:before {
  content: "\\f585";
}

.fa-grin-squint-tears:before {
  content: "\\f586";
}

.fa-grin-stars:before {
  content: "\\f587";
}

.fa-grin-tears:before {
  content: "\\f588";
}

.fa-grin-tongue:before {
  content: "\\f589";
}

.fa-grin-tongue-squint:before {
  content: "\\f58a";
}

.fa-grin-tongue-wink:before {
  content: "\\f58b";
}

.fa-grin-wink:before {
  content: "\\f58c";
}

.fa-grip-horizontal:before {
  content: "\\f58d";
}

.fa-grip-lines:before {
  content: "\\f7a4";
}

.fa-grip-lines-vertical:before {
  content: "\\f7a5";
}

.fa-grip-vertical:before {
  content: "\\f58e";
}

.fa-gripfire:before {
  content: "\\f3ac";
}

.fa-grunt:before {
  content: "\\f3ad";
}

.fa-guitar:before {
  content: "\\f7a6";
}

.fa-gulp:before {
  content: "\\f3ae";
}

.fa-h-square:before {
  content: "\\f0fd";
}

.fa-hacker-news:before {
  content: "\\f1d4";
}

.fa-hacker-news-square:before {
  content: "\\f3af";
}

.fa-hackerrank:before {
  content: "\\f5f7";
}

.fa-hamburger:before {
  content: "\\f805";
}

.fa-hammer:before {
  content: "\\f6e3";
}

.fa-hamsa:before {
  content: "\\f665";
}

.fa-hand-holding:before {
  content: "\\f4bd";
}

.fa-hand-holding-heart:before {
  content: "\\f4be";
}

.fa-hand-holding-medical:before {
  content: "樂";
}

.fa-hand-holding-usd:before {
  content: "\\f4c0";
}

.fa-hand-holding-water:before {
  content: "\\f4c1";
}

.fa-hand-lizard:before {
  content: "\\f258";
}

.fa-hand-middle-finger:before {
  content: "\\f806";
}

.fa-hand-paper:before {
  content: "\\f256";
}

.fa-hand-peace:before {
  content: "\\f25b";
}

.fa-hand-point-down:before {
  content: "\\f0a7";
}

.fa-hand-point-left:before {
  content: "\\f0a5";
}

.fa-hand-point-right:before {
  content: "\\f0a4";
}

.fa-hand-point-up:before {
  content: "\\f0a6";
}

.fa-hand-pointer:before {
  content: "\\f25a";
}

.fa-hand-rock:before {
  content: "\\f255";
}

.fa-hand-scissors:before {
  content: "\\f257";
}

.fa-hand-sparkles:before {
  content: "諾";
}

.fa-hand-spock:before {
  content: "\\f259";
}

.fa-hands:before {
  content: "\\f4c2";
}

.fa-hands-helping:before {
  content: "\\f4c4";
}

.fa-hands-wash:before {
  content: "丹";
}

.fa-handshake:before {
  content: "\\f2b5";
}

.fa-handshake-alt-slash:before {
  content: "寧";
}

.fa-handshake-slash:before {
  content: "怒";
}

.fa-hanukiah:before {
  content: "\\f6e6";
}

.fa-hard-hat:before {
  content: "\\f807";
}

.fa-hashtag:before {
  content: "\\f292";
}

.fa-hat-cowboy:before {
  content: "\\f8c0";
}

.fa-hat-cowboy-side:before {
  content: "\\f8c1";
}

.fa-hat-wizard:before {
  content: "\\f6e8";
}

.fa-hdd:before {
  content: "\\f0a0";
}

.fa-head-side-cough:before {
  content: "率";
}

.fa-head-side-cough-slash:before {
  content: "異";
}

.fa-head-side-mask:before {
  content: "北";
}

.fa-head-side-virus:before {
  content: "磻";
}

.fa-heading:before {
  content: "\\f1dc";
}

.fa-headphones:before {
  content: "\\f025";
}

.fa-headphones-alt:before {
  content: "\\f58f";
}

.fa-headset:before {
  content: "\\f590";
}

.fa-heart:before {
  content: "\\f004";
}

.fa-heart-broken:before {
  content: "\\f7a9";
}

.fa-heartbeat:before {
  content: "\\f21e";
}

.fa-helicopter:before {
  content: "\\f533";
}

.fa-highlighter:before {
  content: "\\f591";
}

.fa-hiking:before {
  content: "\\f6ec";
}

.fa-hippo:before {
  content: "\\f6ed";
}

.fa-hips:before {
  content: "\\f452";
}

.fa-hire-a-helper:before {
  content: "\\f3b0";
}

.fa-history:before {
  content: "\\f1da";
}

.fa-hockey-puck:before {
  content: "\\f453";
}

.fa-holly-berry:before {
  content: "\\f7aa";
}

.fa-home:before {
  content: "\\f015";
}

.fa-hooli:before {
  content: "\\f427";
}

.fa-hornbill:before {
  content: "\\f592";
}

.fa-horse:before {
  content: "\\f6f0";
}

.fa-horse-head:before {
  content: "\\f7ab";
}

.fa-hospital:before {
  content: "\\f0f8";
}

.fa-hospital-alt:before {
  content: "\\f47d";
}

.fa-hospital-symbol:before {
  content: "\\f47e";
}

.fa-hospital-user:before {
  content: "\\f80d";
}

.fa-hot-tub:before {
  content: "\\f593";
}

.fa-hotdog:before {
  content: "\\f80f";
}

.fa-hotel:before {
  content: "\\f594";
}

.fa-hotjar:before {
  content: "\\f3b1";
}

.fa-hourglass:before {
  content: "\\f254";
}

.fa-hourglass-end:before {
  content: "\\f253";
}

.fa-hourglass-half:before {
  content: "\\f252";
}

.fa-hourglass-start:before {
  content: "\\f251";
}

.fa-house-damage:before {
  content: "\\f6f1";
}

.fa-house-user:before {
  content: "便";
}

.fa-houzz:before {
  content: "\\f27c";
}

.fa-hryvnia:before {
  content: "\\f6f2";
}

.fa-html5:before {
  content: "\\f13b";
}

.fa-hubspot:before {
  content: "\\f3b2";
}

.fa-i-cursor:before {
  content: "\\f246";
}

.fa-ice-cream:before {
  content: "\\f810";
}

.fa-icicles:before {
  content: "\\f7ad";
}

.fa-icons:before {
  content: "\\f86d";
}

.fa-id-badge:before {
  content: "\\f2c1";
}

.fa-id-card:before {
  content: "\\f2c2";
}

.fa-id-card-alt:before {
  content: "\\f47f";
}

.fa-ideal:before {
  content: "邏";
}

.fa-igloo:before {
  content: "\\f7ae";
}

.fa-image:before {
  content: "\\f03e";
}

.fa-images:before {
  content: "\\f302";
}

.fa-imdb:before {
  content: "\\f2d8";
}

.fa-inbox:before {
  content: "\\f01c";
}

.fa-indent:before {
  content: "\\f03c";
}

.fa-industry:before {
  content: "\\f275";
}

.fa-infinity:before {
  content: "\\f534";
}

.fa-info:before {
  content: "\\f129";
}

.fa-info-circle:before {
  content: "\\f05a";
}

.fa-instagram:before {
  content: "\\f16d";
}

.fa-instagram-square:before {
  content: "凌";
}

.fa-intercom:before {
  content: "\\f7af";
}

.fa-internet-explorer:before {
  content: "\\f26b";
}

.fa-invision:before {
  content: "\\f7b0";
}

.fa-ioxhost:before {
  content: "\\f208";
}

.fa-italic:before {
  content: "\\f033";
}

.fa-itch-io:before {
  content: "\\f83a";
}

.fa-itunes:before {
  content: "\\f3b4";
}

.fa-itunes-note:before {
  content: "\\f3b5";
}

.fa-java:before {
  content: "\\f4e4";
}

.fa-jedi:before {
  content: "\\f669";
}

.fa-jedi-order:before {
  content: "\\f50e";
}

.fa-jenkins:before {
  content: "\\f3b6";
}

.fa-jira:before {
  content: "\\f7b1";
}

.fa-joget:before {
  content: "\\f3b7";
}

.fa-joint:before {
  content: "\\f595";
}

.fa-joomla:before {
  content: "\\f1aa";
}

.fa-journal-whills:before {
  content: "\\f66a";
}

.fa-js:before {
  content: "\\f3b8";
}

.fa-js-square:before {
  content: "\\f3b9";
}

.fa-jsfiddle:before {
  content: "\\f1cc";
}

.fa-kaaba:before {
  content: "\\f66b";
}

.fa-kaggle:before {
  content: "\\f5fa";
}

.fa-key:before {
  content: "\\f084";
}

.fa-keybase:before {
  content: "\\f4f5";
}

.fa-keyboard:before {
  content: "\\f11c";
}

.fa-keycdn:before {
  content: "\\f3ba";
}

.fa-khanda:before {
  content: "\\f66d";
}

.fa-kickstarter:before {
  content: "\\f3bb";
}

.fa-kickstarter-k:before {
  content: "\\f3bc";
}

.fa-kiss:before {
  content: "\\f596";
}

.fa-kiss-beam:before {
  content: "\\f597";
}

.fa-kiss-wink-heart:before {
  content: "\\f598";
}

.fa-kiwi-bird:before {
  content: "\\f535";
}

.fa-korvue:before {
  content: "\\f42f";
}

.fa-landmark:before {
  content: "\\f66f";
}

.fa-language:before {
  content: "\\f1ab";
}

.fa-laptop:before {
  content: "\\f109";
}

.fa-laptop-code:before {
  content: "\\f5fc";
}

.fa-laptop-house:before {
  content: "復";
}

.fa-laptop-medical:before {
  content: "\\f812";
}

.fa-laravel:before {
  content: "\\f3bd";
}

.fa-lastfm:before {
  content: "\\f202";
}

.fa-lastfm-square:before {
  content: "\\f203";
}

.fa-laugh:before {
  content: "\\f599";
}

.fa-laugh-beam:before {
  content: "\\f59a";
}

.fa-laugh-squint:before {
  content: "\\f59b";
}

.fa-laugh-wink:before {
  content: "\\f59c";
}

.fa-layer-group:before {
  content: "\\f5fd";
}

.fa-leaf:before {
  content: "\\f06c";
}

.fa-leanpub:before {
  content: "\\f212";
}

.fa-lemon:before {
  content: "\\f094";
}

.fa-less:before {
  content: "\\f41d";
}

.fa-less-than:before {
  content: "\\f536";
}

.fa-less-than-equal:before {
  content: "\\f537";
}

.fa-level-down-alt:before {
  content: "\\f3be";
}

.fa-level-up-alt:before {
  content: "\\f3bf";
}

.fa-life-ring:before {
  content: "\\f1cd";
}

.fa-lightbulb:before {
  content: "\\f0eb";
}

.fa-line:before {
  content: "\\f3c0";
}

.fa-link:before {
  content: "\\f0c1";
}

.fa-linkedin:before {
  content: "\\f08c";
}

.fa-linkedin-in:before {
  content: "\\f0e1";
}

.fa-linode:before {
  content: "\\f2b8";
}

.fa-linux:before {
  content: "\\f17c";
}

.fa-lira-sign:before {
  content: "\\f195";
}

.fa-list:before {
  content: "\\f03a";
}

.fa-list-alt:before {
  content: "\\f022";
}

.fa-list-ol:before {
  content: "\\f0cb";
}

.fa-list-ul:before {
  content: "\\f0ca";
}

.fa-location-arrow:before {
  content: "\\f124";
}

.fa-lock:before {
  content: "\\f023";
}

.fa-lock-open:before {
  content: "\\f3c1";
}

.fa-long-arrow-alt-down:before {
  content: "\\f309";
}

.fa-long-arrow-alt-left:before {
  content: "\\f30a";
}

.fa-long-arrow-alt-right:before {
  content: "\\f30b";
}

.fa-long-arrow-alt-up:before {
  content: "\\f30c";
}

.fa-low-vision:before {
  content: "\\f2a8";
}

.fa-luggage-cart:before {
  content: "\\f59d";
}

.fa-lungs:before {
  content: "\\f604";
}

.fa-lungs-virus:before {
  content: "不";
}

.fa-lyft:before {
  content: "\\f3c3";
}

.fa-magento:before {
  content: "\\f3c4";
}

.fa-magic:before {
  content: "\\f0d0";
}

.fa-magnet:before {
  content: "\\f076";
}

.fa-mail-bulk:before {
  content: "\\f674";
}

.fa-mailchimp:before {
  content: "\\f59e";
}

.fa-male:before {
  content: "\\f183";
}

.fa-mandalorian:before {
  content: "\\f50f";
}

.fa-map:before {
  content: "\\f279";
}

.fa-map-marked:before {
  content: "\\f59f";
}

.fa-map-marked-alt:before {
  content: "\\f5a0";
}

.fa-map-marker:before {
  content: "\\f041";
}

.fa-map-marker-alt:before {
  content: "\\f3c5";
}

.fa-map-pin:before {
  content: "\\f276";
}

.fa-map-signs:before {
  content: "\\f277";
}

.fa-markdown:before {
  content: "\\f60f";
}

.fa-marker:before {
  content: "\\f5a1";
}

.fa-mars:before {
  content: "\\f222";
}

.fa-mars-double:before {
  content: "\\f227";
}

.fa-mars-stroke:before {
  content: "\\f229";
}

.fa-mars-stroke-h:before {
  content: "\\f22b";
}

.fa-mars-stroke-v:before {
  content: "\\f22a";
}

.fa-mask:before {
  content: "\\f6fa";
}

.fa-mastodon:before {
  content: "\\f4f6";
}

.fa-maxcdn:before {
  content: "\\f136";
}

.fa-mdb:before {
  content: "\\f8ca";
}

.fa-medal:before {
  content: "\\f5a2";
}

.fa-medapps:before {
  content: "\\f3c6";
}

.fa-medium:before {
  content: "\\f23a";
}

.fa-medium-m:before {
  content: "\\f3c7";
}

.fa-medkit:before {
  content: "\\f0fa";
}

.fa-medrt:before {
  content: "\\f3c8";
}

.fa-meetup:before {
  content: "\\f2e0";
}

.fa-megaport:before {
  content: "\\f5a3";
}

.fa-meh:before {
  content: "\\f11a";
}

.fa-meh-blank:before {
  content: "\\f5a4";
}

.fa-meh-rolling-eyes:before {
  content: "\\f5a5";
}

.fa-memory:before {
  content: "\\f538";
}

.fa-mendeley:before {
  content: "\\f7b3";
}

.fa-menorah:before {
  content: "\\f676";
}

.fa-mercury:before {
  content: "\\f223";
}

.fa-meteor:before {
  content: "\\f753";
}

.fa-microblog:before {
  content: "駱";
}

.fa-microchip:before {
  content: "\\f2db";
}

.fa-microphone:before {
  content: "\\f130";
}

.fa-microphone-alt:before {
  content: "\\f3c9";
}

.fa-microphone-alt-slash:before {
  content: "\\f539";
}

.fa-microphone-slash:before {
  content: "\\f131";
}

.fa-microscope:before {
  content: "\\f610";
}

.fa-microsoft:before {
  content: "\\f3ca";
}

.fa-minus:before {
  content: "\\f068";
}

.fa-minus-circle:before {
  content: "\\f056";
}

.fa-minus-square:before {
  content: "\\f146";
}

.fa-mitten:before {
  content: "\\f7b5";
}

.fa-mix:before {
  content: "\\f3cb";
}

.fa-mixcloud:before {
  content: "\\f289";
}

.fa-mixer:before {
  content: "稜";
}

.fa-mizuni:before {
  content: "\\f3cc";
}

.fa-mobile:before {
  content: "\\f10b";
}

.fa-mobile-alt:before {
  content: "\\f3cd";
}

.fa-modx:before {
  content: "\\f285";
}

.fa-monero:before {
  content: "\\f3d0";
}

.fa-money-bill:before {
  content: "\\f0d6";
}

.fa-money-bill-alt:before {
  content: "\\f3d1";
}

.fa-money-bill-wave:before {
  content: "\\f53a";
}

.fa-money-bill-wave-alt:before {
  content: "\\f53b";
}

.fa-money-check:before {
  content: "\\f53c";
}

.fa-money-check-alt:before {
  content: "\\f53d";
}

.fa-monument:before {
  content: "\\f5a6";
}

.fa-moon:before {
  content: "\\f186";
}

.fa-mortar-pestle:before {
  content: "\\f5a7";
}

.fa-mosque:before {
  content: "\\f678";
}

.fa-motorcycle:before {
  content: "\\f21c";
}

.fa-mountain:before {
  content: "\\f6fc";
}

.fa-mouse:before {
  content: "\\f8cc";
}

.fa-mouse-pointer:before {
  content: "\\f245";
}

.fa-mug-hot:before {
  content: "\\f7b6";
}

.fa-music:before {
  content: "\\f001";
}

.fa-napster:before {
  content: "\\f3d2";
}

.fa-neos:before {
  content: "\\f612";
}

.fa-network-wired:before {
  content: "\\f6ff";
}

.fa-neuter:before {
  content: "\\f22c";
}

.fa-newspaper:before {
  content: "\\f1ea";
}

.fa-nimblr:before {
  content: "\\f5a8";
}

.fa-node:before {
  content: "\\f419";
}

.fa-node-js:before {
  content: "\\f3d3";
}

.fa-not-equal:before {
  content: "\\f53e";
}

.fa-notes-medical:before {
  content: "\\f481";
}

.fa-npm:before {
  content: "\\f3d4";
}

.fa-ns8:before {
  content: "\\f3d5";
}

.fa-nutritionix:before {
  content: "\\f3d6";
}

.fa-object-group:before {
  content: "\\f247";
}

.fa-object-ungroup:before {
  content: "\\f248";
}

.fa-odnoklassniki:before {
  content: "\\f263";
}

.fa-odnoklassniki-square:before {
  content: "\\f264";
}

.fa-oil-can:before {
  content: "\\f613";
}

.fa-old-republic:before {
  content: "\\f510";
}

.fa-om:before {
  content: "\\f679";
}

.fa-opencart:before {
  content: "\\f23d";
}

.fa-openid:before {
  content: "\\f19b";
}

.fa-opera:before {
  content: "\\f26a";
}

.fa-optin-monster:before {
  content: "\\f23c";
}

.fa-orcid:before {
  content: "\\f8d2";
}

.fa-osi:before {
  content: "\\f41a";
}

.fa-otter:before {
  content: "\\f700";
}

.fa-outdent:before {
  content: "\\f03b";
}

.fa-page4:before {
  content: "\\f3d7";
}

.fa-pagelines:before {
  content: "\\f18c";
}

.fa-pager:before {
  content: "\\f815";
}

.fa-paint-brush:before {
  content: "\\f1fc";
}

.fa-paint-roller:before {
  content: "\\f5aa";
}

.fa-palette:before {
  content: "\\f53f";
}

.fa-palfed:before {
  content: "\\f3d8";
}

.fa-pallet:before {
  content: "\\f482";
}

.fa-paper-plane:before {
  content: "\\f1d8";
}

.fa-paperclip:before {
  content: "\\f0c6";
}

.fa-parachute-box:before {
  content: "\\f4cd";
}

.fa-paragraph:before {
  content: "\\f1dd";
}

.fa-parking:before {
  content: "\\f540";
}

.fa-passport:before {
  content: "\\f5ab";
}

.fa-pastafarianism:before {
  content: "\\f67b";
}

.fa-paste:before {
  content: "\\f0ea";
}

.fa-patreon:before {
  content: "\\f3d9";
}

.fa-pause:before {
  content: "\\f04c";
}

.fa-pause-circle:before {
  content: "\\f28b";
}

.fa-paw:before {
  content: "\\f1b0";
}

.fa-paypal:before {
  content: "\\f1ed";
}

.fa-peace:before {
  content: "\\f67c";
}

.fa-pen:before {
  content: "\\f304";
}

.fa-pen-alt:before {
  content: "\\f305";
}

.fa-pen-fancy:before {
  content: "\\f5ac";
}

.fa-pen-nib:before {
  content: "\\f5ad";
}

.fa-pen-square:before {
  content: "\\f14b";
}

.fa-pencil-alt:before {
  content: "\\f303";
}

.fa-pencil-ruler:before {
  content: "\\f5ae";
}

.fa-penny-arcade:before {
  content: "\\f704";
}

.fa-people-arrows:before {
  content: "泌";
}

.fa-people-carry:before {
  content: "\\f4ce";
}

.fa-pepper-hot:before {
  content: "\\f816";
}

.fa-percent:before {
  content: "\\f295";
}

.fa-percentage:before {
  content: "\\f541";
}

.fa-periscope:before {
  content: "\\f3da";
}

.fa-person-booth:before {
  content: "\\f756";
}

.fa-phabricator:before {
  content: "\\f3db";
}

.fa-phoenix-framework:before {
  content: "\\f3dc";
}

.fa-phoenix-squadron:before {
  content: "\\f511";
}

.fa-phone:before {
  content: "\\f095";
}

.fa-phone-alt:before {
  content: "\\f879";
}

.fa-phone-slash:before {
  content: "\\f3dd";
}

.fa-phone-square:before {
  content: "\\f098";
}

.fa-phone-square-alt:before {
  content: "\\f87b";
}

.fa-phone-volume:before {
  content: "\\f2a0";
}

.fa-photo-video:before {
  content: "\\f87c";
}

.fa-php:before {
  content: "\\f457";
}

.fa-pied-piper:before {
  content: "\\f2ae";
}

.fa-pied-piper-alt:before {
  content: "\\f1a8";
}

.fa-pied-piper-hat:before {
  content: "\\f4e5";
}

.fa-pied-piper-pp:before {
  content: "\\f1a7";
}

.fa-pied-piper-square:before {
  content: "爛";
}

.fa-piggy-bank:before {
  content: "\\f4d3";
}

.fa-pills:before {
  content: "\\f484";
}

.fa-pinterest:before {
  content: "\\f0d2";
}

.fa-pinterest-p:before {
  content: "\\f231";
}

.fa-pinterest-square:before {
  content: "\\f0d3";
}

.fa-pizza-slice:before {
  content: "\\f818";
}

.fa-place-of-worship:before {
  content: "\\f67f";
}

.fa-plane:before {
  content: "\\f072";
}

.fa-plane-arrival:before {
  content: "\\f5af";
}

.fa-plane-departure:before {
  content: "\\f5b0";
}

.fa-plane-slash:before {
  content: "數";
}

.fa-play:before {
  content: "\\f04b";
}

.fa-play-circle:before {
  content: "\\f144";
}

.fa-playstation:before {
  content: "\\f3df";
}

.fa-plug:before {
  content: "\\f1e6";
}

.fa-plus:before {
  content: "\\f067";
}

.fa-plus-circle:before {
  content: "\\f055";
}

.fa-plus-square:before {
  content: "\\f0fe";
}

.fa-podcast:before {
  content: "\\f2ce";
}

.fa-poll:before {
  content: "\\f681";
}

.fa-poll-h:before {
  content: "\\f682";
}

.fa-poo:before {
  content: "\\f2fe";
}

.fa-poo-storm:before {
  content: "\\f75a";
}

.fa-poop:before {
  content: "\\f619";
}

.fa-portrait:before {
  content: "\\f3e0";
}

.fa-pound-sign:before {
  content: "\\f154";
}

.fa-power-off:before {
  content: "\\f011";
}

.fa-pray:before {
  content: "\\f683";
}

.fa-praying-hands:before {
  content: "\\f684";
}

.fa-prescription:before {
  content: "\\f5b1";
}

.fa-prescription-bottle:before {
  content: "\\f485";
}

.fa-prescription-bottle-alt:before {
  content: "\\f486";
}

.fa-print:before {
  content: "\\f02f";
}

.fa-procedures:before {
  content: "\\f487";
}

.fa-product-hunt:before {
  content: "\\f288";
}

.fa-project-diagram:before {
  content: "\\f542";
}

.fa-pump-medical:before {
  content: "索";
}

.fa-pump-soap:before {
  content: "參";
}

.fa-pushed:before {
  content: "\\f3e1";
}

.fa-puzzle-piece:before {
  content: "\\f12e";
}

.fa-python:before {
  content: "\\f3e2";
}

.fa-qq:before {
  content: "\\f1d6";
}

.fa-qrcode:before {
  content: "\\f029";
}

.fa-question:before {
  content: "\\f128";
}

.fa-question-circle:before {
  content: "\\f059";
}

.fa-quidditch:before {
  content: "\\f458";
}

.fa-quinscape:before {
  content: "\\f459";
}

.fa-quora:before {
  content: "\\f2c4";
}

.fa-quote-left:before {
  content: "\\f10d";
}

.fa-quote-right:before {
  content: "\\f10e";
}

.fa-quran:before {
  content: "\\f687";
}

.fa-r-project:before {
  content: "\\f4f7";
}

.fa-radiation:before {
  content: "\\f7b9";
}

.fa-radiation-alt:before {
  content: "\\f7ba";
}

.fa-rainbow:before {
  content: "\\f75b";
}

.fa-random:before {
  content: "\\f074";
}

.fa-raspberry-pi:before {
  content: "\\f7bb";
}

.fa-ravelry:before {
  content: "\\f2d9";
}

.fa-react:before {
  content: "\\f41b";
}

.fa-reacteurope:before {
  content: "\\f75d";
}

.fa-readme:before {
  content: "\\f4d5";
}

.fa-rebel:before {
  content: "\\f1d0";
}

.fa-receipt:before {
  content: "\\f543";
}

.fa-record-vinyl:before {
  content: "\\f8d9";
}

.fa-recycle:before {
  content: "\\f1b8";
}

.fa-red-river:before {
  content: "\\f3e3";
}

.fa-reddit:before {
  content: "\\f1a1";
}

.fa-reddit-alien:before {
  content: "\\f281";
}

.fa-reddit-square:before {
  content: "\\f1a2";
}

.fa-redhat:before {
  content: "\\f7bc";
}

.fa-redo:before {
  content: "\\f01e";
}

.fa-redo-alt:before {
  content: "\\f2f9";
}

.fa-registered:before {
  content: "\\f25d";
}

.fa-remove-format:before {
  content: "\\f87d";
}

.fa-renren:before {
  content: "\\f18b";
}

.fa-reply:before {
  content: "\\f3e5";
}

.fa-reply-all:before {
  content: "\\f122";
}

.fa-replyd:before {
  content: "\\f3e6";
}

.fa-republican:before {
  content: "\\f75e";
}

.fa-researchgate:before {
  content: "\\f4f8";
}

.fa-resolving:before {
  content: "\\f3e7";
}

.fa-restroom:before {
  content: "\\f7bd";
}

.fa-retweet:before {
  content: "\\f079";
}

.fa-rev:before {
  content: "\\f5b2";
}

.fa-ribbon:before {
  content: "\\f4d6";
}

.fa-ring:before {
  content: "\\f70b";
}

.fa-road:before {
  content: "\\f018";
}

.fa-robot:before {
  content: "\\f544";
}

.fa-rocket:before {
  content: "\\f135";
}

.fa-rocketchat:before {
  content: "\\f3e8";
}

.fa-rockrms:before {
  content: "\\f3e9";
}

.fa-route:before {
  content: "\\f4d7";
}

.fa-rss:before {
  content: "\\f09e";
}

.fa-rss-square:before {
  content: "\\f143";
}

.fa-ruble-sign:before {
  content: "\\f158";
}

.fa-ruler:before {
  content: "\\f545";
}

.fa-ruler-combined:before {
  content: "\\f546";
}

.fa-ruler-horizontal:before {
  content: "\\f547";
}

.fa-ruler-vertical:before {
  content: "\\f548";
}

.fa-running:before {
  content: "\\f70c";
}

.fa-rupee-sign:before {
  content: "\\f156";
}

.fa-sad-cry:before {
  content: "\\f5b3";
}

.fa-sad-tear:before {
  content: "\\f5b4";
}

.fa-safari:before {
  content: "\\f267";
}

.fa-salesforce:before {
  content: "\\f83b";
}

.fa-sass:before {
  content: "\\f41e";
}

.fa-satellite:before {
  content: "\\f7bf";
}

.fa-satellite-dish:before {
  content: "\\f7c0";
}

.fa-save:before {
  content: "\\f0c7";
}

.fa-schlix:before {
  content: "\\f3ea";
}

.fa-school:before {
  content: "\\f549";
}

.fa-screwdriver:before {
  content: "\\f54a";
}

.fa-scribd:before {
  content: "\\f28a";
}

.fa-scroll:before {
  content: "\\f70e";
}

.fa-sd-card:before {
  content: "\\f7c2";
}

.fa-search:before {
  content: "\\f002";
}

.fa-search-dollar:before {
  content: "\\f688";
}

.fa-search-location:before {
  content: "\\f689";
}

.fa-search-minus:before {
  content: "\\f010";
}

.fa-search-plus:before {
  content: "\\f00e";
}

.fa-searchengin:before {
  content: "\\f3eb";
}

.fa-seedling:before {
  content: "\\f4d8";
}

.fa-sellcast:before {
  content: "\\f2da";
}

.fa-sellsy:before {
  content: "\\f213";
}

.fa-server:before {
  content: "\\f233";
}

.fa-servicestack:before {
  content: "\\f3ec";
}

.fa-shapes:before {
  content: "\\f61f";
}

.fa-share:before {
  content: "\\f064";
}

.fa-share-alt:before {
  content: "\\f1e0";
}

.fa-share-alt-square:before {
  content: "\\f1e1";
}

.fa-share-square:before {
  content: "\\f14d";
}

.fa-shekel-sign:before {
  content: "\\f20b";
}

.fa-shield-alt:before {
  content: "\\f3ed";
}

.fa-shield-virus:before {
  content: "塞";
}

.fa-ship:before {
  content: "\\f21a";
}

.fa-shipping-fast:before {
  content: "\\f48b";
}

.fa-shirtsinbulk:before {
  content: "\\f214";
}

.fa-shoe-prints:before {
  content: "\\f54b";
}

.fa-shopify:before {
  content: "綾";
}

.fa-shopping-bag:before {
  content: "\\f290";
}

.fa-shopping-basket:before {
  content: "\\f291";
}

.fa-shopping-cart:before {
  content: "\\f07a";
}

.fa-shopware:before {
  content: "\\f5b5";
}

.fa-shower:before {
  content: "\\f2cc";
}

.fa-shuttle-van:before {
  content: "\\f5b6";
}

.fa-sign:before {
  content: "\\f4d9";
}

.fa-sign-in-alt:before {
  content: "\\f2f6";
}

.fa-sign-language:before {
  content: "\\f2a7";
}

.fa-sign-out-alt:before {
  content: "\\f2f5";
}

.fa-signal:before {
  content: "\\f012";
}

.fa-signature:before {
  content: "\\f5b7";
}

.fa-sim-card:before {
  content: "\\f7c4";
}

.fa-simplybuilt:before {
  content: "\\f215";
}

.fa-sistrix:before {
  content: "\\f3ee";
}

.fa-sitemap:before {
  content: "\\f0e8";
}

.fa-sith:before {
  content: "\\f512";
}

.fa-skating:before {
  content: "\\f7c5";
}

.fa-sketch:before {
  content: "\\f7c6";
}

.fa-skiing:before {
  content: "\\f7c9";
}

.fa-skiing-nordic:before {
  content: "\\f7ca";
}

.fa-skull:before {
  content: "\\f54c";
}

.fa-skull-crossbones:before {
  content: "\\f714";
}

.fa-skyatlas:before {
  content: "\\f216";
}

.fa-skype:before {
  content: "\\f17e";
}

.fa-slack:before {
  content: "\\f198";
}

.fa-slack-hash:before {
  content: "\\f3ef";
}

.fa-slash:before {
  content: "\\f715";
}

.fa-sleigh:before {
  content: "\\f7cc";
}

.fa-sliders-h:before {
  content: "\\f1de";
}

.fa-slideshare:before {
  content: "\\f1e7";
}

.fa-smile:before {
  content: "\\f118";
}

.fa-smile-beam:before {
  content: "\\f5b8";
}

.fa-smile-wink:before {
  content: "\\f4da";
}

.fa-smog:before {
  content: "\\f75f";
}

.fa-smoking:before {
  content: "\\f48d";
}

.fa-smoking-ban:before {
  content: "\\f54d";
}

.fa-sms:before {
  content: "\\f7cd";
}

.fa-snapchat:before {
  content: "\\f2ab";
}

.fa-snapchat-ghost:before {
  content: "\\f2ac";
}

.fa-snapchat-square:before {
  content: "\\f2ad";
}

.fa-snowboarding:before {
  content: "\\f7ce";
}

.fa-snowflake:before {
  content: "\\f2dc";
}

.fa-snowman:before {
  content: "\\f7d0";
}

.fa-snowplow:before {
  content: "\\f7d2";
}

.fa-soap:before {
  content: "葉";
}

.fa-socks:before {
  content: "\\f696";
}

.fa-solar-panel:before {
  content: "\\f5ba";
}

.fa-sort:before {
  content: "\\f0dc";
}

.fa-sort-alpha-down:before {
  content: "\\f15d";
}

.fa-sort-alpha-down-alt:before {
  content: "\\f881";
}

.fa-sort-alpha-up:before {
  content: "\\f15e";
}

.fa-sort-alpha-up-alt:before {
  content: "\\f882";
}

.fa-sort-amount-down:before {
  content: "\\f160";
}

.fa-sort-amount-down-alt:before {
  content: "\\f884";
}

.fa-sort-amount-up:before {
  content: "\\f161";
}

.fa-sort-amount-up-alt:before {
  content: "\\f885";
}

.fa-sort-down:before {
  content: "\\f0dd";
}

.fa-sort-numeric-down:before {
  content: "\\f162";
}

.fa-sort-numeric-down-alt:before {
  content: "\\f886";
}

.fa-sort-numeric-up:before {
  content: "\\f163";
}

.fa-sort-numeric-up-alt:before {
  content: "\\f887";
}

.fa-sort-up:before {
  content: "\\f0de";
}

.fa-soundcloud:before {
  content: "\\f1be";
}

.fa-sourcetree:before {
  content: "\\f7d3";
}

.fa-spa:before {
  content: "\\f5bb";
}

.fa-space-shuttle:before {
  content: "\\f197";
}

.fa-speakap:before {
  content: "\\f3f3";
}

.fa-speaker-deck:before {
  content: "\\f83c";
}

.fa-spell-check:before {
  content: "\\f891";
}

.fa-spider:before {
  content: "\\f717";
}

.fa-spinner:before {
  content: "\\f110";
}

.fa-splotch:before {
  content: "\\f5bc";
}

.fa-spotify:before {
  content: "\\f1bc";
}

.fa-spray-can:before {
  content: "\\f5bd";
}

.fa-square:before {
  content: "\\f0c8";
}

.fa-square-full:before {
  content: "\\f45c";
}

.fa-square-root-alt:before {
  content: "\\f698";
}

.fa-squarespace:before {
  content: "\\f5be";
}

.fa-stack-exchange:before {
  content: "\\f18d";
}

.fa-stack-overflow:before {
  content: "\\f16c";
}

.fa-stackpath:before {
  content: "\\f842";
}

.fa-stamp:before {
  content: "\\f5bf";
}

.fa-star:before {
  content: "\\f005";
}

.fa-star-and-crescent:before {
  content: "\\f699";
}

.fa-star-half:before {
  content: "\\f089";
}

.fa-star-half-alt:before {
  content: "\\f5c0";
}

.fa-star-of-david:before {
  content: "\\f69a";
}

.fa-star-of-life:before {
  content: "\\f621";
}

.fa-staylinked:before {
  content: "\\f3f5";
}

.fa-steam:before {
  content: "\\f1b6";
}

.fa-steam-square:before {
  content: "\\f1b7";
}

.fa-steam-symbol:before {
  content: "\\f3f6";
}

.fa-step-backward:before {
  content: "\\f048";
}

.fa-step-forward:before {
  content: "\\f051";
}

.fa-stethoscope:before {
  content: "\\f0f1";
}

.fa-sticker-mule:before {
  content: "\\f3f7";
}

.fa-sticky-note:before {
  content: "\\f249";
}

.fa-stop:before {
  content: "\\f04d";
}

.fa-stop-circle:before {
  content: "\\f28d";
}

.fa-stopwatch:before {
  content: "\\f2f2";
}

.fa-stopwatch-20:before {
  content: "說";
}

.fa-store:before {
  content: "\\f54e";
}

.fa-store-alt:before {
  content: "\\f54f";
}

.fa-store-alt-slash:before {
  content: "殺";
}

.fa-store-slash:before {
  content: "辰";
}

.fa-strava:before {
  content: "\\f428";
}

.fa-stream:before {
  content: "\\f550";
}

.fa-street-view:before {
  content: "\\f21d";
}

.fa-strikethrough:before {
  content: "\\f0cc";
}

.fa-stripe:before {
  content: "\\f429";
}

.fa-stripe-s:before {
  content: "\\f42a";
}

.fa-stroopwafel:before {
  content: "\\f551";
}

.fa-studiovinari:before {
  content: "\\f3f8";
}

.fa-stumbleupon:before {
  content: "\\f1a4";
}

.fa-stumbleupon-circle:before {
  content: "\\f1a3";
}

.fa-subscript:before {
  content: "\\f12c";
}

.fa-subway:before {
  content: "\\f239";
}

.fa-suitcase:before {
  content: "\\f0f2";
}

.fa-suitcase-rolling:before {
  content: "\\f5c1";
}

.fa-sun:before {
  content: "\\f185";
}

.fa-superpowers:before {
  content: "\\f2dd";
}

.fa-superscript:before {
  content: "\\f12b";
}

.fa-supple:before {
  content: "\\f3f9";
}

.fa-surprise:before {
  content: "\\f5c2";
}

.fa-suse:before {
  content: "\\f7d6";
}

.fa-swatchbook:before {
  content: "\\f5c3";
}

.fa-swift:before {
  content: "\\f8e1";
}

.fa-swimmer:before {
  content: "\\f5c4";
}

.fa-swimming-pool:before {
  content: "\\f5c5";
}

.fa-symfony:before {
  content: "\\f83d";
}

.fa-synagogue:before {
  content: "\\f69b";
}

.fa-sync:before {
  content: "\\f021";
}

.fa-sync-alt:before {
  content: "\\f2f1";
}

.fa-syringe:before {
  content: "\\f48e";
}

.fa-table:before {
  content: "\\f0ce";
}

.fa-table-tennis:before {
  content: "\\f45d";
}

.fa-tablet:before {
  content: "\\f10a";
}

.fa-tablet-alt:before {
  content: "\\f3fa";
}

.fa-tablets:before {
  content: "\\f490";
}

.fa-tachometer-alt:before {
  content: "\\f3fd";
}

.fa-tag:before {
  content: "\\f02b";
}

.fa-tags:before {
  content: "\\f02c";
}

.fa-tape:before {
  content: "\\f4db";
}

.fa-tasks:before {
  content: "\\f0ae";
}

.fa-taxi:before {
  content: "\\f1ba";
}

.fa-teamspeak:before {
  content: "\\f4f9";
}

.fa-teeth:before {
  content: "\\f62e";
}

.fa-teeth-open:before {
  content: "\\f62f";
}

.fa-telegram:before {
  content: "\\f2c6";
}

.fa-telegram-plane:before {
  content: "\\f3fe";
}

.fa-temperature-high:before {
  content: "\\f769";
}

.fa-temperature-low:before {
  content: "\\f76b";
}

.fa-tencent-weibo:before {
  content: "\\f1d5";
}

.fa-tenge:before {
  content: "\\f7d7";
}

.fa-terminal:before {
  content: "\\f120";
}

.fa-text-height:before {
  content: "\\f034";
}

.fa-text-width:before {
  content: "\\f035";
}

.fa-th:before {
  content: "\\f00a";
}

.fa-th-large:before {
  content: "\\f009";
}

.fa-th-list:before {
  content: "\\f00b";
}

.fa-the-red-yeti:before {
  content: "\\f69d";
}

.fa-theater-masks:before {
  content: "\\f630";
}

.fa-themeco:before {
  content: "\\f5c6";
}

.fa-themeisle:before {
  content: "\\f2b2";
}

.fa-thermometer:before {
  content: "\\f491";
}

.fa-thermometer-empty:before {
  content: "\\f2cb";
}

.fa-thermometer-full:before {
  content: "\\f2c7";
}

.fa-thermometer-half:before {
  content: "\\f2c9";
}

.fa-thermometer-quarter:before {
  content: "\\f2ca";
}

.fa-thermometer-three-quarters:before {
  content: "\\f2c8";
}

.fa-think-peaks:before {
  content: "\\f731";
}

.fa-thumbs-down:before {
  content: "\\f165";
}

.fa-thumbs-up:before {
  content: "\\f164";
}

.fa-thumbtack:before {
  content: "\\f08d";
}

.fa-ticket-alt:before {
  content: "\\f3ff";
}

.fa-times:before {
  content: "\\f00d";
}

.fa-times-circle:before {
  content: "\\f057";
}

.fa-tint:before {
  content: "\\f043";
}

.fa-tint-slash:before {
  content: "\\f5c7";
}

.fa-tired:before {
  content: "\\f5c8";
}

.fa-toggle-off:before {
  content: "\\f204";
}

.fa-toggle-on:before {
  content: "\\f205";
}

.fa-toilet:before {
  content: "\\f7d8";
}

.fa-toilet-paper:before {
  content: "\\f71e";
}

.fa-toilet-paper-slash:before {
  content: "沈";
}

.fa-toolbox:before {
  content: "\\f552";
}

.fa-tools:before {
  content: "\\f7d9";
}

.fa-tooth:before {
  content: "\\f5c9";
}

.fa-torah:before {
  content: "\\f6a0";
}

.fa-torii-gate:before {
  content: "\\f6a1";
}

.fa-tractor:before {
  content: "\\f722";
}

.fa-trade-federation:before {
  content: "\\f513";
}

.fa-trademark:before {
  content: "\\f25c";
}

.fa-traffic-light:before {
  content: "\\f637";
}

.fa-trailer:before {
  content: "論";
}

.fa-train:before {
  content: "\\f238";
}

.fa-tram:before {
  content: "\\f7da";
}

.fa-transgender:before {
  content: "\\f224";
}

.fa-transgender-alt:before {
  content: "\\f225";
}

.fa-trash:before {
  content: "\\f1f8";
}

.fa-trash-alt:before {
  content: "\\f2ed";
}

.fa-trash-restore:before {
  content: "\\f829";
}

.fa-trash-restore-alt:before {
  content: "\\f82a";
}

.fa-tree:before {
  content: "\\f1bb";
}

.fa-trello:before {
  content: "\\f181";
}

.fa-tripadvisor:before {
  content: "\\f262";
}

.fa-trophy:before {
  content: "\\f091";
}

.fa-truck:before {
  content: "\\f0d1";
}

.fa-truck-loading:before {
  content: "\\f4de";
}

.fa-truck-monster:before {
  content: "\\f63b";
}

.fa-truck-moving:before {
  content: "\\f4df";
}

.fa-truck-pickup:before {
  content: "\\f63c";
}

.fa-tshirt:before {
  content: "\\f553";
}

.fa-tty:before {
  content: "\\f1e4";
}

.fa-tumblr:before {
  content: "\\f173";
}

.fa-tumblr-square:before {
  content: "\\f174";
}

.fa-tv:before {
  content: "\\f26c";
}

.fa-twitch:before {
  content: "\\f1e8";
}

.fa-twitter:before {
  content: "\\f099";
}

.fa-twitter-square:before {
  content: "\\f081";
}

.fa-typo3:before {
  content: "\\f42b";
}

.fa-uber:before {
  content: "\\f402";
}

.fa-ubuntu:before {
  content: "\\f7df";
}

.fa-uikit:before {
  content: "\\f403";
}

.fa-umbraco:before {
  content: "\\f8e8";
}

.fa-umbrella:before {
  content: "\\f0e9";
}

.fa-umbrella-beach:before {
  content: "\\f5ca";
}

.fa-underline:before {
  content: "\\f0cd";
}

.fa-undo:before {
  content: "\\f0e2";
}

.fa-undo-alt:before {
  content: "\\f2ea";
}

.fa-uniregistry:before {
  content: "\\f404";
}

.fa-unity:before {
  content: "雷";
}

.fa-universal-access:before {
  content: "\\f29a";
}

.fa-university:before {
  content: "\\f19c";
}

.fa-unlink:before {
  content: "\\f127";
}

.fa-unlock:before {
  content: "\\f09c";
}

.fa-unlock-alt:before {
  content: "\\f13e";
}

.fa-untappd:before {
  content: "\\f405";
}

.fa-upload:before {
  content: "\\f093";
}

.fa-ups:before {
  content: "\\f7e0";
}

.fa-usb:before {
  content: "\\f287";
}

.fa-user:before {
  content: "\\f007";
}

.fa-user-alt:before {
  content: "\\f406";
}

.fa-user-alt-slash:before {
  content: "\\f4fa";
}

.fa-user-astronaut:before {
  content: "\\f4fb";
}

.fa-user-check:before {
  content: "\\f4fc";
}

.fa-user-circle:before {
  content: "\\f2bd";
}

.fa-user-clock:before {
  content: "\\f4fd";
}

.fa-user-cog:before {
  content: "\\f4fe";
}

.fa-user-edit:before {
  content: "\\f4ff";
}

.fa-user-friends:before {
  content: "\\f500";
}

.fa-user-graduate:before {
  content: "\\f501";
}

.fa-user-injured:before {
  content: "\\f728";
}

.fa-user-lock:before {
  content: "\\f502";
}

.fa-user-md:before {
  content: "\\f0f0";
}

.fa-user-minus:before {
  content: "\\f503";
}

.fa-user-ninja:before {
  content: "\\f504";
}

.fa-user-nurse:before {
  content: "\\f82f";
}

.fa-user-plus:before {
  content: "\\f234";
}

.fa-user-secret:before {
  content: "\\f21b";
}

.fa-user-shield:before {
  content: "\\f505";
}

.fa-user-slash:before {
  content: "\\f506";
}

.fa-user-tag:before {
  content: "\\f507";
}

.fa-user-tie:before {
  content: "\\f508";
}

.fa-user-times:before {
  content: "\\f235";
}

.fa-users:before {
  content: "\\f0c0";
}

.fa-users-cog:before {
  content: "\\f509";
}

.fa-usps:before {
  content: "\\f7e1";
}

.fa-ussunnah:before {
  content: "\\f407";
}

.fa-utensil-spoon:before {
  content: "\\f2e5";
}

.fa-utensils:before {
  content: "\\f2e7";
}

.fa-vaadin:before {
  content: "\\f408";
}

.fa-vector-square:before {
  content: "\\f5cb";
}

.fa-venus:before {
  content: "\\f221";
}

.fa-venus-double:before {
  content: "\\f226";
}

.fa-venus-mars:before {
  content: "\\f228";
}

.fa-viacoin:before {
  content: "\\f237";
}

.fa-viadeo:before {
  content: "\\f2a9";
}

.fa-viadeo-square:before {
  content: "\\f2aa";
}

.fa-vial:before {
  content: "\\f492";
}

.fa-vials:before {
  content: "\\f493";
}

.fa-viber:before {
  content: "\\f409";
}

.fa-video:before {
  content: "\\f03d";
}

.fa-video-slash:before {
  content: "\\f4e2";
}

.fa-vihara:before {
  content: "\\f6a7";
}

.fa-vimeo:before {
  content: "\\f40a";
}

.fa-vimeo-square:before {
  content: "\\f194";
}

.fa-vimeo-v:before {
  content: "\\f27d";
}

.fa-vine:before {
  content: "\\f1ca";
}

.fa-virus:before {
  content: "若";
}

.fa-virus-slash:before {
  content: "掠";
}

.fa-viruses:before {
  content: "略";
}

.fa-vk:before {
  content: "\\f189";
}

.fa-vnv:before {
  content: "\\f40b";
}

.fa-voicemail:before {
  content: "\\f897";
}

.fa-volleyball-ball:before {
  content: "\\f45f";
}

.fa-volume-down:before {
  content: "\\f027";
}

.fa-volume-mute:before {
  content: "\\f6a9";
}

.fa-volume-off:before {
  content: "\\f026";
}

.fa-volume-up:before {
  content: "\\f028";
}

.fa-vote-yea:before {
  content: "\\f772";
}

.fa-vr-cardboard:before {
  content: "\\f729";
}

.fa-vuejs:before {
  content: "\\f41f";
}

.fa-walking:before {
  content: "\\f554";
}

.fa-wallet:before {
  content: "\\f555";
}

.fa-warehouse:before {
  content: "\\f494";
}

.fa-water:before {
  content: "\\f773";
}

.fa-wave-square:before {
  content: "\\f83e";
}

.fa-waze:before {
  content: "\\f83f";
}

.fa-weebly:before {
  content: "\\f5cc";
}

.fa-weibo:before {
  content: "\\f18a";
}

.fa-weight:before {
  content: "\\f496";
}

.fa-weight-hanging:before {
  content: "\\f5cd";
}

.fa-weixin:before {
  content: "\\f1d7";
}

.fa-whatsapp:before {
  content: "\\f232";
}

.fa-whatsapp-square:before {
  content: "\\f40c";
}

.fa-wheelchair:before {
  content: "\\f193";
}

.fa-whmcs:before {
  content: "\\f40d";
}

.fa-wifi:before {
  content: "\\f1eb";
}

.fa-wikipedia-w:before {
  content: "\\f266";
}

.fa-wind:before {
  content: "\\f72e";
}

.fa-window-close:before {
  content: "\\f410";
}

.fa-window-maximize:before {
  content: "\\f2d0";
}

.fa-window-minimize:before {
  content: "\\f2d1";
}

.fa-window-restore:before {
  content: "\\f2d2";
}

.fa-windows:before {
  content: "\\f17a";
}

.fa-wine-bottle:before {
  content: "\\f72f";
}

.fa-wine-glass:before {
  content: "\\f4e3";
}

.fa-wine-glass-alt:before {
  content: "\\f5ce";
}

.fa-wix:before {
  content: "\\f5cf";
}

.fa-wizards-of-the-coast:before {
  content: "\\f730";
}

.fa-wolf-pack-battalion:before {
  content: "\\f514";
}

.fa-won-sign:before {
  content: "\\f159";
}

.fa-wordpress:before {
  content: "\\f19a";
}

.fa-wordpress-simple:before {
  content: "\\f411";
}

.fa-wpbeginner:before {
  content: "\\f297";
}

.fa-wpexplorer:before {
  content: "\\f2de";
}

.fa-wpforms:before {
  content: "\\f298";
}

.fa-wpressr:before {
  content: "\\f3e4";
}

.fa-wrench:before {
  content: "\\f0ad";
}

.fa-x-ray:before {
  content: "\\f497";
}

.fa-xbox:before {
  content: "\\f412";
}

.fa-xing:before {
  content: "\\f168";
}

.fa-xing-square:before {
  content: "\\f169";
}

.fa-y-combinator:before {
  content: "\\f23b";
}

.fa-yahoo:before {
  content: "\\f19e";
}

.fa-yammer:before {
  content: "\\f840";
}

.fa-yandex:before {
  content: "\\f413";
}

.fa-yandex-international:before {
  content: "\\f414";
}

.fa-yarn:before {
  content: "\\f7e3";
}

.fa-yelp:before {
  content: "\\f1e9";
}

.fa-yen-sign:before {
  content: "\\f157";
}

.fa-yin-yang:before {
  content: "\\f6ad";
}

.fa-yoast:before {
  content: "\\f2b1";
}

.fa-youtube:before {
  content: "\\f167";
}

.fa-youtube-square:before {
  content: "\\f431";
}

.fa-zhihu:before {
  content: "\\f63f";
}

.sr-only {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.sr-only-focusable:active,
.sr-only-focusable:focus {
  clip: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  position: static;
  width: auto;
}

@font-face {
  font-family: "Font Awesome 5 Brands";
  font-style: normal;
  font-weight: 400;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("svg");
}
.fab {
  font-family: "Font Awesome 5 Brands";
  font-weight: 400;
}

@font-face {
  font-family: "Font Awesome 5 Free";
  font-style: normal;
  font-weight: 400;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("svg");
}
.far {
  font-family: "Font Awesome 5 Free";
  font-weight: 400;
}

@font-face {
  font-family: "Font Awesome 5 Free";
  font-style: normal;
  font-weight: 900;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("svg");
}
.fa,
.fas {
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
}

@font-face {
  font-family: "dripicons-v2";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
[data-icon]:before {
  font-family: "dripicons-v2" !important;
  content: attr(data-icon);
  font-style: normal !important;
  font-weight: normal !important;
  font-variant: normal !important;
  text-transform: none !important;
  speak: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

[class^=dripicons-]:before,
[class*=" dripicons-"]:before {
  font-family: "dripicons-v2" !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-variant: normal !important;
  text-transform: none !important;
  speak: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.dripicons-alarm:before {
  content: "a";
}

.dripicons-align-center:before {
  content: "b";
}

.dripicons-align-justify:before {
  content: "c";
}

.dripicons-align-left:before {
  content: "d";
}

.dripicons-align-right:before {
  content: "e";
}

.dripicons-anchor:before {
  content: "f";
}

.dripicons-archive:before {
  content: "g";
}

.dripicons-arrow-down:before {
  content: "h";
}

.dripicons-arrow-left:before {
  content: "i";
}

.dripicons-arrow-right:before {
  content: "j";
}

.dripicons-arrow-thin-down:before {
  content: "k";
}

.dripicons-arrow-thin-left:before {
  content: "l";
}

.dripicons-arrow-thin-right:before {
  content: "m";
}

.dripicons-arrow-thin-up:before {
  content: "n";
}

.dripicons-arrow-up:before {
  content: "o";
}

.dripicons-article:before {
  content: "p";
}

.dripicons-backspace:before {
  content: "q";
}

.dripicons-basket:before {
  content: "r";
}

.dripicons-basketball:before {
  content: "s";
}

.dripicons-battery-empty:before {
  content: "t";
}

.dripicons-battery-full:before {
  content: "u";
}

.dripicons-battery-low:before {
  content: "v";
}

.dripicons-battery-medium:before {
  content: "w";
}

.dripicons-bell:before {
  content: "x";
}

.dripicons-blog:before {
  content: "y";
}

.dripicons-bluetooth:before {
  content: "z";
}

.dripicons-bold:before {
  content: "A";
}

.dripicons-bookmark:before {
  content: "B";
}

.dripicons-bookmarks:before {
  content: "C";
}

.dripicons-box:before {
  content: "D";
}

.dripicons-briefcase:before {
  content: "E";
}

.dripicons-brightness-low:before {
  content: "F";
}

.dripicons-brightness-max:before {
  content: "G";
}

.dripicons-brightness-medium:before {
  content: "H";
}

.dripicons-broadcast:before {
  content: "I";
}

.dripicons-browser:before {
  content: "J";
}

.dripicons-browser-upload:before {
  content: "K";
}

.dripicons-brush:before {
  content: "L";
}

.dripicons-calendar:before {
  content: "M";
}

.dripicons-camcorder:before {
  content: "N";
}

.dripicons-camera:before {
  content: "O";
}

.dripicons-card:before {
  content: "P";
}

.dripicons-cart:before {
  content: "Q";
}

.dripicons-checklist:before {
  content: "R";
}

.dripicons-checkmark:before {
  content: "S";
}

.dripicons-chevron-down:before {
  content: "T";
}

.dripicons-chevron-left:before {
  content: "U";
}

.dripicons-chevron-right:before {
  content: "V";
}

.dripicons-chevron-up:before {
  content: "W";
}

.dripicons-clipboard:before {
  content: "X";
}

.dripicons-clock:before {
  content: "Y";
}

.dripicons-clockwise:before {
  content: "Z";
}

.dripicons-cloud:before {
  content: "0";
}

.dripicons-cloud-download:before {
  content: "1";
}

.dripicons-cloud-upload:before {
  content: "2";
}

.dripicons-code:before {
  content: "3";
}

.dripicons-contract:before {
  content: "4";
}

.dripicons-contract-2:before {
  content: "5";
}

.dripicons-conversation:before {
  content: "6";
}

.dripicons-copy:before {
  content: "7";
}

.dripicons-crop:before {
  content: "8";
}

.dripicons-cross:before {
  content: "9";
}

.dripicons-crosshair:before {
  content: "!";
}

.dripicons-cutlery:before {
  content: '"';
}

.dripicons-device-desktop:before {
  content: "#";
}

.dripicons-device-mobile:before {
  content: "\$";
}

.dripicons-device-tablet:before {
  content: "%";
}

.dripicons-direction:before {
  content: "&";
}

.dripicons-disc:before {
  content: "'";
}

.dripicons-document:before {
  content: "(";
}

.dripicons-document-delete:before {
  content: ")";
}

.dripicons-document-edit:before {
  content: "*";
}

.dripicons-document-new:before {
  content: "+";
}

.dripicons-document-remove:before {
  content: ",";
}

.dripicons-dot:before {
  content: "-";
}

.dripicons-dots-2:before {
  content: ".";
}

.dripicons-dots-3:before {
  content: "/";
}

.dripicons-download:before {
  content: ":";
}

.dripicons-duplicate:before {
  content: ";";
}

.dripicons-enter:before {
  content: "<";
}

.dripicons-exit:before {
  content: "=";
}

.dripicons-expand:before {
  content: ">";
}

.dripicons-expand-2:before {
  content: "?";
}

.dripicons-experiment:before {
  content: "@";
}

.dripicons-export:before {
  content: "[";
}

.dripicons-feed:before {
  content: "]";
}

.dripicons-flag:before {
  content: "^";
}

.dripicons-flashlight:before {
  content: "_";
}

.dripicons-folder:before {
  content: "\`";
}

.dripicons-folder-open:before {
  content: "{";
}

.dripicons-forward:before {
  content: "|";
}

.dripicons-gaming:before {
  content: "}";
}

.dripicons-gear:before {
  content: "~";
}

.dripicons-graduation:before {
  content: "\\\\";
}

.dripicons-graph-bar:before {
  content: "\\e000";
}

.dripicons-graph-line:before {
  content: "\\e001";
}

.dripicons-graph-pie:before {
  content: "\\e002";
}

.dripicons-headset:before {
  content: "\\e003";
}

.dripicons-heart:before {
  content: "\\e004";
}

.dripicons-help:before {
  content: "\\e005";
}

.dripicons-home:before {
  content: "\\e006";
}

.dripicons-hourglass:before {
  content: "\\e007";
}

.dripicons-inbox:before {
  content: "\\e008";
}

.dripicons-information:before {
  content: "\\e009";
}

.dripicons-italic:before {
  content: "\\e00a";
}

.dripicons-jewel:before {
  content: "\\e00b";
}

.dripicons-lifting:before {
  content: "\\e00c";
}

.dripicons-lightbulb:before {
  content: "\\e00d";
}

.dripicons-link:before {
  content: "\\e00e";
}

.dripicons-link-broken:before {
  content: "\\e00f";
}

.dripicons-list:before {
  content: "\\e010";
}

.dripicons-loading:before {
  content: "\\e011";
}

.dripicons-location:before {
  content: "\\e012";
}

.dripicons-lock:before {
  content: "\\e013";
}

.dripicons-lock-open:before {
  content: "\\e014";
}

.dripicons-mail:before {
  content: "\\e015";
}

.dripicons-map:before {
  content: "\\e016";
}

.dripicons-media-loop:before {
  content: "\\e017";
}

.dripicons-media-next:before {
  content: "\\e018";
}

.dripicons-media-pause:before {
  content: "\\e019";
}

.dripicons-media-play:before {
  content: "\\e01a";
}

.dripicons-media-previous:before {
  content: "\\e01b";
}

.dripicons-media-record:before {
  content: "\\e01c";
}

.dripicons-media-shuffle:before {
  content: "\\e01d";
}

.dripicons-media-stop:before {
  content: "\\e01e";
}

.dripicons-medical:before {
  content: "\\e01f";
}

.dripicons-menu:before {
  content: "\\e020";
}

.dripicons-message:before {
  content: "\\e021";
}

.dripicons-meter:before {
  content: "\\e022";
}

.dripicons-microphone:before {
  content: "\\e023";
}

.dripicons-minus:before {
  content: "\\e024";
}

.dripicons-monitor:before {
  content: "\\e025";
}

.dripicons-move:before {
  content: "\\e026";
}

.dripicons-music:before {
  content: "\\e027";
}

.dripicons-network-1:before {
  content: "\\e028";
}

.dripicons-network-2:before {
  content: "\\e029";
}

.dripicons-network-3:before {
  content: "\\e02a";
}

.dripicons-network-4:before {
  content: "\\e02b";
}

.dripicons-network-5:before {
  content: "\\e02c";
}

.dripicons-pamphlet:before {
  content: "\\e02d";
}

.dripicons-paperclip:before {
  content: "\\e02e";
}

.dripicons-pencil:before {
  content: "\\e02f";
}

.dripicons-phone:before {
  content: "\\e030";
}

.dripicons-photo:before {
  content: "\\e031";
}

.dripicons-photo-group:before {
  content: "\\e032";
}

.dripicons-pill:before {
  content: "\\e033";
}

.dripicons-pin:before {
  content: "\\e034";
}

.dripicons-plus:before {
  content: "\\e035";
}

.dripicons-power:before {
  content: "\\e036";
}

.dripicons-preview:before {
  content: "\\e037";
}

.dripicons-print:before {
  content: "\\e038";
}

.dripicons-pulse:before {
  content: "\\e039";
}

.dripicons-question:before {
  content: "\\e03a";
}

.dripicons-reply:before {
  content: "\\e03b";
}

.dripicons-reply-all:before {
  content: "\\e03c";
}

.dripicons-return:before {
  content: "\\e03d";
}

.dripicons-retweet:before {
  content: "\\e03e";
}

.dripicons-rocket:before {
  content: "\\e03f";
}

.dripicons-scale:before {
  content: "\\e040";
}

.dripicons-search:before {
  content: "\\e041";
}

.dripicons-shopping-bag:before {
  content: "\\e042";
}

.dripicons-skip:before {
  content: "\\e043";
}

.dripicons-stack:before {
  content: "\\e044";
}

.dripicons-star:before {
  content: "\\e045";
}

.dripicons-stopwatch:before {
  content: "\\e046";
}

.dripicons-store:before {
  content: "\\e047";
}

.dripicons-suitcase:before {
  content: "\\e048";
}

.dripicons-swap:before {
  content: "\\e049";
}

.dripicons-tag:before {
  content: "\\e04a";
}

.dripicons-tag-delete:before {
  content: "\\e04b";
}

.dripicons-tags:before {
  content: "\\e04c";
}

.dripicons-thumbs-down:before {
  content: "\\e04d";
}

.dripicons-thumbs-up:before {
  content: "\\e04e";
}

.dripicons-ticket:before {
  content: "\\e04f";
}

.dripicons-time-reverse:before {
  content: "\\e050";
}

.dripicons-to-do:before {
  content: "\\e051";
}

.dripicons-toggles:before {
  content: "\\e052";
}

.dripicons-trash:before {
  content: "\\e053";
}

.dripicons-trophy:before {
  content: "\\e054";
}

.dripicons-upload:before {
  content: "\\e055";
}

.dripicons-user:before {
  content: "\\e056";
}

.dripicons-user-group:before {
  content: "\\e057";
}

.dripicons-user-id:before {
  content: "\\e058";
}

.dripicons-vibrate:before {
  content: "\\e059";
}

.dripicons-view-apps:before {
  content: "\\e05a";
}

.dripicons-view-list:before {
  content: "\\e05b";
}

.dripicons-view-list-large:before {
  content: "\\e05c";
}

.dripicons-view-thumb:before {
  content: "\\e05d";
}

.dripicons-volume-full:before {
  content: "\\e05e";
}

.dripicons-volume-low:before {
  content: "\\e05f";
}

.dripicons-volume-medium:before {
  content: "\\e060";
}

.dripicons-volume-off:before {
  content: "\\e061";
}

.dripicons-wallet:before {
  content: "\\e062";
}

.dripicons-warning:before {
  content: "\\e063";
}

.dripicons-web:before {
  content: "\\e064";
}

.dripicons-weight:before {
  content: "\\e065";
}

.dripicons-wifi:before {
  content: "\\e066";
}

.dripicons-wrong:before {
  content: "\\e067";
}

.dripicons-zoom-in:before {
  content: "\\e068";
}

.dripicons-zoom-out:before {
  content: "\\e069";
}

/*
Template Name: Minible - Admin & Dashboard Template
Author: Themesbrand
Version: 2.1.0
Website: https://themesbrand.com/
Contact: themesbrand@gmail.com
File: Custom Bootstrap Css File
*/
/*!
 * Bootstrap  v5.3.2 (https://getbootstrap.com/)
 * Copyright 2011-2023 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --bs-blue: #5b73e8;
  --bs-indigo: #564ab1;
  --bs-purple: #6f42c1;
  --bs-pink: #e83e8c;
  --bs-red: #f46a6a;
  --bs-orange: #f1734f;
  --bs-yellow: #f1b44c;
  --bs-green: #34c38f;
  --bs-teal: #050505;
  --bs-cyan: #50a5f1;
  --bs-white: #fff;
  --bs-gray: #74788d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #f5f6f8;
  --bs-gray-300: #f6f6f6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #74788d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #5b73e8;
  --bs-secondary: #74788d;
  --bs-success: #34c38f;
  --bs-info: #50a5f1;
  --bs-warning: #f1b44c;
  --bs-danger: #f46a6a;
  --bs-pink: #e83e8c;
  --bs-light: #f5f6f8;
  --bs-dark: #343a40;
  --bs-purple: #6f42c1;
  --bs-primary-rgb: 91, 115, 232;
  --bs-secondary-rgb: 116, 120, 141;
  --bs-success-rgb: 52, 195, 143;
  --bs-info-rgb: 80, 165, 241;
  --bs-warning-rgb: 241, 180, 76;
  --bs-danger-rgb: 244, 106, 106;
  --bs-pink-rgb: 232, 62, 140;
  --bs-light-rgb: 245, 246, 248;
  --bs-dark-rgb: 52, 58, 64;
  --bs-purple-rgb: 111, 66, 193;
  --bs-primary-text-emphasis: rgb(5.2, 44, 101.2);
  --bs-secondary-text-emphasis: rgb(43.2, 46.8, 50);
  --bs-success-text-emphasis: rgb(10, 54, 33.6);
  --bs-info-text-emphasis: rgb(5.2, 80.8, 96);
  --bs-warning-text-emphasis: rgb(102, 77.2, 2.8);
  --bs-danger-text-emphasis: rgb(88, 21.2, 27.6);
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: rgb(206.6, 226, 254.6);
  --bs-secondary-bg-subtle: rgb(225.6, 227.4, 229);
  --bs-success-bg-subtle: rgb(209, 231, 220.8);
  --bs-info-bg-subtle: rgb(206.6, 244.4, 252);
  --bs-warning-bg-subtle: rgb(255, 242.6, 205.4);
  --bs-danger-bg-subtle: rgb(248, 214.6, 217.8);
  --bs-light-bg-subtle: rgb(251.5, 252, 252.5);
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: rgb(158.2, 197, 254.2);
  --bs-secondary-border-subtle: rgb(196.2, 199.8, 203);
  --bs-success-border-subtle: rgb(163, 207, 186.6);
  --bs-info-border-subtle: rgb(158.2, 233.8, 249);
  --bs-warning-border-subtle: rgb(255, 230.2, 155.8);
  --bs-danger-border-subtle: rgb(241, 174.2, 180.6);
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: "IBM Plex Sans", sans-serif;
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: "IBM Plex Sans", sans-serif;
  --bs-body-font-size: 0.9rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #495057;
  --bs-body-color-rgb: 73, 80, 87;
  --bs-body-bg: #f5f6f8;
  --bs-body-bg-rgb: 245, 246, 248;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(33, 37, 41, 0.75);
  --bs-secondary-color-rgb: 33, 37, 41;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(33, 37, 41, 0.5);
  --bs-tertiary-color-rgb: 33, 37, 41;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #5b73e8;
  --bs-link-color-rgb: 91, 115, 232;
  --bs-link-decoration: none;
  --bs-link-hover-color: rgb(30.3181818182, 61.9545454545, 216.1818181818);
  --bs-link-hover-color-rgb: 30, 62, 216;
  --bs-code-color: #e83e8c;
  --bs-highlight-color: #212529;
  --bs-highlight-bg: #fcf8e3;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #f5f6f8;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.25rem;
  --bs-border-radius-sm: 0.2rem;
  --bs-border-radius-lg: 0.4rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);
  --bs-form-valid-color: #198754;
  --bs-form-valid-border-color: #198754;
  --bs-form-invalid-color: #dc3545;
  --bs-form-invalid-border-color: #dc3545;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #f6f6f6;
  --bs-body-color-rgb: 246, 246, 246;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(246, 246, 246, 0.75);
  --bs-secondary-color-rgb: 246, 246, 246;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(246, 246, 246, 0.5);
  --bs-tertiary-color-rgb: 246, 246, 246;
  --bs-tertiary-bg: rgb(42.5, 47.5, 52.5);
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: rgb(156.6, 171, 241.2);
  --bs-secondary-text-emphasis: rgb(171.6, 174, 186.6);
  --bs-success-text-emphasis: rgb(133.2, 219, 187.8);
  --bs-info-text-emphasis: rgb(150, 201, 246.6);
  --bs-warning-text-emphasis: rgb(246.6, 210, 147.6);
  --bs-danger-text-emphasis: rgb(248.4, 165.6, 165.6);
  --bs-light-text-emphasis: #f8f9fa;
  --bs-dark-text-emphasis: #f6f6f6;
  --bs-primary-bg-subtle: rgb(18.2, 23, 46.4);
  --bs-secondary-bg-subtle: rgb(23.2, 24, 28.2);
  --bs-success-bg-subtle: rgb(10.4, 39, 28.6);
  --bs-info-bg-subtle: rgb(16, 33, 48.2);
  --bs-warning-bg-subtle: rgb(48.2, 36, 15.2);
  --bs-danger-bg-subtle: rgb(48.8, 21.2, 21.2);
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: #1a1d20;
  --bs-primary-border-subtle: rgb(54.6, 69, 139.2);
  --bs-secondary-border-subtle: rgb(69.6, 72, 84.6);
  --bs-success-border-subtle: rgb(31.2, 117, 85.8);
  --bs-info-border-subtle: rgb(48, 99, 144.6);
  --bs-warning-border-subtle: rgb(144.6, 108, 45.6);
  --bs-danger-border-subtle: rgb(146.4, 63.6, 63.6);
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: rgb(156.6, 171, 241.2);
  --bs-link-hover-color: rgb(176.28, 187.8, 243.96);
  --bs-link-color-rgb: 157, 171, 241;
  --bs-link-hover-color-rgb: 176, 188, 244;
  --bs-code-color: rgb(241.2, 139.2, 186);
  --bs-highlight-color: #f6f6f6;
  --bs-highlight-bg: rgb(96.4, 72, 30.4);
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: rgb(133.2, 219, 187.8);
  --bs-form-valid-border-color: rgb(133.2, 219, 187.8);
  --bs-form-invalid-color: rgb(248.4, 165.6, 165.6);
  --bs-form-invalid-border-color: rgb(248.4, 165.6, 165.6);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: rgba(0, 0, 0, 0.1);
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.5;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color);
}

h1, .h1 {
  font-size: calc(1.35rem + 1.2vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.25rem;
  }
}

h2, .h2 {
  font-size: calc(1.305rem + 0.66vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 1.8rem;
  }
}

h3, .h3 {
  font-size: calc(1.2825rem + 0.39vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.575rem;
  }
}

h4, .h4 {
  font-size: calc(1.26rem + 0.12vw);
}
@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.35rem;
  }
}

h5, .h5 {
  font-size: 1.125rem;
}

h6, .h6 {
  font-size: 0.9rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 600;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 87.5%;
}

mark, .mark {
  padding: 0.2em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: none;
}
a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 87.5%;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 87.5%;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #fff;
  background-color: #212529;
  border-radius: 0.2rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
  font-weight: 600;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #74788d;
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend {
  line-height: inherit;
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.125rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}
.display-1 {
  font-weight: 300;
  line-height: 1.2;
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}
.display-2 {
  font-weight: 300;
  line-height: 1.2;
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}
.display-3 {
  font-weight: 300;
  line-height: 1.2;
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}
.display-4 {
  font-weight: 300;
  line-height: 1.2;
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}
.display-5 {
  font-weight: 300;
  line-height: 1.2;
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}
.display-6 {
  font-weight: 300;
  line-height: 1.2;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 87.5%;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.125rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 87.5%;
  color: #74788d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #f5f6f8;
  border: 1px solid #f6f6f6;
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 87.5%;
  color: #74788d;
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 0.625rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 1.25rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}
.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: #495057;
  --bs-table-bg: var(--bs-body-bg);
  --bs-table-border-color: #f5f6f8;
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: #495057;
  --bs-table-striped-bg: #f8f9fa;
  --bs-table-active-color: #495057;
  --bs-table-active-bg: rgba(0, 0, 0, 0.1);
  --bs-table-hover-color: #495057;
  --bs-table-hover-bg: #f8f9fa;
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.75rem 0.75rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(1px * 2) solid #f5f6f8;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: 1px 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 1px;
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #000;
  --bs-table-bg: rgb(222.2, 227, 250.4);
  --bs-table-border-color: rgb(199.98, 204.3, 225.36);
  --bs-table-striped-bg: rgb(211.09, 215.65, 237.88);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(199.98, 204.3, 225.36);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(205.535, 209.975, 231.62);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #000;
  --bs-table-bg: rgb(227.2, 228, 232.2);
  --bs-table-border-color: rgb(204.48, 205.2, 208.98);
  --bs-table-striped-bg: rgb(215.84, 216.6, 220.59);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(204.48, 205.2, 208.98);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(210.16, 210.9, 214.785);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #000;
  --bs-table-bg: rgb(214.4, 243, 232.6);
  --bs-table-border-color: rgb(192.96, 218.7, 209.34);
  --bs-table-striped-bg: rgb(203.68, 230.85, 220.97);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(192.96, 218.7, 209.34);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(198.32, 224.775, 215.155);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #000;
  --bs-table-bg: rgb(220, 237, 252.2);
  --bs-table-border-color: rgb(198, 213.3, 226.98);
  --bs-table-striped-bg: rgb(209, 225.15, 239.59);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(198, 213.3, 226.98);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(203.5, 219.225, 233.285);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #000;
  --bs-table-bg: rgb(252.2, 240, 219.2);
  --bs-table-border-color: rgb(226.98, 216, 197.28);
  --bs-table-striped-bg: rgb(239.59, 228, 208.24);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(226.98, 216, 197.28);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(233.285, 222, 202.76);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #000;
  --bs-table-bg: rgb(252.8, 225.2, 225.2);
  --bs-table-border-color: rgb(227.52, 202.68, 202.68);
  --bs-table-striped-bg: rgb(240.16, 213.94, 213.94);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(227.52, 202.68, 202.68);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(233.84, 208.31, 208.31);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #000;
  --bs-table-bg: #f5f6f8;
  --bs-table-border-color: rgb(220.5, 221.4, 223.2);
  --bs-table-striped-bg: rgb(232.75, 233.7, 235.6);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(220.5, 221.4, 223.2);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(226.625, 227.55, 229.4);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #343a40;
  --bs-table-border-color: rgb(72.3, 77.7, 83.1);
  --bs-table-striped-bg: rgb(62.15, 67.85, 73.55);
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(72.3, 77.7, 83.1);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(67.225, 72.775, 78.325);
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.47rem + 1px);
  padding-bottom: calc(0.47rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 1.125rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.7875rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 87.5%;
  color: #74788d;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.47rem 0.75rem;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  appearance: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: #495057;
  background-color: #fff;
  border-color: rgb(210.9, 216.3, 221.7);
  outline: 0;
  box-shadow: none;
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: #74788d;
  opacity: 1;
}
.form-control:disabled {
  background-color: #f5f6f8;
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.47rem 0.75rem;
  margin: -0.47rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: #495057;
  background-color: #f5f6f8;
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: rgb(232.75, 233.7, 235.6);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.47rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: #495057;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.7875rem;
  border-radius: 0.2rem;
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 1.125rem;
  border-radius: 0.4rem;
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.94rem + 2px);
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + 2px);
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + 2px);
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.94rem + 2px);
  padding: 0.47rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: 0.25rem;
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: 0.25rem;
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + 2px);
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + 2px);
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
  display: block;
  width: 100%;
  padding: 0.47rem 1.75rem 0.47rem 0.75rem;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  appearance: none;
  background-color: #fff;
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: rgb(210.9, 216.3, 221.7);
  outline: 0;
  box-shadow: 0 0 0 0.15rem rgba(91, 115, 232, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
  background-image: none;
}
.form-select:disabled {
  color: #74788d;
  background-color: #f5f6f8;
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #495057;
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.7875rem;
  border-radius: var(--bs-border-radius-sm);
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.125rem;
  border-radius: var(--bs-border-radius-lg);
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
}

.form-check {
  display: block;
  min-height: 1.35rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: #fff;
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid #adb5bd;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
  transition: background-color 0.15s ease-in-out, background-position 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-check-input {
    transition: none;
  }
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: rgb(210.9, 216.3, 221.7);
  outline: 0;
  box-shadow: none;
}
.form-check-input:checked {
  background-color: #5b73e8;
  border-color: #5b73e8;
}
.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
}
.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #5b73e8;
  border-color: #5b73e8;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
}
.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
}

.form-range {
  width: 100%;
  height: 1.3rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #f5f6f8, none;
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #f5f6f8, none;
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #5b73e8;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: rgb(205.8, 213, 248.1);
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #f6f6f6;
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #5b73e8;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: rgb(205.8, 213, 248.1);
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #f6f6f6;
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}
.form-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + 2px);
  min-height: calc(3.5rem + 2px);
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:focus ~ label::after,
.form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.form-floating > .form-control-plaintext ~ label::after,
.form-floating > .form-select ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: #fff;
  border-radius: 0.25rem;
}
.form-floating > .form-control:-webkit-autofill ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: 1px 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #6c757d;
}
.form-floating > :disabled ~ label::after,
.form-floating > .form-control:disabled ~ label::after {
  background-color: #f5f6f8;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.47rem 0.75rem;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #f5f6f8;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.125rem;
  border-radius: 0.4rem;
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.7875rem;
  border-radius: 0.2rem;
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 2.5rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(1px * -1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 87.5%;
  color: #34c38f;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.4rem 0.7rem;
  margin-top: 0.1rem;
  font-size: 0.7875rem;
  color: #fff;
  background-color: rgba(52, 195, 143, 0.9);
  border-radius: 0.25rem;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #34c38f;
  padding-right: calc(1.5em + 0.94rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: #34c38f;
  box-shadow: 0 0 0 0.15rem rgba(52, 195, 143, 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.94rem);
  background-position: top calc(0.375em + 0.235rem) right calc(0.375em + 0.235rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: #34c38f;
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
  padding-right: calc(0.75em + 3.205rem);
  background-position: right 0.75rem center, center right 2.5rem;
  background-size: 16px 12px, calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: #34c38f;
  box-shadow: 0 0 0 0.15rem rgba(52, 195, 143, 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.94rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: #34c38f;
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: #34c38f;
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.15rem rgba(52, 195, 143, 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #34c38f;
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 87.5%;
  color: #f46a6a;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.4rem 0.7rem;
  margin-top: 0.1rem;
  font-size: 0.7875rem;
  color: #fff;
  background-color: rgba(244, 106, 106, 0.9);
  border-radius: 0.25rem;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #f46a6a;
  padding-right: calc(1.5em + 0.94rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: #f46a6a;
  box-shadow: 0 0 0 0.15rem rgba(244, 106, 106, 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.94rem);
  background-position: top calc(0.375em + 0.235rem) right calc(0.375em + 0.235rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: #f46a6a;
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  padding-right: calc(0.75em + 3.205rem);
  background-position: right 0.75rem center, center right 2.5rem;
  background-size: 16px 12px, calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: #f46a6a;
  box-shadow: 0 0 0 0.15rem rgba(244, 106, 106, 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.94rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: #f46a6a;
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: #f46a6a;
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.15rem rgba(244, 106, 106, 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #f46a6a;
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.47rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 0.9rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: 1px;
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: 0.25rem;
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.15rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #5b73e8;
  --bs-btn-border-color: #5b73e8;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(77.35, 97.75, 197.2);
  --bs-btn-hover-border-color: rgb(72.8, 92, 185.6);
  --bs-btn-focus-shadow-rgb: 116, 136, 235;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(72.8, 92, 185.6);
  --bs-btn-active-border-color: rgb(68.25, 86.25, 174);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #5b73e8;
  --bs-btn-disabled-border-color: #5b73e8;
}

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #74788d;
  --bs-btn-border-color: #74788d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(98.6, 102, 119.85);
  --bs-btn-hover-border-color: rgb(92.8, 96, 112.8);
  --bs-btn-focus-shadow-rgb: 137, 140, 158;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(92.8, 96, 112.8);
  --bs-btn-active-border-color: rgb(87, 90, 105.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #74788d;
  --bs-btn-disabled-border-color: #74788d;
}

.btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #34c38f;
  --bs-btn-border-color: #34c38f;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(44.2, 165.75, 121.55);
  --bs-btn-hover-border-color: rgb(41.6, 156, 114.4);
  --bs-btn-focus-shadow-rgb: 82, 204, 160;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(41.6, 156, 114.4);
  --bs-btn-active-border-color: rgb(39, 146.25, 107.25);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #34c38f;
  --bs-btn-disabled-border-color: #34c38f;
}

.btn-info {
  --bs-btn-color: #fff;
  --bs-btn-bg: #50a5f1;
  --bs-btn-border-color: #50a5f1;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(68, 140.25, 204.85);
  --bs-btn-hover-border-color: rgb(64, 132, 192.8);
  --bs-btn-focus-shadow-rgb: 106, 179, 243;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(64, 132, 192.8);
  --bs-btn-active-border-color: rgb(60, 123.75, 180.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #50a5f1;
  --bs-btn-disabled-border-color: #50a5f1;
}

.btn-warning {
  --bs-btn-color: #fff;
  --bs-btn-bg: #f1b44c;
  --bs-btn-border-color: #f1b44c;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(204.85, 153, 64.6);
  --bs-btn-hover-border-color: rgb(192.8, 144, 60.8);
  --bs-btn-focus-shadow-rgb: 243, 191, 103;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(192.8, 144, 60.8);
  --bs-btn-active-border-color: rgb(180.75, 135, 57);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #f1b44c;
  --bs-btn-disabled-border-color: #f1b44c;
}

.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #f46a6a;
  --bs-btn-border-color: #f46a6a;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(207.4, 90.1, 90.1);
  --bs-btn-hover-border-color: rgb(195.2, 84.8, 84.8);
  --bs-btn-focus-shadow-rgb: 246, 128, 128;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(195.2, 84.8, 84.8);
  --bs-btn-active-border-color: rgb(183, 79.5, 79.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #f46a6a;
  --bs-btn-disabled-border-color: #f46a6a;
}

.btn-pink {
  --bs-btn-color: #fff;
  --bs-btn-bg: #e83e8c;
  --bs-btn-border-color: #e83e8c;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(197.2, 52.7, 119);
  --bs-btn-hover-border-color: rgb(185.6, 49.6, 112);
  --bs-btn-focus-shadow-rgb: 235, 91, 157;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(185.6, 49.6, 112);
  --bs-btn-active-border-color: rgb(174, 46.5, 105);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #e83e8c;
  --bs-btn-disabled-border-color: #e83e8c;
}

.btn-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #f5f6f8;
  --bs-btn-border-color: #f5f6f8;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(208.25, 209.1, 210.8);
  --bs-btn-hover-border-color: rgb(196, 196.8, 198.4);
  --bs-btn-focus-shadow-rgb: 208, 209, 211;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(196, 196.8, 198.4);
  --bs-btn-active-border-color: rgb(183.75, 184.5, 186);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #f5f6f8;
  --bs-btn-disabled-border-color: #f5f6f8;
}

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #343a40;
  --bs-btn-border-color: #343a40;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(82.45, 87.55, 92.65);
  --bs-btn-hover-border-color: rgb(72.3, 77.7, 83.1);
  --bs-btn-focus-shadow-rgb: 82, 88, 93;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(92.6, 97.4, 102.2);
  --bs-btn-active-border-color: rgb(72.3, 77.7, 83.1);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #343a40;
  --bs-btn-disabled-border-color: #343a40;
}

.btn-purple {
  --bs-btn-color: #fff;
  --bs-btn-bg: #6f42c1;
  --bs-btn-border-color: #6f42c1;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(94.35, 56.1, 164.05);
  --bs-btn-hover-border-color: rgb(88.8, 52.8, 154.4);
  --bs-btn-focus-shadow-rgb: 133, 94, 202;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(88.8, 52.8, 154.4);
  --bs-btn-active-border-color: rgb(83.25, 49.5, 144.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #6f42c1;
  --bs-btn-disabled-border-color: #6f42c1;
}

.btn-outline-primary {
  --bs-btn-color: #5b73e8;
  --bs-btn-border-color: #5b73e8;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #5b73e8;
  --bs-btn-hover-border-color: #5b73e8;
  --bs-btn-focus-shadow-rgb: 91, 115, 232;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #5b73e8;
  --bs-btn-active-border-color: #5b73e8;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #5b73e8;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #5b73e8;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #74788d;
  --bs-btn-border-color: #74788d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #74788d;
  --bs-btn-hover-border-color: #74788d;
  --bs-btn-focus-shadow-rgb: 116, 120, 141;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #74788d;
  --bs-btn-active-border-color: #74788d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #74788d;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #74788d;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #34c38f;
  --bs-btn-border-color: #34c38f;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #34c38f;
  --bs-btn-hover-border-color: #34c38f;
  --bs-btn-focus-shadow-rgb: 52, 195, 143;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #34c38f;
  --bs-btn-active-border-color: #34c38f;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #34c38f;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #34c38f;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #50a5f1;
  --bs-btn-border-color: #50a5f1;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #50a5f1;
  --bs-btn-hover-border-color: #50a5f1;
  --bs-btn-focus-shadow-rgb: 80, 165, 241;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #50a5f1;
  --bs-btn-active-border-color: #50a5f1;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #50a5f1;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #50a5f1;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #f1b44c;
  --bs-btn-border-color: #f1b44c;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #f1b44c;
  --bs-btn-hover-border-color: #f1b44c;
  --bs-btn-focus-shadow-rgb: 241, 180, 76;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #f1b44c;
  --bs-btn-active-border-color: #f1b44c;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f1b44c;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f1b44c;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #f46a6a;
  --bs-btn-border-color: #f46a6a;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #f46a6a;
  --bs-btn-hover-border-color: #f46a6a;
  --bs-btn-focus-shadow-rgb: 244, 106, 106;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #f46a6a;
  --bs-btn-active-border-color: #f46a6a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f46a6a;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f46a6a;
  --bs-gradient: none;
}

.btn-outline-pink {
  --bs-btn-color: #e83e8c;
  --bs-btn-border-color: #e83e8c;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #e83e8c;
  --bs-btn-hover-border-color: #e83e8c;
  --bs-btn-focus-shadow-rgb: 232, 62, 140;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #e83e8c;
  --bs-btn-active-border-color: #e83e8c;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #e83e8c;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #e83e8c;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: #f5f6f8;
  --bs-btn-border-color: #f5f6f8;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f5f6f8;
  --bs-btn-hover-border-color: #f5f6f8;
  --bs-btn-focus-shadow-rgb: 245, 246, 248;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f5f6f8;
  --bs-btn-active-border-color: #f5f6f8;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f5f6f8;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f5f6f8;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #343a40;
  --bs-btn-border-color: #343a40;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #343a40;
  --bs-btn-hover-border-color: #343a40;
  --bs-btn-focus-shadow-rgb: 52, 58, 64;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #343a40;
  --bs-btn-active-border-color: #343a40;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #343a40;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #343a40;
  --bs-gradient: none;
}

.btn-outline-purple {
  --bs-btn-color: #6f42c1;
  --bs-btn-border-color: #6f42c1;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #6f42c1;
  --bs-btn-hover-border-color: #6f42c1;
  --bs-btn-focus-shadow-rgb: 111, 66, 193;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #6f42c1;
  --bs-btn-active-border-color: #6f42c1;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #6f42c1;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #6f42c1;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: #5b73e8;
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: rgb(30.3181818182, 61.9545454545, 216.1818181818);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: rgb(30.3181818182, 61.9545454545, 216.1818181818);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #74788d;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  text-decoration: none;
}
.btn-link:focus-visible {
  color: var(--bs-btn-color);
}
.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 1.125rem;
  --bs-btn-border-radius: 0.4rem;
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.7875rem;
  --bs-btn-border-radius: 0.2rem;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 0.9rem;
  --bs-dropdown-color: #495057;
  --bs-dropdown-bg: #fff;
  --bs-dropdown-border-color: rgba(0, 0, 0, 0.15);
  --bs-dropdown-border-radius: 0.25rem;
  --bs-dropdown-border-width: 0;
  --bs-dropdown-inner-border-radius: 0.25rem;
  --bs-dropdown-divider-bg: rgba(0, 0, 0, 0.15);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  --bs-dropdown-link-color: #212529;
  --bs-dropdown-link-hover-color: rgb(44.1, 47.9, 51.7);
  --bs-dropdown-link-hover-bg: #f8f9fa;
  --bs-dropdown-link-active-color: rgb(44.1, 47.9, 51.7);
  --bs-dropdown-link-active-bg: #f8f9fa;
  --bs-dropdown-link-disabled-color: #74788d;
  --bs-dropdown-item-padding-x: 1.5rem;
  --bs-dropdown-item-padding-y: 0.35rem;
  --bs-dropdown-header-color: #74788d;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.7875rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #f6f6f6;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: rgba(0, 0, 0, 0.15);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #f6f6f6;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: rgba(0, 0, 0, 0.15);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: rgb(44.1, 47.9, 51.7);
  --bs-dropdown-link-active-bg: #f8f9fa;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: 0.25rem;
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(1px * -1);
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(1px * -1);
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: #74788d;
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: 1px;
  --bs-nav-tabs-border-color: #ced4da;
  --bs-nav-tabs-border-radius: 0.25rem;
  --bs-nav-tabs-link-hover-border-color: #f5f6f8 #f5f6f8 #ced4da;
  --bs-nav-tabs-link-active-color: #495057;
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: #ced4da #ced4da var(--bs-body-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: 0.25rem;
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #5b73e8;
}
.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 600;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(0, 0, 0, 0.55);
  --bs-navbar-hover-color: rgba(0, 0, 0, 0.7);
  --bs-navbar-disabled-color: rgba(0, 0, 0, 0.3);
  --bs-navbar-active-color: rgba(0, 0, 0, 0.9);
  --bs-navbar-brand-padding-y: 0.33125rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.125rem;
  --bs-navbar-brand-color: rgba(0, 0, 0, 0.9);
  --bs-navbar-brand-hover-color: rgba(0, 0, 0, 0.9);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.125rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
  --bs-navbar-toggler-border-color: rgba(0, 0, 0, 0.1);
  --bs-navbar-toggler-border-radius: 0.25rem;
  --bs-navbar-toggler-focus-width: 0.15rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
}

.card {
  --bs-card-spacer-y: 1.25rem;
  --bs-card-spacer-x: 1.25rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: 0;
  --bs-card-border-color: #f6f6f6;
  --bs-card-border-radius: 0.25rem;
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: 0.25rem;
  --bs-card-cap-padding-y: 0.75rem;
  --bs-card-cap-padding-x: 1.25rem;
  --bs-card-cap-bg: rgba(0, 0, 0, 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: #fff;
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.625rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: #495057;
  --bs-accordion-bg: transparent;
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: rgba(0, 0, 0, 0.125);
  --bs-accordion-border-width: 1px;
  --bs-accordion-border-radius: 0.25rem;
  --bs-accordion-inner-border-radius: calc(0.25rem - 1px);
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: #495057;
  --bs-accordion-btn-bg: transparent;
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
  --bs-accordion-btn-icon-width: 16px;
  --bs-accordion-btn-icon-transform: rotate(180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
  --bs-accordion-btn-focus-border-color: rgb(210.9, 216.3, 221.7);
  --bs-accordion-btn-focus-box-shadow: none;
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: rgb(81.9, 103.5, 208.8);
  --bs-accordion-active-bg: rgb(238.6, 241, 252.7);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 0.9rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  border-color: var(--bs-accordion-btn-focus-border-color);
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:last-of-type .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush .accordion-collapse {
  border-width: 0;
}
.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush .accordion-item .accordion-button, .accordion-flush .accordion-item .accordion-button.collapsed {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: #74788d;
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: #74788d;
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: #74788d;
  --bs-pagination-bg: #fff;
  --bs-pagination-border-width: 1px;
  --bs-pagination-border-color: #ced4da;
  --bs-pagination-border-radius: 0.25rem;
  --bs-pagination-hover-color: rgb(30.3181818182, 61.9545454545, 216.1818181818);
  --bs-pagination-hover-bg: #f5f6f8;
  --bs-pagination-hover-border-color: #ced4da;
  --bs-pagination-focus-color: rgb(30.3181818182, 61.9545454545, 216.1818181818);
  --bs-pagination-focus-bg: #f5f6f8;
  --bs-pagination-focus-box-shadow: 0 0 0 0.15rem rgba(91, 115, 232, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #5b73e8;
  --bs-pagination-active-border-color: #5b73e8;
  --bs-pagination-disabled-color: #ced4da;
  --bs-pagination-disabled-bg: #fff;
  --bs-pagination-disabled-border-color: #ced4da;
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: -1px;
}
.page-item .page-link {
  border-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.125rem;
  --bs-pagination-border-radius: 0.4rem;
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.7875rem;
  --bs-pagination-border-radius: 0.2rem;
}

.badge {
  --bs-badge-padding-x: 0.4em;
  --bs-badge-padding-y: 0.25em;
  --bs-badge-font-size: 75%;
  --bs-badge-font-weight: 500;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: 0.25rem;
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1.25rem;
  --bs-alert-padding-y: 0.75rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: 1px solid var(--bs-alert-border-color);
  --bs-alert-border-radius: 0.25rem;
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 600;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 3.75rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 0.9375rem 1.25rem;
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-pink {
  --bs-alert-color: var(--bs-pink-text-emphasis);
  --bs-alert-bg: var(--bs-pink-bg-subtle);
  --bs-alert-border-color: var(--bs-pink-border-subtle);
  --bs-alert-link-color: var(--bs-pink-text-emphasis);
}

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

.alert-purple {
  --bs-alert-color: var(--bs-purple-text-emphasis);
  --bs-alert-bg: var(--bs-purple-bg-subtle);
  --bs-alert-border-color: var(--bs-purple-border-subtle);
  --bs-alert-link-color: var(--bs-purple-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 0.625rem;
  }
}
.progress,
.progress-stacked {
  --bs-progress-height: 0.625rem;
  --bs-progress-font-size: 0.675rem;
  --bs-progress-bg: #f5f6f8;
  --bs-progress-border-radius: 0.25rem;
  --bs-progress-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #5b73e8;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: #fff;
  --bs-list-group-border-color: #f5f6f8;
  --bs-list-group-border-width: 1px;
  --bs-list-group-border-radius: 0.25rem;
  --bs-list-group-item-padding-x: 1.25rem;
  --bs-list-group-item-padding-y: 0.75rem;
  --bs-list-group-action-color: #495057;
  --bs-list-group-action-hover-color: #495057;
  --bs-list-group-action-hover-bg: #f8f9fa;
  --bs-list-group-action-active-color: #495057;
  --bs-list-group-action-active-bg: #f5f6f8;
  --bs-list-group-disabled-color: #74788d;
  --bs-list-group-disabled-bg: #fff;
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #5b73e8;
  --bs-list-group-active-border-color: #5b73e8;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.list-group-item-action:active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-pink {
  --bs-list-group-color: var(--bs-pink-text-emphasis);
  --bs-list-group-bg: var(--bs-pink-bg-subtle);
  --bs-list-group-border-color: var(--bs-pink-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-pink-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-pink-border-subtle);
  --bs-list-group-active-color: var(--bs-pink-bg-subtle);
  --bs-list-group-active-bg: var(--bs-pink-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-pink-text-emphasis);
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.list-group-item-purple {
  --bs-list-group-color: var(--bs-purple-text-emphasis);
  --bs-list-group-bg: var(--bs-purple-bg-subtle);
  --bs-list-group-border-color: var(--bs-purple-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-purple-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-purple-border-subtle);
  --bs-list-group-active-color: var(--bs-purple-bg-subtle);
  --bs-list-group-active-bg: var(--bs-purple-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-purple-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: none;
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.25rem;
  opacity: var(--bs-btn-close-opacity);
}
.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  filter: var(--bs-btn-close-white-filter);
}

[data-bs-theme=dark] .btn-close {
  filter: var(--bs-btn-close-white-filter);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 0.625rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(255, 255, 255, 0.85);
  --bs-toast-border-width: 1px;
  --bs-toast-border-color: rgba(0, 0, 0, 0.1);
  --bs-toast-border-radius: 0.25rem;
  --bs-toast-box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  --bs-toast-header-color: #74788d;
  --bs-toast-header-bg: rgba(255, 255, 255, 0.85);
  --bs-toast-header-border-color: rgba(0, 0, 0, 0.05);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: #fff;
  --bs-modal-border-color: #f6f6f6;
  --bs-modal-border-width: 1px;
  --bs-modal-border-radius: 0.4rem;
  --bs-modal-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-modal-inner-border-radius: calc(0.4rem - 1px);
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: #f5f6f8;
  --bs-modal-header-border-width: 1px;
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: #f5f6f8;
  --bs-modal-footer-border-width: 1px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.fade .modal-dialog {
  transform: translate(0, -50px);
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 999;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.7rem;
  --bs-tooltip-padding-y: 0.4rem;
  --bs-tooltip-margin: 0;
  --bs-tooltip-font-size: 0.7875rem;
  --bs-tooltip-color: #fff;
  --bs-tooltip-bg: #000;
  --bs-tooltip-border-radius: 0.25rem;
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: "IBM Plex Sans", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 999;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.7875rem;
  --bs-popover-bg: #fff;
  --bs-popover-border-width: 1px;
  --bs-popover-border-color: rgba(0, 0, 0, 0.1);
  --bs-popover-border-radius: 0.4rem;
  --bs-popover-inner-border-radius: calc(0.4rem - 1px);
  --bs-popover-box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  --bs-popover-header-padding-x: 0.75rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: inherit;
  --bs-popover-header-bg: rgb(239.7, 239.7, 239.7);
  --bs-popover-body-padding-x: 0.75rem;
  --bs-popover-body-padding-y: 0.5rem;
  --bs-popover-body-color: #495057;
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: "IBM Plex Sans", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

/* rtl:options: {
  "autoRename": true,
  "stringMap":[ {
    "name"    : "prev-next",
    "search"  : "prev",
    "replace" : "next"
  } ]
} */
.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_51___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000;
}
.carousel-dark .carousel-caption {
  color: #000;
}

[data-bs-theme=dark] .carousel .carousel-control-prev-icon,
[data-bs-theme=dark] .carousel .carousel-control-next-icon, [data-bs-theme=dark].carousel .carousel-control-prev-icon,
[data-bs-theme=dark].carousel .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target], [data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {
  background-color: #000;
}
[data-bs-theme=dark] .carousel .carousel-caption, [data-bs-theme=dark].carousel .carousel-caption {
  color: #000;
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: #fff;
  --bs-offcanvas-border-width: 1px;
  --bs-offcanvas-border-color: #f6f6f6;
  --bs-offcanvas-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #fff !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #fff !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-pink {
  color: #fff !important;
  background-color: RGBA(var(--bs-pink-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-purple {
  color: #fff !important;
  background-color: RGBA(var(--bs-purple-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(73, 92, 186, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(73, 92, 186, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(93, 96, 113, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(93, 96, 113, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(42, 156, 114, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(42, 156, 114, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(64, 132, 193, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(64, 132, 193, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(193, 144, 61, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(193, 144, 61, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(195, 85, 85, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(195, 85, 85, var(--bs-link-underline-opacity, 1)) !important;
}

.link-pink {
  color: RGBA(var(--bs-pink-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-pink-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-pink:hover, .link-pink:focus {
  color: RGBA(186, 50, 112, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(186, 50, 112, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(247, 248, 249, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(247, 248, 249, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(42, 46, 51, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(42, 46, 51, var(--bs-link-underline-opacity, 1)) !important;
}

.link-purple {
  color: RGBA(var(--bs-purple-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-purple-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-purple:hover, .link-purple:focus {
  color: RGBA(89, 53, 154, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(89, 53, 154, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.5;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-pink {
  --bs-focus-ring-color: rgba(var(--bs-pink-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-purple {
  --bs-focus-ring-color: rgba(var(--bs-purple-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-pink {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-pink-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-purple {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-purple-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-0 {
  border-width: 0 !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.35rem + 1.2vw) !important;
}

.fs-2 {
  font-size: calc(1.305rem + 0.66vw) !important;
}

.fs-3 {
  font-size: calc(1.2825rem + 0.39vw) !important;
}

.fs-4 {
  font-size: calc(1.26rem + 0.12vw) !important;
}

.fs-5 {
  font-size: 1.125rem !important;
}

.fs-6 {
  font-size: 0.9rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 600 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-pink {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-pink-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-purple {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-purple-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-pink {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-pink-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-purple {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-purple-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-pink {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-pink-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-purple {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-purple-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.25rem !important;
  }
  .fs-2 {
    font-size: 1.8rem !important;
  }
  .fs-3 {
    font-size: 1.575rem !important;
  }
  .fs-4 {
    font-size: 1.35rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
/* =============
   General
============= */
html {
  position: relative;
  min-height: 100%;
}

.h1, .h2, .h3, .h4, .h5, .h6,
h1, h2, h3, h4, h5, h6 {
  color: #495057;
}

.h1,
h1 {
  font-size: 2.25rem;
}

.h2,
h2 {
  font-size: 1.8rem;
}

.h3,
h3 {
  font-size: 1.575rem;
}

.h4,
h4 {
  font-size: 1.35rem;
}

.h5,
h5 {
  font-size: 1.125rem;
}

.h6,
h6 {
  font-size: 0.9rem;
}

a {
  text-decoration: none !important;
}

label {
  font-weight: 500;
}

.blockquote {
  padding: 10px 20px;
  border-left: 4px solid #f6f6f6;
}

.blockquote-reverse {
  border-left: 0;
  border-right: 4px solid #f6f6f6;
  text-align: right;
}

@media (min-width: 1200px) {
  .container, .container-lg, .container-md, .container-sm, .container-xl, .container-xxl {
    max-width: 1140px;
  }
}

.row > * {
  position: relative;
}

label {
  margin-bottom: 0.5rem;
}

.bg-soft-primary {
  background-color: rgba(91, 115, 232, 0.25) !important;
}

.bg-soft-secondary {
  background-color: rgba(116, 120, 141, 0.25) !important;
}

.bg-soft-success {
  background-color: rgba(52, 195, 143, 0.25) !important;
}

.bg-soft-info {
  background-color: rgba(80, 165, 241, 0.25) !important;
}

.bg-soft-warning {
  background-color: rgba(241, 180, 76, 0.25) !important;
}

.bg-soft-danger {
  background-color: rgba(244, 106, 106, 0.25) !important;
}

.bg-soft-pink {
  background-color: rgba(232, 62, 140, 0.25) !important;
}

.bg-soft-light {
  background-color: rgba(245, 246, 248, 0.25) !important;
}

.bg-soft-dark {
  background-color: rgba(52, 58, 64, 0.25) !important;
}

.bg-soft-purple {
  background-color: rgba(111, 66, 193, 0.25) !important;
}

.bg-gradient-primary {
  background: linear-gradient(to bottom, #5b73e8, rgba(91, 115, 232, 0.5)) !important;
}

.bg-gradient-secondary {
  background: linear-gradient(to bottom, #74788d, rgba(116, 120, 141, 0.5)) !important;
}

.bg-gradient-success {
  background: linear-gradient(to bottom, #34c38f, rgba(52, 195, 143, 0.5)) !important;
}

.bg-gradient-info {
  background: linear-gradient(to bottom, #50a5f1, rgba(80, 165, 241, 0.5)) !important;
}

.bg-gradient-warning {
  background: linear-gradient(to bottom, #f1b44c, rgba(241, 180, 76, 0.5)) !important;
}

.bg-gradient-danger {
  background: linear-gradient(to bottom, #f46a6a, rgba(244, 106, 106, 0.5)) !important;
}

.bg-gradient-pink {
  background: linear-gradient(to bottom, #e83e8c, rgba(232, 62, 140, 0.5)) !important;
}

.bg-gradient-light {
  background: linear-gradient(to bottom, #f5f6f8, rgba(245, 246, 248, 0.5)) !important;
}

.bg-gradient-dark {
  background: linear-gradient(to bottom, #343a40, rgba(52, 58, 64, 0.5)) !important;
}

.bg-gradient-purple {
  background: linear-gradient(to bottom, #6f42c1, rgba(111, 66, 193, 0.5)) !important;
}

.rounded-pill {
  padding-right: 0.6em;
  padding-left: 0.6em;
}

.badge.bg-primary[href]:hover, .badge.bg-primary[href]:focus {
  background-color: rgb(73.1090909091, 99.7272727273, 229.4909090909) !important;
}

.bg-soft-primary {
  color: #5b73e8;
  background-color: rgba(91, 115, 232, 0.18);
}
.bg-soft-primary[href] {
  color: #5b73e8;
  text-decoration: none;
  background-color: rgba(91, 115, 232, 0.4);
}
.bg-soft-primary[href]:hover, .bg-soft-primary[href]:focus {
  color: #5b73e8;
  text-decoration: none;
  background-color: rgba(91, 115, 232, 0.4);
}

.badge.bg-secondary[href]:hover, .badge.bg-secondary[href]:focus {
  background-color: rgb(106.6102766798, 110.3509881423, 129.9897233202) !important;
}

.bg-soft-secondary {
  color: #74788d;
  background-color: rgba(116, 120, 141, 0.18);
}
.bg-soft-secondary[href] {
  color: #74788d;
  text-decoration: none;
  background-color: rgba(116, 120, 141, 0.4);
}
.bg-soft-secondary[href]:hover, .bg-soft-secondary[href]:focus {
  color: #74788d;
  text-decoration: none;
  background-color: rgba(116, 120, 141, 0.4);
}

.badge.bg-success[href]:hover, .badge.bg-success[href]:focus {
  background-color: rgb(47.7052631579, 178.8947368421, 131.1894736842) !important;
}

.bg-soft-success {
  color: #34c38f;
  background-color: rgba(52, 195, 143, 0.18);
}
.bg-soft-success[href] {
  color: #34c38f;
  text-decoration: none;
  background-color: rgba(52, 195, 143, 0.4);
}
.bg-soft-success[href]:hover, .bg-soft-success[href]:focus {
  color: #34c38f;
  text-decoration: none;
  background-color: rgba(52, 195, 143, 0.4);
}

.badge.bg-info[href]:hover, .badge.bg-info[href]:focus {
  background-color: rgb(61.1111111111, 155.2857142857, 239.4888888889) !important;
}

.bg-soft-info {
  color: #50a5f1;
  background-color: rgba(80, 165, 241, 0.18);
}
.bg-soft-info[href] {
  color: #50a5f1;
  text-decoration: none;
  background-color: rgba(80, 165, 241, 0.4);
}
.bg-soft-info[href]:hover, .bg-soft-info[href]:focus {
  color: #50a5f1;
  text-decoration: none;
  background-color: rgba(80, 165, 241, 0.4);
}

.badge.bg-warning[href]:hover, .badge.bg-warning[href]:focus {
  background-color: rgb(239.5202072539, 172.0725388601, 57.0797927461) !important;
}

.bg-soft-warning {
  color: #f1b44c;
  background-color: rgba(241, 180, 76, 0.18);
}
.bg-soft-warning[href] {
  color: #f1b44c;
  text-decoration: none;
  background-color: rgba(241, 180, 76, 0.4);
}
.bg-soft-warning[href]:hover, .bg-soft-warning[href]:focus {
  color: #f1b44c;
  text-decoration: none;
  background-color: rgba(241, 180, 76, 0.4);
}

.badge.bg-danger[href]:hover, .badge.bg-danger[href]:focus {
  background-color: rgb(242.5975, 87.0025, 87.0025) !important;
}

.bg-soft-danger {
  color: #f46a6a;
  background-color: rgba(244, 106, 106, 0.18);
}
.bg-soft-danger[href] {
  color: #f46a6a;
  text-decoration: none;
  background-color: rgba(244, 106, 106, 0.4);
}
.bg-soft-danger[href]:hover, .bg-soft-danger[href]:focus {
  color: #f46a6a;
  text-decoration: none;
  background-color: rgba(244, 106, 106, 0.4);
}

.badge.bg-pink[href]:hover, .badge.bg-pink[href]:focus {
  background-color: rgb(229.8277777778, 43.7722222222, 129.1388888889) !important;
}

.bg-soft-pink {
  color: #e83e8c;
  background-color: rgba(232, 62, 140, 0.18);
}
.bg-soft-pink[href] {
  color: #e83e8c;
  text-decoration: none;
  background-color: rgba(232, 62, 140, 0.4);
}
.bg-soft-pink[href]:hover, .bg-soft-pink[href]:focus {
  color: #e83e8c;
  text-decoration: none;
  background-color: rgba(232, 62, 140, 0.4);
}

.badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
  background-color: rgb(233, 235.2, 239.6) !important;
}

.bg-soft-light {
  color: #f5f6f8;
  background-color: rgba(245, 246, 248, 0.18);
}
.bg-soft-light[href] {
  color: #f5f6f8;
  text-decoration: none;
  background-color: rgba(245, 246, 248, 0.4);
}
.bg-soft-light[href]:hover, .bg-soft-light[href]:focus {
  color: #f5f6f8;
  text-decoration: none;
  background-color: rgba(245, 246, 248, 0.4);
}

.badge.bg-dark[href]:hover, .badge.bg-dark[href]:focus {
  background-color: rgb(42.8551724138, 47.8, 52.7448275862) !important;
}

.bg-soft-dark {
  color: #343a40;
  background-color: rgba(52, 58, 64, 0.18);
}
.bg-soft-dark[href] {
  color: #343a40;
  text-decoration: none;
  background-color: rgba(52, 58, 64, 0.4);
}
.bg-soft-dark[href]:hover, .bg-soft-dark[href]:focus {
  color: #343a40;
  text-decoration: none;
  background-color: rgba(52, 58, 64, 0.4);
}

.badge.bg-purple[href]:hover, .badge.bg-purple[href]:focus {
  background-color: rgb(101.7139442231, 58.9370517928, 179.6629482072) !important;
}

.bg-soft-purple {
  color: #6f42c1;
  background-color: rgba(111, 66, 193, 0.18);
}
.bg-soft-purple[href] {
  color: #6f42c1;
  text-decoration: none;
  background-color: rgba(111, 66, 193, 0.4);
}
.bg-soft-purple[href]:hover, .bg-soft-purple[href]:focus {
  color: #6f42c1;
  text-decoration: none;
  background-color: rgba(111, 66, 193, 0.4);
}

.badge.bg-light {
  color: #495057;
}
.badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
  color: #495057;
}

.badge.bg-dark {
  color: #f5f6f8;
}

button, a {
  outline: none !important;
}

.btn-rounded {
  border-radius: 30px;
}

.btn-dark, .btn-secondary {
  color: #f5f6f8;
}

.btn-outline-light {
  color: #212529;
}

.btn-soft-primary {
  background-color: rgba(91, 115, 232, 0.25);
  border-color: rgba(91, 115, 232, 0.25);
  color: #5b73e8;
}

.btn-soft-secondary {
  background-color: rgba(116, 120, 141, 0.25);
  border-color: rgba(116, 120, 141, 0.25);
  color: #74788d;
}

.btn-soft-success {
  background-color: rgba(52, 195, 143, 0.25);
  border-color: rgba(52, 195, 143, 0.25);
  color: #34c38f;
}

.btn-soft-info {
  background-color: rgba(80, 165, 241, 0.25);
  border-color: rgba(80, 165, 241, 0.25);
  color: #50a5f1;
}

.btn-soft-warning {
  background-color: rgba(241, 180, 76, 0.25);
  border-color: rgba(241, 180, 76, 0.25);
  color: #f1b44c;
}

.btn-soft-danger {
  background-color: rgba(244, 106, 106, 0.25);
  border-color: rgba(244, 106, 106, 0.25);
  color: #f46a6a;
}

.btn-soft-pink {
  background-color: rgba(232, 62, 140, 0.25);
  border-color: rgba(232, 62, 140, 0.25);
  color: #e83e8c;
}

.btn-soft-light {
  background-color: rgba(245, 246, 248, 0.25);
  border-color: rgba(245, 246, 248, 0.25);
  color: #f5f6f8;
}

.btn-soft-dark {
  background-color: rgba(52, 58, 64, 0.25);
  border-color: rgba(52, 58, 64, 0.25);
  color: #343a40;
}

.btn-soft-purple {
  background-color: rgba(111, 66, 193, 0.25);
  border-color: rgba(111, 66, 193, 0.25);
  color: #6f42c1;
}

.breadcrumb-item > a {
  color: #495057;
}
.breadcrumb-item + .breadcrumb-item::before {
  font-family: "Material Design Icons";
}

.card {
  margin-bottom: 1.25rem;
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
}

.card-drop {
  color: #495057;
}

.card-title {
  font-size: 16px;
  margin: 0 0 7px 0;
  font-weight: 600;
}

.card-title-desc {
  color: #74788d;
  margin-bottom: 24px;
}

.dropdown-menu {
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  animation-name: DropDownSlide;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  margin: 0;
  position: absolute;
  z-index: 1000;
}
.dropdown-menu.show {
  top: 100% !important;
}
.dropdown-menu[style] {
  right: auto !important;
  left: 0;
}

.dropdown-menu-end[style] {
  left: auto !important;
  right: 0 !important;
}

.dropdown-menu[data-popper-placement^=right], .dropdown-menu[data-popper-placement^=top], .dropdown-menu[data-popper-placement^=left] {
  top: auto !important;
  animation: none !important;
}

@keyframes DropDownSlide {
  100% {
    transform: translateY(0);
  }
  0% {
    transform: translateY(10px);
  }
}
@media (min-width: 600px) {
  .dropdown-menu-lg {
    width: 320px;
  }
  .dropdown-menu-md {
    width: 240px;
  }
}
.dropdown-divider {
  border-top-color: #f5f6f8;
}

.dropdown-mega-menu-xl {
  width: 40rem;
}

.dropdown-mega-menu-lg {
  width: 26rem;
}

.nav-tabs > li > a, .nav-pills > li > a {
  color: #495057;
  font-weight: 500;
}

.nav-pills > a {
  color: #495057;
  font-weight: 500;
}

.nav-tabs-custom {
  border-bottom: 2px solid #f6f6f6;
}
.nav-tabs-custom .nav-item {
  position: relative;
  color: #343a40;
}
.nav-tabs-custom .nav-item .nav-link {
  border: none;
}
.nav-tabs-custom .nav-item .nav-link::after {
  content: "";
  background: #5b73e8;
  height: 2px;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: -2px;
  transition: all 250ms ease 0s;
  transform: scale(0);
}
.nav-tabs-custom .nav-item .nav-link.active {
  color: #5b73e8;
}
.nav-tabs-custom .nav-item .nav-link.active:after {
  transform: scale(1);
}

.nav-pills .nav-link.active, .nav-pills .show > .nav-link {
  color: #fff;
  background-color: #4360AB;
}

.vertical-nav .nav .nav-link {
  padding: 24px 16px;
  text-align: center;
  margin-bottom: 8px;
}
.vertical-nav .nav .nav-link .nav-icon {
  font-size: 24px;
}

.table th {
  font-weight: 600;
}
.table .table-light {
  color: #495057;
  border-color: #f5f6f8;
  background-color: #f8f9fa;
}

.table > :not(caption) > * > * {
  border-bottom-width: 0px;
  border-top-width: 1px;
}

.table > :not(:last-child) > :last-child > * {
  border-bottom-color: #f5f6f8;
}

.table-dark > :not(:last-child) > :last-child > * {
  border-bottom-color: rgb(67.225, 72.775, 78.325);
}

.table-nowrap th, .table-nowrap td {
  white-space: nowrap;
}

.table-centered td, .table-centered th {
  vertical-align: middle !important;
}

.table-card-list {
  border-collapse: separate;
  border-spacing: 0 12px;
}
.table-card-list tr {
  background-color: #fff;
}

.table > thead:last-child {
  display: none;
}

.pagination-rounded .page-link {
  border-radius: 30px !important;
  margin: 0 3px !important;
  border: none;
  width: 32px;
  height: 32px;
  padding: 0;
  text-align: center;
  line-height: 32px;
}

@media only screen and (max-width: 768px) {
  .pagination {
    justify-content: center;
  }
}
.progress-sm {
  height: 5px;
}

.progress-md {
  height: 8px;
}

.progress-lg {
  height: 12px;
}

.progress-xl {
  height: 16px;
}

.animated-progess {
  position: relative;
}
.animated-progess .progress-bar {
  position: relative;
  border-radius: 6px;
  animation: animate-positive 2s;
}

@keyframes animate-positive {
  0% {
    width: 0;
  }
}
/*
Template Name: Minible - Admin & Dashboard Template
Author: Themesbrand
Version: 2.1.0
Website: https://themesbrand.com/
Contact: themesbrand@gmail.com
File: Main Css File
*/
#page-topbar {
  position: fixed;
  top: 0;
  right: 0;
  left: 250px;
  z-index: 4;
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
}

.navbar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  height: 65px;
  padding: 0 calc(1.25rem / 2) 0 0;
}
.navbar-header .dropdown .show.header-item {
  background-color: #f8f9fa;
}
.navbar-header .navbar-brand-box {
  display: none;
}

body.vertical-collpsed #page-topbar {
  left: 70px;
}
@media (max-width: 991.98px) {
  body.vertical-collpsed #page-topbar {
    left: 0;
  }
}
body:not(.vertical-collpsed) .navbar-header .vertical-menu-btn {
  display: none;
}
body:not(.vertical-collpsed) .app-search {
  margin-left: 10px;
}

.navbar-brand-box {
  width: 250px;
  position: fixed;
  z-index: 1;
  background-color: #ffffff;
}

.logo {
  line-height: 65px;
}
.logo .logo-sm {
  display: none;
}

.logo-dark {
  display: block;
}

.logo-light {
  display: none;
}

/* Search */
.app-search {
  padding: calc(27px / 2) 0;
}
.app-search .form-control {
  border: none;
  height: 38px;
  padding-left: 40px;
  padding-right: 20px;
  background-color: transparent;
  box-shadow: none;
  border-radius: 5px;
}
.app-search span {
  position: absolute;
  z-index: 10;
  font-size: 16px;
  line-height: 38px;
  left: 13px;
  top: 0;
  color: #74788d;
}

.megamenu-list li {
  position: relative;
  padding: 5px 0px;
}
.megamenu-list li a {
  color: #495057;
}

@media (max-width: 991.98px) {
  .navbar-brand-box {
    width: auto;
  }
  #page-topbar {
    left: 0;
  }
  #page-topbar .navbar-header .navbar-brand-box {
    display: inline-block;
    position: relative;
  }
  #page-topbar .navbar-header .vertical-menu-btn {
    display: inline-block;
  }
  .logo span.logo-lg {
    display: none;
  }
  .logo span.logo-sm {
    display: inline-block;
  }
}
.page-content {
  padding: calc(65px + 1.25rem) calc(1.25rem / 2) 120px calc(1.25rem / 2);
}

.header-item {
  height: 65px;
  box-shadow: none !important;
  color: #555b6d;
  border: 0;
  border-radius: 0px;
}
.header-item:hover {
  color: #555b6d;
}

.header-profile-user {
  height: 36px;
  width: 36px;
  background-color: #f6f6f6;
  padding: 3px;
}

.noti-icon i {
  font-size: 22px;
  color: #555b6d;
}
.noti-icon .badge {
  position: absolute;
  top: 12px;
  right: 5px;
}

.notification-item .d-flex {
  padding: 0.75rem 1rem;
  display: flex;
}
.notification-item .d-flex:hover {
  background-color: #f8f9fa;
}

.dropdown-icon-item {
  display: block;
  border-radius: 3px;
  line-height: 34px;
  text-align: center;
  padding: 15px 0 9px;
  display: block;
  border: 1px solid transparent;
  color: #74788d;
}
.dropdown-icon-item img {
  height: 24px;
}
.dropdown-icon-item span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dropdown-icon-item:hover {
  border-color: #f5f6f8;
}

.fullscreen-enable [data-bs-toggle=fullscreen] .uil-minus-path::before {
  content: "\\eb8d";
}

body[data-topbar=dark] #page-topbar {
  background-color: #2f374e;
}
body[data-topbar=dark] .navbar-header .dropdown .show.header-item {
  background-color: rgba(255, 255, 255, 0.05);
}
body[data-topbar=dark] .navbar-header .waves-effect .waves-ripple {
  background: rgba(255, 255, 255, 0.4);
}
body[data-topbar=dark] .header-item {
  color: #e9ecef;
}
body[data-topbar=dark] .header-item:hover {
  color: #e9ecef;
}
body[data-topbar=dark] .header-profile-user {
  background-color: rgba(255, 255, 255, 0.25);
}
body[data-topbar=dark] .noti-icon i {
  color: #e9ecef;
}
body[data-topbar=dark] .logo-dark {
  display: none;
}
body[data-topbar=dark] .logo-light {
  display: block;
}
body[data-topbar=dark] .app-search .form-control {
  background-color: rgb(54.6704, 63.976, 90.7296);
  color: #fff;
}
body[data-topbar=dark] .app-search span,
body[data-topbar=dark] .app-search input.form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.5);
}

body[data-sidebar=dark] .navbar-brand-box {
  background: #1c2742;
}
body[data-sidebar=dark] .navbar-brand-box .logo-dark {
  display: none;
}
body[data-sidebar=dark] .navbar-brand-box .logo-light {
  display: block;
}

@media (max-width: 600px) {
  .navbar-header .dropdown {
    position: static;
  }
  .navbar-header .dropdown .dropdown-menu {
    left: 10px !important;
    right: 10px !important;
  }
}
@media (max-width: 380px) {
  .navbar-brand-box {
    display: none;
  }
}
body[data-layout=horizontal] .page-content {
  padding: calc(80px + 1.25rem) calc(1.25rem / 2) 120px calc(1.25rem / 2);
}
@media (max-width: 991.98px) {
  body[data-layout=horizontal] .page-content {
    margin-top: 0px;
  }
}

@media (max-width: 374.99px) {
  .navbar-brand-box {
    padding: 0 1rem;
    text-align: center;
  }
  .language-switch {
    display: none !important;
  }
}
.page-title-box {
  padding-bottom: 1.25rem;
}
.page-title-box .breadcrumb {
  background-color: transparent;
  padding: 0;
}
.page-title-box h4, .page-title-box .h4 {
  font-weight: 600;
  font-size: 18px !important;
}
@media (max-width: 575.98px) {
  .page-title-box .page-title-right {
    display: none;
  }
}

.footer {
  bottom: 0;
  padding: 20px calc(1.25rem / 2);
  position: absolute;
  right: 0;
  color: #74788d;
  left: 250px;
  height: 120px;
  box-shadow: 0 0px 4px rgba(15, 34, 58, 0.12);
}

@media (max-width: 992px) {
  .footer {
    left: 0;
  }
}
.vertical-collpsed .footer {
  left: 70px;
}

body[data-layout=horizontal] .footer {
  left: 0 !important;
}

.right-bar {
  background-color: #fff;
  box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.06), 0 1px 0 0 rgba(0, 0, 0, 0.02);
  display: block;
  position: fixed;
  transition: all 200ms ease-out;
  width: 280px;
  z-index: 9999;
  float: right !important;
  right: -290px;
  top: 0;
  bottom: 0;
}
.right-bar .right-bar-toggle {
  background-color: rgb(68.0034482759, 75.85, 83.6965517241);
  height: 24px;
  width: 24px;
  line-height: 24px;
  color: #f5f6f8;
  text-align: center;
  border-radius: 50%;
}
.right-bar .right-bar-toggle:hover {
  background-color: rgb(74.8620689655, 83.5, 92.1379310345);
}

.rightbar-overlay {
  background-color: rgba(52, 58, 64, 0.55);
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: none;
  z-index: 9998;
  transition: all 0.2s ease-out;
}

.right-bar-enabled .right-bar {
  right: 0;
}
.right-bar-enabled .rightbar-overlay {
  display: block;
}

@media (max-width: 575.98px) {
  .right-bar {
    overflow: auto;
  }
  .right-bar .slimscroll-menu {
    height: auto !important;
  }
}
.metismenu {
  margin: 0;
}
.metismenu li {
  display: block;
  width: 100%;
}
.metismenu .mm-collapse {
  display: none;
}
.metismenu .mm-collapse:not(.mm-show) {
  display: none;
}
.metismenu .mm-collapse.mm-show {
  display: block;
}
.metismenu .mm-collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition-timing-function: ease;
  transition-duration: 0.35s;
  transition-property: height, visibility;
}

.vertical-menu {
  width: 250px;
  z-index: 1005;
  background: #ffffff;
  bottom: 0;
  margin-top: 0;
  position: fixed;
  top: 0;
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
}
.vertical-menu .vertical-menu-btn {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 2;
}

.main-content {
  margin-left: 250px;
  overflow: hidden;
}
.main-content .content {
  padding: 0 15px 10px 15px;
  margin-top: 65px;
}

.sidebar-menu-scroll {
  height: calc(100% - 65px);
  margin-top: 65px;
}

#sidebar-menu {
  padding: 10px 0 30px 0;
}
#sidebar-menu .mm-active > .has-arrow:after {
  transform: rotate(-180deg);
}
#sidebar-menu .has-arrow:after {
  content: "\\f0140";
  font-family: "Material Design Icons";
  display: block;
  float: right;
  transition: transform 0.2s;
  font-size: 1rem;
}
#sidebar-menu ul li a {
  display: block;
  padding: 0.6rem 1.1rem;
  color: #7b8190;
  position: relative;
  font-size: 15px;
  font-weight: 500;
  transition: all 0.4s;
  margin: 0 10px;
  border-radius: 3px;
}
#sidebar-menu ul li a i {
  display: inline-block;
  min-width: 1.5rem;
  padding-bottom: 0.125em;
  font-size: 1.05rem;
  line-height: 1.40625rem;
  vertical-align: middle;
  color: #7b8190;
  transition: all 0.4s;
}
#sidebar-menu ul li a:hover {
  color: #383c40;
}
#sidebar-menu ul li a:hover i {
  color: #383c40;
}
#sidebar-menu ul li .badge {
  margin-top: 4px;
}
#sidebar-menu ul li ul.sub-menu {
  padding: 0;
}
#sidebar-menu ul li ul.sub-menu li a {
  padding: 0.4rem 1.5rem 0.4rem 3.5rem;
  font-weight: 400;
  color: #7b8190;
  margin: 0;
  background-color: transparent;
  font-size: 14.4px;
}
#sidebar-menu ul li ul.sub-menu li a:hover {
  color: #383c40;
}
#sidebar-menu ul li ul.sub-menu li ul.sub-menu {
  padding: 0;
}
#sidebar-menu ul li ul.sub-menu li ul.sub-menu li a {
  padding: 0.4rem 1.5rem 0.4rem 4.5rem;
  font-size: 13.5px;
}

.menu-title {
  padding: 12px 20px !important;
  letter-spacing: 0.05em;
  pointer-events: none;
  cursor: default;
  font-size: 11px;
  text-transform: uppercase;
  color: #7b8190;
  font-weight: 600;
}

.mm-active {
  color: #5b73e8 !important;
}
.mm-active > a {
  background-color: #f3f8fb;
  color: #5b73e8 !important;
}
.mm-active > a > i {
  color: #5b73e8 !important;
}
.mm-active .active {
  color: #5b73e8 !important;
}
.mm-active .active i {
  color: #5b73e8 !important;
}
.mm-active > i {
  color: #5b73e8 !important;
}

@media (max-width: 992px) {
  .vertical-menu {
    display: none;
    top: 65px;
  }
  .vertical-menu .sidebar-menu-scroll {
    height: 100%;
    margin-top: 0;
  }
  .vertical-menu .navbar-brand-box,
  .vertical-menu .vertical-menu-btn {
    display: none;
  }
  .main-content {
    margin-left: 0 !important;
  }
  body.sidebar-enable .vertical-menu {
    display: block;
  }
}
@media (min-width: 769px) {
  .vertical-collpsed {
    min-height: 1450px;
  }
}
.vertical-collpsed .main-content {
  margin-left: 70px;
}
.vertical-collpsed .navbar-brand-box {
  width: 70px !important;
}
.vertical-collpsed .logo span.logo-lg {
  display: none;
}
.vertical-collpsed .logo span.logo-sm {
  display: block;
}
.vertical-collpsed .vertical-menu {
  position: absolute;
  width: 70px !important;
  z-index: 1001;
}
.vertical-collpsed .vertical-menu .simplebar-mask,
.vertical-collpsed .vertical-menu .simplebar-content-wrapper {
  overflow: visible !important;
}
.vertical-collpsed .vertical-menu .simplebar-scrollbar,
.vertical-collpsed .vertical-menu .vertical-menu-btn {
  display: none !important;
}
.vertical-collpsed .vertical-menu .simplebar-offset {
  bottom: 0 !important;
}
.vertical-collpsed .vertical-menu #sidebar-menu .menu-title,
.vertical-collpsed .vertical-menu #sidebar-menu .badge,
.vertical-collpsed .vertical-menu #sidebar-menu .collapse.in {
  display: none !important;
}
.vertical-collpsed .vertical-menu #sidebar-menu .nav.collapse {
  height: inherit !important;
}
.vertical-collpsed .vertical-menu #sidebar-menu .has-arrow:after {
  display: none;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li {
  position: relative;
  white-space: nowrap;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a {
  padding: 15px 0;
  transition: none;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a:hover, .vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a:active, .vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a:focus {
  color: #383c40;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a i {
  font-size: 1.3rem;
  text-align: center;
  min-width: 50px;
  padding-bottom: 0;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a span {
  display: none;
  padding-left: 25px;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a {
  position: relative;
  width: calc(180px + 70px);
  color: #5b73e8;
  background-color: #f3f8fb;
  transition: none;
  box-shadow: inset 0 3px 10px 0 rgba(154, 161, 171, 0.2);
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a i {
  color: #5b73e8;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a span {
  display: inline;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > ul {
  display: block;
  left: 70px;
  position: absolute;
  width: 190px;
  height: auto !important;
  box-shadow: 3px 5px 10px 0 rgba(54, 61, 71, 0.1);
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > ul ul {
  box-shadow: 3px 5px 10px 0 rgba(54, 61, 71, 0.1);
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > ul a {
  box-shadow: none;
  padding: 8px 20px;
  position: relative;
  width: 190px;
  z-index: 6;
  color: #7b8190;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > ul a:hover {
  color: #383c40;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul ul {
  padding: 5px 0;
  z-index: 9999;
  display: none;
  background-color: #ffffff;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul ul li:hover > ul {
  display: block;
  left: 190px;
  height: auto !important;
  margin-top: -36px;
  position: absolute;
  width: 190px;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul ul li > a span.pull-right {
  position: absolute;
  right: 20px;
  top: 12px;
  transform: rotate(270deg);
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul ul li.active a {
  color: #f8f9fa;
}

body[data-sidebar=dark] .vertical-menu {
  background: #1c2742;
}
body[data-sidebar=dark] .vertical-menu .vertical-menu-btn {
  color: #8c98bb;
}
body[data-sidebar=dark] #sidebar-menu ul li a {
  color: #8c98bb;
}
body[data-sidebar=dark] #sidebar-menu ul li a i {
  color: #6d7794;
}
body[data-sidebar=dark] #sidebar-menu ul li a:hover {
  color: #ffffff;
}
body[data-sidebar=dark] #sidebar-menu ul li a:hover i {
  color: #ffffff;
}
body[data-sidebar=dark] #sidebar-menu ul li ul.sub-menu li a {
  color: #7b85a2;
}
body[data-sidebar=dark] #sidebar-menu ul li ul.sub-menu li a:hover {
  color: #ffffff;
}
body[data-sidebar=dark].vertical-collpsed {
  min-height: 1300px;
}
body[data-sidebar=dark].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a {
  background: rgb(31.0382978723, 43.2319148936, 73.1617021277);
  color: #ffffff;
}
body[data-sidebar=dark].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a i {
  color: #ffffff;
}
body[data-sidebar=dark].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > ul a {
  color: #7b85a2;
}
body[data-sidebar=dark].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > ul a:hover {
  color: #ffffff;
}
body[data-sidebar=dark].vertical-collpsed .vertical-menu #sidebar-menu > ul ul {
  background-color: #1c2742;
}
body[data-sidebar=dark].vertical-collpsed .vertical-menu #sidebar-menu ul li.mm-active .active {
  color: #5b73e8 !important;
}
body[data-sidebar=dark].vertical-collpsed .vertical-menu #sidebar-menu ul li.mm-active .active i {
  color: #5b73e8 !important;
}
body[data-sidebar=dark] .mm-active {
  color: #ffffff !important;
}
body[data-sidebar=dark] .mm-active > i {
  color: #ffffff !important;
}
body[data-sidebar=dark] .mm-active > a {
  background-color: #293552;
  color: #ffffff !important;
}
body[data-sidebar=dark] .mm-active > a > i {
  color: #ffffff !important;
}
body[data-sidebar=dark] .mm-active .active {
  color: #ffffff !important;
}
body[data-sidebar=dark] .mm-active .active i {
  color: #ffffff !important;
}
body[data-sidebar=dark] .menu-title {
  color: #6d7794;
}

body[data-layout=horizontal] .main-content {
  margin-left: 0 !important;
}

body[data-sidebar-size=small] .navbar-brand-box {
  width: 160px;
}
@media (max-width: 991.98px) {
  body[data-sidebar-size=small] .navbar-brand-box {
    width: auto;
  }
}
body[data-sidebar-size=small] .vertical-menu {
  width: 160px;
  text-align: center;
}
body[data-sidebar-size=small] .vertical-menu .has-arrow:after,
body[data-sidebar-size=small] .vertical-menu .badge {
  display: none !important;
}
body[data-sidebar-size=small] .vertical-menu .vertical-menu-btn {
  display: none;
}
body[data-sidebar-size=small] .main-content {
  margin-left: 160px;
}
body[data-sidebar-size=small] #page-topbar, body[data-sidebar-size=small] .footer {
  left: 160px;
}
@media (max-width: 991.98px) {
  body[data-sidebar-size=small] #page-topbar, body[data-sidebar-size=small] .footer {
    left: 0;
  }
}
body[data-sidebar-size=small] #sidebar-menu ul li.menu-title {
  background-color: rgb(249.9, 249.9, 249.9);
}
body[data-sidebar-size=small] #sidebar-menu ul li a i {
  display: block;
}
body[data-sidebar-size=small] #sidebar-menu ul li ul.sub-menu li a {
  padding-left: 1.5rem;
}
body[data-sidebar-size=small] #sidebar-menu ul li ul.sub-menu li ul.sub-menu li a {
  padding-left: 1.5rem;
}
body[data-sidebar-size=small][data-sidebar=dark] #sidebar-menu ul li.menu-title {
  background-color: rgb(31.0382978723, 43.2319148936, 73.1617021277);
}
body[data-sidebar-size=small]:not(.vertical-collpsed) .navbar-header .vertical-menu-btn {
  display: block;
}
body[data-sidebar-size=small].vertical-collpsed .main-content {
  margin-left: 70px;
}
body[data-sidebar-size=small].vertical-collpsed .vertical-menu #sidebar-menu {
  text-align: left;
}
body[data-sidebar-size=small].vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a i {
  display: inline-block;
}
body[data-sidebar-size=small].vertical-collpsed #page-topbar, body[data-sidebar-size=small].vertical-collpsed .footer {
  left: 70px;
}

body[data-sidebar=colored] .vertical-menu {
  background-color: #5b73e8;
}
body[data-sidebar=colored] .vertical-menu .vertical-menu-btn {
  color: rgba(255, 255, 255, 0.8);
}
body[data-sidebar=colored] .navbar-brand-box {
  background-color: #5b73e8;
}
body[data-sidebar=colored] .navbar-brand-box .logo-dark {
  display: none;
}
body[data-sidebar=colored] .navbar-brand-box .logo-light {
  display: block;
}
body[data-sidebar=colored] .mm-active {
  color: #fff !important;
}
body[data-sidebar=colored] .mm-active > a {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff !important;
}
body[data-sidebar=colored] .mm-active > a > i {
  color: #fff !important;
}
body[data-sidebar=colored] .mm-active > i, body[data-sidebar=colored] .mm-active .active {
  color: #fff !important;
}
body[data-sidebar=colored] #sidebar-menu ul li.menu-title {
  color: rgba(255, 255, 255, 0.7);
}
body[data-sidebar=colored] #sidebar-menu ul li a {
  color: rgba(255, 255, 255, 0.7);
}
body[data-sidebar=colored] #sidebar-menu ul li a i {
  color: rgba(255, 255, 255, 0.7);
}
body[data-sidebar=colored] #sidebar-menu ul li a.waves-effect .waves-ripple {
  background: rgba(255, 255, 255, 0.1);
}
body[data-sidebar=colored] #sidebar-menu ul li ul.sub-menu li a {
  color: rgba(255, 255, 255, 0.6);
}
body[data-sidebar=colored] #sidebar-menu ul li .badge.badge-primary {
  background-color: #fff;
  color: #5b73e8;
}
body[data-sidebar=colored].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a {
  background-color: rgb(99.9454545455, 122.6363636364, 233.2545454545);
  color: #fff;
}
body[data-sidebar=colored].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a i {
  color: #fff;
}
body[data-sidebar=colored].vertical-collpsed .vertical-menu #sidebar-menu ul li.mm-active .active {
  color: #5b73e8 !important;
}

.topnav {
  background: #4360AB;
  padding: 0 calc(1.25rem / 2);
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  left: 0;
  right: 0;
  z-index: 1;
}
.topnav .topnav-menu {
  margin: 0;
  padding: 0;
}
.topnav .navbar-nav .nav-link {
  font-size: 14.5px;
  position: relative;
  padding: 1rem 1.3rem;
  color: #fff;
}
.topnav .navbar-nav .nav-link i {
  font-size: 15px;
}
.topnav .navbar-nav .nav-link:focus, .topnav .navbar-nav .nav-link:hover {
  color: rgba(255, 255, 255, 0.6);
  background-color: transparent;
}
.topnav .navbar-nav .dropdown-item {
  color: #7b8190;
}
.topnav .navbar-nav .dropdown-item.active, .topnav .navbar-nav .dropdown-item:hover {
  color: rgba(255, 255, 255, 0.6);
  background-color: transparent;
}
.topnav .navbar-nav .nav-item .nav-link.active {
  color: #5b73e8;
}
.topnav .navbar-nav .dropdown.active > a {
  color: #5b73e8;
  background-color: transparent;
}

body[data-layout=horizontal] #page-topbar {
  left: 0;
}
@media (min-width: 992px) {
  body[data-layout=horizontal] #page-topbar {
    padding: 0 calc(1.25rem / 2);
  }
}
body[data-layout=horizontal] .navbar-brand-box {
  position: relative;
  width: auto;
  display: block;
  background-color: transparent;
}
@media (min-width: 992px) {
  body[data-layout=horizontal] .navbar-brand-box {
    padding-left: 0;
  }
}
@media (min-width: 992px) {
  body[data-layout=horizontal] .topnav {
    margin-top: 24px;
    margin-bottom: -16px;
    border-radius: 4px;
  }
  body[data-layout=horizontal] .navbar-header {
    padding: 0 calc(1.25rem / 2);
  }
}

@media (min-width: 1200px) {
  body[data-layout=horizontal] .container-fluid, body[data-layout=horizontal] .container-sm, body[data-layout=horizontal] .container-md, body[data-layout=horizontal] .container-lg, body[data-layout=horizontal] .container-xl, body[data-layout=horizontal] .container-xxl,
  body[data-layout=horizontal] .navbar-header {
    max-width: 100%;
  }
}
@media (min-width: 992px) {
  .topnav .dropdown-item {
    padding: 0.5rem 1.5rem;
    min-width: 180px;
  }
  .topnav .dropdown.mega-dropdown .mega-dropdown-menu {
    left: 0px;
    right: auto;
  }
  .topnav .dropdown .dropdown-menu {
    margin-top: 0;
    border-radius: 0 0 0.25rem 0.25rem;
  }
  .topnav .dropdown .dropdown-menu .arrow-down::after {
    right: 15px;
    transform: rotate(-135deg) translateY(-50%);
    position: absolute;
  }
  .topnav .dropdown .dropdown-menu .dropdown .dropdown-menu {
    position: absolute;
    top: 0 !important;
    left: 100%;
    display: none;
  }
  .topnav .dropdown:hover > .dropdown-menu {
    display: block;
  }
  .topnav .dropdown:hover > .dropdown-menu > .dropdown:hover > .dropdown-menu {
    display: block;
  }
  .navbar-toggle {
    display: none;
  }
}
.arrow-down {
  display: inline-block;
}
.arrow-down:after {
  border-color: initial;
  border-style: solid;
  border-width: 0 0 1px 1px;
  content: "";
  height: 0.4em;
  display: inline-block;
  right: 5px;
  top: 50%;
  margin-left: 10px;
  transform: rotate(-45deg) translateY(-50%);
  transform-origin: top;
  transition: all 0.3s ease-out;
  width: 0.4em;
}

@media (max-width: 991.98px) {
  .topnav-menu .navbar-nav li:last-of-type .dropdown .dropdown-menu {
    right: 100%;
    left: auto;
  }
}
@media (max-width: 991.98px) {
  .toggle_nav_option_desktop {
    display: none;
  }
}
@media (min-width: 991.98px) {
  .toggle_nav_option_mobile {
    display: none;
  }
}
@media (max-width: 991.98px) {
  body[data-layout=horizontal] .navbar-brand-box .logo-dark {
    display: block;
  }
  body[data-layout=horizontal] .navbar-brand-box .logo-dark span.logo-sm {
    display: block;
  }
  body[data-layout=horizontal] .navbar-brand-box .logo-light {
    display: none;
  }
  .topnav {
    position: fixed;
    max-height: 380px;
    overflow-y: auto;
    padding: 0;
  }
  .topnav .navbar-nav .nav-link {
    padding: 0.5rem 1rem;
  }
  .topnav .dropdown .dropdown-menu {
    background-color: transparent;
    border: none;
    box-shadow: none;
    padding-left: 15px;
  }
  .topnav .dropdown .dropdown-menu.dropdown-mega-menu-xl {
    width: auto;
  }
  .topnav .dropdown .dropdown-menu.dropdown-mega-menu-xl .row {
    margin: 0px;
  }
  .topnav .dropdown .dropdown-item {
    position: relative;
    background-color: transparent;
  }
  .topnav .dropdown .dropdown-item.active, .topnav .dropdown .dropdown-item:active {
    color: #5b73e8;
  }
  .topnav .arrow-down::after {
    right: 15px;
    position: absolute;
  }
}
@media (min-width: 992px) {
  body[data-layout=horizontal][data-topbar=light] .navbar-brand-box .logo-dark {
    display: block;
  }
  body[data-layout=horizontal][data-topbar=light] .navbar-brand-box .logo-light {
    display: none;
  }
  body[data-layout=horizontal][data-topbar=light] .topnav {
    background-color: #5b73e8;
  }
  body[data-layout=horizontal][data-topbar=light] .topnav .navbar-nav .nav-link {
    color: rgba(255, 255, 255, 0.6);
  }
  body[data-layout=horizontal][data-topbar=light] .topnav .navbar-nav .nav-link:focus, body[data-layout=horizontal][data-topbar=light] .topnav .navbar-nav .nav-link:hover {
    color: rgba(255, 255, 255, 0.9);
  }
  body[data-layout=horizontal][data-topbar=light] .topnav .navbar-nav > .dropdown.active > a {
    color: rgba(255, 255, 255, 0.9) !important;
  }
}
body[data-layout=horizontal][data-topbar=colored] #page-topbar {
  background-color: #5b73e8;
  box-shadow: none;
}
body[data-layout=horizontal][data-topbar=colored] .logo-dark {
  display: none;
}
body[data-layout=horizontal][data-topbar=colored] .logo-light {
  display: block;
}
body[data-layout=horizontal][data-topbar=colored] .app-search .form-control {
  background-color: rgba(0, 0, 0, 0.07);
  color: #fff;
}
body[data-layout=horizontal][data-topbar=colored] .app-search span,
body[data-layout=horizontal][data-topbar=colored] .app-search input.form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.5);
}
body[data-layout=horizontal][data-topbar=colored] .header-item {
  color: #e9ecef;
}
body[data-layout=horizontal][data-topbar=colored] .header-item:hover {
  color: #e9ecef;
}
body[data-layout=horizontal][data-topbar=colored] .navbar-header .dropdown .show.header-item {
  background-color: rgba(255, 255, 255, 0.1);
}
body[data-layout=horizontal][data-topbar=colored] .navbar-header .waves-effect .waves-ripple {
  background: rgba(255, 255, 255, 0.4);
}
body[data-layout=horizontal][data-topbar=colored] .noti-icon i {
  color: #e9ecef;
}

body[data-layout-size=boxed] {
  background-color: #e9ebf0;
}
body[data-layout-size=boxed] #layout-wrapper {
  background-color: #f5f6f8;
  max-width: 1300px;
  margin: 0 auto;
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
}
body[data-layout-size=boxed] #page-topbar {
  max-width: calc(1300px - 250px);
  margin: 0 auto;
}
body[data-layout-size=boxed] .footer {
  margin: 0 auto;
  max-width: calc(1300px - 250px);
}
body[data-layout-size=boxed].vertical-collpsed #page-topbar {
  max-width: calc(1300px - 70px);
}
body[data-layout-size=boxed].vertical-collpsed .footer {
  max-width: calc(1300px - 70px);
}

body[data-layout=horizontal][data-layout-size=boxed] #page-topbar, body[data-layout=horizontal][data-layout-size=boxed] #layout-wrapper, body[data-layout=horizontal][data-layout-size=boxed] .footer {
  max-width: 100%;
}
body[data-layout=horizontal][data-layout-size=boxed] .container-fluid, body[data-layout=horizontal][data-layout-size=boxed] .container-sm, body[data-layout=horizontal][data-layout-size=boxed] .container-md, body[data-layout=horizontal][data-layout-size=boxed] .container-lg, body[data-layout=horizontal][data-layout-size=boxed] .container-xl, body[data-layout=horizontal][data-layout-size=boxed] .container-xxl, body[data-layout=horizontal][data-layout-size=boxed] .navbar-header {
  max-width: 1300px;
}

/*!
 * Waves v0.7.6
 * http://fian.my.id/Waves 
 * 
 * Copyright 2014-2018 Alfiana E. Sibuea and other contributors 
 * Released under the MIT license 
 * https://github.com/fians/Waves/blob/master/LICENSE */
.waves-effect {
  position: relative;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  -webkit-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.waves-effect .waves-ripple {
  position: absolute;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  margin-top: -50px;
  margin-left: -50px;
  opacity: 0;
  background: rgba(0, 0, 0, 0.2);
  background: radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);
  transition: all 0.5s ease-out;
  transition-property: transform, opacity;
  transform: scale(0) translate(0, 0);
  pointer-events: none;
}

.waves-effect.waves-light .waves-ripple {
  background: rgba(255, 255, 255, 0.4);
  background: radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);
}

.waves-effect.waves-classic .waves-ripple {
  background: rgba(0, 0, 0, 0.2);
}

.waves-effect.waves-classic.waves-light .waves-ripple {
  background: rgba(255, 255, 255, 0.4);
}

.waves-notransition {
  transition: none !important;
}

.waves-button,
.waves-circle {
  transform: translateZ(0);
  -webkit-mask-image: -webkit-radial-gradient(circle, white 100%, black 100%);
}

.waves-button,
.waves-button:hover,
.waves-button:visited,
.waves-button-input {
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  border: none;
  outline: none;
  color: inherit;
  background-color: rgba(0, 0, 0, 0);
  font-size: 1em;
  line-height: 1em;
  text-align: center;
  text-decoration: none;
  z-index: 1;
}

.waves-button {
  padding: 0.85em 1.1em;
  border-radius: 0.2em;
}

.waves-button-input {
  margin: 0;
  padding: 0.85em 1.1em;
}

.waves-input-wrapper {
  border-radius: 0.2em;
  vertical-align: bottom;
}

.waves-input-wrapper.waves-button {
  padding: 0;
}

.waves-input-wrapper .waves-button-input {
  position: relative;
  top: 0;
  left: 0;
  z-index: 1;
}

.waves-circle {
  text-align: center;
  width: 2.5em;
  height: 2.5em;
  line-height: 2.5em;
  border-radius: 50%;
}

.waves-float {
  -webkit-mask-image: none;
  box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);
  transition: all 300ms;
}

.waves-float:active {
  box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);
}

.waves-block {
  display: block;
}

.waves-effect.waves-light .waves-ripple {
  background-color: rgba(255, 255, 255, 0.4);
}

.waves-effect.waves-primary .waves-ripple {
  background-color: rgba(91, 115, 232, 0.4);
}

.waves-effect.waves-success .waves-ripple {
  background-color: rgba(52, 195, 143, 0.4);
}

.waves-effect.waves-info .waves-ripple {
  background-color: rgba(80, 165, 241, 0.4);
}

.waves-effect.waves-warning .waves-ripple {
  background-color: rgba(241, 180, 76, 0.4);
}

.waves-effect.waves-danger .waves-ripple {
  background-color: rgba(244, 106, 106, 0.4);
}

.avatar-xs {
  height: 2rem;
  width: 2rem;
}

.avatar-sm {
  height: 3rem;
  width: 3rem;
}

.avatar-md {
  height: 4.5rem;
  width: 4.5rem;
}

.avatar-lg {
  height: 6rem;
  width: 6rem;
}

.avatar-xl {
  height: 7.5rem;
  width: 7.5rem;
}

.avatar-title {
  align-items: center;
  background-color: #5b73e8;
  color: #fff;
  display: flex;
  font-weight: 500;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.alert-border {
  background-color: #fff;
  border-color: #f5f6f8;
  border-top: 2px solid #f5f6f8;
}

.alert-dismissible .btn-close {
  font-size: 10px;
  padding: 1.05rem 1.25rem;
  box-shadow: none;
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_49___}) center/1em auto no-repeat;
}

.alert-border .btn-close {
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_49___}) center/1em auto no-repeat;
}

.alert-border-primary {
  border-top-color: #5b73e8;
}

.alert-border-secondary {
  border-top-color: #74788d;
}

.alert-border-success {
  border-top-color: #34c38f;
}

.alert-border-info {
  border-top-color: #50a5f1;
}

.alert-border-warning {
  border-top-color: #f1b44c;
}

.alert-border-danger {
  border-top-color: #f46a6a;
}

.alert-border-pink {
  border-top-color: #e83e8c;
}

.alert-border-light {
  border-top-color: #f5f6f8;
}

.alert-border-dark {
  border-top-color: #343a40;
}

.alert-border-purple {
  border-top-color: #6f42c1;
}

.custom-accordion .card + .card {
  margin-top: 0.5rem;
}
.custom-accordion a.collapsed i.accor-down-icon:before {
  content: "\\f0140";
}
.custom-accordion .card-body {
  color: #74788d;
}

.row > * {
  position: relative;
}

.font-size-10 {
  font-size: 10px !important;
}

.font-size-11 {
  font-size: 11px !important;
}

.font-size-12 {
  font-size: 12px !important;
}

.font-size-13 {
  font-size: 13px !important;
}

.font-size-14 {
  font-size: 14px !important;
}

.font-size-15 {
  font-size: 15px !important;
}

.font-size-16 {
  font-size: 16px !important;
}

.font-size-17 {
  font-size: 17px !important;
}

.font-size-18 {
  font-size: 18px !important;
}

.font-size-20 {
  font-size: 20px !important;
}

.font-size-22 {
  font-size: 22px !important;
}

.font-size-24 {
  font-size: 24px !important;
}

.fw-medium {
  font-weight: 500;
}

.fw-semibold {
  font-weight: 600;
}

.social-list-item {
  height: 2rem;
  width: 2rem;
  line-height: calc(2rem - 2px);
  display: block;
  border: 1px solid #adb5bd;
  border-radius: 50%;
  color: #adb5bd;
  text-align: center;
  transition: all 0.4s;
}
.social-list-item:hover {
  color: #74788d;
  background-color: #f5f6f8;
}

.w-xs {
  min-width: 80px;
}

.w-sm {
  min-width: 95px;
}

.w-md {
  min-width: 110px;
}

.w-lg {
  min-width: 140px;
}

.w-xl {
  min-width: 160px;
}

#preloader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 9999;
}

#status {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateY(-50%);
  margin: -20px 0 0 -20px;
}

.spinner .spin-icon {
  font-size: 48px;
  color: #5b73e8;
  position: relative;
  display: inline-block;
  animation: spin 1.6s infinite linear;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}
.form-check {
  position: relative;
}

.form-check-right {
  padding-left: 0;
  display: inline-block;
  padding-right: 1.5em;
}
.form-check-right .form-check-input {
  float: right;
  margin-left: 0;
  margin-right: -1.5em;
}
.form-check-right .form-check-label {
  display: block;
}

.form-checkbox-outline .form-check-input {
  border-width: 2px;
  background-color: #fff;
}
.form-checkbox-outline .form-check-input:active {
  filter: none;
}
.form-checkbox-outline .form-check-input:checked {
  background-color: #fff !important;
}
.form-checkbox-outline .form-check-input:checked[type=checkbox] {
  background-image: none;
}
.form-checkbox-outline .form-check-input:checked:after {
  position: absolute;
  content: "\\f012c";
  font-family: "Material Design Icons";
  top: -4px !important;
  left: 1px;
  font-size: 16px;
}

.form-radio-outline .form-check-input {
  border-width: 2px;
  background-color: #fff;
}
.form-radio-outline .form-check-input:active {
  filter: none;
}
.form-radio-outline .form-check-input:checked {
  background-color: #fff !important;
}
.form-radio-outline .form-check-input:checked[type=checkbox] {
  background-image: none;
}
.form-radio-outline .form-check-input:checked:after {
  position: absolute;
  content: "\\f0765";
  font-family: "Material Design Icons";
  top: 6px !important;
  left: 4px;
  font-size: 6px;
}

.form-check-primary .form-check-input:checked {
  background-color: #5b73e8;
  border-color: #5b73e8;
}

.form-radio-primary .form-check-input:checked {
  border-color: #5b73e8;
  background-color: #5b73e8;
}
.form-radio-primary .form-check-input:checked:after {
  color: #5b73e8;
}

.form-check-secondary .form-check-input:checked {
  background-color: #74788d;
  border-color: #74788d;
}

.form-radio-secondary .form-check-input:checked {
  border-color: #74788d;
  background-color: #74788d;
}
.form-radio-secondary .form-check-input:checked:after {
  color: #74788d;
}

.form-check-success .form-check-input:checked {
  background-color: #34c38f;
  border-color: #34c38f;
}

.form-radio-success .form-check-input:checked {
  border-color: #34c38f;
  background-color: #34c38f;
}
.form-radio-success .form-check-input:checked:after {
  color: #34c38f;
}

.form-check-info .form-check-input:checked {
  background-color: #50a5f1;
  border-color: #50a5f1;
}

.form-radio-info .form-check-input:checked {
  border-color: #50a5f1;
  background-color: #50a5f1;
}
.form-radio-info .form-check-input:checked:after {
  color: #50a5f1;
}

.form-check-warning .form-check-input:checked {
  background-color: #f1b44c;
  border-color: #f1b44c;
}

.form-radio-warning .form-check-input:checked {
  border-color: #f1b44c;
  background-color: #f1b44c;
}
.form-radio-warning .form-check-input:checked:after {
  color: #f1b44c;
}

.form-check-danger .form-check-input:checked {
  background-color: #f46a6a;
  border-color: #f46a6a;
}

.form-radio-danger .form-check-input:checked {
  border-color: #f46a6a;
  background-color: #f46a6a;
}
.form-radio-danger .form-check-input:checked:after {
  color: #f46a6a;
}

.form-check-pink .form-check-input:checked {
  background-color: #e83e8c;
  border-color: #e83e8c;
}

.form-radio-pink .form-check-input:checked {
  border-color: #e83e8c;
  background-color: #e83e8c;
}
.form-radio-pink .form-check-input:checked:after {
  color: #e83e8c;
}

.form-check-light .form-check-input:checked {
  background-color: #f5f6f8;
  border-color: #f5f6f8;
}

.form-radio-light .form-check-input:checked {
  border-color: #f5f6f8;
  background-color: #f5f6f8;
}
.form-radio-light .form-check-input:checked:after {
  color: #f5f6f8;
}

.form-check-dark .form-check-input:checked {
  background-color: #343a40;
  border-color: #343a40;
}

.form-radio-dark .form-check-input:checked {
  border-color: #343a40;
  background-color: #343a40;
}
.form-radio-dark .form-check-input:checked:after {
  color: #343a40;
}

.form-check-purple .form-check-input:checked {
  background-color: #6f42c1;
  border-color: #6f42c1;
}

.form-radio-purple .form-check-input:checked {
  border-color: #6f42c1;
  background-color: #6f42c1;
}
.form-radio-purple .form-check-input:checked:after {
  color: #6f42c1;
}

.form-check, .form-check-input, .form-check-label {
  cursor: pointer;
  margin-bottom: 0;
}

.form-check {
  position: relative;
  text-align: left;
}

.form-switch-md {
  padding-left: 2.5rem;
  min-height: 24px;
  line-height: 24px;
}
.form-switch-md .form-check-input {
  width: 40px;
  height: 20px;
  left: -0.5rem;
  position: relative;
}
.form-switch-md .form-check-label {
  vertical-align: middle;
}

.form-switch-lg {
  padding-left: 2.75rem;
  min-height: 28px;
  line-height: 28px;
}
.form-switch-lg .form-check-input {
  width: 48px;
  height: 24px;
  left: -0.75rem;
  position: relative;
}

.input-group-text {
  margin-bottom: 0px;
}

.custom-control-label::before {
  background-color: #fff;
}

.main-chart .chart-border-left {
  border-left: 1.4px solid #f5f6f8;
  padding: 2px 20px;
}
.main-chart .chart-border-left:last-child {
  margin-right: 0px;
}

/* Activity */
.activity-feed {
  list-style: none;
}
.activity-feed .feed-item {
  position: relative;
  padding-bottom: 27px;
  padding-left: 16px;
  border-left: 2px solid #f5f6f8;
}
.activity-feed .feed-item:after {
  content: "";
  display: block;
  position: absolute;
  top: 4px;
  left: -6px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid #5b73e8;
  background-color: #fff;
}
.activity-feed .feed-item:last-child {
  border-color: transparent;
}

.button-items {
  margin-left: -8px;
  margin-bottom: -12px;
}
.button-items .btn {
  margin-bottom: 12px;
  margin-left: 8px;
}

.mfp-popup-form {
  max-width: 1140px;
}

.bs-example-modal {
  position: relative;
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
  z-index: 1;
  display: block;
}

.icon-demo-content {
  text-align: center;
  color: #adb5bd;
}
.icon-demo-content i {
  display: block;
  width: 40px;
  height: 40px;
  line-height: 36px;
  font-size: 24px;
  margin: 0px auto 16px;
  border: 2px solid #f6f6f6;
  color: #74788d;
  border-radius: 4px;
  transition: all 0.4s;
}
.icon-demo-content .col-lg-4 {
  margin-top: 24px;
}
.icon-demo-content .col-lg-4:hover i {
  color: #fff;
  background-color: #5b73e8;
  border-color: #5b73e8;
}

.grid-structure .grid-container {
  background-color: #f8f9fa;
  margin-top: 10px;
  font-size: 0.8rem;
  font-weight: 500;
  padding: 10px 20px;
}

.card-radio {
  background-color: #fff;
  border: 2px solid #f6f6f6;
  border-radius: 0.25rem;
  padding: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}
.card-radio:hover {
  cursor: pointer;
}

.card-radio-label {
  display: block;
}

.card-radio-input {
  display: none;
}
.card-radio-input:checked + .card-radio {
  border-color: #5b73e8 !important;
}
.card-radio-input:checked + .card-radio:before {
  content: "\\e9c3";
  font-family: "unicons-line";
  position: absolute;
  top: 5px;
  right: 20px;
  font-size: 22px;
  color: #5b73e8;
}

.navs-carousel .owl-nav {
  margin-top: 16px;
}
.navs-carousel .owl-nav button {
  width: 30px;
  height: 30px;
  line-height: 28px !important;
  font-size: 20px !important;
  border-radius: 50% !important;
  background-color: rgba(91, 115, 232, 0.25) !important;
  color: #5b73e8 !important;
  margin: 4px 8px !important;
}

@media print {
  .vertical-menu,
  .right-bar,
  .page-title-box,
  .navbar-header,
  .footer {
    display: none !important;
  }
  .card-body,
  .main-content,
  .right-bar,
  .page-content,
  body {
    padding: 0;
    margin: 0;
  }
  .card {
    border: 0;
  }
}
[data-simplebar] {
  position: relative;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
}

.simplebar-wrapper {
  overflow: hidden;
  width: inherit;
  height: inherit;
  max-width: inherit;
  max-height: inherit;
}

.simplebar-mask {
  direction: inherit;
  position: absolute;
  overflow: hidden;
  padding: 0;
  margin: 0;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: auto !important;
  height: auto !important;
  z-index: 0;
}

.simplebar-offset {
  direction: inherit !important;
  box-sizing: inherit !important;
  resize: none !important;
  position: absolute;
  top: 0;
  left: 0 !important;
  bottom: 0;
  right: 0 !important;
  padding: 0;
  margin: 0;
  -webkit-overflow-scrolling: touch;
}

.simplebar-content-wrapper {
  direction: inherit;
  box-sizing: border-box !important;
  position: relative;
  display: block;
  height: 100%; /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */
  width: auto;
  visibility: visible;
  overflow: auto; /* Scroll on this element otherwise element can't have a padding applied properly */
  max-width: 100%; /* Not required for horizontal scroll to trigger */
  max-height: 100%; /* Needed for vertical scroll to trigger */
  scrollbar-width: none;
  padding: 0px !important;
}

.simplebar-content-wrapper::-webkit-scrollbar,
.simplebar-hide-scrollbar::-webkit-scrollbar {
  display: none;
}

.simplebar-content:before,
.simplebar-content:after {
  content: " ";
  display: table;
}

.simplebar-placeholder {
  max-height: 100%;
  max-width: 100%;
  width: 100%;
  pointer-events: none;
}

.simplebar-height-auto-observer-wrapper {
  box-sizing: inherit !important;
  height: 100%;
  width: 100%;
  max-width: 1px;
  position: relative;
  float: left;
  max-height: 1px;
  overflow: hidden;
  z-index: -1;
  padding: 0;
  margin: 0;
  pointer-events: none;
  flex-grow: inherit;
  flex-shrink: 0;
  flex-basis: 0;
}

.simplebar-height-auto-observer {
  box-sizing: inherit;
  display: block;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 1000%;
  width: 1000%;
  min-height: 1px;
  min-width: 1px;
  overflow: hidden;
  pointer-events: none;
  z-index: -1;
}

.simplebar-track {
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
}

[data-simplebar].simplebar-dragging .simplebar-content {
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none;
}

[data-simplebar].simplebar-dragging .simplebar-track {
  pointer-events: all;
}

.simplebar-scrollbar {
  position: absolute;
  right: 2px;
  width: 6px;
  min-height: 10px;
}

.simplebar-scrollbar:before {
  position: absolute;
  content: "";
  background: #a2adb7;
  border-radius: 7px;
  left: 0;
  right: 0;
  opacity: 0;
  transition: opacity 0.2s linear;
}

.simplebar-scrollbar.simplebar-visible:before {
  /* When hovered, remove all transitions from drag handle */
  opacity: 0.5;
  transition: opacity 0s linear;
}

.simplebar-track.simplebar-vertical {
  top: 0;
  width: 11px;
}

.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {
  top: 2px;
  bottom: 2px;
}

.simplebar-track.simplebar-horizontal {
  left: 0;
  height: 11px;
}

.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {
  height: 100%;
  left: 2px;
  right: 2px;
}

.simplebar-track.simplebar-horizontal .simplebar-scrollbar {
  right: auto;
  left: 0;
  top: 2px;
  height: 7px;
  min-height: 0;
  min-width: 10px;
  width: auto;
}

/* Rtl support */
[data-simplebar-direction=rtl] .simplebar-track.simplebar-vertical {
  right: auto;
  left: 0;
}

.hs-dummy-scrollbar-size {
  direction: rtl;
  position: fixed;
  opacity: 0;
  visibility: hidden;
  height: 500px;
  width: 500px;
  overflow-y: hidden;
  overflow-x: scroll;
}

.simplebar-hide-scrollbar {
  position: fixed;
  left: 0;
  visibility: hidden;
  overflow-y: scroll;
  scrollbar-width: none;
}

.custom-scroll {
  height: 100%;
}

/* ==============
  Calendar
===================*/
.fc td, .fc th {
  border: 1px solid #f5f6f8;
}

.fc .fc-toolbar h2, .fc .fc-toolbar .h2 {
  font-size: 16px;
  line-height: 30px;
  text-transform: uppercase;
}
@media (max-width: 767.98px) {
  .fc .fc-toolbar .fc-left,
  .fc .fc-toolbar .fc-right,
  .fc .fc-toolbar .fc-center {
    float: none;
    display: block;
    text-align: center;
    clear: both;
    margin: 10px 0;
  }
  .fc .fc-toolbar > * > * {
    float: none;
  }
  .fc .fc-toolbar .fc-today-button {
    display: none;
  }
}
.fc .fc-toolbar .btn {
  text-transform: capitalize;
}

.fc th.fc-widget-header {
  background: #f6f6f6;
  color: #495057;
  line-height: 20px;
  padding: 10px 0;
  text-transform: uppercase;
  font-weight: 600;
}

.fc-unthemed .fc-content,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-list-heading td,
.fc-unthemed .fc-list-view,
.fc-unthemed .fc-popover,
.fc-unthemed .fc-row,
.fc-unthemed tbody,
.fc-unthemed td,
.fc-unthemed th,
.fc-unthemed thead {
  border-color: #f6f6f6;
}
.fc-unthemed td.fc-today {
  background: rgb(251, 251.4, 252.2);
}

.fc-button {
  background: #fff;
  border-color: #f5f6f8;
  color: #495057;
  text-transform: capitalize;
  box-shadow: none;
  padding: 6px 12px !important;
  height: auto !important;
}

.fc-state-down,
.fc-state-active,
.fc-state-disabled {
  background-color: #5b73e8;
  color: #fff;
  text-shadow: none;
}

.fc-event {
  border-radius: 2px;
  border: none;
  cursor: move;
  font-size: 0.8125rem;
  margin: 5px 7px;
  padding: 5px 5px;
  text-align: center;
}

.fc-event,
.fc-event-dot {
  background-color: #5b73e8;
}

.fc-event .fc-content {
  color: #fff;
}

#external-events .external-event {
  text-align: left;
  padding: 8px 16px;
}

.fc-day-grid-event.fc-h-event.fc-event.fc-start.fc-end.bg-dark .fc-content {
  color: #f5f6f8;
}

[dir=rtl] .fc-header-toolbar {
  direction: ltr !important;
}
[dir=rtl] .fc-toolbar > * > :not(:first-child) {
  margin-left: 0.75em;
}

#session-timeout-dialog .close {
  display: none;
}
#session-timeout-dialog .countdown-holder {
  color: #f46a6a;
  font-weight: 500;
}
#session-timeout-dialog .btn-default {
  background-color: #fff;
  color: #f46a6a;
  box-shadow: none;
}

.irs {
  font-family: "IBM Plex Sans", sans-serif;
}

.irs--round .irs-bar, .irs--round .irs-to, .irs--round .irs-from, .irs--round .irs-single {
  background: #5b73e8 !important;
  font-size: 11px;
}
.irs--round .irs-to:before, .irs--round .irs-from:before, .irs--round .irs-single:before {
  display: none;
}
.irs--round .irs-line {
  background: #f6f6f6;
  border-color: #f6f6f6;
}
.irs--round .irs-grid-text {
  font-size: 11px;
  color: #adb5bd;
}
.irs--round .irs-min, .irs--round .irs-max {
  color: #adb5bd;
  background: #f6f6f6;
  font-size: 11px;
}
.irs--round .irs-handle {
  border: 1px solid #5b73e8;
  width: 6px;
  height: 16px;
  top: 29px;
  background-color: #fff !important;
}

.swal2-container .swal2-title {
  font-size: 24px;
  font-weight: 500;
}

.swal2-content {
  font-size: 16px;
}

.swal2-icon.swal2-question {
  border-color: #50a5f1;
  color: #50a5f1;
}
.swal2-icon.swal2-success [class^=swal2-success-line] {
  background-color: #34c38f;
}
.swal2-icon.swal2-success .swal2-success-ring {
  border-color: rgba(52, 195, 143, 0.3);
}
.swal2-icon.swal2-warning {
  border-color: #f1b44c;
  color: #f1b44c;
}

.swal2-styled:focus {
  box-shadow: none;
}

.swal2-progress-steps .swal2-progress-step {
  background: #5b73e8;
}
.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step {
  background: #5b73e8;
}
.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step, .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step-line {
  background: rgba(91, 115, 232, 0.3);
}
.swal2-progress-steps .swal2-progress-step-line {
  background: #5b73e8;
}

.swal2-loader {
  border-color: #5b73e8 transparent #5b73e8 transparent;
}

.br-wrapper {
  display: inline-block;
}

.br-theme-fontawesome-stars .br-widget a, .br-theme-css-stars .br-widget a {
  font-weight: 900;
}
.br-theme-fontawesome-stars .br-widget a.br-selected:after, .br-theme-css-stars .br-widget a.br-selected:after {
  color: #f1b44c;
}

.br-theme-fontawesome-stars .br-widget a {
  font-weight: 900;
}

.br-theme-fontawesome-stars .br-widget a, .br-theme-fontawesome-stars-o .br-widget a {
  font-family: "Font Awesome 5 Free";
}

.br-theme-fontawesome-stars-o .br-widget a.br-selected:after, .br-theme-fontawesome-stars-o .br-widget a.br-active:after, .br-theme-fontawesome-stars-o .br-widget a.br-fractional:after {
  font-weight: 900;
  color: #34c38f;
}
.br-theme-fontawesome-stars-o .br-widget a.br-fractional:after, .br-theme-fontawesome-stars-o .br-widget a:after {
  content: "\\f005";
}

.hidden {
  display: none !important;
  visibility: hidden;
}

.br-theme-bars-1to10 .br-widget .br-current-rating {
  line-height: inherit;
}

/* =============
   Notification
============= */
#toast-container > div {
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  opacity: 1;
}
#toast-container > div:hover {
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  opacity: 0.9;
}
#toast-container.toast-top-full-width > div, #toast-container.toast-bottom-full-width > div {
  min-width: 96%;
  margin: 4px auto;
}

.toast-primary {
  border: 2px solid #5b73e8 !important;
  background-color: rgba(91, 115, 232, 0.8) !important;
}

.toast-secondary {
  border: 2px solid #74788d !important;
  background-color: rgba(116, 120, 141, 0.8) !important;
}

.toast-success {
  border: 2px solid #34c38f !important;
  background-color: rgba(52, 195, 143, 0.8) !important;
}

.toast-info {
  border: 2px solid #50a5f1 !important;
  background-color: rgba(80, 165, 241, 0.8) !important;
}

.toast-warning {
  border: 2px solid #f1b44c !important;
  background-color: rgba(241, 180, 76, 0.8) !important;
}

.toast-danger {
  border: 2px solid #f46a6a !important;
  background-color: rgba(244, 106, 106, 0.8) !important;
}

.toast-pink {
  border: 2px solid #e83e8c !important;
  background-color: rgba(232, 62, 140, 0.8) !important;
}

.toast-light {
  border: 2px solid #f5f6f8 !important;
  background-color: rgba(245, 246, 248, 0.8) !important;
}

.toast-dark {
  border: 2px solid #343a40 !important;
  background-color: rgba(52, 58, 64, 0.8) !important;
}

.toast-purple {
  border: 2px solid #6f42c1 !important;
  background-color: rgba(111, 66, 193, 0.8) !important;
}

.toast-error {
  background-color: rgba(244, 106, 106, 0.8);
  border: 2px solid #f46a6a;
}

.toastr-options {
  padding: 24px;
  background-color: rgb(251, 251.4, 252.2);
  margin-bottom: 0;
  border: 1px solid #f5f6f8;
}

.error {
  color: #f46a6a;
}

.parsley-error {
  border-color: #f46a6a;
}

.parsley-errors-list {
  display: none;
  margin: 0;
  padding: 0;
}
.parsley-errors-list.filled {
  display: block;
}
.parsley-errors-list > li {
  font-size: 12px;
  list-style: none;
  color: #f46a6a;
  margin-top: 5px;
}

.select2-container .select2-selection--single {
  background-color: #fff;
  border: 1px solid #ced4da;
  height: 38px;
}
.select2-container .select2-selection--single:focus {
  outline: none;
}
.select2-container .select2-selection--single .select2-selection__rendered {
  line-height: 36px;
  padding-left: 12px;
  color: #495057;
}
.select2-container .select2-selection--single .select2-selection__arrow {
  height: 34px;
  width: 34px;
  right: 3px;
}
.select2-container .select2-selection--single .select2-selection__arrow b {
  border-color: #adb5bd transparent transparent transparent;
  border-width: 6px 6px 0 6px;
}
.select2-container .select2-selection--single .select2-selection__placeholder {
  color: #495057;
}

.select2-container--open .select2-selection--single .select2-selection__arrow b {
  border-color: transparent transparent #adb5bd transparent !important;
  border-width: 0 6px 6px 6px !important;
}

.select2-container--default .select2-search--dropdown {
  padding: 10px;
  background-color: #fff;
}
.select2-container--default .select2-search--dropdown .select2-search__field {
  border: 1px solid #ced4da;
  background-color: #fff;
  color: #74788d;
  outline: none;
}
.select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #5b73e8;
}
.select2-container--default .select2-results__option[aria-selected=true] {
  background-color: #f8f9fa;
  color: rgb(44.1, 47.9, 51.7);
}
.select2-container--default .select2-results__option[aria-selected=true]:hover {
  background-color: #5b73e8;
  color: #fff;
}

.select2-results__option {
  padding: 6px 12px;
}

.select2-dropdown {
  border: 1px solid rgba(0, 0, 0, 0.15);
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
}

.select2-search input {
  border: 1px solid #f6f6f6;
}

.select2-container .select2-selection--multiple {
  min-height: 38px;
  background-color: #fff;
  border: 1px solid #ced4da !important;
}
.select2-container .select2-selection--multiple .select2-selection__rendered {
  padding: 2px 10px;
}
.select2-container .select2-selection--multiple .select2-search__field {
  border: 0;
  color: #495057;
}
.select2-container .select2-selection--multiple .select2-search__field::placeholder {
  color: #495057;
}
.select2-container .select2-selection--multiple .select2-selection__choice {
  background-color: #f5f6f8;
  border: 1px solid #f6f6f6;
  border-radius: 1px;
  padding: 0 7px;
}

.select2-container--default.select2-container--focus .select2-selection--multiple {
  border-color: #ced4da;
}
.select2-container--default .select2-results__group {
  font-weight: 600;
}

.select2-result-repository__avatar {
  float: left;
  width: 60px;
  margin-right: 10px;
}
.select2-result-repository__avatar img {
  width: 100%;
  height: auto;
  border-radius: 2px;
}

.select2-result-repository__statistics {
  margin-top: 7px;
}

.select2-result-repository__forks,
.select2-result-repository__stargazers,
.select2-result-repository__watchers {
  display: inline-block;
  font-size: 11px;
  margin-right: 1em;
  color: #adb5bd;
}
.select2-result-repository__forks .fa,
.select2-result-repository__stargazers .fa,
.select2-result-repository__watchers .fa {
  margin-right: 4px;
}
.select2-result-repository__forks .fa.fa-flash::before,
.select2-result-repository__stargazers .fa.fa-flash::before,
.select2-result-repository__watchers .fa.fa-flash::before {
  content: "\\f0e7";
  font-family: "Font Awesome 5 Free";
}

.select2-results__option--highlighted .select2-result-repository__forks,
.select2-results__option--highlighted .select2-result-repository__stargazers,
.select2-results__option--highlighted .select2-result-repository__watchers {
  color: rgba(255, 255, 255, 0.8);
}

.select2-result-repository__meta {
  overflow: hidden;
}

.img-flag {
  margin-right: 7px;
  height: 15px;
  width: 18px;
}

/* CSS Switch */
input[switch] {
  display: none;
}
input[switch] + label {
  font-size: 1em;
  line-height: 1;
  width: 56px;
  height: 24px;
  background-color: #ced4da;
  background-image: none;
  border-radius: 2rem;
  padding: 0.16667rem;
  cursor: pointer;
  display: inline-block;
  text-align: center;
  position: relative;
  font-weight: 500;
  transition: all 0.1s ease-in-out;
}
input[switch] + label:before {
  color: #343a40;
  content: attr(data-off-label);
  display: block;
  font-family: inherit;
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  position: absolute;
  right: 1px;
  margin: 3px;
  top: -2px;
  text-align: center;
  min-width: 1.66667rem;
  overflow: hidden;
  transition: all 0.1s ease-in-out;
}
input[switch] + label:after {
  content: "";
  position: absolute;
  left: 3px;
  background-color: #f5f6f8;
  box-shadow: none;
  border-radius: 2rem;
  height: 20px;
  width: 20px;
  top: 2px;
  transition: all 0.1s ease-in-out;
}
input[switch]:checked + label {
  background-color: #5b73e8;
}

input[switch]:checked + label {
  background-color: #5b73e8;
}
input[switch]:checked + label:before {
  color: #fff;
  content: attr(data-on-label);
  right: auto;
  left: 3px;
}
input[switch]:checked + label:after {
  left: 33px;
  background-color: #f5f6f8;
}

input[switch=bool] + label {
  background-color: #f46a6a;
}

input[switch=bool] + label:before, input[switch=bool]:checked + label:before,
input[switch=default]:checked + label:before {
  color: #fff;
}

input[switch=bool]:checked + label {
  background-color: #34c38f;
}

input[switch=default]:checked + label {
  background-color: #a2a2a2;
}

input[switch=primary]:checked + label {
  background-color: #5b73e8;
}

input[switch=success]:checked + label {
  background-color: #34c38f;
}

input[switch=info]:checked + label {
  background-color: #50a5f1;
}

input[switch=warning]:checked + label {
  background-color: #f1b44c;
}

input[switch=danger]:checked + label {
  background-color: #f46a6a;
}

input[switch=dark]:checked + label {
  background-color: #343a40;
}

.square-switch {
  margin-right: 7px;
}
.square-switch input[switch] + label, .square-switch input[switch] + label:after {
  border-radius: 4px;
}

.sp-container {
  background-color: #fff;
  z-index: 999;
}
.sp-container button {
  padding: 0.25rem 0.5rem;
  font-size: 0.71094rem;
  border-radius: 0.2rem;
  font-weight: 400;
  color: #343a40;
}
.sp-container button.sp-palette-toggle {
  background-color: #f5f6f8;
}
.sp-container button.sp-choose {
  background-color: #34c38f;
}

.sp-palette-container {
  border-color: #f5f6f8;
}

.sp-input {
  background-color: #fff;
  border-color: #ced4da !important;
  color: #495057;
}
.sp-input:focus {
  outline: none;
}

[dir=rtl] .sp-alpha {
  direction: rtl;
}
[dir=rtl] .sp-original-input-container .sp-add-on {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-top-left-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
}
[dir=rtl] input.spectrum.with-add-on {
  border: 1px solid #ced4da;
  border-left: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

[dir=rtl] .datepicker {
  right: 0 !important;
  left: auto;
}

[dir=rtl] .bootstrap-timepicker-widget {
  right: 0 !important;
  left: auto;
}
[dir=rtl] .timepicker-orient-top {
  top: calc(1.5em + 0.94rem + 2px) !important;
}
[dir=rtl] .timepicker-orient-bottom {
  top: auto !important;
  bottom: calc(1.5em + 0.94rem + 2px) !important;
}

.datepicker {
  border: 1px solid #f5f6f8;
  padding: 8px;
  z-index: 999 !important;
}
.datepicker table tr th {
  font-weight: 500;
}
.datepicker table tr td.active, .datepicker table tr td.active:hover, .datepicker table tr td .active.disabled, .datepicker table tr td.active.disabled:hover, .datepicker table tr td.today, .datepicker table tr td.today:hover, .datepicker table tr td.today.disabled, .datepicker table tr td.today.disabled:hover, .datepicker table tr td.selected, .datepicker table tr td.selected:hover, .datepicker table tr td.selected.disabled, .datepicker table tr td.selected.disabled:hover,
.datepicker table tr td span.active.active, .datepicker table tr td span.active:hover.active {
  background-color: #5b73e8 !important;
  background-image: none;
  box-shadow: none;
  color: #fff !important;
}
.datepicker table tr td.day.focused, .datepicker table tr td.day:hover,
.datepicker table tr td span.focused,
.datepicker table tr td span:hover {
  background: #f5f6f8;
}
.datepicker table tr td.new, .datepicker table tr td.old,
.datepicker table tr td span.new,
.datepicker table tr td span.old {
  color: #adb5bd;
  opacity: 0.6;
}
.datepicker table tr td.range, .datepicker table tr td.range.disabled, .datepicker table tr td.range.disabled:hover, .datepicker table tr td.range:hover {
  background-color: #f6f6f6;
}

.table-condensed > thead > tr > th, .table-condensed > tbody > tr > td {
  padding: 7px;
}

.bootstrap-datepicker-inline .datepicker-inline {
  width: auto !important;
  display: inline-block;
}

.datepicker-container {
  border: 1px solid #f5f6f8;
  box-shadow: none;
  background-color: #fff;
}
.datepicker-container.datepicker-inline {
  width: 212px;
}

.datepicker-panel > ul > li {
  background-color: #fff;
  border-radius: 4px;
}
.datepicker-panel > ul > li.picked, .datepicker-panel > ul > li.picked:hover {
  background-color: rgba(91, 115, 232, 0.25);
  color: #5b73e8;
}
.datepicker-panel > ul > li.highlighted, .datepicker-panel > ul > li.highlighted:hover, .datepicker-panel > ul > li:hover {
  background-color: #5b73e8;
  color: #fff;
}
.datepicker-panel > ul > li.muted, .datepicker-panel > ul > li.muted:hover {
  color: #adb5bd;
  opacity: 0.6;
}
.datepicker-panel > ul[data-view=week] > li {
  font-weight: 500;
}
.datepicker-panel > ul[data-view=week] > li, .datepicker-panel > ul[data-view=week] > li:hover {
  background-color: #fff;
}

.bootstrap-touchspin.input-group > .input-group-prepend > .btn, .bootstrap-touchspin.input-group > .input-group-prepend > .input-group-text {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.bootstrap-touchspin.input-group > .input-group-append > .btn, .bootstrap-touchspin.input-group > .input-group-append > .input-group-text {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

[type=tel]::placeholder,
[type=url]::placeholder,
[type=email]::placeholder,
[type=number]::placeholder {
  text-align: left;
}

.tox-tinymce {
  border: 1px solid #ced4da !important;
}

.tox .tox-statusbar {
  border-top: 1px solid #f5f6f8 !important;
}
.tox .tox-menubar, .tox .tox-edit-area__iframe, .tox .tox-statusbar {
  background-color: #fff !important;
  background: none !important;
}
.tox .tox-mbtn {
  color: #495057 !important;
}
.tox .tox-mbtn:hover:not(:disabled):not(.tox-mbtn--active) {
  background-color: #f5f6f8 !important;
}
.tox .tox-tbtn:hover {
  background-color: #f5f6f8 !important;
}
.tox .tox-toolbar, .tox .tox-toolbar__overflow, .tox .tox-toolbar__primary {
  background: #f5f6f8 !important;
}
.tox .tox-toolbar__primary {
  border-top-color: #f5f6f8 !important;
}
.tox .tox-tbtn {
  color: #495057 !important;
}
.tox .tox-tbtn svg {
  fill: #495057 !important;
}
.tox .tox-edit-area__iframe {
  background-color: #fff !important;
}
.tox .tox-statusbar a, .tox .tox-statusbar__path-item, .tox .tox-statusbar__wordcount {
  color: #495057 !important;
}
.tox:not([dir=rtl]) .tox-toolbar__group:not(:last-of-type) {
  border-right: 1px solid rgb(230, 232.5, 237.5) !important;
}

.editable-input .form-control {
  display: inline-block;
}

.editable-buttons {
  margin-left: 7px;
}
.editable-buttons .editable-cancel {
  margin-left: 7px;
}

.ck-editor__editable {
  min-height: 250px !important;
}

.ck.ck-reset_all, .ck.ck-reset_all * {
  color: #495057 !important;
}
.ck.ck-editor__main > .ck-editor__editable:not(.ck-focused) {
  border-color: #ced4da !important;
}
.ck.ck-toolbar {
  background-color: #f5f6f8 !important;
  border-color: #ced4da !important;
}
.ck.ck-toolbar .ck.ck-toolbar__separator {
  background-color: #ced4da !important;
}
.ck.ck-tooltip .ck-tooltip__text {
  background-color: #343a40 !important;
  color: #f5f6f8 !important;
}
.ck.ck-editor__main > .ck-editor__editable, .ck.ck-list {
  background-color: #fff !important;
}
.ck.ck-dropdown__panel {
  border-color: #f5f6f8 !important;
}

.ck.ck-button:not(.ck-disabled):hover, a.ck.ck-button:not(.ck-disabled):hover, .ck.ck-button.ck-on, a.ck.ck-button.ck-on {
  background-color: rgb(239, 240.6, 243.8) !important;
}

.editable-input .form-control {
  display: inline-block;
}

.editable-buttons {
  margin-left: 7px;
}
.editable-buttons .editable-cancel {
  margin-left: 7px;
}

/* Dropzone */
.dropzone {
  min-height: 230px;
  border: 2px dashed #ced4da;
  background: #fff;
  border-radius: 6px;
}
.dropzone .dz-message {
  font-size: 24px;
  width: 100%;
}

.form-wizard-wrapper label {
  font-size: 14px;
  text-align: right;
}

.wizard .steps > ul {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
@media (max-width: 1199.98px) {
  .wizard .steps > ul {
    flex-direction: column;
  }
}
.wizard .steps > ul > a, .wizard .steps > ul > li {
  flex-basis: 0;
  flex-grow: 1;
}
.wizard .steps > ul > li {
  width: 100%;
}
.wizard .steps > ul > li a {
  display: block;
  padding: 0.5rem 1rem;
  color: #495057;
  font-weight: 500;
  background-color: rgba(91, 115, 232, 0.1);
}
.wizard .steps > ul .current-info {
  position: absolute;
  left: -999em;
}
.wizard .steps .number {
  display: inline-block;
  width: 38px;
  height: 38px;
  line-height: 34px;
  border: 2px solid #5b73e8;
  color: #5b73e8;
  text-align: center;
  border-radius: 50%;
  margin-right: 0.5rem;
}
.wizard .steps .current a, .wizard .steps .current a:active, .wizard .steps .current a:hover {
  background-color: rgba(91, 115, 232, 0.2);
  color: #495057;
}
.wizard .steps .current a .number, .wizard .steps .current a:active .number, .wizard .steps .current a:hover .number {
  background-color: #5b73e8;
  color: #fff;
}
.wizard > .content {
  background-color: transparent;
  padding: 14px;
  margin-top: 0;
  border-radius: 0;
  min-height: 150px;
}
.wizard > .content > .title {
  position: absolute;
  left: -999em;
}
.wizard > .content > .body {
  width: 100%;
  height: 100%;
  padding: 14px 0 0;
  position: static;
}
.wizard > .actions {
  position: relative;
  display: block;
  text-align: right;
  width: 100%;
}
.wizard > .actions > ul {
  display: block;
  text-align: right;
  padding-left: 0;
}
.wizard > .actions > ul > li {
  display: inline-block;
  margin: 0 0.5em;
}
.wizard > .actions a, .wizard > .actions a:active, .wizard > .actions a:hover {
  background-color: #5b73e8;
  border-radius: 4px;
  padding: 8px 15px;
  color: #fff;
}
.wizard > .actions .disabled a, .wizard > .actions .disabled a:active, .wizard > .actions .disabled a:hover {
  opacity: 0.65;
  background-color: #5b73e8;
  color: #fff;
  cursor: not-allowed;
}
.wizard.vertical-wizard {
  display: flex;
  flex-wrap: wrap;
}
.wizard.vertical-wizard .steps > ul {
  flex-direction: column;
}
.wizard.vertical-wizard .steps > ul > li {
  width: 100% !important;
}
.wizard.vertical-wizard .steps, .wizard.vertical-wizard .content, .wizard.vertical-wizard .actions {
  width: 100%;
}
@media (min-width: 1200px) {
  .wizard.vertical-wizard .steps {
    width: 25%;
  }
}
.wizard.vertical-wizard .content {
  padding: 24px;
}
@media (min-width: 1200px) {
  .wizard.vertical-wizard .content {
    width: 75%;
    padding: 12px 24px;
  }
}
.wizard.vertical-wizard .content > .body {
  padding: 0;
}

.table-rep-plugin .btn-toolbar {
  display: block;
}
.table-rep-plugin .table-responsive {
  border: none !important;
}
.table-rep-plugin .btn-group .btn-default {
  background-color: #f5f6f8;
  color: #343a40;
  border: 1px solid rgb(239, 240.6, 243.8);
}
.table-rep-plugin .btn-group .btn-default.btn-primary {
  background-color: #5b73e8;
  border-color: #5b73e8;
  color: #fff;
  box-shadow: 0 0 0 2px rgba(91, 115, 232, 0.5);
}
.table-rep-plugin .btn-group.pull-right {
  float: right;
}
.table-rep-plugin .btn-group.pull-right .dropdown-menu {
  right: 0;
  transform: none !important;
  top: 100% !important;
}
.table-rep-plugin tbody th {
  font-size: 14px;
  font-weight: normal;
}
.table-rep-plugin .checkbox-row {
  padding-left: 40px;
  color: #495057 !important;
}
.table-rep-plugin .checkbox-row:hover {
  background-color: rgb(251, 251.4, 252.2) !important;
}
.table-rep-plugin .checkbox-row label {
  display: inline-block;
  padding-left: 5px;
  position: relative;
}
.table-rep-plugin .checkbox-row label::before {
  -o-transition: 0.3s ease-in-out;
  -webkit-transition: 0.3s ease-in-out;
  background-color: #fff;
  border-radius: 3px;
  border: 1px solid #f6f6f6;
  content: "";
  display: inline-block;
  height: 17px;
  left: 0;
  margin-left: -20px;
  position: absolute;
  transition: 0.3s ease-in-out;
  width: 17px;
  outline: none !important;
}
.table-rep-plugin .checkbox-row label::after {
  color: #f5f6f8;
  display: inline-block;
  font-size: 11px;
  height: 16px;
  left: 0;
  margin-left: -20px;
  padding-left: 3px;
  padding-top: 1px;
  position: absolute;
  top: -1px;
  width: 16px;
}
.table-rep-plugin .checkbox-row input[type=checkbox] {
  cursor: pointer;
  opacity: 0;
  z-index: 1;
  outline: none !important;
}
.table-rep-plugin .checkbox-row input[type=checkbox]:disabled + label {
  opacity: 0.65;
}
.table-rep-plugin .checkbox-row input[type=checkbox]:focus + label::before {
  outline-offset: -2px;
  outline: none;
}
.table-rep-plugin .checkbox-row input[type=checkbox]:checked + label::after {
  content: "\\f00c";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
}
.table-rep-plugin .checkbox-row input[type=checkbox]:disabled + label::before {
  background-color: #f8f9fa;
  cursor: not-allowed;
}
.table-rep-plugin .checkbox-row input[type=checkbox]:checked + label::before {
  background-color: #5b73e8;
  border-color: #5b73e8;
}
.table-rep-plugin .checkbox-row input[type=checkbox]:checked + label::after {
  color: #fff;
}
.table-rep-plugin .fixed-solution .sticky-table-header {
  top: 65px !important;
  background-color: #5b73e8;
}
.table-rep-plugin .fixed-solution .sticky-table-header table {
  color: #fff;
}
.table-rep-plugin table.focus-on tbody tr.focused th,
.table-rep-plugin table.focus-on tbody tr.focused td,
.table-rep-plugin .sticky-table-header {
  background: #5b73e8;
  border-color: #5b73e8;
  color: #fff;
}
.table-rep-plugin table.focus-on tbody tr.focused th table,
.table-rep-plugin table.focus-on tbody tr.focused td table,
.table-rep-plugin .sticky-table-header table {
  color: #fff;
}

@media (min-width: 992px) {
  body[data-layout=horizontal] .fixed-solution .sticky-table-header {
    top: 143px !important;
  }
}

.table-bordered {
  border: 1px solid #f5f6f8;
}

div.dataTables_wrapper div.dataTables_filter {
  text-align: right;
}
@media (max-width: 767px) {
  div.dataTables_wrapper div.dataTables_filter {
    text-align: center;
  }
}
div.dataTables_wrapper div.dataTables_filter input {
  margin-left: 0.5em;
  margin-right: 0;
}

.datatable td:focus {
  outline: none;
}

div.table-responsive > div.dataTables_wrapper > div.row > div[class^=col-]:first-child {
  padding-left: 0;
}
div.table-responsive > div.dataTables_wrapper > div.row > div[class^=col-]:last-child {
  padding-right: 0;
}

.table.dataTable thead .sorting:before, .table.dataTable thead .sorting_asc:before, .table.dataTable thead .sorting_desc:before, .table.dataTable thead .sorting_asc_disabled:before, .table.dataTable thead .sorting_desc_disabled:before {
  left: auto;
  right: 1em;
}
.table.dataTable thead .sorting:after, .table.dataTable thead .sorting_asc:after, .table.dataTable thead .sorting_desc:after, .table.dataTable thead .sorting_asc_disabled:after, .table.dataTable thead .sorting_desc_disabled:after {
  left: auto;
  right: 0.5em;
}
.table.dataTable thead tr th.sorting_asc, .table.dataTable thead tr th.sorting_desc, .table.dataTable thead tr th.sorting, .table.dataTable thead tr td.sorting_asc, .table.dataTable thead tr td.sorting_desc, .table.dataTable thead tr td.sorting {
  padding-left: 12px;
  padding-right: 30px;
}

.table.dataTable.dtr-inline.collapsed > tbody > tr > td, table.dataTable.dtr-inline.collapsed > tbody > tr > td {
  position: relative;
}
.table.dataTable.dtr-inline.collapsed > tbody > tr > td.dtr-control, table.dataTable.dtr-inline.collapsed > tbody > tr > td.dtr-control {
  padding-left: 30px;
}
.table.dataTable.dtr-inline.collapsed > tbody > tr > td.dtr-control:before, table.dataTable.dtr-inline.collapsed > tbody > tr > td.dtr-control:before {
  top: 50%;
  left: 5px;
  height: 14px;
  width: 14px;
  margin-top: -9px;
  display: block;
  position: absolute;
  color: #fff;
  border: 2px solid #fff;
  border-radius: 14px;
  box-sizing: content-box;
  text-align: center;
  text-indent: 0 !important;
  line-height: 14px;
  content: "+";
  background-color: #5b73e8;
}

.table-edits input, .table-edits select {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  border: 1px solid #ced4da;
  color: #495057;
  border-radius: 0.25rem;
  background-color: #fff;
}
.table-edits input:focus, .table-edits select:focus {
  outline: none;
  border-color: rgb(210.9, 216.3, 221.7);
}

.apex-charts {
  min-height: 10px !important;
}
.apex-charts text {
  font-family: "IBM Plex Sans", sans-serif !important;
  fill: #adb5bd;
  font-weight: 400;
}
.apex-charts .apexcharts-canvas {
  margin: 0 auto;
}

.apexcharts-tooltip-title,
.apexcharts-tooltip-text {
  font-family: "IBM Plex Sans", sans-serif !important;
}

.apexcharts-legend-series {
  font-weight: 500;
}

.apexcharts-gridline {
  pointer-events: none;
  stroke: #f8f9fa;
}

.apexcharts-legend-text {
  color: #74788d !important;
  font-family: "IBM Plex Sans", sans-serif !important;
  font-size: 13px !important;
  font-weight: 500 !important;
}

.apexcharts-pie-label {
  fill: #fff !important;
}

.apexcharts-yaxis text,
.apexcharts-xaxis text {
  font-family: "IBM Plex Sans", sans-serif !important;
  fill: #adb5bd;
}

/* Flot chart */
.flot-charts-height {
  height: 320px;
}

.flotTip {
  padding: 8px 12px;
  background-color: rgba(52, 58, 64, 0.9);
  z-index: 100;
  color: #f8f9fa;
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  border-radius: 4px;
}

.legendLabel {
  color: #adb5bd;
  padding-right: 5px;
  padding-left: 10px;
}

.jqstooltip {
  box-sizing: content-box;
  width: auto !important;
  height: auto !important;
  background-color: #343a40 !important;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  padding: 5px 10px !important;
  border-radius: 3px;
  border-color: #212529 !important;
}

.jqsfield {
  color: #f5f6f8 !important;
  font-size: 12px !important;
  line-height: 18px !important;
  font-family: "IBM Plex Sans", sans-serif !important;
  font-weight: 500 !important;
}

.gmaps, .gmaps-panaroma {
  height: 300px;
  background: #f8f9fa;
  border-radius: 3px;
}

.gmaps-overlay {
  display: block;
  text-align: center;
  color: #fff;
  font-size: 16px;
  line-height: 40px;
  background: #5b73e8;
  border-radius: 4px;
  padding: 10px 20px;
}

.gmaps-overlay_arrow {
  left: 50%;
  margin-left: -16px;
  width: 0;
  height: 0;
  position: absolute;
}
.gmaps-overlay_arrow.above {
  bottom: -15px;
  border-left: 16px solid transparent;
  border-right: 16px solid transparent;
  border-top: 16px solid #5b73e8;
}
.gmaps-overlay_arrow.below {
  top: -15px;
  border-left: 16px solid transparent;
  border-right: 16px solid transparent;
  border-bottom: 16px solid #5b73e8;
}

.jvectormap-label {
  border: none;
  background: #343a40;
  color: #f8f9fa;
  font-family: "IBM Plex Sans", sans-serif;
  font-size: 0.9rem;
  padding: 5px 8px;
}

.leaflet-map {
  height: 300px;
}
.leaflet-map.leaflet-container {
  z-index: 99;
}

.authentication-bg {
  background-color: rgba(211, 211, 211, 0.5294117647);
  background-size: cover;
}
.authentication-bg .auth-logo .logo {
  margin: 0px auto;
}

.signin-other-title {
  position: relative;
}
.signin-other-title:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  left: 0;
  right: 0;
  background-color: #f5f6f8;
  top: 10px;
}
.signin-other-title .title {
  display: inline-block;
  position: relative;
  z-index: 9;
  background-color: #fff;
  padding: 2px 16px;
}

.auth-carousel.owl-theme .owl-dots .owl-dot span {
  background-color: #fff;
}
.auth-carousel.owl-theme .owl-dots .owl-dot.active span {
  background-color: #5b73e8;
}

.search-box .form-control {
  border-radius: 30px;
  padding-left: 40px;
}
.search-box .search-icon {
  font-size: 16px;
  position: absolute;
  left: 13px;
  top: 0;
  line-height: 38px;
}

.categories-list {
  padding: 4px 0;
}
.categories-list li a {
  display: block;
  padding: 4px 12px;
  color: #495057;
}
.categories-list li.active a {
  color: #5b73e8;
}

.product-box {
  border: 1px solid #f5f6f8;
  transition: all 0.4s;
  overflow: hidden;
  margin-top: 20px;
  cursor: pointer;
}
.product-box:hover {
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
}
.product-box:hover .product-content {
  transform: translateY(-30px);
}
.product-box:hover .product-color {
  visibility: visible;
}

.product-img {
  position: relative;
}
.product-img .product-ribbon {
  position: absolute;
  top: 20px;
  left: 20px;
  padding: 6px 8px;
}

.product-wishlist {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 9;
}
.product-wishlist a {
  display: inline-block;
  width: 40px;
  height: 40px;
  border: 2px solid #f6f6f6;
  line-height: 38px;
  border-radius: 50%;
  text-align: center;
  color: #adb5bd;
}

.product-content {
  position: relative;
  transition: all 0.2s;
}

.product-color {
  position: absolute;
  left: 0;
  right: 0;
  margin: 16px auto 0;
  visibility: hidden;
}

.product-detail .nav-pills .nav-link {
  margin-bottom: 7px;
}
.product-detail .nav-pills .nav-link.active {
  background-color: #f6f6f6;
}
.product-detail .nav-pills .nav-link .tab-img {
  width: 5rem;
}
.product-detail .product-img {
  padding: 24px;
}

.product-desc-list li {
  padding: 2px 0px;
}

.product-desc-color a {
  display: inline-block;
  text-align: center;
  color: #495057;
  margin: 4px;
  border: 2px solid #f5f6f8;
  border-radius: 4px;
}
.product-desc-color a.active, .product-desc-color a:hover {
  color: #5b73e8;
  border-color: #5b73e8 !important;
}

.product-review-link .list-inline-item a {
  color: #74788d;
  padding: 4px 8px;
  font-size: 15px;
}

.product-cart-touchspin {
  border: 1px solid #ced4da;
  background-color: #fff;
  border-radius: 0.25rem;
}
.product-cart-touchspin .form-control {
  border-color: transparent;
  height: 32px;
}
.product-cart-touchspin .input-group-btn .btn {
  background-color: transparent !important;
  border-color: transparent !important;
  color: #5b73e8 !important;
  font-size: 16px;
  padding: 3px 12px;
  box-shadow: none;
}

.shipping-address {
  box-shadow: none;
}
.shipping-address.active {
  border-color: #5b73e8 !important;
}

/* ==============
  Email
===================*/
.email-leftbar {
  width: 236px;
  float: left;
  padding: 20px;
  border-radius: 5px;
}

.email-rightbar {
  margin-left: 260px;
}

.chat-user-box p.user-title {
  color: #343a40;
  font-weight: 500;
}
.chat-user-box p {
  font-size: 13px;
}

@media (max-width: 767px) {
  .email-leftbar {
    float: none;
    width: 100%;
  }
  .email-rightbar {
    margin: 0;
  }
}
.mail-list a {
  display: block;
  color: #74788d;
  line-height: 24px;
  padding: 8px 5px;
}
.mail-list a.active {
  color: #f46a6a;
  font-weight: 500;
}

.message-list {
  display: block;
  padding-left: 0;
}
.message-list li {
  position: relative;
  display: block;
  height: 50px;
  line-height: 50px;
  cursor: default;
  transition-duration: 0.3s;
}
.message-list li a {
  color: #74788d;
}
.message-list li:hover {
  background: #f6f6f6;
  transition-duration: 0.05s;
}
.message-list li .col-mail {
  float: left;
  position: relative;
}
.message-list li .col-mail-1 {
  width: 320px;
}
.message-list li .col-mail-1 .star-toggle,
.message-list li .col-mail-1 .checkbox-wrapper-mail,
.message-list li .col-mail-1 .dot {
  display: block;
  float: left;
}
.message-list li .col-mail-1 .dot {
  border: 4px solid transparent;
  border-radius: 100px;
  margin: 22px 26px 0;
  height: 0;
  width: 0;
  line-height: 0;
  font-size: 0;
}
.message-list li .col-mail-1 .checkbox-wrapper-mail {
  margin: 15px 10px 0 20px;
}
.message-list li .col-mail-1 .star-toggle {
  margin-top: 18px;
  margin-left: 5px;
}
.message-list li .col-mail-1 .title {
  position: absolute;
  top: 0;
  left: 110px;
  right: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-bottom: 0;
}
.message-list li .col-mail-2 {
  position: absolute;
  top: 0;
  left: 320px;
  right: 0;
  bottom: 0;
}
.message-list li .col-mail-2 .subject,
.message-list li .col-mail-2 .date {
  position: absolute;
  top: 0;
}
.message-list li .col-mail-2 .subject {
  left: 0;
  right: 200px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.message-list li .col-mail-2 .date {
  right: 0;
  width: 170px;
  padding-left: 80px;
}
.message-list li.active, .message-list li.active:hover {
  box-shadow: inset 3px 0 0 #5b73e8;
}
.message-list li.unread {
  background-color: #f6f6f6;
  font-weight: 500;
  color: rgb(40.5689655172, 45.25, 49.9310344828);
}
.message-list li.unread a {
  color: rgb(40.5689655172, 45.25, 49.9310344828);
  font-weight: 500;
}
.message-list .checkbox-wrapper-mail {
  cursor: pointer;
  height: 20px;
  width: 20px;
  position: relative;
  display: inline-block;
  box-shadow: inset 0 0 0 1px #ced4da;
  border-radius: 1px;
}
.message-list .checkbox-wrapper-mail input {
  opacity: 0;
  cursor: pointer;
}
.message-list .checkbox-wrapper-mail input:checked ~ label {
  opacity: 1;
}
.message-list .checkbox-wrapper-mail label {
  position: absolute;
  height: 20px;
  width: 20px;
  left: 0;
  cursor: pointer;
  opacity: 0;
  margin-bottom: 0;
  transition-duration: 0.05s;
  top: 0;
}
.message-list .checkbox-wrapper-mail label:before {
  content: "\\f012c";
  font-family: "Material Design Icons";
  top: 0;
  height: 20px;
  color: rgb(40.5689655172, 45.25, 49.9310344828);
  width: 20px;
  position: absolute;
  margin-top: -16px;
  left: 4px;
  font-size: 13px;
}

@media (max-width: 575.98px) {
  .message-list li .col-mail-1 {
    width: 200px;
  }
}
@media (min-width: 1200px) {
  .chat-leftsidebar {
    min-width: 380px;
  }
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  .chat-leftsidebar {
    min-width: 280px;
  }
}

.chat-noti-dropdown.active:before {
  content: "";
  position: absolute;
  width: 8px;
  height: 8px;
  background-color: #f46a6a;
  border-radius: 50%;
  right: 0;
}
.chat-noti-dropdown .btn {
  padding: 6px;
  box-shadow: none;
  font-size: 20px;
}

.chat-search-box .form-control {
  border: 0;
}

.chat-list {
  margin: 0;
}
.chat-list li.active a {
  background-color: rgba(91, 115, 232, 0.075);
  border-color: transparent;
}
.chat-list li a {
  position: relative;
  display: block;
  color: #74788d;
  transition: all 0.4s;
  padding: 12px;
  border-top: 1px solid #f5f6f8;
  border-radius: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 500;
}
.chat-list li a:hover {
  background-color: rgba(91, 115, 232, 0.075);
  border-color: transparent;
}
.chat-list li .user-img {
  position: relative;
}
.chat-list li .user-img .user-status {
  width: 10px;
  height: 10px;
  background-color: #adb5bd;
  border-radius: 50%;
  border: 2px solid #fff;
  position: absolute;
  right: 0;
  bottom: 0;
}
.chat-list li .user-img.online .user-status {
  background-color: #34c38f;
}
.chat-list li .user-img.away .user-status {
  background-color: #f1b44c;
}
.chat-list li.unread a {
  font-weight: 600;
  color: #343a40;
}
.chat-list li .unread-message {
  position: absolute;
  display: inline-block;
  right: 16px;
  top: 33px;
}

.group-list li a {
  border: 0;
}

.user-chat-nav .dropdown .nav-btn {
  height: 36px;
  width: 36px;
  line-height: 36px;
  box-shadow: none;
  padding: 0;
  font-size: 16px;
  border-radius: 50%;
}
.user-chat-nav .dropdown .dropdown-menu {
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  border: 1px solid #f5f6f8;
}

.chat-conversation li {
  clear: both;
}
.chat-conversation .chat-day-title {
  position: relative;
  text-align: center;
  margin-bottom: 24px;
  border: none;
}
.chat-conversation .chat-day-title .title {
  display: inline-block;
  background-color: #f5f6f8;
  position: relative;
  z-index: 1;
  padding: 4px 16px;
  border-radius: 30px;
}
.chat-conversation .chat-day-title:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  left: 0;
  right: 0;
  background-color: #f5f6f8;
  top: 16px;
}
.chat-conversation .chat-day-title .badge {
  font-size: 12px;
}
.chat-conversation .conversation-list {
  margin-bottom: 24px;
  position: relative;
}
.chat-conversation .conversation-list .ctext-wrap {
  display: flex;
  margin-bottom: 10px;
}
.chat-conversation .conversation-list .ctext-wrap-content {
  padding: 12px 20px;
  background-color: rgba(91, 115, 232, 0.1);
  border-radius: 0px 8px 8px 8px;
  color: #74788d;
  position: relative;
  margin-left: 16px;
}
.chat-conversation .conversation-list .ctext-wrap-content:before {
  content: "";
  position: absolute;
  border: 5px solid transparent;
  border-right-color: rgba(91, 115, 232, 0.1);
  border-top-color: rgba(91, 115, 232, 0.1);
  left: -10px;
  top: 0;
}
.chat-conversation .conversation-list .conversation-name {
  margin-bottom: 4px;
}
.chat-conversation .conversation-list .dropdown .dropdown-toggle {
  font-size: 18px;
  padding: 4px;
  color: #74788d;
}
@media (max-width: 575.98px) {
  .chat-conversation .conversation-list .dropdown .dropdown-toggle {
    display: none;
  }
}
.chat-conversation .conversation-list .chat-time {
  font-size: 12px;
  margin-top: 4px;
  text-align: right;
  color: rgba(255, 255, 255, 0.5);
}
.chat-conversation .conversation-list .message-img {
  border-radius: 0.2rem;
  position: relative;
}
.chat-conversation .conversation-list .message-img .message-img-list {
  position: relative;
}
.chat-conversation .conversation-list .message-img img {
  max-width: 140px;
}
.chat-conversation .right .conversation-list {
  float: right;
  text-align: right;
}
.chat-conversation .right .conversation-list .ctext-wrap .ctext-wrap-content {
  order: 2;
  background-color: #f5f6f8;
  text-align: right;
  border-radius: 8px 0px 8px 8px;
  margin-left: 0;
  margin-right: 16px;
}
.chat-conversation .right .conversation-list .ctext-wrap .ctext-wrap-content:before {
  border: 5px solid transparent;
  border-top-color: #f5f6f8;
  border-left-color: #f5f6f8;
  left: auto;
  right: -10px;
}
.chat-conversation .right .conversation-list .dropdown {
  order: 1;
}

.chat-input-section {
  border-top: 1px solid #f5f6f8;
}

.chat-input {
  border-radius: 30px;
  background-color: #f5f6f8 !important;
  border-color: #f5f6f8 !important;
}

@media (max-width: 575.98px) {
  .chat-send {
    min-width: auto;
  }
}

.counter-number {
  font-size: 32px;
  font-weight: 600;
  text-align: center;
  display: flex;
}
.counter-number span {
  font-size: 16px;
  font-weight: 400;
  display: block;
  padding-top: 5px;
}

.coming-box {
  width: 25%;
}

/************** Horizontal timeline **************/
.hori-timeline .events .event-list {
  text-align: center;
  display: block;
}
.hori-timeline .events .event-list::after {
  content: "\\e858";
  font-family: "unicons-line";
  display: block;
  position: absolute;
  top: 34px;
  left: 0;
  right: 0;
  margin: 0px auto;
  color: #ced4da;
  font-size: 24px;
}
.hori-timeline .events .event-list:before {
  content: "";
  display: block;
  position: absolute;
  top: 14px;
  left: 0;
  right: 0;
  width: 100%;
  height: 2px;
  border-radius: 50%;
  background-color: #f6f6f6;
}
.hori-timeline .events .event-list .event-date {
  display: inline-block;
  position: relative;
  border-radius: 4px;
  background-color: rgba(91, 115, 232, 0.2);
  padding: 2px 12px;
  margin-bottom: 48px;
}

/************** vertical timeline **************/
.verti-timeline {
  padding-left: 100px;
}
.verti-timeline .event-list {
  border-left: 3px dashed #f6f6f6;
  position: relative;
  padding: 0px 0px 30px 30px;
}
.verti-timeline .event-list:after {
  content: "";
  display: block;
  position: absolute;
  top: 6px;
  left: -6px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid #5b73e8;
  background-color: #fff;
}
.verti-timeline .event-list .event-date {
  display: inline-block;
  border-radius: 4px;
  background-color: rgba(91, 115, 232, 0.2);
  color: #5b73e8;
  padding: 2px 12px;
  position: absolute;
  left: -102px;
}
.verti-timeline .event-list:last-child {
  padding-bottom: 0;
}

.faq-nav-tabs .nav-link {
  margin-bottom: 8px;
  background-color: #f5f6f8;
  padding: 8px 16px;
}
.faq-nav-tabs .nav-link .nav-icon {
  font-size: 24px;
  vertical-align: middle;
}

.pricing-box {
  max-width: 388px;
  margin: 0px auto 20px;
}
.pricing-box .plan-features li {
  padding: 7px 0px;
}

body * {
  outline: none;
}

.react-bootstrap-table-page-btns-ul {
  margin-bottom: 0px;
}

.pagination-bar {
  display: flex;
  padding-left: 0;
  list-style: none;
  justify-content: center;
}

.page-link {
  padding: 10px 15px;
  position: relative;
  display: block;
  color: #74788d;
  background-color: #fff;
  border: 1px solid #ced4da;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.page-link.active {
  background-color: blue;
}

.close {
  background: transparent;
  border: 0;
  font-size: 10px;
  padding: 1.35rem 1.25rem;
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_49___}) center/1em auto no-repeat;
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0.5;
  width: 1em;
  height: 1em;
  z-index: 2;
}
.close span {
  display: none;
}

.rangeslider__fill {
  background-color: #556ee6 !important;
}

.rdw-editor-main {
  border: 1px solid #f6f6f6;
  height: 239px;
}

.dz-message {
  text-align: center;
  margin: 2em 0;
}

.bs-select select {
  width: auto !important;
}

.apexcharts-canvas text {
  fill: #adb5bd !important;
}

.card-columns .card {
  margin-bottom: 1.25rem;
}
@media (min-width: 576px) {
  .card-columns {
    column-count: 3;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
  }
  .card-columns .card {
    display: inline-block;
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/theme.scss","webpack://./src/assets/scss/icons.scss","webpack://./src/assets/scss/custom/plugins/icons/_materialdesignicons.scss","webpack://./src/assets/scss/custom/plugins/icons/_boxicons.scss","webpack://./src/assets/scss/custom/plugins/icons/_fontawesome-all.scss","webpack://./src/assets/scss/custom/plugins/icons/_dripicons.scss","webpack://./src/assets/scss/bootstrap.scss","webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/mixins/_color-mode.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./src/assets/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss","webpack://./src/assets/scss/custom/components/_reboot.scss","webpack://./src/assets/scss/custom/components/_backgrounds.scss","webpack://./src/assets/scss/custom/components/_badge.scss","webpack://./src/assets/scss/custom/components/_buttons.scss","webpack://./src/assets/scss/custom/components/_breadcrumb.scss","webpack://./src/assets/scss/custom/components/_card.scss","webpack://./src/assets/scss/custom/components/_dropdown.scss","webpack://./src/assets/scss/custom/components/_nav.scss","webpack://./src/assets/scss/custom/components/_table.scss","webpack://./src/assets/scss/custom/components/_pagination.scss","webpack://./src/assets/scss/custom/components/_progress.scss","webpack://./src/assets/scss/app.scss","webpack://./src/assets/scss/custom/structure/_topbar.scss","webpack://./src/assets/scss/custom/structure/_page-head.scss","webpack://./src/assets/scss/custom/structure/_footer.scss","webpack://./src/assets/scss/custom/structure/_right-sidebar.scss","webpack://./src/assets/scss/custom/structure/_vertical.scss","webpack://./src/assets/scss/custom/structure/_horizontal-nav.scss","webpack://./src/assets/scss/custom/structure/_layouts.scss","webpack://./src/assets/scss/custom/components/_waves.scss","webpack://./src/assets/scss/custom/components/_avatar.scss","webpack://./src/assets/scss/custom/components/_alerts.scss","webpack://./src/assets/scss/custom/components/_accordion.scss","webpack://./src/assets/scss/custom/components/_helper.scss","webpack://./src/assets/scss/custom/components/_preloader.scss","webpack://./src/assets/scss/custom/components/_forms.scss","webpack://./src/assets/scss/custom/components/_widgets.scss","webpack://./src/assets/scss/custom/components/_demos.scss","webpack://./src/assets/scss/custom/components/_print.scss","webpack://./src/assets/scss/custom/plugins/_custom-scrollbar.scss","webpack://./src/assets/scss/custom/plugins/_calendar.scss","webpack://./src/assets/scss/custom/plugins/_session-timeout.scss","webpack://./src/assets/scss/custom/plugins/_range-slider.scss","webpack://./src/assets/scss/custom/plugins/_sweatalert2.scss","webpack://./src/assets/scss/custom/plugins/_rating.scss","webpack://./src/assets/scss/custom/plugins/_toastr.scss","webpack://./src/assets/scss/custom/plugins/_parsley.scss","webpack://./src/assets/scss/custom/plugins/_select2.scss","webpack://./src/assets/scss/custom/plugins/_switch.scss","webpack://./src/assets/scss/custom/plugins/_colorpicker.scss","webpack://./src/assets/scss/custom/plugins/_datepicker.scss","webpack://./src/assets/scss/custom/plugins/_bootstrap-touchspin.scss","webpack://./src/assets/scss/custom/plugins/_repeater.scss","webpack://./src/assets/scss/custom/plugins/_form-editors.scss","webpack://./src/assets/scss/custom/plugins/_xeditable.scss","webpack://./src/assets/scss/custom/plugins/_form-upload.scss","webpack://./src/assets/scss/custom/plugins/_form-wizard.scss","webpack://./src/assets/scss/custom/plugins/_responsive-table.scss","webpack://./src/assets/scss/custom/plugins/_datatable.scss","webpack://./src/assets/scss/custom/plugins/_table-editable.scss","webpack://./src/assets/scss/custom/plugins/_apexcharts.scss","webpack://./src/assets/scss/custom/plugins/_flot.scss","webpack://./src/assets/scss/custom/plugins/_sparkline-chart.scss","webpack://./src/assets/scss/custom/plugins/_google-map.scss","webpack://./src/assets/scss/custom/plugins/_vector-maps.scss","webpack://./src/assets/scss/custom/plugins/_leaflet-maps.scss","webpack://./src/assets/scss/custom/pages/_authentication.scss","webpack://./src/assets/scss/custom/pages/_ecommerce.scss","webpack://./src/assets/scss/custom/pages/_email.scss","webpack://./src/assets/scss/custom/pages/_chat.scss","webpack://./src/assets/scss/custom/pages/_coming-soon.scss","webpack://./src/assets/scss/custom/pages/_timeline.scss","webpack://./src/assets/scss/custom/pages/_extras-pages.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;;;;;CAAA;ACAA,4BAAA;AACA;EACE,oCAAA;EACA,4CAAA;EACA,qPAAA;EAQA,mBAAA;EACA,kBAAA;AFIF;AEDA;;EAEE,qBAAA;EACA,yDAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mCAAA;EACA,kCAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,gBAAA;EACA,kBAAA;AFGF;;AEAA;;EAEE,eAAA;AFGF;;AEAA;;EAEE,eAAA;AFGF;;AEAA;;EAEE,eAAA;AFGF;;AEAA;;EAEE,eAAA;AFGF;;AEAA;EACE,0BAAA;AFGF;;AEAA;EACE,0BAAA;AFGF;;AEAA;EACE,YAAA;AFGF;;AEAA;EACE,+BAAA;AFGF;;AEAA;EACE;;;;;;;;;;;;;;;SAAA;AFkBF;;AEAA;EAGE,wBAAA;AFGF;;AEAA;EACE;;;;;;;;;;;;;;;SAAA;AFkBF;;AEAA;EAGE,wBAAA;AFGF;;AEAA;EACE;;;;;;;;;;;;;;;SAAA;AFkBF;;AEAA;EAGE,yBAAA;AFGF;;AEAA;EACE;;;;;;;;;;;;;;;SAAA;AFkBF;;AEAA;EAGE,yBAAA;AFGF;;AEAA;EACE;;;;;;;;;;;;;;;SAAA;AFkBF;;AEAA;EAGE,yBAAA;AFGF;;AEAA;EACE;;;;;;;;;;;;;;;SAAA;AFkBF;;AEAA;EAGE,yBAAA;AFGF;;AEAA;EACE;;;;;;;;;;;;;;;SAAA;AFkBF;;AEAA;EAGE,yBAAA;AFGF;;AEAA;EAEE,qBAAA;EACA,aAAA;EACA,mBAAA;AFGF;;AEAA;EAEE,qBAAA;EACA,aAAA;EACA,mBAAA;AFGF;;AEAA;EAEE,sCAAA;AFGF;AEWA;EACE;IAEE,uBAAA;EFEF;EEAA;IAEE,yBAAA;EFEF;AACF;;AGvpuBA;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EAEA,4CAAA;EACA,4SAAA;AHypuBF;AGnpuBA;EACE,kCAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EAEA,qBAAA;EAEA,oBAAA;EAEA,WAAA;EACA,mCAAA;EACA,kCAAA;AHkpuBF;;AGhpuBA;EACE,gBAAA;EACA,eAAA;EAEA,gBAAA;AHkpuBF;;AGhpuBA;EACE,kBAAA;AHmpuBF;;AGjpuBA;EACE,kBAAA;EACA,oBAAA;EAEA,kBAAA;EACA,UAAA;EAEA,UAAA;EAEA,kBAAA;AHipuBF;AGrouBA;EACE;IAEE,oBAAA;EHkpuBF;EGhpuBA;IAEE,yBAAA;EHkpuBF;AACF;AGlouBA;EACE;IAEE,mBAAA;IAEA,UAAA;EH+ouBF;EG7ouBA;IAEE,qBAAA;IAEA,UAAA;EH8ouBF;AACF;AGjouBA;EACE;IACE,UAAA;EH8ouBF;EG5ouBA;IACE,UAAA;EH8ouBF;EG5ouBA;IACE,UAAA;EH8ouBF;AACF;AG9nuBA;EACE;IAEE,wBAAA;IAEA,UAAA;EH2ouBF;EGzouBA;IAEE,4BAAA;IAEA,UAAA;EH0ouBF;AACF;AG1nuBA;EACE;IAEE,wBAAA;IAEA,UAAA;EHuouBF;EGrouBA;IAEE,2BAAA;IAEA,UAAA;EHsouBF;AACF;AGtnuBA;EACE;IAEE,wBAAA;IAEA,UAAA;EHmouBF;EGjouBA;IAEE,4BAAA;IAEA,UAAA;EHkouBF;AACF;AGlnuBA;EACE;IAEE,wBAAA;IAEA,UAAA;EH+nuBF;EG7nuBA;IAEE,2BAAA;IAEA,UAAA;EH8nuBF;AACF;AG3luBA;EACE;IAEE,2BAAA;EHmnuBF;EGhnuBA;IAGE,8DAAA;EHinuBF;EG9muBA;IAKE,oDAAA;EH6muBF;EG1muBA;IAIE,oCAAA;EH0muBF;EGvmuBA;IAEE,2BAAA;EHymuBF;AACF;AGvmuBA;EAEE,kCAAA;AHymuBF;;AGvmuBA;EAEE,kCAAA;AH0muBF;;AGvmuBA;EAEE,kCAAA;AH0muBF;;AGxmuBA;EAEE,kCAAA;AH2muBF;;AGxmuBA;EAEE,wCAAA;AH2muBF;;AGzmuBA;EAEE,wCAAA;AH4muBF;;AGzmuBA;EAEE,qCAAA;AH4muBF;;AG1muBA;EAEE,qCAAA;AH6muBF;;AG3muBA;EAEE,uCAAA;AH8muBF;;AG5muBA;EAEE,uCAAA;AH+muBF;;AG7muBA;EAEE,yCAAA;AHgnuBF;;AG9muBA;EAEE,yCAAA;AHinuBF;;AG/muBA;EAEE,yCAAA;AHknuBF;;AGhnuBA;EAEE,yCAAA;AHmnuBF;;AGjnuBA;EAEE,0CAAA;AHonuBF;;AGlnuBA;EAEE,0CAAA;AHqnuBF;;AGnnuBA;EACE,0BAAA;AHsnuBF;;AGpnuBA;EACE,6BAAA;AHunuBF;;AGrnuBA;EACE,6BAAA;AHwnuBF;;AGtnuBA;EACE,yBAAA;EACA,kBAAA;EAEA,qBAAA;EACA,aAAA;EACA,6BAAA;EAEA,sBAAA;AHunuBF;;AGpnuBA;EACE,0BAAA;AHunuBF;;AGrnuBA;EACE,WAAA;EAEA,8BAAA;AHunuBF;;AGpnuBA;EACE,YAAA;EAEA,6BAAA;AHsnuBF;;AGpnuBA;EACE,wBAAA;EAEA,sEAAA;AHsnuBF;;AGpnuBA;EACE,yBAAA;EAEA,sEAAA;AHsnuBF;;AGpnuBA;EACE,yBAAA;EAEA,sEAAA;AHsnuBF;;AGpnuBA;EACE,qBAAA;EAEA,gFAAA;AHsnuBF;;AGpnuBA;EACE,qBAAA;EAEA,gFAAA;AHsnuBF;;AGpnuBA;EACE,eAAA;EAEA,uCAAA;EACA,qBAAA;AHsnuBF;;AGpnuBA;EACE,eAAA;EAEA,uCAAA;EACA,kBAAA;AHsnuBF;;AGnnuBA;EACE,gBAAA;AHsnuBF;;AGpnuBA;EACE,gBAAA;AHunuBF;;AGrnuBA;EACE,gBAAA;AHwnuBF;;AGtnuBA;EACE,gBAAA;AHynuBF;;AGvnuBA;EACE,gBAAA;AH0nuBF;;AGxnuBA;EACE,gBAAA;AH2nuBF;;AGznuBA;EACE,gBAAA;AH4nuBF;;AG1nuBA;EACE,gBAAA;AH6nuBF;;AG3nuBA;EACE,gBAAA;AH8nuBF;;AG5nuBA;EACE,gBAAA;AH+nuBF;;AG7nuBA;EACE,gBAAA;AHgouBF;;AG9nuBA;EACE,gBAAA;AHiouBF;;AG/nuBA;EACE,gBAAA;AHkouBF;;AGhouBA;EACE,gBAAA;AHmouBF;;AGjouBA;EACE,gBAAA;AHoouBF;;AGlouBA;EACE,gBAAA;AHqouBF;;AGnouBA;EACE,gBAAA;AHsouBF;;AGpouBA;EACE,gBAAA;AHuouBF;;AGrouBA;EACE,gBAAA;AHwouBF;;AGtouBA;EACE,gBAAA;AHyouBF;;AGvouBA;EACE,gBAAA;AH0ouBF;;AGxouBA;EACE,gBAAA;AH2ouBF;;AGzouBA;EACE,gBAAA;AH4ouBF;;AG1ouBA;EACE,gBAAA;AH6ouBF;;AG3ouBA;EACE,gBAAA;AH8ouBF;;AG5ouBA;EACE,gBAAA;AH+ouBF;;AG7ouBA;EACE,gBAAA;AHgpuBF;;AG9ouBA;EACE,gBAAA;AHipuBF;;AG/ouBA;EACE,gBAAA;AHkpuBF;;AGhpuBA;EACE,gBAAA;AHmpuBF;;AGjpuBA;EACE,gBAAA;AHopuBF;;AGlpuBA;EACE,gBAAA;AHqpuBF;;AGnpuBA;EACE,gBAAA;AHspuBF;;AGppuBA;EACE,gBAAA;AHupuBF;;AGrpuBA;EACE,gBAAA;AHwpuBF;;AGtpuBA;EACE,gBAAA;AHypuBF;;AGvpuBA;EACE,gBAAA;AH0puBF;;AGxpuBA;EACE,gBAAA;AH2puBF;;AGzpuBA;EACE,gBAAA;AH4puBF;;AG1puBA;EACE,gBAAA;AH6puBF;;AG3puBA;EACE,gBAAA;AH8puBF;;AG5puBA;EACE,gBAAA;AH+puBF;;AG7puBA;EACE,gBAAA;AHgquBF;;AG9puBA;EACE,gBAAA;AHiquBF;;AG/puBA;EACE,gBAAA;AHkquBF;;AGhquBA;EACE,gBAAA;AHmquBF;;AGjquBA;EACE,gBAAA;AHoquBF;;AGlquBA;EACE,gBAAA;AHqquBF;;AGnquBA;EACE,gBAAA;AHsquBF;;AGpquBA;EACE,gBAAA;AHuquBF;;AGrquBA;EACE,gBAAA;AHwquBF;;AGtquBA;EACE,gBAAA;AHyquBF;;AGvquBA;EACE,gBAAA;AH0quBF;;AGxquBA;EACE,gBAAA;AH2quBF;;AGzquBA;EACE,gBAAA;AH4quBF;;AG1quBA;EACE,gBAAA;AH6quBF;;AG3quBA;EACE,gBAAA;AH8quBF;;AG5quBA;EACE,gBAAA;AH+quBF;;AG7quBA;EACE,gBAAA;AHgruBF;;AG9quBA;EACE,gBAAA;AHiruBF;;AG/quBA;EACE,gBAAA;AHkruBF;;AGhruBA;EACE,gBAAA;AHmruBF;;AGjruBA;EACE,gBAAA;AHoruBF;;AGlruBA;EACE,gBAAA;AHqruBF;;AGnruBA;EACE,gBAAA;AHsruBF;;AGpruBA;EACE,gBAAA;AHuruBF;;AGrruBA;EACE,gBAAA;AHwruBF;;AGtruBA;EACE,gBAAA;AHyruBF;;AGvruBA;EACE,gBAAA;AH0ruBF;;AGxruBA;EACE,gBAAA;AH2ruBF;;AGzruBA;EACE,gBAAA;AH4ruBF;;AG1ruBA;EACE,gBAAA;AH6ruBF;;AG3ruBA;EACE,gBAAA;AH8ruBF;;AG5ruBA;EACE,gBAAA;AH+ruBF;;AG7ruBA;EACE,gBAAA;AHgsuBF;;AG9ruBA;EACE,gBAAA;AHisuBF;;AG/ruBA;EACE,gBAAA;AHksuBF;;AGhsuBA;EACE,gBAAA;AHmsuBF;;AGjsuBA;EACE,gBAAA;AHosuBF;;AGlsuBA;EACE,gBAAA;AHqsuBF;;AGnsuBA;EACE,gBAAA;AHssuBF;;AGpsuBA;EACE,gBAAA;AHusuBF;;AGrsuBA;EACE,gBAAA;AHwsuBF;;AGtsuBA;EACE,gBAAA;AHysuBF;;AGvsuBA;EACE,gBAAA;AH0suBF;;AGxsuBA;EACE,gBAAA;AH2suBF;;AGzsuBA;EACE,gBAAA;AH4suBF;;AG1suBA;EACE,gBAAA;AH6suBF;;AG3suBA;EACE,gBAAA;AH8suBF;;AG5suBA;EACE,gBAAA;AH+suBF;;AG7suBA;EACE,gBAAA;AHgtuBF;;AG9suBA;EACE,gBAAA;AHituBF;;AG/suBA;EACE,gBAAA;AHktuBF;;AGhtuBA;EACE,gBAAA;AHmtuBF;;AGjtuBA;EACE,gBAAA;AHotuBF;;AGltuBA;EACE,gBAAA;AHqtuBF;;AGntuBA;EACE,gBAAA;AHstuBF;;AGptuBA;EACE,gBAAA;AHutuBF;;AGrtuBA;EACE,gBAAA;AHwtuBF;;AGttuBA;EACE,gBAAA;AHytuBF;;AGvtuBA;EACE,gBAAA;AH0tuBF;;AGxtuBA;EACE,gBAAA;AH2tuBF;;AGztuBA;EACE,gBAAA;AH4tuBF;;AG1tuBA;EACE,gBAAA;AH6tuBF;;AG3tuBA;EACE,gBAAA;AH8tuBF;;AG5tuBA;EACE,gBAAA;AH+tuBF;;AG7tuBA;EACE,gBAAA;AHguuBF;;AG9tuBA;EACE,gBAAA;AHiuuBF;;AG/tuBA;EACE,gBAAA;AHkuuBF;;AGhuuBA;EACE,gBAAA;AHmuuBF;;AGjuuBA;EACE,gBAAA;AHouuBF;;AGluuBA;EACE,gBAAA;AHquuBF;;AGnuuBA;EACE,gBAAA;AHsuuBF;;AGpuuBA;EACE,gBAAA;AHuuuBF;;AGruuBA;EACE,gBAAA;AHwuuBF;;AGtuuBA;EACE,gBAAA;AHyuuBF;;AGvuuBA;EACE,gBAAA;AH0uuBF;;AGxuuBA;EACE,gBAAA;AH2uuBF;;AGzuuBA;EACE,gBAAA;AH4uuBF;;AG1uuBA;EACE,gBAAA;AH6uuBF;;AG3uuBA;EACE,gBAAA;AH8uuBF;;AG5uuBA;EACE,gBAAA;AH+uuBF;;AG7uuBA;EACE,gBAAA;AHgvuBF;;AG9uuBA;EACE,gBAAA;AHivuBF;;AG/uuBA;EACE,gBAAA;AHkvuBF;;AGhvuBA;EACE,gBAAA;AHmvuBF;;AGjvuBA;EACE,gBAAA;AHovuBF;;AGlvuBA;EACE,gBAAA;AHqvuBF;;AGnvuBA;EACE,gBAAA;AHsvuBF;;AGpvuBA;EACE,gBAAA;AHuvuBF;;AGrvuBA;EACE,gBAAA;AHwvuBF;;AGtvuBA;EACE,gBAAA;AHyvuBF;;AGvvuBA;EACE,gBAAA;AH0vuBF;;AGxvuBA;EACE,gBAAA;AH2vuBF;;AGzvuBA;EACE,gBAAA;AH4vuBF;;AG1vuBA;EACE,gBAAA;AH6vuBF;;AG3vuBA;EACE,gBAAA;AH8vuBF;;AG5vuBA;EACE,gBAAA;AH+vuBF;;AG7vuBA;EACE,gBAAA;AHgwuBF;;AG9vuBA;EACE,gBAAA;AHiwuBF;;AG/vuBA;EACE,gBAAA;AHkwuBF;;AGhwuBA;EACE,gBAAA;AHmwuBF;;AGjwuBA;EACE,gBAAA;AHowuBF;;AGlwuBA;EACE,gBAAA;AHqwuBF;;AGnwuBA;EACE,gBAAA;AHswuBF;;AGpwuBA;EACE,gBAAA;AHuwuBF;;AGrwuBA;EACE,gBAAA;AHwwuBF;;AGtwuBA;EACE,gBAAA;AHywuBF;;AGvwuBA;EACE,gBAAA;AH0wuBF;;AGxwuBA;EACE,gBAAA;AH2wuBF;;AGzwuBA;EACE,gBAAA;AH4wuBF;;AG1wuBA;EACE,gBAAA;AH6wuBF;;AG3wuBA;EACE,gBAAA;AH8wuBF;;AG5wuBA;EACE,gBAAA;AH+wuBF;;AG7wuBA;EACE,gBAAA;AHgxuBF;;AG9wuBA;EACE,gBAAA;AHixuBF;;AG/wuBA;EACE,gBAAA;AHkxuBF;;AGhxuBA;EACE,gBAAA;AHmxuBF;;AGjxuBA;EACE,gBAAA;AHoxuBF;;AGlxuBA;EACE,gBAAA;AHqxuBF;;AGnxuBA;EACE,gBAAA;AHsxuBF;;AGpxuBA;EACE,gBAAA;AHuxuBF;;AGrxuBA;EACE,gBAAA;AHwxuBF;;AGtxuBA;EACE,gBAAA;AHyxuBF;;AGvxuBA;EACE,gBAAA;AH0xuBF;;AGxxuBA;EACE,gBAAA;AH2xuBF;;AGzxuBA;EACE,gBAAA;AH4xuBF;;AG1xuBA;EACE,gBAAA;AH6xuBF;;AG3xuBA;EACE,gBAAA;AH8xuBF;;AG5xuBA;EACE,gBAAA;AH+xuBF;;AG7xuBA;EACE,gBAAA;AHgyuBF;;AG9xuBA;EACE,gBAAA;AHiyuBF;;AG/xuBA;EACE,gBAAA;AHkyuBF;;AGhyuBA;EACE,gBAAA;AHmyuBF;;AGjyuBA;EACE,gBAAA;AHoyuBF;;AGlyuBA;EACE,gBAAA;AHqyuBF;;AGnyuBA;EACE,gBAAA;AHsyuBF;;AGpyuBA;EACE,gBAAA;AHuyuBF;;AGryuBA;EACE,gBAAA;AHwyuBF;;AGtyuBA;EACE,gBAAA;AHyyuBF;;AGvyuBA;EACE,gBAAA;AH0yuBF;;AGxyuBA;EACE,gBAAA;AH2yuBF;;AGzyuBA;EACE,gBAAA;AH4yuBF;;AG1yuBA;EACE,gBAAA;AH6yuBF;;AG3yuBA;EACE,gBAAA;AH8yuBF;;AG5yuBA;EACE,gBAAA;AH+yuBF;;AG7yuBA;EACE,gBAAA;AHgzuBF;;AG9yuBA;EACE,gBAAA;AHizuBF;;AG/yuBA;EACE,gBAAA;AHkzuBF;;AGhzuBA;EACE,gBAAA;AHmzuBF;;AGjzuBA;EACE,gBAAA;AHozuBF;;AGlzuBA;EACE,gBAAA;AHqzuBF;;AGnzuBA;EACE,gBAAA;AHszuBF;;AGpzuBA;EACE,gBAAA;AHuzuBF;;AGrzuBA;EACE,gBAAA;AHwzuBF;;AGtzuBA;EACE,gBAAA;AHyzuBF;;AGvzuBA;EACE,gBAAA;AH0zuBF;;AGxzuBA;EACE,gBAAA;AH2zuBF;;AGzzuBA;EACE,gBAAA;AH4zuBF;;AG1zuBA;EACE,gBAAA;AH6zuBF;;AG3zuBA;EACE,gBAAA;AH8zuBF;;AG5zuBA;EACE,gBAAA;AH+zuBF;;AG7zuBA;EACE,gBAAA;AHg0uBF;;AG9zuBA;EACE,gBAAA;AHi0uBF;;AG/zuBA;EACE,gBAAA;AHk0uBF;;AGh0uBA;EACE,gBAAA;AHm0uBF;;AGj0uBA;EACE,gBAAA;AHo0uBF;;AGl0uBA;EACE,gBAAA;AHq0uBF;;AGn0uBA;EACE,gBAAA;AHs0uBF;;AGp0uBA;EACE,gBAAA;AHu0uBF;;AGr0uBA;EACE,gBAAA;AHw0uBF;;AGt0uBA;EACE,gBAAA;AHy0uBF;;AGv0uBA;EACE,gBAAA;AH00uBF;;AGx0uBA;EACE,gBAAA;AH20uBF;;AGz0uBA;EACE,gBAAA;AH40uBF;;AG10uBA;EACE,gBAAA;AH60uBF;;AG30uBA;EACE,gBAAA;AH80uBF;;AG50uBA;EACE,gBAAA;AH+0uBF;;AG70uBA;EACE,gBAAA;AHg1uBF;;AG90uBA;EACE,gBAAA;AHi1uBF;;AG/0uBA;EACE,gBAAA;AHk1uBF;;AGh1uBA;EACE,gBAAA;AHm1uBF;;AGj1uBA;EACE,gBAAA;AHo1uBF;;AGl1uBA;EACE,gBAAA;AHq1uBF;;AGn1uBA;EACE,gBAAA;AHs1uBF;;AGp1uBA;EACE,gBAAA;AHu1uBF;;AGr1uBA;EACE,gBAAA;AHw1uBF;;AGt1uBA;EACE,gBAAA;AHy1uBF;;AGv1uBA;EACE,gBAAA;AH01uBF;;AGx1uBA;EACE,gBAAA;AH21uBF;;AGz1uBA;EACE,gBAAA;AH41uBF;;AG11uBA;EACE,gBAAA;AH61uBF;;AG31uBA;EACE,gBAAA;AH81uBF;;AG51uBA;EACE,gBAAA;AH+1uBF;;AG71uBA;EACE,gBAAA;AHg2uBF;;AG91uBA;EACE,gBAAA;AHi2uBF;;AG/1uBA;EACE,gBAAA;AHk2uBF;;AGh2uBA;EACE,gBAAA;AHm2uBF;;AGj2uBA;EACE,gBAAA;AHo2uBF;;AGl2uBA;EACE,gBAAA;AHq2uBF;;AGn2uBA;EACE,gBAAA;AHs2uBF;;AGp2uBA;EACE,gBAAA;AHu2uBF;;AGr2uBA;EACE,gBAAA;AHw2uBF;;AGt2uBA;EACE,gBAAA;AHy2uBF;;AGv2uBA;EACE,gBAAA;AH02uBF;;AGx2uBA;EACE,gBAAA;AH22uBF;;AGz2uBA;EACE,gBAAA;AH42uBF;;AG12uBA;EACE,gBAAA;AH62uBF;;AG32uBA;EACE,gBAAA;AH82uBF;;AG52uBA;EACE,gBAAA;AH+2uBF;;AG72uBA;EACE,gBAAA;AHg3uBF;;AG92uBA;EACE,gBAAA;AHi3uBF;;AG/2uBA;EACE,gBAAA;AHk3uBF;;AGh3uBA;EACE,gBAAA;AHm3uBF;;AGj3uBA;EACE,gBAAA;AHo3uBF;;AGl3uBA;EACE,gBAAA;AHq3uBF;;AGn3uBA;EACE,gBAAA;AHs3uBF;;AGp3uBA;EACE,gBAAA;AHu3uBF;;AGr3uBA;EACE,gBAAA;AHw3uBF;;AGt3uBA;EACE,gBAAA;AHy3uBF;;AGv3uBA;EACE,gBAAA;AH03uBF;;AGx3uBA;EACE,gBAAA;AH23uBF;;AGz3uBA;EACE,gBAAA;AH43uBF;;AG13uBA;EACE,gBAAA;AH63uBF;;AG33uBA;EACE,gBAAA;AH83uBF;;AG53uBA;EACE,gBAAA;AH+3uBF;;AG73uBA;EACE,gBAAA;AHg4uBF;;AG93uBA;EACE,gBAAA;AHi4uBF;;AG/3uBA;EACE,gBAAA;AHk4uBF;;AGh4uBA;EACE,gBAAA;AHm4uBF;;AGj4uBA;EACE,gBAAA;AHo4uBF;;AGl4uBA;EACE,gBAAA;AHq4uBF;;AGn4uBA;EACE,gBAAA;AHs4uBF;;AGp4uBA;EACE,gBAAA;AHu4uBF;;AGr4uBA;EACE,gBAAA;AHw4uBF;;AGt4uBA;EACE,gBAAA;AHy4uBF;;AGv4uBA;EACE,gBAAA;AH04uBF;;AGx4uBA;EACE,gBAAA;AH24uBF;;AGz4uBA;EACE,gBAAA;AH44uBF;;AG14uBA;EACE,gBAAA;AH64uBF;;AG34uBA;EACE,gBAAA;AH84uBF;;AG54uBA;EACE,gBAAA;AH+4uBF;;AG74uBA;EACE,gBAAA;AHg5uBF;;AG94uBA;EACE,gBAAA;AHi5uBF;;AG/4uBA;EACE,gBAAA;AHk5uBF;;AGh5uBA;EACE,gBAAA;AHm5uBF;;AGj5uBA;EACE,gBAAA;AHo5uBF;;AGl5uBA;EACE,gBAAA;AHq5uBF;;AGn5uBA;EACE,gBAAA;AHs5uBF;;AGp5uBA;EACE,gBAAA;AHu5uBF;;AGr5uBA;EACE,gBAAA;AHw5uBF;;AGt5uBA;EACE,gBAAA;AHy5uBF;;AGv5uBA;EACE,gBAAA;AH05uBF;;AGx5uBA;EACE,gBAAA;AH25uBF;;AGz5uBA;EACE,gBAAA;AH45uBF;;AG15uBA;EACE,gBAAA;AH65uBF;;AG35uBA;EACE,gBAAA;AH85uBF;;AG55uBA;EACE,gBAAA;AH+5uBF;;AG75uBA;EACE,gBAAA;AHg6uBF;;AG95uBA;EACE,gBAAA;AHi6uBF;;AG/5uBA;EACE,gBAAA;AHk6uBF;;AGh6uBA;EACE,gBAAA;AHm6uBF;;AGj6uBA;EACE,gBAAA;AHo6uBF;;AGl6uBA;EACE,gBAAA;AHq6uBF;;AGn6uBA;EACE,gBAAA;AHs6uBF;;AGp6uBA;EACE,gBAAA;AHu6uBF;;AGr6uBA;EACE,gBAAA;AHw6uBF;;AGt6uBA;EACE,gBAAA;AHy6uBF;;AGv6uBA;EACE,gBAAA;AH06uBF;;AGx6uBA;EACE,gBAAA;AH26uBF;;AGz6uBA;EACE,gBAAA;AH46uBF;;AG16uBA;EACE,gBAAA;AH66uBF;;AG36uBA;EACE,gBAAA;AH86uBF;;AG56uBA;EACE,gBAAA;AH+6uBF;;AG76uBA;EACE,gBAAA;AHg7uBF;;AG96uBA;EACE,gBAAA;AHi7uBF;;AG/6uBA;EACE,gBAAA;AHk7uBF;;AGh7uBA;EACE,gBAAA;AHm7uBF;;AGj7uBA;EACE,gBAAA;AHo7uBF;;AGl7uBA;EACE,gBAAA;AHq7uBF;;AGn7uBA;EACE,gBAAA;AHs7uBF;;AGp7uBA;EACE,gBAAA;AHu7uBF;;AGr7uBA;EACE,gBAAA;AHw7uBF;;AGt7uBA;EACE,gBAAA;AHy7uBF;;AGv7uBA;EACE,gBAAA;AH07uBF;;AGx7uBA;EACE,gBAAA;AH27uBF;;AGz7uBA;EACE,gBAAA;AH47uBF;;AG17uBA;EACE,gBAAA;AH67uBF;;AG37uBA;EACE,gBAAA;AH87uBF;;AG57uBA;EACE,gBAAA;AH+7uBF;;AG77uBA;EACE,gBAAA;AHg8uBF;;AG97uBA;EACE,gBAAA;AHi8uBF;;AG/7uBA;EACE,gBAAA;AHk8uBF;;AGh8uBA;EACE,gBAAA;AHm8uBF;;AGj8uBA;EACE,gBAAA;AHo8uBF;;AGl8uBA;EACE,gBAAA;AHq8uBF;;AGn8uBA;EACE,gBAAA;AHs8uBF;;AGp8uBA;EACE,gBAAA;AHu8uBF;;AGr8uBA;EACE,gBAAA;AHw8uBF;;AGt8uBA;EACE,gBAAA;AHy8uBF;;AGv8uBA;EACE,gBAAA;AH08uBF;;AGx8uBA;EACE,gBAAA;AH28uBF;;AGz8uBA;EACE,gBAAA;AH48uBF;;AG18uBA;EACE,gBAAA;AH68uBF;;AG38uBA;EACE,gBAAA;AH88uBF;;AG58uBA;EACE,gBAAA;AH+8uBF;;AG78uBA;EACE,gBAAA;AHg9uBF;;AG98uBA;EACE,gBAAA;AHi9uBF;;AG/8uBA;EACE,gBAAA;AHk9uBF;;AGh9uBA;EACE,gBAAA;AHm9uBF;;AGj9uBA;EACE,gBAAA;AHo9uBF;;AGl9uBA;EACE,gBAAA;AHq9uBF;;AGn9uBA;EACE,gBAAA;AHs9uBF;;AGp9uBA;EACE,gBAAA;AHu9uBF;;AGr9uBA;EACE,gBAAA;AHw9uBF;;AGt9uBA;EACE,gBAAA;AHy9uBF;;AGv9uBA;EACE,gBAAA;AH09uBF;;AGx9uBA;EACE,gBAAA;AH29uBF;;AGz9uBA;EACE,gBAAA;AH49uBF;;AG19uBA;EACE,gBAAA;AH69uBF;;AG39uBA;EACE,gBAAA;AH89uBF;;AG59uBA;EACE,gBAAA;AH+9uBF;;AG79uBA;EACE,gBAAA;AHg+uBF;;AG99uBA;EACE,gBAAA;AHi+uBF;;AG/9uBA;EACE,gBAAA;AHk+uBF;;AGh+uBA;EACE,gBAAA;AHm+uBF;;AGj+uBA;EACE,gBAAA;AHo+uBF;;AGl+uBA;EACE,gBAAA;AHq+uBF;;AGn+uBA;EACE,gBAAA;AHs+uBF;;AGp+uBA;EACE,gBAAA;AHu+uBF;;AGr+uBA;EACE,gBAAA;AHw+uBF;;AGt+uBA;EACE,gBAAA;AHy+uBF;;AGv+uBA;EACE,gBAAA;AH0+uBF;;AGx+uBA;EACE,gBAAA;AH2+uBF;;AGz+uBA;EACE,gBAAA;AH4+uBF;;AG1+uBA;EACE,gBAAA;AH6+uBF;;AG3+uBA;EACE,gBAAA;AH8+uBF;;AG5+uBA;EACE,gBAAA;AH++uBF;;AG7+uBA;EACE,gBAAA;AHg/uBF;;AG9+uBA;EACE,gBAAA;AHi/uBF;;AG/+uBA;EACE,gBAAA;AHk/uBF;;AGh/uBA;EACE,gBAAA;AHm/uBF;;AGj/uBA;EACE,gBAAA;AHo/uBF;;AGl/uBA;EACE,gBAAA;AHq/uBF;;AGn/uBA;EACE,gBAAA;AHs/uBF;;AGp/uBA;EACE,gBAAA;AHu/uBF;;AGr/uBA;EACE,gBAAA;AHw/uBF;;AGt/uBA;EACE,gBAAA;AHy/uBF;;AGv/uBA;EACE,gBAAA;AH0/uBF;;AGx/uBA;EACE,gBAAA;AH2/uBF;;AGz/uBA;EACE,gBAAA;AH4/uBF;;AG1/uBA;EACE,gBAAA;AH6/uBF;;AG3/uBA;EACE,gBAAA;AH8/uBF;;AG5/uBA;EACE,gBAAA;AH+/uBF;;AG7/uBA;EACE,gBAAA;AHggvBF;;AG9/uBA;EACE,gBAAA;AHigvBF;;AG//uBA;EACE,gBAAA;AHkgvBF;;AGhgvBA;EACE,gBAAA;AHmgvBF;;AGjgvBA;EACE,gBAAA;AHogvBF;;AGlgvBA;EACE,gBAAA;AHqgvBF;;AGngvBA;EACE,gBAAA;AHsgvBF;;AGpgvBA;EACE,gBAAA;AHugvBF;;AGrgvBA;EACE,gBAAA;AHwgvBF;;AGtgvBA;EACE,gBAAA;AHygvBF;;AGvgvBA;EACE,gBAAA;AH0gvBF;;AGxgvBA;EACE,gBAAA;AH2gvBF;;AGzgvBA;EACE,gBAAA;AH4gvBF;;AG1gvBA;EACE,gBAAA;AH6gvBF;;AG3gvBA;EACE,gBAAA;AH8gvBF;;AG5gvBA;EACE,gBAAA;AH+gvBF;;AG7gvBA;EACE,gBAAA;AHghvBF;;AG9gvBA;EACE,gBAAA;AHihvBF;;AG/gvBA;EACE,gBAAA;AHkhvBF;;AGhhvBA;EACE,gBAAA;AHmhvBF;;AGjhvBA;EACE,gBAAA;AHohvBF;;AGlhvBA;EACE,gBAAA;AHqhvBF;;AGnhvBA;EACE,gBAAA;AHshvBF;;AGphvBA;EACE,gBAAA;AHuhvBF;;AGrhvBA;EACE,gBAAA;AHwhvBF;;AGthvBA;EACE,gBAAA;AHyhvBF;;AGvhvBA;EACE,gBAAA;AH0hvBF;;AGxhvBA;EACE,gBAAA;AH2hvBF;;AGzhvBA;EACE,gBAAA;AH4hvBF;;AG1hvBA;EACE,gBAAA;AH6hvBF;;AG3hvBA;EACE,gBAAA;AH8hvBF;;AG5hvBA;EACE,gBAAA;AH+hvBF;;AG7hvBA;EACE,gBAAA;AHgivBF;;AG9hvBA;EACE,gBAAA;AHiivBF;;AG/hvBA;EACE,gBAAA;AHkivBF;;AGhivBA;EACE,gBAAA;AHmivBF;;AGjivBA;EACE,gBAAA;AHoivBF;;AGlivBA;EACE,gBAAA;AHqivBF;;AGnivBA;EACE,gBAAA;AHsivBF;;AGpivBA;EACE,gBAAA;AHuivBF;;AGrivBA;EACE,gBAAA;AHwivBF;;AGtivBA;EACE,gBAAA;AHyivBF;;AGvivBA;EACE,gBAAA;AH0ivBF;;AGxivBA;EACE,gBAAA;AH2ivBF;;AGzivBA;EACE,gBAAA;AH4ivBF;;AG1ivBA;EACE,gBAAA;AH6ivBF;;AG3ivBA;EACE,gBAAA;AH8ivBF;;AG5ivBA;EACE,gBAAA;AH+ivBF;;AG7ivBA;EACE,gBAAA;AHgjvBF;;AG9ivBA;EACE,gBAAA;AHijvBF;;AG/ivBA;EACE,gBAAA;AHkjvBF;;AGhjvBA;EACE,gBAAA;AHmjvBF;;AGjjvBA;EACE,gBAAA;AHojvBF;;AGljvBA;EACE,gBAAA;AHqjvBF;;AGnjvBA;EACE,gBAAA;AHsjvBF;;AGpjvBA;EACE,gBAAA;AHujvBF;;AGrjvBA;EACE,gBAAA;AHwjvBF;;AGtjvBA;EACE,gBAAA;AHyjvBF;;AGvjvBA;EACE,gBAAA;AH0jvBF;;AGxjvBA;EACE,gBAAA;AH2jvBF;;AGzjvBA;EACE,gBAAA;AH4jvBF;;AG1jvBA;EACE,gBAAA;AH6jvBF;;AG3jvBA;EACE,gBAAA;AH8jvBF;;AG5jvBA;EACE,gBAAA;AH+jvBF;;AG7jvBA;EACE,gBAAA;AHgkvBF;;AG9jvBA;EACE,gBAAA;AHikvBF;;AG/jvBA;EACE,gBAAA;AHkkvBF;;AGhkvBA;EACE,gBAAA;AHmkvBF;;AGjkvBA;EACE,gBAAA;AHokvBF;;AGlkvBA;EACE,gBAAA;AHqkvBF;;AGnkvBA;EACE,gBAAA;AHskvBF;;AGpkvBA;EACE,gBAAA;AHukvBF;;AGrkvBA;EACE,gBAAA;AHwkvBF;;AGtkvBA;EACE,gBAAA;AHykvBF;;AGvkvBA;EACE,gBAAA;AH0kvBF;;AGxkvBA;EACE,gBAAA;AH2kvBF;;AGzkvBA;EACE,gBAAA;AH4kvBF;;AG1kvBA;EACE,gBAAA;AH6kvBF;;AG3kvBA;EACE,gBAAA;AH8kvBF;;AG5kvBA;EACE,gBAAA;AH+kvBF;;AG7kvBA;EACE,gBAAA;AHglvBF;;AG9kvBA;EACE,gBAAA;AHilvBF;;AG/kvBA;EACE,gBAAA;AHklvBF;;AGhlvBA;EACE,gBAAA;AHmlvBF;;AGjlvBA;EACE,gBAAA;AHolvBF;;AGllvBA;EACE,gBAAA;AHqlvBF;;AGnlvBA;EACE,gBAAA;AHslvBF;;AGplvBA;EACE,gBAAA;AHulvBF;;AGrlvBA;EACE,gBAAA;AHwlvBF;;AGtlvBA;EACE,gBAAA;AHylvBF;;AGvlvBA;EACE,gBAAA;AH0lvBF;;AGxlvBA;EACE,gBAAA;AH2lvBF;;AGzlvBA;EACE,gBAAA;AH4lvBF;;AG1lvBA;EACE,gBAAA;AH6lvBF;;AG3lvBA;EACE,gBAAA;AH8lvBF;;AG5lvBA;EACE,gBAAA;AH+lvBF;;AG7lvBA;EACE,gBAAA;AHgmvBF;;AG9lvBA;EACE,gBAAA;AHimvBF;;AG/lvBA;EACE,gBAAA;AHkmvBF;;AGhmvBA;EACE,gBAAA;AHmmvBF;;AGjmvBA;EACE,gBAAA;AHomvBF;;AGlmvBA;EACE,gBAAA;AHqmvBF;;AGnmvBA;EACE,gBAAA;AHsmvBF;;AGpmvBA;EACE,gBAAA;AHumvBF;;AGrmvBA;EACE,gBAAA;AHwmvBF;;AGtmvBA;EACE,gBAAA;AHymvBF;;AGvmvBA;EACE,gBAAA;AH0mvBF;;AGxmvBA;EACE,gBAAA;AH2mvBF;;AGzmvBA;EACE,gBAAA;AH4mvBF;;AG1mvBA;EACE,gBAAA;AH6mvBF;;AG3mvBA;EACE,gBAAA;AH8mvBF;;AG5mvBA;EACE,gBAAA;AH+mvBF;;AG7mvBA;EACE,gBAAA;AHgnvBF;;AG9mvBA;EACE,gBAAA;AHinvBF;;AG/mvBA;EACE,gBAAA;AHknvBF;;AGhnvBA;EACE,gBAAA;AHmnvBF;;AGjnvBA;EACE,gBAAA;AHonvBF;;AGlnvBA;EACE,gBAAA;AHqnvBF;;AGnnvBA;EACE,gBAAA;AHsnvBF;;AGpnvBA;EACE,gBAAA;AHunvBF;;AGrnvBA;EACE,gBAAA;AHwnvBF;;AGtnvBA;EACE,gBAAA;AHynvBF;;AGvnvBA;EACE,gBAAA;AH0nvBF;;AGxnvBA;EACE,gBAAA;AH2nvBF;;AGznvBA;EACE,gBAAA;AH4nvBF;;AG1nvBA;EACE,gBAAA;AH6nvBF;;AG3nvBA;EACE,gBAAA;AH8nvBF;;AG5nvBA;EACE,gBAAA;AH+nvBF;;AG7nvBA;EACE,gBAAA;AHgovBF;;AG9nvBA;EACE,gBAAA;AHiovBF;;AG/nvBA;EACE,gBAAA;AHkovBF;;AGhovBA;EACE,gBAAA;AHmovBF;;AGjovBA;EACE,gBAAA;AHoovBF;;AGlovBA;EACE,gBAAA;AHqovBF;;AGnovBA;EACE,gBAAA;AHsovBF;;AGpovBA;EACE,gBAAA;AHuovBF;;AGrovBA;EACE,gBAAA;AHwovBF;;AGtovBA;EACE,gBAAA;AHyovBF;;AGvovBA;EACE,gBAAA;AH0ovBF;;AGxovBA;EACE,gBAAA;AH2ovBF;;AGzovBA;EACE,gBAAA;AH4ovBF;;AG1ovBA;EACE,gBAAA;AH6ovBF;;AG3ovBA;EACE,gBAAA;AH8ovBF;;AG5ovBA;EACE,gBAAA;AH+ovBF;;AG7ovBA;EACE,gBAAA;AHgpvBF;;AG9ovBA;EACE,gBAAA;AHipvBF;;AG/ovBA;EACE,gBAAA;AHkpvBF;;AGhpvBA;EACE,gBAAA;AHmpvBF;;AGjpvBA;EACE,gBAAA;AHopvBF;;AGlpvBA;EACE,gBAAA;AHqpvBF;;AGnpvBA;EACE,gBAAA;AHspvBF;;AGppvBA;EACE,gBAAA;AHupvBF;;AGrpvBA;EACE,gBAAA;AHwpvBF;;AGtpvBA;EACE,gBAAA;AHypvBF;;AGvpvBA;EACE,gBAAA;AH0pvBF;;AGxpvBA;EACE,gBAAA;AH2pvBF;;AGzpvBA;EACE,gBAAA;AH4pvBF;;AG1pvBA;EACE,gBAAA;AH6pvBF;;AG3pvBA;EACE,gBAAA;AH8pvBF;;AG5pvBA;EACE,gBAAA;AH+pvBF;;AG7pvBA;EACE,gBAAA;AHgqvBF;;AG9pvBA;EACE,gBAAA;AHiqvBF;;AG/pvBA;EACE,gBAAA;AHkqvBF;;AGhqvBA;EACE,gBAAA;AHmqvBF;;AGjqvBA;EACE,gBAAA;AHoqvBF;;AGlqvBA;EACE,gBAAA;AHqqvBF;;AGnqvBA;EACE,gBAAA;AHsqvBF;;AGpqvBA;EACE,gBAAA;AHuqvBF;;AGrqvBA;EACE,gBAAA;AHwqvBF;;AGtqvBA;EACE,gBAAA;AHyqvBF;;AGvqvBA;EACE,gBAAA;AH0qvBF;;AGxqvBA;EACE,gBAAA;AH2qvBF;;AGzqvBA;EACE,gBAAA;AH4qvBF;;AG1qvBA;EACE,gBAAA;AH6qvBF;;AG3qvBA;EACE,gBAAA;AH8qvBF;;AG5qvBA;EACE,gBAAA;AH+qvBF;;AG7qvBA;EACE,gBAAA;AHgrvBF;;AG9qvBA;EACE,gBAAA;AHirvBF;;AG/qvBA;EACE,gBAAA;AHkrvBF;;AGhrvBA;EACE,gBAAA;AHmrvBF;;AGjrvBA;EACE,gBAAA;AHorvBF;;AGlrvBA;EACE,gBAAA;AHqrvBF;;AGnrvBA;EACE,gBAAA;AHsrvBF;;AGprvBA;EACE,gBAAA;AHurvBF;;AGrrvBA;EACE,gBAAA;AHwrvBF;;AGtrvBA;EACE,gBAAA;AHyrvBF;;AGvrvBA;EACE,gBAAA;AH0rvBF;;AGxrvBA;EACE,gBAAA;AH2rvBF;;AGzrvBA;EACE,gBAAA;AH4rvBF;;AG1rvBA;EACE,gBAAA;AH6rvBF;;AG3rvBA;EACE,gBAAA;AH8rvBF;;AG5rvBA;EACE,gBAAA;AH+rvBF;;AG7rvBA;EACE,gBAAA;AHgsvBF;;AG9rvBA;EACE,gBAAA;AHisvBF;;AG/rvBA;EACE,gBAAA;AHksvBF;;AGhsvBA;EACE,gBAAA;AHmsvBF;;AGjsvBA;EACE,gBAAA;AHosvBF;;AGlsvBA;EACE,gBAAA;AHqsvBF;;AGnsvBA;EACE,gBAAA;AHssvBF;;AGpsvBA;EACE,gBAAA;AHusvBF;;AGrsvBA;EACE,gBAAA;AHwsvBF;;AGtsvBA;EACE,gBAAA;AHysvBF;;AGvsvBA;EACE,gBAAA;AH0svBF;;AGxsvBA;EACE,gBAAA;AH2svBF;;AGzsvBA;EACE,gBAAA;AH4svBF;;AG1svBA;EACE,gBAAA;AH6svBF;;AG3svBA;EACE,gBAAA;AH8svBF;;AG5svBA;EACE,gBAAA;AH+svBF;;AG7svBA;EACE,gBAAA;AHgtvBF;;AG9svBA;EACE,gBAAA;AHitvBF;;AG/svBA;EACE,gBAAA;AHktvBF;;AGhtvBA;EACE,gBAAA;AHmtvBF;;AGjtvBA;EACE,gBAAA;AHotvBF;;AGltvBA;EACE,gBAAA;AHqtvBF;;AGntvBA;EACE,gBAAA;AHstvBF;;AGptvBA;EACE,gBAAA;AHutvBF;;AGrtvBA;EACE,gBAAA;AHwtvBF;;AGttvBA;EACE,gBAAA;AHytvBF;;AGvtvBA;EACE,gBAAA;AH0tvBF;;AGxtvBA;EACE,gBAAA;AH2tvBF;;AGztvBA;EACE,gBAAA;AH4tvBF;;AG1tvBA;EACE,gBAAA;AH6tvBF;;AG3tvBA;EACE,gBAAA;AH8tvBF;;AG5tvBA;EACE,gBAAA;AH+tvBF;;AG7tvBA;EACE,gBAAA;AHguvBF;;AG9tvBA;EACE,gBAAA;AHiuvBF;;AG/tvBA;EACE,gBAAA;AHkuvBF;;AGhuvBA;EACE,gBAAA;AHmuvBF;;AGjuvBA;EACE,gBAAA;AHouvBF;;AGluvBA;EACE,gBAAA;AHquvBF;;AGnuvBA;EACE,gBAAA;AHsuvBF;;AGpuvBA;EACE,gBAAA;AHuuvBF;;AGruvBA;EACE,gBAAA;AHwuvBF;;AGtuvBA;EACE,gBAAA;AHyuvBF;;AGvuvBA;EACE,gBAAA;AH0uvBF;;AGxuvBA;EACE,gBAAA;AH2uvBF;;AGzuvBA;EACE,gBAAA;AH4uvBF;;AG1uvBA;EACE,gBAAA;AH6uvBF;;AG3uvBA;EACE,gBAAA;AH8uvBF;;AG5uvBA;EACE,gBAAA;AH+uvBF;;AG7uvBA;EACE,gBAAA;AHgvvBF;;AG9uvBA;EACE,gBAAA;AHivvBF;;AG/uvBA;EACE,gBAAA;AHkvvBF;;AGhvvBA;EACE,gBAAA;AHmvvBF;;AGjvvBA;EACE,gBAAA;AHovvBF;;AGlvvBA;EACE,gBAAA;AHqvvBF;;AGnvvBA;EACE,gBAAA;AHsvvBF;;AGpvvBA;EACE,gBAAA;AHuvvBF;;AGrvvBA;EACE,gBAAA;AHwvvBF;;AGtvvBA;EACE,gBAAA;AHyvvBF;;AGvvvBA;EACE,gBAAA;AH0vvBF;;AGxvvBA;EACE,gBAAA;AH2vvBF;;AGzvvBA;EACE,gBAAA;AH4vvBF;;AG1vvBA;EACE,gBAAA;AH6vvBF;;AG3vvBA;EACE,gBAAA;AH8vvBF;;AG5vvBA;EACE,gBAAA;AH+vvBF;;AG7vvBA;EACE,gBAAA;AHgwvBF;;AG9vvBA;EACE,gBAAA;AHiwvBF;;AG/vvBA;EACE,gBAAA;AHkwvBF;;AGhwvBA;EACE,gBAAA;AHmwvBF;;AGjwvBA;EACE,gBAAA;AHowvBF;;AGlwvBA;EACE,gBAAA;AHqwvBF;;AGnwvBA;EACE,gBAAA;AHswvBF;;AGpwvBA;EACE,gBAAA;AHuwvBF;;AGrwvBA;EACE,gBAAA;AHwwvBF;;AGtwvBA;EACE,gBAAA;AHywvBF;;AGvwvBA;EACE,gBAAA;AH0wvBF;;AGxwvBA;EACE,gBAAA;AH2wvBF;;AGzwvBA;EACE,gBAAA;AH4wvBF;;AG1wvBA;EACE,gBAAA;AH6wvBF;;AG3wvBA;EACE,gBAAA;AH8wvBF;;AG5wvBA;EACE,gBAAA;AH+wvBF;;AG7wvBA;EACE,gBAAA;AHgxvBF;;AG9wvBA;EACE,gBAAA;AHixvBF;;AG/wvBA;EACE,gBAAA;AHkxvBF;;AGhxvBA;EACE,gBAAA;AHmxvBF;;AGjxvBA;EACE,gBAAA;AHoxvBF;;AGlxvBA;EACE,gBAAA;AHqxvBF;;AGnxvBA;EACE,gBAAA;AHsxvBF;;AGpxvBA;EACE,gBAAA;AHuxvBF;;AGrxvBA;EACE,gBAAA;AHwxvBF;;AGtxvBA;EACE,gBAAA;AHyxvBF;;AGvxvBA;EACE,gBAAA;AH0xvBF;;AGxxvBA;EACE,gBAAA;AH2xvBF;;AGzxvBA;EACE,gBAAA;AH4xvBF;;AG1xvBA;EACE,gBAAA;AH6xvBF;;AG3xvBA;EACE,gBAAA;AH8xvBF;;AG5xvBA;EACE,gBAAA;AH+xvBF;;AG7xvBA;EACE,gBAAA;AHgyvBF;;AG9xvBA;EACE,gBAAA;AHiyvBF;;AG/xvBA;EACE,gBAAA;AHkyvBF;;AGhyvBA;EACE,gBAAA;AHmyvBF;;AGjyvBA;EACE,gBAAA;AHoyvBF;;AGlyvBA;EACE,gBAAA;AHqyvBF;;AGnyvBA;EACE,gBAAA;AHsyvBF;;AGpyvBA;EACE,gBAAA;AHuyvBF;;AGryvBA;EACE,gBAAA;AHwyvBF;;AGtyvBA;EACE,gBAAA;AHyyvBF;;AGvyvBA;EACE,gBAAA;AH0yvBF;;AGxyvBA;EACE,gBAAA;AH2yvBF;;AGzyvBA;EACE,gBAAA;AH4yvBF;;AG1yvBA;EACE,gBAAA;AH6yvBF;;AG3yvBA;EACE,gBAAA;AH8yvBF;;AG5yvBA;EACE,gBAAA;AH+yvBF;;AG7yvBA;EACE,gBAAA;AHgzvBF;;AG9yvBA;EACE,gBAAA;AHizvBF;;AG/yvBA;EACE,gBAAA;AHkzvBF;;AGhzvBA;EACE,gBAAA;AHmzvBF;;AGjzvBA;EACE,gBAAA;AHozvBF;;AGlzvBA;EACE,gBAAA;AHqzvBF;;AGnzvBA;EACE,gBAAA;AHszvBF;;AGpzvBA;EACE,gBAAA;AHuzvBF;;AGrzvBA;EACE,gBAAA;AHwzvBF;;AGtzvBA;EACE,gBAAA;AHyzvBF;;AGvzvBA;EACE,gBAAA;AH0zvBF;;AGxzvBA;EACE,gBAAA;AH2zvBF;;AGzzvBA;EACE,gBAAA;AH4zvBF;;AG1zvBA;EACE,gBAAA;AH6zvBF;;AG3zvBA;EACE,gBAAA;AH8zvBF;;AG5zvBA;EACE,gBAAA;AH+zvBF;;AG7zvBA;EACE,gBAAA;AHg0vBF;;AG9zvBA;EACE,gBAAA;AHi0vBF;;AG/zvBA;EACE,gBAAA;AHk0vBF;;AGh0vBA;EACE,gBAAA;AHm0vBF;;AGj0vBA;EACE,gBAAA;AHo0vBF;;AGl0vBA;EACE,gBAAA;AHq0vBF;;AGn0vBA;EACE,gBAAA;AHs0vBF;;AGp0vBA;EACE,gBAAA;AHu0vBF;;AGr0vBA;EACE,gBAAA;AHw0vBF;;AGt0vBA;EACE,gBAAA;AHy0vBF;;AGv0vBA;EACE,gBAAA;AH00vBF;;AGx0vBA;EACE,gBAAA;AH20vBF;;AGz0vBA;EACE,gBAAA;AH40vBF;;AG10vBA;EACE,gBAAA;AH60vBF;;AG30vBA;EACE,gBAAA;AH80vBF;;AG50vBA;EACE,gBAAA;AH+0vBF;;AG70vBA;EACE,gBAAA;AHg1vBF;;AG90vBA;EACE,gBAAA;AHi1vBF;;AG/0vBA;EACE,gBAAA;AHk1vBF;;AGh1vBA;EACE,gBAAA;AHm1vBF;;AGj1vBA;EACE,gBAAA;AHo1vBF;;AGl1vBA;EACE,gBAAA;AHq1vBF;;AGn1vBA;EACE,gBAAA;AHs1vBF;;AGp1vBA;EACE,gBAAA;AHu1vBF;;AGr1vBA;EACE,gBAAA;AHw1vBF;;AGt1vBA;EACE,gBAAA;AHy1vBF;;AGv1vBA;EACE,gBAAA;AH01vBF;;AGx1vBA;EACE,gBAAA;AH21vBF;;AGz1vBA;EACE,gBAAA;AH41vBF;;AG11vBA;EACE,gBAAA;AH61vBF;;AG31vBA;EACE,gBAAA;AH81vBF;;AG51vBA;EACE,gBAAA;AH+1vBF;;AG71vBA;EACE,gBAAA;AHg2vBF;;AG91vBA;EACE,gBAAA;AHi2vBF;;AG/1vBA;EACE,gBAAA;AHk2vBF;;AGh2vBA;EACE,gBAAA;AHm2vBF;;AGj2vBA;EACE,gBAAA;AHo2vBF;;AGl2vBA;EACE,gBAAA;AHq2vBF;;AGn2vBA;EACE,gBAAA;AHs2vBF;;AGp2vBA;EACE,gBAAA;AHu2vBF;;AGr2vBA;EACE,gBAAA;AHw2vBF;;AGt2vBA;EACE,gBAAA;AHy2vBF;;AGv2vBA;EACE,gBAAA;AH02vBF;;AGx2vBA;EACE,gBAAA;AH22vBF;;AGz2vBA;EACE,gBAAA;AH42vBF;;AG12vBA;EACE,gBAAA;AH62vBF;;AG32vBA;EACE,gBAAA;AH82vBF;;AG52vBA;EACE,gBAAA;AH+2vBF;;AG72vBA;EACE,gBAAA;AHg3vBF;;AG92vBA;EACE,gBAAA;AHi3vBF;;AG/2vBA;EACE,gBAAA;AHk3vBF;;AGh3vBA;EACE,gBAAA;AHm3vBF;;AGj3vBA;EACE,gBAAA;AHo3vBF;;AGl3vBA;EACE,gBAAA;AHq3vBF;;AGn3vBA;EACE,gBAAA;AHs3vBF;;AGp3vBA;EACE,gBAAA;AHu3vBF;;AGr3vBA;EACE,gBAAA;AHw3vBF;;AGt3vBA;EACE,gBAAA;AHy3vBF;;AGv3vBA;EACE,gBAAA;AH03vBF;;AGx3vBA;EACE,gBAAA;AH23vBF;;AGz3vBA;EACE,gBAAA;AH43vBF;;AG13vBA;EACE,gBAAA;AH63vBF;;AG33vBA;EACE,gBAAA;AH83vBF;;AG53vBA;EACE,gBAAA;AH+3vBF;;AG73vBA;EACE,gBAAA;AHg4vBF;;AG93vBA;EACE,gBAAA;AHi4vBF;;AG/3vBA;EACE,gBAAA;AHk4vBF;;AGh4vBA;EACE,gBAAA;AHm4vBF;;AGj4vBA;EACE,gBAAA;AHo4vBF;;AGl4vBA;EACE,gBAAA;AHq4vBF;;AGn4vBA;EACE,gBAAA;AHs4vBF;;AGp4vBA;EACE,gBAAA;AHu4vBF;;AGr4vBA;EACE,gBAAA;AHw4vBF;;AGt4vBA;EACE,gBAAA;AHy4vBF;;AGv4vBA;EACE,gBAAA;AH04vBF;;AGx4vBA;EACE,gBAAA;AH24vBF;;AGz4vBA;EACE,gBAAA;AH44vBF;;AG14vBA;EACE,gBAAA;AH64vBF;;AG34vBA;EACE,gBAAA;AH84vBF;;AG54vBA;EACE,gBAAA;AH+4vBF;;AG74vBA;EACE,gBAAA;AHg5vBF;;AG94vBA;EACE,gBAAA;AHi5vBF;;AG/4vBA;EACE,gBAAA;AHk5vBF;;AGh5vBA;EACE,gBAAA;AHm5vBF;;AGj5vBA;EACE,gBAAA;AHo5vBF;;AGl5vBA;EACE,gBAAA;AHq5vBF;;AGn5vBA;EACE,gBAAA;AHs5vBF;;AGp5vBA;EACE,gBAAA;AHu5vBF;;AGr5vBA;EACE,gBAAA;AHw5vBF;;AGt5vBA;EACE,gBAAA;AHy5vBF;;AGv5vBA;EACE,gBAAA;AH05vBF;;AGx5vBA;EACE,gBAAA;AH25vBF;;AGz5vBA;EACE,gBAAA;AH45vBF;;AG15vBA;EACE,gBAAA;AH65vBF;;AG35vBA;EACE,gBAAA;AH85vBF;;AG55vBA;EACE,gBAAA;AH+5vBF;;AG75vBA;EACE,gBAAA;AHg6vBF;;AG95vBA;EACE,gBAAA;AHi6vBF;;AG/5vBA;EACE,gBAAA;AHk6vBF;;AGh6vBA;EACE,gBAAA;AHm6vBF;;AGj6vBA;EACE,gBAAA;AHo6vBF;;AGl6vBA;EACE,gBAAA;AHq6vBF;;AGn6vBA;EACE,gBAAA;AHs6vBF;;AGp6vBA;EACE,gBAAA;AHu6vBF;;AGr6vBA;EACE,gBAAA;AHw6vBF;;AGt6vBA;EACE,gBAAA;AHy6vBF;;AGv6vBA;EACE,gBAAA;AH06vBF;;AGx6vBA;EACE,gBAAA;AH26vBF;;AGz6vBA;EACE,gBAAA;AH46vBF;;AG16vBA;EACE,gBAAA;AH66vBF;;AG36vBA;EACE,gBAAA;AH86vBF;;AG56vBA;EACE,gBAAA;AH+6vBF;;AG76vBA;EACE,gBAAA;AHg7vBF;;AG96vBA;EACE,gBAAA;AHi7vBF;;AG/6vBA;EACE,gBAAA;AHk7vBF;;AGh7vBA;EACE,gBAAA;AHm7vBF;;AGj7vBA;EACE,gBAAA;AHo7vBF;;AGl7vBA;EACE,gBAAA;AHq7vBF;;AGn7vBA;EACE,gBAAA;AHs7vBF;;AGp7vBA;EACE,gBAAA;AHu7vBF;;AGr7vBA;EACE,gBAAA;AHw7vBF;;AGt7vBA;EACE,gBAAA;AHy7vBF;;AGv7vBA;EACE,gBAAA;AH07vBF;;AGx7vBA;EACE,gBAAA;AH27vBF;;AGz7vBA;EACE,gBAAA;AH47vBF;;AG17vBA;EACE,gBAAA;AH67vBF;;AG37vBA;EACE,gBAAA;AH87vBF;;AG57vBA;EACE,gBAAA;AH+7vBF;;AG77vBA;EACE,gBAAA;AHg8vBF;;AG97vBA;EACE,gBAAA;AHi8vBF;;AG/7vBA;EACE,gBAAA;AHk8vBF;;AGh8vBA;EACE,gBAAA;AHm8vBF;;AGj8vBA;EACE,gBAAA;AHo8vBF;;AGl8vBA;EACE,gBAAA;AHq8vBF;;AGn8vBA;EACE,gBAAA;AHs8vBF;;AGp8vBA;EACE,gBAAA;AHu8vBF;;AGr8vBA;EACE,gBAAA;AHw8vBF;;AGt8vBA;EACE,gBAAA;AHy8vBF;;AGv8vBA;EACE,gBAAA;AH08vBF;;AGx8vBA;EACE,gBAAA;AH28vBF;;AGz8vBA;EACE,gBAAA;AH48vBF;;AG18vBA;EACE,gBAAA;AH68vBF;;AG38vBA;EACE,gBAAA;AH88vBF;;AG58vBA;EACE,gBAAA;AH+8vBF;;AG78vBA;EACE,gBAAA;AHg9vBF;;AG98vBA;EACE,gBAAA;AHi9vBF;;AG/8vBA;EACE,gBAAA;AHk9vBF;;AGh9vBA;EACE,gBAAA;AHm9vBF;;AGj9vBA;EACE,gBAAA;AHo9vBF;;AGl9vBA;EACE,gBAAA;AHq9vBF;;AGn9vBA;EACE,gBAAA;AHs9vBF;;AGp9vBA;EACE,gBAAA;AHu9vBF;;AGr9vBA;EACE,gBAAA;AHw9vBF;;AGt9vBA;EACE,gBAAA;AHy9vBF;;AGv9vBA;EACE,gBAAA;AH09vBF;;AGx9vBA;EACE,gBAAA;AH29vBF;;AGz9vBA;EACE,gBAAA;AH49vBF;;AG19vBA;EACE,gBAAA;AH69vBF;;AG39vBA;EACE,gBAAA;AH89vBF;;AG59vBA;EACE,gBAAA;AH+9vBF;;AG79vBA;EACE,gBAAA;AHg+vBF;;AG99vBA;EACE,gBAAA;AHi+vBF;;AG/9vBA;EACE,gBAAA;AHk+vBF;;AGh+vBA;EACE,gBAAA;AHm+vBF;;AGj+vBA;EACE,gBAAA;AHo+vBF;;AGl+vBA;EACE,gBAAA;AHq+vBF;;AGn+vBA;EACE,gBAAA;AHs+vBF;;AGp+vBA;EACE,gBAAA;AHu+vBF;;AGr+vBA;EACE,gBAAA;AHw+vBF;;AGt+vBA;EACE,gBAAA;AHy+vBF;;AGv+vBA;EACE,gBAAA;AH0+vBF;;AGx+vBA;EACE,gBAAA;AH2+vBF;;AGz+vBA;EACE,gBAAA;AH4+vBF;;AG1+vBA;EACE,gBAAA;AH6+vBF;;AG3+vBA;EACE,gBAAA;AH8+vBF;;AG5+vBA;EACE,gBAAA;AH++vBF;;AG7+vBA;EACE,gBAAA;AHg/vBF;;AG9+vBA;EACE,gBAAA;AHi/vBF;;AG/+vBA;EACE,gBAAA;AHk/vBF;;AGh/vBA;EACE,gBAAA;AHm/vBF;;AGj/vBA;EACE,gBAAA;AHo/vBF;;AGl/vBA;EACE,gBAAA;AHq/vBF;;AGn/vBA;EACE,gBAAA;AHs/vBF;;AGp/vBA;EACE,gBAAA;AHu/vBF;;AGr/vBA;EACE,gBAAA;AHw/vBF;;AGt/vBA;EACE,gBAAA;AHy/vBF;;AGv/vBA;EACE,gBAAA;AH0/vBF;;AGx/vBA;EACE,gBAAA;AH2/vBF;;AGz/vBA;EACE,gBAAA;AH4/vBF;;AG1/vBA;EACE,gBAAA;AH6/vBF;;AG3/vBA;EACE,gBAAA;AH8/vBF;;AG5/vBA;EACE,gBAAA;AH+/vBF;;AG7/vBA;EACE,gBAAA;AHggwBF;;AG9/vBA;EACE,gBAAA;AHigwBF;;AG//vBA;EACE,gBAAA;AHkgwBF;;AGhgwBA;EACE,gBAAA;AHmgwBF;;AGjgwBA;EACE,gBAAA;AHogwBF;;AGlgwBA;EACE,gBAAA;AHqgwBF;;AGngwBA;EACE,gBAAA;AHsgwBF;;AGpgwBA;EACE,gBAAA;AHugwBF;;AGrgwBA;EACE,gBAAA;AHwgwBF;;AGtgwBA;EACE,gBAAA;AHygwBF;;AGvgwBA;EACE,gBAAA;AH0gwBF;;AGxgwBA;EACE,gBAAA;AH2gwBF;;AGzgwBA;EACE,gBAAA;AH4gwBF;;AG1gwBA;EACE,gBAAA;AH6gwBF;;AG3gwBA;EACE,gBAAA;AH8gwBF;;AG5gwBA;EACE,gBAAA;AH+gwBF;;AG7gwBA;EACE,gBAAA;AHghwBF;;AG9gwBA;EACE,gBAAA;AHihwBF;;AG/gwBA;EACE,gBAAA;AHkhwBF;;AGhhwBA;EACE,gBAAA;AHmhwBF;;AGjhwBA;EACE,gBAAA;AHohwBF;;AGlhwBA;EACE,gBAAA;AHqhwBF;;AGnhwBA;EACE,gBAAA;AHshwBF;;AGphwBA;EACE,gBAAA;AHuhwBF;;AGrhwBA;EACE,gBAAA;AHwhwBF;;AGthwBA;EACE,gBAAA;AHyhwBF;;AGvhwBA;EACE,gBAAA;AH0hwBF;;AGxhwBA;EACE,gBAAA;AH2hwBF;;AGzhwBA;EACE,gBAAA;AH4hwBF;;AG1hwBA;EACE,gBAAA;AH6hwBF;;AG3hwBA;EACE,gBAAA;AH8hwBF;;AG5hwBA;EACE,gBAAA;AH+hwBF;;AG7hwBA;EACE,gBAAA;AHgiwBF;;AG9hwBA;EACE,gBAAA;AHiiwBF;;AG/hwBA;EACE,gBAAA;AHkiwBF;;AGhiwBA;EACE,gBAAA;AHmiwBF;;AGjiwBA;EACE,gBAAA;AHoiwBF;;AGliwBA;EACE,gBAAA;AHqiwBF;;AGniwBA;EACE,gBAAA;AHsiwBF;;AGpiwBA;EACE,gBAAA;AHuiwBF;;AGriwBA;EACE,gBAAA;AHwiwBF;;AGtiwBA;EACE,gBAAA;AHyiwBF;;AGviwBA;EACE,gBAAA;AH0iwBF;;AGxiwBA;EACE,gBAAA;AH2iwBF;;AGziwBA;EACE,gBAAA;AH4iwBF;;AG1iwBA;EACE,gBAAA;AH6iwBF;;AG3iwBA;EACE,gBAAA;AH8iwBF;;AG5iwBA;EACE,gBAAA;AH+iwBF;;AG7iwBA;EACE,gBAAA;AHgjwBF;;AG9iwBA;EACE,gBAAA;AHijwBF;;AG/iwBA;EACE,gBAAA;AHkjwBF;;AGhjwBA;EACE,gBAAA;AHmjwBF;;AGjjwBA;EACE,gBAAA;AHojwBF;;AGljwBA;EACE,gBAAA;AHqjwBF;;AGnjwBA;EACE,gBAAA;AHsjwBF;;AGpjwBA;EACE,gBAAA;AHujwBF;;AGrjwBA;EACE,gBAAA;AHwjwBF;;AGtjwBA;EACE,gBAAA;AHyjwBF;;AGvjwBA;EACE,gBAAA;AH0jwBF;;AGxjwBA;EACE,gBAAA;AH2jwBF;;AGzjwBA;EACE,gBAAA;AH4jwBF;;AG1jwBA;EACE,gBAAA;AH6jwBF;;AG3jwBA;EACE,gBAAA;AH8jwBF;;AG5jwBA;EACE,gBAAA;AH+jwBF;;AG7jwBA;EACE,gBAAA;AHgkwBF;;AG9jwBA;EACE,gBAAA;AHikwBF;;AG/jwBA;EACE,gBAAA;AHkkwBF;;AGhkwBA;EACE,gBAAA;AHmkwBF;;AGjkwBA;EACE,gBAAA;AHokwBF;;AGlkwBA;EACE,gBAAA;AHqkwBF;;AGnkwBA;EACE,gBAAA;AHskwBF;;AGpkwBA;EACE,gBAAA;AHukwBF;;AGrkwBA;EACE,gBAAA;AHwkwBF;;AGtkwBA;EACE,gBAAA;AHykwBF;;AGvkwBA;EACE,gBAAA;AH0kwBF;;AGxkwBA;EACE,gBAAA;AH2kwBF;;AGzkwBA;EACE,gBAAA;AH4kwBF;;AG1kwBA;EACE,gBAAA;AH6kwBF;;AG3kwBA;EACE,gBAAA;AH8kwBF;;AG5kwBA;EACE,gBAAA;AH+kwBF;;AG7kwBA;EACE,gBAAA;AHglwBF;;AG9kwBA;EACE,gBAAA;AHilwBF;;AG/kwBA;EACE,gBAAA;AHklwBF;;AGhlwBA;EACE,gBAAA;AHmlwBF;;AGjlwBA;EACE,gBAAA;AHolwBF;;AGllwBA;EACE,gBAAA;AHqlwBF;;AGnlwBA;EACE,gBAAA;AHslwBF;;AGplwBA;EACE,gBAAA;AHulwBF;;AGrlwBA;EACE,gBAAA;AHwlwBF;;AGtlwBA;EACE,gBAAA;AHylwBF;;AGvlwBA;EACE,gBAAA;AH0lwBF;;AGxlwBA;EACE,gBAAA;AH2lwBF;;AGzlwBA;EACE,gBAAA;AH4lwBF;;AG1lwBA;EACE,gBAAA;AH6lwBF;;AG3lwBA;EACE,gBAAA;AH8lwBF;;AG5lwBA;EACE,gBAAA;AH+lwBF;;AG7lwBA;EACE,gBAAA;AHgmwBF;;AG9lwBA;EACE,gBAAA;AHimwBF;;AG/lwBA;EACE,gBAAA;AHkmwBF;;AGhmwBA;EACE,gBAAA;AHmmwBF;;AGjmwBA;EACE,gBAAA;AHomwBF;;AGlmwBA;EACE,gBAAA;AHqmwBF;;AGnmwBA;EACE,gBAAA;AHsmwBF;;AGpmwBA;EACE,gBAAA;AHumwBF;;AGrmwBA;EACE,gBAAA;AHwmwBF;;AGtmwBA;EACE,gBAAA;AHymwBF;;AGvmwBA;EACE,gBAAA;AH0mwBF;;AGxmwBA;EACE,gBAAA;AH2mwBF;;AGzmwBA;EACE,gBAAA;AH4mwBF;;AG1mwBA;EACE,gBAAA;AH6mwBF;;AG3mwBA;EACE,gBAAA;AH8mwBF;;AG5mwBA;EACE,gBAAA;AH+mwBF;;AG7mwBA;EACE,gBAAA;AHgnwBF;;AG9mwBA;EACE,gBAAA;AHinwBF;;AG/mwBA;EACE,gBAAA;AHknwBF;;AGhnwBA;EACE,gBAAA;AHmnwBF;;AGjnwBA;EACE,gBAAA;AHonwBF;;AGlnwBA;EACE,gBAAA;AHqnwBF;;AGnnwBA;EACE,gBAAA;AHsnwBF;;AGpnwBA;EACE,gBAAA;AHunwBF;;AGrnwBA;EACE,gBAAA;AHwnwBF;;AGtnwBA;EACE,gBAAA;AHynwBF;;AGvnwBA;EACE,gBAAA;AH0nwBF;;AGxnwBA;EACE,gBAAA;AH2nwBF;;AGznwBA;EACE,gBAAA;AH4nwBF;;AG1nwBA;EACE,gBAAA;AH6nwBF;;AG3nwBA;EACE,gBAAA;AH8nwBF;;AG5nwBA;EACE,gBAAA;AH+nwBF;;AG7nwBA;EACE,gBAAA;AHgowBF;;AG9nwBA;EACE,gBAAA;AHiowBF;;AG/nwBA;EACE,gBAAA;AHkowBF;;AGhowBA;EACE,gBAAA;AHmowBF;;AGjowBA;EACE,gBAAA;AHoowBF;;AGlowBA;EACE,gBAAA;AHqowBF;;AGnowBA;EACE,gBAAA;AHsowBF;;AGpowBA;EACE,gBAAA;AHuowBF;;AGrowBA;EACE,gBAAA;AHwowBF;;AGtowBA;EACE,gBAAA;AHyowBF;;AGvowBA;EACE,gBAAA;AH0owBF;;AGxowBA;EACE,gBAAA;AH2owBF;;AGzowBA;EACE,gBAAA;AH4owBF;;AG1owBA;EACE,gBAAA;AH6owBF;;AG3owBA;EACE,gBAAA;AH8owBF;;AG5owBA;EACE,gBAAA;AH+owBF;;AG7owBA;EACE,gBAAA;AHgpwBF;;AG9owBA;EACE,gBAAA;AHipwBF;;AG/owBA;EACE,gBAAA;AHkpwBF;;AGhpwBA;EACE,gBAAA;AHmpwBF;;AGjpwBA;EACE,gBAAA;AHopwBF;;AGlpwBA;EACE,gBAAA;AHqpwBF;;AGnpwBA;EACE,gBAAA;AHspwBF;;AGppwBA;EACE,gBAAA;AHupwBF;;AGrpwBA;EACE,gBAAA;AHwpwBF;;AGtpwBA;EACE,gBAAA;AHypwBF;;AGvpwBA;EACE,gBAAA;AH0pwBF;;AGxpwBA;EACE,gBAAA;AH2pwBF;;AGzpwBA;EACE,gBAAA;AH4pwBF;;AG1pwBA;EACE,gBAAA;AH6pwBF;;AG3pwBA;EACE,gBAAA;AH8pwBF;;AG5pwBA;EACE,gBAAA;AH+pwBF;;AG7pwBA;EACE,gBAAA;AHgqwBF;;AG9pwBA;EACE,gBAAA;AHiqwBF;;AG/pwBA;EACE,gBAAA;AHkqwBF;;AGhqwBA;EACE,gBAAA;AHmqwBF;;AGjqwBA;EACE,gBAAA;AHoqwBF;;AGlqwBA;EACE,gBAAA;AHqqwBF;;AGnqwBA;EACE,gBAAA;AHsqwBF;;AGpqwBA;EACE,gBAAA;AHuqwBF;;AGrqwBA;EACE,gBAAA;AHwqwBF;;AGtqwBA;EACE,gBAAA;AHyqwBF;;AGvqwBA;EACE,gBAAA;AH0qwBF;;AGxqwBA;EACE,gBAAA;AH2qwBF;;AGzqwBA;EACE,gBAAA;AH4qwBF;;AG1qwBA;EACE,gBAAA;AH6qwBF;;AG3qwBA;EACE,gBAAA;AH8qwBF;;AG5qwBA;EACE,gBAAA;AH+qwBF;;AG7qwBA;EACE,gBAAA;AHgrwBF;;AG9qwBA;EACE,gBAAA;AHirwBF;;AG/qwBA;EACE,gBAAA;AHkrwBF;;AGhrwBA;EACE,gBAAA;AHmrwBF;;AGjrwBA;EACE,gBAAA;AHorwBF;;AGlrwBA;EACE,gBAAA;AHqrwBF;;AGnrwBA;EACE,gBAAA;AHsrwBF;;AGprwBA;EACE,gBAAA;AHurwBF;;AGrrwBA;EACE,gBAAA;AHwrwBF;;AGtrwBA;EACE,gBAAA;AHyrwBF;;AGvrwBA;EACE,gBAAA;AH0rwBF;;AGxrwBA;EACE,gBAAA;AH2rwBF;;AGzrwBA;EACE,gBAAA;AH4rwBF;;AG1rwBA;EACE,gBAAA;AH6rwBF;;AG3rwBA;EACE,gBAAA;AH8rwBF;;AG5rwBA;EACE,gBAAA;AH+rwBF;;AG7rwBA;EACE,gBAAA;AHgswBF;;AG9rwBA;EACE,gBAAA;AHiswBF;;AG/rwBA;EACE,gBAAA;AHkswBF;;AGhswBA;EACE,gBAAA;AHmswBF;;AGjswBA;EACE,gBAAA;AHoswBF;;AGlswBA;EACE,gBAAA;AHqswBF;;AGnswBA;EACE,gBAAA;AHsswBF;;AGpswBA;EACE,gBAAA;AHuswBF;;AGrswBA;EACE,gBAAA;AHwswBF;;AGtswBA;EACE,gBAAA;AHyswBF;;AGvswBA;EACE,gBAAA;AH0swBF;;AGxswBA;EACE,gBAAA;AH2swBF;;AGzswBA;EACE,gBAAA;AH4swBF;;AG1swBA;EACE,gBAAA;AH6swBF;;AG3swBA;EACE,gBAAA;AH8swBF;;AG5swBA;EACE,gBAAA;AH+swBF;;AG7swBA;EACE,gBAAA;AHgtwBF;;AG9swBA;EACE,gBAAA;AHitwBF;;AG/swBA;EACE,gBAAA;AHktwBF;;AGhtwBA;EACE,gBAAA;AHmtwBF;;AGjtwBA;EACE,gBAAA;AHotwBF;;AGltwBA;EACE,gBAAA;AHqtwBF;;AGntwBA;EACE,gBAAA;AHstwBF;;AGptwBA;EACE,gBAAA;AHutwBF;;AGrtwBA;EACE,gBAAA;AHwtwBF;;AGttwBA;EACE,gBAAA;AHytwBF;;AGvtwBA;EACE,gBAAA;AH0twBF;;AGxtwBA;EACE,gBAAA;AH2twBF;;AGztwBA;EACE,gBAAA;AH4twBF;;AG1twBA;EACE,gBAAA;AH6twBF;;AG3twBA;EACE,gBAAA;AH8twBF;;AG5twBA;EACE,gBAAA;AH+twBF;;AG7twBA;EACE,gBAAA;AHguwBF;;AG9twBA;EACE,gBAAA;AHiuwBF;;AG/twBA;EACE,gBAAA;AHkuwBF;;AGhuwBA;EACE,gBAAA;AHmuwBF;;AGjuwBA;EACE,gBAAA;AHouwBF;;AGluwBA;EACE,gBAAA;AHquwBF;;AGnuwBA;EACE,gBAAA;AHsuwBF;;AGpuwBA;EACE,gBAAA;AHuuwBF;;AGruwBA;EACE,gBAAA;AHwuwBF;;AGtuwBA;EACE,gBAAA;AHyuwBF;;AIp/3BA;;;EAAA;AAIA;;;;;;EAME,kCAAA;EACA,mCAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;AJu/3BF;;AIp/3BA;EACE,oBAAA;EACA,mBAAA;EACA,yBAAA;AJu/3BF;;AIp/3BA;EACE,iBAAA;AJu/3BF;;AIp/3BA;EACE,kBAAA;AJu/3BF;;AIp/3BA;EACE,cAAA;AJu/3BF;;AIp/3BA;EACE,cAAA;AJu/3BF;;AIp/3BA;EACE,cAAA;AJu/3BF;;AIp/3BA;EACE,cAAA;AJu/3BF;;AIp/3BA;EACE,cAAA;AJu/3BF;;AIp/3BA;EACE,cAAA;AJu/3BF;;AIp/3BA;EACE,cAAA;AJu/3BF;;AIp/3BA;EACE,cAAA;AJu/3BF;;AIp/3BA;EACE,cAAA;AJu/3BF;;AIp/3BA;EACE,eAAA;AJu/3BF;;AIp/3BA;EACE,kBAAA;EACA,aAAA;AJu/3BF;;AIp/3BA;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;AJu/3BF;;AIr/3BA;EACE,kBAAA;AJw/3BF;;AIr/3BA;EACE,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;AJw/3BF;;AIr/3BA;EACE,yBAAA;EACA,oBAAA;EACA,4BAAA;AJw/3BF;;AIr/3BA;EACE,WAAA;AJw/3BF;;AIr/3BA;EACE,YAAA;AJw/3BF;;AIr/3BA;;;;;EAKE,mBAAA;AJw/3BF;;AIr/3BA;;;;;EAKE,kBAAA;AJw/3BF;;AIr/3BA;EAEE,qCAAA;AJw/3BF;;AIr/3BA;EAEE,uCAAA;AJw/3BF;AI1+3BA;EACE;IAEE,uBAAA;EJu/3BF;EIr/3BA;IAEE,yBAAA;EJu/3BF;AACF;AIp/3BA;EACE,sEAAA;EAEA,wBAAA;AJs/3BF;;AIn/3BA;EACE,sEAAA;EAEA,yBAAA;AJs/3BF;;AIn/3BA;EACE,sEAAA;EAEA,yBAAA;AJs/3BF;;AIn/3BA;EACE,gFAAA;EAEA,uBAAA;AJs/3BF;;AIn/3BA;EACE,gFAAA;EAEA,uBAAA;AJs/3BF;;AIn/3BA;;EAEE,gFAAA;EAEA,wBAAA;AJs/3BF;;AIn/3BA;;;;;;EAOE,YAAA;AJs/3BF;;AIn/3BA;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;AJs/3BF;;AIn/3BA;;EAEE,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AJs/3BF;;AIn/3BA;EACE,oBAAA;AJs/3BF;;AIn/3BA;EACE,cAAA;AJs/3BF;;AIn/3BA;EACE,WAAA;AJs/3BF;;AIn/3BA;gEAAA;AAEA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,YAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,gBAAA;AJs/3BF;;AIn/3BA;EACE,SAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AJs/3BF;;AIn/3BA;;EAEE,UAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AJs/3BF;;AIp/3BA;EACE,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,6CAAA;EACA,iTAAA;AJu/3BF;AI/+3BA;EACE,oCAAA;EACA,gBAAA;AJi/3BF;;AI/+3BA;EACE,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,6CAAA;EACA,iTAAA;AJk/3BF;AI1+3BA;EACE,kCAAA;EACA,gBAAA;AJ4+3BF;;AI1+3BA;EACE,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,6CAAA;EACA,iTAAA;AJ6+3BF;AIr+3BA;;EAEE,kCAAA;EACA,gBAAA;AJu+3BF;;AKj5jCA;EACE,2BAAA;EACA,6CAAA;EACA,uPAAA;EAKA,mBAAA;EACA,kBAAA;ALg5jCF;AK74jCA;EACE,sCAAA;EACA,wBAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,+BAAA;EACA,WAAA;EACA,cAAA;EACA,mCAAA;EACA,kCAAA;AL+4jCF;;AK54jCA;;EAEE,sCAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,+BAAA;EACA,WAAA;EACA,cAAA;EACA,mCAAA;EACA,kCAAA;AL+4jCF;;AK54jCA;EACE,YAAA;AL+4jCF;;AK74jCA;EACE,YAAA;ALg5jCF;;AK94jCA;EACE,YAAA;ALi5jCF;;AK/4jCA;EACE,YAAA;ALk5jCF;;AKh5jCA;EACE,YAAA;ALm5jCF;;AKj5jCA;EACE,YAAA;ALo5jCF;;AKl5jCA;EACE,YAAA;ALq5jCF;;AKn5jCA;EACE,YAAA;ALs5jCF;;AKp5jCA;EACE,YAAA;ALu5jCF;;AKr5jCA;EACE,YAAA;ALw5jCF;;AKt5jCA;EACE,YAAA;ALy5jCF;;AKv5jCA;EACE,YAAA;AL05jCF;;AKx5jCA;EACE,YAAA;AL25jCF;;AKz5jCA;EACE,YAAA;AL45jCF;;AK15jCA;EACE,YAAA;AL65jCF;;AK35jCA;EACE,YAAA;AL85jCF;;AK55jCA;EACE,YAAA;AL+5jCF;;AK75jCA;EACE,YAAA;ALg6jCF;;AK95jCA;EACE,YAAA;ALi6jCF;;AK/5jCA;EACE,YAAA;ALk6jCF;;AKh6jCA;EACE,YAAA;ALm6jCF;;AKj6jCA;EACE,YAAA;ALo6jCF;;AKl6jCA;EACE,YAAA;ALq6jCF;;AKn6jCA;EACE,YAAA;ALs6jCF;;AKp6jCA;EACE,YAAA;ALu6jCF;;AKr6jCA;EACE,YAAA;ALw6jCF;;AKt6jCA;EACE,YAAA;ALy6jCF;;AKv6jCA;EACE,YAAA;AL06jCF;;AKx6jCA;EACE,YAAA;AL26jCF;;AKz6jCA;EACE,YAAA;AL46jCF;;AK16jCA;EACE,YAAA;AL66jCF;;AK36jCA;EACE,YAAA;AL86jCF;;AK56jCA;EACE,YAAA;AL+6jCF;;AK76jCA;EACE,YAAA;ALg7jCF;;AK96jCA;EACE,YAAA;ALi7jCF;;AK/6jCA;EACE,YAAA;ALk7jCF;;AKh7jCA;EACE,YAAA;ALm7jCF;;AKj7jCA;EACE,YAAA;ALo7jCF;;AKl7jCA;EACE,YAAA;ALq7jCF;;AKn7jCA;EACE,YAAA;ALs7jCF;;AKp7jCA;EACE,YAAA;ALu7jCF;;AKr7jCA;EACE,YAAA;ALw7jCF;;AKt7jCA;EACE,YAAA;ALy7jCF;;AKv7jCA;EACE,YAAA;AL07jCF;;AKx7jCA;EACE,YAAA;AL27jCF;;AKz7jCA;EACE,YAAA;AL47jCF;;AK17jCA;EACE,YAAA;AL67jCF;;AK37jCA;EACE,YAAA;AL87jCF;;AK57jCA;EACE,YAAA;AL+7jCF;;AK77jCA;EACE,YAAA;ALg8jCF;;AK97jCA;EACE,YAAA;ALi8jCF;;AK/7jCA;EACE,YAAA;ALk8jCF;;AKh8jCA;EACE,YAAA;ALm8jCF;;AKj8jCA;EACE,YAAA;ALo8jCF;;AKl8jCA;EACE,YAAA;ALq8jCF;;AKn8jCA;EACE,YAAA;ALs8jCF;;AKp8jCA;EACE,YAAA;ALu8jCF;;AKr8jCA;EACE,YAAA;ALw8jCF;;AKt8jCA;EACE,YAAA;ALy8jCF;;AKv8jCA;EACE,YAAA;AL08jCF;;AKx8jCA;EACE,YAAA;AL28jCF;;AKz8jCA;EACE,YAAA;AL48jCF;;AK18jCA;EACE,YAAA;AL68jCF;;AK38jCA;EACE,YAAA;AL88jCF;;AK58jCA;EACE,YAAA;AL+8jCF;;AK78jCA;EACE,YAAA;ALg9jCF;;AK98jCA;EACE,YAAA;ALi9jCF;;AK/8jCA;EACE,YAAA;ALk9jCF;;AKh9jCA;EACE,YAAA;ALm9jCF;;AKj9jCA;EACE,YAAA;ALo9jCF;;AKl9jCA;EACE,YAAA;ALq9jCF;;AKn9jCA;EACE,YAAA;ALs9jCF;;AKp9jCA;EACE,YAAA;ALu9jCF;;AKr9jCA;EACE,YAAA;ALw9jCF;;AKt9jCA;EACE,YAAA;ALy9jCF;;AKv9jCA;EACE,YAAA;AL09jCF;;AKx9jCA;EACE,YAAA;AL29jCF;;AKz9jCA;EACE,YAAA;AL49jCF;;AK19jCA;EACE,YAAA;AL69jCF;;AK39jCA;EACE,YAAA;AL89jCF;;AK59jCA;EACE,YAAA;AL+9jCF;;AK79jCA;EACE,YAAA;ALg+jCF;;AK99jCA;EACE,YAAA;ALi+jCF;;AK/9jCA;EACE,YAAA;ALk+jCF;;AKh+jCA;EACE,YAAA;ALm+jCF;;AKj+jCA;EACE,YAAA;ALo+jCF;;AKl+jCA;EACE,YAAA;ALq+jCF;;AKn+jCA;EACE,YAAA;ALs+jCF;;AKp+jCA;EACE,YAAA;ALu+jCF;;AKr+jCA;EACE,YAAA;ALw+jCF;;AKt+jCA;EACE,YAAA;ALy+jCF;;AKv+jCA;EACE,YAAA;AL0+jCF;;AKx+jCA;EACE,YAAA;AL2+jCF;;AKz+jCA;EACE,aAAA;AL4+jCF;;AK1+jCA;EACE,gBAAA;AL6+jCF;;AK3+jCA;EACE,gBAAA;AL8+jCF;;AK5+jCA;EACE,gBAAA;AL++jCF;;AK7+jCA;EACE,gBAAA;ALg/jCF;;AK9+jCA;EACE,gBAAA;ALi/jCF;;AK/+jCA;EACE,gBAAA;ALk/jCF;;AKh/jCA;EACE,gBAAA;ALm/jCF;;AKj/jCA;EACE,gBAAA;ALo/jCF;;AKl/jCA;EACE,gBAAA;ALq/jCF;;AKn/jCA;EACE,gBAAA;ALs/jCF;;AKp/jCA;EACE,gBAAA;ALu/jCF;;AKr/jCA;EACE,gBAAA;ALw/jCF;;AKt/jCA;EACE,gBAAA;ALy/jCF;;AKv/jCA;EACE,gBAAA;AL0/jCF;;AKx/jCA;EACE,gBAAA;AL2/jCF;;AKz/jCA;EACE,gBAAA;AL4/jCF;;AK1/jCA;EACE,gBAAA;AL6/jCF;;AK3/jCA;EACE,gBAAA;AL8/jCF;;AK5/jCA;EACE,gBAAA;AL+/jCF;;AK7/jCA;EACE,gBAAA;ALggkCF;;AK9/jCA;EACE,gBAAA;ALigkCF;;AK//jCA;EACE,gBAAA;ALkgkCF;;AKhgkCA;EACE,gBAAA;ALmgkCF;;AKjgkCA;EACE,gBAAA;ALogkCF;;AKlgkCA;EACE,gBAAA;ALqgkCF;;AKngkCA;EACE,gBAAA;ALsgkCF;;AKpgkCA;EACE,gBAAA;ALugkCF;;AKrgkCA;EACE,gBAAA;ALwgkCF;;AKtgkCA;EACE,gBAAA;ALygkCF;;AKvgkCA;EACE,gBAAA;AL0gkCF;;AKxgkCA;EACE,gBAAA;AL2gkCF;;AKzgkCA;EACE,gBAAA;AL4gkCF;;AK1gkCA;EACE,gBAAA;AL6gkCF;;AK3gkCA;EACE,gBAAA;AL8gkCF;;AK5gkCA;EACE,gBAAA;AL+gkCF;;AK7gkCA;EACE,gBAAA;ALghkCF;;AK9gkCA;EACE,gBAAA;ALihkCF;;AK/gkCA;EACE,gBAAA;ALkhkCF;;AKhhkCA;EACE,gBAAA;ALmhkCF;;AKjhkCA;EACE,gBAAA;ALohkCF;;AKlhkCA;EACE,gBAAA;ALqhkCF;;AKnhkCA;EACE,gBAAA;ALshkCF;;AKphkCA;EACE,gBAAA;ALuhkCF;;AKrhkCA;EACE,gBAAA;ALwhkCF;;AKthkCA;EACE,gBAAA;ALyhkCF;;AKvhkCA;EACE,gBAAA;AL0hkCF;;AKxhkCA;EACE,gBAAA;AL2hkCF;;AKzhkCA;EACE,gBAAA;AL4hkCF;;AK1hkCA;EACE,gBAAA;AL6hkCF;;AK3hkCA;EACE,gBAAA;AL8hkCF;;AK5hkCA;EACE,gBAAA;AL+hkCF;;AK7hkCA;EACE,gBAAA;ALgikCF;;AK9hkCA;EACE,gBAAA;ALiikCF;;AK/hkCA;EACE,gBAAA;ALkikCF;;AKhikCA;EACE,gBAAA;ALmikCF;;AKjikCA;EACE,gBAAA;ALoikCF;;AKlikCA;EACE,gBAAA;ALqikCF;;AKnikCA;EACE,gBAAA;ALsikCF;;AKpikCA;EACE,gBAAA;ALuikCF;;AKrikCA;EACE,gBAAA;ALwikCF;;AKtikCA;EACE,gBAAA;ALyikCF;;AKvikCA;EACE,gBAAA;AL0ikCF;;AKxikCA;EACE,gBAAA;AL2ikCF;;AKzikCA;EACE,gBAAA;AL4ikCF;;AK1ikCA;EACE,gBAAA;AL6ikCF;;AK3ikCA;EACE,gBAAA;AL8ikCF;;AK5ikCA;EACE,gBAAA;AL+ikCF;;AK7ikCA;EACE,gBAAA;ALgjkCF;;AK9ikCA;EACE,gBAAA;ALijkCF;;AK/ikCA;EACE,gBAAA;ALkjkCF;;AKhjkCA;EACE,gBAAA;ALmjkCF;;AKjjkCA;EACE,gBAAA;ALojkCF;;AKljkCA;EACE,gBAAA;ALqjkCF;;AKnjkCA;EACE,gBAAA;ALsjkCF;;AKpjkCA;EACE,gBAAA;ALujkCF;;AKrjkCA;EACE,gBAAA;ALwjkCF;;AKtjkCA;EACE,gBAAA;ALyjkCF;;AKvjkCA;EACE,gBAAA;AL0jkCF;;AKxjkCA;EACE,gBAAA;AL2jkCF;;AKzjkCA;EACE,gBAAA;AL4jkCF;;AK1jkCA;EACE,gBAAA;AL6jkCF;;AK3jkCA;EACE,gBAAA;AL8jkCF;;AK5jkCA;EACE,gBAAA;AL+jkCF;;AK7jkCA;EACE,gBAAA;ALgkkCF;;AK9jkCA;EACE,gBAAA;ALikkCF;;AK/jkCA;EACE,gBAAA;ALkkkCF;;AKhkkCA;EACE,gBAAA;ALmkkCF;;AKjkkCA;EACE,gBAAA;ALokkCF;;AKlkkCA;EACE,gBAAA;ALqkkCF;;AKnkkCA;EACE,gBAAA;ALskkCF;;AKpkkCA;EACE,gBAAA;ALukkCF;;AKrkkCA;EACE,gBAAA;ALwkkCF;;AKtkkCA;EACE,gBAAA;ALykkCF;;AKvkkCA;EACE,gBAAA;AL0kkCF;;AKxkkCA;EACE,gBAAA;AL2kkCF;;AKzkkCA;EACE,gBAAA;AL4kkCF;;AK1kkCA;EACE,gBAAA;AL6kkCF;;AK3kkCA;EACE,gBAAA;AL8kkCF;;AK5kkCA;EACE,gBAAA;AL+kkCF;;AK7kkCA;EACE,gBAAA;ALglkCF;;AK9kkCA;EACE,gBAAA;ALilkCF;;AK/kkCA;EACE,gBAAA;ALklkCF;;AKhlkCA;EACE,gBAAA;ALmlkCF;;AKjlkCA;EACE,gBAAA;ALolkCF;;AKllkCA;EACE,gBAAA;ALqlkCF;;AKnlkCA;EACE,gBAAA;ALslkCF;;AMptlCA;;;;;;;CAAA;ACCE;;;;EAAA;ACDF;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,oBAAA;EAIA,8BAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,2BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,yBAAA;EAAA,6BAAA;EAIA,+CAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,8CAAA;EAAA,gDAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,4CAAA;EAAA,4BAAA;EAIA,kDAAA;EAAA,oDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,iDAAA;EACA,yGAAA;EACA,yFAAA;EAOA,kDAAA;EC2OI,2BALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,wBAAA;EACA,+BAAA;EACA,qBAAA;EACA,+BAAA;EAEA,yBAAA;EACA,gCAAA;EAEA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,iCAAA;EACA,0BAAA;EAEA,wEAAA;EACA,sCAAA;EAMA,wBAAA;EACA,6BAAA;EACA,0BAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,2BAAA;EACA,6BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,iDAAA;EACA,2DAAA;EACA,oDAAA;EACA,2DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,+CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AR8tlCF;;AU90lCI;EFsHA,kBAAA;EAGA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,sCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,uCAAA;EACA,gCAAA;EAGE,kDAAA;EAAA,oDAAA;EAAA,kDAAA;EAAA,6CAAA;EAAA,kDAAA;EAAA,mDAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,2CAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,sCAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,gDAAA;EAAA,iDAAA;EAAA,gDAAA;EAAA,2CAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,2BAAA;EAEA,uCAAA;EACA,iDAAA;EACA,kCAAA;EACA,wCAAA;EAEA,uCAAA;EACA,6BAAA;EACA,sCAAA;EAEA,0BAAA;EACA,wDAAA;EAEA,6CAAA;EACA,oDAAA;EACA,iDAAA;EACA,wDAAA;AR8tlCJ;;AWt4lCA;;;EAGE,sBAAA;AXy4lCF;;AW13lCI;EANJ;IAOM,uBAAA;EX83lCJ;AACF;;AWj3lCA;EACE,SAAA;EACA,uCAAA;EF6OI,mCALI;EEtOR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;AXo3lCF;;AW32lCA;EACE,cAAA;EACA,yBCoqB4B;EDnqB5B,SAAA;EACA,wCAAA;EACA,YCmqB4B;AZ2skC9B;;AWp2lCA;EACE,aAAA;EACA,qBC6mB4B;ED1mB5B,gBC6mB4B;ED5mB5B,gBC6mB4B;ED5mB5B,8BAAA;AXq2lCF;;AWl2lCA;EFuMQ,gCAAA;AT+plCR;AS3zlCI;EE3CJ;IF8MQ,kBAAA;ET4plCN;AACF;;AWt2lCA;EFkMQ,kCAAA;ATwqlCR;ASp0lCI;EEtCJ;IFyMQ,iBAAA;ETqqlCN;AACF;;AW12lCA;EF6LQ,mCAAA;ATirlCR;AS70lCI;EEjCJ;IFoMQ,mBAAA;ET8qlCN;AACF;;AW92lCA;EFwLQ,iCAAA;AT0rlCR;ASt1lCI;EE5BJ;IF+LQ,kBAAA;ETurlCN;AACF;;AWl3lCA;EF+KM,mBALI;AT4slCV;;AWj3lCA;EF0KM,iBALI;ATgtlCV;;AW12lCA;EACE,aAAA;EACA,mBC2Z0B;AZk9kC5B;;AWn2lCA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,8BAAA;AXs2lCF;;AWh2lCA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AXm2lCF;;AW71lCA;;EAEE,kBAAA;AXg2lCF;;AW71lCA;;;EAGE,aAAA;EACA,mBAAA;AXg2lCF;;AW71lCA;;;;EAIE,gBAAA;AXg2lCF;;AW71lCA;EACE,gBCkf4B;AZ82kC9B;;AW31lCA;EACE,qBAAA;EACA,cAAA;AX81lCF;;AWx1lCA;EACE,gBAAA;AX21lCF;;AWn1lCA;;EAEE,mBC2d4B;AZ23kC9B;;AW90lCA;EF6EM,gBALI;AT0wlCV;;AW30lCA;EACE,cCuhB4B;EDthB5B,gCAAA;EACA,wCAAA;AX80lCF;;AWr0lCA;;EAEE,kBAAA;EFwDI,iBALI;EEjDR,cAAA;EACA,wBAAA;AXw0lCF;;AWr0lCA;EAAM,eAAA;AXy0lCN;;AWx0lCA;EAAM,WAAA;AX40lCN;;AWv0lCA;EACE,gEAAA;EACA,qBC4RwC;AZ8ilC1C;AWx0lCE;EACE,mDAAA;AX00lCJ;;AW/zlCE;EAEE,cAAA;EACA,qBAAA;AXi0lCJ;;AW1zlCA;;;;EAIE,qCCuY4B;EHzXxB,cALI;ATqzlCV;;AWtzlCA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFEI,gBALI;AT6zlCV;AWrzlCE;EFHI,kBALI;EEUN,cAAA;EACA,kBAAA;AXuzlCJ;;AWnzlCA;EFVM,gBALI;EEiBR,2BAAA;EACA,qBAAA;AXszlCF;AWnzlCE;EACE,cAAA;AXqzlCJ;;AWjzlCA;EACE,sBAAA;EFtBI,gBALI;EE6BR,WC7NS;ED8NT,yBCrNS;EChFP,qBAAA;Ab0lmCJ;AWlzlCE;EACE,UAAA;EF7BE,cALI;EEoCN,gBCsW0B;AZ88kC9B;;AW3ylCA;EACE,gBAAA;AX8ylCF;;AWxylCA;;EAEE,sBAAA;AX2ylCF;;AWnylCA;EACE,oBAAA;EACA,yBAAA;AXsylCF;;AWnylCA;EACE,oBCqa4B;EDpa5B,uBCoa4B;EDna5B,cChQS;EDiQT,gBAAA;AXsylCF;;AW/xlCA;EAEE,mBAAA;EACA,gCAAA;AXiylCF;;AW9xlCA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AXiylCF;;AWzxlCA;EACE,qBAAA;AX4xlCF;;AWtxlCA;EAEE,gBAAA;AXwxlCF;;AWhxlCA;EACE,UAAA;AXmxlCF;;AW9wlCA;;;;;EAKE,SAAA;EACA,oBAAA;EF5HI,kBALI;EEmIR,oBAAA;AXixlCF;;AW7wlCA;;EAEE,oBAAA;AXgxlCF;;AW3wlCA;EACE,eAAA;AX8wlCF;;AW3wlCA;EAGE,iBAAA;AX4wlCF;AWzwlCE;EACE,UAAA;AX2wlCJ;;AWpwlCA;EACE,wBAAA;AXuwlCF;;AW/vlCA;;;;EAIE,0BAAA;AXkwlCF;AW/vlCI;;;;EACE,eAAA;AXowlCN;;AW7vlCA;EACE,UAAA;EACA,kBAAA;AXgwlCF;;AW3vlCA;EACE,gBAAA;AX8vlCF;;AWpvlCA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AXuvlCF;;AW/ulCA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBCyP4B;EH1ctB,iCAAA;ATo8lCR;AShmmCI;EEyWJ;IFtMQ,iBAAA;ETi8lCN;AACF;AW5vlCA;EAOE,oBAAA;AXwvlCF;AWtvlCE;EACE,WAAA;AXwvlCJ;;AWjvlCA;;;;;;;EAOE,UAAA;AXovlCF;;AWjvlCA;EACE,YAAA;AXovlCF;;AW3ulCA;EACE,6BAAA;EACA,oBAAA;AX8ulCF;;AWtulCA;;;;;;;CAAA;AAWA;EACE,wBAAA;AXsulCF;;AWjulCA;EACE,UAAA;AXoulCF;;AW7tlCA;EACE,aAAA;EACA,0BAAA;AXgulCF;;AW3tlCA;EACE,qBAAA;AX8tlCF;;AWztlCA;EACE,SAAA;AX4tlCF;;AWrtlCA;EACE,kBAAA;EACA,eAAA;AXwtlCF;;AWhtlCA;EACE,wBAAA;AXmtlCF;;AW3slCA;EACE,wBAAA;AX8slCF;;AcnxmCA;ELmQM,mBALI;EK5PR,gBF2rB4B;AZ2llC9B;;AcjxmCE;ELgQM,iCAAA;ATqhmCR;ASjrmCI;EKpGF;ILuQM,eAAA;ETkhmCN;AACF;Ac1xmCE;EAIE,gBF4qBkB;EE3qBlB,gBF6pB0B;AZ4nlC9B;;Ac9xmCE;ELgQM,iCAAA;ATkimCR;AS9rmCI;EKpGF;ILuQM,iBAAA;ET+hmCN;AACF;AcvymCE;EAIE,gBF4qBkB;EE3qBlB,gBF6pB0B;AZyolC9B;;Ac3ymCE;ELgQM,iCAAA;AT+imCR;AS3smCI;EKpGF;ILuQM,eAAA;ET4imCN;AACF;AcpzmCE;EAIE,gBF4qBkB;EE3qBlB,gBF6pB0B;AZsplC9B;;AcxzmCE;ELgQM,iCAAA;AT4jmCR;ASxtmCI;EKpGF;ILuQM,iBAAA;ETyjmCN;AACF;Acj0mCE;EAIE,gBF4qBkB;EE3qBlB,gBF6pB0B;AZmqlC9B;;Acr0mCE;ELgQM,iCAAA;ATykmCR;ASrumCI;EKpGF;ILuQM,eAAA;ETskmCN;AACF;Ac90mCE;EAIE,gBF4qBkB;EE3qBlB,gBF6pB0B;AZgrlC9B;;Acl1mCE;ELgQM,iCAAA;ATslmCR;ASlvmCI;EKpGF;ILuQM,iBAAA;ETmlmCN;AACF;Ac31mCE;EAIE,gBF4qBkB;EE3qBlB,gBF6pB0B;AZ6rlC9B;;Acv0mCA;ECvDE,eAAA;EACA,gBAAA;Afk4mCF;;Acv0mCA;EC5DE,eAAA;EACA,gBAAA;Afu4mCF;;Acz0mCA;EACE,qBAAA;Ad40mCF;Ac10mCE;EACE,oBFgrB0B;AZ4plC9B;;Acl0mCA;EL8MM,gBALI;EKvMR,yBAAA;Adq0mCF;;Acj0mCA;EACE,mBFkXO;EH3KH,mBALI;ATmomCV;Acl0mCE;EACE,gBAAA;Ado0mCJ;;Ach0mCA;EACE,iBAAA;EACA,mBFwWO;EH3KH,gBALI;EKtLR,cFJS;AZu0mCX;Acj0mCE;EACE,aAAA;Adm0mCJ;;AgBn6mCA;ECIE,eAAA;EAGA,YAAA;AjBi6mCF;;AgBl6mCA;EACE,gBJ8iDkC;EI7iDlC,yBJwd0B;EIvd1B,yBAAA;EHGE,sBAAA;EIRF,eAAA;EAGA,YAAA;AjB06mCF;;AgB55mCA;EAEE,qBAAA;AhB85mCF;;AgB35mCA;EACE,qBAAA;EACA,cAAA;AhB85mCF;;AgB35mCA;EPyPM,gBALI;EOlPR,cJwDS;AZs2mCX;;AkBh8mCE;;;;;;;ECHA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;AnB68mCF;;AoBv5mCI;EF5CE;IACE,gBNqiBe;EZk6lCrB;AACF;AoB75mCI;EF5CE;IACE,gBNqiBe;EZu6lCrB;AACF;AoBl6mCI;EF5CE;IACE,gBNqiBe;EZ46lCrB;AACF;AoBv6mCI;EF5CE;IACE,iBNqiBe;EZi7lCrB;AACF;AoB56mCI;EF5CE;IACE,iBNqiBe;EZs7lCrB;AACF;AqB5+mCA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;ArBk/mCJ;;AqB7+mCE;ECNA,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AtBs/mCF;AqBp/mCI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AtBg/mCF;;AsBj8mCM;EACE,SAAA;AtBo8mCR;;AsBj8mCM;EApCJ,cAAA;EACA,WAAA;AtBy+mCF;;AsB39mCE;EACE,cAAA;EACA,WAAA;AtB89mCJ;;AsBh+mCE;EACE,cAAA;EACA,UAAA;AtBm+mCJ;;AsBr+mCE;EACE,cAAA;EACA,mBAAA;AtBw+mCJ;;AsB1+mCE;EACE,cAAA;EACA,UAAA;AtB6+mCJ;;AsB/+mCE;EACE,cAAA;EACA,UAAA;AtBk/mCJ;;AsBp/mCE;EACE,cAAA;EACA,mBAAA;AtBu/mCJ;;AsBx9mCM;EAhDJ,cAAA;EACA,WAAA;AtB4gnCF;;AsBv9mCU;EAhEN,cAAA;EACA,kBAAA;AtB2hnCJ;;AsB59mCU;EAhEN,cAAA;EACA,mBAAA;AtBginCJ;;AsBj+mCU;EAhEN,cAAA;EACA,UAAA;AtBqinCJ;;AsBt+mCU;EAhEN,cAAA;EACA,mBAAA;AtB0inCJ;;AsB3+mCU;EAhEN,cAAA;EACA,mBAAA;AtB+inCJ;;AsBh/mCU;EAhEN,cAAA;EACA,UAAA;AtBojnCJ;;AsBr/mCU;EAhEN,cAAA;EACA,mBAAA;AtByjnCJ;;AsB1/mCU;EAhEN,cAAA;EACA,mBAAA;AtB8jnCJ;;AsB//mCU;EAhEN,cAAA;EACA,UAAA;AtBmknCJ;;AsBpgnCU;EAhEN,cAAA;EACA,mBAAA;AtBwknCJ;;AsBzgnCU;EAhEN,cAAA;EACA,mBAAA;AtB6knCJ;;AsB9gnCU;EAhEN,cAAA;EACA,WAAA;AtBklnCJ;;AsB3gnCY;EAxDV,wBAAA;AtBuknCF;;AsB/gnCY;EAxDV,yBAAA;AtB2knCF;;AsBnhnCY;EAxDV,gBAAA;AtB+knCF;;AsBvhnCY;EAxDV,yBAAA;AtBmlnCF;;AsB3hnCY;EAxDV,yBAAA;AtBulnCF;;AsB/hnCY;EAxDV,gBAAA;AtB2lnCF;;AsBninCY;EAxDV,yBAAA;AtB+lnCF;;AsBvinCY;EAxDV,yBAAA;AtBmmnCF;;AsB3inCY;EAxDV,gBAAA;AtBumnCF;;AsB/inCY;EAxDV,yBAAA;AtB2mnCF;;AsBnjnCY;EAxDV,yBAAA;AtB+mnCF;;AsB5inCQ;;EAEE,gBAAA;AtB+inCV;;AsB5inCQ;;EAEE,gBAAA;AtB+inCV;;AsBtjnCQ;;EAEE,sBAAA;AtByjnCV;;AsBtjnCQ;;EAEE,sBAAA;AtByjnCV;;AsBhknCQ;;EAEE,qBAAA;AtBmknCV;;AsBhknCQ;;EAEE,qBAAA;AtBmknCV;;AsB1knCQ;;EAEE,mBAAA;AtB6knCV;;AsB1knCQ;;EAEE,mBAAA;AtB6knCV;;AsBplnCQ;;EAEE,qBAAA;AtBulnCV;;AsBplnCQ;;EAEE,qBAAA;AtBulnCV;;AsB9lnCQ;;EAEE,mBAAA;AtBimnCV;;AsB9lnCQ;;EAEE,mBAAA;AtBimnCV;;AoB3pnCI;EEUE;IACE,SAAA;EtBqpnCN;EsBlpnCI;IApCJ,cAAA;IACA,WAAA;EtByrnCA;EsB3qnCA;IACE,cAAA;IACA,WAAA;EtB6qnCF;EsB/qnCA;IACE,cAAA;IACA,UAAA;EtBirnCF;EsBnrnCA;IACE,cAAA;IACA,mBAAA;EtBqrnCF;EsBvrnCA;IACE,cAAA;IACA,UAAA;EtByrnCF;EsB3rnCA;IACE,cAAA;IACA,UAAA;EtB6rnCF;EsB/rnCA;IACE,cAAA;IACA,mBAAA;EtBisnCF;EsBlqnCI;IAhDJ,cAAA;IACA,WAAA;EtBqtnCA;EsBhqnCQ;IAhEN,cAAA;IACA,kBAAA;EtBmunCF;EsBpqnCQ;IAhEN,cAAA;IACA,mBAAA;EtBuunCF;EsBxqnCQ;IAhEN,cAAA;IACA,UAAA;EtB2unCF;EsB5qnCQ;IAhEN,cAAA;IACA,mBAAA;EtB+unCF;EsBhrnCQ;IAhEN,cAAA;IACA,mBAAA;EtBmvnCF;EsBprnCQ;IAhEN,cAAA;IACA,UAAA;EtBuvnCF;EsBxrnCQ;IAhEN,cAAA;IACA,mBAAA;EtB2vnCF;EsB5rnCQ;IAhEN,cAAA;IACA,mBAAA;EtB+vnCF;EsBhsnCQ;IAhEN,cAAA;IACA,UAAA;EtBmwnCF;EsBpsnCQ;IAhEN,cAAA;IACA,mBAAA;EtBuwnCF;EsBxsnCQ;IAhEN,cAAA;IACA,mBAAA;EtB2wnCF;EsB5snCQ;IAhEN,cAAA;IACA,WAAA;EtB+wnCF;EsBxsnCU;IAxDV,cAAA;EtBmwnCA;EsB3snCU;IAxDV,wBAAA;EtBswnCA;EsB9snCU;IAxDV,yBAAA;EtBywnCA;EsBjtnCU;IAxDV,gBAAA;EtB4wnCA;EsBptnCU;IAxDV,yBAAA;EtB+wnCA;EsBvtnCU;IAxDV,yBAAA;EtBkxnCA;EsB1tnCU;IAxDV,gBAAA;EtBqxnCA;EsB7tnCU;IAxDV,yBAAA;EtBwxnCA;EsBhunCU;IAxDV,yBAAA;EtB2xnCA;EsBnunCU;IAxDV,gBAAA;EtB8xnCA;EsBtunCU;IAxDV,yBAAA;EtBiynCA;EsBzunCU;IAxDV,yBAAA;EtBoynCA;EsBjunCM;;IAEE,gBAAA;EtBmunCR;EsBhunCM;;IAEE,gBAAA;EtBkunCR;EsBzunCM;;IAEE,sBAAA;EtB2unCR;EsBxunCM;;IAEE,sBAAA;EtB0unCR;EsBjvnCM;;IAEE,qBAAA;EtBmvnCR;EsBhvnCM;;IAEE,qBAAA;EtBkvnCR;EsBzvnCM;;IAEE,mBAAA;EtB2vnCR;EsBxvnCM;;IAEE,mBAAA;EtB0vnCR;EsBjwnCM;;IAEE,qBAAA;EtBmwnCR;EsBhwnCM;;IAEE,qBAAA;EtBkwnCR;EsBzwnCM;;IAEE,mBAAA;EtB2wnCR;EsBxwnCM;;IAEE,mBAAA;EtB0wnCR;AACF;AoBr0nCI;EEUE;IACE,SAAA;EtB8znCN;EsB3znCI;IApCJ,cAAA;IACA,WAAA;EtBk2nCA;EsBp1nCA;IACE,cAAA;IACA,WAAA;EtBs1nCF;EsBx1nCA;IACE,cAAA;IACA,UAAA;EtB01nCF;EsB51nCA;IACE,cAAA;IACA,mBAAA;EtB81nCF;EsBh2nCA;IACE,cAAA;IACA,UAAA;EtBk2nCF;EsBp2nCA;IACE,cAAA;IACA,UAAA;EtBs2nCF;EsBx2nCA;IACE,cAAA;IACA,mBAAA;EtB02nCF;EsB30nCI;IAhDJ,cAAA;IACA,WAAA;EtB83nCA;EsBz0nCQ;IAhEN,cAAA;IACA,kBAAA;EtB44nCF;EsB70nCQ;IAhEN,cAAA;IACA,mBAAA;EtBg5nCF;EsBj1nCQ;IAhEN,cAAA;IACA,UAAA;EtBo5nCF;EsBr1nCQ;IAhEN,cAAA;IACA,mBAAA;EtBw5nCF;EsBz1nCQ;IAhEN,cAAA;IACA,mBAAA;EtB45nCF;EsB71nCQ;IAhEN,cAAA;IACA,UAAA;EtBg6nCF;EsBj2nCQ;IAhEN,cAAA;IACA,mBAAA;EtBo6nCF;EsBr2nCQ;IAhEN,cAAA;IACA,mBAAA;EtBw6nCF;EsBz2nCQ;IAhEN,cAAA;IACA,UAAA;EtB46nCF;EsB72nCQ;IAhEN,cAAA;IACA,mBAAA;EtBg7nCF;EsBj3nCQ;IAhEN,cAAA;IACA,mBAAA;EtBo7nCF;EsBr3nCQ;IAhEN,cAAA;IACA,WAAA;EtBw7nCF;EsBj3nCU;IAxDV,cAAA;EtB46nCA;EsBp3nCU;IAxDV,wBAAA;EtB+6nCA;EsBv3nCU;IAxDV,yBAAA;EtBk7nCA;EsB13nCU;IAxDV,gBAAA;EtBq7nCA;EsB73nCU;IAxDV,yBAAA;EtBw7nCA;EsBh4nCU;IAxDV,yBAAA;EtB27nCA;EsBn4nCU;IAxDV,gBAAA;EtB87nCA;EsBt4nCU;IAxDV,yBAAA;EtBi8nCA;EsBz4nCU;IAxDV,yBAAA;EtBo8nCA;EsB54nCU;IAxDV,gBAAA;EtBu8nCA;EsB/4nCU;IAxDV,yBAAA;EtB08nCA;EsBl5nCU;IAxDV,yBAAA;EtB68nCA;EsB14nCM;;IAEE,gBAAA;EtB44nCR;EsBz4nCM;;IAEE,gBAAA;EtB24nCR;EsBl5nCM;;IAEE,sBAAA;EtBo5nCR;EsBj5nCM;;IAEE,sBAAA;EtBm5nCR;EsB15nCM;;IAEE,qBAAA;EtB45nCR;EsBz5nCM;;IAEE,qBAAA;EtB25nCR;EsBl6nCM;;IAEE,mBAAA;EtBo6nCR;EsBj6nCM;;IAEE,mBAAA;EtBm6nCR;EsB16nCM;;IAEE,qBAAA;EtB46nCR;EsBz6nCM;;IAEE,qBAAA;EtB26nCR;EsBl7nCM;;IAEE,mBAAA;EtBo7nCR;EsBj7nCM;;IAEE,mBAAA;EtBm7nCR;AACF;AoB9+nCI;EEUE;IACE,SAAA;EtBu+nCN;EsBp+nCI;IApCJ,cAAA;IACA,WAAA;EtB2goCA;EsB7/nCA;IACE,cAAA;IACA,WAAA;EtB+/nCF;EsBjgoCA;IACE,cAAA;IACA,UAAA;EtBmgoCF;EsBrgoCA;IACE,cAAA;IACA,mBAAA;EtBugoCF;EsBzgoCA;IACE,cAAA;IACA,UAAA;EtB2goCF;EsB7goCA;IACE,cAAA;IACA,UAAA;EtB+goCF;EsBjhoCA;IACE,cAAA;IACA,mBAAA;EtBmhoCF;EsBp/nCI;IAhDJ,cAAA;IACA,WAAA;EtBuioCA;EsBl/nCQ;IAhEN,cAAA;IACA,kBAAA;EtBqjoCF;EsBt/nCQ;IAhEN,cAAA;IACA,mBAAA;EtByjoCF;EsB1/nCQ;IAhEN,cAAA;IACA,UAAA;EtB6joCF;EsB9/nCQ;IAhEN,cAAA;IACA,mBAAA;EtBikoCF;EsBlgoCQ;IAhEN,cAAA;IACA,mBAAA;EtBqkoCF;EsBtgoCQ;IAhEN,cAAA;IACA,UAAA;EtBykoCF;EsB1goCQ;IAhEN,cAAA;IACA,mBAAA;EtB6koCF;EsB9goCQ;IAhEN,cAAA;IACA,mBAAA;EtBiloCF;EsBlhoCQ;IAhEN,cAAA;IACA,UAAA;EtBqloCF;EsBthoCQ;IAhEN,cAAA;IACA,mBAAA;EtByloCF;EsB1hoCQ;IAhEN,cAAA;IACA,mBAAA;EtB6loCF;EsB9hoCQ;IAhEN,cAAA;IACA,WAAA;EtBimoCF;EsB1hoCU;IAxDV,cAAA;EtBqloCA;EsB7hoCU;IAxDV,wBAAA;EtBwloCA;EsBhioCU;IAxDV,yBAAA;EtB2loCA;EsBnioCU;IAxDV,gBAAA;EtB8loCA;EsBtioCU;IAxDV,yBAAA;EtBimoCA;EsBzioCU;IAxDV,yBAAA;EtBomoCA;EsB5ioCU;IAxDV,gBAAA;EtBumoCA;EsB/ioCU;IAxDV,yBAAA;EtB0moCA;EsBljoCU;IAxDV,yBAAA;EtB6moCA;EsBrjoCU;IAxDV,gBAAA;EtBgnoCA;EsBxjoCU;IAxDV,yBAAA;EtBmnoCA;EsB3joCU;IAxDV,yBAAA;EtBsnoCA;EsBnjoCM;;IAEE,gBAAA;EtBqjoCR;EsBljoCM;;IAEE,gBAAA;EtBojoCR;EsB3joCM;;IAEE,sBAAA;EtB6joCR;EsB1joCM;;IAEE,sBAAA;EtB4joCR;EsBnkoCM;;IAEE,qBAAA;EtBqkoCR;EsBlkoCM;;IAEE,qBAAA;EtBokoCR;EsB3koCM;;IAEE,mBAAA;EtB6koCR;EsB1koCM;;IAEE,mBAAA;EtB4koCR;EsBnloCM;;IAEE,qBAAA;EtBqloCR;EsBlloCM;;IAEE,qBAAA;EtBoloCR;EsB3loCM;;IAEE,mBAAA;EtB6loCR;EsB1loCM;;IAEE,mBAAA;EtB4loCR;AACF;AoBvpoCI;EEUE;IACE,SAAA;EtBgpoCN;EsB7ooCI;IApCJ,cAAA;IACA,WAAA;EtBoroCA;EsBtqoCA;IACE,cAAA;IACA,WAAA;EtBwqoCF;EsB1qoCA;IACE,cAAA;IACA,UAAA;EtB4qoCF;EsB9qoCA;IACE,cAAA;IACA,mBAAA;EtBgroCF;EsBlroCA;IACE,cAAA;IACA,UAAA;EtBoroCF;EsBtroCA;IACE,cAAA;IACA,UAAA;EtBwroCF;EsB1roCA;IACE,cAAA;IACA,mBAAA;EtB4roCF;EsB7poCI;IAhDJ,cAAA;IACA,WAAA;EtBgtoCA;EsB3poCQ;IAhEN,cAAA;IACA,kBAAA;EtB8toCF;EsB/poCQ;IAhEN,cAAA;IACA,mBAAA;EtBkuoCF;EsBnqoCQ;IAhEN,cAAA;IACA,UAAA;EtBsuoCF;EsBvqoCQ;IAhEN,cAAA;IACA,mBAAA;EtB0uoCF;EsB3qoCQ;IAhEN,cAAA;IACA,mBAAA;EtB8uoCF;EsB/qoCQ;IAhEN,cAAA;IACA,UAAA;EtBkvoCF;EsBnroCQ;IAhEN,cAAA;IACA,mBAAA;EtBsvoCF;EsBvroCQ;IAhEN,cAAA;IACA,mBAAA;EtB0voCF;EsB3roCQ;IAhEN,cAAA;IACA,UAAA;EtB8voCF;EsB/roCQ;IAhEN,cAAA;IACA,mBAAA;EtBkwoCF;EsBnsoCQ;IAhEN,cAAA;IACA,mBAAA;EtBswoCF;EsBvsoCQ;IAhEN,cAAA;IACA,WAAA;EtB0woCF;EsBnsoCU;IAxDV,cAAA;EtB8voCA;EsBtsoCU;IAxDV,wBAAA;EtBiwoCA;EsBzsoCU;IAxDV,yBAAA;EtBowoCA;EsB5soCU;IAxDV,gBAAA;EtBuwoCA;EsB/soCU;IAxDV,yBAAA;EtB0woCA;EsBltoCU;IAxDV,yBAAA;EtB6woCA;EsBrtoCU;IAxDV,gBAAA;EtBgxoCA;EsBxtoCU;IAxDV,yBAAA;EtBmxoCA;EsB3toCU;IAxDV,yBAAA;EtBsxoCA;EsB9toCU;IAxDV,gBAAA;EtByxoCA;EsBjuoCU;IAxDV,yBAAA;EtB4xoCA;EsBpuoCU;IAxDV,yBAAA;EtB+xoCA;EsB5toCM;;IAEE,gBAAA;EtB8toCR;EsB3toCM;;IAEE,gBAAA;EtB6toCR;EsBpuoCM;;IAEE,sBAAA;EtBsuoCR;EsBnuoCM;;IAEE,sBAAA;EtBquoCR;EsB5uoCM;;IAEE,qBAAA;EtB8uoCR;EsB3uoCM;;IAEE,qBAAA;EtB6uoCR;EsBpvoCM;;IAEE,mBAAA;EtBsvoCR;EsBnvoCM;;IAEE,mBAAA;EtBqvoCR;EsB5voCM;;IAEE,qBAAA;EtB8voCR;EsB3voCM;;IAEE,qBAAA;EtB6voCR;EsBpwoCM;;IAEE,mBAAA;EtBswoCR;EsBnwoCM;;IAEE,mBAAA;EtBqwoCR;AACF;AoBh0oCI;EEUE;IACE,SAAA;EtByzoCN;EsBtzoCI;IApCJ,cAAA;IACA,WAAA;EtB61oCA;EsB/0oCA;IACE,cAAA;IACA,WAAA;EtBi1oCF;EsBn1oCA;IACE,cAAA;IACA,UAAA;EtBq1oCF;EsBv1oCA;IACE,cAAA;IACA,mBAAA;EtBy1oCF;EsB31oCA;IACE,cAAA;IACA,UAAA;EtB61oCF;EsB/1oCA;IACE,cAAA;IACA,UAAA;EtBi2oCF;EsBn2oCA;IACE,cAAA;IACA,mBAAA;EtBq2oCF;EsBt0oCI;IAhDJ,cAAA;IACA,WAAA;EtBy3oCA;EsBp0oCQ;IAhEN,cAAA;IACA,kBAAA;EtBu4oCF;EsBx0oCQ;IAhEN,cAAA;IACA,mBAAA;EtB24oCF;EsB50oCQ;IAhEN,cAAA;IACA,UAAA;EtB+4oCF;EsBh1oCQ;IAhEN,cAAA;IACA,mBAAA;EtBm5oCF;EsBp1oCQ;IAhEN,cAAA;IACA,mBAAA;EtBu5oCF;EsBx1oCQ;IAhEN,cAAA;IACA,UAAA;EtB25oCF;EsB51oCQ;IAhEN,cAAA;IACA,mBAAA;EtB+5oCF;EsBh2oCQ;IAhEN,cAAA;IACA,mBAAA;EtBm6oCF;EsBp2oCQ;IAhEN,cAAA;IACA,UAAA;EtBu6oCF;EsBx2oCQ;IAhEN,cAAA;IACA,mBAAA;EtB26oCF;EsB52oCQ;IAhEN,cAAA;IACA,mBAAA;EtB+6oCF;EsBh3oCQ;IAhEN,cAAA;IACA,WAAA;EtBm7oCF;EsB52oCU;IAxDV,cAAA;EtBu6oCA;EsB/2oCU;IAxDV,wBAAA;EtB06oCA;EsBl3oCU;IAxDV,yBAAA;EtB66oCA;EsBr3oCU;IAxDV,gBAAA;EtBg7oCA;EsBx3oCU;IAxDV,yBAAA;EtBm7oCA;EsB33oCU;IAxDV,yBAAA;EtBs7oCA;EsB93oCU;IAxDV,gBAAA;EtBy7oCA;EsBj4oCU;IAxDV,yBAAA;EtB47oCA;EsBp4oCU;IAxDV,yBAAA;EtB+7oCA;EsBv4oCU;IAxDV,gBAAA;EtBk8oCA;EsB14oCU;IAxDV,yBAAA;EtBq8oCA;EsB74oCU;IAxDV,yBAAA;EtBw8oCA;EsBr4oCM;;IAEE,gBAAA;EtBu4oCR;EsBp4oCM;;IAEE,gBAAA;EtBs4oCR;EsB74oCM;;IAEE,sBAAA;EtB+4oCR;EsB54oCM;;IAEE,sBAAA;EtB84oCR;EsBr5oCM;;IAEE,qBAAA;EtBu5oCR;EsBp5oCM;;IAEE,qBAAA;EtBs5oCR;EsB75oCM;;IAEE,mBAAA;EtB+5oCR;EsB55oCM;;IAEE,mBAAA;EtB85oCR;EsBr6oCM;;IAEE,qBAAA;EtBu6oCR;EsBp6oCM;;IAEE,qBAAA;EtBs6oCR;EsB76oCM;;IAEE,mBAAA;EtB+6oCR;EsB56oCM;;IAEE,mBAAA;EtB86oCR;AACF;AuBpipCA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,yBAAA;EACA,gCAAA;EACA,gCAAA;EACA,iCAAA;EACA,iCAAA;EACA,8BAAA;EACA,gCAAA;EACA,wCAAA;EACA,+BAAA;EACA,4BAAA;EAEA,WAAA;EACA,mBXmbO;EWlbP,mBXgvB4B;EW/uB5B,0CAAA;AvBmipCF;AuB5hpCE;EACE,wBAAA;EAEA,qFAAA;EACA,oCAAA;EACA,wBXojB0B;EWnjB1B,2GAAA;AvB6hpCJ;AuB1hpCE;EACE,uBAAA;AvB4hpCJ;AuBzhpCE;EACE,sBAAA;AvB2hpCJ;;AuBvhpCA;EACE,uCAAA;AvB0hpCF;;AuBnhpCA;EACE,iBAAA;AvBshpCF;;AuB5gpCE;EACE,wBAAA;AvB+gpCJ;;AuBhgpCE;EACE,mBAAA;AvBmgpCJ;AuBhgpCI;EACE,mBAAA;AvBkgpCN;;AuB3/oCE;EACE,sBAAA;AvB8/oCJ;AuB3/oCE;EACE,mBAAA;AvB6/oCJ;;AuBn/oCE;EACE,oDAAA;EACA,8CAAA;AvBs/oCJ;;AuBh/oCE;EACE,oDAAA;EACA,8CAAA;AvBm/oCJ;;AuB3+oCA;EACE,oDAAA;EACA,8CAAA;AvB8+oCF;;AuBt+oCE;EACE,mDAAA;EACA,6CAAA;AvBy+oCJ;;AwBrnpCE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AxBinpCJ;;AwBnopCE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AxB+npCJ;;AwBjppCE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AxB6opCJ;;AwB/ppCE;EAOE,sBAAA;EACA,mCAAA;EACA,gDAAA;EACA,+CAAA;EACA,8BAAA;EACA,6CAAA;EACA,6BAAA;EACA,iDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AxB2ppCJ;;AwB7qpCE;EAOE,sBAAA;EACA,qCAAA;EACA,iDAAA;EACA,+CAAA;EACA,8BAAA;EACA,8CAAA;EACA,6BAAA;EACA,8CAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AxByqpCJ;;AwB3rpCE;EAOE,sBAAA;EACA,uCAAA;EACA,oDAAA;EACA,kDAAA;EACA,8BAAA;EACA,iDAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AxBurpCJ;;AwBzspCE;EAOE,sBAAA;EACA,sBAAA;EACA,iDAAA;EACA,gDAAA;EACA,8BAAA;EACA,8CAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AxBqspCJ;;AwBvtpCE;EAOE,sBAAA;EACA,sBAAA;EACA,8CAAA;EACA,+CAAA;EACA,8BAAA;EACA,2CAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AxBmtpCJ;;AuBlkpCI;EACE,gBAAA;EACA,iCAAA;AvBqkpCN;;AoBhqpCI;EGyFA;IACE,gBAAA;IACA,iCAAA;EvB2kpCJ;AACF;AoBvqpCI;EGyFA;IACE,gBAAA;IACA,iCAAA;EvBilpCJ;AACF;AoB7qpCI;EGyFA;IACE,gBAAA;IACA,iCAAA;EvBulpCJ;AACF;AoBnrpCI;EGyFA;IACE,gBAAA;IACA,iCAAA;EvB6lpCJ;AACF;AoBzrpCI;EGyFA;IACE,gBAAA;IACA,iCAAA;EvBmmpCJ;AACF;AyBvwpCA;EACE,qBb84BsC;AZ23nCxC;;AyBhwpCA;EACE,gCAAA;EACA,mCAAA;EACA,gBAAA;EhB8QI,kBALI;EgBrQR,gBbopB4B;AZ6moC9B;;AyB7vpCA;EACE,+BAAA;EACA,kCAAA;EhBoQI,mBALI;ATkgpCV;;AyB7vpCA;EACE,gCAAA;EACA,mCAAA;EhB8PI,oBALI;ATwgpCV;;A0B9xpCA;EACE,mBds4BsC;EH5mBlC,gBALI;EiBjRR,cduFS;AZwspCX;;A2BpypCA;EACE,cAAA;EACA,WAAA;EACA,wBAAA;ElBwRI,iBALI;EkBhRR,gBfypB4B;EexpB5B,gBf8pB4B;Ee7pB5B,cfqFS;EepFT,gBAAA;EACA,sBf4ES;Ee3ET,4BAAA;EACA,yBAAA;EdGE,sBAAA;EeHE,wEDMJ;A3BkypCF;A4BpypCM;EDhBN;ICiBQ,gBAAA;E5BuypCN;AACF;A2BrypCE;EACE,gBAAA;A3BuypCJ;A2BrypCI;EACE,eAAA;A3BuypCN;A2BlypCE;EACE,cf+DO;Ee9DP,sBfuDO;EetDP,sCfo5BoC;Een5BpC,UAAA;EAKE,gBfi5BkC;AZ+4nCxC;A2B5xpCE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;A3BgxpCJ;A2B3wpCE;EACE,cAAA;EACA,UAAA;A3B6wpCJ;A2BzwpCE;EACE,cfqBO;EenBP,UAAA;A3B0wpCJ;A2BlwpCE;EAEE,yBfKO;EeFP,UAAA;A3BiwpCJ;A2B7vpCE;EACE,wBAAA;EACA,yBAAA;EACA,0Bf8tB0B;Ee7tB1B,cfDO;EiB7FT,yBjBwFS;EeQP,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,4Bfif0B;Eehf1B,gBAAA;ECzFE,qID0FF;A3B+vpCJ;A4Br1pCM;ED0EJ;ICzEM,gBAAA;E5Bw1pCN;AACF;A2BjwpCE;EACE,2Cf69B8B;AZsynClC;;A2B1vpCA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBf6iB4B;Ee5iB5B,cf5BS;Ee6BT,6BAAA;EACA,yBAAA;EACA,mBAAA;A3B6vpCF;A2B3vpCE;EACE,UAAA;A3B6vpCJ;A2B1vpCE;EAEE,gBAAA;EACA,eAAA;A3B2vpCJ;;A2BhvpCA;EACE,sCfkzBsC;EejzBtC,uBAAA;ElByII,oBALI;EIvQN,qBAAA;Abw3pCJ;A2BjvpCE;EACE,uBAAA;EACA,wBAAA;EACA,yBf8qB0B;AZqkoC9B;;A2B/upCA;EACE,oCfsyBsC;EeryBtC,oBAAA;ElB4HI,mBALI;EIvQN,qBAAA;Abo4pCJ;A2BhvpCE;EACE,oBAAA;EACA,qBAAA;EACA,uBfqqB0B;AZ6koC9B;;A2B1upCE;EACE,uCfmxBoC;AZ09nCxC;A2B1upCE;EACE,sCfgxBoC;AZ49nCxC;A2BzupCE;EACE,oCf6wBoC;AZ89nCxC;;A2BtupCA;EACE,Wf0wBsC;EezwBtC,mCfowBsC;EenwBtC,gBf2nB4B;AZ8moC9B;A2BvupCE;EACE,eAAA;A3ByupCJ;A2BtupCE;EACE,oBAAA;EdvLA,sBAAA;Abg6pCJ;A2BrupCE;EACE,oBAAA;Ed5LA,sBAAA;Abo6pCJ;A2BpupCE;EAAoB,kCfovBkB;AZm/nCxC;A2BtupCE;EAAoB,gCfovBkB;AZq/nCxC;;A8Bx7pCA;EACE,iEAAA;EAEA,cAAA;EACA,WAAA;EACA,wCAAA;ErBqRI,iBALI;EqB7QR,gBlBspB4B;EkBrpB5B,gBlB2pB4B;EkB1pB5B,clBkFS;EkBjFT,gBAAA;EACA,sBlByES;EkBxET,mFAAA;EACA,4BAAA;EACA,yClBmgCkC;EkBlgClC,0BlBmgCkC;EkBlgClC,yBAAA;EjBHE,sBAAA;EeHE,wEESJ;A9Bw7pCF;A4B77pCM;EEfN;IFgBQ,gBAAA;E5Bg8pCN;AACF;A8B37pCE;EACE,sClB45BoC;EkB35BpC,UAAA;EAKE,kDlBqgC4B;AZo7nClC;A8Br7pCE;EAEE,sBlBuxB0B;EkBtxB1B,sBAAA;A9Bs7pCJ;A8Bn7pCE;EACE,clBmDO;EkBlDP,yBlB8CO;AZu4pCX;A8Bh7pCE;EACE,kBAAA;EACA,0BAAA;A9Bk7pCJ;;A8B96pCA;EACE,oBlBgxB4B;EkB/wB5B,uBlB+wB4B;EkB9wB5B,oBlB+wB4B;EH5iBxB,oBALI;EIvQN,yCAAA;Ab49pCJ;;A8B96pCA;EACE,mBlB4wB4B;EkB3wB5B,sBlB2wB4B;EkB1wB5B,kBlB2wB4B;EHhjBxB,mBALI;EIvQN,yCAAA;Abo+pCJ;;A8B56pCI;EACE,iEAAA;A9B+6pCN;;A+Bv/pCA;EACE,cAAA;EACA,mBnB08BwC;EmBz8BxC,mBnB08BwC;EmBz8BxC,uBnB08BwC;AZgjoC1C;A+Bx/pCE;EACE,WAAA;EACA,mBAAA;A/B0/pCJ;;A+Bt/pCA;EACE,oBnBg8BwC;EmB/7BxC,eAAA;EACA,iBAAA;A/By/pCF;A+Bv/pCE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;A/By/pCJ;;A+Br/pCA;EACE,wBAAA;EAEA,cAAA;EACA,UnB+6BwC;EmB96BxC,WnB86BwC;EmB76BxC,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,yBnBg7BwC;EmB/6BxC,iCAAA;UAAA,yBAAA;EH3BI,mJG4BJ;A/Bu/pCF;A4B/gqCM;EGQN;IHPQ,gBAAA;E5BkhqCN;AACF;A+B1/pCE;ElB3BE,qBAAA;AbwhqCJ;A+Bz/pCE;EAEE,kBnBw6BsC;AZkloC1C;A+Bv/pCE;EACE,uBnB+5BsC;AZ0loC1C;A+Bt/pCE;EACE,sCnB43BoC;EmB33BpC,UAAA;EACA,gBnBg6BsC;AZwloC1C;A+Br/pCE;EACE,yBnBqDM;EmBpDN,qBnBoDM;AZm8pCV;A+Br/pCI;EAII,kEAAA;A/Bo/pCR;A+Bh/pCI;EAII,kEAAA;A/B++pCR;A+B1+pCE;EACE,yBnBgCM;EmB/BN,qBnB+BM;EmB1BJ,kEAAA;A/Bw+pCN;A+Bp+pCE;EACE,oBAAA;EACA,YAAA;EACA,YnBu4BuC;AZ+loC3C;A+B/9pCI;EACE,eAAA;EACA,YnB83BqC;AZmmoC3C;;A+Bn9pCA;EACE,mBnBw3BgC;AZ8loClC;A+Bp9pCE;EACE,6DAAA;EAEA,UnBk3B8B;EmBj3B9B,mBAAA;EACA,0CAAA;EACA,gCAAA;ElBjHA,kBAAA;EeHE,iDGsHF;A/Bq9pCJ;A4BvkqCM;EG0GJ;IHzGM,gBAAA;E5B0kqCN;AACF;A+Bx9pCI;EACE,6DAAA;A/B09pCN;A+Bv9pCI;EACE,iCnBi3B4B;EmB52B1B,6DAAA;A/Bq9pCR;A+Bh9pCE;EACE,oBnB41B8B;EmB31B9B,eAAA;A/Bk9pCJ;A+Bh9pCI;EACE,oBAAA;EACA,cAAA;A/Bk9pCN;;A+B78pCA;EACE,qBAAA;EACA,kBnB41BgC;AZonoClC;;A+B78pCA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;A/Bg9pCF;A+B58pCI;EACE,oBAAA;EACA,YAAA;EACA,anB+rBwB;AZ+woC9B;;A+Bv8pCI;EACE,6DAAA;A/B08pCN;;AgC7nqCA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;AhCgoqCF;AgC9nqCE;EACE,UAAA;AhCgoqCJ;AgC5nqCI;EAA0B,mCpB+iCa;AZgloC3C;AgC9nqCI;EAA0B,mCpB8iCa;AZmloC3C;AgC9nqCE;EACE,SAAA;AhCgoqCJ;AgC7nqCE;EACE,WpBgiCuC;EoB/hCvC,YpB+hCuC;EoB9hCvC,oBAAA;EACA,gBAAA;EH1BF,yBjBmHQ;EoBvFN,SpB8hCuC;EC3iCvC,mBAAA;EeHE,oHImBF;EJnBE,4GImBF;AhC8nqCJ;A4B7oqCM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;E5BgpqCN;AACF;AgCjoqCI;EHjCF,wCjB+jCyC;AZsmoC3C;AgC/nqCE;EACE,WpBygC8B;EoBxgC9B,cpBygC8B;EoBxgC9B,kBAAA;EACA,epBwgC8B;EoBvgC9B,yBpB8CO;EoB7CP,yBAAA;EnB7BA,mBAAA;Ab+pqCJ;AgC7nqCE;EACE,WpBqgCuC;EoBpgCvC,YpBogCuC;EoBngCvC,gBAAA;EHpDF,yBjBmHQ;EoB7DN,SpBogCuC;EC3iCvC,mBAAA;EeHE,iHI6CF;EJ7CE,4GI6CF;AhC8nqCJ;A4BvqqCM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;E5B0qqCN;AACF;AgCjoqCI;EH3DF,wCjB+jCyC;AZgooC3C;AgC/nqCE;EACE,WpB++B8B;EoB9+B9B,cpB++B8B;EoB9+B9B,kBAAA;EACA,epB8+B8B;EoB7+B9B,yBpBoBO;EoBnBP,yBAAA;EnBvDA,mBAAA;AbyrqCJ;AgC7nqCE;EACE,oBAAA;AhC+nqCJ;AgC7nqCI;EACE,yBpBYK;AZmnqCX;AgC5nqCI;EACE,yBpBQK;AZsnqCX;;AiCrtqCA;EACE,kBAAA;AjCwtqCF;AiCttqCE;;;EAGE,0BrBykC8B;EqBxkC9B,8BrBwkC8B;EqBvkC9B,iBrBwkC8B;AZgpoClC;AiCrtqCE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,6BAAA;EACA,qBAAA;ELRE,gEKSF;AjCutqCJ;A4B5tqCM;EKTJ;ILUM,gBAAA;E5B+tqCN;AACF;AiCztqCE;;EAEE,qBAAA;AjC2tqCJ;AiCztqCI;;EACE,kBAAA;AjC4tqCN;AiCztqCI;;;EAEE,qBrB6iC4B;EqB5iC5B,wBrB6iC4B;AZ+qoClC;AiCztqCI;;EACE,qBrBwiC4B;EqBviC5B,wBrBwiC4B;AZoroClC;AiCxtqCE;EACE,qBrBkiC8B;EqBjiC9B,wBrBkiC8B;AZwroClC;AiCntqCI;;;;EACE,2CAAA;EACA,8DrB2hC4B;AZ6roClC;AiCttqCM;;;;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,aCm/BgC;EDl/BhC,WAAA;EACA,sBrBuBG;ECvEP,sBAAA;Ab4wqCJ;AiCrtqCI;EACE,2CAAA;EACA,8DrB0gC4B;AZ6soClC;AiCltqCI;EACE,mBAAA;AjCotqCN;AiChtqCE;;EAEE,cC1EO;AlC4xqCX;AiChtqCI;;EACE,yBrBCK;AZktqCX;;AmC1yqCA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;AnC6yqCF;AmC3yqCE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;AnC6yqCJ;AmCzyqCE;;;EAGE,UAAA;AnC2yqCJ;AmCryqCE;EACE,kBAAA;EACA,UAAA;AnCuyqCJ;AmCryqCI;EACE,UAAA;AnCuyqCN;;AmC5xqCA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;E1B8OI,iBALI;E0BvOR,gBvBgnB4B;EuB/mB5B,gBvBqnB4B;EuBpnB5B,cvB4CS;EuB3CT,kBAAA;EACA,mBAAA;EACA,yBvBoCS;EuBnCT,yBAAA;EtBtCE,sBAAA;Abs0qCJ;;AmCtxqCA;;;;EAIE,oBAAA;E1BwNI,mBALI;EIvQN,qBAAA;Ab+0qCJ;;AmCtxqCA;;;;EAIE,uBAAA;E1B+MI,oBALI;EIvQN,qBAAA;Abw1qCJ;;AmCtxqCA;;EAEE,qBAAA;AnCyxqCF;;AmC5wqCI;;;;EtBjEA,0BAAA;EACA,6BAAA;Abo1qCJ;AmC3wqCI;;;;EtB1EA,0BAAA;EACA,6BAAA;Ab21qCJ;AmCrwqCE;EACE,2BAAA;EtB1EA,yBAAA;EACA,4BAAA;Abk1qCJ;AmCrwqCE;;EtB9EE,yBAAA;EACA,4BAAA;Abu1qCJ;;AoC/2qCE;EACE,aAAA;EACA,WAAA;EACA,mBxB82BoC;EH5mBlC,gBALI;E2B1PN,cxB0kCqB;AZuyoCzB;;AoC92qCE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;E3BqPE,oBALI;E2B7ON,WAxBc;EAyBd,yCAxBiB;EvBHjB,sBAAA;Ab44qCJ;;AoC52qCI;;;;EAEE,cAAA;ApCi3qCN;;AoCh6qCI;EAqDE,qBxB+iCmB;EwB5iCjB,oCxBo4BgC;EwBn4BhC,0DAAA;EACA,4BAAA;EACA,0DAAA;EACA,8DAAA;ApC62qCR;AoC12qCM;EACE,qBxBoiCiB;EwBniCjB,kDAhDa;ApC45qCrB;;AoC76qCI;EA0EI,oCxBk3BgC;EwBj3BhC,gFAAA;ApCu2qCR;;AoCl7qCI;EAkFE,qBxBkhCmB;AZk1oCzB;AoCj2qCQ;EAEE,kEAAA;EACA,sCxB87B8B;EwB77B9B,8DAAA;EACA,yEAAA;ApCk2qCV;AoC91qCM;EACE,qBxBqgCiB;EwBpgCjB,kDA/Ea;ApC+6qCrB;;AoCh8qCI;EAwGI,yCAAA;ApC41qCR;;AoCp8qCI;EA+GE,qBxBq/BmB;AZo2oCzB;AoCv1qCM;EACE,yBxBk/BiB;AZu2oCzB;AoCt1qCM;EACE,kDArGa;ApC67qCrB;AoCr1qCM;EACE,cxB0+BiB;AZ62oCzB;;AoCl1qCI;EACE,kBAAA;ApCq1qCN;;AoCr9qCI;;;;;EA0IM,UAAA;ApCm1qCV;;AoCz8qCE;EACE,aAAA;EACA,WAAA;EACA,mBxB82BoC;EH5mBlC,gBALI;E2B1PN,cxB0kCqB;AZi4oCzB;;AoCx8qCE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;E3BqPE,oBALI;E2B7ON,WAxBc;EAyBd,0CAxBiB;EvBHjB,sBAAA;Abs+qCJ;;AoCt8qCI;;;;EAEE,cAAA;ApC28qCN;;AoC1/qCI;EAqDE,qBxB+iCmB;EwB5iCjB,oCxBo4BgC;EwBn4BhC,0DAAA;EACA,4BAAA;EACA,0DAAA;EACA,8DAAA;ApCu8qCR;AoCp8qCM;EACE,qBxBoiCiB;EwBniCjB,mDAhDa;ApCs/qCrB;;AoCvgrCI;EA0EI,oCxBk3BgC;EwBj3BhC,gFAAA;ApCi8qCR;;AoC5grCI;EAkFE,qBxBkhCmB;AZ46oCzB;AoC37qCQ;EAEE,kEAAA;EACA,sCxB87B8B;EwB77B9B,8DAAA;EACA,yEAAA;ApC47qCV;AoCx7qCM;EACE,qBxBqgCiB;EwBpgCjB,mDA/Ea;ApCygrCrB;;AoC1hrCI;EAwGI,yCAAA;ApCs7qCR;;AoC9hrCI;EA+GE,qBxBq/BmB;AZ87oCzB;AoCj7qCM;EACE,yBxBk/BiB;AZi8oCzB;AoCh7qCM;EACE,mDArGa;ApCuhrCrB;AoC/6qCM;EACE,cxB0+BiB;AZu8oCzB;;AoC56qCI;EACE,kBAAA;ApC+6qCN;;AoC/irCI;;;;;EA4IM,UAAA;ApC26qCV;;AqCzjrCA;EAEE,2BAAA;EACA,2BAAA;EACA,sBAAA;E5BuRI,0BALI;E4BhRR,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,0BAAA;EACA,kCAAA;EACA,+BAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E5BsQI,kCALI;E4B/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EAGA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mEAAA;ExBjBE,0CAAA;EgBfF,kCQkCqB;ETtBjB,qISwBJ;ArCsjrCF;A4B1krCM;EShBN;ITiBQ,gBAAA;E5B6krCN;AACF;AqCzjrCE;EACE,gCAAA;EAEA,wCAAA;EACA,8CAAA;ArC0jrCJ;AqCvjrCE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;ArCwjrCJ;AqCrjrCE;EACE,gCAAA;ERrDF,wCQsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;ArCmjrCN;AqC/irCE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;ArC6irCN;AqCzirCE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;ArCqirCJ;AqClirCI;EAKI,0CAAA;ArCgirCR;AqC3hrCE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;ArC0hrCJ;;AqC9grCE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,iDAAA;EACA,wCAAA;EACA,2BAAA;EACA,wCAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AtCwnrCF;;AqC/hrCE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EACA,iDAAA;EACA,wCAAA;EACA,2BAAA;EACA,wCAAA;EACA,iDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AtCyorCF;;AqChjrCE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,kDAAA;EACA,uCAAA;EACA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AtC0prCF;;AqCjkrCE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0CAAA;EACA,gDAAA;EACA,wCAAA;EACA,2BAAA;EACA,uCAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AtC2qrCF;;AqCllrCE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EACA,kDAAA;EACA,wCAAA;EACA,2BAAA;EACA,yCAAA;EACA,kDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AtC4rrCF;;AqCnmrCE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EACA,mDAAA;EACA,wCAAA;EACA,2BAAA;EACA,0CAAA;EACA,kDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AtC6srCF;;AqCpnrCE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,wCAAA;EACA,kDAAA;EACA,uCAAA;EACA,2BAAA;EACA,yCAAA;EACA,iDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AtC8trCF;;AqCrorCE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,mDAAA;EACA,wCAAA;EACA,2BAAA;EACA,0CAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AtC+urCF;;AqCtprCE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,kDAAA;EACA,qCAAA;EACA,2BAAA;EACA,0CAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AtCgwrCF;;AqCvqrCE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,mDAAA;EACA,uCAAA;EACA,2BAAA;EACA,0CAAA;EACA,sDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AtCixrCF;;AqC9prCE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AtCywrCF;;AqC/qrCE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AtC0xrCF;;AqChsrCE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AtC2yrCF;;AqCjtrCE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AtC4zrCF;;AqClurCE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AtC60rCF;;AqCnvrCE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AtC81rCF;;AqCpwrCE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AtC+2rCF;;AqCrxrCE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AtCg4rCF;;AqCtyrCE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AtCi5rCF;;AqCvzrCE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AtCk6rCF;;AqC5zrCA;EACE,yBAAA;EACA,uBAAA;EACA,wBAAA;EACA,kCAAA;EACA,uEAAA;EACA,wCAAA;EACA,wEAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,uCAAA;EAEA,qBzBmWwC;AZ29qC1C;AqCpzrCE;EACE,0BAAA;ArCszrCJ;AqCnzrCE;EACE,gCAAA;ArCqzrCJ;;AqC1yrCA;ECxIE,0BAAA;EACA,wBAAA;E7B8NI,4BALI;E6BvNR,8BAAA;AtCs7rCF;;AqC7yrCA;EC5IE,2BAAA;EACA,0BAAA;E7B8NI,6BALI;E6BvNR,8BAAA;AtC67rCF;;AuChgsCA;EXgBM,gCWfJ;AvCmgsCF;A4Bh/rCM;EWpBN;IXqBQ,gBAAA;E5Bm/rCN;AACF;AuCtgsCE;EACE,UAAA;AvCwgsCJ;;AuClgsCE;EACE,aAAA;AvCqgsCJ;;AuCjgsCA;EACE,SAAA;EACA,gBAAA;EXDI,6BWEJ;AvCogsCF;A4BlgsCM;EWLN;IXMQ,gBAAA;E5BqgsCN;AACF;AuCvgsCE;EACE,QAAA;EACA,YAAA;EXNE,4BWOF;AvCygsCJ;A4B5gsCM;EWAJ;IXCM,gBAAA;E5B+gsCN;AACF;;AwCpisCA;;;;;;EAME,kBAAA;AxCuisCF;;AwCpisCA;EACE,mBAAA;AxCuisCF;;AwChisCA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;E/BuQI,+BALI;E+BhQR,4BAAA;EACA,sBAAA;EACA,+CAAA;EACA,oCAAA;EACA,6BAAA;EACA,0CAAA;EACA,6CAAA;EACA,sCAAA;EACA,0DAAA;EACA,iCAAA;EACA,qDAAA;EACA,oCAAA;EACA,sDAAA;EACA,qCAAA;EACA,0CAAA;EACA,oCAAA;EACA,qCAAA;EACA,mCAAA;EACA,oCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E/B0OI,uCALI;E+BnOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E3BzCE,+CAAA;Ab0ksCJ;AwC7hsCE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AxC+hsCJ;;AwCvgsCI;EACE,oBAAA;AxC0gsCN;AwCxgsCM;EACE,WAAA;EACA,OAAA;AxC0gsCR;;AwCtgsCI;EACE,kBAAA;AxCygsCN;AwCvgsCM;EACE,QAAA;EACA,UAAA;AxCygsCR;;AoBnjsCI;EoB4BA;IACE,oBAAA;ExC2hsCJ;EwCzhsCI;IACE,WAAA;IACA,OAAA;ExC2hsCN;EwCvhsCE;IACE,kBAAA;ExCyhsCJ;EwCvhsCI;IACE,QAAA;IACA,UAAA;ExCyhsCN;AACF;AoBpksCI;EoB4BA;IACE,oBAAA;ExC2isCJ;EwCzisCI;IACE,WAAA;IACA,OAAA;ExC2isCN;EwCvisCE;IACE,kBAAA;ExCyisCJ;EwCvisCI;IACE,QAAA;IACA,UAAA;ExCyisCN;AACF;AoBplsCI;EoB4BA;IACE,oBAAA;ExC2jsCJ;EwCzjsCI;IACE,WAAA;IACA,OAAA;ExC2jsCN;EwCvjsCE;IACE,kBAAA;ExCyjsCJ;EwCvjsCI;IACE,QAAA;IACA,UAAA;ExCyjsCN;AACF;AoBpmsCI;EoB4BA;IACE,oBAAA;ExC2ksCJ;EwCzksCI;IACE,WAAA;IACA,OAAA;ExC2ksCN;EwCvksCE;IACE,kBAAA;ExCyksCJ;EwCvksCI;IACE,QAAA;IACA,UAAA;ExCyksCN;AACF;AoBpnsCI;EoB4BA;IACE,oBAAA;ExC2lsCJ;EwCzlsCI;IACE,WAAA;IACA,OAAA;ExC2lsCN;EwCvlsCE;IACE,kBAAA;ExCylsCJ;EwCvlsCI;IACE,QAAA;IACA,UAAA;ExCylsCN;AACF;AwChlsCE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AxCklsCJ;AwCzksCE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AxC2ksCJ;AwCtksCI;EACE,iBAAA;AxCwksCN;;AwClksCE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AxCqksCJ;AwChksCI;EACE,iBAAA;AxCkksCN;;AwC3jsCA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AxC8jsCF;;AwCxjsCA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gB5Bgf4B;E4B/e5B,oCAAA;EACA,mBAAA;EAEA,mBAAA;EACA,6BAAA;EACA,SAAA;E3BtKE,uDAAA;AbiusCJ;AwCxjsCE;EAEE,0CAAA;EX1LF,kDW4LuB;AxCwjsCzB;AwCrjsCE;EAEE,2CAAA;EACA,qBAAA;EXlMF,mDWmMuB;AxCsjsCzB;AwCnjsCE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AxCojsCJ;;AwC9isCA;EACE,cAAA;AxCijsCF;;AwC7isCA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E/BmEI,oBALI;E+B5DR,sCAAA;EACA,mBAAA;AxCgjsCF;;AwC5isCA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AxC+isCF;;AwC3isCA;EAEE,4BAAA;EACA,yBAAA;EACA,+CAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,6CAAA;EACA,sDAAA;EACA,sDAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;AxC6isCF;;AyCnysCA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AzCsysCF;AyCpysCE;;EACE,kBAAA;EACA,cAAA;AzCuysCJ;AyClysCE;;;;;;;;;;;;EAME,UAAA;AzC0ysCJ;;AyCrysCA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AzCwysCF;AyCtysCE;EACE,WAAA;AzCwysCJ;;AyCpysCA;E5BhBI,sBAAA;AbwzsCJ;AyCpysCE;;EAEE,2BAAA;AzCsysCJ;AyClysCE;;;E5BVE,0BAAA;EACA,6BAAA;AbizsCJ;AyC9xsCE;;;E5BNE,yBAAA;EACA,4BAAA;AbyysCJ;;AyCjxsCA;EACE,wBAAA;EACA,uBAAA;AzCoxsCF;AyClxsCE;EAGE,cAAA;AzCkxsCJ;AyC/wsCE;EACE,eAAA;AzCixsCJ;;AyC7wsCA;EACE,uBAAA;EACA,sBAAA;AzCgxsCF;;AyC7wsCA;EACE,sBAAA;EACA,qBAAA;AzCgxsCF;;AyC5vsCA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AzC+vsCF;AyC7vsCE;;EAEE,WAAA;AzC+vsCJ;AyC5vsCE;;EAEE,0BAAA;AzC8vsCJ;AyC1vsCE;;E5B1FE,6BAAA;EACA,4BAAA;Abw1sCJ;AyC1vsCE;;E5B7GE,yBAAA;EACA,0BAAA;Ab22sCJ;;A0Cn4sCA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,qCAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;A1Ck4sCF;;A0C/3sCA;EACE,cAAA;EACA,kEAAA;EjCsQI,uCALI;EiC/PR,2CAAA;EACA,+BAAA;EAEA,gBAAA;EACA,SAAA;EdfI,uGcgBJ;A1Ci4sCF;A4B74sCM;EcGN;IdFQ,gBAAA;E5Bg5sCN;AACF;A0Cp4sCE;EAEE,qCAAA;A1Cq4sCJ;A0Cj4sCE;EACE,UAAA;EACA,kDRkhBoB;AlCi3rCxB;A0C/3sCE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;A1Cg4sCJ;;A0Cx3sCA;EAEE,+BAAA;EACA,mCAAA;EACA,oCAAA;EACA,8DAAA;EACA,wCAAA;EACA,+CAAA;EACA,yEAAA;EAGA,oFAAA;A1Cw3sCF;A0Ct3sCE;EACE,yDAAA;EACA,yDAAA;E7B7CA,wDAAA;EACA,yDAAA;Abs6sCJ;A0Cv3sCI;EAGE,kBAAA;EACA,wDAAA;A1Cu3sCN;A0Cn3sCE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;A1Cq3sCJ;A0Cl3sCE;EAEE,sDAAA;E7BjEA,yBAAA;EACA,0BAAA;Abq7sCJ;;A0C12sCA;EAEE,qCAAA;EACA,sCAAA;EACA,sCAAA;A1C42sCF;A0Cz2sCE;E7B5FE,gDAAA;Abw8sCJ;A0Cx2sCE;;EAEE,4CAAA;EbjHF,oDakHuB;A1C02sCzB;;A0Cj2sCA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;A1Ci2sCF;A0C/1sCE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;A1Ci2sCJ;A0C/1sCI;EAEE,iCAAA;A1Cg2sCN;A0C51sCE;;EAEE,gB9B+gB0B;E8B9gB1B,gDAAA;EACA,iCAAA;A1C81sCJ;;A0Cp1sCE;;EAEE,cAAA;EACA,kBAAA;A1Cu1sCJ;;A0Cl1sCE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;A1Cq1sCJ;;A0C/0sCE;;EACE,WAAA;A1Cm1sCJ;;A0Cz0sCE;EACE,aAAA;A1C40sCJ;A0C10sCE;EACE,cAAA;A1C40sCJ;;A2CzgtCA;EAEE,wBAAA;EACA,6BAAA;EACA,sCAAA;EACA,2CAAA;EACA,8CAAA;EACA,4CAAA;EACA,uCAAA;EACA,kCAAA;EACA,qCAAA;EACA,2CAAA;EACA,iDAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,uCAAA;EACA,qEAAA;EACA,oDAAA;EACA,0CAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;A3CygtCF;A2CngtCE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;A3C2gtCJ;A2Cv/sCA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;ElC4NI,2CALI;EkCrNR,mCAAA;EAEA,mBAAA;A3Cw/sCF;A2Ct/sCE;EAEE,yCAAA;A3Cu/sCJ;;A2C7+sCA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;A3C4+sCF;A2Cz+sCI;EAEE,oCAAA;A3C0+sCN;A2Ct+sCE;EACE,gBAAA;A3Cw+sCJ;;A2C/9sCA;EACE,mB/BmhCkC;E+BlhClC,sB/BkhCkC;E+BjhClC,6BAAA;A3Ck+sCF;A2Ch+sCE;;;EAGE,oCAAA;A3Ck+sCJ;;A2Cr9sCA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;A3Cs9sCF;;A2Cl9sCA;EACE,8EAAA;ElCyII,6CALI;EkClIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;E9BxIE,qDAAA;EeHE,+Ce6IJ;A3Cq9sCF;A4B9ltCM;EeiIN;IfhIQ,gBAAA;E5BimtCN;AACF;A2Cx9sCE;EACE,qBAAA;A3C09sCJ;A2Cv9sCE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;A3Cy9sCJ;;A2Cn9sCA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;A3Cs9sCF;;A2Cn9sCA;EACE,yCAAA;EACA,gBAAA;A3Cs9sCF;;AoBhltCI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;E3C68sCN;E2C38sCM;IACE,mBAAA;E3C68sCR;E2C38sCQ;IACE,kBAAA;E3C68sCV;E2C18sCQ;IACE,kDAAA;IACA,iDAAA;E3C48sCV;E2Cx8sCM;IACE,iBAAA;E3C08sCR;E2Cv8sCM;IACE,wBAAA;IACA,gBAAA;E3Cy8sCR;E2Ct8sCM;IACE,aAAA;E3Cw8sCR;E2Cr8sCM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;E3Cq8sCR;E2Cl8sCQ;IACE,aAAA;E3Co8sCV;E2Cj8sCQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;E3Cm8sCV;AACF;AoBhotCI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;E3C4/sCN;E2C1/sCM;IACE,mBAAA;E3C4/sCR;E2C1/sCQ;IACE,kBAAA;E3C4/sCV;E2Cz/sCQ;IACE,kDAAA;IACA,iDAAA;E3C2/sCV;E2Cv/sCM;IACE,iBAAA;E3Cy/sCR;E2Ct/sCM;IACE,wBAAA;IACA,gBAAA;E3Cw/sCR;E2Cr/sCM;IACE,aAAA;E3Cu/sCR;E2Cp/sCM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;E3Co/sCR;E2Cj/sCQ;IACE,aAAA;E3Cm/sCV;E2Ch/sCQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;E3Ck/sCV;AACF;AoB/qtCI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;E3C2itCN;E2CzitCM;IACE,mBAAA;E3C2itCR;E2CzitCQ;IACE,kBAAA;E3C2itCV;E2CxitCQ;IACE,kDAAA;IACA,iDAAA;E3C0itCV;E2CtitCM;IACE,iBAAA;E3CwitCR;E2CritCM;IACE,wBAAA;IACA,gBAAA;E3CuitCR;E2CpitCM;IACE,aAAA;E3CsitCR;E2CnitCM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;E3CmitCR;E2ChitCQ;IACE,aAAA;E3CkitCV;E2C/htCQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;E3CiitCV;AACF;AoB9ttCI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;E3C0ltCN;E2CxltCM;IACE,mBAAA;E3C0ltCR;E2CxltCQ;IACE,kBAAA;E3C0ltCV;E2CvltCQ;IACE,kDAAA;IACA,iDAAA;E3CyltCV;E2CrltCM;IACE,iBAAA;E3CultCR;E2CpltCM;IACE,wBAAA;IACA,gBAAA;E3CsltCR;E2CnltCM;IACE,aAAA;E3CqltCR;E2ClltCM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;E3CkltCR;E2C/ktCQ;IACE,aAAA;E3CiltCV;E2C9ktCQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;E3CgltCV;AACF;AoB7wtCI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;E3CyotCN;E2CvotCM;IACE,mBAAA;E3CyotCR;E2CvotCQ;IACE,kBAAA;E3CyotCV;E2CtotCQ;IACE,kDAAA;IACA,iDAAA;E3CwotCV;E2CpotCM;IACE,iBAAA;E3CsotCR;E2CnotCM;IACE,wBAAA;IACA,gBAAA;E3CqotCR;E2ClotCM;IACE,aAAA;E3CootCR;E2CjotCM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;E3CiotCR;E2C9ntCQ;IACE,aAAA;E3CgotCV;E2C7ntCQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;E3C+ntCV;AACF;A2CtrtCI;EAEI,iBAAA;EACA,2BAAA;A3CurtCR;A2CrrtCQ;EACE,mBAAA;A3CurtCV;A2CrrtCU;EACE,kBAAA;A3CurtCZ;A2CprtCU;EACE,kDAAA;EACA,iDAAA;A3CsrtCZ;A2ClrtCQ;EACE,iBAAA;A3CortCV;A2CjrtCQ;EACE,wBAAA;EACA,gBAAA;A3CmrtCV;A2ChrtCQ;EACE,aAAA;A3CkrtCV;A2C/qtCQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ef9NJ,gBegOI;A3C+qtCV;A2C5qtCU;EACE,aAAA;A3C8qtCZ;A2C3qtCU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;A3C6qtCZ;;A2C5ptCA;;EAGE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,qEAAA;A3C8ptCF;;A2CxptCI;EACE,qEAAA;A3C2ptCN;;A4Cp7tCA;EAEE,2BAAA;EACA,2BAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,yBAAA;EACA,+BAAA;EACA,gCAAA;EACA,sBAAA;EACA,sCAAA;EACA,gCAAA;EACA,gCAAA;EACA,qCAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mCAAA;EACA,gCAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;E/BjBE,2CAAA;Abs8tCJ;A4Cj7tCE;EACE,eAAA;EACA,cAAA;A5Cm7tCJ;A4Ch7tCE;EACE,mBAAA;EACA,sBAAA;A5Ck7tCJ;A4Ch7tCI;EACE,mBAAA;E/BtBF,0DAAA;EACA,2DAAA;Aby8tCJ;A4Ch7tCI;EACE,sBAAA;E/BbF,8DAAA;EACA,6DAAA;Abg8tCJ;A4C76tCE;;EAEE,aAAA;A5C+6tCJ;;A4C36tCA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;A5C46tCF;;A4Cz6tCA;EACE,4CAAA;EACA,iCAAA;A5C46tCF;;A4Cz6tCA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;A5C46tCF;;A4Cz6tCA;EACE,gBAAA;A5C46tCF;;A4Cp6tCE;EACE,oCAAA;A5Cu6tCJ;;A4C/5tCA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;A5Ck6tCF;A4Ch6tCE;E/B7FE,wFAAA;AbgguCJ;;A4C95tCA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;A5Ci6tCF;A4C/5tCE;E/BxGE,wFAAA;Ab0guCJ;;A4Cx5tCA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;A5C25tCF;A4Cz5tCE;EACE,mCAAA;EACA,sCAAA;A5C25tCJ;;A4Cv5tCA;EACE,uDAAA;EACA,sDAAA;A5C05tCF;;A4Ct5tCA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;E/B1IE,iDAAA;AboiuCJ;;A4Ct5tCA;;;EAGE,WAAA;A5Cy5tCF;;A4Ct5tCA;;E/B3II,0DAAA;EACA,2DAAA;AbsiuCJ;;A4Cv5tCA;;E/BlII,8DAAA;EACA,6DAAA;Ab8huCJ;;A4Ch5tCE;EACE,0CAAA;A5Cm5tCJ;AoB9guCI;EwBuHJ;IAQI,aAAA;IACA,mBAAA;E5Cm5tCF;E4Ch5tCE;IAEE,SAAA;IACA,gBAAA;E5Ci5tCJ;E4C/4tCI;IACE,cAAA;IACA,cAAA;E5Ci5tCN;E4C54tCM;I/B3KJ,0BAAA;IACA,6BAAA;Eb0juCF;E4C74tCQ;;IAGE,0BAAA;E5C84tCV;E4C54tCQ;;IAGE,6BAAA;E5C64tCV;E4Cz4tCM;I/B5KJ,yBAAA;IACA,4BAAA;EbwjuCF;E4C14tCQ;;IAGE,yBAAA;E5C24tCV;E4Cz4tCQ;;IAGE,4BAAA;E5C04tCV;AACF;;A6C/muCA;EAEE,6BAAA;EACA,8BAAA;EACA,8KAAA;EACA,iDAAA;EACA,gCAAA;EACA,qCAAA;EACA,uDAAA;EACA,qCAAA;EACA,kCAAA;EACA,iCAAA;EACA,kCAAA;EACA,iEAAA;EACA,mCAAA;EACA,iDAAA;EACA,8DAAA;EACA,wEAAA;EACA,+DAAA;EACA,yCAAA;EACA,sCAAA;EACA,mCAAA;EACA,oDAAA;EACA,gDAAA;A7CinuCF;;A6C7muCA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EpC2PI,iBALI;EoCpPR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EhCtBE,gBAAA;EgCwBF,qBAAA;EjB3BI,0CiB4BJ;A7CgnuCF;A4BxouCM;EiBWN;IjBVQ,gBAAA;E5B2ouCN;AACF;A6CnnuCE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;A7CqnuCJ;A6CnnuCI;EACE,qDAAA;EACA,iDAAA;A7CqnuCN;A6ChnuCE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EjBlDE,mDiBmDF;A7CknuCJ;A4BjquCM;EiBsCJ;IjBrCM,gBAAA;E5BoquCN;AACF;A6CpnuCE;EACE,UAAA;A7CsnuCJ;A6CnnuCE;EACE,UAAA;EACA,wDAAA;EACA,UAAA;EACA,oDAAA;A7CqnuCJ;;A6CjnuCA;EACE,gBAAA;A7ConuCF;;A6CjnuCA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;A7ConuCF;A6ClnuCE;EhC/DE,yDAAA;EACA,0DAAA;AboruCJ;A6CnnuCI;EhClEA,+DAAA;EACA,gEAAA;AbwruCJ;A6ClnuCE;EACE,aAAA;A7ConuCJ;A6ChnuCE;EhC9DE,6DAAA;EACA,4DAAA;AbiruCJ;A6ChnuCM;EhClEF,mEAAA;EACA,kEAAA;AbqruCJ;A6C/muCI;EhCvEA,6DAAA;EACA,4DAAA;AbyruCJ;;A6C7muCA;EACE,8EAAA;A7CgnuCF;;A6CvmuCE;EACE,eAAA;A7C0muCJ;A6CvmuCE;EACE,eAAA;EACA,cAAA;EhCpHA,gBAAA;Ab8tuCJ;A6CvmuCI;EAAgB,aAAA;A7C0muCpB;A6CzmuCI;EAAe,gBAAA;A7C4muCnB;A6CzmuCM;EhC3HF,gBAAA;AbuuuCJ;;A6ClmuCI;EACE,iEAAA;EACA,wEAAA;A7CqmuCN;;A8C/vuCA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,sCAAA;EACA,sCAAA;EACA,0CAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;ErC+QI,yCALI;EqCxQR,gBAAA;EACA,yCAAA;EjCAE,iDAAA;Ab+vuCJ;;A8CzvuCE;EACE,iDAAA;A9C4vuCJ;A8C1vuCI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,uFAAA;A9C4vuCN;A8CxvuCE;EACE,6CAAA;A9C0vuCJ;;A+C/xuCA;EAEE,kCAAA;EACA,mCAAA;EtC4RI,+BALI;EsCrRR,8BAAA;EACA,wBAAA;EACA,iCAAA;EACA,qCAAA;EACA,sCAAA;EACA,8EAAA;EACA,iCAAA;EACA,2CAAA;EACA,8EAAA;EACA,iCAAA;EACA,wEAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,uCAAA;EACA,iCAAA;EACA,8CAAA;EAGA,aAAA;EhCpBA,eAAA;EACA,gBAAA;AfozuCF;;A+C7xuCA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;EtCgQI,yCALI;EsCzPR,iCAAA;EAEA,yCAAA;EACA,iFAAA;EnBpBI,qImBqBJ;A/C+xuCF;A4BhzuCM;EmBQN;InBPQ,gBAAA;E5BmzuCN;AACF;A+ClyuCE;EACE,UAAA;EACA,uCAAA;EAEA,+CAAA;EACA,qDAAA;A/CmyuCJ;A+ChyuCE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UnCouCgC;EmCnuChC,iDAAA;A/CkyuCJ;A+C/xuCE;EAEE,UAAA;EACA,wCAAA;ElBtDF,gDkBuDuB;EACrB,sDAAA;A/CgyuCJ;A+C7xuCE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;A/C8xuCJ;;A+CzxuCE;EACE,iBnCusCgC;AZqlsCpC;A+C3wuCI;ElCxEA,iDAAA;Abs1uCJ;;A+CnwuCA;EClGE,iCAAA;EACA,kCAAA;EvC0RI,mCALI;EuCnRR,qCAAA;AhDy2uCF;;A+CtwuCA;ECtGE,iCAAA;EACA,kCAAA;EvC0RI,oCALI;EuCnRR,qCAAA;AhDg3uCF;;AiDl3uCA;EAEE,2BAAA;EACA,4BAAA;ExCuRI,yBALI;EwChRR,2BAAA;EACA,sBAAA;EACA,iCAAA;EAGA,qBAAA;EACA,4DAAA;ExC+QI,oCALI;EwCxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EpCJE,4CAAA;Abu3uCJ;AiD92uCE;EACE,aAAA;AjDg3uCJ;;AiD32uCA;EACE,kBAAA;EACA,SAAA;AjD82uCF;;AkD94uCA;EAEE,0BAAA;EACA,6BAAA;EACA,6BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,yDAAA;EACA,iCAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;ErCHE,4CAAA;Abk5uCJ;;AkD14uCA;EAEE,cAAA;AlD44uCF;;AkDx4uCA;EACE,gBtCkoB4B;EsCjoB5B,iCAAA;AlD24uCF;;AkDn4uCA;EACE,sBtC49CkC;AZ06rCpC;AkDn4uCE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,0BAAA;AlDq4uCJ;;AkD73uCE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;AlDg4uCJ;;AkDp4uCE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;AlDu4uCJ;;AkD34uCE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;AlD84uCJ;;AkDl5uCE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;AlDq5uCJ;;AkDz5uCE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;AlD45uCJ;;AkDh6uCE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;AlDm6uCJ;;AkDv6uCE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;AlD06uCJ;;AkD96uCE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;AlDi7uCJ;;AkDr7uCE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;AlDw7uCJ;;AkD57uCE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;AlD+7uCJ;;AmD3/uCE;EACE;IAAK,+BvC0gD2B;EZq/rClC;AACF;AmD3/uCA;;EAGE,8BAAA;E1CkRI,iCALI;E0C3QR,yBAAA;EACA,oCAAA;EACA,8DAAA;EACA,6BAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;E1CsQI,uCALI;E0C/PR,uCAAA;EtCRE,+CAAA;AbmgvCJ;;AmDt/uCA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EvBxBI,6CuByBJ;AnDy/uCF;A4B9gvCM;EuBYN;IvBXQ,gBAAA;E5BihvCN;AACF;;AmD3/uCA;EtBAE,qMAAA;EsBEA,oEAAA;AnD8/uCF;;AmD3/uCA;EACE,iBAAA;AnD8/uCF;;AmD3/uCA;EACE,WAAA;AnD8/uCF;;AmD1/uCE;EACE,kDAAA;AnD6/uCJ;AmD1/uCM;EAJJ;IAKM,eAAA;EnD6/uCN;AACF;;AoDzjvCA;EAEE,2CAAA;EACA,wBAAA;EACA,qCAAA;EACA,iCAAA;EACA,sCAAA;EACA,uCAAA;EACA,uCAAA;EACA,qCAAA;EACA,2CAAA;EACA,wCAAA;EACA,4CAAA;EACA,yCAAA;EACA,uCAAA;EACA,iCAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EvCXE,iDAAA;AbmkvCJ;;AoDpjvCA;EACE,qBAAA;EACA,sBAAA;ApDujvCF;AoDrjvCE;EAEE,oCAAA;EACA,0BAAA;ApDsjvCJ;;AoD7ivCA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;ApDgjvCF;AoD7ivCE;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;ApD8ivCJ;AoD3ivCE;EACE,+CAAA;EACA,uDAAA;ApD6ivCJ;;AoDrivCA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EAEA,yCAAA;EACA,iFAAA;ApDuivCF;AoDrivCE;EvCvDE,+BAAA;EACA,gCAAA;Ab+lvCJ;AoDrivCE;EvC7CE,mCAAA;EACA,kCAAA;AbqlvCJ;AoDrivCE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;ApDsivCJ;AoDlivCE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;ApDoivCJ;AoDhivCE;EACE,mBAAA;ApDkivCJ;AoDhivCI;EACE,wDAAA;EACA,mDAAA;ApDkivCN;;AoDrhvCI;EACE,mBAAA;ApDwhvCN;AoDrhvCQ;EvCvDJ,6DAAA;EAZA,0BAAA;Ab4lvCJ;AoDphvCQ;EvCxEJ,2DAAA;EAYA,4BAAA;AbolvCJ;AoDnhvCQ;EACE,aAAA;ApDqhvCV;AoDlhvCQ;EACE,mDAAA;EACA,oBAAA;ApDohvCV;AoDlhvCU;EACE,yDAAA;EACA,oDAAA;ApDohvCZ;;AoB1mvCI;EgC8DA;IACE,mBAAA;EpDgjvCJ;EoD7ivCM;IvCvDJ,6DAAA;IAZA,0BAAA;EbonvCF;EoD5ivCM;IvCxEJ,2DAAA;IAYA,4BAAA;Eb4mvCF;EoD3ivCM;IACE,aAAA;EpD6ivCR;EoD1ivCM;IACE,mDAAA;IACA,oBAAA;EpD4ivCR;EoD1ivCQ;IACE,yDAAA;IACA,oDAAA;EpD4ivCV;AACF;AoBnovCI;EgC8DA;IACE,mBAAA;EpDwkvCJ;EoDrkvCM;IvCvDJ,6DAAA;IAZA,0BAAA;Eb4ovCF;EoDpkvCM;IvCxEJ,2DAAA;IAYA,4BAAA;EboovCF;EoDnkvCM;IACE,aAAA;EpDqkvCR;EoDlkvCM;IACE,mDAAA;IACA,oBAAA;EpDokvCR;EoDlkvCQ;IACE,yDAAA;IACA,oDAAA;EpDokvCV;AACF;AoB3pvCI;EgC8DA;IACE,mBAAA;EpDgmvCJ;EoD7lvCM;IvCvDJ,6DAAA;IAZA,0BAAA;EboqvCF;EoD5lvCM;IvCxEJ,2DAAA;IAYA,4BAAA;Eb4pvCF;EoD3lvCM;IACE,aAAA;EpD6lvCR;EoD1lvCM;IACE,mDAAA;IACA,oBAAA;EpD4lvCR;EoD1lvCQ;IACE,yDAAA;IACA,oDAAA;EpD4lvCV;AACF;AoBnrvCI;EgC8DA;IACE,mBAAA;EpDwnvCJ;EoDrnvCM;IvCvDJ,6DAAA;IAZA,0BAAA;Eb4rvCF;EoDpnvCM;IvCxEJ,2DAAA;IAYA,4BAAA;EborvCF;EoDnnvCM;IACE,aAAA;EpDqnvCR;EoDlnvCM;IACE,mDAAA;IACA,oBAAA;EpDonvCR;EoDlnvCQ;IACE,yDAAA;IACA,oDAAA;EpDonvCV;AACF;AoB3svCI;EgC8DA;IACE,mBAAA;EpDgpvCJ;EoD7ovCM;IvCvDJ,6DAAA;IAZA,0BAAA;EbotvCF;EoD5ovCM;IvCxEJ,2DAAA;IAYA,4BAAA;Eb4svCF;EoD3ovCM;IACE,aAAA;EpD6ovCR;EoD1ovCM;IACE,mDAAA;IACA,oBAAA;EpD4ovCR;EoD1ovCQ;IACE,yDAAA;IACA,oDAAA;EpD4ovCV;AACF;AoD/nvCA;EvChJI,gBAAA;AbkxvCJ;AoD/nvCE;EACE,mDAAA;ApDiovCJ;AoD/nvCI;EACE,sBAAA;ApDiovCN;;AoDpnvCE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;ApDunvCJ;;AoDjovCE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;ApDoovCJ;;AoD9ovCE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;ApDipvCJ;;AoD3pvCE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;ApD8pvCJ;;AoDxqvCE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;ApD2qvCJ;;AoDrrvCE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;ApDwrvCJ;;AoDlsvCE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;ApDqsvCJ;;AoD/svCE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;ApDktvCJ;;AoD5tvCE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;ApD+tvCJ;;AoDzuvCE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;ApD4uvCJ;;AqDx6vCA;EAEE,0BAAA;EACA,2DAAA;EACA,2BAAA;EACA,kCAAA;EACA,iCAAA;EACA,+BAAA;EACA,qCAAA;EACA,uEAAA;EAGA,uBAAA;EACA,UzCkoD2B;EyCjoD3B,WzCioD2B;EyChoD3B,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,SAAA;ExCJE,sBAAA;EwCMF,oCAAA;ArDw6vCF;AqDr6vCE;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;ArDu6vCJ;AqDp6vCE;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;ArDs6vCJ;AqDn6vCE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6CAAA;ArDo6vCJ;;AqD55vCA;EAHE,wCAAA;ArDm6vCF;;AqD15vCI;EATF,wCAAA;ArDu6vCF;;AsDx9vCA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EACA,2BAAA;E7CyRI,8BALI;E6ClRR,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,2CAAA;EACA,iCAAA;EACA,uDAAA;EACA,gCAAA;EACA,+CAAA;EACA,mDAAA;EAGA,gCAAA;EACA,eAAA;E7C2QI,oCALI;E6CpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;EzCRE,4CAAA;Abi+vCJ;AsDt9vCE;EACE,UAAA;AtDw9vCJ;AsDr9vCE;EACE,aAAA;AtDu9vCJ;;AsDn9vCA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AtDq9vCF;AsDn9vCE;EACE,sCAAA;AtDq9vCJ;;AsDj9vCA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;EzChCE,0FAAA;EACA,2FAAA;Abq/vCJ;AsDn9vCE;EACE,oDAAA;EACA,sCAAA;AtDq9vCJ;;AsDj9vCA;EACE,kCAAA;EACA,qBAAA;AtDo9vCF;;AuDlhwCA;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,4BAAA;EACA,gCAAA;EACA,8DAAA;EACA,kDAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,uCAAA;EACA,mCAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,uCAAA;EACA,mCAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AvDghwCF;;AuDzgwCA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;AvD2gwCF;AuDxgwCE;E3B5CI,mC2B6CF;AvD0gwCJ;A4BnjwCM;E2BwCJ;I3BvCM,gBAAA;E5BsjwCN;AACF;AuDhhwCE;EAEE,8B3Cm7CgC;AZ8ltCpC;AuD/gwCE;EACE,e3Ci7CgC;AZgmtCpC;AuD7gwCE;EACE,sB3C86CgC;AZimtCpC;;AuD3gwCA;EACE,+CAAA;AvD8gwCF;AuD5gwCE;EACE,gBAAA;EACA,gBAAA;AvD8gwCJ;AuD3gwCE;EACE,gBAAA;AvD6gwCJ;;AuDzgwCA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AvD4gwCF;;AuDxgwCA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E1CrFE,4CAAA;E0CyFF,UAAA;AvDwgwCF;;AuDpgwCA;EAEE,0BAAA;EACA,sBAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;AvD0gwC9D;AwDtnwCE;EAAS,UAAA;AxDynwCX;AwDxnwCE;EAAS,mCD2GiF;AvDghwC5F;;AuD3gwCA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,uCAAA;EACA,4FAAA;E1CtGE,2DAAA;EACA,4DAAA;AbqnwCJ;AuD7gwCE;EACE,kGAAA;EACA,sJAAA;AvD+gwCJ;;AuD1gwCA;EACE,gBAAA;EACA,8CAAA;AvD6gwCF;;AuDxgwCA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;AvDygwCF;;AuDrgwCA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;E1C1HE,+DAAA;EACA,8DAAA;AbmowCJ;AuDpgwCE;EACE,8CAAA;AvDsgwCJ;;AoBlnwCI;EmCkHF;IACE,0BAAA;IACA,uDAAA;EvDogwCF;EuDhgwCA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;EvDkgwCF;EuD//vCA;IACE,uBAAA;EvDigwCF;AACF;AoBjowCI;EmCoIF;;IAEE,uBAAA;EvDggwCF;AACF;AoBvowCI;EmC2IF;IACE,wBAAA;EvD+/vCF;AACF;AuDt/vCI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AvDw/vCN;AuDt/vCM;EACE,YAAA;EACA,SAAA;E1C1MJ,gBAAA;AbmswCJ;AuDr/vCM;;E1C9MF,gBAAA;AbuswCJ;AuDp/vCM;EACE,gBAAA;AvDs/vCR;;AoBjpwCI;EmCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EvD4gwCJ;EuD1gwCI;IACE,YAAA;IACA,SAAA;I1C1MJ,gBAAA;EbutwCF;EuDzgwCI;;I1C9MF,gBAAA;Eb2twCF;EuDxgwCI;IACE,gBAAA;EvD0gwCN;AACF;AoBtqwCI;EmCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EvDgiwCJ;EuD9hwCI;IACE,YAAA;IACA,SAAA;I1C1MJ,gBAAA;Eb2uwCF;EuD7hwCI;;I1C9MF,gBAAA;Eb+uwCF;EuD5hwCI;IACE,gBAAA;EvD8hwCN;AACF;AoB1rwCI;EmCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EvDojwCJ;EuDljwCI;IACE,YAAA;IACA,SAAA;I1C1MJ,gBAAA;Eb+vwCF;EuDjjwCI;;I1C9MF,gBAAA;EbmwwCF;EuDhjwCI;IACE,gBAAA;EvDkjwCN;AACF;AoB9swCI;EmCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EvDwkwCJ;EuDtkwCI;IACE,YAAA;IACA,SAAA;I1C1MJ,gBAAA;EbmxwCF;EuDrkwCI;;I1C9MF,gBAAA;EbuxwCF;EuDpkwCI;IACE,gBAAA;EvDskwCN;AACF;AoBluwCI;EmCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EvD4lwCJ;EuD1lwCI;IACE,YAAA;IACA,SAAA;I1C1MJ,gBAAA;EbuywCF;EuDzlwCI;;I1C9MF,gBAAA;Eb2ywCF;EuDxlwCI;IACE,gBAAA;EvD0lwCN;AACF;AyDj0wCA;EAEE,wBAAA;EACA,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,sBAAA;EhDwRI,iCALI;EgDjRR,wBAAA;EACA,qBAAA;EACA,mCAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EClBA,wC9CmpB4B;E8CjpB5B,kBAAA;EACA,gB9C+pB4B;E8C9pB5B,gB9CoqB4B;E8CnqB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EgDhQR,qBAAA;EACA,UAAA;AzDy0wCF;AyDv0wCE;EAAS,kCAAA;AzD00wCX;AyDx0wCE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AzD00wCJ;AyDx0wCI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AzD00wCN;;AyDr0wCA;EACE,iDAAA;AzDw0wCF;AyDt0wCE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;AzDw0wCJ;;AyDp0wCA,qBAAA;AACA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;AzDu0wCF;AyDr0wCE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;AzDu0wCJ;;AyDn0wCA,mBAAA;AAEA;EACE,8CAAA;AzDq0wCF;AyDn0wCE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;AzDq0wCJ;;AyDj0wCA,qBAAA;AACA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;AzDo0wCF;AyDl0wCE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;AzDo0wCJ;;AyDh0wCA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E5CjGE,8CAAA;Abo5wCJ;;A2Dv6wCA;EAEE,wBAAA;EACA,6BAAA;ElD4RI,iCALI;EkDrRR,qBAAA;EACA,8BAAA;EACA,6CAAA;EACA,kCAAA;EACA,oDAAA;EACA,yDAAA;EACA,sCAAA;EACA,qCAAA;ElDmRI,mCALI;EkD5QR,kCAAA;EACA,gDAAA;EACA,oCAAA;EACA,mCAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,wC9CmpB4B;E8CjpB5B,kBAAA;EACA,gB9C+pB4B;E8C9pB5B,gB9CoqB4B;E8CnqB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EkD1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E9ChBE,8CAAA;Abk8wCJ;A2D96wCE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;A3Dg7wCJ;A2D96wCI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;A3D+6wCN;;A2Dz6wCE;EACE,oFAAA;A3D46wCJ;A2D16wCI;EAEE,wFAAA;A3D26wCN;A2Dx6wCI;EACE,SAAA;EACA,gDAAA;A3D06wCN;A2Dv6wCI;EACE,sCAAA;EACA,sCAAA;A3Dy6wCN;;A2Dp6wCA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;A3Ds6wCJ;A2Dp6wCI;EAEE,kIAAA;A3Dq6wCN;A2Dl6wCI;EACE,OAAA;EACA,kDAAA;A3Do6wCN;A2Dj6wCI;EACE,oCAAA;EACA,wCAAA;A3Dm6wCN;;A2D95wCA,mBAAA;AAGE;EACE,iFAAA;A3D+5wCJ;A2D75wCI;EAEE,wFAAA;A3D85wCN;A2D35wCI;EACE,MAAA;EACA,mDAAA;A3D65wCN;A2D15wCI;EACE,mCAAA;EACA,yCAAA;A3D45wCN;A2Dv5wCE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;A3Dy5wCJ;;A2Dr5wCA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;A3Du5wCJ;A2Dr5wCI;EAEE,kIAAA;A3Ds5wCN;A2Dn5wCI;EACE,QAAA;EACA,iDAAA;A3Dq5wCN;A2Dl5wCI;EACE,qCAAA;EACA,uCAAA;A3Do5wCN;;A2D/4wCA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;ElD2GI,6CALI;EkDpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;E9C5JE,6DAAA;EACA,8DAAA;Ab8hxCJ;A2Dh4wCE;EACE,aAAA;A3Dk4wCJ;;A2D93wCA;EACE,0EAAA;EACA,mCAAA;A3Di4wCF;;A4DtjxCA;EACE,kBAAA;A5DyjxCF;;A4DtjxCA;EACE,mBAAA;A5DyjxCF;;A4DtjxCA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;A5DyjxCF;A6D/kxCE;EACE,cAAA;EACA,WAAA;EACA,WAAA;A7DilxCJ;;A4D1jxCA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EhClBI,sCgCmBJ;A5D6jxCF;A4B5kxCM;EgCQN;IhCPQ,gBAAA;E5B+kxCN;AACF;;A4D/jxCA;;;EAGE,cAAA;A5DkkxCF;;A4D/jxCA;;EAEE,2BAAA;A5DkkxCF;;A4D/jxCA;;EAEE,4BAAA;A5DkkxCF;;A4DzjxCE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;A5D4jxCJ;A4DzjxCE;;;EAGE,UAAA;EACA,UAAA;A5D2jxCJ;A4DxjxCE;;EAEE,UAAA;EACA,UAAA;EhC5DE,2BgC6DF;A5D0jxCJ;A4BnnxCM;EgCqDJ;;IhCpDM,gBAAA;E5BunxCN;AACF;;A4DvjxCA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UhDigDmC;EgDhgDnC,UAAA;EACA,WhDRS;EgDST,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YhD4/CmC;EgBllD/B,8BgCuFJ;A5DyjxCF;A4B5oxCM;EgCkEN;;IhCjEQ,gBAAA;E5BgpxCN;AACF;A4D5jxCE;;;EAEE,WhDlBO;EgDmBP,qBAAA;EACA,UAAA;EACA,YhDo/CiC;AZ2kuCrC;;A4D5jxCA;EACE,OAAA;A5D+jxCF;;A4D5jxCA;EACE,QAAA;A5D+jxCF;;A4D1jxCA;;EAEE,qBAAA;EACA,WhDq/CmC;EgDp/CnC,YhDo/CmC;EgDn/CnC,4BAAA;EACA,wBAAA;EACA,0BAAA;A5D6jxCF;;A4D1jxCA;;;;;;;GAAA;AAQA;EACE,0DAAA;A5D6jxCF;;A4D3jxCA;EACE,0DAAA;A5D8jxCF;;A4DtjxCA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBhD67CmC;EgD57CnC,mBAAA;EACA,gBhD27CmC;AZ6nuCrC;A4DtjxCE;EACE,uBAAA;EACA,cAAA;EACA,WhD27CiC;EgD17CjC,WhD27CiC;EgD17CjC,UAAA;EACA,iBhD27CiC;EgD17CjC,gBhD07CiC;EgDz7CjC,mBAAA;EACA,eAAA;EACA,sBhDxFO;EgDyFP,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YhDk7CiC;EgB1lD/B,6BgCyKF;A5DujxCJ;A4B5txCM;EgCoJJ;IhCnJM,gBAAA;E5B+txCN;AACF;A4DzjxCE;EACE,UhD+6CiC;AZ4ouCrC;;A4DljxCA;EACE,kBAAA;EACA,UAAA;EACA,ehDy6CmC;EgDx6CnC,SAAA;EACA,oBhDs6CmC;EgDr6CnC,uBhDq6CmC;EgDp6CnC,WhDnHS;EgDoHT,kBAAA;A5DqjxCF;;A4D/ixCE;;EAEE,gChDw6CiC;AZ0ouCrC;A4D/ixCE;EACE,sBhDtHO;AZuqxCX;A4D9ixCE;EACE,WhD1HO;AZ0qxCX;;A4D1jxCE;;;EAEE,gChDw6CiC;AZspuCrC;A4D3jxCE;EACE,sBhDtHO;AZmrxCX;A4D1jxCE;EACE,WhD1HO;AZsrxCX;;A8DtxxCA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;A9DwxxCF;;A8DpxxCA;EACE;IAAK,0CAAA;E9DwxxCL;AACF;A8DrxxCA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;A9DoxxCF;;A8DjxxCA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;A9DmxxCF;;A8D1wxCA;EACE;IACE,mBAAA;E9D6wxCF;E8D3wxCA;IACE,UAAA;IACA,eAAA;E9D6wxCF;AACF;A8DzwxCA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;A9DwwxCF;;A8DrwxCA;EACE,wBAAA;EACA,yBAAA;A9DwwxCF;;A8DpwxCE;EACE;;IAEE,kCAAA;E9DuwxCJ;AACF;A+Dv1xCA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,uBAAA;EACA,gCAAA;EACA,oCAAA;EACA,kEAAA;EACA,qDAAA;EACA,qCAAA;A/Dw1xCF;;AoB3xxCI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E/Dy0xCJ;AACF;A4Bp2xCM;EmCYJ;InCXM,gBAAA;E5Bu2xCN;AACF;AoBjzxCI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E/Dg1xCN;E+D70xCI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E/D+0xCN;E+D50xCI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E/D80xCN;E+D30xCI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E/D60xCN;E+D10xCI;IAEE,eAAA;E/D20xCN;E+Dx0xCI;IAGE,mBAAA;E/Dw0xCN;AACF;AoBr2xCI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E/Du0xCN;E+Dr0xCM;IACE,aAAA;E/Du0xCR;E+Dp0xCM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E/Dq0xCR;AACF;;AoBz2xCI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E/Du5xCJ;AACF;A4Bl7xCM;EmCYJ;InCXM,gBAAA;E5Bq7xCN;AACF;AoB/3xCI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E/D85xCN;E+D35xCI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E/D65xCN;E+D15xCI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E/D45xCN;E+Dz5xCI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E/D25xCN;E+Dx5xCI;IAEE,eAAA;E/Dy5xCN;E+Dt5xCI;IAGE,mBAAA;E/Ds5xCN;AACF;AoBn7xCI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E/Dq5xCN;E+Dn5xCM;IACE,aAAA;E/Dq5xCR;E+Dl5xCM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E/Dm5xCR;AACF;;AoBv7xCI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E/Dq+xCJ;AACF;A4BhgyCM;EmCYJ;InCXM,gBAAA;E5BmgyCN;AACF;AoB78xCI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E/D4+xCN;E+Dz+xCI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E/D2+xCN;E+Dx+xCI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E/D0+xCN;E+Dv+xCI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E/Dy+xCN;E+Dt+xCI;IAEE,eAAA;E/Du+xCN;E+Dp+xCI;IAGE,mBAAA;E/Do+xCN;AACF;AoBjgyCI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E/Dm+xCN;E+Dj+xCM;IACE,aAAA;E/Dm+xCR;E+Dh+xCM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E/Di+xCR;AACF;;AoBrgyCI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E/DmjyCJ;AACF;A4B9kyCM;EmCYJ;InCXM,gBAAA;E5BilyCN;AACF;AoB3hyCI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E/D0jyCN;E+DvjyCI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E/DyjyCN;E+DtjyCI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E/DwjyCN;E+DrjyCI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E/DujyCN;E+DpjyCI;IAEE,eAAA;E/DqjyCN;E+DljyCI;IAGE,mBAAA;E/DkjyCN;AACF;AoB/kyCI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E/DijyCN;E+D/iyCM;IACE,aAAA;E/DijyCR;E+D9iyCM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E/D+iyCR;AACF;;AoBnlyCI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E/DioyCJ;AACF;A4B5pyCM;EmCYJ;InCXM,gBAAA;E5B+pyCN;AACF;AoBzmyCI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E/DwoyCN;E+DroyCI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E/DuoyCN;E+DpoyCI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E/DsoyCN;E+DnoyCI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E/DqoyCN;E+DloyCI;IAEE,eAAA;E/DmoyCN;E+DhoyCI;IAGE,mBAAA;E/DgoyCN;AACF;AoB7pyCI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E/D+nyCN;E+D7nyCM;IACE,aAAA;E/D+nyCR;E+D5nyCM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E/D6nyCR;AACF;;A+D7syCE;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EnC5BA,0CmC8BA;A/D8syCN;A4BxuyCM;EmCYJ;InCXM,gBAAA;E5B2uyCN;AACF;A+DjtyCM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;A/DmtyCR;A+DhtyCM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;A/DktyCR;A+D/syCM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;A/DityCR;A+D9syCM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;A/DgtyCR;A+D7syCM;EAEE,eAAA;A/D8syCR;A+D3syCM;EAGE,mBAAA;A/D2syCR;;A+DhryCA;EPpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5C0nCkC;E4CznClC,YAAA;EACA,aAAA;EACA,sB5C4FS;AZ4syCX;AwDryyCE;EAAS,UAAA;AxDwyyCX;AwDvyyCE;EAAS,Y5Cu9CyB;AZm1vCpC;;A+D5ryCA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oEAAA;A/D+ryCF;A+D7ryCE;EACE,4FAAA;EACA,sDAAA;EACA,wDAAA;EACA,yDAAA;A/D+ryCJ;;A+D3ryCA;EACE,gBAAA;EACA,kDAAA;A/D8ryCF;;A+D3ryCA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;A/D8ryCF;;AgE90yCA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YpDyyCkC;AZwiwCpC;AgE/0yCE;EACE,qBAAA;EACA,WAAA;AhEi1yCJ;;AgE50yCA;EACE,iBAAA;AhE+0yCF;;AgE50yCA;EACE,iBAAA;AhE+0yCF;;AgE50yCA;EACE,iBAAA;AhE+0yCF;;AgE10yCE;EACE,mDAAA;AhE60yCJ;;AgEz0yCA;EACE;IACE,YpD4wCgC;EZgkwClC;AACF;AgEz0yCA;EACE,+EAAA;EACA,oBAAA;EACA,8CAAA;AhE20yCF;;AgEx0yCA;EACE;IACE,uBAAA;EhE20yCF;AACF;A6D13yCE;EACE,cAAA;EACA,WAAA;EACA,WAAA;A7D43yCJ;;AiE/3yCE;EACE,sBAAA;EACA,iFAAA;AjEk4yCJ;;AiEp4yCE;EACE,sBAAA;EACA,mFAAA;AjEu4yCJ;;AiEz4yCE;EACE,sBAAA;EACA,iFAAA;AjE44yCJ;;AiE94yCE;EACE,sBAAA;EACA,8EAAA;AjEi5yCJ;;AiEn5yCE;EACE,sBAAA;EACA,iFAAA;AjEs5yCJ;;AiEx5yCE;EACE,sBAAA;EACA,gFAAA;AjE25yCJ;;AiE75yCE;EACE,sBAAA;EACA,8EAAA;AjEg6yCJ;;AiEl6yCE;EACE,sBAAA;EACA,+EAAA;AjEq6yCJ;;AiEv6yCE;EACE,sBAAA;EACA,8EAAA;AjE06yCJ;;AiE56yCE;EACE,sBAAA;EACA,gFAAA;AjE+6yCJ;;AkEj7yCE;EACE,wEAAA;EACA,kGAAA;AlEo7yCJ;AkEj7yCM;EAGE,8DAAA;EACA,wFAAA;AlEi7yCR;;AkE17yCE;EACE,0EAAA;EACA,oGAAA;AlE67yCJ;AkE17yCM;EAGE,8DAAA;EACA,wFAAA;AlE07yCR;;AkEn8yCE;EACE,wEAAA;EACA,kGAAA;AlEs8yCJ;AkEn8yCM;EAGE,+DAAA;EACA,yFAAA;AlEm8yCR;;AkE58yCE;EACE,qEAAA;EACA,+FAAA;AlE+8yCJ;AkE58yCM;EAGE,+DAAA;EACA,yFAAA;AlE48yCR;;AkEr9yCE;EACE,wEAAA;EACA,kGAAA;AlEw9yCJ;AkEr9yCM;EAGE,+DAAA;EACA,yFAAA;AlEq9yCR;;AkE99yCE;EACE,uEAAA;EACA,iGAAA;AlEi+yCJ;AkE99yCM;EAGE,8DAAA;EACA,wFAAA;AlE89yCR;;AkEv+yCE;EACE,qEAAA;EACA,+FAAA;AlE0+yCJ;AkEv+yCM;EAGE,+DAAA;EACA,yFAAA;AlEu+yCR;;AkEh/yCE;EACE,sEAAA;EACA,gGAAA;AlEm/yCJ;AkEh/yCM;EAGE,gEAAA;EACA,0FAAA;AlEg/yCR;;AkEz/yCE;EACE,qEAAA;EACA,+FAAA;AlE4/yCJ;AkEz/yCM;EAGE,6DAAA;EACA,uFAAA;AlEy/yCR;;AkElgzCE;EACE,uEAAA;EACA,iGAAA;AlEqgzCJ;AkElgzCM;EAGE,8DAAA;EACA,wFAAA;AlEkgzCR;;AkE3/yCA;EACE,+EAAA;EACA,yGAAA;AlE8/yCF;AkE3/yCI;EAEE,kFAAA;EACA,4GAAA;AlE4/yCN;;AmEthzCA;EACE,UAAA;EAEA,kJAAA;AnEwhzCF;;AoE3hzCA;EACE,oBAAA;EACA,alC6c4B;EkC5c5B,mBAAA;EACA,kFAAA;EACA,6BlC2c4B;EkC1c5B,2BAAA;ApE8hzCF;AoE5hzCE;EACE,cAAA;EACA,UlCuc0B;EkCtc1B,WlCsc0B;EkCrc1B,kBAAA;ExCIE,sCwCHF;ApE8hzCJ;A4BvhzCM;EwCZJ;IxCaM,gBAAA;E5B0hzCN;AACF;;AoE5hzCI;EACE,mEAAA;ApE+hzCN;;AqEljzCA;EACE,kBAAA;EACA,WAAA;ArEqjzCF;AqEnjzCE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;ArEqjzCJ;AqEljzCE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;ArEojzCJ;;AqE/izCE;EACE,uBAAA;ArEkjzCJ;;AqEnjzCE;EACE,sBAAA;ArEsjzCJ;;AqEvjzCE;EACE,yBAAA;ArE0jzCJ;;AqE3jzCE;EACE,iCAAA;ArE8jzCJ;;AsEnlzCA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a1DunCkC;AZ+9wCpC;;AsEnlzCA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a1D+mCkC;AZu+wCpC;;AsE9kzCI;EACE,gBAAA;EACA,MAAA;EACA,a1DmmC8B;AZ8+wCpC;;AsE9kzCI;EACE,gBAAA;EACA,SAAA;EACA,a1D6lC8B;AZo/wCpC;;AoBljzCI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmmC8B;EZ2/wClC;EsE3lzCE;IACE,gBAAA;IACA,SAAA;IACA,a1D6lC8B;EZggxClC;AACF;AoB/jzCI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmmC8B;EZugxClC;EsEvmzCE;IACE,gBAAA;IACA,SAAA;IACA,a1D6lC8B;EZ4gxClC;AACF;AoB3kzCI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmmC8B;EZmhxClC;EsEnnzCE;IACE,gBAAA;IACA,SAAA;IACA,a1D6lC8B;EZwhxClC;AACF;AoBvlzCI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmmC8B;EZ+hxClC;EsE/nzCE;IACE,gBAAA;IACA,SAAA;IACA,a1D6lC8B;EZoixClC;AACF;AoBnmzCI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmmC8B;EZ2ixClC;EsE3ozCE;IACE,gBAAA;IACA,SAAA;IACA,a1D6lC8B;EZgjxClC;AACF;AuE7qzCA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AvE+qzCF;;AuE5qzCA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AvE+qzCF;;AwEvrzCA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AzEwrzCF;AyErrzCE;;EACE,6BAAA;AzEwrzCJ;;A0EtszCE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U9D4gBsC;E8D3gBtC,WAAA;A1EyszCJ;;A2EjtzCA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;A5EqtzCF;;A6E3tzCA;EACE,qBAAA;EACA,mBAAA;EACA,6B3CisB4B;E2ChsB5B,eAAA;EACA,8BAAA;EACA,YjEquB4B;AZy/xC9B;;A8ElqzCQ;EAOI,mCAAA;A9E+pzCZ;;A8EtqzCQ;EAOI,8BAAA;A9EmqzCZ;;A8E1qzCQ;EAOI,iCAAA;A9EuqzCZ;;A8E9qzCQ;EAOI,iCAAA;A9E2qzCZ;;A8ElrzCQ;EAOI,sCAAA;A9E+qzCZ;;A8EtrzCQ;EAOI,mCAAA;A9EmrzCZ;;A8E1rzCQ;EAOI,sBAAA;A9EurzCZ;;A8E9rzCQ;EAOI,uBAAA;A9E2rzCZ;;A8ElszCQ;EAOI,sBAAA;A9E+rzCZ;;A8EtszCQ;EAOI,8BAAA;A9EmszCZ;;A8E1szCQ;EAOI,4BAAA;A9EuszCZ;;A8E9szCQ;EAOI,2BAAA;A9E2szCZ;;A8EltzCQ;EAOI,iCAAA;A9E+szCZ;;A8EttzCQ;EAOI,2BAAA;A9EmtzCZ;;A8E1tzCQ;EAOI,qBAAA;A9EutzCZ;;A8E9tzCQ;EAOI,wBAAA;A9E2tzCZ;;A8EluzCQ;EAOI,uBAAA;A9E+tzCZ;;A8EtuzCQ;EAOI,wBAAA;A9EmuzCZ;;A8E1uzCQ;EAOI,qBAAA;A9EuuzCZ;;A8E9uzCQ;EAOI,yBAAA;A9E2uzCZ;;A8ElvzCQ;EAOI,2BAAA;A9E+uzCZ;;A8EtvzCQ;EAOI,4BAAA;A9EmvzCZ;;A8E1vzCQ;EAOI,2BAAA;A9EuvzCZ;;A8E9vzCQ;EAOI,2BAAA;A9E2vzCZ;;A8ElwzCQ;EAOI,6BAAA;A9E+vzCZ;;A8EtwzCQ;EAOI,8BAAA;A9EmwzCZ;;A8E1wzCQ;EAOI,6BAAA;A9EuwzCZ;;A8E9wzCQ;EAOI,2BAAA;A9E2wzCZ;;A8ElxzCQ;EAOI,6BAAA;A9E+wzCZ;;A8EtxzCQ;EAOI,8BAAA;A9EmxzCZ;;A8E1xzCQ;EAOI,6BAAA;A9EuxzCZ;;A8E9xzCQ;EAOI,0BAAA;A9E2xzCZ;;A8ElyzCQ;EAOI,gCAAA;A9E+xzCZ;;A8EtyzCQ;EAOI,yBAAA;A9EmyzCZ;;A8E1yzCQ;EAOI,wBAAA;A9EuyzCZ;;A8E9yzCQ;EAOI,+BAAA;A9E2yzCZ;;A8ElzzCQ;EAOI,yBAAA;A9E+yzCZ;;A8EtzzCQ;EAOI,6BAAA;A9EmzzCZ;;A8E1zzCQ;EAOI,8BAAA;A9EuzzCZ;;A8E9zzCQ;EAOI,wBAAA;A9E2zzCZ;;A8El0zCQ;EAOI,+BAAA;A9E+zzCZ;;A8Et0zCQ;EAOI,wBAAA;A9Em0zCZ;;A8E10zCQ;EAOI,2CAAA;A9Eu0zCZ;;A8E90zCQ;EAOI,8CAAA;A9E20zCZ;;A8El1zCQ;EAOI,8CAAA;A9E+0zCZ;;A8Et1zCQ;EAOI,2BAAA;A9Em1zCZ;;A8Ep2zCQ;EACE,gFAAA;A9Eu2zCV;;A8Ex2zCQ;EACE,kFAAA;A9E22zCV;;A8E52zCQ;EACE,gFAAA;A9E+2zCV;;A8Eh3zCQ;EACE,6EAAA;A9Em3zCV;;A8Ep3zCQ;EACE,gFAAA;A9Eu3zCV;;A8Ex3zCQ;EACE,+EAAA;A9E23zCV;;A8E53zCQ;EACE,6EAAA;A9E+3zCV;;A8Eh4zCQ;EACE,8EAAA;A9Em4zCV;;A8Ep4zCQ;EACE,6EAAA;A9Eu4zCV;;A8Ex4zCQ;EACE,+EAAA;A9E24zCV;;A8El4zCQ;EAOI,2BAAA;A9E+3zCZ;;A8Et4zCQ;EAOI,6BAAA;A9Em4zCZ;;A8E14zCQ;EAOI,6BAAA;A9Eu4zCZ;;A8E94zCQ;EAOI,0BAAA;A9E24zCZ;;A8El5zCQ;EAOI,2BAAA;A9E+4zCZ;;A8Et5zCQ;EAOI,iBAAA;A9Em5zCZ;;A8E15zCQ;EAOI,mBAAA;A9Eu5zCZ;;A8E95zCQ;EAOI,oBAAA;A9E25zCZ;;A8El6zCQ;EAOI,oBAAA;A9E+5zCZ;;A8Et6zCQ;EAOI,sBAAA;A9Em6zCZ;;A8E16zCQ;EAOI,uBAAA;A9Eu6zCZ;;A8E96zCQ;EAOI,kBAAA;A9E26zCZ;;A8El7zCQ;EAOI,oBAAA;A9E+6zCZ;;A8Et7zCQ;EAOI,qBAAA;A9Em7zCZ;;A8E17zCQ;EAOI,mBAAA;A9Eu7zCZ;;A8E97zCQ;EAOI,qBAAA;A9E27zCZ;;A8El8zCQ;EAOI,sBAAA;A9E+7zCZ;;A8Et8zCQ;EAOI,2CAAA;A9Em8zCZ;;A8E18zCQ;EAOI,sCAAA;A9Eu8zCZ;;A8E98zCQ;EAOI,sCAAA;A9E28zCZ;;A8El9zCQ;EAOI,uFAAA;A9E+8zCZ;;A8Et9zCQ;EAOI,oBAAA;A9Em9zCZ;;A8E19zCQ;EAOI,2FAAA;A9Eu9zCZ;;A8E99zCQ;EAOI,wBAAA;A9E29zCZ;;A8El+zCQ;EAOI,6FAAA;A9E+9zCZ;;A8Et+zCQ;EAOI,0BAAA;A9Em+zCZ;;A8E1+zCQ;EAOI,8FAAA;A9Eu+zCZ;;A8E9+zCQ;EAOI,2BAAA;A9E2+zCZ;;A8El/zCQ;EAOI,4FAAA;A9E++zCZ;;A8Et/zCQ;EAOI,yBAAA;A9Em/zCZ;;A8E1/zCQ;EAIQ,sBAAA;EAGJ,8EAAA;A9Ew/zCZ;;A8E//zCQ;EAIQ,sBAAA;EAGJ,gFAAA;A9E6/zCZ;;A8Epg0CQ;EAIQ,sBAAA;EAGJ,8EAAA;A9Ekg0CZ;;A8Ezg0CQ;EAIQ,sBAAA;EAGJ,2EAAA;A9Eug0CZ;;A8E9g0CQ;EAIQ,sBAAA;EAGJ,8EAAA;A9E4g0CZ;;A8Enh0CQ;EAIQ,sBAAA;EAGJ,6EAAA;A9Eih0CZ;;A8Exh0CQ;EAIQ,sBAAA;EAGJ,2EAAA;A9Esh0CZ;;A8E7h0CQ;EAIQ,sBAAA;EAGJ,4EAAA;A9E2h0CZ;;A8Eli0CQ;EAIQ,sBAAA;EAGJ,2EAAA;A9Egi0CZ;;A8Evi0CQ;EAIQ,sBAAA;EAGJ,6EAAA;A9Eqi0CZ;;A8E5i0CQ;EAIQ,sBAAA;EAGJ,4EAAA;A9E0i0CZ;;A8Ejj0CQ;EAIQ,sBAAA;EAGJ,4EAAA;A9E+i0CZ;;A8Etj0CQ;EAOI,wDAAA;A9Emj0CZ;;A8E1j0CQ;EAOI,0DAAA;A9Euj0CZ;;A8E9j0CQ;EAOI,wDAAA;A9E2j0CZ;;A8Elk0CQ;EAOI,qDAAA;A9E+j0CZ;;A8Etk0CQ;EAOI,wDAAA;A9Emk0CZ;;A8E1k0CQ;EAOI,uDAAA;A9Euk0CZ;;A8E9k0CQ;EAOI,sDAAA;A9E2k0CZ;;A8Ell0CQ;EAOI,qDAAA;A9E+k0CZ;;A8Etl0CQ;EAOI,0BAAA;A9Eml0CZ;;A8E1l0CQ;EAOI,4BAAA;A9Eul0CZ;;A8E9l0CQ;EAOI,4BAAA;A9E2l0CZ;;A8Elm0CQ;EAOI,4BAAA;A9E+l0CZ;;A8Etm0CQ;EAOI,4BAAA;A9Emm0CZ;;A8E1m0CQ;EAOI,4BAAA;A9Eum0CZ;;A8Exn0CQ;EACE,wBAAA;A9E2n0CV;;A8E5n0CQ;EACE,yBAAA;A9E+n0CV;;A8Eho0CQ;EACE,wBAAA;A9Emo0CV;;A8Epo0CQ;EACE,yBAAA;A9Euo0CV;;A8Exo0CQ;EACE,sBAAA;A9E2o0CV;;A8Elo0CQ;EAOI,qBAAA;A9E+n0CZ;;A8Eto0CQ;EAOI,qBAAA;A9Emo0CZ;;A8E1o0CQ;EAOI,qBAAA;A9Euo0CZ;;A8E9o0CQ;EAOI,sBAAA;A9E2o0CZ;;A8Elp0CQ;EAOI,sBAAA;A9E+o0CZ;;A8Etp0CQ;EAOI,0BAAA;A9Emp0CZ;;A8E1p0CQ;EAOI,uBAAA;A9Eup0CZ;;A8E9p0CQ;EAOI,2BAAA;A9E2p0CZ;;A8Elq0CQ;EAOI,sBAAA;A9E+p0CZ;;A8Etq0CQ;EAOI,sBAAA;A9Emq0CZ;;A8E1q0CQ;EAOI,sBAAA;A9Euq0CZ;;A8E9q0CQ;EAOI,uBAAA;A9E2q0CZ;;A8Elr0CQ;EAOI,uBAAA;A9E+q0CZ;;A8Etr0CQ;EAOI,2BAAA;A9Emr0CZ;;A8E1r0CQ;EAOI,wBAAA;A9Eur0CZ;;A8E9r0CQ;EAOI,4BAAA;A9E2r0CZ;;A8Els0CQ;EAOI,yBAAA;A9E+r0CZ;;A8Ets0CQ;EAOI,8BAAA;A9Ems0CZ;;A8E1s0CQ;EAOI,iCAAA;A9Eus0CZ;;A8E9s0CQ;EAOI,sCAAA;A9E2s0CZ;;A8Elt0CQ;EAOI,yCAAA;A9E+s0CZ;;A8Ett0CQ;EAOI,uBAAA;A9Emt0CZ;;A8E1t0CQ;EAOI,uBAAA;A9Eut0CZ;;A8E9t0CQ;EAOI,yBAAA;A9E2t0CZ;;A8Elu0CQ;EAOI,yBAAA;A9E+t0CZ;;A8Etu0CQ;EAOI,0BAAA;A9Emu0CZ;;A8E1u0CQ;EAOI,4BAAA;A9Euu0CZ;;A8E9u0CQ;EAOI,kCAAA;A9E2u0CZ;;A8Elv0CQ;EAOI,sCAAA;A9E+u0CZ;;A8Etv0CQ;EAOI,oCAAA;A9Emv0CZ;;A8E1v0CQ;EAOI,kCAAA;A9Euv0CZ;;A8E9v0CQ;EAOI,yCAAA;A9E2v0CZ;;A8Elw0CQ;EAOI,wCAAA;A9E+v0CZ;;A8Etw0CQ;EAOI,wCAAA;A9Emw0CZ;;A8E1w0CQ;EAOI,kCAAA;A9Euw0CZ;;A8E9w0CQ;EAOI,gCAAA;A9E2w0CZ;;A8Elx0CQ;EAOI,8BAAA;A9E+w0CZ;;A8Etx0CQ;EAOI,gCAAA;A9Emx0CZ;;A8E1x0CQ;EAOI,+BAAA;A9Eux0CZ;;A8E9x0CQ;EAOI,oCAAA;A9E2x0CZ;;A8Ely0CQ;EAOI,kCAAA;A9E+x0CZ;;A8Ety0CQ;EAOI,gCAAA;A9Emy0CZ;;A8E1y0CQ;EAOI,uCAAA;A9Euy0CZ;;A8E9y0CQ;EAOI,sCAAA;A9E2y0CZ;;A8Elz0CQ;EAOI,iCAAA;A9E+y0CZ;;A8Etz0CQ;EAOI,2BAAA;A9Emz0CZ;;A8E1z0CQ;EAOI,iCAAA;A9Euz0CZ;;A8E9z0CQ;EAOI,+BAAA;A9E2z0CZ;;A8El00CQ;EAOI,6BAAA;A9E+z0CZ;;A8Et00CQ;EAOI,+BAAA;A9Em00CZ;;A8E100CQ;EAOI,8BAAA;A9Eu00CZ;;A8E900CQ;EAOI,oBAAA;A9E200CZ;;A8El10CQ;EAOI,mBAAA;A9E+00CZ;;A8Et10CQ;EAOI,mBAAA;A9Em10CZ;;A8E110CQ;EAOI,mBAAA;A9Eu10CZ;;A8E910CQ;EAOI,mBAAA;A9E210CZ;;A8El20CQ;EAOI,mBAAA;A9E+10CZ;;A8Et20CQ;EAOI,mBAAA;A9Em20CZ;;A8E120CQ;EAOI,mBAAA;A9Eu20CZ;;A8E920CQ;EAOI,oBAAA;A9E220CZ;;A8El30CQ;EAOI,0BAAA;A9E+20CZ;;A8Et30CQ;EAOI,yBAAA;A9Em30CZ;;A8E130CQ;EAOI,uBAAA;A9Eu30CZ;;A8E930CQ;EAOI,yBAAA;A9E230CZ;;A8El40CQ;EAOI,uBAAA;A9E+30CZ;;A8Et40CQ;EAOI,uBAAA;A9Em40CZ;;A8E140CQ;EAOI,0BAAA;EAAA,yBAAA;A9Ew40CZ;;A8E/40CQ;EAOI,gCAAA;EAAA,+BAAA;A9E640CZ;;A8Ep50CQ;EAOI,+BAAA;EAAA,8BAAA;A9Ek50CZ;;A8Ez50CQ;EAOI,6BAAA;EAAA,4BAAA;A9Eu50CZ;;A8E950CQ;EAOI,+BAAA;EAAA,8BAAA;A9E450CZ;;A8En60CQ;EAOI,6BAAA;EAAA,4BAAA;A9Ei60CZ;;A8Ex60CQ;EAOI,6BAAA;EAAA,4BAAA;A9Es60CZ;;A8E760CQ;EAOI,wBAAA;EAAA,2BAAA;A9E260CZ;;A8El70CQ;EAOI,8BAAA;EAAA,iCAAA;A9Eg70CZ;;A8Ev70CQ;EAOI,6BAAA;EAAA,gCAAA;A9Eq70CZ;;A8E570CQ;EAOI,2BAAA;EAAA,8BAAA;A9E070CZ;;A8Ej80CQ;EAOI,6BAAA;EAAA,gCAAA;A9E+70CZ;;A8Et80CQ;EAOI,2BAAA;EAAA,8BAAA;A9Eo80CZ;;A8E380CQ;EAOI,2BAAA;EAAA,8BAAA;A9Ey80CZ;;A8Eh90CQ;EAOI,wBAAA;A9E680CZ;;A8Ep90CQ;EAOI,8BAAA;A9Ei90CZ;;A8Ex90CQ;EAOI,6BAAA;A9Eq90CZ;;A8E590CQ;EAOI,2BAAA;A9Ey90CZ;;A8Eh+0CQ;EAOI,6BAAA;A9E690CZ;;A8Ep+0CQ;EAOI,2BAAA;A9Ei+0CZ;;A8Ex+0CQ;EAOI,2BAAA;A9Eq+0CZ;;A8E5+0CQ;EAOI,0BAAA;A9Ey+0CZ;;A8Eh/0CQ;EAOI,gCAAA;A9E6+0CZ;;A8Ep/0CQ;EAOI,+BAAA;A9Ei/0CZ;;A8Ex/0CQ;EAOI,6BAAA;A9Eq/0CZ;;A8E5/0CQ;EAOI,+BAAA;A9Ey/0CZ;;A8Ehg1CQ;EAOI,6BAAA;A9E6/0CZ;;A8Epg1CQ;EAOI,6BAAA;A9Eig1CZ;;A8Exg1CQ;EAOI,2BAAA;A9Eqg1CZ;;A8E5g1CQ;EAOI,iCAAA;A9Eyg1CZ;;A8Ehh1CQ;EAOI,gCAAA;A9E6g1CZ;;A8Eph1CQ;EAOI,8BAAA;A9Eih1CZ;;A8Exh1CQ;EAOI,gCAAA;A9Eqh1CZ;;A8E5h1CQ;EAOI,8BAAA;A9Eyh1CZ;;A8Ehi1CQ;EAOI,8BAAA;A9E6h1CZ;;A8Epi1CQ;EAOI,yBAAA;A9Eii1CZ;;A8Exi1CQ;EAOI,+BAAA;A9Eqi1CZ;;A8E5i1CQ;EAOI,8BAAA;A9Eyi1CZ;;A8Ehj1CQ;EAOI,4BAAA;A9E6i1CZ;;A8Epj1CQ;EAOI,8BAAA;A9Eij1CZ;;A8Exj1CQ;EAOI,4BAAA;A9Eqj1CZ;;A8E5j1CQ;EAOI,4BAAA;A9Eyj1CZ;;A8Ehk1CQ;EAOI,qBAAA;A9E6j1CZ;;A8Epk1CQ;EAOI,2BAAA;A9Eik1CZ;;A8Exk1CQ;EAOI,0BAAA;A9Eqk1CZ;;A8E5k1CQ;EAOI,wBAAA;A9Eyk1CZ;;A8Ehl1CQ;EAOI,0BAAA;A9E6k1CZ;;A8Epl1CQ;EAOI,wBAAA;A9Eil1CZ;;A8Exl1CQ;EAOI,2BAAA;EAAA,0BAAA;A9Esl1CZ;;A8E7l1CQ;EAOI,iCAAA;EAAA,gCAAA;A9E2l1CZ;;A8Elm1CQ;EAOI,gCAAA;EAAA,+BAAA;A9Egm1CZ;;A8Evm1CQ;EAOI,8BAAA;EAAA,6BAAA;A9Eqm1CZ;;A8E5m1CQ;EAOI,gCAAA;EAAA,+BAAA;A9E0m1CZ;;A8Ejn1CQ;EAOI,8BAAA;EAAA,6BAAA;A9E+m1CZ;;A8Etn1CQ;EAOI,yBAAA;EAAA,4BAAA;A9Eon1CZ;;A8E3n1CQ;EAOI,+BAAA;EAAA,kCAAA;A9Eyn1CZ;;A8Eho1CQ;EAOI,8BAAA;EAAA,iCAAA;A9E8n1CZ;;A8Ero1CQ;EAOI,4BAAA;EAAA,+BAAA;A9Emo1CZ;;A8E1o1CQ;EAOI,8BAAA;EAAA,iCAAA;A9Ewo1CZ;;A8E/o1CQ;EAOI,4BAAA;EAAA,+BAAA;A9E6o1CZ;;A8Epp1CQ;EAOI,yBAAA;A9Eip1CZ;;A8Exp1CQ;EAOI,+BAAA;A9Eqp1CZ;;A8E5p1CQ;EAOI,8BAAA;A9Eyp1CZ;;A8Ehq1CQ;EAOI,4BAAA;A9E6p1CZ;;A8Epq1CQ;EAOI,8BAAA;A9Eiq1CZ;;A8Exq1CQ;EAOI,4BAAA;A9Eqq1CZ;;A8E5q1CQ;EAOI,2BAAA;A9Eyq1CZ;;A8Ehr1CQ;EAOI,iCAAA;A9E6q1CZ;;A8Epr1CQ;EAOI,gCAAA;A9Eir1CZ;;A8Exr1CQ;EAOI,8BAAA;A9Eqr1CZ;;A8E5r1CQ;EAOI,gCAAA;A9Eyr1CZ;;A8Ehs1CQ;EAOI,8BAAA;A9E6r1CZ;;A8Eps1CQ;EAOI,4BAAA;A9Eis1CZ;;A8Exs1CQ;EAOI,kCAAA;A9Eqs1CZ;;A8E5s1CQ;EAOI,iCAAA;A9Eys1CZ;;A8Eht1CQ;EAOI,+BAAA;A9E6s1CZ;;A8Ept1CQ;EAOI,iCAAA;A9Eit1CZ;;A8Ext1CQ;EAOI,+BAAA;A9Eqt1CZ;;A8E5t1CQ;EAOI,0BAAA;A9Eyt1CZ;;A8Ehu1CQ;EAOI,gCAAA;A9E6t1CZ;;A8Epu1CQ;EAOI,+BAAA;A9Eiu1CZ;;A8Exu1CQ;EAOI,6BAAA;A9Equ1CZ;;A8E5u1CQ;EAOI,+BAAA;A9Eyu1CZ;;A8Ehv1CQ;EAOI,6BAAA;A9E6u1CZ;;A8Epv1CQ;EAOI,iBAAA;A9Eiv1CZ;;A8Exv1CQ;EAOI,uBAAA;A9Eqv1CZ;;A8E5v1CQ;EAOI,sBAAA;A9Eyv1CZ;;A8Ehw1CQ;EAOI,oBAAA;A9E6v1CZ;;A8Epw1CQ;EAOI,sBAAA;A9Eiw1CZ;;A8Exw1CQ;EAOI,oBAAA;A9Eqw1CZ;;A8E5w1CQ;EAOI,qBAAA;A9Eyw1CZ;;A8Ehx1CQ;EAOI,2BAAA;A9E6w1CZ;;A8Epx1CQ;EAOI,0BAAA;A9Eix1CZ;;A8Exx1CQ;EAOI,wBAAA;A9Eqx1CZ;;A8E5x1CQ;EAOI,0BAAA;A9Eyx1CZ;;A8Ehy1CQ;EAOI,wBAAA;A9E6x1CZ;;A8Epy1CQ;EAOI,wBAAA;A9Eiy1CZ;;A8Exy1CQ;EAOI,8BAAA;A9Eqy1CZ;;A8E5y1CQ;EAOI,6BAAA;A9Eyy1CZ;;A8Ehz1CQ;EAOI,2BAAA;A9E6y1CZ;;A8Epz1CQ;EAOI,6BAAA;A9Eiz1CZ;;A8Exz1CQ;EAOI,2BAAA;A9Eqz1CZ;;A8E5z1CQ;EAOI,gDAAA;A9Eyz1CZ;;A8Eh01CQ;EAOI,2CAAA;A9E6z1CZ;;A8Ep01CQ;EAOI,6CAAA;A9Ei01CZ;;A8Ex01CQ;EAOI,8CAAA;A9Eq01CZ;;A8E501CQ;EAOI,4CAAA;A9Ey01CZ;;A8Eh11CQ;EAOI,8BAAA;A9E601CZ;;A8Ep11CQ;EAOI,4BAAA;A9Ei11CZ;;A8Ex11CQ;EAOI,6BAAA;A9Eq11CZ;;A8E511CQ;EAOI,6BAAA;A9Ey11CZ;;A8Eh21CQ;EAOI,+BAAA;A9E611CZ;;A8Ep21CQ;EAOI,2BAAA;A9Ei21CZ;;A8Ex21CQ;EAOI,2BAAA;A9Eq21CZ;;A8E521CQ;EAOI,2BAAA;A9Ey21CZ;;A8Eh31CQ;EAOI,2BAAA;A9E621CZ;;A8Ep31CQ;EAOI,2BAAA;A9Ei31CZ;;A8Ex31CQ;EAOI,8BAAA;A9Eq31CZ;;A8E531CQ;EAOI,yBAAA;A9Ey31CZ;;A8Eh41CQ;EAOI,4BAAA;A9E631CZ;;A8Ep41CQ;EAOI,2BAAA;A9Ei41CZ;;A8Ex41CQ;EAOI,yBAAA;A9Eq41CZ;;A8E541CQ;EAOI,2BAAA;A9Ey41CZ;;A8Eh51CQ;EAOI,4BAAA;A9E641CZ;;A8Ep51CQ;EAOI,6BAAA;A9Ei51CZ;;A8Ex51CQ;EAOI,gCAAA;A9Eq51CZ;;A8E551CQ;EAOI,qCAAA;A9Ey51CZ;;A8Eh61CQ;EAOI,wCAAA;A9E651CZ;;A8Ep61CQ;EAOI,oCAAA;A9Ei61CZ;;A8Ex61CQ;EAOI,oCAAA;A9Eq61CZ;;A8E561CQ;EAOI,qCAAA;A9Ey61CZ;;A8Eh71CQ;EAOI,8BAAA;A9E661CZ;;A8Ep71CQ;EAOI,8BAAA;A9Ei71CZ;;A8Et81CQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;A9Eu71CZ;;A8Ep61CQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,qEAAA;A9E671CZ;;A8Ep81CQ;EAIQ,oBAAA;EAGJ,uEAAA;A9Ek81CZ;;A8Ez81CQ;EAIQ,oBAAA;EAGJ,qEAAA;A9Eu81CZ;;A8E981CQ;EAIQ,oBAAA;EAGJ,kEAAA;A9E481CZ;;A8En91CQ;EAIQ,oBAAA;EAGJ,qEAAA;A9Ei91CZ;;A8Ex91CQ;EAIQ,oBAAA;EAGJ,oEAAA;A9Es91CZ;;A8E791CQ;EAIQ,oBAAA;EAGJ,kEAAA;A9E291CZ;;A8El+1CQ;EAIQ,oBAAA;EAGJ,mEAAA;A9Eg+1CZ;;A8Ev+1CQ;EAIQ,oBAAA;EAGJ,kEAAA;A9Eq+1CZ;;A8E5+1CQ;EAIQ,oBAAA;EAGJ,oEAAA;A9E0+1CZ;;A8Ej/1CQ;EAIQ,oBAAA;EAGJ,mEAAA;A9E++1CZ;;A8Et/1CQ;EAIQ,oBAAA;EAGJ,mEAAA;A9Eo/1CZ;;A8E3/1CQ;EAIQ,oBAAA;EAGJ,wEAAA;A9Ey/1CZ;;A8Ehg2CQ;EAIQ,oBAAA;EAGJ,2CAAA;A9E8/1CZ;;A8Erg2CQ;EAIQ,oBAAA;EAGJ,oCAAA;A9Emg2CZ;;A8E1g2CQ;EAIQ,oBAAA;EAGJ,0CAAA;A9Ewg2CZ;;A8E/g2CQ;EAIQ,oBAAA;EAGJ,2CAAA;A9E6g2CZ;;A8Eph2CQ;EAIQ,oBAAA;EAGJ,0CAAA;A9Ekh2CZ;;A8Ezh2CQ;EAIQ,oBAAA;EAGJ,0CAAA;A9Euh2CZ;;A8E9h2CQ;EAIQ,oBAAA;EAGJ,yBAAA;A9E4h2CZ;;A8E7i2CQ;EACE,uBAAA;A9Egj2CV;;A8Ejj2CQ;EACE,sBAAA;A9Eoj2CV;;A8Erj2CQ;EACE,uBAAA;A9Ewj2CV;;A8Ezj2CQ;EACE,oBAAA;A9E4j2CV;;A8Enj2CQ;EAOI,iDAAA;A9Egj2CZ;;A8Evj2CQ;EAOI,mDAAA;A9Eoj2CZ;;A8E3j2CQ;EAOI,iDAAA;A9Ewj2CZ;;A8E/j2CQ;EAOI,8CAAA;A9E4j2CZ;;A8Enk2CQ;EAOI,iDAAA;A9Egk2CZ;;A8Evk2CQ;EAOI,gDAAA;A9Eok2CZ;;A8E3k2CQ;EAOI,+CAAA;A9Ewk2CZ;;A8E/k2CQ;EAOI,8CAAA;A9E4k2CZ;;A8E7l2CQ;EACE,sBAAA;A9Egm2CV;;A8E5l2CU;EACE,sBAAA;A9E+l2CZ;;A8Erm2CQ;EACE,uBAAA;A9Ewm2CV;;A8Epm2CU;EACE,uBAAA;A9Eum2CZ;;A8E7m2CQ;EACE,sBAAA;A9Egn2CV;;A8E5m2CU;EACE,sBAAA;A9E+m2CZ;;A8Ern2CQ;EACE,uBAAA;A9Ewn2CV;;A8Epn2CU;EACE,uBAAA;A9Eun2CZ;;A8E7n2CQ;EACE,oBAAA;A9Ego2CV;;A8E5n2CU;EACE,oBAAA;A9E+n2CZ;;A8E3n2CQ;EAOI,yCAAA;A9Ewn2CZ;;A8Enn2CU;EAOI,yCAAA;A9Egn2Cd;;A8Eno2CQ;EAOI,wCAAA;A9Ego2CZ;;A8E3n2CU;EAOI,wCAAA;A9Ewn2Cd;;A8E3o2CQ;EAOI,yCAAA;A9Ewo2CZ;;A8Eno2CU;EAOI,yCAAA;A9Ego2Cd;;A8Enp2CQ;EAIQ,8BAAA;EAGJ,+FAAA;A9Eip2CZ;;A8Exp2CQ;EAIQ,8BAAA;EAGJ,iGAAA;A9Esp2CZ;;A8E7p2CQ;EAIQ,8BAAA;EAGJ,+FAAA;A9E2p2CZ;;A8Elq2CQ;EAIQ,8BAAA;EAGJ,4FAAA;A9Egq2CZ;;A8Evq2CQ;EAIQ,8BAAA;EAGJ,+FAAA;A9Eqq2CZ;;A8E5q2CQ;EAIQ,8BAAA;EAGJ,8FAAA;A9E0q2CZ;;A8Ejr2CQ;EAIQ,8BAAA;EAGJ,4FAAA;A9E+q2CZ;;A8Etr2CQ;EAIQ,8BAAA;EAGJ,6FAAA;A9Eor2CZ;;A8E3r2CQ;EAIQ,8BAAA;EAGJ,4FAAA;A9Eyr2CZ;;A8Ehs2CQ;EAIQ,8BAAA;EAGJ,8FAAA;A9E8r2CZ;;A8Ers2CQ;EAIQ,8BAAA;EAGJ,qGAAA;A9Ems2CZ;;A8Ept2CQ;EACE,8BAAA;A9Eut2CV;;A8Ent2CU;EACE,8BAAA;A9Est2CZ;;A8E5t2CQ;EACE,gCAAA;A9E+t2CV;;A8E3t2CU;EACE,gCAAA;A9E8t2CZ;;A8Epu2CQ;EACE,iCAAA;A9Euu2CV;;A8Enu2CU;EACE,iCAAA;A9Esu2CZ;;A8E5u2CQ;EACE,gCAAA;A9E+u2CV;;A8E3u2CU;EACE,gCAAA;A9E8u2CZ;;A8Epv2CQ;EACE,iCAAA;A9Euv2CV;;A8Env2CU;EACE,iCAAA;A9Esv2CZ;;A8E5v2CQ;EACE,8BAAA;A9E+v2CV;;A8E3v2CU;EACE,8BAAA;A9E8v2CZ;;A8E1v2CQ;EAIQ,kBAAA;EAGJ,8EAAA;A9Ewv2CZ;;A8E/v2CQ;EAIQ,kBAAA;EAGJ,gFAAA;A9E6v2CZ;;A8Epw2CQ;EAIQ,kBAAA;EAGJ,8EAAA;A9Ekw2CZ;;A8Ezw2CQ;EAIQ,kBAAA;EAGJ,2EAAA;A9Euw2CZ;;A8E9w2CQ;EAIQ,kBAAA;EAGJ,8EAAA;A9E4w2CZ;;A8Enx2CQ;EAIQ,kBAAA;EAGJ,6EAAA;A9Eix2CZ;;A8Exx2CQ;EAIQ,kBAAA;EAGJ,2EAAA;A9Esx2CZ;;A8E7x2CQ;EAIQ,kBAAA;EAGJ,4EAAA;A9E2x2CZ;;A8Ely2CQ;EAIQ,kBAAA;EAGJ,2EAAA;A9Egy2CZ;;A8Evy2CQ;EAIQ,kBAAA;EAGJ,6EAAA;A9Eqy2CZ;;A8E5y2CQ;EAIQ,kBAAA;EAGJ,4EAAA;A9E0y2CZ;;A8Ejz2CQ;EAIQ,kBAAA;EAGJ,4EAAA;A9E+y2CZ;;A8Etz2CQ;EAIQ,kBAAA;EAGJ,8EAAA;A9Eoz2CZ;;A8E3z2CQ;EAIQ,kBAAA;EAGJ,wCAAA;A9Eyz2CZ;;A8Eh02CQ;EAIQ,kBAAA;EAGJ,mFAAA;A9E8z2CZ;;A8Er02CQ;EAIQ,kBAAA;EAGJ,kFAAA;A9Em02CZ;;A8Ep12CQ;EACE,oBAAA;A9Eu12CV;;A8Ex12CQ;EACE,qBAAA;A9E212CV;;A8E512CQ;EACE,oBAAA;A9E+12CV;;A8Eh22CQ;EACE,qBAAA;A9Em22CV;;A8Ep22CQ;EACE,kBAAA;A9Eu22CV;;A8E912CQ;EAOI,wDAAA;A9E212CZ;;A8El22CQ;EAOI,0DAAA;A9E+12CZ;;A8Et22CQ;EAOI,wDAAA;A9Em22CZ;;A8E122CQ;EAOI,qDAAA;A9Eu22CZ;;A8E922CQ;EAOI,wDAAA;A9E222CZ;;A8El32CQ;EAOI,uDAAA;A9E+22CZ;;A8Et32CQ;EAOI,sDAAA;A9Em32CZ;;A8E132CQ;EAOI,qDAAA;A9Eu32CZ;;A8E932CQ;EAOI,+CAAA;A9E232CZ;;A8El42CQ;EAOI,mCAAA;UAAA,2BAAA;A9E+32CZ;;A8Et42CQ;EAOI,oCAAA;UAAA,4BAAA;A9Em42CZ;;A8E142CQ;EAOI,oCAAA;UAAA,4BAAA;A9Eu42CZ;;A8E942CQ;EAOI,+BAAA;A9E242CZ;;A8El52CQ;EAOI,+BAAA;A9E+42CZ;;A8Et52CQ;EAOI,iDAAA;A9Em52CZ;;A8E152CQ;EAOI,2BAAA;A9Eu52CZ;;A8E952CQ;EAOI,oDAAA;A9E252CZ;;A8El62CQ;EAOI,iDAAA;A9E+52CZ;;A8Et62CQ;EAOI,oDAAA;A9Em62CZ;;A8E162CQ;EAOI,oDAAA;A9Eu62CZ;;A8E962CQ;EAOI,qDAAA;A9E262CZ;;A8El72CQ;EAOI,6BAAA;A9E+62CZ;;A8Et72CQ;EAOI,sDAAA;A9Em72CZ;;A8E172CQ;EAOI,0DAAA;EAAA,2DAAA;A9Ew72CZ;;A8E/72CQ;EAOI,oCAAA;EAAA,qCAAA;A9E672CZ;;A8Ep82CQ;EAOI,6DAAA;EAAA,8DAAA;A9Ek82CZ;;A8Ez82CQ;EAOI,0DAAA;EAAA,2DAAA;A9Eu82CZ;;A8E982CQ;EAOI,6DAAA;EAAA,8DAAA;A9E482CZ;;A8En92CQ;EAOI,6DAAA;EAAA,8DAAA;A9Ei92CZ;;A8Ex92CQ;EAOI,8DAAA;EAAA,+DAAA;A9Es92CZ;;A8E792CQ;EAOI,sCAAA;EAAA,uCAAA;A9E292CZ;;A8El+2CQ;EAOI,+DAAA;EAAA,gEAAA;A9Eg+2CZ;;A8Ev+2CQ;EAOI,2DAAA;EAAA,8DAAA;A9Eq+2CZ;;A8E5+2CQ;EAOI,qCAAA;EAAA,wCAAA;A9E0+2CZ;;A8Ej/2CQ;EAOI,8DAAA;EAAA,iEAAA;A9E++2CZ;;A8Et/2CQ;EAOI,2DAAA;EAAA,8DAAA;A9Eo/2CZ;;A8E3/2CQ;EAOI,8DAAA;EAAA,iEAAA;A9Ey/2CZ;;A8Ehg3CQ;EAOI,8DAAA;EAAA,iEAAA;A9E8/2CZ;;A8Erg3CQ;EAOI,+DAAA;EAAA,kEAAA;A9Emg3CZ;;A8E1g3CQ;EAOI,uCAAA;EAAA,0CAAA;A9Ewg3CZ;;A8E/g3CQ;EAOI,gEAAA;EAAA,mEAAA;A9E6g3CZ;;A8Eph3CQ;EAOI,8DAAA;EAAA,6DAAA;A9Ekh3CZ;;A8Ezh3CQ;EAOI,wCAAA;EAAA,uCAAA;A9Euh3CZ;;A8E9h3CQ;EAOI,iEAAA;EAAA,gEAAA;A9E4h3CZ;;A8Eni3CQ;EAOI,8DAAA;EAAA,6DAAA;A9Eii3CZ;;A8Exi3CQ;EAOI,iEAAA;EAAA,gEAAA;A9Esi3CZ;;A8E7i3CQ;EAOI,iEAAA;EAAA,gEAAA;A9E2i3CZ;;A8Elj3CQ;EAOI,kEAAA;EAAA,iEAAA;A9Egj3CZ;;A8Evj3CQ;EAOI,0CAAA;EAAA,yCAAA;A9Eqj3CZ;;A8E5j3CQ;EAOI,mEAAA;EAAA,kEAAA;A9E0j3CZ;;A8Ejk3CQ;EAOI,6DAAA;EAAA,0DAAA;A9E+j3CZ;;A8Etk3CQ;EAOI,uCAAA;EAAA,oCAAA;A9Eok3CZ;;A8E3k3CQ;EAOI,gEAAA;EAAA,6DAAA;A9Eyk3CZ;;A8Ehl3CQ;EAOI,6DAAA;EAAA,0DAAA;A9E8k3CZ;;A8Erl3CQ;EAOI,gEAAA;EAAA,6DAAA;A9Eml3CZ;;A8E1l3CQ;EAOI,gEAAA;EAAA,6DAAA;A9Ewl3CZ;;A8E/l3CQ;EAOI,iEAAA;EAAA,8DAAA;A9E6l3CZ;;A8Epm3CQ;EAOI,yCAAA;EAAA,sCAAA;A9Ekm3CZ;;A8Ezm3CQ;EAOI,kEAAA;EAAA,+DAAA;A9Eum3CZ;;A8E9m3CQ;EAOI,8BAAA;A9E2m3CZ;;A8Eln3CQ;EAOI,6BAAA;A9E+m3CZ;;A8Etn3CQ;EAOI,sBAAA;A9Emn3CZ;;A8E1n3CQ;EAOI,qBAAA;A9Eun3CZ;;A8E9n3CQ;EAOI,qBAAA;A9E2n3CZ;;A8Elo3CQ;EAOI,qBAAA;A9E+n3CZ;;A8Eto3CQ;EAOI,qBAAA;A9Emo3CZ;;AoB7o3CI;E0DGI;IAOI,sBAAA;E9Ewo3CV;E8E/o3CM;IAOI,uBAAA;E9E2o3CV;E8Elp3CM;IAOI,sBAAA;E9E8o3CV;E8Erp3CM;IAOI,8BAAA;E9Eip3CV;E8Exp3CM;IAOI,4BAAA;E9Eop3CV;E8E3p3CM;IAOI,2BAAA;E9Eup3CV;E8E9p3CM;IAOI,iCAAA;E9E0p3CV;E8Ejq3CM;IAOI,2BAAA;E9E6p3CV;E8Epq3CM;IAOI,0BAAA;E9Egq3CV;E8Evq3CM;IAOI,gCAAA;E9Emq3CV;E8E1q3CM;IAOI,yBAAA;E9Esq3CV;E8E7q3CM;IAOI,wBAAA;E9Eyq3CV;E8Ehr3CM;IAOI,+BAAA;E9E4q3CV;E8Enr3CM;IAOI,yBAAA;E9E+q3CV;E8Etr3CM;IAOI,6BAAA;E9Ekr3CV;E8Ezr3CM;IAOI,8BAAA;E9Eqr3CV;E8E5r3CM;IAOI,wBAAA;E9Ewr3CV;E8E/r3CM;IAOI,+BAAA;E9E2r3CV;E8Els3CM;IAOI,wBAAA;E9E8r3CV;E8Ers3CM;IAOI,yBAAA;E9Eis3CV;E8Exs3CM;IAOI,8BAAA;E9Eos3CV;E8E3s3CM;IAOI,iCAAA;E9Eus3CV;E8E9s3CM;IAOI,sCAAA;E9E0s3CV;E8Ejt3CM;IAOI,yCAAA;E9E6s3CV;E8Ept3CM;IAOI,uBAAA;E9Egt3CV;E8Evt3CM;IAOI,uBAAA;E9Emt3CV;E8E1t3CM;IAOI,yBAAA;E9Est3CV;E8E7t3CM;IAOI,yBAAA;E9Eyt3CV;E8Ehu3CM;IAOI,0BAAA;E9E4t3CV;E8Enu3CM;IAOI,4BAAA;E9E+t3CV;E8Etu3CM;IAOI,kCAAA;E9Eku3CV;E8Ezu3CM;IAOI,sCAAA;E9Equ3CV;E8E5u3CM;IAOI,oCAAA;E9Ewu3CV;E8E/u3CM;IAOI,kCAAA;E9E2u3CV;E8Elv3CM;IAOI,yCAAA;E9E8u3CV;E8Erv3CM;IAOI,wCAAA;E9Eiv3CV;E8Exv3CM;IAOI,wCAAA;E9Eov3CV;E8E3v3CM;IAOI,kCAAA;E9Euv3CV;E8E9v3CM;IAOI,gCAAA;E9E0v3CV;E8Ejw3CM;IAOI,8BAAA;E9E6v3CV;E8Epw3CM;IAOI,gCAAA;E9Egw3CV;E8Evw3CM;IAOI,+BAAA;E9Emw3CV;E8E1w3CM;IAOI,oCAAA;E9Esw3CV;E8E7w3CM;IAOI,kCAAA;E9Eyw3CV;E8Ehx3CM;IAOI,gCAAA;E9E4w3CV;E8Enx3CM;IAOI,uCAAA;E9E+w3CV;E8Etx3CM;IAOI,sCAAA;E9Ekx3CV;E8Ezx3CM;IAOI,iCAAA;E9Eqx3CV;E8E5x3CM;IAOI,2BAAA;E9Ewx3CV;E8E/x3CM;IAOI,iCAAA;E9E2x3CV;E8Ely3CM;IAOI,+BAAA;E9E8x3CV;E8Ery3CM;IAOI,6BAAA;E9Eiy3CV;E8Exy3CM;IAOI,+BAAA;E9Eoy3CV;E8E3y3CM;IAOI,8BAAA;E9Euy3CV;E8E9y3CM;IAOI,oBAAA;E9E0y3CV;E8Ejz3CM;IAOI,mBAAA;E9E6y3CV;E8Epz3CM;IAOI,mBAAA;E9Egz3CV;E8Evz3CM;IAOI,mBAAA;E9Emz3CV;E8E1z3CM;IAOI,mBAAA;E9Esz3CV;E8E7z3CM;IAOI,mBAAA;E9Eyz3CV;E8Eh03CM;IAOI,mBAAA;E9E4z3CV;E8En03CM;IAOI,mBAAA;E9E+z3CV;E8Et03CM;IAOI,oBAAA;E9Ek03CV;E8Ez03CM;IAOI,0BAAA;E9Eq03CV;E8E503CM;IAOI,yBAAA;E9Ew03CV;E8E/03CM;IAOI,uBAAA;E9E203CV;E8El13CM;IAOI,yBAAA;E9E803CV;E8Er13CM;IAOI,uBAAA;E9Ei13CV;E8Ex13CM;IAOI,uBAAA;E9Eo13CV;E8E313CM;IAOI,0BAAA;IAAA,yBAAA;E9Ew13CV;E8E/13CM;IAOI,gCAAA;IAAA,+BAAA;E9E413CV;E8En23CM;IAOI,+BAAA;IAAA,8BAAA;E9Eg23CV;E8Ev23CM;IAOI,6BAAA;IAAA,4BAAA;E9Eo23CV;E8E323CM;IAOI,+BAAA;IAAA,8BAAA;E9Ew23CV;E8E/23CM;IAOI,6BAAA;IAAA,4BAAA;E9E423CV;E8En33CM;IAOI,6BAAA;IAAA,4BAAA;E9Eg33CV;E8Ev33CM;IAOI,wBAAA;IAAA,2BAAA;E9Eo33CV;E8E333CM;IAOI,8BAAA;IAAA,iCAAA;E9Ew33CV;E8E/33CM;IAOI,6BAAA;IAAA,gCAAA;E9E433CV;E8En43CM;IAOI,2BAAA;IAAA,8BAAA;E9Eg43CV;E8Ev43CM;IAOI,6BAAA;IAAA,gCAAA;E9Eo43CV;E8E343CM;IAOI,2BAAA;IAAA,8BAAA;E9Ew43CV;E8E/43CM;IAOI,2BAAA;IAAA,8BAAA;E9E443CV;E8En53CM;IAOI,wBAAA;E9E+43CV;E8Et53CM;IAOI,8BAAA;E9Ek53CV;E8Ez53CM;IAOI,6BAAA;E9Eq53CV;E8E553CM;IAOI,2BAAA;E9Ew53CV;E8E/53CM;IAOI,6BAAA;E9E253CV;E8El63CM;IAOI,2BAAA;E9E853CV;E8Er63CM;IAOI,2BAAA;E9Ei63CV;E8Ex63CM;IAOI,0BAAA;E9Eo63CV;E8E363CM;IAOI,gCAAA;E9Eu63CV;E8E963CM;IAOI,+BAAA;E9E063CV;E8Ej73CM;IAOI,6BAAA;E9E663CV;E8Ep73CM;IAOI,+BAAA;E9Eg73CV;E8Ev73CM;IAOI,6BAAA;E9Em73CV;E8E173CM;IAOI,6BAAA;E9Es73CV;E8E773CM;IAOI,2BAAA;E9Ey73CV;E8Eh83CM;IAOI,iCAAA;E9E473CV;E8En83CM;IAOI,gCAAA;E9E+73CV;E8Et83CM;IAOI,8BAAA;E9Ek83CV;E8Ez83CM;IAOI,gCAAA;E9Eq83CV;E8E583CM;IAOI,8BAAA;E9Ew83CV;E8E/83CM;IAOI,8BAAA;E9E283CV;E8El93CM;IAOI,yBAAA;E9E883CV;E8Er93CM;IAOI,+BAAA;E9Ei93CV;E8Ex93CM;IAOI,8BAAA;E9Eo93CV;E8E393CM;IAOI,4BAAA;E9Eu93CV;E8E993CM;IAOI,8BAAA;E9E093CV;E8Ej+3CM;IAOI,4BAAA;E9E693CV;E8Ep+3CM;IAOI,4BAAA;E9Eg+3CV;E8Ev+3CM;IAOI,qBAAA;E9Em+3CV;E8E1+3CM;IAOI,2BAAA;E9Es+3CV;E8E7+3CM;IAOI,0BAAA;E9Ey+3CV;E8Eh/3CM;IAOI,wBAAA;E9E4+3CV;E8En/3CM;IAOI,0BAAA;E9E++3CV;E8Et/3CM;IAOI,wBAAA;E9Ek/3CV;E8Ez/3CM;IAOI,2BAAA;IAAA,0BAAA;E9Es/3CV;E8E7/3CM;IAOI,iCAAA;IAAA,gCAAA;E9E0/3CV;E8Ejg4CM;IAOI,gCAAA;IAAA,+BAAA;E9E8/3CV;E8Erg4CM;IAOI,8BAAA;IAAA,6BAAA;E9Ekg4CV;E8Ezg4CM;IAOI,gCAAA;IAAA,+BAAA;E9Esg4CV;E8E7g4CM;IAOI,8BAAA;IAAA,6BAAA;E9E0g4CV;E8Ejh4CM;IAOI,yBAAA;IAAA,4BAAA;E9E8g4CV;E8Erh4CM;IAOI,+BAAA;IAAA,kCAAA;E9Ekh4CV;E8Ezh4CM;IAOI,8BAAA;IAAA,iCAAA;E9Esh4CV;E8E7h4CM;IAOI,4BAAA;IAAA,+BAAA;E9E0h4CV;E8Eji4CM;IAOI,8BAAA;IAAA,iCAAA;E9E8h4CV;E8Eri4CM;IAOI,4BAAA;IAAA,+BAAA;E9Eki4CV;E8Ezi4CM;IAOI,yBAAA;E9Eqi4CV;E8E5i4CM;IAOI,+BAAA;E9Ewi4CV;E8E/i4CM;IAOI,8BAAA;E9E2i4CV;E8Elj4CM;IAOI,4BAAA;E9E8i4CV;E8Erj4CM;IAOI,8BAAA;E9Eij4CV;E8Exj4CM;IAOI,4BAAA;E9Eoj4CV;E8E3j4CM;IAOI,2BAAA;E9Euj4CV;E8E9j4CM;IAOI,iCAAA;E9E0j4CV;E8Ejk4CM;IAOI,gCAAA;E9E6j4CV;E8Epk4CM;IAOI,8BAAA;E9Egk4CV;E8Evk4CM;IAOI,gCAAA;E9Emk4CV;E8E1k4CM;IAOI,8BAAA;E9Esk4CV;E8E7k4CM;IAOI,4BAAA;E9Eyk4CV;E8Ehl4CM;IAOI,kCAAA;E9E4k4CV;E8Enl4CM;IAOI,iCAAA;E9E+k4CV;E8Etl4CM;IAOI,+BAAA;E9Ekl4CV;E8Ezl4CM;IAOI,iCAAA;E9Eql4CV;E8E5l4CM;IAOI,+BAAA;E9Ewl4CV;E8E/l4CM;IAOI,0BAAA;E9E2l4CV;E8Elm4CM;IAOI,gCAAA;E9E8l4CV;E8Erm4CM;IAOI,+BAAA;E9Eim4CV;E8Exm4CM;IAOI,6BAAA;E9Eom4CV;E8E3m4CM;IAOI,+BAAA;E9Eum4CV;E8E9m4CM;IAOI,6BAAA;E9E0m4CV;E8Ejn4CM;IAOI,iBAAA;E9E6m4CV;E8Epn4CM;IAOI,uBAAA;E9Egn4CV;E8Evn4CM;IAOI,sBAAA;E9Emn4CV;E8E1n4CM;IAOI,oBAAA;E9Esn4CV;E8E7n4CM;IAOI,sBAAA;E9Eyn4CV;E8Eho4CM;IAOI,oBAAA;E9E4n4CV;E8Eno4CM;IAOI,qBAAA;E9E+n4CV;E8Eto4CM;IAOI,2BAAA;E9Eko4CV;E8Ezo4CM;IAOI,0BAAA;E9Eqo4CV;E8E5o4CM;IAOI,wBAAA;E9Ewo4CV;E8E/o4CM;IAOI,0BAAA;E9E2o4CV;E8Elp4CM;IAOI,wBAAA;E9E8o4CV;E8Erp4CM;IAOI,wBAAA;E9Eip4CV;E8Exp4CM;IAOI,8BAAA;E9Eop4CV;E8E3p4CM;IAOI,6BAAA;E9Eup4CV;E8E9p4CM;IAOI,2BAAA;E9E0p4CV;E8Ejq4CM;IAOI,6BAAA;E9E6p4CV;E8Epq4CM;IAOI,2BAAA;E9Egq4CV;E8Evq4CM;IAOI,2BAAA;E9Emq4CV;E8E1q4CM;IAOI,4BAAA;E9Esq4CV;E8E7q4CM;IAOI,6BAAA;E9Eyq4CV;AACF;AoBpr4CI;E0DGI;IAOI,sBAAA;E9E8q4CV;E8Err4CM;IAOI,uBAAA;E9Eir4CV;E8Exr4CM;IAOI,sBAAA;E9Eor4CV;E8E3r4CM;IAOI,8BAAA;E9Eur4CV;E8E9r4CM;IAOI,4BAAA;E9E0r4CV;E8Ejs4CM;IAOI,2BAAA;E9E6r4CV;E8Eps4CM;IAOI,iCAAA;E9Egs4CV;E8Evs4CM;IAOI,2BAAA;E9Ems4CV;E8E1s4CM;IAOI,0BAAA;E9Ess4CV;E8E7s4CM;IAOI,gCAAA;E9Eys4CV;E8Eht4CM;IAOI,yBAAA;E9E4s4CV;E8Ent4CM;IAOI,wBAAA;E9E+s4CV;E8Ett4CM;IAOI,+BAAA;E9Ekt4CV;E8Ezt4CM;IAOI,yBAAA;E9Eqt4CV;E8E5t4CM;IAOI,6BAAA;E9Ewt4CV;E8E/t4CM;IAOI,8BAAA;E9E2t4CV;E8Elu4CM;IAOI,wBAAA;E9E8t4CV;E8Eru4CM;IAOI,+BAAA;E9Eiu4CV;E8Exu4CM;IAOI,wBAAA;E9Eou4CV;E8E3u4CM;IAOI,yBAAA;E9Euu4CV;E8E9u4CM;IAOI,8BAAA;E9E0u4CV;E8Ejv4CM;IAOI,iCAAA;E9E6u4CV;E8Epv4CM;IAOI,sCAAA;E9Egv4CV;E8Evv4CM;IAOI,yCAAA;E9Emv4CV;E8E1v4CM;IAOI,uBAAA;E9Esv4CV;E8E7v4CM;IAOI,uBAAA;E9Eyv4CV;E8Ehw4CM;IAOI,yBAAA;E9E4v4CV;E8Enw4CM;IAOI,yBAAA;E9E+v4CV;E8Etw4CM;IAOI,0BAAA;E9Ekw4CV;E8Ezw4CM;IAOI,4BAAA;E9Eqw4CV;E8E5w4CM;IAOI,kCAAA;E9Eww4CV;E8E/w4CM;IAOI,sCAAA;E9E2w4CV;E8Elx4CM;IAOI,oCAAA;E9E8w4CV;E8Erx4CM;IAOI,kCAAA;E9Eix4CV;E8Exx4CM;IAOI,yCAAA;E9Eox4CV;E8E3x4CM;IAOI,wCAAA;E9Eux4CV;E8E9x4CM;IAOI,wCAAA;E9E0x4CV;E8Ejy4CM;IAOI,kCAAA;E9E6x4CV;E8Epy4CM;IAOI,gCAAA;E9Egy4CV;E8Evy4CM;IAOI,8BAAA;E9Emy4CV;E8E1y4CM;IAOI,gCAAA;E9Esy4CV;E8E7y4CM;IAOI,+BAAA;E9Eyy4CV;E8Ehz4CM;IAOI,oCAAA;E9E4y4CV;E8Enz4CM;IAOI,kCAAA;E9E+y4CV;E8Etz4CM;IAOI,gCAAA;E9Ekz4CV;E8Ezz4CM;IAOI,uCAAA;E9Eqz4CV;E8E5z4CM;IAOI,sCAAA;E9Ewz4CV;E8E/z4CM;IAOI,iCAAA;E9E2z4CV;E8El04CM;IAOI,2BAAA;E9E8z4CV;E8Er04CM;IAOI,iCAAA;E9Ei04CV;E8Ex04CM;IAOI,+BAAA;E9Eo04CV;E8E304CM;IAOI,6BAAA;E9Eu04CV;E8E904CM;IAOI,+BAAA;E9E004CV;E8Ej14CM;IAOI,8BAAA;E9E604CV;E8Ep14CM;IAOI,oBAAA;E9Eg14CV;E8Ev14CM;IAOI,mBAAA;E9Em14CV;E8E114CM;IAOI,mBAAA;E9Es14CV;E8E714CM;IAOI,mBAAA;E9Ey14CV;E8Eh24CM;IAOI,mBAAA;E9E414CV;E8En24CM;IAOI,mBAAA;E9E+14CV;E8Et24CM;IAOI,mBAAA;E9Ek24CV;E8Ez24CM;IAOI,mBAAA;E9Eq24CV;E8E524CM;IAOI,oBAAA;E9Ew24CV;E8E/24CM;IAOI,0BAAA;E9E224CV;E8El34CM;IAOI,yBAAA;E9E824CV;E8Er34CM;IAOI,uBAAA;E9Ei34CV;E8Ex34CM;IAOI,yBAAA;E9Eo34CV;E8E334CM;IAOI,uBAAA;E9Eu34CV;E8E934CM;IAOI,uBAAA;E9E034CV;E8Ej44CM;IAOI,0BAAA;IAAA,yBAAA;E9E834CV;E8Er44CM;IAOI,gCAAA;IAAA,+BAAA;E9Ek44CV;E8Ez44CM;IAOI,+BAAA;IAAA,8BAAA;E9Es44CV;E8E744CM;IAOI,6BAAA;IAAA,4BAAA;E9E044CV;E8Ej54CM;IAOI,+BAAA;IAAA,8BAAA;E9E844CV;E8Er54CM;IAOI,6BAAA;IAAA,4BAAA;E9Ek54CV;E8Ez54CM;IAOI,6BAAA;IAAA,4BAAA;E9Es54CV;E8E754CM;IAOI,wBAAA;IAAA,2BAAA;E9E054CV;E8Ej64CM;IAOI,8BAAA;IAAA,iCAAA;E9E854CV;E8Er64CM;IAOI,6BAAA;IAAA,gCAAA;E9Ek64CV;E8Ez64CM;IAOI,2BAAA;IAAA,8BAAA;E9Es64CV;E8E764CM;IAOI,6BAAA;IAAA,gCAAA;E9E064CV;E8Ej74CM;IAOI,2BAAA;IAAA,8BAAA;E9E864CV;E8Er74CM;IAOI,2BAAA;IAAA,8BAAA;E9Ek74CV;E8Ez74CM;IAOI,wBAAA;E9Eq74CV;E8E574CM;IAOI,8BAAA;E9Ew74CV;E8E/74CM;IAOI,6BAAA;E9E274CV;E8El84CM;IAOI,2BAAA;E9E874CV;E8Er84CM;IAOI,6BAAA;E9Ei84CV;E8Ex84CM;IAOI,2BAAA;E9Eo84CV;E8E384CM;IAOI,2BAAA;E9Eu84CV;E8E984CM;IAOI,0BAAA;E9E084CV;E8Ej94CM;IAOI,gCAAA;E9E684CV;E8Ep94CM;IAOI,+BAAA;E9Eg94CV;E8Ev94CM;IAOI,6BAAA;E9Em94CV;E8E194CM;IAOI,+BAAA;E9Es94CV;E8E794CM;IAOI,6BAAA;E9Ey94CV;E8Eh+4CM;IAOI,6BAAA;E9E494CV;E8En+4CM;IAOI,2BAAA;E9E+94CV;E8Et+4CM;IAOI,iCAAA;E9Ek+4CV;E8Ez+4CM;IAOI,gCAAA;E9Eq+4CV;E8E5+4CM;IAOI,8BAAA;E9Ew+4CV;E8E/+4CM;IAOI,gCAAA;E9E2+4CV;E8El/4CM;IAOI,8BAAA;E9E8+4CV;E8Er/4CM;IAOI,8BAAA;E9Ei/4CV;E8Ex/4CM;IAOI,yBAAA;E9Eo/4CV;E8E3/4CM;IAOI,+BAAA;E9Eu/4CV;E8E9/4CM;IAOI,8BAAA;E9E0/4CV;E8Ejg5CM;IAOI,4BAAA;E9E6/4CV;E8Epg5CM;IAOI,8BAAA;E9Egg5CV;E8Evg5CM;IAOI,4BAAA;E9Emg5CV;E8E1g5CM;IAOI,4BAAA;E9Esg5CV;E8E7g5CM;IAOI,qBAAA;E9Eyg5CV;E8Ehh5CM;IAOI,2BAAA;E9E4g5CV;E8Enh5CM;IAOI,0BAAA;E9E+g5CV;E8Eth5CM;IAOI,wBAAA;E9Ekh5CV;E8Ezh5CM;IAOI,0BAAA;E9Eqh5CV;E8E5h5CM;IAOI,wBAAA;E9Ewh5CV;E8E/h5CM;IAOI,2BAAA;IAAA,0BAAA;E9E4h5CV;E8Eni5CM;IAOI,iCAAA;IAAA,gCAAA;E9Egi5CV;E8Evi5CM;IAOI,gCAAA;IAAA,+BAAA;E9Eoi5CV;E8E3i5CM;IAOI,8BAAA;IAAA,6BAAA;E9Ewi5CV;E8E/i5CM;IAOI,gCAAA;IAAA,+BAAA;E9E4i5CV;E8Enj5CM;IAOI,8BAAA;IAAA,6BAAA;E9Egj5CV;E8Evj5CM;IAOI,yBAAA;IAAA,4BAAA;E9Eoj5CV;E8E3j5CM;IAOI,+BAAA;IAAA,kCAAA;E9Ewj5CV;E8E/j5CM;IAOI,8BAAA;IAAA,iCAAA;E9E4j5CV;E8Enk5CM;IAOI,4BAAA;IAAA,+BAAA;E9Egk5CV;E8Evk5CM;IAOI,8BAAA;IAAA,iCAAA;E9Eok5CV;E8E3k5CM;IAOI,4BAAA;IAAA,+BAAA;E9Ewk5CV;E8E/k5CM;IAOI,yBAAA;E9E2k5CV;E8Ell5CM;IAOI,+BAAA;E9E8k5CV;E8Erl5CM;IAOI,8BAAA;E9Eil5CV;E8Exl5CM;IAOI,4BAAA;E9Eol5CV;E8E3l5CM;IAOI,8BAAA;E9Eul5CV;E8E9l5CM;IAOI,4BAAA;E9E0l5CV;E8Ejm5CM;IAOI,2BAAA;E9E6l5CV;E8Epm5CM;IAOI,iCAAA;E9Egm5CV;E8Evm5CM;IAOI,gCAAA;E9Emm5CV;E8E1m5CM;IAOI,8BAAA;E9Esm5CV;E8E7m5CM;IAOI,gCAAA;E9Eym5CV;E8Ehn5CM;IAOI,8BAAA;E9E4m5CV;E8Enn5CM;IAOI,4BAAA;E9E+m5CV;E8Etn5CM;IAOI,kCAAA;E9Ekn5CV;E8Ezn5CM;IAOI,iCAAA;E9Eqn5CV;E8E5n5CM;IAOI,+BAAA;E9Ewn5CV;E8E/n5CM;IAOI,iCAAA;E9E2n5CV;E8Elo5CM;IAOI,+BAAA;E9E8n5CV;E8Ero5CM;IAOI,0BAAA;E9Eio5CV;E8Exo5CM;IAOI,gCAAA;E9Eoo5CV;E8E3o5CM;IAOI,+BAAA;E9Euo5CV;E8E9o5CM;IAOI,6BAAA;E9E0o5CV;E8Ejp5CM;IAOI,+BAAA;E9E6o5CV;E8Epp5CM;IAOI,6BAAA;E9Egp5CV;E8Evp5CM;IAOI,iBAAA;E9Emp5CV;E8E1p5CM;IAOI,uBAAA;E9Esp5CV;E8E7p5CM;IAOI,sBAAA;E9Eyp5CV;E8Ehq5CM;IAOI,oBAAA;E9E4p5CV;E8Enq5CM;IAOI,sBAAA;E9E+p5CV;E8Etq5CM;IAOI,oBAAA;E9Ekq5CV;E8Ezq5CM;IAOI,qBAAA;E9Eqq5CV;E8E5q5CM;IAOI,2BAAA;E9Ewq5CV;E8E/q5CM;IAOI,0BAAA;E9E2q5CV;E8Elr5CM;IAOI,wBAAA;E9E8q5CV;E8Err5CM;IAOI,0BAAA;E9Eir5CV;E8Exr5CM;IAOI,wBAAA;E9Eor5CV;E8E3r5CM;IAOI,wBAAA;E9Eur5CV;E8E9r5CM;IAOI,8BAAA;E9E0r5CV;E8Ejs5CM;IAOI,6BAAA;E9E6r5CV;E8Eps5CM;IAOI,2BAAA;E9Egs5CV;E8Evs5CM;IAOI,6BAAA;E9Ems5CV;E8E1s5CM;IAOI,2BAAA;E9Ess5CV;E8E7s5CM;IAOI,2BAAA;E9Eys5CV;E8Eht5CM;IAOI,4BAAA;E9E4s5CV;E8Ent5CM;IAOI,6BAAA;E9E+s5CV;AACF;AoB1t5CI;E0DGI;IAOI,sBAAA;E9Eot5CV;E8E3t5CM;IAOI,uBAAA;E9Eut5CV;E8E9t5CM;IAOI,sBAAA;E9E0t5CV;E8Eju5CM;IAOI,8BAAA;E9E6t5CV;E8Epu5CM;IAOI,4BAAA;E9Egu5CV;E8Evu5CM;IAOI,2BAAA;E9Emu5CV;E8E1u5CM;IAOI,iCAAA;E9Esu5CV;E8E7u5CM;IAOI,2BAAA;E9Eyu5CV;E8Ehv5CM;IAOI,0BAAA;E9E4u5CV;E8Env5CM;IAOI,gCAAA;E9E+u5CV;E8Etv5CM;IAOI,yBAAA;E9Ekv5CV;E8Ezv5CM;IAOI,wBAAA;E9Eqv5CV;E8E5v5CM;IAOI,+BAAA;E9Ewv5CV;E8E/v5CM;IAOI,yBAAA;E9E2v5CV;E8Elw5CM;IAOI,6BAAA;E9E8v5CV;E8Erw5CM;IAOI,8BAAA;E9Eiw5CV;E8Exw5CM;IAOI,wBAAA;E9Eow5CV;E8E3w5CM;IAOI,+BAAA;E9Euw5CV;E8E9w5CM;IAOI,wBAAA;E9E0w5CV;E8Ejx5CM;IAOI,yBAAA;E9E6w5CV;E8Epx5CM;IAOI,8BAAA;E9Egx5CV;E8Evx5CM;IAOI,iCAAA;E9Emx5CV;E8E1x5CM;IAOI,sCAAA;E9Esx5CV;E8E7x5CM;IAOI,yCAAA;E9Eyx5CV;E8Ehy5CM;IAOI,uBAAA;E9E4x5CV;E8Eny5CM;IAOI,uBAAA;E9E+x5CV;E8Ety5CM;IAOI,yBAAA;E9Eky5CV;E8Ezy5CM;IAOI,yBAAA;E9Eqy5CV;E8E5y5CM;IAOI,0BAAA;E9Ewy5CV;E8E/y5CM;IAOI,4BAAA;E9E2y5CV;E8Elz5CM;IAOI,kCAAA;E9E8y5CV;E8Erz5CM;IAOI,sCAAA;E9Eiz5CV;E8Exz5CM;IAOI,oCAAA;E9Eoz5CV;E8E3z5CM;IAOI,kCAAA;E9Euz5CV;E8E9z5CM;IAOI,yCAAA;E9E0z5CV;E8Ej05CM;IAOI,wCAAA;E9E6z5CV;E8Ep05CM;IAOI,wCAAA;E9Eg05CV;E8Ev05CM;IAOI,kCAAA;E9Em05CV;E8E105CM;IAOI,gCAAA;E9Es05CV;E8E705CM;IAOI,8BAAA;E9Ey05CV;E8Eh15CM;IAOI,gCAAA;E9E405CV;E8En15CM;IAOI,+BAAA;E9E+05CV;E8Et15CM;IAOI,oCAAA;E9Ek15CV;E8Ez15CM;IAOI,kCAAA;E9Eq15CV;E8E515CM;IAOI,gCAAA;E9Ew15CV;E8E/15CM;IAOI,uCAAA;E9E215CV;E8El25CM;IAOI,sCAAA;E9E815CV;E8Er25CM;IAOI,iCAAA;E9Ei25CV;E8Ex25CM;IAOI,2BAAA;E9Eo25CV;E8E325CM;IAOI,iCAAA;E9Eu25CV;E8E925CM;IAOI,+BAAA;E9E025CV;E8Ej35CM;IAOI,6BAAA;E9E625CV;E8Ep35CM;IAOI,+BAAA;E9Eg35CV;E8Ev35CM;IAOI,8BAAA;E9Em35CV;E8E135CM;IAOI,oBAAA;E9Es35CV;E8E735CM;IAOI,mBAAA;E9Ey35CV;E8Eh45CM;IAOI,mBAAA;E9E435CV;E8En45CM;IAOI,mBAAA;E9E+35CV;E8Et45CM;IAOI,mBAAA;E9Ek45CV;E8Ez45CM;IAOI,mBAAA;E9Eq45CV;E8E545CM;IAOI,mBAAA;E9Ew45CV;E8E/45CM;IAOI,mBAAA;E9E245CV;E8El55CM;IAOI,oBAAA;E9E845CV;E8Er55CM;IAOI,0BAAA;E9Ei55CV;E8Ex55CM;IAOI,yBAAA;E9Eo55CV;E8E355CM;IAOI,uBAAA;E9Eu55CV;E8E955CM;IAOI,yBAAA;E9E055CV;E8Ej65CM;IAOI,uBAAA;E9E655CV;E8Ep65CM;IAOI,uBAAA;E9Eg65CV;E8Ev65CM;IAOI,0BAAA;IAAA,yBAAA;E9Eo65CV;E8E365CM;IAOI,gCAAA;IAAA,+BAAA;E9Ew65CV;E8E/65CM;IAOI,+BAAA;IAAA,8BAAA;E9E465CV;E8En75CM;IAOI,6BAAA;IAAA,4BAAA;E9Eg75CV;E8Ev75CM;IAOI,+BAAA;IAAA,8BAAA;E9Eo75CV;E8E375CM;IAOI,6BAAA;IAAA,4BAAA;E9Ew75CV;E8E/75CM;IAOI,6BAAA;IAAA,4BAAA;E9E475CV;E8En85CM;IAOI,wBAAA;IAAA,2BAAA;E9Eg85CV;E8Ev85CM;IAOI,8BAAA;IAAA,iCAAA;E9Eo85CV;E8E385CM;IAOI,6BAAA;IAAA,gCAAA;E9Ew85CV;E8E/85CM;IAOI,2BAAA;IAAA,8BAAA;E9E485CV;E8En95CM;IAOI,6BAAA;IAAA,gCAAA;E9Eg95CV;E8Ev95CM;IAOI,2BAAA;IAAA,8BAAA;E9Eo95CV;E8E395CM;IAOI,2BAAA;IAAA,8BAAA;E9Ew95CV;E8E/95CM;IAOI,wBAAA;E9E295CV;E8El+5CM;IAOI,8BAAA;E9E895CV;E8Er+5CM;IAOI,6BAAA;E9Ei+5CV;E8Ex+5CM;IAOI,2BAAA;E9Eo+5CV;E8E3+5CM;IAOI,6BAAA;E9Eu+5CV;E8E9+5CM;IAOI,2BAAA;E9E0+5CV;E8Ej/5CM;IAOI,2BAAA;E9E6+5CV;E8Ep/5CM;IAOI,0BAAA;E9Eg/5CV;E8Ev/5CM;IAOI,gCAAA;E9Em/5CV;E8E1/5CM;IAOI,+BAAA;E9Es/5CV;E8E7/5CM;IAOI,6BAAA;E9Ey/5CV;E8Ehg6CM;IAOI,+BAAA;E9E4/5CV;E8Eng6CM;IAOI,6BAAA;E9E+/5CV;E8Etg6CM;IAOI,6BAAA;E9Ekg6CV;E8Ezg6CM;IAOI,2BAAA;E9Eqg6CV;E8E5g6CM;IAOI,iCAAA;E9Ewg6CV;E8E/g6CM;IAOI,gCAAA;E9E2g6CV;E8Elh6CM;IAOI,8BAAA;E9E8g6CV;E8Erh6CM;IAOI,gCAAA;E9Eih6CV;E8Exh6CM;IAOI,8BAAA;E9Eoh6CV;E8E3h6CM;IAOI,8BAAA;E9Euh6CV;E8E9h6CM;IAOI,yBAAA;E9E0h6CV;E8Eji6CM;IAOI,+BAAA;E9E6h6CV;E8Epi6CM;IAOI,8BAAA;E9Egi6CV;E8Evi6CM;IAOI,4BAAA;E9Emi6CV;E8E1i6CM;IAOI,8BAAA;E9Esi6CV;E8E7i6CM;IAOI,4BAAA;E9Eyi6CV;E8Ehj6CM;IAOI,4BAAA;E9E4i6CV;E8Enj6CM;IAOI,qBAAA;E9E+i6CV;E8Etj6CM;IAOI,2BAAA;E9Ekj6CV;E8Ezj6CM;IAOI,0BAAA;E9Eqj6CV;E8E5j6CM;IAOI,wBAAA;E9Ewj6CV;E8E/j6CM;IAOI,0BAAA;E9E2j6CV;E8Elk6CM;IAOI,wBAAA;E9E8j6CV;E8Erk6CM;IAOI,2BAAA;IAAA,0BAAA;E9Ekk6CV;E8Ezk6CM;IAOI,iCAAA;IAAA,gCAAA;E9Esk6CV;E8E7k6CM;IAOI,gCAAA;IAAA,+BAAA;E9E0k6CV;E8Ejl6CM;IAOI,8BAAA;IAAA,6BAAA;E9E8k6CV;E8Erl6CM;IAOI,gCAAA;IAAA,+BAAA;E9Ekl6CV;E8Ezl6CM;IAOI,8BAAA;IAAA,6BAAA;E9Esl6CV;E8E7l6CM;IAOI,yBAAA;IAAA,4BAAA;E9E0l6CV;E8Ejm6CM;IAOI,+BAAA;IAAA,kCAAA;E9E8l6CV;E8Erm6CM;IAOI,8BAAA;IAAA,iCAAA;E9Ekm6CV;E8Ezm6CM;IAOI,4BAAA;IAAA,+BAAA;E9Esm6CV;E8E7m6CM;IAOI,8BAAA;IAAA,iCAAA;E9E0m6CV;E8Ejn6CM;IAOI,4BAAA;IAAA,+BAAA;E9E8m6CV;E8Ern6CM;IAOI,yBAAA;E9Ein6CV;E8Exn6CM;IAOI,+BAAA;E9Eon6CV;E8E3n6CM;IAOI,8BAAA;E9Eun6CV;E8E9n6CM;IAOI,4BAAA;E9E0n6CV;E8Ejo6CM;IAOI,8BAAA;E9E6n6CV;E8Epo6CM;IAOI,4BAAA;E9Ego6CV;E8Evo6CM;IAOI,2BAAA;E9Emo6CV;E8E1o6CM;IAOI,iCAAA;E9Eso6CV;E8E7o6CM;IAOI,gCAAA;E9Eyo6CV;E8Ehp6CM;IAOI,8BAAA;E9E4o6CV;E8Enp6CM;IAOI,gCAAA;E9E+o6CV;E8Etp6CM;IAOI,8BAAA;E9Ekp6CV;E8Ezp6CM;IAOI,4BAAA;E9Eqp6CV;E8E5p6CM;IAOI,kCAAA;E9Ewp6CV;E8E/p6CM;IAOI,iCAAA;E9E2p6CV;E8Elq6CM;IAOI,+BAAA;E9E8p6CV;E8Erq6CM;IAOI,iCAAA;E9Eiq6CV;E8Exq6CM;IAOI,+BAAA;E9Eoq6CV;E8E3q6CM;IAOI,0BAAA;E9Euq6CV;E8E9q6CM;IAOI,gCAAA;E9E0q6CV;E8Ejr6CM;IAOI,+BAAA;E9E6q6CV;E8Epr6CM;IAOI,6BAAA;E9Egr6CV;E8Evr6CM;IAOI,+BAAA;E9Emr6CV;E8E1r6CM;IAOI,6BAAA;E9Esr6CV;E8E7r6CM;IAOI,iBAAA;E9Eyr6CV;E8Ehs6CM;IAOI,uBAAA;E9E4r6CV;E8Ens6CM;IAOI,sBAAA;E9E+r6CV;E8Ets6CM;IAOI,oBAAA;E9Eks6CV;E8Ezs6CM;IAOI,sBAAA;E9Eqs6CV;E8E5s6CM;IAOI,oBAAA;E9Ews6CV;E8E/s6CM;IAOI,qBAAA;E9E2s6CV;E8Elt6CM;IAOI,2BAAA;E9E8s6CV;E8Ert6CM;IAOI,0BAAA;E9Eit6CV;E8Ext6CM;IAOI,wBAAA;E9Eot6CV;E8E3t6CM;IAOI,0BAAA;E9Eut6CV;E8E9t6CM;IAOI,wBAAA;E9E0t6CV;E8Eju6CM;IAOI,wBAAA;E9E6t6CV;E8Epu6CM;IAOI,8BAAA;E9Egu6CV;E8Evu6CM;IAOI,6BAAA;E9Emu6CV;E8E1u6CM;IAOI,2BAAA;E9Esu6CV;E8E7u6CM;IAOI,6BAAA;E9Eyu6CV;E8Ehv6CM;IAOI,2BAAA;E9E4u6CV;E8Env6CM;IAOI,2BAAA;E9E+u6CV;E8Etv6CM;IAOI,4BAAA;E9Ekv6CV;E8Ezv6CM;IAOI,6BAAA;E9Eqv6CV;AACF;AoBhw6CI;E0DGI;IAOI,sBAAA;E9E0v6CV;E8Ejw6CM;IAOI,uBAAA;E9E6v6CV;E8Epw6CM;IAOI,sBAAA;E9Egw6CV;E8Evw6CM;IAOI,8BAAA;E9Emw6CV;E8E1w6CM;IAOI,4BAAA;E9Esw6CV;E8E7w6CM;IAOI,2BAAA;E9Eyw6CV;E8Ehx6CM;IAOI,iCAAA;E9E4w6CV;E8Enx6CM;IAOI,2BAAA;E9E+w6CV;E8Etx6CM;IAOI,0BAAA;E9Ekx6CV;E8Ezx6CM;IAOI,gCAAA;E9Eqx6CV;E8E5x6CM;IAOI,yBAAA;E9Ewx6CV;E8E/x6CM;IAOI,wBAAA;E9E2x6CV;E8Ely6CM;IAOI,+BAAA;E9E8x6CV;E8Ery6CM;IAOI,yBAAA;E9Eiy6CV;E8Exy6CM;IAOI,6BAAA;E9Eoy6CV;E8E3y6CM;IAOI,8BAAA;E9Euy6CV;E8E9y6CM;IAOI,wBAAA;E9E0y6CV;E8Ejz6CM;IAOI,+BAAA;E9E6y6CV;E8Epz6CM;IAOI,wBAAA;E9Egz6CV;E8Evz6CM;IAOI,yBAAA;E9Emz6CV;E8E1z6CM;IAOI,8BAAA;E9Esz6CV;E8E7z6CM;IAOI,iCAAA;E9Eyz6CV;E8Eh06CM;IAOI,sCAAA;E9E4z6CV;E8En06CM;IAOI,yCAAA;E9E+z6CV;E8Et06CM;IAOI,uBAAA;E9Ek06CV;E8Ez06CM;IAOI,uBAAA;E9Eq06CV;E8E506CM;IAOI,yBAAA;E9Ew06CV;E8E/06CM;IAOI,yBAAA;E9E206CV;E8El16CM;IAOI,0BAAA;E9E806CV;E8Er16CM;IAOI,4BAAA;E9Ei16CV;E8Ex16CM;IAOI,kCAAA;E9Eo16CV;E8E316CM;IAOI,sCAAA;E9Eu16CV;E8E916CM;IAOI,oCAAA;E9E016CV;E8Ej26CM;IAOI,kCAAA;E9E616CV;E8Ep26CM;IAOI,yCAAA;E9Eg26CV;E8Ev26CM;IAOI,wCAAA;E9Em26CV;E8E126CM;IAOI,wCAAA;E9Es26CV;E8E726CM;IAOI,kCAAA;E9Ey26CV;E8Eh36CM;IAOI,gCAAA;E9E426CV;E8En36CM;IAOI,8BAAA;E9E+26CV;E8Et36CM;IAOI,gCAAA;E9Ek36CV;E8Ez36CM;IAOI,+BAAA;E9Eq36CV;E8E536CM;IAOI,oCAAA;E9Ew36CV;E8E/36CM;IAOI,kCAAA;E9E236CV;E8El46CM;IAOI,gCAAA;E9E836CV;E8Er46CM;IAOI,uCAAA;E9Ei46CV;E8Ex46CM;IAOI,sCAAA;E9Eo46CV;E8E346CM;IAOI,iCAAA;E9Eu46CV;E8E946CM;IAOI,2BAAA;E9E046CV;E8Ej56CM;IAOI,iCAAA;E9E646CV;E8Ep56CM;IAOI,+BAAA;E9Eg56CV;E8Ev56CM;IAOI,6BAAA;E9Em56CV;E8E156CM;IAOI,+BAAA;E9Es56CV;E8E756CM;IAOI,8BAAA;E9Ey56CV;E8Eh66CM;IAOI,oBAAA;E9E456CV;E8En66CM;IAOI,mBAAA;E9E+56CV;E8Et66CM;IAOI,mBAAA;E9Ek66CV;E8Ez66CM;IAOI,mBAAA;E9Eq66CV;E8E566CM;IAOI,mBAAA;E9Ew66CV;E8E/66CM;IAOI,mBAAA;E9E266CV;E8El76CM;IAOI,mBAAA;E9E866CV;E8Er76CM;IAOI,mBAAA;E9Ei76CV;E8Ex76CM;IAOI,oBAAA;E9Eo76CV;E8E376CM;IAOI,0BAAA;E9Eu76CV;E8E976CM;IAOI,yBAAA;E9E076CV;E8Ej86CM;IAOI,uBAAA;E9E676CV;E8Ep86CM;IAOI,yBAAA;E9Eg86CV;E8Ev86CM;IAOI,uBAAA;E9Em86CV;E8E186CM;IAOI,uBAAA;E9Es86CV;E8E786CM;IAOI,0BAAA;IAAA,yBAAA;E9E086CV;E8Ej96CM;IAOI,gCAAA;IAAA,+BAAA;E9E886CV;E8Er96CM;IAOI,+BAAA;IAAA,8BAAA;E9Ek96CV;E8Ez96CM;IAOI,6BAAA;IAAA,4BAAA;E9Es96CV;E8E796CM;IAOI,+BAAA;IAAA,8BAAA;E9E096CV;E8Ej+6CM;IAOI,6BAAA;IAAA,4BAAA;E9E896CV;E8Er+6CM;IAOI,6BAAA;IAAA,4BAAA;E9Ek+6CV;E8Ez+6CM;IAOI,wBAAA;IAAA,2BAAA;E9Es+6CV;E8E7+6CM;IAOI,8BAAA;IAAA,iCAAA;E9E0+6CV;E8Ej/6CM;IAOI,6BAAA;IAAA,gCAAA;E9E8+6CV;E8Er/6CM;IAOI,2BAAA;IAAA,8BAAA;E9Ek/6CV;E8Ez/6CM;IAOI,6BAAA;IAAA,gCAAA;E9Es/6CV;E8E7/6CM;IAOI,2BAAA;IAAA,8BAAA;E9E0/6CV;E8Ejg7CM;IAOI,2BAAA;IAAA,8BAAA;E9E8/6CV;E8Erg7CM;IAOI,wBAAA;E9Eig7CV;E8Exg7CM;IAOI,8BAAA;E9Eog7CV;E8E3g7CM;IAOI,6BAAA;E9Eug7CV;E8E9g7CM;IAOI,2BAAA;E9E0g7CV;E8Ejh7CM;IAOI,6BAAA;E9E6g7CV;E8Eph7CM;IAOI,2BAAA;E9Egh7CV;E8Evh7CM;IAOI,2BAAA;E9Emh7CV;E8E1h7CM;IAOI,0BAAA;E9Esh7CV;E8E7h7CM;IAOI,gCAAA;E9Eyh7CV;E8Ehi7CM;IAOI,+BAAA;E9E4h7CV;E8Eni7CM;IAOI,6BAAA;E9E+h7CV;E8Eti7CM;IAOI,+BAAA;E9Eki7CV;E8Ezi7CM;IAOI,6BAAA;E9Eqi7CV;E8E5i7CM;IAOI,6BAAA;E9Ewi7CV;E8E/i7CM;IAOI,2BAAA;E9E2i7CV;E8Elj7CM;IAOI,iCAAA;E9E8i7CV;E8Erj7CM;IAOI,gCAAA;E9Eij7CV;E8Exj7CM;IAOI,8BAAA;E9Eoj7CV;E8E3j7CM;IAOI,gCAAA;E9Euj7CV;E8E9j7CM;IAOI,8BAAA;E9E0j7CV;E8Ejk7CM;IAOI,8BAAA;E9E6j7CV;E8Epk7CM;IAOI,yBAAA;E9Egk7CV;E8Evk7CM;IAOI,+BAAA;E9Emk7CV;E8E1k7CM;IAOI,8BAAA;E9Esk7CV;E8E7k7CM;IAOI,4BAAA;E9Eyk7CV;E8Ehl7CM;IAOI,8BAAA;E9E4k7CV;E8Enl7CM;IAOI,4BAAA;E9E+k7CV;E8Etl7CM;IAOI,4BAAA;E9Ekl7CV;E8Ezl7CM;IAOI,qBAAA;E9Eql7CV;E8E5l7CM;IAOI,2BAAA;E9Ewl7CV;E8E/l7CM;IAOI,0BAAA;E9E2l7CV;E8Elm7CM;IAOI,wBAAA;E9E8l7CV;E8Erm7CM;IAOI,0BAAA;E9Eim7CV;E8Exm7CM;IAOI,wBAAA;E9Eom7CV;E8E3m7CM;IAOI,2BAAA;IAAA,0BAAA;E9Ewm7CV;E8E/m7CM;IAOI,iCAAA;IAAA,gCAAA;E9E4m7CV;E8Enn7CM;IAOI,gCAAA;IAAA,+BAAA;E9Egn7CV;E8Evn7CM;IAOI,8BAAA;IAAA,6BAAA;E9Eon7CV;E8E3n7CM;IAOI,gCAAA;IAAA,+BAAA;E9Ewn7CV;E8E/n7CM;IAOI,8BAAA;IAAA,6BAAA;E9E4n7CV;E8Eno7CM;IAOI,yBAAA;IAAA,4BAAA;E9Ego7CV;E8Evo7CM;IAOI,+BAAA;IAAA,kCAAA;E9Eoo7CV;E8E3o7CM;IAOI,8BAAA;IAAA,iCAAA;E9Ewo7CV;E8E/o7CM;IAOI,4BAAA;IAAA,+BAAA;E9E4o7CV;E8Enp7CM;IAOI,8BAAA;IAAA,iCAAA;E9Egp7CV;E8Evp7CM;IAOI,4BAAA;IAAA,+BAAA;E9Eop7CV;E8E3p7CM;IAOI,yBAAA;E9Eup7CV;E8E9p7CM;IAOI,+BAAA;E9E0p7CV;E8Ejq7CM;IAOI,8BAAA;E9E6p7CV;E8Epq7CM;IAOI,4BAAA;E9Egq7CV;E8Evq7CM;IAOI,8BAAA;E9Emq7CV;E8E1q7CM;IAOI,4BAAA;E9Esq7CV;E8E7q7CM;IAOI,2BAAA;E9Eyq7CV;E8Ehr7CM;IAOI,iCAAA;E9E4q7CV;E8Enr7CM;IAOI,gCAAA;E9E+q7CV;E8Etr7CM;IAOI,8BAAA;E9Ekr7CV;E8Ezr7CM;IAOI,gCAAA;E9Eqr7CV;E8E5r7CM;IAOI,8BAAA;E9Ewr7CV;E8E/r7CM;IAOI,4BAAA;E9E2r7CV;E8Els7CM;IAOI,kCAAA;E9E8r7CV;E8Ers7CM;IAOI,iCAAA;E9Eis7CV;E8Exs7CM;IAOI,+BAAA;E9Eos7CV;E8E3s7CM;IAOI,iCAAA;E9Eus7CV;E8E9s7CM;IAOI,+BAAA;E9E0s7CV;E8Ejt7CM;IAOI,0BAAA;E9E6s7CV;E8Ept7CM;IAOI,gCAAA;E9Egt7CV;E8Evt7CM;IAOI,+BAAA;E9Emt7CV;E8E1t7CM;IAOI,6BAAA;E9Est7CV;E8E7t7CM;IAOI,+BAAA;E9Eyt7CV;E8Ehu7CM;IAOI,6BAAA;E9E4t7CV;E8Enu7CM;IAOI,iBAAA;E9E+t7CV;E8Etu7CM;IAOI,uBAAA;E9Eku7CV;E8Ezu7CM;IAOI,sBAAA;E9Equ7CV;E8E5u7CM;IAOI,oBAAA;E9Ewu7CV;E8E/u7CM;IAOI,sBAAA;E9E2u7CV;E8Elv7CM;IAOI,oBAAA;E9E8u7CV;E8Erv7CM;IAOI,qBAAA;E9Eiv7CV;E8Exv7CM;IAOI,2BAAA;E9Eov7CV;E8E3v7CM;IAOI,0BAAA;E9Euv7CV;E8E9v7CM;IAOI,wBAAA;E9E0v7CV;E8Ejw7CM;IAOI,0BAAA;E9E6v7CV;E8Epw7CM;IAOI,wBAAA;E9Egw7CV;E8Evw7CM;IAOI,wBAAA;E9Emw7CV;E8E1w7CM;IAOI,8BAAA;E9Esw7CV;E8E7w7CM;IAOI,6BAAA;E9Eyw7CV;E8Ehx7CM;IAOI,2BAAA;E9E4w7CV;E8Enx7CM;IAOI,6BAAA;E9E+w7CV;E8Etx7CM;IAOI,2BAAA;E9Ekx7CV;E8Ezx7CM;IAOI,2BAAA;E9Eqx7CV;E8E5x7CM;IAOI,4BAAA;E9Ewx7CV;E8E/x7CM;IAOI,6BAAA;E9E2x7CV;AACF;AoBty7CI;E0DGI;IAOI,sBAAA;E9Egy7CV;E8Evy7CM;IAOI,uBAAA;E9Emy7CV;E8E1y7CM;IAOI,sBAAA;E9Esy7CV;E8E7y7CM;IAOI,8BAAA;E9Eyy7CV;E8Ehz7CM;IAOI,4BAAA;E9E4y7CV;E8Enz7CM;IAOI,2BAAA;E9E+y7CV;E8Etz7CM;IAOI,iCAAA;E9Ekz7CV;E8Ezz7CM;IAOI,2BAAA;E9Eqz7CV;E8E5z7CM;IAOI,0BAAA;E9Ewz7CV;E8E/z7CM;IAOI,gCAAA;E9E2z7CV;E8El07CM;IAOI,yBAAA;E9E8z7CV;E8Er07CM;IAOI,wBAAA;E9Ei07CV;E8Ex07CM;IAOI,+BAAA;E9Eo07CV;E8E307CM;IAOI,yBAAA;E9Eu07CV;E8E907CM;IAOI,6BAAA;E9E007CV;E8Ej17CM;IAOI,8BAAA;E9E607CV;E8Ep17CM;IAOI,wBAAA;E9Eg17CV;E8Ev17CM;IAOI,+BAAA;E9Em17CV;E8E117CM;IAOI,wBAAA;E9Es17CV;E8E717CM;IAOI,yBAAA;E9Ey17CV;E8Eh27CM;IAOI,8BAAA;E9E417CV;E8En27CM;IAOI,iCAAA;E9E+17CV;E8Et27CM;IAOI,sCAAA;E9Ek27CV;E8Ez27CM;IAOI,yCAAA;E9Eq27CV;E8E527CM;IAOI,uBAAA;E9Ew27CV;E8E/27CM;IAOI,uBAAA;E9E227CV;E8El37CM;IAOI,yBAAA;E9E827CV;E8Er37CM;IAOI,yBAAA;E9Ei37CV;E8Ex37CM;IAOI,0BAAA;E9Eo37CV;E8E337CM;IAOI,4BAAA;E9Eu37CV;E8E937CM;IAOI,kCAAA;E9E037CV;E8Ej47CM;IAOI,sCAAA;E9E637CV;E8Ep47CM;IAOI,oCAAA;E9Eg47CV;E8Ev47CM;IAOI,kCAAA;E9Em47CV;E8E147CM;IAOI,yCAAA;E9Es47CV;E8E747CM;IAOI,wCAAA;E9Ey47CV;E8Eh57CM;IAOI,wCAAA;E9E447CV;E8En57CM;IAOI,kCAAA;E9E+47CV;E8Et57CM;IAOI,gCAAA;E9Ek57CV;E8Ez57CM;IAOI,8BAAA;E9Eq57CV;E8E557CM;IAOI,gCAAA;E9Ew57CV;E8E/57CM;IAOI,+BAAA;E9E257CV;E8El67CM;IAOI,oCAAA;E9E857CV;E8Er67CM;IAOI,kCAAA;E9Ei67CV;E8Ex67CM;IAOI,gCAAA;E9Eo67CV;E8E367CM;IAOI,uCAAA;E9Eu67CV;E8E967CM;IAOI,sCAAA;E9E067CV;E8Ej77CM;IAOI,iCAAA;E9E667CV;E8Ep77CM;IAOI,2BAAA;E9Eg77CV;E8Ev77CM;IAOI,iCAAA;E9Em77CV;E8E177CM;IAOI,+BAAA;E9Es77CV;E8E777CM;IAOI,6BAAA;E9Ey77CV;E8Eh87CM;IAOI,+BAAA;E9E477CV;E8En87CM;IAOI,8BAAA;E9E+77CV;E8Et87CM;IAOI,oBAAA;E9Ek87CV;E8Ez87CM;IAOI,mBAAA;E9Eq87CV;E8E587CM;IAOI,mBAAA;E9Ew87CV;E8E/87CM;IAOI,mBAAA;E9E287CV;E8El97CM;IAOI,mBAAA;E9E887CV;E8Er97CM;IAOI,mBAAA;E9Ei97CV;E8Ex97CM;IAOI,mBAAA;E9Eo97CV;E8E397CM;IAOI,mBAAA;E9Eu97CV;E8E997CM;IAOI,oBAAA;E9E097CV;E8Ej+7CM;IAOI,0BAAA;E9E697CV;E8Ep+7CM;IAOI,yBAAA;E9Eg+7CV;E8Ev+7CM;IAOI,uBAAA;E9Em+7CV;E8E1+7CM;IAOI,yBAAA;E9Es+7CV;E8E7+7CM;IAOI,uBAAA;E9Ey+7CV;E8Eh/7CM;IAOI,uBAAA;E9E4+7CV;E8En/7CM;IAOI,0BAAA;IAAA,yBAAA;E9Eg/7CV;E8Ev/7CM;IAOI,gCAAA;IAAA,+BAAA;E9Eo/7CV;E8E3/7CM;IAOI,+BAAA;IAAA,8BAAA;E9Ew/7CV;E8E//7CM;IAOI,6BAAA;IAAA,4BAAA;E9E4/7CV;E8Eng8CM;IAOI,+BAAA;IAAA,8BAAA;E9Egg8CV;E8Evg8CM;IAOI,6BAAA;IAAA,4BAAA;E9Eog8CV;E8E3g8CM;IAOI,6BAAA;IAAA,4BAAA;E9Ewg8CV;E8E/g8CM;IAOI,wBAAA;IAAA,2BAAA;E9E4g8CV;E8Enh8CM;IAOI,8BAAA;IAAA,iCAAA;E9Egh8CV;E8Evh8CM;IAOI,6BAAA;IAAA,gCAAA;E9Eoh8CV;E8E3h8CM;IAOI,2BAAA;IAAA,8BAAA;E9Ewh8CV;E8E/h8CM;IAOI,6BAAA;IAAA,gCAAA;E9E4h8CV;E8Eni8CM;IAOI,2BAAA;IAAA,8BAAA;E9Egi8CV;E8Evi8CM;IAOI,2BAAA;IAAA,8BAAA;E9Eoi8CV;E8E3i8CM;IAOI,wBAAA;E9Eui8CV;E8E9i8CM;IAOI,8BAAA;E9E0i8CV;E8Ejj8CM;IAOI,6BAAA;E9E6i8CV;E8Epj8CM;IAOI,2BAAA;E9Egj8CV;E8Evj8CM;IAOI,6BAAA;E9Emj8CV;E8E1j8CM;IAOI,2BAAA;E9Esj8CV;E8E7j8CM;IAOI,2BAAA;E9Eyj8CV;E8Ehk8CM;IAOI,0BAAA;E9E4j8CV;E8Enk8CM;IAOI,gCAAA;E9E+j8CV;E8Etk8CM;IAOI,+BAAA;E9Ekk8CV;E8Ezk8CM;IAOI,6BAAA;E9Eqk8CV;E8E5k8CM;IAOI,+BAAA;E9Ewk8CV;E8E/k8CM;IAOI,6BAAA;E9E2k8CV;E8Ell8CM;IAOI,6BAAA;E9E8k8CV;E8Erl8CM;IAOI,2BAAA;E9Eil8CV;E8Exl8CM;IAOI,iCAAA;E9Eol8CV;E8E3l8CM;IAOI,gCAAA;E9Eul8CV;E8E9l8CM;IAOI,8BAAA;E9E0l8CV;E8Ejm8CM;IAOI,gCAAA;E9E6l8CV;E8Epm8CM;IAOI,8BAAA;E9Egm8CV;E8Evm8CM;IAOI,8BAAA;E9Emm8CV;E8E1m8CM;IAOI,yBAAA;E9Esm8CV;E8E7m8CM;IAOI,+BAAA;E9Eym8CV;E8Ehn8CM;IAOI,8BAAA;E9E4m8CV;E8Enn8CM;IAOI,4BAAA;E9E+m8CV;E8Etn8CM;IAOI,8BAAA;E9Ekn8CV;E8Ezn8CM;IAOI,4BAAA;E9Eqn8CV;E8E5n8CM;IAOI,4BAAA;E9Ewn8CV;E8E/n8CM;IAOI,qBAAA;E9E2n8CV;E8Elo8CM;IAOI,2BAAA;E9E8n8CV;E8Ero8CM;IAOI,0BAAA;E9Eio8CV;E8Exo8CM;IAOI,wBAAA;E9Eoo8CV;E8E3o8CM;IAOI,0BAAA;E9Euo8CV;E8E9o8CM;IAOI,wBAAA;E9E0o8CV;E8Ejp8CM;IAOI,2BAAA;IAAA,0BAAA;E9E8o8CV;E8Erp8CM;IAOI,iCAAA;IAAA,gCAAA;E9Ekp8CV;E8Ezp8CM;IAOI,gCAAA;IAAA,+BAAA;E9Esp8CV;E8E7p8CM;IAOI,8BAAA;IAAA,6BAAA;E9E0p8CV;E8Ejq8CM;IAOI,gCAAA;IAAA,+BAAA;E9E8p8CV;E8Erq8CM;IAOI,8BAAA;IAAA,6BAAA;E9Ekq8CV;E8Ezq8CM;IAOI,yBAAA;IAAA,4BAAA;E9Esq8CV;E8E7q8CM;IAOI,+BAAA;IAAA,kCAAA;E9E0q8CV;E8Ejr8CM;IAOI,8BAAA;IAAA,iCAAA;E9E8q8CV;E8Err8CM;IAOI,4BAAA;IAAA,+BAAA;E9Ekr8CV;E8Ezr8CM;IAOI,8BAAA;IAAA,iCAAA;E9Esr8CV;E8E7r8CM;IAOI,4BAAA;IAAA,+BAAA;E9E0r8CV;E8Ejs8CM;IAOI,yBAAA;E9E6r8CV;E8Eps8CM;IAOI,+BAAA;E9Egs8CV;E8Evs8CM;IAOI,8BAAA;E9Ems8CV;E8E1s8CM;IAOI,4BAAA;E9Ess8CV;E8E7s8CM;IAOI,8BAAA;E9Eys8CV;E8Eht8CM;IAOI,4BAAA;E9E4s8CV;E8Ent8CM;IAOI,2BAAA;E9E+s8CV;E8Ett8CM;IAOI,iCAAA;E9Ekt8CV;E8Ezt8CM;IAOI,gCAAA;E9Eqt8CV;E8E5t8CM;IAOI,8BAAA;E9Ewt8CV;E8E/t8CM;IAOI,gCAAA;E9E2t8CV;E8Elu8CM;IAOI,8BAAA;E9E8t8CV;E8Eru8CM;IAOI,4BAAA;E9Eiu8CV;E8Exu8CM;IAOI,kCAAA;E9Eou8CV;E8E3u8CM;IAOI,iCAAA;E9Euu8CV;E8E9u8CM;IAOI,+BAAA;E9E0u8CV;E8Ejv8CM;IAOI,iCAAA;E9E6u8CV;E8Epv8CM;IAOI,+BAAA;E9Egv8CV;E8Evv8CM;IAOI,0BAAA;E9Emv8CV;E8E1v8CM;IAOI,gCAAA;E9Esv8CV;E8E7v8CM;IAOI,+BAAA;E9Eyv8CV;E8Ehw8CM;IAOI,6BAAA;E9E4v8CV;E8Enw8CM;IAOI,+BAAA;E9E+v8CV;E8Etw8CM;IAOI,6BAAA;E9Ekw8CV;E8Ezw8CM;IAOI,iBAAA;E9Eqw8CV;E8E5w8CM;IAOI,uBAAA;E9Eww8CV;E8E/w8CM;IAOI,sBAAA;E9E2w8CV;E8Elx8CM;IAOI,oBAAA;E9E8w8CV;E8Erx8CM;IAOI,sBAAA;E9Eix8CV;E8Exx8CM;IAOI,oBAAA;E9Eox8CV;E8E3x8CM;IAOI,qBAAA;E9Eux8CV;E8E9x8CM;IAOI,2BAAA;E9E0x8CV;E8Ejy8CM;IAOI,0BAAA;E9E6x8CV;E8Epy8CM;IAOI,wBAAA;E9Egy8CV;E8Evy8CM;IAOI,0BAAA;E9Emy8CV;E8E1y8CM;IAOI,wBAAA;E9Esy8CV;E8E7y8CM;IAOI,wBAAA;E9Eyy8CV;E8Ehz8CM;IAOI,8BAAA;E9E4y8CV;E8Enz8CM;IAOI,6BAAA;E9E+y8CV;E8Etz8CM;IAOI,2BAAA;E9Ekz8CV;E8Ezz8CM;IAOI,6BAAA;E9Eqz8CV;E8E5z8CM;IAOI,2BAAA;E9Ewz8CV;E8E/z8CM;IAOI,2BAAA;E9E2z8CV;E8El08CM;IAOI,4BAAA;E9E8z8CV;E8Er08CM;IAOI,6BAAA;E9Ei08CV;AACF;A+Ex38CA;ED+CQ;IAOI,6BAAA;E9Es08CV;E8E708CM;IAOI,4BAAA;E9Ey08CV;E8Eh18CM;IAOI,8BAAA;E9E408CV;E8En18CM;IAOI,6BAAA;E9E+08CV;AACF;A+En38CA;ED4BQ;IAOI,0BAAA;E9Eo18CV;E8E318CM;IAOI,gCAAA;E9Eu18CV;E8E918CM;IAOI,yBAAA;E9E018CV;E8Ej28CM;IAOI,wBAAA;E9E618CV;E8Ep28CM;IAOI,+BAAA;E9Eg28CV;E8Ev28CM;IAOI,yBAAA;E9Em28CV;E8E128CM;IAOI,6BAAA;E9Es28CV;E8E728CM;IAOI,8BAAA;E9Ey28CV;E8Eh38CM;IAOI,wBAAA;E9E428CV;E8En38CM;IAOI,+BAAA;E9E+28CV;E8Et38CM;IAOI,wBAAA;E9Ek38CV;AACF;AgF578CA;;eAAA;AAIA;EACE,kBAAA;EACA,gBAAA;AhF678CF;;AgF178CA;;EAEE,cpEsFS;AZu28CX;;AgFz78CA;;EAEE,kBAAA;AhF478CF;;AgFz78CA;;EAEE,iBAAA;AhF478CF;;AgFz78CA;;EAEE,mBAAA;AhF478CF;;AgFz78CA;;EAEE,kBAAA;AhF478CF;;AgFz78CA;;EAEE,mBAAA;AhF478CF;;AgFz78CA;;EAEE,iBAAA;AhF478CF;;AgFz78CA;EACE,gCAAA;AhF478CF;;AgFz78CA;EACE,gBAAA;AhF478CF;;AgFv78CA;EACE,kBAAA;EACA,8BAAA;AhF078CF;;AgFv78CA;EACE,cAAA;EACA,+BAAA;EACA,iBAAA;AhF078CF;;AgFp78CE;EADF;IAEM,iBAAA;EhFw78CJ;AACF;;AgFl78CE;EACI,kBAAA;AhFq78CN;;AgF768CA;EACI,qBpE4zBoC;AZon7CxC;;AiFhg9CI;EACI,qDAAA;AjFmg9CR;;AiFpg9CI;EACI,sDAAA;AjFug9CR;;AiFxg9CI;EACI,qDAAA;AjF2g9CR;;AiF5g9CI;EACI,qDAAA;AjF+g9CR;;AiFhh9CI;EACI,qDAAA;AjFmh9CR;;AiFph9CI;EACI,sDAAA;AjFuh9CR;;AiFxh9CI;EACI,qDAAA;AjF2h9CR;;AiF5h9CI;EACI,sDAAA;AjF+h9CR;;AiFhi9CI;EACI,mDAAA;AjFmi9CR;;AiFpi9CI;EACI,qDAAA;AjFui9CR;;AiFji9CI;EACI,mFAAA;AjFoi9CR;;AiFri9CI;EACI,oFAAA;AjFwi9CR;;AiFzi9CI;EACI,mFAAA;AjF4i9CR;;AiF7i9CI;EACI,mFAAA;AjFgj9CR;;AiFjj9CI;EACI,mFAAA;AjFoj9CR;;AiFrj9CI;EACI,oFAAA;AjFwj9CR;;AiFzj9CI;EACI,mFAAA;AjF4j9CR;;AiF7j9CI;EACI,oFAAA;AjFgk9CR;;AiFjk9CI;EACI,iFAAA;AjFok9CR;;AiFrk9CI;EACI,mFAAA;AjFwk9CR;;AkFnl9CA;EACG,oBAAA;EACC,mBAAA;AlFsl9CJ;;AkFzj9CQ;EAEE,8EAAA;AlF2j9CV;;AkFrj9CE;EA/BA,ctEsJa;EsErJb,0CAAA;AlFwl9CF;AkFtl9CE;EACI,ctEkJS;EsEjJT,qBAAA;EACA,yCAAA;AlFwl9CN;AkFtl9CM;EAEE,ctE4IO;EsE3IP,qBAAA;EACA,yCAAA;AlFul9CR;;AkF5k9CQ;EAEE,gFAAA;AlF8k9CV;;AkFxk9CE;EA/BA,ctEsJa;EsErJb,2CAAA;AlF2m9CF;AkFzm9CE;EACI,ctEkJS;EsEjJT,qBAAA;EACA,0CAAA;AlF2m9CN;AkFzm9CM;EAEE,ctE4IO;EsE3IP,qBAAA;EACA,0CAAA;AlF0m9CR;;AkF/l9CQ;EAEE,+EAAA;AlFim9CV;;AkF3l9CE;EA/BA,ctEsJa;EsErJb,0CAAA;AlF8n9CF;AkF5n9CE;EACI,ctEkJS;EsEjJT,qBAAA;EACA,yCAAA;AlF8n9CN;AkF5n9CM;EAEE,ctE4IO;EsE3IP,qBAAA;EACA,yCAAA;AlF6n9CR;;AkFln9CQ;EAEE,+EAAA;AlFon9CV;;AkF9m9CE;EA/BA,ctEsJa;EsErJb,0CAAA;AlFip9CF;AkF/o9CE;EACI,ctEkJS;EsEjJT,qBAAA;EACA,yCAAA;AlFip9CN;AkF/o9CM;EAEE,ctE4IO;EsE3IP,qBAAA;EACA,yCAAA;AlFgp9CR;;AkFro9CQ;EAEE,+EAAA;AlFuo9CV;;AkFjo9CE;EA/BA,ctEsJa;EsErJb,0CAAA;AlFoq9CF;AkFlq9CE;EACI,ctEkJS;EsEjJT,qBAAA;EACA,yCAAA;AlFoq9CN;AkFlq9CM;EAEE,ctE4IO;EsE3IP,qBAAA;EACA,yCAAA;AlFmq9CR;;AkFxp9CQ;EAEE,4DAAA;AlF0p9CV;;AkFpp9CE;EA/BA,ctEsJa;EsErJb,2CAAA;AlFur9CF;AkFrr9CE;EACI,ctEkJS;EsEjJT,qBAAA;EACA,0CAAA;AlFur9CN;AkFrr9CM;EAEE,ctE4IO;EsE3IP,qBAAA;EACA,0CAAA;AlFsr9CR;;AkF3q9CQ;EAEE,+EAAA;AlF6q9CV;;AkFvq9CE;EA/BA,ctEsJa;EsErJb,0CAAA;AlF0s9CF;AkFxs9CE;EACI,ctEkJS;EsEjJT,qBAAA;EACA,yCAAA;AlF0s9CN;AkFxs9CM;EAEE,ctE4IO;EsE3IP,qBAAA;EACA,yCAAA;AlFys9CR;;AkF9r9CQ;EAEE,mDAAA;AlFgs9CV;;AkF1r9CE;EA/BA,ctEsJa;EsErJb,2CAAA;AlF6t9CF;AkF3t9CE;EACI,ctEkJS;EsEjJT,qBAAA;EACA,0CAAA;AlF6t9CN;AkF3t9CM;EAEE,ctE4IO;EsE3IP,qBAAA;EACA,0CAAA;AlF4t9CR;;AkFjt9CQ;EAEE,oEAAA;AlFmt9CV;;AkF7s9CE;EA/BA,ctEsJa;EsErJb,wCAAA;AlFgv9CF;AkF9u9CE;EACI,ctEkJS;EsEjJT,qBAAA;EACA,uCAAA;AlFgv9CN;AkF9u9CM;EAEE,ctE4IO;EsE3IP,qBAAA;EACA,uCAAA;AlF+u9CR;;AkFpu9CQ;EAEE,+EAAA;AlFsu9CV;;AkFhu9CE;EA/BA,ctEsJa;EsErJb,0CAAA;AlFmw9CF;AkFjw9CE;EACI,ctEkJS;EsEjJT,qBAAA;EACA,yCAAA;AlFmw9CN;AkFjw9CM;EAEE,ctE4IO;EsE3IP,qBAAA;EACA,yCAAA;AlFkw9CR;;AkFzu9CE;EACE,ctE+CO;AZ6r9CX;AkFzu9CM;EAEE,ctE0CG;AZgs9CX;;AkFju9CA;EACE,ctE2BS;AZys9CX;;AmFjy9CA;EACE,wBAAA;AnFoy9CF;;AmF/x9CA;EACE,mBAAA;AnFky9CF;;AmF/x9CA;EACE,cvE6ES;AZqt9CX;;AmF/x9CA;EACE,cvEgFS;AZkt9CX;;AmF3x9CI;EACI,0CAAA;EACA,sCAAA;EACA,cvEqIO;AZyp9Cf;;AmFjy9CI;EACI,2CAAA;EACA,uCAAA;EACA,cvEqIO;AZ+p9Cf;;AmFvy9CI;EACI,0CAAA;EACA,sCAAA;EACA,cvEqIO;AZqq9Cf;;AmF7y9CI;EACI,0CAAA;EACA,sCAAA;EACA,cvEqIO;AZ2q9Cf;;AmFnz9CI;EACI,0CAAA;EACA,sCAAA;EACA,cvEqIO;AZir9Cf;;AmFzz9CI;EACI,2CAAA;EACA,uCAAA;EACA,cvEqIO;AZur9Cf;;AmF/z9CI;EACI,0CAAA;EACA,sCAAA;EACA,cvEqIO;AZ6r9Cf;;AmFr09CI;EACI,2CAAA;EACA,uCAAA;EACA,cvEqIO;AZms9Cf;;AmF309CI;EACI,wCAAA;EACA,oCAAA;EACA,cvEqIO;AZys9Cf;;AmFj19CI;EACI,0CAAA;EACA,sCAAA;EACA,cvEqIO;AZ+s9Cf;;AoFz29CI;EACI,cxEwFG;AZox9CX;AoFz29CQ;EACI,oCAAA;ApF229CZ;;AqFp39CA;EACE,sBzEqkB4B;EyEpkB5B,4CzEumB4B;AZgx8C9B;;AqFp39CA;EACE,czEuFS;AZgy9CX;;AqFp39CA;EACE,eAAA;EACA,iBAAA;EACA,gBzEkDqB;AZq09CvB;;AqFp39CA;EACE,czE4ES;EyE3ET,mBAAA;ArFu39CF;;AsFx49CA;EACE,4C1EwmB4B;E0EvmB5B,6BAAA;EACA,wBAAA;EACA,yBAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;AtF249CF;AsF149CE;EACE,oBAAA;AtF449CJ;AsFz49CE;EACE,sBAAA;EACA,OAAA;AtF249CJ;;AsFt49CA;EACE,qBAAA;EACA,mBAAA;AtFy49CF;;AsFt49CA;EACE,oBAAA;EACA,0BAAA;AtFy49CF;;AsFt49CA;EACE;IAEI,wBAAA;EtFy49CJ;EsFv49CA;IAEI,2BAAA;EtFy49CJ;AACF;AsFt49CA;EACE;IACE,YAAA;EtFw49CF;EsFr49CA;IACE,YAAA;EtFu49CF;AACF;AsFp49CA;EACE,yB1EqCS;AZi29CX;;AsFj49CA;EACE,YAAA;AtFo49CF;;AsFj49CA;EACE,YAAA;AtFo49CF;;AuF/79CM;EACI,c3E0FC;E2EzFD,gB3EyDW;AZy49CrB;;AuF579CE;EACI,c3EkFK;E2EjFL,gB3EiDe;AZ849CrB;;AuF179CA;EACE,gCAAA;AvF679CF;AuF379CE;EACE,kBAAA;EACA,c3EwEO;AZq39CX;AuF579CI;EACE,YAAA;AvF879CN;AuF579CM;EACE,WAAA;EACA,mB3EuFE;E2EtFF,WAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,YAAA;EACA,6BAAA;EACA,mBAAA;AvF879CR;AuF379CM;EACE,c3E4EE;AZi39CV;AuF579CQ;EACE,mBAAA;AvF879CV;;AuFv79CA;EACE,WAAA;EACA,yBAAA;AvF079CF;;AuFl79CM;EACI,kBAAA;EACA,kBAAA;EACA,kBAAA;AvFq79CV;AuFp79CU;EACI,eAAA;AvFs79Cd;;AwFp/9CE;EACI,gB5E8pBwB;AZy18C9B;AwFr/9CE;EACE,c5EwFO;E4EvFP,qB5EkFO;E4EjFP,yBtDFO;AlCy/9CX;;AwFl/9CA;EACE,wBAAA;EACA,qB5EukB4B;AZ868C9B;;AwFl/9CA;EACE,4B5EsES;AZ+69CX;;AwFl/9CA;EACE,gD5EyvB4B;AZ4v8C9B;;AwFj/9CE;EACE,mBAAA;AxFo/9CJ;;AwF9+9CE;EACI,iCAAA;AxFi/9CN;;AwFz+9CA;EACE,yBAAA;EACA,sBAAA;AxF4+9CF;AwF3+9CE;EACE,sB5EwCO;AZq89CX;;AwFz+9CA;EACE,aAAA;AxF4+9CF;;AyF7h+CI;EACI,8BAAA;EACA,wBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;AzFgi+CR;;AyF5h+CE;EACE;IACG,uBAAA;EzF+h+CL;AACF;A0F/i+CA;EACE,WAAA;A1Fij+CF;;A0F5i+CA;EACE,WAAA;A1F+i+CF;;A0F1i+CA;EACE,YAAA;A1F6i+CF;;A0Fzi+CA;EACE,YAAA;A1F4i+CF;;A0Fzi+CA;EACE,kBAAA;A1F4i+CF;A0F3i+CE;EACE,kBAAA;EACA,kBAAA;EACA,8BAAA;A1F6i+CJ;;A0Fzi+CA;EACE;IACI,QAAA;E1F4i+CJ;AACF;A2Fll+CA;;;;;;;CAAA;ACIA;EACI,eAAA;EACA,MAAA;EACA,QAAA;EACA,WhFOa;EgFNb,UAAA;EACA,yBhFmBQ;EgFlBR,4ChFkmB0B;AZs/8C9B;;A4Frl+CA;EACI,aAAA;EAEA,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,YhFQY;EgFPZ,gCAAA;A5Fwl+CJ;A4Frl+CQ;EACI,yBhFkED;AZqh+CX;A4Fnl+CI;EACI,aAAA;A5Fql+CR;;A4F/k+CQ;EACI,UhFrBe;AZum+C3B;A4Fjl+CY;EAFJ;IAGQ,OAAA;E5Fol+Cd;AACF;A4F/k+CY;EACI,aAAA;A5Fil+ChB;A4F7k+CQ;EACI,iBAAA;A5F+k+CZ;;A4F1k+CA;EAEI,YAAA;EACA,eAAA;EACA,UAAA;EACA,yBhFtDS;AZko+Cb;;A4Fzk+CA;EACI,iBAAA;A5F4k+CJ;A4F1k+CI;EACI,aAAA;A5F4k+CR;;A4Fxk+CA;EACI,chFlBY;AZ6l+ChB;;A4Fxk+CA;EACI,ahFvBW;AZkm+Cf;;A4Fxk+CA,WAAA;AAEA;EACI,yBAAA;A5F0k+CJ;A4Fxk+CI;EACI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BhFrDW;EgFsDX,gBAAA;EACA,kBAAA;A5F0k+CR;A4Fxk+CI;EACI,kBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,MAAA;EACA,chFLG;AZ+k+CX;;A4Fnk+CI;EACI,kBAAA;EACA,gBAAA;A5Fsk+CR;A4Frk+CQ;EACI,chFfD;AZsl+CX;;A4Flk+CA;EACI;IACI,WAAA;E5Fqk+CN;E4Flk+CE;IACI,OAAA;E5Fok+CN;E4Fhk+CU;IACI,qBAAA;IACA,kBAAA;E5Fkk+Cd;E4F/j+CU;IACI,qBAAA;E5Fik+Cd;E4F1j+CM;IACI,aAAA;E5F4j+CV;E4Fzj+CM;IACI,qBAAA;E5F2j+CV;AACF;A4Fvj+CA;EACI,uEAAA;A5Fyj+CJ;;A4Ftj+CA;EACI,YhF/HY;EgFgIZ,2BAAA;EACA,chF/HgB;EgFgIhB,SAAA;EACA,kBAAA;A5Fyj+CJ;A4Fvj+CI;EACI,chFpIY;AZ6r+CpB;;A4Frj+CA;EACI,YAAA;EACA,WAAA;EACA,yBhF5EO;EgF6EP,YAAA;A5Fwj+CJ;;A4Fpj+CI;EACI,eAAA;EACA,chFlJY;AZys+CpB;A4Fpj+CI;EACI,kBAAA;EACA,SAAA;EACA,UAAA;A5Fsj+CR;;A4Fjj+CI;EACI,qBAAA;EACA,aAAA;A5Foj+CR;A4Flj+CQ;EACI,yBhFrGD;AZyp+CX;;A4F9i+CA;EACI,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,6BAAA;EACA,chF9GO;AZ+p+CX;A4F/i+CI;EACI,YAAA;A5Fij+CR;A4F9i+CI;EACI,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;A5Fgj+CR;A4F7i+CI;EACI,qBhFhIG;AZ+q+CX;;A4Fxi+CQ;EACI,gBAAA;A5F2i+CZ;;A4Fri+CI;EACI,yBhF1MS;AZkv+CjB;A4Fpi+CY;EACI,2CAAA;A5Fsi+ChB;A4Fli+CQ;EACI,oCAAA;A5Foi+CZ;A4Fhi+CI;EACI,chFxNiB;AZ0v+CzB;A4Fhi+CQ;EACI,chF3Na;AZ6v+CzB;A4F9h+CI;EACI,2CAAA;A5Fgi+CR;A4F5h+CQ;EACI,chFrOa;AZmw+CzB;A4F1h+CI;EACI,aAAA;A5F4h+CR;A4Fzh+CI;EACI,cAAA;A5F2h+CR;A4Fth+CQ;EACI,+CAAA;EACA,WhF7LD;AZqt+CX;A4Fth+CQ;;EAEI,+BAAA;A5Fwh+CZ;;A4Flh+CI;EACI,mBhF9QU;AZmy+ClB;A4Fnh+CQ;EACI,aAAA;A5Fqh+CZ;A4Flh+CQ;EACI,cAAA;A5Foh+CZ;;A4F5g+CA;EAEQ;IACI,gBAAA;E5F8g+CV;E4F5g+CU;IACI,qBAAA;IACA,sBAAA;E5F8g+Cd;AACF;A4Fzg+CA;EACI;IACI,aAAA;E5F2g+CN;AACF;A4Fvg+CI;EAEI,uEAAA;A5Fwg+CR;A4Ftg+CQ;EAJJ;IAKQ,eAAA;E5Fyg+CV;AACF;;A4Fng+CA;EACI;IACI,eAAA;IACA,kBAAA;E5Fsg+CN;E4Fng+CE;IACI,wBAAA;E5Fqg+CN;AACF;A6F11+CA;EACI,uBjFqkB0B;AZux9C9B;A6F11+CI;EACI,6BAAA;EACA,UAAA;A7F41+CR;A6Fz1+CI;EACI,gBAAA;EACA,0BAAA;A7F21+CR;A6Fv1+CQ;EADJ;IAEQ,aAAA;E7F01+CV;AACF;;A8F12+CA;EACI,SAAA;EACA,+BAAA;EACA,kBAAA;EACA,QAAA;EACA,clFiCW;EkFhCX,WAAA;EACA,alF6BY;EkF5BZ,4CAAA;A9F62+CJ;;A8F12+CA;EACI;IACI,OAAA;E9F62+CN;AACF;A8Fx2+CI;EACI,UlFRmB;AZk3+C3B;;A8Fr2+CI;EACI,kBAAA;A9Fw2+CR;;A+Fl4+CA;EACI,sBnFqFO;EmFpFP,yEAAA;EACA,cAAA;EACA,eAAA;EACA,8BAAA;EACA,YnFyCc;EmFxCd,aAAA;EACA,uBAAA;EACA,aAAA;EACA,MAAA;EACA,SAAA;A/Fq4+CJ;A+Fn4+CI;EACI,0DAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,cnFsEG;EmFrEH,kBAAA;EACA,kBAAA;A/Fq4+CR;A+Fn4+CQ;EACI,yDAAA;A/Fq4+CZ;;A+F/3+CA;EACI,wCAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,aAAA;EACA,6BAAA;A/Fk4+CJ;;A+F93+CI;EACI,QAAA;A/Fi4+CR;A+F/3+CI;EACI,cAAA;A/Fi4+CR;;AoBv2+CI;E2ErBA;IACI,cAAA;E/Fg4+CN;E+F/3+CM;IACI,uBAAA;E/Fi4+CV;AACF;AgGx7+CA;EACI,SAAA;AhG07+CJ;AgGx7+CI;EACI,cAAA;EACA,WAAA;AhG07+CR;AgGv7+CI;EACI,aAAA;AhGy7+CR;AgGv7+CQ;EACI,aAAA;AhGy7+CZ;AgGt7+CQ;EACI,cAAA;AhGw7+CZ;AgGp7+CI;EACI,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,gCAAA;EACA,0BAAA;EACA,uCAAA;AhGs7+CR;;AgGj7+CA;EACI,YpFrBa;EoFsBb,aAAA;EACA,mBpF/BS;EoFgCT,SAAA;EACA,aAAA;EACA,eAAA;EACA,MAAA;EACA,4CpFkkB0B;AZk39C9B;AgGl7+CI;EACI,kBAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;AhGo7+CR;;AgGh7+CA;EACI,kBpFvCa;EoFwCb,gBAAA;AhGm7+CJ;AgGj7+CI;EACI,yBAAA;EACA,gBpF/BQ;AZk9+ChB;;AgG/6+CA;EACI,yBAAA;EACA,gBpFrCY;AZu9+ChB;;AgG96+CA;EACI,sBAAA;AhGi7+CJ;AgG76+CY;EACI,0BAAA;AhG+6+ChB;AgGz6+CQ;EACI,iBAAA;EACA,oCAAA;EACA,cAAA;EACA,YAAA;EACA,0BAAA;EACA,eAAA;AhG26+CZ;AgGr6+CY;EACI,cAAA;EACA,sBAAA;EACA,cpFxFU;EoFyFV,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;EACA,kBAAA;AhGu6+ChB;AgGr6+CgB;EACI,qBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,cpFrGW;EoFsGX,oBAAA;AhGu6+CpB;AgGp6+CgB;EACI,cpFzGY;AZ+g/ChC;AgGp6+CoB;EACI,cpF5GQ;AZkh/ChC;AgGj6+CY;EACI,eAAA;AhGm6+ChB;AgGh6+CY;EACI,UAAA;AhGk6+ChB;AgG95+CoB;EACI,oCAAA;EACA,gBAAA;EACA,cpF/HM;EoFgIN,SAAA;EACA,6BAAA;EACA,iBAAA;AhGg6+CxB;AgG95+CwB;EACI,cpFnII;AZmi/ChC;AgG55+CoB;EACI,UAAA;AhG85+CxB;AgG35+C4B;EACI,oCAAA;EACA,iBAAA;AhG65+ChC;;AgGl5+CA;EACI,6BAAA;EACA,sBAAA;EACA,oBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,cpFhK2B;EoFiK3B,gBpFzGmB;AZ8/+CvB;;AgGl5+CA;EACI,yBAAA;AhGq5+CJ;AgGn5+CI;EACI,yBpFrK4B;EoFsK5B,yBAAA;AhGq5+CR;AgGp5+CQ;EACI,yBAAA;AhGs5+CZ;AgGj5+CI;EACI,yBAAA;AhGm5+CR;AgGj5+CQ;EACI,yBAAA;AhGm5+CZ;AgGh5+CI;EACI,yBAAA;AhGk5+CR;;AgG94+CA;EACI;IACI,aAAA;IACA,SpF7KQ;EZ8j/Cd;EgG/4+CM;IACI,YAAA;IACA,aAAA;EhGi5+CV;EgG94+CM;;IAEI,aAAA;EhGg5+CV;EgG34+CE;IACI,yBAAA;EhG64+CN;EgGz4+CM;IACI,cAAA;EhG24+CV;AACF;AgGp4+CI;EAFJ;IAGQ,kBAAA;EhGu4+CN;AACF;AgGr4+CI;EACI,iBpF1NmB;AZim/C3B;AgGp4+CI;EACI,sBAAA;AhGs4+CR;AgGl4+CQ;EACI,aAAA;AhGo4+CZ;AgGj4+CQ;EACI,cAAA;AhGm4+CZ;AgG93+CI;EACI,kBAAA;EACA,sBAAA;EACA,aAAA;AhGg4+CR;AgG93+CQ;;EAEI,4BAAA;AhGg4+CZ;AgG73+CQ;;EAEI,wBAAA;AhG+3+CZ;AgG53+CQ;EACI,oBAAA;AhG83+CZ;AgGx3+CY;;;EAGI,wBAAA;AhG03+ChB;AgGv3+CY;EACI,0BAAA;AhGy3+ChB;AgGr3+CgB;EACI,aAAA;AhGu3+CpB;AgGl3+CgB;EACI,kBAAA;EACA,mBAAA;AhGo3+CpB;AgGl3+CoB;EACI,eAAA;EACA,gBAAA;AhGo3+CxB;AgGl3+CwB;EAGI,cpFnSI;AZqp/ChC;AgG/2+CwB;EACI,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AhGi3+C5B;AgG92+CwB;EACI,aAAA;EACA,kBAAA;AhGg3+C5B;AgG32+CwB;EACI,kBAAA;EACA,yBAAA;EACA,cpF3MlB;EoF4MkB,yBpFtTQ;EoFuTR,gBAAA;EACA,uDAAA;AhG62+C5B;AgG32+C4B;EACI,cpFjNtB;AZ8j/CV;AgG12+C4B;EACI,eAAA;AhG42+ChC;AgGx2+CwB;EACI,cAAA;EACA,UpFlUD;EoFmUC,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,gDAAA;AhG02+C5B;AgGx2+C4B;EACI,gDAAA;AhG02+ChC;AgGv2+C4B;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,cpFzVF;AZks/C9B;AgGv2+CgC;EACI,cpF1VJ;AZms/ChC;AgGl2+CgB;EACI,cAAA;EACA,aAAA;EACA,aAAA;EACA,yBpFzWP;AZ6s/Cb;AgGh2+C4B;EACI,cAAA;EACA,WAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;AhGk2+ChC;AgG71+C4B;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,yBAAA;AhG+1+ChC;AgGz1+CwB;EACI,cpF/SjB;AZ0o/CX;;AgG/0+CI;EACI,mBpFnYU;AZqt/ClB;AgGh1+CQ;EACI,cpFrYmB;AZut/C/B;AgG10+CgB;EACI,cpF9YW;AZ0t/C/B;AgG10+CoB;EACI,cpF/YY;AZ2t/CpC;AgGz0+CoB;EACI,cpFlZa;AZ6t/CrC;AgGz0+CwB;EACI,cpFrZS;AZgu/CrC;AgGn0+CwB;EACI,cpFhaO;AZqu/CnC;AgGn0+C4B;EACI,cpFjaK;AZsu/CrC;AgG5z+CI;EACI,kBAAA;AhG8z+CR;AgGnz+C4B;EACI,4DAAA;EACA,cpFxbK;AZ6u/CrC;AgGpz+CgC;EACI,cpF1bC;AZgv/CrC;AgGjz+CgC;EACI,cpFlcD;AZqv/CnC;AgGlz+CoC;EACI,cpFlcH;AZsv/CrC;AgG7y+CoB;EACI,yBpF9cN;AZ6v/ClB;AgGvy+CwB;EACI,yBAAA;AhGyy+C5B;AgGxy+C4B;EACI,yBAAA;AhG0y+ChC;AgG/x+CI;EACI,yBAAA;AhGiy+CR;AgGhy+CQ;EACI,yBAAA;AhGky+CZ;AgG/x+CQ;EACI,yBpFjf6B;EoFkf7B,yBAAA;AhGiy+CZ;AgGhy+CY;EACI,yBAAA;AhGky+ChB;AgG/x+CQ;EACI,yBAAA;AhGiy+CZ;AgG/x+CY;EACI,yBAAA;AhGiy+ChB;AgG5x+CI;EACI,cpFxf4B;AZsx/CpC;;AgGxx+CI;EACI,yBAAA;AhG2x+CR;;AgGpx+CI;EACI,YpF7gBY;AZoy/CpB;AgGtx+CQ;EAFJ;IAGQ,WAAA;EhGyx+CV;AACF;AgGvx+CI;EACI,YpFnhBY;EoFohBZ,kBAAA;AhGyx+CR;AgGvx+CQ;;EAEI,wBAAA;AhGyx+CZ;AgGtx+CQ;EACI,aAAA;AhGwx+CZ;AgGnx+CI;EACI,kBpFliBY;AZuz/CpB;AgGnx+CI;EACI,WpFriBY;AZ0z/CpB;AgGpx+CQ;EAFJ;IAGQ,OAAA;EhGux+CV;AACF;AgGlx+CY;EACI,0CAAA;AhGox+ChB;AgGjx+CgB;EACI,cAAA;AhGmx+CpB;AgG9w+CoB;EACI,oBAAA;AhGgx+CxB;AgG7w+CoB;EACI,oBAAA;AhG+w+CxB;AgGrw+CgB;EACI,kEAAA;AhGuw+CpB;AgGhw+CQ;EACI,cAAA;AhGkw+CZ;AgG9v+CQ;EACI,iBpFrlBe;AZq1/C3B;AgG7v+CY;EACI,gBAAA;AhG+v+ChB;AgG3v+C4B;EACI,qBAAA;AhG6v+ChC;AgGtv+CQ;EACI,UpFtmBe;AZ81/C3B;;AgGhv+CI;EACI,yBpFxgBE;AZ2v/CV;AgGjv+CQ;EACI,+BAAA;AhGmv+CZ;AgGhv+CI;EACI,yBpF/gBE;AZiw/CV;AgGjv+CQ;EACI,aAAA;AhGmv+CZ;AgGjv+CQ;EACI,cAAA;AhGmv+CZ;AgG/u+CI;EACI,sBAAA;AhGiv+CR;AgGhv+CQ;EACI,0CAAA;EACA,sBAAA;AhGkv+CZ;AgGjv+CY;EACI,sBAAA;AhGmv+ChB;AgGhv+CQ;EACI,sBAAA;AhGkv+CZ;AgG3u+CgB;EACI,+BAAA;AhG6u+CpB;AgG1u+CgB;EACI,+BAAA;AhG4u+CpB;AgG3u+CoB;EACI,+BAAA;AhG6u+CxB;AgG1u+CwB;EACE,oCAAA;AhG4u+C1B;AgGru+CwB;EACI,+BAAA;AhGuu+C5B;AgGju+CoB;EACI,sBpFhmBb;EoFimBa,cpFpkBd;AZuy/CV;AgGvt+CwB;EACI,oEAAA;EACA,WpF/mBjB;AZw0/CX;AgGxt+C4B;EACI,WpFjnBrB;AZ20/CX;AgGjt+C4B;EACI,yBAAA;AhGmt+ChC;;AiGp6/CA;EACI,mBAAA;EACA,4BAAA;EACA,4CrFsmB0B;EqFrmB1B,OAAA;EACA,QAAA;EACA,UAAA;AjGu6/CJ;AiGr6/CI;EACI,SAAA;EACA,UAAA;AjGu6/CR;AiGl6/CQ;EACI,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,WAAA;AjGo6/CZ;AiGn6/CY;EACI,eAAA;AjGq6/ChB;AiGn6/CY;EACI,+BAAA;EACA,6BAAA;AjGq6/ChB;AiGj6/CQ;EACI,crFaM;AZs5/ClB;AiGl6/CY;EACI,+BAAA;EACA,6BAAA;AjGo6/ChB;AiG/5/CY;EACI,crFKS;AZ45/CzB;AiG35/Cc;EACM,crFFK;EqFGL,6BAAA;AjG65/CpB;;AiGr5/CI;EACI,OAAA;AjGw5/CR;AiGv5/CQ;EAFJ;IAGQ,4BAAA;EjG05/CV;AACF;AiGv5/CI;EACI,kBAAA;EACA,WAAA;EACA,cAAA;EACA,6BAAA;AjGy5/CR;AiGv5/CQ;EANJ;IAOQ,eAAA;EjG05/CV;AACF;AiGt5/CI;EACI;IACI,gBAAA;IACA,oBAAA;IACA,kBAAA;EjGw5/CV;EiGr5/CM;IACI,4BAAA;EjGu5/CV;AACF;;AoB/6/CI;E6EiCI;;IAEI,eAAA;EjGk5/CV;AACF;AoBt7/CI;E6E2CI;IACI,sBAAA;IACA,gBAAA;EjG84/CV;EiGx4/Cc;IACI,SAAA;IACA,WAAA;EjG04/ClB;EiGv4/CU;IACI,aAAA;IACA,kCAAA;EjGy4/Cd;EiGt4/CkB;IACI,WAAA;IACA,2CAAA;IACA,kBAAA;EjGw4/CtB;EiGn4/CkB;IACI,kBAAA;IACA,iBAAA;IACA,UAAA;IACA,aAAA;EjGq4/CtB;EiG/3/Cc;IACI,cAAA;EjGi4/ClB;EiG53/CM;IACI,cAAA;EjG83/CV;EiG13/CE;IACI,aAAA;EjG43/CN;AACF;AiGz3/CA;EACI,qBAAA;AjG23/CJ;AiGz3/CI;EACI,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,UAAA;EACA,QAAA;EACA,iBAAA;EACA,0CAAA;EACA,qBAAA;EACA,6BAAA;EACA,YAAA;AjG23/CR;;AoB79/CI;E6E6GoB;IACI,WAAA;IACA,UAAA;EjGo3/C1B;AACF;AiG52/CA;EACI;IACI,aAAA;EjG82/CN;AACF;AiG52/CA;EACI;IACI,aAAA;EjG82/CN;AACF;AiG32/CA;EAIY;IACI,crF7JA;EZuggDd;EiGz2/Cc;IACI,crF/JJ;EZ0ggDd;EiGv2/CU;IACI,arFrKD;EZ8ggDb;EiGn2/CE;IACI,eAAA;IACA,iBAAA;IACA,gBAAA;IACA,UAAA;EjGq2/CN;EiGn2/CU;IACI,oBAAA;EjGq2/Cd;EiGh2/CU;IACI,6BAAA;IACA,YAAA;IACA,gBAAA;IACA,kBAAA;EjGk2/Cd;EiGj2/Cc;IACI,WAAA;EjGm2/ClB;EiGj2/CkB;IACI,WAAA;EjGm2/CtB;EiG91/CU;IACI,kBAAA;IACA,6BAAA;EjGg2/Cd;EiG91/Cc;IAEI,crF1IV;EZy+/CR;EiGz1/CU;IACI,WAAA;IACA,kBAAA;EjG21/Cd;AACF;AoBtigDI;E6EqNQ;IACI,crF9NA;EZkjgDd;EiGj1/CU;IACI,arFnOD;EZsjgDb;EiG/0/CM;IACI,yBrFvKF;EZw//CR;EiG90/Cc;IACI,+BAAA;EjGg1/ClB;EiG90/CkB;IACI,+BAAA;EjGg1/CtB;EiG10/CkB;IACQ,0CAAA;EjG40/C1B;AACF;AiGj0/CI;EACI,yBrFlME;EqFmMF,gBAAA;AjGm0/CR;AiGh0/CI;EACI,aAAA;AjGk0/CR;AiG/z/CI;EACI,cAAA;AjGi0/CR;AiG5z/CQ;EACI,qCAAA;EACA,WrF/OD;AZ6igDX;AiG5z/CQ;;EAEI,+BAAA;AjG8z/CZ;AiG3z/CI;EACI,crF/SiB;AZ4mgDzB;AiG3z/CQ;EACI,crFlTa;AZ+mgDzB;AiGvz/CY;EACI,0CAAA;AjGyz/ChB;AiGrz/CQ;EACI,oCAAA;AjGuz/CZ;AiGlz/CQ;EACI,crFpUa;AZwngDzB;;AkGtpgDA;EACI,yBtFyDkB;AZgmgDtB;AkGxpgDI;EACI,yBtFgeoB;EsF/dpB,iBtFqDgB;EsFpDhB,cAAA;EACA,4CtFmmBsB;AZuj/C9B;AkGvpgDI;EACI,+BAAA;EACA,cAAA;AlGypgDR;AkGtpgDI;EACI,cAAA;EACA,+BAAA;AlGwpgDR;AkGppgDQ;EACI,8BAAA;AlGspgDZ;AkGppgDQ;EACI,8BAAA;AlGspgDZ;;AkG7ogDI;EACI,eAAA;AlGgpgDR;AkG9ogDI;EACI,iBtFoBgB;AZ4ngDxB;;AmGxrgDA;;;;;;uDAAA;AAOC;EACG,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,yBAAA;EAGA,iBAAA;EACA,wCAAA;AnG2rgDJ;;AmGzrgDE;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,8BAAA;EAIA,qJAAA;EAIA,6BAAA;EAIA,uCAAA;EAKA,mCAAA;EACA,oBAAA;AnG4rgDJ;;AmG1rgDE;EACE,oCAAA;EAIA,6KAAA;AnG6rgDJ;;AmG3rgDE;EACE,8BAAA;AnG8rgDJ;;AmG5rgDE;EACE,oCAAA;AnG+rgDJ;;AmG7rgDE;EAIE,2BAAA;AnGgsgDJ;;AmG9rgDE;;EAME,wBAAA;EACA,2EAAA;AnGisgDJ;;AmG/rgDE;;;;EAIE,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,kCAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,UAAA;AnGksgDJ;;AmGhsgDE;EACE,qBAAA;EACA,oBAAA;AnGmsgDJ;;AmGjsgDE;EACE,SAAA;EACA,qBAAA;AnGosgDJ;;AmGlsgDE;EACE,oBAAA;EACA,sBAAA;AnGqsgDJ;;AmGnsgDE;EACE,UAAA;AnGssgDJ;;AmGpsgDE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;AnGusgDJ;;AmGrsgDE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AnGwsgDJ;;AmGtsgDE;EACE,wBAAA;EAEA,iDAAA;EAIA,qBAAA;AnGysgDJ;;AmGvsgDE;EAEE,+CAAA;AnG0sgDJ;;AmGxsgDE;EACE,cAAA;AnG2sgDJ;;AmGvsgDI;EACI,0CAAA;AnG0sgDR;;AmGrsgDI;EACI,yCAAA;AnGwsgDR;;AmGpsgDI;EACI,yCAAA;AnGusgDR;;AmGnsgDI;EACI,yCAAA;AnGssgDR;;AmGlsgDI;EACI,yCAAA;AnGqsgDR;;AmGjsgDI;EACI,0CAAA;AnGosgDR;;AoGr2gDA;EACE,YAAA;EACA,WAAA;ApGw2gDF;;AoGr2gDA;EACE,YAAA;EACA,WAAA;ApGw2gDF;;AoGr2gDA;EACE,cAAA;EACA,aAAA;ApGw2gDF;;AoGr2gDA;EACE,YAAA;EACA,WAAA;ApGw2gDF;;AoGr2gDA;EACE,cAAA;EACA,aAAA;ApGw2gDF;;AoGr2gDA;EACE,mBAAA;EACA,yBxFwFQ;EwFvFR,WxF0DS;EwFzDT,aAAA;EACA,gBxF+BmB;EwF9BnB,YAAA;EACA,uBAAA;EACA,WAAA;ApGw2gDF;;AqGx4gDA;EACI,sBzFoFO;EyFnFP,qBzFqFO;EyFpFP,6BAAA;ArG24gDJ;;AqGt4gDI;EACE,eAAA;EACA,wBAAA;EACA,gBAAA;EACA,0FAAA;ArGy4gDN;;AqGp4gDE;EACE,0FAAA;ArGu4gDJ;;AqGj4gDM;EACI,yBzFoIK;AZgwgDf;;AqGr4gDM;EACI,yBzFoIK;AZowgDf;;AqGz4gDM;EACI,yBzFoIK;AZwwgDf;;AqG74gDM;EACI,yBzFoIK;AZ4wgDf;;AqGj5gDM;EACI,yBzFoIK;AZgxgDf;;AqGr5gDM;EACI,yBzFoIK;AZoxgDf;;AqGz5gDM;EACI,yBzFoIK;AZwxgDf;;AqG75gDM;EACI,yBzFoIK;AZ4xgDf;;AqGj6gDM;EACI,yBzFoIK;AZgygDf;;AqGr6gDM;EACI,yBzFoIK;AZoygDf;;AsG97gDQ;EACI,kBAAA;AtGi8gDZ;AsGz7gDgB;EACI,iBAAA;AtG27gDpB;AsGr7gDI;EACI,c1FuEG;AZg3gDX;;AuG58gDA;EACE,kBAAA;AvG+8gDF;;AuG58gDA;EACE,0BAAA;AvG+8gDF;;AuG58gDA;EACE,0BAAA;AvG+8gDF;;AuG58gDA;EACE,0BAAA;AvG+8gDF;;AuG58gDA;EACE,0BAAA;AvG+8gDF;;AuG58gDA;EACE,0BAAA;AvG+8gDF;;AuG58gDA;EACE,0BAAA;AvG+8gDF;;AuG58gDA;EACE,0BAAA;AvG+8gDF;;AuG58gDA;EACE,0BAAA;AvG+8gDF;;AuG58gDA;EACE,0BAAA;AvG+8gDF;;AuG58gDA;EACE,0BAAA;AvG+8gDF;;AuG58gDA;EACE,0BAAA;AvG+8gDF;;AuG58gDA;EACE,0BAAA;AvG+8gDF;;AuGz8gDA;EACE,gB3FKmB;AZu8gDrB;;AuGz8gDA;EACE,gB3FEqB;AZ08gDvB;;AuGv8gDA;EACE,YAAA;EACA,WAAA;EACA,6BAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,c3FmBS;E2FlBT,kBAAA;EACA,oBAAA;AvG08gDF;AuGz8gDE;EACE,c3FgBO;E2FfP,yB3FWO;AZg8gDX;;AuGt8gDA;EACE,eAAA;AvGy8gDF;;AuGv8gDA;EACE,eAAA;AvG08gDF;;AuGx8gDA;EACE,gBAAA;AvG28gDF;;AuGz8gDA;EACE,gBAAA;AvG48gDF;;AuGz8gDA;EACE,gBAAA;AvG48gDF;;AwG5ihDA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sB5FgFO;E4F/EP,aAAA;AxG+ihDJ;;AwG5ihDA;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,2BAAA;EACA,uBAAA;AxG+ihDJ;;AwG3ihDI;EACI,eAAA;EACA,c5F8FE;E4F7FF,kBAAA;EACA,qBAAA;EACA,oCAAA;AxG8ihDR;;AwG1ihDA;EACI;IACE,uBAAA;ExG6ihDJ;EwG3ihDE;IACE,yBAAA;ExG6ihDJ;AACF;AyG9khDA;EACE,kBAAA;AzGglhDF;;AyG3khDA;EACE,eAAA;EACA,qBAAA;EACA,oB7Fm8BwC;AZ2o/C1C;AyG7khDE;EACE,YAAA;EACA,cAAA;EACA,oBAAA;AzG+khDJ;AyG7khDE;EACE,cAAA;AzG+khDJ;;AyGvkhDE;EACE,iBAAA;EACA,sB7F2DO;AZ+ghDX;AyGxkhDI;EACE,YAAA;AzG0khDN;AyGvkhDI;EACE,iCAAA;AzGykhDN;AyGvkhDM;EACE,sBAAA;AzGykhDR;AyGrkhDM;EACE,kBAAA;EACA,iBAAA;EACA,oCAAA;EACA,oBAAA;EACA,SAAA;EACA,eAAA;AzGukhDR;;AyG9jhDE;EACE,iBAAA;EACA,sB7F4BO;AZqihDX;AyG/jhDI;EACE,YAAA;AzGikhDN;AyG9jhDI;EACE,iCAAA;AzGgkhDN;AyG9jhDM;EACE,sBAAA;AzGgkhDR;AyG5jhDM;EACE,kBAAA;EACA,iBAAA;EACA,oCAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AzG8jhDR;;AyGjjhDM;EACE,yB7FkEO;E6FjEP,qB7FiEO;AZm/gDf;;AyG7ihDM;EACE,qB7FyDO;E6FxDP,yB7FwDO;AZw/gDf;AyG/ihDQ;EACE,c7FsDK;AZ2/gDf;;AyG9jhDM;EACE,yB7FkEO;E6FjEP,qB7FiEO;AZgghDf;;AyG1jhDM;EACE,qB7FyDO;E6FxDP,yB7FwDO;AZqghDf;AyG5jhDQ;EACE,c7FsDK;AZwghDf;;AyG3khDM;EACE,yB7FkEO;E6FjEP,qB7FiEO;AZ6ghDf;;AyGvkhDM;EACE,qB7FyDO;E6FxDP,yB7FwDO;AZkhhDf;AyGzkhDQ;EACE,c7FsDK;AZqhhDf;;AyGxlhDM;EACE,yB7FkEO;E6FjEP,qB7FiEO;AZ0hhDf;;AyGplhDM;EACE,qB7FyDO;E6FxDP,yB7FwDO;AZ+hhDf;AyGtlhDQ;EACE,c7FsDK;AZkihDf;;AyGrmhDM;EACE,yB7FkEO;E6FjEP,qB7FiEO;AZuihDf;;AyGjmhDM;EACE,qB7FyDO;E6FxDP,yB7FwDO;AZ4ihDf;AyGnmhDQ;EACE,c7FsDK;AZ+ihDf;;AyGlnhDM;EACE,yB7FkEO;E6FjEP,qB7FiEO;AZojhDf;;AyG9mhDM;EACE,qB7FyDO;E6FxDP,yB7FwDO;AZyjhDf;AyGhnhDQ;EACE,c7FsDK;AZ4jhDf;;AyG/nhDM;EACE,yB7FkEO;E6FjEP,qB7FiEO;AZikhDf;;AyG3nhDM;EACE,qB7FyDO;E6FxDP,yB7FwDO;AZskhDf;AyG7nhDQ;EACE,c7FsDK;AZykhDf;;AyG5ohDM;EACE,yB7FkEO;E6FjEP,qB7FiEO;AZ8khDf;;AyGxohDM;EACE,qB7FyDO;E6FxDP,yB7FwDO;AZmlhDf;AyG1ohDQ;EACE,c7FsDK;AZslhDf;;AyGzphDM;EACE,yB7FkEO;E6FjEP,qB7FiEO;AZ2lhDf;;AyGrphDM;EACE,qB7FyDO;E6FxDP,yB7FwDO;AZgmhDf;AyGvphDQ;EACE,c7FsDK;AZmmhDf;;AyGtqhDM;EACE,yB7FkEO;E6FjEP,qB7FiEO;AZwmhDf;;AyGlqhDM;EACE,qB7FyDO;E6FxDP,yB7FwDO;AZ6mhDf;AyGpqhDQ;EACE,c7FsDK;AZgnhDf;;AyG/phDA;EACE,eAAA;EACA,gBAAA;AzGkqhDF;;AyG7phDA;EACE,kBAAA;EACA,gBAAA;AzGgqhDF;;AyG7phDA;EACE,oBAAA;EACA,gBAAA;EACA,iBAAA;AzGgqhDF;AyG/phDE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AzGiqhDJ;AyG9phDE;EACE,sBAAA;AzGgqhDJ;;AyG3phDA;EACE,qBAAA;EACA,gBAAA;EACA,iBAAA;AzG8phDF;AyG7phDE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;AzG+phDJ;;AyG3phDA;EACE,kBAAA;AzG8phDF;;AyG3phDA;EACE,sB7FvES;AZquhDX;;A0G1zhDI;EACI,gCAAA;EACA,iBAAA;A1G6zhDR;A0G3zhDQ;EACI,iBAAA;A1G6zhDZ;;A0GvzhDA,aAAA;AAEA;EACI,gBAAA;A1GyzhDJ;A0GvzhDI;EACI,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,8BAAA;A1GyzhDR;A0GvzhDQ;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,sB9FqDD;AZowhDX;A0GtzhDQ;EACI,yBAAA;A1GwzhDZ;;A2G51hDA;EACI,iBAAA;EACA,oBAAA;A3G+1hDJ;A2G71hDI;EACI,mBAAA;EACA,gBAAA;A3G+1hDR;;A2Gz1hDA;EACI,iBAAA;A3G41hDJ;;A2Gv1hDA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;A3G01hDJ;;A2Gr1hDA;EACI,kBAAA;EACA,c/F0DO;AZ8xhDX;A2Gt1hDI;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,c/FiDK;E+FhDL,kBAAA;EACA,oBAAA;A3Gw1hDN;A2Gr1hDI;EACE,gBAAA;A3Gu1hDN;A2Gp1hDQ;EACE,W/FiCC;E+FhCD,yB/F6DA;E+F5DA,qB/F4DA;AZ0xhDV;;A2G50hDI;EACI,yB/FqBG;E+FpBH,gBAAA;EACA,iBAAA;EACA,gB/FRa;E+FSb,kBAAA;A3G+0hDR;;A2Gx0hDA;EACE,sB/FQS;E+FPT,yBAAA;EACA,sB/FmhB4B;E+FlhB5B,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;A3G20hDF;A2Gz0hDE;EACE,eAAA;A3G20hDJ;;A2Gv0hDA;EACE,cAAA;A3G00hDF;;A2Gt0hDA;EACE,aAAA;A3Gy0hDF;A2Gx0hDE;EACE,gCAAA;A3G00hDJ;A2Gx0hDI;EACE,gBAAA;EACA,2BAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;EACA,c/FMI;AZo0hDV;;A2Gp0hDE;EACI,gBAAA;A3Gu0hDN;A2Gt0hDM;EACI,WAAA;EACA,YAAA;EACA,4BAAA;EACA,0BAAA;EACA,6BAAA;EACA,qDAAA;EACA,yBAAA;EACA,0BAAA;A3Gw0hDV;;A4Gp8hDA;EACI;;;;;IAKI,wBAAA;E5Gu8hDN;E4Gr8hDE;;;;;IAKI,UAAA;IACA,SAAA;E5Gu8hDN;E4Gp8hDE;IACI,SAAA;E5Gs8hDN;AACF;A6G99hDA;EACE,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;EACA,uBAAA;A7Gg+hDF;;A6G79hDA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;A7Gg+hDF;;A6G79hDA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,sBAAA;EACA,uBAAA;EACA,UAAA;A7Gg+hDF;;A6G79hDA;EACE,6BAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;EACA,iCAAA;A7Gg+hDF;;A6G79hDA;EACE,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA,EAAA,mGAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA,EAAA,mFAAA;EACA,eAAA,EAAA,kDAAA;EACA,gBAAA,EAAA,0CAAA;EACA,qBAAA;EACA,uBAAA;A7Gg+hDF;;A6G79hDA;;EAEE,aAAA;A7Gg+hDF;;A6G79hDA;;EAEE,YAAA;EACA,cAAA;A7Gg+hDF;;A6G79hDA;EACE,gBAAA;EACA,eAAA;EACA,WAAA;EACA,oBAAA;A7Gg+hDF;;A6G79hDA;EACE,8BAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;A7Gg+hDF;;A6G79hDA;EACE,mBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,WAAA;A7Gg+hDF;;A6G79hDA;EACE,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,gBAAA;A7Gg+hDF;;A6G79hDA;EACE,oBAAA;EACA,iBAAA;EACA,yBAAA;A7Gg+hDF;;A6G79hDA;EACE,mBAAA;A7Gg+hDF;;A6G79hDA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;A7Gg+hDF;;A6G79hDA;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,+BAAA;A7Gg+hDF;;A6G79hDA;EACE,0DAAA;EACA,YAAA;EACA,6BAAA;A7Gg+hDF;;A6G79hDA;EACE,MAAA;EACA,WAAA;A7Gg+hDF;;A6G79hDA;EACE,QAAA;EACA,WAAA;A7Gg+hDF;;A6G79hDA;EACE,OAAA;EACA,YAAA;A7Gg+hDF;;A6G79hDA;EACE,YAAA;EACA,SAAA;EACA,UAAA;A7Gg+hDF;;A6G79hDA;EACE,WAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;A7Gg+hDF;;A6G79hDA,gBAAA;AACA;EACE,WAAA;EACA,OAAA;A7Gg+hDF;;A6G79hDA;EACE,cAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;A7Gg+hDF;;A6G79hDA;EACE,eAAA;EACA,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;A7Gg+hDF;;A6G79hDA;EACE,YAAA;A7Gg+hDF;;A8GrriDA;;oBAAA;AAKA;EACI,yBAAA;A9GsriDJ;;A8G/qiDQ;EACI,eAAA;EACA,iBAAA;EACA,yBAAA;A9GkriDZ;A8G/qiDQ;EAEI;;;IAGI,WAAA;IACA,cAAA;IACA,kBAAA;IACA,WAAA;IACA,cAAA;E9GgriDd;E8G7qiDU;IACI,WAAA;E9G+qiDd;E8G5qiDU;IACI,aAAA;E9G8qiDd;AACF;A8G3qiDQ;EACI,0BAAA;A9G6qiDZ;;A8GtqiDI;EACI,mBlG4CG;EkG3CH,clG+CG;EkG9CH,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBlG8mBsB;AZ2jhD9B;;A8GnqiDI;;;;;;;;;;EAUI,qBlGuBG;AZ+oiDX;A8GnqiDI;EACI,kCAAA;A9GqqiDR;;A8GjqiDA;EACI,gBlGWO;EkGVP,qBlGYO;EkGXP,clGgBO;EkGfP,0BAAA;EACA,gBAAA;EACA,4BAAA;EACA,uBAAA;A9GoqiDJ;;A8GjqiDA;;;EAGI,yBlG4BM;EkG3BN,WlGFO;EkGGP,iBAAA;A9GoqiDJ;;A8GjqiDA;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;A9GoqiDJ;;A8GjqiDA;;EAEI,yBlGWM;AZypiDV;;A8GjqiDA;EACI,WlGtBO;AZ0riDX;;A8GhqiDI;EACI,gBAAA;EACA,iBAAA;A9GmqiDR;;A8G7piDI;EACE,clGjCK;AZisiDX;;A8GzpiDI;EACI,yBAAA;A9G4piDR;A8GzpiDI;EACI,mBAAA;A9G2piDR;;A+G/xiDI;EACI,aAAA;A/GkyiDR;A+G/xiDI;EACI,cnGiHE;EmGhHF,gBnGsDa;AZ2uiDrB;A+G9xiDI;EACI,sBnG2EG;EmG1EH,cnG2GE;EmG1GF,gBAAA;A/GgyiDR;;AgH5yiDA;EACE,wCpG8oB4B;AZiqhD9B;;AgH3yiDE;EACE,8BAAA;EACA,eAAA;AhH8yiDJ;AgH3yiDI;EACE,aAAA;AhH6yiDN;AgHzyiDE;EACE,mBpGwEO;EoGvEP,qBpGuEO;AZouiDX;AgHzyiDE;EACE,eAAA;EACA,cpGqEO;AZsuiDX;AgHzyiDE;EACE,cpGkEO;EoGjEP,mBpG+DO;EoG9DP,eAAA;AhH2yiDJ;AgHxyiDE;EACE,yBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,iCAAA;AhH0yiDJ;;AiH30iDE;EACE,eAAA;EACA,gBrGyDiB;AZqxiDrB;;AiH10iDA;EACE,eAAA;AjH60iDF;;AiHz0iDE;EACE,qBrG8GM;EqG7GN,crG6GM;AZ+tiDV;AiHz0iDI;EACE,yBrGuGI;AZouiDV;AiHx0iDI;EACE,qCAAA;AjH00iDN;AiHv0iDE;EACE,qBrG8FM;EqG7FN,crG6FM;AZ4uiDV;;AiHp0iDE;EACE,gBAAA;AjHu0iDJ;;AiHl0iDE;EACE,mBrG2EM;AZ0viDV;AiHp0iDI;EACE,mBrGyEI;AZ6viDV;AiHr0iDM;EACE,mCAAA;AjHu0iDR;AiHl0iDE;EACE,mBrGiEM;AZmwiDV;;AiHh0iDA;EACE,qDAAA;AjHm0iDF;;AkHz3iDA;EACE,qBAAA;AlH43iDF;;AkHv3iDI;EACE,gBAAA;AlH03iDN;AkHv3iDQ;EACE,ctG6GA;AZ4wiDV;;AkH/2iDI;EACE,gBAAA;AlHk3iDN;;AkH12iDI;EACE,kCAAA;AlH62iDN;;AkHp2iDM;EACE,gBAAA;EACA,ctG+EE;AZwxiDV;AkHn2iDI;EACE,gBAAA;AlHq2iDN;;AkH/1iDA;EACE,wBAAA;EACA,kBAAA;AlHk2iDF;;AkH31iDE;EACE,oBAAA;AlH81iDJ;;AmH55iDA;;eAAA;AAII;EACI,4CvGkmBsB;EuGjmBtB,UAAA;AnH85iDR;AmH75iDQ;EACI,4CvG+lBkB;EuG9lBlB,YAAA;AnH+5iDZ;AmH15iDQ;EACE,cAAA;EACA,gBAAA;AnH45iDV;;AmHp5iDI;EACI,oCAAA;EACA,oDAAA;AnHu5iDR;;AmHz5iDI;EACI,oCAAA;EACA,qDAAA;AnH45iDR;;AmH95iDI;EACI,oCAAA;EACA,oDAAA;AnHi6iDR;;AmHn6iDI;EACI,oCAAA;EACA,oDAAA;AnHs6iDR;;AmHx6iDI;EACI,oCAAA;EACA,oDAAA;AnH26iDR;;AmH76iDI;EACI,oCAAA;EACA,qDAAA;AnHg7iDR;;AmHl7iDI;EACI,oCAAA;EACA,oDAAA;AnHq7iDR;;AmHv7iDI;EACI,oCAAA;EACA,qDAAA;AnH07iDR;;AmH57iDI;EACI,oCAAA;EACA,kDAAA;AnH+7iDR;;AmHj8iDI;EACI,oCAAA;EACA,oDAAA;AnHo8iDR;;AmH77iDA;EACI,0CAAA;EACA,yBAAA;AnHg8iDJ;;AmH77iDA;EACI,aAAA;EACA,wCAAA;EACA,gBAAA;EACA,yBAAA;AnHg8iDJ;;AoH3+iDA;EACE,cxGqHQ;AZy3iDV;;AoH3+iDA;EACE,qBxGiHQ;AZ63iDV;;AoH3+iDA;EACE,aAAA;EACA,SAAA;EACA,UAAA;ApH8+iDF;AoH7+iDE;EACE,cAAA;ApH++iDJ;AoH7+iDE;EACE,eAAA;EACA,gBAAA;EACA,cxGoGM;EwGnGN,eAAA;ApH++iDJ;;AqHhgjDE;EACE,sBzGkFO;EyGjFP,yBAAA;EACA,YAAA;ArHmgjDJ;AqHlgjDI;EACE,aAAA;ArHogjDN;AqHjgjDI;EACE,iBAAA;EACA,kBAAA;EACA,czG+EK;AZo7iDX;AqHhgjDI;EACE,YAAA;EACA,WAAA;EACA,UAAA;ArHkgjDN;AqHhgjDM;EACE,yDAAA;EACA,2BAAA;ArHkgjDR;AqH9/iDI;EACE,czGgEK;AZg8iDX;;AqHt/iDM;EACE,oEAAA;EACA,sCAAA;ArHy/iDR;;AqHl/iDE;EACI,aAAA;EACA,sBzGoCK;AZi9iDX;AqHp/iDM;EACI,yBAAA;EACA,sBzGiCC;EyGhCD,czGsCC;EyGrCD,aAAA;ArHs/iDV;AqHn/iDE;EACI,yBzGwDI;AZ67iDV;AqHn/iDE;EACI,yBzGyBK;EyGxBL,4BzGoqC8B;AZi1gDpC;AqHp/iDM;EACI,yBzGkDA;EyGjDA,WzGoBC;AZk+iDX;;AqHj/iDA;EACE,iBAAA;ArHo/iDF;;AqHj/iDA;EACE,qCAAA;EACA,sBzGSS;EyGRT,4CzG2hB4B;AZy9hD9B;;AqHh/iDE;EACE,yBAAA;ArHm/iDJ;;AqH9+iDE;EACE,gBAAA;EACA,sBzGJO;EyGKP,oCAAA;ArHi/iDJ;AqH/+iDI;EACE,iBAAA;ArHi/iDN;AqH/+iDI;EACE,SAAA;EACA,czGLK;AZs/iDX;AqHh/iDM;EACI,czGPC;AZy/iDX;AqH/+iDI;EACE,yBzGhBK;EyGiBL,yBAAA;EACA,kBAAA;EACA,cAAA;ArHi/iDN;;AqH1+iDI;EACE,qBzGzBK;AZsgjDX;AqHz+iDE;EACE,gBzG1DmB;AZqijDvB;;AqHr+iDA;EACI,WAAA;EACA,WAAA;EACA,kBAAA;ArHw+iDJ;AqHv+iDE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ArHy+iDJ;;AqHr+iDA;EACE,eAAA;ArHw+iDF;;AqHr+iDA;;;EAGE,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,czGxDS;AZgijDX;AqHt+iDE;;;EACE,iBAAA;ArH0+iDJ;AqHv+iDM;;;EACE,gBAAA;EACA,kCAAA;ArH2+iDR;;AqHp+iDE;;;EAGA,+BAAA;ArHu+iDF;;AqHn+iDA;EACE,gBAAA;ArHs+iDF;;AqHh+iDA;EACE,iBAAA;EACA,YAAA;EACA,WAAA;ArHm+iDF;;AsHtpjDA,eAAA;AACA;EACE,aAAA;AtHypjDF;AsHxpjDE;EACE,cAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,yB1GkFO;E0GjFP,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gB1G6CiB;E0G5CjB,gCAAA;AtH0pjDJ;AsHzpjDI;EACE,c1G2EK;E0G1EL,6BAAA;EACA,cAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,gCAAA;AtH2pjDN;AsHxpjDI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,yB1GgDK;E0G/CL,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,gCAAA;AtH0pjDN;AsHtpjDE;EACE,yB1GgEM;AZwljDV;;AsHppjDA;EACE,yB1G2DQ;AZ4ljDV;AsHtpjDE;EACE,W1G4BO;E0G3BP,4BAAA;EACA,WAAA;EACA,SAAA;AtHwpjDJ;AsHrpjDE;EACE,UAAA;EACA,yB1GsBO;AZiojDX;;AsHnpjDA;EACE,yB1GgDQ;AZsmjDV;;AsHppjDA;;EAEE,W1GWS;AZ4ojDX;;AsHppjDA;EACE,yB1G2CQ;AZ4mjDV;;AsHppjDA;EACE,yBAAA;AtHupjDF;;AsHppjDA;EACE,yB1G4BQ;AZ2njDV;;AsHppjDA;EACE,yB1G+BQ;AZwnjDV;;AsHppjDA;EACE,yB1G6BQ;AZ0njDV;;AsHppjDA;EACE,yB1GsBQ;AZiojDV;;AsHppjDA;EACE,yB1GgBQ;AZuojDV;;AsHppjDA;EACE,yB1GbS;AZoqjDX;;AsHppjDA;EACE,iBAAA;AtHupjDF;AsHtpjDE;EACE,kBAAA;AtHwpjDJ;;AuHxwjDA;EACE,sB3GoFS;E2GnFT,YAAA;AvH2wjDF;AuH1wjDE;EACE,uBAAA;EACE,qBAAA;EACA,qBAAA;EACA,gBAAA;EACA,c3GqFK;AZurjDX;AuH1wjDM;EACE,yB3G4EG;AZgsjDX;AuHzwjDM;EACE,yB3G0GE;AZiqjDV;;AuHtwjDA;EACE,qB3GkES;AZusjDX;;AuHtwjDA;EACE,sB3G4DS;E2G3DT,gCAAA;EACA,c3GiES;AZwsjDX;AuHxwjDE;EACE,aAAA;AvH0wjDJ;;AuHhwjDE;EACE,cAAA;AvHmwjDJ;AuH/vjDI;EACE,qCAAA;EACA,wCAAA;EACA,sCAAA;EACA,yCAAA;AvHiwjDN;AuH7vjDE;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;EACA,4BAAA;EACA,gC3GyiB0B;E2GxiB1B,mC3GwiB0B;AZutiD9B;;AwHxzjDE;EACE,mBAAA;EACA,UAAA;AxH2zjDJ;;AwHtzjDE;EACE,mBAAA;EACA,UAAA;AxHyzjDJ;AwHrzjDE;EACE,2CAAA;AxHuzjDJ;AwHpzjDE;EACE,oBAAA;EACA,8CAAA;AxHszjDJ;;AwHlzjDA;EACE,yBAAA;EACA,YAAA;EACA,uBAAA;AxHqzjDF;AwHhzjDM;EACE,gBAAA;AxHkzjDR;AwH/yjDQ;;EAIE,oCAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;AxH+yjDV;AwH5yjDQ;;;EAII,mB5GqCD;AZwwjDX;AwH1yjDQ;;;EAII,c5GiCD;E4GhCC,YAAA;AxH2yjDZ;AwHxyjDQ;EACI,yB5G0BD;AZgxjDX;;AwHlyjDE;EACE,YAAA;AxHqyjDJ;;AwHhyjDE;EACE,sBAAA;EACA,qBAAA;AxHmyjDJ;;AwH5xjDA;EACE,yBAAA;EACA,gBAAA;EACA,sB5GHS;AZkyjDX;AwH7xjDE;EACE,YAAA;AxH+xjDJ;;AwHxxjDI;EACE,sB5GdK;E4GeL,kBAAA;AxH2xjDN;AwHzxjDM;EACE,0CAAA;EACA,c5GUE;AZixjDV;AwHxxjDM;EACE,yB5GME;E4GLF,W5GxBG;AZkzjDX;AwHtxjDM;EACE,c5GxBG;E4GyBH,YAAA;AxHwxjDR;AwHjxjDM;EACE,gB5G/Da;AZk1jDrB;AwHhxjDM;EACE,sB5G1CG;AZ4zjDX;;AyH74jDQ;EACA,0BAAA;EACA,6BAAA;AzHg5jDR;AyHz4jDQ;EACE,yBAAA;EACA,4BAAA;AzH24jDV;;A0Ht5jDC;;;;EACE,gBAAA;A1H45jDH;;A2H/5jDA;EACE,oCAAA;A3Hk6jDF;;A2H95jDE;EACE,wCAAA;A3Hi6jDJ;A2H/5jDI;EACE,iCAAA;EACA,2BAAA;A3Hi6jDN;A2H/5jDI;EACE,yBAAA;A3Hi6jDN;A2Hh6jDQ;EACI,oCAAA;A3Hk6jDZ;A2H95jDQ;EACI,oCAAA;A3Hg6jDZ;A2H55jDI;EACE,8BAAA;A3H85jDN;A2H35jDI;EACE,oCAAA;A3H65jDN;A2H15jDI;EACE,yBAAA;A3H45jDN;A2H35jDM;EACE,wBAAA;A3H65jDR;A2Hz5jDI;EACE,iCAAA;A3H25jDN;A2Hx5jDI;EACE,yBAAA;A3H05jDN;A2Hv5jDI;EACE,yDAAA;A3Hy5jDN;;A2Hh5jDE;EACE,qBAAA;A3Hm5jDJ;;A2H/4jDA;EACE,gBAAA;A3Hk5jDF;A2Hj5jDE;EACE,gBAAA;A3Hm5jDJ;;A2H34jDA;EACE,4BAAA;A3H84jDF;;A2H14jDE;EACE,yBAAA;A3H64jDJ;A2H14jDE;EACE,gCAAA;A3H44jDJ;A2Hz4jDE;EACE,oCAAA;EACA,gCAAA;A3H24jDJ;A2Hz4jDI;EACE,oCAAA;A3H24jDN;A2Hv4jDE;EACE,oCAAA;EACA,yBAAA;A3Hy4jDJ;A2Ht4jDE;EACE,iCAAA;A3Hw4jDJ;A2Hr4jDE;EACE,gCAAA;A3Hu4jDJ;;A2Hj4jDA;EACE,mDAAA;A3Ho4jDF;;A4Hv/jDE;EACE,qBAAA;A5H0/jDJ;;A4Ht/jDA;EACE,gBAAA;A5Hy/jDF;A4Hx/jDE;EACE,gBAAA;A5H0/jDJ;;A6HjgkDA,aAAA;AACA;EACE,iBAAA;EACA,0BAAA;EACA,gBjHiFS;EiHhFT,kBAAA;A7HogkDF;A6HlgkDE;EACE,eAAA;EACA,WAAA;A7HogkDJ;;A8H7gkDE;EACE,eAAA;EACA,iBAAA;A9HghkDJ;;A8HxgkDI;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;A9H2gkDN;A8HzgkDM;EAPF;IAQI,sBAAA;E9H4gkDN;AACF;A8H1gkDM;EACE,aAAA;EACA,YAAA;A9H4gkDR;A8HzgkDM;EACE,WAAA;A9H2gkDR;A8HzgkDQ;EACE,cAAA;EACA,oBAAA;EACA,clH4DC;EkH3DD,gBlH2BW;EkHzBX,yCAAA;A9H0gkDV;A8HtgkDM;EACE,kBAAA;EACA,YAAA;A9HwgkDR;A8HlgkDI;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,clH6DI;EkH5DJ,kBAAA;EACA,kBAAA;EACA,oBAAA;A9HogkDN;A8HhgkDM;EACE,yCAAA;EACA,clH8BG;AZo+jDX;A8HjgkDQ;EACE,yBlHkDA;EkHjDA,WlHoBC;AZ++jDX;A8H5/jDE;EACE,6BAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;A9H8/jDJ;A8H7/jDI;EACE,kBAAA;EACA,YAAA;A9H+/jDN;A8H7/jDI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;A9H+/jDN;A8Hz/jDE;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,WAAA;A9H2/jDJ;A8H1/jDI;EACI,cAAA;EACA,iBAAA;EACA,eAAA;A9H4/jDR;A8H3/jDU;EACE,qBAAA;EACA,eAAA;A9H6/jDZ;A8Hz/jDM;EACE,yBlHME;EkHLF,kBAAA;EACA,iBAAA;EACA,WlH1BG;AZqhkDX;A8Hv/jDQ;EACE,aAAA;EACA,yBlHHA;EkHIA,WlHjCC;EkHkCD,mBAAA;A9Hy/jDV;A8Hn/jDE;EACE,aAAA;EACA,eAAA;A9Hq/jDJ;A8Hj/jDM;EACE,sBAAA;A9Hm/jDR;A8Hj/jDQ;EACI,sBAAA;A9Hm/jDZ;A8H7+jDI;EACE,WAAA;A9H++jDN;A8H3+jDQ;EADJ;IAEM,UAAA;E9H8+jDR;AACF;A8H3+jDM;EACE,aAAA;A9H6+jDR;A8H5+jDQ;EAFF;IAGI,UAAA;IACA,kBAAA;E9H++jDR;AACF;A8H7+jDM;EACE,UAAA;A9H++jDR;;A+H7okDE;EACE,cAAA;A/HgpkDJ;A+H9okDE;EACE,uBAAA;A/HgpkDJ;A+H7okDI;EACE,yBnH8EK;EmH7EL,cnHmFK;EmHlFL,wCAAA;A/H+okDN;A+H9okDM;EACI,yBnHqGA;EmHpGA,qBnHoGA;EmHnGA,WnHsEC;EmHrED,6CAAA;A/HgpkDV;A+H7okDI;EACE,YAAA;A/H+okDN;A+H9okDM;EACE,QAAA;EACA,0BAAA;EACA,oBAAA;A/HgpkDR;A+H3okDI;EACE,eAAA;EACA,mBAAA;A/H6okDN;A+HzokDE;EACE,kBAAA;EACA,yBAAA;A/H2okDJ;A+HzokDI;EACE,mDAAA;A/H2okDN;A+HxokDI;EACE,qBAAA;EACA,iBAAA;EACA,kBAAA;A/H0okDN;A+HzokDM;EACE,+BAAA;EACA,oCAAA;EACA,sBnHmCG;EmHlCH,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,4BAAA;EACA,WAAA;EACA,wBAAA;A/H2okDR;A+HzokDM;EACE,cnHuBG;EmHtBH,qBAAA;EACA,eAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;A/H2okDR;A+HxokDI;EACE,eAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;A/H0okDN;A+HxokDM;EACE,aAAA;A/H0okDR;A+HtokDM;EACE,oBAAA;EACA,aAAA;A/HwokDR;A+HpokDM;EACE,gBAAA;EACA,kCAAA;EACA,gBAAA;A/HsokDR;A+HlokDM;EACE,yBnHhBG;EmHiBH,mBAAA;A/HookDR;A+HhokDM;EACE,yBnHME;EmHLF,qBnHKE;AZ6nkDV;A+HhokDM;EACE,WnH3BG;AZ6pkDX;A+H5nkDI;EACE,oBAAA;EACA,yBnHNI;AZookDV;A+H7nkDM;EACE,WnHrCG;AZoqkDX;A+H1nkDE;;;EAGI,mBnHhBI;EmHiBJ,qBnHjBI;EmHkBJ,WnH/CK;AZ2qkDX;A+H1nkDM;;;EACI,WnHlDC;AZgrkDX;;A+HxnkDE;EAEI;IACE,qBAAA;E/H0nkDN;AACF;;AgI7wkDA;EACE,yBAAA;AhIgxkDF;;AgI3wkDE;EACE,iBAAA;AhI8wkDJ;AgI5wkDI;EAHF;IAII,kBAAA;EhI+wkDJ;AACF;AgI5wkDI;EACE,kBAAA;EACA,eAAA;AhI8wkDN;;AgIvwkDI;EACE,aAAA;AhI0wkDN;;AgIpwkDE;EACE,eAAA;AhIuwkDJ;AgIpwkDE;EACE,gBAAA;AhIswkDJ;;AgI7vkDM;EACE,UAAA;EACA,UAAA;AhIgwkDR;AgI3vkDM;EACE,UAAA;EACA,YAAA;AhI6vkDR;AgIvvkDQ;EACE,kBAAA;EACA,mBAAA;AhIyvkDV;;AgIhvkDI;EACE,kBAAA;AhImvkDN;AgIlvkDM;EACE,kBAAA;AhIovkDR;AgInvkDQ;EACE,QAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,WpHKC;EoHJD,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,YAAA;EACA,yBpH0BA;AZ2tkDV;;AiI50kDE;EACE,kCrHg8BoC;EqH/7BpC,uBAAA;EACA,yBAAA;EACA,crHuFO;EqHtFP,sBrH4lB0B;EqH3lB1B,sBrH8EO;AZiwkDX;AiI90kDI;EACE,aAAA;EACA,sCrHy6BkC;AZu6iDxC;;AkI31kDA;EACI,2BAAA;AlI81kDJ;AkI71kDI;EACI,mDAAA;EACA,atHuFG;EsHtFH,gBAAA;AlI+1kDR;AkI71kDI;EACI,cAAA;AlI+1kDR;;AkI31kDA;;EAEI,mDAAA;AlI81kDJ;;AkI31kDA;EACI,gBtH2CiB;AZmzkDrB;;AkI31kDA;EACI,oBAAA;EACA,etH0Cc;AZozkDlB;;AkI31kDA;EACI,yBAAA;EACA,mDAAA;EACA,0BAAA;EACA,2BAAA;AlI81kDJ;;AkI31kDA;EACI,qBAAA;AlI81kDJ;;AkIz1kDI;;EACI,mDAAA;EACA,atHkDG;AZ2ykDX;;AmIx4kDA,eAAA;AACA;EACE,aAAA;AnI24kDF;;AmIx4kDA;EACE,iBAAA;EACA,uCAAA;EACA,YAAA;EACA,cvHgFS;EuH/ET,4CvHimB4B;EuHhmB5B,kBAAA;AnI24kDF;;AmIx4kDA;EACE,cvH8ES;EuH7ET,kBAAA;EACA,kBAAA;AnI24kDF;;AoI15kDA;EACE,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,oCAAA;EACA,4CxHsmB4B;EwHrmB5B,4BAAA;EACA,kBAAA;EACA,gCAAA;ApI65kDF;;AoI15kDA;EACE,yBAAA;EACA,0BAAA;EACA,4BAAA;EACA,mDAAA;EACA,2BAAA;ApI65kDF;;AqI56kDA;EACE,aAAA;EACA,mBzHoFS;EyHnFT,kBAAA;ArI+6kDF;;AqI56kDA;EACE,cAAA;EACA,kBAAA;EACA,WzH4ES;EyH3ET,eAAA;EACA,iBAAA;EACA,mBzHsGQ;EyHrGR,kBAAA;EACA,kBAAA;ArI+6kDF;;AqI56kDA;EACE,SAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;ArI+6kDF;AqI96kDE;EACE,aAAA;EACA,mCAAA;EACA,oCAAA;EACA,8BAAA;ArIg7kDJ;AqI96kDE;EACE,UAAA;EACA,mCAAA;EACA,oCAAA;EACA,iCAAA;ArIg7kDJ;;AsIl9kDA;EACI,YAAA;EACA,mB1H4FO;E0H3FP,c1HoFO;E0HnFP,wC1H4oB0B;E0H3oB1B,iB1HopB0B;E0HnpB1B,gBAAA;AtIq9kDJ;;AuI39kDA;EACI,aAAA;AvI89kDJ;AuI79kDI;EACI,WAAA;AvI+9kDR;;AwI/9kDA;EACI,mDAAA;EAEA,sBAAA;AxIi+kDJ;AwI/9kDQ;EACI,gBAAA;AxIi+kDZ;;AwIx9kDA;EACI,kBAAA;AxI29kDJ;AwI19kDI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,yB5H6DG;E4H5DH,SAAA;AxI49kDR;AwIz9kDI;EACI,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,sB5HmDG;E4HlDH,iBAAA;AxI29kDR;;AwIh9kDgB;EACI,sB5HsCT;AZ66kDX;AwIh9kDoB;EACI,yB5H+Dd;AZm5kDV;;AyInglDI;EACI,mBAAA;EACA,kBAAA;AzIsglDR;AyIpglDI;EACI,eAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,iBAAA;AzIsglDR;;AyIjglDA;EACI,cAAA;AzIoglDJ;AyIlglDQ;EACI,cAAA;EACA,iBAAA;EACA,c7HsED;AZ87kDX;AyIhglDY;EACI,c7HuFN;AZ26kDV;;AyIz/kDA;EACI,yBAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AzI4/kDJ;AyI1/kDI;EACI,4C7H4jBsB;AZg8jD9B;AyI1/kDQ;EACI,4BAAA;AzI4/kDZ;AyIz/kDQ;EACI,mBAAA;AzI2/kDZ;;AyIt/kDA;EACI,kBAAA;AzIy/kDJ;AyIv/kDI;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AzIy/kDR;;AyIr/kDA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AzIw/kDJ;AyIv/kDI;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,c7HUG;AZ++kDX;;AyIr/kDA;EACI,kBAAA;EACA,oBAAA;AzIw/kDJ;;AyIr/kDA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;AzIw/kDJ;;AyI/+kDQ;EACI,kBAAA;AzIk/kDZ;AyIj/kDY;EACI,yB7HlBL;AZqglDX;AyIh/kDY;EACI,WAAA;AzIk/kDhB;AyI5+kDI;EACI,aAAA;AzI8+kDR;;AyIz+kDI;EACI,gBAAA;AzI4+kDR;;AyIv+kDI;EACI,qBAAA;EACA,kBAAA;EACA,c7HvCG;E6HwCH,WAAA;EACA,yBAAA;EACA,kBAAA;AzI0+kDR;AyIx+kDQ;EACI,c7HvBF;E6HwBE,gCAAA;AzI0+kDZ;;AyIl+kDQ;EACI,c7HxDD;E6HyDC,gBAAA;EACA,eAAA;AzIq+kDZ;;AyI79kDA;EACI,yBAAA;EACA,sB7H1EO;E6H2EP,sB7Hkc0B;AZ8hkD9B;AyI/9kDI;EACI,yBAAA;EACA,YAAA;AzIi+kDR;AyI99kDI;EACI,wCAAA;EACA,oCAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AzIg+kDR;;AyIx9kDA;EACI,gBAAA;AzI29kDJ;AyI19kDI;EACI,gCAAA;AzI49kDR;;A0IxplDA;;oBAAA;AAGA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;A1I2plDF;;A0IxplDA;EACE,kBAAA;A1I2plDF;;A0IvplDE;EACE,c9HkFO;E8HjFP,gBAAA;A1I0plDJ;A0IxplDE;EACE,eAAA;A1I0plDJ;;A0ItplDA;EACE;IACE,WAAA;IACA,WAAA;E1IyplDF;E0IvplDA;IACE,SAAA;E1IyplDF;AACF;A0IpplDE;EACE,cAAA;EACA,c9H0DO;E8HzDP,iBAAA;EACA,gBAAA;A1IsplDJ;A0IrplDI;EACE,c9HiFI;E8HhFJ,gBAAA;A1IuplDN;;A0IlplDA;EACE,cAAA;EACA,eAAA;A1IqplDF;A0InplDE;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;A1IqplDJ;A0InplDI;EACE,c9HmCK;AZknlDX;A0IlplDI;EACE,mB9H4BK;E8H3BL,0BAAA;A1IoplDN;A0IjplDI;EACE,WAAA;EACA,kBAAA;A1ImplDN;A0IhplDI;EACE,YAAA;A1IkplDN;A0IhplDM;;;EAGE,cAAA;EACA,WAAA;A1IkplDR;A0I/olDM;EACE,6BAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;EACA,YAAA;A1IiplDR;A0I9olDM;EACE,wBAAA;A1IgplDR;A0I7olDM;EACE,gBAAA;EACA,gBAAA;A1I+olDR;A0I5olDM;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,QAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;A1I8olDR;A0I1olDI;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;A1I4olDN;A0I1olDM;;EAEE,kBAAA;EACA,MAAA;A1I4olDR;A0IzolDM;EACE,OAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;A1I2olDR;A0IxolDM;EACE,QAAA;EACA,YAAA;EACA,kBAAA;A1I0olDR;A0ItolDI;EAEE,iCAAA;A1IuolDN;A0InolDE;EACE,yB9HzDO;E8H0DP,gBAAA;EACA,+CAAA;A1IqolDJ;A0IpolDM;EACE,+CAAA;EACA,gBAAA;A1IsolDR;A0IholDE;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,mCAAA;EACA,kBAAA;A1IkolDJ;A0IholDI;EACE,UAAA;EACA,eAAA;A1IkolDN;A0IholDI;EACE,UAAA;A1IkolDN;A0I/nlDI;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,eAAA;EACA,UAAA;EACA,gBAAA;EACA,0BAAA;EACA,MAAA;A1IiolDN;A0IholDM;EACE,iBAAA;EACA,oCAAA;EACA,MAAA;EACA,YAAA;EACA,+CAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,eAAA;A1IkolDR;;A0I5nlDA;EACE;IACI,YAAA;E1I+nlDJ;AACF;A2Iz0lDE;EADF;IAEI,gBAAA;E3I40lDF;AACF;A2I10lDE;EALF;IAMI,gBAAA;E3I60lDF;AACF;;A2Ix0lDI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,yB/HsGI;E+HrGJ,kBAAA;EACA,QAAA;A3I20lDN;A2Iv0lDE;EACE,YAAA;EACA,gBAAA;EACA,eAAA;A3Iy0lDJ;;A2Ip0lDE;EACE,SAAA;A3Iu0lDJ;;A2In0lDA;EACE,SAAA;A3Is0lDF;A2Il0lDQ;EACE,2CAAA;EACA,yBAAA;A3Io0lDV;A2Ih0lDI;EACE,kBAAA;EACA,cAAA;EACA,c/H0CK;E+HzCL,oBAAA;EACA,aAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;A3Ik0lDN;A2Ih0lDM;EACE,2CAAA;EACA,yBAAA;A3Ik0lDR;A2I7zlDI;EACE,kBAAA;A3I+zlDN;A2I7zlDM;EACE,WAAA;EACA,YAAA;EACA,yB/HiBG;E+HhBH,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;A3I+zlDR;A2IzzlDQ;EACE,yB/HoCA;AZuxlDV;A2ItzlDQ;EACE,yB/H6BA;AZ2xlDV;A2IlzlDM;EACE,gB/HrCe;E+HsCf,c/HNG;AZ0zlDX;A2IhzlDI;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,SAAA;A3IkzlDN;;A2IzylDI;EACE,SAAA;A3I4ylDN;;A2IpylDI;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;A3IuylDN;A2IpylDI;EACE,4C/HgewB;E+H/dxB,yBAAA;A3IsylDN;;A2I/xlDG;EACC,WAAA;A3IkylDJ;A2I9xlDE;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;A3IgylDJ;A2I9xlDI;EACE,qBAAA;EACA,yB/HtEK;E+HuEL,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,mBAAA;A3IgylDN;A2I7xlDI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,yB/HpFK;E+HqFL,SAAA;A3I+xlDN;A2I7xlDI;EACE,eAAA;A3I+xlDN;A2I1xlDE;EACE,mBAAA;EACA,kBAAA;A3I4xlDJ;A2I1xlDI;EACE,aAAA;EACA,mBAAA;A3I4xlDN;A2IzxlDI;EACE,kBAAA;EACA,yCAAA;EACA,8BAAA;EACA,c/HtGK;E+HuGL,kBAAA;EACA,iBAAA;A3I2xlDN;A2IzxlDM;EACI,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,2CAAA;EACA,yCAAA;EACA,WAAA;EACA,MAAA;A3I2xlDV;A2IvxlDE;EACE,kBAAA;A3IyxlDJ;A2IrxlDM;EACI,eAAA;EACA,YAAA;EACA,c/H7HC;AZo5lDX;A2IrxlDU;EALJ;IAMQ,aAAA;E3IwxlDZ;AACF;A2InxlDE;EACI,eAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;A3IqxlDN;A2IjxlDE;EACE,qBAAA;EACA,kBAAA;A3ImxlDJ;A2IjxlDM;EACI,kBAAA;A3ImxlDV;A2IhxlDM;EACI,gBAAA;A3IkxlDV;A2I3wlDI;EACI,YAAA;EACA,iBAAA;A3I6wlDR;A2IzwlDY;EACI,QAAA;EACA,yB/H1KL;E+H2KK,iBAAA;EACA,8BAAA;EACA,cAAA;EACA,kBAAA;A3I2wlDhB;A2IzwlDgB;EACI,6BAAA;EACA,yB/HlLT;E+HmLS,0B/HnLT;E+HoLS,UAAA;EACA,YAAA;A3I2wlDpB;A2ItwlDQ;EACI,QAAA;A3IwwlDZ;;A2IlwlDA;EACE,6BAAA;A3IqwlDF;;A2IlwlDA;EACE,mBAAA;EACA,oCAAA;EACA,gCAAA;A3IqwlDF;;A2IhwlDE;EADF;IAEI,eAAA;E3IowlDF;AACF;;A4I3imDA;EACI,eAAA;EACA,gBhI4DmB;EgI3DnB,kBAAA;EACA,aAAA;A5I8imDJ;A4I7imDI;EACI,eAAA;EACA,gBhIwpBsB;EgIvpBtB,cAAA;EACA,gBAAA;A5I+imDR;;A4I3imDA;EACI,UAAA;A5I8imDJ;;A6I5jmDA,kDAAA;AAMQ;EACI,kBAAA;EACA,cAAA;A7I0jmDZ;A6IxjmDY;EACI,gBAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,gBAAA;EACA,cjIuEL;EiItEK,eAAA;A7I0jmDhB;A6IvjmDY;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,yBjIwDL;AZigmDX;A6ItjmDY;EACI,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yCAAA;EACA,iBAAA;EACA,mBAAA;A7IwjmDhB;;A6IhjmDA,gDAAA;AAEA;EACI,mBAAA;A7IkjmDJ;A6IjjmDI;EACI,+BAAA;EACA,kBAAA;EACA,0BAAA;A7ImjmDR;A6IjjmDQ;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBjIiBD;AZkimDX;A6I/imDQ;EACI,qBAAA;EACA,kBAAA;EACA,yCAAA;EACA,cjIsCF;EiIrCE,iBAAA;EACA,kBAAA;EACA,YAAA;A7IijmDZ;A6I9imDQ;EACI,iBAAA;A7IgjmDZ;;A8IjomDI;EACI,kBAAA;EACA,yBlImFG;EkIlFH,iBAAA;A9IoomDR;A8InomDQ;EACI,eAAA;EACA,sBAAA;A9IqomDZ;;A8I5nmDA;EACI,gBAAA;EACA,qBAAA;A9I+nmDJ;A8I5nmDQ;EACI,gBAAA;A9I8nmDZ;;AApomDE;EACE,aAAA;AAuomDJ;;AAnomDA;EACE,kBAAA;AAsomDF;;AApomDA;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AAuomDF;;AAromDA;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,sBAAA;EACA,yBAAA;EACA,qIAAA;AAwomDF;;AAtomDA;EACE,sBAAA;AAyomDF;;AAvomDA;EACE,uBAAA;EACA,SAAA;EACA,eAAA;EACA,wBAAA;EACA,0FAAA;EAEA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;AAyomDF;AAxomDE;EACE,aAAA;AA0omDJ;;AAvomDA;EACE,oCAAA;AA0omDF;;AAxomDA;EACE,yBAAA;EACA,aAAA;AA2omDF;;AAxomDA;EACE,kBAAA;EACA,aAAA;AA2omDF;;AAxomDA;EACE,sBAAA;AA2omDF;;AAvomDE;EACE,wBAAA;AA0omDJ;;AAjomDE;EACE,sBY2e0B;AZyplD9B;AoBpqmDI;EpB8BJ;IAMI,eAAA;IACA,mBAAA;IACA,UAAA;IACA,SAAA;EAoomDF;EAlomDE;IACE,qBAAA;IACA,WAAA;EAoomDJ;AACF","sourcesContent":["@import \"./icons.scss\";\r\n\r\n// Dark Theme\r\n// @import \"./bootstrap-dark.scss\";\r\n// @import \"./app-dark.scss\";\r\n\r\n// Light Theme\r\n@import \"./bootstrap.scss\";\r\n@import \"./app.scss\";\r\n\r\n// RTL Mode\r\n// @import \"./rtl/bootstrap-rtl\";\r\n// @import \"./rtl/components-rtl\";\r\n// @import \"./rtl/float-rtl\";\r\n// @import \"./rtl/general-rtl\";\r\n// @import \"./rtl/pages-rtl\";\r\n// @import \"./rtl/plugins-rtl\";\r\n// @import \"./rtl/spacing-rtl\";\r\n// @import \"./rtl/structure-rtl\";\r\n// @import \"./rtl/text-rtl\";\r\n\r\nbody {\r\n  * {\r\n    outline: none;\r\n  }\r\n}\r\n\r\n.react-bootstrap-table-page-btns-ul {\r\n  margin-bottom: 0px;\r\n}\r\n.pagination-bar {\r\n  display: flex;\r\n  padding-left: 0;\r\n  list-style: none;\r\n  justify-content: center;\r\n}\r\n.page-link {\r\n  padding:  10px 15px;\r\n  position: relative;\r\n  display: block;\r\n  color: #74788d;\r\n  background-color: #fff;\r\n  border: 1px solid #ced4da;\r\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\r\n}\r\n.page-link.active{\r\n  background-color: blue;\r\n}\r\n.close {\r\n  background: transparent;\r\n  border: 0;\r\n  font-size: 10px;\r\n  padding: 1.35rem 1.25rem;\r\n  background: transparent escape-svg($btn-close-bg-dark) center /\r\n    $btn-close-width auto no-repeat;\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  opacity: 0.5;\r\n  width: 1em;\r\n  height: 1em;\r\n  z-index: 2;\r\n  span {\r\n    display: none;\r\n  }\r\n}\r\n.rangeslider__fill {\r\n  background-color: #556ee6 !important;\r\n}\r\n.rdw-editor-main {\r\n  border: 1px solid $gray-300;\r\n  height: 239px;\r\n}\r\n\r\n.dz-message {\r\n  text-align: center;\r\n  margin: 2em 0;\r\n}\r\n//Crypto enteries\r\n.bs-select select {\r\n  width: auto !important;\r\n}\r\n\r\n.apexcharts-canvas {\r\n  text {\r\n    fill: #adb5bd !important;\r\n  }\r\n}\r\n\r\n//\r\n// Columns\r\n//\r\n\r\n.card-columns {\r\n  .card {\r\n    margin-bottom: $grid-gutter-width;\r\n  }\r\n\r\n  @include media-breakpoint-up(sm) {\r\n    column-count: 3;\r\n    column-gap: 1.25rem;\r\n    orphans: 1;\r\n    widows: 1;\r\n\r\n    .card {\r\n      display: inline-block; // Don't let them vertically span multiple columns\r\n      width: 100%; // Don't let their width change\r\n    }\r\n  }\r\n}\r\n","/*\r\nTemplate Name: Minible - Admin & Dashboard Template\r\nAuthor: Themesbrand\r\nVersion: 2.1.0\r\nWebsite: https://themesbrand.com/\r\nContact: themesbrand@gmail.com\r\nFile: Icons Css File\r\n*/\r\n\r\n// Plugins\r\n@import \"custom/plugins/icons\";","/* MaterialDesignIcons.com */\r\n@font-face {\r\n  font-family: \"Material Design Icons\";\r\n  src: url(\"../../../../fonts/materialdesignicons-webfont.eot?v=5.8.55\");\r\n  src: url(\"../../../../fonts/materialdesignicons-webfont.eot?#iefix&v=5.8.55\")\r\n      format(\"embedded-opentype\"),\r\n    url(\"../../../../fonts/materialdesignicons-webfont.woff2?v=5.8.55\")\r\n      format(\"woff2\"),\r\n    url(\"../../../../fonts/materialdesignicons-webfont.woff?v=5.8.55\")\r\n      format(\"woff\"),\r\n    url(\"../../../../fonts/materialdesignicons-webfont.ttf?v=5.8.55\")\r\n      format(\"truetype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n.mdi:before,\r\n.mdi-set {\r\n  display: inline-block;\r\n  font: normal normal normal 24px/1 \"Material Design Icons\";\r\n  font-size: inherit;\r\n  text-rendering: auto;\r\n  line-height: inherit;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n.mdi-ab-testing::before {\r\n  content: \"\\F01C9\";\r\n}\r\n\r\n.mdi-abjad-arabic::before {\r\n  content: \"\\F1328\";\r\n}\r\n\r\n.mdi-abjad-hebrew::before {\r\n  content: \"\\F1329\";\r\n}\r\n\r\n.mdi-abugida-devanagari::before {\r\n  content: \"\\F132A\";\r\n}\r\n\r\n.mdi-abugida-thai::before {\r\n  content: \"\\F132B\";\r\n}\r\n\r\n.mdi-access-point::before {\r\n  content: \"\\F0003\";\r\n}\r\n\r\n.mdi-access-point-check::before {\r\n  content: \"\\F1538\";\r\n}\r\n\r\n.mdi-access-point-minus::before {\r\n  content: \"\\F1539\";\r\n}\r\n\r\n.mdi-access-point-network::before {\r\n  content: \"\\F0002\";\r\n}\r\n\r\n.mdi-access-point-network-off::before {\r\n  content: \"\\F0BE1\";\r\n}\r\n\r\n.mdi-access-point-off::before {\r\n  content: \"\\F1511\";\r\n}\r\n\r\n.mdi-access-point-plus::before {\r\n  content: \"\\F153A\";\r\n}\r\n\r\n.mdi-access-point-remove::before {\r\n  content: \"\\F153B\";\r\n}\r\n\r\n.mdi-account::before {\r\n  content: \"\\F0004\";\r\n}\r\n\r\n.mdi-account-alert::before {\r\n  content: \"\\F0005\";\r\n}\r\n\r\n.mdi-account-alert-outline::before {\r\n  content: \"\\F0B50\";\r\n}\r\n\r\n.mdi-account-arrow-left::before {\r\n  content: \"\\F0B51\";\r\n}\r\n\r\n.mdi-account-arrow-left-outline::before {\r\n  content: \"\\F0B52\";\r\n}\r\n\r\n.mdi-account-arrow-right::before {\r\n  content: \"\\F0B53\";\r\n}\r\n\r\n.mdi-account-arrow-right-outline::before {\r\n  content: \"\\F0B54\";\r\n}\r\n\r\n.mdi-account-box::before {\r\n  content: \"\\F0006\";\r\n}\r\n\r\n.mdi-account-box-multiple::before {\r\n  content: \"\\F0934\";\r\n}\r\n\r\n.mdi-account-box-multiple-outline::before {\r\n  content: \"\\F100A\";\r\n}\r\n\r\n.mdi-account-box-outline::before {\r\n  content: \"\\F0007\";\r\n}\r\n\r\n.mdi-account-cancel::before {\r\n  content: \"\\F12DF\";\r\n}\r\n\r\n.mdi-account-cancel-outline::before {\r\n  content: \"\\F12E0\";\r\n}\r\n\r\n.mdi-account-cash::before {\r\n  content: \"\\F1097\";\r\n}\r\n\r\n.mdi-account-cash-outline::before {\r\n  content: \"\\F1098\";\r\n}\r\n\r\n.mdi-account-check::before {\r\n  content: \"\\F0008\";\r\n}\r\n\r\n.mdi-account-check-outline::before {\r\n  content: \"\\F0BE2\";\r\n}\r\n\r\n.mdi-account-child::before {\r\n  content: \"\\F0A89\";\r\n}\r\n\r\n.mdi-account-child-circle::before {\r\n  content: \"\\F0A8A\";\r\n}\r\n\r\n.mdi-account-child-outline::before {\r\n  content: \"\\F10C8\";\r\n}\r\n\r\n.mdi-account-circle::before {\r\n  content: \"\\F0009\";\r\n}\r\n\r\n.mdi-account-circle-outline::before {\r\n  content: \"\\F0B55\";\r\n}\r\n\r\n.mdi-account-clock::before {\r\n  content: \"\\F0B56\";\r\n}\r\n\r\n.mdi-account-clock-outline::before {\r\n  content: \"\\F0B57\";\r\n}\r\n\r\n.mdi-account-cog::before {\r\n  content: \"\\F1370\";\r\n}\r\n\r\n.mdi-account-cog-outline::before {\r\n  content: \"\\F1371\";\r\n}\r\n\r\n.mdi-account-convert::before {\r\n  content: \"\\F000A\";\r\n}\r\n\r\n.mdi-account-convert-outline::before {\r\n  content: \"\\F1301\";\r\n}\r\n\r\n.mdi-account-cowboy-hat::before {\r\n  content: \"\\F0E9B\";\r\n}\r\n\r\n.mdi-account-details::before {\r\n  content: \"\\F0631\";\r\n}\r\n\r\n.mdi-account-details-outline::before {\r\n  content: \"\\F1372\";\r\n}\r\n\r\n.mdi-account-edit::before {\r\n  content: \"\\F06BC\";\r\n}\r\n\r\n.mdi-account-edit-outline::before {\r\n  content: \"\\F0FFB\";\r\n}\r\n\r\n.mdi-account-group::before {\r\n  content: \"\\F0849\";\r\n}\r\n\r\n.mdi-account-group-outline::before {\r\n  content: \"\\F0B58\";\r\n}\r\n\r\n.mdi-account-hard-hat::before {\r\n  content: \"\\F05B5\";\r\n}\r\n\r\n.mdi-account-heart::before {\r\n  content: \"\\F0899\";\r\n}\r\n\r\n.mdi-account-heart-outline::before {\r\n  content: \"\\F0BE3\";\r\n}\r\n\r\n.mdi-account-key::before {\r\n  content: \"\\F000B\";\r\n}\r\n\r\n.mdi-account-key-outline::before {\r\n  content: \"\\F0BE4\";\r\n}\r\n\r\n.mdi-account-lock::before {\r\n  content: \"\\F115E\";\r\n}\r\n\r\n.mdi-account-lock-outline::before {\r\n  content: \"\\F115F\";\r\n}\r\n\r\n.mdi-account-minus::before {\r\n  content: \"\\F000D\";\r\n}\r\n\r\n.mdi-account-minus-outline::before {\r\n  content: \"\\F0AEC\";\r\n}\r\n\r\n.mdi-account-multiple::before {\r\n  content: \"\\F000E\";\r\n}\r\n\r\n.mdi-account-multiple-check::before {\r\n  content: \"\\F08C5\";\r\n}\r\n\r\n.mdi-account-multiple-check-outline::before {\r\n  content: \"\\F11FE\";\r\n}\r\n\r\n.mdi-account-multiple-minus::before {\r\n  content: \"\\F05D3\";\r\n}\r\n\r\n.mdi-account-multiple-minus-outline::before {\r\n  content: \"\\F0BE5\";\r\n}\r\n\r\n.mdi-account-multiple-outline::before {\r\n  content: \"\\F000F\";\r\n}\r\n\r\n.mdi-account-multiple-plus::before {\r\n  content: \"\\F0010\";\r\n}\r\n\r\n.mdi-account-multiple-plus-outline::before {\r\n  content: \"\\F0800\";\r\n}\r\n\r\n.mdi-account-multiple-remove::before {\r\n  content: \"\\F120A\";\r\n}\r\n\r\n.mdi-account-multiple-remove-outline::before {\r\n  content: \"\\F120B\";\r\n}\r\n\r\n.mdi-account-music::before {\r\n  content: \"\\F0803\";\r\n}\r\n\r\n.mdi-account-music-outline::before {\r\n  content: \"\\F0CE9\";\r\n}\r\n\r\n.mdi-account-network::before {\r\n  content: \"\\F0011\";\r\n}\r\n\r\n.mdi-account-network-outline::before {\r\n  content: \"\\F0BE6\";\r\n}\r\n\r\n.mdi-account-off::before {\r\n  content: \"\\F0012\";\r\n}\r\n\r\n.mdi-account-off-outline::before {\r\n  content: \"\\F0BE7\";\r\n}\r\n\r\n.mdi-account-outline::before {\r\n  content: \"\\F0013\";\r\n}\r\n\r\n.mdi-account-plus::before {\r\n  content: \"\\F0014\";\r\n}\r\n\r\n.mdi-account-plus-outline::before {\r\n  content: \"\\F0801\";\r\n}\r\n\r\n.mdi-account-question::before {\r\n  content: \"\\F0B59\";\r\n}\r\n\r\n.mdi-account-question-outline::before {\r\n  content: \"\\F0B5A\";\r\n}\r\n\r\n.mdi-account-reactivate::before {\r\n  content: \"\\F152B\";\r\n}\r\n\r\n.mdi-account-reactivate-outline::before {\r\n  content: \"\\F152C\";\r\n}\r\n\r\n.mdi-account-remove::before {\r\n  content: \"\\F0015\";\r\n}\r\n\r\n.mdi-account-remove-outline::before {\r\n  content: \"\\F0AED\";\r\n}\r\n\r\n.mdi-account-search::before {\r\n  content: \"\\F0016\";\r\n}\r\n\r\n.mdi-account-search-outline::before {\r\n  content: \"\\F0935\";\r\n}\r\n\r\n.mdi-account-settings::before {\r\n  content: \"\\F0630\";\r\n}\r\n\r\n.mdi-account-settings-outline::before {\r\n  content: \"\\F10C9\";\r\n}\r\n\r\n.mdi-account-star::before {\r\n  content: \"\\F0017\";\r\n}\r\n\r\n.mdi-account-star-outline::before {\r\n  content: \"\\F0BE8\";\r\n}\r\n\r\n.mdi-account-supervisor::before {\r\n  content: \"\\F0A8B\";\r\n}\r\n\r\n.mdi-account-supervisor-circle::before {\r\n  content: \"\\F0A8C\";\r\n}\r\n\r\n.mdi-account-supervisor-circle-outline::before {\r\n  content: \"\\F14EC\";\r\n}\r\n\r\n.mdi-account-supervisor-outline::before {\r\n  content: \"\\F112D\";\r\n}\r\n\r\n.mdi-account-switch::before {\r\n  content: \"\\F0019\";\r\n}\r\n\r\n.mdi-account-switch-outline::before {\r\n  content: \"\\F04CB\";\r\n}\r\n\r\n.mdi-account-tie::before {\r\n  content: \"\\F0CE3\";\r\n}\r\n\r\n.mdi-account-tie-outline::before {\r\n  content: \"\\F10CA\";\r\n}\r\n\r\n.mdi-account-tie-voice::before {\r\n  content: \"\\F1308\";\r\n}\r\n\r\n.mdi-account-tie-voice-off::before {\r\n  content: \"\\F130A\";\r\n}\r\n\r\n.mdi-account-tie-voice-off-outline::before {\r\n  content: \"\\F130B\";\r\n}\r\n\r\n.mdi-account-tie-voice-outline::before {\r\n  content: \"\\F1309\";\r\n}\r\n\r\n.mdi-account-voice::before {\r\n  content: \"\\F05CB\";\r\n}\r\n\r\n.mdi-adjust::before {\r\n  content: \"\\F001A\";\r\n}\r\n\r\n.mdi-adobe::before {\r\n  content: \"\\F0936\";\r\n}\r\n\r\n.mdi-adobe-acrobat::before {\r\n  content: \"\\F0F9D\";\r\n}\r\n\r\n.mdi-air-conditioner::before {\r\n  content: \"\\F001B\";\r\n}\r\n\r\n.mdi-air-filter::before {\r\n  content: \"\\F0D43\";\r\n}\r\n\r\n.mdi-air-horn::before {\r\n  content: \"\\F0DAC\";\r\n}\r\n\r\n.mdi-air-humidifier::before {\r\n  content: \"\\F1099\";\r\n}\r\n\r\n.mdi-air-humidifier-off::before {\r\n  content: \"\\F1466\";\r\n}\r\n\r\n.mdi-air-purifier::before {\r\n  content: \"\\F0D44\";\r\n}\r\n\r\n.mdi-airbag::before {\r\n  content: \"\\F0BE9\";\r\n}\r\n\r\n.mdi-airballoon::before {\r\n  content: \"\\F001C\";\r\n}\r\n\r\n.mdi-airballoon-outline::before {\r\n  content: \"\\F100B\";\r\n}\r\n\r\n.mdi-airplane::before {\r\n  content: \"\\F001D\";\r\n}\r\n\r\n.mdi-airplane-landing::before {\r\n  content: \"\\F05D4\";\r\n}\r\n\r\n.mdi-airplane-off::before {\r\n  content: \"\\F001E\";\r\n}\r\n\r\n.mdi-airplane-takeoff::before {\r\n  content: \"\\F05D5\";\r\n}\r\n\r\n.mdi-airport::before {\r\n  content: \"\\F084B\";\r\n}\r\n\r\n.mdi-alarm::before {\r\n  content: \"\\F0020\";\r\n}\r\n\r\n.mdi-alarm-bell::before {\r\n  content: \"\\F078E\";\r\n}\r\n\r\n.mdi-alarm-check::before {\r\n  content: \"\\F0021\";\r\n}\r\n\r\n.mdi-alarm-light::before {\r\n  content: \"\\F078F\";\r\n}\r\n\r\n.mdi-alarm-light-outline::before {\r\n  content: \"\\F0BEA\";\r\n}\r\n\r\n.mdi-alarm-multiple::before {\r\n  content: \"\\F0022\";\r\n}\r\n\r\n.mdi-alarm-note::before {\r\n  content: \"\\F0E71\";\r\n}\r\n\r\n.mdi-alarm-note-off::before {\r\n  content: \"\\F0E72\";\r\n}\r\n\r\n.mdi-alarm-off::before {\r\n  content: \"\\F0023\";\r\n}\r\n\r\n.mdi-alarm-panel::before {\r\n  content: \"\\F15C4\";\r\n}\r\n\r\n.mdi-alarm-panel-outline::before {\r\n  content: \"\\F15C5\";\r\n}\r\n\r\n.mdi-alarm-plus::before {\r\n  content: \"\\F0024\";\r\n}\r\n\r\n.mdi-alarm-snooze::before {\r\n  content: \"\\F068E\";\r\n}\r\n\r\n.mdi-album::before {\r\n  content: \"\\F0025\";\r\n}\r\n\r\n.mdi-alert::before {\r\n  content: \"\\F0026\";\r\n}\r\n\r\n.mdi-alert-box::before {\r\n  content: \"\\F0027\";\r\n}\r\n\r\n.mdi-alert-box-outline::before {\r\n  content: \"\\F0CE4\";\r\n}\r\n\r\n.mdi-alert-circle::before {\r\n  content: \"\\F0028\";\r\n}\r\n\r\n.mdi-alert-circle-check::before {\r\n  content: \"\\F11ED\";\r\n}\r\n\r\n.mdi-alert-circle-check-outline::before {\r\n  content: \"\\F11EE\";\r\n}\r\n\r\n.mdi-alert-circle-outline::before {\r\n  content: \"\\F05D6\";\r\n}\r\n\r\n.mdi-alert-decagram::before {\r\n  content: \"\\F06BD\";\r\n}\r\n\r\n.mdi-alert-decagram-outline::before {\r\n  content: \"\\F0CE5\";\r\n}\r\n\r\n.mdi-alert-minus::before {\r\n  content: \"\\F14BB\";\r\n}\r\n\r\n.mdi-alert-minus-outline::before {\r\n  content: \"\\F14BE\";\r\n}\r\n\r\n.mdi-alert-octagon::before {\r\n  content: \"\\F0029\";\r\n}\r\n\r\n.mdi-alert-octagon-outline::before {\r\n  content: \"\\F0CE6\";\r\n}\r\n\r\n.mdi-alert-octagram::before {\r\n  content: \"\\F0767\";\r\n}\r\n\r\n.mdi-alert-octagram-outline::before {\r\n  content: \"\\F0CE7\";\r\n}\r\n\r\n.mdi-alert-outline::before {\r\n  content: \"\\F002A\";\r\n}\r\n\r\n.mdi-alert-plus::before {\r\n  content: \"\\F14BA\";\r\n}\r\n\r\n.mdi-alert-plus-outline::before {\r\n  content: \"\\F14BD\";\r\n}\r\n\r\n.mdi-alert-remove::before {\r\n  content: \"\\F14BC\";\r\n}\r\n\r\n.mdi-alert-remove-outline::before {\r\n  content: \"\\F14BF\";\r\n}\r\n\r\n.mdi-alert-rhombus::before {\r\n  content: \"\\F11CE\";\r\n}\r\n\r\n.mdi-alert-rhombus-outline::before {\r\n  content: \"\\F11CF\";\r\n}\r\n\r\n.mdi-alien::before {\r\n  content: \"\\F089A\";\r\n}\r\n\r\n.mdi-alien-outline::before {\r\n  content: \"\\F10CB\";\r\n}\r\n\r\n.mdi-align-horizontal-center::before {\r\n  content: \"\\F11C3\";\r\n}\r\n\r\n.mdi-align-horizontal-left::before {\r\n  content: \"\\F11C2\";\r\n}\r\n\r\n.mdi-align-horizontal-right::before {\r\n  content: \"\\F11C4\";\r\n}\r\n\r\n.mdi-align-vertical-bottom::before {\r\n  content: \"\\F11C5\";\r\n}\r\n\r\n.mdi-align-vertical-center::before {\r\n  content: \"\\F11C6\";\r\n}\r\n\r\n.mdi-align-vertical-top::before {\r\n  content: \"\\F11C7\";\r\n}\r\n\r\n.mdi-all-inclusive::before {\r\n  content: \"\\F06BE\";\r\n}\r\n\r\n.mdi-allergy::before {\r\n  content: \"\\F1258\";\r\n}\r\n\r\n.mdi-alpha::before {\r\n  content: \"\\F002B\";\r\n}\r\n\r\n.mdi-alpha-a::before {\r\n  content: \"\\F0AEE\";\r\n}\r\n\r\n.mdi-alpha-a-box::before {\r\n  content: \"\\F0B08\";\r\n}\r\n\r\n.mdi-alpha-a-box-outline::before {\r\n  content: \"\\F0BEB\";\r\n}\r\n\r\n.mdi-alpha-a-circle::before {\r\n  content: \"\\F0BEC\";\r\n}\r\n\r\n.mdi-alpha-a-circle-outline::before {\r\n  content: \"\\F0BED\";\r\n}\r\n\r\n.mdi-alpha-b::before {\r\n  content: \"\\F0AEF\";\r\n}\r\n\r\n.mdi-alpha-b-box::before {\r\n  content: \"\\F0B09\";\r\n}\r\n\r\n.mdi-alpha-b-box-outline::before {\r\n  content: \"\\F0BEE\";\r\n}\r\n\r\n.mdi-alpha-b-circle::before {\r\n  content: \"\\F0BEF\";\r\n}\r\n\r\n.mdi-alpha-b-circle-outline::before {\r\n  content: \"\\F0BF0\";\r\n}\r\n\r\n.mdi-alpha-c::before {\r\n  content: \"\\F0AF0\";\r\n}\r\n\r\n.mdi-alpha-c-box::before {\r\n  content: \"\\F0B0A\";\r\n}\r\n\r\n.mdi-alpha-c-box-outline::before {\r\n  content: \"\\F0BF1\";\r\n}\r\n\r\n.mdi-alpha-c-circle::before {\r\n  content: \"\\F0BF2\";\r\n}\r\n\r\n.mdi-alpha-c-circle-outline::before {\r\n  content: \"\\F0BF3\";\r\n}\r\n\r\n.mdi-alpha-d::before {\r\n  content: \"\\F0AF1\";\r\n}\r\n\r\n.mdi-alpha-d-box::before {\r\n  content: \"\\F0B0B\";\r\n}\r\n\r\n.mdi-alpha-d-box-outline::before {\r\n  content: \"\\F0BF4\";\r\n}\r\n\r\n.mdi-alpha-d-circle::before {\r\n  content: \"\\F0BF5\";\r\n}\r\n\r\n.mdi-alpha-d-circle-outline::before {\r\n  content: \"\\F0BF6\";\r\n}\r\n\r\n.mdi-alpha-e::before {\r\n  content: \"\\F0AF2\";\r\n}\r\n\r\n.mdi-alpha-e-box::before {\r\n  content: \"\\F0B0C\";\r\n}\r\n\r\n.mdi-alpha-e-box-outline::before {\r\n  content: \"\\F0BF7\";\r\n}\r\n\r\n.mdi-alpha-e-circle::before {\r\n  content: \"\\F0BF8\";\r\n}\r\n\r\n.mdi-alpha-e-circle-outline::before {\r\n  content: \"\\F0BF9\";\r\n}\r\n\r\n.mdi-alpha-f::before {\r\n  content: \"\\F0AF3\";\r\n}\r\n\r\n.mdi-alpha-f-box::before {\r\n  content: \"\\F0B0D\";\r\n}\r\n\r\n.mdi-alpha-f-box-outline::before {\r\n  content: \"\\F0BFA\";\r\n}\r\n\r\n.mdi-alpha-f-circle::before {\r\n  content: \"\\F0BFB\";\r\n}\r\n\r\n.mdi-alpha-f-circle-outline::before {\r\n  content: \"\\F0BFC\";\r\n}\r\n\r\n.mdi-alpha-g::before {\r\n  content: \"\\F0AF4\";\r\n}\r\n\r\n.mdi-alpha-g-box::before {\r\n  content: \"\\F0B0E\";\r\n}\r\n\r\n.mdi-alpha-g-box-outline::before {\r\n  content: \"\\F0BFD\";\r\n}\r\n\r\n.mdi-alpha-g-circle::before {\r\n  content: \"\\F0BFE\";\r\n}\r\n\r\n.mdi-alpha-g-circle-outline::before {\r\n  content: \"\\F0BFF\";\r\n}\r\n\r\n.mdi-alpha-h::before {\r\n  content: \"\\F0AF5\";\r\n}\r\n\r\n.mdi-alpha-h-box::before {\r\n  content: \"\\F0B0F\";\r\n}\r\n\r\n.mdi-alpha-h-box-outline::before {\r\n  content: \"\\F0C00\";\r\n}\r\n\r\n.mdi-alpha-h-circle::before {\r\n  content: \"\\F0C01\";\r\n}\r\n\r\n.mdi-alpha-h-circle-outline::before {\r\n  content: \"\\F0C02\";\r\n}\r\n\r\n.mdi-alpha-i::before {\r\n  content: \"\\F0AF6\";\r\n}\r\n\r\n.mdi-alpha-i-box::before {\r\n  content: \"\\F0B10\";\r\n}\r\n\r\n.mdi-alpha-i-box-outline::before {\r\n  content: \"\\F0C03\";\r\n}\r\n\r\n.mdi-alpha-i-circle::before {\r\n  content: \"\\F0C04\";\r\n}\r\n\r\n.mdi-alpha-i-circle-outline::before {\r\n  content: \"\\F0C05\";\r\n}\r\n\r\n.mdi-alpha-j::before {\r\n  content: \"\\F0AF7\";\r\n}\r\n\r\n.mdi-alpha-j-box::before {\r\n  content: \"\\F0B11\";\r\n}\r\n\r\n.mdi-alpha-j-box-outline::before {\r\n  content: \"\\F0C06\";\r\n}\r\n\r\n.mdi-alpha-j-circle::before {\r\n  content: \"\\F0C07\";\r\n}\r\n\r\n.mdi-alpha-j-circle-outline::before {\r\n  content: \"\\F0C08\";\r\n}\r\n\r\n.mdi-alpha-k::before {\r\n  content: \"\\F0AF8\";\r\n}\r\n\r\n.mdi-alpha-k-box::before {\r\n  content: \"\\F0B12\";\r\n}\r\n\r\n.mdi-alpha-k-box-outline::before {\r\n  content: \"\\F0C09\";\r\n}\r\n\r\n.mdi-alpha-k-circle::before {\r\n  content: \"\\F0C0A\";\r\n}\r\n\r\n.mdi-alpha-k-circle-outline::before {\r\n  content: \"\\F0C0B\";\r\n}\r\n\r\n.mdi-alpha-l::before {\r\n  content: \"\\F0AF9\";\r\n}\r\n\r\n.mdi-alpha-l-box::before {\r\n  content: \"\\F0B13\";\r\n}\r\n\r\n.mdi-alpha-l-box-outline::before {\r\n  content: \"\\F0C0C\";\r\n}\r\n\r\n.mdi-alpha-l-circle::before {\r\n  content: \"\\F0C0D\";\r\n}\r\n\r\n.mdi-alpha-l-circle-outline::before {\r\n  content: \"\\F0C0E\";\r\n}\r\n\r\n.mdi-alpha-m::before {\r\n  content: \"\\F0AFA\";\r\n}\r\n\r\n.mdi-alpha-m-box::before {\r\n  content: \"\\F0B14\";\r\n}\r\n\r\n.mdi-alpha-m-box-outline::before {\r\n  content: \"\\F0C0F\";\r\n}\r\n\r\n.mdi-alpha-m-circle::before {\r\n  content: \"\\F0C10\";\r\n}\r\n\r\n.mdi-alpha-m-circle-outline::before {\r\n  content: \"\\F0C11\";\r\n}\r\n\r\n.mdi-alpha-n::before {\r\n  content: \"\\F0AFB\";\r\n}\r\n\r\n.mdi-alpha-n-box::before {\r\n  content: \"\\F0B15\";\r\n}\r\n\r\n.mdi-alpha-n-box-outline::before {\r\n  content: \"\\F0C12\";\r\n}\r\n\r\n.mdi-alpha-n-circle::before {\r\n  content: \"\\F0C13\";\r\n}\r\n\r\n.mdi-alpha-n-circle-outline::before {\r\n  content: \"\\F0C14\";\r\n}\r\n\r\n.mdi-alpha-o::before {\r\n  content: \"\\F0AFC\";\r\n}\r\n\r\n.mdi-alpha-o-box::before {\r\n  content: \"\\F0B16\";\r\n}\r\n\r\n.mdi-alpha-o-box-outline::before {\r\n  content: \"\\F0C15\";\r\n}\r\n\r\n.mdi-alpha-o-circle::before {\r\n  content: \"\\F0C16\";\r\n}\r\n\r\n.mdi-alpha-o-circle-outline::before {\r\n  content: \"\\F0C17\";\r\n}\r\n\r\n.mdi-alpha-p::before {\r\n  content: \"\\F0AFD\";\r\n}\r\n\r\n.mdi-alpha-p-box::before {\r\n  content: \"\\F0B17\";\r\n}\r\n\r\n.mdi-alpha-p-box-outline::before {\r\n  content: \"\\F0C18\";\r\n}\r\n\r\n.mdi-alpha-p-circle::before {\r\n  content: \"\\F0C19\";\r\n}\r\n\r\n.mdi-alpha-p-circle-outline::before {\r\n  content: \"\\F0C1A\";\r\n}\r\n\r\n.mdi-alpha-q::before {\r\n  content: \"\\F0AFE\";\r\n}\r\n\r\n.mdi-alpha-q-box::before {\r\n  content: \"\\F0B18\";\r\n}\r\n\r\n.mdi-alpha-q-box-outline::before {\r\n  content: \"\\F0C1B\";\r\n}\r\n\r\n.mdi-alpha-q-circle::before {\r\n  content: \"\\F0C1C\";\r\n}\r\n\r\n.mdi-alpha-q-circle-outline::before {\r\n  content: \"\\F0C1D\";\r\n}\r\n\r\n.mdi-alpha-r::before {\r\n  content: \"\\F0AFF\";\r\n}\r\n\r\n.mdi-alpha-r-box::before {\r\n  content: \"\\F0B19\";\r\n}\r\n\r\n.mdi-alpha-r-box-outline::before {\r\n  content: \"\\F0C1E\";\r\n}\r\n\r\n.mdi-alpha-r-circle::before {\r\n  content: \"\\F0C1F\";\r\n}\r\n\r\n.mdi-alpha-r-circle-outline::before {\r\n  content: \"\\F0C20\";\r\n}\r\n\r\n.mdi-alpha-s::before {\r\n  content: \"\\F0B00\";\r\n}\r\n\r\n.mdi-alpha-s-box::before {\r\n  content: \"\\F0B1A\";\r\n}\r\n\r\n.mdi-alpha-s-box-outline::before {\r\n  content: \"\\F0C21\";\r\n}\r\n\r\n.mdi-alpha-s-circle::before {\r\n  content: \"\\F0C22\";\r\n}\r\n\r\n.mdi-alpha-s-circle-outline::before {\r\n  content: \"\\F0C23\";\r\n}\r\n\r\n.mdi-alpha-t::before {\r\n  content: \"\\F0B01\";\r\n}\r\n\r\n.mdi-alpha-t-box::before {\r\n  content: \"\\F0B1B\";\r\n}\r\n\r\n.mdi-alpha-t-box-outline::before {\r\n  content: \"\\F0C24\";\r\n}\r\n\r\n.mdi-alpha-t-circle::before {\r\n  content: \"\\F0C25\";\r\n}\r\n\r\n.mdi-alpha-t-circle-outline::before {\r\n  content: \"\\F0C26\";\r\n}\r\n\r\n.mdi-alpha-u::before {\r\n  content: \"\\F0B02\";\r\n}\r\n\r\n.mdi-alpha-u-box::before {\r\n  content: \"\\F0B1C\";\r\n}\r\n\r\n.mdi-alpha-u-box-outline::before {\r\n  content: \"\\F0C27\";\r\n}\r\n\r\n.mdi-alpha-u-circle::before {\r\n  content: \"\\F0C28\";\r\n}\r\n\r\n.mdi-alpha-u-circle-outline::before {\r\n  content: \"\\F0C29\";\r\n}\r\n\r\n.mdi-alpha-v::before {\r\n  content: \"\\F0B03\";\r\n}\r\n\r\n.mdi-alpha-v-box::before {\r\n  content: \"\\F0B1D\";\r\n}\r\n\r\n.mdi-alpha-v-box-outline::before {\r\n  content: \"\\F0C2A\";\r\n}\r\n\r\n.mdi-alpha-v-circle::before {\r\n  content: \"\\F0C2B\";\r\n}\r\n\r\n.mdi-alpha-v-circle-outline::before {\r\n  content: \"\\F0C2C\";\r\n}\r\n\r\n.mdi-alpha-w::before {\r\n  content: \"\\F0B04\";\r\n}\r\n\r\n.mdi-alpha-w-box::before {\r\n  content: \"\\F0B1E\";\r\n}\r\n\r\n.mdi-alpha-w-box-outline::before {\r\n  content: \"\\F0C2D\";\r\n}\r\n\r\n.mdi-alpha-w-circle::before {\r\n  content: \"\\F0C2E\";\r\n}\r\n\r\n.mdi-alpha-w-circle-outline::before {\r\n  content: \"\\F0C2F\";\r\n}\r\n\r\n.mdi-alpha-x::before {\r\n  content: \"\\F0B05\";\r\n}\r\n\r\n.mdi-alpha-x-box::before {\r\n  content: \"\\F0B1F\";\r\n}\r\n\r\n.mdi-alpha-x-box-outline::before {\r\n  content: \"\\F0C30\";\r\n}\r\n\r\n.mdi-alpha-x-circle::before {\r\n  content: \"\\F0C31\";\r\n}\r\n\r\n.mdi-alpha-x-circle-outline::before {\r\n  content: \"\\F0C32\";\r\n}\r\n\r\n.mdi-alpha-y::before {\r\n  content: \"\\F0B06\";\r\n}\r\n\r\n.mdi-alpha-y-box::before {\r\n  content: \"\\F0B20\";\r\n}\r\n\r\n.mdi-alpha-y-box-outline::before {\r\n  content: \"\\F0C33\";\r\n}\r\n\r\n.mdi-alpha-y-circle::before {\r\n  content: \"\\F0C34\";\r\n}\r\n\r\n.mdi-alpha-y-circle-outline::before {\r\n  content: \"\\F0C35\";\r\n}\r\n\r\n.mdi-alpha-z::before {\r\n  content: \"\\F0B07\";\r\n}\r\n\r\n.mdi-alpha-z-box::before {\r\n  content: \"\\F0B21\";\r\n}\r\n\r\n.mdi-alpha-z-box-outline::before {\r\n  content: \"\\F0C36\";\r\n}\r\n\r\n.mdi-alpha-z-circle::before {\r\n  content: \"\\F0C37\";\r\n}\r\n\r\n.mdi-alpha-z-circle-outline::before {\r\n  content: \"\\F0C38\";\r\n}\r\n\r\n.mdi-alphabet-aurebesh::before {\r\n  content: \"\\F132C\";\r\n}\r\n\r\n.mdi-alphabet-cyrillic::before {\r\n  content: \"\\F132D\";\r\n}\r\n\r\n.mdi-alphabet-greek::before {\r\n  content: \"\\F132E\";\r\n}\r\n\r\n.mdi-alphabet-latin::before {\r\n  content: \"\\F132F\";\r\n}\r\n\r\n.mdi-alphabet-piqad::before {\r\n  content: \"\\F1330\";\r\n}\r\n\r\n.mdi-alphabet-tengwar::before {\r\n  content: \"\\F1337\";\r\n}\r\n\r\n.mdi-alphabetical::before {\r\n  content: \"\\F002C\";\r\n}\r\n\r\n.mdi-alphabetical-off::before {\r\n  content: \"\\F100C\";\r\n}\r\n\r\n.mdi-alphabetical-variant::before {\r\n  content: \"\\F100D\";\r\n}\r\n\r\n.mdi-alphabetical-variant-off::before {\r\n  content: \"\\F100E\";\r\n}\r\n\r\n.mdi-altimeter::before {\r\n  content: \"\\F05D7\";\r\n}\r\n\r\n.mdi-amazon::before {\r\n  content: \"\\F002D\";\r\n}\r\n\r\n.mdi-amazon-alexa::before {\r\n  content: \"\\F08C6\";\r\n}\r\n\r\n.mdi-ambulance::before {\r\n  content: \"\\F002F\";\r\n}\r\n\r\n.mdi-ammunition::before {\r\n  content: \"\\F0CE8\";\r\n}\r\n\r\n.mdi-ampersand::before {\r\n  content: \"\\F0A8D\";\r\n}\r\n\r\n.mdi-amplifier::before {\r\n  content: \"\\F0030\";\r\n}\r\n\r\n.mdi-amplifier-off::before {\r\n  content: \"\\F11B5\";\r\n}\r\n\r\n.mdi-anchor::before {\r\n  content: \"\\F0031\";\r\n}\r\n\r\n.mdi-android::before {\r\n  content: \"\\F0032\";\r\n}\r\n\r\n.mdi-android-auto::before {\r\n  content: \"\\F0A8E\";\r\n}\r\n\r\n.mdi-android-debug-bridge::before {\r\n  content: \"\\F0033\";\r\n}\r\n\r\n.mdi-android-messages::before {\r\n  content: \"\\F0D45\";\r\n}\r\n\r\n.mdi-android-studio::before {\r\n  content: \"\\F0034\";\r\n}\r\n\r\n.mdi-angle-acute::before {\r\n  content: \"\\F0937\";\r\n}\r\n\r\n.mdi-angle-obtuse::before {\r\n  content: \"\\F0938\";\r\n}\r\n\r\n.mdi-angle-right::before {\r\n  content: \"\\F0939\";\r\n}\r\n\r\n.mdi-angular::before {\r\n  content: \"\\F06B2\";\r\n}\r\n\r\n.mdi-angularjs::before {\r\n  content: \"\\F06BF\";\r\n}\r\n\r\n.mdi-animation::before {\r\n  content: \"\\F05D8\";\r\n}\r\n\r\n.mdi-animation-outline::before {\r\n  content: \"\\F0A8F\";\r\n}\r\n\r\n.mdi-animation-play::before {\r\n  content: \"\\F093A\";\r\n}\r\n\r\n.mdi-animation-play-outline::before {\r\n  content: \"\\F0A90\";\r\n}\r\n\r\n.mdi-ansible::before {\r\n  content: \"\\F109A\";\r\n}\r\n\r\n.mdi-antenna::before {\r\n  content: \"\\F1119\";\r\n}\r\n\r\n.mdi-anvil::before {\r\n  content: \"\\F089B\";\r\n}\r\n\r\n.mdi-apache-kafka::before {\r\n  content: \"\\F100F\";\r\n}\r\n\r\n.mdi-api::before {\r\n  content: \"\\F109B\";\r\n}\r\n\r\n.mdi-api-off::before {\r\n  content: \"\\F1257\";\r\n}\r\n\r\n.mdi-apple::before {\r\n  content: \"\\F0035\";\r\n}\r\n\r\n.mdi-apple-airplay::before {\r\n  content: \"\\F001F\";\r\n}\r\n\r\n.mdi-apple-finder::before {\r\n  content: \"\\F0036\";\r\n}\r\n\r\n.mdi-apple-icloud::before {\r\n  content: \"\\F0038\";\r\n}\r\n\r\n.mdi-apple-ios::before {\r\n  content: \"\\F0037\";\r\n}\r\n\r\n.mdi-apple-keyboard-caps::before {\r\n  content: \"\\F0632\";\r\n}\r\n\r\n.mdi-apple-keyboard-command::before {\r\n  content: \"\\F0633\";\r\n}\r\n\r\n.mdi-apple-keyboard-control::before {\r\n  content: \"\\F0634\";\r\n}\r\n\r\n.mdi-apple-keyboard-option::before {\r\n  content: \"\\F0635\";\r\n}\r\n\r\n.mdi-apple-keyboard-shift::before {\r\n  content: \"\\F0636\";\r\n}\r\n\r\n.mdi-apple-safari::before {\r\n  content: \"\\F0039\";\r\n}\r\n\r\n.mdi-application::before {\r\n  content: \"\\F0614\";\r\n}\r\n\r\n.mdi-application-cog::before {\r\n  content: \"\\F1577\";\r\n}\r\n\r\n.mdi-application-export::before {\r\n  content: \"\\F0DAD\";\r\n}\r\n\r\n.mdi-application-import::before {\r\n  content: \"\\F0DAE\";\r\n}\r\n\r\n.mdi-application-settings::before {\r\n  content: \"\\F1555\";\r\n}\r\n\r\n.mdi-approximately-equal::before {\r\n  content: \"\\F0F9E\";\r\n}\r\n\r\n.mdi-approximately-equal-box::before {\r\n  content: \"\\F0F9F\";\r\n}\r\n\r\n.mdi-apps::before {\r\n  content: \"\\F003B\";\r\n}\r\n\r\n.mdi-apps-box::before {\r\n  content: \"\\F0D46\";\r\n}\r\n\r\n.mdi-arch::before {\r\n  content: \"\\F08C7\";\r\n}\r\n\r\n.mdi-archive::before {\r\n  content: \"\\F003C\";\r\n}\r\n\r\n.mdi-archive-alert::before {\r\n  content: \"\\F14FD\";\r\n}\r\n\r\n.mdi-archive-alert-outline::before {\r\n  content: \"\\F14FE\";\r\n}\r\n\r\n.mdi-archive-arrow-down::before {\r\n  content: \"\\F1259\";\r\n}\r\n\r\n.mdi-archive-arrow-down-outline::before {\r\n  content: \"\\F125A\";\r\n}\r\n\r\n.mdi-archive-arrow-up::before {\r\n  content: \"\\F125B\";\r\n}\r\n\r\n.mdi-archive-arrow-up-outline::before {\r\n  content: \"\\F125C\";\r\n}\r\n\r\n.mdi-archive-outline::before {\r\n  content: \"\\F120E\";\r\n}\r\n\r\n.mdi-arm-flex::before {\r\n  content: \"\\F0FD7\";\r\n}\r\n\r\n.mdi-arm-flex-outline::before {\r\n  content: \"\\F0FD6\";\r\n}\r\n\r\n.mdi-arrange-bring-forward::before {\r\n  content: \"\\F003D\";\r\n}\r\n\r\n.mdi-arrange-bring-to-front::before {\r\n  content: \"\\F003E\";\r\n}\r\n\r\n.mdi-arrange-send-backward::before {\r\n  content: \"\\F003F\";\r\n}\r\n\r\n.mdi-arrange-send-to-back::before {\r\n  content: \"\\F0040\";\r\n}\r\n\r\n.mdi-arrow-all::before {\r\n  content: \"\\F0041\";\r\n}\r\n\r\n.mdi-arrow-bottom-left::before {\r\n  content: \"\\F0042\";\r\n}\r\n\r\n.mdi-arrow-bottom-left-bold-outline::before {\r\n  content: \"\\F09B7\";\r\n}\r\n\r\n.mdi-arrow-bottom-left-thick::before {\r\n  content: \"\\F09B8\";\r\n}\r\n\r\n.mdi-arrow-bottom-left-thin-circle-outline::before {\r\n  content: \"\\F1596\";\r\n}\r\n\r\n.mdi-arrow-bottom-right::before {\r\n  content: \"\\F0043\";\r\n}\r\n\r\n.mdi-arrow-bottom-right-bold-outline::before {\r\n  content: \"\\F09B9\";\r\n}\r\n\r\n.mdi-arrow-bottom-right-thick::before {\r\n  content: \"\\F09BA\";\r\n}\r\n\r\n.mdi-arrow-bottom-right-thin-circle-outline::before {\r\n  content: \"\\F1595\";\r\n}\r\n\r\n.mdi-arrow-collapse::before {\r\n  content: \"\\F0615\";\r\n}\r\n\r\n.mdi-arrow-collapse-all::before {\r\n  content: \"\\F0044\";\r\n}\r\n\r\n.mdi-arrow-collapse-down::before {\r\n  content: \"\\F0792\";\r\n}\r\n\r\n.mdi-arrow-collapse-horizontal::before {\r\n  content: \"\\F084C\";\r\n}\r\n\r\n.mdi-arrow-collapse-left::before {\r\n  content: \"\\F0793\";\r\n}\r\n\r\n.mdi-arrow-collapse-right::before {\r\n  content: \"\\F0794\";\r\n}\r\n\r\n.mdi-arrow-collapse-up::before {\r\n  content: \"\\F0795\";\r\n}\r\n\r\n.mdi-arrow-collapse-vertical::before {\r\n  content: \"\\F084D\";\r\n}\r\n\r\n.mdi-arrow-decision::before {\r\n  content: \"\\F09BB\";\r\n}\r\n\r\n.mdi-arrow-decision-auto::before {\r\n  content: \"\\F09BC\";\r\n}\r\n\r\n.mdi-arrow-decision-auto-outline::before {\r\n  content: \"\\F09BD\";\r\n}\r\n\r\n.mdi-arrow-decision-outline::before {\r\n  content: \"\\F09BE\";\r\n}\r\n\r\n.mdi-arrow-down::before {\r\n  content: \"\\F0045\";\r\n}\r\n\r\n.mdi-arrow-down-bold::before {\r\n  content: \"\\F072E\";\r\n}\r\n\r\n.mdi-arrow-down-bold-box::before {\r\n  content: \"\\F072F\";\r\n}\r\n\r\n.mdi-arrow-down-bold-box-outline::before {\r\n  content: \"\\F0730\";\r\n}\r\n\r\n.mdi-arrow-down-bold-circle::before {\r\n  content: \"\\F0047\";\r\n}\r\n\r\n.mdi-arrow-down-bold-circle-outline::before {\r\n  content: \"\\F0048\";\r\n}\r\n\r\n.mdi-arrow-down-bold-hexagon-outline::before {\r\n  content: \"\\F0049\";\r\n}\r\n\r\n.mdi-arrow-down-bold-outline::before {\r\n  content: \"\\F09BF\";\r\n}\r\n\r\n.mdi-arrow-down-box::before {\r\n  content: \"\\F06C0\";\r\n}\r\n\r\n.mdi-arrow-down-circle::before {\r\n  content: \"\\F0CDB\";\r\n}\r\n\r\n.mdi-arrow-down-circle-outline::before {\r\n  content: \"\\F0CDC\";\r\n}\r\n\r\n.mdi-arrow-down-drop-circle::before {\r\n  content: \"\\F004A\";\r\n}\r\n\r\n.mdi-arrow-down-drop-circle-outline::before {\r\n  content: \"\\F004B\";\r\n}\r\n\r\n.mdi-arrow-down-thick::before {\r\n  content: \"\\F0046\";\r\n}\r\n\r\n.mdi-arrow-down-thin-circle-outline::before {\r\n  content: \"\\F1599\";\r\n}\r\n\r\n.mdi-arrow-expand::before {\r\n  content: \"\\F0616\";\r\n}\r\n\r\n.mdi-arrow-expand-all::before {\r\n  content: \"\\F004C\";\r\n}\r\n\r\n.mdi-arrow-expand-down::before {\r\n  content: \"\\F0796\";\r\n}\r\n\r\n.mdi-arrow-expand-horizontal::before {\r\n  content: \"\\F084E\";\r\n}\r\n\r\n.mdi-arrow-expand-left::before {\r\n  content: \"\\F0797\";\r\n}\r\n\r\n.mdi-arrow-expand-right::before {\r\n  content: \"\\F0798\";\r\n}\r\n\r\n.mdi-arrow-expand-up::before {\r\n  content: \"\\F0799\";\r\n}\r\n\r\n.mdi-arrow-expand-vertical::before {\r\n  content: \"\\F084F\";\r\n}\r\n\r\n.mdi-arrow-horizontal-lock::before {\r\n  content: \"\\F115B\";\r\n}\r\n\r\n.mdi-arrow-left::before {\r\n  content: \"\\F004D\";\r\n}\r\n\r\n.mdi-arrow-left-bold::before {\r\n  content: \"\\F0731\";\r\n}\r\n\r\n.mdi-arrow-left-bold-box::before {\r\n  content: \"\\F0732\";\r\n}\r\n\r\n.mdi-arrow-left-bold-box-outline::before {\r\n  content: \"\\F0733\";\r\n}\r\n\r\n.mdi-arrow-left-bold-circle::before {\r\n  content: \"\\F004F\";\r\n}\r\n\r\n.mdi-arrow-left-bold-circle-outline::before {\r\n  content: \"\\F0050\";\r\n}\r\n\r\n.mdi-arrow-left-bold-hexagon-outline::before {\r\n  content: \"\\F0051\";\r\n}\r\n\r\n.mdi-arrow-left-bold-outline::before {\r\n  content: \"\\F09C0\";\r\n}\r\n\r\n.mdi-arrow-left-box::before {\r\n  content: \"\\F06C1\";\r\n}\r\n\r\n.mdi-arrow-left-circle::before {\r\n  content: \"\\F0CDD\";\r\n}\r\n\r\n.mdi-arrow-left-circle-outline::before {\r\n  content: \"\\F0CDE\";\r\n}\r\n\r\n.mdi-arrow-left-drop-circle::before {\r\n  content: \"\\F0052\";\r\n}\r\n\r\n.mdi-arrow-left-drop-circle-outline::before {\r\n  content: \"\\F0053\";\r\n}\r\n\r\n.mdi-arrow-left-right::before {\r\n  content: \"\\F0E73\";\r\n}\r\n\r\n.mdi-arrow-left-right-bold::before {\r\n  content: \"\\F0E74\";\r\n}\r\n\r\n.mdi-arrow-left-right-bold-outline::before {\r\n  content: \"\\F09C1\";\r\n}\r\n\r\n.mdi-arrow-left-thick::before {\r\n  content: \"\\F004E\";\r\n}\r\n\r\n.mdi-arrow-left-thin-circle-outline::before {\r\n  content: \"\\F159A\";\r\n}\r\n\r\n.mdi-arrow-right::before {\r\n  content: \"\\F0054\";\r\n}\r\n\r\n.mdi-arrow-right-bold::before {\r\n  content: \"\\F0734\";\r\n}\r\n\r\n.mdi-arrow-right-bold-box::before {\r\n  content: \"\\F0735\";\r\n}\r\n\r\n.mdi-arrow-right-bold-box-outline::before {\r\n  content: \"\\F0736\";\r\n}\r\n\r\n.mdi-arrow-right-bold-circle::before {\r\n  content: \"\\F0056\";\r\n}\r\n\r\n.mdi-arrow-right-bold-circle-outline::before {\r\n  content: \"\\F0057\";\r\n}\r\n\r\n.mdi-arrow-right-bold-hexagon-outline::before {\r\n  content: \"\\F0058\";\r\n}\r\n\r\n.mdi-arrow-right-bold-outline::before {\r\n  content: \"\\F09C2\";\r\n}\r\n\r\n.mdi-arrow-right-box::before {\r\n  content: \"\\F06C2\";\r\n}\r\n\r\n.mdi-arrow-right-circle::before {\r\n  content: \"\\F0CDF\";\r\n}\r\n\r\n.mdi-arrow-right-circle-outline::before {\r\n  content: \"\\F0CE0\";\r\n}\r\n\r\n.mdi-arrow-right-drop-circle::before {\r\n  content: \"\\F0059\";\r\n}\r\n\r\n.mdi-arrow-right-drop-circle-outline::before {\r\n  content: \"\\F005A\";\r\n}\r\n\r\n.mdi-arrow-right-thick::before {\r\n  content: \"\\F0055\";\r\n}\r\n\r\n.mdi-arrow-right-thin-circle-outline::before {\r\n  content: \"\\F1598\";\r\n}\r\n\r\n.mdi-arrow-split-horizontal::before {\r\n  content: \"\\F093B\";\r\n}\r\n\r\n.mdi-arrow-split-vertical::before {\r\n  content: \"\\F093C\";\r\n}\r\n\r\n.mdi-arrow-top-left::before {\r\n  content: \"\\F005B\";\r\n}\r\n\r\n.mdi-arrow-top-left-bold-outline::before {\r\n  content: \"\\F09C3\";\r\n}\r\n\r\n.mdi-arrow-top-left-bottom-right::before {\r\n  content: \"\\F0E75\";\r\n}\r\n\r\n.mdi-arrow-top-left-bottom-right-bold::before {\r\n  content: \"\\F0E76\";\r\n}\r\n\r\n.mdi-arrow-top-left-thick::before {\r\n  content: \"\\F09C4\";\r\n}\r\n\r\n.mdi-arrow-top-left-thin-circle-outline::before {\r\n  content: \"\\F1593\";\r\n}\r\n\r\n.mdi-arrow-top-right::before {\r\n  content: \"\\F005C\";\r\n}\r\n\r\n.mdi-arrow-top-right-bold-outline::before {\r\n  content: \"\\F09C5\";\r\n}\r\n\r\n.mdi-arrow-top-right-bottom-left::before {\r\n  content: \"\\F0E77\";\r\n}\r\n\r\n.mdi-arrow-top-right-bottom-left-bold::before {\r\n  content: \"\\F0E78\";\r\n}\r\n\r\n.mdi-arrow-top-right-thick::before {\r\n  content: \"\\F09C6\";\r\n}\r\n\r\n.mdi-arrow-top-right-thin-circle-outline::before {\r\n  content: \"\\F1594\";\r\n}\r\n\r\n.mdi-arrow-up::before {\r\n  content: \"\\F005D\";\r\n}\r\n\r\n.mdi-arrow-up-bold::before {\r\n  content: \"\\F0737\";\r\n}\r\n\r\n.mdi-arrow-up-bold-box::before {\r\n  content: \"\\F0738\";\r\n}\r\n\r\n.mdi-arrow-up-bold-box-outline::before {\r\n  content: \"\\F0739\";\r\n}\r\n\r\n.mdi-arrow-up-bold-circle::before {\r\n  content: \"\\F005F\";\r\n}\r\n\r\n.mdi-arrow-up-bold-circle-outline::before {\r\n  content: \"\\F0060\";\r\n}\r\n\r\n.mdi-arrow-up-bold-hexagon-outline::before {\r\n  content: \"\\F0061\";\r\n}\r\n\r\n.mdi-arrow-up-bold-outline::before {\r\n  content: \"\\F09C7\";\r\n}\r\n\r\n.mdi-arrow-up-box::before {\r\n  content: \"\\F06C3\";\r\n}\r\n\r\n.mdi-arrow-up-circle::before {\r\n  content: \"\\F0CE1\";\r\n}\r\n\r\n.mdi-arrow-up-circle-outline::before {\r\n  content: \"\\F0CE2\";\r\n}\r\n\r\n.mdi-arrow-up-down::before {\r\n  content: \"\\F0E79\";\r\n}\r\n\r\n.mdi-arrow-up-down-bold::before {\r\n  content: \"\\F0E7A\";\r\n}\r\n\r\n.mdi-arrow-up-down-bold-outline::before {\r\n  content: \"\\F09C8\";\r\n}\r\n\r\n.mdi-arrow-up-drop-circle::before {\r\n  content: \"\\F0062\";\r\n}\r\n\r\n.mdi-arrow-up-drop-circle-outline::before {\r\n  content: \"\\F0063\";\r\n}\r\n\r\n.mdi-arrow-up-thick::before {\r\n  content: \"\\F005E\";\r\n}\r\n\r\n.mdi-arrow-up-thin-circle-outline::before {\r\n  content: \"\\F1597\";\r\n}\r\n\r\n.mdi-arrow-vertical-lock::before {\r\n  content: \"\\F115C\";\r\n}\r\n\r\n.mdi-artstation::before {\r\n  content: \"\\F0B5B\";\r\n}\r\n\r\n.mdi-aspect-ratio::before {\r\n  content: \"\\F0A24\";\r\n}\r\n\r\n.mdi-assistant::before {\r\n  content: \"\\F0064\";\r\n}\r\n\r\n.mdi-asterisk::before {\r\n  content: \"\\F06C4\";\r\n}\r\n\r\n.mdi-at::before {\r\n  content: \"\\F0065\";\r\n}\r\n\r\n.mdi-atlassian::before {\r\n  content: \"\\F0804\";\r\n}\r\n\r\n.mdi-atm::before {\r\n  content: \"\\F0D47\";\r\n}\r\n\r\n.mdi-atom::before {\r\n  content: \"\\F0768\";\r\n}\r\n\r\n.mdi-atom-variant::before {\r\n  content: \"\\F0E7B\";\r\n}\r\n\r\n.mdi-attachment::before {\r\n  content: \"\\F0066\";\r\n}\r\n\r\n.mdi-audio-video::before {\r\n  content: \"\\F093D\";\r\n}\r\n\r\n.mdi-audio-video-off::before {\r\n  content: \"\\F11B6\";\r\n}\r\n\r\n.mdi-augmented-reality::before {\r\n  content: \"\\F0850\";\r\n}\r\n\r\n.mdi-auto-download::before {\r\n  content: \"\\F137E\";\r\n}\r\n\r\n.mdi-auto-fix::before {\r\n  content: \"\\F0068\";\r\n}\r\n\r\n.mdi-auto-upload::before {\r\n  content: \"\\F0069\";\r\n}\r\n\r\n.mdi-autorenew::before {\r\n  content: \"\\F006A\";\r\n}\r\n\r\n.mdi-av-timer::before {\r\n  content: \"\\F006B\";\r\n}\r\n\r\n.mdi-aws::before {\r\n  content: \"\\F0E0F\";\r\n}\r\n\r\n.mdi-axe::before {\r\n  content: \"\\F08C8\";\r\n}\r\n\r\n.mdi-axis::before {\r\n  content: \"\\F0D48\";\r\n}\r\n\r\n.mdi-axis-arrow::before {\r\n  content: \"\\F0D49\";\r\n}\r\n\r\n.mdi-axis-arrow-info::before {\r\n  content: \"\\F140E\";\r\n}\r\n\r\n.mdi-axis-arrow-lock::before {\r\n  content: \"\\F0D4A\";\r\n}\r\n\r\n.mdi-axis-lock::before {\r\n  content: \"\\F0D4B\";\r\n}\r\n\r\n.mdi-axis-x-arrow::before {\r\n  content: \"\\F0D4C\";\r\n}\r\n\r\n.mdi-axis-x-arrow-lock::before {\r\n  content: \"\\F0D4D\";\r\n}\r\n\r\n.mdi-axis-x-rotate-clockwise::before {\r\n  content: \"\\F0D4E\";\r\n}\r\n\r\n.mdi-axis-x-rotate-counterclockwise::before {\r\n  content: \"\\F0D4F\";\r\n}\r\n\r\n.mdi-axis-x-y-arrow-lock::before {\r\n  content: \"\\F0D50\";\r\n}\r\n\r\n.mdi-axis-y-arrow::before {\r\n  content: \"\\F0D51\";\r\n}\r\n\r\n.mdi-axis-y-arrow-lock::before {\r\n  content: \"\\F0D52\";\r\n}\r\n\r\n.mdi-axis-y-rotate-clockwise::before {\r\n  content: \"\\F0D53\";\r\n}\r\n\r\n.mdi-axis-y-rotate-counterclockwise::before {\r\n  content: \"\\F0D54\";\r\n}\r\n\r\n.mdi-axis-z-arrow::before {\r\n  content: \"\\F0D55\";\r\n}\r\n\r\n.mdi-axis-z-arrow-lock::before {\r\n  content: \"\\F0D56\";\r\n}\r\n\r\n.mdi-axis-z-rotate-clockwise::before {\r\n  content: \"\\F0D57\";\r\n}\r\n\r\n.mdi-axis-z-rotate-counterclockwise::before {\r\n  content: \"\\F0D58\";\r\n}\r\n\r\n.mdi-babel::before {\r\n  content: \"\\F0A25\";\r\n}\r\n\r\n.mdi-baby::before {\r\n  content: \"\\F006C\";\r\n}\r\n\r\n.mdi-baby-bottle::before {\r\n  content: \"\\F0F39\";\r\n}\r\n\r\n.mdi-baby-bottle-outline::before {\r\n  content: \"\\F0F3A\";\r\n}\r\n\r\n.mdi-baby-buggy::before {\r\n  content: \"\\F13E0\";\r\n}\r\n\r\n.mdi-baby-carriage::before {\r\n  content: \"\\F068F\";\r\n}\r\n\r\n.mdi-baby-carriage-off::before {\r\n  content: \"\\F0FA0\";\r\n}\r\n\r\n.mdi-baby-face::before {\r\n  content: \"\\F0E7C\";\r\n}\r\n\r\n.mdi-baby-face-outline::before {\r\n  content: \"\\F0E7D\";\r\n}\r\n\r\n.mdi-backburger::before {\r\n  content: \"\\F006D\";\r\n}\r\n\r\n.mdi-backspace::before {\r\n  content: \"\\F006E\";\r\n}\r\n\r\n.mdi-backspace-outline::before {\r\n  content: \"\\F0B5C\";\r\n}\r\n\r\n.mdi-backspace-reverse::before {\r\n  content: \"\\F0E7E\";\r\n}\r\n\r\n.mdi-backspace-reverse-outline::before {\r\n  content: \"\\F0E7F\";\r\n}\r\n\r\n.mdi-backup-restore::before {\r\n  content: \"\\F006F\";\r\n}\r\n\r\n.mdi-bacteria::before {\r\n  content: \"\\F0ED5\";\r\n}\r\n\r\n.mdi-bacteria-outline::before {\r\n  content: \"\\F0ED6\";\r\n}\r\n\r\n.mdi-badge-account::before {\r\n  content: \"\\F0DA7\";\r\n}\r\n\r\n.mdi-badge-account-alert::before {\r\n  content: \"\\F0DA8\";\r\n}\r\n\r\n.mdi-badge-account-alert-outline::before {\r\n  content: \"\\F0DA9\";\r\n}\r\n\r\n.mdi-badge-account-horizontal::before {\r\n  content: \"\\F0E0D\";\r\n}\r\n\r\n.mdi-badge-account-horizontal-outline::before {\r\n  content: \"\\F0E0E\";\r\n}\r\n\r\n.mdi-badge-account-outline::before {\r\n  content: \"\\F0DAA\";\r\n}\r\n\r\n.mdi-badminton::before {\r\n  content: \"\\F0851\";\r\n}\r\n\r\n.mdi-bag-carry-on::before {\r\n  content: \"\\F0F3B\";\r\n}\r\n\r\n.mdi-bag-carry-on-check::before {\r\n  content: \"\\F0D65\";\r\n}\r\n\r\n.mdi-bag-carry-on-off::before {\r\n  content: \"\\F0F3C\";\r\n}\r\n\r\n.mdi-bag-checked::before {\r\n  content: \"\\F0F3D\";\r\n}\r\n\r\n.mdi-bag-personal::before {\r\n  content: \"\\F0E10\";\r\n}\r\n\r\n.mdi-bag-personal-off::before {\r\n  content: \"\\F0E11\";\r\n}\r\n\r\n.mdi-bag-personal-off-outline::before {\r\n  content: \"\\F0E12\";\r\n}\r\n\r\n.mdi-bag-personal-outline::before {\r\n  content: \"\\F0E13\";\r\n}\r\n\r\n.mdi-bag-suitcase::before {\r\n  content: \"\\F158B\";\r\n}\r\n\r\n.mdi-bag-suitcase-off::before {\r\n  content: \"\\F158D\";\r\n}\r\n\r\n.mdi-bag-suitcase-off-outline::before {\r\n  content: \"\\F158E\";\r\n}\r\n\r\n.mdi-bag-suitcase-outline::before {\r\n  content: \"\\F158C\";\r\n}\r\n\r\n.mdi-baguette::before {\r\n  content: \"\\F0F3E\";\r\n}\r\n\r\n.mdi-balloon::before {\r\n  content: \"\\F0A26\";\r\n}\r\n\r\n.mdi-ballot::before {\r\n  content: \"\\F09C9\";\r\n}\r\n\r\n.mdi-ballot-outline::before {\r\n  content: \"\\F09CA\";\r\n}\r\n\r\n.mdi-ballot-recount::before {\r\n  content: \"\\F0C39\";\r\n}\r\n\r\n.mdi-ballot-recount-outline::before {\r\n  content: \"\\F0C3A\";\r\n}\r\n\r\n.mdi-bandage::before {\r\n  content: \"\\F0DAF\";\r\n}\r\n\r\n.mdi-bandcamp::before {\r\n  content: \"\\F0675\";\r\n}\r\n\r\n.mdi-bank::before {\r\n  content: \"\\F0070\";\r\n}\r\n\r\n.mdi-bank-check::before {\r\n  content: \"\\F1655\";\r\n}\r\n\r\n.mdi-bank-minus::before {\r\n  content: \"\\F0DB0\";\r\n}\r\n\r\n.mdi-bank-off::before {\r\n  content: \"\\F1656\";\r\n}\r\n\r\n.mdi-bank-off-outline::before {\r\n  content: \"\\F1657\";\r\n}\r\n\r\n.mdi-bank-outline::before {\r\n  content: \"\\F0E80\";\r\n}\r\n\r\n.mdi-bank-plus::before {\r\n  content: \"\\F0DB1\";\r\n}\r\n\r\n.mdi-bank-remove::before {\r\n  content: \"\\F0DB2\";\r\n}\r\n\r\n.mdi-bank-transfer::before {\r\n  content: \"\\F0A27\";\r\n}\r\n\r\n.mdi-bank-transfer-in::before {\r\n  content: \"\\F0A28\";\r\n}\r\n\r\n.mdi-bank-transfer-out::before {\r\n  content: \"\\F0A29\";\r\n}\r\n\r\n.mdi-barcode::before {\r\n  content: \"\\F0071\";\r\n}\r\n\r\n.mdi-barcode-off::before {\r\n  content: \"\\F1236\";\r\n}\r\n\r\n.mdi-barcode-scan::before {\r\n  content: \"\\F0072\";\r\n}\r\n\r\n.mdi-barley::before {\r\n  content: \"\\F0073\";\r\n}\r\n\r\n.mdi-barley-off::before {\r\n  content: \"\\F0B5D\";\r\n}\r\n\r\n.mdi-barn::before {\r\n  content: \"\\F0B5E\";\r\n}\r\n\r\n.mdi-barrel::before {\r\n  content: \"\\F0074\";\r\n}\r\n\r\n.mdi-baseball::before {\r\n  content: \"\\F0852\";\r\n}\r\n\r\n.mdi-baseball-bat::before {\r\n  content: \"\\F0853\";\r\n}\r\n\r\n.mdi-baseball-diamond::before {\r\n  content: \"\\F15EC\";\r\n}\r\n\r\n.mdi-baseball-diamond-outline::before {\r\n  content: \"\\F15ED\";\r\n}\r\n\r\n.mdi-bash::before {\r\n  content: \"\\F1183\";\r\n}\r\n\r\n.mdi-basket::before {\r\n  content: \"\\F0076\";\r\n}\r\n\r\n.mdi-basket-fill::before {\r\n  content: \"\\F0077\";\r\n}\r\n\r\n.mdi-basket-minus::before {\r\n  content: \"\\F1523\";\r\n}\r\n\r\n.mdi-basket-minus-outline::before {\r\n  content: \"\\F1524\";\r\n}\r\n\r\n.mdi-basket-off::before {\r\n  content: \"\\F1525\";\r\n}\r\n\r\n.mdi-basket-off-outline::before {\r\n  content: \"\\F1526\";\r\n}\r\n\r\n.mdi-basket-outline::before {\r\n  content: \"\\F1181\";\r\n}\r\n\r\n.mdi-basket-plus::before {\r\n  content: \"\\F1527\";\r\n}\r\n\r\n.mdi-basket-plus-outline::before {\r\n  content: \"\\F1528\";\r\n}\r\n\r\n.mdi-basket-remove::before {\r\n  content: \"\\F1529\";\r\n}\r\n\r\n.mdi-basket-remove-outline::before {\r\n  content: \"\\F152A\";\r\n}\r\n\r\n.mdi-basket-unfill::before {\r\n  content: \"\\F0078\";\r\n}\r\n\r\n.mdi-basketball::before {\r\n  content: \"\\F0806\";\r\n}\r\n\r\n.mdi-basketball-hoop::before {\r\n  content: \"\\F0C3B\";\r\n}\r\n\r\n.mdi-basketball-hoop-outline::before {\r\n  content: \"\\F0C3C\";\r\n}\r\n\r\n.mdi-bat::before {\r\n  content: \"\\F0B5F\";\r\n}\r\n\r\n.mdi-battery::before {\r\n  content: \"\\F0079\";\r\n}\r\n\r\n.mdi-battery-10::before {\r\n  content: \"\\F007A\";\r\n}\r\n\r\n.mdi-battery-10-bluetooth::before {\r\n  content: \"\\F093E\";\r\n}\r\n\r\n.mdi-battery-20::before {\r\n  content: \"\\F007B\";\r\n}\r\n\r\n.mdi-battery-20-bluetooth::before {\r\n  content: \"\\F093F\";\r\n}\r\n\r\n.mdi-battery-30::before {\r\n  content: \"\\F007C\";\r\n}\r\n\r\n.mdi-battery-30-bluetooth::before {\r\n  content: \"\\F0940\";\r\n}\r\n\r\n.mdi-battery-40::before {\r\n  content: \"\\F007D\";\r\n}\r\n\r\n.mdi-battery-40-bluetooth::before {\r\n  content: \"\\F0941\";\r\n}\r\n\r\n.mdi-battery-50::before {\r\n  content: \"\\F007E\";\r\n}\r\n\r\n.mdi-battery-50-bluetooth::before {\r\n  content: \"\\F0942\";\r\n}\r\n\r\n.mdi-battery-60::before {\r\n  content: \"\\F007F\";\r\n}\r\n\r\n.mdi-battery-60-bluetooth::before {\r\n  content: \"\\F0943\";\r\n}\r\n\r\n.mdi-battery-70::before {\r\n  content: \"\\F0080\";\r\n}\r\n\r\n.mdi-battery-70-bluetooth::before {\r\n  content: \"\\F0944\";\r\n}\r\n\r\n.mdi-battery-80::before {\r\n  content: \"\\F0081\";\r\n}\r\n\r\n.mdi-battery-80-bluetooth::before {\r\n  content: \"\\F0945\";\r\n}\r\n\r\n.mdi-battery-90::before {\r\n  content: \"\\F0082\";\r\n}\r\n\r\n.mdi-battery-90-bluetooth::before {\r\n  content: \"\\F0946\";\r\n}\r\n\r\n.mdi-battery-alert::before {\r\n  content: \"\\F0083\";\r\n}\r\n\r\n.mdi-battery-alert-bluetooth::before {\r\n  content: \"\\F0947\";\r\n}\r\n\r\n.mdi-battery-alert-variant::before {\r\n  content: \"\\F10CC\";\r\n}\r\n\r\n.mdi-battery-alert-variant-outline::before {\r\n  content: \"\\F10CD\";\r\n}\r\n\r\n.mdi-battery-bluetooth::before {\r\n  content: \"\\F0948\";\r\n}\r\n\r\n.mdi-battery-bluetooth-variant::before {\r\n  content: \"\\F0949\";\r\n}\r\n\r\n.mdi-battery-charging::before {\r\n  content: \"\\F0084\";\r\n}\r\n\r\n.mdi-battery-charging-10::before {\r\n  content: \"\\F089C\";\r\n}\r\n\r\n.mdi-battery-charging-100::before {\r\n  content: \"\\F0085\";\r\n}\r\n\r\n.mdi-battery-charging-20::before {\r\n  content: \"\\F0086\";\r\n}\r\n\r\n.mdi-battery-charging-30::before {\r\n  content: \"\\F0087\";\r\n}\r\n\r\n.mdi-battery-charging-40::before {\r\n  content: \"\\F0088\";\r\n}\r\n\r\n.mdi-battery-charging-50::before {\r\n  content: \"\\F089D\";\r\n}\r\n\r\n.mdi-battery-charging-60::before {\r\n  content: \"\\F0089\";\r\n}\r\n\r\n.mdi-battery-charging-70::before {\r\n  content: \"\\F089E\";\r\n}\r\n\r\n.mdi-battery-charging-80::before {\r\n  content: \"\\F008A\";\r\n}\r\n\r\n.mdi-battery-charging-90::before {\r\n  content: \"\\F008B\";\r\n}\r\n\r\n.mdi-battery-charging-high::before {\r\n  content: \"\\F12A6\";\r\n}\r\n\r\n.mdi-battery-charging-low::before {\r\n  content: \"\\F12A4\";\r\n}\r\n\r\n.mdi-battery-charging-medium::before {\r\n  content: \"\\F12A5\";\r\n}\r\n\r\n.mdi-battery-charging-outline::before {\r\n  content: \"\\F089F\";\r\n}\r\n\r\n.mdi-battery-charging-wireless::before {\r\n  content: \"\\F0807\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-10::before {\r\n  content: \"\\F0808\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-20::before {\r\n  content: \"\\F0809\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-30::before {\r\n  content: \"\\F080A\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-40::before {\r\n  content: \"\\F080B\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-50::before {\r\n  content: \"\\F080C\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-60::before {\r\n  content: \"\\F080D\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-70::before {\r\n  content: \"\\F080E\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-80::before {\r\n  content: \"\\F080F\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-90::before {\r\n  content: \"\\F0810\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-alert::before {\r\n  content: \"\\F0811\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-outline::before {\r\n  content: \"\\F0812\";\r\n}\r\n\r\n.mdi-battery-heart::before {\r\n  content: \"\\F120F\";\r\n}\r\n\r\n.mdi-battery-heart-outline::before {\r\n  content: \"\\F1210\";\r\n}\r\n\r\n.mdi-battery-heart-variant::before {\r\n  content: \"\\F1211\";\r\n}\r\n\r\n.mdi-battery-high::before {\r\n  content: \"\\F12A3\";\r\n}\r\n\r\n.mdi-battery-low::before {\r\n  content: \"\\F12A1\";\r\n}\r\n\r\n.mdi-battery-medium::before {\r\n  content: \"\\F12A2\";\r\n}\r\n\r\n.mdi-battery-minus::before {\r\n  content: \"\\F008C\";\r\n}\r\n\r\n.mdi-battery-negative::before {\r\n  content: \"\\F008D\";\r\n}\r\n\r\n.mdi-battery-off::before {\r\n  content: \"\\F125D\";\r\n}\r\n\r\n.mdi-battery-off-outline::before {\r\n  content: \"\\F125E\";\r\n}\r\n\r\n.mdi-battery-outline::before {\r\n  content: \"\\F008E\";\r\n}\r\n\r\n.mdi-battery-plus::before {\r\n  content: \"\\F008F\";\r\n}\r\n\r\n.mdi-battery-positive::before {\r\n  content: \"\\F0090\";\r\n}\r\n\r\n.mdi-battery-unknown::before {\r\n  content: \"\\F0091\";\r\n}\r\n\r\n.mdi-battery-unknown-bluetooth::before {\r\n  content: \"\\F094A\";\r\n}\r\n\r\n.mdi-battlenet::before {\r\n  content: \"\\F0B60\";\r\n}\r\n\r\n.mdi-beach::before {\r\n  content: \"\\F0092\";\r\n}\r\n\r\n.mdi-beaker::before {\r\n  content: \"\\F0CEA\";\r\n}\r\n\r\n.mdi-beaker-alert::before {\r\n  content: \"\\F1229\";\r\n}\r\n\r\n.mdi-beaker-alert-outline::before {\r\n  content: \"\\F122A\";\r\n}\r\n\r\n.mdi-beaker-check::before {\r\n  content: \"\\F122B\";\r\n}\r\n\r\n.mdi-beaker-check-outline::before {\r\n  content: \"\\F122C\";\r\n}\r\n\r\n.mdi-beaker-minus::before {\r\n  content: \"\\F122D\";\r\n}\r\n\r\n.mdi-beaker-minus-outline::before {\r\n  content: \"\\F122E\";\r\n}\r\n\r\n.mdi-beaker-outline::before {\r\n  content: \"\\F0690\";\r\n}\r\n\r\n.mdi-beaker-plus::before {\r\n  content: \"\\F122F\";\r\n}\r\n\r\n.mdi-beaker-plus-outline::before {\r\n  content: \"\\F1230\";\r\n}\r\n\r\n.mdi-beaker-question::before {\r\n  content: \"\\F1231\";\r\n}\r\n\r\n.mdi-beaker-question-outline::before {\r\n  content: \"\\F1232\";\r\n}\r\n\r\n.mdi-beaker-remove::before {\r\n  content: \"\\F1233\";\r\n}\r\n\r\n.mdi-beaker-remove-outline::before {\r\n  content: \"\\F1234\";\r\n}\r\n\r\n.mdi-bed::before {\r\n  content: \"\\F02E3\";\r\n}\r\n\r\n.mdi-bed-double::before {\r\n  content: \"\\F0FD4\";\r\n}\r\n\r\n.mdi-bed-double-outline::before {\r\n  content: \"\\F0FD3\";\r\n}\r\n\r\n.mdi-bed-empty::before {\r\n  content: \"\\F08A0\";\r\n}\r\n\r\n.mdi-bed-king::before {\r\n  content: \"\\F0FD2\";\r\n}\r\n\r\n.mdi-bed-king-outline::before {\r\n  content: \"\\F0FD1\";\r\n}\r\n\r\n.mdi-bed-outline::before {\r\n  content: \"\\F0099\";\r\n}\r\n\r\n.mdi-bed-queen::before {\r\n  content: \"\\F0FD0\";\r\n}\r\n\r\n.mdi-bed-queen-outline::before {\r\n  content: \"\\F0FDB\";\r\n}\r\n\r\n.mdi-bed-single::before {\r\n  content: \"\\F106D\";\r\n}\r\n\r\n.mdi-bed-single-outline::before {\r\n  content: \"\\F106E\";\r\n}\r\n\r\n.mdi-bee::before {\r\n  content: \"\\F0FA1\";\r\n}\r\n\r\n.mdi-bee-flower::before {\r\n  content: \"\\F0FA2\";\r\n}\r\n\r\n.mdi-beehive-off-outline::before {\r\n  content: \"\\F13ED\";\r\n}\r\n\r\n.mdi-beehive-outline::before {\r\n  content: \"\\F10CE\";\r\n}\r\n\r\n.mdi-beekeeper::before {\r\n  content: \"\\F14E2\";\r\n}\r\n\r\n.mdi-beer::before {\r\n  content: \"\\F0098\";\r\n}\r\n\r\n.mdi-beer-outline::before {\r\n  content: \"\\F130C\";\r\n}\r\n\r\n.mdi-bell::before {\r\n  content: \"\\F009A\";\r\n}\r\n\r\n.mdi-bell-alert::before {\r\n  content: \"\\F0D59\";\r\n}\r\n\r\n.mdi-bell-alert-outline::before {\r\n  content: \"\\F0E81\";\r\n}\r\n\r\n.mdi-bell-cancel::before {\r\n  content: \"\\F13E7\";\r\n}\r\n\r\n.mdi-bell-cancel-outline::before {\r\n  content: \"\\F13E8\";\r\n}\r\n\r\n.mdi-bell-check::before {\r\n  content: \"\\F11E5\";\r\n}\r\n\r\n.mdi-bell-check-outline::before {\r\n  content: \"\\F11E6\";\r\n}\r\n\r\n.mdi-bell-circle::before {\r\n  content: \"\\F0D5A\";\r\n}\r\n\r\n.mdi-bell-circle-outline::before {\r\n  content: \"\\F0D5B\";\r\n}\r\n\r\n.mdi-bell-minus::before {\r\n  content: \"\\F13E9\";\r\n}\r\n\r\n.mdi-bell-minus-outline::before {\r\n  content: \"\\F13EA\";\r\n}\r\n\r\n.mdi-bell-off::before {\r\n  content: \"\\F009B\";\r\n}\r\n\r\n.mdi-bell-off-outline::before {\r\n  content: \"\\F0A91\";\r\n}\r\n\r\n.mdi-bell-outline::before {\r\n  content: \"\\F009C\";\r\n}\r\n\r\n.mdi-bell-plus::before {\r\n  content: \"\\F009D\";\r\n}\r\n\r\n.mdi-bell-plus-outline::before {\r\n  content: \"\\F0A92\";\r\n}\r\n\r\n.mdi-bell-remove::before {\r\n  content: \"\\F13EB\";\r\n}\r\n\r\n.mdi-bell-remove-outline::before {\r\n  content: \"\\F13EC\";\r\n}\r\n\r\n.mdi-bell-ring::before {\r\n  content: \"\\F009E\";\r\n}\r\n\r\n.mdi-bell-ring-outline::before {\r\n  content: \"\\F009F\";\r\n}\r\n\r\n.mdi-bell-sleep::before {\r\n  content: \"\\F00A0\";\r\n}\r\n\r\n.mdi-bell-sleep-outline::before {\r\n  content: \"\\F0A93\";\r\n}\r\n\r\n.mdi-beta::before {\r\n  content: \"\\F00A1\";\r\n}\r\n\r\n.mdi-betamax::before {\r\n  content: \"\\F09CB\";\r\n}\r\n\r\n.mdi-biathlon::before {\r\n  content: \"\\F0E14\";\r\n}\r\n\r\n.mdi-bicycle::before {\r\n  content: \"\\F109C\";\r\n}\r\n\r\n.mdi-bicycle-basket::before {\r\n  content: \"\\F1235\";\r\n}\r\n\r\n.mdi-bicycle-electric::before {\r\n  content: \"\\F15B4\";\r\n}\r\n\r\n.mdi-bicycle-penny-farthing::before {\r\n  content: \"\\F15E9\";\r\n}\r\n\r\n.mdi-bike::before {\r\n  content: \"\\F00A3\";\r\n}\r\n\r\n.mdi-bike-fast::before {\r\n  content: \"\\F111F\";\r\n}\r\n\r\n.mdi-billboard::before {\r\n  content: \"\\F1010\";\r\n}\r\n\r\n.mdi-billiards::before {\r\n  content: \"\\F0B61\";\r\n}\r\n\r\n.mdi-billiards-rack::before {\r\n  content: \"\\F0B62\";\r\n}\r\n\r\n.mdi-binoculars::before {\r\n  content: \"\\F00A5\";\r\n}\r\n\r\n.mdi-bio::before {\r\n  content: \"\\F00A6\";\r\n}\r\n\r\n.mdi-biohazard::before {\r\n  content: \"\\F00A7\";\r\n}\r\n\r\n.mdi-bird::before {\r\n  content: \"\\F15C6\";\r\n}\r\n\r\n.mdi-bitbucket::before {\r\n  content: \"\\F00A8\";\r\n}\r\n\r\n.mdi-bitcoin::before {\r\n  content: \"\\F0813\";\r\n}\r\n\r\n.mdi-black-mesa::before {\r\n  content: \"\\F00A9\";\r\n}\r\n\r\n.mdi-blender::before {\r\n  content: \"\\F0CEB\";\r\n}\r\n\r\n.mdi-blender-software::before {\r\n  content: \"\\F00AB\";\r\n}\r\n\r\n.mdi-blinds::before {\r\n  content: \"\\F00AC\";\r\n}\r\n\r\n.mdi-blinds-open::before {\r\n  content: \"\\F1011\";\r\n}\r\n\r\n.mdi-block-helper::before {\r\n  content: \"\\F00AD\";\r\n}\r\n\r\n.mdi-blogger::before {\r\n  content: \"\\F00AE\";\r\n}\r\n\r\n.mdi-blood-bag::before {\r\n  content: \"\\F0CEC\";\r\n}\r\n\r\n.mdi-bluetooth::before {\r\n  content: \"\\F00AF\";\r\n}\r\n\r\n.mdi-bluetooth-audio::before {\r\n  content: \"\\F00B0\";\r\n}\r\n\r\n.mdi-bluetooth-connect::before {\r\n  content: \"\\F00B1\";\r\n}\r\n\r\n.mdi-bluetooth-off::before {\r\n  content: \"\\F00B2\";\r\n}\r\n\r\n.mdi-bluetooth-settings::before {\r\n  content: \"\\F00B3\";\r\n}\r\n\r\n.mdi-bluetooth-transfer::before {\r\n  content: \"\\F00B4\";\r\n}\r\n\r\n.mdi-blur::before {\r\n  content: \"\\F00B5\";\r\n}\r\n\r\n.mdi-blur-linear::before {\r\n  content: \"\\F00B6\";\r\n}\r\n\r\n.mdi-blur-off::before {\r\n  content: \"\\F00B7\";\r\n}\r\n\r\n.mdi-blur-radial::before {\r\n  content: \"\\F00B8\";\r\n}\r\n\r\n.mdi-bolnisi-cross::before {\r\n  content: \"\\F0CED\";\r\n}\r\n\r\n.mdi-bolt::before {\r\n  content: \"\\F0DB3\";\r\n}\r\n\r\n.mdi-bomb::before {\r\n  content: \"\\F0691\";\r\n}\r\n\r\n.mdi-bomb-off::before {\r\n  content: \"\\F06C5\";\r\n}\r\n\r\n.mdi-bone::before {\r\n  content: \"\\F00B9\";\r\n}\r\n\r\n.mdi-book::before {\r\n  content: \"\\F00BA\";\r\n}\r\n\r\n.mdi-book-account::before {\r\n  content: \"\\F13AD\";\r\n}\r\n\r\n.mdi-book-account-outline::before {\r\n  content: \"\\F13AE\";\r\n}\r\n\r\n.mdi-book-alert::before {\r\n  content: \"\\F167C\";\r\n}\r\n\r\n.mdi-book-alert-outline::before {\r\n  content: \"\\F167D\";\r\n}\r\n\r\n.mdi-book-alphabet::before {\r\n  content: \"\\F061D\";\r\n}\r\n\r\n.mdi-book-arrow-down::before {\r\n  content: \"\\F167E\";\r\n}\r\n\r\n.mdi-book-arrow-down-outline::before {\r\n  content: \"\\F167F\";\r\n}\r\n\r\n.mdi-book-arrow-left::before {\r\n  content: \"\\F1680\";\r\n}\r\n\r\n.mdi-book-arrow-left-outline::before {\r\n  content: \"\\F1681\";\r\n}\r\n\r\n.mdi-book-arrow-right::before {\r\n  content: \"\\F1682\";\r\n}\r\n\r\n.mdi-book-arrow-right-outline::before {\r\n  content: \"\\F1683\";\r\n}\r\n\r\n.mdi-book-arrow-up::before {\r\n  content: \"\\F1684\";\r\n}\r\n\r\n.mdi-book-arrow-up-outline::before {\r\n  content: \"\\F1685\";\r\n}\r\n\r\n.mdi-book-cancel::before {\r\n  content: \"\\F1686\";\r\n}\r\n\r\n.mdi-book-cancel-outline::before {\r\n  content: \"\\F1687\";\r\n}\r\n\r\n.mdi-book-check::before {\r\n  content: \"\\F14F3\";\r\n}\r\n\r\n.mdi-book-check-outline::before {\r\n  content: \"\\F14F4\";\r\n}\r\n\r\n.mdi-book-clock::before {\r\n  content: \"\\F1688\";\r\n}\r\n\r\n.mdi-book-clock-outline::before {\r\n  content: \"\\F1689\";\r\n}\r\n\r\n.mdi-book-cog::before {\r\n  content: \"\\F168A\";\r\n}\r\n\r\n.mdi-book-cog-outline::before {\r\n  content: \"\\F168B\";\r\n}\r\n\r\n.mdi-book-cross::before {\r\n  content: \"\\F00A2\";\r\n}\r\n\r\n.mdi-book-edit::before {\r\n  content: \"\\F168C\";\r\n}\r\n\r\n.mdi-book-edit-outline::before {\r\n  content: \"\\F168D\";\r\n}\r\n\r\n.mdi-book-education::before {\r\n  content: \"\\F16C9\";\r\n}\r\n\r\n.mdi-book-education-outline::before {\r\n  content: \"\\F16CA\";\r\n}\r\n\r\n.mdi-book-information-variant::before {\r\n  content: \"\\F106F\";\r\n}\r\n\r\n.mdi-book-lock::before {\r\n  content: \"\\F079A\";\r\n}\r\n\r\n.mdi-book-lock-open::before {\r\n  content: \"\\F079B\";\r\n}\r\n\r\n.mdi-book-lock-open-outline::before {\r\n  content: \"\\F168E\";\r\n}\r\n\r\n.mdi-book-lock-outline::before {\r\n  content: \"\\F168F\";\r\n}\r\n\r\n.mdi-book-marker::before {\r\n  content: \"\\F1690\";\r\n}\r\n\r\n.mdi-book-marker-outline::before {\r\n  content: \"\\F1691\";\r\n}\r\n\r\n.mdi-book-minus::before {\r\n  content: \"\\F05D9\";\r\n}\r\n\r\n.mdi-book-minus-multiple::before {\r\n  content: \"\\F0A94\";\r\n}\r\n\r\n.mdi-book-minus-multiple-outline::before {\r\n  content: \"\\F090B\";\r\n}\r\n\r\n.mdi-book-minus-outline::before {\r\n  content: \"\\F1692\";\r\n}\r\n\r\n.mdi-book-multiple::before {\r\n  content: \"\\F00BB\";\r\n}\r\n\r\n.mdi-book-multiple-outline::before {\r\n  content: \"\\F0436\";\r\n}\r\n\r\n.mdi-book-music::before {\r\n  content: \"\\F0067\";\r\n}\r\n\r\n.mdi-book-music-outline::before {\r\n  content: \"\\F1693\";\r\n}\r\n\r\n.mdi-book-off::before {\r\n  content: \"\\F1694\";\r\n}\r\n\r\n.mdi-book-off-outline::before {\r\n  content: \"\\F1695\";\r\n}\r\n\r\n.mdi-book-open::before {\r\n  content: \"\\F00BD\";\r\n}\r\n\r\n.mdi-book-open-blank-variant::before {\r\n  content: \"\\F00BE\";\r\n}\r\n\r\n.mdi-book-open-outline::before {\r\n  content: \"\\F0B63\";\r\n}\r\n\r\n.mdi-book-open-page-variant::before {\r\n  content: \"\\F05DA\";\r\n}\r\n\r\n.mdi-book-open-page-variant-outline::before {\r\n  content: \"\\F15D6\";\r\n}\r\n\r\n.mdi-book-open-variant::before {\r\n  content: \"\\F14F7\";\r\n}\r\n\r\n.mdi-book-outline::before {\r\n  content: \"\\F0B64\";\r\n}\r\n\r\n.mdi-book-play::before {\r\n  content: \"\\F0E82\";\r\n}\r\n\r\n.mdi-book-play-outline::before {\r\n  content: \"\\F0E83\";\r\n}\r\n\r\n.mdi-book-plus::before {\r\n  content: \"\\F05DB\";\r\n}\r\n\r\n.mdi-book-plus-multiple::before {\r\n  content: \"\\F0A95\";\r\n}\r\n\r\n.mdi-book-plus-multiple-outline::before {\r\n  content: \"\\F0ADE\";\r\n}\r\n\r\n.mdi-book-plus-outline::before {\r\n  content: \"\\F1696\";\r\n}\r\n\r\n.mdi-book-refresh::before {\r\n  content: \"\\F1697\";\r\n}\r\n\r\n.mdi-book-refresh-outline::before {\r\n  content: \"\\F1698\";\r\n}\r\n\r\n.mdi-book-remove::before {\r\n  content: \"\\F0A97\";\r\n}\r\n\r\n.mdi-book-remove-multiple::before {\r\n  content: \"\\F0A96\";\r\n}\r\n\r\n.mdi-book-remove-multiple-outline::before {\r\n  content: \"\\F04CA\";\r\n}\r\n\r\n.mdi-book-remove-outline::before {\r\n  content: \"\\F1699\";\r\n}\r\n\r\n.mdi-book-search::before {\r\n  content: \"\\F0E84\";\r\n}\r\n\r\n.mdi-book-search-outline::before {\r\n  content: \"\\F0E85\";\r\n}\r\n\r\n.mdi-book-settings::before {\r\n  content: \"\\F169A\";\r\n}\r\n\r\n.mdi-book-settings-outline::before {\r\n  content: \"\\F169B\";\r\n}\r\n\r\n.mdi-book-sync::before {\r\n  content: \"\\F169C\";\r\n}\r\n\r\n.mdi-book-sync-outline::before {\r\n  content: \"\\F16C8\";\r\n}\r\n\r\n.mdi-book-variant::before {\r\n  content: \"\\F00BF\";\r\n}\r\n\r\n.mdi-book-variant-multiple::before {\r\n  content: \"\\F00BC\";\r\n}\r\n\r\n.mdi-bookmark::before {\r\n  content: \"\\F00C0\";\r\n}\r\n\r\n.mdi-bookmark-check::before {\r\n  content: \"\\F00C1\";\r\n}\r\n\r\n.mdi-bookmark-check-outline::before {\r\n  content: \"\\F137B\";\r\n}\r\n\r\n.mdi-bookmark-minus::before {\r\n  content: \"\\F09CC\";\r\n}\r\n\r\n.mdi-bookmark-minus-outline::before {\r\n  content: \"\\F09CD\";\r\n}\r\n\r\n.mdi-bookmark-multiple::before {\r\n  content: \"\\F0E15\";\r\n}\r\n\r\n.mdi-bookmark-multiple-outline::before {\r\n  content: \"\\F0E16\";\r\n}\r\n\r\n.mdi-bookmark-music::before {\r\n  content: \"\\F00C2\";\r\n}\r\n\r\n.mdi-bookmark-music-outline::before {\r\n  content: \"\\F1379\";\r\n}\r\n\r\n.mdi-bookmark-off::before {\r\n  content: \"\\F09CE\";\r\n}\r\n\r\n.mdi-bookmark-off-outline::before {\r\n  content: \"\\F09CF\";\r\n}\r\n\r\n.mdi-bookmark-outline::before {\r\n  content: \"\\F00C3\";\r\n}\r\n\r\n.mdi-bookmark-plus::before {\r\n  content: \"\\F00C5\";\r\n}\r\n\r\n.mdi-bookmark-plus-outline::before {\r\n  content: \"\\F00C4\";\r\n}\r\n\r\n.mdi-bookmark-remove::before {\r\n  content: \"\\F00C6\";\r\n}\r\n\r\n.mdi-bookmark-remove-outline::before {\r\n  content: \"\\F137A\";\r\n}\r\n\r\n.mdi-bookshelf::before {\r\n  content: \"\\F125F\";\r\n}\r\n\r\n.mdi-boom-gate::before {\r\n  content: \"\\F0E86\";\r\n}\r\n\r\n.mdi-boom-gate-alert::before {\r\n  content: \"\\F0E87\";\r\n}\r\n\r\n.mdi-boom-gate-alert-outline::before {\r\n  content: \"\\F0E88\";\r\n}\r\n\r\n.mdi-boom-gate-down::before {\r\n  content: \"\\F0E89\";\r\n}\r\n\r\n.mdi-boom-gate-down-outline::before {\r\n  content: \"\\F0E8A\";\r\n}\r\n\r\n.mdi-boom-gate-outline::before {\r\n  content: \"\\F0E8B\";\r\n}\r\n\r\n.mdi-boom-gate-up::before {\r\n  content: \"\\F0E8C\";\r\n}\r\n\r\n.mdi-boom-gate-up-outline::before {\r\n  content: \"\\F0E8D\";\r\n}\r\n\r\n.mdi-boombox::before {\r\n  content: \"\\F05DC\";\r\n}\r\n\r\n.mdi-boomerang::before {\r\n  content: \"\\F10CF\";\r\n}\r\n\r\n.mdi-bootstrap::before {\r\n  content: \"\\F06C6\";\r\n}\r\n\r\n.mdi-border-all::before {\r\n  content: \"\\F00C7\";\r\n}\r\n\r\n.mdi-border-all-variant::before {\r\n  content: \"\\F08A1\";\r\n}\r\n\r\n.mdi-border-bottom::before {\r\n  content: \"\\F00C8\";\r\n}\r\n\r\n.mdi-border-bottom-variant::before {\r\n  content: \"\\F08A2\";\r\n}\r\n\r\n.mdi-border-color::before {\r\n  content: \"\\F00C9\";\r\n}\r\n\r\n.mdi-border-horizontal::before {\r\n  content: \"\\F00CA\";\r\n}\r\n\r\n.mdi-border-inside::before {\r\n  content: \"\\F00CB\";\r\n}\r\n\r\n.mdi-border-left::before {\r\n  content: \"\\F00CC\";\r\n}\r\n\r\n.mdi-border-left-variant::before {\r\n  content: \"\\F08A3\";\r\n}\r\n\r\n.mdi-border-none::before {\r\n  content: \"\\F00CD\";\r\n}\r\n\r\n.mdi-border-none-variant::before {\r\n  content: \"\\F08A4\";\r\n}\r\n\r\n.mdi-border-outside::before {\r\n  content: \"\\F00CE\";\r\n}\r\n\r\n.mdi-border-right::before {\r\n  content: \"\\F00CF\";\r\n}\r\n\r\n.mdi-border-right-variant::before {\r\n  content: \"\\F08A5\";\r\n}\r\n\r\n.mdi-border-style::before {\r\n  content: \"\\F00D0\";\r\n}\r\n\r\n.mdi-border-top::before {\r\n  content: \"\\F00D1\";\r\n}\r\n\r\n.mdi-border-top-variant::before {\r\n  content: \"\\F08A6\";\r\n}\r\n\r\n.mdi-border-vertical::before {\r\n  content: \"\\F00D2\";\r\n}\r\n\r\n.mdi-bottle-soda::before {\r\n  content: \"\\F1070\";\r\n}\r\n\r\n.mdi-bottle-soda-classic::before {\r\n  content: \"\\F1071\";\r\n}\r\n\r\n.mdi-bottle-soda-classic-outline::before {\r\n  content: \"\\F1363\";\r\n}\r\n\r\n.mdi-bottle-soda-outline::before {\r\n  content: \"\\F1072\";\r\n}\r\n\r\n.mdi-bottle-tonic::before {\r\n  content: \"\\F112E\";\r\n}\r\n\r\n.mdi-bottle-tonic-outline::before {\r\n  content: \"\\F112F\";\r\n}\r\n\r\n.mdi-bottle-tonic-plus::before {\r\n  content: \"\\F1130\";\r\n}\r\n\r\n.mdi-bottle-tonic-plus-outline::before {\r\n  content: \"\\F1131\";\r\n}\r\n\r\n.mdi-bottle-tonic-skull::before {\r\n  content: \"\\F1132\";\r\n}\r\n\r\n.mdi-bottle-tonic-skull-outline::before {\r\n  content: \"\\F1133\";\r\n}\r\n\r\n.mdi-bottle-wine::before {\r\n  content: \"\\F0854\";\r\n}\r\n\r\n.mdi-bottle-wine-outline::before {\r\n  content: \"\\F1310\";\r\n}\r\n\r\n.mdi-bow-tie::before {\r\n  content: \"\\F0678\";\r\n}\r\n\r\n.mdi-bowl::before {\r\n  content: \"\\F028E\";\r\n}\r\n\r\n.mdi-bowl-mix::before {\r\n  content: \"\\F0617\";\r\n}\r\n\r\n.mdi-bowl-mix-outline::before {\r\n  content: \"\\F02E4\";\r\n}\r\n\r\n.mdi-bowl-outline::before {\r\n  content: \"\\F02A9\";\r\n}\r\n\r\n.mdi-bowling::before {\r\n  content: \"\\F00D3\";\r\n}\r\n\r\n.mdi-box::before {\r\n  content: \"\\F00D4\";\r\n}\r\n\r\n.mdi-box-cutter::before {\r\n  content: \"\\F00D5\";\r\n}\r\n\r\n.mdi-box-cutter-off::before {\r\n  content: \"\\F0B4A\";\r\n}\r\n\r\n.mdi-box-shadow::before {\r\n  content: \"\\F0637\";\r\n}\r\n\r\n.mdi-boxing-glove::before {\r\n  content: \"\\F0B65\";\r\n}\r\n\r\n.mdi-braille::before {\r\n  content: \"\\F09D0\";\r\n}\r\n\r\n.mdi-brain::before {\r\n  content: \"\\F09D1\";\r\n}\r\n\r\n.mdi-bread-slice::before {\r\n  content: \"\\F0CEE\";\r\n}\r\n\r\n.mdi-bread-slice-outline::before {\r\n  content: \"\\F0CEF\";\r\n}\r\n\r\n.mdi-bridge::before {\r\n  content: \"\\F0618\";\r\n}\r\n\r\n.mdi-briefcase::before {\r\n  content: \"\\F00D6\";\r\n}\r\n\r\n.mdi-briefcase-account::before {\r\n  content: \"\\F0CF0\";\r\n}\r\n\r\n.mdi-briefcase-account-outline::before {\r\n  content: \"\\F0CF1\";\r\n}\r\n\r\n.mdi-briefcase-check::before {\r\n  content: \"\\F00D7\";\r\n}\r\n\r\n.mdi-briefcase-check-outline::before {\r\n  content: \"\\F131E\";\r\n}\r\n\r\n.mdi-briefcase-clock::before {\r\n  content: \"\\F10D0\";\r\n}\r\n\r\n.mdi-briefcase-clock-outline::before {\r\n  content: \"\\F10D1\";\r\n}\r\n\r\n.mdi-briefcase-download::before {\r\n  content: \"\\F00D8\";\r\n}\r\n\r\n.mdi-briefcase-download-outline::before {\r\n  content: \"\\F0C3D\";\r\n}\r\n\r\n.mdi-briefcase-edit::before {\r\n  content: \"\\F0A98\";\r\n}\r\n\r\n.mdi-briefcase-edit-outline::before {\r\n  content: \"\\F0C3E\";\r\n}\r\n\r\n.mdi-briefcase-minus::before {\r\n  content: \"\\F0A2A\";\r\n}\r\n\r\n.mdi-briefcase-minus-outline::before {\r\n  content: \"\\F0C3F\";\r\n}\r\n\r\n.mdi-briefcase-off::before {\r\n  content: \"\\F1658\";\r\n}\r\n\r\n.mdi-briefcase-off-outline::before {\r\n  content: \"\\F1659\";\r\n}\r\n\r\n.mdi-briefcase-outline::before {\r\n  content: \"\\F0814\";\r\n}\r\n\r\n.mdi-briefcase-plus::before {\r\n  content: \"\\F0A2B\";\r\n}\r\n\r\n.mdi-briefcase-plus-outline::before {\r\n  content: \"\\F0C40\";\r\n}\r\n\r\n.mdi-briefcase-remove::before {\r\n  content: \"\\F0A2C\";\r\n}\r\n\r\n.mdi-briefcase-remove-outline::before {\r\n  content: \"\\F0C41\";\r\n}\r\n\r\n.mdi-briefcase-search::before {\r\n  content: \"\\F0A2D\";\r\n}\r\n\r\n.mdi-briefcase-search-outline::before {\r\n  content: \"\\F0C42\";\r\n}\r\n\r\n.mdi-briefcase-upload::before {\r\n  content: \"\\F00D9\";\r\n}\r\n\r\n.mdi-briefcase-upload-outline::before {\r\n  content: \"\\F0C43\";\r\n}\r\n\r\n.mdi-briefcase-variant::before {\r\n  content: \"\\F1494\";\r\n}\r\n\r\n.mdi-briefcase-variant-off::before {\r\n  content: \"\\F165A\";\r\n}\r\n\r\n.mdi-briefcase-variant-off-outline::before {\r\n  content: \"\\F165B\";\r\n}\r\n\r\n.mdi-briefcase-variant-outline::before {\r\n  content: \"\\F1495\";\r\n}\r\n\r\n.mdi-brightness-1::before {\r\n  content: \"\\F00DA\";\r\n}\r\n\r\n.mdi-brightness-2::before {\r\n  content: \"\\F00DB\";\r\n}\r\n\r\n.mdi-brightness-3::before {\r\n  content: \"\\F00DC\";\r\n}\r\n\r\n.mdi-brightness-4::before {\r\n  content: \"\\F00DD\";\r\n}\r\n\r\n.mdi-brightness-5::before {\r\n  content: \"\\F00DE\";\r\n}\r\n\r\n.mdi-brightness-6::before {\r\n  content: \"\\F00DF\";\r\n}\r\n\r\n.mdi-brightness-7::before {\r\n  content: \"\\F00E0\";\r\n}\r\n\r\n.mdi-brightness-auto::before {\r\n  content: \"\\F00E1\";\r\n}\r\n\r\n.mdi-brightness-percent::before {\r\n  content: \"\\F0CF2\";\r\n}\r\n\r\n.mdi-broom::before {\r\n  content: \"\\F00E2\";\r\n}\r\n\r\n.mdi-brush::before {\r\n  content: \"\\F00E3\";\r\n}\r\n\r\n.mdi-bucket::before {\r\n  content: \"\\F1415\";\r\n}\r\n\r\n.mdi-bucket-outline::before {\r\n  content: \"\\F1416\";\r\n}\r\n\r\n.mdi-buddhism::before {\r\n  content: \"\\F094B\";\r\n}\r\n\r\n.mdi-buffer::before {\r\n  content: \"\\F0619\";\r\n}\r\n\r\n.mdi-buffet::before {\r\n  content: \"\\F0578\";\r\n}\r\n\r\n.mdi-bug::before {\r\n  content: \"\\F00E4\";\r\n}\r\n\r\n.mdi-bug-check::before {\r\n  content: \"\\F0A2E\";\r\n}\r\n\r\n.mdi-bug-check-outline::before {\r\n  content: \"\\F0A2F\";\r\n}\r\n\r\n.mdi-bug-outline::before {\r\n  content: \"\\F0A30\";\r\n}\r\n\r\n.mdi-bugle::before {\r\n  content: \"\\F0DB4\";\r\n}\r\n\r\n.mdi-bulldozer::before {\r\n  content: \"\\F0B22\";\r\n}\r\n\r\n.mdi-bullet::before {\r\n  content: \"\\F0CF3\";\r\n}\r\n\r\n.mdi-bulletin-board::before {\r\n  content: \"\\F00E5\";\r\n}\r\n\r\n.mdi-bullhorn::before {\r\n  content: \"\\F00E6\";\r\n}\r\n\r\n.mdi-bullhorn-outline::before {\r\n  content: \"\\F0B23\";\r\n}\r\n\r\n.mdi-bullseye::before {\r\n  content: \"\\F05DD\";\r\n}\r\n\r\n.mdi-bullseye-arrow::before {\r\n  content: \"\\F08C9\";\r\n}\r\n\r\n.mdi-bulma::before {\r\n  content: \"\\F12E7\";\r\n}\r\n\r\n.mdi-bunk-bed::before {\r\n  content: \"\\F1302\";\r\n}\r\n\r\n.mdi-bunk-bed-outline::before {\r\n  content: \"\\F0097\";\r\n}\r\n\r\n.mdi-bus::before {\r\n  content: \"\\F00E7\";\r\n}\r\n\r\n.mdi-bus-alert::before {\r\n  content: \"\\F0A99\";\r\n}\r\n\r\n.mdi-bus-articulated-end::before {\r\n  content: \"\\F079C\";\r\n}\r\n\r\n.mdi-bus-articulated-front::before {\r\n  content: \"\\F079D\";\r\n}\r\n\r\n.mdi-bus-clock::before {\r\n  content: \"\\F08CA\";\r\n}\r\n\r\n.mdi-bus-double-decker::before {\r\n  content: \"\\F079E\";\r\n}\r\n\r\n.mdi-bus-marker::before {\r\n  content: \"\\F1212\";\r\n}\r\n\r\n.mdi-bus-multiple::before {\r\n  content: \"\\F0F3F\";\r\n}\r\n\r\n.mdi-bus-school::before {\r\n  content: \"\\F079F\";\r\n}\r\n\r\n.mdi-bus-side::before {\r\n  content: \"\\F07A0\";\r\n}\r\n\r\n.mdi-bus-stop::before {\r\n  content: \"\\F1012\";\r\n}\r\n\r\n.mdi-bus-stop-covered::before {\r\n  content: \"\\F1013\";\r\n}\r\n\r\n.mdi-bus-stop-uncovered::before {\r\n  content: \"\\F1014\";\r\n}\r\n\r\n.mdi-butterfly::before {\r\n  content: \"\\F1589\";\r\n}\r\n\r\n.mdi-butterfly-outline::before {\r\n  content: \"\\F158A\";\r\n}\r\n\r\n.mdi-cable-data::before {\r\n  content: \"\\F1394\";\r\n}\r\n\r\n.mdi-cached::before {\r\n  content: \"\\F00E8\";\r\n}\r\n\r\n.mdi-cactus::before {\r\n  content: \"\\F0DB5\";\r\n}\r\n\r\n.mdi-cake::before {\r\n  content: \"\\F00E9\";\r\n}\r\n\r\n.mdi-cake-layered::before {\r\n  content: \"\\F00EA\";\r\n}\r\n\r\n.mdi-cake-variant::before {\r\n  content: \"\\F00EB\";\r\n}\r\n\r\n.mdi-calculator::before {\r\n  content: \"\\F00EC\";\r\n}\r\n\r\n.mdi-calculator-variant::before {\r\n  content: \"\\F0A9A\";\r\n}\r\n\r\n.mdi-calculator-variant-outline::before {\r\n  content: \"\\F15A6\";\r\n}\r\n\r\n.mdi-calendar::before {\r\n  content: \"\\F00ED\";\r\n}\r\n\r\n.mdi-calendar-account::before {\r\n  content: \"\\F0ED7\";\r\n}\r\n\r\n.mdi-calendar-account-outline::before {\r\n  content: \"\\F0ED8\";\r\n}\r\n\r\n.mdi-calendar-alert::before {\r\n  content: \"\\F0A31\";\r\n}\r\n\r\n.mdi-calendar-arrow-left::before {\r\n  content: \"\\F1134\";\r\n}\r\n\r\n.mdi-calendar-arrow-right::before {\r\n  content: \"\\F1135\";\r\n}\r\n\r\n.mdi-calendar-blank::before {\r\n  content: \"\\F00EE\";\r\n}\r\n\r\n.mdi-calendar-blank-multiple::before {\r\n  content: \"\\F1073\";\r\n}\r\n\r\n.mdi-calendar-blank-outline::before {\r\n  content: \"\\F0B66\";\r\n}\r\n\r\n.mdi-calendar-check::before {\r\n  content: \"\\F00EF\";\r\n}\r\n\r\n.mdi-calendar-check-outline::before {\r\n  content: \"\\F0C44\";\r\n}\r\n\r\n.mdi-calendar-clock::before {\r\n  content: \"\\F00F0\";\r\n}\r\n\r\n.mdi-calendar-cursor::before {\r\n  content: \"\\F157B\";\r\n}\r\n\r\n.mdi-calendar-edit::before {\r\n  content: \"\\F08A7\";\r\n}\r\n\r\n.mdi-calendar-end::before {\r\n  content: \"\\F166C\";\r\n}\r\n\r\n.mdi-calendar-export::before {\r\n  content: \"\\F0B24\";\r\n}\r\n\r\n.mdi-calendar-heart::before {\r\n  content: \"\\F09D2\";\r\n}\r\n\r\n.mdi-calendar-import::before {\r\n  content: \"\\F0B25\";\r\n}\r\n\r\n.mdi-calendar-lock::before {\r\n  content: \"\\F1641\";\r\n}\r\n\r\n.mdi-calendar-lock-outline::before {\r\n  content: \"\\F1642\";\r\n}\r\n\r\n.mdi-calendar-minus::before {\r\n  content: \"\\F0D5C\";\r\n}\r\n\r\n.mdi-calendar-month::before {\r\n  content: \"\\F0E17\";\r\n}\r\n\r\n.mdi-calendar-month-outline::before {\r\n  content: \"\\F0E18\";\r\n}\r\n\r\n.mdi-calendar-multiple::before {\r\n  content: \"\\F00F1\";\r\n}\r\n\r\n.mdi-calendar-multiple-check::before {\r\n  content: \"\\F00F2\";\r\n}\r\n\r\n.mdi-calendar-multiselect::before {\r\n  content: \"\\F0A32\";\r\n}\r\n\r\n.mdi-calendar-outline::before {\r\n  content: \"\\F0B67\";\r\n}\r\n\r\n.mdi-calendar-plus::before {\r\n  content: \"\\F00F3\";\r\n}\r\n\r\n.mdi-calendar-question::before {\r\n  content: \"\\F0692\";\r\n}\r\n\r\n.mdi-calendar-range::before {\r\n  content: \"\\F0679\";\r\n}\r\n\r\n.mdi-calendar-range-outline::before {\r\n  content: \"\\F0B68\";\r\n}\r\n\r\n.mdi-calendar-refresh::before {\r\n  content: \"\\F01E1\";\r\n}\r\n\r\n.mdi-calendar-refresh-outline::before {\r\n  content: \"\\F0203\";\r\n}\r\n\r\n.mdi-calendar-remove::before {\r\n  content: \"\\F00F4\";\r\n}\r\n\r\n.mdi-calendar-remove-outline::before {\r\n  content: \"\\F0C45\";\r\n}\r\n\r\n.mdi-calendar-search::before {\r\n  content: \"\\F094C\";\r\n}\r\n\r\n.mdi-calendar-star::before {\r\n  content: \"\\F09D3\";\r\n}\r\n\r\n.mdi-calendar-start::before {\r\n  content: \"\\F166D\";\r\n}\r\n\r\n.mdi-calendar-sync::before {\r\n  content: \"\\F0E8E\";\r\n}\r\n\r\n.mdi-calendar-sync-outline::before {\r\n  content: \"\\F0E8F\";\r\n}\r\n\r\n.mdi-calendar-text::before {\r\n  content: \"\\F00F5\";\r\n}\r\n\r\n.mdi-calendar-text-outline::before {\r\n  content: \"\\F0C46\";\r\n}\r\n\r\n.mdi-calendar-today::before {\r\n  content: \"\\F00F6\";\r\n}\r\n\r\n.mdi-calendar-week::before {\r\n  content: \"\\F0A33\";\r\n}\r\n\r\n.mdi-calendar-week-begin::before {\r\n  content: \"\\F0A34\";\r\n}\r\n\r\n.mdi-calendar-weekend::before {\r\n  content: \"\\F0ED9\";\r\n}\r\n\r\n.mdi-calendar-weekend-outline::before {\r\n  content: \"\\F0EDA\";\r\n}\r\n\r\n.mdi-call-made::before {\r\n  content: \"\\F00F7\";\r\n}\r\n\r\n.mdi-call-merge::before {\r\n  content: \"\\F00F8\";\r\n}\r\n\r\n.mdi-call-missed::before {\r\n  content: \"\\F00F9\";\r\n}\r\n\r\n.mdi-call-received::before {\r\n  content: \"\\F00FA\";\r\n}\r\n\r\n.mdi-call-split::before {\r\n  content: \"\\F00FB\";\r\n}\r\n\r\n.mdi-camcorder::before {\r\n  content: \"\\F00FC\";\r\n}\r\n\r\n.mdi-camcorder-off::before {\r\n  content: \"\\F00FF\";\r\n}\r\n\r\n.mdi-camera::before {\r\n  content: \"\\F0100\";\r\n}\r\n\r\n.mdi-camera-account::before {\r\n  content: \"\\F08CB\";\r\n}\r\n\r\n.mdi-camera-burst::before {\r\n  content: \"\\F0693\";\r\n}\r\n\r\n.mdi-camera-control::before {\r\n  content: \"\\F0B69\";\r\n}\r\n\r\n.mdi-camera-enhance::before {\r\n  content: \"\\F0101\";\r\n}\r\n\r\n.mdi-camera-enhance-outline::before {\r\n  content: \"\\F0B6A\";\r\n}\r\n\r\n.mdi-camera-flip::before {\r\n  content: \"\\F15D9\";\r\n}\r\n\r\n.mdi-camera-flip-outline::before {\r\n  content: \"\\F15DA\";\r\n}\r\n\r\n.mdi-camera-front::before {\r\n  content: \"\\F0102\";\r\n}\r\n\r\n.mdi-camera-front-variant::before {\r\n  content: \"\\F0103\";\r\n}\r\n\r\n.mdi-camera-gopro::before {\r\n  content: \"\\F07A1\";\r\n}\r\n\r\n.mdi-camera-image::before {\r\n  content: \"\\F08CC\";\r\n}\r\n\r\n.mdi-camera-iris::before {\r\n  content: \"\\F0104\";\r\n}\r\n\r\n.mdi-camera-metering-center::before {\r\n  content: \"\\F07A2\";\r\n}\r\n\r\n.mdi-camera-metering-matrix::before {\r\n  content: \"\\F07A3\";\r\n}\r\n\r\n.mdi-camera-metering-partial::before {\r\n  content: \"\\F07A4\";\r\n}\r\n\r\n.mdi-camera-metering-spot::before {\r\n  content: \"\\F07A5\";\r\n}\r\n\r\n.mdi-camera-off::before {\r\n  content: \"\\F05DF\";\r\n}\r\n\r\n.mdi-camera-outline::before {\r\n  content: \"\\F0D5D\";\r\n}\r\n\r\n.mdi-camera-party-mode::before {\r\n  content: \"\\F0105\";\r\n}\r\n\r\n.mdi-camera-plus::before {\r\n  content: \"\\F0EDB\";\r\n}\r\n\r\n.mdi-camera-plus-outline::before {\r\n  content: \"\\F0EDC\";\r\n}\r\n\r\n.mdi-camera-rear::before {\r\n  content: \"\\F0106\";\r\n}\r\n\r\n.mdi-camera-rear-variant::before {\r\n  content: \"\\F0107\";\r\n}\r\n\r\n.mdi-camera-retake::before {\r\n  content: \"\\F0E19\";\r\n}\r\n\r\n.mdi-camera-retake-outline::before {\r\n  content: \"\\F0E1A\";\r\n}\r\n\r\n.mdi-camera-switch::before {\r\n  content: \"\\F0108\";\r\n}\r\n\r\n.mdi-camera-switch-outline::before {\r\n  content: \"\\F084A\";\r\n}\r\n\r\n.mdi-camera-timer::before {\r\n  content: \"\\F0109\";\r\n}\r\n\r\n.mdi-camera-wireless::before {\r\n  content: \"\\F0DB6\";\r\n}\r\n\r\n.mdi-camera-wireless-outline::before {\r\n  content: \"\\F0DB7\";\r\n}\r\n\r\n.mdi-campfire::before {\r\n  content: \"\\F0EDD\";\r\n}\r\n\r\n.mdi-cancel::before {\r\n  content: \"\\F073A\";\r\n}\r\n\r\n.mdi-candle::before {\r\n  content: \"\\F05E2\";\r\n}\r\n\r\n.mdi-candycane::before {\r\n  content: \"\\F010A\";\r\n}\r\n\r\n.mdi-cannabis::before {\r\n  content: \"\\F07A6\";\r\n}\r\n\r\n.mdi-cannabis-off::before {\r\n  content: \"\\F166E\";\r\n}\r\n\r\n.mdi-caps-lock::before {\r\n  content: \"\\F0A9B\";\r\n}\r\n\r\n.mdi-car::before {\r\n  content: \"\\F010B\";\r\n}\r\n\r\n.mdi-car-2-plus::before {\r\n  content: \"\\F1015\";\r\n}\r\n\r\n.mdi-car-3-plus::before {\r\n  content: \"\\F1016\";\r\n}\r\n\r\n.mdi-car-arrow-left::before {\r\n  content: \"\\F13B2\";\r\n}\r\n\r\n.mdi-car-arrow-right::before {\r\n  content: \"\\F13B3\";\r\n}\r\n\r\n.mdi-car-back::before {\r\n  content: \"\\F0E1B\";\r\n}\r\n\r\n.mdi-car-battery::before {\r\n  content: \"\\F010C\";\r\n}\r\n\r\n.mdi-car-brake-abs::before {\r\n  content: \"\\F0C47\";\r\n}\r\n\r\n.mdi-car-brake-alert::before {\r\n  content: \"\\F0C48\";\r\n}\r\n\r\n.mdi-car-brake-hold::before {\r\n  content: \"\\F0D5E\";\r\n}\r\n\r\n.mdi-car-brake-parking::before {\r\n  content: \"\\F0D5F\";\r\n}\r\n\r\n.mdi-car-brake-retarder::before {\r\n  content: \"\\F1017\";\r\n}\r\n\r\n.mdi-car-child-seat::before {\r\n  content: \"\\F0FA3\";\r\n}\r\n\r\n.mdi-car-clutch::before {\r\n  content: \"\\F1018\";\r\n}\r\n\r\n.mdi-car-cog::before {\r\n  content: \"\\F13CC\";\r\n}\r\n\r\n.mdi-car-connected::before {\r\n  content: \"\\F010D\";\r\n}\r\n\r\n.mdi-car-convertible::before {\r\n  content: \"\\F07A7\";\r\n}\r\n\r\n.mdi-car-coolant-level::before {\r\n  content: \"\\F1019\";\r\n}\r\n\r\n.mdi-car-cruise-control::before {\r\n  content: \"\\F0D60\";\r\n}\r\n\r\n.mdi-car-defrost-front::before {\r\n  content: \"\\F0D61\";\r\n}\r\n\r\n.mdi-car-defrost-rear::before {\r\n  content: \"\\F0D62\";\r\n}\r\n\r\n.mdi-car-door::before {\r\n  content: \"\\F0B6B\";\r\n}\r\n\r\n.mdi-car-door-lock::before {\r\n  content: \"\\F109D\";\r\n}\r\n\r\n.mdi-car-electric::before {\r\n  content: \"\\F0B6C\";\r\n}\r\n\r\n.mdi-car-electric-outline::before {\r\n  content: \"\\F15B5\";\r\n}\r\n\r\n.mdi-car-emergency::before {\r\n  content: \"\\F160F\";\r\n}\r\n\r\n.mdi-car-esp::before {\r\n  content: \"\\F0C49\";\r\n}\r\n\r\n.mdi-car-estate::before {\r\n  content: \"\\F07A8\";\r\n}\r\n\r\n.mdi-car-hatchback::before {\r\n  content: \"\\F07A9\";\r\n}\r\n\r\n.mdi-car-info::before {\r\n  content: \"\\F11BE\";\r\n}\r\n\r\n.mdi-car-key::before {\r\n  content: \"\\F0B6D\";\r\n}\r\n\r\n.mdi-car-lifted-pickup::before {\r\n  content: \"\\F152D\";\r\n}\r\n\r\n.mdi-car-light-dimmed::before {\r\n  content: \"\\F0C4A\";\r\n}\r\n\r\n.mdi-car-light-fog::before {\r\n  content: \"\\F0C4B\";\r\n}\r\n\r\n.mdi-car-light-high::before {\r\n  content: \"\\F0C4C\";\r\n}\r\n\r\n.mdi-car-limousine::before {\r\n  content: \"\\F08CD\";\r\n}\r\n\r\n.mdi-car-multiple::before {\r\n  content: \"\\F0B6E\";\r\n}\r\n\r\n.mdi-car-off::before {\r\n  content: \"\\F0E1C\";\r\n}\r\n\r\n.mdi-car-outline::before {\r\n  content: \"\\F14ED\";\r\n}\r\n\r\n.mdi-car-parking-lights::before {\r\n  content: \"\\F0D63\";\r\n}\r\n\r\n.mdi-car-pickup::before {\r\n  content: \"\\F07AA\";\r\n}\r\n\r\n.mdi-car-seat::before {\r\n  content: \"\\F0FA4\";\r\n}\r\n\r\n.mdi-car-seat-cooler::before {\r\n  content: \"\\F0FA5\";\r\n}\r\n\r\n.mdi-car-seat-heater::before {\r\n  content: \"\\F0FA6\";\r\n}\r\n\r\n.mdi-car-settings::before {\r\n  content: \"\\F13CD\";\r\n}\r\n\r\n.mdi-car-shift-pattern::before {\r\n  content: \"\\F0F40\";\r\n}\r\n\r\n.mdi-car-side::before {\r\n  content: \"\\F07AB\";\r\n}\r\n\r\n.mdi-car-sports::before {\r\n  content: \"\\F07AC\";\r\n}\r\n\r\n.mdi-car-tire-alert::before {\r\n  content: \"\\F0C4D\";\r\n}\r\n\r\n.mdi-car-traction-control::before {\r\n  content: \"\\F0D64\";\r\n}\r\n\r\n.mdi-car-turbocharger::before {\r\n  content: \"\\F101A\";\r\n}\r\n\r\n.mdi-car-wash::before {\r\n  content: \"\\F010E\";\r\n}\r\n\r\n.mdi-car-windshield::before {\r\n  content: \"\\F101B\";\r\n}\r\n\r\n.mdi-car-windshield-outline::before {\r\n  content: \"\\F101C\";\r\n}\r\n\r\n.mdi-carabiner::before {\r\n  content: \"\\F14C0\";\r\n}\r\n\r\n.mdi-caravan::before {\r\n  content: \"\\F07AD\";\r\n}\r\n\r\n.mdi-card::before {\r\n  content: \"\\F0B6F\";\r\n}\r\n\r\n.mdi-card-account-details::before {\r\n  content: \"\\F05D2\";\r\n}\r\n\r\n.mdi-card-account-details-outline::before {\r\n  content: \"\\F0DAB\";\r\n}\r\n\r\n.mdi-card-account-details-star::before {\r\n  content: \"\\F02A3\";\r\n}\r\n\r\n.mdi-card-account-details-star-outline::before {\r\n  content: \"\\F06DB\";\r\n}\r\n\r\n.mdi-card-account-mail::before {\r\n  content: \"\\F018E\";\r\n}\r\n\r\n.mdi-card-account-mail-outline::before {\r\n  content: \"\\F0E98\";\r\n}\r\n\r\n.mdi-card-account-phone::before {\r\n  content: \"\\F0E99\";\r\n}\r\n\r\n.mdi-card-account-phone-outline::before {\r\n  content: \"\\F0E9A\";\r\n}\r\n\r\n.mdi-card-bulleted::before {\r\n  content: \"\\F0B70\";\r\n}\r\n\r\n.mdi-card-bulleted-off::before {\r\n  content: \"\\F0B71\";\r\n}\r\n\r\n.mdi-card-bulleted-off-outline::before {\r\n  content: \"\\F0B72\";\r\n}\r\n\r\n.mdi-card-bulleted-outline::before {\r\n  content: \"\\F0B73\";\r\n}\r\n\r\n.mdi-card-bulleted-settings::before {\r\n  content: \"\\F0B74\";\r\n}\r\n\r\n.mdi-card-bulleted-settings-outline::before {\r\n  content: \"\\F0B75\";\r\n}\r\n\r\n.mdi-card-minus::before {\r\n  content: \"\\F1600\";\r\n}\r\n\r\n.mdi-card-minus-outline::before {\r\n  content: \"\\F1601\";\r\n}\r\n\r\n.mdi-card-off::before {\r\n  content: \"\\F1602\";\r\n}\r\n\r\n.mdi-card-off-outline::before {\r\n  content: \"\\F1603\";\r\n}\r\n\r\n.mdi-card-outline::before {\r\n  content: \"\\F0B76\";\r\n}\r\n\r\n.mdi-card-plus::before {\r\n  content: \"\\F11FF\";\r\n}\r\n\r\n.mdi-card-plus-outline::before {\r\n  content: \"\\F1200\";\r\n}\r\n\r\n.mdi-card-remove::before {\r\n  content: \"\\F1604\";\r\n}\r\n\r\n.mdi-card-remove-outline::before {\r\n  content: \"\\F1605\";\r\n}\r\n\r\n.mdi-card-search::before {\r\n  content: \"\\F1074\";\r\n}\r\n\r\n.mdi-card-search-outline::before {\r\n  content: \"\\F1075\";\r\n}\r\n\r\n.mdi-card-text::before {\r\n  content: \"\\F0B77\";\r\n}\r\n\r\n.mdi-card-text-outline::before {\r\n  content: \"\\F0B78\";\r\n}\r\n\r\n.mdi-cards::before {\r\n  content: \"\\F0638\";\r\n}\r\n\r\n.mdi-cards-club::before {\r\n  content: \"\\F08CE\";\r\n}\r\n\r\n.mdi-cards-diamond::before {\r\n  content: \"\\F08CF\";\r\n}\r\n\r\n.mdi-cards-diamond-outline::before {\r\n  content: \"\\F101D\";\r\n}\r\n\r\n.mdi-cards-heart::before {\r\n  content: \"\\F08D0\";\r\n}\r\n\r\n.mdi-cards-outline::before {\r\n  content: \"\\F0639\";\r\n}\r\n\r\n.mdi-cards-playing-outline::before {\r\n  content: \"\\F063A\";\r\n}\r\n\r\n.mdi-cards-spade::before {\r\n  content: \"\\F08D1\";\r\n}\r\n\r\n.mdi-cards-variant::before {\r\n  content: \"\\F06C7\";\r\n}\r\n\r\n.mdi-carrot::before {\r\n  content: \"\\F010F\";\r\n}\r\n\r\n.mdi-cart::before {\r\n  content: \"\\F0110\";\r\n}\r\n\r\n.mdi-cart-arrow-down::before {\r\n  content: \"\\F0D66\";\r\n}\r\n\r\n.mdi-cart-arrow-right::before {\r\n  content: \"\\F0C4E\";\r\n}\r\n\r\n.mdi-cart-arrow-up::before {\r\n  content: \"\\F0D67\";\r\n}\r\n\r\n.mdi-cart-check::before {\r\n  content: \"\\F15EA\";\r\n}\r\n\r\n.mdi-cart-minus::before {\r\n  content: \"\\F0D68\";\r\n}\r\n\r\n.mdi-cart-off::before {\r\n  content: \"\\F066B\";\r\n}\r\n\r\n.mdi-cart-outline::before {\r\n  content: \"\\F0111\";\r\n}\r\n\r\n.mdi-cart-plus::before {\r\n  content: \"\\F0112\";\r\n}\r\n\r\n.mdi-cart-remove::before {\r\n  content: \"\\F0D69\";\r\n}\r\n\r\n.mdi-cart-variant::before {\r\n  content: \"\\F15EB\";\r\n}\r\n\r\n.mdi-case-sensitive-alt::before {\r\n  content: \"\\F0113\";\r\n}\r\n\r\n.mdi-cash::before {\r\n  content: \"\\F0114\";\r\n}\r\n\r\n.mdi-cash-100::before {\r\n  content: \"\\F0115\";\r\n}\r\n\r\n.mdi-cash-check::before {\r\n  content: \"\\F14EE\";\r\n}\r\n\r\n.mdi-cash-lock::before {\r\n  content: \"\\F14EA\";\r\n}\r\n\r\n.mdi-cash-lock-open::before {\r\n  content: \"\\F14EB\";\r\n}\r\n\r\n.mdi-cash-marker::before {\r\n  content: \"\\F0DB8\";\r\n}\r\n\r\n.mdi-cash-minus::before {\r\n  content: \"\\F1260\";\r\n}\r\n\r\n.mdi-cash-multiple::before {\r\n  content: \"\\F0116\";\r\n}\r\n\r\n.mdi-cash-plus::before {\r\n  content: \"\\F1261\";\r\n}\r\n\r\n.mdi-cash-refund::before {\r\n  content: \"\\F0A9C\";\r\n}\r\n\r\n.mdi-cash-register::before {\r\n  content: \"\\F0CF4\";\r\n}\r\n\r\n.mdi-cash-remove::before {\r\n  content: \"\\F1262\";\r\n}\r\n\r\n.mdi-cash-usd::before {\r\n  content: \"\\F1176\";\r\n}\r\n\r\n.mdi-cash-usd-outline::before {\r\n  content: \"\\F0117\";\r\n}\r\n\r\n.mdi-cassette::before {\r\n  content: \"\\F09D4\";\r\n}\r\n\r\n.mdi-cast::before {\r\n  content: \"\\F0118\";\r\n}\r\n\r\n.mdi-cast-audio::before {\r\n  content: \"\\F101E\";\r\n}\r\n\r\n.mdi-cast-connected::before {\r\n  content: \"\\F0119\";\r\n}\r\n\r\n.mdi-cast-education::before {\r\n  content: \"\\F0E1D\";\r\n}\r\n\r\n.mdi-cast-off::before {\r\n  content: \"\\F078A\";\r\n}\r\n\r\n.mdi-castle::before {\r\n  content: \"\\F011A\";\r\n}\r\n\r\n.mdi-cat::before {\r\n  content: \"\\F011B\";\r\n}\r\n\r\n.mdi-cctv::before {\r\n  content: \"\\F07AE\";\r\n}\r\n\r\n.mdi-ceiling-light::before {\r\n  content: \"\\F0769\";\r\n}\r\n\r\n.mdi-cellphone::before {\r\n  content: \"\\F011C\";\r\n}\r\n\r\n.mdi-cellphone-android::before {\r\n  content: \"\\F011D\";\r\n}\r\n\r\n.mdi-cellphone-arrow-down::before {\r\n  content: \"\\F09D5\";\r\n}\r\n\r\n.mdi-cellphone-basic::before {\r\n  content: \"\\F011E\";\r\n}\r\n\r\n.mdi-cellphone-charging::before {\r\n  content: \"\\F1397\";\r\n}\r\n\r\n.mdi-cellphone-cog::before {\r\n  content: \"\\F0951\";\r\n}\r\n\r\n.mdi-cellphone-dock::before {\r\n  content: \"\\F011F\";\r\n}\r\n\r\n.mdi-cellphone-erase::before {\r\n  content: \"\\F094D\";\r\n}\r\n\r\n.mdi-cellphone-information::before {\r\n  content: \"\\F0F41\";\r\n}\r\n\r\n.mdi-cellphone-iphone::before {\r\n  content: \"\\F0120\";\r\n}\r\n\r\n.mdi-cellphone-key::before {\r\n  content: \"\\F094E\";\r\n}\r\n\r\n.mdi-cellphone-link::before {\r\n  content: \"\\F0121\";\r\n}\r\n\r\n.mdi-cellphone-link-off::before {\r\n  content: \"\\F0122\";\r\n}\r\n\r\n.mdi-cellphone-lock::before {\r\n  content: \"\\F094F\";\r\n}\r\n\r\n.mdi-cellphone-message::before {\r\n  content: \"\\F08D3\";\r\n}\r\n\r\n.mdi-cellphone-message-off::before {\r\n  content: \"\\F10D2\";\r\n}\r\n\r\n.mdi-cellphone-nfc::before {\r\n  content: \"\\F0E90\";\r\n}\r\n\r\n.mdi-cellphone-nfc-off::before {\r\n  content: \"\\F12D8\";\r\n}\r\n\r\n.mdi-cellphone-off::before {\r\n  content: \"\\F0950\";\r\n}\r\n\r\n.mdi-cellphone-play::before {\r\n  content: \"\\F101F\";\r\n}\r\n\r\n.mdi-cellphone-screenshot::before {\r\n  content: \"\\F0A35\";\r\n}\r\n\r\n.mdi-cellphone-settings::before {\r\n  content: \"\\F0123\";\r\n}\r\n\r\n.mdi-cellphone-sound::before {\r\n  content: \"\\F0952\";\r\n}\r\n\r\n.mdi-cellphone-text::before {\r\n  content: \"\\F08D2\";\r\n}\r\n\r\n.mdi-cellphone-wireless::before {\r\n  content: \"\\F0815\";\r\n}\r\n\r\n.mdi-celtic-cross::before {\r\n  content: \"\\F0CF5\";\r\n}\r\n\r\n.mdi-centos::before {\r\n  content: \"\\F111A\";\r\n}\r\n\r\n.mdi-certificate::before {\r\n  content: \"\\F0124\";\r\n}\r\n\r\n.mdi-certificate-outline::before {\r\n  content: \"\\F1188\";\r\n}\r\n\r\n.mdi-chair-rolling::before {\r\n  content: \"\\F0F48\";\r\n}\r\n\r\n.mdi-chair-school::before {\r\n  content: \"\\F0125\";\r\n}\r\n\r\n.mdi-charity::before {\r\n  content: \"\\F0C4F\";\r\n}\r\n\r\n.mdi-chart-arc::before {\r\n  content: \"\\F0126\";\r\n}\r\n\r\n.mdi-chart-areaspline::before {\r\n  content: \"\\F0127\";\r\n}\r\n\r\n.mdi-chart-areaspline-variant::before {\r\n  content: \"\\F0E91\";\r\n}\r\n\r\n.mdi-chart-bar::before {\r\n  content: \"\\F0128\";\r\n}\r\n\r\n.mdi-chart-bar-stacked::before {\r\n  content: \"\\F076A\";\r\n}\r\n\r\n.mdi-chart-bell-curve::before {\r\n  content: \"\\F0C50\";\r\n}\r\n\r\n.mdi-chart-bell-curve-cumulative::before {\r\n  content: \"\\F0FA7\";\r\n}\r\n\r\n.mdi-chart-box::before {\r\n  content: \"\\F154D\";\r\n}\r\n\r\n.mdi-chart-box-outline::before {\r\n  content: \"\\F154E\";\r\n}\r\n\r\n.mdi-chart-box-plus-outline::before {\r\n  content: \"\\F154F\";\r\n}\r\n\r\n.mdi-chart-bubble::before {\r\n  content: \"\\F05E3\";\r\n}\r\n\r\n.mdi-chart-donut::before {\r\n  content: \"\\F07AF\";\r\n}\r\n\r\n.mdi-chart-donut-variant::before {\r\n  content: \"\\F07B0\";\r\n}\r\n\r\n.mdi-chart-gantt::before {\r\n  content: \"\\F066C\";\r\n}\r\n\r\n.mdi-chart-histogram::before {\r\n  content: \"\\F0129\";\r\n}\r\n\r\n.mdi-chart-line::before {\r\n  content: \"\\F012A\";\r\n}\r\n\r\n.mdi-chart-line-stacked::before {\r\n  content: \"\\F076B\";\r\n}\r\n\r\n.mdi-chart-line-variant::before {\r\n  content: \"\\F07B1\";\r\n}\r\n\r\n.mdi-chart-multiline::before {\r\n  content: \"\\F08D4\";\r\n}\r\n\r\n.mdi-chart-multiple::before {\r\n  content: \"\\F1213\";\r\n}\r\n\r\n.mdi-chart-pie::before {\r\n  content: \"\\F012B\";\r\n}\r\n\r\n.mdi-chart-ppf::before {\r\n  content: \"\\F1380\";\r\n}\r\n\r\n.mdi-chart-sankey::before {\r\n  content: \"\\F11DF\";\r\n}\r\n\r\n.mdi-chart-sankey-variant::before {\r\n  content: \"\\F11E0\";\r\n}\r\n\r\n.mdi-chart-scatter-plot::before {\r\n  content: \"\\F0E92\";\r\n}\r\n\r\n.mdi-chart-scatter-plot-hexbin::before {\r\n  content: \"\\F066D\";\r\n}\r\n\r\n.mdi-chart-timeline::before {\r\n  content: \"\\F066E\";\r\n}\r\n\r\n.mdi-chart-timeline-variant::before {\r\n  content: \"\\F0E93\";\r\n}\r\n\r\n.mdi-chart-timeline-variant-shimmer::before {\r\n  content: \"\\F15B6\";\r\n}\r\n\r\n.mdi-chart-tree::before {\r\n  content: \"\\F0E94\";\r\n}\r\n\r\n.mdi-chat::before {\r\n  content: \"\\F0B79\";\r\n}\r\n\r\n.mdi-chat-alert::before {\r\n  content: \"\\F0B7A\";\r\n}\r\n\r\n.mdi-chat-alert-outline::before {\r\n  content: \"\\F12C9\";\r\n}\r\n\r\n.mdi-chat-minus::before {\r\n  content: \"\\F1410\";\r\n}\r\n\r\n.mdi-chat-minus-outline::before {\r\n  content: \"\\F1413\";\r\n}\r\n\r\n.mdi-chat-outline::before {\r\n  content: \"\\F0EDE\";\r\n}\r\n\r\n.mdi-chat-plus::before {\r\n  content: \"\\F140F\";\r\n}\r\n\r\n.mdi-chat-plus-outline::before {\r\n  content: \"\\F1412\";\r\n}\r\n\r\n.mdi-chat-processing::before {\r\n  content: \"\\F0B7B\";\r\n}\r\n\r\n.mdi-chat-processing-outline::before {\r\n  content: \"\\F12CA\";\r\n}\r\n\r\n.mdi-chat-remove::before {\r\n  content: \"\\F1411\";\r\n}\r\n\r\n.mdi-chat-remove-outline::before {\r\n  content: \"\\F1414\";\r\n}\r\n\r\n.mdi-chat-sleep::before {\r\n  content: \"\\F12D1\";\r\n}\r\n\r\n.mdi-chat-sleep-outline::before {\r\n  content: \"\\F12D2\";\r\n}\r\n\r\n.mdi-check::before {\r\n  content: \"\\F012C\";\r\n}\r\n\r\n.mdi-check-all::before {\r\n  content: \"\\F012D\";\r\n}\r\n\r\n.mdi-check-bold::before {\r\n  content: \"\\F0E1E\";\r\n}\r\n\r\n.mdi-check-box-multiple-outline::before {\r\n  content: \"\\F0C51\";\r\n}\r\n\r\n.mdi-check-box-outline::before {\r\n  content: \"\\F0C52\";\r\n}\r\n\r\n.mdi-check-circle::before {\r\n  content: \"\\F05E0\";\r\n}\r\n\r\n.mdi-check-circle-outline::before {\r\n  content: \"\\F05E1\";\r\n}\r\n\r\n.mdi-check-decagram::before {\r\n  content: \"\\F0791\";\r\n}\r\n\r\n.mdi-check-network::before {\r\n  content: \"\\F0C53\";\r\n}\r\n\r\n.mdi-check-network-outline::before {\r\n  content: \"\\F0C54\";\r\n}\r\n\r\n.mdi-check-outline::before {\r\n  content: \"\\F0855\";\r\n}\r\n\r\n.mdi-check-underline::before {\r\n  content: \"\\F0E1F\";\r\n}\r\n\r\n.mdi-check-underline-circle::before {\r\n  content: \"\\F0E20\";\r\n}\r\n\r\n.mdi-check-underline-circle-outline::before {\r\n  content: \"\\F0E21\";\r\n}\r\n\r\n.mdi-checkbook::before {\r\n  content: \"\\F0A9D\";\r\n}\r\n\r\n.mdi-checkbox-blank::before {\r\n  content: \"\\F012E\";\r\n}\r\n\r\n.mdi-checkbox-blank-circle::before {\r\n  content: \"\\F012F\";\r\n}\r\n\r\n.mdi-checkbox-blank-circle-outline::before {\r\n  content: \"\\F0130\";\r\n}\r\n\r\n.mdi-checkbox-blank-off::before {\r\n  content: \"\\F12EC\";\r\n}\r\n\r\n.mdi-checkbox-blank-off-outline::before {\r\n  content: \"\\F12ED\";\r\n}\r\n\r\n.mdi-checkbox-blank-outline::before {\r\n  content: \"\\F0131\";\r\n}\r\n\r\n.mdi-checkbox-intermediate::before {\r\n  content: \"\\F0856\";\r\n}\r\n\r\n.mdi-checkbox-marked::before {\r\n  content: \"\\F0132\";\r\n}\r\n\r\n.mdi-checkbox-marked-circle::before {\r\n  content: \"\\F0133\";\r\n}\r\n\r\n.mdi-checkbox-marked-circle-outline::before {\r\n  content: \"\\F0134\";\r\n}\r\n\r\n.mdi-checkbox-marked-outline::before {\r\n  content: \"\\F0135\";\r\n}\r\n\r\n.mdi-checkbox-multiple-blank::before {\r\n  content: \"\\F0136\";\r\n}\r\n\r\n.mdi-checkbox-multiple-blank-circle::before {\r\n  content: \"\\F063B\";\r\n}\r\n\r\n.mdi-checkbox-multiple-blank-circle-outline::before {\r\n  content: \"\\F063C\";\r\n}\r\n\r\n.mdi-checkbox-multiple-blank-outline::before {\r\n  content: \"\\F0137\";\r\n}\r\n\r\n.mdi-checkbox-multiple-marked::before {\r\n  content: \"\\F0138\";\r\n}\r\n\r\n.mdi-checkbox-multiple-marked-circle::before {\r\n  content: \"\\F063D\";\r\n}\r\n\r\n.mdi-checkbox-multiple-marked-circle-outline::before {\r\n  content: \"\\F063E\";\r\n}\r\n\r\n.mdi-checkbox-multiple-marked-outline::before {\r\n  content: \"\\F0139\";\r\n}\r\n\r\n.mdi-checkerboard::before {\r\n  content: \"\\F013A\";\r\n}\r\n\r\n.mdi-checkerboard-minus::before {\r\n  content: \"\\F1202\";\r\n}\r\n\r\n.mdi-checkerboard-plus::before {\r\n  content: \"\\F1201\";\r\n}\r\n\r\n.mdi-checkerboard-remove::before {\r\n  content: \"\\F1203\";\r\n}\r\n\r\n.mdi-cheese::before {\r\n  content: \"\\F12B9\";\r\n}\r\n\r\n.mdi-cheese-off::before {\r\n  content: \"\\F13EE\";\r\n}\r\n\r\n.mdi-chef-hat::before {\r\n  content: \"\\F0B7C\";\r\n}\r\n\r\n.mdi-chemical-weapon::before {\r\n  content: \"\\F013B\";\r\n}\r\n\r\n.mdi-chess-bishop::before {\r\n  content: \"\\F085C\";\r\n}\r\n\r\n.mdi-chess-king::before {\r\n  content: \"\\F0857\";\r\n}\r\n\r\n.mdi-chess-knight::before {\r\n  content: \"\\F0858\";\r\n}\r\n\r\n.mdi-chess-pawn::before {\r\n  content: \"\\F0859\";\r\n}\r\n\r\n.mdi-chess-queen::before {\r\n  content: \"\\F085A\";\r\n}\r\n\r\n.mdi-chess-rook::before {\r\n  content: \"\\F085B\";\r\n}\r\n\r\n.mdi-chevron-double-down::before {\r\n  content: \"\\F013C\";\r\n}\r\n\r\n.mdi-chevron-double-left::before {\r\n  content: \"\\F013D\";\r\n}\r\n\r\n.mdi-chevron-double-right::before {\r\n  content: \"\\F013E\";\r\n}\r\n\r\n.mdi-chevron-double-up::before {\r\n  content: \"\\F013F\";\r\n}\r\n\r\n.mdi-chevron-down::before {\r\n  content: \"\\F0140\";\r\n}\r\n\r\n.mdi-chevron-down-box::before {\r\n  content: \"\\F09D6\";\r\n}\r\n\r\n.mdi-chevron-down-box-outline::before {\r\n  content: \"\\F09D7\";\r\n}\r\n\r\n.mdi-chevron-down-circle::before {\r\n  content: \"\\F0B26\";\r\n}\r\n\r\n.mdi-chevron-down-circle-outline::before {\r\n  content: \"\\F0B27\";\r\n}\r\n\r\n.mdi-chevron-left::before {\r\n  content: \"\\F0141\";\r\n}\r\n\r\n.mdi-chevron-left-box::before {\r\n  content: \"\\F09D8\";\r\n}\r\n\r\n.mdi-chevron-left-box-outline::before {\r\n  content: \"\\F09D9\";\r\n}\r\n\r\n.mdi-chevron-left-circle::before {\r\n  content: \"\\F0B28\";\r\n}\r\n\r\n.mdi-chevron-left-circle-outline::before {\r\n  content: \"\\F0B29\";\r\n}\r\n\r\n.mdi-chevron-right::before {\r\n  content: \"\\F0142\";\r\n}\r\n\r\n.mdi-chevron-right-box::before {\r\n  content: \"\\F09DA\";\r\n}\r\n\r\n.mdi-chevron-right-box-outline::before {\r\n  content: \"\\F09DB\";\r\n}\r\n\r\n.mdi-chevron-right-circle::before {\r\n  content: \"\\F0B2A\";\r\n}\r\n\r\n.mdi-chevron-right-circle-outline::before {\r\n  content: \"\\F0B2B\";\r\n}\r\n\r\n.mdi-chevron-triple-down::before {\r\n  content: \"\\F0DB9\";\r\n}\r\n\r\n.mdi-chevron-triple-left::before {\r\n  content: \"\\F0DBA\";\r\n}\r\n\r\n.mdi-chevron-triple-right::before {\r\n  content: \"\\F0DBB\";\r\n}\r\n\r\n.mdi-chevron-triple-up::before {\r\n  content: \"\\F0DBC\";\r\n}\r\n\r\n.mdi-chevron-up::before {\r\n  content: \"\\F0143\";\r\n}\r\n\r\n.mdi-chevron-up-box::before {\r\n  content: \"\\F09DC\";\r\n}\r\n\r\n.mdi-chevron-up-box-outline::before {\r\n  content: \"\\F09DD\";\r\n}\r\n\r\n.mdi-chevron-up-circle::before {\r\n  content: \"\\F0B2C\";\r\n}\r\n\r\n.mdi-chevron-up-circle-outline::before {\r\n  content: \"\\F0B2D\";\r\n}\r\n\r\n.mdi-chili-hot::before {\r\n  content: \"\\F07B2\";\r\n}\r\n\r\n.mdi-chili-medium::before {\r\n  content: \"\\F07B3\";\r\n}\r\n\r\n.mdi-chili-mild::before {\r\n  content: \"\\F07B4\";\r\n}\r\n\r\n.mdi-chili-off::before {\r\n  content: \"\\F1467\";\r\n}\r\n\r\n.mdi-chip::before {\r\n  content: \"\\F061A\";\r\n}\r\n\r\n.mdi-christianity::before {\r\n  content: \"\\F0953\";\r\n}\r\n\r\n.mdi-christianity-outline::before {\r\n  content: \"\\F0CF6\";\r\n}\r\n\r\n.mdi-church::before {\r\n  content: \"\\F0144\";\r\n}\r\n\r\n.mdi-cigar::before {\r\n  content: \"\\F1189\";\r\n}\r\n\r\n.mdi-cigar-off::before {\r\n  content: \"\\F141B\";\r\n}\r\n\r\n.mdi-circle::before {\r\n  content: \"\\F0765\";\r\n}\r\n\r\n.mdi-circle-box::before {\r\n  content: \"\\F15DC\";\r\n}\r\n\r\n.mdi-circle-box-outline::before {\r\n  content: \"\\F15DD\";\r\n}\r\n\r\n.mdi-circle-double::before {\r\n  content: \"\\F0E95\";\r\n}\r\n\r\n.mdi-circle-edit-outline::before {\r\n  content: \"\\F08D5\";\r\n}\r\n\r\n.mdi-circle-expand::before {\r\n  content: \"\\F0E96\";\r\n}\r\n\r\n.mdi-circle-half::before {\r\n  content: \"\\F1395\";\r\n}\r\n\r\n.mdi-circle-half-full::before {\r\n  content: \"\\F1396\";\r\n}\r\n\r\n.mdi-circle-medium::before {\r\n  content: \"\\F09DE\";\r\n}\r\n\r\n.mdi-circle-multiple::before {\r\n  content: \"\\F0B38\";\r\n}\r\n\r\n.mdi-circle-multiple-outline::before {\r\n  content: \"\\F0695\";\r\n}\r\n\r\n.mdi-circle-off-outline::before {\r\n  content: \"\\F10D3\";\r\n}\r\n\r\n.mdi-circle-outline::before {\r\n  content: \"\\F0766\";\r\n}\r\n\r\n.mdi-circle-slice-1::before {\r\n  content: \"\\F0A9E\";\r\n}\r\n\r\n.mdi-circle-slice-2::before {\r\n  content: \"\\F0A9F\";\r\n}\r\n\r\n.mdi-circle-slice-3::before {\r\n  content: \"\\F0AA0\";\r\n}\r\n\r\n.mdi-circle-slice-4::before {\r\n  content: \"\\F0AA1\";\r\n}\r\n\r\n.mdi-circle-slice-5::before {\r\n  content: \"\\F0AA2\";\r\n}\r\n\r\n.mdi-circle-slice-6::before {\r\n  content: \"\\F0AA3\";\r\n}\r\n\r\n.mdi-circle-slice-7::before {\r\n  content: \"\\F0AA4\";\r\n}\r\n\r\n.mdi-circle-slice-8::before {\r\n  content: \"\\F0AA5\";\r\n}\r\n\r\n.mdi-circle-small::before {\r\n  content: \"\\F09DF\";\r\n}\r\n\r\n.mdi-circular-saw::before {\r\n  content: \"\\F0E22\";\r\n}\r\n\r\n.mdi-city::before {\r\n  content: \"\\F0146\";\r\n}\r\n\r\n.mdi-city-variant::before {\r\n  content: \"\\F0A36\";\r\n}\r\n\r\n.mdi-city-variant-outline::before {\r\n  content: \"\\F0A37\";\r\n}\r\n\r\n.mdi-clipboard::before {\r\n  content: \"\\F0147\";\r\n}\r\n\r\n.mdi-clipboard-account::before {\r\n  content: \"\\F0148\";\r\n}\r\n\r\n.mdi-clipboard-account-outline::before {\r\n  content: \"\\F0C55\";\r\n}\r\n\r\n.mdi-clipboard-alert::before {\r\n  content: \"\\F0149\";\r\n}\r\n\r\n.mdi-clipboard-alert-outline::before {\r\n  content: \"\\F0CF7\";\r\n}\r\n\r\n.mdi-clipboard-arrow-down::before {\r\n  content: \"\\F014A\";\r\n}\r\n\r\n.mdi-clipboard-arrow-down-outline::before {\r\n  content: \"\\F0C56\";\r\n}\r\n\r\n.mdi-clipboard-arrow-left::before {\r\n  content: \"\\F014B\";\r\n}\r\n\r\n.mdi-clipboard-arrow-left-outline::before {\r\n  content: \"\\F0CF8\";\r\n}\r\n\r\n.mdi-clipboard-arrow-right::before {\r\n  content: \"\\F0CF9\";\r\n}\r\n\r\n.mdi-clipboard-arrow-right-outline::before {\r\n  content: \"\\F0CFA\";\r\n}\r\n\r\n.mdi-clipboard-arrow-up::before {\r\n  content: \"\\F0C57\";\r\n}\r\n\r\n.mdi-clipboard-arrow-up-outline::before {\r\n  content: \"\\F0C58\";\r\n}\r\n\r\n.mdi-clipboard-check::before {\r\n  content: \"\\F014E\";\r\n}\r\n\r\n.mdi-clipboard-check-multiple::before {\r\n  content: \"\\F1263\";\r\n}\r\n\r\n.mdi-clipboard-check-multiple-outline::before {\r\n  content: \"\\F1264\";\r\n}\r\n\r\n.mdi-clipboard-check-outline::before {\r\n  content: \"\\F08A8\";\r\n}\r\n\r\n.mdi-clipboard-edit::before {\r\n  content: \"\\F14E5\";\r\n}\r\n\r\n.mdi-clipboard-edit-outline::before {\r\n  content: \"\\F14E6\";\r\n}\r\n\r\n.mdi-clipboard-file::before {\r\n  content: \"\\F1265\";\r\n}\r\n\r\n.mdi-clipboard-file-outline::before {\r\n  content: \"\\F1266\";\r\n}\r\n\r\n.mdi-clipboard-flow::before {\r\n  content: \"\\F06C8\";\r\n}\r\n\r\n.mdi-clipboard-flow-outline::before {\r\n  content: \"\\F1117\";\r\n}\r\n\r\n.mdi-clipboard-list::before {\r\n  content: \"\\F10D4\";\r\n}\r\n\r\n.mdi-clipboard-list-outline::before {\r\n  content: \"\\F10D5\";\r\n}\r\n\r\n.mdi-clipboard-minus::before {\r\n  content: \"\\F1618\";\r\n}\r\n\r\n.mdi-clipboard-minus-outline::before {\r\n  content: \"\\F1619\";\r\n}\r\n\r\n.mdi-clipboard-multiple::before {\r\n  content: \"\\F1267\";\r\n}\r\n\r\n.mdi-clipboard-multiple-outline::before {\r\n  content: \"\\F1268\";\r\n}\r\n\r\n.mdi-clipboard-off::before {\r\n  content: \"\\F161A\";\r\n}\r\n\r\n.mdi-clipboard-off-outline::before {\r\n  content: \"\\F161B\";\r\n}\r\n\r\n.mdi-clipboard-outline::before {\r\n  content: \"\\F014C\";\r\n}\r\n\r\n.mdi-clipboard-play::before {\r\n  content: \"\\F0C59\";\r\n}\r\n\r\n.mdi-clipboard-play-multiple::before {\r\n  content: \"\\F1269\";\r\n}\r\n\r\n.mdi-clipboard-play-multiple-outline::before {\r\n  content: \"\\F126A\";\r\n}\r\n\r\n.mdi-clipboard-play-outline::before {\r\n  content: \"\\F0C5A\";\r\n}\r\n\r\n.mdi-clipboard-plus::before {\r\n  content: \"\\F0751\";\r\n}\r\n\r\n.mdi-clipboard-plus-outline::before {\r\n  content: \"\\F131F\";\r\n}\r\n\r\n.mdi-clipboard-pulse::before {\r\n  content: \"\\F085D\";\r\n}\r\n\r\n.mdi-clipboard-pulse-outline::before {\r\n  content: \"\\F085E\";\r\n}\r\n\r\n.mdi-clipboard-remove::before {\r\n  content: \"\\F161C\";\r\n}\r\n\r\n.mdi-clipboard-remove-outline::before {\r\n  content: \"\\F161D\";\r\n}\r\n\r\n.mdi-clipboard-search::before {\r\n  content: \"\\F161E\";\r\n}\r\n\r\n.mdi-clipboard-search-outline::before {\r\n  content: \"\\F161F\";\r\n}\r\n\r\n.mdi-clipboard-text::before {\r\n  content: \"\\F014D\";\r\n}\r\n\r\n.mdi-clipboard-text-multiple::before {\r\n  content: \"\\F126B\";\r\n}\r\n\r\n.mdi-clipboard-text-multiple-outline::before {\r\n  content: \"\\F126C\";\r\n}\r\n\r\n.mdi-clipboard-text-off::before {\r\n  content: \"\\F1620\";\r\n}\r\n\r\n.mdi-clipboard-text-off-outline::before {\r\n  content: \"\\F1621\";\r\n}\r\n\r\n.mdi-clipboard-text-outline::before {\r\n  content: \"\\F0A38\";\r\n}\r\n\r\n.mdi-clipboard-text-play::before {\r\n  content: \"\\F0C5B\";\r\n}\r\n\r\n.mdi-clipboard-text-play-outline::before {\r\n  content: \"\\F0C5C\";\r\n}\r\n\r\n.mdi-clipboard-text-search::before {\r\n  content: \"\\F1622\";\r\n}\r\n\r\n.mdi-clipboard-text-search-outline::before {\r\n  content: \"\\F1623\";\r\n}\r\n\r\n.mdi-clippy::before {\r\n  content: \"\\F014F\";\r\n}\r\n\r\n.mdi-clock::before {\r\n  content: \"\\F0954\";\r\n}\r\n\r\n.mdi-clock-alert::before {\r\n  content: \"\\F0955\";\r\n}\r\n\r\n.mdi-clock-alert-outline::before {\r\n  content: \"\\F05CE\";\r\n}\r\n\r\n.mdi-clock-check::before {\r\n  content: \"\\F0FA8\";\r\n}\r\n\r\n.mdi-clock-check-outline::before {\r\n  content: \"\\F0FA9\";\r\n}\r\n\r\n.mdi-clock-digital::before {\r\n  content: \"\\F0E97\";\r\n}\r\n\r\n.mdi-clock-end::before {\r\n  content: \"\\F0151\";\r\n}\r\n\r\n.mdi-clock-fast::before {\r\n  content: \"\\F0152\";\r\n}\r\n\r\n.mdi-clock-in::before {\r\n  content: \"\\F0153\";\r\n}\r\n\r\n.mdi-clock-out::before {\r\n  content: \"\\F0154\";\r\n}\r\n\r\n.mdi-clock-outline::before {\r\n  content: \"\\F0150\";\r\n}\r\n\r\n.mdi-clock-start::before {\r\n  content: \"\\F0155\";\r\n}\r\n\r\n.mdi-clock-time-eight::before {\r\n  content: \"\\F1446\";\r\n}\r\n\r\n.mdi-clock-time-eight-outline::before {\r\n  content: \"\\F1452\";\r\n}\r\n\r\n.mdi-clock-time-eleven::before {\r\n  content: \"\\F1449\";\r\n}\r\n\r\n.mdi-clock-time-eleven-outline::before {\r\n  content: \"\\F1455\";\r\n}\r\n\r\n.mdi-clock-time-five::before {\r\n  content: \"\\F1443\";\r\n}\r\n\r\n.mdi-clock-time-five-outline::before {\r\n  content: \"\\F144F\";\r\n}\r\n\r\n.mdi-clock-time-four::before {\r\n  content: \"\\F1442\";\r\n}\r\n\r\n.mdi-clock-time-four-outline::before {\r\n  content: \"\\F144E\";\r\n}\r\n\r\n.mdi-clock-time-nine::before {\r\n  content: \"\\F1447\";\r\n}\r\n\r\n.mdi-clock-time-nine-outline::before {\r\n  content: \"\\F1453\";\r\n}\r\n\r\n.mdi-clock-time-one::before {\r\n  content: \"\\F143F\";\r\n}\r\n\r\n.mdi-clock-time-one-outline::before {\r\n  content: \"\\F144B\";\r\n}\r\n\r\n.mdi-clock-time-seven::before {\r\n  content: \"\\F1445\";\r\n}\r\n\r\n.mdi-clock-time-seven-outline::before {\r\n  content: \"\\F1451\";\r\n}\r\n\r\n.mdi-clock-time-six::before {\r\n  content: \"\\F1444\";\r\n}\r\n\r\n.mdi-clock-time-six-outline::before {\r\n  content: \"\\F1450\";\r\n}\r\n\r\n.mdi-clock-time-ten::before {\r\n  content: \"\\F1448\";\r\n}\r\n\r\n.mdi-clock-time-ten-outline::before {\r\n  content: \"\\F1454\";\r\n}\r\n\r\n.mdi-clock-time-three::before {\r\n  content: \"\\F1441\";\r\n}\r\n\r\n.mdi-clock-time-three-outline::before {\r\n  content: \"\\F144D\";\r\n}\r\n\r\n.mdi-clock-time-twelve::before {\r\n  content: \"\\F144A\";\r\n}\r\n\r\n.mdi-clock-time-twelve-outline::before {\r\n  content: \"\\F1456\";\r\n}\r\n\r\n.mdi-clock-time-two::before {\r\n  content: \"\\F1440\";\r\n}\r\n\r\n.mdi-clock-time-two-outline::before {\r\n  content: \"\\F144C\";\r\n}\r\n\r\n.mdi-close::before {\r\n  content: \"\\F0156\";\r\n}\r\n\r\n.mdi-close-box::before {\r\n  content: \"\\F0157\";\r\n}\r\n\r\n.mdi-close-box-multiple::before {\r\n  content: \"\\F0C5D\";\r\n}\r\n\r\n.mdi-close-box-multiple-outline::before {\r\n  content: \"\\F0C5E\";\r\n}\r\n\r\n.mdi-close-box-outline::before {\r\n  content: \"\\F0158\";\r\n}\r\n\r\n.mdi-close-circle::before {\r\n  content: \"\\F0159\";\r\n}\r\n\r\n.mdi-close-circle-multiple::before {\r\n  content: \"\\F062A\";\r\n}\r\n\r\n.mdi-close-circle-multiple-outline::before {\r\n  content: \"\\F0883\";\r\n}\r\n\r\n.mdi-close-circle-outline::before {\r\n  content: \"\\F015A\";\r\n}\r\n\r\n.mdi-close-network::before {\r\n  content: \"\\F015B\";\r\n}\r\n\r\n.mdi-close-network-outline::before {\r\n  content: \"\\F0C5F\";\r\n}\r\n\r\n.mdi-close-octagon::before {\r\n  content: \"\\F015C\";\r\n}\r\n\r\n.mdi-close-octagon-outline::before {\r\n  content: \"\\F015D\";\r\n}\r\n\r\n.mdi-close-outline::before {\r\n  content: \"\\F06C9\";\r\n}\r\n\r\n.mdi-close-thick::before {\r\n  content: \"\\F1398\";\r\n}\r\n\r\n.mdi-closed-caption::before {\r\n  content: \"\\F015E\";\r\n}\r\n\r\n.mdi-closed-caption-outline::before {\r\n  content: \"\\F0DBD\";\r\n}\r\n\r\n.mdi-cloud::before {\r\n  content: \"\\F015F\";\r\n}\r\n\r\n.mdi-cloud-alert::before {\r\n  content: \"\\F09E0\";\r\n}\r\n\r\n.mdi-cloud-braces::before {\r\n  content: \"\\F07B5\";\r\n}\r\n\r\n.mdi-cloud-check::before {\r\n  content: \"\\F0160\";\r\n}\r\n\r\n.mdi-cloud-check-outline::before {\r\n  content: \"\\F12CC\";\r\n}\r\n\r\n.mdi-cloud-circle::before {\r\n  content: \"\\F0161\";\r\n}\r\n\r\n.mdi-cloud-download::before {\r\n  content: \"\\F0162\";\r\n}\r\n\r\n.mdi-cloud-download-outline::before {\r\n  content: \"\\F0B7D\";\r\n}\r\n\r\n.mdi-cloud-lock::before {\r\n  content: \"\\F11F1\";\r\n}\r\n\r\n.mdi-cloud-lock-outline::before {\r\n  content: \"\\F11F2\";\r\n}\r\n\r\n.mdi-cloud-off-outline::before {\r\n  content: \"\\F0164\";\r\n}\r\n\r\n.mdi-cloud-outline::before {\r\n  content: \"\\F0163\";\r\n}\r\n\r\n.mdi-cloud-print::before {\r\n  content: \"\\F0165\";\r\n}\r\n\r\n.mdi-cloud-print-outline::before {\r\n  content: \"\\F0166\";\r\n}\r\n\r\n.mdi-cloud-question::before {\r\n  content: \"\\F0A39\";\r\n}\r\n\r\n.mdi-cloud-refresh::before {\r\n  content: \"\\F052A\";\r\n}\r\n\r\n.mdi-cloud-search::before {\r\n  content: \"\\F0956\";\r\n}\r\n\r\n.mdi-cloud-search-outline::before {\r\n  content: \"\\F0957\";\r\n}\r\n\r\n.mdi-cloud-sync::before {\r\n  content: \"\\F063F\";\r\n}\r\n\r\n.mdi-cloud-sync-outline::before {\r\n  content: \"\\F12D6\";\r\n}\r\n\r\n.mdi-cloud-tags::before {\r\n  content: \"\\F07B6\";\r\n}\r\n\r\n.mdi-cloud-upload::before {\r\n  content: \"\\F0167\";\r\n}\r\n\r\n.mdi-cloud-upload-outline::before {\r\n  content: \"\\F0B7E\";\r\n}\r\n\r\n.mdi-clover::before {\r\n  content: \"\\F0816\";\r\n}\r\n\r\n.mdi-coach-lamp::before {\r\n  content: \"\\F1020\";\r\n}\r\n\r\n.mdi-coat-rack::before {\r\n  content: \"\\F109E\";\r\n}\r\n\r\n.mdi-code-array::before {\r\n  content: \"\\F0168\";\r\n}\r\n\r\n.mdi-code-braces::before {\r\n  content: \"\\F0169\";\r\n}\r\n\r\n.mdi-code-braces-box::before {\r\n  content: \"\\F10D6\";\r\n}\r\n\r\n.mdi-code-brackets::before {\r\n  content: \"\\F016A\";\r\n}\r\n\r\n.mdi-code-equal::before {\r\n  content: \"\\F016B\";\r\n}\r\n\r\n.mdi-code-greater-than::before {\r\n  content: \"\\F016C\";\r\n}\r\n\r\n.mdi-code-greater-than-or-equal::before {\r\n  content: \"\\F016D\";\r\n}\r\n\r\n.mdi-code-json::before {\r\n  content: \"\\F0626\";\r\n}\r\n\r\n.mdi-code-less-than::before {\r\n  content: \"\\F016E\";\r\n}\r\n\r\n.mdi-code-less-than-or-equal::before {\r\n  content: \"\\F016F\";\r\n}\r\n\r\n.mdi-code-not-equal::before {\r\n  content: \"\\F0170\";\r\n}\r\n\r\n.mdi-code-not-equal-variant::before {\r\n  content: \"\\F0171\";\r\n}\r\n\r\n.mdi-code-parentheses::before {\r\n  content: \"\\F0172\";\r\n}\r\n\r\n.mdi-code-parentheses-box::before {\r\n  content: \"\\F10D7\";\r\n}\r\n\r\n.mdi-code-string::before {\r\n  content: \"\\F0173\";\r\n}\r\n\r\n.mdi-code-tags::before {\r\n  content: \"\\F0174\";\r\n}\r\n\r\n.mdi-code-tags-check::before {\r\n  content: \"\\F0694\";\r\n}\r\n\r\n.mdi-codepen::before {\r\n  content: \"\\F0175\";\r\n}\r\n\r\n.mdi-coffee::before {\r\n  content: \"\\F0176\";\r\n}\r\n\r\n.mdi-coffee-maker::before {\r\n  content: \"\\F109F\";\r\n}\r\n\r\n.mdi-coffee-off::before {\r\n  content: \"\\F0FAA\";\r\n}\r\n\r\n.mdi-coffee-off-outline::before {\r\n  content: \"\\F0FAB\";\r\n}\r\n\r\n.mdi-coffee-outline::before {\r\n  content: \"\\F06CA\";\r\n}\r\n\r\n.mdi-coffee-to-go::before {\r\n  content: \"\\F0177\";\r\n}\r\n\r\n.mdi-coffee-to-go-outline::before {\r\n  content: \"\\F130E\";\r\n}\r\n\r\n.mdi-coffin::before {\r\n  content: \"\\F0B7F\";\r\n}\r\n\r\n.mdi-cog::before {\r\n  content: \"\\F0493\";\r\n}\r\n\r\n.mdi-cog-box::before {\r\n  content: \"\\F0494\";\r\n}\r\n\r\n.mdi-cog-clockwise::before {\r\n  content: \"\\F11DD\";\r\n}\r\n\r\n.mdi-cog-counterclockwise::before {\r\n  content: \"\\F11DE\";\r\n}\r\n\r\n.mdi-cog-off::before {\r\n  content: \"\\F13CE\";\r\n}\r\n\r\n.mdi-cog-off-outline::before {\r\n  content: \"\\F13CF\";\r\n}\r\n\r\n.mdi-cog-outline::before {\r\n  content: \"\\F08BB\";\r\n}\r\n\r\n.mdi-cog-refresh::before {\r\n  content: \"\\F145E\";\r\n}\r\n\r\n.mdi-cog-refresh-outline::before {\r\n  content: \"\\F145F\";\r\n}\r\n\r\n.mdi-cog-sync::before {\r\n  content: \"\\F1460\";\r\n}\r\n\r\n.mdi-cog-sync-outline::before {\r\n  content: \"\\F1461\";\r\n}\r\n\r\n.mdi-cog-transfer::before {\r\n  content: \"\\F105B\";\r\n}\r\n\r\n.mdi-cog-transfer-outline::before {\r\n  content: \"\\F105C\";\r\n}\r\n\r\n.mdi-cogs::before {\r\n  content: \"\\F08D6\";\r\n}\r\n\r\n.mdi-collage::before {\r\n  content: \"\\F0640\";\r\n}\r\n\r\n.mdi-collapse-all::before {\r\n  content: \"\\F0AA6\";\r\n}\r\n\r\n.mdi-collapse-all-outline::before {\r\n  content: \"\\F0AA7\";\r\n}\r\n\r\n.mdi-color-helper::before {\r\n  content: \"\\F0179\";\r\n}\r\n\r\n.mdi-comma::before {\r\n  content: \"\\F0E23\";\r\n}\r\n\r\n.mdi-comma-box::before {\r\n  content: \"\\F0E2B\";\r\n}\r\n\r\n.mdi-comma-box-outline::before {\r\n  content: \"\\F0E24\";\r\n}\r\n\r\n.mdi-comma-circle::before {\r\n  content: \"\\F0E25\";\r\n}\r\n\r\n.mdi-comma-circle-outline::before {\r\n  content: \"\\F0E26\";\r\n}\r\n\r\n.mdi-comment::before {\r\n  content: \"\\F017A\";\r\n}\r\n\r\n.mdi-comment-account::before {\r\n  content: \"\\F017B\";\r\n}\r\n\r\n.mdi-comment-account-outline::before {\r\n  content: \"\\F017C\";\r\n}\r\n\r\n.mdi-comment-alert::before {\r\n  content: \"\\F017D\";\r\n}\r\n\r\n.mdi-comment-alert-outline::before {\r\n  content: \"\\F017E\";\r\n}\r\n\r\n.mdi-comment-arrow-left::before {\r\n  content: \"\\F09E1\";\r\n}\r\n\r\n.mdi-comment-arrow-left-outline::before {\r\n  content: \"\\F09E2\";\r\n}\r\n\r\n.mdi-comment-arrow-right::before {\r\n  content: \"\\F09E3\";\r\n}\r\n\r\n.mdi-comment-arrow-right-outline::before {\r\n  content: \"\\F09E4\";\r\n}\r\n\r\n.mdi-comment-bookmark::before {\r\n  content: \"\\F15AE\";\r\n}\r\n\r\n.mdi-comment-bookmark-outline::before {\r\n  content: \"\\F15AF\";\r\n}\r\n\r\n.mdi-comment-check::before {\r\n  content: \"\\F017F\";\r\n}\r\n\r\n.mdi-comment-check-outline::before {\r\n  content: \"\\F0180\";\r\n}\r\n\r\n.mdi-comment-edit::before {\r\n  content: \"\\F11BF\";\r\n}\r\n\r\n.mdi-comment-edit-outline::before {\r\n  content: \"\\F12C4\";\r\n}\r\n\r\n.mdi-comment-eye::before {\r\n  content: \"\\F0A3A\";\r\n}\r\n\r\n.mdi-comment-eye-outline::before {\r\n  content: \"\\F0A3B\";\r\n}\r\n\r\n.mdi-comment-flash::before {\r\n  content: \"\\F15B0\";\r\n}\r\n\r\n.mdi-comment-flash-outline::before {\r\n  content: \"\\F15B1\";\r\n}\r\n\r\n.mdi-comment-minus::before {\r\n  content: \"\\F15DF\";\r\n}\r\n\r\n.mdi-comment-minus-outline::before {\r\n  content: \"\\F15E0\";\r\n}\r\n\r\n.mdi-comment-multiple::before {\r\n  content: \"\\F085F\";\r\n}\r\n\r\n.mdi-comment-multiple-outline::before {\r\n  content: \"\\F0181\";\r\n}\r\n\r\n.mdi-comment-off::before {\r\n  content: \"\\F15E1\";\r\n}\r\n\r\n.mdi-comment-off-outline::before {\r\n  content: \"\\F15E2\";\r\n}\r\n\r\n.mdi-comment-outline::before {\r\n  content: \"\\F0182\";\r\n}\r\n\r\n.mdi-comment-plus::before {\r\n  content: \"\\F09E5\";\r\n}\r\n\r\n.mdi-comment-plus-outline::before {\r\n  content: \"\\F0183\";\r\n}\r\n\r\n.mdi-comment-processing::before {\r\n  content: \"\\F0184\";\r\n}\r\n\r\n.mdi-comment-processing-outline::before {\r\n  content: \"\\F0185\";\r\n}\r\n\r\n.mdi-comment-question::before {\r\n  content: \"\\F0817\";\r\n}\r\n\r\n.mdi-comment-question-outline::before {\r\n  content: \"\\F0186\";\r\n}\r\n\r\n.mdi-comment-quote::before {\r\n  content: \"\\F1021\";\r\n}\r\n\r\n.mdi-comment-quote-outline::before {\r\n  content: \"\\F1022\";\r\n}\r\n\r\n.mdi-comment-remove::before {\r\n  content: \"\\F05DE\";\r\n}\r\n\r\n.mdi-comment-remove-outline::before {\r\n  content: \"\\F0187\";\r\n}\r\n\r\n.mdi-comment-search::before {\r\n  content: \"\\F0A3C\";\r\n}\r\n\r\n.mdi-comment-search-outline::before {\r\n  content: \"\\F0A3D\";\r\n}\r\n\r\n.mdi-comment-text::before {\r\n  content: \"\\F0188\";\r\n}\r\n\r\n.mdi-comment-text-multiple::before {\r\n  content: \"\\F0860\";\r\n}\r\n\r\n.mdi-comment-text-multiple-outline::before {\r\n  content: \"\\F0861\";\r\n}\r\n\r\n.mdi-comment-text-outline::before {\r\n  content: \"\\F0189\";\r\n}\r\n\r\n.mdi-compare::before {\r\n  content: \"\\F018A\";\r\n}\r\n\r\n.mdi-compare-horizontal::before {\r\n  content: \"\\F1492\";\r\n}\r\n\r\n.mdi-compare-vertical::before {\r\n  content: \"\\F1493\";\r\n}\r\n\r\n.mdi-compass::before {\r\n  content: \"\\F018B\";\r\n}\r\n\r\n.mdi-compass-off::before {\r\n  content: \"\\F0B80\";\r\n}\r\n\r\n.mdi-compass-off-outline::before {\r\n  content: \"\\F0B81\";\r\n}\r\n\r\n.mdi-compass-outline::before {\r\n  content: \"\\F018C\";\r\n}\r\n\r\n.mdi-compass-rose::before {\r\n  content: \"\\F1382\";\r\n}\r\n\r\n.mdi-concourse-ci::before {\r\n  content: \"\\F10A0\";\r\n}\r\n\r\n.mdi-connection::before {\r\n  content: \"\\F1616\";\r\n}\r\n\r\n.mdi-console::before {\r\n  content: \"\\F018D\";\r\n}\r\n\r\n.mdi-console-line::before {\r\n  content: \"\\F07B7\";\r\n}\r\n\r\n.mdi-console-network::before {\r\n  content: \"\\F08A9\";\r\n}\r\n\r\n.mdi-console-network-outline::before {\r\n  content: \"\\F0C60\";\r\n}\r\n\r\n.mdi-consolidate::before {\r\n  content: \"\\F10D8\";\r\n}\r\n\r\n.mdi-contactless-payment::before {\r\n  content: \"\\F0D6A\";\r\n}\r\n\r\n.mdi-contactless-payment-circle::before {\r\n  content: \"\\F0321\";\r\n}\r\n\r\n.mdi-contactless-payment-circle-outline::before {\r\n  content: \"\\F0408\";\r\n}\r\n\r\n.mdi-contacts::before {\r\n  content: \"\\F06CB\";\r\n}\r\n\r\n.mdi-contacts-outline::before {\r\n  content: \"\\F05B8\";\r\n}\r\n\r\n.mdi-contain::before {\r\n  content: \"\\F0A3E\";\r\n}\r\n\r\n.mdi-contain-end::before {\r\n  content: \"\\F0A3F\";\r\n}\r\n\r\n.mdi-contain-start::before {\r\n  content: \"\\F0A40\";\r\n}\r\n\r\n.mdi-content-copy::before {\r\n  content: \"\\F018F\";\r\n}\r\n\r\n.mdi-content-cut::before {\r\n  content: \"\\F0190\";\r\n}\r\n\r\n.mdi-content-duplicate::before {\r\n  content: \"\\F0191\";\r\n}\r\n\r\n.mdi-content-paste::before {\r\n  content: \"\\F0192\";\r\n}\r\n\r\n.mdi-content-save::before {\r\n  content: \"\\F0193\";\r\n}\r\n\r\n.mdi-content-save-alert::before {\r\n  content: \"\\F0F42\";\r\n}\r\n\r\n.mdi-content-save-alert-outline::before {\r\n  content: \"\\F0F43\";\r\n}\r\n\r\n.mdi-content-save-all::before {\r\n  content: \"\\F0194\";\r\n}\r\n\r\n.mdi-content-save-all-outline::before {\r\n  content: \"\\F0F44\";\r\n}\r\n\r\n.mdi-content-save-cog::before {\r\n  content: \"\\F145B\";\r\n}\r\n\r\n.mdi-content-save-cog-outline::before {\r\n  content: \"\\F145C\";\r\n}\r\n\r\n.mdi-content-save-edit::before {\r\n  content: \"\\F0CFB\";\r\n}\r\n\r\n.mdi-content-save-edit-outline::before {\r\n  content: \"\\F0CFC\";\r\n}\r\n\r\n.mdi-content-save-move::before {\r\n  content: \"\\F0E27\";\r\n}\r\n\r\n.mdi-content-save-move-outline::before {\r\n  content: \"\\F0E28\";\r\n}\r\n\r\n.mdi-content-save-off::before {\r\n  content: \"\\F1643\";\r\n}\r\n\r\n.mdi-content-save-off-outline::before {\r\n  content: \"\\F1644\";\r\n}\r\n\r\n.mdi-content-save-outline::before {\r\n  content: \"\\F0818\";\r\n}\r\n\r\n.mdi-content-save-settings::before {\r\n  content: \"\\F061B\";\r\n}\r\n\r\n.mdi-content-save-settings-outline::before {\r\n  content: \"\\F0B2E\";\r\n}\r\n\r\n.mdi-contrast::before {\r\n  content: \"\\F0195\";\r\n}\r\n\r\n.mdi-contrast-box::before {\r\n  content: \"\\F0196\";\r\n}\r\n\r\n.mdi-contrast-circle::before {\r\n  content: \"\\F0197\";\r\n}\r\n\r\n.mdi-controller-classic::before {\r\n  content: \"\\F0B82\";\r\n}\r\n\r\n.mdi-controller-classic-outline::before {\r\n  content: \"\\F0B83\";\r\n}\r\n\r\n.mdi-cookie::before {\r\n  content: \"\\F0198\";\r\n}\r\n\r\n.mdi-cookie-alert::before {\r\n  content: \"\\F16D0\";\r\n}\r\n\r\n.mdi-cookie-alert-outline::before {\r\n  content: \"\\F16D1\";\r\n}\r\n\r\n.mdi-cookie-check::before {\r\n  content: \"\\F16D2\";\r\n}\r\n\r\n.mdi-cookie-check-outline::before {\r\n  content: \"\\F16D3\";\r\n}\r\n\r\n.mdi-cookie-cog::before {\r\n  content: \"\\F16D4\";\r\n}\r\n\r\n.mdi-cookie-cog-outline::before {\r\n  content: \"\\F16D5\";\r\n}\r\n\r\n.mdi-cookie-minus::before {\r\n  content: \"\\F16DA\";\r\n}\r\n\r\n.mdi-cookie-minus-outline::before {\r\n  content: \"\\F16DB\";\r\n}\r\n\r\n.mdi-cookie-outline::before {\r\n  content: \"\\F16DE\";\r\n}\r\n\r\n.mdi-cookie-plus::before {\r\n  content: \"\\F16D6\";\r\n}\r\n\r\n.mdi-cookie-plus-outline::before {\r\n  content: \"\\F16D7\";\r\n}\r\n\r\n.mdi-cookie-remove::before {\r\n  content: \"\\F16D8\";\r\n}\r\n\r\n.mdi-cookie-remove-outline::before {\r\n  content: \"\\F16D9\";\r\n}\r\n\r\n.mdi-cookie-settings::before {\r\n  content: \"\\F16DC\";\r\n}\r\n\r\n.mdi-cookie-settings-outline::before {\r\n  content: \"\\F16DD\";\r\n}\r\n\r\n.mdi-coolant-temperature::before {\r\n  content: \"\\F03C8\";\r\n}\r\n\r\n.mdi-copyright::before {\r\n  content: \"\\F05E6\";\r\n}\r\n\r\n.mdi-cordova::before {\r\n  content: \"\\F0958\";\r\n}\r\n\r\n.mdi-corn::before {\r\n  content: \"\\F07B8\";\r\n}\r\n\r\n.mdi-corn-off::before {\r\n  content: \"\\F13EF\";\r\n}\r\n\r\n.mdi-cosine-wave::before {\r\n  content: \"\\F1479\";\r\n}\r\n\r\n.mdi-counter::before {\r\n  content: \"\\F0199\";\r\n}\r\n\r\n.mdi-cow::before {\r\n  content: \"\\F019A\";\r\n}\r\n\r\n.mdi-cpu-32-bit::before {\r\n  content: \"\\F0EDF\";\r\n}\r\n\r\n.mdi-cpu-64-bit::before {\r\n  content: \"\\F0EE0\";\r\n}\r\n\r\n.mdi-crane::before {\r\n  content: \"\\F0862\";\r\n}\r\n\r\n.mdi-creation::before {\r\n  content: \"\\F0674\";\r\n}\r\n\r\n.mdi-creative-commons::before {\r\n  content: \"\\F0D6B\";\r\n}\r\n\r\n.mdi-credit-card::before {\r\n  content: \"\\F0FEF\";\r\n}\r\n\r\n.mdi-credit-card-check::before {\r\n  content: \"\\F13D0\";\r\n}\r\n\r\n.mdi-credit-card-check-outline::before {\r\n  content: \"\\F13D1\";\r\n}\r\n\r\n.mdi-credit-card-clock::before {\r\n  content: \"\\F0EE1\";\r\n}\r\n\r\n.mdi-credit-card-clock-outline::before {\r\n  content: \"\\F0EE2\";\r\n}\r\n\r\n.mdi-credit-card-marker::before {\r\n  content: \"\\F06A8\";\r\n}\r\n\r\n.mdi-credit-card-marker-outline::before {\r\n  content: \"\\F0DBE\";\r\n}\r\n\r\n.mdi-credit-card-minus::before {\r\n  content: \"\\F0FAC\";\r\n}\r\n\r\n.mdi-credit-card-minus-outline::before {\r\n  content: \"\\F0FAD\";\r\n}\r\n\r\n.mdi-credit-card-multiple::before {\r\n  content: \"\\F0FF0\";\r\n}\r\n\r\n.mdi-credit-card-multiple-outline::before {\r\n  content: \"\\F019C\";\r\n}\r\n\r\n.mdi-credit-card-off::before {\r\n  content: \"\\F0FF1\";\r\n}\r\n\r\n.mdi-credit-card-off-outline::before {\r\n  content: \"\\F05E4\";\r\n}\r\n\r\n.mdi-credit-card-outline::before {\r\n  content: \"\\F019B\";\r\n}\r\n\r\n.mdi-credit-card-plus::before {\r\n  content: \"\\F0FF2\";\r\n}\r\n\r\n.mdi-credit-card-plus-outline::before {\r\n  content: \"\\F0676\";\r\n}\r\n\r\n.mdi-credit-card-refresh::before {\r\n  content: \"\\F1645\";\r\n}\r\n\r\n.mdi-credit-card-refresh-outline::before {\r\n  content: \"\\F1646\";\r\n}\r\n\r\n.mdi-credit-card-refund::before {\r\n  content: \"\\F0FF3\";\r\n}\r\n\r\n.mdi-credit-card-refund-outline::before {\r\n  content: \"\\F0AA8\";\r\n}\r\n\r\n.mdi-credit-card-remove::before {\r\n  content: \"\\F0FAE\";\r\n}\r\n\r\n.mdi-credit-card-remove-outline::before {\r\n  content: \"\\F0FAF\";\r\n}\r\n\r\n.mdi-credit-card-scan::before {\r\n  content: \"\\F0FF4\";\r\n}\r\n\r\n.mdi-credit-card-scan-outline::before {\r\n  content: \"\\F019D\";\r\n}\r\n\r\n.mdi-credit-card-search::before {\r\n  content: \"\\F1647\";\r\n}\r\n\r\n.mdi-credit-card-search-outline::before {\r\n  content: \"\\F1648\";\r\n}\r\n\r\n.mdi-credit-card-settings::before {\r\n  content: \"\\F0FF5\";\r\n}\r\n\r\n.mdi-credit-card-settings-outline::before {\r\n  content: \"\\F08D7\";\r\n}\r\n\r\n.mdi-credit-card-sync::before {\r\n  content: \"\\F1649\";\r\n}\r\n\r\n.mdi-credit-card-sync-outline::before {\r\n  content: \"\\F164A\";\r\n}\r\n\r\n.mdi-credit-card-wireless::before {\r\n  content: \"\\F0802\";\r\n}\r\n\r\n.mdi-credit-card-wireless-off::before {\r\n  content: \"\\F057A\";\r\n}\r\n\r\n.mdi-credit-card-wireless-off-outline::before {\r\n  content: \"\\F057B\";\r\n}\r\n\r\n.mdi-credit-card-wireless-outline::before {\r\n  content: \"\\F0D6C\";\r\n}\r\n\r\n.mdi-cricket::before {\r\n  content: \"\\F0D6D\";\r\n}\r\n\r\n.mdi-crop::before {\r\n  content: \"\\F019E\";\r\n}\r\n\r\n.mdi-crop-free::before {\r\n  content: \"\\F019F\";\r\n}\r\n\r\n.mdi-crop-landscape::before {\r\n  content: \"\\F01A0\";\r\n}\r\n\r\n.mdi-crop-portrait::before {\r\n  content: \"\\F01A1\";\r\n}\r\n\r\n.mdi-crop-rotate::before {\r\n  content: \"\\F0696\";\r\n}\r\n\r\n.mdi-crop-square::before {\r\n  content: \"\\F01A2\";\r\n}\r\n\r\n.mdi-crosshairs::before {\r\n  content: \"\\F01A3\";\r\n}\r\n\r\n.mdi-crosshairs-gps::before {\r\n  content: \"\\F01A4\";\r\n}\r\n\r\n.mdi-crosshairs-off::before {\r\n  content: \"\\F0F45\";\r\n}\r\n\r\n.mdi-crosshairs-question::before {\r\n  content: \"\\F1136\";\r\n}\r\n\r\n.mdi-crown::before {\r\n  content: \"\\F01A5\";\r\n}\r\n\r\n.mdi-crown-outline::before {\r\n  content: \"\\F11D0\";\r\n}\r\n\r\n.mdi-cryengine::before {\r\n  content: \"\\F0959\";\r\n}\r\n\r\n.mdi-crystal-ball::before {\r\n  content: \"\\F0B2F\";\r\n}\r\n\r\n.mdi-cube::before {\r\n  content: \"\\F01A6\";\r\n}\r\n\r\n.mdi-cube-off::before {\r\n  content: \"\\F141C\";\r\n}\r\n\r\n.mdi-cube-off-outline::before {\r\n  content: \"\\F141D\";\r\n}\r\n\r\n.mdi-cube-outline::before {\r\n  content: \"\\F01A7\";\r\n}\r\n\r\n.mdi-cube-scan::before {\r\n  content: \"\\F0B84\";\r\n}\r\n\r\n.mdi-cube-send::before {\r\n  content: \"\\F01A8\";\r\n}\r\n\r\n.mdi-cube-unfolded::before {\r\n  content: \"\\F01A9\";\r\n}\r\n\r\n.mdi-cup::before {\r\n  content: \"\\F01AA\";\r\n}\r\n\r\n.mdi-cup-off::before {\r\n  content: \"\\F05E5\";\r\n}\r\n\r\n.mdi-cup-off-outline::before {\r\n  content: \"\\F137D\";\r\n}\r\n\r\n.mdi-cup-outline::before {\r\n  content: \"\\F130F\";\r\n}\r\n\r\n.mdi-cup-water::before {\r\n  content: \"\\F01AB\";\r\n}\r\n\r\n.mdi-cupboard::before {\r\n  content: \"\\F0F46\";\r\n}\r\n\r\n.mdi-cupboard-outline::before {\r\n  content: \"\\F0F47\";\r\n}\r\n\r\n.mdi-cupcake::before {\r\n  content: \"\\F095A\";\r\n}\r\n\r\n.mdi-curling::before {\r\n  content: \"\\F0863\";\r\n}\r\n\r\n.mdi-currency-bdt::before {\r\n  content: \"\\F0864\";\r\n}\r\n\r\n.mdi-currency-brl::before {\r\n  content: \"\\F0B85\";\r\n}\r\n\r\n.mdi-currency-btc::before {\r\n  content: \"\\F01AC\";\r\n}\r\n\r\n.mdi-currency-cny::before {\r\n  content: \"\\F07BA\";\r\n}\r\n\r\n.mdi-currency-eth::before {\r\n  content: \"\\F07BB\";\r\n}\r\n\r\n.mdi-currency-eur::before {\r\n  content: \"\\F01AD\";\r\n}\r\n\r\n.mdi-currency-eur-off::before {\r\n  content: \"\\F1315\";\r\n}\r\n\r\n.mdi-currency-gbp::before {\r\n  content: \"\\F01AE\";\r\n}\r\n\r\n.mdi-currency-ils::before {\r\n  content: \"\\F0C61\";\r\n}\r\n\r\n.mdi-currency-inr::before {\r\n  content: \"\\F01AF\";\r\n}\r\n\r\n.mdi-currency-jpy::before {\r\n  content: \"\\F07BC\";\r\n}\r\n\r\n.mdi-currency-krw::before {\r\n  content: \"\\F07BD\";\r\n}\r\n\r\n.mdi-currency-kzt::before {\r\n  content: \"\\F0865\";\r\n}\r\n\r\n.mdi-currency-mnt::before {\r\n  content: \"\\F1512\";\r\n}\r\n\r\n.mdi-currency-ngn::before {\r\n  content: \"\\F01B0\";\r\n}\r\n\r\n.mdi-currency-php::before {\r\n  content: \"\\F09E6\";\r\n}\r\n\r\n.mdi-currency-rial::before {\r\n  content: \"\\F0E9C\";\r\n}\r\n\r\n.mdi-currency-rub::before {\r\n  content: \"\\F01B1\";\r\n}\r\n\r\n.mdi-currency-sign::before {\r\n  content: \"\\F07BE\";\r\n}\r\n\r\n.mdi-currency-try::before {\r\n  content: \"\\F01B2\";\r\n}\r\n\r\n.mdi-currency-twd::before {\r\n  content: \"\\F07BF\";\r\n}\r\n\r\n.mdi-currency-usd::before {\r\n  content: \"\\F01C1\";\r\n}\r\n\r\n.mdi-currency-usd-circle::before {\r\n  content: \"\\F116B\";\r\n}\r\n\r\n.mdi-currency-usd-circle-outline::before {\r\n  content: \"\\F0178\";\r\n}\r\n\r\n.mdi-currency-usd-off::before {\r\n  content: \"\\F067A\";\r\n}\r\n\r\n.mdi-current-ac::before {\r\n  content: \"\\F1480\";\r\n}\r\n\r\n.mdi-current-dc::before {\r\n  content: \"\\F095C\";\r\n}\r\n\r\n.mdi-cursor-default::before {\r\n  content: \"\\F01C0\";\r\n}\r\n\r\n.mdi-cursor-default-click::before {\r\n  content: \"\\F0CFD\";\r\n}\r\n\r\n.mdi-cursor-default-click-outline::before {\r\n  content: \"\\F0CFE\";\r\n}\r\n\r\n.mdi-cursor-default-gesture::before {\r\n  content: \"\\F1127\";\r\n}\r\n\r\n.mdi-cursor-default-gesture-outline::before {\r\n  content: \"\\F1128\";\r\n}\r\n\r\n.mdi-cursor-default-outline::before {\r\n  content: \"\\F01BF\";\r\n}\r\n\r\n.mdi-cursor-move::before {\r\n  content: \"\\F01BE\";\r\n}\r\n\r\n.mdi-cursor-pointer::before {\r\n  content: \"\\F01BD\";\r\n}\r\n\r\n.mdi-cursor-text::before {\r\n  content: \"\\F05E7\";\r\n}\r\n\r\n.mdi-dance-ballroom::before {\r\n  content: \"\\F15FB\";\r\n}\r\n\r\n.mdi-dance-pole::before {\r\n  content: \"\\F1578\";\r\n}\r\n\r\n.mdi-data-matrix::before {\r\n  content: \"\\F153C\";\r\n}\r\n\r\n.mdi-data-matrix-edit::before {\r\n  content: \"\\F153D\";\r\n}\r\n\r\n.mdi-data-matrix-minus::before {\r\n  content: \"\\F153E\";\r\n}\r\n\r\n.mdi-data-matrix-plus::before {\r\n  content: \"\\F153F\";\r\n}\r\n\r\n.mdi-data-matrix-remove::before {\r\n  content: \"\\F1540\";\r\n}\r\n\r\n.mdi-data-matrix-scan::before {\r\n  content: \"\\F1541\";\r\n}\r\n\r\n.mdi-database::before {\r\n  content: \"\\F01BC\";\r\n}\r\n\r\n.mdi-database-alert::before {\r\n  content: \"\\F163A\";\r\n}\r\n\r\n.mdi-database-alert-outline::before {\r\n  content: \"\\F1624\";\r\n}\r\n\r\n.mdi-database-arrow-down::before {\r\n  content: \"\\F163B\";\r\n}\r\n\r\n.mdi-database-arrow-down-outline::before {\r\n  content: \"\\F1625\";\r\n}\r\n\r\n.mdi-database-arrow-left::before {\r\n  content: \"\\F163C\";\r\n}\r\n\r\n.mdi-database-arrow-left-outline::before {\r\n  content: \"\\F1626\";\r\n}\r\n\r\n.mdi-database-arrow-right::before {\r\n  content: \"\\F163D\";\r\n}\r\n\r\n.mdi-database-arrow-right-outline::before {\r\n  content: \"\\F1627\";\r\n}\r\n\r\n.mdi-database-arrow-up::before {\r\n  content: \"\\F163E\";\r\n}\r\n\r\n.mdi-database-arrow-up-outline::before {\r\n  content: \"\\F1628\";\r\n}\r\n\r\n.mdi-database-check::before {\r\n  content: \"\\F0AA9\";\r\n}\r\n\r\n.mdi-database-check-outline::before {\r\n  content: \"\\F1629\";\r\n}\r\n\r\n.mdi-database-clock::before {\r\n  content: \"\\F163F\";\r\n}\r\n\r\n.mdi-database-clock-outline::before {\r\n  content: \"\\F162A\";\r\n}\r\n\r\n.mdi-database-cog::before {\r\n  content: \"\\F164B\";\r\n}\r\n\r\n.mdi-database-cog-outline::before {\r\n  content: \"\\F164C\";\r\n}\r\n\r\n.mdi-database-edit::before {\r\n  content: \"\\F0B86\";\r\n}\r\n\r\n.mdi-database-edit-outline::before {\r\n  content: \"\\F162B\";\r\n}\r\n\r\n.mdi-database-export::before {\r\n  content: \"\\F095E\";\r\n}\r\n\r\n.mdi-database-export-outline::before {\r\n  content: \"\\F162C\";\r\n}\r\n\r\n.mdi-database-import::before {\r\n  content: \"\\F095D\";\r\n}\r\n\r\n.mdi-database-import-outline::before {\r\n  content: \"\\F162D\";\r\n}\r\n\r\n.mdi-database-lock::before {\r\n  content: \"\\F0AAA\";\r\n}\r\n\r\n.mdi-database-lock-outline::before {\r\n  content: \"\\F162E\";\r\n}\r\n\r\n.mdi-database-marker::before {\r\n  content: \"\\F12F6\";\r\n}\r\n\r\n.mdi-database-marker-outline::before {\r\n  content: \"\\F162F\";\r\n}\r\n\r\n.mdi-database-minus::before {\r\n  content: \"\\F01BB\";\r\n}\r\n\r\n.mdi-database-minus-outline::before {\r\n  content: \"\\F1630\";\r\n}\r\n\r\n.mdi-database-off::before {\r\n  content: \"\\F1640\";\r\n}\r\n\r\n.mdi-database-off-outline::before {\r\n  content: \"\\F1631\";\r\n}\r\n\r\n.mdi-database-outline::before {\r\n  content: \"\\F1632\";\r\n}\r\n\r\n.mdi-database-plus::before {\r\n  content: \"\\F01BA\";\r\n}\r\n\r\n.mdi-database-plus-outline::before {\r\n  content: \"\\F1633\";\r\n}\r\n\r\n.mdi-database-refresh::before {\r\n  content: \"\\F05C2\";\r\n}\r\n\r\n.mdi-database-refresh-outline::before {\r\n  content: \"\\F1634\";\r\n}\r\n\r\n.mdi-database-remove::before {\r\n  content: \"\\F0D00\";\r\n}\r\n\r\n.mdi-database-remove-outline::before {\r\n  content: \"\\F1635\";\r\n}\r\n\r\n.mdi-database-search::before {\r\n  content: \"\\F0866\";\r\n}\r\n\r\n.mdi-database-search-outline::before {\r\n  content: \"\\F1636\";\r\n}\r\n\r\n.mdi-database-settings::before {\r\n  content: \"\\F0D01\";\r\n}\r\n\r\n.mdi-database-settings-outline::before {\r\n  content: \"\\F1637\";\r\n}\r\n\r\n.mdi-database-sync::before {\r\n  content: \"\\F0CFF\";\r\n}\r\n\r\n.mdi-database-sync-outline::before {\r\n  content: \"\\F1638\";\r\n}\r\n\r\n.mdi-death-star::before {\r\n  content: \"\\F08D8\";\r\n}\r\n\r\n.mdi-death-star-variant::before {\r\n  content: \"\\F08D9\";\r\n}\r\n\r\n.mdi-deathly-hallows::before {\r\n  content: \"\\F0B87\";\r\n}\r\n\r\n.mdi-debian::before {\r\n  content: \"\\F08DA\";\r\n}\r\n\r\n.mdi-debug-step-into::before {\r\n  content: \"\\F01B9\";\r\n}\r\n\r\n.mdi-debug-step-out::before {\r\n  content: \"\\F01B8\";\r\n}\r\n\r\n.mdi-debug-step-over::before {\r\n  content: \"\\F01B7\";\r\n}\r\n\r\n.mdi-decagram::before {\r\n  content: \"\\F076C\";\r\n}\r\n\r\n.mdi-decagram-outline::before {\r\n  content: \"\\F076D\";\r\n}\r\n\r\n.mdi-decimal::before {\r\n  content: \"\\F10A1\";\r\n}\r\n\r\n.mdi-decimal-comma::before {\r\n  content: \"\\F10A2\";\r\n}\r\n\r\n.mdi-decimal-comma-decrease::before {\r\n  content: \"\\F10A3\";\r\n}\r\n\r\n.mdi-decimal-comma-increase::before {\r\n  content: \"\\F10A4\";\r\n}\r\n\r\n.mdi-decimal-decrease::before {\r\n  content: \"\\F01B6\";\r\n}\r\n\r\n.mdi-decimal-increase::before {\r\n  content: \"\\F01B5\";\r\n}\r\n\r\n.mdi-delete::before {\r\n  content: \"\\F01B4\";\r\n}\r\n\r\n.mdi-delete-alert::before {\r\n  content: \"\\F10A5\";\r\n}\r\n\r\n.mdi-delete-alert-outline::before {\r\n  content: \"\\F10A6\";\r\n}\r\n\r\n.mdi-delete-circle::before {\r\n  content: \"\\F0683\";\r\n}\r\n\r\n.mdi-delete-circle-outline::before {\r\n  content: \"\\F0B88\";\r\n}\r\n\r\n.mdi-delete-clock::before {\r\n  content: \"\\F1556\";\r\n}\r\n\r\n.mdi-delete-clock-outline::before {\r\n  content: \"\\F1557\";\r\n}\r\n\r\n.mdi-delete-empty::before {\r\n  content: \"\\F06CC\";\r\n}\r\n\r\n.mdi-delete-empty-outline::before {\r\n  content: \"\\F0E9D\";\r\n}\r\n\r\n.mdi-delete-forever::before {\r\n  content: \"\\F05E8\";\r\n}\r\n\r\n.mdi-delete-forever-outline::before {\r\n  content: \"\\F0B89\";\r\n}\r\n\r\n.mdi-delete-off::before {\r\n  content: \"\\F10A7\";\r\n}\r\n\r\n.mdi-delete-off-outline::before {\r\n  content: \"\\F10A8\";\r\n}\r\n\r\n.mdi-delete-outline::before {\r\n  content: \"\\F09E7\";\r\n}\r\n\r\n.mdi-delete-restore::before {\r\n  content: \"\\F0819\";\r\n}\r\n\r\n.mdi-delete-sweep::before {\r\n  content: \"\\F05E9\";\r\n}\r\n\r\n.mdi-delete-sweep-outline::before {\r\n  content: \"\\F0C62\";\r\n}\r\n\r\n.mdi-delete-variant::before {\r\n  content: \"\\F01B3\";\r\n}\r\n\r\n.mdi-delta::before {\r\n  content: \"\\F01C2\";\r\n}\r\n\r\n.mdi-desk::before {\r\n  content: \"\\F1239\";\r\n}\r\n\r\n.mdi-desk-lamp::before {\r\n  content: \"\\F095F\";\r\n}\r\n\r\n.mdi-deskphone::before {\r\n  content: \"\\F01C3\";\r\n}\r\n\r\n.mdi-desktop-classic::before {\r\n  content: \"\\F07C0\";\r\n}\r\n\r\n.mdi-desktop-mac::before {\r\n  content: \"\\F01C4\";\r\n}\r\n\r\n.mdi-desktop-mac-dashboard::before {\r\n  content: \"\\F09E8\";\r\n}\r\n\r\n.mdi-desktop-tower::before {\r\n  content: \"\\F01C5\";\r\n}\r\n\r\n.mdi-desktop-tower-monitor::before {\r\n  content: \"\\F0AAB\";\r\n}\r\n\r\n.mdi-details::before {\r\n  content: \"\\F01C6\";\r\n}\r\n\r\n.mdi-dev-to::before {\r\n  content: \"\\F0D6E\";\r\n}\r\n\r\n.mdi-developer-board::before {\r\n  content: \"\\F0697\";\r\n}\r\n\r\n.mdi-deviantart::before {\r\n  content: \"\\F01C7\";\r\n}\r\n\r\n.mdi-devices::before {\r\n  content: \"\\F0FB0\";\r\n}\r\n\r\n.mdi-diabetes::before {\r\n  content: \"\\F1126\";\r\n}\r\n\r\n.mdi-dialpad::before {\r\n  content: \"\\F061C\";\r\n}\r\n\r\n.mdi-diameter::before {\r\n  content: \"\\F0C63\";\r\n}\r\n\r\n.mdi-diameter-outline::before {\r\n  content: \"\\F0C64\";\r\n}\r\n\r\n.mdi-diameter-variant::before {\r\n  content: \"\\F0C65\";\r\n}\r\n\r\n.mdi-diamond::before {\r\n  content: \"\\F0B8A\";\r\n}\r\n\r\n.mdi-diamond-outline::before {\r\n  content: \"\\F0B8B\";\r\n}\r\n\r\n.mdi-diamond-stone::before {\r\n  content: \"\\F01C8\";\r\n}\r\n\r\n.mdi-dice-1::before {\r\n  content: \"\\F01CA\";\r\n}\r\n\r\n.mdi-dice-1-outline::before {\r\n  content: \"\\F114A\";\r\n}\r\n\r\n.mdi-dice-2::before {\r\n  content: \"\\F01CB\";\r\n}\r\n\r\n.mdi-dice-2-outline::before {\r\n  content: \"\\F114B\";\r\n}\r\n\r\n.mdi-dice-3::before {\r\n  content: \"\\F01CC\";\r\n}\r\n\r\n.mdi-dice-3-outline::before {\r\n  content: \"\\F114C\";\r\n}\r\n\r\n.mdi-dice-4::before {\r\n  content: \"\\F01CD\";\r\n}\r\n\r\n.mdi-dice-4-outline::before {\r\n  content: \"\\F114D\";\r\n}\r\n\r\n.mdi-dice-5::before {\r\n  content: \"\\F01CE\";\r\n}\r\n\r\n.mdi-dice-5-outline::before {\r\n  content: \"\\F114E\";\r\n}\r\n\r\n.mdi-dice-6::before {\r\n  content: \"\\F01CF\";\r\n}\r\n\r\n.mdi-dice-6-outline::before {\r\n  content: \"\\F114F\";\r\n}\r\n\r\n.mdi-dice-d10::before {\r\n  content: \"\\F1153\";\r\n}\r\n\r\n.mdi-dice-d10-outline::before {\r\n  content: \"\\F076F\";\r\n}\r\n\r\n.mdi-dice-d12::before {\r\n  content: \"\\F1154\";\r\n}\r\n\r\n.mdi-dice-d12-outline::before {\r\n  content: \"\\F0867\";\r\n}\r\n\r\n.mdi-dice-d20::before {\r\n  content: \"\\F1155\";\r\n}\r\n\r\n.mdi-dice-d20-outline::before {\r\n  content: \"\\F05EA\";\r\n}\r\n\r\n.mdi-dice-d4::before {\r\n  content: \"\\F1150\";\r\n}\r\n\r\n.mdi-dice-d4-outline::before {\r\n  content: \"\\F05EB\";\r\n}\r\n\r\n.mdi-dice-d6::before {\r\n  content: \"\\F1151\";\r\n}\r\n\r\n.mdi-dice-d6-outline::before {\r\n  content: \"\\F05ED\";\r\n}\r\n\r\n.mdi-dice-d8::before {\r\n  content: \"\\F1152\";\r\n}\r\n\r\n.mdi-dice-d8-outline::before {\r\n  content: \"\\F05EC\";\r\n}\r\n\r\n.mdi-dice-multiple::before {\r\n  content: \"\\F076E\";\r\n}\r\n\r\n.mdi-dice-multiple-outline::before {\r\n  content: \"\\F1156\";\r\n}\r\n\r\n.mdi-digital-ocean::before {\r\n  content: \"\\F1237\";\r\n}\r\n\r\n.mdi-dip-switch::before {\r\n  content: \"\\F07C1\";\r\n}\r\n\r\n.mdi-directions::before {\r\n  content: \"\\F01D0\";\r\n}\r\n\r\n.mdi-directions-fork::before {\r\n  content: \"\\F0641\";\r\n}\r\n\r\n.mdi-disc::before {\r\n  content: \"\\F05EE\";\r\n}\r\n\r\n.mdi-disc-alert::before {\r\n  content: \"\\F01D1\";\r\n}\r\n\r\n.mdi-disc-player::before {\r\n  content: \"\\F0960\";\r\n}\r\n\r\n.mdi-discord::before {\r\n  content: \"\\F066F\";\r\n}\r\n\r\n.mdi-dishwasher::before {\r\n  content: \"\\F0AAC\";\r\n}\r\n\r\n.mdi-dishwasher-alert::before {\r\n  content: \"\\F11B8\";\r\n}\r\n\r\n.mdi-dishwasher-off::before {\r\n  content: \"\\F11B9\";\r\n}\r\n\r\n.mdi-disqus::before {\r\n  content: \"\\F01D2\";\r\n}\r\n\r\n.mdi-distribute-horizontal-center::before {\r\n  content: \"\\F11C9\";\r\n}\r\n\r\n.mdi-distribute-horizontal-left::before {\r\n  content: \"\\F11C8\";\r\n}\r\n\r\n.mdi-distribute-horizontal-right::before {\r\n  content: \"\\F11CA\";\r\n}\r\n\r\n.mdi-distribute-vertical-bottom::before {\r\n  content: \"\\F11CB\";\r\n}\r\n\r\n.mdi-distribute-vertical-center::before {\r\n  content: \"\\F11CC\";\r\n}\r\n\r\n.mdi-distribute-vertical-top::before {\r\n  content: \"\\F11CD\";\r\n}\r\n\r\n.mdi-diving-flippers::before {\r\n  content: \"\\F0DBF\";\r\n}\r\n\r\n.mdi-diving-helmet::before {\r\n  content: \"\\F0DC0\";\r\n}\r\n\r\n.mdi-diving-scuba::before {\r\n  content: \"\\F0DC1\";\r\n}\r\n\r\n.mdi-diving-scuba-flag::before {\r\n  content: \"\\F0DC2\";\r\n}\r\n\r\n.mdi-diving-scuba-tank::before {\r\n  content: \"\\F0DC3\";\r\n}\r\n\r\n.mdi-diving-scuba-tank-multiple::before {\r\n  content: \"\\F0DC4\";\r\n}\r\n\r\n.mdi-diving-snorkel::before {\r\n  content: \"\\F0DC5\";\r\n}\r\n\r\n.mdi-division::before {\r\n  content: \"\\F01D4\";\r\n}\r\n\r\n.mdi-division-box::before {\r\n  content: \"\\F01D5\";\r\n}\r\n\r\n.mdi-dlna::before {\r\n  content: \"\\F0A41\";\r\n}\r\n\r\n.mdi-dna::before {\r\n  content: \"\\F0684\";\r\n}\r\n\r\n.mdi-dns::before {\r\n  content: \"\\F01D6\";\r\n}\r\n\r\n.mdi-dns-outline::before {\r\n  content: \"\\F0B8C\";\r\n}\r\n\r\n.mdi-do-not-disturb::before {\r\n  content: \"\\F0698\";\r\n}\r\n\r\n.mdi-do-not-disturb-off::before {\r\n  content: \"\\F0699\";\r\n}\r\n\r\n.mdi-dock-bottom::before {\r\n  content: \"\\F10A9\";\r\n}\r\n\r\n.mdi-dock-left::before {\r\n  content: \"\\F10AA\";\r\n}\r\n\r\n.mdi-dock-right::before {\r\n  content: \"\\F10AB\";\r\n}\r\n\r\n.mdi-dock-top::before {\r\n  content: \"\\F1513\";\r\n}\r\n\r\n.mdi-dock-window::before {\r\n  content: \"\\F10AC\";\r\n}\r\n\r\n.mdi-docker::before {\r\n  content: \"\\F0868\";\r\n}\r\n\r\n.mdi-doctor::before {\r\n  content: \"\\F0A42\";\r\n}\r\n\r\n.mdi-dog::before {\r\n  content: \"\\F0A43\";\r\n}\r\n\r\n.mdi-dog-service::before {\r\n  content: \"\\F0AAD\";\r\n}\r\n\r\n.mdi-dog-side::before {\r\n  content: \"\\F0A44\";\r\n}\r\n\r\n.mdi-dolby::before {\r\n  content: \"\\F06B3\";\r\n}\r\n\r\n.mdi-dolly::before {\r\n  content: \"\\F0E9E\";\r\n}\r\n\r\n.mdi-domain::before {\r\n  content: \"\\F01D7\";\r\n}\r\n\r\n.mdi-domain-off::before {\r\n  content: \"\\F0D6F\";\r\n}\r\n\r\n.mdi-domain-plus::before {\r\n  content: \"\\F10AD\";\r\n}\r\n\r\n.mdi-domain-remove::before {\r\n  content: \"\\F10AE\";\r\n}\r\n\r\n.mdi-dome-light::before {\r\n  content: \"\\F141E\";\r\n}\r\n\r\n.mdi-domino-mask::before {\r\n  content: \"\\F1023\";\r\n}\r\n\r\n.mdi-donkey::before {\r\n  content: \"\\F07C2\";\r\n}\r\n\r\n.mdi-door::before {\r\n  content: \"\\F081A\";\r\n}\r\n\r\n.mdi-door-closed::before {\r\n  content: \"\\F081B\";\r\n}\r\n\r\n.mdi-door-closed-lock::before {\r\n  content: \"\\F10AF\";\r\n}\r\n\r\n.mdi-door-open::before {\r\n  content: \"\\F081C\";\r\n}\r\n\r\n.mdi-doorbell::before {\r\n  content: \"\\F12E6\";\r\n}\r\n\r\n.mdi-doorbell-video::before {\r\n  content: \"\\F0869\";\r\n}\r\n\r\n.mdi-dot-net::before {\r\n  content: \"\\F0AAE\";\r\n}\r\n\r\n.mdi-dots-grid::before {\r\n  content: \"\\F15FC\";\r\n}\r\n\r\n.mdi-dots-hexagon::before {\r\n  content: \"\\F15FF\";\r\n}\r\n\r\n.mdi-dots-horizontal::before {\r\n  content: \"\\F01D8\";\r\n}\r\n\r\n.mdi-dots-horizontal-circle::before {\r\n  content: \"\\F07C3\";\r\n}\r\n\r\n.mdi-dots-horizontal-circle-outline::before {\r\n  content: \"\\F0B8D\";\r\n}\r\n\r\n.mdi-dots-square::before {\r\n  content: \"\\F15FD\";\r\n}\r\n\r\n.mdi-dots-triangle::before {\r\n  content: \"\\F15FE\";\r\n}\r\n\r\n.mdi-dots-vertical::before {\r\n  content: \"\\F01D9\";\r\n}\r\n\r\n.mdi-dots-vertical-circle::before {\r\n  content: \"\\F07C4\";\r\n}\r\n\r\n.mdi-dots-vertical-circle-outline::before {\r\n  content: \"\\F0B8E\";\r\n}\r\n\r\n.mdi-douban::before {\r\n  content: \"\\F069A\";\r\n}\r\n\r\n.mdi-download::before {\r\n  content: \"\\F01DA\";\r\n}\r\n\r\n.mdi-download-box::before {\r\n  content: \"\\F1462\";\r\n}\r\n\r\n.mdi-download-box-outline::before {\r\n  content: \"\\F1463\";\r\n}\r\n\r\n.mdi-download-circle::before {\r\n  content: \"\\F1464\";\r\n}\r\n\r\n.mdi-download-circle-outline::before {\r\n  content: \"\\F1465\";\r\n}\r\n\r\n.mdi-download-lock::before {\r\n  content: \"\\F1320\";\r\n}\r\n\r\n.mdi-download-lock-outline::before {\r\n  content: \"\\F1321\";\r\n}\r\n\r\n.mdi-download-multiple::before {\r\n  content: \"\\F09E9\";\r\n}\r\n\r\n.mdi-download-network::before {\r\n  content: \"\\F06F4\";\r\n}\r\n\r\n.mdi-download-network-outline::before {\r\n  content: \"\\F0C66\";\r\n}\r\n\r\n.mdi-download-off::before {\r\n  content: \"\\F10B0\";\r\n}\r\n\r\n.mdi-download-off-outline::before {\r\n  content: \"\\F10B1\";\r\n}\r\n\r\n.mdi-download-outline::before {\r\n  content: \"\\F0B8F\";\r\n}\r\n\r\n.mdi-drag::before {\r\n  content: \"\\F01DB\";\r\n}\r\n\r\n.mdi-drag-horizontal::before {\r\n  content: \"\\F01DC\";\r\n}\r\n\r\n.mdi-drag-horizontal-variant::before {\r\n  content: \"\\F12F0\";\r\n}\r\n\r\n.mdi-drag-variant::before {\r\n  content: \"\\F0B90\";\r\n}\r\n\r\n.mdi-drag-vertical::before {\r\n  content: \"\\F01DD\";\r\n}\r\n\r\n.mdi-drag-vertical-variant::before {\r\n  content: \"\\F12F1\";\r\n}\r\n\r\n.mdi-drama-masks::before {\r\n  content: \"\\F0D02\";\r\n}\r\n\r\n.mdi-draw::before {\r\n  content: \"\\F0F49\";\r\n}\r\n\r\n.mdi-drawing::before {\r\n  content: \"\\F01DE\";\r\n}\r\n\r\n.mdi-drawing-box::before {\r\n  content: \"\\F01DF\";\r\n}\r\n\r\n.mdi-dresser::before {\r\n  content: \"\\F0F4A\";\r\n}\r\n\r\n.mdi-dresser-outline::before {\r\n  content: \"\\F0F4B\";\r\n}\r\n\r\n.mdi-drone::before {\r\n  content: \"\\F01E2\";\r\n}\r\n\r\n.mdi-dropbox::before {\r\n  content: \"\\F01E3\";\r\n}\r\n\r\n.mdi-drupal::before {\r\n  content: \"\\F01E4\";\r\n}\r\n\r\n.mdi-duck::before {\r\n  content: \"\\F01E5\";\r\n}\r\n\r\n.mdi-dumbbell::before {\r\n  content: \"\\F01E6\";\r\n}\r\n\r\n.mdi-dump-truck::before {\r\n  content: \"\\F0C67\";\r\n}\r\n\r\n.mdi-ear-hearing::before {\r\n  content: \"\\F07C5\";\r\n}\r\n\r\n.mdi-ear-hearing-off::before {\r\n  content: \"\\F0A45\";\r\n}\r\n\r\n.mdi-earth::before {\r\n  content: \"\\F01E7\";\r\n}\r\n\r\n.mdi-earth-arrow-right::before {\r\n  content: \"\\F1311\";\r\n}\r\n\r\n.mdi-earth-box::before {\r\n  content: \"\\F06CD\";\r\n}\r\n\r\n.mdi-earth-box-minus::before {\r\n  content: \"\\F1407\";\r\n}\r\n\r\n.mdi-earth-box-off::before {\r\n  content: \"\\F06CE\";\r\n}\r\n\r\n.mdi-earth-box-plus::before {\r\n  content: \"\\F1406\";\r\n}\r\n\r\n.mdi-earth-box-remove::before {\r\n  content: \"\\F1408\";\r\n}\r\n\r\n.mdi-earth-minus::before {\r\n  content: \"\\F1404\";\r\n}\r\n\r\n.mdi-earth-off::before {\r\n  content: \"\\F01E8\";\r\n}\r\n\r\n.mdi-earth-plus::before {\r\n  content: \"\\F1403\";\r\n}\r\n\r\n.mdi-earth-remove::before {\r\n  content: \"\\F1405\";\r\n}\r\n\r\n.mdi-egg::before {\r\n  content: \"\\F0AAF\";\r\n}\r\n\r\n.mdi-egg-easter::before {\r\n  content: \"\\F0AB0\";\r\n}\r\n\r\n.mdi-egg-off::before {\r\n  content: \"\\F13F0\";\r\n}\r\n\r\n.mdi-egg-off-outline::before {\r\n  content: \"\\F13F1\";\r\n}\r\n\r\n.mdi-egg-outline::before {\r\n  content: \"\\F13F2\";\r\n}\r\n\r\n.mdi-eiffel-tower::before {\r\n  content: \"\\F156B\";\r\n}\r\n\r\n.mdi-eight-track::before {\r\n  content: \"\\F09EA\";\r\n}\r\n\r\n.mdi-eject::before {\r\n  content: \"\\F01EA\";\r\n}\r\n\r\n.mdi-eject-outline::before {\r\n  content: \"\\F0B91\";\r\n}\r\n\r\n.mdi-electric-switch::before {\r\n  content: \"\\F0E9F\";\r\n}\r\n\r\n.mdi-electric-switch-closed::before {\r\n  content: \"\\F10D9\";\r\n}\r\n\r\n.mdi-electron-framework::before {\r\n  content: \"\\F1024\";\r\n}\r\n\r\n.mdi-elephant::before {\r\n  content: \"\\F07C6\";\r\n}\r\n\r\n.mdi-elevation-decline::before {\r\n  content: \"\\F01EB\";\r\n}\r\n\r\n.mdi-elevation-rise::before {\r\n  content: \"\\F01EC\";\r\n}\r\n\r\n.mdi-elevator::before {\r\n  content: \"\\F01ED\";\r\n}\r\n\r\n.mdi-elevator-down::before {\r\n  content: \"\\F12C2\";\r\n}\r\n\r\n.mdi-elevator-passenger::before {\r\n  content: \"\\F1381\";\r\n}\r\n\r\n.mdi-elevator-up::before {\r\n  content: \"\\F12C1\";\r\n}\r\n\r\n.mdi-ellipse::before {\r\n  content: \"\\F0EA0\";\r\n}\r\n\r\n.mdi-ellipse-outline::before {\r\n  content: \"\\F0EA1\";\r\n}\r\n\r\n.mdi-email::before {\r\n  content: \"\\F01EE\";\r\n}\r\n\r\n.mdi-email-alert::before {\r\n  content: \"\\F06CF\";\r\n}\r\n\r\n.mdi-email-alert-outline::before {\r\n  content: \"\\F0D42\";\r\n}\r\n\r\n.mdi-email-box::before {\r\n  content: \"\\F0D03\";\r\n}\r\n\r\n.mdi-email-check::before {\r\n  content: \"\\F0AB1\";\r\n}\r\n\r\n.mdi-email-check-outline::before {\r\n  content: \"\\F0AB2\";\r\n}\r\n\r\n.mdi-email-edit::before {\r\n  content: \"\\F0EE3\";\r\n}\r\n\r\n.mdi-email-edit-outline::before {\r\n  content: \"\\F0EE4\";\r\n}\r\n\r\n.mdi-email-lock::before {\r\n  content: \"\\F01F1\";\r\n}\r\n\r\n.mdi-email-mark-as-unread::before {\r\n  content: \"\\F0B92\";\r\n}\r\n\r\n.mdi-email-minus::before {\r\n  content: \"\\F0EE5\";\r\n}\r\n\r\n.mdi-email-minus-outline::before {\r\n  content: \"\\F0EE6\";\r\n}\r\n\r\n.mdi-email-multiple::before {\r\n  content: \"\\F0EE7\";\r\n}\r\n\r\n.mdi-email-multiple-outline::before {\r\n  content: \"\\F0EE8\";\r\n}\r\n\r\n.mdi-email-newsletter::before {\r\n  content: \"\\F0FB1\";\r\n}\r\n\r\n.mdi-email-off::before {\r\n  content: \"\\F13E3\";\r\n}\r\n\r\n.mdi-email-off-outline::before {\r\n  content: \"\\F13E4\";\r\n}\r\n\r\n.mdi-email-open::before {\r\n  content: \"\\F01EF\";\r\n}\r\n\r\n.mdi-email-open-multiple::before {\r\n  content: \"\\F0EE9\";\r\n}\r\n\r\n.mdi-email-open-multiple-outline::before {\r\n  content: \"\\F0EEA\";\r\n}\r\n\r\n.mdi-email-open-outline::before {\r\n  content: \"\\F05EF\";\r\n}\r\n\r\n.mdi-email-outline::before {\r\n  content: \"\\F01F0\";\r\n}\r\n\r\n.mdi-email-plus::before {\r\n  content: \"\\F09EB\";\r\n}\r\n\r\n.mdi-email-plus-outline::before {\r\n  content: \"\\F09EC\";\r\n}\r\n\r\n.mdi-email-receive::before {\r\n  content: \"\\F10DA\";\r\n}\r\n\r\n.mdi-email-receive-outline::before {\r\n  content: \"\\F10DB\";\r\n}\r\n\r\n.mdi-email-remove::before {\r\n  content: \"\\F1661\";\r\n}\r\n\r\n.mdi-email-remove-outline::before {\r\n  content: \"\\F1662\";\r\n}\r\n\r\n.mdi-email-search::before {\r\n  content: \"\\F0961\";\r\n}\r\n\r\n.mdi-email-search-outline::before {\r\n  content: \"\\F0962\";\r\n}\r\n\r\n.mdi-email-send::before {\r\n  content: \"\\F10DC\";\r\n}\r\n\r\n.mdi-email-send-outline::before {\r\n  content: \"\\F10DD\";\r\n}\r\n\r\n.mdi-email-sync::before {\r\n  content: \"\\F12C7\";\r\n}\r\n\r\n.mdi-email-sync-outline::before {\r\n  content: \"\\F12C8\";\r\n}\r\n\r\n.mdi-email-variant::before {\r\n  content: \"\\F05F0\";\r\n}\r\n\r\n.mdi-ember::before {\r\n  content: \"\\F0B30\";\r\n}\r\n\r\n.mdi-emby::before {\r\n  content: \"\\F06B4\";\r\n}\r\n\r\n.mdi-emoticon::before {\r\n  content: \"\\F0C68\";\r\n}\r\n\r\n.mdi-emoticon-angry::before {\r\n  content: \"\\F0C69\";\r\n}\r\n\r\n.mdi-emoticon-angry-outline::before {\r\n  content: \"\\F0C6A\";\r\n}\r\n\r\n.mdi-emoticon-confused::before {\r\n  content: \"\\F10DE\";\r\n}\r\n\r\n.mdi-emoticon-confused-outline::before {\r\n  content: \"\\F10DF\";\r\n}\r\n\r\n.mdi-emoticon-cool::before {\r\n  content: \"\\F0C6B\";\r\n}\r\n\r\n.mdi-emoticon-cool-outline::before {\r\n  content: \"\\F01F3\";\r\n}\r\n\r\n.mdi-emoticon-cry::before {\r\n  content: \"\\F0C6C\";\r\n}\r\n\r\n.mdi-emoticon-cry-outline::before {\r\n  content: \"\\F0C6D\";\r\n}\r\n\r\n.mdi-emoticon-dead::before {\r\n  content: \"\\F0C6E\";\r\n}\r\n\r\n.mdi-emoticon-dead-outline::before {\r\n  content: \"\\F069B\";\r\n}\r\n\r\n.mdi-emoticon-devil::before {\r\n  content: \"\\F0C6F\";\r\n}\r\n\r\n.mdi-emoticon-devil-outline::before {\r\n  content: \"\\F01F4\";\r\n}\r\n\r\n.mdi-emoticon-excited::before {\r\n  content: \"\\F0C70\";\r\n}\r\n\r\n.mdi-emoticon-excited-outline::before {\r\n  content: \"\\F069C\";\r\n}\r\n\r\n.mdi-emoticon-frown::before {\r\n  content: \"\\F0F4C\";\r\n}\r\n\r\n.mdi-emoticon-frown-outline::before {\r\n  content: \"\\F0F4D\";\r\n}\r\n\r\n.mdi-emoticon-happy::before {\r\n  content: \"\\F0C71\";\r\n}\r\n\r\n.mdi-emoticon-happy-outline::before {\r\n  content: \"\\F01F5\";\r\n}\r\n\r\n.mdi-emoticon-kiss::before {\r\n  content: \"\\F0C72\";\r\n}\r\n\r\n.mdi-emoticon-kiss-outline::before {\r\n  content: \"\\F0C73\";\r\n}\r\n\r\n.mdi-emoticon-lol::before {\r\n  content: \"\\F1214\";\r\n}\r\n\r\n.mdi-emoticon-lol-outline::before {\r\n  content: \"\\F1215\";\r\n}\r\n\r\n.mdi-emoticon-neutral::before {\r\n  content: \"\\F0C74\";\r\n}\r\n\r\n.mdi-emoticon-neutral-outline::before {\r\n  content: \"\\F01F6\";\r\n}\r\n\r\n.mdi-emoticon-outline::before {\r\n  content: \"\\F01F2\";\r\n}\r\n\r\n.mdi-emoticon-poop::before {\r\n  content: \"\\F01F7\";\r\n}\r\n\r\n.mdi-emoticon-poop-outline::before {\r\n  content: \"\\F0C75\";\r\n}\r\n\r\n.mdi-emoticon-sad::before {\r\n  content: \"\\F0C76\";\r\n}\r\n\r\n.mdi-emoticon-sad-outline::before {\r\n  content: \"\\F01F8\";\r\n}\r\n\r\n.mdi-emoticon-sick::before {\r\n  content: \"\\F157C\";\r\n}\r\n\r\n.mdi-emoticon-sick-outline::before {\r\n  content: \"\\F157D\";\r\n}\r\n\r\n.mdi-emoticon-tongue::before {\r\n  content: \"\\F01F9\";\r\n}\r\n\r\n.mdi-emoticon-tongue-outline::before {\r\n  content: \"\\F0C77\";\r\n}\r\n\r\n.mdi-emoticon-wink::before {\r\n  content: \"\\F0C78\";\r\n}\r\n\r\n.mdi-emoticon-wink-outline::before {\r\n  content: \"\\F0C79\";\r\n}\r\n\r\n.mdi-engine::before {\r\n  content: \"\\F01FA\";\r\n}\r\n\r\n.mdi-engine-off::before {\r\n  content: \"\\F0A46\";\r\n}\r\n\r\n.mdi-engine-off-outline::before {\r\n  content: \"\\F0A47\";\r\n}\r\n\r\n.mdi-engine-outline::before {\r\n  content: \"\\F01FB\";\r\n}\r\n\r\n.mdi-epsilon::before {\r\n  content: \"\\F10E0\";\r\n}\r\n\r\n.mdi-equal::before {\r\n  content: \"\\F01FC\";\r\n}\r\n\r\n.mdi-equal-box::before {\r\n  content: \"\\F01FD\";\r\n}\r\n\r\n.mdi-equalizer::before {\r\n  content: \"\\F0EA2\";\r\n}\r\n\r\n.mdi-equalizer-outline::before {\r\n  content: \"\\F0EA3\";\r\n}\r\n\r\n.mdi-eraser::before {\r\n  content: \"\\F01FE\";\r\n}\r\n\r\n.mdi-eraser-variant::before {\r\n  content: \"\\F0642\";\r\n}\r\n\r\n.mdi-escalator::before {\r\n  content: \"\\F01FF\";\r\n}\r\n\r\n.mdi-escalator-box::before {\r\n  content: \"\\F1399\";\r\n}\r\n\r\n.mdi-escalator-down::before {\r\n  content: \"\\F12C0\";\r\n}\r\n\r\n.mdi-escalator-up::before {\r\n  content: \"\\F12BF\";\r\n}\r\n\r\n.mdi-eslint::before {\r\n  content: \"\\F0C7A\";\r\n}\r\n\r\n.mdi-et::before {\r\n  content: \"\\F0AB3\";\r\n}\r\n\r\n.mdi-ethereum::before {\r\n  content: \"\\F086A\";\r\n}\r\n\r\n.mdi-ethernet::before {\r\n  content: \"\\F0200\";\r\n}\r\n\r\n.mdi-ethernet-cable::before {\r\n  content: \"\\F0201\";\r\n}\r\n\r\n.mdi-ethernet-cable-off::before {\r\n  content: \"\\F0202\";\r\n}\r\n\r\n.mdi-ev-plug-ccs1::before {\r\n  content: \"\\F1519\";\r\n}\r\n\r\n.mdi-ev-plug-ccs2::before {\r\n  content: \"\\F151A\";\r\n}\r\n\r\n.mdi-ev-plug-chademo::before {\r\n  content: \"\\F151B\";\r\n}\r\n\r\n.mdi-ev-plug-tesla::before {\r\n  content: \"\\F151C\";\r\n}\r\n\r\n.mdi-ev-plug-type1::before {\r\n  content: \"\\F151D\";\r\n}\r\n\r\n.mdi-ev-plug-type2::before {\r\n  content: \"\\F151E\";\r\n}\r\n\r\n.mdi-ev-station::before {\r\n  content: \"\\F05F1\";\r\n}\r\n\r\n.mdi-evernote::before {\r\n  content: \"\\F0204\";\r\n}\r\n\r\n.mdi-excavator::before {\r\n  content: \"\\F1025\";\r\n}\r\n\r\n.mdi-exclamation::before {\r\n  content: \"\\F0205\";\r\n}\r\n\r\n.mdi-exclamation-thick::before {\r\n  content: \"\\F1238\";\r\n}\r\n\r\n.mdi-exit-run::before {\r\n  content: \"\\F0A48\";\r\n}\r\n\r\n.mdi-exit-to-app::before {\r\n  content: \"\\F0206\";\r\n}\r\n\r\n.mdi-expand-all::before {\r\n  content: \"\\F0AB4\";\r\n}\r\n\r\n.mdi-expand-all-outline::before {\r\n  content: \"\\F0AB5\";\r\n}\r\n\r\n.mdi-expansion-card::before {\r\n  content: \"\\F08AE\";\r\n}\r\n\r\n.mdi-expansion-card-variant::before {\r\n  content: \"\\F0FB2\";\r\n}\r\n\r\n.mdi-exponent::before {\r\n  content: \"\\F0963\";\r\n}\r\n\r\n.mdi-exponent-box::before {\r\n  content: \"\\F0964\";\r\n}\r\n\r\n.mdi-export::before {\r\n  content: \"\\F0207\";\r\n}\r\n\r\n.mdi-export-variant::before {\r\n  content: \"\\F0B93\";\r\n}\r\n\r\n.mdi-eye::before {\r\n  content: \"\\F0208\";\r\n}\r\n\r\n.mdi-eye-check::before {\r\n  content: \"\\F0D04\";\r\n}\r\n\r\n.mdi-eye-check-outline::before {\r\n  content: \"\\F0D05\";\r\n}\r\n\r\n.mdi-eye-circle::before {\r\n  content: \"\\F0B94\";\r\n}\r\n\r\n.mdi-eye-circle-outline::before {\r\n  content: \"\\F0B95\";\r\n}\r\n\r\n.mdi-eye-minus::before {\r\n  content: \"\\F1026\";\r\n}\r\n\r\n.mdi-eye-minus-outline::before {\r\n  content: \"\\F1027\";\r\n}\r\n\r\n.mdi-eye-off::before {\r\n  content: \"\\F0209\";\r\n}\r\n\r\n.mdi-eye-off-outline::before {\r\n  content: \"\\F06D1\";\r\n}\r\n\r\n.mdi-eye-outline::before {\r\n  content: \"\\F06D0\";\r\n}\r\n\r\n.mdi-eye-plus::before {\r\n  content: \"\\F086B\";\r\n}\r\n\r\n.mdi-eye-plus-outline::before {\r\n  content: \"\\F086C\";\r\n}\r\n\r\n.mdi-eye-remove::before {\r\n  content: \"\\F15E3\";\r\n}\r\n\r\n.mdi-eye-remove-outline::before {\r\n  content: \"\\F15E4\";\r\n}\r\n\r\n.mdi-eye-settings::before {\r\n  content: \"\\F086D\";\r\n}\r\n\r\n.mdi-eye-settings-outline::before {\r\n  content: \"\\F086E\";\r\n}\r\n\r\n.mdi-eyedropper::before {\r\n  content: \"\\F020A\";\r\n}\r\n\r\n.mdi-eyedropper-minus::before {\r\n  content: \"\\F13DD\";\r\n}\r\n\r\n.mdi-eyedropper-off::before {\r\n  content: \"\\F13DF\";\r\n}\r\n\r\n.mdi-eyedropper-plus::before {\r\n  content: \"\\F13DC\";\r\n}\r\n\r\n.mdi-eyedropper-remove::before {\r\n  content: \"\\F13DE\";\r\n}\r\n\r\n.mdi-eyedropper-variant::before {\r\n  content: \"\\F020B\";\r\n}\r\n\r\n.mdi-face::before {\r\n  content: \"\\F0643\";\r\n}\r\n\r\n.mdi-face-agent::before {\r\n  content: \"\\F0D70\";\r\n}\r\n\r\n.mdi-face-mask::before {\r\n  content: \"\\F1586\";\r\n}\r\n\r\n.mdi-face-mask-outline::before {\r\n  content: \"\\F1587\";\r\n}\r\n\r\n.mdi-face-outline::before {\r\n  content: \"\\F0B96\";\r\n}\r\n\r\n.mdi-face-profile::before {\r\n  content: \"\\F0644\";\r\n}\r\n\r\n.mdi-face-profile-woman::before {\r\n  content: \"\\F1076\";\r\n}\r\n\r\n.mdi-face-recognition::before {\r\n  content: \"\\F0C7B\";\r\n}\r\n\r\n.mdi-face-shimmer::before {\r\n  content: \"\\F15CC\";\r\n}\r\n\r\n.mdi-face-shimmer-outline::before {\r\n  content: \"\\F15CD\";\r\n}\r\n\r\n.mdi-face-woman::before {\r\n  content: \"\\F1077\";\r\n}\r\n\r\n.mdi-face-woman-outline::before {\r\n  content: \"\\F1078\";\r\n}\r\n\r\n.mdi-face-woman-shimmer::before {\r\n  content: \"\\F15CE\";\r\n}\r\n\r\n.mdi-face-woman-shimmer-outline::before {\r\n  content: \"\\F15CF\";\r\n}\r\n\r\n.mdi-facebook::before {\r\n  content: \"\\F020C\";\r\n}\r\n\r\n.mdi-facebook-gaming::before {\r\n  content: \"\\F07DD\";\r\n}\r\n\r\n.mdi-facebook-messenger::before {\r\n  content: \"\\F020E\";\r\n}\r\n\r\n.mdi-facebook-workplace::before {\r\n  content: \"\\F0B31\";\r\n}\r\n\r\n.mdi-factory::before {\r\n  content: \"\\F020F\";\r\n}\r\n\r\n.mdi-family-tree::before {\r\n  content: \"\\F160E\";\r\n}\r\n\r\n.mdi-fan::before {\r\n  content: \"\\F0210\";\r\n}\r\n\r\n.mdi-fan-alert::before {\r\n  content: \"\\F146C\";\r\n}\r\n\r\n.mdi-fan-chevron-down::before {\r\n  content: \"\\F146D\";\r\n}\r\n\r\n.mdi-fan-chevron-up::before {\r\n  content: \"\\F146E\";\r\n}\r\n\r\n.mdi-fan-minus::before {\r\n  content: \"\\F1470\";\r\n}\r\n\r\n.mdi-fan-off::before {\r\n  content: \"\\F081D\";\r\n}\r\n\r\n.mdi-fan-plus::before {\r\n  content: \"\\F146F\";\r\n}\r\n\r\n.mdi-fan-remove::before {\r\n  content: \"\\F1471\";\r\n}\r\n\r\n.mdi-fan-speed-1::before {\r\n  content: \"\\F1472\";\r\n}\r\n\r\n.mdi-fan-speed-2::before {\r\n  content: \"\\F1473\";\r\n}\r\n\r\n.mdi-fan-speed-3::before {\r\n  content: \"\\F1474\";\r\n}\r\n\r\n.mdi-fast-forward::before {\r\n  content: \"\\F0211\";\r\n}\r\n\r\n.mdi-fast-forward-10::before {\r\n  content: \"\\F0D71\";\r\n}\r\n\r\n.mdi-fast-forward-30::before {\r\n  content: \"\\F0D06\";\r\n}\r\n\r\n.mdi-fast-forward-5::before {\r\n  content: \"\\F11F8\";\r\n}\r\n\r\n.mdi-fast-forward-60::before {\r\n  content: \"\\F160B\";\r\n}\r\n\r\n.mdi-fast-forward-outline::before {\r\n  content: \"\\F06D2\";\r\n}\r\n\r\n.mdi-fax::before {\r\n  content: \"\\F0212\";\r\n}\r\n\r\n.mdi-feather::before {\r\n  content: \"\\F06D3\";\r\n}\r\n\r\n.mdi-feature-search::before {\r\n  content: \"\\F0A49\";\r\n}\r\n\r\n.mdi-feature-search-outline::before {\r\n  content: \"\\F0A4A\";\r\n}\r\n\r\n.mdi-fedora::before {\r\n  content: \"\\F08DB\";\r\n}\r\n\r\n.mdi-fencing::before {\r\n  content: \"\\F14C1\";\r\n}\r\n\r\n.mdi-ferris-wheel::before {\r\n  content: \"\\F0EA4\";\r\n}\r\n\r\n.mdi-ferry::before {\r\n  content: \"\\F0213\";\r\n}\r\n\r\n.mdi-file::before {\r\n  content: \"\\F0214\";\r\n}\r\n\r\n.mdi-file-account::before {\r\n  content: \"\\F073B\";\r\n}\r\n\r\n.mdi-file-account-outline::before {\r\n  content: \"\\F1028\";\r\n}\r\n\r\n.mdi-file-alert::before {\r\n  content: \"\\F0A4B\";\r\n}\r\n\r\n.mdi-file-alert-outline::before {\r\n  content: \"\\F0A4C\";\r\n}\r\n\r\n.mdi-file-cabinet::before {\r\n  content: \"\\F0AB6\";\r\n}\r\n\r\n.mdi-file-cad::before {\r\n  content: \"\\F0EEB\";\r\n}\r\n\r\n.mdi-file-cad-box::before {\r\n  content: \"\\F0EEC\";\r\n}\r\n\r\n.mdi-file-cancel::before {\r\n  content: \"\\F0DC6\";\r\n}\r\n\r\n.mdi-file-cancel-outline::before {\r\n  content: \"\\F0DC7\";\r\n}\r\n\r\n.mdi-file-certificate::before {\r\n  content: \"\\F1186\";\r\n}\r\n\r\n.mdi-file-certificate-outline::before {\r\n  content: \"\\F1187\";\r\n}\r\n\r\n.mdi-file-chart::before {\r\n  content: \"\\F0215\";\r\n}\r\n\r\n.mdi-file-chart-outline::before {\r\n  content: \"\\F1029\";\r\n}\r\n\r\n.mdi-file-check::before {\r\n  content: \"\\F0216\";\r\n}\r\n\r\n.mdi-file-check-outline::before {\r\n  content: \"\\F0E29\";\r\n}\r\n\r\n.mdi-file-clock::before {\r\n  content: \"\\F12E1\";\r\n}\r\n\r\n.mdi-file-clock-outline::before {\r\n  content: \"\\F12E2\";\r\n}\r\n\r\n.mdi-file-cloud::before {\r\n  content: \"\\F0217\";\r\n}\r\n\r\n.mdi-file-cloud-outline::before {\r\n  content: \"\\F102A\";\r\n}\r\n\r\n.mdi-file-code::before {\r\n  content: \"\\F022E\";\r\n}\r\n\r\n.mdi-file-code-outline::before {\r\n  content: \"\\F102B\";\r\n}\r\n\r\n.mdi-file-cog::before {\r\n  content: \"\\F107B\";\r\n}\r\n\r\n.mdi-file-cog-outline::before {\r\n  content: \"\\F107C\";\r\n}\r\n\r\n.mdi-file-compare::before {\r\n  content: \"\\F08AA\";\r\n}\r\n\r\n.mdi-file-delimited::before {\r\n  content: \"\\F0218\";\r\n}\r\n\r\n.mdi-file-delimited-outline::before {\r\n  content: \"\\F0EA5\";\r\n}\r\n\r\n.mdi-file-document::before {\r\n  content: \"\\F0219\";\r\n}\r\n\r\n.mdi-file-document-edit::before {\r\n  content: \"\\F0DC8\";\r\n}\r\n\r\n.mdi-file-document-edit-outline::before {\r\n  content: \"\\F0DC9\";\r\n}\r\n\r\n.mdi-file-document-multiple::before {\r\n  content: \"\\F1517\";\r\n}\r\n\r\n.mdi-file-document-multiple-outline::before {\r\n  content: \"\\F1518\";\r\n}\r\n\r\n.mdi-file-document-outline::before {\r\n  content: \"\\F09EE\";\r\n}\r\n\r\n.mdi-file-download::before {\r\n  content: \"\\F0965\";\r\n}\r\n\r\n.mdi-file-download-outline::before {\r\n  content: \"\\F0966\";\r\n}\r\n\r\n.mdi-file-edit::before {\r\n  content: \"\\F11E7\";\r\n}\r\n\r\n.mdi-file-edit-outline::before {\r\n  content: \"\\F11E8\";\r\n}\r\n\r\n.mdi-file-excel::before {\r\n  content: \"\\F021B\";\r\n}\r\n\r\n.mdi-file-excel-box::before {\r\n  content: \"\\F021C\";\r\n}\r\n\r\n.mdi-file-excel-box-outline::before {\r\n  content: \"\\F102C\";\r\n}\r\n\r\n.mdi-file-excel-outline::before {\r\n  content: \"\\F102D\";\r\n}\r\n\r\n.mdi-file-export::before {\r\n  content: \"\\F021D\";\r\n}\r\n\r\n.mdi-file-export-outline::before {\r\n  content: \"\\F102E\";\r\n}\r\n\r\n.mdi-file-eye::before {\r\n  content: \"\\F0DCA\";\r\n}\r\n\r\n.mdi-file-eye-outline::before {\r\n  content: \"\\F0DCB\";\r\n}\r\n\r\n.mdi-file-find::before {\r\n  content: \"\\F021E\";\r\n}\r\n\r\n.mdi-file-find-outline::before {\r\n  content: \"\\F0B97\";\r\n}\r\n\r\n.mdi-file-hidden::before {\r\n  content: \"\\F0613\";\r\n}\r\n\r\n.mdi-file-image::before {\r\n  content: \"\\F021F\";\r\n}\r\n\r\n.mdi-file-image-outline::before {\r\n  content: \"\\F0EB0\";\r\n}\r\n\r\n.mdi-file-import::before {\r\n  content: \"\\F0220\";\r\n}\r\n\r\n.mdi-file-import-outline::before {\r\n  content: \"\\F102F\";\r\n}\r\n\r\n.mdi-file-key::before {\r\n  content: \"\\F1184\";\r\n}\r\n\r\n.mdi-file-key-outline::before {\r\n  content: \"\\F1185\";\r\n}\r\n\r\n.mdi-file-link::before {\r\n  content: \"\\F1177\";\r\n}\r\n\r\n.mdi-file-link-outline::before {\r\n  content: \"\\F1178\";\r\n}\r\n\r\n.mdi-file-lock::before {\r\n  content: \"\\F0221\";\r\n}\r\n\r\n.mdi-file-lock-outline::before {\r\n  content: \"\\F1030\";\r\n}\r\n\r\n.mdi-file-move::before {\r\n  content: \"\\F0AB9\";\r\n}\r\n\r\n.mdi-file-move-outline::before {\r\n  content: \"\\F1031\";\r\n}\r\n\r\n.mdi-file-multiple::before {\r\n  content: \"\\F0222\";\r\n}\r\n\r\n.mdi-file-multiple-outline::before {\r\n  content: \"\\F1032\";\r\n}\r\n\r\n.mdi-file-music::before {\r\n  content: \"\\F0223\";\r\n}\r\n\r\n.mdi-file-music-outline::before {\r\n  content: \"\\F0E2A\";\r\n}\r\n\r\n.mdi-file-outline::before {\r\n  content: \"\\F0224\";\r\n}\r\n\r\n.mdi-file-pdf::before {\r\n  content: \"\\F0225\";\r\n}\r\n\r\n.mdi-file-pdf-box::before {\r\n  content: \"\\F0226\";\r\n}\r\n\r\n.mdi-file-pdf-box-outline::before {\r\n  content: \"\\F0FB3\";\r\n}\r\n\r\n.mdi-file-pdf-outline::before {\r\n  content: \"\\F0E2D\";\r\n}\r\n\r\n.mdi-file-percent::before {\r\n  content: \"\\F081E\";\r\n}\r\n\r\n.mdi-file-percent-outline::before {\r\n  content: \"\\F1033\";\r\n}\r\n\r\n.mdi-file-phone::before {\r\n  content: \"\\F1179\";\r\n}\r\n\r\n.mdi-file-phone-outline::before {\r\n  content: \"\\F117A\";\r\n}\r\n\r\n.mdi-file-plus::before {\r\n  content: \"\\F0752\";\r\n}\r\n\r\n.mdi-file-plus-outline::before {\r\n  content: \"\\F0EED\";\r\n}\r\n\r\n.mdi-file-powerpoint::before {\r\n  content: \"\\F0227\";\r\n}\r\n\r\n.mdi-file-powerpoint-box::before {\r\n  content: \"\\F0228\";\r\n}\r\n\r\n.mdi-file-powerpoint-box-outline::before {\r\n  content: \"\\F1034\";\r\n}\r\n\r\n.mdi-file-powerpoint-outline::before {\r\n  content: \"\\F1035\";\r\n}\r\n\r\n.mdi-file-presentation-box::before {\r\n  content: \"\\F0229\";\r\n}\r\n\r\n.mdi-file-question::before {\r\n  content: \"\\F086F\";\r\n}\r\n\r\n.mdi-file-question-outline::before {\r\n  content: \"\\F1036\";\r\n}\r\n\r\n.mdi-file-refresh::before {\r\n  content: \"\\F0918\";\r\n}\r\n\r\n.mdi-file-refresh-outline::before {\r\n  content: \"\\F0541\";\r\n}\r\n\r\n.mdi-file-remove::before {\r\n  content: \"\\F0B98\";\r\n}\r\n\r\n.mdi-file-remove-outline::before {\r\n  content: \"\\F1037\";\r\n}\r\n\r\n.mdi-file-replace::before {\r\n  content: \"\\F0B32\";\r\n}\r\n\r\n.mdi-file-replace-outline::before {\r\n  content: \"\\F0B33\";\r\n}\r\n\r\n.mdi-file-restore::before {\r\n  content: \"\\F0670\";\r\n}\r\n\r\n.mdi-file-restore-outline::before {\r\n  content: \"\\F1038\";\r\n}\r\n\r\n.mdi-file-search::before {\r\n  content: \"\\F0C7C\";\r\n}\r\n\r\n.mdi-file-search-outline::before {\r\n  content: \"\\F0C7D\";\r\n}\r\n\r\n.mdi-file-send::before {\r\n  content: \"\\F022A\";\r\n}\r\n\r\n.mdi-file-send-outline::before {\r\n  content: \"\\F1039\";\r\n}\r\n\r\n.mdi-file-settings::before {\r\n  content: \"\\F1079\";\r\n}\r\n\r\n.mdi-file-settings-outline::before {\r\n  content: \"\\F107A\";\r\n}\r\n\r\n.mdi-file-star::before {\r\n  content: \"\\F103A\";\r\n}\r\n\r\n.mdi-file-star-outline::before {\r\n  content: \"\\F103B\";\r\n}\r\n\r\n.mdi-file-swap::before {\r\n  content: \"\\F0FB4\";\r\n}\r\n\r\n.mdi-file-swap-outline::before {\r\n  content: \"\\F0FB5\";\r\n}\r\n\r\n.mdi-file-sync::before {\r\n  content: \"\\F1216\";\r\n}\r\n\r\n.mdi-file-sync-outline::before {\r\n  content: \"\\F1217\";\r\n}\r\n\r\n.mdi-file-table::before {\r\n  content: \"\\F0C7E\";\r\n}\r\n\r\n.mdi-file-table-box::before {\r\n  content: \"\\F10E1\";\r\n}\r\n\r\n.mdi-file-table-box-multiple::before {\r\n  content: \"\\F10E2\";\r\n}\r\n\r\n.mdi-file-table-box-multiple-outline::before {\r\n  content: \"\\F10E3\";\r\n}\r\n\r\n.mdi-file-table-box-outline::before {\r\n  content: \"\\F10E4\";\r\n}\r\n\r\n.mdi-file-table-outline::before {\r\n  content: \"\\F0C7F\";\r\n}\r\n\r\n.mdi-file-tree::before {\r\n  content: \"\\F0645\";\r\n}\r\n\r\n.mdi-file-tree-outline::before {\r\n  content: \"\\F13D2\";\r\n}\r\n\r\n.mdi-file-undo::before {\r\n  content: \"\\F08DC\";\r\n}\r\n\r\n.mdi-file-undo-outline::before {\r\n  content: \"\\F103C\";\r\n}\r\n\r\n.mdi-file-upload::before {\r\n  content: \"\\F0A4D\";\r\n}\r\n\r\n.mdi-file-upload-outline::before {\r\n  content: \"\\F0A4E\";\r\n}\r\n\r\n.mdi-file-video::before {\r\n  content: \"\\F022B\";\r\n}\r\n\r\n.mdi-file-video-outline::before {\r\n  content: \"\\F0E2C\";\r\n}\r\n\r\n.mdi-file-word::before {\r\n  content: \"\\F022C\";\r\n}\r\n\r\n.mdi-file-word-box::before {\r\n  content: \"\\F022D\";\r\n}\r\n\r\n.mdi-file-word-box-outline::before {\r\n  content: \"\\F103D\";\r\n}\r\n\r\n.mdi-file-word-outline::before {\r\n  content: \"\\F103E\";\r\n}\r\n\r\n.mdi-film::before {\r\n  content: \"\\F022F\";\r\n}\r\n\r\n.mdi-filmstrip::before {\r\n  content: \"\\F0230\";\r\n}\r\n\r\n.mdi-filmstrip-box::before {\r\n  content: \"\\F0332\";\r\n}\r\n\r\n.mdi-filmstrip-box-multiple::before {\r\n  content: \"\\F0D18\";\r\n}\r\n\r\n.mdi-filmstrip-off::before {\r\n  content: \"\\F0231\";\r\n}\r\n\r\n.mdi-filter::before {\r\n  content: \"\\F0232\";\r\n}\r\n\r\n.mdi-filter-menu::before {\r\n  content: \"\\F10E5\";\r\n}\r\n\r\n.mdi-filter-menu-outline::before {\r\n  content: \"\\F10E6\";\r\n}\r\n\r\n.mdi-filter-minus::before {\r\n  content: \"\\F0EEE\";\r\n}\r\n\r\n.mdi-filter-minus-outline::before {\r\n  content: \"\\F0EEF\";\r\n}\r\n\r\n.mdi-filter-off::before {\r\n  content: \"\\F14EF\";\r\n}\r\n\r\n.mdi-filter-off-outline::before {\r\n  content: \"\\F14F0\";\r\n}\r\n\r\n.mdi-filter-outline::before {\r\n  content: \"\\F0233\";\r\n}\r\n\r\n.mdi-filter-plus::before {\r\n  content: \"\\F0EF0\";\r\n}\r\n\r\n.mdi-filter-plus-outline::before {\r\n  content: \"\\F0EF1\";\r\n}\r\n\r\n.mdi-filter-remove::before {\r\n  content: \"\\F0234\";\r\n}\r\n\r\n.mdi-filter-remove-outline::before {\r\n  content: \"\\F0235\";\r\n}\r\n\r\n.mdi-filter-variant::before {\r\n  content: \"\\F0236\";\r\n}\r\n\r\n.mdi-filter-variant-minus::before {\r\n  content: \"\\F1112\";\r\n}\r\n\r\n.mdi-filter-variant-plus::before {\r\n  content: \"\\F1113\";\r\n}\r\n\r\n.mdi-filter-variant-remove::before {\r\n  content: \"\\F103F\";\r\n}\r\n\r\n.mdi-finance::before {\r\n  content: \"\\F081F\";\r\n}\r\n\r\n.mdi-find-replace::before {\r\n  content: \"\\F06D4\";\r\n}\r\n\r\n.mdi-fingerprint::before {\r\n  content: \"\\F0237\";\r\n}\r\n\r\n.mdi-fingerprint-off::before {\r\n  content: \"\\F0EB1\";\r\n}\r\n\r\n.mdi-fire::before {\r\n  content: \"\\F0238\";\r\n}\r\n\r\n.mdi-fire-alert::before {\r\n  content: \"\\F15D7\";\r\n}\r\n\r\n.mdi-fire-extinguisher::before {\r\n  content: \"\\F0EF2\";\r\n}\r\n\r\n.mdi-fire-hydrant::before {\r\n  content: \"\\F1137\";\r\n}\r\n\r\n.mdi-fire-hydrant-alert::before {\r\n  content: \"\\F1138\";\r\n}\r\n\r\n.mdi-fire-hydrant-off::before {\r\n  content: \"\\F1139\";\r\n}\r\n\r\n.mdi-fire-truck::before {\r\n  content: \"\\F08AB\";\r\n}\r\n\r\n.mdi-firebase::before {\r\n  content: \"\\F0967\";\r\n}\r\n\r\n.mdi-firefox::before {\r\n  content: \"\\F0239\";\r\n}\r\n\r\n.mdi-fireplace::before {\r\n  content: \"\\F0E2E\";\r\n}\r\n\r\n.mdi-fireplace-off::before {\r\n  content: \"\\F0E2F\";\r\n}\r\n\r\n.mdi-firework::before {\r\n  content: \"\\F0E30\";\r\n}\r\n\r\n.mdi-fish::before {\r\n  content: \"\\F023A\";\r\n}\r\n\r\n.mdi-fish-off::before {\r\n  content: \"\\F13F3\";\r\n}\r\n\r\n.mdi-fishbowl::before {\r\n  content: \"\\F0EF3\";\r\n}\r\n\r\n.mdi-fishbowl-outline::before {\r\n  content: \"\\F0EF4\";\r\n}\r\n\r\n.mdi-fit-to-page::before {\r\n  content: \"\\F0EF5\";\r\n}\r\n\r\n.mdi-fit-to-page-outline::before {\r\n  content: \"\\F0EF6\";\r\n}\r\n\r\n.mdi-flag::before {\r\n  content: \"\\F023B\";\r\n}\r\n\r\n.mdi-flag-checkered::before {\r\n  content: \"\\F023C\";\r\n}\r\n\r\n.mdi-flag-minus::before {\r\n  content: \"\\F0B99\";\r\n}\r\n\r\n.mdi-flag-minus-outline::before {\r\n  content: \"\\F10B2\";\r\n}\r\n\r\n.mdi-flag-outline::before {\r\n  content: \"\\F023D\";\r\n}\r\n\r\n.mdi-flag-plus::before {\r\n  content: \"\\F0B9A\";\r\n}\r\n\r\n.mdi-flag-plus-outline::before {\r\n  content: \"\\F10B3\";\r\n}\r\n\r\n.mdi-flag-remove::before {\r\n  content: \"\\F0B9B\";\r\n}\r\n\r\n.mdi-flag-remove-outline::before {\r\n  content: \"\\F10B4\";\r\n}\r\n\r\n.mdi-flag-triangle::before {\r\n  content: \"\\F023F\";\r\n}\r\n\r\n.mdi-flag-variant::before {\r\n  content: \"\\F0240\";\r\n}\r\n\r\n.mdi-flag-variant-outline::before {\r\n  content: \"\\F023E\";\r\n}\r\n\r\n.mdi-flare::before {\r\n  content: \"\\F0D72\";\r\n}\r\n\r\n.mdi-flash::before {\r\n  content: \"\\F0241\";\r\n}\r\n\r\n.mdi-flash-alert::before {\r\n  content: \"\\F0EF7\";\r\n}\r\n\r\n.mdi-flash-alert-outline::before {\r\n  content: \"\\F0EF8\";\r\n}\r\n\r\n.mdi-flash-auto::before {\r\n  content: \"\\F0242\";\r\n}\r\n\r\n.mdi-flash-circle::before {\r\n  content: \"\\F0820\";\r\n}\r\n\r\n.mdi-flash-off::before {\r\n  content: \"\\F0243\";\r\n}\r\n\r\n.mdi-flash-outline::before {\r\n  content: \"\\F06D5\";\r\n}\r\n\r\n.mdi-flash-red-eye::before {\r\n  content: \"\\F067B\";\r\n}\r\n\r\n.mdi-flashlight::before {\r\n  content: \"\\F0244\";\r\n}\r\n\r\n.mdi-flashlight-off::before {\r\n  content: \"\\F0245\";\r\n}\r\n\r\n.mdi-flask::before {\r\n  content: \"\\F0093\";\r\n}\r\n\r\n.mdi-flask-empty::before {\r\n  content: \"\\F0094\";\r\n}\r\n\r\n.mdi-flask-empty-minus::before {\r\n  content: \"\\F123A\";\r\n}\r\n\r\n.mdi-flask-empty-minus-outline::before {\r\n  content: \"\\F123B\";\r\n}\r\n\r\n.mdi-flask-empty-off::before {\r\n  content: \"\\F13F4\";\r\n}\r\n\r\n.mdi-flask-empty-off-outline::before {\r\n  content: \"\\F13F5\";\r\n}\r\n\r\n.mdi-flask-empty-outline::before {\r\n  content: \"\\F0095\";\r\n}\r\n\r\n.mdi-flask-empty-plus::before {\r\n  content: \"\\F123C\";\r\n}\r\n\r\n.mdi-flask-empty-plus-outline::before {\r\n  content: \"\\F123D\";\r\n}\r\n\r\n.mdi-flask-empty-remove::before {\r\n  content: \"\\F123E\";\r\n}\r\n\r\n.mdi-flask-empty-remove-outline::before {\r\n  content: \"\\F123F\";\r\n}\r\n\r\n.mdi-flask-minus::before {\r\n  content: \"\\F1240\";\r\n}\r\n\r\n.mdi-flask-minus-outline::before {\r\n  content: \"\\F1241\";\r\n}\r\n\r\n.mdi-flask-off::before {\r\n  content: \"\\F13F6\";\r\n}\r\n\r\n.mdi-flask-off-outline::before {\r\n  content: \"\\F13F7\";\r\n}\r\n\r\n.mdi-flask-outline::before {\r\n  content: \"\\F0096\";\r\n}\r\n\r\n.mdi-flask-plus::before {\r\n  content: \"\\F1242\";\r\n}\r\n\r\n.mdi-flask-plus-outline::before {\r\n  content: \"\\F1243\";\r\n}\r\n\r\n.mdi-flask-remove::before {\r\n  content: \"\\F1244\";\r\n}\r\n\r\n.mdi-flask-remove-outline::before {\r\n  content: \"\\F1245\";\r\n}\r\n\r\n.mdi-flask-round-bottom::before {\r\n  content: \"\\F124B\";\r\n}\r\n\r\n.mdi-flask-round-bottom-empty::before {\r\n  content: \"\\F124C\";\r\n}\r\n\r\n.mdi-flask-round-bottom-empty-outline::before {\r\n  content: \"\\F124D\";\r\n}\r\n\r\n.mdi-flask-round-bottom-outline::before {\r\n  content: \"\\F124E\";\r\n}\r\n\r\n.mdi-fleur-de-lis::before {\r\n  content: \"\\F1303\";\r\n}\r\n\r\n.mdi-flip-horizontal::before {\r\n  content: \"\\F10E7\";\r\n}\r\n\r\n.mdi-flip-to-back::before {\r\n  content: \"\\F0247\";\r\n}\r\n\r\n.mdi-flip-to-front::before {\r\n  content: \"\\F0248\";\r\n}\r\n\r\n.mdi-flip-vertical::before {\r\n  content: \"\\F10E8\";\r\n}\r\n\r\n.mdi-floor-lamp::before {\r\n  content: \"\\F08DD\";\r\n}\r\n\r\n.mdi-floor-lamp-dual::before {\r\n  content: \"\\F1040\";\r\n}\r\n\r\n.mdi-floor-lamp-variant::before {\r\n  content: \"\\F1041\";\r\n}\r\n\r\n.mdi-floor-plan::before {\r\n  content: \"\\F0821\";\r\n}\r\n\r\n.mdi-floppy::before {\r\n  content: \"\\F0249\";\r\n}\r\n\r\n.mdi-floppy-variant::before {\r\n  content: \"\\F09EF\";\r\n}\r\n\r\n.mdi-flower::before {\r\n  content: \"\\F024A\";\r\n}\r\n\r\n.mdi-flower-outline::before {\r\n  content: \"\\F09F0\";\r\n}\r\n\r\n.mdi-flower-poppy::before {\r\n  content: \"\\F0D08\";\r\n}\r\n\r\n.mdi-flower-tulip::before {\r\n  content: \"\\F09F1\";\r\n}\r\n\r\n.mdi-flower-tulip-outline::before {\r\n  content: \"\\F09F2\";\r\n}\r\n\r\n.mdi-focus-auto::before {\r\n  content: \"\\F0F4E\";\r\n}\r\n\r\n.mdi-focus-field::before {\r\n  content: \"\\F0F4F\";\r\n}\r\n\r\n.mdi-focus-field-horizontal::before {\r\n  content: \"\\F0F50\";\r\n}\r\n\r\n.mdi-focus-field-vertical::before {\r\n  content: \"\\F0F51\";\r\n}\r\n\r\n.mdi-folder::before {\r\n  content: \"\\F024B\";\r\n}\r\n\r\n.mdi-folder-account::before {\r\n  content: \"\\F024C\";\r\n}\r\n\r\n.mdi-folder-account-outline::before {\r\n  content: \"\\F0B9C\";\r\n}\r\n\r\n.mdi-folder-alert::before {\r\n  content: \"\\F0DCC\";\r\n}\r\n\r\n.mdi-folder-alert-outline::before {\r\n  content: \"\\F0DCD\";\r\n}\r\n\r\n.mdi-folder-clock::before {\r\n  content: \"\\F0ABA\";\r\n}\r\n\r\n.mdi-folder-clock-outline::before {\r\n  content: \"\\F0ABB\";\r\n}\r\n\r\n.mdi-folder-cog::before {\r\n  content: \"\\F107F\";\r\n}\r\n\r\n.mdi-folder-cog-outline::before {\r\n  content: \"\\F1080\";\r\n}\r\n\r\n.mdi-folder-download::before {\r\n  content: \"\\F024D\";\r\n}\r\n\r\n.mdi-folder-download-outline::before {\r\n  content: \"\\F10E9\";\r\n}\r\n\r\n.mdi-folder-edit::before {\r\n  content: \"\\F08DE\";\r\n}\r\n\r\n.mdi-folder-edit-outline::before {\r\n  content: \"\\F0DCE\";\r\n}\r\n\r\n.mdi-folder-google-drive::before {\r\n  content: \"\\F024E\";\r\n}\r\n\r\n.mdi-folder-heart::before {\r\n  content: \"\\F10EA\";\r\n}\r\n\r\n.mdi-folder-heart-outline::before {\r\n  content: \"\\F10EB\";\r\n}\r\n\r\n.mdi-folder-home::before {\r\n  content: \"\\F10B5\";\r\n}\r\n\r\n.mdi-folder-home-outline::before {\r\n  content: \"\\F10B6\";\r\n}\r\n\r\n.mdi-folder-image::before {\r\n  content: \"\\F024F\";\r\n}\r\n\r\n.mdi-folder-information::before {\r\n  content: \"\\F10B7\";\r\n}\r\n\r\n.mdi-folder-information-outline::before {\r\n  content: \"\\F10B8\";\r\n}\r\n\r\n.mdi-folder-key::before {\r\n  content: \"\\F08AC\";\r\n}\r\n\r\n.mdi-folder-key-network::before {\r\n  content: \"\\F08AD\";\r\n}\r\n\r\n.mdi-folder-key-network-outline::before {\r\n  content: \"\\F0C80\";\r\n}\r\n\r\n.mdi-folder-key-outline::before {\r\n  content: \"\\F10EC\";\r\n}\r\n\r\n.mdi-folder-lock::before {\r\n  content: \"\\F0250\";\r\n}\r\n\r\n.mdi-folder-lock-open::before {\r\n  content: \"\\F0251\";\r\n}\r\n\r\n.mdi-folder-marker::before {\r\n  content: \"\\F126D\";\r\n}\r\n\r\n.mdi-folder-marker-outline::before {\r\n  content: \"\\F126E\";\r\n}\r\n\r\n.mdi-folder-move::before {\r\n  content: \"\\F0252\";\r\n}\r\n\r\n.mdi-folder-move-outline::before {\r\n  content: \"\\F1246\";\r\n}\r\n\r\n.mdi-folder-multiple::before {\r\n  content: \"\\F0253\";\r\n}\r\n\r\n.mdi-folder-multiple-image::before {\r\n  content: \"\\F0254\";\r\n}\r\n\r\n.mdi-folder-multiple-outline::before {\r\n  content: \"\\F0255\";\r\n}\r\n\r\n.mdi-folder-multiple-plus::before {\r\n  content: \"\\F147E\";\r\n}\r\n\r\n.mdi-folder-multiple-plus-outline::before {\r\n  content: \"\\F147F\";\r\n}\r\n\r\n.mdi-folder-music::before {\r\n  content: \"\\F1359\";\r\n}\r\n\r\n.mdi-folder-music-outline::before {\r\n  content: \"\\F135A\";\r\n}\r\n\r\n.mdi-folder-network::before {\r\n  content: \"\\F0870\";\r\n}\r\n\r\n.mdi-folder-network-outline::before {\r\n  content: \"\\F0C81\";\r\n}\r\n\r\n.mdi-folder-open::before {\r\n  content: \"\\F0770\";\r\n}\r\n\r\n.mdi-folder-open-outline::before {\r\n  content: \"\\F0DCF\";\r\n}\r\n\r\n.mdi-folder-outline::before {\r\n  content: \"\\F0256\";\r\n}\r\n\r\n.mdi-folder-plus::before {\r\n  content: \"\\F0257\";\r\n}\r\n\r\n.mdi-folder-plus-outline::before {\r\n  content: \"\\F0B9D\";\r\n}\r\n\r\n.mdi-folder-pound::before {\r\n  content: \"\\F0D09\";\r\n}\r\n\r\n.mdi-folder-pound-outline::before {\r\n  content: \"\\F0D0A\";\r\n}\r\n\r\n.mdi-folder-refresh::before {\r\n  content: \"\\F0749\";\r\n}\r\n\r\n.mdi-folder-refresh-outline::before {\r\n  content: \"\\F0542\";\r\n}\r\n\r\n.mdi-folder-remove::before {\r\n  content: \"\\F0258\";\r\n}\r\n\r\n.mdi-folder-remove-outline::before {\r\n  content: \"\\F0B9E\";\r\n}\r\n\r\n.mdi-folder-search::before {\r\n  content: \"\\F0968\";\r\n}\r\n\r\n.mdi-folder-search-outline::before {\r\n  content: \"\\F0969\";\r\n}\r\n\r\n.mdi-folder-settings::before {\r\n  content: \"\\F107D\";\r\n}\r\n\r\n.mdi-folder-settings-outline::before {\r\n  content: \"\\F107E\";\r\n}\r\n\r\n.mdi-folder-star::before {\r\n  content: \"\\F069D\";\r\n}\r\n\r\n.mdi-folder-star-multiple::before {\r\n  content: \"\\F13D3\";\r\n}\r\n\r\n.mdi-folder-star-multiple-outline::before {\r\n  content: \"\\F13D4\";\r\n}\r\n\r\n.mdi-folder-star-outline::before {\r\n  content: \"\\F0B9F\";\r\n}\r\n\r\n.mdi-folder-swap::before {\r\n  content: \"\\F0FB6\";\r\n}\r\n\r\n.mdi-folder-swap-outline::before {\r\n  content: \"\\F0FB7\";\r\n}\r\n\r\n.mdi-folder-sync::before {\r\n  content: \"\\F0D0B\";\r\n}\r\n\r\n.mdi-folder-sync-outline::before {\r\n  content: \"\\F0D0C\";\r\n}\r\n\r\n.mdi-folder-table::before {\r\n  content: \"\\F12E3\";\r\n}\r\n\r\n.mdi-folder-table-outline::before {\r\n  content: \"\\F12E4\";\r\n}\r\n\r\n.mdi-folder-text::before {\r\n  content: \"\\F0C82\";\r\n}\r\n\r\n.mdi-folder-text-outline::before {\r\n  content: \"\\F0C83\";\r\n}\r\n\r\n.mdi-folder-upload::before {\r\n  content: \"\\F0259\";\r\n}\r\n\r\n.mdi-folder-upload-outline::before {\r\n  content: \"\\F10ED\";\r\n}\r\n\r\n.mdi-folder-zip::before {\r\n  content: \"\\F06EB\";\r\n}\r\n\r\n.mdi-folder-zip-outline::before {\r\n  content: \"\\F07B9\";\r\n}\r\n\r\n.mdi-font-awesome::before {\r\n  content: \"\\F003A\";\r\n}\r\n\r\n.mdi-food::before {\r\n  content: \"\\F025A\";\r\n}\r\n\r\n.mdi-food-apple::before {\r\n  content: \"\\F025B\";\r\n}\r\n\r\n.mdi-food-apple-outline::before {\r\n  content: \"\\F0C84\";\r\n}\r\n\r\n.mdi-food-croissant::before {\r\n  content: \"\\F07C8\";\r\n}\r\n\r\n.mdi-food-drumstick::before {\r\n  content: \"\\F141F\";\r\n}\r\n\r\n.mdi-food-drumstick-off::before {\r\n  content: \"\\F1468\";\r\n}\r\n\r\n.mdi-food-drumstick-off-outline::before {\r\n  content: \"\\F1469\";\r\n}\r\n\r\n.mdi-food-drumstick-outline::before {\r\n  content: \"\\F1420\";\r\n}\r\n\r\n.mdi-food-fork-drink::before {\r\n  content: \"\\F05F2\";\r\n}\r\n\r\n.mdi-food-halal::before {\r\n  content: \"\\F1572\";\r\n}\r\n\r\n.mdi-food-kosher::before {\r\n  content: \"\\F1573\";\r\n}\r\n\r\n.mdi-food-off::before {\r\n  content: \"\\F05F3\";\r\n}\r\n\r\n.mdi-food-steak::before {\r\n  content: \"\\F146A\";\r\n}\r\n\r\n.mdi-food-steak-off::before {\r\n  content: \"\\F146B\";\r\n}\r\n\r\n.mdi-food-variant::before {\r\n  content: \"\\F025C\";\r\n}\r\n\r\n.mdi-food-variant-off::before {\r\n  content: \"\\F13E5\";\r\n}\r\n\r\n.mdi-foot-print::before {\r\n  content: \"\\F0F52\";\r\n}\r\n\r\n.mdi-football::before {\r\n  content: \"\\F025D\";\r\n}\r\n\r\n.mdi-football-australian::before {\r\n  content: \"\\F025E\";\r\n}\r\n\r\n.mdi-football-helmet::before {\r\n  content: \"\\F025F\";\r\n}\r\n\r\n.mdi-forklift::before {\r\n  content: \"\\F07C9\";\r\n}\r\n\r\n.mdi-form-dropdown::before {\r\n  content: \"\\F1400\";\r\n}\r\n\r\n.mdi-form-select::before {\r\n  content: \"\\F1401\";\r\n}\r\n\r\n.mdi-form-textarea::before {\r\n  content: \"\\F1095\";\r\n}\r\n\r\n.mdi-form-textbox::before {\r\n  content: \"\\F060E\";\r\n}\r\n\r\n.mdi-form-textbox-lock::before {\r\n  content: \"\\F135D\";\r\n}\r\n\r\n.mdi-form-textbox-password::before {\r\n  content: \"\\F07F5\";\r\n}\r\n\r\n.mdi-format-align-bottom::before {\r\n  content: \"\\F0753\";\r\n}\r\n\r\n.mdi-format-align-center::before {\r\n  content: \"\\F0260\";\r\n}\r\n\r\n.mdi-format-align-justify::before {\r\n  content: \"\\F0261\";\r\n}\r\n\r\n.mdi-format-align-left::before {\r\n  content: \"\\F0262\";\r\n}\r\n\r\n.mdi-format-align-middle::before {\r\n  content: \"\\F0754\";\r\n}\r\n\r\n.mdi-format-align-right::before {\r\n  content: \"\\F0263\";\r\n}\r\n\r\n.mdi-format-align-top::before {\r\n  content: \"\\F0755\";\r\n}\r\n\r\n.mdi-format-annotation-minus::before {\r\n  content: \"\\F0ABC\";\r\n}\r\n\r\n.mdi-format-annotation-plus::before {\r\n  content: \"\\F0646\";\r\n}\r\n\r\n.mdi-format-bold::before {\r\n  content: \"\\F0264\";\r\n}\r\n\r\n.mdi-format-clear::before {\r\n  content: \"\\F0265\";\r\n}\r\n\r\n.mdi-format-color-fill::before {\r\n  content: \"\\F0266\";\r\n}\r\n\r\n.mdi-format-color-highlight::before {\r\n  content: \"\\F0E31\";\r\n}\r\n\r\n.mdi-format-color-marker-cancel::before {\r\n  content: \"\\F1313\";\r\n}\r\n\r\n.mdi-format-color-text::before {\r\n  content: \"\\F069E\";\r\n}\r\n\r\n.mdi-format-columns::before {\r\n  content: \"\\F08DF\";\r\n}\r\n\r\n.mdi-format-float-center::before {\r\n  content: \"\\F0267\";\r\n}\r\n\r\n.mdi-format-float-left::before {\r\n  content: \"\\F0268\";\r\n}\r\n\r\n.mdi-format-float-none::before {\r\n  content: \"\\F0269\";\r\n}\r\n\r\n.mdi-format-float-right::before {\r\n  content: \"\\F026A\";\r\n}\r\n\r\n.mdi-format-font::before {\r\n  content: \"\\F06D6\";\r\n}\r\n\r\n.mdi-format-font-size-decrease::before {\r\n  content: \"\\F09F3\";\r\n}\r\n\r\n.mdi-format-font-size-increase::before {\r\n  content: \"\\F09F4\";\r\n}\r\n\r\n.mdi-format-header-1::before {\r\n  content: \"\\F026B\";\r\n}\r\n\r\n.mdi-format-header-2::before {\r\n  content: \"\\F026C\";\r\n}\r\n\r\n.mdi-format-header-3::before {\r\n  content: \"\\F026D\";\r\n}\r\n\r\n.mdi-format-header-4::before {\r\n  content: \"\\F026E\";\r\n}\r\n\r\n.mdi-format-header-5::before {\r\n  content: \"\\F026F\";\r\n}\r\n\r\n.mdi-format-header-6::before {\r\n  content: \"\\F0270\";\r\n}\r\n\r\n.mdi-format-header-decrease::before {\r\n  content: \"\\F0271\";\r\n}\r\n\r\n.mdi-format-header-equal::before {\r\n  content: \"\\F0272\";\r\n}\r\n\r\n.mdi-format-header-increase::before {\r\n  content: \"\\F0273\";\r\n}\r\n\r\n.mdi-format-header-pound::before {\r\n  content: \"\\F0274\";\r\n}\r\n\r\n.mdi-format-horizontal-align-center::before {\r\n  content: \"\\F061E\";\r\n}\r\n\r\n.mdi-format-horizontal-align-left::before {\r\n  content: \"\\F061F\";\r\n}\r\n\r\n.mdi-format-horizontal-align-right::before {\r\n  content: \"\\F0620\";\r\n}\r\n\r\n.mdi-format-indent-decrease::before {\r\n  content: \"\\F0275\";\r\n}\r\n\r\n.mdi-format-indent-increase::before {\r\n  content: \"\\F0276\";\r\n}\r\n\r\n.mdi-format-italic::before {\r\n  content: \"\\F0277\";\r\n}\r\n\r\n.mdi-format-letter-case::before {\r\n  content: \"\\F0B34\";\r\n}\r\n\r\n.mdi-format-letter-case-lower::before {\r\n  content: \"\\F0B35\";\r\n}\r\n\r\n.mdi-format-letter-case-upper::before {\r\n  content: \"\\F0B36\";\r\n}\r\n\r\n.mdi-format-letter-ends-with::before {\r\n  content: \"\\F0FB8\";\r\n}\r\n\r\n.mdi-format-letter-matches::before {\r\n  content: \"\\F0FB9\";\r\n}\r\n\r\n.mdi-format-letter-starts-with::before {\r\n  content: \"\\F0FBA\";\r\n}\r\n\r\n.mdi-format-line-spacing::before {\r\n  content: \"\\F0278\";\r\n}\r\n\r\n.mdi-format-line-style::before {\r\n  content: \"\\F05C8\";\r\n}\r\n\r\n.mdi-format-line-weight::before {\r\n  content: \"\\F05C9\";\r\n}\r\n\r\n.mdi-format-list-bulleted::before {\r\n  content: \"\\F0279\";\r\n}\r\n\r\n.mdi-format-list-bulleted-square::before {\r\n  content: \"\\F0DD0\";\r\n}\r\n\r\n.mdi-format-list-bulleted-triangle::before {\r\n  content: \"\\F0EB2\";\r\n}\r\n\r\n.mdi-format-list-bulleted-type::before {\r\n  content: \"\\F027A\";\r\n}\r\n\r\n.mdi-format-list-checkbox::before {\r\n  content: \"\\F096A\";\r\n}\r\n\r\n.mdi-format-list-checks::before {\r\n  content: \"\\F0756\";\r\n}\r\n\r\n.mdi-format-list-numbered::before {\r\n  content: \"\\F027B\";\r\n}\r\n\r\n.mdi-format-list-numbered-rtl::before {\r\n  content: \"\\F0D0D\";\r\n}\r\n\r\n.mdi-format-list-text::before {\r\n  content: \"\\F126F\";\r\n}\r\n\r\n.mdi-format-overline::before {\r\n  content: \"\\F0EB3\";\r\n}\r\n\r\n.mdi-format-page-break::before {\r\n  content: \"\\F06D7\";\r\n}\r\n\r\n.mdi-format-paint::before {\r\n  content: \"\\F027C\";\r\n}\r\n\r\n.mdi-format-paragraph::before {\r\n  content: \"\\F027D\";\r\n}\r\n\r\n.mdi-format-pilcrow::before {\r\n  content: \"\\F06D8\";\r\n}\r\n\r\n.mdi-format-quote-close::before {\r\n  content: \"\\F027E\";\r\n}\r\n\r\n.mdi-format-quote-close-outline::before {\r\n  content: \"\\F11A8\";\r\n}\r\n\r\n.mdi-format-quote-open::before {\r\n  content: \"\\F0757\";\r\n}\r\n\r\n.mdi-format-quote-open-outline::before {\r\n  content: \"\\F11A7\";\r\n}\r\n\r\n.mdi-format-rotate-90::before {\r\n  content: \"\\F06AA\";\r\n}\r\n\r\n.mdi-format-section::before {\r\n  content: \"\\F069F\";\r\n}\r\n\r\n.mdi-format-size::before {\r\n  content: \"\\F027F\";\r\n}\r\n\r\n.mdi-format-strikethrough::before {\r\n  content: \"\\F0280\";\r\n}\r\n\r\n.mdi-format-strikethrough-variant::before {\r\n  content: \"\\F0281\";\r\n}\r\n\r\n.mdi-format-subscript::before {\r\n  content: \"\\F0282\";\r\n}\r\n\r\n.mdi-format-superscript::before {\r\n  content: \"\\F0283\";\r\n}\r\n\r\n.mdi-format-text::before {\r\n  content: \"\\F0284\";\r\n}\r\n\r\n.mdi-format-text-rotation-angle-down::before {\r\n  content: \"\\F0FBB\";\r\n}\r\n\r\n.mdi-format-text-rotation-angle-up::before {\r\n  content: \"\\F0FBC\";\r\n}\r\n\r\n.mdi-format-text-rotation-down::before {\r\n  content: \"\\F0D73\";\r\n}\r\n\r\n.mdi-format-text-rotation-down-vertical::before {\r\n  content: \"\\F0FBD\";\r\n}\r\n\r\n.mdi-format-text-rotation-none::before {\r\n  content: \"\\F0D74\";\r\n}\r\n\r\n.mdi-format-text-rotation-up::before {\r\n  content: \"\\F0FBE\";\r\n}\r\n\r\n.mdi-format-text-rotation-vertical::before {\r\n  content: \"\\F0FBF\";\r\n}\r\n\r\n.mdi-format-text-variant::before {\r\n  content: \"\\F0E32\";\r\n}\r\n\r\n.mdi-format-text-variant-outline::before {\r\n  content: \"\\F150F\";\r\n}\r\n\r\n.mdi-format-text-wrapping-clip::before {\r\n  content: \"\\F0D0E\";\r\n}\r\n\r\n.mdi-format-text-wrapping-overflow::before {\r\n  content: \"\\F0D0F\";\r\n}\r\n\r\n.mdi-format-text-wrapping-wrap::before {\r\n  content: \"\\F0D10\";\r\n}\r\n\r\n.mdi-format-textbox::before {\r\n  content: \"\\F0D11\";\r\n}\r\n\r\n.mdi-format-textdirection-l-to-r::before {\r\n  content: \"\\F0285\";\r\n}\r\n\r\n.mdi-format-textdirection-r-to-l::before {\r\n  content: \"\\F0286\";\r\n}\r\n\r\n.mdi-format-title::before {\r\n  content: \"\\F05F4\";\r\n}\r\n\r\n.mdi-format-underline::before {\r\n  content: \"\\F0287\";\r\n}\r\n\r\n.mdi-format-vertical-align-bottom::before {\r\n  content: \"\\F0621\";\r\n}\r\n\r\n.mdi-format-vertical-align-center::before {\r\n  content: \"\\F0622\";\r\n}\r\n\r\n.mdi-format-vertical-align-top::before {\r\n  content: \"\\F0623\";\r\n}\r\n\r\n.mdi-format-wrap-inline::before {\r\n  content: \"\\F0288\";\r\n}\r\n\r\n.mdi-format-wrap-square::before {\r\n  content: \"\\F0289\";\r\n}\r\n\r\n.mdi-format-wrap-tight::before {\r\n  content: \"\\F028A\";\r\n}\r\n\r\n.mdi-format-wrap-top-bottom::before {\r\n  content: \"\\F028B\";\r\n}\r\n\r\n.mdi-forum::before {\r\n  content: \"\\F028C\";\r\n}\r\n\r\n.mdi-forum-outline::before {\r\n  content: \"\\F0822\";\r\n}\r\n\r\n.mdi-forward::before {\r\n  content: \"\\F028D\";\r\n}\r\n\r\n.mdi-forwardburger::before {\r\n  content: \"\\F0D75\";\r\n}\r\n\r\n.mdi-fountain::before {\r\n  content: \"\\F096B\";\r\n}\r\n\r\n.mdi-fountain-pen::before {\r\n  content: \"\\F0D12\";\r\n}\r\n\r\n.mdi-fountain-pen-tip::before {\r\n  content: \"\\F0D13\";\r\n}\r\n\r\n.mdi-freebsd::before {\r\n  content: \"\\F08E0\";\r\n}\r\n\r\n.mdi-frequently-asked-questions::before {\r\n  content: \"\\F0EB4\";\r\n}\r\n\r\n.mdi-fridge::before {\r\n  content: \"\\F0290\";\r\n}\r\n\r\n.mdi-fridge-alert::before {\r\n  content: \"\\F11B1\";\r\n}\r\n\r\n.mdi-fridge-alert-outline::before {\r\n  content: \"\\F11B2\";\r\n}\r\n\r\n.mdi-fridge-bottom::before {\r\n  content: \"\\F0292\";\r\n}\r\n\r\n.mdi-fridge-industrial::before {\r\n  content: \"\\F15EE\";\r\n}\r\n\r\n.mdi-fridge-industrial-alert::before {\r\n  content: \"\\F15EF\";\r\n}\r\n\r\n.mdi-fridge-industrial-alert-outline::before {\r\n  content: \"\\F15F0\";\r\n}\r\n\r\n.mdi-fridge-industrial-off::before {\r\n  content: \"\\F15F1\";\r\n}\r\n\r\n.mdi-fridge-industrial-off-outline::before {\r\n  content: \"\\F15F2\";\r\n}\r\n\r\n.mdi-fridge-industrial-outline::before {\r\n  content: \"\\F15F3\";\r\n}\r\n\r\n.mdi-fridge-off::before {\r\n  content: \"\\F11AF\";\r\n}\r\n\r\n.mdi-fridge-off-outline::before {\r\n  content: \"\\F11B0\";\r\n}\r\n\r\n.mdi-fridge-outline::before {\r\n  content: \"\\F028F\";\r\n}\r\n\r\n.mdi-fridge-top::before {\r\n  content: \"\\F0291\";\r\n}\r\n\r\n.mdi-fridge-variant::before {\r\n  content: \"\\F15F4\";\r\n}\r\n\r\n.mdi-fridge-variant-alert::before {\r\n  content: \"\\F15F5\";\r\n}\r\n\r\n.mdi-fridge-variant-alert-outline::before {\r\n  content: \"\\F15F6\";\r\n}\r\n\r\n.mdi-fridge-variant-off::before {\r\n  content: \"\\F15F7\";\r\n}\r\n\r\n.mdi-fridge-variant-off-outline::before {\r\n  content: \"\\F15F8\";\r\n}\r\n\r\n.mdi-fridge-variant-outline::before {\r\n  content: \"\\F15F9\";\r\n}\r\n\r\n.mdi-fruit-cherries::before {\r\n  content: \"\\F1042\";\r\n}\r\n\r\n.mdi-fruit-cherries-off::before {\r\n  content: \"\\F13F8\";\r\n}\r\n\r\n.mdi-fruit-citrus::before {\r\n  content: \"\\F1043\";\r\n}\r\n\r\n.mdi-fruit-citrus-off::before {\r\n  content: \"\\F13F9\";\r\n}\r\n\r\n.mdi-fruit-grapes::before {\r\n  content: \"\\F1044\";\r\n}\r\n\r\n.mdi-fruit-grapes-outline::before {\r\n  content: \"\\F1045\";\r\n}\r\n\r\n.mdi-fruit-pineapple::before {\r\n  content: \"\\F1046\";\r\n}\r\n\r\n.mdi-fruit-watermelon::before {\r\n  content: \"\\F1047\";\r\n}\r\n\r\n.mdi-fuel::before {\r\n  content: \"\\F07CA\";\r\n}\r\n\r\n.mdi-fullscreen::before {\r\n  content: \"\\F0293\";\r\n}\r\n\r\n.mdi-fullscreen-exit::before {\r\n  content: \"\\F0294\";\r\n}\r\n\r\n.mdi-function::before {\r\n  content: \"\\F0295\";\r\n}\r\n\r\n.mdi-function-variant::before {\r\n  content: \"\\F0871\";\r\n}\r\n\r\n.mdi-furigana-horizontal::before {\r\n  content: \"\\F1081\";\r\n}\r\n\r\n.mdi-furigana-vertical::before {\r\n  content: \"\\F1082\";\r\n}\r\n\r\n.mdi-fuse::before {\r\n  content: \"\\F0C85\";\r\n}\r\n\r\n.mdi-fuse-alert::before {\r\n  content: \"\\F142D\";\r\n}\r\n\r\n.mdi-fuse-blade::before {\r\n  content: \"\\F0C86\";\r\n}\r\n\r\n.mdi-fuse-off::before {\r\n  content: \"\\F142C\";\r\n}\r\n\r\n.mdi-gamepad::before {\r\n  content: \"\\F0296\";\r\n}\r\n\r\n.mdi-gamepad-circle::before {\r\n  content: \"\\F0E33\";\r\n}\r\n\r\n.mdi-gamepad-circle-down::before {\r\n  content: \"\\F0E34\";\r\n}\r\n\r\n.mdi-gamepad-circle-left::before {\r\n  content: \"\\F0E35\";\r\n}\r\n\r\n.mdi-gamepad-circle-outline::before {\r\n  content: \"\\F0E36\";\r\n}\r\n\r\n.mdi-gamepad-circle-right::before {\r\n  content: \"\\F0E37\";\r\n}\r\n\r\n.mdi-gamepad-circle-up::before {\r\n  content: \"\\F0E38\";\r\n}\r\n\r\n.mdi-gamepad-down::before {\r\n  content: \"\\F0E39\";\r\n}\r\n\r\n.mdi-gamepad-left::before {\r\n  content: \"\\F0E3A\";\r\n}\r\n\r\n.mdi-gamepad-right::before {\r\n  content: \"\\F0E3B\";\r\n}\r\n\r\n.mdi-gamepad-round::before {\r\n  content: \"\\F0E3C\";\r\n}\r\n\r\n.mdi-gamepad-round-down::before {\r\n  content: \"\\F0E3D\";\r\n}\r\n\r\n.mdi-gamepad-round-left::before {\r\n  content: \"\\F0E3E\";\r\n}\r\n\r\n.mdi-gamepad-round-outline::before {\r\n  content: \"\\F0E3F\";\r\n}\r\n\r\n.mdi-gamepad-round-right::before {\r\n  content: \"\\F0E40\";\r\n}\r\n\r\n.mdi-gamepad-round-up::before {\r\n  content: \"\\F0E41\";\r\n}\r\n\r\n.mdi-gamepad-square::before {\r\n  content: \"\\F0EB5\";\r\n}\r\n\r\n.mdi-gamepad-square-outline::before {\r\n  content: \"\\F0EB6\";\r\n}\r\n\r\n.mdi-gamepad-up::before {\r\n  content: \"\\F0E42\";\r\n}\r\n\r\n.mdi-gamepad-variant::before {\r\n  content: \"\\F0297\";\r\n}\r\n\r\n.mdi-gamepad-variant-outline::before {\r\n  content: \"\\F0EB7\";\r\n}\r\n\r\n.mdi-gamma::before {\r\n  content: \"\\F10EE\";\r\n}\r\n\r\n.mdi-gantry-crane::before {\r\n  content: \"\\F0DD1\";\r\n}\r\n\r\n.mdi-garage::before {\r\n  content: \"\\F06D9\";\r\n}\r\n\r\n.mdi-garage-alert::before {\r\n  content: \"\\F0872\";\r\n}\r\n\r\n.mdi-garage-alert-variant::before {\r\n  content: \"\\F12D5\";\r\n}\r\n\r\n.mdi-garage-open::before {\r\n  content: \"\\F06DA\";\r\n}\r\n\r\n.mdi-garage-open-variant::before {\r\n  content: \"\\F12D4\";\r\n}\r\n\r\n.mdi-garage-variant::before {\r\n  content: \"\\F12D3\";\r\n}\r\n\r\n.mdi-gas-cylinder::before {\r\n  content: \"\\F0647\";\r\n}\r\n\r\n.mdi-gas-station::before {\r\n  content: \"\\F0298\";\r\n}\r\n\r\n.mdi-gas-station-off::before {\r\n  content: \"\\F1409\";\r\n}\r\n\r\n.mdi-gas-station-off-outline::before {\r\n  content: \"\\F140A\";\r\n}\r\n\r\n.mdi-gas-station-outline::before {\r\n  content: \"\\F0EB8\";\r\n}\r\n\r\n.mdi-gate::before {\r\n  content: \"\\F0299\";\r\n}\r\n\r\n.mdi-gate-and::before {\r\n  content: \"\\F08E1\";\r\n}\r\n\r\n.mdi-gate-arrow-right::before {\r\n  content: \"\\F1169\";\r\n}\r\n\r\n.mdi-gate-nand::before {\r\n  content: \"\\F08E2\";\r\n}\r\n\r\n.mdi-gate-nor::before {\r\n  content: \"\\F08E3\";\r\n}\r\n\r\n.mdi-gate-not::before {\r\n  content: \"\\F08E4\";\r\n}\r\n\r\n.mdi-gate-open::before {\r\n  content: \"\\F116A\";\r\n}\r\n\r\n.mdi-gate-or::before {\r\n  content: \"\\F08E5\";\r\n}\r\n\r\n.mdi-gate-xnor::before {\r\n  content: \"\\F08E6\";\r\n}\r\n\r\n.mdi-gate-xor::before {\r\n  content: \"\\F08E7\";\r\n}\r\n\r\n.mdi-gatsby::before {\r\n  content: \"\\F0E43\";\r\n}\r\n\r\n.mdi-gauge::before {\r\n  content: \"\\F029A\";\r\n}\r\n\r\n.mdi-gauge-empty::before {\r\n  content: \"\\F0873\";\r\n}\r\n\r\n.mdi-gauge-full::before {\r\n  content: \"\\F0874\";\r\n}\r\n\r\n.mdi-gauge-low::before {\r\n  content: \"\\F0875\";\r\n}\r\n\r\n.mdi-gavel::before {\r\n  content: \"\\F029B\";\r\n}\r\n\r\n.mdi-gender-female::before {\r\n  content: \"\\F029C\";\r\n}\r\n\r\n.mdi-gender-male::before {\r\n  content: \"\\F029D\";\r\n}\r\n\r\n.mdi-gender-male-female::before {\r\n  content: \"\\F029E\";\r\n}\r\n\r\n.mdi-gender-male-female-variant::before {\r\n  content: \"\\F113F\";\r\n}\r\n\r\n.mdi-gender-non-binary::before {\r\n  content: \"\\F1140\";\r\n}\r\n\r\n.mdi-gender-transgender::before {\r\n  content: \"\\F029F\";\r\n}\r\n\r\n.mdi-gentoo::before {\r\n  content: \"\\F08E8\";\r\n}\r\n\r\n.mdi-gesture::before {\r\n  content: \"\\F07CB\";\r\n}\r\n\r\n.mdi-gesture-double-tap::before {\r\n  content: \"\\F073C\";\r\n}\r\n\r\n.mdi-gesture-pinch::before {\r\n  content: \"\\F0ABD\";\r\n}\r\n\r\n.mdi-gesture-spread::before {\r\n  content: \"\\F0ABE\";\r\n}\r\n\r\n.mdi-gesture-swipe::before {\r\n  content: \"\\F0D76\";\r\n}\r\n\r\n.mdi-gesture-swipe-down::before {\r\n  content: \"\\F073D\";\r\n}\r\n\r\n.mdi-gesture-swipe-horizontal::before {\r\n  content: \"\\F0ABF\";\r\n}\r\n\r\n.mdi-gesture-swipe-left::before {\r\n  content: \"\\F073E\";\r\n}\r\n\r\n.mdi-gesture-swipe-right::before {\r\n  content: \"\\F073F\";\r\n}\r\n\r\n.mdi-gesture-swipe-up::before {\r\n  content: \"\\F0740\";\r\n}\r\n\r\n.mdi-gesture-swipe-vertical::before {\r\n  content: \"\\F0AC0\";\r\n}\r\n\r\n.mdi-gesture-tap::before {\r\n  content: \"\\F0741\";\r\n}\r\n\r\n.mdi-gesture-tap-box::before {\r\n  content: \"\\F12A9\";\r\n}\r\n\r\n.mdi-gesture-tap-button::before {\r\n  content: \"\\F12A8\";\r\n}\r\n\r\n.mdi-gesture-tap-hold::before {\r\n  content: \"\\F0D77\";\r\n}\r\n\r\n.mdi-gesture-two-double-tap::before {\r\n  content: \"\\F0742\";\r\n}\r\n\r\n.mdi-gesture-two-tap::before {\r\n  content: \"\\F0743\";\r\n}\r\n\r\n.mdi-ghost::before {\r\n  content: \"\\F02A0\";\r\n}\r\n\r\n.mdi-ghost-off::before {\r\n  content: \"\\F09F5\";\r\n}\r\n\r\n.mdi-ghost-off-outline::before {\r\n  content: \"\\F165C\";\r\n}\r\n\r\n.mdi-ghost-outline::before {\r\n  content: \"\\F165D\";\r\n}\r\n\r\n.mdi-gif::before {\r\n  content: \"\\F0D78\";\r\n}\r\n\r\n.mdi-gift::before {\r\n  content: \"\\F0E44\";\r\n}\r\n\r\n.mdi-gift-outline::before {\r\n  content: \"\\F02A1\";\r\n}\r\n\r\n.mdi-git::before {\r\n  content: \"\\F02A2\";\r\n}\r\n\r\n.mdi-github::before {\r\n  content: \"\\F02A4\";\r\n}\r\n\r\n.mdi-gitlab::before {\r\n  content: \"\\F0BA0\";\r\n}\r\n\r\n.mdi-glass-cocktail::before {\r\n  content: \"\\F0356\";\r\n}\r\n\r\n.mdi-glass-cocktail-off::before {\r\n  content: \"\\F15E6\";\r\n}\r\n\r\n.mdi-glass-flute::before {\r\n  content: \"\\F02A5\";\r\n}\r\n\r\n.mdi-glass-mug::before {\r\n  content: \"\\F02A6\";\r\n}\r\n\r\n.mdi-glass-mug-off::before {\r\n  content: \"\\F15E7\";\r\n}\r\n\r\n.mdi-glass-mug-variant::before {\r\n  content: \"\\F1116\";\r\n}\r\n\r\n.mdi-glass-mug-variant-off::before {\r\n  content: \"\\F15E8\";\r\n}\r\n\r\n.mdi-glass-pint-outline::before {\r\n  content: \"\\F130D\";\r\n}\r\n\r\n.mdi-glass-stange::before {\r\n  content: \"\\F02A7\";\r\n}\r\n\r\n.mdi-glass-tulip::before {\r\n  content: \"\\F02A8\";\r\n}\r\n\r\n.mdi-glass-wine::before {\r\n  content: \"\\F0876\";\r\n}\r\n\r\n.mdi-glasses::before {\r\n  content: \"\\F02AA\";\r\n}\r\n\r\n.mdi-globe-light::before {\r\n  content: \"\\F12D7\";\r\n}\r\n\r\n.mdi-globe-model::before {\r\n  content: \"\\F08E9\";\r\n}\r\n\r\n.mdi-gmail::before {\r\n  content: \"\\F02AB\";\r\n}\r\n\r\n.mdi-gnome::before {\r\n  content: \"\\F02AC\";\r\n}\r\n\r\n.mdi-go-kart::before {\r\n  content: \"\\F0D79\";\r\n}\r\n\r\n.mdi-go-kart-track::before {\r\n  content: \"\\F0D7A\";\r\n}\r\n\r\n.mdi-gog::before {\r\n  content: \"\\F0BA1\";\r\n}\r\n\r\n.mdi-gold::before {\r\n  content: \"\\F124F\";\r\n}\r\n\r\n.mdi-golf::before {\r\n  content: \"\\F0823\";\r\n}\r\n\r\n.mdi-golf-cart::before {\r\n  content: \"\\F11A4\";\r\n}\r\n\r\n.mdi-golf-tee::before {\r\n  content: \"\\F1083\";\r\n}\r\n\r\n.mdi-gondola::before {\r\n  content: \"\\F0686\";\r\n}\r\n\r\n.mdi-goodreads::before {\r\n  content: \"\\F0D7B\";\r\n}\r\n\r\n.mdi-google::before {\r\n  content: \"\\F02AD\";\r\n}\r\n\r\n.mdi-google-ads::before {\r\n  content: \"\\F0C87\";\r\n}\r\n\r\n.mdi-google-analytics::before {\r\n  content: \"\\F07CC\";\r\n}\r\n\r\n.mdi-google-assistant::before {\r\n  content: \"\\F07CD\";\r\n}\r\n\r\n.mdi-google-cardboard::before {\r\n  content: \"\\F02AE\";\r\n}\r\n\r\n.mdi-google-chrome::before {\r\n  content: \"\\F02AF\";\r\n}\r\n\r\n.mdi-google-circles::before {\r\n  content: \"\\F02B0\";\r\n}\r\n\r\n.mdi-google-circles-communities::before {\r\n  content: \"\\F02B1\";\r\n}\r\n\r\n.mdi-google-circles-extended::before {\r\n  content: \"\\F02B2\";\r\n}\r\n\r\n.mdi-google-circles-group::before {\r\n  content: \"\\F02B3\";\r\n}\r\n\r\n.mdi-google-classroom::before {\r\n  content: \"\\F02C0\";\r\n}\r\n\r\n.mdi-google-cloud::before {\r\n  content: \"\\F11F6\";\r\n}\r\n\r\n.mdi-google-controller::before {\r\n  content: \"\\F02B4\";\r\n}\r\n\r\n.mdi-google-controller-off::before {\r\n  content: \"\\F02B5\";\r\n}\r\n\r\n.mdi-google-downasaur::before {\r\n  content: \"\\F1362\";\r\n}\r\n\r\n.mdi-google-drive::before {\r\n  content: \"\\F02B6\";\r\n}\r\n\r\n.mdi-google-earth::before {\r\n  content: \"\\F02B7\";\r\n}\r\n\r\n.mdi-google-fit::before {\r\n  content: \"\\F096C\";\r\n}\r\n\r\n.mdi-google-glass::before {\r\n  content: \"\\F02B8\";\r\n}\r\n\r\n.mdi-google-hangouts::before {\r\n  content: \"\\F02C9\";\r\n}\r\n\r\n.mdi-google-home::before {\r\n  content: \"\\F0824\";\r\n}\r\n\r\n.mdi-google-keep::before {\r\n  content: \"\\F06DC\";\r\n}\r\n\r\n.mdi-google-lens::before {\r\n  content: \"\\F09F6\";\r\n}\r\n\r\n.mdi-google-maps::before {\r\n  content: \"\\F05F5\";\r\n}\r\n\r\n.mdi-google-my-business::before {\r\n  content: \"\\F1048\";\r\n}\r\n\r\n.mdi-google-nearby::before {\r\n  content: \"\\F02B9\";\r\n}\r\n\r\n.mdi-google-photos::before {\r\n  content: \"\\F06DD\";\r\n}\r\n\r\n.mdi-google-play::before {\r\n  content: \"\\F02BC\";\r\n}\r\n\r\n.mdi-google-plus::before {\r\n  content: \"\\F02BD\";\r\n}\r\n\r\n.mdi-google-podcast::before {\r\n  content: \"\\F0EB9\";\r\n}\r\n\r\n.mdi-google-spreadsheet::before {\r\n  content: \"\\F09F7\";\r\n}\r\n\r\n.mdi-google-street-view::before {\r\n  content: \"\\F0C88\";\r\n}\r\n\r\n.mdi-google-translate::before {\r\n  content: \"\\F02BF\";\r\n}\r\n\r\n.mdi-gradient::before {\r\n  content: \"\\F06A0\";\r\n}\r\n\r\n.mdi-grain::before {\r\n  content: \"\\F0D7C\";\r\n}\r\n\r\n.mdi-graph::before {\r\n  content: \"\\F1049\";\r\n}\r\n\r\n.mdi-graph-outline::before {\r\n  content: \"\\F104A\";\r\n}\r\n\r\n.mdi-graphql::before {\r\n  content: \"\\F0877\";\r\n}\r\n\r\n.mdi-grass::before {\r\n  content: \"\\F1510\";\r\n}\r\n\r\n.mdi-grave-stone::before {\r\n  content: \"\\F0BA2\";\r\n}\r\n\r\n.mdi-grease-pencil::before {\r\n  content: \"\\F0648\";\r\n}\r\n\r\n.mdi-greater-than::before {\r\n  content: \"\\F096D\";\r\n}\r\n\r\n.mdi-greater-than-or-equal::before {\r\n  content: \"\\F096E\";\r\n}\r\n\r\n.mdi-grid::before {\r\n  content: \"\\F02C1\";\r\n}\r\n\r\n.mdi-grid-large::before {\r\n  content: \"\\F0758\";\r\n}\r\n\r\n.mdi-grid-off::before {\r\n  content: \"\\F02C2\";\r\n}\r\n\r\n.mdi-grill::before {\r\n  content: \"\\F0E45\";\r\n}\r\n\r\n.mdi-grill-outline::before {\r\n  content: \"\\F118A\";\r\n}\r\n\r\n.mdi-group::before {\r\n  content: \"\\F02C3\";\r\n}\r\n\r\n.mdi-guitar-acoustic::before {\r\n  content: \"\\F0771\";\r\n}\r\n\r\n.mdi-guitar-electric::before {\r\n  content: \"\\F02C4\";\r\n}\r\n\r\n.mdi-guitar-pick::before {\r\n  content: \"\\F02C5\";\r\n}\r\n\r\n.mdi-guitar-pick-outline::before {\r\n  content: \"\\F02C6\";\r\n}\r\n\r\n.mdi-guy-fawkes-mask::before {\r\n  content: \"\\F0825\";\r\n}\r\n\r\n.mdi-hail::before {\r\n  content: \"\\F0AC1\";\r\n}\r\n\r\n.mdi-hair-dryer::before {\r\n  content: \"\\F10EF\";\r\n}\r\n\r\n.mdi-hair-dryer-outline::before {\r\n  content: \"\\F10F0\";\r\n}\r\n\r\n.mdi-halloween::before {\r\n  content: \"\\F0BA3\";\r\n}\r\n\r\n.mdi-hamburger::before {\r\n  content: \"\\F0685\";\r\n}\r\n\r\n.mdi-hammer::before {\r\n  content: \"\\F08EA\";\r\n}\r\n\r\n.mdi-hammer-screwdriver::before {\r\n  content: \"\\F1322\";\r\n}\r\n\r\n.mdi-hammer-wrench::before {\r\n  content: \"\\F1323\";\r\n}\r\n\r\n.mdi-hand::before {\r\n  content: \"\\F0A4F\";\r\n}\r\n\r\n.mdi-hand-heart::before {\r\n  content: \"\\F10F1\";\r\n}\r\n\r\n.mdi-hand-heart-outline::before {\r\n  content: \"\\F157E\";\r\n}\r\n\r\n.mdi-hand-left::before {\r\n  content: \"\\F0E46\";\r\n}\r\n\r\n.mdi-hand-okay::before {\r\n  content: \"\\F0A50\";\r\n}\r\n\r\n.mdi-hand-peace::before {\r\n  content: \"\\F0A51\";\r\n}\r\n\r\n.mdi-hand-peace-variant::before {\r\n  content: \"\\F0A52\";\r\n}\r\n\r\n.mdi-hand-pointing-down::before {\r\n  content: \"\\F0A53\";\r\n}\r\n\r\n.mdi-hand-pointing-left::before {\r\n  content: \"\\F0A54\";\r\n}\r\n\r\n.mdi-hand-pointing-right::before {\r\n  content: \"\\F02C7\";\r\n}\r\n\r\n.mdi-hand-pointing-up::before {\r\n  content: \"\\F0A55\";\r\n}\r\n\r\n.mdi-hand-right::before {\r\n  content: \"\\F0E47\";\r\n}\r\n\r\n.mdi-hand-saw::before {\r\n  content: \"\\F0E48\";\r\n}\r\n\r\n.mdi-hand-wash::before {\r\n  content: \"\\F157F\";\r\n}\r\n\r\n.mdi-hand-wash-outline::before {\r\n  content: \"\\F1580\";\r\n}\r\n\r\n.mdi-hand-water::before {\r\n  content: \"\\F139F\";\r\n}\r\n\r\n.mdi-handball::before {\r\n  content: \"\\F0F53\";\r\n}\r\n\r\n.mdi-handcuffs::before {\r\n  content: \"\\F113E\";\r\n}\r\n\r\n.mdi-handshake::before {\r\n  content: \"\\F1218\";\r\n}\r\n\r\n.mdi-handshake-outline::before {\r\n  content: \"\\F15A1\";\r\n}\r\n\r\n.mdi-hanger::before {\r\n  content: \"\\F02C8\";\r\n}\r\n\r\n.mdi-hard-hat::before {\r\n  content: \"\\F096F\";\r\n}\r\n\r\n.mdi-harddisk::before {\r\n  content: \"\\F02CA\";\r\n}\r\n\r\n.mdi-harddisk-plus::before {\r\n  content: \"\\F104B\";\r\n}\r\n\r\n.mdi-harddisk-remove::before {\r\n  content: \"\\F104C\";\r\n}\r\n\r\n.mdi-hat-fedora::before {\r\n  content: \"\\F0BA4\";\r\n}\r\n\r\n.mdi-hazard-lights::before {\r\n  content: \"\\F0C89\";\r\n}\r\n\r\n.mdi-hdr::before {\r\n  content: \"\\F0D7D\";\r\n}\r\n\r\n.mdi-hdr-off::before {\r\n  content: \"\\F0D7E\";\r\n}\r\n\r\n.mdi-head::before {\r\n  content: \"\\F135E\";\r\n}\r\n\r\n.mdi-head-alert::before {\r\n  content: \"\\F1338\";\r\n}\r\n\r\n.mdi-head-alert-outline::before {\r\n  content: \"\\F1339\";\r\n}\r\n\r\n.mdi-head-check::before {\r\n  content: \"\\F133A\";\r\n}\r\n\r\n.mdi-head-check-outline::before {\r\n  content: \"\\F133B\";\r\n}\r\n\r\n.mdi-head-cog::before {\r\n  content: \"\\F133C\";\r\n}\r\n\r\n.mdi-head-cog-outline::before {\r\n  content: \"\\F133D\";\r\n}\r\n\r\n.mdi-head-dots-horizontal::before {\r\n  content: \"\\F133E\";\r\n}\r\n\r\n.mdi-head-dots-horizontal-outline::before {\r\n  content: \"\\F133F\";\r\n}\r\n\r\n.mdi-head-flash::before {\r\n  content: \"\\F1340\";\r\n}\r\n\r\n.mdi-head-flash-outline::before {\r\n  content: \"\\F1341\";\r\n}\r\n\r\n.mdi-head-heart::before {\r\n  content: \"\\F1342\";\r\n}\r\n\r\n.mdi-head-heart-outline::before {\r\n  content: \"\\F1343\";\r\n}\r\n\r\n.mdi-head-lightbulb::before {\r\n  content: \"\\F1344\";\r\n}\r\n\r\n.mdi-head-lightbulb-outline::before {\r\n  content: \"\\F1345\";\r\n}\r\n\r\n.mdi-head-minus::before {\r\n  content: \"\\F1346\";\r\n}\r\n\r\n.mdi-head-minus-outline::before {\r\n  content: \"\\F1347\";\r\n}\r\n\r\n.mdi-head-outline::before {\r\n  content: \"\\F135F\";\r\n}\r\n\r\n.mdi-head-plus::before {\r\n  content: \"\\F1348\";\r\n}\r\n\r\n.mdi-head-plus-outline::before {\r\n  content: \"\\F1349\";\r\n}\r\n\r\n.mdi-head-question::before {\r\n  content: \"\\F134A\";\r\n}\r\n\r\n.mdi-head-question-outline::before {\r\n  content: \"\\F134B\";\r\n}\r\n\r\n.mdi-head-remove::before {\r\n  content: \"\\F134C\";\r\n}\r\n\r\n.mdi-head-remove-outline::before {\r\n  content: \"\\F134D\";\r\n}\r\n\r\n.mdi-head-snowflake::before {\r\n  content: \"\\F134E\";\r\n}\r\n\r\n.mdi-head-snowflake-outline::before {\r\n  content: \"\\F134F\";\r\n}\r\n\r\n.mdi-head-sync::before {\r\n  content: \"\\F1350\";\r\n}\r\n\r\n.mdi-head-sync-outline::before {\r\n  content: \"\\F1351\";\r\n}\r\n\r\n.mdi-headphones::before {\r\n  content: \"\\F02CB\";\r\n}\r\n\r\n.mdi-headphones-bluetooth::before {\r\n  content: \"\\F0970\";\r\n}\r\n\r\n.mdi-headphones-box::before {\r\n  content: \"\\F02CC\";\r\n}\r\n\r\n.mdi-headphones-off::before {\r\n  content: \"\\F07CE\";\r\n}\r\n\r\n.mdi-headphones-settings::before {\r\n  content: \"\\F02CD\";\r\n}\r\n\r\n.mdi-headset::before {\r\n  content: \"\\F02CE\";\r\n}\r\n\r\n.mdi-headset-dock::before {\r\n  content: \"\\F02CF\";\r\n}\r\n\r\n.mdi-headset-off::before {\r\n  content: \"\\F02D0\";\r\n}\r\n\r\n.mdi-heart::before {\r\n  content: \"\\F02D1\";\r\n}\r\n\r\n.mdi-heart-box::before {\r\n  content: \"\\F02D2\";\r\n}\r\n\r\n.mdi-heart-box-outline::before {\r\n  content: \"\\F02D3\";\r\n}\r\n\r\n.mdi-heart-broken::before {\r\n  content: \"\\F02D4\";\r\n}\r\n\r\n.mdi-heart-broken-outline::before {\r\n  content: \"\\F0D14\";\r\n}\r\n\r\n.mdi-heart-circle::before {\r\n  content: \"\\F0971\";\r\n}\r\n\r\n.mdi-heart-circle-outline::before {\r\n  content: \"\\F0972\";\r\n}\r\n\r\n.mdi-heart-cog::before {\r\n  content: \"\\F1663\";\r\n}\r\n\r\n.mdi-heart-cog-outline::before {\r\n  content: \"\\F1664\";\r\n}\r\n\r\n.mdi-heart-flash::before {\r\n  content: \"\\F0EF9\";\r\n}\r\n\r\n.mdi-heart-half::before {\r\n  content: \"\\F06DF\";\r\n}\r\n\r\n.mdi-heart-half-full::before {\r\n  content: \"\\F06DE\";\r\n}\r\n\r\n.mdi-heart-half-outline::before {\r\n  content: \"\\F06E0\";\r\n}\r\n\r\n.mdi-heart-minus::before {\r\n  content: \"\\F142F\";\r\n}\r\n\r\n.mdi-heart-minus-outline::before {\r\n  content: \"\\F1432\";\r\n}\r\n\r\n.mdi-heart-multiple::before {\r\n  content: \"\\F0A56\";\r\n}\r\n\r\n.mdi-heart-multiple-outline::before {\r\n  content: \"\\F0A57\";\r\n}\r\n\r\n.mdi-heart-off::before {\r\n  content: \"\\F0759\";\r\n}\r\n\r\n.mdi-heart-off-outline::before {\r\n  content: \"\\F1434\";\r\n}\r\n\r\n.mdi-heart-outline::before {\r\n  content: \"\\F02D5\";\r\n}\r\n\r\n.mdi-heart-plus::before {\r\n  content: \"\\F142E\";\r\n}\r\n\r\n.mdi-heart-plus-outline::before {\r\n  content: \"\\F1431\";\r\n}\r\n\r\n.mdi-heart-pulse::before {\r\n  content: \"\\F05F6\";\r\n}\r\n\r\n.mdi-heart-remove::before {\r\n  content: \"\\F1430\";\r\n}\r\n\r\n.mdi-heart-remove-outline::before {\r\n  content: \"\\F1433\";\r\n}\r\n\r\n.mdi-heart-settings::before {\r\n  content: \"\\F1665\";\r\n}\r\n\r\n.mdi-heart-settings-outline::before {\r\n  content: \"\\F1666\";\r\n}\r\n\r\n.mdi-helicopter::before {\r\n  content: \"\\F0AC2\";\r\n}\r\n\r\n.mdi-help::before {\r\n  content: \"\\F02D6\";\r\n}\r\n\r\n.mdi-help-box::before {\r\n  content: \"\\F078B\";\r\n}\r\n\r\n.mdi-help-circle::before {\r\n  content: \"\\F02D7\";\r\n}\r\n\r\n.mdi-help-circle-outline::before {\r\n  content: \"\\F0625\";\r\n}\r\n\r\n.mdi-help-network::before {\r\n  content: \"\\F06F5\";\r\n}\r\n\r\n.mdi-help-network-outline::before {\r\n  content: \"\\F0C8A\";\r\n}\r\n\r\n.mdi-help-rhombus::before {\r\n  content: \"\\F0BA5\";\r\n}\r\n\r\n.mdi-help-rhombus-outline::before {\r\n  content: \"\\F0BA6\";\r\n}\r\n\r\n.mdi-hexadecimal::before {\r\n  content: \"\\F12A7\";\r\n}\r\n\r\n.mdi-hexagon::before {\r\n  content: \"\\F02D8\";\r\n}\r\n\r\n.mdi-hexagon-multiple::before {\r\n  content: \"\\F06E1\";\r\n}\r\n\r\n.mdi-hexagon-multiple-outline::before {\r\n  content: \"\\F10F2\";\r\n}\r\n\r\n.mdi-hexagon-outline::before {\r\n  content: \"\\F02D9\";\r\n}\r\n\r\n.mdi-hexagon-slice-1::before {\r\n  content: \"\\F0AC3\";\r\n}\r\n\r\n.mdi-hexagon-slice-2::before {\r\n  content: \"\\F0AC4\";\r\n}\r\n\r\n.mdi-hexagon-slice-3::before {\r\n  content: \"\\F0AC5\";\r\n}\r\n\r\n.mdi-hexagon-slice-4::before {\r\n  content: \"\\F0AC6\";\r\n}\r\n\r\n.mdi-hexagon-slice-5::before {\r\n  content: \"\\F0AC7\";\r\n}\r\n\r\n.mdi-hexagon-slice-6::before {\r\n  content: \"\\F0AC8\";\r\n}\r\n\r\n.mdi-hexagram::before {\r\n  content: \"\\F0AC9\";\r\n}\r\n\r\n.mdi-hexagram-outline::before {\r\n  content: \"\\F0ACA\";\r\n}\r\n\r\n.mdi-high-definition::before {\r\n  content: \"\\F07CF\";\r\n}\r\n\r\n.mdi-high-definition-box::before {\r\n  content: \"\\F0878\";\r\n}\r\n\r\n.mdi-highway::before {\r\n  content: \"\\F05F7\";\r\n}\r\n\r\n.mdi-hiking::before {\r\n  content: \"\\F0D7F\";\r\n}\r\n\r\n.mdi-hinduism::before {\r\n  content: \"\\F0973\";\r\n}\r\n\r\n.mdi-history::before {\r\n  content: \"\\F02DA\";\r\n}\r\n\r\n.mdi-hockey-puck::before {\r\n  content: \"\\F0879\";\r\n}\r\n\r\n.mdi-hockey-sticks::before {\r\n  content: \"\\F087A\";\r\n}\r\n\r\n.mdi-hololens::before {\r\n  content: \"\\F02DB\";\r\n}\r\n\r\n.mdi-home::before {\r\n  content: \"\\F02DC\";\r\n}\r\n\r\n.mdi-home-account::before {\r\n  content: \"\\F0826\";\r\n}\r\n\r\n.mdi-home-alert::before {\r\n  content: \"\\F087B\";\r\n}\r\n\r\n.mdi-home-alert-outline::before {\r\n  content: \"\\F15D0\";\r\n}\r\n\r\n.mdi-home-analytics::before {\r\n  content: \"\\F0EBA\";\r\n}\r\n\r\n.mdi-home-assistant::before {\r\n  content: \"\\F07D0\";\r\n}\r\n\r\n.mdi-home-automation::before {\r\n  content: \"\\F07D1\";\r\n}\r\n\r\n.mdi-home-circle::before {\r\n  content: \"\\F07D2\";\r\n}\r\n\r\n.mdi-home-circle-outline::before {\r\n  content: \"\\F104D\";\r\n}\r\n\r\n.mdi-home-city::before {\r\n  content: \"\\F0D15\";\r\n}\r\n\r\n.mdi-home-city-outline::before {\r\n  content: \"\\F0D16\";\r\n}\r\n\r\n.mdi-home-currency-usd::before {\r\n  content: \"\\F08AF\";\r\n}\r\n\r\n.mdi-home-edit::before {\r\n  content: \"\\F1159\";\r\n}\r\n\r\n.mdi-home-edit-outline::before {\r\n  content: \"\\F115A\";\r\n}\r\n\r\n.mdi-home-export-outline::before {\r\n  content: \"\\F0F9B\";\r\n}\r\n\r\n.mdi-home-flood::before {\r\n  content: \"\\F0EFA\";\r\n}\r\n\r\n.mdi-home-floor-0::before {\r\n  content: \"\\F0DD2\";\r\n}\r\n\r\n.mdi-home-floor-1::before {\r\n  content: \"\\F0D80\";\r\n}\r\n\r\n.mdi-home-floor-2::before {\r\n  content: \"\\F0D81\";\r\n}\r\n\r\n.mdi-home-floor-3::before {\r\n  content: \"\\F0D82\";\r\n}\r\n\r\n.mdi-home-floor-a::before {\r\n  content: \"\\F0D83\";\r\n}\r\n\r\n.mdi-home-floor-b::before {\r\n  content: \"\\F0D84\";\r\n}\r\n\r\n.mdi-home-floor-g::before {\r\n  content: \"\\F0D85\";\r\n}\r\n\r\n.mdi-home-floor-l::before {\r\n  content: \"\\F0D86\";\r\n}\r\n\r\n.mdi-home-floor-negative-1::before {\r\n  content: \"\\F0DD3\";\r\n}\r\n\r\n.mdi-home-group::before {\r\n  content: \"\\F0DD4\";\r\n}\r\n\r\n.mdi-home-heart::before {\r\n  content: \"\\F0827\";\r\n}\r\n\r\n.mdi-home-import-outline::before {\r\n  content: \"\\F0F9C\";\r\n}\r\n\r\n.mdi-home-lightbulb::before {\r\n  content: \"\\F1251\";\r\n}\r\n\r\n.mdi-home-lightbulb-outline::before {\r\n  content: \"\\F1252\";\r\n}\r\n\r\n.mdi-home-lock::before {\r\n  content: \"\\F08EB\";\r\n}\r\n\r\n.mdi-home-lock-open::before {\r\n  content: \"\\F08EC\";\r\n}\r\n\r\n.mdi-home-map-marker::before {\r\n  content: \"\\F05F8\";\r\n}\r\n\r\n.mdi-home-minus::before {\r\n  content: \"\\F0974\";\r\n}\r\n\r\n.mdi-home-minus-outline::before {\r\n  content: \"\\F13D5\";\r\n}\r\n\r\n.mdi-home-modern::before {\r\n  content: \"\\F02DD\";\r\n}\r\n\r\n.mdi-home-outline::before {\r\n  content: \"\\F06A1\";\r\n}\r\n\r\n.mdi-home-plus::before {\r\n  content: \"\\F0975\";\r\n}\r\n\r\n.mdi-home-plus-outline::before {\r\n  content: \"\\F13D6\";\r\n}\r\n\r\n.mdi-home-remove::before {\r\n  content: \"\\F1247\";\r\n}\r\n\r\n.mdi-home-remove-outline::before {\r\n  content: \"\\F13D7\";\r\n}\r\n\r\n.mdi-home-roof::before {\r\n  content: \"\\F112B\";\r\n}\r\n\r\n.mdi-home-search::before {\r\n  content: \"\\F13B0\";\r\n}\r\n\r\n.mdi-home-search-outline::before {\r\n  content: \"\\F13B1\";\r\n}\r\n\r\n.mdi-home-thermometer::before {\r\n  content: \"\\F0F54\";\r\n}\r\n\r\n.mdi-home-thermometer-outline::before {\r\n  content: \"\\F0F55\";\r\n}\r\n\r\n.mdi-home-variant::before {\r\n  content: \"\\F02DE\";\r\n}\r\n\r\n.mdi-home-variant-outline::before {\r\n  content: \"\\F0BA7\";\r\n}\r\n\r\n.mdi-hook::before {\r\n  content: \"\\F06E2\";\r\n}\r\n\r\n.mdi-hook-off::before {\r\n  content: \"\\F06E3\";\r\n}\r\n\r\n.mdi-hops::before {\r\n  content: \"\\F02DF\";\r\n}\r\n\r\n.mdi-horizontal-rotate-clockwise::before {\r\n  content: \"\\F10F3\";\r\n}\r\n\r\n.mdi-horizontal-rotate-counterclockwise::before {\r\n  content: \"\\F10F4\";\r\n}\r\n\r\n.mdi-horse::before {\r\n  content: \"\\F15BF\";\r\n}\r\n\r\n.mdi-horse-human::before {\r\n  content: \"\\F15C0\";\r\n}\r\n\r\n.mdi-horse-variant::before {\r\n  content: \"\\F15C1\";\r\n}\r\n\r\n.mdi-horseshoe::before {\r\n  content: \"\\F0A58\";\r\n}\r\n\r\n.mdi-hospital::before {\r\n  content: \"\\F0FF6\";\r\n}\r\n\r\n.mdi-hospital-box::before {\r\n  content: \"\\F02E0\";\r\n}\r\n\r\n.mdi-hospital-box-outline::before {\r\n  content: \"\\F0FF7\";\r\n}\r\n\r\n.mdi-hospital-building::before {\r\n  content: \"\\F02E1\";\r\n}\r\n\r\n.mdi-hospital-marker::before {\r\n  content: \"\\F02E2\";\r\n}\r\n\r\n.mdi-hot-tub::before {\r\n  content: \"\\F0828\";\r\n}\r\n\r\n.mdi-hours-24::before {\r\n  content: \"\\F1478\";\r\n}\r\n\r\n.mdi-hubspot::before {\r\n  content: \"\\F0D17\";\r\n}\r\n\r\n.mdi-hulu::before {\r\n  content: \"\\F0829\";\r\n}\r\n\r\n.mdi-human::before {\r\n  content: \"\\F02E6\";\r\n}\r\n\r\n.mdi-human-baby-changing-table::before {\r\n  content: \"\\F138B\";\r\n}\r\n\r\n.mdi-human-cane::before {\r\n  content: \"\\F1581\";\r\n}\r\n\r\n.mdi-human-capacity-decrease::before {\r\n  content: \"\\F159B\";\r\n}\r\n\r\n.mdi-human-capacity-increase::before {\r\n  content: \"\\F159C\";\r\n}\r\n\r\n.mdi-human-child::before {\r\n  content: \"\\F02E7\";\r\n}\r\n\r\n.mdi-human-edit::before {\r\n  content: \"\\F14E8\";\r\n}\r\n\r\n.mdi-human-female::before {\r\n  content: \"\\F0649\";\r\n}\r\n\r\n.mdi-human-female-boy::before {\r\n  content: \"\\F0A59\";\r\n}\r\n\r\n.mdi-human-female-dance::before {\r\n  content: \"\\F15C9\";\r\n}\r\n\r\n.mdi-human-female-female::before {\r\n  content: \"\\F0A5A\";\r\n}\r\n\r\n.mdi-human-female-girl::before {\r\n  content: \"\\F0A5B\";\r\n}\r\n\r\n.mdi-human-greeting::before {\r\n  content: \"\\F064A\";\r\n}\r\n\r\n.mdi-human-greeting-proximity::before {\r\n  content: \"\\F159D\";\r\n}\r\n\r\n.mdi-human-handsdown::before {\r\n  content: \"\\F064B\";\r\n}\r\n\r\n.mdi-human-handsup::before {\r\n  content: \"\\F064C\";\r\n}\r\n\r\n.mdi-human-male::before {\r\n  content: \"\\F064D\";\r\n}\r\n\r\n.mdi-human-male-boy::before {\r\n  content: \"\\F0A5C\";\r\n}\r\n\r\n.mdi-human-male-child::before {\r\n  content: \"\\F138C\";\r\n}\r\n\r\n.mdi-human-male-female::before {\r\n  content: \"\\F02E8\";\r\n}\r\n\r\n.mdi-human-male-girl::before {\r\n  content: \"\\F0A5D\";\r\n}\r\n\r\n.mdi-human-male-height::before {\r\n  content: \"\\F0EFB\";\r\n}\r\n\r\n.mdi-human-male-height-variant::before {\r\n  content: \"\\F0EFC\";\r\n}\r\n\r\n.mdi-human-male-male::before {\r\n  content: \"\\F0A5E\";\r\n}\r\n\r\n.mdi-human-pregnant::before {\r\n  content: \"\\F05CF\";\r\n}\r\n\r\n.mdi-human-queue::before {\r\n  content: \"\\F1571\";\r\n}\r\n\r\n.mdi-human-scooter::before {\r\n  content: \"\\F11E9\";\r\n}\r\n\r\n.mdi-human-wheelchair::before {\r\n  content: \"\\F138D\";\r\n}\r\n\r\n.mdi-humble-bundle::before {\r\n  content: \"\\F0744\";\r\n}\r\n\r\n.mdi-hvac::before {\r\n  content: \"\\F1352\";\r\n}\r\n\r\n.mdi-hvac-off::before {\r\n  content: \"\\F159E\";\r\n}\r\n\r\n.mdi-hydraulic-oil-level::before {\r\n  content: \"\\F1324\";\r\n}\r\n\r\n.mdi-hydraulic-oil-temperature::before {\r\n  content: \"\\F1325\";\r\n}\r\n\r\n.mdi-hydro-power::before {\r\n  content: \"\\F12E5\";\r\n}\r\n\r\n.mdi-ice-cream::before {\r\n  content: \"\\F082A\";\r\n}\r\n\r\n.mdi-ice-cream-off::before {\r\n  content: \"\\F0E52\";\r\n}\r\n\r\n.mdi-ice-pop::before {\r\n  content: \"\\F0EFD\";\r\n}\r\n\r\n.mdi-id-card::before {\r\n  content: \"\\F0FC0\";\r\n}\r\n\r\n.mdi-identifier::before {\r\n  content: \"\\F0EFE\";\r\n}\r\n\r\n.mdi-ideogram-cjk::before {\r\n  content: \"\\F1331\";\r\n}\r\n\r\n.mdi-ideogram-cjk-variant::before {\r\n  content: \"\\F1332\";\r\n}\r\n\r\n.mdi-iframe::before {\r\n  content: \"\\F0C8B\";\r\n}\r\n\r\n.mdi-iframe-array::before {\r\n  content: \"\\F10F5\";\r\n}\r\n\r\n.mdi-iframe-array-outline::before {\r\n  content: \"\\F10F6\";\r\n}\r\n\r\n.mdi-iframe-braces::before {\r\n  content: \"\\F10F7\";\r\n}\r\n\r\n.mdi-iframe-braces-outline::before {\r\n  content: \"\\F10F8\";\r\n}\r\n\r\n.mdi-iframe-outline::before {\r\n  content: \"\\F0C8C\";\r\n}\r\n\r\n.mdi-iframe-parentheses::before {\r\n  content: \"\\F10F9\";\r\n}\r\n\r\n.mdi-iframe-parentheses-outline::before {\r\n  content: \"\\F10FA\";\r\n}\r\n\r\n.mdi-iframe-variable::before {\r\n  content: \"\\F10FB\";\r\n}\r\n\r\n.mdi-iframe-variable-outline::before {\r\n  content: \"\\F10FC\";\r\n}\r\n\r\n.mdi-image::before {\r\n  content: \"\\F02E9\";\r\n}\r\n\r\n.mdi-image-album::before {\r\n  content: \"\\F02EA\";\r\n}\r\n\r\n.mdi-image-area::before {\r\n  content: \"\\F02EB\";\r\n}\r\n\r\n.mdi-image-area-close::before {\r\n  content: \"\\F02EC\";\r\n}\r\n\r\n.mdi-image-auto-adjust::before {\r\n  content: \"\\F0FC1\";\r\n}\r\n\r\n.mdi-image-broken::before {\r\n  content: \"\\F02ED\";\r\n}\r\n\r\n.mdi-image-broken-variant::before {\r\n  content: \"\\F02EE\";\r\n}\r\n\r\n.mdi-image-edit::before {\r\n  content: \"\\F11E3\";\r\n}\r\n\r\n.mdi-image-edit-outline::before {\r\n  content: \"\\F11E4\";\r\n}\r\n\r\n.mdi-image-filter-black-white::before {\r\n  content: \"\\F02F0\";\r\n}\r\n\r\n.mdi-image-filter-center-focus::before {\r\n  content: \"\\F02F1\";\r\n}\r\n\r\n.mdi-image-filter-center-focus-strong::before {\r\n  content: \"\\F0EFF\";\r\n}\r\n\r\n.mdi-image-filter-center-focus-strong-outline::before {\r\n  content: \"\\F0F00\";\r\n}\r\n\r\n.mdi-image-filter-center-focus-weak::before {\r\n  content: \"\\F02F2\";\r\n}\r\n\r\n.mdi-image-filter-drama::before {\r\n  content: \"\\F02F3\";\r\n}\r\n\r\n.mdi-image-filter-frames::before {\r\n  content: \"\\F02F4\";\r\n}\r\n\r\n.mdi-image-filter-hdr::before {\r\n  content: \"\\F02F5\";\r\n}\r\n\r\n.mdi-image-filter-none::before {\r\n  content: \"\\F02F6\";\r\n}\r\n\r\n.mdi-image-filter-tilt-shift::before {\r\n  content: \"\\F02F7\";\r\n}\r\n\r\n.mdi-image-filter-vintage::before {\r\n  content: \"\\F02F8\";\r\n}\r\n\r\n.mdi-image-frame::before {\r\n  content: \"\\F0E49\";\r\n}\r\n\r\n.mdi-image-minus::before {\r\n  content: \"\\F1419\";\r\n}\r\n\r\n.mdi-image-move::before {\r\n  content: \"\\F09F8\";\r\n}\r\n\r\n.mdi-image-multiple::before {\r\n  content: \"\\F02F9\";\r\n}\r\n\r\n.mdi-image-multiple-outline::before {\r\n  content: \"\\F02EF\";\r\n}\r\n\r\n.mdi-image-off::before {\r\n  content: \"\\F082B\";\r\n}\r\n\r\n.mdi-image-off-outline::before {\r\n  content: \"\\F11D1\";\r\n}\r\n\r\n.mdi-image-outline::before {\r\n  content: \"\\F0976\";\r\n}\r\n\r\n.mdi-image-plus::before {\r\n  content: \"\\F087C\";\r\n}\r\n\r\n.mdi-image-remove::before {\r\n  content: \"\\F1418\";\r\n}\r\n\r\n.mdi-image-search::before {\r\n  content: \"\\F0977\";\r\n}\r\n\r\n.mdi-image-search-outline::before {\r\n  content: \"\\F0978\";\r\n}\r\n\r\n.mdi-image-size-select-actual::before {\r\n  content: \"\\F0C8D\";\r\n}\r\n\r\n.mdi-image-size-select-large::before {\r\n  content: \"\\F0C8E\";\r\n}\r\n\r\n.mdi-image-size-select-small::before {\r\n  content: \"\\F0C8F\";\r\n}\r\n\r\n.mdi-image-text::before {\r\n  content: \"\\F160D\";\r\n}\r\n\r\n.mdi-import::before {\r\n  content: \"\\F02FA\";\r\n}\r\n\r\n.mdi-inbox::before {\r\n  content: \"\\F0687\";\r\n}\r\n\r\n.mdi-inbox-arrow-down::before {\r\n  content: \"\\F02FB\";\r\n}\r\n\r\n.mdi-inbox-arrow-down-outline::before {\r\n  content: \"\\F1270\";\r\n}\r\n\r\n.mdi-inbox-arrow-up::before {\r\n  content: \"\\F03D1\";\r\n}\r\n\r\n.mdi-inbox-arrow-up-outline::before {\r\n  content: \"\\F1271\";\r\n}\r\n\r\n.mdi-inbox-full::before {\r\n  content: \"\\F1272\";\r\n}\r\n\r\n.mdi-inbox-full-outline::before {\r\n  content: \"\\F1273\";\r\n}\r\n\r\n.mdi-inbox-multiple::before {\r\n  content: \"\\F08B0\";\r\n}\r\n\r\n.mdi-inbox-multiple-outline::before {\r\n  content: \"\\F0BA8\";\r\n}\r\n\r\n.mdi-inbox-outline::before {\r\n  content: \"\\F1274\";\r\n}\r\n\r\n.mdi-inbox-remove::before {\r\n  content: \"\\F159F\";\r\n}\r\n\r\n.mdi-inbox-remove-outline::before {\r\n  content: \"\\F15A0\";\r\n}\r\n\r\n.mdi-incognito::before {\r\n  content: \"\\F05F9\";\r\n}\r\n\r\n.mdi-incognito-circle::before {\r\n  content: \"\\F1421\";\r\n}\r\n\r\n.mdi-incognito-circle-off::before {\r\n  content: \"\\F1422\";\r\n}\r\n\r\n.mdi-incognito-off::before {\r\n  content: \"\\F0075\";\r\n}\r\n\r\n.mdi-infinity::before {\r\n  content: \"\\F06E4\";\r\n}\r\n\r\n.mdi-information::before {\r\n  content: \"\\F02FC\";\r\n}\r\n\r\n.mdi-information-outline::before {\r\n  content: \"\\F02FD\";\r\n}\r\n\r\n.mdi-information-variant::before {\r\n  content: \"\\F064E\";\r\n}\r\n\r\n.mdi-instagram::before {\r\n  content: \"\\F02FE\";\r\n}\r\n\r\n.mdi-instrument-triangle::before {\r\n  content: \"\\F104E\";\r\n}\r\n\r\n.mdi-invert-colors::before {\r\n  content: \"\\F0301\";\r\n}\r\n\r\n.mdi-invert-colors-off::before {\r\n  content: \"\\F0E4A\";\r\n}\r\n\r\n.mdi-iobroker::before {\r\n  content: \"\\F12E8\";\r\n}\r\n\r\n.mdi-ip::before {\r\n  content: \"\\F0A5F\";\r\n}\r\n\r\n.mdi-ip-network::before {\r\n  content: \"\\F0A60\";\r\n}\r\n\r\n.mdi-ip-network-outline::before {\r\n  content: \"\\F0C90\";\r\n}\r\n\r\n.mdi-ipod::before {\r\n  content: \"\\F0C91\";\r\n}\r\n\r\n.mdi-islam::before {\r\n  content: \"\\F0979\";\r\n}\r\n\r\n.mdi-island::before {\r\n  content: \"\\F104F\";\r\n}\r\n\r\n.mdi-iv-bag::before {\r\n  content: \"\\F10B9\";\r\n}\r\n\r\n.mdi-jabber::before {\r\n  content: \"\\F0DD5\";\r\n}\r\n\r\n.mdi-jeepney::before {\r\n  content: \"\\F0302\";\r\n}\r\n\r\n.mdi-jellyfish::before {\r\n  content: \"\\F0F01\";\r\n}\r\n\r\n.mdi-jellyfish-outline::before {\r\n  content: \"\\F0F02\";\r\n}\r\n\r\n.mdi-jira::before {\r\n  content: \"\\F0303\";\r\n}\r\n\r\n.mdi-jquery::before {\r\n  content: \"\\F087D\";\r\n}\r\n\r\n.mdi-jsfiddle::before {\r\n  content: \"\\F0304\";\r\n}\r\n\r\n.mdi-judaism::before {\r\n  content: \"\\F097A\";\r\n}\r\n\r\n.mdi-jump-rope::before {\r\n  content: \"\\F12FF\";\r\n}\r\n\r\n.mdi-kabaddi::before {\r\n  content: \"\\F0D87\";\r\n}\r\n\r\n.mdi-kangaroo::before {\r\n  content: \"\\F1558\";\r\n}\r\n\r\n.mdi-karate::before {\r\n  content: \"\\F082C\";\r\n}\r\n\r\n.mdi-keg::before {\r\n  content: \"\\F0305\";\r\n}\r\n\r\n.mdi-kettle::before {\r\n  content: \"\\F05FA\";\r\n}\r\n\r\n.mdi-kettle-alert::before {\r\n  content: \"\\F1317\";\r\n}\r\n\r\n.mdi-kettle-alert-outline::before {\r\n  content: \"\\F1318\";\r\n}\r\n\r\n.mdi-kettle-off::before {\r\n  content: \"\\F131B\";\r\n}\r\n\r\n.mdi-kettle-off-outline::before {\r\n  content: \"\\F131C\";\r\n}\r\n\r\n.mdi-kettle-outline::before {\r\n  content: \"\\F0F56\";\r\n}\r\n\r\n.mdi-kettle-steam::before {\r\n  content: \"\\F1319\";\r\n}\r\n\r\n.mdi-kettle-steam-outline::before {\r\n  content: \"\\F131A\";\r\n}\r\n\r\n.mdi-kettlebell::before {\r\n  content: \"\\F1300\";\r\n}\r\n\r\n.mdi-key::before {\r\n  content: \"\\F0306\";\r\n}\r\n\r\n.mdi-key-arrow-right::before {\r\n  content: \"\\F1312\";\r\n}\r\n\r\n.mdi-key-chain::before {\r\n  content: \"\\F1574\";\r\n}\r\n\r\n.mdi-key-chain-variant::before {\r\n  content: \"\\F1575\";\r\n}\r\n\r\n.mdi-key-change::before {\r\n  content: \"\\F0307\";\r\n}\r\n\r\n.mdi-key-link::before {\r\n  content: \"\\F119F\";\r\n}\r\n\r\n.mdi-key-minus::before {\r\n  content: \"\\F0308\";\r\n}\r\n\r\n.mdi-key-outline::before {\r\n  content: \"\\F0DD6\";\r\n}\r\n\r\n.mdi-key-plus::before {\r\n  content: \"\\F0309\";\r\n}\r\n\r\n.mdi-key-remove::before {\r\n  content: \"\\F030A\";\r\n}\r\n\r\n.mdi-key-star::before {\r\n  content: \"\\F119E\";\r\n}\r\n\r\n.mdi-key-variant::before {\r\n  content: \"\\F030B\";\r\n}\r\n\r\n.mdi-key-wireless::before {\r\n  content: \"\\F0FC2\";\r\n}\r\n\r\n.mdi-keyboard::before {\r\n  content: \"\\F030C\";\r\n}\r\n\r\n.mdi-keyboard-backspace::before {\r\n  content: \"\\F030D\";\r\n}\r\n\r\n.mdi-keyboard-caps::before {\r\n  content: \"\\F030E\";\r\n}\r\n\r\n.mdi-keyboard-close::before {\r\n  content: \"\\F030F\";\r\n}\r\n\r\n.mdi-keyboard-esc::before {\r\n  content: \"\\F12B7\";\r\n}\r\n\r\n.mdi-keyboard-f1::before {\r\n  content: \"\\F12AB\";\r\n}\r\n\r\n.mdi-keyboard-f10::before {\r\n  content: \"\\F12B4\";\r\n}\r\n\r\n.mdi-keyboard-f11::before {\r\n  content: \"\\F12B5\";\r\n}\r\n\r\n.mdi-keyboard-f12::before {\r\n  content: \"\\F12B6\";\r\n}\r\n\r\n.mdi-keyboard-f2::before {\r\n  content: \"\\F12AC\";\r\n}\r\n\r\n.mdi-keyboard-f3::before {\r\n  content: \"\\F12AD\";\r\n}\r\n\r\n.mdi-keyboard-f4::before {\r\n  content: \"\\F12AE\";\r\n}\r\n\r\n.mdi-keyboard-f5::before {\r\n  content: \"\\F12AF\";\r\n}\r\n\r\n.mdi-keyboard-f6::before {\r\n  content: \"\\F12B0\";\r\n}\r\n\r\n.mdi-keyboard-f7::before {\r\n  content: \"\\F12B1\";\r\n}\r\n\r\n.mdi-keyboard-f8::before {\r\n  content: \"\\F12B2\";\r\n}\r\n\r\n.mdi-keyboard-f9::before {\r\n  content: \"\\F12B3\";\r\n}\r\n\r\n.mdi-keyboard-off::before {\r\n  content: \"\\F0310\";\r\n}\r\n\r\n.mdi-keyboard-off-outline::before {\r\n  content: \"\\F0E4B\";\r\n}\r\n\r\n.mdi-keyboard-outline::before {\r\n  content: \"\\F097B\";\r\n}\r\n\r\n.mdi-keyboard-return::before {\r\n  content: \"\\F0311\";\r\n}\r\n\r\n.mdi-keyboard-settings::before {\r\n  content: \"\\F09F9\";\r\n}\r\n\r\n.mdi-keyboard-settings-outline::before {\r\n  content: \"\\F09FA\";\r\n}\r\n\r\n.mdi-keyboard-space::before {\r\n  content: \"\\F1050\";\r\n}\r\n\r\n.mdi-keyboard-tab::before {\r\n  content: \"\\F0312\";\r\n}\r\n\r\n.mdi-keyboard-variant::before {\r\n  content: \"\\F0313\";\r\n}\r\n\r\n.mdi-khanda::before {\r\n  content: \"\\F10FD\";\r\n}\r\n\r\n.mdi-kickstarter::before {\r\n  content: \"\\F0745\";\r\n}\r\n\r\n.mdi-klingon::before {\r\n  content: \"\\F135B\";\r\n}\r\n\r\n.mdi-knife::before {\r\n  content: \"\\F09FB\";\r\n}\r\n\r\n.mdi-knife-military::before {\r\n  content: \"\\F09FC\";\r\n}\r\n\r\n.mdi-kodi::before {\r\n  content: \"\\F0314\";\r\n}\r\n\r\n.mdi-kubernetes::before {\r\n  content: \"\\F10FE\";\r\n}\r\n\r\n.mdi-label::before {\r\n  content: \"\\F0315\";\r\n}\r\n\r\n.mdi-label-multiple::before {\r\n  content: \"\\F1375\";\r\n}\r\n\r\n.mdi-label-multiple-outline::before {\r\n  content: \"\\F1376\";\r\n}\r\n\r\n.mdi-label-off::before {\r\n  content: \"\\F0ACB\";\r\n}\r\n\r\n.mdi-label-off-outline::before {\r\n  content: \"\\F0ACC\";\r\n}\r\n\r\n.mdi-label-outline::before {\r\n  content: \"\\F0316\";\r\n}\r\n\r\n.mdi-label-percent::before {\r\n  content: \"\\F12EA\";\r\n}\r\n\r\n.mdi-label-percent-outline::before {\r\n  content: \"\\F12EB\";\r\n}\r\n\r\n.mdi-label-variant::before {\r\n  content: \"\\F0ACD\";\r\n}\r\n\r\n.mdi-label-variant-outline::before {\r\n  content: \"\\F0ACE\";\r\n}\r\n\r\n.mdi-ladder::before {\r\n  content: \"\\F15A2\";\r\n}\r\n\r\n.mdi-ladybug::before {\r\n  content: \"\\F082D\";\r\n}\r\n\r\n.mdi-lambda::before {\r\n  content: \"\\F0627\";\r\n}\r\n\r\n.mdi-lamp::before {\r\n  content: \"\\F06B5\";\r\n}\r\n\r\n.mdi-lamps::before {\r\n  content: \"\\F1576\";\r\n}\r\n\r\n.mdi-lan::before {\r\n  content: \"\\F0317\";\r\n}\r\n\r\n.mdi-lan-check::before {\r\n  content: \"\\F12AA\";\r\n}\r\n\r\n.mdi-lan-connect::before {\r\n  content: \"\\F0318\";\r\n}\r\n\r\n.mdi-lan-disconnect::before {\r\n  content: \"\\F0319\";\r\n}\r\n\r\n.mdi-lan-pending::before {\r\n  content: \"\\F031A\";\r\n}\r\n\r\n.mdi-language-c::before {\r\n  content: \"\\F0671\";\r\n}\r\n\r\n.mdi-language-cpp::before {\r\n  content: \"\\F0672\";\r\n}\r\n\r\n.mdi-language-csharp::before {\r\n  content: \"\\F031B\";\r\n}\r\n\r\n.mdi-language-css3::before {\r\n  content: \"\\F031C\";\r\n}\r\n\r\n.mdi-language-fortran::before {\r\n  content: \"\\F121A\";\r\n}\r\n\r\n.mdi-language-go::before {\r\n  content: \"\\F07D3\";\r\n}\r\n\r\n.mdi-language-haskell::before {\r\n  content: \"\\F0C92\";\r\n}\r\n\r\n.mdi-language-html5::before {\r\n  content: \"\\F031D\";\r\n}\r\n\r\n.mdi-language-java::before {\r\n  content: \"\\F0B37\";\r\n}\r\n\r\n.mdi-language-javascript::before {\r\n  content: \"\\F031E\";\r\n}\r\n\r\n.mdi-language-kotlin::before {\r\n  content: \"\\F1219\";\r\n}\r\n\r\n.mdi-language-lua::before {\r\n  content: \"\\F08B1\";\r\n}\r\n\r\n.mdi-language-markdown::before {\r\n  content: \"\\F0354\";\r\n}\r\n\r\n.mdi-language-markdown-outline::before {\r\n  content: \"\\F0F5B\";\r\n}\r\n\r\n.mdi-language-php::before {\r\n  content: \"\\F031F\";\r\n}\r\n\r\n.mdi-language-python::before {\r\n  content: \"\\F0320\";\r\n}\r\n\r\n.mdi-language-r::before {\r\n  content: \"\\F07D4\";\r\n}\r\n\r\n.mdi-language-ruby::before {\r\n  content: \"\\F0D2D\";\r\n}\r\n\r\n.mdi-language-ruby-on-rails::before {\r\n  content: \"\\F0ACF\";\r\n}\r\n\r\n.mdi-language-rust::before {\r\n  content: \"\\F1617\";\r\n}\r\n\r\n.mdi-language-swift::before {\r\n  content: \"\\F06E5\";\r\n}\r\n\r\n.mdi-language-typescript::before {\r\n  content: \"\\F06E6\";\r\n}\r\n\r\n.mdi-language-xaml::before {\r\n  content: \"\\F0673\";\r\n}\r\n\r\n.mdi-laptop::before {\r\n  content: \"\\F0322\";\r\n}\r\n\r\n.mdi-laptop-chromebook::before {\r\n  content: \"\\F0323\";\r\n}\r\n\r\n.mdi-laptop-mac::before {\r\n  content: \"\\F0324\";\r\n}\r\n\r\n.mdi-laptop-off::before {\r\n  content: \"\\F06E7\";\r\n}\r\n\r\n.mdi-laptop-windows::before {\r\n  content: \"\\F0325\";\r\n}\r\n\r\n.mdi-laravel::before {\r\n  content: \"\\F0AD0\";\r\n}\r\n\r\n.mdi-laser-pointer::before {\r\n  content: \"\\F1484\";\r\n}\r\n\r\n.mdi-lasso::before {\r\n  content: \"\\F0F03\";\r\n}\r\n\r\n.mdi-lastpass::before {\r\n  content: \"\\F0446\";\r\n}\r\n\r\n.mdi-latitude::before {\r\n  content: \"\\F0F57\";\r\n}\r\n\r\n.mdi-launch::before {\r\n  content: \"\\F0327\";\r\n}\r\n\r\n.mdi-lava-lamp::before {\r\n  content: \"\\F07D5\";\r\n}\r\n\r\n.mdi-layers::before {\r\n  content: \"\\F0328\";\r\n}\r\n\r\n.mdi-layers-minus::before {\r\n  content: \"\\F0E4C\";\r\n}\r\n\r\n.mdi-layers-off::before {\r\n  content: \"\\F0329\";\r\n}\r\n\r\n.mdi-layers-off-outline::before {\r\n  content: \"\\F09FD\";\r\n}\r\n\r\n.mdi-layers-outline::before {\r\n  content: \"\\F09FE\";\r\n}\r\n\r\n.mdi-layers-plus::before {\r\n  content: \"\\F0E4D\";\r\n}\r\n\r\n.mdi-layers-remove::before {\r\n  content: \"\\F0E4E\";\r\n}\r\n\r\n.mdi-layers-search::before {\r\n  content: \"\\F1206\";\r\n}\r\n\r\n.mdi-layers-search-outline::before {\r\n  content: \"\\F1207\";\r\n}\r\n\r\n.mdi-layers-triple::before {\r\n  content: \"\\F0F58\";\r\n}\r\n\r\n.mdi-layers-triple-outline::before {\r\n  content: \"\\F0F59\";\r\n}\r\n\r\n.mdi-lead-pencil::before {\r\n  content: \"\\F064F\";\r\n}\r\n\r\n.mdi-leaf::before {\r\n  content: \"\\F032A\";\r\n}\r\n\r\n.mdi-leaf-maple::before {\r\n  content: \"\\F0C93\";\r\n}\r\n\r\n.mdi-leaf-maple-off::before {\r\n  content: \"\\F12DA\";\r\n}\r\n\r\n.mdi-leaf-off::before {\r\n  content: \"\\F12D9\";\r\n}\r\n\r\n.mdi-leak::before {\r\n  content: \"\\F0DD7\";\r\n}\r\n\r\n.mdi-leak-off::before {\r\n  content: \"\\F0DD8\";\r\n}\r\n\r\n.mdi-led-off::before {\r\n  content: \"\\F032B\";\r\n}\r\n\r\n.mdi-led-on::before {\r\n  content: \"\\F032C\";\r\n}\r\n\r\n.mdi-led-outline::before {\r\n  content: \"\\F032D\";\r\n}\r\n\r\n.mdi-led-strip::before {\r\n  content: \"\\F07D6\";\r\n}\r\n\r\n.mdi-led-strip-variant::before {\r\n  content: \"\\F1051\";\r\n}\r\n\r\n.mdi-led-variant-off::before {\r\n  content: \"\\F032E\";\r\n}\r\n\r\n.mdi-led-variant-on::before {\r\n  content: \"\\F032F\";\r\n}\r\n\r\n.mdi-led-variant-outline::before {\r\n  content: \"\\F0330\";\r\n}\r\n\r\n.mdi-leek::before {\r\n  content: \"\\F117D\";\r\n}\r\n\r\n.mdi-less-than::before {\r\n  content: \"\\F097C\";\r\n}\r\n\r\n.mdi-less-than-or-equal::before {\r\n  content: \"\\F097D\";\r\n}\r\n\r\n.mdi-library::before {\r\n  content: \"\\F0331\";\r\n}\r\n\r\n.mdi-library-shelves::before {\r\n  content: \"\\F0BA9\";\r\n}\r\n\r\n.mdi-license::before {\r\n  content: \"\\F0FC3\";\r\n}\r\n\r\n.mdi-lifebuoy::before {\r\n  content: \"\\F087E\";\r\n}\r\n\r\n.mdi-light-switch::before {\r\n  content: \"\\F097E\";\r\n}\r\n\r\n.mdi-lightbulb::before {\r\n  content: \"\\F0335\";\r\n}\r\n\r\n.mdi-lightbulb-cfl::before {\r\n  content: \"\\F1208\";\r\n}\r\n\r\n.mdi-lightbulb-cfl-off::before {\r\n  content: \"\\F1209\";\r\n}\r\n\r\n.mdi-lightbulb-cfl-spiral::before {\r\n  content: \"\\F1275\";\r\n}\r\n\r\n.mdi-lightbulb-cfl-spiral-off::before {\r\n  content: \"\\F12C3\";\r\n}\r\n\r\n.mdi-lightbulb-group::before {\r\n  content: \"\\F1253\";\r\n}\r\n\r\n.mdi-lightbulb-group-off::before {\r\n  content: \"\\F12CD\";\r\n}\r\n\r\n.mdi-lightbulb-group-off-outline::before {\r\n  content: \"\\F12CE\";\r\n}\r\n\r\n.mdi-lightbulb-group-outline::before {\r\n  content: \"\\F1254\";\r\n}\r\n\r\n.mdi-lightbulb-multiple::before {\r\n  content: \"\\F1255\";\r\n}\r\n\r\n.mdi-lightbulb-multiple-off::before {\r\n  content: \"\\F12CF\";\r\n}\r\n\r\n.mdi-lightbulb-multiple-off-outline::before {\r\n  content: \"\\F12D0\";\r\n}\r\n\r\n.mdi-lightbulb-multiple-outline::before {\r\n  content: \"\\F1256\";\r\n}\r\n\r\n.mdi-lightbulb-off::before {\r\n  content: \"\\F0E4F\";\r\n}\r\n\r\n.mdi-lightbulb-off-outline::before {\r\n  content: \"\\F0E50\";\r\n}\r\n\r\n.mdi-lightbulb-on::before {\r\n  content: \"\\F06E8\";\r\n}\r\n\r\n.mdi-lightbulb-on-outline::before {\r\n  content: \"\\F06E9\";\r\n}\r\n\r\n.mdi-lightbulb-outline::before {\r\n  content: \"\\F0336\";\r\n}\r\n\r\n.mdi-lighthouse::before {\r\n  content: \"\\F09FF\";\r\n}\r\n\r\n.mdi-lighthouse-on::before {\r\n  content: \"\\F0A00\";\r\n}\r\n\r\n.mdi-lightning-bolt::before {\r\n  content: \"\\F140B\";\r\n}\r\n\r\n.mdi-lightning-bolt-outline::before {\r\n  content: \"\\F140C\";\r\n}\r\n\r\n.mdi-lingerie::before {\r\n  content: \"\\F1476\";\r\n}\r\n\r\n.mdi-link::before {\r\n  content: \"\\F0337\";\r\n}\r\n\r\n.mdi-link-box::before {\r\n  content: \"\\F0D1A\";\r\n}\r\n\r\n.mdi-link-box-outline::before {\r\n  content: \"\\F0D1B\";\r\n}\r\n\r\n.mdi-link-box-variant::before {\r\n  content: \"\\F0D1C\";\r\n}\r\n\r\n.mdi-link-box-variant-outline::before {\r\n  content: \"\\F0D1D\";\r\n}\r\n\r\n.mdi-link-lock::before {\r\n  content: \"\\F10BA\";\r\n}\r\n\r\n.mdi-link-off::before {\r\n  content: \"\\F0338\";\r\n}\r\n\r\n.mdi-link-plus::before {\r\n  content: \"\\F0C94\";\r\n}\r\n\r\n.mdi-link-variant::before {\r\n  content: \"\\F0339\";\r\n}\r\n\r\n.mdi-link-variant-minus::before {\r\n  content: \"\\F10FF\";\r\n}\r\n\r\n.mdi-link-variant-off::before {\r\n  content: \"\\F033A\";\r\n}\r\n\r\n.mdi-link-variant-plus::before {\r\n  content: \"\\F1100\";\r\n}\r\n\r\n.mdi-link-variant-remove::before {\r\n  content: \"\\F1101\";\r\n}\r\n\r\n.mdi-linkedin::before {\r\n  content: \"\\F033B\";\r\n}\r\n\r\n.mdi-linux::before {\r\n  content: \"\\F033D\";\r\n}\r\n\r\n.mdi-linux-mint::before {\r\n  content: \"\\F08ED\";\r\n}\r\n\r\n.mdi-lipstick::before {\r\n  content: \"\\F13B5\";\r\n}\r\n\r\n.mdi-list-status::before {\r\n  content: \"\\F15AB\";\r\n}\r\n\r\n.mdi-litecoin::before {\r\n  content: \"\\F0A61\";\r\n}\r\n\r\n.mdi-loading::before {\r\n  content: \"\\F0772\";\r\n}\r\n\r\n.mdi-location-enter::before {\r\n  content: \"\\F0FC4\";\r\n}\r\n\r\n.mdi-location-exit::before {\r\n  content: \"\\F0FC5\";\r\n}\r\n\r\n.mdi-lock::before {\r\n  content: \"\\F033E\";\r\n}\r\n\r\n.mdi-lock-alert::before {\r\n  content: \"\\F08EE\";\r\n}\r\n\r\n.mdi-lock-alert-outline::before {\r\n  content: \"\\F15D1\";\r\n}\r\n\r\n.mdi-lock-check::before {\r\n  content: \"\\F139A\";\r\n}\r\n\r\n.mdi-lock-check-outline::before {\r\n  content: \"\\F16A8\";\r\n}\r\n\r\n.mdi-lock-clock::before {\r\n  content: \"\\F097F\";\r\n}\r\n\r\n.mdi-lock-minus::before {\r\n  content: \"\\F16A9\";\r\n}\r\n\r\n.mdi-lock-minus-outline::before {\r\n  content: \"\\F16AA\";\r\n}\r\n\r\n.mdi-lock-off::before {\r\n  content: \"\\F1671\";\r\n}\r\n\r\n.mdi-lock-off-outline::before {\r\n  content: \"\\F1672\";\r\n}\r\n\r\n.mdi-lock-open::before {\r\n  content: \"\\F033F\";\r\n}\r\n\r\n.mdi-lock-open-alert::before {\r\n  content: \"\\F139B\";\r\n}\r\n\r\n.mdi-lock-open-alert-outline::before {\r\n  content: \"\\F15D2\";\r\n}\r\n\r\n.mdi-lock-open-check::before {\r\n  content: \"\\F139C\";\r\n}\r\n\r\n.mdi-lock-open-check-outline::before {\r\n  content: \"\\F16AB\";\r\n}\r\n\r\n.mdi-lock-open-minus::before {\r\n  content: \"\\F16AC\";\r\n}\r\n\r\n.mdi-lock-open-minus-outline::before {\r\n  content: \"\\F16AD\";\r\n}\r\n\r\n.mdi-lock-open-outline::before {\r\n  content: \"\\F0340\";\r\n}\r\n\r\n.mdi-lock-open-plus::before {\r\n  content: \"\\F16AE\";\r\n}\r\n\r\n.mdi-lock-open-plus-outline::before {\r\n  content: \"\\F16AF\";\r\n}\r\n\r\n.mdi-lock-open-remove::before {\r\n  content: \"\\F16B0\";\r\n}\r\n\r\n.mdi-lock-open-remove-outline::before {\r\n  content: \"\\F16B1\";\r\n}\r\n\r\n.mdi-lock-open-variant::before {\r\n  content: \"\\F0FC6\";\r\n}\r\n\r\n.mdi-lock-open-variant-outline::before {\r\n  content: \"\\F0FC7\";\r\n}\r\n\r\n.mdi-lock-outline::before {\r\n  content: \"\\F0341\";\r\n}\r\n\r\n.mdi-lock-pattern::before {\r\n  content: \"\\F06EA\";\r\n}\r\n\r\n.mdi-lock-plus::before {\r\n  content: \"\\F05FB\";\r\n}\r\n\r\n.mdi-lock-plus-outline::before {\r\n  content: \"\\F16B2\";\r\n}\r\n\r\n.mdi-lock-question::before {\r\n  content: \"\\F08EF\";\r\n}\r\n\r\n.mdi-lock-remove::before {\r\n  content: \"\\F16B3\";\r\n}\r\n\r\n.mdi-lock-remove-outline::before {\r\n  content: \"\\F16B4\";\r\n}\r\n\r\n.mdi-lock-reset::before {\r\n  content: \"\\F0773\";\r\n}\r\n\r\n.mdi-lock-smart::before {\r\n  content: \"\\F08B2\";\r\n}\r\n\r\n.mdi-locker::before {\r\n  content: \"\\F07D7\";\r\n}\r\n\r\n.mdi-locker-multiple::before {\r\n  content: \"\\F07D8\";\r\n}\r\n\r\n.mdi-login::before {\r\n  content: \"\\F0342\";\r\n}\r\n\r\n.mdi-login-variant::before {\r\n  content: \"\\F05FC\";\r\n}\r\n\r\n.mdi-logout::before {\r\n  content: \"\\F0343\";\r\n}\r\n\r\n.mdi-logout-variant::before {\r\n  content: \"\\F05FD\";\r\n}\r\n\r\n.mdi-longitude::before {\r\n  content: \"\\F0F5A\";\r\n}\r\n\r\n.mdi-looks::before {\r\n  content: \"\\F0344\";\r\n}\r\n\r\n.mdi-lotion::before {\r\n  content: \"\\F1582\";\r\n}\r\n\r\n.mdi-lotion-outline::before {\r\n  content: \"\\F1583\";\r\n}\r\n\r\n.mdi-lotion-plus::before {\r\n  content: \"\\F1584\";\r\n}\r\n\r\n.mdi-lotion-plus-outline::before {\r\n  content: \"\\F1585\";\r\n}\r\n\r\n.mdi-loupe::before {\r\n  content: \"\\F0345\";\r\n}\r\n\r\n.mdi-lumx::before {\r\n  content: \"\\F0346\";\r\n}\r\n\r\n.mdi-lungs::before {\r\n  content: \"\\F1084\";\r\n}\r\n\r\n.mdi-magnet::before {\r\n  content: \"\\F0347\";\r\n}\r\n\r\n.mdi-magnet-on::before {\r\n  content: \"\\F0348\";\r\n}\r\n\r\n.mdi-magnify::before {\r\n  content: \"\\F0349\";\r\n}\r\n\r\n.mdi-magnify-close::before {\r\n  content: \"\\F0980\";\r\n}\r\n\r\n.mdi-magnify-minus::before {\r\n  content: \"\\F034A\";\r\n}\r\n\r\n.mdi-magnify-minus-cursor::before {\r\n  content: \"\\F0A62\";\r\n}\r\n\r\n.mdi-magnify-minus-outline::before {\r\n  content: \"\\F06EC\";\r\n}\r\n\r\n.mdi-magnify-plus::before {\r\n  content: \"\\F034B\";\r\n}\r\n\r\n.mdi-magnify-plus-cursor::before {\r\n  content: \"\\F0A63\";\r\n}\r\n\r\n.mdi-magnify-plus-outline::before {\r\n  content: \"\\F06ED\";\r\n}\r\n\r\n.mdi-magnify-remove-cursor::before {\r\n  content: \"\\F120C\";\r\n}\r\n\r\n.mdi-magnify-remove-outline::before {\r\n  content: \"\\F120D\";\r\n}\r\n\r\n.mdi-magnify-scan::before {\r\n  content: \"\\F1276\";\r\n}\r\n\r\n.mdi-mail::before {\r\n  content: \"\\F0EBB\";\r\n}\r\n\r\n.mdi-mailbox::before {\r\n  content: \"\\F06EE\";\r\n}\r\n\r\n.mdi-mailbox-open::before {\r\n  content: \"\\F0D88\";\r\n}\r\n\r\n.mdi-mailbox-open-outline::before {\r\n  content: \"\\F0D89\";\r\n}\r\n\r\n.mdi-mailbox-open-up::before {\r\n  content: \"\\F0D8A\";\r\n}\r\n\r\n.mdi-mailbox-open-up-outline::before {\r\n  content: \"\\F0D8B\";\r\n}\r\n\r\n.mdi-mailbox-outline::before {\r\n  content: \"\\F0D8C\";\r\n}\r\n\r\n.mdi-mailbox-up::before {\r\n  content: \"\\F0D8D\";\r\n}\r\n\r\n.mdi-mailbox-up-outline::before {\r\n  content: \"\\F0D8E\";\r\n}\r\n\r\n.mdi-manjaro::before {\r\n  content: \"\\F160A\";\r\n}\r\n\r\n.mdi-map::before {\r\n  content: \"\\F034D\";\r\n}\r\n\r\n.mdi-map-check::before {\r\n  content: \"\\F0EBC\";\r\n}\r\n\r\n.mdi-map-check-outline::before {\r\n  content: \"\\F0EBD\";\r\n}\r\n\r\n.mdi-map-clock::before {\r\n  content: \"\\F0D1E\";\r\n}\r\n\r\n.mdi-map-clock-outline::before {\r\n  content: \"\\F0D1F\";\r\n}\r\n\r\n.mdi-map-legend::before {\r\n  content: \"\\F0A01\";\r\n}\r\n\r\n.mdi-map-marker::before {\r\n  content: \"\\F034E\";\r\n}\r\n\r\n.mdi-map-marker-alert::before {\r\n  content: \"\\F0F05\";\r\n}\r\n\r\n.mdi-map-marker-alert-outline::before {\r\n  content: \"\\F0F06\";\r\n}\r\n\r\n.mdi-map-marker-check::before {\r\n  content: \"\\F0C95\";\r\n}\r\n\r\n.mdi-map-marker-check-outline::before {\r\n  content: \"\\F12FB\";\r\n}\r\n\r\n.mdi-map-marker-circle::before {\r\n  content: \"\\F034F\";\r\n}\r\n\r\n.mdi-map-marker-distance::before {\r\n  content: \"\\F08F0\";\r\n}\r\n\r\n.mdi-map-marker-down::before {\r\n  content: \"\\F1102\";\r\n}\r\n\r\n.mdi-map-marker-left::before {\r\n  content: \"\\F12DB\";\r\n}\r\n\r\n.mdi-map-marker-left-outline::before {\r\n  content: \"\\F12DD\";\r\n}\r\n\r\n.mdi-map-marker-minus::before {\r\n  content: \"\\F0650\";\r\n}\r\n\r\n.mdi-map-marker-minus-outline::before {\r\n  content: \"\\F12F9\";\r\n}\r\n\r\n.mdi-map-marker-multiple::before {\r\n  content: \"\\F0350\";\r\n}\r\n\r\n.mdi-map-marker-multiple-outline::before {\r\n  content: \"\\F1277\";\r\n}\r\n\r\n.mdi-map-marker-off::before {\r\n  content: \"\\F0351\";\r\n}\r\n\r\n.mdi-map-marker-off-outline::before {\r\n  content: \"\\F12FD\";\r\n}\r\n\r\n.mdi-map-marker-outline::before {\r\n  content: \"\\F07D9\";\r\n}\r\n\r\n.mdi-map-marker-path::before {\r\n  content: \"\\F0D20\";\r\n}\r\n\r\n.mdi-map-marker-plus::before {\r\n  content: \"\\F0651\";\r\n}\r\n\r\n.mdi-map-marker-plus-outline::before {\r\n  content: \"\\F12F8\";\r\n}\r\n\r\n.mdi-map-marker-question::before {\r\n  content: \"\\F0F07\";\r\n}\r\n\r\n.mdi-map-marker-question-outline::before {\r\n  content: \"\\F0F08\";\r\n}\r\n\r\n.mdi-map-marker-radius::before {\r\n  content: \"\\F0352\";\r\n}\r\n\r\n.mdi-map-marker-radius-outline::before {\r\n  content: \"\\F12FC\";\r\n}\r\n\r\n.mdi-map-marker-remove::before {\r\n  content: \"\\F0F09\";\r\n}\r\n\r\n.mdi-map-marker-remove-outline::before {\r\n  content: \"\\F12FA\";\r\n}\r\n\r\n.mdi-map-marker-remove-variant::before {\r\n  content: \"\\F0F0A\";\r\n}\r\n\r\n.mdi-map-marker-right::before {\r\n  content: \"\\F12DC\";\r\n}\r\n\r\n.mdi-map-marker-right-outline::before {\r\n  content: \"\\F12DE\";\r\n}\r\n\r\n.mdi-map-marker-star::before {\r\n  content: \"\\F1608\";\r\n}\r\n\r\n.mdi-map-marker-star-outline::before {\r\n  content: \"\\F1609\";\r\n}\r\n\r\n.mdi-map-marker-up::before {\r\n  content: \"\\F1103\";\r\n}\r\n\r\n.mdi-map-minus::before {\r\n  content: \"\\F0981\";\r\n}\r\n\r\n.mdi-map-outline::before {\r\n  content: \"\\F0982\";\r\n}\r\n\r\n.mdi-map-plus::before {\r\n  content: \"\\F0983\";\r\n}\r\n\r\n.mdi-map-search::before {\r\n  content: \"\\F0984\";\r\n}\r\n\r\n.mdi-map-search-outline::before {\r\n  content: \"\\F0985\";\r\n}\r\n\r\n.mdi-mapbox::before {\r\n  content: \"\\F0BAA\";\r\n}\r\n\r\n.mdi-margin::before {\r\n  content: \"\\F0353\";\r\n}\r\n\r\n.mdi-marker::before {\r\n  content: \"\\F0652\";\r\n}\r\n\r\n.mdi-marker-cancel::before {\r\n  content: \"\\F0DD9\";\r\n}\r\n\r\n.mdi-marker-check::before {\r\n  content: \"\\F0355\";\r\n}\r\n\r\n.mdi-mastodon::before {\r\n  content: \"\\F0AD1\";\r\n}\r\n\r\n.mdi-material-design::before {\r\n  content: \"\\F0986\";\r\n}\r\n\r\n.mdi-material-ui::before {\r\n  content: \"\\F0357\";\r\n}\r\n\r\n.mdi-math-compass::before {\r\n  content: \"\\F0358\";\r\n}\r\n\r\n.mdi-math-cos::before {\r\n  content: \"\\F0C96\";\r\n}\r\n\r\n.mdi-math-integral::before {\r\n  content: \"\\F0FC8\";\r\n}\r\n\r\n.mdi-math-integral-box::before {\r\n  content: \"\\F0FC9\";\r\n}\r\n\r\n.mdi-math-log::before {\r\n  content: \"\\F1085\";\r\n}\r\n\r\n.mdi-math-norm::before {\r\n  content: \"\\F0FCA\";\r\n}\r\n\r\n.mdi-math-norm-box::before {\r\n  content: \"\\F0FCB\";\r\n}\r\n\r\n.mdi-math-sin::before {\r\n  content: \"\\F0C97\";\r\n}\r\n\r\n.mdi-math-tan::before {\r\n  content: \"\\F0C98\";\r\n}\r\n\r\n.mdi-matrix::before {\r\n  content: \"\\F0628\";\r\n}\r\n\r\n.mdi-medal::before {\r\n  content: \"\\F0987\";\r\n}\r\n\r\n.mdi-medal-outline::before {\r\n  content: \"\\F1326\";\r\n}\r\n\r\n.mdi-medical-bag::before {\r\n  content: \"\\F06EF\";\r\n}\r\n\r\n.mdi-meditation::before {\r\n  content: \"\\F117B\";\r\n}\r\n\r\n.mdi-memory::before {\r\n  content: \"\\F035B\";\r\n}\r\n\r\n.mdi-menu::before {\r\n  content: \"\\F035C\";\r\n}\r\n\r\n.mdi-menu-down::before {\r\n  content: \"\\F035D\";\r\n}\r\n\r\n.mdi-menu-down-outline::before {\r\n  content: \"\\F06B6\";\r\n}\r\n\r\n.mdi-menu-left::before {\r\n  content: \"\\F035E\";\r\n}\r\n\r\n.mdi-menu-left-outline::before {\r\n  content: \"\\F0A02\";\r\n}\r\n\r\n.mdi-menu-open::before {\r\n  content: \"\\F0BAB\";\r\n}\r\n\r\n.mdi-menu-right::before {\r\n  content: \"\\F035F\";\r\n}\r\n\r\n.mdi-menu-right-outline::before {\r\n  content: \"\\F0A03\";\r\n}\r\n\r\n.mdi-menu-swap::before {\r\n  content: \"\\F0A64\";\r\n}\r\n\r\n.mdi-menu-swap-outline::before {\r\n  content: \"\\F0A65\";\r\n}\r\n\r\n.mdi-menu-up::before {\r\n  content: \"\\F0360\";\r\n}\r\n\r\n.mdi-menu-up-outline::before {\r\n  content: \"\\F06B7\";\r\n}\r\n\r\n.mdi-merge::before {\r\n  content: \"\\F0F5C\";\r\n}\r\n\r\n.mdi-message::before {\r\n  content: \"\\F0361\";\r\n}\r\n\r\n.mdi-message-alert::before {\r\n  content: \"\\F0362\";\r\n}\r\n\r\n.mdi-message-alert-outline::before {\r\n  content: \"\\F0A04\";\r\n}\r\n\r\n.mdi-message-arrow-left::before {\r\n  content: \"\\F12F2\";\r\n}\r\n\r\n.mdi-message-arrow-left-outline::before {\r\n  content: \"\\F12F3\";\r\n}\r\n\r\n.mdi-message-arrow-right::before {\r\n  content: \"\\F12F4\";\r\n}\r\n\r\n.mdi-message-arrow-right-outline::before {\r\n  content: \"\\F12F5\";\r\n}\r\n\r\n.mdi-message-bookmark::before {\r\n  content: \"\\F15AC\";\r\n}\r\n\r\n.mdi-message-bookmark-outline::before {\r\n  content: \"\\F15AD\";\r\n}\r\n\r\n.mdi-message-bulleted::before {\r\n  content: \"\\F06A2\";\r\n}\r\n\r\n.mdi-message-bulleted-off::before {\r\n  content: \"\\F06A3\";\r\n}\r\n\r\n.mdi-message-cog::before {\r\n  content: \"\\F06F1\";\r\n}\r\n\r\n.mdi-message-cog-outline::before {\r\n  content: \"\\F1172\";\r\n}\r\n\r\n.mdi-message-draw::before {\r\n  content: \"\\F0363\";\r\n}\r\n\r\n.mdi-message-flash::before {\r\n  content: \"\\F15A9\";\r\n}\r\n\r\n.mdi-message-flash-outline::before {\r\n  content: \"\\F15AA\";\r\n}\r\n\r\n.mdi-message-image::before {\r\n  content: \"\\F0364\";\r\n}\r\n\r\n.mdi-message-image-outline::before {\r\n  content: \"\\F116C\";\r\n}\r\n\r\n.mdi-message-lock::before {\r\n  content: \"\\F0FCC\";\r\n}\r\n\r\n.mdi-message-lock-outline::before {\r\n  content: \"\\F116D\";\r\n}\r\n\r\n.mdi-message-minus::before {\r\n  content: \"\\F116E\";\r\n}\r\n\r\n.mdi-message-minus-outline::before {\r\n  content: \"\\F116F\";\r\n}\r\n\r\n.mdi-message-off::before {\r\n  content: \"\\F164D\";\r\n}\r\n\r\n.mdi-message-off-outline::before {\r\n  content: \"\\F164E\";\r\n}\r\n\r\n.mdi-message-outline::before {\r\n  content: \"\\F0365\";\r\n}\r\n\r\n.mdi-message-plus::before {\r\n  content: \"\\F0653\";\r\n}\r\n\r\n.mdi-message-plus-outline::before {\r\n  content: \"\\F10BB\";\r\n}\r\n\r\n.mdi-message-processing::before {\r\n  content: \"\\F0366\";\r\n}\r\n\r\n.mdi-message-processing-outline::before {\r\n  content: \"\\F1170\";\r\n}\r\n\r\n.mdi-message-reply::before {\r\n  content: \"\\F0367\";\r\n}\r\n\r\n.mdi-message-reply-text::before {\r\n  content: \"\\F0368\";\r\n}\r\n\r\n.mdi-message-settings::before {\r\n  content: \"\\F06F0\";\r\n}\r\n\r\n.mdi-message-settings-outline::before {\r\n  content: \"\\F1171\";\r\n}\r\n\r\n.mdi-message-text::before {\r\n  content: \"\\F0369\";\r\n}\r\n\r\n.mdi-message-text-clock::before {\r\n  content: \"\\F1173\";\r\n}\r\n\r\n.mdi-message-text-clock-outline::before {\r\n  content: \"\\F1174\";\r\n}\r\n\r\n.mdi-message-text-lock::before {\r\n  content: \"\\F0FCD\";\r\n}\r\n\r\n.mdi-message-text-lock-outline::before {\r\n  content: \"\\F1175\";\r\n}\r\n\r\n.mdi-message-text-outline::before {\r\n  content: \"\\F036A\";\r\n}\r\n\r\n.mdi-message-video::before {\r\n  content: \"\\F036B\";\r\n}\r\n\r\n.mdi-meteor::before {\r\n  content: \"\\F0629\";\r\n}\r\n\r\n.mdi-metronome::before {\r\n  content: \"\\F07DA\";\r\n}\r\n\r\n.mdi-metronome-tick::before {\r\n  content: \"\\F07DB\";\r\n}\r\n\r\n.mdi-micro-sd::before {\r\n  content: \"\\F07DC\";\r\n}\r\n\r\n.mdi-microphone::before {\r\n  content: \"\\F036C\";\r\n}\r\n\r\n.mdi-microphone-minus::before {\r\n  content: \"\\F08B3\";\r\n}\r\n\r\n.mdi-microphone-off::before {\r\n  content: \"\\F036D\";\r\n}\r\n\r\n.mdi-microphone-outline::before {\r\n  content: \"\\F036E\";\r\n}\r\n\r\n.mdi-microphone-plus::before {\r\n  content: \"\\F08B4\";\r\n}\r\n\r\n.mdi-microphone-settings::before {\r\n  content: \"\\F036F\";\r\n}\r\n\r\n.mdi-microphone-variant::before {\r\n  content: \"\\F0370\";\r\n}\r\n\r\n.mdi-microphone-variant-off::before {\r\n  content: \"\\F0371\";\r\n}\r\n\r\n.mdi-microscope::before {\r\n  content: \"\\F0654\";\r\n}\r\n\r\n.mdi-microsoft::before {\r\n  content: \"\\F0372\";\r\n}\r\n\r\n.mdi-microsoft-access::before {\r\n  content: \"\\F138E\";\r\n}\r\n\r\n.mdi-microsoft-azure::before {\r\n  content: \"\\F0805\";\r\n}\r\n\r\n.mdi-microsoft-azure-devops::before {\r\n  content: \"\\F0FD5\";\r\n}\r\n\r\n.mdi-microsoft-bing::before {\r\n  content: \"\\F00A4\";\r\n}\r\n\r\n.mdi-microsoft-dynamics-365::before {\r\n  content: \"\\F0988\";\r\n}\r\n\r\n.mdi-microsoft-edge::before {\r\n  content: \"\\F01E9\";\r\n}\r\n\r\n.mdi-microsoft-edge-legacy::before {\r\n  content: \"\\F1250\";\r\n}\r\n\r\n.mdi-microsoft-excel::before {\r\n  content: \"\\F138F\";\r\n}\r\n\r\n.mdi-microsoft-internet-explorer::before {\r\n  content: \"\\F0300\";\r\n}\r\n\r\n.mdi-microsoft-office::before {\r\n  content: \"\\F03C6\";\r\n}\r\n\r\n.mdi-microsoft-onedrive::before {\r\n  content: \"\\F03CA\";\r\n}\r\n\r\n.mdi-microsoft-onenote::before {\r\n  content: \"\\F0747\";\r\n}\r\n\r\n.mdi-microsoft-outlook::before {\r\n  content: \"\\F0D22\";\r\n}\r\n\r\n.mdi-microsoft-powerpoint::before {\r\n  content: \"\\F1390\";\r\n}\r\n\r\n.mdi-microsoft-sharepoint::before {\r\n  content: \"\\F1391\";\r\n}\r\n\r\n.mdi-microsoft-teams::before {\r\n  content: \"\\F02BB\";\r\n}\r\n\r\n.mdi-microsoft-visual-studio::before {\r\n  content: \"\\F0610\";\r\n}\r\n\r\n.mdi-microsoft-visual-studio-code::before {\r\n  content: \"\\F0A1E\";\r\n}\r\n\r\n.mdi-microsoft-windows::before {\r\n  content: \"\\F05B3\";\r\n}\r\n\r\n.mdi-microsoft-windows-classic::before {\r\n  content: \"\\F0A21\";\r\n}\r\n\r\n.mdi-microsoft-word::before {\r\n  content: \"\\F1392\";\r\n}\r\n\r\n.mdi-microsoft-xbox::before {\r\n  content: \"\\F05B9\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller::before {\r\n  content: \"\\F05BA\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller-battery-alert::before {\r\n  content: \"\\F074B\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller-battery-charging::before {\r\n  content: \"\\F0A22\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller-battery-empty::before {\r\n  content: \"\\F074C\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller-battery-full::before {\r\n  content: \"\\F074D\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller-battery-low::before {\r\n  content: \"\\F074E\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller-battery-medium::before {\r\n  content: \"\\F074F\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller-battery-unknown::before {\r\n  content: \"\\F0750\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller-menu::before {\r\n  content: \"\\F0E6F\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller-off::before {\r\n  content: \"\\F05BB\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller-view::before {\r\n  content: \"\\F0E70\";\r\n}\r\n\r\n.mdi-microsoft-yammer::before {\r\n  content: \"\\F0789\";\r\n}\r\n\r\n.mdi-microwave::before {\r\n  content: \"\\F0C99\";\r\n}\r\n\r\n.mdi-microwave-off::before {\r\n  content: \"\\F1423\";\r\n}\r\n\r\n.mdi-middleware::before {\r\n  content: \"\\F0F5D\";\r\n}\r\n\r\n.mdi-middleware-outline::before {\r\n  content: \"\\F0F5E\";\r\n}\r\n\r\n.mdi-midi::before {\r\n  content: \"\\F08F1\";\r\n}\r\n\r\n.mdi-midi-port::before {\r\n  content: \"\\F08F2\";\r\n}\r\n\r\n.mdi-mine::before {\r\n  content: \"\\F0DDA\";\r\n}\r\n\r\n.mdi-minecraft::before {\r\n  content: \"\\F0373\";\r\n}\r\n\r\n.mdi-mini-sd::before {\r\n  content: \"\\F0A05\";\r\n}\r\n\r\n.mdi-minidisc::before {\r\n  content: \"\\F0A06\";\r\n}\r\n\r\n.mdi-minus::before {\r\n  content: \"\\F0374\";\r\n}\r\n\r\n.mdi-minus-box::before {\r\n  content: \"\\F0375\";\r\n}\r\n\r\n.mdi-minus-box-multiple::before {\r\n  content: \"\\F1141\";\r\n}\r\n\r\n.mdi-minus-box-multiple-outline::before {\r\n  content: \"\\F1142\";\r\n}\r\n\r\n.mdi-minus-box-outline::before {\r\n  content: \"\\F06F2\";\r\n}\r\n\r\n.mdi-minus-circle::before {\r\n  content: \"\\F0376\";\r\n}\r\n\r\n.mdi-minus-circle-multiple::before {\r\n  content: \"\\F035A\";\r\n}\r\n\r\n.mdi-minus-circle-multiple-outline::before {\r\n  content: \"\\F0AD3\";\r\n}\r\n\r\n.mdi-minus-circle-off::before {\r\n  content: \"\\F1459\";\r\n}\r\n\r\n.mdi-minus-circle-off-outline::before {\r\n  content: \"\\F145A\";\r\n}\r\n\r\n.mdi-minus-circle-outline::before {\r\n  content: \"\\F0377\";\r\n}\r\n\r\n.mdi-minus-network::before {\r\n  content: \"\\F0378\";\r\n}\r\n\r\n.mdi-minus-network-outline::before {\r\n  content: \"\\F0C9A\";\r\n}\r\n\r\n.mdi-minus-thick::before {\r\n  content: \"\\F1639\";\r\n}\r\n\r\n.mdi-mirror::before {\r\n  content: \"\\F11FD\";\r\n}\r\n\r\n.mdi-mixed-martial-arts::before {\r\n  content: \"\\F0D8F\";\r\n}\r\n\r\n.mdi-mixed-reality::before {\r\n  content: \"\\F087F\";\r\n}\r\n\r\n.mdi-molecule::before {\r\n  content: \"\\F0BAC\";\r\n}\r\n\r\n.mdi-molecule-co::before {\r\n  content: \"\\F12FE\";\r\n}\r\n\r\n.mdi-molecule-co2::before {\r\n  content: \"\\F07E4\";\r\n}\r\n\r\n.mdi-monitor::before {\r\n  content: \"\\F0379\";\r\n}\r\n\r\n.mdi-monitor-cellphone::before {\r\n  content: \"\\F0989\";\r\n}\r\n\r\n.mdi-monitor-cellphone-star::before {\r\n  content: \"\\F098A\";\r\n}\r\n\r\n.mdi-monitor-clean::before {\r\n  content: \"\\F1104\";\r\n}\r\n\r\n.mdi-monitor-dashboard::before {\r\n  content: \"\\F0A07\";\r\n}\r\n\r\n.mdi-monitor-edit::before {\r\n  content: \"\\F12C6\";\r\n}\r\n\r\n.mdi-monitor-eye::before {\r\n  content: \"\\F13B4\";\r\n}\r\n\r\n.mdi-monitor-lock::before {\r\n  content: \"\\F0DDB\";\r\n}\r\n\r\n.mdi-monitor-multiple::before {\r\n  content: \"\\F037A\";\r\n}\r\n\r\n.mdi-monitor-off::before {\r\n  content: \"\\F0D90\";\r\n}\r\n\r\n.mdi-monitor-screenshot::before {\r\n  content: \"\\F0E51\";\r\n}\r\n\r\n.mdi-monitor-share::before {\r\n  content: \"\\F1483\";\r\n}\r\n\r\n.mdi-monitor-speaker::before {\r\n  content: \"\\F0F5F\";\r\n}\r\n\r\n.mdi-monitor-speaker-off::before {\r\n  content: \"\\F0F60\";\r\n}\r\n\r\n.mdi-monitor-star::before {\r\n  content: \"\\F0DDC\";\r\n}\r\n\r\n.mdi-moon-first-quarter::before {\r\n  content: \"\\F0F61\";\r\n}\r\n\r\n.mdi-moon-full::before {\r\n  content: \"\\F0F62\";\r\n}\r\n\r\n.mdi-moon-last-quarter::before {\r\n  content: \"\\F0F63\";\r\n}\r\n\r\n.mdi-moon-new::before {\r\n  content: \"\\F0F64\";\r\n}\r\n\r\n.mdi-moon-waning-crescent::before {\r\n  content: \"\\F0F65\";\r\n}\r\n\r\n.mdi-moon-waning-gibbous::before {\r\n  content: \"\\F0F66\";\r\n}\r\n\r\n.mdi-moon-waxing-crescent::before {\r\n  content: \"\\F0F67\";\r\n}\r\n\r\n.mdi-moon-waxing-gibbous::before {\r\n  content: \"\\F0F68\";\r\n}\r\n\r\n.mdi-moped::before {\r\n  content: \"\\F1086\";\r\n}\r\n\r\n.mdi-moped-electric::before {\r\n  content: \"\\F15B7\";\r\n}\r\n\r\n.mdi-moped-electric-outline::before {\r\n  content: \"\\F15B8\";\r\n}\r\n\r\n.mdi-moped-outline::before {\r\n  content: \"\\F15B9\";\r\n}\r\n\r\n.mdi-more::before {\r\n  content: \"\\F037B\";\r\n}\r\n\r\n.mdi-mother-heart::before {\r\n  content: \"\\F1314\";\r\n}\r\n\r\n.mdi-mother-nurse::before {\r\n  content: \"\\F0D21\";\r\n}\r\n\r\n.mdi-motion::before {\r\n  content: \"\\F15B2\";\r\n}\r\n\r\n.mdi-motion-outline::before {\r\n  content: \"\\F15B3\";\r\n}\r\n\r\n.mdi-motion-pause::before {\r\n  content: \"\\F1590\";\r\n}\r\n\r\n.mdi-motion-pause-outline::before {\r\n  content: \"\\F1592\";\r\n}\r\n\r\n.mdi-motion-play::before {\r\n  content: \"\\F158F\";\r\n}\r\n\r\n.mdi-motion-play-outline::before {\r\n  content: \"\\F1591\";\r\n}\r\n\r\n.mdi-motion-sensor::before {\r\n  content: \"\\F0D91\";\r\n}\r\n\r\n.mdi-motion-sensor-off::before {\r\n  content: \"\\F1435\";\r\n}\r\n\r\n.mdi-motorbike::before {\r\n  content: \"\\F037C\";\r\n}\r\n\r\n.mdi-motorbike-electric::before {\r\n  content: \"\\F15BA\";\r\n}\r\n\r\n.mdi-mouse::before {\r\n  content: \"\\F037D\";\r\n}\r\n\r\n.mdi-mouse-bluetooth::before {\r\n  content: \"\\F098B\";\r\n}\r\n\r\n.mdi-mouse-move-down::before {\r\n  content: \"\\F1550\";\r\n}\r\n\r\n.mdi-mouse-move-up::before {\r\n  content: \"\\F1551\";\r\n}\r\n\r\n.mdi-mouse-move-vertical::before {\r\n  content: \"\\F1552\";\r\n}\r\n\r\n.mdi-mouse-off::before {\r\n  content: \"\\F037E\";\r\n}\r\n\r\n.mdi-mouse-variant::before {\r\n  content: \"\\F037F\";\r\n}\r\n\r\n.mdi-mouse-variant-off::before {\r\n  content: \"\\F0380\";\r\n}\r\n\r\n.mdi-move-resize::before {\r\n  content: \"\\F0655\";\r\n}\r\n\r\n.mdi-move-resize-variant::before {\r\n  content: \"\\F0656\";\r\n}\r\n\r\n.mdi-movie::before {\r\n  content: \"\\F0381\";\r\n}\r\n\r\n.mdi-movie-edit::before {\r\n  content: \"\\F1122\";\r\n}\r\n\r\n.mdi-movie-edit-outline::before {\r\n  content: \"\\F1123\";\r\n}\r\n\r\n.mdi-movie-filter::before {\r\n  content: \"\\F1124\";\r\n}\r\n\r\n.mdi-movie-filter-outline::before {\r\n  content: \"\\F1125\";\r\n}\r\n\r\n.mdi-movie-open::before {\r\n  content: \"\\F0FCE\";\r\n}\r\n\r\n.mdi-movie-open-outline::before {\r\n  content: \"\\F0FCF\";\r\n}\r\n\r\n.mdi-movie-outline::before {\r\n  content: \"\\F0DDD\";\r\n}\r\n\r\n.mdi-movie-roll::before {\r\n  content: \"\\F07DE\";\r\n}\r\n\r\n.mdi-movie-search::before {\r\n  content: \"\\F11D2\";\r\n}\r\n\r\n.mdi-movie-search-outline::before {\r\n  content: \"\\F11D3\";\r\n}\r\n\r\n.mdi-mower::before {\r\n  content: \"\\F166F\";\r\n}\r\n\r\n.mdi-mower-bag::before {\r\n  content: \"\\F1670\";\r\n}\r\n\r\n.mdi-muffin::before {\r\n  content: \"\\F098C\";\r\n}\r\n\r\n.mdi-multiplication::before {\r\n  content: \"\\F0382\";\r\n}\r\n\r\n.mdi-multiplication-box::before {\r\n  content: \"\\F0383\";\r\n}\r\n\r\n.mdi-mushroom::before {\r\n  content: \"\\F07DF\";\r\n}\r\n\r\n.mdi-mushroom-off::before {\r\n  content: \"\\F13FA\";\r\n}\r\n\r\n.mdi-mushroom-off-outline::before {\r\n  content: \"\\F13FB\";\r\n}\r\n\r\n.mdi-mushroom-outline::before {\r\n  content: \"\\F07E0\";\r\n}\r\n\r\n.mdi-music::before {\r\n  content: \"\\F075A\";\r\n}\r\n\r\n.mdi-music-accidental-double-flat::before {\r\n  content: \"\\F0F69\";\r\n}\r\n\r\n.mdi-music-accidental-double-sharp::before {\r\n  content: \"\\F0F6A\";\r\n}\r\n\r\n.mdi-music-accidental-flat::before {\r\n  content: \"\\F0F6B\";\r\n}\r\n\r\n.mdi-music-accidental-natural::before {\r\n  content: \"\\F0F6C\";\r\n}\r\n\r\n.mdi-music-accidental-sharp::before {\r\n  content: \"\\F0F6D\";\r\n}\r\n\r\n.mdi-music-box::before {\r\n  content: \"\\F0384\";\r\n}\r\n\r\n.mdi-music-box-multiple::before {\r\n  content: \"\\F0333\";\r\n}\r\n\r\n.mdi-music-box-multiple-outline::before {\r\n  content: \"\\F0F04\";\r\n}\r\n\r\n.mdi-music-box-outline::before {\r\n  content: \"\\F0385\";\r\n}\r\n\r\n.mdi-music-circle::before {\r\n  content: \"\\F0386\";\r\n}\r\n\r\n.mdi-music-circle-outline::before {\r\n  content: \"\\F0AD4\";\r\n}\r\n\r\n.mdi-music-clef-alto::before {\r\n  content: \"\\F0F6E\";\r\n}\r\n\r\n.mdi-music-clef-bass::before {\r\n  content: \"\\F0F6F\";\r\n}\r\n\r\n.mdi-music-clef-treble::before {\r\n  content: \"\\F0F70\";\r\n}\r\n\r\n.mdi-music-note::before {\r\n  content: \"\\F0387\";\r\n}\r\n\r\n.mdi-music-note-bluetooth::before {\r\n  content: \"\\F05FE\";\r\n}\r\n\r\n.mdi-music-note-bluetooth-off::before {\r\n  content: \"\\F05FF\";\r\n}\r\n\r\n.mdi-music-note-eighth::before {\r\n  content: \"\\F0388\";\r\n}\r\n\r\n.mdi-music-note-eighth-dotted::before {\r\n  content: \"\\F0F71\";\r\n}\r\n\r\n.mdi-music-note-half::before {\r\n  content: \"\\F0389\";\r\n}\r\n\r\n.mdi-music-note-half-dotted::before {\r\n  content: \"\\F0F72\";\r\n}\r\n\r\n.mdi-music-note-off::before {\r\n  content: \"\\F038A\";\r\n}\r\n\r\n.mdi-music-note-off-outline::before {\r\n  content: \"\\F0F73\";\r\n}\r\n\r\n.mdi-music-note-outline::before {\r\n  content: \"\\F0F74\";\r\n}\r\n\r\n.mdi-music-note-plus::before {\r\n  content: \"\\F0DDE\";\r\n}\r\n\r\n.mdi-music-note-quarter::before {\r\n  content: \"\\F038B\";\r\n}\r\n\r\n.mdi-music-note-quarter-dotted::before {\r\n  content: \"\\F0F75\";\r\n}\r\n\r\n.mdi-music-note-sixteenth::before {\r\n  content: \"\\F038C\";\r\n}\r\n\r\n.mdi-music-note-sixteenth-dotted::before {\r\n  content: \"\\F0F76\";\r\n}\r\n\r\n.mdi-music-note-whole::before {\r\n  content: \"\\F038D\";\r\n}\r\n\r\n.mdi-music-note-whole-dotted::before {\r\n  content: \"\\F0F77\";\r\n}\r\n\r\n.mdi-music-off::before {\r\n  content: \"\\F075B\";\r\n}\r\n\r\n.mdi-music-rest-eighth::before {\r\n  content: \"\\F0F78\";\r\n}\r\n\r\n.mdi-music-rest-half::before {\r\n  content: \"\\F0F79\";\r\n}\r\n\r\n.mdi-music-rest-quarter::before {\r\n  content: \"\\F0F7A\";\r\n}\r\n\r\n.mdi-music-rest-sixteenth::before {\r\n  content: \"\\F0F7B\";\r\n}\r\n\r\n.mdi-music-rest-whole::before {\r\n  content: \"\\F0F7C\";\r\n}\r\n\r\n.mdi-mustache::before {\r\n  content: \"\\F15DE\";\r\n}\r\n\r\n.mdi-nail::before {\r\n  content: \"\\F0DDF\";\r\n}\r\n\r\n.mdi-nas::before {\r\n  content: \"\\F08F3\";\r\n}\r\n\r\n.mdi-nativescript::before {\r\n  content: \"\\F0880\";\r\n}\r\n\r\n.mdi-nature::before {\r\n  content: \"\\F038E\";\r\n}\r\n\r\n.mdi-nature-people::before {\r\n  content: \"\\F038F\";\r\n}\r\n\r\n.mdi-navigation::before {\r\n  content: \"\\F0390\";\r\n}\r\n\r\n.mdi-navigation-outline::before {\r\n  content: \"\\F1607\";\r\n}\r\n\r\n.mdi-near-me::before {\r\n  content: \"\\F05CD\";\r\n}\r\n\r\n.mdi-necklace::before {\r\n  content: \"\\F0F0B\";\r\n}\r\n\r\n.mdi-needle::before {\r\n  content: \"\\F0391\";\r\n}\r\n\r\n.mdi-netflix::before {\r\n  content: \"\\F0746\";\r\n}\r\n\r\n.mdi-network::before {\r\n  content: \"\\F06F3\";\r\n}\r\n\r\n.mdi-network-off::before {\r\n  content: \"\\F0C9B\";\r\n}\r\n\r\n.mdi-network-off-outline::before {\r\n  content: \"\\F0C9C\";\r\n}\r\n\r\n.mdi-network-outline::before {\r\n  content: \"\\F0C9D\";\r\n}\r\n\r\n.mdi-network-strength-1::before {\r\n  content: \"\\F08F4\";\r\n}\r\n\r\n.mdi-network-strength-1-alert::before {\r\n  content: \"\\F08F5\";\r\n}\r\n\r\n.mdi-network-strength-2::before {\r\n  content: \"\\F08F6\";\r\n}\r\n\r\n.mdi-network-strength-2-alert::before {\r\n  content: \"\\F08F7\";\r\n}\r\n\r\n.mdi-network-strength-3::before {\r\n  content: \"\\F08F8\";\r\n}\r\n\r\n.mdi-network-strength-3-alert::before {\r\n  content: \"\\F08F9\";\r\n}\r\n\r\n.mdi-network-strength-4::before {\r\n  content: \"\\F08FA\";\r\n}\r\n\r\n.mdi-network-strength-4-alert::before {\r\n  content: \"\\F08FB\";\r\n}\r\n\r\n.mdi-network-strength-off::before {\r\n  content: \"\\F08FC\";\r\n}\r\n\r\n.mdi-network-strength-off-outline::before {\r\n  content: \"\\F08FD\";\r\n}\r\n\r\n.mdi-network-strength-outline::before {\r\n  content: \"\\F08FE\";\r\n}\r\n\r\n.mdi-new-box::before {\r\n  content: \"\\F0394\";\r\n}\r\n\r\n.mdi-newspaper::before {\r\n  content: \"\\F0395\";\r\n}\r\n\r\n.mdi-newspaper-minus::before {\r\n  content: \"\\F0F0C\";\r\n}\r\n\r\n.mdi-newspaper-plus::before {\r\n  content: \"\\F0F0D\";\r\n}\r\n\r\n.mdi-newspaper-variant::before {\r\n  content: \"\\F1001\";\r\n}\r\n\r\n.mdi-newspaper-variant-multiple::before {\r\n  content: \"\\F1002\";\r\n}\r\n\r\n.mdi-newspaper-variant-multiple-outline::before {\r\n  content: \"\\F1003\";\r\n}\r\n\r\n.mdi-newspaper-variant-outline::before {\r\n  content: \"\\F1004\";\r\n}\r\n\r\n.mdi-nfc::before {\r\n  content: \"\\F0396\";\r\n}\r\n\r\n.mdi-nfc-search-variant::before {\r\n  content: \"\\F0E53\";\r\n}\r\n\r\n.mdi-nfc-tap::before {\r\n  content: \"\\F0397\";\r\n}\r\n\r\n.mdi-nfc-variant::before {\r\n  content: \"\\F0398\";\r\n}\r\n\r\n.mdi-nfc-variant-off::before {\r\n  content: \"\\F0E54\";\r\n}\r\n\r\n.mdi-ninja::before {\r\n  content: \"\\F0774\";\r\n}\r\n\r\n.mdi-nintendo-game-boy::before {\r\n  content: \"\\F1393\";\r\n}\r\n\r\n.mdi-nintendo-switch::before {\r\n  content: \"\\F07E1\";\r\n}\r\n\r\n.mdi-nintendo-wii::before {\r\n  content: \"\\F05AB\";\r\n}\r\n\r\n.mdi-nintendo-wiiu::before {\r\n  content: \"\\F072D\";\r\n}\r\n\r\n.mdi-nix::before {\r\n  content: \"\\F1105\";\r\n}\r\n\r\n.mdi-nodejs::before {\r\n  content: \"\\F0399\";\r\n}\r\n\r\n.mdi-noodles::before {\r\n  content: \"\\F117E\";\r\n}\r\n\r\n.mdi-not-equal::before {\r\n  content: \"\\F098D\";\r\n}\r\n\r\n.mdi-not-equal-variant::before {\r\n  content: \"\\F098E\";\r\n}\r\n\r\n.mdi-note::before {\r\n  content: \"\\F039A\";\r\n}\r\n\r\n.mdi-note-minus::before {\r\n  content: \"\\F164F\";\r\n}\r\n\r\n.mdi-note-minus-outline::before {\r\n  content: \"\\F1650\";\r\n}\r\n\r\n.mdi-note-multiple::before {\r\n  content: \"\\F06B8\";\r\n}\r\n\r\n.mdi-note-multiple-outline::before {\r\n  content: \"\\F06B9\";\r\n}\r\n\r\n.mdi-note-outline::before {\r\n  content: \"\\F039B\";\r\n}\r\n\r\n.mdi-note-plus::before {\r\n  content: \"\\F039C\";\r\n}\r\n\r\n.mdi-note-plus-outline::before {\r\n  content: \"\\F039D\";\r\n}\r\n\r\n.mdi-note-remove::before {\r\n  content: \"\\F1651\";\r\n}\r\n\r\n.mdi-note-remove-outline::before {\r\n  content: \"\\F1652\";\r\n}\r\n\r\n.mdi-note-search::before {\r\n  content: \"\\F1653\";\r\n}\r\n\r\n.mdi-note-search-outline::before {\r\n  content: \"\\F1654\";\r\n}\r\n\r\n.mdi-note-text::before {\r\n  content: \"\\F039E\";\r\n}\r\n\r\n.mdi-note-text-outline::before {\r\n  content: \"\\F11D7\";\r\n}\r\n\r\n.mdi-notebook::before {\r\n  content: \"\\F082E\";\r\n}\r\n\r\n.mdi-notebook-check::before {\r\n  content: \"\\F14F5\";\r\n}\r\n\r\n.mdi-notebook-check-outline::before {\r\n  content: \"\\F14F6\";\r\n}\r\n\r\n.mdi-notebook-edit::before {\r\n  content: \"\\F14E7\";\r\n}\r\n\r\n.mdi-notebook-edit-outline::before {\r\n  content: \"\\F14E9\";\r\n}\r\n\r\n.mdi-notebook-minus::before {\r\n  content: \"\\F1610\";\r\n}\r\n\r\n.mdi-notebook-minus-outline::before {\r\n  content: \"\\F1611\";\r\n}\r\n\r\n.mdi-notebook-multiple::before {\r\n  content: \"\\F0E55\";\r\n}\r\n\r\n.mdi-notebook-outline::before {\r\n  content: \"\\F0EBF\";\r\n}\r\n\r\n.mdi-notebook-plus::before {\r\n  content: \"\\F1612\";\r\n}\r\n\r\n.mdi-notebook-plus-outline::before {\r\n  content: \"\\F1613\";\r\n}\r\n\r\n.mdi-notebook-remove::before {\r\n  content: \"\\F1614\";\r\n}\r\n\r\n.mdi-notebook-remove-outline::before {\r\n  content: \"\\F1615\";\r\n}\r\n\r\n.mdi-notification-clear-all::before {\r\n  content: \"\\F039F\";\r\n}\r\n\r\n.mdi-npm::before {\r\n  content: \"\\F06F7\";\r\n}\r\n\r\n.mdi-nuke::before {\r\n  content: \"\\F06A4\";\r\n}\r\n\r\n.mdi-null::before {\r\n  content: \"\\F07E2\";\r\n}\r\n\r\n.mdi-numeric::before {\r\n  content: \"\\F03A0\";\r\n}\r\n\r\n.mdi-numeric-0::before {\r\n  content: \"\\F0B39\";\r\n}\r\n\r\n.mdi-numeric-0-box::before {\r\n  content: \"\\F03A1\";\r\n}\r\n\r\n.mdi-numeric-0-box-multiple::before {\r\n  content: \"\\F0F0E\";\r\n}\r\n\r\n.mdi-numeric-0-box-multiple-outline::before {\r\n  content: \"\\F03A2\";\r\n}\r\n\r\n.mdi-numeric-0-box-outline::before {\r\n  content: \"\\F03A3\";\r\n}\r\n\r\n.mdi-numeric-0-circle::before {\r\n  content: \"\\F0C9E\";\r\n}\r\n\r\n.mdi-numeric-0-circle-outline::before {\r\n  content: \"\\F0C9F\";\r\n}\r\n\r\n.mdi-numeric-1::before {\r\n  content: \"\\F0B3A\";\r\n}\r\n\r\n.mdi-numeric-1-box::before {\r\n  content: \"\\F03A4\";\r\n}\r\n\r\n.mdi-numeric-1-box-multiple::before {\r\n  content: \"\\F0F0F\";\r\n}\r\n\r\n.mdi-numeric-1-box-multiple-outline::before {\r\n  content: \"\\F03A5\";\r\n}\r\n\r\n.mdi-numeric-1-box-outline::before {\r\n  content: \"\\F03A6\";\r\n}\r\n\r\n.mdi-numeric-1-circle::before {\r\n  content: \"\\F0CA0\";\r\n}\r\n\r\n.mdi-numeric-1-circle-outline::before {\r\n  content: \"\\F0CA1\";\r\n}\r\n\r\n.mdi-numeric-10::before {\r\n  content: \"\\F0FE9\";\r\n}\r\n\r\n.mdi-numeric-10-box::before {\r\n  content: \"\\F0F7D\";\r\n}\r\n\r\n.mdi-numeric-10-box-multiple::before {\r\n  content: \"\\F0FEA\";\r\n}\r\n\r\n.mdi-numeric-10-box-multiple-outline::before {\r\n  content: \"\\F0FEB\";\r\n}\r\n\r\n.mdi-numeric-10-box-outline::before {\r\n  content: \"\\F0F7E\";\r\n}\r\n\r\n.mdi-numeric-10-circle::before {\r\n  content: \"\\F0FEC\";\r\n}\r\n\r\n.mdi-numeric-10-circle-outline::before {\r\n  content: \"\\F0FED\";\r\n}\r\n\r\n.mdi-numeric-2::before {\r\n  content: \"\\F0B3B\";\r\n}\r\n\r\n.mdi-numeric-2-box::before {\r\n  content: \"\\F03A7\";\r\n}\r\n\r\n.mdi-numeric-2-box-multiple::before {\r\n  content: \"\\F0F10\";\r\n}\r\n\r\n.mdi-numeric-2-box-multiple-outline::before {\r\n  content: \"\\F03A8\";\r\n}\r\n\r\n.mdi-numeric-2-box-outline::before {\r\n  content: \"\\F03A9\";\r\n}\r\n\r\n.mdi-numeric-2-circle::before {\r\n  content: \"\\F0CA2\";\r\n}\r\n\r\n.mdi-numeric-2-circle-outline::before {\r\n  content: \"\\F0CA3\";\r\n}\r\n\r\n.mdi-numeric-3::before {\r\n  content: \"\\F0B3C\";\r\n}\r\n\r\n.mdi-numeric-3-box::before {\r\n  content: \"\\F03AA\";\r\n}\r\n\r\n.mdi-numeric-3-box-multiple::before {\r\n  content: \"\\F0F11\";\r\n}\r\n\r\n.mdi-numeric-3-box-multiple-outline::before {\r\n  content: \"\\F03AB\";\r\n}\r\n\r\n.mdi-numeric-3-box-outline::before {\r\n  content: \"\\F03AC\";\r\n}\r\n\r\n.mdi-numeric-3-circle::before {\r\n  content: \"\\F0CA4\";\r\n}\r\n\r\n.mdi-numeric-3-circle-outline::before {\r\n  content: \"\\F0CA5\";\r\n}\r\n\r\n.mdi-numeric-4::before {\r\n  content: \"\\F0B3D\";\r\n}\r\n\r\n.mdi-numeric-4-box::before {\r\n  content: \"\\F03AD\";\r\n}\r\n\r\n.mdi-numeric-4-box-multiple::before {\r\n  content: \"\\F0F12\";\r\n}\r\n\r\n.mdi-numeric-4-box-multiple-outline::before {\r\n  content: \"\\F03B2\";\r\n}\r\n\r\n.mdi-numeric-4-box-outline::before {\r\n  content: \"\\F03AE\";\r\n}\r\n\r\n.mdi-numeric-4-circle::before {\r\n  content: \"\\F0CA6\";\r\n}\r\n\r\n.mdi-numeric-4-circle-outline::before {\r\n  content: \"\\F0CA7\";\r\n}\r\n\r\n.mdi-numeric-5::before {\r\n  content: \"\\F0B3E\";\r\n}\r\n\r\n.mdi-numeric-5-box::before {\r\n  content: \"\\F03B1\";\r\n}\r\n\r\n.mdi-numeric-5-box-multiple::before {\r\n  content: \"\\F0F13\";\r\n}\r\n\r\n.mdi-numeric-5-box-multiple-outline::before {\r\n  content: \"\\F03AF\";\r\n}\r\n\r\n.mdi-numeric-5-box-outline::before {\r\n  content: \"\\F03B0\";\r\n}\r\n\r\n.mdi-numeric-5-circle::before {\r\n  content: \"\\F0CA8\";\r\n}\r\n\r\n.mdi-numeric-5-circle-outline::before {\r\n  content: \"\\F0CA9\";\r\n}\r\n\r\n.mdi-numeric-6::before {\r\n  content: \"\\F0B3F\";\r\n}\r\n\r\n.mdi-numeric-6-box::before {\r\n  content: \"\\F03B3\";\r\n}\r\n\r\n.mdi-numeric-6-box-multiple::before {\r\n  content: \"\\F0F14\";\r\n}\r\n\r\n.mdi-numeric-6-box-multiple-outline::before {\r\n  content: \"\\F03B4\";\r\n}\r\n\r\n.mdi-numeric-6-box-outline::before {\r\n  content: \"\\F03B5\";\r\n}\r\n\r\n.mdi-numeric-6-circle::before {\r\n  content: \"\\F0CAA\";\r\n}\r\n\r\n.mdi-numeric-6-circle-outline::before {\r\n  content: \"\\F0CAB\";\r\n}\r\n\r\n.mdi-numeric-7::before {\r\n  content: \"\\F0B40\";\r\n}\r\n\r\n.mdi-numeric-7-box::before {\r\n  content: \"\\F03B6\";\r\n}\r\n\r\n.mdi-numeric-7-box-multiple::before {\r\n  content: \"\\F0F15\";\r\n}\r\n\r\n.mdi-numeric-7-box-multiple-outline::before {\r\n  content: \"\\F03B7\";\r\n}\r\n\r\n.mdi-numeric-7-box-outline::before {\r\n  content: \"\\F03B8\";\r\n}\r\n\r\n.mdi-numeric-7-circle::before {\r\n  content: \"\\F0CAC\";\r\n}\r\n\r\n.mdi-numeric-7-circle-outline::before {\r\n  content: \"\\F0CAD\";\r\n}\r\n\r\n.mdi-numeric-8::before {\r\n  content: \"\\F0B41\";\r\n}\r\n\r\n.mdi-numeric-8-box::before {\r\n  content: \"\\F03B9\";\r\n}\r\n\r\n.mdi-numeric-8-box-multiple::before {\r\n  content: \"\\F0F16\";\r\n}\r\n\r\n.mdi-numeric-8-box-multiple-outline::before {\r\n  content: \"\\F03BA\";\r\n}\r\n\r\n.mdi-numeric-8-box-outline::before {\r\n  content: \"\\F03BB\";\r\n}\r\n\r\n.mdi-numeric-8-circle::before {\r\n  content: \"\\F0CAE\";\r\n}\r\n\r\n.mdi-numeric-8-circle-outline::before {\r\n  content: \"\\F0CAF\";\r\n}\r\n\r\n.mdi-numeric-9::before {\r\n  content: \"\\F0B42\";\r\n}\r\n\r\n.mdi-numeric-9-box::before {\r\n  content: \"\\F03BC\";\r\n}\r\n\r\n.mdi-numeric-9-box-multiple::before {\r\n  content: \"\\F0F17\";\r\n}\r\n\r\n.mdi-numeric-9-box-multiple-outline::before {\r\n  content: \"\\F03BD\";\r\n}\r\n\r\n.mdi-numeric-9-box-outline::before {\r\n  content: \"\\F03BE\";\r\n}\r\n\r\n.mdi-numeric-9-circle::before {\r\n  content: \"\\F0CB0\";\r\n}\r\n\r\n.mdi-numeric-9-circle-outline::before {\r\n  content: \"\\F0CB1\";\r\n}\r\n\r\n.mdi-numeric-9-plus::before {\r\n  content: \"\\F0FEE\";\r\n}\r\n\r\n.mdi-numeric-9-plus-box::before {\r\n  content: \"\\F03BF\";\r\n}\r\n\r\n.mdi-numeric-9-plus-box-multiple::before {\r\n  content: \"\\F0F18\";\r\n}\r\n\r\n.mdi-numeric-9-plus-box-multiple-outline::before {\r\n  content: \"\\F03C0\";\r\n}\r\n\r\n.mdi-numeric-9-plus-box-outline::before {\r\n  content: \"\\F03C1\";\r\n}\r\n\r\n.mdi-numeric-9-plus-circle::before {\r\n  content: \"\\F0CB2\";\r\n}\r\n\r\n.mdi-numeric-9-plus-circle-outline::before {\r\n  content: \"\\F0CB3\";\r\n}\r\n\r\n.mdi-numeric-negative-1::before {\r\n  content: \"\\F1052\";\r\n}\r\n\r\n.mdi-numeric-positive-1::before {\r\n  content: \"\\F15CB\";\r\n}\r\n\r\n.mdi-nut::before {\r\n  content: \"\\F06F8\";\r\n}\r\n\r\n.mdi-nutrition::before {\r\n  content: \"\\F03C2\";\r\n}\r\n\r\n.mdi-nuxt::before {\r\n  content: \"\\F1106\";\r\n}\r\n\r\n.mdi-oar::before {\r\n  content: \"\\F067C\";\r\n}\r\n\r\n.mdi-ocarina::before {\r\n  content: \"\\F0DE0\";\r\n}\r\n\r\n.mdi-oci::before {\r\n  content: \"\\F12E9\";\r\n}\r\n\r\n.mdi-ocr::before {\r\n  content: \"\\F113A\";\r\n}\r\n\r\n.mdi-octagon::before {\r\n  content: \"\\F03C3\";\r\n}\r\n\r\n.mdi-octagon-outline::before {\r\n  content: \"\\F03C4\";\r\n}\r\n\r\n.mdi-octagram::before {\r\n  content: \"\\F06F9\";\r\n}\r\n\r\n.mdi-octagram-outline::before {\r\n  content: \"\\F0775\";\r\n}\r\n\r\n.mdi-odnoklassniki::before {\r\n  content: \"\\F03C5\";\r\n}\r\n\r\n.mdi-offer::before {\r\n  content: \"\\F121B\";\r\n}\r\n\r\n.mdi-office-building::before {\r\n  content: \"\\F0991\";\r\n}\r\n\r\n.mdi-office-building-marker::before {\r\n  content: \"\\F1520\";\r\n}\r\n\r\n.mdi-office-building-marker-outline::before {\r\n  content: \"\\F1521\";\r\n}\r\n\r\n.mdi-office-building-outline::before {\r\n  content: \"\\F151F\";\r\n}\r\n\r\n.mdi-oil::before {\r\n  content: \"\\F03C7\";\r\n}\r\n\r\n.mdi-oil-lamp::before {\r\n  content: \"\\F0F19\";\r\n}\r\n\r\n.mdi-oil-level::before {\r\n  content: \"\\F1053\";\r\n}\r\n\r\n.mdi-oil-temperature::before {\r\n  content: \"\\F0FF8\";\r\n}\r\n\r\n.mdi-omega::before {\r\n  content: \"\\F03C9\";\r\n}\r\n\r\n.mdi-one-up::before {\r\n  content: \"\\F0BAD\";\r\n}\r\n\r\n.mdi-onepassword::before {\r\n  content: \"\\F0881\";\r\n}\r\n\r\n.mdi-opacity::before {\r\n  content: \"\\F05CC\";\r\n}\r\n\r\n.mdi-open-in-app::before {\r\n  content: \"\\F03CB\";\r\n}\r\n\r\n.mdi-open-in-new::before {\r\n  content: \"\\F03CC\";\r\n}\r\n\r\n.mdi-open-source-initiative::before {\r\n  content: \"\\F0BAE\";\r\n}\r\n\r\n.mdi-openid::before {\r\n  content: \"\\F03CD\";\r\n}\r\n\r\n.mdi-opera::before {\r\n  content: \"\\F03CE\";\r\n}\r\n\r\n.mdi-orbit::before {\r\n  content: \"\\F0018\";\r\n}\r\n\r\n.mdi-orbit-variant::before {\r\n  content: \"\\F15DB\";\r\n}\r\n\r\n.mdi-order-alphabetical-ascending::before {\r\n  content: \"\\F020D\";\r\n}\r\n\r\n.mdi-order-alphabetical-descending::before {\r\n  content: \"\\F0D07\";\r\n}\r\n\r\n.mdi-order-bool-ascending::before {\r\n  content: \"\\F02BE\";\r\n}\r\n\r\n.mdi-order-bool-ascending-variant::before {\r\n  content: \"\\F098F\";\r\n}\r\n\r\n.mdi-order-bool-descending::before {\r\n  content: \"\\F1384\";\r\n}\r\n\r\n.mdi-order-bool-descending-variant::before {\r\n  content: \"\\F0990\";\r\n}\r\n\r\n.mdi-order-numeric-ascending::before {\r\n  content: \"\\F0545\";\r\n}\r\n\r\n.mdi-order-numeric-descending::before {\r\n  content: \"\\F0546\";\r\n}\r\n\r\n.mdi-origin::before {\r\n  content: \"\\F0B43\";\r\n}\r\n\r\n.mdi-ornament::before {\r\n  content: \"\\F03CF\";\r\n}\r\n\r\n.mdi-ornament-variant::before {\r\n  content: \"\\F03D0\";\r\n}\r\n\r\n.mdi-outdoor-lamp::before {\r\n  content: \"\\F1054\";\r\n}\r\n\r\n.mdi-overscan::before {\r\n  content: \"\\F1005\";\r\n}\r\n\r\n.mdi-owl::before {\r\n  content: \"\\F03D2\";\r\n}\r\n\r\n.mdi-pac-man::before {\r\n  content: \"\\F0BAF\";\r\n}\r\n\r\n.mdi-package::before {\r\n  content: \"\\F03D3\";\r\n}\r\n\r\n.mdi-package-down::before {\r\n  content: \"\\F03D4\";\r\n}\r\n\r\n.mdi-package-up::before {\r\n  content: \"\\F03D5\";\r\n}\r\n\r\n.mdi-package-variant::before {\r\n  content: \"\\F03D6\";\r\n}\r\n\r\n.mdi-package-variant-closed::before {\r\n  content: \"\\F03D7\";\r\n}\r\n\r\n.mdi-page-first::before {\r\n  content: \"\\F0600\";\r\n}\r\n\r\n.mdi-page-last::before {\r\n  content: \"\\F0601\";\r\n}\r\n\r\n.mdi-page-layout-body::before {\r\n  content: \"\\F06FA\";\r\n}\r\n\r\n.mdi-page-layout-footer::before {\r\n  content: \"\\F06FB\";\r\n}\r\n\r\n.mdi-page-layout-header::before {\r\n  content: \"\\F06FC\";\r\n}\r\n\r\n.mdi-page-layout-header-footer::before {\r\n  content: \"\\F0F7F\";\r\n}\r\n\r\n.mdi-page-layout-sidebar-left::before {\r\n  content: \"\\F06FD\";\r\n}\r\n\r\n.mdi-page-layout-sidebar-right::before {\r\n  content: \"\\F06FE\";\r\n}\r\n\r\n.mdi-page-next::before {\r\n  content: \"\\F0BB0\";\r\n}\r\n\r\n.mdi-page-next-outline::before {\r\n  content: \"\\F0BB1\";\r\n}\r\n\r\n.mdi-page-previous::before {\r\n  content: \"\\F0BB2\";\r\n}\r\n\r\n.mdi-page-previous-outline::before {\r\n  content: \"\\F0BB3\";\r\n}\r\n\r\n.mdi-pail::before {\r\n  content: \"\\F1417\";\r\n}\r\n\r\n.mdi-pail-minus::before {\r\n  content: \"\\F1437\";\r\n}\r\n\r\n.mdi-pail-minus-outline::before {\r\n  content: \"\\F143C\";\r\n}\r\n\r\n.mdi-pail-off::before {\r\n  content: \"\\F1439\";\r\n}\r\n\r\n.mdi-pail-off-outline::before {\r\n  content: \"\\F143E\";\r\n}\r\n\r\n.mdi-pail-outline::before {\r\n  content: \"\\F143A\";\r\n}\r\n\r\n.mdi-pail-plus::before {\r\n  content: \"\\F1436\";\r\n}\r\n\r\n.mdi-pail-plus-outline::before {\r\n  content: \"\\F143B\";\r\n}\r\n\r\n.mdi-pail-remove::before {\r\n  content: \"\\F1438\";\r\n}\r\n\r\n.mdi-pail-remove-outline::before {\r\n  content: \"\\F143D\";\r\n}\r\n\r\n.mdi-palette::before {\r\n  content: \"\\F03D8\";\r\n}\r\n\r\n.mdi-palette-advanced::before {\r\n  content: \"\\F03D9\";\r\n}\r\n\r\n.mdi-palette-outline::before {\r\n  content: \"\\F0E0C\";\r\n}\r\n\r\n.mdi-palette-swatch::before {\r\n  content: \"\\F08B5\";\r\n}\r\n\r\n.mdi-palette-swatch-outline::before {\r\n  content: \"\\F135C\";\r\n}\r\n\r\n.mdi-palm-tree::before {\r\n  content: \"\\F1055\";\r\n}\r\n\r\n.mdi-pan::before {\r\n  content: \"\\F0BB4\";\r\n}\r\n\r\n.mdi-pan-bottom-left::before {\r\n  content: \"\\F0BB5\";\r\n}\r\n\r\n.mdi-pan-bottom-right::before {\r\n  content: \"\\F0BB6\";\r\n}\r\n\r\n.mdi-pan-down::before {\r\n  content: \"\\F0BB7\";\r\n}\r\n\r\n.mdi-pan-horizontal::before {\r\n  content: \"\\F0BB8\";\r\n}\r\n\r\n.mdi-pan-left::before {\r\n  content: \"\\F0BB9\";\r\n}\r\n\r\n.mdi-pan-right::before {\r\n  content: \"\\F0BBA\";\r\n}\r\n\r\n.mdi-pan-top-left::before {\r\n  content: \"\\F0BBB\";\r\n}\r\n\r\n.mdi-pan-top-right::before {\r\n  content: \"\\F0BBC\";\r\n}\r\n\r\n.mdi-pan-up::before {\r\n  content: \"\\F0BBD\";\r\n}\r\n\r\n.mdi-pan-vertical::before {\r\n  content: \"\\F0BBE\";\r\n}\r\n\r\n.mdi-panda::before {\r\n  content: \"\\F03DA\";\r\n}\r\n\r\n.mdi-pandora::before {\r\n  content: \"\\F03DB\";\r\n}\r\n\r\n.mdi-panorama::before {\r\n  content: \"\\F03DC\";\r\n}\r\n\r\n.mdi-panorama-fisheye::before {\r\n  content: \"\\F03DD\";\r\n}\r\n\r\n.mdi-panorama-horizontal::before {\r\n  content: \"\\F03DE\";\r\n}\r\n\r\n.mdi-panorama-vertical::before {\r\n  content: \"\\F03DF\";\r\n}\r\n\r\n.mdi-panorama-wide-angle::before {\r\n  content: \"\\F03E0\";\r\n}\r\n\r\n.mdi-paper-cut-vertical::before {\r\n  content: \"\\F03E1\";\r\n}\r\n\r\n.mdi-paper-roll::before {\r\n  content: \"\\F1157\";\r\n}\r\n\r\n.mdi-paper-roll-outline::before {\r\n  content: \"\\F1158\";\r\n}\r\n\r\n.mdi-paperclip::before {\r\n  content: \"\\F03E2\";\r\n}\r\n\r\n.mdi-parachute::before {\r\n  content: \"\\F0CB4\";\r\n}\r\n\r\n.mdi-parachute-outline::before {\r\n  content: \"\\F0CB5\";\r\n}\r\n\r\n.mdi-parking::before {\r\n  content: \"\\F03E3\";\r\n}\r\n\r\n.mdi-party-popper::before {\r\n  content: \"\\F1056\";\r\n}\r\n\r\n.mdi-passport::before {\r\n  content: \"\\F07E3\";\r\n}\r\n\r\n.mdi-passport-biometric::before {\r\n  content: \"\\F0DE1\";\r\n}\r\n\r\n.mdi-pasta::before {\r\n  content: \"\\F1160\";\r\n}\r\n\r\n.mdi-patio-heater::before {\r\n  content: \"\\F0F80\";\r\n}\r\n\r\n.mdi-patreon::before {\r\n  content: \"\\F0882\";\r\n}\r\n\r\n.mdi-pause::before {\r\n  content: \"\\F03E4\";\r\n}\r\n\r\n.mdi-pause-circle::before {\r\n  content: \"\\F03E5\";\r\n}\r\n\r\n.mdi-pause-circle-outline::before {\r\n  content: \"\\F03E6\";\r\n}\r\n\r\n.mdi-pause-octagon::before {\r\n  content: \"\\F03E7\";\r\n}\r\n\r\n.mdi-pause-octagon-outline::before {\r\n  content: \"\\F03E8\";\r\n}\r\n\r\n.mdi-paw::before {\r\n  content: \"\\F03E9\";\r\n}\r\n\r\n.mdi-paw-off::before {\r\n  content: \"\\F0657\";\r\n}\r\n\r\n.mdi-paw-off-outline::before {\r\n  content: \"\\F1676\";\r\n}\r\n\r\n.mdi-paw-outline::before {\r\n  content: \"\\F1675\";\r\n}\r\n\r\n.mdi-pdf-box::before {\r\n  content: \"\\F0E56\";\r\n}\r\n\r\n.mdi-peace::before {\r\n  content: \"\\F0884\";\r\n}\r\n\r\n.mdi-peanut::before {\r\n  content: \"\\F0FFC\";\r\n}\r\n\r\n.mdi-peanut-off::before {\r\n  content: \"\\F0FFD\";\r\n}\r\n\r\n.mdi-peanut-off-outline::before {\r\n  content: \"\\F0FFF\";\r\n}\r\n\r\n.mdi-peanut-outline::before {\r\n  content: \"\\F0FFE\";\r\n}\r\n\r\n.mdi-pen::before {\r\n  content: \"\\F03EA\";\r\n}\r\n\r\n.mdi-pen-lock::before {\r\n  content: \"\\F0DE2\";\r\n}\r\n\r\n.mdi-pen-minus::before {\r\n  content: \"\\F0DE3\";\r\n}\r\n\r\n.mdi-pen-off::before {\r\n  content: \"\\F0DE4\";\r\n}\r\n\r\n.mdi-pen-plus::before {\r\n  content: \"\\F0DE5\";\r\n}\r\n\r\n.mdi-pen-remove::before {\r\n  content: \"\\F0DE6\";\r\n}\r\n\r\n.mdi-pencil::before {\r\n  content: \"\\F03EB\";\r\n}\r\n\r\n.mdi-pencil-box::before {\r\n  content: \"\\F03EC\";\r\n}\r\n\r\n.mdi-pencil-box-multiple::before {\r\n  content: \"\\F1144\";\r\n}\r\n\r\n.mdi-pencil-box-multiple-outline::before {\r\n  content: \"\\F1145\";\r\n}\r\n\r\n.mdi-pencil-box-outline::before {\r\n  content: \"\\F03ED\";\r\n}\r\n\r\n.mdi-pencil-circle::before {\r\n  content: \"\\F06FF\";\r\n}\r\n\r\n.mdi-pencil-circle-outline::before {\r\n  content: \"\\F0776\";\r\n}\r\n\r\n.mdi-pencil-lock::before {\r\n  content: \"\\F03EE\";\r\n}\r\n\r\n.mdi-pencil-lock-outline::before {\r\n  content: \"\\F0DE7\";\r\n}\r\n\r\n.mdi-pencil-minus::before {\r\n  content: \"\\F0DE8\";\r\n}\r\n\r\n.mdi-pencil-minus-outline::before {\r\n  content: \"\\F0DE9\";\r\n}\r\n\r\n.mdi-pencil-off::before {\r\n  content: \"\\F03EF\";\r\n}\r\n\r\n.mdi-pencil-off-outline::before {\r\n  content: \"\\F0DEA\";\r\n}\r\n\r\n.mdi-pencil-outline::before {\r\n  content: \"\\F0CB6\";\r\n}\r\n\r\n.mdi-pencil-plus::before {\r\n  content: \"\\F0DEB\";\r\n}\r\n\r\n.mdi-pencil-plus-outline::before {\r\n  content: \"\\F0DEC\";\r\n}\r\n\r\n.mdi-pencil-remove::before {\r\n  content: \"\\F0DED\";\r\n}\r\n\r\n.mdi-pencil-remove-outline::before {\r\n  content: \"\\F0DEE\";\r\n}\r\n\r\n.mdi-pencil-ruler::before {\r\n  content: \"\\F1353\";\r\n}\r\n\r\n.mdi-penguin::before {\r\n  content: \"\\F0EC0\";\r\n}\r\n\r\n.mdi-pentagon::before {\r\n  content: \"\\F0701\";\r\n}\r\n\r\n.mdi-pentagon-outline::before {\r\n  content: \"\\F0700\";\r\n}\r\n\r\n.mdi-pentagram::before {\r\n  content: \"\\F1667\";\r\n}\r\n\r\n.mdi-percent::before {\r\n  content: \"\\F03F0\";\r\n}\r\n\r\n.mdi-percent-outline::before {\r\n  content: \"\\F1278\";\r\n}\r\n\r\n.mdi-periodic-table::before {\r\n  content: \"\\F08B6\";\r\n}\r\n\r\n.mdi-perspective-less::before {\r\n  content: \"\\F0D23\";\r\n}\r\n\r\n.mdi-perspective-more::before {\r\n  content: \"\\F0D24\";\r\n}\r\n\r\n.mdi-pharmacy::before {\r\n  content: \"\\F03F1\";\r\n}\r\n\r\n.mdi-phone::before {\r\n  content: \"\\F03F2\";\r\n}\r\n\r\n.mdi-phone-alert::before {\r\n  content: \"\\F0F1A\";\r\n}\r\n\r\n.mdi-phone-alert-outline::before {\r\n  content: \"\\F118E\";\r\n}\r\n\r\n.mdi-phone-bluetooth::before {\r\n  content: \"\\F03F3\";\r\n}\r\n\r\n.mdi-phone-bluetooth-outline::before {\r\n  content: \"\\F118F\";\r\n}\r\n\r\n.mdi-phone-cancel::before {\r\n  content: \"\\F10BC\";\r\n}\r\n\r\n.mdi-phone-cancel-outline::before {\r\n  content: \"\\F1190\";\r\n}\r\n\r\n.mdi-phone-check::before {\r\n  content: \"\\F11A9\";\r\n}\r\n\r\n.mdi-phone-check-outline::before {\r\n  content: \"\\F11AA\";\r\n}\r\n\r\n.mdi-phone-classic::before {\r\n  content: \"\\F0602\";\r\n}\r\n\r\n.mdi-phone-classic-off::before {\r\n  content: \"\\F1279\";\r\n}\r\n\r\n.mdi-phone-dial::before {\r\n  content: \"\\F1559\";\r\n}\r\n\r\n.mdi-phone-dial-outline::before {\r\n  content: \"\\F155A\";\r\n}\r\n\r\n.mdi-phone-forward::before {\r\n  content: \"\\F03F4\";\r\n}\r\n\r\n.mdi-phone-forward-outline::before {\r\n  content: \"\\F1191\";\r\n}\r\n\r\n.mdi-phone-hangup::before {\r\n  content: \"\\F03F5\";\r\n}\r\n\r\n.mdi-phone-hangup-outline::before {\r\n  content: \"\\F1192\";\r\n}\r\n\r\n.mdi-phone-in-talk::before {\r\n  content: \"\\F03F6\";\r\n}\r\n\r\n.mdi-phone-in-talk-outline::before {\r\n  content: \"\\F1182\";\r\n}\r\n\r\n.mdi-phone-incoming::before {\r\n  content: \"\\F03F7\";\r\n}\r\n\r\n.mdi-phone-incoming-outline::before {\r\n  content: \"\\F1193\";\r\n}\r\n\r\n.mdi-phone-lock::before {\r\n  content: \"\\F03F8\";\r\n}\r\n\r\n.mdi-phone-lock-outline::before {\r\n  content: \"\\F1194\";\r\n}\r\n\r\n.mdi-phone-log::before {\r\n  content: \"\\F03F9\";\r\n}\r\n\r\n.mdi-phone-log-outline::before {\r\n  content: \"\\F1195\";\r\n}\r\n\r\n.mdi-phone-message::before {\r\n  content: \"\\F1196\";\r\n}\r\n\r\n.mdi-phone-message-outline::before {\r\n  content: \"\\F1197\";\r\n}\r\n\r\n.mdi-phone-minus::before {\r\n  content: \"\\F0658\";\r\n}\r\n\r\n.mdi-phone-minus-outline::before {\r\n  content: \"\\F1198\";\r\n}\r\n\r\n.mdi-phone-missed::before {\r\n  content: \"\\F03FA\";\r\n}\r\n\r\n.mdi-phone-missed-outline::before {\r\n  content: \"\\F11A5\";\r\n}\r\n\r\n.mdi-phone-off::before {\r\n  content: \"\\F0DEF\";\r\n}\r\n\r\n.mdi-phone-off-outline::before {\r\n  content: \"\\F11A6\";\r\n}\r\n\r\n.mdi-phone-outgoing::before {\r\n  content: \"\\F03FB\";\r\n}\r\n\r\n.mdi-phone-outgoing-outline::before {\r\n  content: \"\\F1199\";\r\n}\r\n\r\n.mdi-phone-outline::before {\r\n  content: \"\\F0DF0\";\r\n}\r\n\r\n.mdi-phone-paused::before {\r\n  content: \"\\F03FC\";\r\n}\r\n\r\n.mdi-phone-paused-outline::before {\r\n  content: \"\\F119A\";\r\n}\r\n\r\n.mdi-phone-plus::before {\r\n  content: \"\\F0659\";\r\n}\r\n\r\n.mdi-phone-plus-outline::before {\r\n  content: \"\\F119B\";\r\n}\r\n\r\n.mdi-phone-remove::before {\r\n  content: \"\\F152F\";\r\n}\r\n\r\n.mdi-phone-remove-outline::before {\r\n  content: \"\\F1530\";\r\n}\r\n\r\n.mdi-phone-return::before {\r\n  content: \"\\F082F\";\r\n}\r\n\r\n.mdi-phone-return-outline::before {\r\n  content: \"\\F119C\";\r\n}\r\n\r\n.mdi-phone-ring::before {\r\n  content: \"\\F11AB\";\r\n}\r\n\r\n.mdi-phone-ring-outline::before {\r\n  content: \"\\F11AC\";\r\n}\r\n\r\n.mdi-phone-rotate-landscape::before {\r\n  content: \"\\F0885\";\r\n}\r\n\r\n.mdi-phone-rotate-portrait::before {\r\n  content: \"\\F0886\";\r\n}\r\n\r\n.mdi-phone-settings::before {\r\n  content: \"\\F03FD\";\r\n}\r\n\r\n.mdi-phone-settings-outline::before {\r\n  content: \"\\F119D\";\r\n}\r\n\r\n.mdi-phone-voip::before {\r\n  content: \"\\F03FE\";\r\n}\r\n\r\n.mdi-pi::before {\r\n  content: \"\\F03FF\";\r\n}\r\n\r\n.mdi-pi-box::before {\r\n  content: \"\\F0400\";\r\n}\r\n\r\n.mdi-pi-hole::before {\r\n  content: \"\\F0DF1\";\r\n}\r\n\r\n.mdi-piano::before {\r\n  content: \"\\F067D\";\r\n}\r\n\r\n.mdi-pickaxe::before {\r\n  content: \"\\F08B7\";\r\n}\r\n\r\n.mdi-picture-in-picture-bottom-right::before {\r\n  content: \"\\F0E57\";\r\n}\r\n\r\n.mdi-picture-in-picture-bottom-right-outline::before {\r\n  content: \"\\F0E58\";\r\n}\r\n\r\n.mdi-picture-in-picture-top-right::before {\r\n  content: \"\\F0E59\";\r\n}\r\n\r\n.mdi-picture-in-picture-top-right-outline::before {\r\n  content: \"\\F0E5A\";\r\n}\r\n\r\n.mdi-pier::before {\r\n  content: \"\\F0887\";\r\n}\r\n\r\n.mdi-pier-crane::before {\r\n  content: \"\\F0888\";\r\n}\r\n\r\n.mdi-pig::before {\r\n  content: \"\\F0401\";\r\n}\r\n\r\n.mdi-pig-variant::before {\r\n  content: \"\\F1006\";\r\n}\r\n\r\n.mdi-pig-variant-outline::before {\r\n  content: \"\\F1678\";\r\n}\r\n\r\n.mdi-piggy-bank::before {\r\n  content: \"\\F1007\";\r\n}\r\n\r\n.mdi-piggy-bank-outline::before {\r\n  content: \"\\F1679\";\r\n}\r\n\r\n.mdi-pill::before {\r\n  content: \"\\F0402\";\r\n}\r\n\r\n.mdi-pillar::before {\r\n  content: \"\\F0702\";\r\n}\r\n\r\n.mdi-pin::before {\r\n  content: \"\\F0403\";\r\n}\r\n\r\n.mdi-pin-off::before {\r\n  content: \"\\F0404\";\r\n}\r\n\r\n.mdi-pin-off-outline::before {\r\n  content: \"\\F0930\";\r\n}\r\n\r\n.mdi-pin-outline::before {\r\n  content: \"\\F0931\";\r\n}\r\n\r\n.mdi-pine-tree::before {\r\n  content: \"\\F0405\";\r\n}\r\n\r\n.mdi-pine-tree-box::before {\r\n  content: \"\\F0406\";\r\n}\r\n\r\n.mdi-pine-tree-fire::before {\r\n  content: \"\\F141A\";\r\n}\r\n\r\n.mdi-pinterest::before {\r\n  content: \"\\F0407\";\r\n}\r\n\r\n.mdi-pinwheel::before {\r\n  content: \"\\F0AD5\";\r\n}\r\n\r\n.mdi-pinwheel-outline::before {\r\n  content: \"\\F0AD6\";\r\n}\r\n\r\n.mdi-pipe::before {\r\n  content: \"\\F07E5\";\r\n}\r\n\r\n.mdi-pipe-disconnected::before {\r\n  content: \"\\F07E6\";\r\n}\r\n\r\n.mdi-pipe-leak::before {\r\n  content: \"\\F0889\";\r\n}\r\n\r\n.mdi-pipe-wrench::before {\r\n  content: \"\\F1354\";\r\n}\r\n\r\n.mdi-pirate::before {\r\n  content: \"\\F0A08\";\r\n}\r\n\r\n.mdi-pistol::before {\r\n  content: \"\\F0703\";\r\n}\r\n\r\n.mdi-piston::before {\r\n  content: \"\\F088A\";\r\n}\r\n\r\n.mdi-pitchfork::before {\r\n  content: \"\\F1553\";\r\n}\r\n\r\n.mdi-pizza::before {\r\n  content: \"\\F0409\";\r\n}\r\n\r\n.mdi-play::before {\r\n  content: \"\\F040A\";\r\n}\r\n\r\n.mdi-play-box::before {\r\n  content: \"\\F127A\";\r\n}\r\n\r\n.mdi-play-box-multiple::before {\r\n  content: \"\\F0D19\";\r\n}\r\n\r\n.mdi-play-box-multiple-outline::before {\r\n  content: \"\\F13E6\";\r\n}\r\n\r\n.mdi-play-box-outline::before {\r\n  content: \"\\F040B\";\r\n}\r\n\r\n.mdi-play-circle::before {\r\n  content: \"\\F040C\";\r\n}\r\n\r\n.mdi-play-circle-outline::before {\r\n  content: \"\\F040D\";\r\n}\r\n\r\n.mdi-play-network::before {\r\n  content: \"\\F088B\";\r\n}\r\n\r\n.mdi-play-network-outline::before {\r\n  content: \"\\F0CB7\";\r\n}\r\n\r\n.mdi-play-outline::before {\r\n  content: \"\\F0F1B\";\r\n}\r\n\r\n.mdi-play-pause::before {\r\n  content: \"\\F040E\";\r\n}\r\n\r\n.mdi-play-protected-content::before {\r\n  content: \"\\F040F\";\r\n}\r\n\r\n.mdi-play-speed::before {\r\n  content: \"\\F08FF\";\r\n}\r\n\r\n.mdi-playlist-check::before {\r\n  content: \"\\F05C7\";\r\n}\r\n\r\n.mdi-playlist-edit::before {\r\n  content: \"\\F0900\";\r\n}\r\n\r\n.mdi-playlist-minus::before {\r\n  content: \"\\F0410\";\r\n}\r\n\r\n.mdi-playlist-music::before {\r\n  content: \"\\F0CB8\";\r\n}\r\n\r\n.mdi-playlist-music-outline::before {\r\n  content: \"\\F0CB9\";\r\n}\r\n\r\n.mdi-playlist-play::before {\r\n  content: \"\\F0411\";\r\n}\r\n\r\n.mdi-playlist-plus::before {\r\n  content: \"\\F0412\";\r\n}\r\n\r\n.mdi-playlist-remove::before {\r\n  content: \"\\F0413\";\r\n}\r\n\r\n.mdi-playlist-star::before {\r\n  content: \"\\F0DF2\";\r\n}\r\n\r\n.mdi-plex::before {\r\n  content: \"\\F06BA\";\r\n}\r\n\r\n.mdi-plus::before {\r\n  content: \"\\F0415\";\r\n}\r\n\r\n.mdi-plus-box::before {\r\n  content: \"\\F0416\";\r\n}\r\n\r\n.mdi-plus-box-multiple::before {\r\n  content: \"\\F0334\";\r\n}\r\n\r\n.mdi-plus-box-multiple-outline::before {\r\n  content: \"\\F1143\";\r\n}\r\n\r\n.mdi-plus-box-outline::before {\r\n  content: \"\\F0704\";\r\n}\r\n\r\n.mdi-plus-circle::before {\r\n  content: \"\\F0417\";\r\n}\r\n\r\n.mdi-plus-circle-multiple::before {\r\n  content: \"\\F034C\";\r\n}\r\n\r\n.mdi-plus-circle-multiple-outline::before {\r\n  content: \"\\F0418\";\r\n}\r\n\r\n.mdi-plus-circle-outline::before {\r\n  content: \"\\F0419\";\r\n}\r\n\r\n.mdi-plus-minus::before {\r\n  content: \"\\F0992\";\r\n}\r\n\r\n.mdi-plus-minus-box::before {\r\n  content: \"\\F0993\";\r\n}\r\n\r\n.mdi-plus-minus-variant::before {\r\n  content: \"\\F14C9\";\r\n}\r\n\r\n.mdi-plus-network::before {\r\n  content: \"\\F041A\";\r\n}\r\n\r\n.mdi-plus-network-outline::before {\r\n  content: \"\\F0CBA\";\r\n}\r\n\r\n.mdi-plus-one::before {\r\n  content: \"\\F041B\";\r\n}\r\n\r\n.mdi-plus-outline::before {\r\n  content: \"\\F0705\";\r\n}\r\n\r\n.mdi-plus-thick::before {\r\n  content: \"\\F11EC\";\r\n}\r\n\r\n.mdi-podcast::before {\r\n  content: \"\\F0994\";\r\n}\r\n\r\n.mdi-podium::before {\r\n  content: \"\\F0D25\";\r\n}\r\n\r\n.mdi-podium-bronze::before {\r\n  content: \"\\F0D26\";\r\n}\r\n\r\n.mdi-podium-gold::before {\r\n  content: \"\\F0D27\";\r\n}\r\n\r\n.mdi-podium-silver::before {\r\n  content: \"\\F0D28\";\r\n}\r\n\r\n.mdi-point-of-sale::before {\r\n  content: \"\\F0D92\";\r\n}\r\n\r\n.mdi-pokeball::before {\r\n  content: \"\\F041D\";\r\n}\r\n\r\n.mdi-pokemon-go::before {\r\n  content: \"\\F0A09\";\r\n}\r\n\r\n.mdi-poker-chip::before {\r\n  content: \"\\F0830\";\r\n}\r\n\r\n.mdi-polaroid::before {\r\n  content: \"\\F041E\";\r\n}\r\n\r\n.mdi-police-badge::before {\r\n  content: \"\\F1167\";\r\n}\r\n\r\n.mdi-police-badge-outline::before {\r\n  content: \"\\F1168\";\r\n}\r\n\r\n.mdi-poll::before {\r\n  content: \"\\F041F\";\r\n}\r\n\r\n.mdi-poll-box::before {\r\n  content: \"\\F0420\";\r\n}\r\n\r\n.mdi-poll-box-outline::before {\r\n  content: \"\\F127B\";\r\n}\r\n\r\n.mdi-polo::before {\r\n  content: \"\\F14C3\";\r\n}\r\n\r\n.mdi-polymer::before {\r\n  content: \"\\F0421\";\r\n}\r\n\r\n.mdi-pool::before {\r\n  content: \"\\F0606\";\r\n}\r\n\r\n.mdi-popcorn::before {\r\n  content: \"\\F0422\";\r\n}\r\n\r\n.mdi-post::before {\r\n  content: \"\\F1008\";\r\n}\r\n\r\n.mdi-post-outline::before {\r\n  content: \"\\F1009\";\r\n}\r\n\r\n.mdi-postage-stamp::before {\r\n  content: \"\\F0CBB\";\r\n}\r\n\r\n.mdi-pot::before {\r\n  content: \"\\F02E5\";\r\n}\r\n\r\n.mdi-pot-mix::before {\r\n  content: \"\\F065B\";\r\n}\r\n\r\n.mdi-pot-mix-outline::before {\r\n  content: \"\\F0677\";\r\n}\r\n\r\n.mdi-pot-outline::before {\r\n  content: \"\\F02FF\";\r\n}\r\n\r\n.mdi-pot-steam::before {\r\n  content: \"\\F065A\";\r\n}\r\n\r\n.mdi-pot-steam-outline::before {\r\n  content: \"\\F0326\";\r\n}\r\n\r\n.mdi-pound::before {\r\n  content: \"\\F0423\";\r\n}\r\n\r\n.mdi-pound-box::before {\r\n  content: \"\\F0424\";\r\n}\r\n\r\n.mdi-pound-box-outline::before {\r\n  content: \"\\F117F\";\r\n}\r\n\r\n.mdi-power::before {\r\n  content: \"\\F0425\";\r\n}\r\n\r\n.mdi-power-cycle::before {\r\n  content: \"\\F0901\";\r\n}\r\n\r\n.mdi-power-off::before {\r\n  content: \"\\F0902\";\r\n}\r\n\r\n.mdi-power-on::before {\r\n  content: \"\\F0903\";\r\n}\r\n\r\n.mdi-power-plug::before {\r\n  content: \"\\F06A5\";\r\n}\r\n\r\n.mdi-power-plug-off::before {\r\n  content: \"\\F06A6\";\r\n}\r\n\r\n.mdi-power-plug-off-outline::before {\r\n  content: \"\\F1424\";\r\n}\r\n\r\n.mdi-power-plug-outline::before {\r\n  content: \"\\F1425\";\r\n}\r\n\r\n.mdi-power-settings::before {\r\n  content: \"\\F0426\";\r\n}\r\n\r\n.mdi-power-sleep::before {\r\n  content: \"\\F0904\";\r\n}\r\n\r\n.mdi-power-socket::before {\r\n  content: \"\\F0427\";\r\n}\r\n\r\n.mdi-power-socket-au::before {\r\n  content: \"\\F0905\";\r\n}\r\n\r\n.mdi-power-socket-de::before {\r\n  content: \"\\F1107\";\r\n}\r\n\r\n.mdi-power-socket-eu::before {\r\n  content: \"\\F07E7\";\r\n}\r\n\r\n.mdi-power-socket-fr::before {\r\n  content: \"\\F1108\";\r\n}\r\n\r\n.mdi-power-socket-it::before {\r\n  content: \"\\F14FF\";\r\n}\r\n\r\n.mdi-power-socket-jp::before {\r\n  content: \"\\F1109\";\r\n}\r\n\r\n.mdi-power-socket-uk::before {\r\n  content: \"\\F07E8\";\r\n}\r\n\r\n.mdi-power-socket-us::before {\r\n  content: \"\\F07E9\";\r\n}\r\n\r\n.mdi-power-standby::before {\r\n  content: \"\\F0906\";\r\n}\r\n\r\n.mdi-powershell::before {\r\n  content: \"\\F0A0A\";\r\n}\r\n\r\n.mdi-prescription::before {\r\n  content: \"\\F0706\";\r\n}\r\n\r\n.mdi-presentation::before {\r\n  content: \"\\F0428\";\r\n}\r\n\r\n.mdi-presentation-play::before {\r\n  content: \"\\F0429\";\r\n}\r\n\r\n.mdi-pretzel::before {\r\n  content: \"\\F1562\";\r\n}\r\n\r\n.mdi-printer::before {\r\n  content: \"\\F042A\";\r\n}\r\n\r\n.mdi-printer-3d::before {\r\n  content: \"\\F042B\";\r\n}\r\n\r\n.mdi-printer-3d-nozzle::before {\r\n  content: \"\\F0E5B\";\r\n}\r\n\r\n.mdi-printer-3d-nozzle-alert::before {\r\n  content: \"\\F11C0\";\r\n}\r\n\r\n.mdi-printer-3d-nozzle-alert-outline::before {\r\n  content: \"\\F11C1\";\r\n}\r\n\r\n.mdi-printer-3d-nozzle-outline::before {\r\n  content: \"\\F0E5C\";\r\n}\r\n\r\n.mdi-printer-alert::before {\r\n  content: \"\\F042C\";\r\n}\r\n\r\n.mdi-printer-check::before {\r\n  content: \"\\F1146\";\r\n}\r\n\r\n.mdi-printer-eye::before {\r\n  content: \"\\F1458\";\r\n}\r\n\r\n.mdi-printer-off::before {\r\n  content: \"\\F0E5D\";\r\n}\r\n\r\n.mdi-printer-pos::before {\r\n  content: \"\\F1057\";\r\n}\r\n\r\n.mdi-printer-search::before {\r\n  content: \"\\F1457\";\r\n}\r\n\r\n.mdi-printer-settings::before {\r\n  content: \"\\F0707\";\r\n}\r\n\r\n.mdi-printer-wireless::before {\r\n  content: \"\\F0A0B\";\r\n}\r\n\r\n.mdi-priority-high::before {\r\n  content: \"\\F0603\";\r\n}\r\n\r\n.mdi-priority-low::before {\r\n  content: \"\\F0604\";\r\n}\r\n\r\n.mdi-professional-hexagon::before {\r\n  content: \"\\F042D\";\r\n}\r\n\r\n.mdi-progress-alert::before {\r\n  content: \"\\F0CBC\";\r\n}\r\n\r\n.mdi-progress-check::before {\r\n  content: \"\\F0995\";\r\n}\r\n\r\n.mdi-progress-clock::before {\r\n  content: \"\\F0996\";\r\n}\r\n\r\n.mdi-progress-close::before {\r\n  content: \"\\F110A\";\r\n}\r\n\r\n.mdi-progress-download::before {\r\n  content: \"\\F0997\";\r\n}\r\n\r\n.mdi-progress-question::before {\r\n  content: \"\\F1522\";\r\n}\r\n\r\n.mdi-progress-upload::before {\r\n  content: \"\\F0998\";\r\n}\r\n\r\n.mdi-progress-wrench::before {\r\n  content: \"\\F0CBD\";\r\n}\r\n\r\n.mdi-projector::before {\r\n  content: \"\\F042E\";\r\n}\r\n\r\n.mdi-projector-screen::before {\r\n  content: \"\\F042F\";\r\n}\r\n\r\n.mdi-propane-tank::before {\r\n  content: \"\\F1357\";\r\n}\r\n\r\n.mdi-propane-tank-outline::before {\r\n  content: \"\\F1358\";\r\n}\r\n\r\n.mdi-protocol::before {\r\n  content: \"\\F0FD8\";\r\n}\r\n\r\n.mdi-publish::before {\r\n  content: \"\\F06A7\";\r\n}\r\n\r\n.mdi-pulse::before {\r\n  content: \"\\F0430\";\r\n}\r\n\r\n.mdi-pump::before {\r\n  content: \"\\F1402\";\r\n}\r\n\r\n.mdi-pumpkin::before {\r\n  content: \"\\F0BBF\";\r\n}\r\n\r\n.mdi-purse::before {\r\n  content: \"\\F0F1C\";\r\n}\r\n\r\n.mdi-purse-outline::before {\r\n  content: \"\\F0F1D\";\r\n}\r\n\r\n.mdi-puzzle::before {\r\n  content: \"\\F0431\";\r\n}\r\n\r\n.mdi-puzzle-check::before {\r\n  content: \"\\F1426\";\r\n}\r\n\r\n.mdi-puzzle-check-outline::before {\r\n  content: \"\\F1427\";\r\n}\r\n\r\n.mdi-puzzle-edit::before {\r\n  content: \"\\F14D3\";\r\n}\r\n\r\n.mdi-puzzle-edit-outline::before {\r\n  content: \"\\F14D9\";\r\n}\r\n\r\n.mdi-puzzle-heart::before {\r\n  content: \"\\F14D4\";\r\n}\r\n\r\n.mdi-puzzle-heart-outline::before {\r\n  content: \"\\F14DA\";\r\n}\r\n\r\n.mdi-puzzle-minus::before {\r\n  content: \"\\F14D1\";\r\n}\r\n\r\n.mdi-puzzle-minus-outline::before {\r\n  content: \"\\F14D7\";\r\n}\r\n\r\n.mdi-puzzle-outline::before {\r\n  content: \"\\F0A66\";\r\n}\r\n\r\n.mdi-puzzle-plus::before {\r\n  content: \"\\F14D0\";\r\n}\r\n\r\n.mdi-puzzle-plus-outline::before {\r\n  content: \"\\F14D6\";\r\n}\r\n\r\n.mdi-puzzle-remove::before {\r\n  content: \"\\F14D2\";\r\n}\r\n\r\n.mdi-puzzle-remove-outline::before {\r\n  content: \"\\F14D8\";\r\n}\r\n\r\n.mdi-puzzle-star::before {\r\n  content: \"\\F14D5\";\r\n}\r\n\r\n.mdi-puzzle-star-outline::before {\r\n  content: \"\\F14DB\";\r\n}\r\n\r\n.mdi-qi::before {\r\n  content: \"\\F0999\";\r\n}\r\n\r\n.mdi-qqchat::before {\r\n  content: \"\\F0605\";\r\n}\r\n\r\n.mdi-qrcode::before {\r\n  content: \"\\F0432\";\r\n}\r\n\r\n.mdi-qrcode-edit::before {\r\n  content: \"\\F08B8\";\r\n}\r\n\r\n.mdi-qrcode-minus::before {\r\n  content: \"\\F118C\";\r\n}\r\n\r\n.mdi-qrcode-plus::before {\r\n  content: \"\\F118B\";\r\n}\r\n\r\n.mdi-qrcode-remove::before {\r\n  content: \"\\F118D\";\r\n}\r\n\r\n.mdi-qrcode-scan::before {\r\n  content: \"\\F0433\";\r\n}\r\n\r\n.mdi-quadcopter::before {\r\n  content: \"\\F0434\";\r\n}\r\n\r\n.mdi-quality-high::before {\r\n  content: \"\\F0435\";\r\n}\r\n\r\n.mdi-quality-low::before {\r\n  content: \"\\F0A0C\";\r\n}\r\n\r\n.mdi-quality-medium::before {\r\n  content: \"\\F0A0D\";\r\n}\r\n\r\n.mdi-quora::before {\r\n  content: \"\\F0D29\";\r\n}\r\n\r\n.mdi-rabbit::before {\r\n  content: \"\\F0907\";\r\n}\r\n\r\n.mdi-racing-helmet::before {\r\n  content: \"\\F0D93\";\r\n}\r\n\r\n.mdi-racquetball::before {\r\n  content: \"\\F0D94\";\r\n}\r\n\r\n.mdi-radar::before {\r\n  content: \"\\F0437\";\r\n}\r\n\r\n.mdi-radiator::before {\r\n  content: \"\\F0438\";\r\n}\r\n\r\n.mdi-radiator-disabled::before {\r\n  content: \"\\F0AD7\";\r\n}\r\n\r\n.mdi-radiator-off::before {\r\n  content: \"\\F0AD8\";\r\n}\r\n\r\n.mdi-radio::before {\r\n  content: \"\\F0439\";\r\n}\r\n\r\n.mdi-radio-am::before {\r\n  content: \"\\F0CBE\";\r\n}\r\n\r\n.mdi-radio-fm::before {\r\n  content: \"\\F0CBF\";\r\n}\r\n\r\n.mdi-radio-handheld::before {\r\n  content: \"\\F043A\";\r\n}\r\n\r\n.mdi-radio-off::before {\r\n  content: \"\\F121C\";\r\n}\r\n\r\n.mdi-radio-tower::before {\r\n  content: \"\\F043B\";\r\n}\r\n\r\n.mdi-radioactive::before {\r\n  content: \"\\F043C\";\r\n}\r\n\r\n.mdi-radioactive-off::before {\r\n  content: \"\\F0EC1\";\r\n}\r\n\r\n.mdi-radiobox-blank::before {\r\n  content: \"\\F043D\";\r\n}\r\n\r\n.mdi-radiobox-marked::before {\r\n  content: \"\\F043E\";\r\n}\r\n\r\n.mdi-radiology-box::before {\r\n  content: \"\\F14C5\";\r\n}\r\n\r\n.mdi-radiology-box-outline::before {\r\n  content: \"\\F14C6\";\r\n}\r\n\r\n.mdi-radius::before {\r\n  content: \"\\F0CC0\";\r\n}\r\n\r\n.mdi-radius-outline::before {\r\n  content: \"\\F0CC1\";\r\n}\r\n\r\n.mdi-railroad-light::before {\r\n  content: \"\\F0F1E\";\r\n}\r\n\r\n.mdi-rake::before {\r\n  content: \"\\F1544\";\r\n}\r\n\r\n.mdi-raspberry-pi::before {\r\n  content: \"\\F043F\";\r\n}\r\n\r\n.mdi-ray-end::before {\r\n  content: \"\\F0440\";\r\n}\r\n\r\n.mdi-ray-end-arrow::before {\r\n  content: \"\\F0441\";\r\n}\r\n\r\n.mdi-ray-start::before {\r\n  content: \"\\F0442\";\r\n}\r\n\r\n.mdi-ray-start-arrow::before {\r\n  content: \"\\F0443\";\r\n}\r\n\r\n.mdi-ray-start-end::before {\r\n  content: \"\\F0444\";\r\n}\r\n\r\n.mdi-ray-start-vertex-end::before {\r\n  content: \"\\F15D8\";\r\n}\r\n\r\n.mdi-ray-vertex::before {\r\n  content: \"\\F0445\";\r\n}\r\n\r\n.mdi-react::before {\r\n  content: \"\\F0708\";\r\n}\r\n\r\n.mdi-read::before {\r\n  content: \"\\F0447\";\r\n}\r\n\r\n.mdi-receipt::before {\r\n  content: \"\\F0449\";\r\n}\r\n\r\n.mdi-record::before {\r\n  content: \"\\F044A\";\r\n}\r\n\r\n.mdi-record-circle::before {\r\n  content: \"\\F0EC2\";\r\n}\r\n\r\n.mdi-record-circle-outline::before {\r\n  content: \"\\F0EC3\";\r\n}\r\n\r\n.mdi-record-player::before {\r\n  content: \"\\F099A\";\r\n}\r\n\r\n.mdi-record-rec::before {\r\n  content: \"\\F044B\";\r\n}\r\n\r\n.mdi-rectangle::before {\r\n  content: \"\\F0E5E\";\r\n}\r\n\r\n.mdi-rectangle-outline::before {\r\n  content: \"\\F0E5F\";\r\n}\r\n\r\n.mdi-recycle::before {\r\n  content: \"\\F044C\";\r\n}\r\n\r\n.mdi-recycle-variant::before {\r\n  content: \"\\F139D\";\r\n}\r\n\r\n.mdi-reddit::before {\r\n  content: \"\\F044D\";\r\n}\r\n\r\n.mdi-redhat::before {\r\n  content: \"\\F111B\";\r\n}\r\n\r\n.mdi-redo::before {\r\n  content: \"\\F044E\";\r\n}\r\n\r\n.mdi-redo-variant::before {\r\n  content: \"\\F044F\";\r\n}\r\n\r\n.mdi-reflect-horizontal::before {\r\n  content: \"\\F0A0E\";\r\n}\r\n\r\n.mdi-reflect-vertical::before {\r\n  content: \"\\F0A0F\";\r\n}\r\n\r\n.mdi-refresh::before {\r\n  content: \"\\F0450\";\r\n}\r\n\r\n.mdi-refresh-circle::before {\r\n  content: \"\\F1377\";\r\n}\r\n\r\n.mdi-regex::before {\r\n  content: \"\\F0451\";\r\n}\r\n\r\n.mdi-registered-trademark::before {\r\n  content: \"\\F0A67\";\r\n}\r\n\r\n.mdi-reiterate::before {\r\n  content: \"\\F1588\";\r\n}\r\n\r\n.mdi-relation-many-to-many::before {\r\n  content: \"\\F1496\";\r\n}\r\n\r\n.mdi-relation-many-to-one::before {\r\n  content: \"\\F1497\";\r\n}\r\n\r\n.mdi-relation-many-to-one-or-many::before {\r\n  content: \"\\F1498\";\r\n}\r\n\r\n.mdi-relation-many-to-only-one::before {\r\n  content: \"\\F1499\";\r\n}\r\n\r\n.mdi-relation-many-to-zero-or-many::before {\r\n  content: \"\\F149A\";\r\n}\r\n\r\n.mdi-relation-many-to-zero-or-one::before {\r\n  content: \"\\F149B\";\r\n}\r\n\r\n.mdi-relation-one-or-many-to-many::before {\r\n  content: \"\\F149C\";\r\n}\r\n\r\n.mdi-relation-one-or-many-to-one::before {\r\n  content: \"\\F149D\";\r\n}\r\n\r\n.mdi-relation-one-or-many-to-one-or-many::before {\r\n  content: \"\\F149E\";\r\n}\r\n\r\n.mdi-relation-one-or-many-to-only-one::before {\r\n  content: \"\\F149F\";\r\n}\r\n\r\n.mdi-relation-one-or-many-to-zero-or-many::before {\r\n  content: \"\\F14A0\";\r\n}\r\n\r\n.mdi-relation-one-or-many-to-zero-or-one::before {\r\n  content: \"\\F14A1\";\r\n}\r\n\r\n.mdi-relation-one-to-many::before {\r\n  content: \"\\F14A2\";\r\n}\r\n\r\n.mdi-relation-one-to-one::before {\r\n  content: \"\\F14A3\";\r\n}\r\n\r\n.mdi-relation-one-to-one-or-many::before {\r\n  content: \"\\F14A4\";\r\n}\r\n\r\n.mdi-relation-one-to-only-one::before {\r\n  content: \"\\F14A5\";\r\n}\r\n\r\n.mdi-relation-one-to-zero-or-many::before {\r\n  content: \"\\F14A6\";\r\n}\r\n\r\n.mdi-relation-one-to-zero-or-one::before {\r\n  content: \"\\F14A7\";\r\n}\r\n\r\n.mdi-relation-only-one-to-many::before {\r\n  content: \"\\F14A8\";\r\n}\r\n\r\n.mdi-relation-only-one-to-one::before {\r\n  content: \"\\F14A9\";\r\n}\r\n\r\n.mdi-relation-only-one-to-one-or-many::before {\r\n  content: \"\\F14AA\";\r\n}\r\n\r\n.mdi-relation-only-one-to-only-one::before {\r\n  content: \"\\F14AB\";\r\n}\r\n\r\n.mdi-relation-only-one-to-zero-or-many::before {\r\n  content: \"\\F14AC\";\r\n}\r\n\r\n.mdi-relation-only-one-to-zero-or-one::before {\r\n  content: \"\\F14AD\";\r\n}\r\n\r\n.mdi-relation-zero-or-many-to-many::before {\r\n  content: \"\\F14AE\";\r\n}\r\n\r\n.mdi-relation-zero-or-many-to-one::before {\r\n  content: \"\\F14AF\";\r\n}\r\n\r\n.mdi-relation-zero-or-many-to-one-or-many::before {\r\n  content: \"\\F14B0\";\r\n}\r\n\r\n.mdi-relation-zero-or-many-to-only-one::before {\r\n  content: \"\\F14B1\";\r\n}\r\n\r\n.mdi-relation-zero-or-many-to-zero-or-many::before {\r\n  content: \"\\F14B2\";\r\n}\r\n\r\n.mdi-relation-zero-or-many-to-zero-or-one::before {\r\n  content: \"\\F14B3\";\r\n}\r\n\r\n.mdi-relation-zero-or-one-to-many::before {\r\n  content: \"\\F14B4\";\r\n}\r\n\r\n.mdi-relation-zero-or-one-to-one::before {\r\n  content: \"\\F14B5\";\r\n}\r\n\r\n.mdi-relation-zero-or-one-to-one-or-many::before {\r\n  content: \"\\F14B6\";\r\n}\r\n\r\n.mdi-relation-zero-or-one-to-only-one::before {\r\n  content: \"\\F14B7\";\r\n}\r\n\r\n.mdi-relation-zero-or-one-to-zero-or-many::before {\r\n  content: \"\\F14B8\";\r\n}\r\n\r\n.mdi-relation-zero-or-one-to-zero-or-one::before {\r\n  content: \"\\F14B9\";\r\n}\r\n\r\n.mdi-relative-scale::before {\r\n  content: \"\\F0452\";\r\n}\r\n\r\n.mdi-reload::before {\r\n  content: \"\\F0453\";\r\n}\r\n\r\n.mdi-reload-alert::before {\r\n  content: \"\\F110B\";\r\n}\r\n\r\n.mdi-reminder::before {\r\n  content: \"\\F088C\";\r\n}\r\n\r\n.mdi-remote::before {\r\n  content: \"\\F0454\";\r\n}\r\n\r\n.mdi-remote-desktop::before {\r\n  content: \"\\F08B9\";\r\n}\r\n\r\n.mdi-remote-off::before {\r\n  content: \"\\F0EC4\";\r\n}\r\n\r\n.mdi-remote-tv::before {\r\n  content: \"\\F0EC5\";\r\n}\r\n\r\n.mdi-remote-tv-off::before {\r\n  content: \"\\F0EC6\";\r\n}\r\n\r\n.mdi-rename-box::before {\r\n  content: \"\\F0455\";\r\n}\r\n\r\n.mdi-reorder-horizontal::before {\r\n  content: \"\\F0688\";\r\n}\r\n\r\n.mdi-reorder-vertical::before {\r\n  content: \"\\F0689\";\r\n}\r\n\r\n.mdi-repeat::before {\r\n  content: \"\\F0456\";\r\n}\r\n\r\n.mdi-repeat-off::before {\r\n  content: \"\\F0457\";\r\n}\r\n\r\n.mdi-repeat-once::before {\r\n  content: \"\\F0458\";\r\n}\r\n\r\n.mdi-replay::before {\r\n  content: \"\\F0459\";\r\n}\r\n\r\n.mdi-reply::before {\r\n  content: \"\\F045A\";\r\n}\r\n\r\n.mdi-reply-all::before {\r\n  content: \"\\F045B\";\r\n}\r\n\r\n.mdi-reply-all-outline::before {\r\n  content: \"\\F0F1F\";\r\n}\r\n\r\n.mdi-reply-circle::before {\r\n  content: \"\\F11AE\";\r\n}\r\n\r\n.mdi-reply-outline::before {\r\n  content: \"\\F0F20\";\r\n}\r\n\r\n.mdi-reproduction::before {\r\n  content: \"\\F045C\";\r\n}\r\n\r\n.mdi-resistor::before {\r\n  content: \"\\F0B44\";\r\n}\r\n\r\n.mdi-resistor-nodes::before {\r\n  content: \"\\F0B45\";\r\n}\r\n\r\n.mdi-resize::before {\r\n  content: \"\\F0A68\";\r\n}\r\n\r\n.mdi-resize-bottom-right::before {\r\n  content: \"\\F045D\";\r\n}\r\n\r\n.mdi-responsive::before {\r\n  content: \"\\F045E\";\r\n}\r\n\r\n.mdi-restart::before {\r\n  content: \"\\F0709\";\r\n}\r\n\r\n.mdi-restart-alert::before {\r\n  content: \"\\F110C\";\r\n}\r\n\r\n.mdi-restart-off::before {\r\n  content: \"\\F0D95\";\r\n}\r\n\r\n.mdi-restore::before {\r\n  content: \"\\F099B\";\r\n}\r\n\r\n.mdi-restore-alert::before {\r\n  content: \"\\F110D\";\r\n}\r\n\r\n.mdi-rewind::before {\r\n  content: \"\\F045F\";\r\n}\r\n\r\n.mdi-rewind-10::before {\r\n  content: \"\\F0D2A\";\r\n}\r\n\r\n.mdi-rewind-30::before {\r\n  content: \"\\F0D96\";\r\n}\r\n\r\n.mdi-rewind-5::before {\r\n  content: \"\\F11F9\";\r\n}\r\n\r\n.mdi-rewind-60::before {\r\n  content: \"\\F160C\";\r\n}\r\n\r\n.mdi-rewind-outline::before {\r\n  content: \"\\F070A\";\r\n}\r\n\r\n.mdi-rhombus::before {\r\n  content: \"\\F070B\";\r\n}\r\n\r\n.mdi-rhombus-medium::before {\r\n  content: \"\\F0A10\";\r\n}\r\n\r\n.mdi-rhombus-medium-outline::before {\r\n  content: \"\\F14DC\";\r\n}\r\n\r\n.mdi-rhombus-outline::before {\r\n  content: \"\\F070C\";\r\n}\r\n\r\n.mdi-rhombus-split::before {\r\n  content: \"\\F0A11\";\r\n}\r\n\r\n.mdi-rhombus-split-outline::before {\r\n  content: \"\\F14DD\";\r\n}\r\n\r\n.mdi-ribbon::before {\r\n  content: \"\\F0460\";\r\n}\r\n\r\n.mdi-rice::before {\r\n  content: \"\\F07EA\";\r\n}\r\n\r\n.mdi-rickshaw::before {\r\n  content: \"\\F15BB\";\r\n}\r\n\r\n.mdi-rickshaw-electric::before {\r\n  content: \"\\F15BC\";\r\n}\r\n\r\n.mdi-ring::before {\r\n  content: \"\\F07EB\";\r\n}\r\n\r\n.mdi-rivet::before {\r\n  content: \"\\F0E60\";\r\n}\r\n\r\n.mdi-road::before {\r\n  content: \"\\F0461\";\r\n}\r\n\r\n.mdi-road-variant::before {\r\n  content: \"\\F0462\";\r\n}\r\n\r\n.mdi-robber::before {\r\n  content: \"\\F1058\";\r\n}\r\n\r\n.mdi-robot::before {\r\n  content: \"\\F06A9\";\r\n}\r\n\r\n.mdi-robot-angry::before {\r\n  content: \"\\F169D\";\r\n}\r\n\r\n.mdi-robot-angry-outline::before {\r\n  content: \"\\F169E\";\r\n}\r\n\r\n.mdi-robot-confused::before {\r\n  content: \"\\F169F\";\r\n}\r\n\r\n.mdi-robot-confused-outline::before {\r\n  content: \"\\F16A0\";\r\n}\r\n\r\n.mdi-robot-dead::before {\r\n  content: \"\\F16A1\";\r\n}\r\n\r\n.mdi-robot-dead-outline::before {\r\n  content: \"\\F16A2\";\r\n}\r\n\r\n.mdi-robot-excited::before {\r\n  content: \"\\F16A3\";\r\n}\r\n\r\n.mdi-robot-excited-outline::before {\r\n  content: \"\\F16A4\";\r\n}\r\n\r\n.mdi-robot-industrial::before {\r\n  content: \"\\F0B46\";\r\n}\r\n\r\n.mdi-robot-love::before {\r\n  content: \"\\F16A5\";\r\n}\r\n\r\n.mdi-robot-love-outline::before {\r\n  content: \"\\F16A6\";\r\n}\r\n\r\n.mdi-robot-mower::before {\r\n  content: \"\\F11F7\";\r\n}\r\n\r\n.mdi-robot-mower-outline::before {\r\n  content: \"\\F11F3\";\r\n}\r\n\r\n.mdi-robot-off::before {\r\n  content: \"\\F16A7\";\r\n}\r\n\r\n.mdi-robot-off-outline::before {\r\n  content: \"\\F167B\";\r\n}\r\n\r\n.mdi-robot-outline::before {\r\n  content: \"\\F167A\";\r\n}\r\n\r\n.mdi-robot-vacuum::before {\r\n  content: \"\\F070D\";\r\n}\r\n\r\n.mdi-robot-vacuum-variant::before {\r\n  content: \"\\F0908\";\r\n}\r\n\r\n.mdi-rocket::before {\r\n  content: \"\\F0463\";\r\n}\r\n\r\n.mdi-rocket-launch::before {\r\n  content: \"\\F14DE\";\r\n}\r\n\r\n.mdi-rocket-launch-outline::before {\r\n  content: \"\\F14DF\";\r\n}\r\n\r\n.mdi-rocket-outline::before {\r\n  content: \"\\F13AF\";\r\n}\r\n\r\n.mdi-rodent::before {\r\n  content: \"\\F1327\";\r\n}\r\n\r\n.mdi-roller-skate::before {\r\n  content: \"\\F0D2B\";\r\n}\r\n\r\n.mdi-roller-skate-off::before {\r\n  content: \"\\F0145\";\r\n}\r\n\r\n.mdi-rollerblade::before {\r\n  content: \"\\F0D2C\";\r\n}\r\n\r\n.mdi-rollerblade-off::before {\r\n  content: \"\\F002E\";\r\n}\r\n\r\n.mdi-rollupjs::before {\r\n  content: \"\\F0BC0\";\r\n}\r\n\r\n.mdi-roman-numeral-1::before {\r\n  content: \"\\F1088\";\r\n}\r\n\r\n.mdi-roman-numeral-10::before {\r\n  content: \"\\F1091\";\r\n}\r\n\r\n.mdi-roman-numeral-2::before {\r\n  content: \"\\F1089\";\r\n}\r\n\r\n.mdi-roman-numeral-3::before {\r\n  content: \"\\F108A\";\r\n}\r\n\r\n.mdi-roman-numeral-4::before {\r\n  content: \"\\F108B\";\r\n}\r\n\r\n.mdi-roman-numeral-5::before {\r\n  content: \"\\F108C\";\r\n}\r\n\r\n.mdi-roman-numeral-6::before {\r\n  content: \"\\F108D\";\r\n}\r\n\r\n.mdi-roman-numeral-7::before {\r\n  content: \"\\F108E\";\r\n}\r\n\r\n.mdi-roman-numeral-8::before {\r\n  content: \"\\F108F\";\r\n}\r\n\r\n.mdi-roman-numeral-9::before {\r\n  content: \"\\F1090\";\r\n}\r\n\r\n.mdi-room-service::before {\r\n  content: \"\\F088D\";\r\n}\r\n\r\n.mdi-room-service-outline::before {\r\n  content: \"\\F0D97\";\r\n}\r\n\r\n.mdi-rotate-3d::before {\r\n  content: \"\\F0EC7\";\r\n}\r\n\r\n.mdi-rotate-3d-variant::before {\r\n  content: \"\\F0464\";\r\n}\r\n\r\n.mdi-rotate-left::before {\r\n  content: \"\\F0465\";\r\n}\r\n\r\n.mdi-rotate-left-variant::before {\r\n  content: \"\\F0466\";\r\n}\r\n\r\n.mdi-rotate-orbit::before {\r\n  content: \"\\F0D98\";\r\n}\r\n\r\n.mdi-rotate-right::before {\r\n  content: \"\\F0467\";\r\n}\r\n\r\n.mdi-rotate-right-variant::before {\r\n  content: \"\\F0468\";\r\n}\r\n\r\n.mdi-rounded-corner::before {\r\n  content: \"\\F0607\";\r\n}\r\n\r\n.mdi-router::before {\r\n  content: \"\\F11E2\";\r\n}\r\n\r\n.mdi-router-network::before {\r\n  content: \"\\F1087\";\r\n}\r\n\r\n.mdi-router-wireless::before {\r\n  content: \"\\F0469\";\r\n}\r\n\r\n.mdi-router-wireless-off::before {\r\n  content: \"\\F15A3\";\r\n}\r\n\r\n.mdi-router-wireless-settings::before {\r\n  content: \"\\F0A69\";\r\n}\r\n\r\n.mdi-routes::before {\r\n  content: \"\\F046A\";\r\n}\r\n\r\n.mdi-routes-clock::before {\r\n  content: \"\\F1059\";\r\n}\r\n\r\n.mdi-rowing::before {\r\n  content: \"\\F0608\";\r\n}\r\n\r\n.mdi-rss::before {\r\n  content: \"\\F046B\";\r\n}\r\n\r\n.mdi-rss-box::before {\r\n  content: \"\\F046C\";\r\n}\r\n\r\n.mdi-rss-off::before {\r\n  content: \"\\F0F21\";\r\n}\r\n\r\n.mdi-rug::before {\r\n  content: \"\\F1475\";\r\n}\r\n\r\n.mdi-rugby::before {\r\n  content: \"\\F0D99\";\r\n}\r\n\r\n.mdi-ruler::before {\r\n  content: \"\\F046D\";\r\n}\r\n\r\n.mdi-ruler-square::before {\r\n  content: \"\\F0CC2\";\r\n}\r\n\r\n.mdi-ruler-square-compass::before {\r\n  content: \"\\F0EBE\";\r\n}\r\n\r\n.mdi-run::before {\r\n  content: \"\\F070E\";\r\n}\r\n\r\n.mdi-run-fast::before {\r\n  content: \"\\F046E\";\r\n}\r\n\r\n.mdi-rv-truck::before {\r\n  content: \"\\F11D4\";\r\n}\r\n\r\n.mdi-sack::before {\r\n  content: \"\\F0D2E\";\r\n}\r\n\r\n.mdi-sack-percent::before {\r\n  content: \"\\F0D2F\";\r\n}\r\n\r\n.mdi-safe::before {\r\n  content: \"\\F0A6A\";\r\n}\r\n\r\n.mdi-safe-square::before {\r\n  content: \"\\F127C\";\r\n}\r\n\r\n.mdi-safe-square-outline::before {\r\n  content: \"\\F127D\";\r\n}\r\n\r\n.mdi-safety-goggles::before {\r\n  content: \"\\F0D30\";\r\n}\r\n\r\n.mdi-sail-boat::before {\r\n  content: \"\\F0EC8\";\r\n}\r\n\r\n.mdi-sale::before {\r\n  content: \"\\F046F\";\r\n}\r\n\r\n.mdi-salesforce::before {\r\n  content: \"\\F088E\";\r\n}\r\n\r\n.mdi-sass::before {\r\n  content: \"\\F07EC\";\r\n}\r\n\r\n.mdi-satellite::before {\r\n  content: \"\\F0470\";\r\n}\r\n\r\n.mdi-satellite-uplink::before {\r\n  content: \"\\F0909\";\r\n}\r\n\r\n.mdi-satellite-variant::before {\r\n  content: \"\\F0471\";\r\n}\r\n\r\n.mdi-sausage::before {\r\n  content: \"\\F08BA\";\r\n}\r\n\r\n.mdi-saw-blade::before {\r\n  content: \"\\F0E61\";\r\n}\r\n\r\n.mdi-sawtooth-wave::before {\r\n  content: \"\\F147A\";\r\n}\r\n\r\n.mdi-saxophone::before {\r\n  content: \"\\F0609\";\r\n}\r\n\r\n.mdi-scale::before {\r\n  content: \"\\F0472\";\r\n}\r\n\r\n.mdi-scale-balance::before {\r\n  content: \"\\F05D1\";\r\n}\r\n\r\n.mdi-scale-bathroom::before {\r\n  content: \"\\F0473\";\r\n}\r\n\r\n.mdi-scale-off::before {\r\n  content: \"\\F105A\";\r\n}\r\n\r\n.mdi-scan-helper::before {\r\n  content: \"\\F13D8\";\r\n}\r\n\r\n.mdi-scanner::before {\r\n  content: \"\\F06AB\";\r\n}\r\n\r\n.mdi-scanner-off::before {\r\n  content: \"\\F090A\";\r\n}\r\n\r\n.mdi-scatter-plot::before {\r\n  content: \"\\F0EC9\";\r\n}\r\n\r\n.mdi-scatter-plot-outline::before {\r\n  content: \"\\F0ECA\";\r\n}\r\n\r\n.mdi-school::before {\r\n  content: \"\\F0474\";\r\n}\r\n\r\n.mdi-school-outline::before {\r\n  content: \"\\F1180\";\r\n}\r\n\r\n.mdi-scissors-cutting::before {\r\n  content: \"\\F0A6B\";\r\n}\r\n\r\n.mdi-scooter::before {\r\n  content: \"\\F15BD\";\r\n}\r\n\r\n.mdi-scooter-electric::before {\r\n  content: \"\\F15BE\";\r\n}\r\n\r\n.mdi-scoreboard::before {\r\n  content: \"\\F127E\";\r\n}\r\n\r\n.mdi-scoreboard-outline::before {\r\n  content: \"\\F127F\";\r\n}\r\n\r\n.mdi-screen-rotation::before {\r\n  content: \"\\F0475\";\r\n}\r\n\r\n.mdi-screen-rotation-lock::before {\r\n  content: \"\\F0478\";\r\n}\r\n\r\n.mdi-screw-flat-top::before {\r\n  content: \"\\F0DF3\";\r\n}\r\n\r\n.mdi-screw-lag::before {\r\n  content: \"\\F0DF4\";\r\n}\r\n\r\n.mdi-screw-machine-flat-top::before {\r\n  content: \"\\F0DF5\";\r\n}\r\n\r\n.mdi-screw-machine-round-top::before {\r\n  content: \"\\F0DF6\";\r\n}\r\n\r\n.mdi-screw-round-top::before {\r\n  content: \"\\F0DF7\";\r\n}\r\n\r\n.mdi-screwdriver::before {\r\n  content: \"\\F0476\";\r\n}\r\n\r\n.mdi-script::before {\r\n  content: \"\\F0BC1\";\r\n}\r\n\r\n.mdi-script-outline::before {\r\n  content: \"\\F0477\";\r\n}\r\n\r\n.mdi-script-text::before {\r\n  content: \"\\F0BC2\";\r\n}\r\n\r\n.mdi-script-text-outline::before {\r\n  content: \"\\F0BC3\";\r\n}\r\n\r\n.mdi-sd::before {\r\n  content: \"\\F0479\";\r\n}\r\n\r\n.mdi-seal::before {\r\n  content: \"\\F047A\";\r\n}\r\n\r\n.mdi-seal-variant::before {\r\n  content: \"\\F0FD9\";\r\n}\r\n\r\n.mdi-search-web::before {\r\n  content: \"\\F070F\";\r\n}\r\n\r\n.mdi-seat::before {\r\n  content: \"\\F0CC3\";\r\n}\r\n\r\n.mdi-seat-flat::before {\r\n  content: \"\\F047B\";\r\n}\r\n\r\n.mdi-seat-flat-angled::before {\r\n  content: \"\\F047C\";\r\n}\r\n\r\n.mdi-seat-individual-suite::before {\r\n  content: \"\\F047D\";\r\n}\r\n\r\n.mdi-seat-legroom-extra::before {\r\n  content: \"\\F047E\";\r\n}\r\n\r\n.mdi-seat-legroom-normal::before {\r\n  content: \"\\F047F\";\r\n}\r\n\r\n.mdi-seat-legroom-reduced::before {\r\n  content: \"\\F0480\";\r\n}\r\n\r\n.mdi-seat-outline::before {\r\n  content: \"\\F0CC4\";\r\n}\r\n\r\n.mdi-seat-passenger::before {\r\n  content: \"\\F1249\";\r\n}\r\n\r\n.mdi-seat-recline-extra::before {\r\n  content: \"\\F0481\";\r\n}\r\n\r\n.mdi-seat-recline-normal::before {\r\n  content: \"\\F0482\";\r\n}\r\n\r\n.mdi-seatbelt::before {\r\n  content: \"\\F0CC5\";\r\n}\r\n\r\n.mdi-security::before {\r\n  content: \"\\F0483\";\r\n}\r\n\r\n.mdi-security-network::before {\r\n  content: \"\\F0484\";\r\n}\r\n\r\n.mdi-seed::before {\r\n  content: \"\\F0E62\";\r\n}\r\n\r\n.mdi-seed-off::before {\r\n  content: \"\\F13FD\";\r\n}\r\n\r\n.mdi-seed-off-outline::before {\r\n  content: \"\\F13FE\";\r\n}\r\n\r\n.mdi-seed-outline::before {\r\n  content: \"\\F0E63\";\r\n}\r\n\r\n.mdi-seesaw::before {\r\n  content: \"\\F15A4\";\r\n}\r\n\r\n.mdi-segment::before {\r\n  content: \"\\F0ECB\";\r\n}\r\n\r\n.mdi-select::before {\r\n  content: \"\\F0485\";\r\n}\r\n\r\n.mdi-select-all::before {\r\n  content: \"\\F0486\";\r\n}\r\n\r\n.mdi-select-color::before {\r\n  content: \"\\F0D31\";\r\n}\r\n\r\n.mdi-select-compare::before {\r\n  content: \"\\F0AD9\";\r\n}\r\n\r\n.mdi-select-drag::before {\r\n  content: \"\\F0A6C\";\r\n}\r\n\r\n.mdi-select-group::before {\r\n  content: \"\\F0F82\";\r\n}\r\n\r\n.mdi-select-inverse::before {\r\n  content: \"\\F0487\";\r\n}\r\n\r\n.mdi-select-marker::before {\r\n  content: \"\\F1280\";\r\n}\r\n\r\n.mdi-select-multiple::before {\r\n  content: \"\\F1281\";\r\n}\r\n\r\n.mdi-select-multiple-marker::before {\r\n  content: \"\\F1282\";\r\n}\r\n\r\n.mdi-select-off::before {\r\n  content: \"\\F0488\";\r\n}\r\n\r\n.mdi-select-place::before {\r\n  content: \"\\F0FDA\";\r\n}\r\n\r\n.mdi-select-search::before {\r\n  content: \"\\F1204\";\r\n}\r\n\r\n.mdi-selection::before {\r\n  content: \"\\F0489\";\r\n}\r\n\r\n.mdi-selection-drag::before {\r\n  content: \"\\F0A6D\";\r\n}\r\n\r\n.mdi-selection-ellipse::before {\r\n  content: \"\\F0D32\";\r\n}\r\n\r\n.mdi-selection-ellipse-arrow-inside::before {\r\n  content: \"\\F0F22\";\r\n}\r\n\r\n.mdi-selection-marker::before {\r\n  content: \"\\F1283\";\r\n}\r\n\r\n.mdi-selection-multiple::before {\r\n  content: \"\\F1285\";\r\n}\r\n\r\n.mdi-selection-multiple-marker::before {\r\n  content: \"\\F1284\";\r\n}\r\n\r\n.mdi-selection-off::before {\r\n  content: \"\\F0777\";\r\n}\r\n\r\n.mdi-selection-search::before {\r\n  content: \"\\F1205\";\r\n}\r\n\r\n.mdi-semantic-web::before {\r\n  content: \"\\F1316\";\r\n}\r\n\r\n.mdi-send::before {\r\n  content: \"\\F048A\";\r\n}\r\n\r\n.mdi-send-check::before {\r\n  content: \"\\F1161\";\r\n}\r\n\r\n.mdi-send-check-outline::before {\r\n  content: \"\\F1162\";\r\n}\r\n\r\n.mdi-send-circle::before {\r\n  content: \"\\F0DF8\";\r\n}\r\n\r\n.mdi-send-circle-outline::before {\r\n  content: \"\\F0DF9\";\r\n}\r\n\r\n.mdi-send-clock::before {\r\n  content: \"\\F1163\";\r\n}\r\n\r\n.mdi-send-clock-outline::before {\r\n  content: \"\\F1164\";\r\n}\r\n\r\n.mdi-send-lock::before {\r\n  content: \"\\F07ED\";\r\n}\r\n\r\n.mdi-send-lock-outline::before {\r\n  content: \"\\F1166\";\r\n}\r\n\r\n.mdi-send-outline::before {\r\n  content: \"\\F1165\";\r\n}\r\n\r\n.mdi-serial-port::before {\r\n  content: \"\\F065C\";\r\n}\r\n\r\n.mdi-server::before {\r\n  content: \"\\F048B\";\r\n}\r\n\r\n.mdi-server-minus::before {\r\n  content: \"\\F048C\";\r\n}\r\n\r\n.mdi-server-network::before {\r\n  content: \"\\F048D\";\r\n}\r\n\r\n.mdi-server-network-off::before {\r\n  content: \"\\F048E\";\r\n}\r\n\r\n.mdi-server-off::before {\r\n  content: \"\\F048F\";\r\n}\r\n\r\n.mdi-server-plus::before {\r\n  content: \"\\F0490\";\r\n}\r\n\r\n.mdi-server-remove::before {\r\n  content: \"\\F0491\";\r\n}\r\n\r\n.mdi-server-security::before {\r\n  content: \"\\F0492\";\r\n}\r\n\r\n.mdi-set-all::before {\r\n  content: \"\\F0778\";\r\n}\r\n\r\n.mdi-set-center::before {\r\n  content: \"\\F0779\";\r\n}\r\n\r\n.mdi-set-center-right::before {\r\n  content: \"\\F077A\";\r\n}\r\n\r\n.mdi-set-left::before {\r\n  content: \"\\F077B\";\r\n}\r\n\r\n.mdi-set-left-center::before {\r\n  content: \"\\F077C\";\r\n}\r\n\r\n.mdi-set-left-right::before {\r\n  content: \"\\F077D\";\r\n}\r\n\r\n.mdi-set-merge::before {\r\n  content: \"\\F14E0\";\r\n}\r\n\r\n.mdi-set-none::before {\r\n  content: \"\\F077E\";\r\n}\r\n\r\n.mdi-set-right::before {\r\n  content: \"\\F077F\";\r\n}\r\n\r\n.mdi-set-split::before {\r\n  content: \"\\F14E1\";\r\n}\r\n\r\n.mdi-set-square::before {\r\n  content: \"\\F145D\";\r\n}\r\n\r\n.mdi-set-top-box::before {\r\n  content: \"\\F099F\";\r\n}\r\n\r\n.mdi-settings-helper::before {\r\n  content: \"\\F0A6E\";\r\n}\r\n\r\n.mdi-shaker::before {\r\n  content: \"\\F110E\";\r\n}\r\n\r\n.mdi-shaker-outline::before {\r\n  content: \"\\F110F\";\r\n}\r\n\r\n.mdi-shape::before {\r\n  content: \"\\F0831\";\r\n}\r\n\r\n.mdi-shape-circle-plus::before {\r\n  content: \"\\F065D\";\r\n}\r\n\r\n.mdi-shape-outline::before {\r\n  content: \"\\F0832\";\r\n}\r\n\r\n.mdi-shape-oval-plus::before {\r\n  content: \"\\F11FA\";\r\n}\r\n\r\n.mdi-shape-plus::before {\r\n  content: \"\\F0495\";\r\n}\r\n\r\n.mdi-shape-polygon-plus::before {\r\n  content: \"\\F065E\";\r\n}\r\n\r\n.mdi-shape-rectangle-plus::before {\r\n  content: \"\\F065F\";\r\n}\r\n\r\n.mdi-shape-square-plus::before {\r\n  content: \"\\F0660\";\r\n}\r\n\r\n.mdi-shape-square-rounded-plus::before {\r\n  content: \"\\F14FA\";\r\n}\r\n\r\n.mdi-share::before {\r\n  content: \"\\F0496\";\r\n}\r\n\r\n.mdi-share-all::before {\r\n  content: \"\\F11F4\";\r\n}\r\n\r\n.mdi-share-all-outline::before {\r\n  content: \"\\F11F5\";\r\n}\r\n\r\n.mdi-share-circle::before {\r\n  content: \"\\F11AD\";\r\n}\r\n\r\n.mdi-share-off::before {\r\n  content: \"\\F0F23\";\r\n}\r\n\r\n.mdi-share-off-outline::before {\r\n  content: \"\\F0F24\";\r\n}\r\n\r\n.mdi-share-outline::before {\r\n  content: \"\\F0932\";\r\n}\r\n\r\n.mdi-share-variant::before {\r\n  content: \"\\F0497\";\r\n}\r\n\r\n.mdi-share-variant-outline::before {\r\n  content: \"\\F1514\";\r\n}\r\n\r\n.mdi-shark-fin::before {\r\n  content: \"\\F1673\";\r\n}\r\n\r\n.mdi-shark-fin-outline::before {\r\n  content: \"\\F1674\";\r\n}\r\n\r\n.mdi-sheep::before {\r\n  content: \"\\F0CC6\";\r\n}\r\n\r\n.mdi-shield::before {\r\n  content: \"\\F0498\";\r\n}\r\n\r\n.mdi-shield-account::before {\r\n  content: \"\\F088F\";\r\n}\r\n\r\n.mdi-shield-account-outline::before {\r\n  content: \"\\F0A12\";\r\n}\r\n\r\n.mdi-shield-account-variant::before {\r\n  content: \"\\F15A7\";\r\n}\r\n\r\n.mdi-shield-account-variant-outline::before {\r\n  content: \"\\F15A8\";\r\n}\r\n\r\n.mdi-shield-airplane::before {\r\n  content: \"\\F06BB\";\r\n}\r\n\r\n.mdi-shield-airplane-outline::before {\r\n  content: \"\\F0CC7\";\r\n}\r\n\r\n.mdi-shield-alert::before {\r\n  content: \"\\F0ECC\";\r\n}\r\n\r\n.mdi-shield-alert-outline::before {\r\n  content: \"\\F0ECD\";\r\n}\r\n\r\n.mdi-shield-bug::before {\r\n  content: \"\\F13DA\";\r\n}\r\n\r\n.mdi-shield-bug-outline::before {\r\n  content: \"\\F13DB\";\r\n}\r\n\r\n.mdi-shield-car::before {\r\n  content: \"\\F0F83\";\r\n}\r\n\r\n.mdi-shield-check::before {\r\n  content: \"\\F0565\";\r\n}\r\n\r\n.mdi-shield-check-outline::before {\r\n  content: \"\\F0CC8\";\r\n}\r\n\r\n.mdi-shield-cross::before {\r\n  content: \"\\F0CC9\";\r\n}\r\n\r\n.mdi-shield-cross-outline::before {\r\n  content: \"\\F0CCA\";\r\n}\r\n\r\n.mdi-shield-edit::before {\r\n  content: \"\\F11A0\";\r\n}\r\n\r\n.mdi-shield-edit-outline::before {\r\n  content: \"\\F11A1\";\r\n}\r\n\r\n.mdi-shield-half::before {\r\n  content: \"\\F1360\";\r\n}\r\n\r\n.mdi-shield-half-full::before {\r\n  content: \"\\F0780\";\r\n}\r\n\r\n.mdi-shield-home::before {\r\n  content: \"\\F068A\";\r\n}\r\n\r\n.mdi-shield-home-outline::before {\r\n  content: \"\\F0CCB\";\r\n}\r\n\r\n.mdi-shield-key::before {\r\n  content: \"\\F0BC4\";\r\n}\r\n\r\n.mdi-shield-key-outline::before {\r\n  content: \"\\F0BC5\";\r\n}\r\n\r\n.mdi-shield-link-variant::before {\r\n  content: \"\\F0D33\";\r\n}\r\n\r\n.mdi-shield-link-variant-outline::before {\r\n  content: \"\\F0D34\";\r\n}\r\n\r\n.mdi-shield-lock::before {\r\n  content: \"\\F099D\";\r\n}\r\n\r\n.mdi-shield-lock-outline::before {\r\n  content: \"\\F0CCC\";\r\n}\r\n\r\n.mdi-shield-off::before {\r\n  content: \"\\F099E\";\r\n}\r\n\r\n.mdi-shield-off-outline::before {\r\n  content: \"\\F099C\";\r\n}\r\n\r\n.mdi-shield-outline::before {\r\n  content: \"\\F0499\";\r\n}\r\n\r\n.mdi-shield-plus::before {\r\n  content: \"\\F0ADA\";\r\n}\r\n\r\n.mdi-shield-plus-outline::before {\r\n  content: \"\\F0ADB\";\r\n}\r\n\r\n.mdi-shield-refresh::before {\r\n  content: \"\\F00AA\";\r\n}\r\n\r\n.mdi-shield-refresh-outline::before {\r\n  content: \"\\F01E0\";\r\n}\r\n\r\n.mdi-shield-remove::before {\r\n  content: \"\\F0ADC\";\r\n}\r\n\r\n.mdi-shield-remove-outline::before {\r\n  content: \"\\F0ADD\";\r\n}\r\n\r\n.mdi-shield-search::before {\r\n  content: \"\\F0D9A\";\r\n}\r\n\r\n.mdi-shield-star::before {\r\n  content: \"\\F113B\";\r\n}\r\n\r\n.mdi-shield-star-outline::before {\r\n  content: \"\\F113C\";\r\n}\r\n\r\n.mdi-shield-sun::before {\r\n  content: \"\\F105D\";\r\n}\r\n\r\n.mdi-shield-sun-outline::before {\r\n  content: \"\\F105E\";\r\n}\r\n\r\n.mdi-shield-sync::before {\r\n  content: \"\\F11A2\";\r\n}\r\n\r\n.mdi-shield-sync-outline::before {\r\n  content: \"\\F11A3\";\r\n}\r\n\r\n.mdi-ship-wheel::before {\r\n  content: \"\\F0833\";\r\n}\r\n\r\n.mdi-shoe-ballet::before {\r\n  content: \"\\F15CA\";\r\n}\r\n\r\n.mdi-shoe-cleat::before {\r\n  content: \"\\F15C7\";\r\n}\r\n\r\n.mdi-shoe-formal::before {\r\n  content: \"\\F0B47\";\r\n}\r\n\r\n.mdi-shoe-heel::before {\r\n  content: \"\\F0B48\";\r\n}\r\n\r\n.mdi-shoe-print::before {\r\n  content: \"\\F0DFA\";\r\n}\r\n\r\n.mdi-shoe-sneaker::before {\r\n  content: \"\\F15C8\";\r\n}\r\n\r\n.mdi-shopping::before {\r\n  content: \"\\F049A\";\r\n}\r\n\r\n.mdi-shopping-music::before {\r\n  content: \"\\F049B\";\r\n}\r\n\r\n.mdi-shopping-outline::before {\r\n  content: \"\\F11D5\";\r\n}\r\n\r\n.mdi-shopping-search::before {\r\n  content: \"\\F0F84\";\r\n}\r\n\r\n.mdi-shore::before {\r\n  content: \"\\F14F9\";\r\n}\r\n\r\n.mdi-shovel::before {\r\n  content: \"\\F0710\";\r\n}\r\n\r\n.mdi-shovel-off::before {\r\n  content: \"\\F0711\";\r\n}\r\n\r\n.mdi-shower::before {\r\n  content: \"\\F09A0\";\r\n}\r\n\r\n.mdi-shower-head::before {\r\n  content: \"\\F09A1\";\r\n}\r\n\r\n.mdi-shredder::before {\r\n  content: \"\\F049C\";\r\n}\r\n\r\n.mdi-shuffle::before {\r\n  content: \"\\F049D\";\r\n}\r\n\r\n.mdi-shuffle-disabled::before {\r\n  content: \"\\F049E\";\r\n}\r\n\r\n.mdi-shuffle-variant::before {\r\n  content: \"\\F049F\";\r\n}\r\n\r\n.mdi-shuriken::before {\r\n  content: \"\\F137F\";\r\n}\r\n\r\n.mdi-sigma::before {\r\n  content: \"\\F04A0\";\r\n}\r\n\r\n.mdi-sigma-lower::before {\r\n  content: \"\\F062B\";\r\n}\r\n\r\n.mdi-sign-caution::before {\r\n  content: \"\\F04A1\";\r\n}\r\n\r\n.mdi-sign-direction::before {\r\n  content: \"\\F0781\";\r\n}\r\n\r\n.mdi-sign-direction-minus::before {\r\n  content: \"\\F1000\";\r\n}\r\n\r\n.mdi-sign-direction-plus::before {\r\n  content: \"\\F0FDC\";\r\n}\r\n\r\n.mdi-sign-direction-remove::before {\r\n  content: \"\\F0FDD\";\r\n}\r\n\r\n.mdi-sign-pole::before {\r\n  content: \"\\F14F8\";\r\n}\r\n\r\n.mdi-sign-real-estate::before {\r\n  content: \"\\F1118\";\r\n}\r\n\r\n.mdi-sign-text::before {\r\n  content: \"\\F0782\";\r\n}\r\n\r\n.mdi-signal::before {\r\n  content: \"\\F04A2\";\r\n}\r\n\r\n.mdi-signal-2g::before {\r\n  content: \"\\F0712\";\r\n}\r\n\r\n.mdi-signal-3g::before {\r\n  content: \"\\F0713\";\r\n}\r\n\r\n.mdi-signal-4g::before {\r\n  content: \"\\F0714\";\r\n}\r\n\r\n.mdi-signal-5g::before {\r\n  content: \"\\F0A6F\";\r\n}\r\n\r\n.mdi-signal-cellular-1::before {\r\n  content: \"\\F08BC\";\r\n}\r\n\r\n.mdi-signal-cellular-2::before {\r\n  content: \"\\F08BD\";\r\n}\r\n\r\n.mdi-signal-cellular-3::before {\r\n  content: \"\\F08BE\";\r\n}\r\n\r\n.mdi-signal-cellular-outline::before {\r\n  content: \"\\F08BF\";\r\n}\r\n\r\n.mdi-signal-distance-variant::before {\r\n  content: \"\\F0E64\";\r\n}\r\n\r\n.mdi-signal-hspa::before {\r\n  content: \"\\F0715\";\r\n}\r\n\r\n.mdi-signal-hspa-plus::before {\r\n  content: \"\\F0716\";\r\n}\r\n\r\n.mdi-signal-off::before {\r\n  content: \"\\F0783\";\r\n}\r\n\r\n.mdi-signal-variant::before {\r\n  content: \"\\F060A\";\r\n}\r\n\r\n.mdi-signature::before {\r\n  content: \"\\F0DFB\";\r\n}\r\n\r\n.mdi-signature-freehand::before {\r\n  content: \"\\F0DFC\";\r\n}\r\n\r\n.mdi-signature-image::before {\r\n  content: \"\\F0DFD\";\r\n}\r\n\r\n.mdi-signature-text::before {\r\n  content: \"\\F0DFE\";\r\n}\r\n\r\n.mdi-silo::before {\r\n  content: \"\\F0B49\";\r\n}\r\n\r\n.mdi-silverware::before {\r\n  content: \"\\F04A3\";\r\n}\r\n\r\n.mdi-silverware-clean::before {\r\n  content: \"\\F0FDE\";\r\n}\r\n\r\n.mdi-silverware-fork::before {\r\n  content: \"\\F04A4\";\r\n}\r\n\r\n.mdi-silverware-fork-knife::before {\r\n  content: \"\\F0A70\";\r\n}\r\n\r\n.mdi-silverware-spoon::before {\r\n  content: \"\\F04A5\";\r\n}\r\n\r\n.mdi-silverware-variant::before {\r\n  content: \"\\F04A6\";\r\n}\r\n\r\n.mdi-sim::before {\r\n  content: \"\\F04A7\";\r\n}\r\n\r\n.mdi-sim-alert::before {\r\n  content: \"\\F04A8\";\r\n}\r\n\r\n.mdi-sim-alert-outline::before {\r\n  content: \"\\F15D3\";\r\n}\r\n\r\n.mdi-sim-off::before {\r\n  content: \"\\F04A9\";\r\n}\r\n\r\n.mdi-sim-off-outline::before {\r\n  content: \"\\F15D4\";\r\n}\r\n\r\n.mdi-sim-outline::before {\r\n  content: \"\\F15D5\";\r\n}\r\n\r\n.mdi-simple-icons::before {\r\n  content: \"\\F131D\";\r\n}\r\n\r\n.mdi-sina-weibo::before {\r\n  content: \"\\F0ADF\";\r\n}\r\n\r\n.mdi-sine-wave::before {\r\n  content: \"\\F095B\";\r\n}\r\n\r\n.mdi-sitemap::before {\r\n  content: \"\\F04AA\";\r\n}\r\n\r\n.mdi-size-l::before {\r\n  content: \"\\F13A6\";\r\n}\r\n\r\n.mdi-size-m::before {\r\n  content: \"\\F13A5\";\r\n}\r\n\r\n.mdi-size-s::before {\r\n  content: \"\\F13A4\";\r\n}\r\n\r\n.mdi-size-xl::before {\r\n  content: \"\\F13A7\";\r\n}\r\n\r\n.mdi-size-xs::before {\r\n  content: \"\\F13A3\";\r\n}\r\n\r\n.mdi-size-xxl::before {\r\n  content: \"\\F13A8\";\r\n}\r\n\r\n.mdi-size-xxs::before {\r\n  content: \"\\F13A2\";\r\n}\r\n\r\n.mdi-size-xxxl::before {\r\n  content: \"\\F13A9\";\r\n}\r\n\r\n.mdi-skate::before {\r\n  content: \"\\F0D35\";\r\n}\r\n\r\n.mdi-skateboard::before {\r\n  content: \"\\F14C2\";\r\n}\r\n\r\n.mdi-skew-less::before {\r\n  content: \"\\F0D36\";\r\n}\r\n\r\n.mdi-skew-more::before {\r\n  content: \"\\F0D37\";\r\n}\r\n\r\n.mdi-ski::before {\r\n  content: \"\\F1304\";\r\n}\r\n\r\n.mdi-ski-cross-country::before {\r\n  content: \"\\F1305\";\r\n}\r\n\r\n.mdi-ski-water::before {\r\n  content: \"\\F1306\";\r\n}\r\n\r\n.mdi-skip-backward::before {\r\n  content: \"\\F04AB\";\r\n}\r\n\r\n.mdi-skip-backward-outline::before {\r\n  content: \"\\F0F25\";\r\n}\r\n\r\n.mdi-skip-forward::before {\r\n  content: \"\\F04AC\";\r\n}\r\n\r\n.mdi-skip-forward-outline::before {\r\n  content: \"\\F0F26\";\r\n}\r\n\r\n.mdi-skip-next::before {\r\n  content: \"\\F04AD\";\r\n}\r\n\r\n.mdi-skip-next-circle::before {\r\n  content: \"\\F0661\";\r\n}\r\n\r\n.mdi-skip-next-circle-outline::before {\r\n  content: \"\\F0662\";\r\n}\r\n\r\n.mdi-skip-next-outline::before {\r\n  content: \"\\F0F27\";\r\n}\r\n\r\n.mdi-skip-previous::before {\r\n  content: \"\\F04AE\";\r\n}\r\n\r\n.mdi-skip-previous-circle::before {\r\n  content: \"\\F0663\";\r\n}\r\n\r\n.mdi-skip-previous-circle-outline::before {\r\n  content: \"\\F0664\";\r\n}\r\n\r\n.mdi-skip-previous-outline::before {\r\n  content: \"\\F0F28\";\r\n}\r\n\r\n.mdi-skull::before {\r\n  content: \"\\F068C\";\r\n}\r\n\r\n.mdi-skull-crossbones::before {\r\n  content: \"\\F0BC6\";\r\n}\r\n\r\n.mdi-skull-crossbones-outline::before {\r\n  content: \"\\F0BC7\";\r\n}\r\n\r\n.mdi-skull-outline::before {\r\n  content: \"\\F0BC8\";\r\n}\r\n\r\n.mdi-skull-scan::before {\r\n  content: \"\\F14C7\";\r\n}\r\n\r\n.mdi-skull-scan-outline::before {\r\n  content: \"\\F14C8\";\r\n}\r\n\r\n.mdi-skype::before {\r\n  content: \"\\F04AF\";\r\n}\r\n\r\n.mdi-skype-business::before {\r\n  content: \"\\F04B0\";\r\n}\r\n\r\n.mdi-slack::before {\r\n  content: \"\\F04B1\";\r\n}\r\n\r\n.mdi-slash-forward::before {\r\n  content: \"\\F0FDF\";\r\n}\r\n\r\n.mdi-slash-forward-box::before {\r\n  content: \"\\F0FE0\";\r\n}\r\n\r\n.mdi-sleep::before {\r\n  content: \"\\F04B2\";\r\n}\r\n\r\n.mdi-sleep-off::before {\r\n  content: \"\\F04B3\";\r\n}\r\n\r\n.mdi-slide::before {\r\n  content: \"\\F15A5\";\r\n}\r\n\r\n.mdi-slope-downhill::before {\r\n  content: \"\\F0DFF\";\r\n}\r\n\r\n.mdi-slope-uphill::before {\r\n  content: \"\\F0E00\";\r\n}\r\n\r\n.mdi-slot-machine::before {\r\n  content: \"\\F1114\";\r\n}\r\n\r\n.mdi-slot-machine-outline::before {\r\n  content: \"\\F1115\";\r\n}\r\n\r\n.mdi-smart-card::before {\r\n  content: \"\\F10BD\";\r\n}\r\n\r\n.mdi-smart-card-outline::before {\r\n  content: \"\\F10BE\";\r\n}\r\n\r\n.mdi-smart-card-reader::before {\r\n  content: \"\\F10BF\";\r\n}\r\n\r\n.mdi-smart-card-reader-outline::before {\r\n  content: \"\\F10C0\";\r\n}\r\n\r\n.mdi-smog::before {\r\n  content: \"\\F0A71\";\r\n}\r\n\r\n.mdi-smoke-detector::before {\r\n  content: \"\\F0392\";\r\n}\r\n\r\n.mdi-smoking::before {\r\n  content: \"\\F04B4\";\r\n}\r\n\r\n.mdi-smoking-off::before {\r\n  content: \"\\F04B5\";\r\n}\r\n\r\n.mdi-smoking-pipe::before {\r\n  content: \"\\F140D\";\r\n}\r\n\r\n.mdi-smoking-pipe-off::before {\r\n  content: \"\\F1428\";\r\n}\r\n\r\n.mdi-snail::before {\r\n  content: \"\\F1677\";\r\n}\r\n\r\n.mdi-snake::before {\r\n  content: \"\\F150E\";\r\n}\r\n\r\n.mdi-snapchat::before {\r\n  content: \"\\F04B6\";\r\n}\r\n\r\n.mdi-snowboard::before {\r\n  content: \"\\F1307\";\r\n}\r\n\r\n.mdi-snowflake::before {\r\n  content: \"\\F0717\";\r\n}\r\n\r\n.mdi-snowflake-alert::before {\r\n  content: \"\\F0F29\";\r\n}\r\n\r\n.mdi-snowflake-melt::before {\r\n  content: \"\\F12CB\";\r\n}\r\n\r\n.mdi-snowflake-off::before {\r\n  content: \"\\F14E3\";\r\n}\r\n\r\n.mdi-snowflake-variant::before {\r\n  content: \"\\F0F2A\";\r\n}\r\n\r\n.mdi-snowman::before {\r\n  content: \"\\F04B7\";\r\n}\r\n\r\n.mdi-soccer::before {\r\n  content: \"\\F04B8\";\r\n}\r\n\r\n.mdi-soccer-field::before {\r\n  content: \"\\F0834\";\r\n}\r\n\r\n.mdi-social-distance-2-meters::before {\r\n  content: \"\\F1579\";\r\n}\r\n\r\n.mdi-social-distance-6-feet::before {\r\n  content: \"\\F157A\";\r\n}\r\n\r\n.mdi-sofa::before {\r\n  content: \"\\F04B9\";\r\n}\r\n\r\n.mdi-sofa-outline::before {\r\n  content: \"\\F156D\";\r\n}\r\n\r\n.mdi-sofa-single::before {\r\n  content: \"\\F156E\";\r\n}\r\n\r\n.mdi-sofa-single-outline::before {\r\n  content: \"\\F156F\";\r\n}\r\n\r\n.mdi-solar-panel::before {\r\n  content: \"\\F0D9B\";\r\n}\r\n\r\n.mdi-solar-panel-large::before {\r\n  content: \"\\F0D9C\";\r\n}\r\n\r\n.mdi-solar-power::before {\r\n  content: \"\\F0A72\";\r\n}\r\n\r\n.mdi-soldering-iron::before {\r\n  content: \"\\F1092\";\r\n}\r\n\r\n.mdi-solid::before {\r\n  content: \"\\F068D\";\r\n}\r\n\r\n.mdi-sony-playstation::before {\r\n  content: \"\\F0414\";\r\n}\r\n\r\n.mdi-sort::before {\r\n  content: \"\\F04BA\";\r\n}\r\n\r\n.mdi-sort-alphabetical-ascending::before {\r\n  content: \"\\F05BD\";\r\n}\r\n\r\n.mdi-sort-alphabetical-ascending-variant::before {\r\n  content: \"\\F1148\";\r\n}\r\n\r\n.mdi-sort-alphabetical-descending::before {\r\n  content: \"\\F05BF\";\r\n}\r\n\r\n.mdi-sort-alphabetical-descending-variant::before {\r\n  content: \"\\F1149\";\r\n}\r\n\r\n.mdi-sort-alphabetical-variant::before {\r\n  content: \"\\F04BB\";\r\n}\r\n\r\n.mdi-sort-ascending::before {\r\n  content: \"\\F04BC\";\r\n}\r\n\r\n.mdi-sort-bool-ascending::before {\r\n  content: \"\\F1385\";\r\n}\r\n\r\n.mdi-sort-bool-ascending-variant::before {\r\n  content: \"\\F1386\";\r\n}\r\n\r\n.mdi-sort-bool-descending::before {\r\n  content: \"\\F1387\";\r\n}\r\n\r\n.mdi-sort-bool-descending-variant::before {\r\n  content: \"\\F1388\";\r\n}\r\n\r\n.mdi-sort-calendar-ascending::before {\r\n  content: \"\\F1547\";\r\n}\r\n\r\n.mdi-sort-calendar-descending::before {\r\n  content: \"\\F1548\";\r\n}\r\n\r\n.mdi-sort-clock-ascending::before {\r\n  content: \"\\F1549\";\r\n}\r\n\r\n.mdi-sort-clock-ascending-outline::before {\r\n  content: \"\\F154A\";\r\n}\r\n\r\n.mdi-sort-clock-descending::before {\r\n  content: \"\\F154B\";\r\n}\r\n\r\n.mdi-sort-clock-descending-outline::before {\r\n  content: \"\\F154C\";\r\n}\r\n\r\n.mdi-sort-descending::before {\r\n  content: \"\\F04BD\";\r\n}\r\n\r\n.mdi-sort-numeric-ascending::before {\r\n  content: \"\\F1389\";\r\n}\r\n\r\n.mdi-sort-numeric-ascending-variant::before {\r\n  content: \"\\F090D\";\r\n}\r\n\r\n.mdi-sort-numeric-descending::before {\r\n  content: \"\\F138A\";\r\n}\r\n\r\n.mdi-sort-numeric-descending-variant::before {\r\n  content: \"\\F0AD2\";\r\n}\r\n\r\n.mdi-sort-numeric-variant::before {\r\n  content: \"\\F04BE\";\r\n}\r\n\r\n.mdi-sort-reverse-variant::before {\r\n  content: \"\\F033C\";\r\n}\r\n\r\n.mdi-sort-variant::before {\r\n  content: \"\\F04BF\";\r\n}\r\n\r\n.mdi-sort-variant-lock::before {\r\n  content: \"\\F0CCD\";\r\n}\r\n\r\n.mdi-sort-variant-lock-open::before {\r\n  content: \"\\F0CCE\";\r\n}\r\n\r\n.mdi-sort-variant-remove::before {\r\n  content: \"\\F1147\";\r\n}\r\n\r\n.mdi-soundcloud::before {\r\n  content: \"\\F04C0\";\r\n}\r\n\r\n.mdi-source-branch::before {\r\n  content: \"\\F062C\";\r\n}\r\n\r\n.mdi-source-branch-check::before {\r\n  content: \"\\F14CF\";\r\n}\r\n\r\n.mdi-source-branch-minus::before {\r\n  content: \"\\F14CB\";\r\n}\r\n\r\n.mdi-source-branch-plus::before {\r\n  content: \"\\F14CA\";\r\n}\r\n\r\n.mdi-source-branch-refresh::before {\r\n  content: \"\\F14CD\";\r\n}\r\n\r\n.mdi-source-branch-remove::before {\r\n  content: \"\\F14CC\";\r\n}\r\n\r\n.mdi-source-branch-sync::before {\r\n  content: \"\\F14CE\";\r\n}\r\n\r\n.mdi-source-commit::before {\r\n  content: \"\\F0718\";\r\n}\r\n\r\n.mdi-source-commit-end::before {\r\n  content: \"\\F0719\";\r\n}\r\n\r\n.mdi-source-commit-end-local::before {\r\n  content: \"\\F071A\";\r\n}\r\n\r\n.mdi-source-commit-local::before {\r\n  content: \"\\F071B\";\r\n}\r\n\r\n.mdi-source-commit-next-local::before {\r\n  content: \"\\F071C\";\r\n}\r\n\r\n.mdi-source-commit-start::before {\r\n  content: \"\\F071D\";\r\n}\r\n\r\n.mdi-source-commit-start-next-local::before {\r\n  content: \"\\F071E\";\r\n}\r\n\r\n.mdi-source-fork::before {\r\n  content: \"\\F04C1\";\r\n}\r\n\r\n.mdi-source-merge::before {\r\n  content: \"\\F062D\";\r\n}\r\n\r\n.mdi-source-pull::before {\r\n  content: \"\\F04C2\";\r\n}\r\n\r\n.mdi-source-repository::before {\r\n  content: \"\\F0CCF\";\r\n}\r\n\r\n.mdi-source-repository-multiple::before {\r\n  content: \"\\F0CD0\";\r\n}\r\n\r\n.mdi-soy-sauce::before {\r\n  content: \"\\F07EE\";\r\n}\r\n\r\n.mdi-soy-sauce-off::before {\r\n  content: \"\\F13FC\";\r\n}\r\n\r\n.mdi-spa::before {\r\n  content: \"\\F0CD1\";\r\n}\r\n\r\n.mdi-spa-outline::before {\r\n  content: \"\\F0CD2\";\r\n}\r\n\r\n.mdi-space-invaders::before {\r\n  content: \"\\F0BC9\";\r\n}\r\n\r\n.mdi-space-station::before {\r\n  content: \"\\F1383\";\r\n}\r\n\r\n.mdi-spade::before {\r\n  content: \"\\F0E65\";\r\n}\r\n\r\n.mdi-sparkles::before {\r\n  content: \"\\F1545\";\r\n}\r\n\r\n.mdi-speaker::before {\r\n  content: \"\\F04C3\";\r\n}\r\n\r\n.mdi-speaker-bluetooth::before {\r\n  content: \"\\F09A2\";\r\n}\r\n\r\n.mdi-speaker-multiple::before {\r\n  content: \"\\F0D38\";\r\n}\r\n\r\n.mdi-speaker-off::before {\r\n  content: \"\\F04C4\";\r\n}\r\n\r\n.mdi-speaker-wireless::before {\r\n  content: \"\\F071F\";\r\n}\r\n\r\n.mdi-speedometer::before {\r\n  content: \"\\F04C5\";\r\n}\r\n\r\n.mdi-speedometer-medium::before {\r\n  content: \"\\F0F85\";\r\n}\r\n\r\n.mdi-speedometer-slow::before {\r\n  content: \"\\F0F86\";\r\n}\r\n\r\n.mdi-spellcheck::before {\r\n  content: \"\\F04C6\";\r\n}\r\n\r\n.mdi-spider::before {\r\n  content: \"\\F11EA\";\r\n}\r\n\r\n.mdi-spider-thread::before {\r\n  content: \"\\F11EB\";\r\n}\r\n\r\n.mdi-spider-web::before {\r\n  content: \"\\F0BCA\";\r\n}\r\n\r\n.mdi-spirit-level::before {\r\n  content: \"\\F14F1\";\r\n}\r\n\r\n.mdi-spoon-sugar::before {\r\n  content: \"\\F1429\";\r\n}\r\n\r\n.mdi-spotify::before {\r\n  content: \"\\F04C7\";\r\n}\r\n\r\n.mdi-spotlight::before {\r\n  content: \"\\F04C8\";\r\n}\r\n\r\n.mdi-spotlight-beam::before {\r\n  content: \"\\F04C9\";\r\n}\r\n\r\n.mdi-spray::before {\r\n  content: \"\\F0665\";\r\n}\r\n\r\n.mdi-spray-bottle::before {\r\n  content: \"\\F0AE0\";\r\n}\r\n\r\n.mdi-sprinkler::before {\r\n  content: \"\\F105F\";\r\n}\r\n\r\n.mdi-sprinkler-variant::before {\r\n  content: \"\\F1060\";\r\n}\r\n\r\n.mdi-sprout::before {\r\n  content: \"\\F0E66\";\r\n}\r\n\r\n.mdi-sprout-outline::before {\r\n  content: \"\\F0E67\";\r\n}\r\n\r\n.mdi-square::before {\r\n  content: \"\\F0764\";\r\n}\r\n\r\n.mdi-square-circle::before {\r\n  content: \"\\F1500\";\r\n}\r\n\r\n.mdi-square-edit-outline::before {\r\n  content: \"\\F090C\";\r\n}\r\n\r\n.mdi-square-medium::before {\r\n  content: \"\\F0A13\";\r\n}\r\n\r\n.mdi-square-medium-outline::before {\r\n  content: \"\\F0A14\";\r\n}\r\n\r\n.mdi-square-off::before {\r\n  content: \"\\F12EE\";\r\n}\r\n\r\n.mdi-square-off-outline::before {\r\n  content: \"\\F12EF\";\r\n}\r\n\r\n.mdi-square-outline::before {\r\n  content: \"\\F0763\";\r\n}\r\n\r\n.mdi-square-root::before {\r\n  content: \"\\F0784\";\r\n}\r\n\r\n.mdi-square-root-box::before {\r\n  content: \"\\F09A3\";\r\n}\r\n\r\n.mdi-square-rounded::before {\r\n  content: \"\\F14FB\";\r\n}\r\n\r\n.mdi-square-rounded-outline::before {\r\n  content: \"\\F14FC\";\r\n}\r\n\r\n.mdi-square-small::before {\r\n  content: \"\\F0A15\";\r\n}\r\n\r\n.mdi-square-wave::before {\r\n  content: \"\\F147B\";\r\n}\r\n\r\n.mdi-squeegee::before {\r\n  content: \"\\F0AE1\";\r\n}\r\n\r\n.mdi-ssh::before {\r\n  content: \"\\F08C0\";\r\n}\r\n\r\n.mdi-stack-exchange::before {\r\n  content: \"\\F060B\";\r\n}\r\n\r\n.mdi-stack-overflow::before {\r\n  content: \"\\F04CC\";\r\n}\r\n\r\n.mdi-stackpath::before {\r\n  content: \"\\F0359\";\r\n}\r\n\r\n.mdi-stadium::before {\r\n  content: \"\\F0FF9\";\r\n}\r\n\r\n.mdi-stadium-variant::before {\r\n  content: \"\\F0720\";\r\n}\r\n\r\n.mdi-stairs::before {\r\n  content: \"\\F04CD\";\r\n}\r\n\r\n.mdi-stairs-box::before {\r\n  content: \"\\F139E\";\r\n}\r\n\r\n.mdi-stairs-down::before {\r\n  content: \"\\F12BE\";\r\n}\r\n\r\n.mdi-stairs-up::before {\r\n  content: \"\\F12BD\";\r\n}\r\n\r\n.mdi-stamper::before {\r\n  content: \"\\F0D39\";\r\n}\r\n\r\n.mdi-standard-definition::before {\r\n  content: \"\\F07EF\";\r\n}\r\n\r\n.mdi-star::before {\r\n  content: \"\\F04CE\";\r\n}\r\n\r\n.mdi-star-box::before {\r\n  content: \"\\F0A73\";\r\n}\r\n\r\n.mdi-star-box-multiple::before {\r\n  content: \"\\F1286\";\r\n}\r\n\r\n.mdi-star-box-multiple-outline::before {\r\n  content: \"\\F1287\";\r\n}\r\n\r\n.mdi-star-box-outline::before {\r\n  content: \"\\F0A74\";\r\n}\r\n\r\n.mdi-star-check::before {\r\n  content: \"\\F1566\";\r\n}\r\n\r\n.mdi-star-check-outline::before {\r\n  content: \"\\F156A\";\r\n}\r\n\r\n.mdi-star-circle::before {\r\n  content: \"\\F04CF\";\r\n}\r\n\r\n.mdi-star-circle-outline::before {\r\n  content: \"\\F09A4\";\r\n}\r\n\r\n.mdi-star-cog::before {\r\n  content: \"\\F1668\";\r\n}\r\n\r\n.mdi-star-cog-outline::before {\r\n  content: \"\\F1669\";\r\n}\r\n\r\n.mdi-star-face::before {\r\n  content: \"\\F09A5\";\r\n}\r\n\r\n.mdi-star-four-points::before {\r\n  content: \"\\F0AE2\";\r\n}\r\n\r\n.mdi-star-four-points-outline::before {\r\n  content: \"\\F0AE3\";\r\n}\r\n\r\n.mdi-star-half::before {\r\n  content: \"\\F0246\";\r\n}\r\n\r\n.mdi-star-half-full::before {\r\n  content: \"\\F04D0\";\r\n}\r\n\r\n.mdi-star-minus::before {\r\n  content: \"\\F1564\";\r\n}\r\n\r\n.mdi-star-minus-outline::before {\r\n  content: \"\\F1568\";\r\n}\r\n\r\n.mdi-star-off::before {\r\n  content: \"\\F04D1\";\r\n}\r\n\r\n.mdi-star-off-outline::before {\r\n  content: \"\\F155B\";\r\n}\r\n\r\n.mdi-star-outline::before {\r\n  content: \"\\F04D2\";\r\n}\r\n\r\n.mdi-star-plus::before {\r\n  content: \"\\F1563\";\r\n}\r\n\r\n.mdi-star-plus-outline::before {\r\n  content: \"\\F1567\";\r\n}\r\n\r\n.mdi-star-remove::before {\r\n  content: \"\\F1565\";\r\n}\r\n\r\n.mdi-star-remove-outline::before {\r\n  content: \"\\F1569\";\r\n}\r\n\r\n.mdi-star-settings::before {\r\n  content: \"\\F166A\";\r\n}\r\n\r\n.mdi-star-settings-outline::before {\r\n  content: \"\\F166B\";\r\n}\r\n\r\n.mdi-star-three-points::before {\r\n  content: \"\\F0AE4\";\r\n}\r\n\r\n.mdi-star-three-points-outline::before {\r\n  content: \"\\F0AE5\";\r\n}\r\n\r\n.mdi-state-machine::before {\r\n  content: \"\\F11EF\";\r\n}\r\n\r\n.mdi-steam::before {\r\n  content: \"\\F04D3\";\r\n}\r\n\r\n.mdi-steering::before {\r\n  content: \"\\F04D4\";\r\n}\r\n\r\n.mdi-steering-off::before {\r\n  content: \"\\F090E\";\r\n}\r\n\r\n.mdi-step-backward::before {\r\n  content: \"\\F04D5\";\r\n}\r\n\r\n.mdi-step-backward-2::before {\r\n  content: \"\\F04D6\";\r\n}\r\n\r\n.mdi-step-forward::before {\r\n  content: \"\\F04D7\";\r\n}\r\n\r\n.mdi-step-forward-2::before {\r\n  content: \"\\F04D8\";\r\n}\r\n\r\n.mdi-stethoscope::before {\r\n  content: \"\\F04D9\";\r\n}\r\n\r\n.mdi-sticker::before {\r\n  content: \"\\F1364\";\r\n}\r\n\r\n.mdi-sticker-alert::before {\r\n  content: \"\\F1365\";\r\n}\r\n\r\n.mdi-sticker-alert-outline::before {\r\n  content: \"\\F1366\";\r\n}\r\n\r\n.mdi-sticker-check::before {\r\n  content: \"\\F1367\";\r\n}\r\n\r\n.mdi-sticker-check-outline::before {\r\n  content: \"\\F1368\";\r\n}\r\n\r\n.mdi-sticker-circle-outline::before {\r\n  content: \"\\F05D0\";\r\n}\r\n\r\n.mdi-sticker-emoji::before {\r\n  content: \"\\F0785\";\r\n}\r\n\r\n.mdi-sticker-minus::before {\r\n  content: \"\\F1369\";\r\n}\r\n\r\n.mdi-sticker-minus-outline::before {\r\n  content: \"\\F136A\";\r\n}\r\n\r\n.mdi-sticker-outline::before {\r\n  content: \"\\F136B\";\r\n}\r\n\r\n.mdi-sticker-plus::before {\r\n  content: \"\\F136C\";\r\n}\r\n\r\n.mdi-sticker-plus-outline::before {\r\n  content: \"\\F136D\";\r\n}\r\n\r\n.mdi-sticker-remove::before {\r\n  content: \"\\F136E\";\r\n}\r\n\r\n.mdi-sticker-remove-outline::before {\r\n  content: \"\\F136F\";\r\n}\r\n\r\n.mdi-stocking::before {\r\n  content: \"\\F04DA\";\r\n}\r\n\r\n.mdi-stomach::before {\r\n  content: \"\\F1093\";\r\n}\r\n\r\n.mdi-stop::before {\r\n  content: \"\\F04DB\";\r\n}\r\n\r\n.mdi-stop-circle::before {\r\n  content: \"\\F0666\";\r\n}\r\n\r\n.mdi-stop-circle-outline::before {\r\n  content: \"\\F0667\";\r\n}\r\n\r\n.mdi-store::before {\r\n  content: \"\\F04DC\";\r\n}\r\n\r\n.mdi-store-24-hour::before {\r\n  content: \"\\F04DD\";\r\n}\r\n\r\n.mdi-store-minus::before {\r\n  content: \"\\F165E\";\r\n}\r\n\r\n.mdi-store-outline::before {\r\n  content: \"\\F1361\";\r\n}\r\n\r\n.mdi-store-plus::before {\r\n  content: \"\\F165F\";\r\n}\r\n\r\n.mdi-store-remove::before {\r\n  content: \"\\F1660\";\r\n}\r\n\r\n.mdi-storefront::before {\r\n  content: \"\\F07C7\";\r\n}\r\n\r\n.mdi-storefront-outline::before {\r\n  content: \"\\F10C1\";\r\n}\r\n\r\n.mdi-stove::before {\r\n  content: \"\\F04DE\";\r\n}\r\n\r\n.mdi-strategy::before {\r\n  content: \"\\F11D6\";\r\n}\r\n\r\n.mdi-stretch-to-page::before {\r\n  content: \"\\F0F2B\";\r\n}\r\n\r\n.mdi-stretch-to-page-outline::before {\r\n  content: \"\\F0F2C\";\r\n}\r\n\r\n.mdi-string-lights::before {\r\n  content: \"\\F12BA\";\r\n}\r\n\r\n.mdi-string-lights-off::before {\r\n  content: \"\\F12BB\";\r\n}\r\n\r\n.mdi-subdirectory-arrow-left::before {\r\n  content: \"\\F060C\";\r\n}\r\n\r\n.mdi-subdirectory-arrow-right::before {\r\n  content: \"\\F060D\";\r\n}\r\n\r\n.mdi-submarine::before {\r\n  content: \"\\F156C\";\r\n}\r\n\r\n.mdi-subtitles::before {\r\n  content: \"\\F0A16\";\r\n}\r\n\r\n.mdi-subtitles-outline::before {\r\n  content: \"\\F0A17\";\r\n}\r\n\r\n.mdi-subway::before {\r\n  content: \"\\F06AC\";\r\n}\r\n\r\n.mdi-subway-alert-variant::before {\r\n  content: \"\\F0D9D\";\r\n}\r\n\r\n.mdi-subway-variant::before {\r\n  content: \"\\F04DF\";\r\n}\r\n\r\n.mdi-summit::before {\r\n  content: \"\\F0786\";\r\n}\r\n\r\n.mdi-sunglasses::before {\r\n  content: \"\\F04E0\";\r\n}\r\n\r\n.mdi-surround-sound::before {\r\n  content: \"\\F05C5\";\r\n}\r\n\r\n.mdi-surround-sound-2-0::before {\r\n  content: \"\\F07F0\";\r\n}\r\n\r\n.mdi-surround-sound-3-1::before {\r\n  content: \"\\F07F1\";\r\n}\r\n\r\n.mdi-surround-sound-5-1::before {\r\n  content: \"\\F07F2\";\r\n}\r\n\r\n.mdi-surround-sound-7-1::before {\r\n  content: \"\\F07F3\";\r\n}\r\n\r\n.mdi-svg::before {\r\n  content: \"\\F0721\";\r\n}\r\n\r\n.mdi-swap-horizontal::before {\r\n  content: \"\\F04E1\";\r\n}\r\n\r\n.mdi-swap-horizontal-bold::before {\r\n  content: \"\\F0BCD\";\r\n}\r\n\r\n.mdi-swap-horizontal-circle::before {\r\n  content: \"\\F0FE1\";\r\n}\r\n\r\n.mdi-swap-horizontal-circle-outline::before {\r\n  content: \"\\F0FE2\";\r\n}\r\n\r\n.mdi-swap-horizontal-variant::before {\r\n  content: \"\\F08C1\";\r\n}\r\n\r\n.mdi-swap-vertical::before {\r\n  content: \"\\F04E2\";\r\n}\r\n\r\n.mdi-swap-vertical-bold::before {\r\n  content: \"\\F0BCE\";\r\n}\r\n\r\n.mdi-swap-vertical-circle::before {\r\n  content: \"\\F0FE3\";\r\n}\r\n\r\n.mdi-swap-vertical-circle-outline::before {\r\n  content: \"\\F0FE4\";\r\n}\r\n\r\n.mdi-swap-vertical-variant::before {\r\n  content: \"\\F08C2\";\r\n}\r\n\r\n.mdi-swim::before {\r\n  content: \"\\F04E3\";\r\n}\r\n\r\n.mdi-switch::before {\r\n  content: \"\\F04E4\";\r\n}\r\n\r\n.mdi-sword::before {\r\n  content: \"\\F04E5\";\r\n}\r\n\r\n.mdi-sword-cross::before {\r\n  content: \"\\F0787\";\r\n}\r\n\r\n.mdi-syllabary-hangul::before {\r\n  content: \"\\F1333\";\r\n}\r\n\r\n.mdi-syllabary-hiragana::before {\r\n  content: \"\\F1334\";\r\n}\r\n\r\n.mdi-syllabary-katakana::before {\r\n  content: \"\\F1335\";\r\n}\r\n\r\n.mdi-syllabary-katakana-halfwidth::before {\r\n  content: \"\\F1336\";\r\n}\r\n\r\n.mdi-symbol::before {\r\n  content: \"\\F1501\";\r\n}\r\n\r\n.mdi-symfony::before {\r\n  content: \"\\F0AE6\";\r\n}\r\n\r\n.mdi-sync::before {\r\n  content: \"\\F04E6\";\r\n}\r\n\r\n.mdi-sync-alert::before {\r\n  content: \"\\F04E7\";\r\n}\r\n\r\n.mdi-sync-circle::before {\r\n  content: \"\\F1378\";\r\n}\r\n\r\n.mdi-sync-off::before {\r\n  content: \"\\F04E8\";\r\n}\r\n\r\n.mdi-tab::before {\r\n  content: \"\\F04E9\";\r\n}\r\n\r\n.mdi-tab-minus::before {\r\n  content: \"\\F0B4B\";\r\n}\r\n\r\n.mdi-tab-plus::before {\r\n  content: \"\\F075C\";\r\n}\r\n\r\n.mdi-tab-remove::before {\r\n  content: \"\\F0B4C\";\r\n}\r\n\r\n.mdi-tab-unselected::before {\r\n  content: \"\\F04EA\";\r\n}\r\n\r\n.mdi-table::before {\r\n  content: \"\\F04EB\";\r\n}\r\n\r\n.mdi-table-account::before {\r\n  content: \"\\F13B9\";\r\n}\r\n\r\n.mdi-table-alert::before {\r\n  content: \"\\F13BA\";\r\n}\r\n\r\n.mdi-table-arrow-down::before {\r\n  content: \"\\F13BB\";\r\n}\r\n\r\n.mdi-table-arrow-left::before {\r\n  content: \"\\F13BC\";\r\n}\r\n\r\n.mdi-table-arrow-right::before {\r\n  content: \"\\F13BD\";\r\n}\r\n\r\n.mdi-table-arrow-up::before {\r\n  content: \"\\F13BE\";\r\n}\r\n\r\n.mdi-table-border::before {\r\n  content: \"\\F0A18\";\r\n}\r\n\r\n.mdi-table-cancel::before {\r\n  content: \"\\F13BF\";\r\n}\r\n\r\n.mdi-table-chair::before {\r\n  content: \"\\F1061\";\r\n}\r\n\r\n.mdi-table-check::before {\r\n  content: \"\\F13C0\";\r\n}\r\n\r\n.mdi-table-clock::before {\r\n  content: \"\\F13C1\";\r\n}\r\n\r\n.mdi-table-cog::before {\r\n  content: \"\\F13C2\";\r\n}\r\n\r\n.mdi-table-column::before {\r\n  content: \"\\F0835\";\r\n}\r\n\r\n.mdi-table-column-plus-after::before {\r\n  content: \"\\F04EC\";\r\n}\r\n\r\n.mdi-table-column-plus-before::before {\r\n  content: \"\\F04ED\";\r\n}\r\n\r\n.mdi-table-column-remove::before {\r\n  content: \"\\F04EE\";\r\n}\r\n\r\n.mdi-table-column-width::before {\r\n  content: \"\\F04EF\";\r\n}\r\n\r\n.mdi-table-edit::before {\r\n  content: \"\\F04F0\";\r\n}\r\n\r\n.mdi-table-eye::before {\r\n  content: \"\\F1094\";\r\n}\r\n\r\n.mdi-table-eye-off::before {\r\n  content: \"\\F13C3\";\r\n}\r\n\r\n.mdi-table-furniture::before {\r\n  content: \"\\F05BC\";\r\n}\r\n\r\n.mdi-table-headers-eye::before {\r\n  content: \"\\F121D\";\r\n}\r\n\r\n.mdi-table-headers-eye-off::before {\r\n  content: \"\\F121E\";\r\n}\r\n\r\n.mdi-table-heart::before {\r\n  content: \"\\F13C4\";\r\n}\r\n\r\n.mdi-table-key::before {\r\n  content: \"\\F13C5\";\r\n}\r\n\r\n.mdi-table-large::before {\r\n  content: \"\\F04F1\";\r\n}\r\n\r\n.mdi-table-large-plus::before {\r\n  content: \"\\F0F87\";\r\n}\r\n\r\n.mdi-table-large-remove::before {\r\n  content: \"\\F0F88\";\r\n}\r\n\r\n.mdi-table-lock::before {\r\n  content: \"\\F13C6\";\r\n}\r\n\r\n.mdi-table-merge-cells::before {\r\n  content: \"\\F09A6\";\r\n}\r\n\r\n.mdi-table-minus::before {\r\n  content: \"\\F13C7\";\r\n}\r\n\r\n.mdi-table-multiple::before {\r\n  content: \"\\F13C8\";\r\n}\r\n\r\n.mdi-table-network::before {\r\n  content: \"\\F13C9\";\r\n}\r\n\r\n.mdi-table-of-contents::before {\r\n  content: \"\\F0836\";\r\n}\r\n\r\n.mdi-table-off::before {\r\n  content: \"\\F13CA\";\r\n}\r\n\r\n.mdi-table-plus::before {\r\n  content: \"\\F0A75\";\r\n}\r\n\r\n.mdi-table-refresh::before {\r\n  content: \"\\F13A0\";\r\n}\r\n\r\n.mdi-table-remove::before {\r\n  content: \"\\F0A76\";\r\n}\r\n\r\n.mdi-table-row::before {\r\n  content: \"\\F0837\";\r\n}\r\n\r\n.mdi-table-row-height::before {\r\n  content: \"\\F04F2\";\r\n}\r\n\r\n.mdi-table-row-plus-after::before {\r\n  content: \"\\F04F3\";\r\n}\r\n\r\n.mdi-table-row-plus-before::before {\r\n  content: \"\\F04F4\";\r\n}\r\n\r\n.mdi-table-row-remove::before {\r\n  content: \"\\F04F5\";\r\n}\r\n\r\n.mdi-table-search::before {\r\n  content: \"\\F090F\";\r\n}\r\n\r\n.mdi-table-settings::before {\r\n  content: \"\\F0838\";\r\n}\r\n\r\n.mdi-table-split-cell::before {\r\n  content: \"\\F142A\";\r\n}\r\n\r\n.mdi-table-star::before {\r\n  content: \"\\F13CB\";\r\n}\r\n\r\n.mdi-table-sync::before {\r\n  content: \"\\F13A1\";\r\n}\r\n\r\n.mdi-table-tennis::before {\r\n  content: \"\\F0E68\";\r\n}\r\n\r\n.mdi-tablet::before {\r\n  content: \"\\F04F6\";\r\n}\r\n\r\n.mdi-tablet-android::before {\r\n  content: \"\\F04F7\";\r\n}\r\n\r\n.mdi-tablet-cellphone::before {\r\n  content: \"\\F09A7\";\r\n}\r\n\r\n.mdi-tablet-dashboard::before {\r\n  content: \"\\F0ECE\";\r\n}\r\n\r\n.mdi-tablet-ipad::before {\r\n  content: \"\\F04F8\";\r\n}\r\n\r\n.mdi-taco::before {\r\n  content: \"\\F0762\";\r\n}\r\n\r\n.mdi-tag::before {\r\n  content: \"\\F04F9\";\r\n}\r\n\r\n.mdi-tag-faces::before {\r\n  content: \"\\F04FA\";\r\n}\r\n\r\n.mdi-tag-heart::before {\r\n  content: \"\\F068B\";\r\n}\r\n\r\n.mdi-tag-heart-outline::before {\r\n  content: \"\\F0BCF\";\r\n}\r\n\r\n.mdi-tag-minus::before {\r\n  content: \"\\F0910\";\r\n}\r\n\r\n.mdi-tag-minus-outline::before {\r\n  content: \"\\F121F\";\r\n}\r\n\r\n.mdi-tag-multiple::before {\r\n  content: \"\\F04FB\";\r\n}\r\n\r\n.mdi-tag-multiple-outline::before {\r\n  content: \"\\F12F7\";\r\n}\r\n\r\n.mdi-tag-off::before {\r\n  content: \"\\F1220\";\r\n}\r\n\r\n.mdi-tag-off-outline::before {\r\n  content: \"\\F1221\";\r\n}\r\n\r\n.mdi-tag-outline::before {\r\n  content: \"\\F04FC\";\r\n}\r\n\r\n.mdi-tag-plus::before {\r\n  content: \"\\F0722\";\r\n}\r\n\r\n.mdi-tag-plus-outline::before {\r\n  content: \"\\F1222\";\r\n}\r\n\r\n.mdi-tag-remove::before {\r\n  content: \"\\F0723\";\r\n}\r\n\r\n.mdi-tag-remove-outline::before {\r\n  content: \"\\F1223\";\r\n}\r\n\r\n.mdi-tag-text::before {\r\n  content: \"\\F1224\";\r\n}\r\n\r\n.mdi-tag-text-outline::before {\r\n  content: \"\\F04FD\";\r\n}\r\n\r\n.mdi-tailwind::before {\r\n  content: \"\\F13FF\";\r\n}\r\n\r\n.mdi-tank::before {\r\n  content: \"\\F0D3A\";\r\n}\r\n\r\n.mdi-tanker-truck::before {\r\n  content: \"\\F0FE5\";\r\n}\r\n\r\n.mdi-tape-drive::before {\r\n  content: \"\\F16DF\";\r\n}\r\n\r\n.mdi-tape-measure::before {\r\n  content: \"\\F0B4D\";\r\n}\r\n\r\n.mdi-target::before {\r\n  content: \"\\F04FE\";\r\n}\r\n\r\n.mdi-target-account::before {\r\n  content: \"\\F0BD0\";\r\n}\r\n\r\n.mdi-target-variant::before {\r\n  content: \"\\F0A77\";\r\n}\r\n\r\n.mdi-taxi::before {\r\n  content: \"\\F04FF\";\r\n}\r\n\r\n.mdi-tea::before {\r\n  content: \"\\F0D9E\";\r\n}\r\n\r\n.mdi-tea-outline::before {\r\n  content: \"\\F0D9F\";\r\n}\r\n\r\n.mdi-teach::before {\r\n  content: \"\\F0890\";\r\n}\r\n\r\n.mdi-teamviewer::before {\r\n  content: \"\\F0500\";\r\n}\r\n\r\n.mdi-telegram::before {\r\n  content: \"\\F0501\";\r\n}\r\n\r\n.mdi-telescope::before {\r\n  content: \"\\F0B4E\";\r\n}\r\n\r\n.mdi-television::before {\r\n  content: \"\\F0502\";\r\n}\r\n\r\n.mdi-television-ambient-light::before {\r\n  content: \"\\F1356\";\r\n}\r\n\r\n.mdi-television-box::before {\r\n  content: \"\\F0839\";\r\n}\r\n\r\n.mdi-television-classic::before {\r\n  content: \"\\F07F4\";\r\n}\r\n\r\n.mdi-television-classic-off::before {\r\n  content: \"\\F083A\";\r\n}\r\n\r\n.mdi-television-clean::before {\r\n  content: \"\\F1110\";\r\n}\r\n\r\n.mdi-television-guide::before {\r\n  content: \"\\F0503\";\r\n}\r\n\r\n.mdi-television-off::before {\r\n  content: \"\\F083B\";\r\n}\r\n\r\n.mdi-television-pause::before {\r\n  content: \"\\F0F89\";\r\n}\r\n\r\n.mdi-television-play::before {\r\n  content: \"\\F0ECF\";\r\n}\r\n\r\n.mdi-television-stop::before {\r\n  content: \"\\F0F8A\";\r\n}\r\n\r\n.mdi-temperature-celsius::before {\r\n  content: \"\\F0504\";\r\n}\r\n\r\n.mdi-temperature-fahrenheit::before {\r\n  content: \"\\F0505\";\r\n}\r\n\r\n.mdi-temperature-kelvin::before {\r\n  content: \"\\F0506\";\r\n}\r\n\r\n.mdi-tennis::before {\r\n  content: \"\\F0DA0\";\r\n}\r\n\r\n.mdi-tennis-ball::before {\r\n  content: \"\\F0507\";\r\n}\r\n\r\n.mdi-tent::before {\r\n  content: \"\\F0508\";\r\n}\r\n\r\n.mdi-terraform::before {\r\n  content: \"\\F1062\";\r\n}\r\n\r\n.mdi-terrain::before {\r\n  content: \"\\F0509\";\r\n}\r\n\r\n.mdi-test-tube::before {\r\n  content: \"\\F0668\";\r\n}\r\n\r\n.mdi-test-tube-empty::before {\r\n  content: \"\\F0911\";\r\n}\r\n\r\n.mdi-test-tube-off::before {\r\n  content: \"\\F0912\";\r\n}\r\n\r\n.mdi-text::before {\r\n  content: \"\\F09A8\";\r\n}\r\n\r\n.mdi-text-account::before {\r\n  content: \"\\F1570\";\r\n}\r\n\r\n.mdi-text-box::before {\r\n  content: \"\\F021A\";\r\n}\r\n\r\n.mdi-text-box-check::before {\r\n  content: \"\\F0EA6\";\r\n}\r\n\r\n.mdi-text-box-check-outline::before {\r\n  content: \"\\F0EA7\";\r\n}\r\n\r\n.mdi-text-box-minus::before {\r\n  content: \"\\F0EA8\";\r\n}\r\n\r\n.mdi-text-box-minus-outline::before {\r\n  content: \"\\F0EA9\";\r\n}\r\n\r\n.mdi-text-box-multiple::before {\r\n  content: \"\\F0AB7\";\r\n}\r\n\r\n.mdi-text-box-multiple-outline::before {\r\n  content: \"\\F0AB8\";\r\n}\r\n\r\n.mdi-text-box-outline::before {\r\n  content: \"\\F09ED\";\r\n}\r\n\r\n.mdi-text-box-plus::before {\r\n  content: \"\\F0EAA\";\r\n}\r\n\r\n.mdi-text-box-plus-outline::before {\r\n  content: \"\\F0EAB\";\r\n}\r\n\r\n.mdi-text-box-remove::before {\r\n  content: \"\\F0EAC\";\r\n}\r\n\r\n.mdi-text-box-remove-outline::before {\r\n  content: \"\\F0EAD\";\r\n}\r\n\r\n.mdi-text-box-search::before {\r\n  content: \"\\F0EAE\";\r\n}\r\n\r\n.mdi-text-box-search-outline::before {\r\n  content: \"\\F0EAF\";\r\n}\r\n\r\n.mdi-text-recognition::before {\r\n  content: \"\\F113D\";\r\n}\r\n\r\n.mdi-text-search::before {\r\n  content: \"\\F13B8\";\r\n}\r\n\r\n.mdi-text-shadow::before {\r\n  content: \"\\F0669\";\r\n}\r\n\r\n.mdi-text-short::before {\r\n  content: \"\\F09A9\";\r\n}\r\n\r\n.mdi-text-subject::before {\r\n  content: \"\\F09AA\";\r\n}\r\n\r\n.mdi-text-to-speech::before {\r\n  content: \"\\F050A\";\r\n}\r\n\r\n.mdi-text-to-speech-off::before {\r\n  content: \"\\F050B\";\r\n}\r\n\r\n.mdi-texture::before {\r\n  content: \"\\F050C\";\r\n}\r\n\r\n.mdi-texture-box::before {\r\n  content: \"\\F0FE6\";\r\n}\r\n\r\n.mdi-theater::before {\r\n  content: \"\\F050D\";\r\n}\r\n\r\n.mdi-theme-light-dark::before {\r\n  content: \"\\F050E\";\r\n}\r\n\r\n.mdi-thermometer::before {\r\n  content: \"\\F050F\";\r\n}\r\n\r\n.mdi-thermometer-alert::before {\r\n  content: \"\\F0E01\";\r\n}\r\n\r\n.mdi-thermometer-chevron-down::before {\r\n  content: \"\\F0E02\";\r\n}\r\n\r\n.mdi-thermometer-chevron-up::before {\r\n  content: \"\\F0E03\";\r\n}\r\n\r\n.mdi-thermometer-high::before {\r\n  content: \"\\F10C2\";\r\n}\r\n\r\n.mdi-thermometer-lines::before {\r\n  content: \"\\F0510\";\r\n}\r\n\r\n.mdi-thermometer-low::before {\r\n  content: \"\\F10C3\";\r\n}\r\n\r\n.mdi-thermometer-minus::before {\r\n  content: \"\\F0E04\";\r\n}\r\n\r\n.mdi-thermometer-off::before {\r\n  content: \"\\F1531\";\r\n}\r\n\r\n.mdi-thermometer-plus::before {\r\n  content: \"\\F0E05\";\r\n}\r\n\r\n.mdi-thermostat::before {\r\n  content: \"\\F0393\";\r\n}\r\n\r\n.mdi-thermostat-box::before {\r\n  content: \"\\F0891\";\r\n}\r\n\r\n.mdi-thought-bubble::before {\r\n  content: \"\\F07F6\";\r\n}\r\n\r\n.mdi-thought-bubble-outline::before {\r\n  content: \"\\F07F7\";\r\n}\r\n\r\n.mdi-thumb-down::before {\r\n  content: \"\\F0511\";\r\n}\r\n\r\n.mdi-thumb-down-outline::before {\r\n  content: \"\\F0512\";\r\n}\r\n\r\n.mdi-thumb-up::before {\r\n  content: \"\\F0513\";\r\n}\r\n\r\n.mdi-thumb-up-outline::before {\r\n  content: \"\\F0514\";\r\n}\r\n\r\n.mdi-thumbs-up-down::before {\r\n  content: \"\\F0515\";\r\n}\r\n\r\n.mdi-ticket::before {\r\n  content: \"\\F0516\";\r\n}\r\n\r\n.mdi-ticket-account::before {\r\n  content: \"\\F0517\";\r\n}\r\n\r\n.mdi-ticket-confirmation::before {\r\n  content: \"\\F0518\";\r\n}\r\n\r\n.mdi-ticket-confirmation-outline::before {\r\n  content: \"\\F13AA\";\r\n}\r\n\r\n.mdi-ticket-outline::before {\r\n  content: \"\\F0913\";\r\n}\r\n\r\n.mdi-ticket-percent::before {\r\n  content: \"\\F0724\";\r\n}\r\n\r\n.mdi-ticket-percent-outline::before {\r\n  content: \"\\F142B\";\r\n}\r\n\r\n.mdi-tie::before {\r\n  content: \"\\F0519\";\r\n}\r\n\r\n.mdi-tilde::before {\r\n  content: \"\\F0725\";\r\n}\r\n\r\n.mdi-timelapse::before {\r\n  content: \"\\F051A\";\r\n}\r\n\r\n.mdi-timeline::before {\r\n  content: \"\\F0BD1\";\r\n}\r\n\r\n.mdi-timeline-alert::before {\r\n  content: \"\\F0F95\";\r\n}\r\n\r\n.mdi-timeline-alert-outline::before {\r\n  content: \"\\F0F98\";\r\n}\r\n\r\n.mdi-timeline-check::before {\r\n  content: \"\\F1532\";\r\n}\r\n\r\n.mdi-timeline-check-outline::before {\r\n  content: \"\\F1533\";\r\n}\r\n\r\n.mdi-timeline-clock::before {\r\n  content: \"\\F11FB\";\r\n}\r\n\r\n.mdi-timeline-clock-outline::before {\r\n  content: \"\\F11FC\";\r\n}\r\n\r\n.mdi-timeline-help::before {\r\n  content: \"\\F0F99\";\r\n}\r\n\r\n.mdi-timeline-help-outline::before {\r\n  content: \"\\F0F9A\";\r\n}\r\n\r\n.mdi-timeline-minus::before {\r\n  content: \"\\F1534\";\r\n}\r\n\r\n.mdi-timeline-minus-outline::before {\r\n  content: \"\\F1535\";\r\n}\r\n\r\n.mdi-timeline-outline::before {\r\n  content: \"\\F0BD2\";\r\n}\r\n\r\n.mdi-timeline-plus::before {\r\n  content: \"\\F0F96\";\r\n}\r\n\r\n.mdi-timeline-plus-outline::before {\r\n  content: \"\\F0F97\";\r\n}\r\n\r\n.mdi-timeline-remove::before {\r\n  content: \"\\F1536\";\r\n}\r\n\r\n.mdi-timeline-remove-outline::before {\r\n  content: \"\\F1537\";\r\n}\r\n\r\n.mdi-timeline-text::before {\r\n  content: \"\\F0BD3\";\r\n}\r\n\r\n.mdi-timeline-text-outline::before {\r\n  content: \"\\F0BD4\";\r\n}\r\n\r\n.mdi-timer::before {\r\n  content: \"\\F13AB\";\r\n}\r\n\r\n.mdi-timer-10::before {\r\n  content: \"\\F051C\";\r\n}\r\n\r\n.mdi-timer-3::before {\r\n  content: \"\\F051D\";\r\n}\r\n\r\n.mdi-timer-off::before {\r\n  content: \"\\F13AC\";\r\n}\r\n\r\n.mdi-timer-off-outline::before {\r\n  content: \"\\F051E\";\r\n}\r\n\r\n.mdi-timer-outline::before {\r\n  content: \"\\F051B\";\r\n}\r\n\r\n.mdi-timer-sand::before {\r\n  content: \"\\F051F\";\r\n}\r\n\r\n.mdi-timer-sand-empty::before {\r\n  content: \"\\F06AD\";\r\n}\r\n\r\n.mdi-timer-sand-full::before {\r\n  content: \"\\F078C\";\r\n}\r\n\r\n.mdi-timetable::before {\r\n  content: \"\\F0520\";\r\n}\r\n\r\n.mdi-toaster::before {\r\n  content: \"\\F1063\";\r\n}\r\n\r\n.mdi-toaster-off::before {\r\n  content: \"\\F11B7\";\r\n}\r\n\r\n.mdi-toaster-oven::before {\r\n  content: \"\\F0CD3\";\r\n}\r\n\r\n.mdi-toggle-switch::before {\r\n  content: \"\\F0521\";\r\n}\r\n\r\n.mdi-toggle-switch-off::before {\r\n  content: \"\\F0522\";\r\n}\r\n\r\n.mdi-toggle-switch-off-outline::before {\r\n  content: \"\\F0A19\";\r\n}\r\n\r\n.mdi-toggle-switch-outline::before {\r\n  content: \"\\F0A1A\";\r\n}\r\n\r\n.mdi-toilet::before {\r\n  content: \"\\F09AB\";\r\n}\r\n\r\n.mdi-toolbox::before {\r\n  content: \"\\F09AC\";\r\n}\r\n\r\n.mdi-toolbox-outline::before {\r\n  content: \"\\F09AD\";\r\n}\r\n\r\n.mdi-tools::before {\r\n  content: \"\\F1064\";\r\n}\r\n\r\n.mdi-tooltip::before {\r\n  content: \"\\F0523\";\r\n}\r\n\r\n.mdi-tooltip-account::before {\r\n  content: \"\\F000C\";\r\n}\r\n\r\n.mdi-tooltip-check::before {\r\n  content: \"\\F155C\";\r\n}\r\n\r\n.mdi-tooltip-check-outline::before {\r\n  content: \"\\F155D\";\r\n}\r\n\r\n.mdi-tooltip-edit::before {\r\n  content: \"\\F0524\";\r\n}\r\n\r\n.mdi-tooltip-edit-outline::before {\r\n  content: \"\\F12C5\";\r\n}\r\n\r\n.mdi-tooltip-image::before {\r\n  content: \"\\F0525\";\r\n}\r\n\r\n.mdi-tooltip-image-outline::before {\r\n  content: \"\\F0BD5\";\r\n}\r\n\r\n.mdi-tooltip-minus::before {\r\n  content: \"\\F155E\";\r\n}\r\n\r\n.mdi-tooltip-minus-outline::before {\r\n  content: \"\\F155F\";\r\n}\r\n\r\n.mdi-tooltip-outline::before {\r\n  content: \"\\F0526\";\r\n}\r\n\r\n.mdi-tooltip-plus::before {\r\n  content: \"\\F0BD6\";\r\n}\r\n\r\n.mdi-tooltip-plus-outline::before {\r\n  content: \"\\F0527\";\r\n}\r\n\r\n.mdi-tooltip-remove::before {\r\n  content: \"\\F1560\";\r\n}\r\n\r\n.mdi-tooltip-remove-outline::before {\r\n  content: \"\\F1561\";\r\n}\r\n\r\n.mdi-tooltip-text::before {\r\n  content: \"\\F0528\";\r\n}\r\n\r\n.mdi-tooltip-text-outline::before {\r\n  content: \"\\F0BD7\";\r\n}\r\n\r\n.mdi-tooth::before {\r\n  content: \"\\F08C3\";\r\n}\r\n\r\n.mdi-tooth-outline::before {\r\n  content: \"\\F0529\";\r\n}\r\n\r\n.mdi-toothbrush::before {\r\n  content: \"\\F1129\";\r\n}\r\n\r\n.mdi-toothbrush-electric::before {\r\n  content: \"\\F112C\";\r\n}\r\n\r\n.mdi-toothbrush-paste::before {\r\n  content: \"\\F112A\";\r\n}\r\n\r\n.mdi-torch::before {\r\n  content: \"\\F1606\";\r\n}\r\n\r\n.mdi-tortoise::before {\r\n  content: \"\\F0D3B\";\r\n}\r\n\r\n.mdi-toslink::before {\r\n  content: \"\\F12B8\";\r\n}\r\n\r\n.mdi-tournament::before {\r\n  content: \"\\F09AE\";\r\n}\r\n\r\n.mdi-tow-truck::before {\r\n  content: \"\\F083C\";\r\n}\r\n\r\n.mdi-tower-beach::before {\r\n  content: \"\\F0681\";\r\n}\r\n\r\n.mdi-tower-fire::before {\r\n  content: \"\\F0682\";\r\n}\r\n\r\n.mdi-toy-brick::before {\r\n  content: \"\\F1288\";\r\n}\r\n\r\n.mdi-toy-brick-marker::before {\r\n  content: \"\\F1289\";\r\n}\r\n\r\n.mdi-toy-brick-marker-outline::before {\r\n  content: \"\\F128A\";\r\n}\r\n\r\n.mdi-toy-brick-minus::before {\r\n  content: \"\\F128B\";\r\n}\r\n\r\n.mdi-toy-brick-minus-outline::before {\r\n  content: \"\\F128C\";\r\n}\r\n\r\n.mdi-toy-brick-outline::before {\r\n  content: \"\\F128D\";\r\n}\r\n\r\n.mdi-toy-brick-plus::before {\r\n  content: \"\\F128E\";\r\n}\r\n\r\n.mdi-toy-brick-plus-outline::before {\r\n  content: \"\\F128F\";\r\n}\r\n\r\n.mdi-toy-brick-remove::before {\r\n  content: \"\\F1290\";\r\n}\r\n\r\n.mdi-toy-brick-remove-outline::before {\r\n  content: \"\\F1291\";\r\n}\r\n\r\n.mdi-toy-brick-search::before {\r\n  content: \"\\F1292\";\r\n}\r\n\r\n.mdi-toy-brick-search-outline::before {\r\n  content: \"\\F1293\";\r\n}\r\n\r\n.mdi-track-light::before {\r\n  content: \"\\F0914\";\r\n}\r\n\r\n.mdi-trackpad::before {\r\n  content: \"\\F07F8\";\r\n}\r\n\r\n.mdi-trackpad-lock::before {\r\n  content: \"\\F0933\";\r\n}\r\n\r\n.mdi-tractor::before {\r\n  content: \"\\F0892\";\r\n}\r\n\r\n.mdi-tractor-variant::before {\r\n  content: \"\\F14C4\";\r\n}\r\n\r\n.mdi-trademark::before {\r\n  content: \"\\F0A78\";\r\n}\r\n\r\n.mdi-traffic-cone::before {\r\n  content: \"\\F137C\";\r\n}\r\n\r\n.mdi-traffic-light::before {\r\n  content: \"\\F052B\";\r\n}\r\n\r\n.mdi-train::before {\r\n  content: \"\\F052C\";\r\n}\r\n\r\n.mdi-train-car::before {\r\n  content: \"\\F0BD8\";\r\n}\r\n\r\n.mdi-train-variant::before {\r\n  content: \"\\F08C4\";\r\n}\r\n\r\n.mdi-tram::before {\r\n  content: \"\\F052D\";\r\n}\r\n\r\n.mdi-tram-side::before {\r\n  content: \"\\F0FE7\";\r\n}\r\n\r\n.mdi-transcribe::before {\r\n  content: \"\\F052E\";\r\n}\r\n\r\n.mdi-transcribe-close::before {\r\n  content: \"\\F052F\";\r\n}\r\n\r\n.mdi-transfer::before {\r\n  content: \"\\F1065\";\r\n}\r\n\r\n.mdi-transfer-down::before {\r\n  content: \"\\F0DA1\";\r\n}\r\n\r\n.mdi-transfer-left::before {\r\n  content: \"\\F0DA2\";\r\n}\r\n\r\n.mdi-transfer-right::before {\r\n  content: \"\\F0530\";\r\n}\r\n\r\n.mdi-transfer-up::before {\r\n  content: \"\\F0DA3\";\r\n}\r\n\r\n.mdi-transit-connection::before {\r\n  content: \"\\F0D3C\";\r\n}\r\n\r\n.mdi-transit-connection-horizontal::before {\r\n  content: \"\\F1546\";\r\n}\r\n\r\n.mdi-transit-connection-variant::before {\r\n  content: \"\\F0D3D\";\r\n}\r\n\r\n.mdi-transit-detour::before {\r\n  content: \"\\F0F8B\";\r\n}\r\n\r\n.mdi-transit-skip::before {\r\n  content: \"\\F1515\";\r\n}\r\n\r\n.mdi-transit-transfer::before {\r\n  content: \"\\F06AE\";\r\n}\r\n\r\n.mdi-transition::before {\r\n  content: \"\\F0915\";\r\n}\r\n\r\n.mdi-transition-masked::before {\r\n  content: \"\\F0916\";\r\n}\r\n\r\n.mdi-translate::before {\r\n  content: \"\\F05CA\";\r\n}\r\n\r\n.mdi-translate-off::before {\r\n  content: \"\\F0E06\";\r\n}\r\n\r\n.mdi-transmission-tower::before {\r\n  content: \"\\F0D3E\";\r\n}\r\n\r\n.mdi-trash-can::before {\r\n  content: \"\\F0A79\";\r\n}\r\n\r\n.mdi-trash-can-outline::before {\r\n  content: \"\\F0A7A\";\r\n}\r\n\r\n.mdi-tray::before {\r\n  content: \"\\F1294\";\r\n}\r\n\r\n.mdi-tray-alert::before {\r\n  content: \"\\F1295\";\r\n}\r\n\r\n.mdi-tray-full::before {\r\n  content: \"\\F1296\";\r\n}\r\n\r\n.mdi-tray-minus::before {\r\n  content: \"\\F1297\";\r\n}\r\n\r\n.mdi-tray-plus::before {\r\n  content: \"\\F1298\";\r\n}\r\n\r\n.mdi-tray-remove::before {\r\n  content: \"\\F1299\";\r\n}\r\n\r\n.mdi-treasure-chest::before {\r\n  content: \"\\F0726\";\r\n}\r\n\r\n.mdi-tree::before {\r\n  content: \"\\F0531\";\r\n}\r\n\r\n.mdi-tree-outline::before {\r\n  content: \"\\F0E69\";\r\n}\r\n\r\n.mdi-trello::before {\r\n  content: \"\\F0532\";\r\n}\r\n\r\n.mdi-trending-down::before {\r\n  content: \"\\F0533\";\r\n}\r\n\r\n.mdi-trending-neutral::before {\r\n  content: \"\\F0534\";\r\n}\r\n\r\n.mdi-trending-up::before {\r\n  content: \"\\F0535\";\r\n}\r\n\r\n.mdi-triangle::before {\r\n  content: \"\\F0536\";\r\n}\r\n\r\n.mdi-triangle-outline::before {\r\n  content: \"\\F0537\";\r\n}\r\n\r\n.mdi-triangle-wave::before {\r\n  content: \"\\F147C\";\r\n}\r\n\r\n.mdi-triforce::before {\r\n  content: \"\\F0BD9\";\r\n}\r\n\r\n.mdi-trophy::before {\r\n  content: \"\\F0538\";\r\n}\r\n\r\n.mdi-trophy-award::before {\r\n  content: \"\\F0539\";\r\n}\r\n\r\n.mdi-trophy-broken::before {\r\n  content: \"\\F0DA4\";\r\n}\r\n\r\n.mdi-trophy-outline::before {\r\n  content: \"\\F053A\";\r\n}\r\n\r\n.mdi-trophy-variant::before {\r\n  content: \"\\F053B\";\r\n}\r\n\r\n.mdi-trophy-variant-outline::before {\r\n  content: \"\\F053C\";\r\n}\r\n\r\n.mdi-truck::before {\r\n  content: \"\\F053D\";\r\n}\r\n\r\n.mdi-truck-check::before {\r\n  content: \"\\F0CD4\";\r\n}\r\n\r\n.mdi-truck-check-outline::before {\r\n  content: \"\\F129A\";\r\n}\r\n\r\n.mdi-truck-delivery::before {\r\n  content: \"\\F053E\";\r\n}\r\n\r\n.mdi-truck-delivery-outline::before {\r\n  content: \"\\F129B\";\r\n}\r\n\r\n.mdi-truck-fast::before {\r\n  content: \"\\F0788\";\r\n}\r\n\r\n.mdi-truck-fast-outline::before {\r\n  content: \"\\F129C\";\r\n}\r\n\r\n.mdi-truck-outline::before {\r\n  content: \"\\F129D\";\r\n}\r\n\r\n.mdi-truck-trailer::before {\r\n  content: \"\\F0727\";\r\n}\r\n\r\n.mdi-trumpet::before {\r\n  content: \"\\F1096\";\r\n}\r\n\r\n.mdi-tshirt-crew::before {\r\n  content: \"\\F0A7B\";\r\n}\r\n\r\n.mdi-tshirt-crew-outline::before {\r\n  content: \"\\F053F\";\r\n}\r\n\r\n.mdi-tshirt-v::before {\r\n  content: \"\\F0A7C\";\r\n}\r\n\r\n.mdi-tshirt-v-outline::before {\r\n  content: \"\\F0540\";\r\n}\r\n\r\n.mdi-tumble-dryer::before {\r\n  content: \"\\F0917\";\r\n}\r\n\r\n.mdi-tumble-dryer-alert::before {\r\n  content: \"\\F11BA\";\r\n}\r\n\r\n.mdi-tumble-dryer-off::before {\r\n  content: \"\\F11BB\";\r\n}\r\n\r\n.mdi-tune::before {\r\n  content: \"\\F062E\";\r\n}\r\n\r\n.mdi-tune-variant::before {\r\n  content: \"\\F1542\";\r\n}\r\n\r\n.mdi-tune-vertical::before {\r\n  content: \"\\F066A\";\r\n}\r\n\r\n.mdi-tune-vertical-variant::before {\r\n  content: \"\\F1543\";\r\n}\r\n\r\n.mdi-turnstile::before {\r\n  content: \"\\F0CD5\";\r\n}\r\n\r\n.mdi-turnstile-outline::before {\r\n  content: \"\\F0CD6\";\r\n}\r\n\r\n.mdi-turtle::before {\r\n  content: \"\\F0CD7\";\r\n}\r\n\r\n.mdi-twitch::before {\r\n  content: \"\\F0543\";\r\n}\r\n\r\n.mdi-twitter::before {\r\n  content: \"\\F0544\";\r\n}\r\n\r\n.mdi-twitter-retweet::before {\r\n  content: \"\\F0547\";\r\n}\r\n\r\n.mdi-two-factor-authentication::before {\r\n  content: \"\\F09AF\";\r\n}\r\n\r\n.mdi-typewriter::before {\r\n  content: \"\\F0F2D\";\r\n}\r\n\r\n.mdi-ubisoft::before {\r\n  content: \"\\F0BDA\";\r\n}\r\n\r\n.mdi-ubuntu::before {\r\n  content: \"\\F0548\";\r\n}\r\n\r\n.mdi-ufo::before {\r\n  content: \"\\F10C4\";\r\n}\r\n\r\n.mdi-ufo-outline::before {\r\n  content: \"\\F10C5\";\r\n}\r\n\r\n.mdi-ultra-high-definition::before {\r\n  content: \"\\F07F9\";\r\n}\r\n\r\n.mdi-umbraco::before {\r\n  content: \"\\F0549\";\r\n}\r\n\r\n.mdi-umbrella::before {\r\n  content: \"\\F054A\";\r\n}\r\n\r\n.mdi-umbrella-closed::before {\r\n  content: \"\\F09B0\";\r\n}\r\n\r\n.mdi-umbrella-closed-outline::before {\r\n  content: \"\\F13E2\";\r\n}\r\n\r\n.mdi-umbrella-closed-variant::before {\r\n  content: \"\\F13E1\";\r\n}\r\n\r\n.mdi-umbrella-outline::before {\r\n  content: \"\\F054B\";\r\n}\r\n\r\n.mdi-undo::before {\r\n  content: \"\\F054C\";\r\n}\r\n\r\n.mdi-undo-variant::before {\r\n  content: \"\\F054D\";\r\n}\r\n\r\n.mdi-unfold-less-horizontal::before {\r\n  content: \"\\F054E\";\r\n}\r\n\r\n.mdi-unfold-less-vertical::before {\r\n  content: \"\\F0760\";\r\n}\r\n\r\n.mdi-unfold-more-horizontal::before {\r\n  content: \"\\F054F\";\r\n}\r\n\r\n.mdi-unfold-more-vertical::before {\r\n  content: \"\\F0761\";\r\n}\r\n\r\n.mdi-ungroup::before {\r\n  content: \"\\F0550\";\r\n}\r\n\r\n.mdi-unicode::before {\r\n  content: \"\\F0ED0\";\r\n}\r\n\r\n.mdi-unicorn::before {\r\n  content: \"\\F15C2\";\r\n}\r\n\r\n.mdi-unicorn-variant::before {\r\n  content: \"\\F15C3\";\r\n}\r\n\r\n.mdi-unicycle::before {\r\n  content: \"\\F15E5\";\r\n}\r\n\r\n.mdi-unity::before {\r\n  content: \"\\F06AF\";\r\n}\r\n\r\n.mdi-unreal::before {\r\n  content: \"\\F09B1\";\r\n}\r\n\r\n.mdi-untappd::before {\r\n  content: \"\\F0551\";\r\n}\r\n\r\n.mdi-update::before {\r\n  content: \"\\F06B0\";\r\n}\r\n\r\n.mdi-upload::before {\r\n  content: \"\\F0552\";\r\n}\r\n\r\n.mdi-upload-lock::before {\r\n  content: \"\\F1373\";\r\n}\r\n\r\n.mdi-upload-lock-outline::before {\r\n  content: \"\\F1374\";\r\n}\r\n\r\n.mdi-upload-multiple::before {\r\n  content: \"\\F083D\";\r\n}\r\n\r\n.mdi-upload-network::before {\r\n  content: \"\\F06F6\";\r\n}\r\n\r\n.mdi-upload-network-outline::before {\r\n  content: \"\\F0CD8\";\r\n}\r\n\r\n.mdi-upload-off::before {\r\n  content: \"\\F10C6\";\r\n}\r\n\r\n.mdi-upload-off-outline::before {\r\n  content: \"\\F10C7\";\r\n}\r\n\r\n.mdi-upload-outline::before {\r\n  content: \"\\F0E07\";\r\n}\r\n\r\n.mdi-usb::before {\r\n  content: \"\\F0553\";\r\n}\r\n\r\n.mdi-usb-flash-drive::before {\r\n  content: \"\\F129E\";\r\n}\r\n\r\n.mdi-usb-flash-drive-outline::before {\r\n  content: \"\\F129F\";\r\n}\r\n\r\n.mdi-usb-port::before {\r\n  content: \"\\F11F0\";\r\n}\r\n\r\n.mdi-valve::before {\r\n  content: \"\\F1066\";\r\n}\r\n\r\n.mdi-valve-closed::before {\r\n  content: \"\\F1067\";\r\n}\r\n\r\n.mdi-valve-open::before {\r\n  content: \"\\F1068\";\r\n}\r\n\r\n.mdi-van-passenger::before {\r\n  content: \"\\F07FA\";\r\n}\r\n\r\n.mdi-van-utility::before {\r\n  content: \"\\F07FB\";\r\n}\r\n\r\n.mdi-vanish::before {\r\n  content: \"\\F07FC\";\r\n}\r\n\r\n.mdi-vanish-quarter::before {\r\n  content: \"\\F1554\";\r\n}\r\n\r\n.mdi-vanity-light::before {\r\n  content: \"\\F11E1\";\r\n}\r\n\r\n.mdi-variable::before {\r\n  content: \"\\F0AE7\";\r\n}\r\n\r\n.mdi-variable-box::before {\r\n  content: \"\\F1111\";\r\n}\r\n\r\n.mdi-vector-arrange-above::before {\r\n  content: \"\\F0554\";\r\n}\r\n\r\n.mdi-vector-arrange-below::before {\r\n  content: \"\\F0555\";\r\n}\r\n\r\n.mdi-vector-bezier::before {\r\n  content: \"\\F0AE8\";\r\n}\r\n\r\n.mdi-vector-circle::before {\r\n  content: \"\\F0556\";\r\n}\r\n\r\n.mdi-vector-circle-variant::before {\r\n  content: \"\\F0557\";\r\n}\r\n\r\n.mdi-vector-combine::before {\r\n  content: \"\\F0558\";\r\n}\r\n\r\n.mdi-vector-curve::before {\r\n  content: \"\\F0559\";\r\n}\r\n\r\n.mdi-vector-difference::before {\r\n  content: \"\\F055A\";\r\n}\r\n\r\n.mdi-vector-difference-ab::before {\r\n  content: \"\\F055B\";\r\n}\r\n\r\n.mdi-vector-difference-ba::before {\r\n  content: \"\\F055C\";\r\n}\r\n\r\n.mdi-vector-ellipse::before {\r\n  content: \"\\F0893\";\r\n}\r\n\r\n.mdi-vector-intersection::before {\r\n  content: \"\\F055D\";\r\n}\r\n\r\n.mdi-vector-line::before {\r\n  content: \"\\F055E\";\r\n}\r\n\r\n.mdi-vector-link::before {\r\n  content: \"\\F0FE8\";\r\n}\r\n\r\n.mdi-vector-point::before {\r\n  content: \"\\F055F\";\r\n}\r\n\r\n.mdi-vector-polygon::before {\r\n  content: \"\\F0560\";\r\n}\r\n\r\n.mdi-vector-polyline::before {\r\n  content: \"\\F0561\";\r\n}\r\n\r\n.mdi-vector-polyline-edit::before {\r\n  content: \"\\F1225\";\r\n}\r\n\r\n.mdi-vector-polyline-minus::before {\r\n  content: \"\\F1226\";\r\n}\r\n\r\n.mdi-vector-polyline-plus::before {\r\n  content: \"\\F1227\";\r\n}\r\n\r\n.mdi-vector-polyline-remove::before {\r\n  content: \"\\F1228\";\r\n}\r\n\r\n.mdi-vector-radius::before {\r\n  content: \"\\F074A\";\r\n}\r\n\r\n.mdi-vector-rectangle::before {\r\n  content: \"\\F05C6\";\r\n}\r\n\r\n.mdi-vector-selection::before {\r\n  content: \"\\F0562\";\r\n}\r\n\r\n.mdi-vector-square::before {\r\n  content: \"\\F0001\";\r\n}\r\n\r\n.mdi-vector-triangle::before {\r\n  content: \"\\F0563\";\r\n}\r\n\r\n.mdi-vector-union::before {\r\n  content: \"\\F0564\";\r\n}\r\n\r\n.mdi-vhs::before {\r\n  content: \"\\F0A1B\";\r\n}\r\n\r\n.mdi-vibrate::before {\r\n  content: \"\\F0566\";\r\n}\r\n\r\n.mdi-vibrate-off::before {\r\n  content: \"\\F0CD9\";\r\n}\r\n\r\n.mdi-video::before {\r\n  content: \"\\F0567\";\r\n}\r\n\r\n.mdi-video-3d::before {\r\n  content: \"\\F07FD\";\r\n}\r\n\r\n.mdi-video-3d-off::before {\r\n  content: \"\\F13D9\";\r\n}\r\n\r\n.mdi-video-3d-variant::before {\r\n  content: \"\\F0ED1\";\r\n}\r\n\r\n.mdi-video-4k-box::before {\r\n  content: \"\\F083E\";\r\n}\r\n\r\n.mdi-video-account::before {\r\n  content: \"\\F0919\";\r\n}\r\n\r\n.mdi-video-box::before {\r\n  content: \"\\F00FD\";\r\n}\r\n\r\n.mdi-video-box-off::before {\r\n  content: \"\\F00FE\";\r\n}\r\n\r\n.mdi-video-check::before {\r\n  content: \"\\F1069\";\r\n}\r\n\r\n.mdi-video-check-outline::before {\r\n  content: \"\\F106A\";\r\n}\r\n\r\n.mdi-video-high-definition::before {\r\n  content: \"\\F152E\";\r\n}\r\n\r\n.mdi-video-image::before {\r\n  content: \"\\F091A\";\r\n}\r\n\r\n.mdi-video-input-antenna::before {\r\n  content: \"\\F083F\";\r\n}\r\n\r\n.mdi-video-input-component::before {\r\n  content: \"\\F0840\";\r\n}\r\n\r\n.mdi-video-input-hdmi::before {\r\n  content: \"\\F0841\";\r\n}\r\n\r\n.mdi-video-input-scart::before {\r\n  content: \"\\F0F8C\";\r\n}\r\n\r\n.mdi-video-input-svideo::before {\r\n  content: \"\\F0842\";\r\n}\r\n\r\n.mdi-video-minus::before {\r\n  content: \"\\F09B2\";\r\n}\r\n\r\n.mdi-video-minus-outline::before {\r\n  content: \"\\F02BA\";\r\n}\r\n\r\n.mdi-video-off::before {\r\n  content: \"\\F0568\";\r\n}\r\n\r\n.mdi-video-off-outline::before {\r\n  content: \"\\F0BDB\";\r\n}\r\n\r\n.mdi-video-outline::before {\r\n  content: \"\\F0BDC\";\r\n}\r\n\r\n.mdi-video-plus::before {\r\n  content: \"\\F09B3\";\r\n}\r\n\r\n.mdi-video-plus-outline::before {\r\n  content: \"\\F01D3\";\r\n}\r\n\r\n.mdi-video-stabilization::before {\r\n  content: \"\\F091B\";\r\n}\r\n\r\n.mdi-video-switch::before {\r\n  content: \"\\F0569\";\r\n}\r\n\r\n.mdi-video-switch-outline::before {\r\n  content: \"\\F0790\";\r\n}\r\n\r\n.mdi-video-vintage::before {\r\n  content: \"\\F0A1C\";\r\n}\r\n\r\n.mdi-video-wireless::before {\r\n  content: \"\\F0ED2\";\r\n}\r\n\r\n.mdi-video-wireless-outline::before {\r\n  content: \"\\F0ED3\";\r\n}\r\n\r\n.mdi-view-agenda::before {\r\n  content: \"\\F056A\";\r\n}\r\n\r\n.mdi-view-agenda-outline::before {\r\n  content: \"\\F11D8\";\r\n}\r\n\r\n.mdi-view-array::before {\r\n  content: \"\\F056B\";\r\n}\r\n\r\n.mdi-view-array-outline::before {\r\n  content: \"\\F1485\";\r\n}\r\n\r\n.mdi-view-carousel::before {\r\n  content: \"\\F056C\";\r\n}\r\n\r\n.mdi-view-carousel-outline::before {\r\n  content: \"\\F1486\";\r\n}\r\n\r\n.mdi-view-column::before {\r\n  content: \"\\F056D\";\r\n}\r\n\r\n.mdi-view-column-outline::before {\r\n  content: \"\\F1487\";\r\n}\r\n\r\n.mdi-view-comfy::before {\r\n  content: \"\\F0E6A\";\r\n}\r\n\r\n.mdi-view-comfy-outline::before {\r\n  content: \"\\F1488\";\r\n}\r\n\r\n.mdi-view-compact::before {\r\n  content: \"\\F0E6B\";\r\n}\r\n\r\n.mdi-view-compact-outline::before {\r\n  content: \"\\F0E6C\";\r\n}\r\n\r\n.mdi-view-dashboard::before {\r\n  content: \"\\F056E\";\r\n}\r\n\r\n.mdi-view-dashboard-outline::before {\r\n  content: \"\\F0A1D\";\r\n}\r\n\r\n.mdi-view-dashboard-variant::before {\r\n  content: \"\\F0843\";\r\n}\r\n\r\n.mdi-view-dashboard-variant-outline::before {\r\n  content: \"\\F1489\";\r\n}\r\n\r\n.mdi-view-day::before {\r\n  content: \"\\F056F\";\r\n}\r\n\r\n.mdi-view-day-outline::before {\r\n  content: \"\\F148A\";\r\n}\r\n\r\n.mdi-view-grid::before {\r\n  content: \"\\F0570\";\r\n}\r\n\r\n.mdi-view-grid-outline::before {\r\n  content: \"\\F11D9\";\r\n}\r\n\r\n.mdi-view-grid-plus::before {\r\n  content: \"\\F0F8D\";\r\n}\r\n\r\n.mdi-view-grid-plus-outline::before {\r\n  content: \"\\F11DA\";\r\n}\r\n\r\n.mdi-view-headline::before {\r\n  content: \"\\F0571\";\r\n}\r\n\r\n.mdi-view-list::before {\r\n  content: \"\\F0572\";\r\n}\r\n\r\n.mdi-view-list-outline::before {\r\n  content: \"\\F148B\";\r\n}\r\n\r\n.mdi-view-module::before {\r\n  content: \"\\F0573\";\r\n}\r\n\r\n.mdi-view-module-outline::before {\r\n  content: \"\\F148C\";\r\n}\r\n\r\n.mdi-view-parallel::before {\r\n  content: \"\\F0728\";\r\n}\r\n\r\n.mdi-view-parallel-outline::before {\r\n  content: \"\\F148D\";\r\n}\r\n\r\n.mdi-view-quilt::before {\r\n  content: \"\\F0574\";\r\n}\r\n\r\n.mdi-view-quilt-outline::before {\r\n  content: \"\\F148E\";\r\n}\r\n\r\n.mdi-view-sequential::before {\r\n  content: \"\\F0729\";\r\n}\r\n\r\n.mdi-view-sequential-outline::before {\r\n  content: \"\\F148F\";\r\n}\r\n\r\n.mdi-view-split-horizontal::before {\r\n  content: \"\\F0BCB\";\r\n}\r\n\r\n.mdi-view-split-vertical::before {\r\n  content: \"\\F0BCC\";\r\n}\r\n\r\n.mdi-view-stream::before {\r\n  content: \"\\F0575\";\r\n}\r\n\r\n.mdi-view-stream-outline::before {\r\n  content: \"\\F1490\";\r\n}\r\n\r\n.mdi-view-week::before {\r\n  content: \"\\F0576\";\r\n}\r\n\r\n.mdi-view-week-outline::before {\r\n  content: \"\\F1491\";\r\n}\r\n\r\n.mdi-vimeo::before {\r\n  content: \"\\F0577\";\r\n}\r\n\r\n.mdi-violin::before {\r\n  content: \"\\F060F\";\r\n}\r\n\r\n.mdi-virtual-reality::before {\r\n  content: \"\\F0894\";\r\n}\r\n\r\n.mdi-virus::before {\r\n  content: \"\\F13B6\";\r\n}\r\n\r\n.mdi-virus-outline::before {\r\n  content: \"\\F13B7\";\r\n}\r\n\r\n.mdi-vk::before {\r\n  content: \"\\F0579\";\r\n}\r\n\r\n.mdi-vlc::before {\r\n  content: \"\\F057C\";\r\n}\r\n\r\n.mdi-voice-off::before {\r\n  content: \"\\F0ED4\";\r\n}\r\n\r\n.mdi-voicemail::before {\r\n  content: \"\\F057D\";\r\n}\r\n\r\n.mdi-volleyball::before {\r\n  content: \"\\F09B4\";\r\n}\r\n\r\n.mdi-volume-high::before {\r\n  content: \"\\F057E\";\r\n}\r\n\r\n.mdi-volume-low::before {\r\n  content: \"\\F057F\";\r\n}\r\n\r\n.mdi-volume-medium::before {\r\n  content: \"\\F0580\";\r\n}\r\n\r\n.mdi-volume-minus::before {\r\n  content: \"\\F075E\";\r\n}\r\n\r\n.mdi-volume-mute::before {\r\n  content: \"\\F075F\";\r\n}\r\n\r\n.mdi-volume-off::before {\r\n  content: \"\\F0581\";\r\n}\r\n\r\n.mdi-volume-plus::before {\r\n  content: \"\\F075D\";\r\n}\r\n\r\n.mdi-volume-source::before {\r\n  content: \"\\F1120\";\r\n}\r\n\r\n.mdi-volume-variant-off::before {\r\n  content: \"\\F0E08\";\r\n}\r\n\r\n.mdi-volume-vibrate::before {\r\n  content: \"\\F1121\";\r\n}\r\n\r\n.mdi-vote::before {\r\n  content: \"\\F0A1F\";\r\n}\r\n\r\n.mdi-vote-outline::before {\r\n  content: \"\\F0A20\";\r\n}\r\n\r\n.mdi-vpn::before {\r\n  content: \"\\F0582\";\r\n}\r\n\r\n.mdi-vuejs::before {\r\n  content: \"\\F0844\";\r\n}\r\n\r\n.mdi-vuetify::before {\r\n  content: \"\\F0E6D\";\r\n}\r\n\r\n.mdi-walk::before {\r\n  content: \"\\F0583\";\r\n}\r\n\r\n.mdi-wall::before {\r\n  content: \"\\F07FE\";\r\n}\r\n\r\n.mdi-wall-sconce::before {\r\n  content: \"\\F091C\";\r\n}\r\n\r\n.mdi-wall-sconce-flat::before {\r\n  content: \"\\F091D\";\r\n}\r\n\r\n.mdi-wall-sconce-flat-variant::before {\r\n  content: \"\\F041C\";\r\n}\r\n\r\n.mdi-wall-sconce-round::before {\r\n  content: \"\\F0748\";\r\n}\r\n\r\n.mdi-wall-sconce-round-variant::before {\r\n  content: \"\\F091E\";\r\n}\r\n\r\n.mdi-wallet::before {\r\n  content: \"\\F0584\";\r\n}\r\n\r\n.mdi-wallet-giftcard::before {\r\n  content: \"\\F0585\";\r\n}\r\n\r\n.mdi-wallet-membership::before {\r\n  content: \"\\F0586\";\r\n}\r\n\r\n.mdi-wallet-outline::before {\r\n  content: \"\\F0BDD\";\r\n}\r\n\r\n.mdi-wallet-plus::before {\r\n  content: \"\\F0F8E\";\r\n}\r\n\r\n.mdi-wallet-plus-outline::before {\r\n  content: \"\\F0F8F\";\r\n}\r\n\r\n.mdi-wallet-travel::before {\r\n  content: \"\\F0587\";\r\n}\r\n\r\n.mdi-wallpaper::before {\r\n  content: \"\\F0E09\";\r\n}\r\n\r\n.mdi-wan::before {\r\n  content: \"\\F0588\";\r\n}\r\n\r\n.mdi-wardrobe::before {\r\n  content: \"\\F0F90\";\r\n}\r\n\r\n.mdi-wardrobe-outline::before {\r\n  content: \"\\F0F91\";\r\n}\r\n\r\n.mdi-warehouse::before {\r\n  content: \"\\F0F81\";\r\n}\r\n\r\n.mdi-washing-machine::before {\r\n  content: \"\\F072A\";\r\n}\r\n\r\n.mdi-washing-machine-alert::before {\r\n  content: \"\\F11BC\";\r\n}\r\n\r\n.mdi-washing-machine-off::before {\r\n  content: \"\\F11BD\";\r\n}\r\n\r\n.mdi-watch::before {\r\n  content: \"\\F0589\";\r\n}\r\n\r\n.mdi-watch-export::before {\r\n  content: \"\\F058A\";\r\n}\r\n\r\n.mdi-watch-export-variant::before {\r\n  content: \"\\F0895\";\r\n}\r\n\r\n.mdi-watch-import::before {\r\n  content: \"\\F058B\";\r\n}\r\n\r\n.mdi-watch-import-variant::before {\r\n  content: \"\\F0896\";\r\n}\r\n\r\n.mdi-watch-variant::before {\r\n  content: \"\\F0897\";\r\n}\r\n\r\n.mdi-watch-vibrate::before {\r\n  content: \"\\F06B1\";\r\n}\r\n\r\n.mdi-watch-vibrate-off::before {\r\n  content: \"\\F0CDA\";\r\n}\r\n\r\n.mdi-water::before {\r\n  content: \"\\F058C\";\r\n}\r\n\r\n.mdi-water-alert::before {\r\n  content: \"\\F1502\";\r\n}\r\n\r\n.mdi-water-alert-outline::before {\r\n  content: \"\\F1503\";\r\n}\r\n\r\n.mdi-water-boiler::before {\r\n  content: \"\\F0F92\";\r\n}\r\n\r\n.mdi-water-boiler-alert::before {\r\n  content: \"\\F11B3\";\r\n}\r\n\r\n.mdi-water-boiler-off::before {\r\n  content: \"\\F11B4\";\r\n}\r\n\r\n.mdi-water-check::before {\r\n  content: \"\\F1504\";\r\n}\r\n\r\n.mdi-water-check-outline::before {\r\n  content: \"\\F1505\";\r\n}\r\n\r\n.mdi-water-minus::before {\r\n  content: \"\\F1506\";\r\n}\r\n\r\n.mdi-water-minus-outline::before {\r\n  content: \"\\F1507\";\r\n}\r\n\r\n.mdi-water-off::before {\r\n  content: \"\\F058D\";\r\n}\r\n\r\n.mdi-water-off-outline::before {\r\n  content: \"\\F1508\";\r\n}\r\n\r\n.mdi-water-outline::before {\r\n  content: \"\\F0E0A\";\r\n}\r\n\r\n.mdi-water-percent::before {\r\n  content: \"\\F058E\";\r\n}\r\n\r\n.mdi-water-percent-alert::before {\r\n  content: \"\\F1509\";\r\n}\r\n\r\n.mdi-water-plus::before {\r\n  content: \"\\F150A\";\r\n}\r\n\r\n.mdi-water-plus-outline::before {\r\n  content: \"\\F150B\";\r\n}\r\n\r\n.mdi-water-polo::before {\r\n  content: \"\\F12A0\";\r\n}\r\n\r\n.mdi-water-pump::before {\r\n  content: \"\\F058F\";\r\n}\r\n\r\n.mdi-water-pump-off::before {\r\n  content: \"\\F0F93\";\r\n}\r\n\r\n.mdi-water-remove::before {\r\n  content: \"\\F150C\";\r\n}\r\n\r\n.mdi-water-remove-outline::before {\r\n  content: \"\\F150D\";\r\n}\r\n\r\n.mdi-water-well::before {\r\n  content: \"\\F106B\";\r\n}\r\n\r\n.mdi-water-well-outline::before {\r\n  content: \"\\F106C\";\r\n}\r\n\r\n.mdi-watering-can::before {\r\n  content: \"\\F1481\";\r\n}\r\n\r\n.mdi-watering-can-outline::before {\r\n  content: \"\\F1482\";\r\n}\r\n\r\n.mdi-watermark::before {\r\n  content: \"\\F0612\";\r\n}\r\n\r\n.mdi-wave::before {\r\n  content: \"\\F0F2E\";\r\n}\r\n\r\n.mdi-waveform::before {\r\n  content: \"\\F147D\";\r\n}\r\n\r\n.mdi-waves::before {\r\n  content: \"\\F078D\";\r\n}\r\n\r\n.mdi-waze::before {\r\n  content: \"\\F0BDE\";\r\n}\r\n\r\n.mdi-weather-cloudy::before {\r\n  content: \"\\F0590\";\r\n}\r\n\r\n.mdi-weather-cloudy-alert::before {\r\n  content: \"\\F0F2F\";\r\n}\r\n\r\n.mdi-weather-cloudy-arrow-right::before {\r\n  content: \"\\F0E6E\";\r\n}\r\n\r\n.mdi-weather-fog::before {\r\n  content: \"\\F0591\";\r\n}\r\n\r\n.mdi-weather-hail::before {\r\n  content: \"\\F0592\";\r\n}\r\n\r\n.mdi-weather-hazy::before {\r\n  content: \"\\F0F30\";\r\n}\r\n\r\n.mdi-weather-hurricane::before {\r\n  content: \"\\F0898\";\r\n}\r\n\r\n.mdi-weather-lightning::before {\r\n  content: \"\\F0593\";\r\n}\r\n\r\n.mdi-weather-lightning-rainy::before {\r\n  content: \"\\F067E\";\r\n}\r\n\r\n.mdi-weather-night::before {\r\n  content: \"\\F0594\";\r\n}\r\n\r\n.mdi-weather-night-partly-cloudy::before {\r\n  content: \"\\F0F31\";\r\n}\r\n\r\n.mdi-weather-partly-cloudy::before {\r\n  content: \"\\F0595\";\r\n}\r\n\r\n.mdi-weather-partly-lightning::before {\r\n  content: \"\\F0F32\";\r\n}\r\n\r\n.mdi-weather-partly-rainy::before {\r\n  content: \"\\F0F33\";\r\n}\r\n\r\n.mdi-weather-partly-snowy::before {\r\n  content: \"\\F0F34\";\r\n}\r\n\r\n.mdi-weather-partly-snowy-rainy::before {\r\n  content: \"\\F0F35\";\r\n}\r\n\r\n.mdi-weather-pouring::before {\r\n  content: \"\\F0596\";\r\n}\r\n\r\n.mdi-weather-rainy::before {\r\n  content: \"\\F0597\";\r\n}\r\n\r\n.mdi-weather-snowy::before {\r\n  content: \"\\F0598\";\r\n}\r\n\r\n.mdi-weather-snowy-heavy::before {\r\n  content: \"\\F0F36\";\r\n}\r\n\r\n.mdi-weather-snowy-rainy::before {\r\n  content: \"\\F067F\";\r\n}\r\n\r\n.mdi-weather-sunny::before {\r\n  content: \"\\F0599\";\r\n}\r\n\r\n.mdi-weather-sunny-alert::before {\r\n  content: \"\\F0F37\";\r\n}\r\n\r\n.mdi-weather-sunny-off::before {\r\n  content: \"\\F14E4\";\r\n}\r\n\r\n.mdi-weather-sunset::before {\r\n  content: \"\\F059A\";\r\n}\r\n\r\n.mdi-weather-sunset-down::before {\r\n  content: \"\\F059B\";\r\n}\r\n\r\n.mdi-weather-sunset-up::before {\r\n  content: \"\\F059C\";\r\n}\r\n\r\n.mdi-weather-tornado::before {\r\n  content: \"\\F0F38\";\r\n}\r\n\r\n.mdi-weather-windy::before {\r\n  content: \"\\F059D\";\r\n}\r\n\r\n.mdi-weather-windy-variant::before {\r\n  content: \"\\F059E\";\r\n}\r\n\r\n.mdi-web::before {\r\n  content: \"\\F059F\";\r\n}\r\n\r\n.mdi-web-box::before {\r\n  content: \"\\F0F94\";\r\n}\r\n\r\n.mdi-web-clock::before {\r\n  content: \"\\F124A\";\r\n}\r\n\r\n.mdi-webcam::before {\r\n  content: \"\\F05A0\";\r\n}\r\n\r\n.mdi-webhook::before {\r\n  content: \"\\F062F\";\r\n}\r\n\r\n.mdi-webpack::before {\r\n  content: \"\\F072B\";\r\n}\r\n\r\n.mdi-webrtc::before {\r\n  content: \"\\F1248\";\r\n}\r\n\r\n.mdi-wechat::before {\r\n  content: \"\\F0611\";\r\n}\r\n\r\n.mdi-weight::before {\r\n  content: \"\\F05A1\";\r\n}\r\n\r\n.mdi-weight-gram::before {\r\n  content: \"\\F0D3F\";\r\n}\r\n\r\n.mdi-weight-kilogram::before {\r\n  content: \"\\F05A2\";\r\n}\r\n\r\n.mdi-weight-lifter::before {\r\n  content: \"\\F115D\";\r\n}\r\n\r\n.mdi-weight-pound::before {\r\n  content: \"\\F09B5\";\r\n}\r\n\r\n.mdi-whatsapp::before {\r\n  content: \"\\F05A3\";\r\n}\r\n\r\n.mdi-wheel-barrow::before {\r\n  content: \"\\F14F2\";\r\n}\r\n\r\n.mdi-wheelchair-accessibility::before {\r\n  content: \"\\F05A4\";\r\n}\r\n\r\n.mdi-whistle::before {\r\n  content: \"\\F09B6\";\r\n}\r\n\r\n.mdi-whistle-outline::before {\r\n  content: \"\\F12BC\";\r\n}\r\n\r\n.mdi-white-balance-auto::before {\r\n  content: \"\\F05A5\";\r\n}\r\n\r\n.mdi-white-balance-incandescent::before {\r\n  content: \"\\F05A6\";\r\n}\r\n\r\n.mdi-white-balance-iridescent::before {\r\n  content: \"\\F05A7\";\r\n}\r\n\r\n.mdi-white-balance-sunny::before {\r\n  content: \"\\F05A8\";\r\n}\r\n\r\n.mdi-widgets::before {\r\n  content: \"\\F072C\";\r\n}\r\n\r\n.mdi-widgets-outline::before {\r\n  content: \"\\F1355\";\r\n}\r\n\r\n.mdi-wifi::before {\r\n  content: \"\\F05A9\";\r\n}\r\n\r\n.mdi-wifi-alert::before {\r\n  content: \"\\F16B5\";\r\n}\r\n\r\n.mdi-wifi-arrow-down::before {\r\n  content: \"\\F16B6\";\r\n}\r\n\r\n.mdi-wifi-arrow-left::before {\r\n  content: \"\\F16B7\";\r\n}\r\n\r\n.mdi-wifi-arrow-left-right::before {\r\n  content: \"\\F16B8\";\r\n}\r\n\r\n.mdi-wifi-arrow-right::before {\r\n  content: \"\\F16B9\";\r\n}\r\n\r\n.mdi-wifi-arrow-up::before {\r\n  content: \"\\F16BA\";\r\n}\r\n\r\n.mdi-wifi-arrow-up-down::before {\r\n  content: \"\\F16BB\";\r\n}\r\n\r\n.mdi-wifi-cancel::before {\r\n  content: \"\\F16BC\";\r\n}\r\n\r\n.mdi-wifi-check::before {\r\n  content: \"\\F16BD\";\r\n}\r\n\r\n.mdi-wifi-cog::before {\r\n  content: \"\\F16BE\";\r\n}\r\n\r\n.mdi-wifi-lock::before {\r\n  content: \"\\F16BF\";\r\n}\r\n\r\n.mdi-wifi-lock-open::before {\r\n  content: \"\\F16C0\";\r\n}\r\n\r\n.mdi-wifi-marker::before {\r\n  content: \"\\F16C1\";\r\n}\r\n\r\n.mdi-wifi-minus::before {\r\n  content: \"\\F16C2\";\r\n}\r\n\r\n.mdi-wifi-off::before {\r\n  content: \"\\F05AA\";\r\n}\r\n\r\n.mdi-wifi-plus::before {\r\n  content: \"\\F16C3\";\r\n}\r\n\r\n.mdi-wifi-refresh::before {\r\n  content: \"\\F16C4\";\r\n}\r\n\r\n.mdi-wifi-remove::before {\r\n  content: \"\\F16C5\";\r\n}\r\n\r\n.mdi-wifi-settings::before {\r\n  content: \"\\F16C6\";\r\n}\r\n\r\n.mdi-wifi-star::before {\r\n  content: \"\\F0E0B\";\r\n}\r\n\r\n.mdi-wifi-strength-1::before {\r\n  content: \"\\F091F\";\r\n}\r\n\r\n.mdi-wifi-strength-1-alert::before {\r\n  content: \"\\F0920\";\r\n}\r\n\r\n.mdi-wifi-strength-1-lock::before {\r\n  content: \"\\F0921\";\r\n}\r\n\r\n.mdi-wifi-strength-1-lock-open::before {\r\n  content: \"\\F16CB\";\r\n}\r\n\r\n.mdi-wifi-strength-2::before {\r\n  content: \"\\F0922\";\r\n}\r\n\r\n.mdi-wifi-strength-2-alert::before {\r\n  content: \"\\F0923\";\r\n}\r\n\r\n.mdi-wifi-strength-2-lock::before {\r\n  content: \"\\F0924\";\r\n}\r\n\r\n.mdi-wifi-strength-2-lock-open::before {\r\n  content: \"\\F16CC\";\r\n}\r\n\r\n.mdi-wifi-strength-3::before {\r\n  content: \"\\F0925\";\r\n}\r\n\r\n.mdi-wifi-strength-3-alert::before {\r\n  content: \"\\F0926\";\r\n}\r\n\r\n.mdi-wifi-strength-3-lock::before {\r\n  content: \"\\F0927\";\r\n}\r\n\r\n.mdi-wifi-strength-3-lock-open::before {\r\n  content: \"\\F16CD\";\r\n}\r\n\r\n.mdi-wifi-strength-4::before {\r\n  content: \"\\F0928\";\r\n}\r\n\r\n.mdi-wifi-strength-4-alert::before {\r\n  content: \"\\F0929\";\r\n}\r\n\r\n.mdi-wifi-strength-4-lock::before {\r\n  content: \"\\F092A\";\r\n}\r\n\r\n.mdi-wifi-strength-4-lock-open::before {\r\n  content: \"\\F16CE\";\r\n}\r\n\r\n.mdi-wifi-strength-alert-outline::before {\r\n  content: \"\\F092B\";\r\n}\r\n\r\n.mdi-wifi-strength-lock-open-outline::before {\r\n  content: \"\\F16CF\";\r\n}\r\n\r\n.mdi-wifi-strength-lock-outline::before {\r\n  content: \"\\F092C\";\r\n}\r\n\r\n.mdi-wifi-strength-off::before {\r\n  content: \"\\F092D\";\r\n}\r\n\r\n.mdi-wifi-strength-off-outline::before {\r\n  content: \"\\F092E\";\r\n}\r\n\r\n.mdi-wifi-strength-outline::before {\r\n  content: \"\\F092F\";\r\n}\r\n\r\n.mdi-wifi-sync::before {\r\n  content: \"\\F16C7\";\r\n}\r\n\r\n.mdi-wikipedia::before {\r\n  content: \"\\F05AC\";\r\n}\r\n\r\n.mdi-wind-turbine::before {\r\n  content: \"\\F0DA5\";\r\n}\r\n\r\n.mdi-window-close::before {\r\n  content: \"\\F05AD\";\r\n}\r\n\r\n.mdi-window-closed::before {\r\n  content: \"\\F05AE\";\r\n}\r\n\r\n.mdi-window-closed-variant::before {\r\n  content: \"\\F11DB\";\r\n}\r\n\r\n.mdi-window-maximize::before {\r\n  content: \"\\F05AF\";\r\n}\r\n\r\n.mdi-window-minimize::before {\r\n  content: \"\\F05B0\";\r\n}\r\n\r\n.mdi-window-open::before {\r\n  content: \"\\F05B1\";\r\n}\r\n\r\n.mdi-window-open-variant::before {\r\n  content: \"\\F11DC\";\r\n}\r\n\r\n.mdi-window-restore::before {\r\n  content: \"\\F05B2\";\r\n}\r\n\r\n.mdi-window-shutter::before {\r\n  content: \"\\F111C\";\r\n}\r\n\r\n.mdi-window-shutter-alert::before {\r\n  content: \"\\F111D\";\r\n}\r\n\r\n.mdi-window-shutter-open::before {\r\n  content: \"\\F111E\";\r\n}\r\n\r\n.mdi-windsock::before {\r\n  content: \"\\F15FA\";\r\n}\r\n\r\n.mdi-wiper::before {\r\n  content: \"\\F0AE9\";\r\n}\r\n\r\n.mdi-wiper-wash::before {\r\n  content: \"\\F0DA6\";\r\n}\r\n\r\n.mdi-wizard-hat::before {\r\n  content: \"\\F1477\";\r\n}\r\n\r\n.mdi-wordpress::before {\r\n  content: \"\\F05B4\";\r\n}\r\n\r\n.mdi-wrap::before {\r\n  content: \"\\F05B6\";\r\n}\r\n\r\n.mdi-wrap-disabled::before {\r\n  content: \"\\F0BDF\";\r\n}\r\n\r\n.mdi-wrench::before {\r\n  content: \"\\F05B7\";\r\n}\r\n\r\n.mdi-wrench-outline::before {\r\n  content: \"\\F0BE0\";\r\n}\r\n\r\n.mdi-xamarin::before {\r\n  content: \"\\F0845\";\r\n}\r\n\r\n.mdi-xamarin-outline::before {\r\n  content: \"\\F0846\";\r\n}\r\n\r\n.mdi-xing::before {\r\n  content: \"\\F05BE\";\r\n}\r\n\r\n.mdi-xml::before {\r\n  content: \"\\F05C0\";\r\n}\r\n\r\n.mdi-xmpp::before {\r\n  content: \"\\F07FF\";\r\n}\r\n\r\n.mdi-y-combinator::before {\r\n  content: \"\\F0624\";\r\n}\r\n\r\n.mdi-yahoo::before {\r\n  content: \"\\F0B4F\";\r\n}\r\n\r\n.mdi-yeast::before {\r\n  content: \"\\F05C1\";\r\n}\r\n\r\n.mdi-yin-yang::before {\r\n  content: \"\\F0680\";\r\n}\r\n\r\n.mdi-yoga::before {\r\n  content: \"\\F117C\";\r\n}\r\n\r\n.mdi-youtube::before {\r\n  content: \"\\F05C3\";\r\n}\r\n\r\n.mdi-youtube-gaming::before {\r\n  content: \"\\F0848\";\r\n}\r\n\r\n.mdi-youtube-studio::before {\r\n  content: \"\\F0847\";\r\n}\r\n\r\n.mdi-youtube-subscription::before {\r\n  content: \"\\F0D40\";\r\n}\r\n\r\n.mdi-youtube-tv::before {\r\n  content: \"\\F0448\";\r\n}\r\n\r\n.mdi-yurt::before {\r\n  content: \"\\F1516\";\r\n}\r\n\r\n.mdi-z-wave::before {\r\n  content: \"\\F0AEA\";\r\n}\r\n\r\n.mdi-zend::before {\r\n  content: \"\\F0AEB\";\r\n}\r\n\r\n.mdi-zigbee::before {\r\n  content: \"\\F0D41\";\r\n}\r\n\r\n.mdi-zip-box::before {\r\n  content: \"\\F05C4\";\r\n}\r\n\r\n.mdi-zip-box-outline::before {\r\n  content: \"\\F0FFA\";\r\n}\r\n\r\n.mdi-zip-disk::before {\r\n  content: \"\\F0A23\";\r\n}\r\n\r\n.mdi-zodiac-aquarius::before {\r\n  content: \"\\F0A7D\";\r\n}\r\n\r\n.mdi-zodiac-aries::before {\r\n  content: \"\\F0A7E\";\r\n}\r\n\r\n.mdi-zodiac-cancer::before {\r\n  content: \"\\F0A7F\";\r\n}\r\n\r\n.mdi-zodiac-capricorn::before {\r\n  content: \"\\F0A80\";\r\n}\r\n\r\n.mdi-zodiac-gemini::before {\r\n  content: \"\\F0A81\";\r\n}\r\n\r\n.mdi-zodiac-leo::before {\r\n  content: \"\\F0A82\";\r\n}\r\n\r\n.mdi-zodiac-libra::before {\r\n  content: \"\\F0A83\";\r\n}\r\n\r\n.mdi-zodiac-pisces::before {\r\n  content: \"\\F0A84\";\r\n}\r\n\r\n.mdi-zodiac-sagittarius::before {\r\n  content: \"\\F0A85\";\r\n}\r\n\r\n.mdi-zodiac-scorpio::before {\r\n  content: \"\\F0A86\";\r\n}\r\n\r\n.mdi-zodiac-taurus::before {\r\n  content: \"\\F0A87\";\r\n}\r\n\r\n.mdi-zodiac-virgo::before {\r\n  content: \"\\F0A88\";\r\n}\r\n\r\n.mdi-blank::before {\r\n  content: \"\\F68C\";\r\n  visibility: hidden;\r\n}\r\n\r\n.mdi-18px.mdi-set,\r\n.mdi-18px.mdi:before {\r\n  font-size: 18px;\r\n}\r\n\r\n.mdi-24px.mdi-set,\r\n.mdi-24px.mdi:before {\r\n  font-size: 24px;\r\n}\r\n\r\n.mdi-36px.mdi-set,\r\n.mdi-36px.mdi:before {\r\n  font-size: 36px;\r\n}\r\n\r\n.mdi-48px.mdi-set,\r\n.mdi-48px.mdi:before {\r\n  font-size: 48px;\r\n}\r\n\r\n.mdi-dark:before {\r\n  color: rgba(0, 0, 0, 0.54);\r\n}\r\n\r\n.mdi-dark.mdi-inactive:before {\r\n  color: rgba(0, 0, 0, 0.26);\r\n}\r\n\r\n.mdi-light:before {\r\n  color: white;\r\n}\r\n\r\n.mdi-light.mdi-inactive:before {\r\n  color: rgba(255, 255, 255, 0.3);\r\n}\r\n\r\n.mdi-rotate-45 {\r\n  /*\r\n        // Not included in production\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(45deg);\r\n            transform: scaleX(-1) rotate(45deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(45deg);\r\n            -ms-transform: rotate(45deg);\r\n            transform: scaleY(-1) rotate(45deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\r\n}\r\n\r\n.mdi-rotate-45:before {\r\n  -webkit-transform: rotate(45deg);\r\n  -ms-transform: rotate(45deg);\r\n  transform: rotate(45deg);\r\n}\r\n\r\n.mdi-rotate-90 {\r\n  /*\r\n        // Not included in production\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(90deg);\r\n            transform: scaleX(-1) rotate(90deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(90deg);\r\n            -ms-transform: rotate(90deg);\r\n            transform: scaleY(-1) rotate(90deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\r\n}\r\n\r\n.mdi-rotate-90:before {\r\n  -webkit-transform: rotate(90deg);\r\n  -ms-transform: rotate(90deg);\r\n  transform: rotate(90deg);\r\n}\r\n\r\n.mdi-rotate-135 {\r\n  /*\r\n        // Not included in production\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(135deg);\r\n            transform: scaleX(-1) rotate(135deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(135deg);\r\n            -ms-transform: rotate(135deg);\r\n            transform: scaleY(-1) rotate(135deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\r\n}\r\n\r\n.mdi-rotate-135:before {\r\n  -webkit-transform: rotate(135deg);\r\n  -ms-transform: rotate(135deg);\r\n  transform: rotate(135deg);\r\n}\r\n\r\n.mdi-rotate-180 {\r\n  /*\r\n        // Not included in production\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(180deg);\r\n            transform: scaleX(-1) rotate(180deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(180deg);\r\n            -ms-transform: rotate(180deg);\r\n            transform: scaleY(-1) rotate(180deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\r\n}\r\n\r\n.mdi-rotate-180:before {\r\n  -webkit-transform: rotate(180deg);\r\n  -ms-transform: rotate(180deg);\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.mdi-rotate-225 {\r\n  /*\r\n        // Not included in production\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(225deg);\r\n            transform: scaleX(-1) rotate(225deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(225deg);\r\n            -ms-transform: rotate(225deg);\r\n            transform: scaleY(-1) rotate(225deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\r\n}\r\n\r\n.mdi-rotate-225:before {\r\n  -webkit-transform: rotate(225deg);\r\n  -ms-transform: rotate(225deg);\r\n  transform: rotate(225deg);\r\n}\r\n\r\n.mdi-rotate-270 {\r\n  /*\r\n        // Not included in production\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(270deg);\r\n            transform: scaleX(-1) rotate(270deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(270deg);\r\n            -ms-transform: rotate(270deg);\r\n            transform: scaleY(-1) rotate(270deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\r\n}\r\n\r\n.mdi-rotate-270:before {\r\n  -webkit-transform: rotate(270deg);\r\n  -ms-transform: rotate(270deg);\r\n  transform: rotate(270deg);\r\n}\r\n\r\n.mdi-rotate-315 {\r\n  /*\r\n        // Not included in production\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(315deg);\r\n            transform: scaleX(-1) rotate(315deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(315deg);\r\n            -ms-transform: rotate(315deg);\r\n            transform: scaleY(-1) rotate(315deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\r\n}\r\n\r\n.mdi-rotate-315:before {\r\n  -webkit-transform: rotate(315deg);\r\n  -ms-transform: rotate(315deg);\r\n  transform: rotate(315deg);\r\n}\r\n\r\n.mdi-flip-h:before {\r\n  -webkit-transform: scaleX(-1);\r\n  transform: scaleX(-1);\r\n  filter: FlipH;\r\n  -ms-filter: \"FlipH\";\r\n}\r\n\r\n.mdi-flip-v:before {\r\n  -webkit-transform: scaleY(-1);\r\n  transform: scaleY(-1);\r\n  filter: FlipV;\r\n  -ms-filter: \"FlipV\";\r\n}\r\n\r\n.mdi-spin:before {\r\n  -webkit-animation: mdi-spin 2s infinite linear;\r\n  animation: mdi-spin 2s infinite linear;\r\n}\r\n\r\n@-webkit-keyframes mdi-spin {\r\n  0% {\r\n    -webkit-transform: rotate(0deg);\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    -webkit-transform: rotate(359deg);\r\n    transform: rotate(359deg);\r\n  }\r\n}\r\n\r\n@keyframes mdi-spin {\r\n  0% {\r\n    -webkit-transform: rotate(0deg);\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    -webkit-transform: rotate(359deg);\r\n    transform: rotate(359deg);\r\n  }\r\n}\r\n\r\n/*# sourceMappingURL=materialdesignicons.css.map */\r\n","@font-face {\r\n  font-family: \"boxicons\";\r\n  font-weight: normal;\r\n  font-style: normal;\r\n\r\n  src: url(\"../../../../fonts/boxicons.eot\");\r\n  src: url(\"../../../../fonts/boxicons.eot\") format(\"embedded-opentype\"),\r\n    url(\"../../../../fonts/boxicons.woff2\") format(\"woff2\"),\r\n    url(\"../../../../fonts/boxicons.woff\") format(\"woff\"),\r\n    url(\"../../../../fonts/boxicons.ttf\") format(\"truetype\"),\r\n    url(\"../../../../fonts/boxicons.svg?#boxicons\") format(\"svg\");\r\n}\r\n.bx {\r\n  font-family: \"boxicons\" !important;\r\n  font-weight: normal;\r\n  font-style: normal;\r\n  font-variant: normal;\r\n  line-height: 1;\r\n\r\n  display: inline-block;\r\n\r\n  text-transform: none;\r\n\r\n  speak: none;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n.bx-ul {\r\n  margin-left: 2em;\r\n  padding-left: 0;\r\n\r\n  list-style: none;\r\n}\r\n.bx-ul > li {\r\n  position: relative;\r\n}\r\n.bx-ul .bx {\r\n  font-size: inherit;\r\n  line-height: inherit;\r\n\r\n  position: absolute;\r\n  left: -2em;\r\n\r\n  width: 2em;\r\n\r\n  text-align: center;\r\n}\r\n@-webkit-keyframes spin {\r\n  0% {\r\n    -webkit-transform: rotate(0);\r\n    transform: rotate(0);\r\n  }\r\n  100% {\r\n    -webkit-transform: rotate(359deg);\r\n    transform: rotate(359deg);\r\n  }\r\n}\r\n@keyframes spin {\r\n  0% {\r\n    -webkit-transform: rotate(0);\r\n    transform: rotate(0);\r\n  }\r\n  100% {\r\n    -webkit-transform: rotate(359deg);\r\n    transform: rotate(359deg);\r\n  }\r\n}\r\n@-webkit-keyframes burst {\r\n  0% {\r\n    -webkit-transform: scale(1);\r\n    transform: scale(1);\r\n\r\n    opacity: 1;\r\n  }\r\n  90% {\r\n    -webkit-transform: scale(1.5);\r\n    transform: scale(1.5);\r\n\r\n    opacity: 0;\r\n  }\r\n}\r\n@keyframes burst {\r\n  0% {\r\n    -webkit-transform: scale(1);\r\n    transform: scale(1);\r\n\r\n    opacity: 1;\r\n  }\r\n  90% {\r\n    -webkit-transform: scale(1.5);\r\n    transform: scale(1.5);\r\n\r\n    opacity: 0;\r\n  }\r\n}\r\n@-webkit-keyframes flashing {\r\n  0% {\r\n    opacity: 1;\r\n  }\r\n  45% {\r\n    opacity: 0;\r\n  }\r\n  90% {\r\n    opacity: 1;\r\n  }\r\n}\r\n@keyframes flashing {\r\n  0% {\r\n    opacity: 1;\r\n  }\r\n  45% {\r\n    opacity: 0;\r\n  }\r\n  90% {\r\n    opacity: 1;\r\n  }\r\n}\r\n@-webkit-keyframes fade-left {\r\n  0% {\r\n    -webkit-transform: translateX(0);\r\n    transform: translateX(0);\r\n\r\n    opacity: 1;\r\n  }\r\n  75% {\r\n    -webkit-transform: translateX(-20px);\r\n    transform: translateX(-20px);\r\n\r\n    opacity: 0;\r\n  }\r\n}\r\n@keyframes fade-left {\r\n  0% {\r\n    -webkit-transform: translateX(0);\r\n    transform: translateX(0);\r\n\r\n    opacity: 1;\r\n  }\r\n  75% {\r\n    -webkit-transform: translateX(-20px);\r\n    transform: translateX(-20px);\r\n\r\n    opacity: 0;\r\n  }\r\n}\r\n@-webkit-keyframes fade-right {\r\n  0% {\r\n    -webkit-transform: translateX(0);\r\n    transform: translateX(0);\r\n\r\n    opacity: 1;\r\n  }\r\n  75% {\r\n    -webkit-transform: translateX(20px);\r\n    transform: translateX(20px);\r\n\r\n    opacity: 0;\r\n  }\r\n}\r\n@keyframes fade-right {\r\n  0% {\r\n    -webkit-transform: translateX(0);\r\n    transform: translateX(0);\r\n\r\n    opacity: 1;\r\n  }\r\n  75% {\r\n    -webkit-transform: translateX(20px);\r\n    transform: translateX(20px);\r\n\r\n    opacity: 0;\r\n  }\r\n}\r\n@-webkit-keyframes fade-up {\r\n  0% {\r\n    -webkit-transform: translateY(0);\r\n    transform: translateY(0);\r\n\r\n    opacity: 1;\r\n  }\r\n  75% {\r\n    -webkit-transform: translateY(-20px);\r\n    transform: translateY(-20px);\r\n\r\n    opacity: 0;\r\n  }\r\n}\r\n@keyframes fade-up {\r\n  0% {\r\n    -webkit-transform: translateY(0);\r\n    transform: translateY(0);\r\n\r\n    opacity: 1;\r\n  }\r\n  75% {\r\n    -webkit-transform: translateY(-20px);\r\n    transform: translateY(-20px);\r\n\r\n    opacity: 0;\r\n  }\r\n}\r\n@-webkit-keyframes fade-down {\r\n  0% {\r\n    -webkit-transform: translateY(0);\r\n    transform: translateY(0);\r\n\r\n    opacity: 1;\r\n  }\r\n  75% {\r\n    -webkit-transform: translateY(20px);\r\n    transform: translateY(20px);\r\n\r\n    opacity: 0;\r\n  }\r\n}\r\n@keyframes fade-down {\r\n  0% {\r\n    -webkit-transform: translateY(0);\r\n    transform: translateY(0);\r\n\r\n    opacity: 1;\r\n  }\r\n  75% {\r\n    -webkit-transform: translateY(20px);\r\n    transform: translateY(20px);\r\n\r\n    opacity: 0;\r\n  }\r\n}\r\n@-webkit-keyframes tada {\r\n  from {\r\n    -webkit-transform: scale3d(1, 1, 1);\r\n    transform: scale3d(1, 1, 1);\r\n  }\r\n\r\n  10%,\r\n  20% {\r\n    -webkit-transform: scale3d(0.95, 0.95, 0.95) rotate3d(0, 0, 1, -10deg);\r\n    transform: scale3d(0.95, 0.95, 0.95) rotate3d(0, 0, 1, -10deg);\r\n  }\r\n\r\n  30%,\r\n  50%,\r\n  70%,\r\n  90% {\r\n    -webkit-transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\r\n    transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\r\n  }\r\n\r\n  40%,\r\n  60%,\r\n  80% {\r\n    -webkit-transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, -10deg);\r\n    transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, -10deg);\r\n  }\r\n\r\n  to {\r\n    -webkit-transform: scale3d(1, 1, 1);\r\n    transform: scale3d(1, 1, 1);\r\n  }\r\n}\r\n\r\n@keyframes tada {\r\n  from {\r\n    -webkit-transform: scale3d(1, 1, 1);\r\n    transform: scale3d(1, 1, 1);\r\n  }\r\n\r\n  10%,\r\n  20% {\r\n    -webkit-transform: scale3d(0.95, 0.95, 0.95) rotate3d(0, 0, 1, -10deg);\r\n    transform: scale3d(0.95, 0.95, 0.95) rotate3d(0, 0, 1, -10deg);\r\n  }\r\n\r\n  30%,\r\n  50%,\r\n  70%,\r\n  90% {\r\n    -webkit-transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\r\n    transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\r\n  }\r\n\r\n  40%,\r\n  60%,\r\n  80% {\r\n    -webkit-transform: rotate3d(0, 0, 1, -10deg);\r\n    transform: rotate3d(0, 0, 1, -10deg);\r\n  }\r\n\r\n  to {\r\n    -webkit-transform: scale3d(1, 1, 1);\r\n    transform: scale3d(1, 1, 1);\r\n  }\r\n}\r\n.bx-spin {\r\n  -webkit-animation: spin 2s linear infinite;\r\n  animation: spin 2s linear infinite;\r\n}\r\n.bx-spin-hover:hover {\r\n  -webkit-animation: spin 2s linear infinite;\r\n  animation: spin 2s linear infinite;\r\n}\r\n\r\n.bx-tada {\r\n  -webkit-animation: tada 1.5s ease infinite;\r\n  animation: tada 1.5s ease infinite;\r\n}\r\n.bx-tada-hover:hover {\r\n  -webkit-animation: tada 1.5s ease infinite;\r\n  animation: tada 1.5s ease infinite;\r\n}\r\n\r\n.bx-flashing {\r\n  -webkit-animation: flashing 1.5s infinite linear;\r\n  animation: flashing 1.5s infinite linear;\r\n}\r\n.bx-flashing-hover:hover {\r\n  -webkit-animation: flashing 1.5s infinite linear;\r\n  animation: flashing 1.5s infinite linear;\r\n}\r\n\r\n.bx-burst {\r\n  -webkit-animation: burst 1.5s infinite linear;\r\n  animation: burst 1.5s infinite linear;\r\n}\r\n.bx-burst-hover:hover {\r\n  -webkit-animation: burst 1.5s infinite linear;\r\n  animation: burst 1.5s infinite linear;\r\n}\r\n.bx-fade-up {\r\n  -webkit-animation: fade-up 1.5s infinite linear;\r\n  animation: fade-up 1.5s infinite linear;\r\n}\r\n.bx-fade-up-hover:hover {\r\n  -webkit-animation: fade-up 1.5s infinite linear;\r\n  animation: fade-up 1.5s infinite linear;\r\n}\r\n.bx-fade-down {\r\n  -webkit-animation: fade-down 1.5s infinite linear;\r\n  animation: fade-down 1.5s infinite linear;\r\n}\r\n.bx-fade-down-hover:hover {\r\n  -webkit-animation: fade-down 1.5s infinite linear;\r\n  animation: fade-down 1.5s infinite linear;\r\n}\r\n.bx-fade-left {\r\n  -webkit-animation: fade-left 1.5s infinite linear;\r\n  animation: fade-left 1.5s infinite linear;\r\n}\r\n.bx-fade-left-hover:hover {\r\n  -webkit-animation: fade-left 1.5s infinite linear;\r\n  animation: fade-left 1.5s infinite linear;\r\n}\r\n.bx-fade-right {\r\n  -webkit-animation: fade-right 1.5s infinite linear;\r\n  animation: fade-right 1.5s infinite linear;\r\n}\r\n.bx-fade-right-hover:hover {\r\n  -webkit-animation: fade-right 1.5s infinite linear;\r\n  animation: fade-right 1.5s infinite linear;\r\n}\r\n.bx-xs {\r\n  font-size: 1rem !important;\r\n}\r\n.bx-sm {\r\n  font-size: 1.55rem !important;\r\n}\r\n.bx-md {\r\n  font-size: 2.25rem !important;\r\n}\r\n.bx-fw {\r\n  font-size: 1.2857142857em;\r\n  line-height: 0.8em;\r\n\r\n  width: 1.2857142857em;\r\n  height: 0.8em;\r\n  margin-top: -0.2em !important;\r\n\r\n  vertical-align: middle;\r\n}\r\n\r\n.bx-lg {\r\n  font-size: 3rem !important;\r\n}\r\n.bx-pull-left {\r\n  float: left;\r\n\r\n  margin-right: 0.3em !important;\r\n}\r\n\r\n.bx-pull-right {\r\n  float: right;\r\n\r\n  margin-left: 0.3em !important;\r\n}\r\n.bx-rotate-90 {\r\n  transform: rotate(90deg);\r\n\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\r\n}\r\n.bx-rotate-180 {\r\n  transform: rotate(180deg);\r\n\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\r\n}\r\n.bx-rotate-270 {\r\n  transform: rotate(270deg);\r\n\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\r\n}\r\n.bx-flip-horizontal {\r\n  transform: scaleX(-1);\r\n\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\r\n}\r\n.bx-flip-vertical {\r\n  transform: scaleY(-1);\r\n\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\r\n}\r\n.bx-border {\r\n  padding: 0.25em;\r\n\r\n  border: 0.07em solid rgba(0, 0, 0, 0.1);\r\n  border-radius: 0.25em;\r\n}\r\n.bx-border-circle {\r\n  padding: 0.25em;\r\n\r\n  border: 0.07em solid rgba(0, 0, 0, 0.1);\r\n  border-radius: 50%;\r\n}\r\n\r\n.bxl-adobe:before {\r\n  content: \"\\e900\";\r\n}\r\n.bxl-algolia:before {\r\n  content: \"\\e901\";\r\n}\r\n.bxl-audible:before {\r\n  content: \"\\e902\";\r\n}\r\n.bxl-figma:before {\r\n  content: \"\\e903\";\r\n}\r\n.bxl-redbubble:before {\r\n  content: \"\\e904\";\r\n}\r\n.bxl-etsy:before {\r\n  content: \"\\e905\";\r\n}\r\n.bxl-gitlab:before {\r\n  content: \"\\e906\";\r\n}\r\n.bxl-patreon:before {\r\n  content: \"\\e907\";\r\n}\r\n.bxl-facebook-circle:before {\r\n  content: \"\\e908\";\r\n}\r\n.bxl-imdb:before {\r\n  content: \"\\e909\";\r\n}\r\n.bxl-jquery:before {\r\n  content: \"\\e90a\";\r\n}\r\n.bxl-pinterest-alt:before {\r\n  content: \"\\e90b\";\r\n}\r\n.bxl-500px:before {\r\n  content: \"\\e90c\";\r\n}\r\n.bxl-airbnb:before {\r\n  content: \"\\e90d\";\r\n}\r\n.bxl-amazon:before {\r\n  content: \"\\e90e\";\r\n}\r\n.bxl-android:before {\r\n  content: \"\\e90f\";\r\n}\r\n.bxl-angular:before {\r\n  content: \"\\e910\";\r\n}\r\n.bxl-apple:before {\r\n  content: \"\\e911\";\r\n}\r\n.bxl-baidu:before {\r\n  content: \"\\e912\";\r\n}\r\n.bxl-behance:before {\r\n  content: \"\\e913\";\r\n}\r\n.bxl-bing:before {\r\n  content: \"\\e914\";\r\n}\r\n.bxl-bitcoin:before {\r\n  content: \"\\e915\";\r\n}\r\n.bxl-blogger:before {\r\n  content: \"\\e916\";\r\n}\r\n.bxl-bootstrap:before {\r\n  content: \"\\e917\";\r\n}\r\n.bxl-chrome:before {\r\n  content: \"\\e918\";\r\n}\r\n.bxl-codepen:before {\r\n  content: \"\\e919\";\r\n}\r\n.bxl-creative-commons:before {\r\n  content: \"\\e91a\";\r\n}\r\n.bxl-css3:before {\r\n  content: \"\\e91b\";\r\n}\r\n.bxl-dailymotion:before {\r\n  content: \"\\e91c\";\r\n}\r\n.bxl-deviantart:before {\r\n  content: \"\\e91d\";\r\n}\r\n.bxl-digg:before {\r\n  content: \"\\e91e\";\r\n}\r\n.bxl-digitalocean:before {\r\n  content: \"\\e91f\";\r\n}\r\n.bxl-discord:before {\r\n  content: \"\\e920\";\r\n}\r\n.bxl-discourse:before {\r\n  content: \"\\e921\";\r\n}\r\n.bxl-dribbble:before {\r\n  content: \"\\e922\";\r\n}\r\n.bxl-dropbox:before {\r\n  content: \"\\e923\";\r\n}\r\n.bxl-drupal:before {\r\n  content: \"\\e924\";\r\n}\r\n.bxl-ebay:before {\r\n  content: \"\\e925\";\r\n}\r\n.bxl-edge:before {\r\n  content: \"\\e926\";\r\n}\r\n.bxl-facebook:before {\r\n  content: \"\\e927\";\r\n}\r\n.bxl-facebook-square:before {\r\n  content: \"\\e928\";\r\n}\r\n.bxl-firefox:before {\r\n  content: \"\\e929\";\r\n}\r\n.bxl-flickr:before {\r\n  content: \"\\e92a\";\r\n}\r\n.bxl-flickr-square:before {\r\n  content: \"\\e92b\";\r\n}\r\n.bxl-foursquare:before {\r\n  content: \"\\e92c\";\r\n}\r\n.bxl-git:before {\r\n  content: \"\\e92d\";\r\n}\r\n.bxl-github:before {\r\n  content: \"\\e92e\";\r\n}\r\n.bxl-google:before {\r\n  content: \"\\e92f\";\r\n}\r\n.bxl-google-plus:before {\r\n  content: \"\\e930\";\r\n}\r\n.bxl-google-plus-circle:before {\r\n  content: \"\\e931\";\r\n}\r\n.bxl-html5:before {\r\n  content: \"\\e932\";\r\n}\r\n.bxl-instagram:before {\r\n  content: \"\\e933\";\r\n}\r\n.bxl-instagram-alt:before {\r\n  content: \"\\e934\";\r\n}\r\n.bxl-internet-explorer:before {\r\n  content: \"\\e935\";\r\n}\r\n.bxl-invision:before {\r\n  content: \"\\e936\";\r\n}\r\n.bxl-javascript:before {\r\n  content: \"\\e937\";\r\n}\r\n.bxl-joomla:before {\r\n  content: \"\\e938\";\r\n}\r\n.bxl-jsfiddle:before {\r\n  content: \"\\e939\";\r\n}\r\n.bxl-kickstarter:before {\r\n  content: \"\\e93a\";\r\n}\r\n.bxl-less:before {\r\n  content: \"\\e93b\";\r\n}\r\n.bxl-linkedin:before {\r\n  content: \"\\e93c\";\r\n}\r\n.bxl-linkedin-square:before {\r\n  content: \"\\e93d\";\r\n}\r\n.bxl-magento:before {\r\n  content: \"\\e93e\";\r\n}\r\n.bxl-mailchimp:before {\r\n  content: \"\\e93f\";\r\n}\r\n.bxl-mastercard:before {\r\n  content: \"\\e940\";\r\n}\r\n.bxl-medium:before {\r\n  content: \"\\e941\";\r\n}\r\n.bxl-medium-old:before {\r\n  content: \"\\e942\";\r\n}\r\n.bxl-medium-square:before {\r\n  content: \"\\e943\";\r\n}\r\n.bxl-messenger:before {\r\n  content: \"\\e944\";\r\n}\r\n.bxl-microsoft:before {\r\n  content: \"\\e945\";\r\n}\r\n.bxl-nodejs:before {\r\n  content: \"\\e946\";\r\n}\r\n.bxl-opera:before {\r\n  content: \"\\e947\";\r\n}\r\n.bxl-paypal:before {\r\n  content: \"\\e948\";\r\n}\r\n.bxl-periscope:before {\r\n  content: \"\\e949\";\r\n}\r\n.bxl-pinterest:before {\r\n  content: \"\\e94a\";\r\n}\r\n.bxl-play-store:before {\r\n  content: \"\\e94b\";\r\n}\r\n.bxl-pocket:before {\r\n  content: \"\\e94c\";\r\n}\r\n.bxl-product-hunt:before {\r\n  content: \"\\e94d\";\r\n}\r\n.bxl-quora:before {\r\n  content: \"\\e94e\";\r\n}\r\n.bxl-react:before {\r\n  content: \"\\e94f\";\r\n}\r\n.bxl-reddit:before {\r\n  content: \"\\e950\";\r\n}\r\n.bxl-redux:before {\r\n  content: \"\\e951\";\r\n}\r\n.bxl-sass:before {\r\n  content: \"\\e952\";\r\n}\r\n.bxl-shopify:before {\r\n  content: \"\\e953\";\r\n}\r\n.bxl-skype:before {\r\n  content: \"\\e954\";\r\n}\r\n.bxl-slack:before {\r\n  content: \"\\e955\";\r\n}\r\n.bxl-slack-old:before {\r\n  content: \"\\e956\";\r\n}\r\n.bxl-snapchat:before {\r\n  content: \"\\e957\";\r\n}\r\n.bxl-soundcloud:before {\r\n  content: \"\\e958\";\r\n}\r\n.bxl-spotify:before {\r\n  content: \"\\e959\";\r\n}\r\n.bxl-squarespace:before {\r\n  content: \"\\e95a\";\r\n}\r\n.bxl-stack-overflow:before {\r\n  content: \"\\e95b\";\r\n}\r\n.bxl-stripe:before {\r\n  content: \"\\e95c\";\r\n}\r\n.bxl-telegram:before {\r\n  content: \"\\e95d\";\r\n}\r\n.bxl-trello:before {\r\n  content: \"\\e95e\";\r\n}\r\n.bxl-tumblr:before {\r\n  content: \"\\e95f\";\r\n}\r\n.bxl-twitch:before {\r\n  content: \"\\e960\";\r\n}\r\n.bxl-twitter:before {\r\n  content: \"\\e961\";\r\n}\r\n.bxl-unsplash:before {\r\n  content: \"\\e962\";\r\n}\r\n.bxl-vimeo:before {\r\n  content: \"\\e963\";\r\n}\r\n.bxl-visa:before {\r\n  content: \"\\e964\";\r\n}\r\n.bxl-vk:before {\r\n  content: \"\\e965\";\r\n}\r\n.bxl-vuejs:before {\r\n  content: \"\\e966\";\r\n}\r\n.bxl-whatsapp:before {\r\n  content: \"\\e967\";\r\n}\r\n.bxl-whatsapp-square:before {\r\n  content: \"\\e968\";\r\n}\r\n.bxl-wikipedia:before {\r\n  content: \"\\e969\";\r\n}\r\n.bxl-windows:before {\r\n  content: \"\\e96a\";\r\n}\r\n.bxl-wix:before {\r\n  content: \"\\e96b\";\r\n}\r\n.bxl-wordpress:before {\r\n  content: \"\\e96c\";\r\n}\r\n.bxl-yahoo:before {\r\n  content: \"\\e96d\";\r\n}\r\n.bxl-yelp:before {\r\n  content: \"\\e96e\";\r\n}\r\n.bxl-youtube:before {\r\n  content: \"\\e96f\";\r\n}\r\n.bx-accessibility:before {\r\n  content: \"\\e970\";\r\n}\r\n.bx-add-to-queue:before {\r\n  content: \"\\e971\";\r\n}\r\n.bx-adjust:before {\r\n  content: \"\\e972\";\r\n}\r\n.bx-alarm:before {\r\n  content: \"\\e973\";\r\n}\r\n.bx-alarm-add:before {\r\n  content: \"\\e974\";\r\n}\r\n.bx-alarm-off:before {\r\n  content: \"\\e975\";\r\n}\r\n.bx-album:before {\r\n  content: \"\\e976\";\r\n}\r\n.bx-align-justify:before {\r\n  content: \"\\e977\";\r\n}\r\n.bx-align-left:before {\r\n  content: \"\\e978\";\r\n}\r\n.bx-align-middle:before {\r\n  content: \"\\e979\";\r\n}\r\n.bx-align-right:before {\r\n  content: \"\\e97a\";\r\n}\r\n.bx-analyse:before {\r\n  content: \"\\e97b\";\r\n}\r\n.bx-anchor:before {\r\n  content: \"\\e97c\";\r\n}\r\n.bx-angry:before {\r\n  content: \"\\e97d\";\r\n}\r\n.bx-aperture:before {\r\n  content: \"\\e97e\";\r\n}\r\n.bx-archive:before {\r\n  content: \"\\e97f\";\r\n}\r\n.bx-archive-in:before {\r\n  content: \"\\e980\";\r\n}\r\n.bx-archive-out:before {\r\n  content: \"\\e981\";\r\n}\r\n.bx-area:before {\r\n  content: \"\\e982\";\r\n}\r\n.bx-arrow-back:before {\r\n  content: \"\\e983\";\r\n}\r\n.bx-at:before {\r\n  content: \"\\e984\";\r\n}\r\n.bx-award:before {\r\n  content: \"\\e985\";\r\n}\r\n.bx-badge:before {\r\n  content: \"\\e986\";\r\n}\r\n.bx-badge-check:before {\r\n  content: \"\\e987\";\r\n}\r\n.bx-ball:before {\r\n  content: \"\\e988\";\r\n}\r\n.bx-band-aid:before {\r\n  content: \"\\e989\";\r\n}\r\n.bx-bar-chart:before {\r\n  content: \"\\e98a\";\r\n}\r\n.bx-bar-chart-alt:before {\r\n  content: \"\\e98b\";\r\n}\r\n.bx-bar-chart-alt-2:before {\r\n  content: \"\\e98c\";\r\n}\r\n.bx-bar-chart-square:before {\r\n  content: \"\\e98d\";\r\n}\r\n.bx-barcode:before {\r\n  content: \"\\e98e\";\r\n}\r\n.bx-basket:before {\r\n  content: \"\\e98f\";\r\n}\r\n.bx-basketball:before {\r\n  content: \"\\e990\";\r\n}\r\n.bx-bath:before {\r\n  content: \"\\e991\";\r\n}\r\n.bx-battery:before {\r\n  content: \"\\e992\";\r\n}\r\n.bx-bed:before {\r\n  content: \"\\e993\";\r\n}\r\n.bx-bell:before {\r\n  content: \"\\e994\";\r\n}\r\n.bx-bell-minus:before {\r\n  content: \"\\e995\";\r\n}\r\n.bx-bell-off:before {\r\n  content: \"\\e996\";\r\n}\r\n.bx-bell-plus:before {\r\n  content: \"\\e997\";\r\n}\r\n.bx-bitcoin:before {\r\n  content: \"\\e998\";\r\n}\r\n.bx-block:before {\r\n  content: \"\\e999\";\r\n}\r\n.bx-bluetooth:before {\r\n  content: \"\\e99a\";\r\n}\r\n.bx-body:before {\r\n  content: \"\\e99b\";\r\n}\r\n.bx-bold:before {\r\n  content: \"\\e99c\";\r\n}\r\n.bx-bolt-circle:before {\r\n  content: \"\\e99d\";\r\n}\r\n.bx-book:before {\r\n  content: \"\\e99e\";\r\n}\r\n.bx-book-bookmark:before {\r\n  content: \"\\e99f\";\r\n}\r\n.bx-book-content:before {\r\n  content: \"\\e9a0\";\r\n}\r\n.bx-bookmark:before {\r\n  content: \"\\e9a1\";\r\n}\r\n.bx-bookmark-minus:before {\r\n  content: \"\\e9a2\";\r\n}\r\n.bx-bookmark-plus:before {\r\n  content: \"\\e9a3\";\r\n}\r\n.bx-bookmarks:before {\r\n  content: \"\\e9a4\";\r\n}\r\n.bx-book-open:before {\r\n  content: \"\\e9a5\";\r\n}\r\n.bx-border-all:before {\r\n  content: \"\\e9a6\";\r\n}\r\n.bx-border-bottom:before {\r\n  content: \"\\e9a7\";\r\n}\r\n.bx-border-left:before {\r\n  content: \"\\e9a8\";\r\n}\r\n.bx-border-radius:before {\r\n  content: \"\\e9a9\";\r\n}\r\n.bx-border-right:before {\r\n  content: \"\\e9aa\";\r\n}\r\n.bx-border-top:before {\r\n  content: \"\\e9ab\";\r\n}\r\n.bx-bot:before {\r\n  content: \"\\e9ac\";\r\n}\r\n.bx-bowling-ball:before {\r\n  content: \"\\e9ad\";\r\n}\r\n.bx-box:before {\r\n  content: \"\\e9ae\";\r\n}\r\n.bx-briefcase:before {\r\n  content: \"\\e9af\";\r\n}\r\n.bx-briefcase-alt:before {\r\n  content: \"\\e9b0\";\r\n}\r\n.bx-briefcase-alt-2:before {\r\n  content: \"\\e9b1\";\r\n}\r\n.bx-brightness:before {\r\n  content: \"\\e9b2\";\r\n}\r\n.bx-brightness-half:before {\r\n  content: \"\\e9b3\";\r\n}\r\n.bx-broadcast:before {\r\n  content: \"\\e9b4\";\r\n}\r\n.bx-brush:before {\r\n  content: \"\\e9b5\";\r\n}\r\n.bx-brush-alt:before {\r\n  content: \"\\e9b6\";\r\n}\r\n.bx-bug:before {\r\n  content: \"\\e9b7\";\r\n}\r\n.bx-bug-alt:before {\r\n  content: \"\\e9b8\";\r\n}\r\n.bx-building:before {\r\n  content: \"\\e9b9\";\r\n}\r\n.bx-building-house:before {\r\n  content: \"\\e9ba\";\r\n}\r\n.bx-buildings:before {\r\n  content: \"\\e9bb\";\r\n}\r\n.bx-bulb:before {\r\n  content: \"\\e9bc\";\r\n}\r\n.bx-bullseye:before {\r\n  content: \"\\e9bd\";\r\n}\r\n.bx-buoy:before {\r\n  content: \"\\e9be\";\r\n}\r\n.bx-bus:before {\r\n  content: \"\\e9bf\";\r\n}\r\n.bx-cake:before {\r\n  content: \"\\e9c0\";\r\n}\r\n.bx-calculator:before {\r\n  content: \"\\e9c1\";\r\n}\r\n.bx-calendar:before {\r\n  content: \"\\e9c2\";\r\n}\r\n.bx-calendar-alt:before {\r\n  content: \"\\e9c3\";\r\n}\r\n.bx-calendar-check:before {\r\n  content: \"\\e9c4\";\r\n}\r\n.bx-calendar-event:before {\r\n  content: \"\\e9c5\";\r\n}\r\n.bx-calendar-minus:before {\r\n  content: \"\\e9c6\";\r\n}\r\n.bx-calendar-plus:before {\r\n  content: \"\\e9c7\";\r\n}\r\n.bx-calendar-x:before {\r\n  content: \"\\e9c8\";\r\n}\r\n.bx-camera:before {\r\n  content: \"\\e9c9\";\r\n}\r\n.bx-camera-off:before {\r\n  content: \"\\e9ca\";\r\n}\r\n.bx-captions:before {\r\n  content: \"\\e9cb\";\r\n}\r\n.bx-car:before {\r\n  content: \"\\e9cc\";\r\n}\r\n.bx-card:before {\r\n  content: \"\\e9cd\";\r\n}\r\n.bx-caret-down:before {\r\n  content: \"\\e9ce\";\r\n}\r\n.bx-caret-left:before {\r\n  content: \"\\e9cf\";\r\n}\r\n.bx-caret-right:before {\r\n  content: \"\\e9d0\";\r\n}\r\n.bx-caret-up:before {\r\n  content: \"\\e9d1\";\r\n}\r\n.bx-carousel:before {\r\n  content: \"\\e9d2\";\r\n}\r\n.bx-cart:before {\r\n  content: \"\\e9d3\";\r\n}\r\n.bx-cart-alt:before {\r\n  content: \"\\e9d4\";\r\n}\r\n.bx-cast:before {\r\n  content: \"\\e9d5\";\r\n}\r\n.bx-certification:before {\r\n  content: \"\\e9d6\";\r\n}\r\n.bx-chalkboard:before {\r\n  content: \"\\e9d7\";\r\n}\r\n.bx-chart:before {\r\n  content: \"\\e9d8\";\r\n}\r\n.bx-chat:before {\r\n  content: \"\\e9d9\";\r\n}\r\n.bx-check:before {\r\n  content: \"\\e9da\";\r\n}\r\n.bx-checkbox:before {\r\n  content: \"\\e9db\";\r\n}\r\n.bx-checkbox-checked:before {\r\n  content: \"\\e9dc\";\r\n}\r\n.bx-checkbox-square:before {\r\n  content: \"\\e9dd\";\r\n}\r\n.bx-check-circle:before {\r\n  content: \"\\e9de\";\r\n}\r\n.bx-check-double:before {\r\n  content: \"\\e9df\";\r\n}\r\n.bx-check-shield:before {\r\n  content: \"\\e9e0\";\r\n}\r\n.bx-check-square:before {\r\n  content: \"\\e9e1\";\r\n}\r\n.bx-chevron-down:before {\r\n  content: \"\\e9e2\";\r\n}\r\n.bx-chevron-left:before {\r\n  content: \"\\e9e3\";\r\n}\r\n.bx-chevron-right:before {\r\n  content: \"\\e9e4\";\r\n}\r\n.bx-chevrons-down:before {\r\n  content: \"\\e9e5\";\r\n}\r\n.bx-chevrons-left:before {\r\n  content: \"\\e9e6\";\r\n}\r\n.bx-chevrons-right:before {\r\n  content: \"\\e9e7\";\r\n}\r\n.bx-chevrons-up:before {\r\n  content: \"\\e9e8\";\r\n}\r\n.bx-chevron-up:before {\r\n  content: \"\\e9e9\";\r\n}\r\n.bx-chip:before {\r\n  content: \"\\e9ea\";\r\n}\r\n.bx-circle:before {\r\n  content: \"\\e9eb\";\r\n}\r\n.bx-clinic:before {\r\n  content: \"\\e9ec\";\r\n}\r\n.bx-clipboard:before {\r\n  content: \"\\e9ed\";\r\n}\r\n.bx-closet:before {\r\n  content: \"\\e9ee\";\r\n}\r\n.bx-cloud:before {\r\n  content: \"\\e9ef\";\r\n}\r\n.bx-cloud-download:before {\r\n  content: \"\\e9f0\";\r\n}\r\n.bx-cloud-drizzle:before {\r\n  content: \"\\e9f1\";\r\n}\r\n.bx-cloud-lightning:before {\r\n  content: \"\\e9f2\";\r\n}\r\n.bx-cloud-light-rain:before {\r\n  content: \"\\e9f3\";\r\n}\r\n.bx-cloud-rain:before {\r\n  content: \"\\e9f4\";\r\n}\r\n.bx-cloud-snow:before {\r\n  content: \"\\e9f5\";\r\n}\r\n.bx-cloud-upload:before {\r\n  content: \"\\e9f6\";\r\n}\r\n.bx-code:before {\r\n  content: \"\\e9f7\";\r\n}\r\n.bx-code-alt:before {\r\n  content: \"\\e9f8\";\r\n}\r\n.bx-code-block:before {\r\n  content: \"\\e9f9\";\r\n}\r\n.bx-code-curly:before {\r\n  content: \"\\e9fa\";\r\n}\r\n.bx-coffee:before {\r\n  content: \"\\e9fb\";\r\n}\r\n.bx-cog:before {\r\n  content: \"\\e9fc\";\r\n}\r\n.bx-collapse:before {\r\n  content: \"\\e9fd\";\r\n}\r\n.bx-collection:before {\r\n  content: \"\\e9fe\";\r\n}\r\n.bx-columns:before {\r\n  content: \"\\e9ff\";\r\n}\r\n.bx-command:before {\r\n  content: \"\\ea00\";\r\n}\r\n.bx-comment:before {\r\n  content: \"\\ea01\";\r\n}\r\n.bx-comment-dots:before {\r\n  content: \"\\ea02\";\r\n}\r\n.bx-compass:before {\r\n  content: \"\\ea03\";\r\n}\r\n.bx-confused:before {\r\n  content: \"\\ea04\";\r\n}\r\n.bx-conversation:before {\r\n  content: \"\\ea05\";\r\n}\r\n.bx-cool:before {\r\n  content: \"\\ea06\";\r\n}\r\n.bx-copy:before {\r\n  content: \"\\ea07\";\r\n}\r\n.bx-copy-alt:before {\r\n  content: \"\\ea08\";\r\n}\r\n.bx-copyright:before {\r\n  content: \"\\ea09\";\r\n}\r\n.bx-credit-card:before {\r\n  content: \"\\ea0a\";\r\n}\r\n.bx-credit-card-alt:before {\r\n  content: \"\\ea0b\";\r\n}\r\n.bx-crop:before {\r\n  content: \"\\ea0c\";\r\n}\r\n.bx-crosshair:before {\r\n  content: \"\\ea0d\";\r\n}\r\n.bx-crown:before {\r\n  content: \"\\ea0e\";\r\n}\r\n.bx-cube:before {\r\n  content: \"\\ea0f\";\r\n}\r\n.bx-cube-alt:before {\r\n  content: \"\\ea10\";\r\n}\r\n.bx-cuboid:before {\r\n  content: \"\\ea11\";\r\n}\r\n.bx-customize:before {\r\n  content: \"\\ea12\";\r\n}\r\n.bx-cut:before {\r\n  content: \"\\ea13\";\r\n}\r\n.bx-cycling:before {\r\n  content: \"\\ea14\";\r\n}\r\n.bx-cylinder:before {\r\n  content: \"\\ea15\";\r\n}\r\n.bx-data:before {\r\n  content: \"\\ea16\";\r\n}\r\n.bx-desktop:before {\r\n  content: \"\\ea17\";\r\n}\r\n.bx-detail:before {\r\n  content: \"\\ea18\";\r\n}\r\n.bx-devices:before {\r\n  content: \"\\ea19\";\r\n}\r\n.bx-dialpad:before {\r\n  content: \"\\ea1a\";\r\n}\r\n.bx-dialpad-alt:before {\r\n  content: \"\\ea1b\";\r\n}\r\n.bx-diamond:before {\r\n  content: \"\\ea1c\";\r\n}\r\n.bx-directions:before {\r\n  content: \"\\ea1d\";\r\n}\r\n.bx-disc:before {\r\n  content: \"\\ea1e\";\r\n}\r\n.bx-dish:before {\r\n  content: \"\\ea1f\";\r\n}\r\n.bx-dislike:before {\r\n  content: \"\\ea20\";\r\n}\r\n.bx-dizzy:before {\r\n  content: \"\\ea21\";\r\n}\r\n.bx-dna:before {\r\n  content: \"\\ea22\";\r\n}\r\n.bx-dock-bottom:before {\r\n  content: \"\\ea23\";\r\n}\r\n.bx-dock-left:before {\r\n  content: \"\\ea24\";\r\n}\r\n.bx-dock-right:before {\r\n  content: \"\\ea25\";\r\n}\r\n.bx-dock-top:before {\r\n  content: \"\\ea26\";\r\n}\r\n.bx-dollar:before {\r\n  content: \"\\ea27\";\r\n}\r\n.bx-dollar-circle:before {\r\n  content: \"\\ea28\";\r\n}\r\n.bx-dots-horizontal:before {\r\n  content: \"\\ea29\";\r\n}\r\n.bx-dots-horizontal-rounded:before {\r\n  content: \"\\ea2a\";\r\n}\r\n.bx-dots-vertical:before {\r\n  content: \"\\ea2b\";\r\n}\r\n.bx-dots-vertical-rounded:before {\r\n  content: \"\\ea2c\";\r\n}\r\n.bx-doughnut-chart:before {\r\n  content: \"\\ea2d\";\r\n}\r\n.bx-down-arrow:before {\r\n  content: \"\\ea2e\";\r\n}\r\n.bx-down-arrow-alt:before {\r\n  content: \"\\ea2f\";\r\n}\r\n.bx-down-arrow-circle:before {\r\n  content: \"\\ea30\";\r\n}\r\n.bx-download:before {\r\n  content: \"\\ea31\";\r\n}\r\n.bx-downvote:before {\r\n  content: \"\\ea32\";\r\n}\r\n.bx-droplet:before {\r\n  content: \"\\ea33\";\r\n}\r\n.bx-dumbbell:before {\r\n  content: \"\\ea34\";\r\n}\r\n.bx-duplicate:before {\r\n  content: \"\\ea35\";\r\n}\r\n.bx-edit:before {\r\n  content: \"\\ea36\";\r\n}\r\n.bx-edit-alt:before {\r\n  content: \"\\ea37\";\r\n}\r\n.bx-envelope:before {\r\n  content: \"\\ea38\";\r\n}\r\n.bx-equalizer:before {\r\n  content: \"\\ea39\";\r\n}\r\n.bx-error:before {\r\n  content: \"\\ea3a\";\r\n}\r\n.bx-error-alt:before {\r\n  content: \"\\ea3b\";\r\n}\r\n.bx-error-circle:before {\r\n  content: \"\\ea3c\";\r\n}\r\n.bx-euro:before {\r\n  content: \"\\ea3d\";\r\n}\r\n.bx-exit:before {\r\n  content: \"\\ea3e\";\r\n}\r\n.bx-exit-fullscreen:before {\r\n  content: \"\\ea3f\";\r\n}\r\n.bx-expand:before {\r\n  content: \"\\ea40\";\r\n}\r\n.bx-export:before {\r\n  content: \"\\ea41\";\r\n}\r\n.bx-extension:before {\r\n  content: \"\\ea42\";\r\n}\r\n.bx-face:before {\r\n  content: \"\\ea43\";\r\n}\r\n.bx-fast-forward:before {\r\n  content: \"\\ea44\";\r\n}\r\n.bx-fast-forward-circle:before {\r\n  content: \"\\ea45\";\r\n}\r\n.bx-female:before {\r\n  content: \"\\ea46\";\r\n}\r\n.bx-female-sign:before {\r\n  content: \"\\ea47\";\r\n}\r\n.bx-file:before {\r\n  content: \"\\ea48\";\r\n}\r\n.bx-file-blank:before {\r\n  content: \"\\ea49\";\r\n}\r\n.bx-file-find:before {\r\n  content: \"\\ea4a\";\r\n}\r\n.bx-film:before {\r\n  content: \"\\ea4b\";\r\n}\r\n.bx-filter:before {\r\n  content: \"\\ea4c\";\r\n}\r\n.bx-filter-alt:before {\r\n  content: \"\\ea4d\";\r\n}\r\n.bx-fingerprint:before {\r\n  content: \"\\ea4e\";\r\n}\r\n.bx-first-aid:before {\r\n  content: \"\\ea4f\";\r\n}\r\n.bx-first-page:before {\r\n  content: \"\\ea50\";\r\n}\r\n.bx-flag:before {\r\n  content: \"\\ea51\";\r\n}\r\n.bx-folder:before {\r\n  content: \"\\ea52\";\r\n}\r\n.bx-folder-minus:before {\r\n  content: \"\\ea53\";\r\n}\r\n.bx-folder-open:before {\r\n  content: \"\\ea54\";\r\n}\r\n.bx-folder-plus:before {\r\n  content: \"\\ea55\";\r\n}\r\n.bx-font:before {\r\n  content: \"\\ea56\";\r\n}\r\n.bx-font-color:before {\r\n  content: \"\\ea57\";\r\n}\r\n.bx-font-family:before {\r\n  content: \"\\ea58\";\r\n}\r\n.bx-font-size:before {\r\n  content: \"\\ea59\";\r\n}\r\n.bx-food-menu:before {\r\n  content: \"\\ea5a\";\r\n}\r\n.bx-food-tag:before {\r\n  content: \"\\ea5b\";\r\n}\r\n.bx-football:before {\r\n  content: \"\\ea5c\";\r\n}\r\n.bx-fridge:before {\r\n  content: \"\\ea5d\";\r\n}\r\n.bx-fullscreen:before {\r\n  content: \"\\ea5e\";\r\n}\r\n.bx-gas-pump:before {\r\n  content: \"\\ea5f\";\r\n}\r\n.bx-ghost:before {\r\n  content: \"\\ea60\";\r\n}\r\n.bx-gift:before {\r\n  content: \"\\ea61\";\r\n}\r\n.bx-git-branch:before {\r\n  content: \"\\ea62\";\r\n}\r\n.bx-git-commit:before {\r\n  content: \"\\ea63\";\r\n}\r\n.bx-git-compare:before {\r\n  content: \"\\ea64\";\r\n}\r\n.bx-git-merge:before {\r\n  content: \"\\ea65\";\r\n}\r\n.bx-git-pull-request:before {\r\n  content: \"\\ea66\";\r\n}\r\n.bx-git-repo-forked:before {\r\n  content: \"\\ea67\";\r\n}\r\n.bx-globe:before {\r\n  content: \"\\ea68\";\r\n}\r\n.bx-globe-alt:before {\r\n  content: \"\\ea69\";\r\n}\r\n.bx-grid:before {\r\n  content: \"\\ea6a\";\r\n}\r\n.bx-grid-alt:before {\r\n  content: \"\\ea6b\";\r\n}\r\n.bx-grid-horizontal:before {\r\n  content: \"\\ea6c\";\r\n}\r\n.bx-grid-small:before {\r\n  content: \"\\ea6d\";\r\n}\r\n.bx-grid-vertical:before {\r\n  content: \"\\ea6e\";\r\n}\r\n.bx-group:before {\r\n  content: \"\\ea6f\";\r\n}\r\n.bx-handicap:before {\r\n  content: \"\\ea70\";\r\n}\r\n.bx-happy:before {\r\n  content: \"\\ea71\";\r\n}\r\n.bx-happy-alt:before {\r\n  content: \"\\ea72\";\r\n}\r\n.bx-happy-beaming:before {\r\n  content: \"\\ea73\";\r\n}\r\n.bx-happy-heart-eyes:before {\r\n  content: \"\\ea74\";\r\n}\r\n.bx-hash:before {\r\n  content: \"\\ea75\";\r\n}\r\n.bx-hdd:before {\r\n  content: \"\\ea76\";\r\n}\r\n.bx-heading:before {\r\n  content: \"\\ea77\";\r\n}\r\n.bx-headphone:before {\r\n  content: \"\\ea78\";\r\n}\r\n.bx-health:before {\r\n  content: \"\\ea79\";\r\n}\r\n.bx-heart:before {\r\n  content: \"\\ea7a\";\r\n}\r\n.bx-help-circle:before {\r\n  content: \"\\ea7b\";\r\n}\r\n.bx-hide:before {\r\n  content: \"\\ea7c\";\r\n}\r\n.bx-highlight:before {\r\n  content: \"\\ea7d\";\r\n}\r\n.bx-history:before {\r\n  content: \"\\ea7e\";\r\n}\r\n.bx-hive:before {\r\n  content: \"\\ea7f\";\r\n}\r\n.bx-home:before {\r\n  content: \"\\ea80\";\r\n}\r\n.bx-home-alt:before {\r\n  content: \"\\ea81\";\r\n}\r\n.bx-home-circle:before {\r\n  content: \"\\ea82\";\r\n}\r\n.bx-horizontal-center:before {\r\n  content: \"\\ea83\";\r\n}\r\n.bx-hotel:before {\r\n  content: \"\\ea84\";\r\n}\r\n.bx-hourglass:before {\r\n  content: \"\\ea85\";\r\n}\r\n.bx-id-card:before {\r\n  content: \"\\ea86\";\r\n}\r\n.bx-image:before {\r\n  content: \"\\ea87\";\r\n}\r\n.bx-image-add:before {\r\n  content: \"\\ea88\";\r\n}\r\n.bx-image-alt:before {\r\n  content: \"\\ea89\";\r\n}\r\n.bx-images:before {\r\n  content: \"\\ea8a\";\r\n}\r\n.bx-import:before {\r\n  content: \"\\ea8b\";\r\n}\r\n.bx-infinite:before {\r\n  content: \"\\ea8c\";\r\n}\r\n.bx-info-circle:before {\r\n  content: \"\\ea8d\";\r\n}\r\n.bx-italic:before {\r\n  content: \"\\ea8e\";\r\n}\r\n.bx-joystick:before {\r\n  content: \"\\ea8f\";\r\n}\r\n.bx-joystick-alt:before {\r\n  content: \"\\ea90\";\r\n}\r\n.bx-joystick-button:before {\r\n  content: \"\\ea91\";\r\n}\r\n.bx-key:before {\r\n  content: \"\\ea92\";\r\n}\r\n.bx-label:before {\r\n  content: \"\\ea93\";\r\n}\r\n.bx-landscape:before {\r\n  content: \"\\ea94\";\r\n}\r\n.bx-laptop:before {\r\n  content: \"\\ea95\";\r\n}\r\n.bx-last-page:before {\r\n  content: \"\\ea96\";\r\n}\r\n.bx-laugh:before {\r\n  content: \"\\ea97\";\r\n}\r\n.bx-layer:before {\r\n  content: \"\\ea98\";\r\n}\r\n.bx-layout:before {\r\n  content: \"\\ea99\";\r\n}\r\n.bx-left-arrow:before {\r\n  content: \"\\ea9a\";\r\n}\r\n.bx-left-arrow-alt:before {\r\n  content: \"\\ea9b\";\r\n}\r\n.bx-left-arrow-circle:before {\r\n  content: \"\\ea9c\";\r\n}\r\n.bx-left-down-arrow-circle:before {\r\n  content: \"\\ea9d\";\r\n}\r\n.bx-left-indent:before {\r\n  content: \"\\ea9e\";\r\n}\r\n.bx-left-top-arrow-circle:before {\r\n  content: \"\\ea9f\";\r\n}\r\n.bx-like:before {\r\n  content: \"\\eaa0\";\r\n}\r\n.bx-line-chart:before {\r\n  content: \"\\eaa1\";\r\n}\r\n.bx-link:before {\r\n  content: \"\\eaa2\";\r\n}\r\n.bx-link-alt:before {\r\n  content: \"\\eaa3\";\r\n}\r\n.bx-link-external:before {\r\n  content: \"\\eaa4\";\r\n}\r\n.bx-lira:before {\r\n  content: \"\\eaa5\";\r\n}\r\n.bx-list-check:before {\r\n  content: \"\\eaa6\";\r\n}\r\n.bx-list-minus:before {\r\n  content: \"\\eaa7\";\r\n}\r\n.bx-list-ol:before {\r\n  content: \"\\eaa8\";\r\n}\r\n.bx-list-plus:before {\r\n  content: \"\\eaa9\";\r\n}\r\n.bx-list-ul:before {\r\n  content: \"\\eaaa\";\r\n}\r\n.bx-loader:before {\r\n  content: \"\\eaab\";\r\n}\r\n.bx-loader-alt:before {\r\n  content: \"\\eaac\";\r\n}\r\n.bx-loader-circle:before {\r\n  content: \"\\eaad\";\r\n}\r\n.bx-lock:before {\r\n  content: \"\\eaae\";\r\n}\r\n.bx-lock-alt:before {\r\n  content: \"\\eaaf\";\r\n}\r\n.bx-lock-open:before {\r\n  content: \"\\eab0\";\r\n}\r\n.bx-lock-open-alt:before {\r\n  content: \"\\eab1\";\r\n}\r\n.bx-log-in:before {\r\n  content: \"\\eab2\";\r\n}\r\n.bx-log-in-circle:before {\r\n  content: \"\\eab3\";\r\n}\r\n.bx-log-out:before {\r\n  content: \"\\eab4\";\r\n}\r\n.bx-log-out-circle:before {\r\n  content: \"\\eab5\";\r\n}\r\n.bx-magnet:before {\r\n  content: \"\\eab6\";\r\n}\r\n.bx-mail-send:before {\r\n  content: \"\\eab7\";\r\n}\r\n.bx-male:before {\r\n  content: \"\\eab8\";\r\n}\r\n.bx-male-sign:before {\r\n  content: \"\\eab9\";\r\n}\r\n.bx-map:before {\r\n  content: \"\\eaba\";\r\n}\r\n.bx-map-alt:before {\r\n  content: \"\\eabb\";\r\n}\r\n.bx-map-pin:before {\r\n  content: \"\\eabc\";\r\n}\r\n.bx-meh:before {\r\n  content: \"\\eabd\";\r\n}\r\n.bx-meh-alt:before {\r\n  content: \"\\eabe\";\r\n}\r\n.bx-meh-blank:before {\r\n  content: \"\\eabf\";\r\n}\r\n.bx-memory-card:before {\r\n  content: \"\\eac0\";\r\n}\r\n.bx-menu:before {\r\n  content: \"\\eac1\";\r\n}\r\n.bx-menu-alt-left:before {\r\n  content: \"\\eac2\";\r\n}\r\n.bx-menu-alt-right:before {\r\n  content: \"\\eac3\";\r\n}\r\n.bx-message:before {\r\n  content: \"\\eac4\";\r\n}\r\n.bx-message-alt:before {\r\n  content: \"\\eac5\";\r\n}\r\n.bx-message-alt-dots:before {\r\n  content: \"\\eac6\";\r\n}\r\n.bx-message-dots:before {\r\n  content: \"\\eac7\";\r\n}\r\n.bx-message-rounded:before {\r\n  content: \"\\eac8\";\r\n}\r\n.bx-message-rounded-dots:before {\r\n  content: \"\\eac9\";\r\n}\r\n.bx-message-square:before {\r\n  content: \"\\eaca\";\r\n}\r\n.bx-message-square-dots:before {\r\n  content: \"\\eacb\";\r\n}\r\n.bx-microphone:before {\r\n  content: \"\\eacc\";\r\n}\r\n.bx-microphone-off:before {\r\n  content: \"\\eacd\";\r\n}\r\n.bx-minus:before {\r\n  content: \"\\eace\";\r\n}\r\n.bx-minus-circle:before {\r\n  content: \"\\eacf\";\r\n}\r\n.bx-mobile:before {\r\n  content: \"\\ead0\";\r\n}\r\n.bx-mobile-alt:before {\r\n  content: \"\\ead1\";\r\n}\r\n.bx-mobile-landscape:before {\r\n  content: \"\\ead2\";\r\n}\r\n.bx-mobile-vibration:before {\r\n  content: \"\\ead3\";\r\n}\r\n.bx-money:before {\r\n  content: \"\\ead4\";\r\n}\r\n.bx-moon:before {\r\n  content: \"\\ead5\";\r\n}\r\n.bx-mouse:before {\r\n  content: \"\\ead6\";\r\n}\r\n.bx-mouse-alt:before {\r\n  content: \"\\ead7\";\r\n}\r\n.bx-move:before {\r\n  content: \"\\ead8\";\r\n}\r\n.bx-move-horizontal:before {\r\n  content: \"\\ead9\";\r\n}\r\n.bx-move-vertical:before {\r\n  content: \"\\eada\";\r\n}\r\n.bx-movie:before {\r\n  content: \"\\eadb\";\r\n}\r\n.bx-music:before {\r\n  content: \"\\eadc\";\r\n}\r\n.bx-navigation:before {\r\n  content: \"\\eadd\";\r\n}\r\n.bx-news:before {\r\n  content: \"\\eade\";\r\n}\r\n.bx-no-entry:before {\r\n  content: \"\\eadf\";\r\n}\r\n.bx-note:before {\r\n  content: \"\\eae0\";\r\n}\r\n.bx-notepad:before {\r\n  content: \"\\eae1\";\r\n}\r\n.bx-notification:before {\r\n  content: \"\\eae2\";\r\n}\r\n.bx-notification-off:before {\r\n  content: \"\\eae3\";\r\n}\r\n.bx-package:before {\r\n  content: \"\\eae4\";\r\n}\r\n.bx-paint:before {\r\n  content: \"\\eae5\";\r\n}\r\n.bx-paint-roll:before {\r\n  content: \"\\eae6\";\r\n}\r\n.bx-palette:before {\r\n  content: \"\\eae7\";\r\n}\r\n.bx-paperclip:before {\r\n  content: \"\\eae8\";\r\n}\r\n.bx-paper-plane:before {\r\n  content: \"\\eae9\";\r\n}\r\n.bx-paragraph:before {\r\n  content: \"\\eaea\";\r\n}\r\n.bx-paste:before {\r\n  content: \"\\eaeb\";\r\n}\r\n.bx-pause:before {\r\n  content: \"\\eaec\";\r\n}\r\n.bx-pause-circle:before {\r\n  content: \"\\eaed\";\r\n}\r\n.bx-pen:before {\r\n  content: \"\\eaee\";\r\n}\r\n.bx-pencil:before {\r\n  content: \"\\eaef\";\r\n}\r\n.bx-phone:before {\r\n  content: \"\\eaf0\";\r\n}\r\n.bx-phone-call:before {\r\n  content: \"\\eaf1\";\r\n}\r\n.bx-phone-incoming:before {\r\n  content: \"\\eaf2\";\r\n}\r\n.bx-phone-outgoing:before {\r\n  content: \"\\eaf3\";\r\n}\r\n.bx-photo-album:before {\r\n  content: \"\\eaf4\";\r\n}\r\n.bx-pie-chart:before {\r\n  content: \"\\eaf5\";\r\n}\r\n.bx-pie-chart-alt:before {\r\n  content: \"\\eaf6\";\r\n}\r\n.bx-pie-chart-alt-2:before {\r\n  content: \"\\eaf7\";\r\n}\r\n.bx-pin:before {\r\n  content: \"\\eaf8\";\r\n}\r\n.bx-planet:before {\r\n  content: \"\\eaf9\";\r\n}\r\n.bx-play:before {\r\n  content: \"\\eafa\";\r\n}\r\n.bx-play-circle:before {\r\n  content: \"\\eafb\";\r\n}\r\n.bx-plug:before {\r\n  content: \"\\eafc\";\r\n}\r\n.bx-plus:before {\r\n  content: \"\\eafd\";\r\n}\r\n.bx-plus-circle:before {\r\n  content: \"\\eafe\";\r\n}\r\n.bx-plus-medical:before {\r\n  content: \"\\eaff\";\r\n}\r\n.bx-poll:before {\r\n  content: \"\\eb00\";\r\n}\r\n.bx-polygon:before {\r\n  content: \"\\eb01\";\r\n}\r\n.bx-pound:before {\r\n  content: \"\\eb02\";\r\n}\r\n.bx-power-off:before {\r\n  content: \"\\eb03\";\r\n}\r\n.bx-printer:before {\r\n  content: \"\\eb04\";\r\n}\r\n.bx-pulse:before {\r\n  content: \"\\eb05\";\r\n}\r\n.bx-purchase-tag:before {\r\n  content: \"\\eb06\";\r\n}\r\n.bx-purchase-tag-alt:before {\r\n  content: \"\\eb07\";\r\n}\r\n.bx-pyramid:before {\r\n  content: \"\\eb08\";\r\n}\r\n.bx-question-mark:before {\r\n  content: \"\\eb09\";\r\n}\r\n.bx-radar:before {\r\n  content: \"\\eb0a\";\r\n}\r\n.bx-radio:before {\r\n  content: \"\\eb0b\";\r\n}\r\n.bx-radio-circle:before {\r\n  content: \"\\eb0c\";\r\n}\r\n.bx-radio-circle-marked:before {\r\n  content: \"\\eb0d\";\r\n}\r\n.bx-receipt:before {\r\n  content: \"\\eb0e\";\r\n}\r\n.bx-rectangle:before {\r\n  content: \"\\eb0f\";\r\n}\r\n.bx-redo:before {\r\n  content: \"\\eb10\";\r\n}\r\n.bx-rename:before {\r\n  content: \"\\eb11\";\r\n}\r\n.bx-repeat:before {\r\n  content: \"\\eb12\";\r\n}\r\n.bx-reply:before {\r\n  content: \"\\eb13\";\r\n}\r\n.bx-reply-all:before {\r\n  content: \"\\eb14\";\r\n}\r\n.bx-repost:before {\r\n  content: \"\\eb15\";\r\n}\r\n.bx-reset:before {\r\n  content: \"\\eb16\";\r\n}\r\n.bx-restaurant:before {\r\n  content: \"\\eb17\";\r\n}\r\n.bx-revision:before {\r\n  content: \"\\eb18\";\r\n}\r\n.bx-rewind:before {\r\n  content: \"\\eb19\";\r\n}\r\n.bx-rewind-circle:before {\r\n  content: \"\\eb1a\";\r\n}\r\n.bx-right-arrow:before {\r\n  content: \"\\eb1b\";\r\n}\r\n.bx-right-arrow-alt:before {\r\n  content: \"\\eb1c\";\r\n}\r\n.bx-right-arrow-circle:before {\r\n  content: \"\\eb1d\";\r\n}\r\n.bx-right-down-arrow-circle:before {\r\n  content: \"\\eb1e\";\r\n}\r\n.bx-right-indent:before {\r\n  content: \"\\eb1f\";\r\n}\r\n.bx-right-top-arrow-circle:before {\r\n  content: \"\\eb20\";\r\n}\r\n.bx-rocket:before {\r\n  content: \"\\eb21\";\r\n}\r\n.bx-rotate-left:before {\r\n  content: \"\\eb22\";\r\n}\r\n.bx-rotate-right:before {\r\n  content: \"\\eb23\";\r\n}\r\n.bx-rss:before {\r\n  content: \"\\eb24\";\r\n}\r\n.bx-ruble:before {\r\n  content: \"\\eb25\";\r\n}\r\n.bx-ruler:before {\r\n  content: \"\\eb26\";\r\n}\r\n.bx-run:before {\r\n  content: \"\\eb27\";\r\n}\r\n.bx-rupee:before {\r\n  content: \"\\eb28\";\r\n}\r\n.bx-sad:before {\r\n  content: \"\\eb29\";\r\n}\r\n.bx-save:before {\r\n  content: \"\\eb2a\";\r\n}\r\n.bx-screenshot:before {\r\n  content: \"\\eb2b\";\r\n}\r\n.bx-search:before {\r\n  content: \"\\eb2c\";\r\n}\r\n.bx-search-alt:before {\r\n  content: \"\\eb2d\";\r\n}\r\n.bx-search-alt-2:before {\r\n  content: \"\\eb2e\";\r\n}\r\n.bx-selection:before {\r\n  content: \"\\eb2f\";\r\n}\r\n.bx-select-multiple:before {\r\n  content: \"\\eb30\";\r\n}\r\n.bx-send:before {\r\n  content: \"\\eb31\";\r\n}\r\n.bx-server:before {\r\n  content: \"\\eb32\";\r\n}\r\n.bx-shape-circle:before {\r\n  content: \"\\eb33\";\r\n}\r\n.bx-shape-square:before {\r\n  content: \"\\eb34\";\r\n}\r\n.bx-shape-triangle:before {\r\n  content: \"\\eb35\";\r\n}\r\n.bx-share:before {\r\n  content: \"\\eb36\";\r\n}\r\n.bx-share-alt:before {\r\n  content: \"\\eb37\";\r\n}\r\n.bx-shekel:before {\r\n  content: \"\\eb38\";\r\n}\r\n.bx-shield:before {\r\n  content: \"\\eb39\";\r\n}\r\n.bx-shield-alt:before {\r\n  content: \"\\eb3a\";\r\n}\r\n.bx-shield-alt-2:before {\r\n  content: \"\\eb3b\";\r\n}\r\n.bx-shield-quarter:before {\r\n  content: \"\\eb3c\";\r\n}\r\n.bx-shocked:before {\r\n  content: \"\\eb3d\";\r\n}\r\n.bx-shopping-bag:before {\r\n  content: \"\\eb3e\";\r\n}\r\n.bx-show:before {\r\n  content: \"\\eb3f\";\r\n}\r\n.bx-show-alt:before {\r\n  content: \"\\eb40\";\r\n}\r\n.bx-shuffle:before {\r\n  content: \"\\eb41\";\r\n}\r\n.bx-sidebar:before {\r\n  content: \"\\eb42\";\r\n}\r\n.bx-sitemap:before {\r\n  content: \"\\eb43\";\r\n}\r\n.bx-skip-next:before {\r\n  content: \"\\eb44\";\r\n}\r\n.bx-skip-next-circle:before {\r\n  content: \"\\eb45\";\r\n}\r\n.bx-skip-previous:before {\r\n  content: \"\\eb46\";\r\n}\r\n.bx-skip-previous-circle:before {\r\n  content: \"\\eb47\";\r\n}\r\n.bx-sleepy:before {\r\n  content: \"\\eb48\";\r\n}\r\n.bx-slider:before {\r\n  content: \"\\eb49\";\r\n}\r\n.bx-slider-alt:before {\r\n  content: \"\\eb4a\";\r\n}\r\n.bx-slideshow:before {\r\n  content: \"\\eb4b\";\r\n}\r\n.bx-smile:before {\r\n  content: \"\\eb4c\";\r\n}\r\n.bx-sort:before {\r\n  content: \"\\eb4d\";\r\n}\r\n.bx-sort-a-z:before {\r\n  content: \"\\eb4e\";\r\n}\r\n.bx-sort-down:before {\r\n  content: \"\\eb4f\";\r\n}\r\n.bx-sort-up:before {\r\n  content: \"\\eb50\";\r\n}\r\n.bx-sort-z-a:before {\r\n  content: \"\\eb51\";\r\n}\r\n.bx-spa:before {\r\n  content: \"\\eb52\";\r\n}\r\n.bx-space-bar:before {\r\n  content: \"\\eb53\";\r\n}\r\n.bx-spreadsheet:before {\r\n  content: \"\\eb54\";\r\n}\r\n.bx-square:before {\r\n  content: \"\\eb55\";\r\n}\r\n.bx-square-rounded:before {\r\n  content: \"\\eb56\";\r\n}\r\n.bx-star:before {\r\n  content: \"\\eb57\";\r\n}\r\n.bx-station:before {\r\n  content: \"\\eb58\";\r\n}\r\n.bx-stats:before {\r\n  content: \"\\eb59\";\r\n}\r\n.bx-sticker:before {\r\n  content: \"\\eb5a\";\r\n}\r\n.bx-stop:before {\r\n  content: \"\\eb5b\";\r\n}\r\n.bx-stop-circle:before {\r\n  content: \"\\eb5c\";\r\n}\r\n.bx-stopwatch:before {\r\n  content: \"\\eb5d\";\r\n}\r\n.bx-store:before {\r\n  content: \"\\eb5e\";\r\n}\r\n.bx-store-alt:before {\r\n  content: \"\\eb5f\";\r\n}\r\n.bx-street-view:before {\r\n  content: \"\\eb60\";\r\n}\r\n.bx-strikethrough:before {\r\n  content: \"\\eb61\";\r\n}\r\n.bx-subdirectory-left:before {\r\n  content: \"\\eb62\";\r\n}\r\n.bx-subdirectory-right:before {\r\n  content: \"\\eb63\";\r\n}\r\n.bx-sun:before {\r\n  content: \"\\eb64\";\r\n}\r\n.bx-support:before {\r\n  content: \"\\eb65\";\r\n}\r\n.bx-swim:before {\r\n  content: \"\\eb66\";\r\n}\r\n.bx-sync:before {\r\n  content: \"\\eb67\";\r\n}\r\n.bx-tab:before {\r\n  content: \"\\eb68\";\r\n}\r\n.bx-table:before {\r\n  content: \"\\eb69\";\r\n}\r\n.bx-tag:before {\r\n  content: \"\\eb6a\";\r\n}\r\n.bx-target-lock:before {\r\n  content: \"\\eb6b\";\r\n}\r\n.bx-task:before {\r\n  content: \"\\eb6c\";\r\n}\r\n.bx-taxi:before {\r\n  content: \"\\eb6d\";\r\n}\r\n.bx-tennis-ball:before {\r\n  content: \"\\eb6e\";\r\n}\r\n.bx-terminal:before {\r\n  content: \"\\eb6f\";\r\n}\r\n.bx-test-tube:before {\r\n  content: \"\\eb70\";\r\n}\r\n.bx-text:before {\r\n  content: \"\\eb71\";\r\n}\r\n.bx-time:before {\r\n  content: \"\\eb72\";\r\n}\r\n.bx-time-five:before {\r\n  content: \"\\eb73\";\r\n}\r\n.bx-timer:before {\r\n  content: \"\\eb74\";\r\n}\r\n.bx-tired:before {\r\n  content: \"\\eb75\";\r\n}\r\n.bx-toggle-left:before {\r\n  content: \"\\eb76\";\r\n}\r\n.bx-toggle-right:before {\r\n  content: \"\\eb77\";\r\n}\r\n.bx-tone:before {\r\n  content: \"\\eb78\";\r\n}\r\n.bx-train:before {\r\n  content: \"\\eb79\";\r\n}\r\n.bx-transfer:before {\r\n  content: \"\\eb7a\";\r\n}\r\n.bx-transfer-alt:before {\r\n  content: \"\\eb7b\";\r\n}\r\n.bx-trash:before {\r\n  content: \"\\eb7c\";\r\n}\r\n.bx-trash-alt:before {\r\n  content: \"\\eb7d\";\r\n}\r\n.bx-trending-down:before {\r\n  content: \"\\eb7e\";\r\n}\r\n.bx-trending-up:before {\r\n  content: \"\\eb7f\";\r\n}\r\n.bx-trophy:before {\r\n  content: \"\\eb80\";\r\n}\r\n.bx-tv:before {\r\n  content: \"\\eb81\";\r\n}\r\n.bx-underline:before {\r\n  content: \"\\eb82\";\r\n}\r\n.bx-undo:before {\r\n  content: \"\\eb83\";\r\n}\r\n.bx-unlink:before {\r\n  content: \"\\eb84\";\r\n}\r\n.bx-up-arrow:before {\r\n  content: \"\\eb85\";\r\n}\r\n.bx-up-arrow-alt:before {\r\n  content: \"\\eb86\";\r\n}\r\n.bx-up-arrow-circle:before {\r\n  content: \"\\eb87\";\r\n}\r\n.bx-upload:before {\r\n  content: \"\\eb88\";\r\n}\r\n.bx-upside-down:before {\r\n  content: \"\\eb89\";\r\n}\r\n.bx-upvote:before {\r\n  content: \"\\eb8a\";\r\n}\r\n.bx-usb:before {\r\n  content: \"\\eb8b\";\r\n}\r\n.bx-user:before {\r\n  content: \"\\eb8c\";\r\n}\r\n.bx-user-check:before {\r\n  content: \"\\eb8d\";\r\n}\r\n.bx-user-circle:before {\r\n  content: \"\\eb8e\";\r\n}\r\n.bx-user-minus:before {\r\n  content: \"\\eb8f\";\r\n}\r\n.bx-user-pin:before {\r\n  content: \"\\eb90\";\r\n}\r\n.bx-user-plus:before {\r\n  content: \"\\eb91\";\r\n}\r\n.bx-user-voice:before {\r\n  content: \"\\eb92\";\r\n}\r\n.bx-user-x:before {\r\n  content: \"\\eb93\";\r\n}\r\n.bx-vertical-center:before {\r\n  content: \"\\eb94\";\r\n}\r\n.bx-video:before {\r\n  content: \"\\eb95\";\r\n}\r\n.bx-video-off:before {\r\n  content: \"\\eb96\";\r\n}\r\n.bx-video-plus:before {\r\n  content: \"\\eb97\";\r\n}\r\n.bx-video-recording:before {\r\n  content: \"\\eb98\";\r\n}\r\n.bx-voicemail:before {\r\n  content: \"\\eb99\";\r\n}\r\n.bx-volume:before {\r\n  content: \"\\eb9a\";\r\n}\r\n.bx-volume-full:before {\r\n  content: \"\\eb9b\";\r\n}\r\n.bx-volume-low:before {\r\n  content: \"\\eb9c\";\r\n}\r\n.bx-volume-mute:before {\r\n  content: \"\\eb9d\";\r\n}\r\n.bx-walk:before {\r\n  content: \"\\eb9e\";\r\n}\r\n.bx-wallet:before {\r\n  content: \"\\eb9f\";\r\n}\r\n.bx-wallet-alt:before {\r\n  content: \"\\eba0\";\r\n}\r\n.bx-water:before {\r\n  content: \"\\eba1\";\r\n}\r\n.bx-wifi:before {\r\n  content: \"\\eba2\";\r\n}\r\n.bx-wifi-off:before {\r\n  content: \"\\eba3\";\r\n}\r\n.bx-wind:before {\r\n  content: \"\\eba4\";\r\n}\r\n.bx-window:before {\r\n  content: \"\\eba5\";\r\n}\r\n.bx-window-close:before {\r\n  content: \"\\eba6\";\r\n}\r\n.bx-window-open:before {\r\n  content: \"\\eba7\";\r\n}\r\n.bx-windows:before {\r\n  content: \"\\eba8\";\r\n}\r\n.bx-wink-smile:before {\r\n  content: \"\\eba9\";\r\n}\r\n.bx-wink-tongue:before {\r\n  content: \"\\ebaa\";\r\n}\r\n.bx-won:before {\r\n  content: \"\\ebab\";\r\n}\r\n.bx-world:before {\r\n  content: \"\\ebac\";\r\n}\r\n.bx-wrench:before {\r\n  content: \"\\ebad\";\r\n}\r\n.bx-x:before {\r\n  content: \"\\ebae\";\r\n}\r\n.bx-x-circle:before {\r\n  content: \"\\ebaf\";\r\n}\r\n.bx-yen:before {\r\n  content: \"\\ebb0\";\r\n}\r\n.bx-zoom-in:before {\r\n  content: \"\\ebb1\";\r\n}\r\n.bx-zoom-out:before {\r\n  content: \"\\ebb2\";\r\n}\r\n.bxs-add-to-queue:before {\r\n  content: \"\\ebb3\";\r\n}\r\n.bxs-adjust:before {\r\n  content: \"\\ebb4\";\r\n}\r\n.bxs-adjust-alt:before {\r\n  content: \"\\ebb5\";\r\n}\r\n.bxs-alarm:before {\r\n  content: \"\\ebb6\";\r\n}\r\n.bxs-alarm-add:before {\r\n  content: \"\\ebb7\";\r\n}\r\n.bxs-alarm-off:before {\r\n  content: \"\\ebb8\";\r\n}\r\n.bxs-album:before {\r\n  content: \"\\ebb9\";\r\n}\r\n.bxs-ambulance:before {\r\n  content: \"\\ebba\";\r\n}\r\n.bxs-analyse:before {\r\n  content: \"\\ebbb\";\r\n}\r\n.bxs-angry:before {\r\n  content: \"\\ebbc\";\r\n}\r\n.bxs-archive:before {\r\n  content: \"\\ebbd\";\r\n}\r\n.bxs-archive-in:before {\r\n  content: \"\\ebbe\";\r\n}\r\n.bxs-archive-out:before {\r\n  content: \"\\ebbf\";\r\n}\r\n.bxs-area:before {\r\n  content: \"\\ebc0\";\r\n}\r\n.bxs-award:before {\r\n  content: \"\\ebc1\";\r\n}\r\n.bxs-baby-carriage:before {\r\n  content: \"\\ebc2\";\r\n}\r\n.bxs-badge:before {\r\n  content: \"\\ebc3\";\r\n}\r\n.bxs-badge-check:before {\r\n  content: \"\\ebc4\";\r\n}\r\n.bxs-ball:before {\r\n  content: \"\\ebc5\";\r\n}\r\n.bxs-band-aid:before {\r\n  content: \"\\ebc6\";\r\n}\r\n.bxs-bank:before {\r\n  content: \"\\ebc7\";\r\n}\r\n.bxs-bar-chart-alt-2:before {\r\n  content: \"\\ebc8\";\r\n}\r\n.bxs-bar-chart-square:before {\r\n  content: \"\\ebc9\";\r\n}\r\n.bxs-barcode:before {\r\n  content: \"\\ebca\";\r\n}\r\n.bxs-basket:before {\r\n  content: \"\\ebcb\";\r\n}\r\n.bxs-bath:before {\r\n  content: \"\\ebcc\";\r\n}\r\n.bxs-battery:before {\r\n  content: \"\\ebcd\";\r\n}\r\n.bxs-battery-charging:before {\r\n  content: \"\\ebce\";\r\n}\r\n.bxs-battery-full:before {\r\n  content: \"\\ebcf\";\r\n}\r\n.bxs-battery-low:before {\r\n  content: \"\\ebd0\";\r\n}\r\n.bxs-bed:before {\r\n  content: \"\\ebd1\";\r\n}\r\n.bxs-bell:before {\r\n  content: \"\\ebd2\";\r\n}\r\n.bxs-bell-minus:before {\r\n  content: \"\\ebd3\";\r\n}\r\n.bxs-bell-off:before {\r\n  content: \"\\ebd4\";\r\n}\r\n.bxs-bell-plus:before {\r\n  content: \"\\ebd5\";\r\n}\r\n.bxs-bell-ring:before {\r\n  content: \"\\ebd6\";\r\n}\r\n.bxs-bolt:before {\r\n  content: \"\\ebd7\";\r\n}\r\n.bxs-bolt-circle:before {\r\n  content: \"\\ebd8\";\r\n}\r\n.bxs-book:before {\r\n  content: \"\\ebd9\";\r\n}\r\n.bxs-book-bookmark:before {\r\n  content: \"\\ebda\";\r\n}\r\n.bxs-book-content:before {\r\n  content: \"\\ebdb\";\r\n}\r\n.bxs-bookmark:before {\r\n  content: \"\\ebdc\";\r\n}\r\n.bxs-bookmark-minus:before {\r\n  content: \"\\ebdd\";\r\n}\r\n.bxs-bookmark-plus:before {\r\n  content: \"\\ebde\";\r\n}\r\n.bxs-bookmarks:before {\r\n  content: \"\\ebdf\";\r\n}\r\n.bxs-bookmark-star:before {\r\n  content: \"\\ebe0\";\r\n}\r\n.bxs-book-open:before {\r\n  content: \"\\ebe1\";\r\n}\r\n.bxs-bot:before {\r\n  content: \"\\ebe2\";\r\n}\r\n.bxs-bowling-ball:before {\r\n  content: \"\\ebe3\";\r\n}\r\n.bxs-box:before {\r\n  content: \"\\ebe4\";\r\n}\r\n.bxs-briefcase:before {\r\n  content: \"\\ebe5\";\r\n}\r\n.bxs-briefcase-alt:before {\r\n  content: \"\\ebe6\";\r\n}\r\n.bxs-briefcase-alt-2:before {\r\n  content: \"\\ebe7\";\r\n}\r\n.bxs-brightness:before {\r\n  content: \"\\ebe8\";\r\n}\r\n.bxs-brightness-half:before {\r\n  content: \"\\ebe9\";\r\n}\r\n.bxs-brush:before {\r\n  content: \"\\ebea\";\r\n}\r\n.bxs-brush-alt:before {\r\n  content: \"\\ebeb\";\r\n}\r\n.bxs-bug:before {\r\n  content: \"\\ebec\";\r\n}\r\n.bxs-bug-alt:before {\r\n  content: \"\\ebed\";\r\n}\r\n.bxs-building:before {\r\n  content: \"\\ebee\";\r\n}\r\n.bxs-building-house:before {\r\n  content: \"\\ebef\";\r\n}\r\n.bxs-buildings:before {\r\n  content: \"\\ebf0\";\r\n}\r\n.bxs-bulb:before {\r\n  content: \"\\ebf1\";\r\n}\r\n.bxs-buoy:before {\r\n  content: \"\\ebf2\";\r\n}\r\n.bxs-bus:before {\r\n  content: \"\\ebf3\";\r\n}\r\n.bxs-business:before {\r\n  content: \"\\ebf4\";\r\n}\r\n.bxs-cake:before {\r\n  content: \"\\ebf5\";\r\n}\r\n.bxs-calculator:before {\r\n  content: \"\\ebf6\";\r\n}\r\n.bxs-calendar:before {\r\n  content: \"\\ebf7\";\r\n}\r\n.bxs-calendar-alt:before {\r\n  content: \"\\ebf8\";\r\n}\r\n.bxs-calendar-check:before {\r\n  content: \"\\ebf9\";\r\n}\r\n.bxs-calendar-event:before {\r\n  content: \"\\ebfa\";\r\n}\r\n.bxs-calendar-minus:before {\r\n  content: \"\\ebfb\";\r\n}\r\n.bxs-calendar-plus:before {\r\n  content: \"\\ebfc\";\r\n}\r\n.bxs-calendar-x:before {\r\n  content: \"\\ebfd\";\r\n}\r\n.bxs-camera:before {\r\n  content: \"\\ebfe\";\r\n}\r\n.bxs-camera-off:before {\r\n  content: \"\\ebff\";\r\n}\r\n.bxs-camera-plus:before {\r\n  content: \"\\ec00\";\r\n}\r\n.bxs-capsule:before {\r\n  content: \"\\ec01\";\r\n}\r\n.bxs-captions:before {\r\n  content: \"\\ec02\";\r\n}\r\n.bxs-car:before {\r\n  content: \"\\ec03\";\r\n}\r\n.bxs-card:before {\r\n  content: \"\\ec04\";\r\n}\r\n.bxs-caret-down-circle:before {\r\n  content: \"\\ec05\";\r\n}\r\n.bxs-caret-left-circle:before {\r\n  content: \"\\ec06\";\r\n}\r\n.bxs-caret-right-circle:before {\r\n  content: \"\\ec07\";\r\n}\r\n.bxs-caret-up-circle:before {\r\n  content: \"\\ec08\";\r\n}\r\n.bxs-carousel:before {\r\n  content: \"\\ec09\";\r\n}\r\n.bxs-cart:before {\r\n  content: \"\\ec0a\";\r\n}\r\n.bxs-cart-alt:before {\r\n  content: \"\\ec0b\";\r\n}\r\n.bxs-certification:before {\r\n  content: \"\\ec0c\";\r\n}\r\n.bxs-chalkboard:before {\r\n  content: \"\\ec0d\";\r\n}\r\n.bxs-chart:before {\r\n  content: \"\\ec0e\";\r\n}\r\n.bxs-chat:before {\r\n  content: \"\\ec0f\";\r\n}\r\n.bxs-checkbox:before {\r\n  content: \"\\ec10\";\r\n}\r\n.bxs-checkbox-checked:before {\r\n  content: \"\\ec11\";\r\n}\r\n.bxs-check-circle:before {\r\n  content: \"\\ec12\";\r\n}\r\n.bxs-check-shield:before {\r\n  content: \"\\ec13\";\r\n}\r\n.bxs-check-square:before {\r\n  content: \"\\ec14\";\r\n}\r\n.bxs-chip:before {\r\n  content: \"\\ec15\";\r\n}\r\n.bxs-circle:before {\r\n  content: \"\\ec16\";\r\n}\r\n.bxs-city:before {\r\n  content: \"\\ec17\";\r\n}\r\n.bxs-clinic:before {\r\n  content: \"\\ec18\";\r\n}\r\n.bxs-cloud:before {\r\n  content: \"\\ec19\";\r\n}\r\n.bxs-cloud-download:before {\r\n  content: \"\\ec1a\";\r\n}\r\n.bxs-cloud-lightning:before {\r\n  content: \"\\ec1b\";\r\n}\r\n.bxs-cloud-rain:before {\r\n  content: \"\\ec1c\";\r\n}\r\n.bxs-cloud-upload:before {\r\n  content: \"\\ec1d\";\r\n}\r\n.bxs-coffee:before {\r\n  content: \"\\ec1e\";\r\n}\r\n.bxs-coffee-alt:before {\r\n  content: \"\\ec1f\";\r\n}\r\n.bxs-cog:before {\r\n  content: \"\\ec20\";\r\n}\r\n.bxs-collection:before {\r\n  content: \"\\ec21\";\r\n}\r\n.bxs-color-fill:before {\r\n  content: \"\\ec22\";\r\n}\r\n.bxs-comment:before {\r\n  content: \"\\ec23\";\r\n}\r\n.bxs-comment-add:before {\r\n  content: \"\\ec24\";\r\n}\r\n.bxs-comment-detail:before {\r\n  content: \"\\ec25\";\r\n}\r\n.bxs-comment-dots:before {\r\n  content: \"\\ec26\";\r\n}\r\n.bxs-comment-error:before {\r\n  content: \"\\ec27\";\r\n}\r\n.bxs-compass:before {\r\n  content: \"\\ec28\";\r\n}\r\n.bxs-component:before {\r\n  content: \"\\ec29\";\r\n}\r\n.bxs-confused:before {\r\n  content: \"\\ec2a\";\r\n}\r\n.bxs-contact:before {\r\n  content: \"\\ec2b\";\r\n}\r\n.bxs-conversation:before {\r\n  content: \"\\ec2c\";\r\n}\r\n.bxs-cool:before {\r\n  content: \"\\ec2d\";\r\n}\r\n.bxs-copy:before {\r\n  content: \"\\ec2e\";\r\n}\r\n.bxs-copy-alt:before {\r\n  content: \"\\ec2f\";\r\n}\r\n.bxs-coupon:before {\r\n  content: \"\\ec30\";\r\n}\r\n.bxs-credit-card:before {\r\n  content: \"\\ec31\";\r\n}\r\n.bxs-credit-card-alt:before {\r\n  content: \"\\ec32\";\r\n}\r\n.bxs-crown:before {\r\n  content: \"\\ec33\";\r\n}\r\n.bxs-cube:before {\r\n  content: \"\\ec34\";\r\n}\r\n.bxs-cube-alt:before {\r\n  content: \"\\ec35\";\r\n}\r\n.bxs-cuboid:before {\r\n  content: \"\\ec36\";\r\n}\r\n.bxs-customize:before {\r\n  content: \"\\ec37\";\r\n}\r\n.bxs-cylinder:before {\r\n  content: \"\\ec38\";\r\n}\r\n.bxs-dashboard:before {\r\n  content: \"\\ec39\";\r\n}\r\n.bxs-data:before {\r\n  content: \"\\ec3a\";\r\n}\r\n.bxs-detail:before {\r\n  content: \"\\ec3b\";\r\n}\r\n.bxs-devices:before {\r\n  content: \"\\ec3c\";\r\n}\r\n.bxs-direction-left:before {\r\n  content: \"\\ec3d\";\r\n}\r\n.bxs-direction-right:before {\r\n  content: \"\\ec3e\";\r\n}\r\n.bxs-directions:before {\r\n  content: \"\\ec3f\";\r\n}\r\n.bxs-disc:before {\r\n  content: \"\\ec40\";\r\n}\r\n.bxs-discount:before {\r\n  content: \"\\ec41\";\r\n}\r\n.bxs-dish:before {\r\n  content: \"\\ec42\";\r\n}\r\n.bxs-dislike:before {\r\n  content: \"\\ec43\";\r\n}\r\n.bxs-dizzy:before {\r\n  content: \"\\ec44\";\r\n}\r\n.bxs-dock-bottom:before {\r\n  content: \"\\ec45\";\r\n}\r\n.bxs-dock-left:before {\r\n  content: \"\\ec46\";\r\n}\r\n.bxs-dock-right:before {\r\n  content: \"\\ec47\";\r\n}\r\n.bxs-dock-top:before {\r\n  content: \"\\ec48\";\r\n}\r\n.bxs-dollar-circle:before {\r\n  content: \"\\ec49\";\r\n}\r\n.bxs-doughnut-chart:before {\r\n  content: \"\\ec4a\";\r\n}\r\n.bxs-down-arrow:before {\r\n  content: \"\\ec4b\";\r\n}\r\n.bxs-down-arrow-circle:before {\r\n  content: \"\\ec4c\";\r\n}\r\n.bxs-down-arrow-square:before {\r\n  content: \"\\ec4d\";\r\n}\r\n.bxs-download:before {\r\n  content: \"\\ec4e\";\r\n}\r\n.bxs-downvote:before {\r\n  content: \"\\ec4f\";\r\n}\r\n.bxs-drink:before {\r\n  content: \"\\ec50\";\r\n}\r\n.bxs-droplet:before {\r\n  content: \"\\ec51\";\r\n}\r\n.bxs-droplet-half:before {\r\n  content: \"\\ec52\";\r\n}\r\n.bxs-duplicate:before {\r\n  content: \"\\ec53\";\r\n}\r\n.bxs-edit:before {\r\n  content: \"\\ec54\";\r\n}\r\n.bxs-edit-alt:before {\r\n  content: \"\\ec55\";\r\n}\r\n.bxs-eject:before {\r\n  content: \"\\ec56\";\r\n}\r\n.bxs-envelope:before {\r\n  content: \"\\ec57\";\r\n}\r\n.bxs-eraser:before {\r\n  content: \"\\ec58\";\r\n}\r\n.bxs-error:before {\r\n  content: \"\\ec59\";\r\n}\r\n.bxs-error-alt:before {\r\n  content: \"\\ec5a\";\r\n}\r\n.bxs-error-circle:before {\r\n  content: \"\\ec5b\";\r\n}\r\n.bxs-exit:before {\r\n  content: \"\\ec5c\";\r\n}\r\n.bxs-extension:before {\r\n  content: \"\\ec5d\";\r\n}\r\n.bxs-eyedropper:before {\r\n  content: \"\\ec5e\";\r\n}\r\n.bxs-face:before {\r\n  content: \"\\ec5f\";\r\n}\r\n.bxs-factory:before {\r\n  content: \"\\ec60\";\r\n}\r\n.bxs-fast-forward-circle:before {\r\n  content: \"\\ec61\";\r\n}\r\n.bxs-file:before {\r\n  content: \"\\ec62\";\r\n}\r\n.bxs-file-blank:before {\r\n  content: \"\\ec63\";\r\n}\r\n.bxs-file-css:before {\r\n  content: \"\\ec64\";\r\n}\r\n.bxs-file-doc:before {\r\n  content: \"\\ec65\";\r\n}\r\n.bxs-file-find:before {\r\n  content: \"\\ec66\";\r\n}\r\n.bxs-file-gif:before {\r\n  content: \"\\ec67\";\r\n}\r\n.bxs-file-html:before {\r\n  content: \"\\ec68\";\r\n}\r\n.bxs-file-image:before {\r\n  content: \"\\ec69\";\r\n}\r\n.bxs-file-jpg:before {\r\n  content: \"\\ec6a\";\r\n}\r\n.bxs-file-js:before {\r\n  content: \"\\ec6b\";\r\n}\r\n.bxs-file-json:before {\r\n  content: \"\\ec6c\";\r\n}\r\n.bxs-file-md:before {\r\n  content: \"\\ec6d\";\r\n}\r\n.bxs-file-pdf:before {\r\n  content: \"\\ec6e\";\r\n}\r\n.bxs-file-plus:before {\r\n  content: \"\\ec6f\";\r\n}\r\n.bxs-file-png:before {\r\n  content: \"\\ec70\";\r\n}\r\n.bxs-file-txt:before {\r\n  content: \"\\ec71\";\r\n}\r\n.bxs-film:before {\r\n  content: \"\\ec72\";\r\n}\r\n.bxs-filter-alt:before {\r\n  content: \"\\ec73\";\r\n}\r\n.bxs-first-aid:before {\r\n  content: \"\\ec74\";\r\n}\r\n.bxs-flag:before {\r\n  content: \"\\ec75\";\r\n}\r\n.bxs-flag-alt:before {\r\n  content: \"\\ec76\";\r\n}\r\n.bxs-flame:before {\r\n  content: \"\\ec77\";\r\n}\r\n.bxs-flask:before {\r\n  content: \"\\ec78\";\r\n}\r\n.bxs-folder:before {\r\n  content: \"\\ec79\";\r\n}\r\n.bxs-folder-minus:before {\r\n  content: \"\\ec7a\";\r\n}\r\n.bxs-folder-open:before {\r\n  content: \"\\ec7b\";\r\n}\r\n.bxs-folder-plus:before {\r\n  content: \"\\ec7c\";\r\n}\r\n.bxs-food-menu:before {\r\n  content: \"\\ec7d\";\r\n}\r\n.bxs-fridge:before {\r\n  content: \"\\ec7e\";\r\n}\r\n.bxs-gas-pump:before {\r\n  content: \"\\ec7f\";\r\n}\r\n.bxs-ghost:before {\r\n  content: \"\\ec80\";\r\n}\r\n.bxs-gift:before {\r\n  content: \"\\ec81\";\r\n}\r\n.bxs-graduation:before {\r\n  content: \"\\ec82\";\r\n}\r\n.bxs-grid:before {\r\n  content: \"\\ec83\";\r\n}\r\n.bxs-grid-alt:before {\r\n  content: \"\\ec84\";\r\n}\r\n.bxs-group:before {\r\n  content: \"\\ec85\";\r\n}\r\n.bxs-hand-down:before {\r\n  content: \"\\ec86\";\r\n}\r\n.bxs-hand-left:before {\r\n  content: \"\\ec87\";\r\n}\r\n.bxs-hand-right:before {\r\n  content: \"\\ec88\";\r\n}\r\n.bxs-hand-up:before {\r\n  content: \"\\ec89\";\r\n}\r\n.bxs-happy:before {\r\n  content: \"\\ec8a\";\r\n}\r\n.bxs-happy-alt:before {\r\n  content: \"\\ec8b\";\r\n}\r\n.bxs-happy-beaming:before {\r\n  content: \"\\ec8c\";\r\n}\r\n.bxs-happy-heart-eyes:before {\r\n  content: \"\\ec8d\";\r\n}\r\n.bxs-hdd:before {\r\n  content: \"\\ec8e\";\r\n}\r\n.bxs-heart:before {\r\n  content: \"\\ec8f\";\r\n}\r\n.bxs-help-circle:before {\r\n  content: \"\\ec90\";\r\n}\r\n.bxs-hide:before {\r\n  content: \"\\ec91\";\r\n}\r\n.bxs-home:before {\r\n  content: \"\\ec92\";\r\n}\r\n.bxs-home-circle:before {\r\n  content: \"\\ec93\";\r\n}\r\n.bxs-hot:before {\r\n  content: \"\\ec94\";\r\n}\r\n.bxs-hotel:before {\r\n  content: \"\\ec95\";\r\n}\r\n.bxs-hourglass:before {\r\n  content: \"\\ec96\";\r\n}\r\n.bxs-hourglass-bottom:before {\r\n  content: \"\\ec97\";\r\n}\r\n.bxs-hourglass-top:before {\r\n  content: \"\\ec98\";\r\n}\r\n.bxs-id-card:before {\r\n  content: \"\\ec99\";\r\n}\r\n.bxs-image:before {\r\n  content: \"\\ec9a\";\r\n}\r\n.bxs-image-add:before {\r\n  content: \"\\ec9b\";\r\n}\r\n.bxs-image-alt:before {\r\n  content: \"\\ec9c\";\r\n}\r\n.bxs-inbox:before {\r\n  content: \"\\ec9d\";\r\n}\r\n.bxs-info-circle:before {\r\n  content: \"\\ec9e\";\r\n}\r\n.bxs-institution:before {\r\n  content: \"\\ec9f\";\r\n}\r\n.bxs-joystick:before {\r\n  content: \"\\eca0\";\r\n}\r\n.bxs-joystick-alt:before {\r\n  content: \"\\eca1\";\r\n}\r\n.bxs-joystick-button:before {\r\n  content: \"\\eca2\";\r\n}\r\n.bxs-key:before {\r\n  content: \"\\eca3\";\r\n}\r\n.bxs-keyboard:before {\r\n  content: \"\\eca4\";\r\n}\r\n.bxs-label:before {\r\n  content: \"\\eca5\";\r\n}\r\n.bxs-landmark:before {\r\n  content: \"\\eca6\";\r\n}\r\n.bxs-landscape:before {\r\n  content: \"\\eca7\";\r\n}\r\n.bxs-laugh:before {\r\n  content: \"\\eca8\";\r\n}\r\n.bxs-layer:before {\r\n  content: \"\\eca9\";\r\n}\r\n.bxs-layout:before {\r\n  content: \"\\ecaa\";\r\n}\r\n.bxs-left-arrow:before {\r\n  content: \"\\ecab\";\r\n}\r\n.bxs-left-arrow-circle:before {\r\n  content: \"\\ecac\";\r\n}\r\n.bxs-left-arrow-square:before {\r\n  content: \"\\ecad\";\r\n}\r\n.bxs-left-down-arrow-circle:before {\r\n  content: \"\\ecae\";\r\n}\r\n.bxs-left-top-arrow-circle:before {\r\n  content: \"\\ecaf\";\r\n}\r\n.bxs-like:before {\r\n  content: \"\\ecb0\";\r\n}\r\n.bxs-lock:before {\r\n  content: \"\\ecb1\";\r\n}\r\n.bxs-lock-alt:before {\r\n  content: \"\\ecb2\";\r\n}\r\n.bxs-lock-open:before {\r\n  content: \"\\ecb3\";\r\n}\r\n.bxs-lock-open-alt:before {\r\n  content: \"\\ecb4\";\r\n}\r\n.bxs-log-in:before {\r\n  content: \"\\ecb5\";\r\n}\r\n.bxs-log-in-circle:before {\r\n  content: \"\\ecb6\";\r\n}\r\n.bxs-log-out:before {\r\n  content: \"\\ecb7\";\r\n}\r\n.bxs-log-out-circle:before {\r\n  content: \"\\ecb8\";\r\n}\r\n.bxs-magic-wand:before {\r\n  content: \"\\ecb9\";\r\n}\r\n.bxs-magnet:before {\r\n  content: \"\\ecba\";\r\n}\r\n.bxs-map:before {\r\n  content: \"\\ecbb\";\r\n}\r\n.bxs-map-alt:before {\r\n  content: \"\\ecbc\";\r\n}\r\n.bxs-map-pin:before {\r\n  content: \"\\ecbd\";\r\n}\r\n.bxs-megaphone:before {\r\n  content: \"\\ecbe\";\r\n}\r\n.bxs-meh:before {\r\n  content: \"\\ecbf\";\r\n}\r\n.bxs-meh-alt:before {\r\n  content: \"\\ecc0\";\r\n}\r\n.bxs-meh-blank:before {\r\n  content: \"\\ecc1\";\r\n}\r\n.bxs-memory-card:before {\r\n  content: \"\\ecc2\";\r\n}\r\n.bxs-message:before {\r\n  content: \"\\ecc3\";\r\n}\r\n.bxs-message-alt:before {\r\n  content: \"\\ecc4\";\r\n}\r\n.bxs-message-alt-dots:before {\r\n  content: \"\\ecc5\";\r\n}\r\n.bxs-message-dots:before {\r\n  content: \"\\ecc6\";\r\n}\r\n.bxs-message-rounded:before {\r\n  content: \"\\ecc7\";\r\n}\r\n.bxs-message-rounded-dots:before {\r\n  content: \"\\ecc8\";\r\n}\r\n.bxs-message-square:before {\r\n  content: \"\\ecc9\";\r\n}\r\n.bxs-message-square-dots:before {\r\n  content: \"\\ecca\";\r\n}\r\n.bxs-microphone:before {\r\n  content: \"\\eccb\";\r\n}\r\n.bxs-microphone-alt:before {\r\n  content: \"\\eccc\";\r\n}\r\n.bxs-microphone-off:before {\r\n  content: \"\\eccd\";\r\n}\r\n.bxs-minus-circle:before {\r\n  content: \"\\ecce\";\r\n}\r\n.bxs-minus-square:before {\r\n  content: \"\\eccf\";\r\n}\r\n.bxs-mobile:before {\r\n  content: \"\\ecd0\";\r\n}\r\n.bxs-mobile-vibration:before {\r\n  content: \"\\ecd1\";\r\n}\r\n.bxs-moon:before {\r\n  content: \"\\ecd2\";\r\n}\r\n.bxs-mouse:before {\r\n  content: \"\\ecd3\";\r\n}\r\n.bxs-mouse-alt:before {\r\n  content: \"\\ecd4\";\r\n}\r\n.bxs-movie:before {\r\n  content: \"\\ecd5\";\r\n}\r\n.bxs-music:before {\r\n  content: \"\\ecd6\";\r\n}\r\n.bxs-navigation:before {\r\n  content: \"\\ecd7\";\r\n}\r\n.bxs-news:before {\r\n  content: \"\\ecd8\";\r\n}\r\n.bxs-no-entry:before {\r\n  content: \"\\ecd9\";\r\n}\r\n.bxs-note:before {\r\n  content: \"\\ecda\";\r\n}\r\n.bxs-notepad:before {\r\n  content: \"\\ecdb\";\r\n}\r\n.bxs-notification:before {\r\n  content: \"\\ecdc\";\r\n}\r\n.bxs-notification-off:before {\r\n  content: \"\\ecdd\";\r\n}\r\n.bxs-offer:before {\r\n  content: \"\\ecde\";\r\n}\r\n.bxs-package:before {\r\n  content: \"\\ecdf\";\r\n}\r\n.bxs-paint:before {\r\n  content: \"\\ece0\";\r\n}\r\n.bxs-paint-roll:before {\r\n  content: \"\\ece1\";\r\n}\r\n.bxs-palette:before {\r\n  content: \"\\ece2\";\r\n}\r\n.bxs-paper-plane:before {\r\n  content: \"\\ece3\";\r\n}\r\n.bxs-parking:before {\r\n  content: \"\\ece4\";\r\n}\r\n.bxs-paste:before {\r\n  content: \"\\ece5\";\r\n}\r\n.bxs-pen:before {\r\n  content: \"\\ece6\";\r\n}\r\n.bxs-pencil:before {\r\n  content: \"\\ece7\";\r\n}\r\n.bxs-phone:before {\r\n  content: \"\\ece8\";\r\n}\r\n.bxs-phone-call:before {\r\n  content: \"\\ece9\";\r\n}\r\n.bxs-phone-incoming:before {\r\n  content: \"\\ecea\";\r\n}\r\n.bxs-phone-outgoing:before {\r\n  content: \"\\eceb\";\r\n}\r\n.bxs-photo-album:before {\r\n  content: \"\\ecec\";\r\n}\r\n.bxs-pie-chart:before {\r\n  content: \"\\eced\";\r\n}\r\n.bxs-pie-chart-alt:before {\r\n  content: \"\\ecee\";\r\n}\r\n.bxs-pie-chart-alt-2:before {\r\n  content: \"\\ecef\";\r\n}\r\n.bxs-pin:before {\r\n  content: \"\\ecf0\";\r\n}\r\n.bxs-plane:before {\r\n  content: \"\\ecf1\";\r\n}\r\n.bxs-plane-alt:before {\r\n  content: \"\\ecf2\";\r\n}\r\n.bxs-plane-land:before {\r\n  content: \"\\ecf3\";\r\n}\r\n.bxs-planet:before {\r\n  content: \"\\ecf4\";\r\n}\r\n.bxs-plane-take-off:before {\r\n  content: \"\\ecf5\";\r\n}\r\n.bxs-playlist:before {\r\n  content: \"\\ecf6\";\r\n}\r\n.bxs-plug:before {\r\n  content: \"\\ecf7\";\r\n}\r\n.bxs-plus-circle:before {\r\n  content: \"\\ecf8\";\r\n}\r\n.bxs-plus-square:before {\r\n  content: \"\\ecf9\";\r\n}\r\n.bxs-polygon:before {\r\n  content: \"\\ecfa\";\r\n}\r\n.bxs-printer:before {\r\n  content: \"\\ecfb\";\r\n}\r\n.bxs-purchase-tag:before {\r\n  content: \"\\ecfc\";\r\n}\r\n.bxs-purchase-tag-alt:before {\r\n  content: \"\\ecfd\";\r\n}\r\n.bxs-pyramid:before {\r\n  content: \"\\ecfe\";\r\n}\r\n.bxs-quote-alt-left:before {\r\n  content: \"\\ecff\";\r\n}\r\n.bxs-quote-alt-right:before {\r\n  content: \"\\ed00\";\r\n}\r\n.bxs-quote-left:before {\r\n  content: \"\\ed01\";\r\n}\r\n.bxs-quote-right:before {\r\n  content: \"\\ed02\";\r\n}\r\n.bxs-quote-single-left:before {\r\n  content: \"\\ed03\";\r\n}\r\n.bxs-quote-single-right:before {\r\n  content: \"\\ed04\";\r\n}\r\n.bxs-radio:before {\r\n  content: \"\\ed05\";\r\n}\r\n.bxs-receipt:before {\r\n  content: \"\\ed06\";\r\n}\r\n.bxs-rectangle:before {\r\n  content: \"\\ed07\";\r\n}\r\n.bxs-rename:before {\r\n  content: \"\\ed08\";\r\n}\r\n.bxs-report:before {\r\n  content: \"\\ed09\";\r\n}\r\n.bxs-rewind-circle:before {\r\n  content: \"\\ed0a\";\r\n}\r\n.bxs-right-arrow:before {\r\n  content: \"\\ed0b\";\r\n}\r\n.bxs-right-arrow-circle:before {\r\n  content: \"\\ed0c\";\r\n}\r\n.bxs-right-arrow-square:before {\r\n  content: \"\\ed0d\";\r\n}\r\n.bxs-right-down-arrow-circle:before {\r\n  content: \"\\ed0e\";\r\n}\r\n.bxs-right-top-arrow-circle:before {\r\n  content: \"\\ed0f\";\r\n}\r\n.bxs-rocket:before {\r\n  content: \"\\ed10\";\r\n}\r\n.bxs-ruler:before {\r\n  content: \"\\ed11\";\r\n}\r\n.bxs-sad:before {\r\n  content: \"\\ed12\";\r\n}\r\n.bxs-save:before {\r\n  content: \"\\ed13\";\r\n}\r\n.bxs-school:before {\r\n  content: \"\\ed14\";\r\n}\r\n.bxs-search:before {\r\n  content: \"\\ed15\";\r\n}\r\n.bxs-search-alt-2:before {\r\n  content: \"\\ed16\";\r\n}\r\n.bxs-select-multiple:before {\r\n  content: \"\\ed17\";\r\n}\r\n.bxs-send:before {\r\n  content: \"\\ed18\";\r\n}\r\n.bxs-server:before {\r\n  content: \"\\ed19\";\r\n}\r\n.bxs-share:before {\r\n  content: \"\\ed1a\";\r\n}\r\n.bxs-share-alt:before {\r\n  content: \"\\ed1b\";\r\n}\r\n.bxs-shield:before {\r\n  content: \"\\ed1c\";\r\n}\r\n.bxs-shield-alt-2:before {\r\n  content: \"\\ed1d\";\r\n}\r\n.bxs-ship:before {\r\n  content: \"\\ed1e\";\r\n}\r\n.bxs-shocked:before {\r\n  content: \"\\ed1f\";\r\n}\r\n.bxs-shopping-bag:before {\r\n  content: \"\\ed20\";\r\n}\r\n.bxs-shopping-bag-alt:before {\r\n  content: \"\\ed21\";\r\n}\r\n.bxs-show:before {\r\n  content: \"\\ed22\";\r\n}\r\n.bxs-skip-next-circle:before {\r\n  content: \"\\ed23\";\r\n}\r\n.bxs-skip-previous-circle:before {\r\n  content: \"\\ed24\";\r\n}\r\n.bxs-skull:before {\r\n  content: \"\\ed25\";\r\n}\r\n.bxs-sleepy:before {\r\n  content: \"\\ed26\";\r\n}\r\n.bxs-slideshow:before {\r\n  content: \"\\ed27\";\r\n}\r\n.bxs-smile:before {\r\n  content: \"\\ed28\";\r\n}\r\n.bxs-sort-alt:before {\r\n  content: \"\\ed29\";\r\n}\r\n.bxs-spa:before {\r\n  content: \"\\ed2a\";\r\n}\r\n.bxs-spreadsheet:before {\r\n  content: \"\\ed2b\";\r\n}\r\n.bxs-square:before {\r\n  content: \"\\ed2c\";\r\n}\r\n.bxs-square-rounded:before {\r\n  content: \"\\ed2d\";\r\n}\r\n.bxs-star:before {\r\n  content: \"\\ed2e\";\r\n}\r\n.bxs-star-half:before {\r\n  content: \"\\ed2f\";\r\n}\r\n.bxs-stopwatch:before {\r\n  content: \"\\ed30\";\r\n}\r\n.bxs-store:before {\r\n  content: \"\\ed31\";\r\n}\r\n.bxs-store-alt:before {\r\n  content: \"\\ed32\";\r\n}\r\n.bxs-sun:before {\r\n  content: \"\\ed33\";\r\n}\r\n.bxs-tag:before {\r\n  content: \"\\ed34\";\r\n}\r\n.bxs-tag-x:before {\r\n  content: \"\\ed35\";\r\n}\r\n.bxs-taxi:before {\r\n  content: \"\\ed36\";\r\n}\r\n.bxs-tennis-ball:before {\r\n  content: \"\\ed37\";\r\n}\r\n.bxs-terminal:before {\r\n  content: \"\\ed38\";\r\n}\r\n.bxs-time:before {\r\n  content: \"\\ed39\";\r\n}\r\n.bxs-time-five:before {\r\n  content: \"\\ed3a\";\r\n}\r\n.bxs-timer:before {\r\n  content: \"\\ed3b\";\r\n}\r\n.bxs-tired:before {\r\n  content: \"\\ed3c\";\r\n}\r\n.bxs-toggle-left:before {\r\n  content: \"\\ed3d\";\r\n}\r\n.bxs-toggle-right:before {\r\n  content: \"\\ed3e\";\r\n}\r\n.bxs-tone:before {\r\n  content: \"\\ed3f\";\r\n}\r\n.bxs-torch:before {\r\n  content: \"\\ed40\";\r\n}\r\n.bxs-to-top:before {\r\n  content: \"\\ed41\";\r\n}\r\n.bxs-traffic:before {\r\n  content: \"\\ed42\";\r\n}\r\n.bxs-traffic-barrier:before {\r\n  content: \"\\ed43\";\r\n}\r\n.bxs-train:before {\r\n  content: \"\\ed44\";\r\n}\r\n.bxs-trash:before {\r\n  content: \"\\ed45\";\r\n}\r\n.bxs-trash-alt:before {\r\n  content: \"\\ed46\";\r\n}\r\n.bxs-tree:before {\r\n  content: \"\\ed47\";\r\n}\r\n.bxs-trophy:before {\r\n  content: \"\\ed48\";\r\n}\r\n.bxs-truck:before {\r\n  content: \"\\ed49\";\r\n}\r\n.bxs-t-shirt:before {\r\n  content: \"\\ed4a\";\r\n}\r\n.bxs-up-arrow:before {\r\n  content: \"\\ed4b\";\r\n}\r\n.bxs-up-arrow-circle:before {\r\n  content: \"\\ed4c\";\r\n}\r\n.bxs-up-arrow-square:before {\r\n  content: \"\\ed4d\";\r\n}\r\n.bxs-upside-down:before {\r\n  content: \"\\ed4e\";\r\n}\r\n.bxs-upvote:before {\r\n  content: \"\\ed4f\";\r\n}\r\n.bxs-user:before {\r\n  content: \"\\ed50\";\r\n}\r\n.bxs-user-badge:before {\r\n  content: \"\\ed51\";\r\n}\r\n.bxs-user-check:before {\r\n  content: \"\\ed52\";\r\n}\r\n.bxs-user-circle:before {\r\n  content: \"\\ed53\";\r\n}\r\n.bxs-user-detail:before {\r\n  content: \"\\ed54\";\r\n}\r\n.bxs-user-minus:before {\r\n  content: \"\\ed55\";\r\n}\r\n.bxs-user-pin:before {\r\n  content: \"\\ed56\";\r\n}\r\n.bxs-user-plus:before {\r\n  content: \"\\ed57\";\r\n}\r\n.bxs-user-rectangle:before {\r\n  content: \"\\ed58\";\r\n}\r\n.bxs-user-voice:before {\r\n  content: \"\\ed59\";\r\n}\r\n.bxs-user-x:before {\r\n  content: \"\\ed5a\";\r\n}\r\n.bxs-vial:before {\r\n  content: \"\\ed5b\";\r\n}\r\n.bxs-video:before {\r\n  content: \"\\ed5c\";\r\n}\r\n.bxs-video-off:before {\r\n  content: \"\\ed5d\";\r\n}\r\n.bxs-video-plus:before {\r\n  content: \"\\ed5e\";\r\n}\r\n.bxs-video-recording:before {\r\n  content: \"\\ed5f\";\r\n}\r\n.bxs-videos:before {\r\n  content: \"\\ed60\";\r\n}\r\n.bxs-volume:before {\r\n  content: \"\\ed61\";\r\n}\r\n.bxs-volume-full:before {\r\n  content: \"\\ed62\";\r\n}\r\n.bxs-volume-low:before {\r\n  content: \"\\ed63\";\r\n}\r\n.bxs-volume-mute:before {\r\n  content: \"\\ed64\";\r\n}\r\n.bxs-wallet:before {\r\n  content: \"\\ed65\";\r\n}\r\n.bxs-wallet-alt:before {\r\n  content: \"\\ed66\";\r\n}\r\n.bxs-watch:before {\r\n  content: \"\\ed67\";\r\n}\r\n.bxs-watch-alt:before {\r\n  content: \"\\ed68\";\r\n}\r\n.bxs-widget:before {\r\n  content: \"\\ed69\";\r\n}\r\n.bxs-wine:before {\r\n  content: \"\\ed6a\";\r\n}\r\n.bxs-wink-smile:before {\r\n  content: \"\\ed6b\";\r\n}\r\n.bxs-wink-tongue:before {\r\n  content: \"\\ed6c\";\r\n}\r\n.bxs-wrench:before {\r\n  content: \"\\ed6d\";\r\n}\r\n.bxs-x-circle:before {\r\n  content: \"\\ed6e\";\r\n}\r\n.bxs-x-square:before {\r\n  content: \"\\ed6f\";\r\n}\r\n.bxs-yin-yang:before {\r\n  content: \"\\ed70\";\r\n}\r\n.bxs-zap:before {\r\n  content: \"\\ed71\";\r\n}\r\n.bxs-zoom-in:before {\r\n  content: \"\\ed72\";\r\n}\r\n.bxs-zoom-out:before {\r\n  content: \"\\ed73\";\r\n}\r\n","/*!\r\n * Font Awesome Free 5.13.0 by @fontawesome - https://fontawesome.com\r\n * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)\r\n */\r\n.fa,\r\n.fas,\r\n.far,\r\n.fal,\r\n.fad,\r\n.fab {\r\n  -moz-osx-font-smoothing: grayscale;\r\n  -webkit-font-smoothing: antialiased;\r\n  display: inline-block;\r\n  font-style: normal;\r\n  font-variant: normal;\r\n  text-rendering: auto;\r\n  line-height: 1;\r\n}\r\n\r\n.fa-lg {\r\n  font-size: 1.33333em;\r\n  line-height: 0.75em;\r\n  vertical-align: -0.0667em;\r\n}\r\n\r\n.fa-xs {\r\n  font-size: 0.75em;\r\n}\r\n\r\n.fa-sm {\r\n  font-size: 0.875em;\r\n}\r\n\r\n.fa-1x {\r\n  font-size: 1em;\r\n}\r\n\r\n.fa-2x {\r\n  font-size: 2em;\r\n}\r\n\r\n.fa-3x {\r\n  font-size: 3em;\r\n}\r\n\r\n.fa-4x {\r\n  font-size: 4em;\r\n}\r\n\r\n.fa-5x {\r\n  font-size: 5em;\r\n}\r\n\r\n.fa-6x {\r\n  font-size: 6em;\r\n}\r\n\r\n.fa-7x {\r\n  font-size: 7em;\r\n}\r\n\r\n.fa-8x {\r\n  font-size: 8em;\r\n}\r\n\r\n.fa-9x {\r\n  font-size: 9em;\r\n}\r\n\r\n.fa-10x {\r\n  font-size: 10em;\r\n}\r\n\r\n.fa-fw {\r\n  text-align: center;\r\n  width: 1.25em;\r\n}\r\n\r\n.fa-ul {\r\n  list-style-type: none;\r\n  margin-left: 2.5em;\r\n  padding-left: 0;\r\n}\r\n.fa-ul > li {\r\n  position: relative;\r\n}\r\n\r\n.fa-li {\r\n  left: -2em;\r\n  position: absolute;\r\n  text-align: center;\r\n  width: 2em;\r\n  line-height: inherit;\r\n}\r\n\r\n.fa-border {\r\n  border: solid 0.08em #eee;\r\n  border-radius: 0.1em;\r\n  padding: 0.2em 0.25em 0.15em;\r\n}\r\n\r\n.fa-pull-left {\r\n  float: left;\r\n}\r\n\r\n.fa-pull-right {\r\n  float: right;\r\n}\r\n\r\n.fa.fa-pull-left,\r\n.fas.fa-pull-left,\r\n.far.fa-pull-left,\r\n.fal.fa-pull-left,\r\n.fab.fa-pull-left {\r\n  margin-right: 0.3em;\r\n}\r\n\r\n.fa.fa-pull-right,\r\n.fas.fa-pull-right,\r\n.far.fa-pull-right,\r\n.fal.fa-pull-right,\r\n.fab.fa-pull-right {\r\n  margin-left: 0.3em;\r\n}\r\n\r\n.fa-spin {\r\n  -webkit-animation: fa-spin 2s infinite linear;\r\n  animation: fa-spin 2s infinite linear;\r\n}\r\n\r\n.fa-pulse {\r\n  -webkit-animation: fa-spin 1s infinite steps(8);\r\n  animation: fa-spin 1s infinite steps(8);\r\n}\r\n\r\n@-webkit-keyframes fa-spin {\r\n  0% {\r\n    -webkit-transform: rotate(0deg);\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    -webkit-transform: rotate(360deg);\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@keyframes fa-spin {\r\n  0% {\r\n    -webkit-transform: rotate(0deg);\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    -webkit-transform: rotate(360deg);\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.fa-rotate-90 {\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\r\n  -webkit-transform: rotate(90deg);\r\n  transform: rotate(90deg);\r\n}\r\n\r\n.fa-rotate-180 {\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\r\n  -webkit-transform: rotate(180deg);\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.fa-rotate-270 {\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\r\n  -webkit-transform: rotate(270deg);\r\n  transform: rotate(270deg);\r\n}\r\n\r\n.fa-flip-horizontal {\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\r\n  -webkit-transform: scale(-1, 1);\r\n  transform: scale(-1, 1);\r\n}\r\n\r\n.fa-flip-vertical {\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\r\n  -webkit-transform: scale(1, -1);\r\n  transform: scale(1, -1);\r\n}\r\n\r\n.fa-flip-both,\r\n.fa-flip-horizontal.fa-flip-vertical {\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\r\n  -webkit-transform: scale(-1, -1);\r\n  transform: scale(-1, -1);\r\n}\r\n\r\n:root .fa-rotate-90,\r\n:root .fa-rotate-180,\r\n:root .fa-rotate-270,\r\n:root .fa-flip-horizontal,\r\n:root .fa-flip-vertical,\r\n:root .fa-flip-both {\r\n  -webkit-filter: none;\r\n  filter: none;\r\n}\r\n\r\n.fa-stack {\r\n  display: inline-block;\r\n  height: 2em;\r\n  line-height: 2em;\r\n  position: relative;\r\n  vertical-align: middle;\r\n  width: 2.5em;\r\n}\r\n\r\n.fa-stack-1x,\r\n.fa-stack-2x {\r\n  left: 0;\r\n  position: absolute;\r\n  text-align: center;\r\n  width: 100%;\r\n}\r\n\r\n.fa-stack-1x {\r\n  line-height: inherit;\r\n}\r\n\r\n.fa-stack-2x {\r\n  font-size: 2em;\r\n}\r\n\r\n.fa-inverse {\r\n  color: #fff;\r\n}\r\n\r\n/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\r\nreaders do not read off random characters that represent icons */\r\n.fa-500px:before {\r\n  content: \"\\f26e\";\r\n}\r\n\r\n.fa-accessible-icon:before {\r\n  content: \"\\f368\";\r\n}\r\n\r\n.fa-accusoft:before {\r\n  content: \"\\f369\";\r\n}\r\n\r\n.fa-acquisitions-incorporated:before {\r\n  content: \"\\f6af\";\r\n}\r\n\r\n.fa-ad:before {\r\n  content: \"\\f641\";\r\n}\r\n\r\n.fa-address-book:before {\r\n  content: \"\\f2b9\";\r\n}\r\n\r\n.fa-address-card:before {\r\n  content: \"\\f2bb\";\r\n}\r\n\r\n.fa-adjust:before {\r\n  content: \"\\f042\";\r\n}\r\n\r\n.fa-adn:before {\r\n  content: \"\\f170\";\r\n}\r\n\r\n.fa-adobe:before {\r\n  content: \"\\f778\";\r\n}\r\n\r\n.fa-adversal:before {\r\n  content: \"\\f36a\";\r\n}\r\n\r\n.fa-affiliatetheme:before {\r\n  content: \"\\f36b\";\r\n}\r\n\r\n.fa-air-freshener:before {\r\n  content: \"\\f5d0\";\r\n}\r\n\r\n.fa-airbnb:before {\r\n  content: \"\\f834\";\r\n}\r\n\r\n.fa-algolia:before {\r\n  content: \"\\f36c\";\r\n}\r\n\r\n.fa-align-center:before {\r\n  content: \"\\f037\";\r\n}\r\n\r\n.fa-align-justify:before {\r\n  content: \"\\f039\";\r\n}\r\n\r\n.fa-align-left:before {\r\n  content: \"\\f036\";\r\n}\r\n\r\n.fa-align-right:before {\r\n  content: \"\\f038\";\r\n}\r\n\r\n.fa-alipay:before {\r\n  content: \"\\f642\";\r\n}\r\n\r\n.fa-allergies:before {\r\n  content: \"\\f461\";\r\n}\r\n\r\n.fa-amazon:before {\r\n  content: \"\\f270\";\r\n}\r\n\r\n.fa-amazon-pay:before {\r\n  content: \"\\f42c\";\r\n}\r\n\r\n.fa-ambulance:before {\r\n  content: \"\\f0f9\";\r\n}\r\n\r\n.fa-american-sign-language-interpreting:before {\r\n  content: \"\\f2a3\";\r\n}\r\n\r\n.fa-amilia:before {\r\n  content: \"\\f36d\";\r\n}\r\n\r\n.fa-anchor:before {\r\n  content: \"\\f13d\";\r\n}\r\n\r\n.fa-android:before {\r\n  content: \"\\f17b\";\r\n}\r\n\r\n.fa-angellist:before {\r\n  content: \"\\f209\";\r\n}\r\n\r\n.fa-angle-double-down:before {\r\n  content: \"\\f103\";\r\n}\r\n\r\n.fa-angle-double-left:before {\r\n  content: \"\\f100\";\r\n}\r\n\r\n.fa-angle-double-right:before {\r\n  content: \"\\f101\";\r\n}\r\n\r\n.fa-angle-double-up:before {\r\n  content: \"\\f102\";\r\n}\r\n\r\n.fa-angle-down:before {\r\n  content: \"\\f107\";\r\n}\r\n\r\n.fa-angle-left:before {\r\n  content: \"\\f104\";\r\n}\r\n\r\n.fa-angle-right:before {\r\n  content: \"\\f105\";\r\n}\r\n\r\n.fa-angle-up:before {\r\n  content: \"\\f106\";\r\n}\r\n\r\n.fa-angry:before {\r\n  content: \"\\f556\";\r\n}\r\n\r\n.fa-angrycreative:before {\r\n  content: \"\\f36e\";\r\n}\r\n\r\n.fa-angular:before {\r\n  content: \"\\f420\";\r\n}\r\n\r\n.fa-ankh:before {\r\n  content: \"\\f644\";\r\n}\r\n\r\n.fa-app-store:before {\r\n  content: \"\\f36f\";\r\n}\r\n\r\n.fa-app-store-ios:before {\r\n  content: \"\\f370\";\r\n}\r\n\r\n.fa-apper:before {\r\n  content: \"\\f371\";\r\n}\r\n\r\n.fa-apple:before {\r\n  content: \"\\f179\";\r\n}\r\n\r\n.fa-apple-alt:before {\r\n  content: \"\\f5d1\";\r\n}\r\n\r\n.fa-apple-pay:before {\r\n  content: \"\\f415\";\r\n}\r\n\r\n.fa-archive:before {\r\n  content: \"\\f187\";\r\n}\r\n\r\n.fa-archway:before {\r\n  content: \"\\f557\";\r\n}\r\n\r\n.fa-arrow-alt-circle-down:before {\r\n  content: \"\\f358\";\r\n}\r\n\r\n.fa-arrow-alt-circle-left:before {\r\n  content: \"\\f359\";\r\n}\r\n\r\n.fa-arrow-alt-circle-right:before {\r\n  content: \"\\f35a\";\r\n}\r\n\r\n.fa-arrow-alt-circle-up:before {\r\n  content: \"\\f35b\";\r\n}\r\n\r\n.fa-arrow-circle-down:before {\r\n  content: \"\\f0ab\";\r\n}\r\n\r\n.fa-arrow-circle-left:before {\r\n  content: \"\\f0a8\";\r\n}\r\n\r\n.fa-arrow-circle-right:before {\r\n  content: \"\\f0a9\";\r\n}\r\n\r\n.fa-arrow-circle-up:before {\r\n  content: \"\\f0aa\";\r\n}\r\n\r\n.fa-arrow-down:before {\r\n  content: \"\\f063\";\r\n}\r\n\r\n.fa-arrow-left:before {\r\n  content: \"\\f060\";\r\n}\r\n\r\n.fa-arrow-right:before {\r\n  content: \"\\f061\";\r\n}\r\n\r\n.fa-arrow-up:before {\r\n  content: \"\\f062\";\r\n}\r\n\r\n.fa-arrows-alt:before {\r\n  content: \"\\f0b2\";\r\n}\r\n\r\n.fa-arrows-alt-h:before {\r\n  content: \"\\f337\";\r\n}\r\n\r\n.fa-arrows-alt-v:before {\r\n  content: \"\\f338\";\r\n}\r\n\r\n.fa-artstation:before {\r\n  content: \"\\f77a\";\r\n}\r\n\r\n.fa-assistive-listening-systems:before {\r\n  content: \"\\f2a2\";\r\n}\r\n\r\n.fa-asterisk:before {\r\n  content: \"\\f069\";\r\n}\r\n\r\n.fa-asymmetrik:before {\r\n  content: \"\\f372\";\r\n}\r\n\r\n.fa-at:before {\r\n  content: \"\\f1fa\";\r\n}\r\n\r\n.fa-atlas:before {\r\n  content: \"\\f558\";\r\n}\r\n\r\n.fa-atlassian:before {\r\n  content: \"\\f77b\";\r\n}\r\n\r\n.fa-atom:before {\r\n  content: \"\\f5d2\";\r\n}\r\n\r\n.fa-audible:before {\r\n  content: \"\\f373\";\r\n}\r\n\r\n.fa-audio-description:before {\r\n  content: \"\\f29e\";\r\n}\r\n\r\n.fa-autoprefixer:before {\r\n  content: \"\\f41c\";\r\n}\r\n\r\n.fa-avianex:before {\r\n  content: \"\\f374\";\r\n}\r\n\r\n.fa-aviato:before {\r\n  content: \"\\f421\";\r\n}\r\n\r\n.fa-award:before {\r\n  content: \"\\f559\";\r\n}\r\n\r\n.fa-aws:before {\r\n  content: \"\\f375\";\r\n}\r\n\r\n.fa-baby:before {\r\n  content: \"\\f77c\";\r\n}\r\n\r\n.fa-baby-carriage:before {\r\n  content: \"\\f77d\";\r\n}\r\n\r\n.fa-backspace:before {\r\n  content: \"\\f55a\";\r\n}\r\n\r\n.fa-backward:before {\r\n  content: \"\\f04a\";\r\n}\r\n\r\n.fa-bacon:before {\r\n  content: \"\\f7e5\";\r\n}\r\n\r\n.fa-bahai:before {\r\n  content: \"\\f666\";\r\n}\r\n\r\n.fa-balance-scale:before {\r\n  content: \"\\f24e\";\r\n}\r\n\r\n.fa-balance-scale-left:before {\r\n  content: \"\\f515\";\r\n}\r\n\r\n.fa-balance-scale-right:before {\r\n  content: \"\\f516\";\r\n}\r\n\r\n.fa-ban:before {\r\n  content: \"\\f05e\";\r\n}\r\n\r\n.fa-band-aid:before {\r\n  content: \"\\f462\";\r\n}\r\n\r\n.fa-bandcamp:before {\r\n  content: \"\\f2d5\";\r\n}\r\n\r\n.fa-barcode:before {\r\n  content: \"\\f02a\";\r\n}\r\n\r\n.fa-bars:before {\r\n  content: \"\\f0c9\";\r\n}\r\n\r\n.fa-baseball-ball:before {\r\n  content: \"\\f433\";\r\n}\r\n\r\n.fa-basketball-ball:before {\r\n  content: \"\\f434\";\r\n}\r\n\r\n.fa-bath:before {\r\n  content: \"\\f2cd\";\r\n}\r\n\r\n.fa-battery-empty:before {\r\n  content: \"\\f244\";\r\n}\r\n\r\n.fa-battery-full:before {\r\n  content: \"\\f240\";\r\n}\r\n\r\n.fa-battery-half:before {\r\n  content: \"\\f242\";\r\n}\r\n\r\n.fa-battery-quarter:before {\r\n  content: \"\\f243\";\r\n}\r\n\r\n.fa-battery-three-quarters:before {\r\n  content: \"\\f241\";\r\n}\r\n\r\n.fa-battle-net:before {\r\n  content: \"\\f835\";\r\n}\r\n\r\n.fa-bed:before {\r\n  content: \"\\f236\";\r\n}\r\n\r\n.fa-beer:before {\r\n  content: \"\\f0fc\";\r\n}\r\n\r\n.fa-behance:before {\r\n  content: \"\\f1b4\";\r\n}\r\n\r\n.fa-behance-square:before {\r\n  content: \"\\f1b5\";\r\n}\r\n\r\n.fa-bell:before {\r\n  content: \"\\f0f3\";\r\n}\r\n\r\n.fa-bell-slash:before {\r\n  content: \"\\f1f6\";\r\n}\r\n\r\n.fa-bezier-curve:before {\r\n  content: \"\\f55b\";\r\n}\r\n\r\n.fa-bible:before {\r\n  content: \"\\f647\";\r\n}\r\n\r\n.fa-bicycle:before {\r\n  content: \"\\f206\";\r\n}\r\n\r\n.fa-biking:before {\r\n  content: \"\\f84a\";\r\n}\r\n\r\n.fa-bimobject:before {\r\n  content: \"\\f378\";\r\n}\r\n\r\n.fa-binoculars:before {\r\n  content: \"\\f1e5\";\r\n}\r\n\r\n.fa-biohazard:before {\r\n  content: \"\\f780\";\r\n}\r\n\r\n.fa-birthday-cake:before {\r\n  content: \"\\f1fd\";\r\n}\r\n\r\n.fa-bitbucket:before {\r\n  content: \"\\f171\";\r\n}\r\n\r\n.fa-bitcoin:before {\r\n  content: \"\\f379\";\r\n}\r\n\r\n.fa-bity:before {\r\n  content: \"\\f37a\";\r\n}\r\n\r\n.fa-black-tie:before {\r\n  content: \"\\f27e\";\r\n}\r\n\r\n.fa-blackberry:before {\r\n  content: \"\\f37b\";\r\n}\r\n\r\n.fa-blender:before {\r\n  content: \"\\f517\";\r\n}\r\n\r\n.fa-blender-phone:before {\r\n  content: \"\\f6b6\";\r\n}\r\n\r\n.fa-blind:before {\r\n  content: \"\\f29d\";\r\n}\r\n\r\n.fa-blog:before {\r\n  content: \"\\f781\";\r\n}\r\n\r\n.fa-blogger:before {\r\n  content: \"\\f37c\";\r\n}\r\n\r\n.fa-blogger-b:before {\r\n  content: \"\\f37d\";\r\n}\r\n\r\n.fa-bluetooth:before {\r\n  content: \"\\f293\";\r\n}\r\n\r\n.fa-bluetooth-b:before {\r\n  content: \"\\f294\";\r\n}\r\n\r\n.fa-bold:before {\r\n  content: \"\\f032\";\r\n}\r\n\r\n.fa-bolt:before {\r\n  content: \"\\f0e7\";\r\n}\r\n\r\n.fa-bomb:before {\r\n  content: \"\\f1e2\";\r\n}\r\n\r\n.fa-bone:before {\r\n  content: \"\\f5d7\";\r\n}\r\n\r\n.fa-bong:before {\r\n  content: \"\\f55c\";\r\n}\r\n\r\n.fa-book:before {\r\n  content: \"\\f02d\";\r\n}\r\n\r\n.fa-book-dead:before {\r\n  content: \"\\f6b7\";\r\n}\r\n\r\n.fa-book-medical:before {\r\n  content: \"\\f7e6\";\r\n}\r\n\r\n.fa-book-open:before {\r\n  content: \"\\f518\";\r\n}\r\n\r\n.fa-book-reader:before {\r\n  content: \"\\f5da\";\r\n}\r\n\r\n.fa-bookmark:before {\r\n  content: \"\\f02e\";\r\n}\r\n\r\n.fa-bootstrap:before {\r\n  content: \"\\f836\";\r\n}\r\n\r\n.fa-border-all:before {\r\n  content: \"\\f84c\";\r\n}\r\n\r\n.fa-border-none:before {\r\n  content: \"\\f850\";\r\n}\r\n\r\n.fa-border-style:before {\r\n  content: \"\\f853\";\r\n}\r\n\r\n.fa-bowling-ball:before {\r\n  content: \"\\f436\";\r\n}\r\n\r\n.fa-box:before {\r\n  content: \"\\f466\";\r\n}\r\n\r\n.fa-box-open:before {\r\n  content: \"\\f49e\";\r\n}\r\n\r\n.fa-box-tissue:before {\r\n  content: \"\\f95b\";\r\n}\r\n\r\n.fa-boxes:before {\r\n  content: \"\\f468\";\r\n}\r\n\r\n.fa-braille:before {\r\n  content: \"\\f2a1\";\r\n}\r\n\r\n.fa-brain:before {\r\n  content: \"\\f5dc\";\r\n}\r\n\r\n.fa-bread-slice:before {\r\n  content: \"\\f7ec\";\r\n}\r\n\r\n.fa-briefcase:before {\r\n  content: \"\\f0b1\";\r\n}\r\n\r\n.fa-briefcase-medical:before {\r\n  content: \"\\f469\";\r\n}\r\n\r\n.fa-broadcast-tower:before {\r\n  content: \"\\f519\";\r\n}\r\n\r\n.fa-broom:before {\r\n  content: \"\\f51a\";\r\n}\r\n\r\n.fa-brush:before {\r\n  content: \"\\f55d\";\r\n}\r\n\r\n.fa-btc:before {\r\n  content: \"\\f15a\";\r\n}\r\n\r\n.fa-buffer:before {\r\n  content: \"\\f837\";\r\n}\r\n\r\n.fa-bug:before {\r\n  content: \"\\f188\";\r\n}\r\n\r\n.fa-building:before {\r\n  content: \"\\f1ad\";\r\n}\r\n\r\n.fa-bullhorn:before {\r\n  content: \"\\f0a1\";\r\n}\r\n\r\n.fa-bullseye:before {\r\n  content: \"\\f140\";\r\n}\r\n\r\n.fa-burn:before {\r\n  content: \"\\f46a\";\r\n}\r\n\r\n.fa-buromobelexperte:before {\r\n  content: \"\\f37f\";\r\n}\r\n\r\n.fa-bus:before {\r\n  content: \"\\f207\";\r\n}\r\n\r\n.fa-bus-alt:before {\r\n  content: \"\\f55e\";\r\n}\r\n\r\n.fa-business-time:before {\r\n  content: \"\\f64a\";\r\n}\r\n\r\n.fa-buy-n-large:before {\r\n  content: \"\\f8a6\";\r\n}\r\n\r\n.fa-buysellads:before {\r\n  content: \"\\f20d\";\r\n}\r\n\r\n.fa-calculator:before {\r\n  content: \"\\f1ec\";\r\n}\r\n\r\n.fa-calendar:before {\r\n  content: \"\\f133\";\r\n}\r\n\r\n.fa-calendar-alt:before {\r\n  content: \"\\f073\";\r\n}\r\n\r\n.fa-calendar-check:before {\r\n  content: \"\\f274\";\r\n}\r\n\r\n.fa-calendar-day:before {\r\n  content: \"\\f783\";\r\n}\r\n\r\n.fa-calendar-minus:before {\r\n  content: \"\\f272\";\r\n}\r\n\r\n.fa-calendar-plus:before {\r\n  content: \"\\f271\";\r\n}\r\n\r\n.fa-calendar-times:before {\r\n  content: \"\\f273\";\r\n}\r\n\r\n.fa-calendar-week:before {\r\n  content: \"\\f784\";\r\n}\r\n\r\n.fa-camera:before {\r\n  content: \"\\f030\";\r\n}\r\n\r\n.fa-camera-retro:before {\r\n  content: \"\\f083\";\r\n}\r\n\r\n.fa-campground:before {\r\n  content: \"\\f6bb\";\r\n}\r\n\r\n.fa-canadian-maple-leaf:before {\r\n  content: \"\\f785\";\r\n}\r\n\r\n.fa-candy-cane:before {\r\n  content: \"\\f786\";\r\n}\r\n\r\n.fa-cannabis:before {\r\n  content: \"\\f55f\";\r\n}\r\n\r\n.fa-capsules:before {\r\n  content: \"\\f46b\";\r\n}\r\n\r\n.fa-car:before {\r\n  content: \"\\f1b9\";\r\n}\r\n\r\n.fa-car-alt:before {\r\n  content: \"\\f5de\";\r\n}\r\n\r\n.fa-car-battery:before {\r\n  content: \"\\f5df\";\r\n}\r\n\r\n.fa-car-crash:before {\r\n  content: \"\\f5e1\";\r\n}\r\n\r\n.fa-car-side:before {\r\n  content: \"\\f5e4\";\r\n}\r\n\r\n.fa-caravan:before {\r\n  content: \"\\f8ff\";\r\n}\r\n\r\n.fa-caret-down:before {\r\n  content: \"\\f0d7\";\r\n}\r\n\r\n.fa-caret-left:before {\r\n  content: \"\\f0d9\";\r\n}\r\n\r\n.fa-caret-right:before {\r\n  content: \"\\f0da\";\r\n}\r\n\r\n.fa-caret-square-down:before {\r\n  content: \"\\f150\";\r\n}\r\n\r\n.fa-caret-square-left:before {\r\n  content: \"\\f191\";\r\n}\r\n\r\n.fa-caret-square-right:before {\r\n  content: \"\\f152\";\r\n}\r\n\r\n.fa-caret-square-up:before {\r\n  content: \"\\f151\";\r\n}\r\n\r\n.fa-caret-up:before {\r\n  content: \"\\f0d8\";\r\n}\r\n\r\n.fa-carrot:before {\r\n  content: \"\\f787\";\r\n}\r\n\r\n.fa-cart-arrow-down:before {\r\n  content: \"\\f218\";\r\n}\r\n\r\n.fa-cart-plus:before {\r\n  content: \"\\f217\";\r\n}\r\n\r\n.fa-cash-register:before {\r\n  content: \"\\f788\";\r\n}\r\n\r\n.fa-cat:before {\r\n  content: \"\\f6be\";\r\n}\r\n\r\n.fa-cc-amazon-pay:before {\r\n  content: \"\\f42d\";\r\n}\r\n\r\n.fa-cc-amex:before {\r\n  content: \"\\f1f3\";\r\n}\r\n\r\n.fa-cc-apple-pay:before {\r\n  content: \"\\f416\";\r\n}\r\n\r\n.fa-cc-diners-club:before {\r\n  content: \"\\f24c\";\r\n}\r\n\r\n.fa-cc-discover:before {\r\n  content: \"\\f1f2\";\r\n}\r\n\r\n.fa-cc-jcb:before {\r\n  content: \"\\f24b\";\r\n}\r\n\r\n.fa-cc-mastercard:before {\r\n  content: \"\\f1f1\";\r\n}\r\n\r\n.fa-cc-paypal:before {\r\n  content: \"\\f1f4\";\r\n}\r\n\r\n.fa-cc-stripe:before {\r\n  content: \"\\f1f5\";\r\n}\r\n\r\n.fa-cc-visa:before {\r\n  content: \"\\f1f0\";\r\n}\r\n\r\n.fa-centercode:before {\r\n  content: \"\\f380\";\r\n}\r\n\r\n.fa-centos:before {\r\n  content: \"\\f789\";\r\n}\r\n\r\n.fa-certificate:before {\r\n  content: \"\\f0a3\";\r\n}\r\n\r\n.fa-chair:before {\r\n  content: \"\\f6c0\";\r\n}\r\n\r\n.fa-chalkboard:before {\r\n  content: \"\\f51b\";\r\n}\r\n\r\n.fa-chalkboard-teacher:before {\r\n  content: \"\\f51c\";\r\n}\r\n\r\n.fa-charging-station:before {\r\n  content: \"\\f5e7\";\r\n}\r\n\r\n.fa-chart-area:before {\r\n  content: \"\\f1fe\";\r\n}\r\n\r\n.fa-chart-bar:before {\r\n  content: \"\\f080\";\r\n}\r\n\r\n.fa-chart-line:before {\r\n  content: \"\\f201\";\r\n}\r\n\r\n.fa-chart-pie:before {\r\n  content: \"\\f200\";\r\n}\r\n\r\n.fa-check:before {\r\n  content: \"\\f00c\";\r\n}\r\n\r\n.fa-check-circle:before {\r\n  content: \"\\f058\";\r\n}\r\n\r\n.fa-check-double:before {\r\n  content: \"\\f560\";\r\n}\r\n\r\n.fa-check-square:before {\r\n  content: \"\\f14a\";\r\n}\r\n\r\n.fa-cheese:before {\r\n  content: \"\\f7ef\";\r\n}\r\n\r\n.fa-chess:before {\r\n  content: \"\\f439\";\r\n}\r\n\r\n.fa-chess-bishop:before {\r\n  content: \"\\f43a\";\r\n}\r\n\r\n.fa-chess-board:before {\r\n  content: \"\\f43c\";\r\n}\r\n\r\n.fa-chess-king:before {\r\n  content: \"\\f43f\";\r\n}\r\n\r\n.fa-chess-knight:before {\r\n  content: \"\\f441\";\r\n}\r\n\r\n.fa-chess-pawn:before {\r\n  content: \"\\f443\";\r\n}\r\n\r\n.fa-chess-queen:before {\r\n  content: \"\\f445\";\r\n}\r\n\r\n.fa-chess-rook:before {\r\n  content: \"\\f447\";\r\n}\r\n\r\n.fa-chevron-circle-down:before {\r\n  content: \"\\f13a\";\r\n}\r\n\r\n.fa-chevron-circle-left:before {\r\n  content: \"\\f137\";\r\n}\r\n\r\n.fa-chevron-circle-right:before {\r\n  content: \"\\f138\";\r\n}\r\n\r\n.fa-chevron-circle-up:before {\r\n  content: \"\\f139\";\r\n}\r\n\r\n.fa-chevron-down:before {\r\n  content: \"\\f078\";\r\n}\r\n\r\n.fa-chevron-left:before {\r\n  content: \"\\f053\";\r\n}\r\n\r\n.fa-chevron-right:before {\r\n  content: \"\\f054\";\r\n}\r\n\r\n.fa-chevron-up:before {\r\n  content: \"\\f077\";\r\n}\r\n\r\n.fa-child:before {\r\n  content: \"\\f1ae\";\r\n}\r\n\r\n.fa-chrome:before {\r\n  content: \"\\f268\";\r\n}\r\n\r\n.fa-chromecast:before {\r\n  content: \"\\f838\";\r\n}\r\n\r\n.fa-church:before {\r\n  content: \"\\f51d\";\r\n}\r\n\r\n.fa-circle:before {\r\n  content: \"\\f111\";\r\n}\r\n\r\n.fa-circle-notch:before {\r\n  content: \"\\f1ce\";\r\n}\r\n\r\n.fa-city:before {\r\n  content: \"\\f64f\";\r\n}\r\n\r\n.fa-clinic-medical:before {\r\n  content: \"\\f7f2\";\r\n}\r\n\r\n.fa-clipboard:before {\r\n  content: \"\\f328\";\r\n}\r\n\r\n.fa-clipboard-check:before {\r\n  content: \"\\f46c\";\r\n}\r\n\r\n.fa-clipboard-list:before {\r\n  content: \"\\f46d\";\r\n}\r\n\r\n.fa-clock:before {\r\n  content: \"\\f017\";\r\n}\r\n\r\n.fa-clone:before {\r\n  content: \"\\f24d\";\r\n}\r\n\r\n.fa-closed-captioning:before {\r\n  content: \"\\f20a\";\r\n}\r\n\r\n.fa-cloud:before {\r\n  content: \"\\f0c2\";\r\n}\r\n\r\n.fa-cloud-download-alt:before {\r\n  content: \"\\f381\";\r\n}\r\n\r\n.fa-cloud-meatball:before {\r\n  content: \"\\f73b\";\r\n}\r\n\r\n.fa-cloud-moon:before {\r\n  content: \"\\f6c3\";\r\n}\r\n\r\n.fa-cloud-moon-rain:before {\r\n  content: \"\\f73c\";\r\n}\r\n\r\n.fa-cloud-rain:before {\r\n  content: \"\\f73d\";\r\n}\r\n\r\n.fa-cloud-showers-heavy:before {\r\n  content: \"\\f740\";\r\n}\r\n\r\n.fa-cloud-sun:before {\r\n  content: \"\\f6c4\";\r\n}\r\n\r\n.fa-cloud-sun-rain:before {\r\n  content: \"\\f743\";\r\n}\r\n\r\n.fa-cloud-upload-alt:before {\r\n  content: \"\\f382\";\r\n}\r\n\r\n.fa-cloudscale:before {\r\n  content: \"\\f383\";\r\n}\r\n\r\n.fa-cloudsmith:before {\r\n  content: \"\\f384\";\r\n}\r\n\r\n.fa-cloudversify:before {\r\n  content: \"\\f385\";\r\n}\r\n\r\n.fa-cocktail:before {\r\n  content: \"\\f561\";\r\n}\r\n\r\n.fa-code:before {\r\n  content: \"\\f121\";\r\n}\r\n\r\n.fa-code-branch:before {\r\n  content: \"\\f126\";\r\n}\r\n\r\n.fa-codepen:before {\r\n  content: \"\\f1cb\";\r\n}\r\n\r\n.fa-codiepie:before {\r\n  content: \"\\f284\";\r\n}\r\n\r\n.fa-coffee:before {\r\n  content: \"\\f0f4\";\r\n}\r\n\r\n.fa-cog:before {\r\n  content: \"\\f013\";\r\n}\r\n\r\n.fa-cogs:before {\r\n  content: \"\\f085\";\r\n}\r\n\r\n.fa-coins:before {\r\n  content: \"\\f51e\";\r\n}\r\n\r\n.fa-columns:before {\r\n  content: \"\\f0db\";\r\n}\r\n\r\n.fa-comment:before {\r\n  content: \"\\f075\";\r\n}\r\n\r\n.fa-comment-alt:before {\r\n  content: \"\\f27a\";\r\n}\r\n\r\n.fa-comment-dollar:before {\r\n  content: \"\\f651\";\r\n}\r\n\r\n.fa-comment-dots:before {\r\n  content: \"\\f4ad\";\r\n}\r\n\r\n.fa-comment-medical:before {\r\n  content: \"\\f7f5\";\r\n}\r\n\r\n.fa-comment-slash:before {\r\n  content: \"\\f4b3\";\r\n}\r\n\r\n.fa-comments:before {\r\n  content: \"\\f086\";\r\n}\r\n\r\n.fa-comments-dollar:before {\r\n  content: \"\\f653\";\r\n}\r\n\r\n.fa-compact-disc:before {\r\n  content: \"\\f51f\";\r\n}\r\n\r\n.fa-compass:before {\r\n  content: \"\\f14e\";\r\n}\r\n\r\n.fa-compress:before {\r\n  content: \"\\f066\";\r\n}\r\n\r\n.fa-compress-alt:before {\r\n  content: \"\\f422\";\r\n}\r\n\r\n.fa-compress-arrows-alt:before {\r\n  content: \"\\f78c\";\r\n}\r\n\r\n.fa-concierge-bell:before {\r\n  content: \"\\f562\";\r\n}\r\n\r\n.fa-confluence:before {\r\n  content: \"\\f78d\";\r\n}\r\n\r\n.fa-connectdevelop:before {\r\n  content: \"\\f20e\";\r\n}\r\n\r\n.fa-contao:before {\r\n  content: \"\\f26d\";\r\n}\r\n\r\n.fa-cookie:before {\r\n  content: \"\\f563\";\r\n}\r\n\r\n.fa-cookie-bite:before {\r\n  content: \"\\f564\";\r\n}\r\n\r\n.fa-copy:before {\r\n  content: \"\\f0c5\";\r\n}\r\n\r\n.fa-copyright:before {\r\n  content: \"\\f1f9\";\r\n}\r\n\r\n.fa-cotton-bureau:before {\r\n  content: \"\\f89e\";\r\n}\r\n\r\n.fa-couch:before {\r\n  content: \"\\f4b8\";\r\n}\r\n\r\n.fa-cpanel:before {\r\n  content: \"\\f388\";\r\n}\r\n\r\n.fa-creative-commons:before {\r\n  content: \"\\f25e\";\r\n}\r\n\r\n.fa-creative-commons-by:before {\r\n  content: \"\\f4e7\";\r\n}\r\n\r\n.fa-creative-commons-nc:before {\r\n  content: \"\\f4e8\";\r\n}\r\n\r\n.fa-creative-commons-nc-eu:before {\r\n  content: \"\\f4e9\";\r\n}\r\n\r\n.fa-creative-commons-nc-jp:before {\r\n  content: \"\\f4ea\";\r\n}\r\n\r\n.fa-creative-commons-nd:before {\r\n  content: \"\\f4eb\";\r\n}\r\n\r\n.fa-creative-commons-pd:before {\r\n  content: \"\\f4ec\";\r\n}\r\n\r\n.fa-creative-commons-pd-alt:before {\r\n  content: \"\\f4ed\";\r\n}\r\n\r\n.fa-creative-commons-remix:before {\r\n  content: \"\\f4ee\";\r\n}\r\n\r\n.fa-creative-commons-sa:before {\r\n  content: \"\\f4ef\";\r\n}\r\n\r\n.fa-creative-commons-sampling:before {\r\n  content: \"\\f4f0\";\r\n}\r\n\r\n.fa-creative-commons-sampling-plus:before {\r\n  content: \"\\f4f1\";\r\n}\r\n\r\n.fa-creative-commons-share:before {\r\n  content: \"\\f4f2\";\r\n}\r\n\r\n.fa-creative-commons-zero:before {\r\n  content: \"\\f4f3\";\r\n}\r\n\r\n.fa-credit-card:before {\r\n  content: \"\\f09d\";\r\n}\r\n\r\n.fa-critical-role:before {\r\n  content: \"\\f6c9\";\r\n}\r\n\r\n.fa-crop:before {\r\n  content: \"\\f125\";\r\n}\r\n\r\n.fa-crop-alt:before {\r\n  content: \"\\f565\";\r\n}\r\n\r\n.fa-cross:before {\r\n  content: \"\\f654\";\r\n}\r\n\r\n.fa-crosshairs:before {\r\n  content: \"\\f05b\";\r\n}\r\n\r\n.fa-crow:before {\r\n  content: \"\\f520\";\r\n}\r\n\r\n.fa-crown:before {\r\n  content: \"\\f521\";\r\n}\r\n\r\n.fa-crutch:before {\r\n  content: \"\\f7f7\";\r\n}\r\n\r\n.fa-css3:before {\r\n  content: \"\\f13c\";\r\n}\r\n\r\n.fa-css3-alt:before {\r\n  content: \"\\f38b\";\r\n}\r\n\r\n.fa-cube:before {\r\n  content: \"\\f1b2\";\r\n}\r\n\r\n.fa-cubes:before {\r\n  content: \"\\f1b3\";\r\n}\r\n\r\n.fa-cut:before {\r\n  content: \"\\f0c4\";\r\n}\r\n\r\n.fa-cuttlefish:before {\r\n  content: \"\\f38c\";\r\n}\r\n\r\n.fa-d-and-d:before {\r\n  content: \"\\f38d\";\r\n}\r\n\r\n.fa-d-and-d-beyond:before {\r\n  content: \"\\f6ca\";\r\n}\r\n\r\n.fa-dailymotion:before {\r\n  content: \"\\f952\";\r\n}\r\n\r\n.fa-dashcube:before {\r\n  content: \"\\f210\";\r\n}\r\n\r\n.fa-database:before {\r\n  content: \"\\f1c0\";\r\n}\r\n\r\n.fa-deaf:before {\r\n  content: \"\\f2a4\";\r\n}\r\n\r\n.fa-delicious:before {\r\n  content: \"\\f1a5\";\r\n}\r\n\r\n.fa-democrat:before {\r\n  content: \"\\f747\";\r\n}\r\n\r\n.fa-deploydog:before {\r\n  content: \"\\f38e\";\r\n}\r\n\r\n.fa-deskpro:before {\r\n  content: \"\\f38f\";\r\n}\r\n\r\n.fa-desktop:before {\r\n  content: \"\\f108\";\r\n}\r\n\r\n.fa-dev:before {\r\n  content: \"\\f6cc\";\r\n}\r\n\r\n.fa-deviantart:before {\r\n  content: \"\\f1bd\";\r\n}\r\n\r\n.fa-dharmachakra:before {\r\n  content: \"\\f655\";\r\n}\r\n\r\n.fa-dhl:before {\r\n  content: \"\\f790\";\r\n}\r\n\r\n.fa-diagnoses:before {\r\n  content: \"\\f470\";\r\n}\r\n\r\n.fa-diaspora:before {\r\n  content: \"\\f791\";\r\n}\r\n\r\n.fa-dice:before {\r\n  content: \"\\f522\";\r\n}\r\n\r\n.fa-dice-d20:before {\r\n  content: \"\\f6cf\";\r\n}\r\n\r\n.fa-dice-d6:before {\r\n  content: \"\\f6d1\";\r\n}\r\n\r\n.fa-dice-five:before {\r\n  content: \"\\f523\";\r\n}\r\n\r\n.fa-dice-four:before {\r\n  content: \"\\f524\";\r\n}\r\n\r\n.fa-dice-one:before {\r\n  content: \"\\f525\";\r\n}\r\n\r\n.fa-dice-six:before {\r\n  content: \"\\f526\";\r\n}\r\n\r\n.fa-dice-three:before {\r\n  content: \"\\f527\";\r\n}\r\n\r\n.fa-dice-two:before {\r\n  content: \"\\f528\";\r\n}\r\n\r\n.fa-digg:before {\r\n  content: \"\\f1a6\";\r\n}\r\n\r\n.fa-digital-ocean:before {\r\n  content: \"\\f391\";\r\n}\r\n\r\n.fa-digital-tachograph:before {\r\n  content: \"\\f566\";\r\n}\r\n\r\n.fa-directions:before {\r\n  content: \"\\f5eb\";\r\n}\r\n\r\n.fa-discord:before {\r\n  content: \"\\f392\";\r\n}\r\n\r\n.fa-discourse:before {\r\n  content: \"\\f393\";\r\n}\r\n\r\n.fa-disease:before {\r\n  content: \"\\f7fa\";\r\n}\r\n\r\n.fa-divide:before {\r\n  content: \"\\f529\";\r\n}\r\n\r\n.fa-dizzy:before {\r\n  content: \"\\f567\";\r\n}\r\n\r\n.fa-dna:before {\r\n  content: \"\\f471\";\r\n}\r\n\r\n.fa-dochub:before {\r\n  content: \"\\f394\";\r\n}\r\n\r\n.fa-docker:before {\r\n  content: \"\\f395\";\r\n}\r\n\r\n.fa-dog:before {\r\n  content: \"\\f6d3\";\r\n}\r\n\r\n.fa-dollar-sign:before {\r\n  content: \"\\f155\";\r\n}\r\n\r\n.fa-dolly:before {\r\n  content: \"\\f472\";\r\n}\r\n\r\n.fa-dolly-flatbed:before {\r\n  content: \"\\f474\";\r\n}\r\n\r\n.fa-donate:before {\r\n  content: \"\\f4b9\";\r\n}\r\n\r\n.fa-door-closed:before {\r\n  content: \"\\f52a\";\r\n}\r\n\r\n.fa-door-open:before {\r\n  content: \"\\f52b\";\r\n}\r\n\r\n.fa-dot-circle:before {\r\n  content: \"\\f192\";\r\n}\r\n\r\n.fa-dove:before {\r\n  content: \"\\f4ba\";\r\n}\r\n\r\n.fa-download:before {\r\n  content: \"\\f019\";\r\n}\r\n\r\n.fa-draft2digital:before {\r\n  content: \"\\f396\";\r\n}\r\n\r\n.fa-drafting-compass:before {\r\n  content: \"\\f568\";\r\n}\r\n\r\n.fa-dragon:before {\r\n  content: \"\\f6d5\";\r\n}\r\n\r\n.fa-draw-polygon:before {\r\n  content: \"\\f5ee\";\r\n}\r\n\r\n.fa-dribbble:before {\r\n  content: \"\\f17d\";\r\n}\r\n\r\n.fa-dribbble-square:before {\r\n  content: \"\\f397\";\r\n}\r\n\r\n.fa-dropbox:before {\r\n  content: \"\\f16b\";\r\n}\r\n\r\n.fa-drum:before {\r\n  content: \"\\f569\";\r\n}\r\n\r\n.fa-drum-steelpan:before {\r\n  content: \"\\f56a\";\r\n}\r\n\r\n.fa-drumstick-bite:before {\r\n  content: \"\\f6d7\";\r\n}\r\n\r\n.fa-drupal:before {\r\n  content: \"\\f1a9\";\r\n}\r\n\r\n.fa-dumbbell:before {\r\n  content: \"\\f44b\";\r\n}\r\n\r\n.fa-dumpster:before {\r\n  content: \"\\f793\";\r\n}\r\n\r\n.fa-dumpster-fire:before {\r\n  content: \"\\f794\";\r\n}\r\n\r\n.fa-dungeon:before {\r\n  content: \"\\f6d9\";\r\n}\r\n\r\n.fa-dyalog:before {\r\n  content: \"\\f399\";\r\n}\r\n\r\n.fa-earlybirds:before {\r\n  content: \"\\f39a\";\r\n}\r\n\r\n.fa-ebay:before {\r\n  content: \"\\f4f4\";\r\n}\r\n\r\n.fa-edge:before {\r\n  content: \"\\f282\";\r\n}\r\n\r\n.fa-edit:before {\r\n  content: \"\\f044\";\r\n}\r\n\r\n.fa-egg:before {\r\n  content: \"\\f7fb\";\r\n}\r\n\r\n.fa-eject:before {\r\n  content: \"\\f052\";\r\n}\r\n\r\n.fa-elementor:before {\r\n  content: \"\\f430\";\r\n}\r\n\r\n.fa-ellipsis-h:before {\r\n  content: \"\\f141\";\r\n}\r\n\r\n.fa-ellipsis-v:before {\r\n  content: \"\\f142\";\r\n}\r\n\r\n.fa-ello:before {\r\n  content: \"\\f5f1\";\r\n}\r\n\r\n.fa-ember:before {\r\n  content: \"\\f423\";\r\n}\r\n\r\n.fa-empire:before {\r\n  content: \"\\f1d1\";\r\n}\r\n\r\n.fa-envelope:before {\r\n  content: \"\\f0e0\";\r\n}\r\n\r\n.fa-envelope-open:before {\r\n  content: \"\\f2b6\";\r\n}\r\n\r\n.fa-envelope-open-text:before {\r\n  content: \"\\f658\";\r\n}\r\n\r\n.fa-envelope-square:before {\r\n  content: \"\\f199\";\r\n}\r\n\r\n.fa-envira:before {\r\n  content: \"\\f299\";\r\n}\r\n\r\n.fa-equals:before {\r\n  content: \"\\f52c\";\r\n}\r\n\r\n.fa-eraser:before {\r\n  content: \"\\f12d\";\r\n}\r\n\r\n.fa-erlang:before {\r\n  content: \"\\f39d\";\r\n}\r\n\r\n.fa-ethereum:before {\r\n  content: \"\\f42e\";\r\n}\r\n\r\n.fa-ethernet:before {\r\n  content: \"\\f796\";\r\n}\r\n\r\n.fa-etsy:before {\r\n  content: \"\\f2d7\";\r\n}\r\n\r\n.fa-euro-sign:before {\r\n  content: \"\\f153\";\r\n}\r\n\r\n.fa-evernote:before {\r\n  content: \"\\f839\";\r\n}\r\n\r\n.fa-exchange-alt:before {\r\n  content: \"\\f362\";\r\n}\r\n\r\n.fa-exclamation:before {\r\n  content: \"\\f12a\";\r\n}\r\n\r\n.fa-exclamation-circle:before {\r\n  content: \"\\f06a\";\r\n}\r\n\r\n.fa-exclamation-triangle:before {\r\n  content: \"\\f071\";\r\n}\r\n\r\n.fa-expand:before {\r\n  content: \"\\f065\";\r\n}\r\n\r\n.fa-expand-alt:before {\r\n  content: \"\\f424\";\r\n}\r\n\r\n.fa-expand-arrows-alt:before {\r\n  content: \"\\f31e\";\r\n}\r\n\r\n.fa-expeditedssl:before {\r\n  content: \"\\f23e\";\r\n}\r\n\r\n.fa-external-link-alt:before {\r\n  content: \"\\f35d\";\r\n}\r\n\r\n.fa-external-link-square-alt:before {\r\n  content: \"\\f360\";\r\n}\r\n\r\n.fa-eye:before {\r\n  content: \"\\f06e\";\r\n}\r\n\r\n.fa-eye-dropper:before {\r\n  content: \"\\f1fb\";\r\n}\r\n\r\n.fa-eye-slash:before {\r\n  content: \"\\f070\";\r\n}\r\n\r\n.fa-facebook:before {\r\n  content: \"\\f09a\";\r\n}\r\n\r\n.fa-facebook-f:before {\r\n  content: \"\\f39e\";\r\n}\r\n\r\n.fa-facebook-messenger:before {\r\n  content: \"\\f39f\";\r\n}\r\n\r\n.fa-facebook-square:before {\r\n  content: \"\\f082\";\r\n}\r\n\r\n.fa-fan:before {\r\n  content: \"\\f863\";\r\n}\r\n\r\n.fa-fantasy-flight-games:before {\r\n  content: \"\\f6dc\";\r\n}\r\n\r\n.fa-fast-backward:before {\r\n  content: \"\\f049\";\r\n}\r\n\r\n.fa-fast-forward:before {\r\n  content: \"\\f050\";\r\n}\r\n\r\n.fa-faucet:before {\r\n  content: \"\\f905\";\r\n}\r\n\r\n.fa-fax:before {\r\n  content: \"\\f1ac\";\r\n}\r\n\r\n.fa-feather:before {\r\n  content: \"\\f52d\";\r\n}\r\n\r\n.fa-feather-alt:before {\r\n  content: \"\\f56b\";\r\n}\r\n\r\n.fa-fedex:before {\r\n  content: \"\\f797\";\r\n}\r\n\r\n.fa-fedora:before {\r\n  content: \"\\f798\";\r\n}\r\n\r\n.fa-female:before {\r\n  content: \"\\f182\";\r\n}\r\n\r\n.fa-fighter-jet:before {\r\n  content: \"\\f0fb\";\r\n}\r\n\r\n.fa-figma:before {\r\n  content: \"\\f799\";\r\n}\r\n\r\n.fa-file:before {\r\n  content: \"\\f15b\";\r\n}\r\n\r\n.fa-file-alt:before {\r\n  content: \"\\f15c\";\r\n}\r\n\r\n.fa-file-archive:before {\r\n  content: \"\\f1c6\";\r\n}\r\n\r\n.fa-file-audio:before {\r\n  content: \"\\f1c7\";\r\n}\r\n\r\n.fa-file-code:before {\r\n  content: \"\\f1c9\";\r\n}\r\n\r\n.fa-file-contract:before {\r\n  content: \"\\f56c\";\r\n}\r\n\r\n.fa-file-csv:before {\r\n  content: \"\\f6dd\";\r\n}\r\n\r\n.fa-file-download:before {\r\n  content: \"\\f56d\";\r\n}\r\n\r\n.fa-file-excel:before {\r\n  content: \"\\f1c3\";\r\n}\r\n\r\n.fa-file-export:before {\r\n  content: \"\\f56e\";\r\n}\r\n\r\n.fa-file-image:before {\r\n  content: \"\\f1c5\";\r\n}\r\n\r\n.fa-file-import:before {\r\n  content: \"\\f56f\";\r\n}\r\n\r\n.fa-file-invoice:before {\r\n  content: \"\\f570\";\r\n}\r\n\r\n.fa-file-invoice-dollar:before {\r\n  content: \"\\f571\";\r\n}\r\n\r\n.fa-file-medical:before {\r\n  content: \"\\f477\";\r\n}\r\n\r\n.fa-file-medical-alt:before {\r\n  content: \"\\f478\";\r\n}\r\n\r\n.fa-file-pdf:before {\r\n  content: \"\\f1c1\";\r\n}\r\n\r\n.fa-file-powerpoint:before {\r\n  content: \"\\f1c4\";\r\n}\r\n\r\n.fa-file-prescription:before {\r\n  content: \"\\f572\";\r\n}\r\n\r\n.fa-file-signature:before {\r\n  content: \"\\f573\";\r\n}\r\n\r\n.fa-file-upload:before {\r\n  content: \"\\f574\";\r\n}\r\n\r\n.fa-file-video:before {\r\n  content: \"\\f1c8\";\r\n}\r\n\r\n.fa-file-word:before {\r\n  content: \"\\f1c2\";\r\n}\r\n\r\n.fa-fill:before {\r\n  content: \"\\f575\";\r\n}\r\n\r\n.fa-fill-drip:before {\r\n  content: \"\\f576\";\r\n}\r\n\r\n.fa-film:before {\r\n  content: \"\\f008\";\r\n}\r\n\r\n.fa-filter:before {\r\n  content: \"\\f0b0\";\r\n}\r\n\r\n.fa-fingerprint:before {\r\n  content: \"\\f577\";\r\n}\r\n\r\n.fa-fire:before {\r\n  content: \"\\f06d\";\r\n}\r\n\r\n.fa-fire-alt:before {\r\n  content: \"\\f7e4\";\r\n}\r\n\r\n.fa-fire-extinguisher:before {\r\n  content: \"\\f134\";\r\n}\r\n\r\n.fa-firefox:before {\r\n  content: \"\\f269\";\r\n}\r\n\r\n.fa-firefox-browser:before {\r\n  content: \"\\f907\";\r\n}\r\n\r\n.fa-first-aid:before {\r\n  content: \"\\f479\";\r\n}\r\n\r\n.fa-first-order:before {\r\n  content: \"\\f2b0\";\r\n}\r\n\r\n.fa-first-order-alt:before {\r\n  content: \"\\f50a\";\r\n}\r\n\r\n.fa-firstdraft:before {\r\n  content: \"\\f3a1\";\r\n}\r\n\r\n.fa-fish:before {\r\n  content: \"\\f578\";\r\n}\r\n\r\n.fa-fist-raised:before {\r\n  content: \"\\f6de\";\r\n}\r\n\r\n.fa-flag:before {\r\n  content: \"\\f024\";\r\n}\r\n\r\n.fa-flag-checkered:before {\r\n  content: \"\\f11e\";\r\n}\r\n\r\n.fa-flag-usa:before {\r\n  content: \"\\f74d\";\r\n}\r\n\r\n.fa-flask:before {\r\n  content: \"\\f0c3\";\r\n}\r\n\r\n.fa-flickr:before {\r\n  content: \"\\f16e\";\r\n}\r\n\r\n.fa-flipboard:before {\r\n  content: \"\\f44d\";\r\n}\r\n\r\n.fa-flushed:before {\r\n  content: \"\\f579\";\r\n}\r\n\r\n.fa-fly:before {\r\n  content: \"\\f417\";\r\n}\r\n\r\n.fa-folder:before {\r\n  content: \"\\f07b\";\r\n}\r\n\r\n.fa-folder-minus:before {\r\n  content: \"\\f65d\";\r\n}\r\n\r\n.fa-folder-open:before {\r\n  content: \"\\f07c\";\r\n}\r\n\r\n.fa-folder-plus:before {\r\n  content: \"\\f65e\";\r\n}\r\n\r\n.fa-font:before {\r\n  content: \"\\f031\";\r\n}\r\n\r\n.fa-font-awesome:before {\r\n  content: \"\\f2b4\";\r\n}\r\n\r\n.fa-font-awesome-alt:before {\r\n  content: \"\\f35c\";\r\n}\r\n\r\n.fa-font-awesome-flag:before {\r\n  content: \"\\f425\";\r\n}\r\n\r\n.fa-font-awesome-logo-full:before {\r\n  content: \"\\f4e6\";\r\n}\r\n\r\n.fa-fonticons:before {\r\n  content: \"\\f280\";\r\n}\r\n\r\n.fa-fonticons-fi:before {\r\n  content: \"\\f3a2\";\r\n}\r\n\r\n.fa-football-ball:before {\r\n  content: \"\\f44e\";\r\n}\r\n\r\n.fa-fort-awesome:before {\r\n  content: \"\\f286\";\r\n}\r\n\r\n.fa-fort-awesome-alt:before {\r\n  content: \"\\f3a3\";\r\n}\r\n\r\n.fa-forumbee:before {\r\n  content: \"\\f211\";\r\n}\r\n\r\n.fa-forward:before {\r\n  content: \"\\f04e\";\r\n}\r\n\r\n.fa-foursquare:before {\r\n  content: \"\\f180\";\r\n}\r\n\r\n.fa-free-code-camp:before {\r\n  content: \"\\f2c5\";\r\n}\r\n\r\n.fa-freebsd:before {\r\n  content: \"\\f3a4\";\r\n}\r\n\r\n.fa-frog:before {\r\n  content: \"\\f52e\";\r\n}\r\n\r\n.fa-frown:before {\r\n  content: \"\\f119\";\r\n}\r\n\r\n.fa-frown-open:before {\r\n  content: \"\\f57a\";\r\n}\r\n\r\n.fa-fulcrum:before {\r\n  content: \"\\f50b\";\r\n}\r\n\r\n.fa-funnel-dollar:before {\r\n  content: \"\\f662\";\r\n}\r\n\r\n.fa-futbol:before {\r\n  content: \"\\f1e3\";\r\n}\r\n\r\n.fa-galactic-republic:before {\r\n  content: \"\\f50c\";\r\n}\r\n\r\n.fa-galactic-senate:before {\r\n  content: \"\\f50d\";\r\n}\r\n\r\n.fa-gamepad:before {\r\n  content: \"\\f11b\";\r\n}\r\n\r\n.fa-gas-pump:before {\r\n  content: \"\\f52f\";\r\n}\r\n\r\n.fa-gavel:before {\r\n  content: \"\\f0e3\";\r\n}\r\n\r\n.fa-gem:before {\r\n  content: \"\\f3a5\";\r\n}\r\n\r\n.fa-genderless:before {\r\n  content: \"\\f22d\";\r\n}\r\n\r\n.fa-get-pocket:before {\r\n  content: \"\\f265\";\r\n}\r\n\r\n.fa-gg:before {\r\n  content: \"\\f260\";\r\n}\r\n\r\n.fa-gg-circle:before {\r\n  content: \"\\f261\";\r\n}\r\n\r\n.fa-ghost:before {\r\n  content: \"\\f6e2\";\r\n}\r\n\r\n.fa-gift:before {\r\n  content: \"\\f06b\";\r\n}\r\n\r\n.fa-gifts:before {\r\n  content: \"\\f79c\";\r\n}\r\n\r\n.fa-git:before {\r\n  content: \"\\f1d3\";\r\n}\r\n\r\n.fa-git-alt:before {\r\n  content: \"\\f841\";\r\n}\r\n\r\n.fa-git-square:before {\r\n  content: \"\\f1d2\";\r\n}\r\n\r\n.fa-github:before {\r\n  content: \"\\f09b\";\r\n}\r\n\r\n.fa-github-alt:before {\r\n  content: \"\\f113\";\r\n}\r\n\r\n.fa-github-square:before {\r\n  content: \"\\f092\";\r\n}\r\n\r\n.fa-gitkraken:before {\r\n  content: \"\\f3a6\";\r\n}\r\n\r\n.fa-gitlab:before {\r\n  content: \"\\f296\";\r\n}\r\n\r\n.fa-gitter:before {\r\n  content: \"\\f426\";\r\n}\r\n\r\n.fa-glass-cheers:before {\r\n  content: \"\\f79f\";\r\n}\r\n\r\n.fa-glass-martini:before {\r\n  content: \"\\f000\";\r\n}\r\n\r\n.fa-glass-martini-alt:before {\r\n  content: \"\\f57b\";\r\n}\r\n\r\n.fa-glass-whiskey:before {\r\n  content: \"\\f7a0\";\r\n}\r\n\r\n.fa-glasses:before {\r\n  content: \"\\f530\";\r\n}\r\n\r\n.fa-glide:before {\r\n  content: \"\\f2a5\";\r\n}\r\n\r\n.fa-glide-g:before {\r\n  content: \"\\f2a6\";\r\n}\r\n\r\n.fa-globe:before {\r\n  content: \"\\f0ac\";\r\n}\r\n\r\n.fa-globe-africa:before {\r\n  content: \"\\f57c\";\r\n}\r\n\r\n.fa-globe-americas:before {\r\n  content: \"\\f57d\";\r\n}\r\n\r\n.fa-globe-asia:before {\r\n  content: \"\\f57e\";\r\n}\r\n\r\n.fa-globe-europe:before {\r\n  content: \"\\f7a2\";\r\n}\r\n\r\n.fa-gofore:before {\r\n  content: \"\\f3a7\";\r\n}\r\n\r\n.fa-golf-ball:before {\r\n  content: \"\\f450\";\r\n}\r\n\r\n.fa-goodreads:before {\r\n  content: \"\\f3a8\";\r\n}\r\n\r\n.fa-goodreads-g:before {\r\n  content: \"\\f3a9\";\r\n}\r\n\r\n.fa-google:before {\r\n  content: \"\\f1a0\";\r\n}\r\n\r\n.fa-google-drive:before {\r\n  content: \"\\f3aa\";\r\n}\r\n\r\n.fa-google-play:before {\r\n  content: \"\\f3ab\";\r\n}\r\n\r\n.fa-google-plus:before {\r\n  content: \"\\f2b3\";\r\n}\r\n\r\n.fa-google-plus-g:before {\r\n  content: \"\\f0d5\";\r\n}\r\n\r\n.fa-google-plus-square:before {\r\n  content: \"\\f0d4\";\r\n}\r\n\r\n.fa-google-wallet:before {\r\n  content: \"\\f1ee\";\r\n}\r\n\r\n.fa-gopuram:before {\r\n  content: \"\\f664\";\r\n}\r\n\r\n.fa-graduation-cap:before {\r\n  content: \"\\f19d\";\r\n}\r\n\r\n.fa-gratipay:before {\r\n  content: \"\\f184\";\r\n}\r\n\r\n.fa-grav:before {\r\n  content: \"\\f2d6\";\r\n}\r\n\r\n.fa-greater-than:before {\r\n  content: \"\\f531\";\r\n}\r\n\r\n.fa-greater-than-equal:before {\r\n  content: \"\\f532\";\r\n}\r\n\r\n.fa-grimace:before {\r\n  content: \"\\f57f\";\r\n}\r\n\r\n.fa-grin:before {\r\n  content: \"\\f580\";\r\n}\r\n\r\n.fa-grin-alt:before {\r\n  content: \"\\f581\";\r\n}\r\n\r\n.fa-grin-beam:before {\r\n  content: \"\\f582\";\r\n}\r\n\r\n.fa-grin-beam-sweat:before {\r\n  content: \"\\f583\";\r\n}\r\n\r\n.fa-grin-hearts:before {\r\n  content: \"\\f584\";\r\n}\r\n\r\n.fa-grin-squint:before {\r\n  content: \"\\f585\";\r\n}\r\n\r\n.fa-grin-squint-tears:before {\r\n  content: \"\\f586\";\r\n}\r\n\r\n.fa-grin-stars:before {\r\n  content: \"\\f587\";\r\n}\r\n\r\n.fa-grin-tears:before {\r\n  content: \"\\f588\";\r\n}\r\n\r\n.fa-grin-tongue:before {\r\n  content: \"\\f589\";\r\n}\r\n\r\n.fa-grin-tongue-squint:before {\r\n  content: \"\\f58a\";\r\n}\r\n\r\n.fa-grin-tongue-wink:before {\r\n  content: \"\\f58b\";\r\n}\r\n\r\n.fa-grin-wink:before {\r\n  content: \"\\f58c\";\r\n}\r\n\r\n.fa-grip-horizontal:before {\r\n  content: \"\\f58d\";\r\n}\r\n\r\n.fa-grip-lines:before {\r\n  content: \"\\f7a4\";\r\n}\r\n\r\n.fa-grip-lines-vertical:before {\r\n  content: \"\\f7a5\";\r\n}\r\n\r\n.fa-grip-vertical:before {\r\n  content: \"\\f58e\";\r\n}\r\n\r\n.fa-gripfire:before {\r\n  content: \"\\f3ac\";\r\n}\r\n\r\n.fa-grunt:before {\r\n  content: \"\\f3ad\";\r\n}\r\n\r\n.fa-guitar:before {\r\n  content: \"\\f7a6\";\r\n}\r\n\r\n.fa-gulp:before {\r\n  content: \"\\f3ae\";\r\n}\r\n\r\n.fa-h-square:before {\r\n  content: \"\\f0fd\";\r\n}\r\n\r\n.fa-hacker-news:before {\r\n  content: \"\\f1d4\";\r\n}\r\n\r\n.fa-hacker-news-square:before {\r\n  content: \"\\f3af\";\r\n}\r\n\r\n.fa-hackerrank:before {\r\n  content: \"\\f5f7\";\r\n}\r\n\r\n.fa-hamburger:before {\r\n  content: \"\\f805\";\r\n}\r\n\r\n.fa-hammer:before {\r\n  content: \"\\f6e3\";\r\n}\r\n\r\n.fa-hamsa:before {\r\n  content: \"\\f665\";\r\n}\r\n\r\n.fa-hand-holding:before {\r\n  content: \"\\f4bd\";\r\n}\r\n\r\n.fa-hand-holding-heart:before {\r\n  content: \"\\f4be\";\r\n}\r\n\r\n.fa-hand-holding-medical:before {\r\n  content: \"\\f95c\";\r\n}\r\n\r\n.fa-hand-holding-usd:before {\r\n  content: \"\\f4c0\";\r\n}\r\n\r\n.fa-hand-holding-water:before {\r\n  content: \"\\f4c1\";\r\n}\r\n\r\n.fa-hand-lizard:before {\r\n  content: \"\\f258\";\r\n}\r\n\r\n.fa-hand-middle-finger:before {\r\n  content: \"\\f806\";\r\n}\r\n\r\n.fa-hand-paper:before {\r\n  content: \"\\f256\";\r\n}\r\n\r\n.fa-hand-peace:before {\r\n  content: \"\\f25b\";\r\n}\r\n\r\n.fa-hand-point-down:before {\r\n  content: \"\\f0a7\";\r\n}\r\n\r\n.fa-hand-point-left:before {\r\n  content: \"\\f0a5\";\r\n}\r\n\r\n.fa-hand-point-right:before {\r\n  content: \"\\f0a4\";\r\n}\r\n\r\n.fa-hand-point-up:before {\r\n  content: \"\\f0a6\";\r\n}\r\n\r\n.fa-hand-pointer:before {\r\n  content: \"\\f25a\";\r\n}\r\n\r\n.fa-hand-rock:before {\r\n  content: \"\\f255\";\r\n}\r\n\r\n.fa-hand-scissors:before {\r\n  content: \"\\f257\";\r\n}\r\n\r\n.fa-hand-sparkles:before {\r\n  content: \"\\f95d\";\r\n}\r\n\r\n.fa-hand-spock:before {\r\n  content: \"\\f259\";\r\n}\r\n\r\n.fa-hands:before {\r\n  content: \"\\f4c2\";\r\n}\r\n\r\n.fa-hands-helping:before {\r\n  content: \"\\f4c4\";\r\n}\r\n\r\n.fa-hands-wash:before {\r\n  content: \"\\f95e\";\r\n}\r\n\r\n.fa-handshake:before {\r\n  content: \"\\f2b5\";\r\n}\r\n\r\n.fa-handshake-alt-slash:before {\r\n  content: \"\\f95f\";\r\n}\r\n\r\n.fa-handshake-slash:before {\r\n  content: \"\\f960\";\r\n}\r\n\r\n.fa-hanukiah:before {\r\n  content: \"\\f6e6\";\r\n}\r\n\r\n.fa-hard-hat:before {\r\n  content: \"\\f807\";\r\n}\r\n\r\n.fa-hashtag:before {\r\n  content: \"\\f292\";\r\n}\r\n\r\n.fa-hat-cowboy:before {\r\n  content: \"\\f8c0\";\r\n}\r\n\r\n.fa-hat-cowboy-side:before {\r\n  content: \"\\f8c1\";\r\n}\r\n\r\n.fa-hat-wizard:before {\r\n  content: \"\\f6e8\";\r\n}\r\n\r\n.fa-hdd:before {\r\n  content: \"\\f0a0\";\r\n}\r\n\r\n.fa-head-side-cough:before {\r\n  content: \"\\f961\";\r\n}\r\n\r\n.fa-head-side-cough-slash:before {\r\n  content: \"\\f962\";\r\n}\r\n\r\n.fa-head-side-mask:before {\r\n  content: \"\\f963\";\r\n}\r\n\r\n.fa-head-side-virus:before {\r\n  content: \"\\f964\";\r\n}\r\n\r\n.fa-heading:before {\r\n  content: \"\\f1dc\";\r\n}\r\n\r\n.fa-headphones:before {\r\n  content: \"\\f025\";\r\n}\r\n\r\n.fa-headphones-alt:before {\r\n  content: \"\\f58f\";\r\n}\r\n\r\n.fa-headset:before {\r\n  content: \"\\f590\";\r\n}\r\n\r\n.fa-heart:before {\r\n  content: \"\\f004\";\r\n}\r\n\r\n.fa-heart-broken:before {\r\n  content: \"\\f7a9\";\r\n}\r\n\r\n.fa-heartbeat:before {\r\n  content: \"\\f21e\";\r\n}\r\n\r\n.fa-helicopter:before {\r\n  content: \"\\f533\";\r\n}\r\n\r\n.fa-highlighter:before {\r\n  content: \"\\f591\";\r\n}\r\n\r\n.fa-hiking:before {\r\n  content: \"\\f6ec\";\r\n}\r\n\r\n.fa-hippo:before {\r\n  content: \"\\f6ed\";\r\n}\r\n\r\n.fa-hips:before {\r\n  content: \"\\f452\";\r\n}\r\n\r\n.fa-hire-a-helper:before {\r\n  content: \"\\f3b0\";\r\n}\r\n\r\n.fa-history:before {\r\n  content: \"\\f1da\";\r\n}\r\n\r\n.fa-hockey-puck:before {\r\n  content: \"\\f453\";\r\n}\r\n\r\n.fa-holly-berry:before {\r\n  content: \"\\f7aa\";\r\n}\r\n\r\n.fa-home:before {\r\n  content: \"\\f015\";\r\n}\r\n\r\n.fa-hooli:before {\r\n  content: \"\\f427\";\r\n}\r\n\r\n.fa-hornbill:before {\r\n  content: \"\\f592\";\r\n}\r\n\r\n.fa-horse:before {\r\n  content: \"\\f6f0\";\r\n}\r\n\r\n.fa-horse-head:before {\r\n  content: \"\\f7ab\";\r\n}\r\n\r\n.fa-hospital:before {\r\n  content: \"\\f0f8\";\r\n}\r\n\r\n.fa-hospital-alt:before {\r\n  content: \"\\f47d\";\r\n}\r\n\r\n.fa-hospital-symbol:before {\r\n  content: \"\\f47e\";\r\n}\r\n\r\n.fa-hospital-user:before {\r\n  content: \"\\f80d\";\r\n}\r\n\r\n.fa-hot-tub:before {\r\n  content: \"\\f593\";\r\n}\r\n\r\n.fa-hotdog:before {\r\n  content: \"\\f80f\";\r\n}\r\n\r\n.fa-hotel:before {\r\n  content: \"\\f594\";\r\n}\r\n\r\n.fa-hotjar:before {\r\n  content: \"\\f3b1\";\r\n}\r\n\r\n.fa-hourglass:before {\r\n  content: \"\\f254\";\r\n}\r\n\r\n.fa-hourglass-end:before {\r\n  content: \"\\f253\";\r\n}\r\n\r\n.fa-hourglass-half:before {\r\n  content: \"\\f252\";\r\n}\r\n\r\n.fa-hourglass-start:before {\r\n  content: \"\\f251\";\r\n}\r\n\r\n.fa-house-damage:before {\r\n  content: \"\\f6f1\";\r\n}\r\n\r\n.fa-house-user:before {\r\n  content: \"\\f965\";\r\n}\r\n\r\n.fa-houzz:before {\r\n  content: \"\\f27c\";\r\n}\r\n\r\n.fa-hryvnia:before {\r\n  content: \"\\f6f2\";\r\n}\r\n\r\n.fa-html5:before {\r\n  content: \"\\f13b\";\r\n}\r\n\r\n.fa-hubspot:before {\r\n  content: \"\\f3b2\";\r\n}\r\n\r\n.fa-i-cursor:before {\r\n  content: \"\\f246\";\r\n}\r\n\r\n.fa-ice-cream:before {\r\n  content: \"\\f810\";\r\n}\r\n\r\n.fa-icicles:before {\r\n  content: \"\\f7ad\";\r\n}\r\n\r\n.fa-icons:before {\r\n  content: \"\\f86d\";\r\n}\r\n\r\n.fa-id-badge:before {\r\n  content: \"\\f2c1\";\r\n}\r\n\r\n.fa-id-card:before {\r\n  content: \"\\f2c2\";\r\n}\r\n\r\n.fa-id-card-alt:before {\r\n  content: \"\\f47f\";\r\n}\r\n\r\n.fa-ideal:before {\r\n  content: \"\\f913\";\r\n}\r\n\r\n.fa-igloo:before {\r\n  content: \"\\f7ae\";\r\n}\r\n\r\n.fa-image:before {\r\n  content: \"\\f03e\";\r\n}\r\n\r\n.fa-images:before {\r\n  content: \"\\f302\";\r\n}\r\n\r\n.fa-imdb:before {\r\n  content: \"\\f2d8\";\r\n}\r\n\r\n.fa-inbox:before {\r\n  content: \"\\f01c\";\r\n}\r\n\r\n.fa-indent:before {\r\n  content: \"\\f03c\";\r\n}\r\n\r\n.fa-industry:before {\r\n  content: \"\\f275\";\r\n}\r\n\r\n.fa-infinity:before {\r\n  content: \"\\f534\";\r\n}\r\n\r\n.fa-info:before {\r\n  content: \"\\f129\";\r\n}\r\n\r\n.fa-info-circle:before {\r\n  content: \"\\f05a\";\r\n}\r\n\r\n.fa-instagram:before {\r\n  content: \"\\f16d\";\r\n}\r\n\r\n.fa-instagram-square:before {\r\n  content: \"\\f955\";\r\n}\r\n\r\n.fa-intercom:before {\r\n  content: \"\\f7af\";\r\n}\r\n\r\n.fa-internet-explorer:before {\r\n  content: \"\\f26b\";\r\n}\r\n\r\n.fa-invision:before {\r\n  content: \"\\f7b0\";\r\n}\r\n\r\n.fa-ioxhost:before {\r\n  content: \"\\f208\";\r\n}\r\n\r\n.fa-italic:before {\r\n  content: \"\\f033\";\r\n}\r\n\r\n.fa-itch-io:before {\r\n  content: \"\\f83a\";\r\n}\r\n\r\n.fa-itunes:before {\r\n  content: \"\\f3b4\";\r\n}\r\n\r\n.fa-itunes-note:before {\r\n  content: \"\\f3b5\";\r\n}\r\n\r\n.fa-java:before {\r\n  content: \"\\f4e4\";\r\n}\r\n\r\n.fa-jedi:before {\r\n  content: \"\\f669\";\r\n}\r\n\r\n.fa-jedi-order:before {\r\n  content: \"\\f50e\";\r\n}\r\n\r\n.fa-jenkins:before {\r\n  content: \"\\f3b6\";\r\n}\r\n\r\n.fa-jira:before {\r\n  content: \"\\f7b1\";\r\n}\r\n\r\n.fa-joget:before {\r\n  content: \"\\f3b7\";\r\n}\r\n\r\n.fa-joint:before {\r\n  content: \"\\f595\";\r\n}\r\n\r\n.fa-joomla:before {\r\n  content: \"\\f1aa\";\r\n}\r\n\r\n.fa-journal-whills:before {\r\n  content: \"\\f66a\";\r\n}\r\n\r\n.fa-js:before {\r\n  content: \"\\f3b8\";\r\n}\r\n\r\n.fa-js-square:before {\r\n  content: \"\\f3b9\";\r\n}\r\n\r\n.fa-jsfiddle:before {\r\n  content: \"\\f1cc\";\r\n}\r\n\r\n.fa-kaaba:before {\r\n  content: \"\\f66b\";\r\n}\r\n\r\n.fa-kaggle:before {\r\n  content: \"\\f5fa\";\r\n}\r\n\r\n.fa-key:before {\r\n  content: \"\\f084\";\r\n}\r\n\r\n.fa-keybase:before {\r\n  content: \"\\f4f5\";\r\n}\r\n\r\n.fa-keyboard:before {\r\n  content: \"\\f11c\";\r\n}\r\n\r\n.fa-keycdn:before {\r\n  content: \"\\f3ba\";\r\n}\r\n\r\n.fa-khanda:before {\r\n  content: \"\\f66d\";\r\n}\r\n\r\n.fa-kickstarter:before {\r\n  content: \"\\f3bb\";\r\n}\r\n\r\n.fa-kickstarter-k:before {\r\n  content: \"\\f3bc\";\r\n}\r\n\r\n.fa-kiss:before {\r\n  content: \"\\f596\";\r\n}\r\n\r\n.fa-kiss-beam:before {\r\n  content: \"\\f597\";\r\n}\r\n\r\n.fa-kiss-wink-heart:before {\r\n  content: \"\\f598\";\r\n}\r\n\r\n.fa-kiwi-bird:before {\r\n  content: \"\\f535\";\r\n}\r\n\r\n.fa-korvue:before {\r\n  content: \"\\f42f\";\r\n}\r\n\r\n.fa-landmark:before {\r\n  content: \"\\f66f\";\r\n}\r\n\r\n.fa-language:before {\r\n  content: \"\\f1ab\";\r\n}\r\n\r\n.fa-laptop:before {\r\n  content: \"\\f109\";\r\n}\r\n\r\n.fa-laptop-code:before {\r\n  content: \"\\f5fc\";\r\n}\r\n\r\n.fa-laptop-house:before {\r\n  content: \"\\f966\";\r\n}\r\n\r\n.fa-laptop-medical:before {\r\n  content: \"\\f812\";\r\n}\r\n\r\n.fa-laravel:before {\r\n  content: \"\\f3bd\";\r\n}\r\n\r\n.fa-lastfm:before {\r\n  content: \"\\f202\";\r\n}\r\n\r\n.fa-lastfm-square:before {\r\n  content: \"\\f203\";\r\n}\r\n\r\n.fa-laugh:before {\r\n  content: \"\\f599\";\r\n}\r\n\r\n.fa-laugh-beam:before {\r\n  content: \"\\f59a\";\r\n}\r\n\r\n.fa-laugh-squint:before {\r\n  content: \"\\f59b\";\r\n}\r\n\r\n.fa-laugh-wink:before {\r\n  content: \"\\f59c\";\r\n}\r\n\r\n.fa-layer-group:before {\r\n  content: \"\\f5fd\";\r\n}\r\n\r\n.fa-leaf:before {\r\n  content: \"\\f06c\";\r\n}\r\n\r\n.fa-leanpub:before {\r\n  content: \"\\f212\";\r\n}\r\n\r\n.fa-lemon:before {\r\n  content: \"\\f094\";\r\n}\r\n\r\n.fa-less:before {\r\n  content: \"\\f41d\";\r\n}\r\n\r\n.fa-less-than:before {\r\n  content: \"\\f536\";\r\n}\r\n\r\n.fa-less-than-equal:before {\r\n  content: \"\\f537\";\r\n}\r\n\r\n.fa-level-down-alt:before {\r\n  content: \"\\f3be\";\r\n}\r\n\r\n.fa-level-up-alt:before {\r\n  content: \"\\f3bf\";\r\n}\r\n\r\n.fa-life-ring:before {\r\n  content: \"\\f1cd\";\r\n}\r\n\r\n.fa-lightbulb:before {\r\n  content: \"\\f0eb\";\r\n}\r\n\r\n.fa-line:before {\r\n  content: \"\\f3c0\";\r\n}\r\n\r\n.fa-link:before {\r\n  content: \"\\f0c1\";\r\n}\r\n\r\n.fa-linkedin:before {\r\n  content: \"\\f08c\";\r\n}\r\n\r\n.fa-linkedin-in:before {\r\n  content: \"\\f0e1\";\r\n}\r\n\r\n.fa-linode:before {\r\n  content: \"\\f2b8\";\r\n}\r\n\r\n.fa-linux:before {\r\n  content: \"\\f17c\";\r\n}\r\n\r\n.fa-lira-sign:before {\r\n  content: \"\\f195\";\r\n}\r\n\r\n.fa-list:before {\r\n  content: \"\\f03a\";\r\n}\r\n\r\n.fa-list-alt:before {\r\n  content: \"\\f022\";\r\n}\r\n\r\n.fa-list-ol:before {\r\n  content: \"\\f0cb\";\r\n}\r\n\r\n.fa-list-ul:before {\r\n  content: \"\\f0ca\";\r\n}\r\n\r\n.fa-location-arrow:before {\r\n  content: \"\\f124\";\r\n}\r\n\r\n.fa-lock:before {\r\n  content: \"\\f023\";\r\n}\r\n\r\n.fa-lock-open:before {\r\n  content: \"\\f3c1\";\r\n}\r\n\r\n.fa-long-arrow-alt-down:before {\r\n  content: \"\\f309\";\r\n}\r\n\r\n.fa-long-arrow-alt-left:before {\r\n  content: \"\\f30a\";\r\n}\r\n\r\n.fa-long-arrow-alt-right:before {\r\n  content: \"\\f30b\";\r\n}\r\n\r\n.fa-long-arrow-alt-up:before {\r\n  content: \"\\f30c\";\r\n}\r\n\r\n.fa-low-vision:before {\r\n  content: \"\\f2a8\";\r\n}\r\n\r\n.fa-luggage-cart:before {\r\n  content: \"\\f59d\";\r\n}\r\n\r\n.fa-lungs:before {\r\n  content: \"\\f604\";\r\n}\r\n\r\n.fa-lungs-virus:before {\r\n  content: \"\\f967\";\r\n}\r\n\r\n.fa-lyft:before {\r\n  content: \"\\f3c3\";\r\n}\r\n\r\n.fa-magento:before {\r\n  content: \"\\f3c4\";\r\n}\r\n\r\n.fa-magic:before {\r\n  content: \"\\f0d0\";\r\n}\r\n\r\n.fa-magnet:before {\r\n  content: \"\\f076\";\r\n}\r\n\r\n.fa-mail-bulk:before {\r\n  content: \"\\f674\";\r\n}\r\n\r\n.fa-mailchimp:before {\r\n  content: \"\\f59e\";\r\n}\r\n\r\n.fa-male:before {\r\n  content: \"\\f183\";\r\n}\r\n\r\n.fa-mandalorian:before {\r\n  content: \"\\f50f\";\r\n}\r\n\r\n.fa-map:before {\r\n  content: \"\\f279\";\r\n}\r\n\r\n.fa-map-marked:before {\r\n  content: \"\\f59f\";\r\n}\r\n\r\n.fa-map-marked-alt:before {\r\n  content: \"\\f5a0\";\r\n}\r\n\r\n.fa-map-marker:before {\r\n  content: \"\\f041\";\r\n}\r\n\r\n.fa-map-marker-alt:before {\r\n  content: \"\\f3c5\";\r\n}\r\n\r\n.fa-map-pin:before {\r\n  content: \"\\f276\";\r\n}\r\n\r\n.fa-map-signs:before {\r\n  content: \"\\f277\";\r\n}\r\n\r\n.fa-markdown:before {\r\n  content: \"\\f60f\";\r\n}\r\n\r\n.fa-marker:before {\r\n  content: \"\\f5a1\";\r\n}\r\n\r\n.fa-mars:before {\r\n  content: \"\\f222\";\r\n}\r\n\r\n.fa-mars-double:before {\r\n  content: \"\\f227\";\r\n}\r\n\r\n.fa-mars-stroke:before {\r\n  content: \"\\f229\";\r\n}\r\n\r\n.fa-mars-stroke-h:before {\r\n  content: \"\\f22b\";\r\n}\r\n\r\n.fa-mars-stroke-v:before {\r\n  content: \"\\f22a\";\r\n}\r\n\r\n.fa-mask:before {\r\n  content: \"\\f6fa\";\r\n}\r\n\r\n.fa-mastodon:before {\r\n  content: \"\\f4f6\";\r\n}\r\n\r\n.fa-maxcdn:before {\r\n  content: \"\\f136\";\r\n}\r\n\r\n.fa-mdb:before {\r\n  content: \"\\f8ca\";\r\n}\r\n\r\n.fa-medal:before {\r\n  content: \"\\f5a2\";\r\n}\r\n\r\n.fa-medapps:before {\r\n  content: \"\\f3c6\";\r\n}\r\n\r\n.fa-medium:before {\r\n  content: \"\\f23a\";\r\n}\r\n\r\n.fa-medium-m:before {\r\n  content: \"\\f3c7\";\r\n}\r\n\r\n.fa-medkit:before {\r\n  content: \"\\f0fa\";\r\n}\r\n\r\n.fa-medrt:before {\r\n  content: \"\\f3c8\";\r\n}\r\n\r\n.fa-meetup:before {\r\n  content: \"\\f2e0\";\r\n}\r\n\r\n.fa-megaport:before {\r\n  content: \"\\f5a3\";\r\n}\r\n\r\n.fa-meh:before {\r\n  content: \"\\f11a\";\r\n}\r\n\r\n.fa-meh-blank:before {\r\n  content: \"\\f5a4\";\r\n}\r\n\r\n.fa-meh-rolling-eyes:before {\r\n  content: \"\\f5a5\";\r\n}\r\n\r\n.fa-memory:before {\r\n  content: \"\\f538\";\r\n}\r\n\r\n.fa-mendeley:before {\r\n  content: \"\\f7b3\";\r\n}\r\n\r\n.fa-menorah:before {\r\n  content: \"\\f676\";\r\n}\r\n\r\n.fa-mercury:before {\r\n  content: \"\\f223\";\r\n}\r\n\r\n.fa-meteor:before {\r\n  content: \"\\f753\";\r\n}\r\n\r\n.fa-microblog:before {\r\n  content: \"\\f91a\";\r\n}\r\n\r\n.fa-microchip:before {\r\n  content: \"\\f2db\";\r\n}\r\n\r\n.fa-microphone:before {\r\n  content: \"\\f130\";\r\n}\r\n\r\n.fa-microphone-alt:before {\r\n  content: \"\\f3c9\";\r\n}\r\n\r\n.fa-microphone-alt-slash:before {\r\n  content: \"\\f539\";\r\n}\r\n\r\n.fa-microphone-slash:before {\r\n  content: \"\\f131\";\r\n}\r\n\r\n.fa-microscope:before {\r\n  content: \"\\f610\";\r\n}\r\n\r\n.fa-microsoft:before {\r\n  content: \"\\f3ca\";\r\n}\r\n\r\n.fa-minus:before {\r\n  content: \"\\f068\";\r\n}\r\n\r\n.fa-minus-circle:before {\r\n  content: \"\\f056\";\r\n}\r\n\r\n.fa-minus-square:before {\r\n  content: \"\\f146\";\r\n}\r\n\r\n.fa-mitten:before {\r\n  content: \"\\f7b5\";\r\n}\r\n\r\n.fa-mix:before {\r\n  content: \"\\f3cb\";\r\n}\r\n\r\n.fa-mixcloud:before {\r\n  content: \"\\f289\";\r\n}\r\n\r\n.fa-mixer:before {\r\n  content: \"\\f956\";\r\n}\r\n\r\n.fa-mizuni:before {\r\n  content: \"\\f3cc\";\r\n}\r\n\r\n.fa-mobile:before {\r\n  content: \"\\f10b\";\r\n}\r\n\r\n.fa-mobile-alt:before {\r\n  content: \"\\f3cd\";\r\n}\r\n\r\n.fa-modx:before {\r\n  content: \"\\f285\";\r\n}\r\n\r\n.fa-monero:before {\r\n  content: \"\\f3d0\";\r\n}\r\n\r\n.fa-money-bill:before {\r\n  content: \"\\f0d6\";\r\n}\r\n\r\n.fa-money-bill-alt:before {\r\n  content: \"\\f3d1\";\r\n}\r\n\r\n.fa-money-bill-wave:before {\r\n  content: \"\\f53a\";\r\n}\r\n\r\n.fa-money-bill-wave-alt:before {\r\n  content: \"\\f53b\";\r\n}\r\n\r\n.fa-money-check:before {\r\n  content: \"\\f53c\";\r\n}\r\n\r\n.fa-money-check-alt:before {\r\n  content: \"\\f53d\";\r\n}\r\n\r\n.fa-monument:before {\r\n  content: \"\\f5a6\";\r\n}\r\n\r\n.fa-moon:before {\r\n  content: \"\\f186\";\r\n}\r\n\r\n.fa-mortar-pestle:before {\r\n  content: \"\\f5a7\";\r\n}\r\n\r\n.fa-mosque:before {\r\n  content: \"\\f678\";\r\n}\r\n\r\n.fa-motorcycle:before {\r\n  content: \"\\f21c\";\r\n}\r\n\r\n.fa-mountain:before {\r\n  content: \"\\f6fc\";\r\n}\r\n\r\n.fa-mouse:before {\r\n  content: \"\\f8cc\";\r\n}\r\n\r\n.fa-mouse-pointer:before {\r\n  content: \"\\f245\";\r\n}\r\n\r\n.fa-mug-hot:before {\r\n  content: \"\\f7b6\";\r\n}\r\n\r\n.fa-music:before {\r\n  content: \"\\f001\";\r\n}\r\n\r\n.fa-napster:before {\r\n  content: \"\\f3d2\";\r\n}\r\n\r\n.fa-neos:before {\r\n  content: \"\\f612\";\r\n}\r\n\r\n.fa-network-wired:before {\r\n  content: \"\\f6ff\";\r\n}\r\n\r\n.fa-neuter:before {\r\n  content: \"\\f22c\";\r\n}\r\n\r\n.fa-newspaper:before {\r\n  content: \"\\f1ea\";\r\n}\r\n\r\n.fa-nimblr:before {\r\n  content: \"\\f5a8\";\r\n}\r\n\r\n.fa-node:before {\r\n  content: \"\\f419\";\r\n}\r\n\r\n.fa-node-js:before {\r\n  content: \"\\f3d3\";\r\n}\r\n\r\n.fa-not-equal:before {\r\n  content: \"\\f53e\";\r\n}\r\n\r\n.fa-notes-medical:before {\r\n  content: \"\\f481\";\r\n}\r\n\r\n.fa-npm:before {\r\n  content: \"\\f3d4\";\r\n}\r\n\r\n.fa-ns8:before {\r\n  content: \"\\f3d5\";\r\n}\r\n\r\n.fa-nutritionix:before {\r\n  content: \"\\f3d6\";\r\n}\r\n\r\n.fa-object-group:before {\r\n  content: \"\\f247\";\r\n}\r\n\r\n.fa-object-ungroup:before {\r\n  content: \"\\f248\";\r\n}\r\n\r\n.fa-odnoklassniki:before {\r\n  content: \"\\f263\";\r\n}\r\n\r\n.fa-odnoklassniki-square:before {\r\n  content: \"\\f264\";\r\n}\r\n\r\n.fa-oil-can:before {\r\n  content: \"\\f613\";\r\n}\r\n\r\n.fa-old-republic:before {\r\n  content: \"\\f510\";\r\n}\r\n\r\n.fa-om:before {\r\n  content: \"\\f679\";\r\n}\r\n\r\n.fa-opencart:before {\r\n  content: \"\\f23d\";\r\n}\r\n\r\n.fa-openid:before {\r\n  content: \"\\f19b\";\r\n}\r\n\r\n.fa-opera:before {\r\n  content: \"\\f26a\";\r\n}\r\n\r\n.fa-optin-monster:before {\r\n  content: \"\\f23c\";\r\n}\r\n\r\n.fa-orcid:before {\r\n  content: \"\\f8d2\";\r\n}\r\n\r\n.fa-osi:before {\r\n  content: \"\\f41a\";\r\n}\r\n\r\n.fa-otter:before {\r\n  content: \"\\f700\";\r\n}\r\n\r\n.fa-outdent:before {\r\n  content: \"\\f03b\";\r\n}\r\n\r\n.fa-page4:before {\r\n  content: \"\\f3d7\";\r\n}\r\n\r\n.fa-pagelines:before {\r\n  content: \"\\f18c\";\r\n}\r\n\r\n.fa-pager:before {\r\n  content: \"\\f815\";\r\n}\r\n\r\n.fa-paint-brush:before {\r\n  content: \"\\f1fc\";\r\n}\r\n\r\n.fa-paint-roller:before {\r\n  content: \"\\f5aa\";\r\n}\r\n\r\n.fa-palette:before {\r\n  content: \"\\f53f\";\r\n}\r\n\r\n.fa-palfed:before {\r\n  content: \"\\f3d8\";\r\n}\r\n\r\n.fa-pallet:before {\r\n  content: \"\\f482\";\r\n}\r\n\r\n.fa-paper-plane:before {\r\n  content: \"\\f1d8\";\r\n}\r\n\r\n.fa-paperclip:before {\r\n  content: \"\\f0c6\";\r\n}\r\n\r\n.fa-parachute-box:before {\r\n  content: \"\\f4cd\";\r\n}\r\n\r\n.fa-paragraph:before {\r\n  content: \"\\f1dd\";\r\n}\r\n\r\n.fa-parking:before {\r\n  content: \"\\f540\";\r\n}\r\n\r\n.fa-passport:before {\r\n  content: \"\\f5ab\";\r\n}\r\n\r\n.fa-pastafarianism:before {\r\n  content: \"\\f67b\";\r\n}\r\n\r\n.fa-paste:before {\r\n  content: \"\\f0ea\";\r\n}\r\n\r\n.fa-patreon:before {\r\n  content: \"\\f3d9\";\r\n}\r\n\r\n.fa-pause:before {\r\n  content: \"\\f04c\";\r\n}\r\n\r\n.fa-pause-circle:before {\r\n  content: \"\\f28b\";\r\n}\r\n\r\n.fa-paw:before {\r\n  content: \"\\f1b0\";\r\n}\r\n\r\n.fa-paypal:before {\r\n  content: \"\\f1ed\";\r\n}\r\n\r\n.fa-peace:before {\r\n  content: \"\\f67c\";\r\n}\r\n\r\n.fa-pen:before {\r\n  content: \"\\f304\";\r\n}\r\n\r\n.fa-pen-alt:before {\r\n  content: \"\\f305\";\r\n}\r\n\r\n.fa-pen-fancy:before {\r\n  content: \"\\f5ac\";\r\n}\r\n\r\n.fa-pen-nib:before {\r\n  content: \"\\f5ad\";\r\n}\r\n\r\n.fa-pen-square:before {\r\n  content: \"\\f14b\";\r\n}\r\n\r\n.fa-pencil-alt:before {\r\n  content: \"\\f303\";\r\n}\r\n\r\n.fa-pencil-ruler:before {\r\n  content: \"\\f5ae\";\r\n}\r\n\r\n.fa-penny-arcade:before {\r\n  content: \"\\f704\";\r\n}\r\n\r\n.fa-people-arrows:before {\r\n  content: \"\\f968\";\r\n}\r\n\r\n.fa-people-carry:before {\r\n  content: \"\\f4ce\";\r\n}\r\n\r\n.fa-pepper-hot:before {\r\n  content: \"\\f816\";\r\n}\r\n\r\n.fa-percent:before {\r\n  content: \"\\f295\";\r\n}\r\n\r\n.fa-percentage:before {\r\n  content: \"\\f541\";\r\n}\r\n\r\n.fa-periscope:before {\r\n  content: \"\\f3da\";\r\n}\r\n\r\n.fa-person-booth:before {\r\n  content: \"\\f756\";\r\n}\r\n\r\n.fa-phabricator:before {\r\n  content: \"\\f3db\";\r\n}\r\n\r\n.fa-phoenix-framework:before {\r\n  content: \"\\f3dc\";\r\n}\r\n\r\n.fa-phoenix-squadron:before {\r\n  content: \"\\f511\";\r\n}\r\n\r\n.fa-phone:before {\r\n  content: \"\\f095\";\r\n}\r\n\r\n.fa-phone-alt:before {\r\n  content: \"\\f879\";\r\n}\r\n\r\n.fa-phone-slash:before {\r\n  content: \"\\f3dd\";\r\n}\r\n\r\n.fa-phone-square:before {\r\n  content: \"\\f098\";\r\n}\r\n\r\n.fa-phone-square-alt:before {\r\n  content: \"\\f87b\";\r\n}\r\n\r\n.fa-phone-volume:before {\r\n  content: \"\\f2a0\";\r\n}\r\n\r\n.fa-photo-video:before {\r\n  content: \"\\f87c\";\r\n}\r\n\r\n.fa-php:before {\r\n  content: \"\\f457\";\r\n}\r\n\r\n.fa-pied-piper:before {\r\n  content: \"\\f2ae\";\r\n}\r\n\r\n.fa-pied-piper-alt:before {\r\n  content: \"\\f1a8\";\r\n}\r\n\r\n.fa-pied-piper-hat:before {\r\n  content: \"\\f4e5\";\r\n}\r\n\r\n.fa-pied-piper-pp:before {\r\n  content: \"\\f1a7\";\r\n}\r\n\r\n.fa-pied-piper-square:before {\r\n  content: \"\\f91e\";\r\n}\r\n\r\n.fa-piggy-bank:before {\r\n  content: \"\\f4d3\";\r\n}\r\n\r\n.fa-pills:before {\r\n  content: \"\\f484\";\r\n}\r\n\r\n.fa-pinterest:before {\r\n  content: \"\\f0d2\";\r\n}\r\n\r\n.fa-pinterest-p:before {\r\n  content: \"\\f231\";\r\n}\r\n\r\n.fa-pinterest-square:before {\r\n  content: \"\\f0d3\";\r\n}\r\n\r\n.fa-pizza-slice:before {\r\n  content: \"\\f818\";\r\n}\r\n\r\n.fa-place-of-worship:before {\r\n  content: \"\\f67f\";\r\n}\r\n\r\n.fa-plane:before {\r\n  content: \"\\f072\";\r\n}\r\n\r\n.fa-plane-arrival:before {\r\n  content: \"\\f5af\";\r\n}\r\n\r\n.fa-plane-departure:before {\r\n  content: \"\\f5b0\";\r\n}\r\n\r\n.fa-plane-slash:before {\r\n  content: \"\\f969\";\r\n}\r\n\r\n.fa-play:before {\r\n  content: \"\\f04b\";\r\n}\r\n\r\n.fa-play-circle:before {\r\n  content: \"\\f144\";\r\n}\r\n\r\n.fa-playstation:before {\r\n  content: \"\\f3df\";\r\n}\r\n\r\n.fa-plug:before {\r\n  content: \"\\f1e6\";\r\n}\r\n\r\n.fa-plus:before {\r\n  content: \"\\f067\";\r\n}\r\n\r\n.fa-plus-circle:before {\r\n  content: \"\\f055\";\r\n}\r\n\r\n.fa-plus-square:before {\r\n  content: \"\\f0fe\";\r\n}\r\n\r\n.fa-podcast:before {\r\n  content: \"\\f2ce\";\r\n}\r\n\r\n.fa-poll:before {\r\n  content: \"\\f681\";\r\n}\r\n\r\n.fa-poll-h:before {\r\n  content: \"\\f682\";\r\n}\r\n\r\n.fa-poo:before {\r\n  content: \"\\f2fe\";\r\n}\r\n\r\n.fa-poo-storm:before {\r\n  content: \"\\f75a\";\r\n}\r\n\r\n.fa-poop:before {\r\n  content: \"\\f619\";\r\n}\r\n\r\n.fa-portrait:before {\r\n  content: \"\\f3e0\";\r\n}\r\n\r\n.fa-pound-sign:before {\r\n  content: \"\\f154\";\r\n}\r\n\r\n.fa-power-off:before {\r\n  content: \"\\f011\";\r\n}\r\n\r\n.fa-pray:before {\r\n  content: \"\\f683\";\r\n}\r\n\r\n.fa-praying-hands:before {\r\n  content: \"\\f684\";\r\n}\r\n\r\n.fa-prescription:before {\r\n  content: \"\\f5b1\";\r\n}\r\n\r\n.fa-prescription-bottle:before {\r\n  content: \"\\f485\";\r\n}\r\n\r\n.fa-prescription-bottle-alt:before {\r\n  content: \"\\f486\";\r\n}\r\n\r\n.fa-print:before {\r\n  content: \"\\f02f\";\r\n}\r\n\r\n.fa-procedures:before {\r\n  content: \"\\f487\";\r\n}\r\n\r\n.fa-product-hunt:before {\r\n  content: \"\\f288\";\r\n}\r\n\r\n.fa-project-diagram:before {\r\n  content: \"\\f542\";\r\n}\r\n\r\n.fa-pump-medical:before {\r\n  content: \"\\f96a\";\r\n}\r\n\r\n.fa-pump-soap:before {\r\n  content: \"\\f96b\";\r\n}\r\n\r\n.fa-pushed:before {\r\n  content: \"\\f3e1\";\r\n}\r\n\r\n.fa-puzzle-piece:before {\r\n  content: \"\\f12e\";\r\n}\r\n\r\n.fa-python:before {\r\n  content: \"\\f3e2\";\r\n}\r\n\r\n.fa-qq:before {\r\n  content: \"\\f1d6\";\r\n}\r\n\r\n.fa-qrcode:before {\r\n  content: \"\\f029\";\r\n}\r\n\r\n.fa-question:before {\r\n  content: \"\\f128\";\r\n}\r\n\r\n.fa-question-circle:before {\r\n  content: \"\\f059\";\r\n}\r\n\r\n.fa-quidditch:before {\r\n  content: \"\\f458\";\r\n}\r\n\r\n.fa-quinscape:before {\r\n  content: \"\\f459\";\r\n}\r\n\r\n.fa-quora:before {\r\n  content: \"\\f2c4\";\r\n}\r\n\r\n.fa-quote-left:before {\r\n  content: \"\\f10d\";\r\n}\r\n\r\n.fa-quote-right:before {\r\n  content: \"\\f10e\";\r\n}\r\n\r\n.fa-quran:before {\r\n  content: \"\\f687\";\r\n}\r\n\r\n.fa-r-project:before {\r\n  content: \"\\f4f7\";\r\n}\r\n\r\n.fa-radiation:before {\r\n  content: \"\\f7b9\";\r\n}\r\n\r\n.fa-radiation-alt:before {\r\n  content: \"\\f7ba\";\r\n}\r\n\r\n.fa-rainbow:before {\r\n  content: \"\\f75b\";\r\n}\r\n\r\n.fa-random:before {\r\n  content: \"\\f074\";\r\n}\r\n\r\n.fa-raspberry-pi:before {\r\n  content: \"\\f7bb\";\r\n}\r\n\r\n.fa-ravelry:before {\r\n  content: \"\\f2d9\";\r\n}\r\n\r\n.fa-react:before {\r\n  content: \"\\f41b\";\r\n}\r\n\r\n.fa-reacteurope:before {\r\n  content: \"\\f75d\";\r\n}\r\n\r\n.fa-readme:before {\r\n  content: \"\\f4d5\";\r\n}\r\n\r\n.fa-rebel:before {\r\n  content: \"\\f1d0\";\r\n}\r\n\r\n.fa-receipt:before {\r\n  content: \"\\f543\";\r\n}\r\n\r\n.fa-record-vinyl:before {\r\n  content: \"\\f8d9\";\r\n}\r\n\r\n.fa-recycle:before {\r\n  content: \"\\f1b8\";\r\n}\r\n\r\n.fa-red-river:before {\r\n  content: \"\\f3e3\";\r\n}\r\n\r\n.fa-reddit:before {\r\n  content: \"\\f1a1\";\r\n}\r\n\r\n.fa-reddit-alien:before {\r\n  content: \"\\f281\";\r\n}\r\n\r\n.fa-reddit-square:before {\r\n  content: \"\\f1a2\";\r\n}\r\n\r\n.fa-redhat:before {\r\n  content: \"\\f7bc\";\r\n}\r\n\r\n.fa-redo:before {\r\n  content: \"\\f01e\";\r\n}\r\n\r\n.fa-redo-alt:before {\r\n  content: \"\\f2f9\";\r\n}\r\n\r\n.fa-registered:before {\r\n  content: \"\\f25d\";\r\n}\r\n\r\n.fa-remove-format:before {\r\n  content: \"\\f87d\";\r\n}\r\n\r\n.fa-renren:before {\r\n  content: \"\\f18b\";\r\n}\r\n\r\n.fa-reply:before {\r\n  content: \"\\f3e5\";\r\n}\r\n\r\n.fa-reply-all:before {\r\n  content: \"\\f122\";\r\n}\r\n\r\n.fa-replyd:before {\r\n  content: \"\\f3e6\";\r\n}\r\n\r\n.fa-republican:before {\r\n  content: \"\\f75e\";\r\n}\r\n\r\n.fa-researchgate:before {\r\n  content: \"\\f4f8\";\r\n}\r\n\r\n.fa-resolving:before {\r\n  content: \"\\f3e7\";\r\n}\r\n\r\n.fa-restroom:before {\r\n  content: \"\\f7bd\";\r\n}\r\n\r\n.fa-retweet:before {\r\n  content: \"\\f079\";\r\n}\r\n\r\n.fa-rev:before {\r\n  content: \"\\f5b2\";\r\n}\r\n\r\n.fa-ribbon:before {\r\n  content: \"\\f4d6\";\r\n}\r\n\r\n.fa-ring:before {\r\n  content: \"\\f70b\";\r\n}\r\n\r\n.fa-road:before {\r\n  content: \"\\f018\";\r\n}\r\n\r\n.fa-robot:before {\r\n  content: \"\\f544\";\r\n}\r\n\r\n.fa-rocket:before {\r\n  content: \"\\f135\";\r\n}\r\n\r\n.fa-rocketchat:before {\r\n  content: \"\\f3e8\";\r\n}\r\n\r\n.fa-rockrms:before {\r\n  content: \"\\f3e9\";\r\n}\r\n\r\n.fa-route:before {\r\n  content: \"\\f4d7\";\r\n}\r\n\r\n.fa-rss:before {\r\n  content: \"\\f09e\";\r\n}\r\n\r\n.fa-rss-square:before {\r\n  content: \"\\f143\";\r\n}\r\n\r\n.fa-ruble-sign:before {\r\n  content: \"\\f158\";\r\n}\r\n\r\n.fa-ruler:before {\r\n  content: \"\\f545\";\r\n}\r\n\r\n.fa-ruler-combined:before {\r\n  content: \"\\f546\";\r\n}\r\n\r\n.fa-ruler-horizontal:before {\r\n  content: \"\\f547\";\r\n}\r\n\r\n.fa-ruler-vertical:before {\r\n  content: \"\\f548\";\r\n}\r\n\r\n.fa-running:before {\r\n  content: \"\\f70c\";\r\n}\r\n\r\n.fa-rupee-sign:before {\r\n  content: \"\\f156\";\r\n}\r\n\r\n.fa-sad-cry:before {\r\n  content: \"\\f5b3\";\r\n}\r\n\r\n.fa-sad-tear:before {\r\n  content: \"\\f5b4\";\r\n}\r\n\r\n.fa-safari:before {\r\n  content: \"\\f267\";\r\n}\r\n\r\n.fa-salesforce:before {\r\n  content: \"\\f83b\";\r\n}\r\n\r\n.fa-sass:before {\r\n  content: \"\\f41e\";\r\n}\r\n\r\n.fa-satellite:before {\r\n  content: \"\\f7bf\";\r\n}\r\n\r\n.fa-satellite-dish:before {\r\n  content: \"\\f7c0\";\r\n}\r\n\r\n.fa-save:before {\r\n  content: \"\\f0c7\";\r\n}\r\n\r\n.fa-schlix:before {\r\n  content: \"\\f3ea\";\r\n}\r\n\r\n.fa-school:before {\r\n  content: \"\\f549\";\r\n}\r\n\r\n.fa-screwdriver:before {\r\n  content: \"\\f54a\";\r\n}\r\n\r\n.fa-scribd:before {\r\n  content: \"\\f28a\";\r\n}\r\n\r\n.fa-scroll:before {\r\n  content: \"\\f70e\";\r\n}\r\n\r\n.fa-sd-card:before {\r\n  content: \"\\f7c2\";\r\n}\r\n\r\n.fa-search:before {\r\n  content: \"\\f002\";\r\n}\r\n\r\n.fa-search-dollar:before {\r\n  content: \"\\f688\";\r\n}\r\n\r\n.fa-search-location:before {\r\n  content: \"\\f689\";\r\n}\r\n\r\n.fa-search-minus:before {\r\n  content: \"\\f010\";\r\n}\r\n\r\n.fa-search-plus:before {\r\n  content: \"\\f00e\";\r\n}\r\n\r\n.fa-searchengin:before {\r\n  content: \"\\f3eb\";\r\n}\r\n\r\n.fa-seedling:before {\r\n  content: \"\\f4d8\";\r\n}\r\n\r\n.fa-sellcast:before {\r\n  content: \"\\f2da\";\r\n}\r\n\r\n.fa-sellsy:before {\r\n  content: \"\\f213\";\r\n}\r\n\r\n.fa-server:before {\r\n  content: \"\\f233\";\r\n}\r\n\r\n.fa-servicestack:before {\r\n  content: \"\\f3ec\";\r\n}\r\n\r\n.fa-shapes:before {\r\n  content: \"\\f61f\";\r\n}\r\n\r\n.fa-share:before {\r\n  content: \"\\f064\";\r\n}\r\n\r\n.fa-share-alt:before {\r\n  content: \"\\f1e0\";\r\n}\r\n\r\n.fa-share-alt-square:before {\r\n  content: \"\\f1e1\";\r\n}\r\n\r\n.fa-share-square:before {\r\n  content: \"\\f14d\";\r\n}\r\n\r\n.fa-shekel-sign:before {\r\n  content: \"\\f20b\";\r\n}\r\n\r\n.fa-shield-alt:before {\r\n  content: \"\\f3ed\";\r\n}\r\n\r\n.fa-shield-virus:before {\r\n  content: \"\\f96c\";\r\n}\r\n\r\n.fa-ship:before {\r\n  content: \"\\f21a\";\r\n}\r\n\r\n.fa-shipping-fast:before {\r\n  content: \"\\f48b\";\r\n}\r\n\r\n.fa-shirtsinbulk:before {\r\n  content: \"\\f214\";\r\n}\r\n\r\n.fa-shoe-prints:before {\r\n  content: \"\\f54b\";\r\n}\r\n\r\n.fa-shopify:before {\r\n  content: \"\\f957\";\r\n}\r\n\r\n.fa-shopping-bag:before {\r\n  content: \"\\f290\";\r\n}\r\n\r\n.fa-shopping-basket:before {\r\n  content: \"\\f291\";\r\n}\r\n\r\n.fa-shopping-cart:before {\r\n  content: \"\\f07a\";\r\n}\r\n\r\n.fa-shopware:before {\r\n  content: \"\\f5b5\";\r\n}\r\n\r\n.fa-shower:before {\r\n  content: \"\\f2cc\";\r\n}\r\n\r\n.fa-shuttle-van:before {\r\n  content: \"\\f5b6\";\r\n}\r\n\r\n.fa-sign:before {\r\n  content: \"\\f4d9\";\r\n}\r\n\r\n.fa-sign-in-alt:before {\r\n  content: \"\\f2f6\";\r\n}\r\n\r\n.fa-sign-language:before {\r\n  content: \"\\f2a7\";\r\n}\r\n\r\n.fa-sign-out-alt:before {\r\n  content: \"\\f2f5\";\r\n}\r\n\r\n.fa-signal:before {\r\n  content: \"\\f012\";\r\n}\r\n\r\n.fa-signature:before {\r\n  content: \"\\f5b7\";\r\n}\r\n\r\n.fa-sim-card:before {\r\n  content: \"\\f7c4\";\r\n}\r\n\r\n.fa-simplybuilt:before {\r\n  content: \"\\f215\";\r\n}\r\n\r\n.fa-sistrix:before {\r\n  content: \"\\f3ee\";\r\n}\r\n\r\n.fa-sitemap:before {\r\n  content: \"\\f0e8\";\r\n}\r\n\r\n.fa-sith:before {\r\n  content: \"\\f512\";\r\n}\r\n\r\n.fa-skating:before {\r\n  content: \"\\f7c5\";\r\n}\r\n\r\n.fa-sketch:before {\r\n  content: \"\\f7c6\";\r\n}\r\n\r\n.fa-skiing:before {\r\n  content: \"\\f7c9\";\r\n}\r\n\r\n.fa-skiing-nordic:before {\r\n  content: \"\\f7ca\";\r\n}\r\n\r\n.fa-skull:before {\r\n  content: \"\\f54c\";\r\n}\r\n\r\n.fa-skull-crossbones:before {\r\n  content: \"\\f714\";\r\n}\r\n\r\n.fa-skyatlas:before {\r\n  content: \"\\f216\";\r\n}\r\n\r\n.fa-skype:before {\r\n  content: \"\\f17e\";\r\n}\r\n\r\n.fa-slack:before {\r\n  content: \"\\f198\";\r\n}\r\n\r\n.fa-slack-hash:before {\r\n  content: \"\\f3ef\";\r\n}\r\n\r\n.fa-slash:before {\r\n  content: \"\\f715\";\r\n}\r\n\r\n.fa-sleigh:before {\r\n  content: \"\\f7cc\";\r\n}\r\n\r\n.fa-sliders-h:before {\r\n  content: \"\\f1de\";\r\n}\r\n\r\n.fa-slideshare:before {\r\n  content: \"\\f1e7\";\r\n}\r\n\r\n.fa-smile:before {\r\n  content: \"\\f118\";\r\n}\r\n\r\n.fa-smile-beam:before {\r\n  content: \"\\f5b8\";\r\n}\r\n\r\n.fa-smile-wink:before {\r\n  content: \"\\f4da\";\r\n}\r\n\r\n.fa-smog:before {\r\n  content: \"\\f75f\";\r\n}\r\n\r\n.fa-smoking:before {\r\n  content: \"\\f48d\";\r\n}\r\n\r\n.fa-smoking-ban:before {\r\n  content: \"\\f54d\";\r\n}\r\n\r\n.fa-sms:before {\r\n  content: \"\\f7cd\";\r\n}\r\n\r\n.fa-snapchat:before {\r\n  content: \"\\f2ab\";\r\n}\r\n\r\n.fa-snapchat-ghost:before {\r\n  content: \"\\f2ac\";\r\n}\r\n\r\n.fa-snapchat-square:before {\r\n  content: \"\\f2ad\";\r\n}\r\n\r\n.fa-snowboarding:before {\r\n  content: \"\\f7ce\";\r\n}\r\n\r\n.fa-snowflake:before {\r\n  content: \"\\f2dc\";\r\n}\r\n\r\n.fa-snowman:before {\r\n  content: \"\\f7d0\";\r\n}\r\n\r\n.fa-snowplow:before {\r\n  content: \"\\f7d2\";\r\n}\r\n\r\n.fa-soap:before {\r\n  content: \"\\f96e\";\r\n}\r\n\r\n.fa-socks:before {\r\n  content: \"\\f696\";\r\n}\r\n\r\n.fa-solar-panel:before {\r\n  content: \"\\f5ba\";\r\n}\r\n\r\n.fa-sort:before {\r\n  content: \"\\f0dc\";\r\n}\r\n\r\n.fa-sort-alpha-down:before {\r\n  content: \"\\f15d\";\r\n}\r\n\r\n.fa-sort-alpha-down-alt:before {\r\n  content: \"\\f881\";\r\n}\r\n\r\n.fa-sort-alpha-up:before {\r\n  content: \"\\f15e\";\r\n}\r\n\r\n.fa-sort-alpha-up-alt:before {\r\n  content: \"\\f882\";\r\n}\r\n\r\n.fa-sort-amount-down:before {\r\n  content: \"\\f160\";\r\n}\r\n\r\n.fa-sort-amount-down-alt:before {\r\n  content: \"\\f884\";\r\n}\r\n\r\n.fa-sort-amount-up:before {\r\n  content: \"\\f161\";\r\n}\r\n\r\n.fa-sort-amount-up-alt:before {\r\n  content: \"\\f885\";\r\n}\r\n\r\n.fa-sort-down:before {\r\n  content: \"\\f0dd\";\r\n}\r\n\r\n.fa-sort-numeric-down:before {\r\n  content: \"\\f162\";\r\n}\r\n\r\n.fa-sort-numeric-down-alt:before {\r\n  content: \"\\f886\";\r\n}\r\n\r\n.fa-sort-numeric-up:before {\r\n  content: \"\\f163\";\r\n}\r\n\r\n.fa-sort-numeric-up-alt:before {\r\n  content: \"\\f887\";\r\n}\r\n\r\n.fa-sort-up:before {\r\n  content: \"\\f0de\";\r\n}\r\n\r\n.fa-soundcloud:before {\r\n  content: \"\\f1be\";\r\n}\r\n\r\n.fa-sourcetree:before {\r\n  content: \"\\f7d3\";\r\n}\r\n\r\n.fa-spa:before {\r\n  content: \"\\f5bb\";\r\n}\r\n\r\n.fa-space-shuttle:before {\r\n  content: \"\\f197\";\r\n}\r\n\r\n.fa-speakap:before {\r\n  content: \"\\f3f3\";\r\n}\r\n\r\n.fa-speaker-deck:before {\r\n  content: \"\\f83c\";\r\n}\r\n\r\n.fa-spell-check:before {\r\n  content: \"\\f891\";\r\n}\r\n\r\n.fa-spider:before {\r\n  content: \"\\f717\";\r\n}\r\n\r\n.fa-spinner:before {\r\n  content: \"\\f110\";\r\n}\r\n\r\n.fa-splotch:before {\r\n  content: \"\\f5bc\";\r\n}\r\n\r\n.fa-spotify:before {\r\n  content: \"\\f1bc\";\r\n}\r\n\r\n.fa-spray-can:before {\r\n  content: \"\\f5bd\";\r\n}\r\n\r\n.fa-square:before {\r\n  content: \"\\f0c8\";\r\n}\r\n\r\n.fa-square-full:before {\r\n  content: \"\\f45c\";\r\n}\r\n\r\n.fa-square-root-alt:before {\r\n  content: \"\\f698\";\r\n}\r\n\r\n.fa-squarespace:before {\r\n  content: \"\\f5be\";\r\n}\r\n\r\n.fa-stack-exchange:before {\r\n  content: \"\\f18d\";\r\n}\r\n\r\n.fa-stack-overflow:before {\r\n  content: \"\\f16c\";\r\n}\r\n\r\n.fa-stackpath:before {\r\n  content: \"\\f842\";\r\n}\r\n\r\n.fa-stamp:before {\r\n  content: \"\\f5bf\";\r\n}\r\n\r\n.fa-star:before {\r\n  content: \"\\f005\";\r\n}\r\n\r\n.fa-star-and-crescent:before {\r\n  content: \"\\f699\";\r\n}\r\n\r\n.fa-star-half:before {\r\n  content: \"\\f089\";\r\n}\r\n\r\n.fa-star-half-alt:before {\r\n  content: \"\\f5c0\";\r\n}\r\n\r\n.fa-star-of-david:before {\r\n  content: \"\\f69a\";\r\n}\r\n\r\n.fa-star-of-life:before {\r\n  content: \"\\f621\";\r\n}\r\n\r\n.fa-staylinked:before {\r\n  content: \"\\f3f5\";\r\n}\r\n\r\n.fa-steam:before {\r\n  content: \"\\f1b6\";\r\n}\r\n\r\n.fa-steam-square:before {\r\n  content: \"\\f1b7\";\r\n}\r\n\r\n.fa-steam-symbol:before {\r\n  content: \"\\f3f6\";\r\n}\r\n\r\n.fa-step-backward:before {\r\n  content: \"\\f048\";\r\n}\r\n\r\n.fa-step-forward:before {\r\n  content: \"\\f051\";\r\n}\r\n\r\n.fa-stethoscope:before {\r\n  content: \"\\f0f1\";\r\n}\r\n\r\n.fa-sticker-mule:before {\r\n  content: \"\\f3f7\";\r\n}\r\n\r\n.fa-sticky-note:before {\r\n  content: \"\\f249\";\r\n}\r\n\r\n.fa-stop:before {\r\n  content: \"\\f04d\";\r\n}\r\n\r\n.fa-stop-circle:before {\r\n  content: \"\\f28d\";\r\n}\r\n\r\n.fa-stopwatch:before {\r\n  content: \"\\f2f2\";\r\n}\r\n\r\n.fa-stopwatch-20:before {\r\n  content: \"\\f96f\";\r\n}\r\n\r\n.fa-store:before {\r\n  content: \"\\f54e\";\r\n}\r\n\r\n.fa-store-alt:before {\r\n  content: \"\\f54f\";\r\n}\r\n\r\n.fa-store-alt-slash:before {\r\n  content: \"\\f970\";\r\n}\r\n\r\n.fa-store-slash:before {\r\n  content: \"\\f971\";\r\n}\r\n\r\n.fa-strava:before {\r\n  content: \"\\f428\";\r\n}\r\n\r\n.fa-stream:before {\r\n  content: \"\\f550\";\r\n}\r\n\r\n.fa-street-view:before {\r\n  content: \"\\f21d\";\r\n}\r\n\r\n.fa-strikethrough:before {\r\n  content: \"\\f0cc\";\r\n}\r\n\r\n.fa-stripe:before {\r\n  content: \"\\f429\";\r\n}\r\n\r\n.fa-stripe-s:before {\r\n  content: \"\\f42a\";\r\n}\r\n\r\n.fa-stroopwafel:before {\r\n  content: \"\\f551\";\r\n}\r\n\r\n.fa-studiovinari:before {\r\n  content: \"\\f3f8\";\r\n}\r\n\r\n.fa-stumbleupon:before {\r\n  content: \"\\f1a4\";\r\n}\r\n\r\n.fa-stumbleupon-circle:before {\r\n  content: \"\\f1a3\";\r\n}\r\n\r\n.fa-subscript:before {\r\n  content: \"\\f12c\";\r\n}\r\n\r\n.fa-subway:before {\r\n  content: \"\\f239\";\r\n}\r\n\r\n.fa-suitcase:before {\r\n  content: \"\\f0f2\";\r\n}\r\n\r\n.fa-suitcase-rolling:before {\r\n  content: \"\\f5c1\";\r\n}\r\n\r\n.fa-sun:before {\r\n  content: \"\\f185\";\r\n}\r\n\r\n.fa-superpowers:before {\r\n  content: \"\\f2dd\";\r\n}\r\n\r\n.fa-superscript:before {\r\n  content: \"\\f12b\";\r\n}\r\n\r\n.fa-supple:before {\r\n  content: \"\\f3f9\";\r\n}\r\n\r\n.fa-surprise:before {\r\n  content: \"\\f5c2\";\r\n}\r\n\r\n.fa-suse:before {\r\n  content: \"\\f7d6\";\r\n}\r\n\r\n.fa-swatchbook:before {\r\n  content: \"\\f5c3\";\r\n}\r\n\r\n.fa-swift:before {\r\n  content: \"\\f8e1\";\r\n}\r\n\r\n.fa-swimmer:before {\r\n  content: \"\\f5c4\";\r\n}\r\n\r\n.fa-swimming-pool:before {\r\n  content: \"\\f5c5\";\r\n}\r\n\r\n.fa-symfony:before {\r\n  content: \"\\f83d\";\r\n}\r\n\r\n.fa-synagogue:before {\r\n  content: \"\\f69b\";\r\n}\r\n\r\n.fa-sync:before {\r\n  content: \"\\f021\";\r\n}\r\n\r\n.fa-sync-alt:before {\r\n  content: \"\\f2f1\";\r\n}\r\n\r\n.fa-syringe:before {\r\n  content: \"\\f48e\";\r\n}\r\n\r\n.fa-table:before {\r\n  content: \"\\f0ce\";\r\n}\r\n\r\n.fa-table-tennis:before {\r\n  content: \"\\f45d\";\r\n}\r\n\r\n.fa-tablet:before {\r\n  content: \"\\f10a\";\r\n}\r\n\r\n.fa-tablet-alt:before {\r\n  content: \"\\f3fa\";\r\n}\r\n\r\n.fa-tablets:before {\r\n  content: \"\\f490\";\r\n}\r\n\r\n.fa-tachometer-alt:before {\r\n  content: \"\\f3fd\";\r\n}\r\n\r\n.fa-tag:before {\r\n  content: \"\\f02b\";\r\n}\r\n\r\n.fa-tags:before {\r\n  content: \"\\f02c\";\r\n}\r\n\r\n.fa-tape:before {\r\n  content: \"\\f4db\";\r\n}\r\n\r\n.fa-tasks:before {\r\n  content: \"\\f0ae\";\r\n}\r\n\r\n.fa-taxi:before {\r\n  content: \"\\f1ba\";\r\n}\r\n\r\n.fa-teamspeak:before {\r\n  content: \"\\f4f9\";\r\n}\r\n\r\n.fa-teeth:before {\r\n  content: \"\\f62e\";\r\n}\r\n\r\n.fa-teeth-open:before {\r\n  content: \"\\f62f\";\r\n}\r\n\r\n.fa-telegram:before {\r\n  content: \"\\f2c6\";\r\n}\r\n\r\n.fa-telegram-plane:before {\r\n  content: \"\\f3fe\";\r\n}\r\n\r\n.fa-temperature-high:before {\r\n  content: \"\\f769\";\r\n}\r\n\r\n.fa-temperature-low:before {\r\n  content: \"\\f76b\";\r\n}\r\n\r\n.fa-tencent-weibo:before {\r\n  content: \"\\f1d5\";\r\n}\r\n\r\n.fa-tenge:before {\r\n  content: \"\\f7d7\";\r\n}\r\n\r\n.fa-terminal:before {\r\n  content: \"\\f120\";\r\n}\r\n\r\n.fa-text-height:before {\r\n  content: \"\\f034\";\r\n}\r\n\r\n.fa-text-width:before {\r\n  content: \"\\f035\";\r\n}\r\n\r\n.fa-th:before {\r\n  content: \"\\f00a\";\r\n}\r\n\r\n.fa-th-large:before {\r\n  content: \"\\f009\";\r\n}\r\n\r\n.fa-th-list:before {\r\n  content: \"\\f00b\";\r\n}\r\n\r\n.fa-the-red-yeti:before {\r\n  content: \"\\f69d\";\r\n}\r\n\r\n.fa-theater-masks:before {\r\n  content: \"\\f630\";\r\n}\r\n\r\n.fa-themeco:before {\r\n  content: \"\\f5c6\";\r\n}\r\n\r\n.fa-themeisle:before {\r\n  content: \"\\f2b2\";\r\n}\r\n\r\n.fa-thermometer:before {\r\n  content: \"\\f491\";\r\n}\r\n\r\n.fa-thermometer-empty:before {\r\n  content: \"\\f2cb\";\r\n}\r\n\r\n.fa-thermometer-full:before {\r\n  content: \"\\f2c7\";\r\n}\r\n\r\n.fa-thermometer-half:before {\r\n  content: \"\\f2c9\";\r\n}\r\n\r\n.fa-thermometer-quarter:before {\r\n  content: \"\\f2ca\";\r\n}\r\n\r\n.fa-thermometer-three-quarters:before {\r\n  content: \"\\f2c8\";\r\n}\r\n\r\n.fa-think-peaks:before {\r\n  content: \"\\f731\";\r\n}\r\n\r\n.fa-thumbs-down:before {\r\n  content: \"\\f165\";\r\n}\r\n\r\n.fa-thumbs-up:before {\r\n  content: \"\\f164\";\r\n}\r\n\r\n.fa-thumbtack:before {\r\n  content: \"\\f08d\";\r\n}\r\n\r\n.fa-ticket-alt:before {\r\n  content: \"\\f3ff\";\r\n}\r\n\r\n.fa-times:before {\r\n  content: \"\\f00d\";\r\n}\r\n\r\n.fa-times-circle:before {\r\n  content: \"\\f057\";\r\n}\r\n\r\n.fa-tint:before {\r\n  content: \"\\f043\";\r\n}\r\n\r\n.fa-tint-slash:before {\r\n  content: \"\\f5c7\";\r\n}\r\n\r\n.fa-tired:before {\r\n  content: \"\\f5c8\";\r\n}\r\n\r\n.fa-toggle-off:before {\r\n  content: \"\\f204\";\r\n}\r\n\r\n.fa-toggle-on:before {\r\n  content: \"\\f205\";\r\n}\r\n\r\n.fa-toilet:before {\r\n  content: \"\\f7d8\";\r\n}\r\n\r\n.fa-toilet-paper:before {\r\n  content: \"\\f71e\";\r\n}\r\n\r\n.fa-toilet-paper-slash:before {\r\n  content: \"\\f972\";\r\n}\r\n\r\n.fa-toolbox:before {\r\n  content: \"\\f552\";\r\n}\r\n\r\n.fa-tools:before {\r\n  content: \"\\f7d9\";\r\n}\r\n\r\n.fa-tooth:before {\r\n  content: \"\\f5c9\";\r\n}\r\n\r\n.fa-torah:before {\r\n  content: \"\\f6a0\";\r\n}\r\n\r\n.fa-torii-gate:before {\r\n  content: \"\\f6a1\";\r\n}\r\n\r\n.fa-tractor:before {\r\n  content: \"\\f722\";\r\n}\r\n\r\n.fa-trade-federation:before {\r\n  content: \"\\f513\";\r\n}\r\n\r\n.fa-trademark:before {\r\n  content: \"\\f25c\";\r\n}\r\n\r\n.fa-traffic-light:before {\r\n  content: \"\\f637\";\r\n}\r\n\r\n.fa-trailer:before {\r\n  content: \"\\f941\";\r\n}\r\n\r\n.fa-train:before {\r\n  content: \"\\f238\";\r\n}\r\n\r\n.fa-tram:before {\r\n  content: \"\\f7da\";\r\n}\r\n\r\n.fa-transgender:before {\r\n  content: \"\\f224\";\r\n}\r\n\r\n.fa-transgender-alt:before {\r\n  content: \"\\f225\";\r\n}\r\n\r\n.fa-trash:before {\r\n  content: \"\\f1f8\";\r\n}\r\n\r\n.fa-trash-alt:before {\r\n  content: \"\\f2ed\";\r\n}\r\n\r\n.fa-trash-restore:before {\r\n  content: \"\\f829\";\r\n}\r\n\r\n.fa-trash-restore-alt:before {\r\n  content: \"\\f82a\";\r\n}\r\n\r\n.fa-tree:before {\r\n  content: \"\\f1bb\";\r\n}\r\n\r\n.fa-trello:before {\r\n  content: \"\\f181\";\r\n}\r\n\r\n.fa-tripadvisor:before {\r\n  content: \"\\f262\";\r\n}\r\n\r\n.fa-trophy:before {\r\n  content: \"\\f091\";\r\n}\r\n\r\n.fa-truck:before {\r\n  content: \"\\f0d1\";\r\n}\r\n\r\n.fa-truck-loading:before {\r\n  content: \"\\f4de\";\r\n}\r\n\r\n.fa-truck-monster:before {\r\n  content: \"\\f63b\";\r\n}\r\n\r\n.fa-truck-moving:before {\r\n  content: \"\\f4df\";\r\n}\r\n\r\n.fa-truck-pickup:before {\r\n  content: \"\\f63c\";\r\n}\r\n\r\n.fa-tshirt:before {\r\n  content: \"\\f553\";\r\n}\r\n\r\n.fa-tty:before {\r\n  content: \"\\f1e4\";\r\n}\r\n\r\n.fa-tumblr:before {\r\n  content: \"\\f173\";\r\n}\r\n\r\n.fa-tumblr-square:before {\r\n  content: \"\\f174\";\r\n}\r\n\r\n.fa-tv:before {\r\n  content: \"\\f26c\";\r\n}\r\n\r\n.fa-twitch:before {\r\n  content: \"\\f1e8\";\r\n}\r\n\r\n.fa-twitter:before {\r\n  content: \"\\f099\";\r\n}\r\n\r\n.fa-twitter-square:before {\r\n  content: \"\\f081\";\r\n}\r\n\r\n.fa-typo3:before {\r\n  content: \"\\f42b\";\r\n}\r\n\r\n.fa-uber:before {\r\n  content: \"\\f402\";\r\n}\r\n\r\n.fa-ubuntu:before {\r\n  content: \"\\f7df\";\r\n}\r\n\r\n.fa-uikit:before {\r\n  content: \"\\f403\";\r\n}\r\n\r\n.fa-umbraco:before {\r\n  content: \"\\f8e8\";\r\n}\r\n\r\n.fa-umbrella:before {\r\n  content: \"\\f0e9\";\r\n}\r\n\r\n.fa-umbrella-beach:before {\r\n  content: \"\\f5ca\";\r\n}\r\n\r\n.fa-underline:before {\r\n  content: \"\\f0cd\";\r\n}\r\n\r\n.fa-undo:before {\r\n  content: \"\\f0e2\";\r\n}\r\n\r\n.fa-undo-alt:before {\r\n  content: \"\\f2ea\";\r\n}\r\n\r\n.fa-uniregistry:before {\r\n  content: \"\\f404\";\r\n}\r\n\r\n.fa-unity:before {\r\n  content: \"\\f949\";\r\n}\r\n\r\n.fa-universal-access:before {\r\n  content: \"\\f29a\";\r\n}\r\n\r\n.fa-university:before {\r\n  content: \"\\f19c\";\r\n}\r\n\r\n.fa-unlink:before {\r\n  content: \"\\f127\";\r\n}\r\n\r\n.fa-unlock:before {\r\n  content: \"\\f09c\";\r\n}\r\n\r\n.fa-unlock-alt:before {\r\n  content: \"\\f13e\";\r\n}\r\n\r\n.fa-untappd:before {\r\n  content: \"\\f405\";\r\n}\r\n\r\n.fa-upload:before {\r\n  content: \"\\f093\";\r\n}\r\n\r\n.fa-ups:before {\r\n  content: \"\\f7e0\";\r\n}\r\n\r\n.fa-usb:before {\r\n  content: \"\\f287\";\r\n}\r\n\r\n.fa-user:before {\r\n  content: \"\\f007\";\r\n}\r\n\r\n.fa-user-alt:before {\r\n  content: \"\\f406\";\r\n}\r\n\r\n.fa-user-alt-slash:before {\r\n  content: \"\\f4fa\";\r\n}\r\n\r\n.fa-user-astronaut:before {\r\n  content: \"\\f4fb\";\r\n}\r\n\r\n.fa-user-check:before {\r\n  content: \"\\f4fc\";\r\n}\r\n\r\n.fa-user-circle:before {\r\n  content: \"\\f2bd\";\r\n}\r\n\r\n.fa-user-clock:before {\r\n  content: \"\\f4fd\";\r\n}\r\n\r\n.fa-user-cog:before {\r\n  content: \"\\f4fe\";\r\n}\r\n\r\n.fa-user-edit:before {\r\n  content: \"\\f4ff\";\r\n}\r\n\r\n.fa-user-friends:before {\r\n  content: \"\\f500\";\r\n}\r\n\r\n.fa-user-graduate:before {\r\n  content: \"\\f501\";\r\n}\r\n\r\n.fa-user-injured:before {\r\n  content: \"\\f728\";\r\n}\r\n\r\n.fa-user-lock:before {\r\n  content: \"\\f502\";\r\n}\r\n\r\n.fa-user-md:before {\r\n  content: \"\\f0f0\";\r\n}\r\n\r\n.fa-user-minus:before {\r\n  content: \"\\f503\";\r\n}\r\n\r\n.fa-user-ninja:before {\r\n  content: \"\\f504\";\r\n}\r\n\r\n.fa-user-nurse:before {\r\n  content: \"\\f82f\";\r\n}\r\n\r\n.fa-user-plus:before {\r\n  content: \"\\f234\";\r\n}\r\n\r\n.fa-user-secret:before {\r\n  content: \"\\f21b\";\r\n}\r\n\r\n.fa-user-shield:before {\r\n  content: \"\\f505\";\r\n}\r\n\r\n.fa-user-slash:before {\r\n  content: \"\\f506\";\r\n}\r\n\r\n.fa-user-tag:before {\r\n  content: \"\\f507\";\r\n}\r\n\r\n.fa-user-tie:before {\r\n  content: \"\\f508\";\r\n}\r\n\r\n.fa-user-times:before {\r\n  content: \"\\f235\";\r\n}\r\n\r\n.fa-users:before {\r\n  content: \"\\f0c0\";\r\n}\r\n\r\n.fa-users-cog:before {\r\n  content: \"\\f509\";\r\n}\r\n\r\n.fa-usps:before {\r\n  content: \"\\f7e1\";\r\n}\r\n\r\n.fa-ussunnah:before {\r\n  content: \"\\f407\";\r\n}\r\n\r\n.fa-utensil-spoon:before {\r\n  content: \"\\f2e5\";\r\n}\r\n\r\n.fa-utensils:before {\r\n  content: \"\\f2e7\";\r\n}\r\n\r\n.fa-vaadin:before {\r\n  content: \"\\f408\";\r\n}\r\n\r\n.fa-vector-square:before {\r\n  content: \"\\f5cb\";\r\n}\r\n\r\n.fa-venus:before {\r\n  content: \"\\f221\";\r\n}\r\n\r\n.fa-venus-double:before {\r\n  content: \"\\f226\";\r\n}\r\n\r\n.fa-venus-mars:before {\r\n  content: \"\\f228\";\r\n}\r\n\r\n.fa-viacoin:before {\r\n  content: \"\\f237\";\r\n}\r\n\r\n.fa-viadeo:before {\r\n  content: \"\\f2a9\";\r\n}\r\n\r\n.fa-viadeo-square:before {\r\n  content: \"\\f2aa\";\r\n}\r\n\r\n.fa-vial:before {\r\n  content: \"\\f492\";\r\n}\r\n\r\n.fa-vials:before {\r\n  content: \"\\f493\";\r\n}\r\n\r\n.fa-viber:before {\r\n  content: \"\\f409\";\r\n}\r\n\r\n.fa-video:before {\r\n  content: \"\\f03d\";\r\n}\r\n\r\n.fa-video-slash:before {\r\n  content: \"\\f4e2\";\r\n}\r\n\r\n.fa-vihara:before {\r\n  content: \"\\f6a7\";\r\n}\r\n\r\n.fa-vimeo:before {\r\n  content: \"\\f40a\";\r\n}\r\n\r\n.fa-vimeo-square:before {\r\n  content: \"\\f194\";\r\n}\r\n\r\n.fa-vimeo-v:before {\r\n  content: \"\\f27d\";\r\n}\r\n\r\n.fa-vine:before {\r\n  content: \"\\f1ca\";\r\n}\r\n\r\n.fa-virus:before {\r\n  content: \"\\f974\";\r\n}\r\n\r\n.fa-virus-slash:before {\r\n  content: \"\\f975\";\r\n}\r\n\r\n.fa-viruses:before {\r\n  content: \"\\f976\";\r\n}\r\n\r\n.fa-vk:before {\r\n  content: \"\\f189\";\r\n}\r\n\r\n.fa-vnv:before {\r\n  content: \"\\f40b\";\r\n}\r\n\r\n.fa-voicemail:before {\r\n  content: \"\\f897\";\r\n}\r\n\r\n.fa-volleyball-ball:before {\r\n  content: \"\\f45f\";\r\n}\r\n\r\n.fa-volume-down:before {\r\n  content: \"\\f027\";\r\n}\r\n\r\n.fa-volume-mute:before {\r\n  content: \"\\f6a9\";\r\n}\r\n\r\n.fa-volume-off:before {\r\n  content: \"\\f026\";\r\n}\r\n\r\n.fa-volume-up:before {\r\n  content: \"\\f028\";\r\n}\r\n\r\n.fa-vote-yea:before {\r\n  content: \"\\f772\";\r\n}\r\n\r\n.fa-vr-cardboard:before {\r\n  content: \"\\f729\";\r\n}\r\n\r\n.fa-vuejs:before {\r\n  content: \"\\f41f\";\r\n}\r\n\r\n.fa-walking:before {\r\n  content: \"\\f554\";\r\n}\r\n\r\n.fa-wallet:before {\r\n  content: \"\\f555\";\r\n}\r\n\r\n.fa-warehouse:before {\r\n  content: \"\\f494\";\r\n}\r\n\r\n.fa-water:before {\r\n  content: \"\\f773\";\r\n}\r\n\r\n.fa-wave-square:before {\r\n  content: \"\\f83e\";\r\n}\r\n\r\n.fa-waze:before {\r\n  content: \"\\f83f\";\r\n}\r\n\r\n.fa-weebly:before {\r\n  content: \"\\f5cc\";\r\n}\r\n\r\n.fa-weibo:before {\r\n  content: \"\\f18a\";\r\n}\r\n\r\n.fa-weight:before {\r\n  content: \"\\f496\";\r\n}\r\n\r\n.fa-weight-hanging:before {\r\n  content: \"\\f5cd\";\r\n}\r\n\r\n.fa-weixin:before {\r\n  content: \"\\f1d7\";\r\n}\r\n\r\n.fa-whatsapp:before {\r\n  content: \"\\f232\";\r\n}\r\n\r\n.fa-whatsapp-square:before {\r\n  content: \"\\f40c\";\r\n}\r\n\r\n.fa-wheelchair:before {\r\n  content: \"\\f193\";\r\n}\r\n\r\n.fa-whmcs:before {\r\n  content: \"\\f40d\";\r\n}\r\n\r\n.fa-wifi:before {\r\n  content: \"\\f1eb\";\r\n}\r\n\r\n.fa-wikipedia-w:before {\r\n  content: \"\\f266\";\r\n}\r\n\r\n.fa-wind:before {\r\n  content: \"\\f72e\";\r\n}\r\n\r\n.fa-window-close:before {\r\n  content: \"\\f410\";\r\n}\r\n\r\n.fa-window-maximize:before {\r\n  content: \"\\f2d0\";\r\n}\r\n\r\n.fa-window-minimize:before {\r\n  content: \"\\f2d1\";\r\n}\r\n\r\n.fa-window-restore:before {\r\n  content: \"\\f2d2\";\r\n}\r\n\r\n.fa-windows:before {\r\n  content: \"\\f17a\";\r\n}\r\n\r\n.fa-wine-bottle:before {\r\n  content: \"\\f72f\";\r\n}\r\n\r\n.fa-wine-glass:before {\r\n  content: \"\\f4e3\";\r\n}\r\n\r\n.fa-wine-glass-alt:before {\r\n  content: \"\\f5ce\";\r\n}\r\n\r\n.fa-wix:before {\r\n  content: \"\\f5cf\";\r\n}\r\n\r\n.fa-wizards-of-the-coast:before {\r\n  content: \"\\f730\";\r\n}\r\n\r\n.fa-wolf-pack-battalion:before {\r\n  content: \"\\f514\";\r\n}\r\n\r\n.fa-won-sign:before {\r\n  content: \"\\f159\";\r\n}\r\n\r\n.fa-wordpress:before {\r\n  content: \"\\f19a\";\r\n}\r\n\r\n.fa-wordpress-simple:before {\r\n  content: \"\\f411\";\r\n}\r\n\r\n.fa-wpbeginner:before {\r\n  content: \"\\f297\";\r\n}\r\n\r\n.fa-wpexplorer:before {\r\n  content: \"\\f2de\";\r\n}\r\n\r\n.fa-wpforms:before {\r\n  content: \"\\f298\";\r\n}\r\n\r\n.fa-wpressr:before {\r\n  content: \"\\f3e4\";\r\n}\r\n\r\n.fa-wrench:before {\r\n  content: \"\\f0ad\";\r\n}\r\n\r\n.fa-x-ray:before {\r\n  content: \"\\f497\";\r\n}\r\n\r\n.fa-xbox:before {\r\n  content: \"\\f412\";\r\n}\r\n\r\n.fa-xing:before {\r\n  content: \"\\f168\";\r\n}\r\n\r\n.fa-xing-square:before {\r\n  content: \"\\f169\";\r\n}\r\n\r\n.fa-y-combinator:before {\r\n  content: \"\\f23b\";\r\n}\r\n\r\n.fa-yahoo:before {\r\n  content: \"\\f19e\";\r\n}\r\n\r\n.fa-yammer:before {\r\n  content: \"\\f840\";\r\n}\r\n\r\n.fa-yandex:before {\r\n  content: \"\\f413\";\r\n}\r\n\r\n.fa-yandex-international:before {\r\n  content: \"\\f414\";\r\n}\r\n\r\n.fa-yarn:before {\r\n  content: \"\\f7e3\";\r\n}\r\n\r\n.fa-yelp:before {\r\n  content: \"\\f1e9\";\r\n}\r\n\r\n.fa-yen-sign:before {\r\n  content: \"\\f157\";\r\n}\r\n\r\n.fa-yin-yang:before {\r\n  content: \"\\f6ad\";\r\n}\r\n\r\n.fa-yoast:before {\r\n  content: \"\\f2b1\";\r\n}\r\n\r\n.fa-youtube:before {\r\n  content: \"\\f167\";\r\n}\r\n\r\n.fa-youtube-square:before {\r\n  content: \"\\f431\";\r\n}\r\n\r\n.fa-zhihu:before {\r\n  content: \"\\f63f\";\r\n}\r\n\r\n.sr-only {\r\n  border: 0;\r\n  clip: rect(0, 0, 0, 0);\r\n  height: 1px;\r\n  margin: -1px;\r\n  overflow: hidden;\r\n  padding: 0;\r\n  position: absolute;\r\n  width: 1px;\r\n}\r\n\r\n.sr-only-focusable:active,\r\n.sr-only-focusable:focus {\r\n  clip: auto;\r\n  height: auto;\r\n  margin: 0;\r\n  overflow: visible;\r\n  position: static;\r\n  width: auto;\r\n}\r\n@font-face {\r\n  font-family: \"Font Awesome 5 Brands\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-display: block;\r\n  src: url(\"../../../../fonts/fa-brands-400.eot\");\r\n  src: url(\"../../../../fonts/fa-brands-400.eot?#iefix\")\r\n      format(\"embedded-opentype\"),\r\n    url(\"../../../../fonts/fa-brands-400.woff2\") format(\"woff2\"),\r\n    url(\"../../../../fonts/fa-brands-400.woff\") format(\"woff\"),\r\n    url(\"../../../../fonts/fa-brands-400.ttf\") format(\"truetype\"),\r\n    url(\"../../../../fonts/fa-brands-400.svg#fontawesome\") format(\"svg\");\r\n}\r\n\r\n.fab {\r\n  font-family: \"Font Awesome 5 Brands\";\r\n  font-weight: 400;\r\n}\r\n@font-face {\r\n  font-family: \"Font Awesome 5 Free\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-display: block;\r\n  src: url(\"../../../../fonts/fa-regular-400.eot\");\r\n  src: url(\"../../../../fonts/fa-regular-400.eot?#iefix\")\r\n      format(\"embedded-opentype\"),\r\n    url(\"../../../../fonts/fa-regular-400.woff2\") format(\"woff2\"),\r\n    url(\"../../../../fonts/fa-regular-400.woff\") format(\"woff\"),\r\n    url(\"../../../../fonts/fa-regular-400.ttf\") format(\"truetype\"),\r\n    url(\"../../../../fonts/fa-regular-400.svg#fontawesome\") format(\"svg\");\r\n}\r\n\r\n.far {\r\n  font-family: \"Font Awesome 5 Free\";\r\n  font-weight: 400;\r\n}\r\n@font-face {\r\n  font-family: \"Font Awesome 5 Free\";\r\n  font-style: normal;\r\n  font-weight: 900;\r\n  font-display: block;\r\n  src: url(\"../../../../fonts/fa-solid-900.eot\");\r\n  src: url(\"../../../../fonts/fa-solid-900.eot?#iefix\")\r\n      format(\"embedded-opentype\"),\r\n    url(\"../../../../fonts/fa-solid-900.woff2\") format(\"woff2\"),\r\n    url(\"../../../../fonts/fa-solid-900.woff\") format(\"woff\"),\r\n    url(\"../../../../fonts/fa-solid-900.ttf\") format(\"truetype\"),\r\n    url(\"../../../../fonts/fa-solid-900.svg#fontawesome\") format(\"svg\");\r\n}\r\n\r\n.fa,\r\n.fas {\r\n  font-family: \"Font Awesome 5 Free\";\r\n  font-weight: 900;\r\n}\r\n","@charset \"UTF-8\";\r\n\r\n@font-face {\r\n  font-family: \"dripicons-v2\";\r\n  src: url(\"../../../../fonts/dripicons-v2.eot\");\r\n  src: url(\"../../../../fonts/dripicons-v2.eot?#iefix\")\r\n      format(\"embedded-opentype\"),\r\n    url(\"../../../../fonts/dripicons-v2.woff\") format(\"woff\"),\r\n    url(\"../../../../fonts/dripicons-v2.ttf\") format(\"truetype\"),\r\n    url(\"../../../../fonts/dripicons-v2.svg#dripicons-v2\") format(\"svg\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n[data-icon]:before {\r\n  font-family: \"dripicons-v2\" !important;\r\n  content: attr(data-icon);\r\n  font-style: normal !important;\r\n  font-weight: normal !important;\r\n  font-variant: normal !important;\r\n  text-transform: none !important;\r\n  speak: none;\r\n  line-height: 1;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n[class^=\"dripicons-\"]:before,\r\n[class*=\" dripicons-\"]:before {\r\n  font-family: \"dripicons-v2\" !important;\r\n  font-style: normal !important;\r\n  font-weight: normal !important;\r\n  font-variant: normal !important;\r\n  text-transform: none !important;\r\n  speak: none;\r\n  line-height: 1;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n.dripicons-alarm:before {\r\n  content: \"\\61\";\r\n}\r\n.dripicons-align-center:before {\r\n  content: \"\\62\";\r\n}\r\n.dripicons-align-justify:before {\r\n  content: \"\\63\";\r\n}\r\n.dripicons-align-left:before {\r\n  content: \"\\64\";\r\n}\r\n.dripicons-align-right:before {\r\n  content: \"\\65\";\r\n}\r\n.dripicons-anchor:before {\r\n  content: \"\\66\";\r\n}\r\n.dripicons-archive:before {\r\n  content: \"\\67\";\r\n}\r\n.dripicons-arrow-down:before {\r\n  content: \"\\68\";\r\n}\r\n.dripicons-arrow-left:before {\r\n  content: \"\\69\";\r\n}\r\n.dripicons-arrow-right:before {\r\n  content: \"\\6a\";\r\n}\r\n.dripicons-arrow-thin-down:before {\r\n  content: \"\\6b\";\r\n}\r\n.dripicons-arrow-thin-left:before {\r\n  content: \"\\6c\";\r\n}\r\n.dripicons-arrow-thin-right:before {\r\n  content: \"\\6d\";\r\n}\r\n.dripicons-arrow-thin-up:before {\r\n  content: \"\\6e\";\r\n}\r\n.dripicons-arrow-up:before {\r\n  content: \"\\6f\";\r\n}\r\n.dripicons-article:before {\r\n  content: \"\\70\";\r\n}\r\n.dripicons-backspace:before {\r\n  content: \"\\71\";\r\n}\r\n.dripicons-basket:before {\r\n  content: \"\\72\";\r\n}\r\n.dripicons-basketball:before {\r\n  content: \"\\73\";\r\n}\r\n.dripicons-battery-empty:before {\r\n  content: \"\\74\";\r\n}\r\n.dripicons-battery-full:before {\r\n  content: \"\\75\";\r\n}\r\n.dripicons-battery-low:before {\r\n  content: \"\\76\";\r\n}\r\n.dripicons-battery-medium:before {\r\n  content: \"\\77\";\r\n}\r\n.dripicons-bell:before {\r\n  content: \"\\78\";\r\n}\r\n.dripicons-blog:before {\r\n  content: \"\\79\";\r\n}\r\n.dripicons-bluetooth:before {\r\n  content: \"\\7a\";\r\n}\r\n.dripicons-bold:before {\r\n  content: \"\\41\";\r\n}\r\n.dripicons-bookmark:before {\r\n  content: \"\\42\";\r\n}\r\n.dripicons-bookmarks:before {\r\n  content: \"\\43\";\r\n}\r\n.dripicons-box:before {\r\n  content: \"\\44\";\r\n}\r\n.dripicons-briefcase:before {\r\n  content: \"\\45\";\r\n}\r\n.dripicons-brightness-low:before {\r\n  content: \"\\46\";\r\n}\r\n.dripicons-brightness-max:before {\r\n  content: \"\\47\";\r\n}\r\n.dripicons-brightness-medium:before {\r\n  content: \"\\48\";\r\n}\r\n.dripicons-broadcast:before {\r\n  content: \"\\49\";\r\n}\r\n.dripicons-browser:before {\r\n  content: \"\\4a\";\r\n}\r\n.dripicons-browser-upload:before {\r\n  content: \"\\4b\";\r\n}\r\n.dripicons-brush:before {\r\n  content: \"\\4c\";\r\n}\r\n.dripicons-calendar:before {\r\n  content: \"\\4d\";\r\n}\r\n.dripicons-camcorder:before {\r\n  content: \"\\4e\";\r\n}\r\n.dripicons-camera:before {\r\n  content: \"\\4f\";\r\n}\r\n.dripicons-card:before {\r\n  content: \"\\50\";\r\n}\r\n.dripicons-cart:before {\r\n  content: \"\\51\";\r\n}\r\n.dripicons-checklist:before {\r\n  content: \"\\52\";\r\n}\r\n.dripicons-checkmark:before {\r\n  content: \"\\53\";\r\n}\r\n.dripicons-chevron-down:before {\r\n  content: \"\\54\";\r\n}\r\n.dripicons-chevron-left:before {\r\n  content: \"\\55\";\r\n}\r\n.dripicons-chevron-right:before {\r\n  content: \"\\56\";\r\n}\r\n.dripicons-chevron-up:before {\r\n  content: \"\\57\";\r\n}\r\n.dripicons-clipboard:before {\r\n  content: \"\\58\";\r\n}\r\n.dripicons-clock:before {\r\n  content: \"\\59\";\r\n}\r\n.dripicons-clockwise:before {\r\n  content: \"\\5a\";\r\n}\r\n.dripicons-cloud:before {\r\n  content: \"\\30\";\r\n}\r\n.dripicons-cloud-download:before {\r\n  content: \"\\31\";\r\n}\r\n.dripicons-cloud-upload:before {\r\n  content: \"\\32\";\r\n}\r\n.dripicons-code:before {\r\n  content: \"\\33\";\r\n}\r\n.dripicons-contract:before {\r\n  content: \"\\34\";\r\n}\r\n.dripicons-contract-2:before {\r\n  content: \"\\35\";\r\n}\r\n.dripicons-conversation:before {\r\n  content: \"\\36\";\r\n}\r\n.dripicons-copy:before {\r\n  content: \"\\37\";\r\n}\r\n.dripicons-crop:before {\r\n  content: \"\\38\";\r\n}\r\n.dripicons-cross:before {\r\n  content: \"\\39\";\r\n}\r\n.dripicons-crosshair:before {\r\n  content: \"\\21\";\r\n}\r\n.dripicons-cutlery:before {\r\n  content: \"\\22\";\r\n}\r\n.dripicons-device-desktop:before {\r\n  content: \"\\23\";\r\n}\r\n.dripicons-device-mobile:before {\r\n  content: \"\\24\";\r\n}\r\n.dripicons-device-tablet:before {\r\n  content: \"\\25\";\r\n}\r\n.dripicons-direction:before {\r\n  content: \"\\26\";\r\n}\r\n.dripicons-disc:before {\r\n  content: \"\\27\";\r\n}\r\n.dripicons-document:before {\r\n  content: \"\\28\";\r\n}\r\n.dripicons-document-delete:before {\r\n  content: \"\\29\";\r\n}\r\n.dripicons-document-edit:before {\r\n  content: \"\\2a\";\r\n}\r\n.dripicons-document-new:before {\r\n  content: \"\\2b\";\r\n}\r\n.dripicons-document-remove:before {\r\n  content: \"\\2c\";\r\n}\r\n.dripicons-dot:before {\r\n  content: \"\\2d\";\r\n}\r\n.dripicons-dots-2:before {\r\n  content: \"\\2e\";\r\n}\r\n.dripicons-dots-3:before {\r\n  content: \"\\2f\";\r\n}\r\n.dripicons-download:before {\r\n  content: \"\\3a\";\r\n}\r\n.dripicons-duplicate:before {\r\n  content: \"\\3b\";\r\n}\r\n.dripicons-enter:before {\r\n  content: \"\\3c\";\r\n}\r\n.dripicons-exit:before {\r\n  content: \"\\3d\";\r\n}\r\n.dripicons-expand:before {\r\n  content: \"\\3e\";\r\n}\r\n.dripicons-expand-2:before {\r\n  content: \"\\3f\";\r\n}\r\n.dripicons-experiment:before {\r\n  content: \"\\40\";\r\n}\r\n.dripicons-export:before {\r\n  content: \"\\5b\";\r\n}\r\n.dripicons-feed:before {\r\n  content: \"\\5d\";\r\n}\r\n.dripicons-flag:before {\r\n  content: \"\\5e\";\r\n}\r\n.dripicons-flashlight:before {\r\n  content: \"\\5f\";\r\n}\r\n.dripicons-folder:before {\r\n  content: \"\\60\";\r\n}\r\n.dripicons-folder-open:before {\r\n  content: \"\\7b\";\r\n}\r\n.dripicons-forward:before {\r\n  content: \"\\7c\";\r\n}\r\n.dripicons-gaming:before {\r\n  content: \"\\7d\";\r\n}\r\n.dripicons-gear:before {\r\n  content: \"\\7e\";\r\n}\r\n.dripicons-graduation:before {\r\n  content: \"\\5c\";\r\n}\r\n.dripicons-graph-bar:before {\r\n  content: \"\\e000\";\r\n}\r\n.dripicons-graph-line:before {\r\n  content: \"\\e001\";\r\n}\r\n.dripicons-graph-pie:before {\r\n  content: \"\\e002\";\r\n}\r\n.dripicons-headset:before {\r\n  content: \"\\e003\";\r\n}\r\n.dripicons-heart:before {\r\n  content: \"\\e004\";\r\n}\r\n.dripicons-help:before {\r\n  content: \"\\e005\";\r\n}\r\n.dripicons-home:before {\r\n  content: \"\\e006\";\r\n}\r\n.dripicons-hourglass:before {\r\n  content: \"\\e007\";\r\n}\r\n.dripicons-inbox:before {\r\n  content: \"\\e008\";\r\n}\r\n.dripicons-information:before {\r\n  content: \"\\e009\";\r\n}\r\n.dripicons-italic:before {\r\n  content: \"\\e00a\";\r\n}\r\n.dripicons-jewel:before {\r\n  content: \"\\e00b\";\r\n}\r\n.dripicons-lifting:before {\r\n  content: \"\\e00c\";\r\n}\r\n.dripicons-lightbulb:before {\r\n  content: \"\\e00d\";\r\n}\r\n.dripicons-link:before {\r\n  content: \"\\e00e\";\r\n}\r\n.dripicons-link-broken:before {\r\n  content: \"\\e00f\";\r\n}\r\n.dripicons-list:before {\r\n  content: \"\\e010\";\r\n}\r\n.dripicons-loading:before {\r\n  content: \"\\e011\";\r\n}\r\n.dripicons-location:before {\r\n  content: \"\\e012\";\r\n}\r\n.dripicons-lock:before {\r\n  content: \"\\e013\";\r\n}\r\n.dripicons-lock-open:before {\r\n  content: \"\\e014\";\r\n}\r\n.dripicons-mail:before {\r\n  content: \"\\e015\";\r\n}\r\n.dripicons-map:before {\r\n  content: \"\\e016\";\r\n}\r\n.dripicons-media-loop:before {\r\n  content: \"\\e017\";\r\n}\r\n.dripicons-media-next:before {\r\n  content: \"\\e018\";\r\n}\r\n.dripicons-media-pause:before {\r\n  content: \"\\e019\";\r\n}\r\n.dripicons-media-play:before {\r\n  content: \"\\e01a\";\r\n}\r\n.dripicons-media-previous:before {\r\n  content: \"\\e01b\";\r\n}\r\n.dripicons-media-record:before {\r\n  content: \"\\e01c\";\r\n}\r\n.dripicons-media-shuffle:before {\r\n  content: \"\\e01d\";\r\n}\r\n.dripicons-media-stop:before {\r\n  content: \"\\e01e\";\r\n}\r\n.dripicons-medical:before {\r\n  content: \"\\e01f\";\r\n}\r\n.dripicons-menu:before {\r\n  content: \"\\e020\";\r\n}\r\n.dripicons-message:before {\r\n  content: \"\\e021\";\r\n}\r\n.dripicons-meter:before {\r\n  content: \"\\e022\";\r\n}\r\n.dripicons-microphone:before {\r\n  content: \"\\e023\";\r\n}\r\n.dripicons-minus:before {\r\n  content: \"\\e024\";\r\n}\r\n.dripicons-monitor:before {\r\n  content: \"\\e025\";\r\n}\r\n.dripicons-move:before {\r\n  content: \"\\e026\";\r\n}\r\n.dripicons-music:before {\r\n  content: \"\\e027\";\r\n}\r\n.dripicons-network-1:before {\r\n  content: \"\\e028\";\r\n}\r\n.dripicons-network-2:before {\r\n  content: \"\\e029\";\r\n}\r\n.dripicons-network-3:before {\r\n  content: \"\\e02a\";\r\n}\r\n.dripicons-network-4:before {\r\n  content: \"\\e02b\";\r\n}\r\n.dripicons-network-5:before {\r\n  content: \"\\e02c\";\r\n}\r\n.dripicons-pamphlet:before {\r\n  content: \"\\e02d\";\r\n}\r\n.dripicons-paperclip:before {\r\n  content: \"\\e02e\";\r\n}\r\n.dripicons-pencil:before {\r\n  content: \"\\e02f\";\r\n}\r\n.dripicons-phone:before {\r\n  content: \"\\e030\";\r\n}\r\n.dripicons-photo:before {\r\n  content: \"\\e031\";\r\n}\r\n.dripicons-photo-group:before {\r\n  content: \"\\e032\";\r\n}\r\n.dripicons-pill:before {\r\n  content: \"\\e033\";\r\n}\r\n.dripicons-pin:before {\r\n  content: \"\\e034\";\r\n}\r\n.dripicons-plus:before {\r\n  content: \"\\e035\";\r\n}\r\n.dripicons-power:before {\r\n  content: \"\\e036\";\r\n}\r\n.dripicons-preview:before {\r\n  content: \"\\e037\";\r\n}\r\n.dripicons-print:before {\r\n  content: \"\\e038\";\r\n}\r\n.dripicons-pulse:before {\r\n  content: \"\\e039\";\r\n}\r\n.dripicons-question:before {\r\n  content: \"\\e03a\";\r\n}\r\n.dripicons-reply:before {\r\n  content: \"\\e03b\";\r\n}\r\n.dripicons-reply-all:before {\r\n  content: \"\\e03c\";\r\n}\r\n.dripicons-return:before {\r\n  content: \"\\e03d\";\r\n}\r\n.dripicons-retweet:before {\r\n  content: \"\\e03e\";\r\n}\r\n.dripicons-rocket:before {\r\n  content: \"\\e03f\";\r\n}\r\n.dripicons-scale:before {\r\n  content: \"\\e040\";\r\n}\r\n.dripicons-search:before {\r\n  content: \"\\e041\";\r\n}\r\n.dripicons-shopping-bag:before {\r\n  content: \"\\e042\";\r\n}\r\n.dripicons-skip:before {\r\n  content: \"\\e043\";\r\n}\r\n.dripicons-stack:before {\r\n  content: \"\\e044\";\r\n}\r\n.dripicons-star:before {\r\n  content: \"\\e045\";\r\n}\r\n.dripicons-stopwatch:before {\r\n  content: \"\\e046\";\r\n}\r\n.dripicons-store:before {\r\n  content: \"\\e047\";\r\n}\r\n.dripicons-suitcase:before {\r\n  content: \"\\e048\";\r\n}\r\n.dripicons-swap:before {\r\n  content: \"\\e049\";\r\n}\r\n.dripicons-tag:before {\r\n  content: \"\\e04a\";\r\n}\r\n.dripicons-tag-delete:before {\r\n  content: \"\\e04b\";\r\n}\r\n.dripicons-tags:before {\r\n  content: \"\\e04c\";\r\n}\r\n.dripicons-thumbs-down:before {\r\n  content: \"\\e04d\";\r\n}\r\n.dripicons-thumbs-up:before {\r\n  content: \"\\e04e\";\r\n}\r\n.dripicons-ticket:before {\r\n  content: \"\\e04f\";\r\n}\r\n.dripicons-time-reverse:before {\r\n  content: \"\\e050\";\r\n}\r\n.dripicons-to-do:before {\r\n  content: \"\\e051\";\r\n}\r\n.dripicons-toggles:before {\r\n  content: \"\\e052\";\r\n}\r\n.dripicons-trash:before {\r\n  content: \"\\e053\";\r\n}\r\n.dripicons-trophy:before {\r\n  content: \"\\e054\";\r\n}\r\n.dripicons-upload:before {\r\n  content: \"\\e055\";\r\n}\r\n.dripicons-user:before {\r\n  content: \"\\e056\";\r\n}\r\n.dripicons-user-group:before {\r\n  content: \"\\e057\";\r\n}\r\n.dripicons-user-id:before {\r\n  content: \"\\e058\";\r\n}\r\n.dripicons-vibrate:before {\r\n  content: \"\\e059\";\r\n}\r\n.dripicons-view-apps:before {\r\n  content: \"\\e05a\";\r\n}\r\n.dripicons-view-list:before {\r\n  content: \"\\e05b\";\r\n}\r\n.dripicons-view-list-large:before {\r\n  content: \"\\e05c\";\r\n}\r\n.dripicons-view-thumb:before {\r\n  content: \"\\e05d\";\r\n}\r\n.dripicons-volume-full:before {\r\n  content: \"\\e05e\";\r\n}\r\n.dripicons-volume-low:before {\r\n  content: \"\\e05f\";\r\n}\r\n.dripicons-volume-medium:before {\r\n  content: \"\\e060\";\r\n}\r\n.dripicons-volume-off:before {\r\n  content: \"\\e061\";\r\n}\r\n.dripicons-wallet:before {\r\n  content: \"\\e062\";\r\n}\r\n.dripicons-warning:before {\r\n  content: \"\\e063\";\r\n}\r\n.dripicons-web:before {\r\n  content: \"\\e064\";\r\n}\r\n.dripicons-weight:before {\r\n  content: \"\\e065\";\r\n}\r\n.dripicons-wifi:before {\r\n  content: \"\\e066\";\r\n}\r\n.dripicons-wrong:before {\r\n  content: \"\\e067\";\r\n}\r\n.dripicons-zoom-in:before {\r\n  content: \"\\e068\";\r\n}\r\n.dripicons-zoom-out:before {\r\n  content: \"\\e069\";\r\n}\r\n","/*\r\nTemplate Name: Minible - Admin & Dashboard Template\r\nAuthor: Themesbrand\r\nVersion: 2.1.0\r\nWebsite: https://themesbrand.com/\r\nContact: themesbrand@gmail.com\r\nFile: Custom Bootstrap Css File\r\n*/\r\n\r\n\r\n//Core files\r\n@import \"./node_modules/bootstrap/scss/functions\";\r\n@import \"./node_modules/bootstrap/scss/variables\";\r\n@import \"variables\";\r\n@import \"./node_modules/bootstrap/scss/bootstrap\";\r\n\r\n@import \"custom/components/reboot\";\r\n@import \"custom/components/backgrounds\";\r\n@import \"custom/components/badge\";\r\n@import \"custom/components/buttons\";\r\n@import \"custom/components/breadcrumb\";\r\n@import \"custom/components/card\";\r\n@import \"custom/components/dropdown\";\r\n@import \"custom/components/nav\";\r\n@import \"custom/components/table\";\r\n@import \"custom/components/pagination\";\r\n@import \"custom/components/progress\";","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.2 (https://getbootstrap.com/)\n   * Copyright 2011-2023 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\r\n\r\n//\r\n// custom-variables\r\n//\r\n\r\n// Vertical Sidebar  Light\r\n$sidebar-bg: #ffffff;\r\n$sidebar-menu-item-color: #7b8190;\r\n$sidebar-menu-sub-item-color: #7b8190;\r\n$sidebar-menu-item-icon-color: #7b8190;\r\n$sidebar-menu-item-hover-color: #383c40;\r\n$sidebar-menu-item-active-color: #5b73e8;\r\n$sidebar-menu-item-active-bg-color: #f3f8fb;\r\n$sidebar-menu-item-active-bg-color-dark: #293552;\r\n$sidebar-width:  250px;\r\n$sidebar-collapsed-width:  70px;\r\n$sidebar-width-sm:  160px;\r\n\r\n// Vertical Sidebar - Dark\r\n$sidebar-dark-bg: #1c2742; //2c313a\r\n$sidebar-dark-menu-item-color: #8c98bb;\r\n$sidebar-dark-menu-sub-item-color: #7b85a2;\r\n$sidebar-dark-menu-item-icon-color: #6d7794;\r\n$sidebar-dark-menu-item-hover-color: #ffffff;\r\n$sidebar-dark-menu-item-active-color: #ffffff;\r\n\r\n// Topbar - Deafult Light\r\n$header-height: 65px;\r\n$header-bg: #ffffff;\r\n$header-item-color: #555b6d;\r\n\r\n// Topbar - Dark\r\n$header-dark-bg: #2f374e;\r\n$header-dark-item-color: #e9ecef;\r\n\r\n// Topbar Search\r\n$topbar-search-bg: transparent;\r\n\r\n// Footer\r\n$footer-height: 120px;\r\n$footer-bg: #f2f2f5;\r\n$footer-color: #74788d;\r\n\r\n// Horizontal nav\r\n$topnav-bg:   #fff;\r\n\r\n$menu-item-color: #7b8190;\r\n$menu-item-active-color: #5b73e8;\r\n\r\n// Right Sidebar\r\n$rightbar-width:  280px;\r\n\r\n// Display\r\n$display-none: none;\r\n$display-block: block;\r\n\r\n// Brand \r\n$navbar-brand-box-width: 250px;\r\n\r\n// Boxed layout width\r\n$boxed-layout-width:    1300px;\r\n$boxed-body-bg:       #e9ebf0;\r\n\r\n// Font Weight\r\n$font-weight-medium: 500;\r\n$font-weight-semibold: 600;\r\n\r\n// apex charts\r\n$apex-grid-color: #f8f9fa;\r\n\r\n// auth bg\r\n$auth-bg: rgba(91,140,232,.25);\r\n\r\n// table\r\n$table-head-bg:               $gray-100;\r\n$table-dark-border-color:     tint-color($gray-800, 7.5%);\r\n\r\n// close dark\r\n$btn-close-bg-dark:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$black}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\");\r\n\r\n\r\n// Variables\r\n//\r\n// Variables should follow the `$component-state-property-size` formula for\r\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\r\n\r\n// Color system\r\n\r\n// scss-docs-start gray-color-variables\r\n$white:    #fff;\r\n$gray-100: #f8f9fa;\r\n$gray-200: #f5f6f8;\r\n$gray-300: #f6f6f6;\r\n$gray-400: #ced4da;\r\n$gray-500: #adb5bd;\r\n$gray-600: #74788d;\r\n$gray-700: #495057;\r\n$gray-800: #343a40;\r\n$gray-900: #212529;\r\n$black:    #000;\r\n// scss-docs-end gray-color-variables\r\n\r\n// fusv-disable\r\n// scss-docs-start gray-colors-map\r\n$grays: (\r\n    \"100\": $gray-100,\r\n    \"200\": $gray-200,\r\n    \"300\": $gray-300,\r\n    \"400\": $gray-400,\r\n    \"500\": $gray-500,\r\n    \"600\": $gray-600,\r\n    \"700\": $gray-700,\r\n    \"800\": $gray-800,\r\n    \"900\": $gray-900\r\n);\r\n// scss-docs-end gray-colors-map\r\n// fusv-enable\r\n// scss-docs-start color-variables\r\n$blue:    #5b73e8;\r\n$indigo:  #564ab1;\r\n$purple:  #6f42c1;\r\n$pink:    #e83e8c;\r\n$red:     #f46a6a;\r\n$orange:  #f1734f;\r\n$yellow:  #f1b44c;\r\n$green:   #34c38f;\r\n$teal:    #050505;\r\n$cyan:    #50a5f1;\r\n// scss-docs-end color-variables\r\n\r\n// scss-docs-start colors-map\r\n$colors: (\r\n    \"blue\":       $blue,\r\n    \"indigo\":     $indigo,\r\n    \"purple\":     $purple,\r\n    \"pink\":       $pink,\r\n    \"red\":        $red,\r\n    \"orange\":     $orange,\r\n    \"yellow\":     $yellow,\r\n    \"green\":      $green,\r\n    \"teal\":       $teal,\r\n    \"cyan\":       $cyan,\r\n    \"white\":      $white,\r\n    \"gray\":       $gray-600,\r\n    \"gray-dark\":  $gray-800\r\n  );\r\n// scss-docs-end colors-map\r\n\r\n// scss-docs-start theme-color-variables\r\n$primary:       $blue;\r\n$secondary:     $gray-600;\r\n$success:       $green;\r\n$info:          $cyan;\r\n$warning:       $yellow;\r\n$danger:        $red;\r\n$light:         $gray-200;\r\n$dark:          $gray-800;\r\n$purple:        $purple;\r\n// scss-docs-end theme-color-variables\r\n\r\n// scss-docs-start theme-colors-map\r\n$theme-colors: (\r\n    \"primary\":    $primary,\r\n    \"secondary\":  $secondary,\r\n    \"success\":    $success,\r\n    \"info\":       $info,\r\n    \"warning\":    $warning,\r\n    \"danger\":     $danger,\r\n    \"pink\":       $pink,\r\n    \"light\":      $light,\r\n    \"dark\":       $dark,\r\n    \"purple\":       $purple\r\n);\r\n\r\n// scss-docs-end theme-colors-map\r\n\r\n// scss-docs-start theme-colors-rgb\r\n$theme-colors-rgb: map-loop($theme-colors, to-rgb, \"$value\");\r\n// scss-docs-end theme-colors-rgb\r\n\r\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\r\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\r\n$min-contrast-ratio:   1.8;\r\n\r\n// Customize the light and dark text colors for use in our color contrast function.\r\n$color-contrast-dark:      $black;\r\n$color-contrast-light:     $white;\r\n\r\n// fusv-disable\r\n$blue-100: tint-color($blue, 80%);\r\n$blue-200: tint-color($blue, 60%);\r\n$blue-300: tint-color($blue, 40%);\r\n$blue-400: tint-color($blue, 20%);\r\n$blue-500: $blue;\r\n$blue-600: shade-color($blue, 20%);\r\n$blue-700: shade-color($blue, 40%);\r\n$blue-800: shade-color($blue, 60%);\r\n$blue-900: shade-color($blue, 80%);\r\n\r\n$indigo-100: tint-color($indigo, 80%);\r\n$indigo-200: tint-color($indigo, 60%);\r\n$indigo-300: tint-color($indigo, 40%);\r\n$indigo-400: tint-color($indigo, 20%);\r\n$indigo-500: $indigo;\r\n$indigo-600: shade-color($indigo, 20%);\r\n$indigo-700: shade-color($indigo, 40%);\r\n$indigo-800: shade-color($indigo, 60%);\r\n$indigo-900: shade-color($indigo, 80%);\r\n\r\n$purple-100: tint-color($purple, 80%);\r\n$purple-200: tint-color($purple, 60%);\r\n$purple-300: tint-color($purple, 40%);\r\n$purple-400: tint-color($purple, 20%);\r\n$purple-500: $purple;\r\n$purple-600: shade-color($purple, 20%);\r\n$purple-700: shade-color($purple, 40%);\r\n$purple-800: shade-color($purple, 60%);\r\n$purple-900: shade-color($purple, 80%);\r\n\r\n$pink-100: tint-color($pink, 80%);\r\n$pink-200: tint-color($pink, 60%);\r\n$pink-300: tint-color($pink, 40%);\r\n$pink-400: tint-color($pink, 20%);\r\n$pink-500: $pink;\r\n$pink-600: shade-color($pink, 20%);\r\n$pink-700: shade-color($pink, 40%);\r\n$pink-800: shade-color($pink, 60%);\r\n$pink-900: shade-color($pink, 80%);\r\n\r\n$red-100: tint-color($red, 80%);\r\n$red-200: tint-color($red, 60%);\r\n$red-300: tint-color($red, 40%);\r\n$red-400: tint-color($red, 20%);\r\n$red-500: $red;\r\n$red-600: shade-color($red, 20%);\r\n$red-700: shade-color($red, 40%);\r\n$red-800: shade-color($red, 60%);\r\n$red-900: shade-color($red, 80%);\r\n\r\n$orange-100: tint-color($orange, 80%);\r\n$orange-200: tint-color($orange, 60%);\r\n$orange-300: tint-color($orange, 40%);\r\n$orange-400: tint-color($orange, 20%);\r\n$orange-500: $orange;\r\n$orange-600: shade-color($orange, 20%);\r\n$orange-700: shade-color($orange, 40%);\r\n$orange-800: shade-color($orange, 60%);\r\n$orange-900: shade-color($orange, 80%);\r\n\r\n$yellow-100: tint-color($yellow, 80%);\r\n$yellow-200: tint-color($yellow, 60%);\r\n$yellow-300: tint-color($yellow, 40%);\r\n$yellow-400: tint-color($yellow, 20%);\r\n$yellow-500: $yellow;\r\n$yellow-600: shade-color($yellow, 20%);\r\n$yellow-700: shade-color($yellow, 40%);\r\n$yellow-800: shade-color($yellow, 60%);\r\n$yellow-900: shade-color($yellow, 80%);\r\n\r\n$green-100: tint-color($green, 80%);\r\n$green-200: tint-color($green, 60%);\r\n$green-300: tint-color($green, 40%);\r\n$green-400: tint-color($green, 20%);\r\n$green-500: $green;\r\n$green-600: shade-color($green, 20%);\r\n$green-700: shade-color($green, 40%);\r\n$green-800: shade-color($green, 60%);\r\n$green-900: shade-color($green, 80%);\r\n\r\n$teal-100: tint-color($teal, 80%);\r\n$teal-200: tint-color($teal, 60%);\r\n$teal-300: tint-color($teal, 40%);\r\n$teal-400: tint-color($teal, 20%);\r\n$teal-500: $teal;\r\n$teal-600: shade-color($teal, 20%);\r\n$teal-700: shade-color($teal, 40%);\r\n$teal-800: shade-color($teal, 60%);\r\n$teal-900: shade-color($teal, 80%);\r\n\r\n$cyan-100: tint-color($cyan, 80%);\r\n$cyan-200: tint-color($cyan, 60%);\r\n$cyan-300: tint-color($cyan, 40%);\r\n$cyan-400: tint-color($cyan, 20%);\r\n$cyan-500: $cyan;\r\n$cyan-600: shade-color($cyan, 20%);\r\n$cyan-700: shade-color($cyan, 40%);\r\n$cyan-800: shade-color($cyan, 60%);\r\n$cyan-900: shade-color($cyan, 80%);\r\n$blues: (\r\n  \"blue-100\": $blue-100,\r\n  \"blue-200\": $blue-200,\r\n  \"blue-300\": $blue-300,\r\n  \"blue-400\": $blue-400,\r\n  \"blue-500\": $blue-500,\r\n  \"blue-600\": $blue-600,\r\n  \"blue-700\": $blue-700,\r\n  \"blue-800\": $blue-800,\r\n  \"blue-900\": $blue-900\r\n);\r\n\r\n$indigos: (\r\n  \"indigo-100\": $indigo-100,\r\n  \"indigo-200\": $indigo-200,\r\n  \"indigo-300\": $indigo-300,\r\n  \"indigo-400\": $indigo-400,\r\n  \"indigo-500\": $indigo-500,\r\n  \"indigo-600\": $indigo-600,\r\n  \"indigo-700\": $indigo-700,\r\n  \"indigo-800\": $indigo-800,\r\n  \"indigo-900\": $indigo-900\r\n);\r\n\r\n$purples: (\r\n  \"purple-100\": $purple-200,\r\n  \"purple-200\": $purple-100,\r\n  \"purple-300\": $purple-300,\r\n  \"purple-400\": $purple-400,\r\n  \"purple-500\": $purple-500,\r\n  \"purple-600\": $purple-600,\r\n  \"purple-700\": $purple-700,\r\n  \"purple-800\": $purple-800,\r\n  \"purple-900\": $purple-900\r\n);\r\n\r\n$pinks: (\r\n  \"pink-100\": $pink-100,\r\n  \"pink-200\": $pink-200,\r\n  \"pink-300\": $pink-300,\r\n  \"pink-400\": $pink-400,\r\n  \"pink-500\": $pink-500,\r\n  \"pink-600\": $pink-600,\r\n  \"pink-700\": $pink-700,\r\n  \"pink-800\": $pink-800,\r\n  \"pink-900\": $pink-900\r\n);\r\n\r\n$reds: (\r\n  \"red-100\": $red-100,\r\n  \"red-200\": $red-200,\r\n  \"red-300\": $red-300,\r\n  \"red-400\": $red-400,\r\n  \"red-500\": $red-500,\r\n  \"red-600\": $red-600,\r\n  \"red-700\": $red-700,\r\n  \"red-800\": $red-800,\r\n  \"red-900\": $red-900\r\n);\r\n\r\n$oranges: (\r\n  \"orange-100\": $orange-100,\r\n  \"orange-200\": $orange-200,\r\n  \"orange-300\": $orange-300,\r\n  \"orange-400\": $orange-400,\r\n  \"orange-500\": $orange-500,\r\n  \"orange-600\": $orange-600,\r\n  \"orange-700\": $orange-700,\r\n  \"orange-800\": $orange-800,\r\n  \"orange-900\": $orange-900\r\n);\r\n\r\n$yellows: (\r\n  \"yellow-100\": $yellow-100,\r\n  \"yellow-200\": $yellow-200,\r\n  \"yellow-300\": $yellow-300,\r\n  \"yellow-400\": $yellow-400,\r\n  \"yellow-500\": $yellow-500,\r\n  \"yellow-600\": $yellow-600,\r\n  \"yellow-700\": $yellow-700,\r\n  \"yellow-800\": $yellow-800,\r\n  \"yellow-900\": $yellow-900\r\n);\r\n\r\n$greens: (\r\n  \"green-100\": $green-100,\r\n  \"green-200\": $green-200,\r\n  \"green-300\": $green-300,\r\n  \"green-400\": $green-400,\r\n  \"green-500\": $green-500,\r\n  \"green-600\": $green-600,\r\n  \"green-700\": $green-700,\r\n  \"green-800\": $green-800,\r\n  \"green-900\": $green-900\r\n);\r\n\r\n$teals: (\r\n  \"teal-100\": $teal-100,\r\n  \"teal-200\": $teal-200,\r\n  \"teal-300\": $teal-300,\r\n  \"teal-400\": $teal-400,\r\n  \"teal-500\": $teal-500,\r\n  \"teal-600\": $teal-600,\r\n  \"teal-700\": $teal-700,\r\n  \"teal-800\": $teal-800,\r\n  \"teal-900\": $teal-900\r\n);\r\n\r\n$cyans: (\r\n  \"cyan-100\": $cyan-100,\r\n  \"cyan-200\": $cyan-200,\r\n  \"cyan-300\": $cyan-300,\r\n  \"cyan-400\": $cyan-400,\r\n  \"cyan-500\": $cyan-500,\r\n  \"cyan-600\": $cyan-600,\r\n  \"cyan-700\": $cyan-700,\r\n  \"cyan-800\": $cyan-800,\r\n  \"cyan-900\": $cyan-900\r\n);\r\n// fusv-enable\r\n\r\n// Characters which are escaped by the escape-svg function\r\n$escaped-characters: (\r\n  (\"<\", \"%3c\"),\r\n  (\">\", \"%3e\"),\r\n  (\"#\", \"%23\"),\r\n  (\"(\", \"%28\"),\r\n  (\")\", \"%29\"),\r\n);\r\n\r\n// Options\r\n//\r\n// Quickly modify global styling by enabling or disabling optional features.\r\n\r\n$enable-caret:                false ;\r\n$enable-rounded:              true;\r\n$enable-shadows:              false;\r\n$enable-gradients:            false;\r\n$enable-transitions:          true;\r\n$enable-reduced-motion:       true;\r\n$enable-smooth-scroll:        true;\r\n$enable-grid-classes:         true;\r\n$enable-cssgrid:              false;\r\n$enable-button-pointers:      true;\r\n$enable-rfs:                  true;\r\n$enable-validation-icons:     true;\r\n$enable-negative-margins:     false;\r\n$enable-deprecation-messages: true;\r\n$enable-important-utilities:  true;\r\n\r\n// Prefix for :root CSS variables\r\n\r\n$variable-prefix:             bs-;\r\n\r\n// Gradient\r\n//\r\n// The gradient which is added to components if `$enable-gradients` is `true`\r\n// This gradient is also added to elements with `.bg-gradient`\r\n// scss-docs-start variable-gradient\r\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0));\r\n// scss-docs-end variable-gradient\r\n\r\n// Spacing\r\n//\r\n// Control the default styling of most Bootstrap elements by modifying these\r\n// variables. Mostly focused on spacing.\r\n// You can add more entries to the $spacers map, should you need more variation.\r\n\r\n// scss-docs-start spacer-variables-maps\r\n$spacer: 1rem;\r\n$spacers: (\r\n  0: 0,\r\n  1: $spacer / 4,\r\n  2: $spacer / 2,\r\n  3: $spacer,\r\n  4: $spacer * 1.5,\r\n  5: $spacer * 3,\r\n);\r\n\r\n$negative-spacers: if($enable-negative-margins, negativify-map($spacers), null);\r\n// scss-docs-end spacer-variables-maps\r\n\r\n// Position\r\n//\r\n// Define the edge positioning anchors of the position utilities.\r\n\r\n// scss-docs-start position-map\r\n$position-values: (\r\n  0: 0,\r\n  50: 50%,\r\n  100: 100%\r\n);\r\n// scss-docs-end position-map\r\n\r\n// Body\r\n//\r\n// Settings for the `<body>` element.\r\n\r\n$body-bg:                   #f5f6f8;\r\n$body-color:                $gray-700;\r\n$body-text-align:           null;\r\n\r\n// Utilities maps\r\n//\r\n// Extends the default `$theme-colors` maps to help create our utilities.\r\n\r\n// Come v6, we'll de-dupe these variables. Until then, for backward compatibility, we keep them to reassign.\r\n// scss-docs-start utilities-colors\r\n$utilities-colors: $theme-colors-rgb;\r\n// scss-docs-end utilities-colors\r\n\r\n// scss-docs-start utilities-text-colors\r\n$utilities-text: map-merge(\r\n  $utilities-colors,\r\n  (\r\n    \"black\": to-rgb($black),\r\n    \"white\": to-rgb($white),\r\n    \"body\": to-rgb($body-color)\r\n  )\r\n);\r\n$utilities-text-colors: map-loop($utilities-text, rgba-css-var, \"$key\", \"text\");\r\n// scss-docs-end utilities-text-colors\r\n\r\n// scss-docs-start utilities-bg-colors\r\n$utilities-bg: map-merge(\r\n  $utilities-colors,\r\n  (\r\n    \"black\": to-rgb($black),\r\n    \"white\": to-rgb($white),\r\n    \"body\": to-rgb($body-bg)\r\n  )\r\n);\r\n$utilities-bg-colors: map-loop($utilities-bg, rgba-css-var, \"$key\", \"bg\");\r\n// scss-docs-end utilities-bg-colors\r\n\r\n// Links\r\n//\r\n// Style anchor elements.\r\n\r\n$link-color:                              $primary;\r\n$link-decoration:                         none;\r\n$link-shade-percentage:                   20%;\r\n$link-hover-color:                        darken($link-color, 15%);\r\n$link-hover-decoration:                   null;\r\n\r\n$stretched-link-pseudo-element:           after;\r\n$stretched-link-z-index:                  1;\r\n\r\n// Paragraphs\r\n//\r\n// Style p element.\r\n\r\n$paragraph-margin-bottom:   1rem;\r\n\r\n\r\n// Grid breakpoints\r\n//\r\n// Define the minimum dimensions at which your layout will change,\r\n// adapting to different screen sizes, for use in media queries.\r\n\r\n// scss-docs-start grid-breakpoints\r\n$grid-breakpoints: (\r\n  xs: 0,\r\n  sm: 576px,\r\n  md: 768px,\r\n  lg: 992px,\r\n  xl: 1200px,\r\n  xxl: 1400px\r\n);\r\n// scss-docs-end grid-breakpoints\r\n\r\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\r\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\r\n\r\n\r\n// Grid containers\r\n//\r\n// Define the maximum width of `.container` for different screen sizes.\r\n\r\n// scss-docs-start container-max-widths\r\n$container-max-widths: (\r\n  sm: 540px,\r\n  md: 720px,\r\n  lg: 960px,\r\n  xl: 1140px,\r\n  xxl: 1320px\r\n);\r\n// scss-docs-end container-max-widths\r\n\r\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\r\n\r\n\r\n// Grid columns\r\n//\r\n// Set the number of columns and specify the width of the gutters.\r\n\r\n$grid-columns:                12;\r\n$grid-gutter-width:           1.25rem;\r\n$grid-row-columns:            6;\r\n\r\n$gutters: $spacers;\r\n\r\n// Container padding\r\n\r\n$container-padding-x: $grid-gutter-width / 2;\r\n\r\n\r\n// Components\r\n//\r\n// Define common padding and border radius sizes and more.\r\n\r\n// scss-docs-start border-variables\r\n$border-width:                1px;\r\n$border-widths: (\r\n  0: 0,\r\n  1: 1px,\r\n  2: 2px,\r\n  3: 3px,\r\n  4: 4px,\r\n  5: 5px\r\n);\r\n\r\n$border-color:                $gray-200;\r\n// scss-docs-end border-variables\r\n\r\n// scss-docs-start border-radius-variables\r\n$border-radius:               .25rem;\r\n$border-radius-sm:            .2rem;\r\n$border-radius-lg:            .4rem;\r\n$border-radius-pill:          50rem;\r\n// scss-docs-end border-radius-variables\r\n// scss-docs-start box-shadow-variables\r\n$box-shadow:                  0 2px 4px rgba(15,34,58,.12);\r\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075);\r\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175);\r\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075);\r\n// scss-docs-end box-shadow-variables\r\n\r\n$component-active-color:      $white;\r\n$component-active-bg:         $primary;\r\n\r\n// scss-docs-start caret-variables\r\n$caret-width:                 .3em;\r\n$caret-vertical-align:        $caret-width * .85;\r\n$caret-spacing:               $caret-width * .85;\r\n// scss-docs-end caret-variables\r\n\r\n$transition-base:             all .2s ease-in-out;\r\n$transition-fade:             opacity .15s linear;\r\n// scss-docs-start collapse-transition\r\n$transition-collapse:         height .35s ease;\r\n$transition-collapse-width:   width .35s ease;\r\n// scss-docs-end collapse-transition\r\n\r\n// stylelint-disable function-disallowed-list\r\n// scss-docs-start aspect-ratios\r\n$aspect-ratios: (\r\n  \"1x1\": 100%,\r\n  \"4x3\": calc(3 / 4 * 100%),\r\n  \"16x9\": calc(9 / 16 * 100%),\r\n  \"21x9\": calc(9 / 21 * 100%)\r\n);\r\n// scss-docs-end aspect-ratios\r\n// stylelint-enable function-disallowed-list\r\n\r\n// Typography\r\n//\r\n// Font, line-height, and color for body text, headings, and more.\r\n\r\n// scss-docs-start font-variables\r\n// stylelint-disable value-keyword-case\r\n$font-family-sans-serif:      'IBM Plex Sans', sans-serif;\r\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\r\n$font-family-base:          $font-family-sans-serif;\r\n// stylelint-enable value-keyword-case\r\n$font-family-code:            var(--#{$variable-prefix}font-monospace);\r\n\r\n// $font-size-root effects the value of `rem`, which is used for as well font sizes, paddings and margins\r\n// $font-size-base effects the font size of the body text\r\n$font-size-root:              null;\r\n$font-size-base:              0.9rem;\r\n$font-size-lg:                $font-size-base * 1.25;\r\n$font-size-sm:                $font-size-base * .875;\r\n\r\n$font-weight-lighter:         lighter;\r\n$font-weight-light:           300;\r\n$font-weight-normal:          400;\r\n$font-weight-bold:            600;\r\n$font-weight-bolder:          bolder;\r\n\r\n$font-weight-base:            $font-weight-normal;\r\n\r\n$line-height-base:            1.5;\r\n$line-height-sm:              1.25;\r\n$line-height-lg:              2;\r\n\r\n$h1-font-size:                $font-size-base * 2.5;\r\n$h2-font-size:                $font-size-base * 2;\r\n$h3-font-size:                $font-size-base * 1.75;\r\n$h4-font-size:                $font-size-base * 1.5;\r\n$h5-font-size:                $font-size-base * 1.25;\r\n$h6-font-size:                $font-size-base;\r\n// scss-docs-end font-variables\r\n\r\n// scss-docs-start font-sizes\r\n$font-sizes: (\r\n  1: $h1-font-size,\r\n  2: $h2-font-size,\r\n  3: $h3-font-size,\r\n  4: $h4-font-size,\r\n  5: $h5-font-size,\r\n  6: $h6-font-size\r\n);\r\n// scss-docs-end font-sizes\r\n\r\n// scss-docs-start headings-variables\r\n$headings-margin-bottom:      $spacer / 2;\r\n$headings-font-family:        null;\r\n$headings-font-style:         null;\r\n$headings-font-weight:        500;\r\n$headings-line-height:        1.2;\r\n$headings-color:              null;\r\n// scss-docs-end headings-variables\r\n\r\n// scss-docs-start display-headings\r\n$display-font-sizes: (\r\n  1: 5rem,\r\n  2: 4.5rem,\r\n  3: 4rem,\r\n  4: 3.5rem,\r\n  5: 3rem,\r\n  6: 2.5rem\r\n);\r\n\r\n$display-font-weight: 300;\r\n$display-line-height: $headings-line-height;\r\n// scss-docs-end display-headings\r\n\r\n// scss-docs-start type-variables\r\n$lead-font-size:              $font-size-base * 1.25;\r\n$lead-font-weight:            300;\r\n\r\n$small-font-size:             87.5%;\r\n\r\n$sub-sup-font-size:           .75em;\r\n\r\n$text-muted:                  $gray-600;\r\n\r\n$initialism-font-size:        $small-font-size;\r\n\r\n$blockquote-margin-y:         $spacer;\r\n$blockquote-font-size:        $font-size-base * 1.25;\r\n$blockquote-footer-color:     $gray-600;\r\n$blockquote-footer-font-size: $small-font-size;\r\n\r\n$hr-margin-y:                 $spacer;\r\n$hr-color:                    rgba($black, .1);\r\n$hr-height:                   $border-width;\r\n$hr-opacity:                  .5;\r\n\r\n$legend-margin-bottom:        .5rem;\r\n$legend-font-size:            1.5rem;\r\n$legend-font-weight:          null;\r\n\r\n$mark-padding:                .2em;\r\n\r\n$dt-font-weight:              $font-weight-bold;\r\n\r\n$nested-kbd-font-weight:      $font-weight-bold;\r\n\r\n$list-inline-padding:         .5rem;\r\n\r\n$mark-bg:                     #fcf8e3;\r\n// scss-docs-end type-variables\r\n\r\n\r\n// Tables\r\n//\r\n// Customizes the `.table` component with basic values, each used across all table variations.\r\n\r\n// scss-docs-start table-variables\r\n\r\n$table-cell-padding-y:        .75rem;\r\n$table-cell-padding-x:        .75rem;\r\n$table-cell-padding-y-sm:     .25rem;\r\n$table-cell-padding-x-sm:     .25rem;\r\n\r\n$table-cell-vertical-align:   top;\r\n\r\n$table-color:                 $body-color;\r\n$table-bg:                    null;\r\n$table-accent-bg:             transparent;\r\n\r\n$table-th-font-weight:        null;\r\n\r\n$table-striped-color:         $table-color;\r\n$table-striped-bg-factor:     .05;\r\n$table-striped-bg:            $gray-100;\r\n$table-dark-border-color:     tint-color($gray-800, 7.5%);\r\n\r\n$table-active-color:          $table-color;\r\n$table-active-bg-factor:      .1;\r\n$table-active-bg:             rgba($black, $table-active-bg-factor);\r\n\r\n$table-hover-color:           $table-color;\r\n$table-hover-bg-factor:       .075;\r\n$table-hover-bg:              $gray-100;\r\n\r\n$table-border-factor:         .1;\r\n$table-border-width:          $border-width;\r\n$table-border-color:          $border-color;\r\n\r\n\r\n$table-striped-order:         odd;\r\n\r\n$table-group-separator-color:   $border-color;\r\n\r\n$table-caption-color:         $text-muted;\r\n\r\n$table-bg-scale:              -80%;\r\n// scss-docs-end table-variables\r\n\r\n// scss-docs-start table-loop\r\n$table-variants: (\r\n  \"primary\":    shift-color($primary, $table-bg-scale),\r\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\r\n  \"success\":    shift-color($success, $table-bg-scale),\r\n  \"info\":       shift-color($info, $table-bg-scale),\r\n  \"warning\":    shift-color($warning, $table-bg-scale),\r\n  \"danger\":     shift-color($danger, $table-bg-scale),\r\n  \"light\":      $light,\r\n  \"dark\":       $dark,\r\n);\r\n// scss-docs-end table-loop\r\n\r\n\r\n// Buttons + Forms\r\n//\r\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\r\n\r\n// scss-docs-start input-btn-variables\r\n$input-btn-padding-y:         .47rem;\r\n$input-btn-padding-x:         .75rem;\r\n$input-btn-font-family:       null;\r\n$input-btn-font-size:         $font-size-base;\r\n$input-btn-line-height:       $line-height-base;\r\n\r\n$input-btn-focus-width:         .15rem;\r\n$input-btn-focus-color-opacity: .25;\r\n$input-btn-focus-color:         rgba($component-active-bg, $input-btn-focus-color-opacity);\r\n$input-btn-focus-blur:          0;\r\n$input-btn-focus-box-shadow:    0 0 0 $input-btn-focus-width $input-btn-focus-color;\r\n\r\n$input-btn-padding-y-sm:      .25rem;\r\n$input-btn-padding-x-sm:      .5rem;\r\n$input-btn-font-size-sm:      $font-size-sm;\r\n\r\n$input-btn-padding-y-lg:      .5rem;\r\n$input-btn-padding-x-lg:      1rem;\r\n$input-btn-font-size-lg:      $font-size-lg;\r\n\r\n$input-btn-border-width:      $border-width;\r\n// scss-docs-end input-btn-variables\r\n\r\n\r\n// Buttons\r\n//\r\n// For each of Bootstrap's buttons, define text, background, and border color.\r\n\r\n// scss-docs-start btn-variables\r\n$btn-padding-y:               $input-btn-padding-y;\r\n$btn-padding-x:               $input-btn-padding-x;\r\n$btn-font-family:             $input-btn-font-family;\r\n$btn-font-size:               $input-btn-font-size;\r\n$btn-line-height:             $input-btn-line-height;\r\n$btn-white-space:             null; // Set to `nowrap` to prevent text wrapping\r\n\r\n$btn-padding-y-sm:            $input-btn-padding-y-sm;\r\n$btn-padding-x-sm:            $input-btn-padding-x-sm;\r\n$btn-font-size-sm:            $input-btn-font-size-sm;\r\n\r\n$btn-padding-y-lg:            $input-btn-padding-y-lg;\r\n$btn-padding-x-lg:            $input-btn-padding-x-lg;\r\n$btn-font-size-lg:            $input-btn-font-size-lg;\r\n\r\n$btn-border-width:            $input-btn-border-width;\r\n\r\n$btn-font-weight:             $font-weight-normal;\r\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075);\r\n$btn-focus-width:             $input-btn-focus-width;\r\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow;\r\n$btn-disabled-opacity:        .65;\r\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125);\r\n\r\n$btn-link-color:              $link-color;\r\n$btn-link-hover-color:        $link-hover-color;\r\n$btn-link-disabled-color:     $gray-600;\r\n\r\n// Allows for customizing button radius independently from global border radius\r\n$btn-border-radius:           $border-radius;\r\n$btn-border-radius-sm:        $border-radius-sm;\r\n$btn-border-radius-lg:        $border-radius-lg;\r\n\r\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\r\n\r\n$btn-hover-bg-shade-amount:       15%;\r\n$btn-hover-bg-tint-amount:        15%;\r\n$btn-hover-border-shade-amount:   20%;\r\n$btn-hover-border-tint-amount:    10%;\r\n$btn-active-bg-shade-amount:      20%;\r\n$btn-active-bg-tint-amount:       20%;\r\n$btn-active-border-shade-amount:  25%;\r\n$btn-active-border-tint-amount:   10%;\r\n// scss-docs-end btn-variables\r\n\r\n// Forms\r\n\r\n// scss-docs-start form-text-variables\r\n$form-text-margin-top:                  .25rem;\r\n$form-text-font-size:                   $small-font-size;\r\n$form-text-font-style:                  null;\r\n$form-text-font-weight:                 null;\r\n$form-text-color:                       $text-muted;\r\n// scss-docs-end form-text-variables\r\n\r\n// scss-docs-start form-label-variables\r\n$form-label-margin-bottom:              .5rem;\r\n$form-label-font-size:                  null;\r\n$form-label-font-style:                 null;\r\n$form-label-font-weight:                null;\r\n$form-label-color:                      null;\r\n// scss-docs-end form-label-variables\r\n\r\n// scss-docs-start form-input-variables\r\n$input-padding-y:                       $input-btn-padding-y;\r\n$input-padding-x:                       $input-btn-padding-x;\r\n$input-font-family:                     $input-btn-font-family;\r\n$input-font-size:                       $input-btn-font-size;\r\n$input-font-weight:                     $font-weight-base;\r\n$input-line-height:                     $input-btn-line-height;\r\n\r\n$input-padding-y-sm:                    $input-btn-padding-y-sm;\r\n$input-padding-x-sm:                    $input-btn-padding-x-sm;\r\n$input-font-size-sm:                    $input-btn-font-size-sm;\r\n\r\n$input-padding-y-lg:                    $input-btn-padding-y-lg;\r\n$input-padding-x-lg:                    $input-btn-padding-x-lg;\r\n$input-font-size-lg:                    $input-btn-font-size-lg;\r\n\r\n$input-bg:                              $white;\r\n$input-disabled-bg:                     $gray-200;\r\n$input-disabled-border-color:           null;\r\n\r\n$input-color:                           $body-color;\r\n$input-border-color:                    $gray-400;\r\n$input-border-width:                    $input-btn-border-width;\r\n$input-box-shadow:                      $box-shadow-inset;\r\n\r\n$input-border-radius:                   $border-radius;\r\n$input-border-radius-sm:                $border-radius-sm;\r\n$input-border-radius-lg:                $border-radius-lg;\r\n\r\n$input-focus-bg:                        $input-bg;\r\n$input-focus-border-color:              tint-color($input-border-color,10%);\r\n$input-focus-color:                     $input-color;\r\n$input-focus-width:                     $input-btn-focus-width;\r\n$input-focus-box-shadow:                none;\r\n\r\n$input-placeholder-color:               $gray-600;\r\n$input-plaintext-color:                 $body-color;\r\n\r\n$input-height-border:                   $input-border-width * 2;\r\n\r\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2);\r\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y);\r\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y / 2);\r\n\r\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false));\r\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false));\r\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false));\r\n\r\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out;\r\n$form-color-width:                      3rem;\r\n// scss-docs-end form-input-variables\r\n\r\n// scss-docs-start form-check-variables\r\n$form-check-input-width:                  1em;\r\n$form-check-min-height:                   $font-size-base * $line-height-base;\r\n$form-check-padding-start:                $form-check-input-width + .5em;\r\n$form-check-margin-bottom:                .125rem;\r\n$form-check-label-color:                  null;\r\n$form-check-label-cursor:                 null;\r\n$form-check-transition:                   background-color .15s ease-in-out, background-position .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\r\n\r\n$form-check-input-active-filter:          brightness(90%);\r\n\r\n$form-check-input-bg:                     $input-bg;\r\n$form-check-input-border:                 1px solid $gray-500;\r\n$form-check-input-border-radius:          .25em;\r\n$form-check-radio-border-radius:          50%;\r\n$form-check-input-focus-border:           $input-focus-border-color;\r\n$form-check-input-focus-box-shadow:       none;\r\n\r\n$form-check-input-checked-color:          $component-active-color;\r\n$form-check-input-checked-bg-color:       $component-active-bg;\r\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color;\r\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/></svg>\");\r\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\");\r\n\r\n$form-check-input-indeterminate-color:          $component-active-color;\r\n$form-check-input-indeterminate-bg-color:       $component-active-bg;\r\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color;\r\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\");\r\n\r\n$form-check-input-disabled-opacity:        .5;\r\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity;\r\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity;\r\n\r\n$form-check-inline-margin-end:    1rem;\r\n// scss-docs-end form-check-variables\r\n// scss-docs-start form-switch-variables\r\n$form-switch-color:               rgba(0, 0, 0, .25);\r\n$form-switch-width:               2em;\r\n$form-switch-padding-start:       $form-switch-width + .5em;\r\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\");\r\n$form-switch-border-radius:       $form-switch-width;\r\n$form-switch-transition:          background-position .15s ease-in-out;\r\n\r\n$form-switch-focus-color:         $input-focus-border-color;\r\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\");\r\n\r\n$form-switch-checked-color:       $component-active-color;\r\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\");\r\n$form-switch-checked-bg-position: right center;\r\n// scss-docs-end form-switch-variables\r\n$form-check-inline-margin-end:    1rem;\r\n// scss-docs-start input-group-variables\r\n$input-group-addon-padding-y:           $input-padding-y;\r\n$input-group-addon-padding-x:           $input-padding-x;\r\n$input-group-addon-font-weight:         $input-font-weight;\r\n$input-group-addon-color:               $input-color;\r\n$input-group-addon-bg:                  $gray-200;\r\n$input-group-addon-border-color:        $input-border-color;\r\n// scss-docs-end input-group-variables\r\n\r\n// scss-docs-start form-select-variables\r\n$form-select-padding-y:             $input-padding-y;\r\n$form-select-padding-x:             $input-padding-x;\r\n$form-select-font-family:           $input-font-family;\r\n$form-select-font-size:             $input-font-size;\r\n$form-select-indicator-padding:     1.75rem; // Extra padding to account for the presence of the background-image based indicator\r\n$form-select-font-weight:           $input-font-weight;\r\n$form-select-line-height:           $input-line-height;\r\n$form-select-color:                 $input-color;\r\n$form-select-disabled-color:        $gray-600;\r\n$form-select-bg:                    $input-bg;\r\n$form-select-disabled-bg:           $gray-200;\r\n$form-select-disabled-border-color: $input-disabled-border-color;\r\n$form-select-bg-position:           right $form-select-padding-x center;\r\n$form-select-bg-size:               16px 12px; // In pixels because image dimensions\r\n$form-select-indicator-color:       $gray-800;\r\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/></svg>\");\r\n\r\n$form-select-feedback-icon-padding-end: add(1em * .75, (2 * $form-select-padding-y * .75) + $form-select-padding-x + $form-select-indicator-padding);\r\n$form-select-feedback-icon-position:    center right ($form-select-padding-x + $form-select-indicator-padding);\r\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half;\r\n\r\n$form-select-border-width:        $input-border-width;\r\n$form-select-border-color:        $input-border-color;\r\n$form-select-border-radius:       $border-radius;\r\n$form-select-box-shadow:          $box-shadow-inset;\r\n\r\n$form-select-focus-border-color:  $input-focus-border-color;\r\n$form-select-focus-width:         $input-focus-width;\r\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color;\r\n\r\n$form-select-padding-y-sm:        $input-padding-y-sm;\r\n$form-select-padding-x-sm:        $input-padding-x-sm;\r\n$form-select-font-size-sm:        $input-font-size-sm;\r\n\r\n$form-select-padding-y-lg:        $input-padding-y-lg;\r\n$form-select-padding-x-lg:        $input-padding-x-lg;\r\n$form-select-font-size-lg:        $input-font-size-lg;\r\n$form-select-transition:          $input-transition;\r\n// scss-docs-end form-select-variables\r\n\r\n// scss-docs-start form-range-variables\r\n$form-range-track-width:          100%;\r\n$form-range-track-height:         .5rem;\r\n$form-range-track-cursor:         pointer;\r\n$form-range-track-bg:             $gray-300;\r\n$form-range-track-border-radius:  1rem;\r\n$form-range-track-box-shadow:     $box-shadow-inset;\r\n\r\n$form-range-thumb-width:                   1rem;\r\n$form-range-thumb-height:                  $form-range-thumb-width;\r\n$form-range-thumb-bg:                      $component-active-bg;\r\n$form-range-thumb-border:                  0;\r\n$form-range-thumb-border-radius:           1rem;\r\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1);\r\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow;\r\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width; // For focus box shadow issue in Edge\r\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%);\r\n$form-range-thumb-disabled-bg:             $gray-500;\r\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\r\n// scss-docs-end form-range-variables\r\n\r\n// scss-docs-start form-file-variables\r\n$form-file-button-color:          $input-color;\r\n$form-file-button-bg:             $input-group-addon-bg;\r\n$form-file-button-hover-bg:       shade-color($form-file-button-bg, 5%);\r\n// scss-docs-end form-file-variables\r\n\r\n// scss-docs-start form-floating-variables\r\n$form-floating-height:            add(3.5rem, $input-height-border);\r\n$form-floating-line-height:       1.25;\r\n$form-floating-padding-x:         $input-padding-x;\r\n$form-floating-padding-y:         1rem;\r\n$form-floating-input-padding-t:   1.625rem;\r\n$form-floating-input-padding-b:   .625rem;\r\n$form-floating-label-opacity:     .65;\r\n$form-floating-label-transform:   scale(.85) translateY(-.5rem) translateX(.15rem);\r\n$form-floating-transition:        opacity .1s ease-in-out, transform .1s ease-in-out;\r\n// scss-docs-end form-floating-variables\r\n\r\n// Form validation\r\n\r\n// scss-docs-start form-feedback-variables\r\n$form-feedback-margin-top:          $form-text-margin-top;\r\n$form-feedback-font-size:           $form-text-font-size;\r\n$form-feedback-font-style:          $form-text-font-style;\r\n$form-feedback-valid-color:         $success;\r\n$form-feedback-invalid-color:       $danger;\r\n\r\n$form-feedback-icon-valid-color:    $form-feedback-valid-color;\r\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\");\r\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color;\r\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\");\r\n// scss-docs-end form-feedback-variables\r\n\r\n// scss-docs-start form-validation-states\r\n$form-validation-states: (\r\n  \"valid\": (\r\n    \"color\": $form-feedback-valid-color,\r\n    \"icon\": $form-feedback-icon-valid\r\n  ),\r\n  \"invalid\": (\r\n    \"color\": $form-feedback-invalid-color,\r\n    \"icon\": $form-feedback-icon-invalid\r\n  )\r\n);\r\n// scss-docs-end form-validation-states\r\n\r\n// Z-index master list\r\n//\r\n// Warning: Avoid customizing these values. They're used for a bird's eye view\r\n// of components dependent on the z-axis and are designed to all work together.\r\n\r\n// scss-docs-start zindex-stack\r\n$zindex-dropdown:                   1000;\r\n$zindex-sticky:                     1020;\r\n$zindex-fixed:                      1030;\r\n$zindex-offcanvas-backdrop:         1040;\r\n$zindex-offcanvas:                  1045;\r\n$zindex-modal-backdrop:             1050;\r\n$zindex-modal:                      1055;\r\n$zindex-popover:                    999;\r\n$zindex-tooltip:                    999;\r\n// scss-docs-end zindex-stack\r\n\r\n\r\n// Navs\r\n\r\n// scss-docs-start nav-variables\r\n$nav-link-padding-y:                .5rem;\r\n$nav-link-padding-x:                1rem;\r\n$nav-link-font-size:                null;\r\n$nav-link-font-weight:              null;\r\n$nav-link-color:                    null;\r\n$nav-link-hover-color:              null;\r\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out;\r\n$nav-link-disabled-color:           $gray-600;\r\n\r\n$nav-tabs-border-color:             $gray-400;\r\n$nav-tabs-border-width:             $border-width;\r\n$nav-tabs-border-radius:            $border-radius;\r\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color;\r\n$nav-tabs-link-active-color:        $gray-700;\r\n$nav-tabs-link-active-bg:           $card-bg;\r\n$nav-tabs-link-active-border-color: $gray-400 $gray-400 $nav-tabs-link-active-bg;\r\n\r\n$nav-pills-border-radius:           $border-radius;\r\n$nav-pills-link-active-color:       $component-active-color;\r\n$nav-pills-link-active-bg:          $component-active-bg;\r\n// scss-docs-end nav-variables\r\n\r\n\r\n// Navbar\r\n\r\n// scss-docs-start navbar-variables\r\n$navbar-padding-y:                  $spacer / 2;\r\n$navbar-padding-x:                  null;\r\n\r\n$navbar-nav-link-padding-x:         .5rem;\r\n\r\n$navbar-brand-font-size:            $font-size-lg;\r\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\r\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2;\r\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base;\r\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) / 2;\r\n$navbar-brand-margin-end:           1rem;\r\n\r\n$navbar-toggler-padding-y:          .25rem;\r\n$navbar-toggler-padding-x:          .75rem;\r\n$navbar-toggler-font-size:          $font-size-lg;\r\n$navbar-toggler-border-radius:      $btn-border-radius;\r\n$navbar-toggler-focus-width:        $btn-focus-width;\r\n$navbar-toggler-transition:         box-shadow .15s ease-in-out;\r\n// scss-docs-end navbar-variables\r\n\r\n// scss-docs-start navbar-theme-variables\r\n$navbar-dark-color:                 rgba($white, .55);\r\n$navbar-dark-hover-color:           rgba($white, .75);\r\n$navbar-dark-active-color:          $white;\r\n$navbar-dark-disabled-color:        rgba($white, .25);\r\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\r\n$navbar-dark-toggler-border-color:  rgba($white, .1);\r\n\r\n$navbar-light-color:                rgba($black, .55);\r\n$navbar-light-hover-color:          rgba($black, .7);\r\n$navbar-light-active-color:         rgba($black, .9);\r\n$navbar-light-disabled-color:       rgba($black, .3);\r\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\r\n$navbar-light-toggler-border-color: rgba($black, .1);\r\n\r\n$navbar-light-brand-color:                $navbar-light-active-color;\r\n$navbar-light-brand-hover-color:          $navbar-light-active-color;\r\n$navbar-dark-brand-color:                 $navbar-dark-active-color;\r\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color;\r\n// scss-docs-end navbar-theme-variables\r\n\r\n\r\n// Dropdowns\r\n//\r\n// Dropdown menu container and contents.\r\n\r\n// scss-docs-start dropdown-variables\r\n$dropdown-min-width:                10rem;\r\n$dropdown-padding-x:                0;\r\n$dropdown-padding-y:                .5rem;\r\n$dropdown-spacer:                   .125rem;\r\n$dropdown-font-size:                $font-size-base ;\r\n$dropdown-color:                    $body-color;\r\n$dropdown-bg:                       $white;\r\n$dropdown-border-color:             rgba($black, .15);\r\n$dropdown-border-radius:            $border-radius;\r\n$dropdown-border-width:             0;\r\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width);\r\n$dropdown-divider-bg:               $dropdown-border-color;\r\n$dropdown-divider-margin-y:         $spacer / 2;\r\n$dropdown-box-shadow:               $box-shadow;\r\n\r\n$dropdown-link-color:               $gray-900;\r\n$dropdown-link-hover-color:         tint-color($gray-900, 5%);\r\n$dropdown-link-hover-bg:            $gray-100;\r\n\r\n$dropdown-link-active-color:        tint-color($gray-900, 5%);\r\n$dropdown-link-active-bg:           $gray-100;\r\n\r\n$dropdown-link-disabled-color:      $gray-600;\r\n\r\n$dropdown-item-padding-y:           .35rem;\r\n$dropdown-item-padding-x:           1.5rem;\r\n\r\n$dropdown-header-color:             $gray-600;\r\n$dropdown-header-padding:           $dropdown-padding-y $dropdown-item-padding-x;\r\n// scss-docs-end dropdown-variables\r\n\r\n// scss-docs-start dropdown-dark-variables\r\n$dropdown-dark-color:               $gray-300;\r\n$dropdown-dark-bg:                  $gray-800;\r\n$dropdown-dark-border-color:        $dropdown-border-color;\r\n$dropdown-dark-divider-bg:          $dropdown-divider-bg;\r\n$dropdown-dark-box-shadow:          null;\r\n$dropdown-dark-link-color:          $dropdown-dark-color;\r\n$dropdown-dark-link-hover-color:    $white;\r\n$dropdown-dark-link-hover-bg:       rgba($white, .15);\r\n$dropdown-dark-link-active-color:   $dropdown-link-active-color;\r\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg;\r\n$dropdown-dark-link-disabled-color: $gray-500;\r\n$dropdown-dark-header-color:        $gray-500;\r\n// scss-docs-end dropdown-dark-variables\r\n\r\n\r\n// Pagination\r\n\r\n// scss-docs-start pagination-variables\r\n$pagination-padding-y:              .375rem;\r\n$pagination-padding-x:              .75rem;\r\n$pagination-padding-y-sm:           .25rem;\r\n$pagination-padding-x-sm:           .5rem;\r\n$pagination-padding-y-lg:           .75rem;\r\n$pagination-padding-x-lg:           1.5rem;\r\n\r\n$pagination-color:                  $gray-600;\r\n$pagination-bg:                     $white;\r\n$pagination-border-width:           $border-width;\r\n$pagination-border-radius:          $border-radius;\r\n$pagination-margin-start:           -$pagination-border-width;\r\n$pagination-border-color:           $gray-400;\r\n\r\n$pagination-focus-color:            $link-hover-color;\r\n$pagination-focus-bg:               $gray-200;\r\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow;\r\n$pagination-focus-outline:          0;\r\n\r\n$pagination-hover-color:            $link-hover-color;\r\n$pagination-hover-bg:               $gray-200;\r\n$pagination-hover-border-color:     $gray-400;\r\n\r\n$pagination-active-color:           $component-active-color;\r\n$pagination-active-bg:              $component-active-bg;\r\n$pagination-active-border-color:    $pagination-active-bg;\r\n\r\n$pagination-disabled-color:         $gray-400;\r\n$pagination-disabled-bg:            $white;\r\n$pagination-disabled-border-color:  $gray-400;\r\n\r\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\r\n\r\n$pagination-border-radius-sm:       $border-radius-sm;\r\n$pagination-border-radius-lg:       $border-radius-lg;\r\n// scss-docs-end pagination-variables\r\n\r\n\r\n// Placeholders\r\n\r\n// scss-docs-start placeholders\r\n$placeholder-opacity-max:           .5;\r\n$placeholder-opacity-min:           .2;\r\n// scss-docs-end placeholders\r\n\r\n// Cards\r\n\r\n// scss-docs-start card-variables\r\n$card-spacer-y:                     1.25rem;\r\n$card-spacer-x:                     1.25rem;\r\n$card-title-spacer-y:               $spacer / 2;\r\n$card-border-width:                 0;\r\n$card-box-shadow:                   null;\r\n$card-border-radius:                $border-radius;\r\n$card-border-color:                 $gray-300;\r\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width);\r\n$card-cap-padding-y:                .75rem;\r\n$card-cap-padding-x:                1.25rem;\r\n$card-cap-bg:                       rgba($black, .03);\r\n$card-cap-color:                    null;\r\n$card-height:                       null;\r\n$card-color:                        null;\r\n$card-bg:                           $white;\r\n\r\n$card-title-desc:                   $gray-600;\r\n\r\n$card-img-overlay-padding:          $spacer;\r\n\r\n$card-group-margin:                 $grid-gutter-width / 2;\r\n// scss-docs-end card-variables\r\n\r\n// Accordion\r\n\r\n// scss-docs-start accordion-variables\r\n$accordion-padding-y:                     1rem;\r\n$accordion-padding-x:                     1.25rem;\r\n$accordion-color:                         $body-color;\r\n$accordion-bg:                            transparent;\r\n$accordion-border-width:                  $border-width;\r\n$accordion-border-color:                  rgba($black, .125);\r\n$accordion-border-radius:                 $border-radius;\r\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width);\r\n\r\n$accordion-body-padding-y:                $accordion-padding-y;\r\n$accordion-body-padding-x:                $accordion-padding-x;\r\n\r\n$accordion-button-padding-y:              $accordion-padding-y;\r\n$accordion-button-padding-x:              $accordion-padding-x;\r\n$accordion-button-color:                  $accordion-color;\r\n$accordion-button-bg:                     $accordion-bg;\r\n$accordion-transition:                    $btn-transition, border-radius .15s ease;\r\n$accordion-button-active-bg:              tint-color($component-active-bg, 90%);\r\n$accordion-button-active-color:           shade-color($primary, 10%);\r\n\r\n$accordion-button-focus-border-color:     $input-focus-border-color;\r\n$accordion-button-focus-box-shadow:       none;\r\n\r\n$accordion-icon-width:                    16px;\r\n$accordion-icon-color:                    $accordion-color;\r\n$accordion-icon-active-color:             $accordion-button-active-color;\r\n$accordion-icon-transition:               transform .2s ease-in-out;\r\n$accordion-icon-transform:                rotate(180deg);\r\n\r\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\r\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\r\n// scss-docs-end accordion-variables\r\n\r\n// Tooltips\r\n\r\n// scss-docs-start tooltip-variables\r\n$tooltip-font-size:                 $font-size-sm;\r\n$tooltip-max-width:                 200px;\r\n$tooltip-color:                     $white;\r\n$tooltip-bg:                        $black;\r\n$tooltip-border-radius:             $border-radius;\r\n$tooltip-opacity:                   .9;\r\n$tooltip-padding-y:                 .4rem;\r\n$tooltip-padding-x:                 .7rem;\r\n$tooltip-margin:                     0;\r\n\r\n$tooltip-arrow-width:               .8rem;\r\n$tooltip-arrow-height:              .4rem;\r\n$tooltip-arrow-color:               $tooltip-bg;\r\n// scss-docs-end tooltip-variables\r\n\r\n// Form tooltips must come after regular tooltips\r\n// scss-docs-start tooltip-feedback-variables\r\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y;\r\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x;\r\n$form-feedback-tooltip-font-size:     $tooltip-font-size;\r\n$form-feedback-tooltip-line-height:   null;\r\n$form-feedback-tooltip-opacity:       $tooltip-opacity;\r\n$form-feedback-tooltip-border-radius: $tooltip-border-radius;\r\n// scss-docs-end tooltip-feedback-variables\r\n\r\n\r\n// Popovers\r\n\r\n// scss-docs-start popover-variables\r\n$popover-font-size:                 $font-size-sm;\r\n$popover-bg:                        $white;\r\n$popover-max-width:                 276px;\r\n$popover-border-width:              $border-width;\r\n$popover-border-color:              rgba($black, .1);\r\n$popover-border-radius:             $border-radius-lg;\r\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width);\r\n$popover-box-shadow:                $box-shadow;\r\n\r\n$popover-header-bg:                 shade-color($popover-bg, 6%);\r\n$popover-header-color:              $headings-color;\r\n$popover-header-padding-y:          .5rem;\r\n$popover-header-padding-x:          .75rem;\r\n\r\n$popover-body-color:                $body-color;\r\n$popover-body-padding-y:            $popover-header-padding-y;\r\n$popover-body-padding-x:            $popover-header-padding-x;\r\n\r\n$popover-arrow-width:               1rem;\r\n$popover-arrow-height:              .5rem;\r\n$popover-arrow-color:               $popover-bg;\r\n\r\n$popover-arrow-outer-color:         fade-in($popover-border-color, .05);\r\n// scss-docs-end popover-variables\r\n\r\n\r\n// Toasts\r\n\r\n// scss-docs-start toast-variables\r\n$toast-max-width:                   350px;\r\n$toast-padding-x:                   .75rem;\r\n$toast-padding-y:                   .5rem;\r\n$toast-font-size:                   .875rem;\r\n$toast-color:                       null;\r\n$toast-background-color:            rgba($white, .85);\r\n$toast-border-width:                1px;\r\n$toast-border-color:                rgba(0, 0, 0, .1);\r\n$toast-border-radius:               $border-radius;\r\n$toast-box-shadow:                  $box-shadow;\r\n$toast-spacing:                     $container-padding-x;\r\n\r\n$toast-header-color:                $gray-600;\r\n$toast-header-background-color:     rgba($white, .85);\r\n$toast-header-border-color:         rgba(0, 0, 0, .05);\r\n// scss-docs-end toast-variables\r\n\r\n\r\n// Badges\r\n\r\n// scss-docs-start badge-variables\r\n$badge-font-size:                   75%;\r\n$badge-font-weight:                 $font-weight-medium;\r\n$badge-color:                       $white;\r\n$badge-padding-y:                   .25em;\r\n$badge-padding-x:                   .4em;\r\n$badge-border-radius:               $border-radius;\r\n// scss-docs-end badge-variables\r\n\r\n\r\n// Modals\r\n\r\n// scss-docs-start modal-variables\r\n$modal-inner-padding:               $spacer;\r\n\r\n// Margin between elements in footer, must be lower than or equal to 2 * $modal-inner-padding\r\n$modal-footer-margin-between:       .5rem;\r\n\r\n$modal-dialog-margin:               .5rem;\r\n$modal-dialog-margin-y-sm-up:       1.75rem;\r\n\r\n$modal-title-line-height:           $line-height-base;\r\n\r\n$modal-content-color:               null;\r\n$modal-content-bg:                  $white;\r\n$modal-content-border-color:        $gray-300;\r\n$modal-content-border-width:        $border-width;\r\n$modal-content-border-radius:       $border-radius-lg;\r\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width);\r\n$modal-content-box-shadow-xs:       $box-shadow-sm;\r\n$modal-content-box-shadow-sm-up:    $box-shadow;\r\n\r\n$modal-backdrop-bg:                 $black;\r\n$modal-backdrop-opacity:            .5;\r\n$modal-header-border-color:         $border-color;\r\n$modal-footer-border-color:         $modal-header-border-color;\r\n$modal-header-border-width:         $modal-content-border-width;\r\n$modal-footer-border-width:         $modal-header-border-width;\r\n$modal-header-padding-y:            $modal-inner-padding;\r\n$modal-header-padding-x:            $modal-inner-padding;\r\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x; // Keep this for backwards compatibility\r\n\r\n$modal-sm:                          300px;\r\n$modal-md:                          500px;\r\n$modal-lg:                          800px;\r\n$modal-xl:                          1140px;\r\n\r\n$modal-fade-transform:              translate(0, -50px);\r\n$modal-show-transform:              none;\r\n$modal-transition:                  transform .3s ease-out;\r\n$modal-scale-transform:             scale(1.02);\r\n// scss-docs-end modal-variables\r\n\r\n\r\n// Alerts\r\n//\r\n// Define alert colors, border radius, and padding.\r\n\r\n// scss-docs-start alert-variables\r\n$alert-padding-y:                   .75rem;\r\n$alert-padding-x:                   1.25rem;\r\n$alert-margin-bottom:               1rem;\r\n$alert-border-radius:               $border-radius;\r\n$alert-link-font-weight:            $font-weight-bold;\r\n$alert-border-width:                $border-width;\r\n\r\n$alert-bg-scale:                    -80%;\r\n$alert-border-scale:                -70%;\r\n$alert-color-scale:                 40%;\r\n\r\n$alert-dismissible-padding-r:       $alert-padding-x * 3; // 3x covers width of x plu padding on either side\r\n// scss-docs-end alert-variables\r\n\r\n\r\n// Progress bars\r\n\r\n// scss-docs-start progress-variables\r\n$progress-height:                   .625rem;\r\n$progress-font-size:                $font-size-base * .75;\r\n$progress-bg:                       $gray-200;\r\n$progress-border-radius:            $border-radius;\r\n$progress-box-shadow:               $box-shadow-inset;\r\n$progress-bar-color:                $white;\r\n$progress-bar-bg:                   $primary;\r\n$progress-bar-animation-timing:     1s linear infinite;\r\n$progress-bar-transition:           width .6s ease;\r\n// scss-docs-end progress-variables\r\n\r\n\r\n// List group\r\n\r\n// scss-docs-start list-group-variables\r\n$list-group-color:                  null;\r\n$list-group-bg:                     $white;\r\n$list-group-border-color:           $border-color;\r\n$list-group-border-width:           $border-width;\r\n$list-group-border-radius:          $border-radius;\r\n\r\n$list-group-item-padding-y:         .75rem;\r\n$list-group-item-padding-x:         1.25rem;\r\n$list-group-item-bg-scale:          -80%;\r\n$list-group-item-color-scale:       40%;\r\n\r\n$list-group-hover-bg:               $gray-100;\r\n$list-group-active-color:           $component-active-color;\r\n$list-group-active-bg:              $component-active-bg;\r\n$list-group-active-border-color:    $list-group-active-bg;\r\n\r\n$list-group-disabled-color:         $gray-600;\r\n$list-group-disabled-bg:            $list-group-bg;\r\n\r\n$list-group-action-color:           $gray-700;\r\n$list-group-action-hover-color:     $list-group-action-color;\r\n\r\n$list-group-action-active-color:    $body-color;\r\n$list-group-action-active-bg:       $gray-200;\r\n// scss-docs-end list-group-variables\r\n\r\n\r\n// Image thumbnails\r\n\r\n// scss-docs-start thumbnail-variables\r\n$thumbnail-padding:                 .25rem;\r\n$thumbnail-bg:                      $body-bg;\r\n$thumbnail-border-width:            $border-width;\r\n$thumbnail-border-color:            $gray-300;\r\n$thumbnail-border-radius:           $border-radius;\r\n$thumbnail-box-shadow:              $box-shadow-sm;\r\n// scss-docs-end thumbnail-variables\r\n\r\n\r\n// Figures\r\n\r\n// scss-docs-start figure-variables\r\n$figure-caption-font-size:          $small-font-size;\r\n$figure-caption-color:              $gray-600;\r\n// scss-docs-end figure-variables\r\n\r\n\r\n// Breadcrumbs\r\n\r\n// scss-docs-start breadcrumb-variables\r\n$breadcrumb-font-size:              null;\r\n$breadcrumb-padding-y:              0;\r\n$breadcrumb-padding-x:              0;\r\n$breadcrumb-item-padding-x:         .5rem;\r\n$breadcrumb-margin-bottom:          1rem;\r\n$breadcrumb-bg:                     null;\r\n$breadcrumb-divider-color:          $gray-600;\r\n$breadcrumb-active-color:           $gray-600;\r\n$breadcrumb-divider:                quote(\"/\");\r\n$breadcrumb-divider-flipped:        $breadcrumb-divider;\r\n$breadcrumb-border-radius:          null;\r\n// scss-docs-end breadcrumb-variables\r\n\r\n// Carousel\r\n\r\n// scss-docs-start carousel-variables\r\n$carousel-control-color:             $white;\r\n$carousel-control-width:             15%;\r\n$carousel-control-opacity:           .5;\r\n$carousel-control-hover-opacity:     .9;\r\n$carousel-control-transition:        opacity .15s ease;\r\n\r\n$carousel-indicator-width:           30px;\r\n$carousel-indicator-height:          3px;\r\n$carousel-indicator-hit-area-height: 10px;\r\n$carousel-indicator-spacer:          3px;\r\n$carousel-indicator-opacity:         .5;\r\n$carousel-indicator-active-bg:       $white;\r\n$carousel-indicator-active-opacity:  1;\r\n$carousel-indicator-transition:      opacity .6s ease;\r\n\r\n$carousel-caption-width:             70%;\r\n$carousel-caption-color:             $white;\r\n$carousel-caption-padding-y:         1.25rem;\r\n$carousel-caption-spacer:            1.25rem;\r\n\r\n$carousel-control-icon-width:        2rem;\r\n\r\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\");\r\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\");\r\n\r\n$carousel-transition-duration:       .6s;\r\n$carousel-transition:                transform $carousel-transition-duration ease-in-out; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\r\n\r\n$carousel-dark-indicator-active-bg:  $black;\r\n$carousel-dark-caption-color:        $black;\r\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100);\r\n// scss-docs-end carousel-variables\r\n\r\n\r\n// Spinners\r\n\r\n// scss-docs-start spinner-variables\r\n$spinner-width:           2rem;\r\n$spinner-height:          $spinner-width;\r\n$spinner-vertical-align:  -.125em;\r\n$spinner-border-width:    .25em;\r\n$spinner-animation-speed: .75s;\r\n\r\n$spinner-width-sm:        1rem;\r\n$spinner-height-sm:       $spinner-width-sm;\r\n$spinner-border-width-sm: .2em;\r\n// scss-docs-end spinner-variables\r\n\r\n\r\n// Close\r\n\r\n// scss-docs-start close-variables\r\n$btn-close-width:            1em;\r\n$btn-close-height:           $btn-close-width;\r\n$btn-close-padding-x:        .25em;\r\n$btn-close-padding-y:        $btn-close-padding-x;\r\n$btn-close-color:            $black;\r\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\");\r\n$btn-close-focus-shadow:     none;\r\n$btn-close-opacity:          .5;\r\n$btn-close-hover-opacity:    .75;\r\n$btn-close-focus-opacity:    1;\r\n$btn-close-disabled-opacity: .25;\r\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%);\r\n// scss-docs-end close-variables\r\n\r\n\r\n// Offcanvas\r\n\r\n// scss-docs-start offcanvas-variables\r\n$offcanvas-padding-y:               $modal-inner-padding;\r\n$offcanvas-padding-x:               $modal-inner-padding;\r\n$offcanvas-horizontal-width:        400px;\r\n$offcanvas-vertical-height:         30vh;\r\n$offcanvas-transition-duration:     .3s;\r\n$offcanvas-border-color:            $modal-content-border-color;\r\n$offcanvas-border-width:            $modal-content-border-width;\r\n$offcanvas-title-line-height:       $modal-title-line-height;\r\n$offcanvas-bg-color:                $modal-content-bg;\r\n$offcanvas-color:                   $modal-content-color;\r\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs;\r\n$offcanvas-backdrop-bg:             $modal-backdrop-bg;\r\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity;\r\n// scss-docs-end offcanvas-variables\r\n\r\n// Code\r\n\r\n$code-font-size:                    $small-font-size;\r\n$code-color:                        $pink;\r\n\r\n$kbd-padding-y:                     .2rem;\r\n$kbd-padding-x:                     .4rem;\r\n$kbd-font-size:                     $code-font-size;\r\n$kbd-color:                         $white;\r\n$kbd-bg:                            $gray-900;\r\n\r\n$pre-color:                         null;","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is and invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefor we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n\n      &::after {\n        position: absolute;\n        inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n        z-index: -1;\n        height: $form-floating-label-height;\n        content: \"\";\n        background-color: $input-bg;\n        @include border-radius($input-border-radius);\n      }\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n\n    &::after {\n      background-color: $input-disabled-bg;\n    }\n  }\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(#{$pagination-border-width} * -1) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n$accordion-button-focus-border-color:     $input-focus-border-color !default;\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $black !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(#{$input-border-width} * -1); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-border-color: #{$accordion-button-focus-border-color};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    border-color: var(--#{$prefix}accordion-btn-focus-border-color);\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  .accordion-collapse {\n    border-width: 0;\n  }\n\n  .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(#{$pagination-border-width} * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  --#{$prefix}btn-close-white-filter: #{$btn-close-white-filter};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  filter: var(--#{$prefix}btn-close-white-filter);\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .btn-close {\n      @include btn-close-white();\n    }\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    @if $color-mode-type == \"media-query\" {\n      .carousel {\n        @include carousel-dark();\n      }\n    } @else {\n      .carousel,\n      &.carousel {\n        @include carousel-dark();\n      }\n    }\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}offcanvas-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","/* =============\r\n   General\r\n============= */\r\n\r\nhtml {\r\n  position: relative;\r\n  min-height: 100%;\r\n}\r\n\r\n.h1,.h2,.h3,.h4,.h5,.h6,\r\nh1,h2,h3,h4,h5,h6 {\r\n  color: $gray-700;\r\n}\r\n\r\n\r\n.h1,\r\nh1 {\r\n  font-size: 2.25rem;\r\n}\r\n\r\n.h2,\r\nh2 {\r\n  font-size: 1.8rem;\r\n}\r\n\r\n.h3,\r\nh3 {\r\n  font-size: 1.575rem;\r\n}\r\n\r\n.h4,\r\nh4 {\r\n  font-size: 1.35rem;\r\n}\r\n\r\n.h5,\r\nh5 {\r\n  font-size: 1.125rem;\r\n}\r\n\r\n.h6,\r\nh6 {\r\n  font-size: .9rem;\r\n}\r\n\r\na {\r\n  text-decoration: none !important;\r\n}\r\n\r\nlabel {\r\n  font-weight: 500;\r\n}\r\n\r\n// blockquote\r\n\r\n.blockquote {\r\n  padding: 10px 20px;\r\n  border-left: 4px solid $gray-300;\r\n}\r\n\r\n.blockquote-reverse {\r\n  border-left: 0;\r\n  border-right: 4px solid $gray-300;\r\n  text-align: right;\r\n}\r\n\r\n// container\r\n\r\n.container, .container-lg, .container-md, .container-sm, .container-xl, .container-xxl{\r\n  @media (min-width: 1200px){\r\n      max-width: 1140px;\r\n  }\r\n}\r\n\r\n// row\r\n\r\n.row{\r\n  > * {\r\n      position: relative;\r\n  }\r\n}\r\n\r\n\r\n// labels\r\n\r\n\r\nlabel {\r\n    margin-bottom: $form-label-margin-bottom;\r\n}","// \r\n// backgrounds.scss\r\n//\r\n\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .bg-soft-#{$color} {\r\n        background-color: rgba(($value), 0.25) !important;\r\n    }\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .bg-gradient-#{$color} {\r\n        background: linear-gradient( to bottom, ($value), rgba(($value), 0.5))!important;\r\n\r\n    }\r\n}","// \r\n// _badge.scss\r\n// \r\n\r\n.rounded-pill{\r\n   padding-right: .6em;\r\n    padding-left: .6em;\r\n}\r\n\r\n\r\n// Soft badge\r\n@mixin bg-variant-soft($bg) {\r\n  color: $bg;\r\n  background-color: rgba($bg, 0.18);\r\n\r\n  &[href] {\r\n      color: $bg;\r\n      text-decoration: none;\r\n      background-color: rgba($bg, 0.4);\r\n\r\n      &:hover,\r\n      &:focus {\r\n        color: $bg;\r\n        text-decoration: none;\r\n        background-color: rgba($bg, 0.4);\r\n      }\r\n  }\r\n}\r\n\r\n\r\n@each $color, $value in $theme-colors {\r\n\r\n  .badge {\r\n    &.bg-#{$color} {\r\n      &[href] {\r\n        &:hover,\r\n        &:focus {\r\n          background-color: darken($value, 4%) !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .bg-soft-#{$color} {\r\n      @include bg-variant-soft($value);\r\n  }\r\n}\r\n\r\n.badge{\r\n  &.bg-light{\r\n    color: $body-color;\r\n\r\n    &[href] {\r\n      &:hover,\r\n      &:focus {\r\n        color: $body-color;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// Dark badge\r\n\r\n.badge.bg-dark{\r\n  color: $light;\r\n}","// \r\n// _buttons.scss\r\n// \r\n\r\nbutton,a {\r\n  outline: none !important;\r\n}\r\n\r\n\r\n// Rounded Buttons\r\n.btn-rounded {\r\n  border-radius: 30px;\r\n}\r\n\r\n.btn-dark, .btn-secondary{\r\n  color: $gray-200;\r\n}\r\n\r\n.btn-outline-light{\r\n  color: $gray-900;\r\n}\r\n\r\n// btn-soft-color\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .btn-soft-#{$color} {\r\n        background-color: rgba(($value), 0.25);\r\n        border-color: rgba(($value), 0.25);\r\n        color: $value;\r\n    }\r\n}\r\n","\r\n// \r\n// breadcrumb.scss\r\n//\r\n\r\n\r\n// Breadcrumb item arrow\r\n.breadcrumb-item {\r\n    > a {\r\n        color: $gray-700;\r\n    }\r\n    +.breadcrumb-item {\r\n        &::before {\r\n            font-family: \"Material Design Icons\";\r\n        }\r\n    }\r\n}\r\n  ","// \r\n// _card.scss\r\n// \r\n\r\n.card {\r\n  margin-bottom: $grid-gutter-width;\r\n  box-shadow: $box-shadow;\r\n}\r\n\r\n.card-drop {\r\n  color: $body-color;\r\n}\r\n\r\n.card-title {\r\n  font-size: 16px;\r\n  margin: 0 0 7px 0;\r\n  font-weight: $font-weight-semibold;\r\n}\r\n\r\n.card-title-desc {\r\n  color: $card-title-desc;\r\n  margin-bottom: 24px;  \r\n}\r\n\r\n","// \r\n// _dropdown.scss\r\n// \r\n\r\n.dropdown-menu {\r\n  box-shadow: $box-shadow;\r\n  animation-name: DropDownSlide;\r\n  animation-duration: .3s;\r\n  animation-fill-mode: both;\r\n  margin: 0;\r\n  position: absolute;\r\n  z-index: 1000;\r\n  &.show {\r\n    top: 100%!important;\r\n  }\r\n\r\n  &[style] {\r\n    right: auto!important;\r\n    left: 0;\r\n  }\r\n  \r\n}\r\n\r\n.dropdown-menu-end[style] {\r\n  left: auto!important;\r\n  right: 0!important;\r\n}\r\n\r\n.dropdown-menu[data-popper-placement^=right],.dropdown-menu[data-popper-placement^=top],.dropdown-menu[data-popper-placement^=left]{\r\n  top: auto !important;\r\n  animation: none !important;\r\n}\r\n\r\n@keyframes DropDownSlide {\r\n  100% {\r\n      -webkit-transform: translateY(0);\r\n      transform: translateY(0)\r\n  }\r\n  0% {\r\n      -webkit-transform: translateY(10px);\r\n      transform: translateY(10px)\r\n  }\r\n}\r\n\r\n@media (min-width: 600px) {\r\n  .dropdown-menu-lg {\r\n    width: 320px;\r\n  }\r\n\r\n  .dropdown-menu-md {\r\n    width: 240px;\r\n  }\r\n}\r\n\r\n.dropdown-divider{\r\n  border-top-color: $border-color;\r\n}\r\n\r\n// Dropdown size\r\n\r\n.dropdown-mega-menu-xl{\r\n  width: 40rem;\r\n}\r\n\r\n.dropdown-mega-menu-lg{\r\n  width: 26rem;\r\n}","// \r\n// _nav.scss\r\n// \r\n\r\n.nav-tabs,.nav-pills {\r\n  > li {\r\n      > a {\r\n          color: $gray-700;\r\n          font-weight: $font-weight-medium;\r\n      }\r\n  }\r\n}\r\n\r\n.nav-pills {\r\n  > a {\r\n      color: $gray-700;  \r\n      font-weight: $font-weight-medium;\r\n  }\r\n}\r\n\r\n\r\n.nav-tabs-custom {\r\n  border-bottom: 2px solid $gray-300;\r\n\r\n  .nav-item {\r\n    position: relative;\r\n    color: $dark;\r\n    .nav-link {\r\n      border: none;\r\n\r\n      &::after {\r\n        content: \"\";\r\n        background: $primary;\r\n        height: 2px;\r\n        position: absolute;\r\n        width: 100%;\r\n        left: 0;\r\n        bottom: -2px;\r\n        transition: all 250ms ease 0s;\r\n        transform: scale(0);\r\n      }\r\n\r\n      &.active{\r\n        color: $primary;\r\n        &:after{\r\n          transform: scale(1);\r\n        }\r\n      }\r\n\r\n    }\r\n  }\r\n}\r\n.nav-pills .nav-link.active, .nav-pills .show > .nav-link {\r\n  color: #fff;\r\n  background-color: #4360AB;\r\n}\r\n\r\n\r\n// vertical nav\r\n\r\n.vertical-nav{\r\n  .nav{\r\n      .nav-link{\r\n          padding: 24px 16px;\r\n          text-align: center;\r\n          margin-bottom: 8px;\r\n          .nav-icon{\r\n              font-size: 24px;\r\n          }\r\n      }\r\n  }\r\n}","// \r\n// _table.scss\r\n// \r\n\r\n.table {\r\n  th {\r\n      font-weight: $font-weight-bold;\r\n  }\r\n  .table-light{\r\n    color: $body-color;\r\n    border-color: $table-border-color;\r\n    background-color: $table-head-bg;\r\n      \r\n  }\r\n}\r\n\r\n.table>:not(caption)>*>*{\r\n  border-bottom-width: 0px;\r\n  border-top-width: $table-border-width;;\r\n}\r\n\r\n.table>:not(:last-child)>:last-child>*{\r\n  border-bottom-color:  $table-border-color;\r\n}\r\n\r\n.table-dark>:not(:last-child)>:last-child>*{\r\n  border-bottom-color:  $table-dark-border-color;\r\n}\r\n\r\n.table-nowrap {\r\n  th, td {\r\n    white-space: nowrap;\r\n  }\r\n}\r\n\r\n//Table centered\r\n.table-centered {\r\n  td,th {\r\n      vertical-align: middle !important;\r\n  }\r\n}\r\n\r\n\r\n\r\n// table card list\r\n\r\n.table-card-list{\r\n  border-collapse:separate; \r\n  border-spacing:0 12px; \r\n  tr{\r\n    background-color: $card-bg;\r\n  }\r\n\r\n}\r\n.table > thead:last-child {\r\n  display: none;\r\n}","// \r\n// _pagination.scss\r\n// \r\n\r\n// Pagination rounded (Custom)\r\n.pagination-rounded {\r\n    .page-link {\r\n        border-radius: 30px !important;\r\n        margin: 0 3px !important;\r\n        border: none;\r\n        width: 32px;\r\n        height: 32px;\r\n        padding: 0;\r\n        text-align: center;\r\n        line-height: 32px;\r\n    }\r\n  }\r\n\r\n  @media only screen and (max-width: 768px) {\r\n    .pagination {\r\n       justify-content: center;\r\n    }\r\n    \r\n  }","// \r\n// _progress.scss\r\n// \r\n\r\n// Progress height small\r\n.progress-sm {\r\n  height: 5px;\r\n}\r\n\r\n\r\n// Progress height medium\r\n.progress-md {\r\n  height: 8px;\r\n}\r\n\r\n\r\n// Progress height large\r\n.progress-lg {\r\n  height: 12px;\r\n}\r\n\r\n// Progress height Extra large\r\n.progress-xl {\r\n  height: 16px;\r\n}\r\n\r\n.animated-progess{\r\n  position: relative;\r\n  .progress-bar {\r\n    position: relative;\r\n    border-radius: 6px;\r\n    animation: animate-positive 2s;\r\n  }\r\n}\r\n\r\n@keyframes animate-positive {\r\n  0% {\r\n      width: 0;\r\n  }\r\n}","/*\r\nTemplate Name: Minible - Admin & Dashboard Template\r\nAuthor: Themesbrand\r\nVersion: 2.1.0\r\nWebsite: https://themesbrand.com/\r\nContact: themesbrand@gmail.com\r\nFile: Main Css File\r\n*/\r\n\r\n//Fonts\r\n@import \"custom/fonts/fonts\";\r\n\r\n//Core files\r\n@import \"./node_modules/bootstrap/scss/functions\";\r\n@import \"./node_modules/bootstrap/scss/variables\";\r\n@import \"variables\";\r\n@import \"./node_modules/bootstrap/scss/mixins.scss\";\r\n\r\n// Structure\r\n@import \"custom/structure/general\";\r\n@import \"custom/structure/topbar\";\r\n@import \"custom/structure/page-head\";\r\n@import \"custom/structure/footer\";\r\n@import \"custom/structure/right-sidebar\";\r\n@import \"custom/structure/vertical\";\r\n@import \"custom/structure/horizontal-nav\";\r\n@import \"custom/structure/layouts\";\r\n\r\n// Components\r\n@import \"custom/components/waves\";\r\n@import \"custom/components/avatar\";\r\n@import \"custom/components/alerts\";\r\n@import \"custom/components/accordion\";\r\n@import \"custom/components/helper\";\r\n@import \"custom/components/preloader\";\r\n@import \"custom/components/forms\";\r\n@import \"custom/components/widgets\";\r\n@import \"custom/components/demos\";\r\n@import \"custom/components/print\";\r\n\r\n\r\n// Plugins\r\n@import \"custom/plugins/custom-scrollbar\";\r\n@import \"custom/plugins/calendar\";\r\n@import \"custom/plugins/session-timeout\";\r\n@import \"custom/plugins/range-slider\";\r\n@import \"custom/plugins/sweatalert2\";\r\n@import \"custom/plugins/rating\";\r\n@import \"custom/plugins/toastr\";;\r\n@import \"custom/plugins/parsley\";\r\n@import \"custom/plugins/select2\";\r\n@import \"custom/plugins/switch\";\r\n@import \"custom/plugins/colorpicker\";\r\n@import \"custom/plugins/datepicker\";\r\n@import \"custom/plugins/bootstrap-touchspin\";\r\n@import \"custom/plugins/repeater\";\r\n@import \"custom/plugins/form-editors\";\r\n@import \"custom/plugins/xeditable\";\r\n@import \"custom/plugins/form-upload\";\r\n@import \"custom/plugins/form-wizard\";\r\n@import \"custom/plugins/responsive-table\";\r\n@import \"custom/plugins/datatable\";\r\n@import \"custom/plugins/table-editable\";\r\n@import \"custom/plugins/apexcharts\";\r\n@import \"custom/plugins/flot\";\r\n@import \"custom/plugins/sparkline-chart\";\r\n@import \"custom/plugins/google-map\";\r\n@import \"custom/plugins/vector-maps\";\r\n@import \"custom/plugins/leaflet-maps\";\r\n\r\n\r\n// Pages\r\n@import \"custom/pages/authentication\";\r\n@import \"custom/pages/ecommerce\";\r\n@import \"custom/pages/email\";\r\n@import \"custom/pages/chat\";\r\n@import \"custom/pages/coming-soon\";\r\n@import \"custom/pages/timeline\";\r\n@import \"custom/pages/extras-pages\";\r\n","// \r\n// _header.scss\r\n// \r\n\r\n#page-topbar {\r\n    position: fixed;\r\n    top: 0;\r\n    right: 0;\r\n    left: $sidebar-width;\r\n    z-index: 4;\r\n    background-color: $header-bg;\r\n    box-shadow: $box-shadow;\r\n}\r\n\r\n.navbar-header {\r\n    display: flex;\r\n    -ms-flex-pack: justify;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin: 0 auto;\r\n    height: $header-height;\r\n    padding: 0 calc(#{$grid-gutter-width} / 2) 0 0;\r\n\r\n    .dropdown .show {\r\n        &.header-item {\r\n            background-color: $gray-100;\r\n        }\r\n    }\r\n\r\n    .navbar-brand-box{\r\n        display: none;\r\n    }\r\n}\r\n\r\nbody {\r\n    &.vertical-collpsed {\r\n        #page-topbar {\r\n            left: $sidebar-collapsed-width;\r\n            @media (max-width: 991.98px){\r\n                left: 0;\r\n            }\r\n        }\r\n    }\r\n    &:not(.vertical-collpsed) {\r\n        .navbar-header {\r\n            .vertical-menu-btn {\r\n                display: none;\r\n            }\r\n        }\r\n\r\n        .app-search {\r\n            margin-left: 10px;\r\n        }\r\n    }\r\n}\r\n\r\n.navbar-brand-box {\r\n    // padding: 0 1.5rem;\r\n    width: $navbar-brand-box-width;\r\n    position: fixed;\r\n    z-index: 1;\r\n    background-color: $sidebar-bg;\r\n}\r\n\r\n.logo {\r\n    line-height: 65px;\r\n\r\n    .logo-sm {\r\n        display: none;\r\n    }\r\n}\r\n\r\n.logo-dark {\r\n    display: $display-block;\r\n}\r\n\r\n.logo-light {\r\n    display: $display-none;\r\n}\r\n\r\n/* Search */\r\n\r\n.app-search {\r\n    padding: calc(#{$header-height - 38px} / 2) 0;\r\n\r\n    .form-control {\r\n        border: none;\r\n        height: 38px;\r\n        padding-left: 40px;\r\n        padding-right: 20px;\r\n        background-color: $topbar-search-bg;\r\n        box-shadow: none;\r\n        border-radius: 5px;\r\n    }\r\n    span {\r\n        position: absolute;\r\n        z-index: 10;\r\n        font-size: 16px;\r\n        line-height: 38px;\r\n        left: 13px;\r\n        top: 0;\r\n        color: $gray-600;\r\n    }\r\n}\r\n\r\n// Mega menu\r\n\r\n.megamenu-list {\r\n    li{\r\n        position: relative;\r\n        padding: 5px 0px;\r\n        a{\r\n            color: $dropdown-color;\r\n        }\r\n    }\r\n}\r\n\r\n@media (max-width: 991.98px) {\r\n    .navbar-brand-box {\r\n        width: auto;\r\n    }\r\n\r\n    #page-topbar {\r\n        left: 0;\r\n\r\n        .navbar-header {\r\n        \r\n            .navbar-brand-box{\r\n                display: inline-block;\r\n                position: relative;\r\n            }\r\n\r\n            .vertical-menu-btn {\r\n                display: inline-block;\r\n            }\r\n        }\r\n    }\r\n\r\n    .logo {\r\n\r\n        span.logo-lg {\r\n            display: none;\r\n        }\r\n\r\n        span.logo-sm {\r\n            display: inline-block;\r\n        }\r\n    }\r\n}\r\n\r\n.page-content {\r\n    padding: calc(#{$header-height} + #{$grid-gutter-width}) calc(#{$grid-gutter-width} / 2) $footer-height calc(#{$grid-gutter-width} / 2);\r\n}\r\n\r\n.header-item {\r\n    height: $header-height;\r\n    box-shadow: none !important;\r\n    color: $header-item-color;\r\n    border: 0;\r\n    border-radius: 0px;\r\n\r\n    &:hover {\r\n        color: $header-item-color;\r\n    }\r\n}\r\n\r\n.header-profile-user {\r\n    height: 36px;\r\n    width: 36px;\r\n    background-color: $gray-300;\r\n    padding: 3px;\r\n}\r\n\r\n.noti-icon {\r\n    i {\r\n        font-size: 22px;\r\n        color: $header-item-color;\r\n    }\r\n\r\n    .badge {\r\n        position: absolute;\r\n        top: 12px;\r\n        right: 5px;\r\n    }\r\n}\r\n\r\n.notification-item {\r\n    .d-flex {\r\n        padding: 0.75rem 1rem;\r\n        display: flex;\r\n\r\n        &:hover {\r\n            background-color: $dropdown-link-hover-bg;\r\n        }\r\n    }\r\n}\r\n\r\n// Dropdown with Icons\r\n.dropdown-icon-item {\r\n    display: block;\r\n    border-radius: 3px;\r\n    line-height: 34px;\r\n    text-align: center;\r\n    padding: 15px 0 9px;\r\n    display: block;\r\n    border: 1px solid transparent;\r\n    color: $gray-600;\r\n\r\n    img {\r\n        height: 24px;\r\n    }\r\n\r\n    span {\r\n        display: block;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        white-space: nowrap;\r\n    }\r\n\r\n    &:hover {\r\n        border-color: $gray-200;\r\n    }\r\n}\r\n\r\n// Full Screen\r\n.fullscreen-enable {\r\n    [data-bs-toggle=\"fullscreen\"] {\r\n        .uil-minus-path::before {\r\n            content: '\\eb8d';\r\n        }\r\n    }\r\n}\r\n\r\nbody[data-topbar=\"dark\"] {\r\n    #page-topbar { \r\n        background-color: $header-dark-bg;\r\n    }\r\n    .navbar-header {\r\n        .dropdown .show {\r\n            &.header-item {\r\n                background-color: rgba($white, 0.05);\r\n            }\r\n        }\r\n\r\n        .waves-effect .waves-ripple {\r\n            background: rgba($white, 0.4);\r\n        }\r\n    }\r\n\r\n    .header-item {\r\n        color: $header-dark-item-color;\r\n    \r\n        &:hover {\r\n            color: $header-dark-item-color;\r\n        }\r\n    }\r\n\r\n    .header-profile-user {\r\n        background-color: rgba($white, 0.25);\r\n    }\r\n    \r\n    .noti-icon {\r\n        i {\r\n            color: $header-dark-item-color;\r\n        }\r\n    }\r\n\r\n    .logo-dark {\r\n        display: none;\r\n    }\r\n\r\n    .logo-light {\r\n        display: block;\r\n    }\r\n\r\n    .app-search {\r\n    \r\n        .form-control {\r\n            background-color: lighten($header-dark-bg,4%);\r\n            color: $white;\r\n        }\r\n        span,\r\n        input.form-control::-webkit-input-placeholder {\r\n            color: rgba($white,0.5);\r\n        }\r\n    }\r\n}\r\n\r\nbody[data-sidebar=\"dark\"] {\r\n    .navbar-brand-box {\r\n        background: $sidebar-dark-bg;\r\n\r\n        .logo-dark {\r\n            display: none;\r\n        }\r\n    \r\n        .logo-light {\r\n            display: block;\r\n\r\n        }\r\n    }\r\n\r\n\r\n}\r\n\r\n@media (max-width: 600px) {\r\n    .navbar-header {\r\n        .dropdown {\r\n            position: static;\r\n\r\n            .dropdown-menu {\r\n                left: 10px !important;\r\n                right: 10px !important;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media (max-width: 380px) {\r\n    .navbar-brand-box {\r\n        display: none;\r\n    }\r\n}\r\n\r\nbody[data-layout=\"horizontal\"] {\r\n    .page-content {\r\n        // margin-top: $header-height;\r\n        padding: calc(80px + #{$grid-gutter-width}) calc(#{$grid-gutter-width} / 2) $footer-height calc(#{$grid-gutter-width} / 2);\r\n\r\n        @media (max-width: 991.98px) { \r\n            margin-top: 0px;\r\n        }\r\n    }    \r\n}\r\n\r\n\r\n\r\n@media (max-width: 374.99px) { \r\n    .navbar-brand-box {\r\n        padding: 0 1rem;\r\n        text-align: center;\r\n    }\r\n\r\n    .language-switch {\r\n        display: none !important;\r\n    }\r\n}"," \r\n// Page-title\r\n// \r\n\r\n.page-title-box {\r\n    padding-bottom: $grid-gutter-width;\r\n\r\n    .breadcrumb {\r\n        background-color: transparent;\r\n        padding: 0;\r\n    }\r\n\r\n    h4 {\r\n        font-weight: 600;\r\n        font-size: 18px !important;\r\n    }\r\n\r\n    .page-title-right{\r\n        @media (max-width: 575.98px) {\r\n            display: none;\r\n        }\r\n    }\r\n}","// \r\n// _footer.scss\r\n// \r\n\r\n.footer {\r\n    bottom: 0;\r\n    padding: 20px calc(#{$grid-gutter-width} / 2);\r\n    position: absolute;\r\n    right: 0;\r\n    color: $footer-color;\r\n    left: 250px;\r\n    height: $footer-height;\r\n    box-shadow: 0 0px 4px rgba(15,34,58,.12);\r\n}\r\n  \r\n@media (max-width: 992px) {\r\n    .footer {\r\n        left: 0;\r\n    }\r\n}\r\n\r\n// Enlarge menu\r\n.vertical-collpsed {\r\n    .footer {\r\n        left: $sidebar-collapsed-width;\r\n    }\r\n}\r\n\r\nbody[data-layout=\"horizontal\"] {\r\n    .footer {\r\n        left: 0 !important;\r\n    }  \r\n}","//\r\n// right-sidebar.scss\r\n//\r\n\r\n.right-bar {\r\n    background-color: $card-bg;\r\n    box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.06), 0 1px 0 0 rgba(0, 0, 0, 0.02);\r\n    display: block;\r\n    position: fixed;\r\n    transition: all 200ms ease-out;\r\n    width: $rightbar-width;\r\n    z-index: 9999;\r\n    float: right !important;\r\n    right: -($rightbar-width + 10px);\r\n    top: 0;\r\n    bottom: 0;\r\n\r\n    .right-bar-toggle {\r\n        background-color: lighten($dark, 7%);\r\n        height: 24px;\r\n        width: 24px;\r\n        line-height: 24px;\r\n        color: $gray-200;\r\n        text-align: center;\r\n        border-radius: 50%;\r\n\r\n        &:hover {\r\n            background-color: lighten($dark, 10%);\r\n        }\r\n    }\r\n}\r\n\r\n// Rightbar overlay\r\n.rightbar-overlay {\r\n    background-color: rgba($dark, 0.55);\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n    bottom: 0;\r\n    display: none;\r\n    z-index: 9998;\r\n    transition: all .2s ease-out;\r\n}\r\n\r\n.right-bar-enabled {\r\n    .right-bar {\r\n        right: 0;\r\n    }\r\n    .rightbar-overlay {\r\n        display: block;\r\n    }\r\n}\r\n\r\n@include media-breakpoint-down(sm) {\r\n    .right-bar {\r\n        overflow: auto;\r\n        .slimscroll-menu {\r\n            height: auto !important;\r\n        }\r\n    }\r\n}","//\r\n// _menu.scss\r\n// \r\n\r\n.metismenu {\r\n    margin: 0;\r\n\r\n    li {\r\n        display: block;\r\n        width: 100%;\r\n    }\r\n\r\n    .mm-collapse {\r\n        display: none;\r\n\r\n        &:not(.mm-show) {\r\n            display: none;\r\n        }\r\n\r\n        &.mm-show {\r\n            display: block\r\n        }\r\n    }\r\n\r\n    .mm-collapsing {\r\n        position: relative;\r\n        height: 0;\r\n        overflow: hidden;\r\n        transition-timing-function: ease;\r\n        transition-duration: .35s;\r\n        transition-property: height, visibility;\r\n    }\r\n}\r\n\r\n\r\n.vertical-menu {\r\n    width: $sidebar-width;\r\n    z-index: 1005;\r\n    background: $sidebar-bg;\r\n    bottom: 0;\r\n    margin-top: 0;\r\n    position: fixed;\r\n    top: 0;\r\n    box-shadow: $box-shadow;\r\n\r\n    .vertical-menu-btn {\r\n        position: absolute;\r\n        right: 0;\r\n        top: 0;\r\n        z-index: 2;\r\n    }\r\n}\r\n\r\n.main-content {\r\n    margin-left: $sidebar-width;\r\n    overflow: hidden;\r\n\r\n    .content {\r\n        padding: 0 15px 10px 15px;\r\n        margin-top: $header-height;\r\n    }\r\n}\r\n\r\n.sidebar-menu-scroll {\r\n    height: calc(100% - #{$header-height});\r\n    margin-top: $header-height;\r\n}\r\n\r\n\r\n#sidebar-menu {\r\n    padding: 10px 0 30px 0;\r\n\r\n    .mm-active {\r\n        >.has-arrow {\r\n            &:after {\r\n                transform: rotate(-180deg);\r\n            }\r\n        }\r\n    }\r\n\r\n    .has-arrow {\r\n        &:after {\r\n            content: \"\\F0140\";\r\n            font-family: 'Material Design Icons';\r\n            display: block;\r\n            float: right;\r\n            transition: transform .2s;\r\n            font-size: 1rem;\r\n        }\r\n    }\r\n\r\n    ul {\r\n        li {\r\n            a {\r\n                display: block;\r\n                padding: .6rem 1.1rem;\r\n                color: $sidebar-menu-item-color;\r\n                position: relative;\r\n                font-size: 15px;\r\n                font-weight: 500;\r\n                transition: all .4s;\r\n                margin: 0 10px;\r\n                border-radius: 3px;\r\n\r\n                i {\r\n                    display: inline-block;\r\n                    min-width: 1.5rem;\r\n                    padding-bottom: .125em;\r\n                    font-size: 1.05rem;\r\n                    line-height: 1.40625rem;\r\n                    vertical-align: middle;\r\n                    color: $sidebar-menu-item-icon-color;\r\n                    transition: all .4s;\r\n                }\r\n\r\n                &:hover {\r\n                    color: $sidebar-menu-item-hover-color;\r\n\r\n                    i {\r\n                        color: $sidebar-menu-item-hover-color;\r\n                    }\r\n                }\r\n            }\r\n\r\n            .badge {\r\n                margin-top: 4px;\r\n            }\r\n\r\n            ul.sub-menu {\r\n                padding: 0;\r\n\r\n                li {\r\n\r\n                    a {\r\n                        padding: .4rem 1.5rem .4rem 3.5rem;\r\n                        font-weight: 400;\r\n                        color: $sidebar-menu-sub-item-color;\r\n                        margin: 0;\r\n                        background-color: transparent;\r\n                        font-size: 14.4px;\r\n\r\n                        &:hover {\r\n                            color: $sidebar-menu-item-hover-color;\r\n                        }\r\n                    }\r\n\r\n                    ul.sub-menu {\r\n                        padding: 0;\r\n\r\n                        li {\r\n                            a {\r\n                                padding: .4rem 1.5rem .4rem 4.5rem;\r\n                                font-size: 13.5px;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n    }\r\n}\r\n\r\n.menu-title {\r\n    padding: 12px 20px !important;\r\n    letter-spacing: .05em;\r\n    pointer-events: none;\r\n    cursor: default;\r\n    font-size: 11px;\r\n    text-transform: uppercase;\r\n    color: $sidebar-menu-item-icon-color;\r\n    font-weight: $font-weight-semibold;\r\n}\r\n\r\n.mm-active {\r\n    color: $sidebar-menu-item-active-color !important;\r\n\r\n    > a {\r\n        background-color: $sidebar-menu-item-active-bg-color;\r\n        color: $sidebar-menu-item-active-color !important;  \r\n        > i{\r\n            color: $sidebar-menu-item-active-color !important;\r\n        }\r\n    }\r\n\r\n   \r\n    .active {\r\n        color: $sidebar-menu-item-active-color !important;\r\n\r\n        i {\r\n            color: $sidebar-menu-item-active-color !important;\r\n        }\r\n    }\r\n    > i {\r\n        color: $sidebar-menu-item-active-color !important;\r\n    }\r\n}\r\n\r\n@media (max-width: 992px) {\r\n    .vertical-menu {\r\n        display: none;\r\n        top: $header-height;\r\n\r\n        .sidebar-menu-scroll {\r\n            height: 100%;\r\n            margin-top: 0;\r\n        }\r\n\r\n        .navbar-brand-box,\r\n        .vertical-menu-btn {\r\n            display: none;\r\n        }\r\n\r\n    }\r\n\r\n    .main-content {\r\n        margin-left: 0 !important;\r\n    }\r\n\r\n    body.sidebar-enable {\r\n        .vertical-menu {\r\n            display: block;\r\n        }\r\n    }\r\n}\r\n\r\n// Enlarge menu\r\n.vertical-collpsed {\r\n\r\n    @media (min-width: 769px) {\r\n        min-height: 1450px;\r\n    }\r\n\r\n    .main-content {\r\n        margin-left: $sidebar-collapsed-width;\r\n    }\r\n\r\n    .navbar-brand-box {\r\n        width: $sidebar-collapsed-width !important;\r\n    }\r\n\r\n    .logo {\r\n        span.logo-lg {\r\n            display: none;\r\n        }\r\n\r\n        span.logo-sm {\r\n            display: block;\r\n        }\r\n    }\r\n\r\n    // Side menu\r\n    .vertical-menu {\r\n        position: absolute;\r\n        width: $sidebar-collapsed-width !important;\r\n        z-index: 1001;\r\n\r\n        .simplebar-mask,\r\n        .simplebar-content-wrapper {\r\n            overflow: visible !important;\r\n        }\r\n\r\n        .simplebar-scrollbar,\r\n        .vertical-menu-btn {\r\n            display: none !important;\r\n        }\r\n\r\n        .simplebar-offset {\r\n            bottom: 0 !important;\r\n        }\r\n\r\n        // Sidebar Menu\r\n        #sidebar-menu {\r\n\r\n            .menu-title,\r\n            .badge,\r\n            .collapse.in {\r\n                display: none !important;\r\n            }\r\n\r\n            .nav.collapse {\r\n                height: inherit !important;\r\n            }\r\n\r\n            .has-arrow {\r\n                &:after {\r\n                    display: none;\r\n                }\r\n            }\r\n\r\n            > ul {\r\n                > li {\r\n                    position: relative;\r\n                    white-space: nowrap;\r\n\r\n                    > a {\r\n                        padding: 15px 0;\r\n                        transition: none;\r\n                        \r\n                        &:hover,\r\n                        &:active,\r\n                        &:focus {\r\n                            color: $sidebar-menu-item-hover-color;\r\n                        }\r\n\r\n                        i {\r\n                            font-size: 1.3rem;\r\n                            text-align: center;\r\n                            min-width: 50px;\r\n                            padding-bottom: 0;\r\n                        }\r\n\r\n                        span {\r\n                            display: none;\r\n                            padding-left: 25px;\r\n                        }\r\n                    }\r\n\r\n                    &:hover {\r\n                        > a {\r\n                            position: relative;\r\n                            width: calc(180px + #{$sidebar-collapsed-width});\r\n                            color: $primary;\r\n                            background-color: $sidebar-menu-item-active-bg-color;\r\n                            transition: none;\r\n                            box-shadow: inset 0 3px 10px 0 rgba(154,161,171,.2);\r\n\r\n                            i{\r\n                                color: $primary;\r\n                            }\r\n\r\n                            span {\r\n                                display: inline;\r\n                            }\r\n                        }\r\n\r\n                        >ul {\r\n                            display: block;\r\n                            left: $sidebar-collapsed-width;\r\n                            position: absolute;\r\n                            width: 190px;\r\n                            height: auto !important;\r\n                            box-shadow: 3px 5px 10px 0 rgba(54, 61, 71, .1);\r\n\r\n                            ul {\r\n                                box-shadow: 3px 5px 10px 0 rgba(54, 61, 71, .1);\r\n                            }\r\n\r\n                            a {\r\n                                box-shadow: none;\r\n                                padding: 8px 20px;\r\n                                position: relative;\r\n                                width: 190px;\r\n                                z-index: 6;\r\n                                color: $sidebar-menu-sub-item-color;\r\n\r\n                                &:hover {\r\n                                    color: $sidebar-menu-item-hover-color;\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n\r\n                ul {\r\n                    padding: 5px 0;\r\n                    z-index: 9999;\r\n                    display: none;\r\n                    background-color: $sidebar-bg;\r\n\r\n                    li {\r\n                        &:hover {\r\n                            >ul {\r\n                                display: block;\r\n                                left: 190px;\r\n                                height: auto !important;\r\n                                margin-top: -36px;\r\n                                position: absolute;\r\n                                width: 190px;\r\n                            }\r\n                        }\r\n\r\n                        >a {\r\n                            span.pull-right {\r\n                                position: absolute;\r\n                                right: 20px;\r\n                                top: 12px;\r\n                                transform: rotate(270deg);\r\n                            }\r\n                        }\r\n                    }\r\n\r\n                    li.active {\r\n                        a {\r\n                            color: $gray-100;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n    }\r\n}\r\n\r\n\r\nbody[data-sidebar=\"dark\"] {\r\n    .vertical-menu {\r\n        background: $sidebar-dark-bg;\r\n\r\n        .vertical-menu-btn{\r\n            color: $sidebar-dark-menu-item-color;\r\n        }\r\n    }\r\n\r\n    #sidebar-menu {\r\n    \r\n        ul {\r\n            li {\r\n                a {\r\n                    color: $sidebar-dark-menu-item-color;\r\n\r\n                    i {\r\n                        color: $sidebar-dark-menu-item-icon-color;\r\n                    }\r\n    \r\n                    &:hover {\r\n                        color: $sidebar-dark-menu-item-hover-color;\r\n\r\n                        i {\r\n                            color: $sidebar-dark-menu-item-hover-color;\r\n                        }\r\n                    }\r\n                }\r\n\r\n                ul.sub-menu {\r\n                    li {\r\n\r\n                        a {\r\n                            color: $sidebar-dark-menu-sub-item-color;\r\n\r\n                            &:hover {\r\n                                color: $sidebar-dark-menu-item-hover-color;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    // Enlarge menu\r\n    &.vertical-collpsed {\r\n        min-height: 1300px;\r\n        // Side menu\r\n        .vertical-menu {\r\n\r\n            // Sidebar Menu\r\n            #sidebar-menu {\r\n\r\n                > ul {\r\n                    > li {\r\n                        \r\n                        &:hover {\r\n                            > a {\r\n                                background: lighten($sidebar-dark-bg, 2%);\r\n                                color: $sidebar-dark-menu-item-hover-color;\r\n                                i{\r\n                                    color: $sidebar-dark-menu-item-hover-color;\r\n                                }\r\n                            }\r\n\r\n                            >ul {\r\n                                a{\r\n                                    color: $sidebar-dark-menu-sub-item-color;\r\n                                    &:hover{\r\n                                        color: $sidebar-dark-menu-item-hover-color;\r\n                                    }\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n\r\n                    ul{\r\n                        background-color: $sidebar-dark-bg;\r\n                    }\r\n                    \r\n                }\r\n\r\n                ul{\r\n                    \r\n                    li{\r\n                        &.mm-active .active{\r\n                            color: $sidebar-menu-item-active-color !important;\r\n                            i{\r\n                                color: $sidebar-menu-item-active-color !important;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n\r\n            }\r\n\r\n\r\n        }\r\n    }\r\n    .mm-active {\r\n        color: $sidebar-dark-menu-item-active-color !important;\r\n        > i {\r\n            color: $sidebar-dark-menu-item-active-color !important;\r\n        }\r\n\r\n        >a {\r\n            background-color: $sidebar-menu-item-active-bg-color-dark;\r\n            color: $sidebar-dark-menu-item-active-color !important;\r\n            >i{\r\n                color: $sidebar-dark-menu-item-active-color !important;\r\n            }\r\n        }\r\n        .active {\r\n            color: $sidebar-dark-menu-item-active-color !important;\r\n\r\n            i {\r\n                color: $sidebar-dark-menu-item-active-color !important;\r\n            }\r\n        }\r\n    }\r\n\r\n    .menu-title {\r\n        color: $sidebar-dark-menu-item-icon-color;\r\n    }\r\n}\r\n\r\n\r\nbody[data-layout=\"horizontal\"] {\r\n    .main-content {\r\n        margin-left: 0 !important;\r\n    }\r\n}\r\n\r\n// Compact Sidebar\r\n\r\nbody[data-sidebar-size=\"small\"] {\r\n    .navbar-brand-box{\r\n        width: $sidebar-width-sm;\r\n        @media (max-width: 991.98px){\r\n            width: auto;\r\n        }\r\n    }\r\n    .vertical-menu{\r\n        width: $sidebar-width-sm;\r\n        text-align: center;\r\n\r\n        .has-arrow:after,\r\n        .badge {\r\n            display: none !important;\r\n        }\r\n\r\n        .vertical-menu-btn{\r\n            display: none;\r\n        }\r\n        \r\n    }\r\n    \r\n    .main-content {\r\n        margin-left: $sidebar-width-sm;\r\n    }\r\n    #page-topbar, .footer {\r\n        left: $sidebar-width-sm;\r\n        @media (max-width: 991.98px){\r\n            left: 0;\r\n        }\r\n    }\r\n\r\n    #sidebar-menu {\r\n        ul li {\r\n            &.menu-title{\r\n                background-color: darken($sidebar-bg, 2%);\r\n            }\r\n            a{\r\n                i{\r\n                    display: block;\r\n                }\r\n            }\r\n            ul.sub-menu {\r\n                li {\r\n                    a{\r\n                        padding-left: 1.5rem;\r\n                    }\r\n\r\n                    ul.sub-menu li a {\r\n                        padding-left: 1.5rem;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &[data-sidebar=\"dark\"] {\r\n        #sidebar-menu {\r\n            ul li {\r\n                &.menu-title{\r\n                    background-color: lighten($sidebar-dark-bg, 2%);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &:not(.vertical-collpsed) {\r\n        .navbar-header .vertical-menu-btn{\r\n            display: block;\r\n        }\r\n    }\r\n    &.vertical-collpsed {\r\n        .main-content {\r\n            margin-left: $sidebar-collapsed-width;\r\n        }\r\n        .vertical-menu {\r\n            #sidebar-menu{\r\n                text-align: left;\r\n                >ul{\r\n                    >li{\r\n                        >a {\r\n                            i{\r\n                                display: inline-block;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        #page-topbar, .footer {\r\n            left: $sidebar-collapsed-width;\r\n        }\r\n    }\r\n}\r\n\r\n// colored sidebar\r\n\r\nbody[data-sidebar=\"colored\"] {\r\n    .vertical-menu{\r\n        background-color: $primary;\r\n\r\n        .vertical-menu-btn{\r\n            color: rgba($white, 0.8);\r\n        }\r\n    }\r\n    .navbar-brand-box{\r\n        background-color: $primary;\r\n        .logo-dark{\r\n            display: none;\r\n        }\r\n        .logo-light{\r\n            display: block;\r\n        }\r\n    }\r\n\r\n    .mm-active {\r\n        color: $white !important;\r\n        > a {\r\n            background-color: rgba($white, 0.1);\r\n            color: $white !important;\r\n            >i{\r\n                color: $white !important;   \r\n            }\r\n        }\r\n        > i, .active {\r\n            color: $white !important;\r\n        }\r\n    }\r\n\r\n    #sidebar-menu {\r\n        ul {\r\n            li {\r\n                &.menu-title{\r\n                    color: rgba($white, 0.7);\r\n                }\r\n\r\n                a{\r\n                    color: rgba($white, 0.7);\r\n                    i{\r\n                        color: rgba($white, 0.7);\r\n                    }\r\n                    &.waves-effect {\r\n                        .waves-ripple {\r\n                          background: rgba($white, 0.1);\r\n                        }\r\n                    }\r\n                }\r\n\r\n                ul.sub-menu {\r\n                    li {\r\n                        a{\r\n                            color: rgba($white, 0.6);\r\n                        }\r\n                    }\r\n                }\r\n\r\n                .badge{\r\n                    &.badge-primary{\r\n                        background-color: $white;\r\n                        color: $primary;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.vertical-collpsed {\r\n        .vertical-menu {\r\n            #sidebar-menu{\r\n                >ul{\r\n                    >li{\r\n                        &:hover>a{\r\n                            background-color: lighten($primary, 2%);\r\n                            color: $white;\r\n                            i{\r\n                                color: $white;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n\r\n                ul{\r\n                    li{\r\n                        &.mm-active {\r\n                            .active{\r\n                                color: $sidebar-menu-item-active-color !important;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n","// \r\n// _horizontal.scss\r\n// \r\n\r\n.topnav {\r\n    background: #4360AB;\r\n    padding: 0 calc(#{$grid-gutter-width} / 2);\r\n    box-shadow: $box-shadow;\r\n    left: 0;\r\n    right: 0;\r\n    z-index: 1;\r\n    \r\n    .topnav-menu {\r\n        margin: 0;\r\n        padding: 0;\r\n    }\r\n\r\n    .navbar-nav {\r\n        \r\n        .nav-link {\r\n            font-size: 14.5px;\r\n            position: relative;\r\n            padding: 1rem 1.3rem;\r\n            color: #fff;\r\n            i{\r\n                font-size: 15px;\r\n            }\r\n            &:focus, &:hover{\r\n                color:  rgba(255, 255, 255, 0.6);;\r\n                background-color: transparent;\r\n            }\r\n        }\r\n        \r\n        .dropdown-item{\r\n            color: $menu-item-color;\r\n            &.active, &:hover{\r\n                color:  rgba(255, 255, 255, 0.6);\r\n                background-color: transparent;\r\n            }\r\n        }\r\n        \r\n        .nav-item{\r\n            .nav-link.active{\r\n                color: $menu-item-active-color;\r\n            }\r\n        }\r\n\r\n        .dropdown{\r\n            &.active{\r\n              >a {\r\n                    color: $menu-item-active-color;\r\n                    background-color: transparent;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\nbody[data-layout=\"horizontal\"] {\r\n    #page-topbar{\r\n        left: 0;\r\n        @media (min-width: 992px) {\r\n            padding: 0 calc(#{$grid-gutter-width} / 2);\r\n        }\r\n    }\r\n\r\n    .navbar-brand-box{\r\n        position: relative;\r\n        width: auto;\r\n        display: block;\r\n        background-color: transparent;\r\n\r\n        @media (min-width: 992px) {\r\n            padding-left: 0;\r\n        }\r\n    }\r\n\r\n    \r\n    @media (min-width: 992px) {\r\n        .topnav{\r\n            margin-top: 24px;\r\n            margin-bottom: -16px;\r\n            border-radius: 4px;\r\n        }\r\n\r\n        .navbar-header {\r\n            padding: 0 calc(#{$grid-gutter-width} / 2);\r\n        }\r\n    }\r\n\r\n\r\n}\r\n\r\n@include media-breakpoint-up(xl) {\r\n\r\n    body[data-layout=\"horizontal\"] {\r\n        .container-fluid,\r\n        .navbar-header {\r\n            max-width: 100%;\r\n        }\r\n    }\r\n}\r\n\r\n@include media-breakpoint-up(lg) {\r\n    .topnav {\r\n\r\n        .dropdown-item {\r\n            padding: .5rem 1.5rem;\r\n            min-width: 180px;\r\n        }\r\n\r\n        .dropdown {\r\n            &.mega-dropdown{\r\n                // position: static;\r\n                .mega-dropdown-menu{\r\n                    left: 0px;\r\n                    right: auto;\r\n                }\r\n            }\r\n            .dropdown-menu {\r\n                margin-top: 0;\r\n                border-radius: 0 0 $dropdown-border-radius $dropdown-border-radius;\r\n\r\n                .arrow-down {\r\n                    &::after {\r\n                        right: 15px;\r\n                        transform: rotate(-135deg) translateY(-50%);\r\n                        position: absolute;\r\n                    }\r\n                }\r\n\r\n                .dropdown {\r\n                    .dropdown-menu {\r\n                        position: absolute;\r\n                        top: 0 !important;\r\n                        left: 100%;\r\n                        display: none\r\n                    }\r\n                }\r\n            }\r\n\r\n            &:hover {\r\n                >.dropdown-menu {\r\n                    display: block;\r\n                }\r\n            }\r\n        }\r\n\r\n        .dropdown:hover>.dropdown-menu>.dropdown:hover>.dropdown-menu {\r\n            display: block\r\n        }\r\n    }\r\n\r\n    .navbar-toggle {\r\n        display: none;\r\n    }\r\n}\r\n\r\n.arrow-down {\r\n    display: inline-block;\r\n\r\n    &:after {\r\n        border-color: initial;\r\n        border-style: solid;\r\n        border-width: 0 0 1px 1px;\r\n        content: \"\";\r\n        height: .4em;\r\n        display: inline-block;\r\n        right: 5px;\r\n        top: 50%;\r\n        margin-left: 10px;\r\n        transform: rotate(-45deg) translateY(-50%);\r\n        transform-origin: top;\r\n        transition: all .3s ease-out;\r\n        width: .4em;\r\n    }\r\n}\r\n\r\n\r\n@include media-breakpoint-down(lg) {\r\n    .topnav-menu {\r\n        .navbar-nav {\r\n            li {\r\n                &:last-of-type {\r\n                    .dropdown {\r\n                        .dropdown-menu {\r\n                            right: 100%;\r\n                            left: auto;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media (max-width: 991.98px) {\r\n    .toggle_nav_option_desktop{\r\n        display: none;\r\n    }\r\n}\r\n@media (min-width: 991.98px) {\r\n    .toggle_nav_option_mobile{\r\n        display: none;\r\n    }\r\n}\r\n\r\n@media (max-width: 991.98px) {\r\n    body[data-layout=\"horizontal\"] {\r\n\r\n        .navbar-brand-box{\r\n            .logo-dark {\r\n                display: $display-block;\r\n                span.logo-sm{\r\n                    display: $display-block;\r\n                }\r\n            }\r\n        \r\n            .logo-light {\r\n                display: $display-none;\r\n                \r\n            }\r\n        }\r\n    }\r\n    \r\n    .topnav {\r\n        position: fixed;\r\n        max-height: 380px;\r\n        overflow-y: auto;\r\n        padding: 0;\r\n        .navbar-nav {\r\n            .nav-link {\r\n                padding: 0.5rem 1rem;\r\n            }\r\n        }\r\n\r\n        .dropdown {\r\n            .dropdown-menu {\r\n                background-color: transparent;\r\n                border: none;\r\n                box-shadow: none;\r\n                padding-left: 15px;\r\n                &.dropdown-mega-menu-xl{\r\n                    width: auto;\r\n    \r\n                    .row{\r\n                        margin: 0px;\r\n                    }\r\n                }\r\n            }\r\n\r\n            .dropdown-item {\r\n                position: relative;\r\n                background-color: transparent;\r\n\r\n                &.active,\r\n                &:active {\r\n                    color: $primary;\r\n                }\r\n            }\r\n        }\r\n\r\n        .arrow-down {\r\n            &::after {\r\n                right: 15px;\r\n                position: absolute;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n@include media-breakpoint-up(lg) {\r\n\r\n    body[data-layout=\"horizontal\"][data-topbar=\"light\"] {\r\n        .navbar-brand-box{\r\n            .logo-dark {\r\n                display: $display-block;\r\n            }\r\n        \r\n            .logo-light {\r\n                display: $display-none;\r\n            }\r\n        }\r\n\r\n        .topnav{\r\n            background-color: $primary;\r\n            .navbar-nav {\r\n        \r\n                .nav-link {\r\n                    color: rgba($white, 0.6);\r\n                    \r\n                    &:focus, &:hover{\r\n                        color: rgba($white, 0.9);\r\n                    }\r\n                }\r\n        \r\n                > .dropdown{\r\n                    &.active{\r\n                    >a {\r\n                            color: rgba($white, 0.9) !important;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// Colored Topbar \r\n\r\nbody[data-layout=\"horizontal\"][data-topbar=\"colored\"] {\r\n    #page-topbar{\r\n        background-color: $primary;\r\n        box-shadow: none;\r\n    }\r\n\r\n    .logo-dark {\r\n        display: none;\r\n    }\r\n\r\n    .logo-light {\r\n        display: block;\r\n    }\r\n\r\n    .app-search {\r\n    \r\n        .form-control {\r\n            background-color: rgba($topbar-search-bg,0.07);\r\n            color: $white;\r\n        }\r\n        span,\r\n        input.form-control::-webkit-input-placeholder {\r\n            color: rgba($white,0.5);\r\n        }\r\n    }\r\n    .header-item {\r\n        color: $header-dark-item-color;\r\n    \r\n        &:hover {\r\n            color: $header-dark-item-color;\r\n        }\r\n    }\r\n\r\n    .navbar-header {\r\n        .dropdown .show {\r\n            &.header-item{\r\n                background-color: rgba($white,0.1);\r\n            }\r\n        }\r\n\r\n        .waves-effect .waves-ripple {\r\n            background: rgba($white, 0.4);\r\n        }\r\n    }\r\n\r\n    .noti-icon {\r\n        i {\r\n            color: $header-dark-item-color;\r\n        }\r\n    }\r\n\r\n}\r\n\r\n","// \r\n// _layouts.scss\r\n// \r\n\r\nbody[data-layout-size=\"boxed\"] {\r\n    background-color: $boxed-body-bg;\r\n    #layout-wrapper {\r\n        background-color: $body-bg;\r\n        max-width: $boxed-layout-width;\r\n        margin: 0 auto;\r\n        box-shadow: $box-shadow;\r\n    }\r\n\r\n    #page-topbar {\r\n        max-width: calc(#{$boxed-layout-width} - #{$sidebar-width});\r\n        margin: 0 auto;\r\n    }\r\n\r\n    .footer {\r\n        margin: 0 auto;\r\n        max-width: calc(#{$boxed-layout-width} - #{$sidebar-width});\r\n    }\r\n\r\n    &.vertical-collpsed {\r\n        #page-topbar {\r\n            max-width: calc(#{$boxed-layout-width} - #{$sidebar-collapsed-width});\r\n        }\r\n        .footer {\r\n            max-width: calc(#{$boxed-layout-width} - #{$sidebar-collapsed-width});\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// Horizontal Boxed Layout\r\n\r\nbody[data-layout=\"horizontal\"][data-layout-size=\"boxed\"]{\r\n    #page-topbar, #layout-wrapper, .footer {\r\n        max-width: 100%;\r\n    }\r\n    .container-fluid, .navbar-header {\r\n        max-width: $boxed-layout-width;\r\n    }\r\n}","\r\n/*!\r\n * Waves v0.7.6\r\n * http://fian.my.id/Waves \r\n * \r\n * Copyright 2014-2018 Alfiana E. Sibuea and other contributors \r\n * Released under the MIT license \r\n * https://github.com/fians/Waves/blob/master/LICENSE */\r\n .waves-effect {\r\n    position: relative;\r\n    cursor: pointer;\r\n    display: inline-block;\r\n    overflow: hidden;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n    -webkit-tap-highlight-color: transparent;\r\n  }\r\n  .waves-effect .waves-ripple {\r\n    position: absolute;\r\n    border-radius: 50%;\r\n    width: 100px;\r\n    height: 100px;\r\n    margin-top: -50px;\r\n    margin-left: -50px;\r\n    opacity: 0;\r\n    background: rgba(0, 0, 0, 0.2);\r\n    background: -webkit-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n    background: -o-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n    background: -moz-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n    background: radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n    -webkit-transition: all 0.5s ease-out;\r\n    -moz-transition: all 0.5s ease-out;\r\n    -o-transition: all 0.5s ease-out;\r\n    transition: all 0.5s ease-out;\r\n    -webkit-transition-property: -webkit-transform, opacity;\r\n    -moz-transition-property: -moz-transform, opacity;\r\n    -o-transition-property: -o-transform, opacity;\r\n    transition-property: transform, opacity;\r\n    -webkit-transform: scale(0) translate(0, 0);\r\n    -moz-transform: scale(0) translate(0, 0);\r\n    -ms-transform: scale(0) translate(0, 0);\r\n    -o-transform: scale(0) translate(0, 0);\r\n    transform: scale(0) translate(0, 0);\r\n    pointer-events: none;\r\n  }\r\n  .waves-effect.waves-light .waves-ripple {\r\n    background: rgba(255, 255, 255, 0.4);\r\n    background: -webkit-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n    background: -o-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n    background: -moz-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n    background: radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n  }\r\n  .waves-effect.waves-classic .waves-ripple {\r\n    background: rgba(0, 0, 0, 0.2);\r\n  }\r\n  .waves-effect.waves-classic.waves-light .waves-ripple {\r\n    background: rgba(255, 255, 255, 0.4);\r\n  }\r\n  .waves-notransition {\r\n    -webkit-transition: none !important;\r\n    -moz-transition: none !important;\r\n    -o-transition: none !important;\r\n    transition: none !important;\r\n  }\r\n  .waves-button,\r\n  .waves-circle {\r\n    -webkit-transform: translateZ(0);\r\n    -moz-transform: translateZ(0);\r\n    -ms-transform: translateZ(0);\r\n    -o-transform: translateZ(0);\r\n    transform: translateZ(0);\r\n    -webkit-mask-image: -webkit-radial-gradient(circle, white 100%, black 100%);\r\n  }\r\n  .waves-button,\r\n  .waves-button:hover,\r\n  .waves-button:visited,\r\n  .waves-button-input {\r\n    white-space: nowrap;\r\n    vertical-align: middle;\r\n    cursor: pointer;\r\n    border: none;\r\n    outline: none;\r\n    color: inherit;\r\n    background-color: rgba(0, 0, 0, 0);\r\n    font-size: 1em;\r\n    line-height: 1em;\r\n    text-align: center;\r\n    text-decoration: none;\r\n    z-index: 1;\r\n  }\r\n  .waves-button {\r\n    padding: 0.85em 1.1em;\r\n    border-radius: 0.2em;\r\n  }\r\n  .waves-button-input {\r\n    margin: 0;\r\n    padding: 0.85em 1.1em;\r\n  }\r\n  .waves-input-wrapper {\r\n    border-radius: 0.2em;\r\n    vertical-align: bottom;\r\n  }\r\n  .waves-input-wrapper.waves-button {\r\n    padding: 0;\r\n  }\r\n  .waves-input-wrapper .waves-button-input {\r\n    position: relative;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 1;\r\n  }\r\n  .waves-circle {\r\n    text-align: center;\r\n    width: 2.5em;\r\n    height: 2.5em;\r\n    line-height: 2.5em;\r\n    border-radius: 50%;\r\n  }\r\n  .waves-float {\r\n    -webkit-mask-image: none;\r\n    -webkit-box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);\r\n    box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);\r\n    -webkit-transition: all 300ms;\r\n    -moz-transition: all 300ms;\r\n    -o-transition: all 300ms;\r\n    transition: all 300ms;\r\n  }\r\n  .waves-float:active {\r\n    -webkit-box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);\r\n    box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);\r\n  }\r\n  .waves-block {\r\n    display: block;\r\n  }\r\n\r\n.waves-effect.waves-light {\r\n    .waves-ripple {\r\n        background-color: rgba($white, 0.4);\r\n    }\r\n}\r\n\r\n.waves-effect.waves-primary {\r\n    .waves-ripple {\r\n        background-color: rgba($primary, 0.4);\r\n    }\r\n}\r\n.waves-effect.waves-success {\r\n    .waves-ripple {\r\n        background-color: rgba($success, 0.4);\r\n    }\r\n}\r\n.waves-effect.waves-info {\r\n    .waves-ripple {\r\n        background-color: rgba($info, 0.4);\r\n    }\r\n}\r\n.waves-effect.waves-warning {\r\n    .waves-ripple {\r\n        background-color: rgba($warning, 0.4);\r\n    }\r\n}\r\n.waves-effect.waves-danger {\r\n    .waves-ripple {\r\n        background-color: rgba($danger, 0.4);\r\n    }\r\n}","//\r\n// avatar.scss\r\n//\r\n\r\n.avatar-xs {\r\n  height: 2rem;\r\n  width: 2rem;\r\n}\r\n\r\n.avatar-sm {\r\n  height: 3rem;\r\n  width: 3rem;\r\n}\r\n\r\n.avatar-md {\r\n  height: 4.5rem;\r\n  width: 4.5rem;\r\n}\r\n\r\n.avatar-lg {\r\n  height: 6rem;\r\n  width: 6rem;\r\n}\r\n\r\n.avatar-xl {\r\n  height: 7.5rem;\r\n  width: 7.5rem;\r\n}\r\n\r\n.avatar-title {\r\n  align-items: center;\r\n  background-color: $primary;\r\n  color: $white;\r\n  display: flex;\r\n  font-weight: $font-weight-medium;\r\n  height: 100%;\r\n  justify-content: center;\r\n  width: 100%;\r\n}","\r\n//\r\n// alerts.scss\r\n//\r\n\r\n.alert-border{\r\n    background-color: $card-bg;\r\n    border-color: $light;\r\n    border-top: 2px solid $light;\r\n  }\r\n\r\n  // alert\r\n.alert-dismissible {\r\n    .btn-close{\r\n      font-size: 10px;\r\n      padding: $alert-padding-y * 1.4 $alert-padding-x;\r\n      box-shadow: none;\r\n      background: transparent escape-svg($btn-close-bg-dark) center / $btn-close-width auto no-repeat;\r\n    }\r\n}\r\n\r\n.alert-border{\r\n  .btn-close{\r\n    background: transparent escape-svg($btn-close-bg) center / $btn-close-width auto no-repeat;\r\n  }\r\n}\r\n  \r\n  @each $color,\r\n  $value in $theme-colors {\r\n      .alert-border-#{$color} {\r\n          border-top-color: $value;\r\n      }\r\n  }\r\n\r\n\r\n  ","\r\n//\r\n// accordion.scss\r\n//\r\n\r\n.custom-accordion {\r\n\r\n    .card {\r\n        + .card {\r\n            margin-top: 0.5rem;\r\n        }\r\n    }\r\n\r\n    a {\r\n\r\n        &.collapsed {\r\n            i.accor-down-icon {\r\n                &:before {\r\n                    content: \"\\F0140\";\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .card-body {\r\n        color: $text-muted;\r\n    }\r\n}","//\r\n// _helper.scss\r\n//\r\n\r\n.row > * {\r\n  position: relative;\r\n}\r\n\r\n.font-size-10 {\r\n  font-size: 10px !important;\r\n}\r\n\r\n.font-size-11 {\r\n  font-size: 11px !important;\r\n}\r\n\r\n.font-size-12 {\r\n  font-size: 12px !important;\r\n}\r\n\r\n.font-size-13 {\r\n  font-size: 13px !important;\r\n}\r\n\r\n.font-size-14 {\r\n  font-size: 14px !important;\r\n}\r\n\r\n.font-size-15 {\r\n  font-size: 15px !important;\r\n}\r\n\r\n.font-size-16 {\r\n  font-size: 16px !important;\r\n}\r\n\r\n.font-size-17 {\r\n  font-size: 17px !important;\r\n}\r\n\r\n.font-size-18 {\r\n  font-size: 18px !important;\r\n}\r\n\r\n.font-size-20 {\r\n  font-size: 20px !important;\r\n}\r\n\r\n.font-size-22 {\r\n  font-size: 22px !important;\r\n}\r\n\r\n.font-size-24 {\r\n  font-size: 24px !important;\r\n}\r\n\r\n\r\n// Font weight help class\r\n\r\n.fw-medium {\r\n  font-weight: $font-weight-medium;\r\n}\r\n\r\n.fw-semibold {\r\n  font-weight: $font-weight-semibold;\r\n}\r\n\r\n// Social\r\n\r\n.social-list-item {\r\n  height: 2rem;\r\n  width: 2rem;\r\n  line-height: calc(2rem - 2px);\r\n  display: block;\r\n  border: 1px solid $gray-500;\r\n  border-radius: 50%;\r\n  color: $gray-500;\r\n  text-align: center;\r\n  transition: all 0.4s;\r\n  &:hover{\r\n    color: $gray-600;\r\n    background-color: $gray-200;\r\n  }\r\n}\r\n\r\n\r\n.w-xs {\r\n  min-width: 80px;\r\n}\r\n.w-sm {\r\n  min-width: 95px;\r\n}\r\n.w-md {\r\n  min-width: 110px;\r\n}\r\n.w-lg {\r\n  min-width: 140px;\r\n}\r\n\r\n.w-xl {\r\n  min-width: 160px;\r\n}\r\n\r\n","// \r\n// preloader.scss\r\n//\r\n\r\n#preloader {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: $card-bg;\r\n    z-index: 9999;\r\n}\r\n\r\n#status {\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    margin: -20px 0 0 -20px;\r\n}\r\n\r\n.spinner{\r\n    .spin-icon {\r\n        font-size: 48px;\r\n        color: $primary;\r\n        position: relative;\r\n        display: inline-block;\r\n        animation: spin 1.6s infinite linear;\r\n    }\r\n}\r\n\r\n@keyframes spin {\r\n    0% {\r\n      transform: rotate(0deg);\r\n    }\r\n    100% {\r\n      transform: rotate(359deg);\r\n    }\r\n}","//\r\n// Forms.scss\r\n//\r\n\r\n\r\n.form-check{\r\n  position: relative;\r\n}\r\n\r\n\r\n  // checkbox input right\r\n.form-check-right{\r\n  padding-left: 0;\r\n  display: inline-block;\r\n  padding-right: $form-check-padding-start;;\r\n  .form-check-input{\r\n    float: right;\r\n    margin-left: 0;\r\n    margin-right: $form-check-padding-start * -1;\r\n  }\r\n  .form-check-label{\r\n    display: block;\r\n  }\r\n}\r\n\r\n// checkbox\r\n\r\n.form-checkbox-outline{\r\n  \r\n  .form-check-input{\r\n    border-width: 2px;\r\n    background-color: $card-bg;\r\n\r\n    &:active{\r\n      filter: none;\r\n    }\r\n\r\n    &:checked{\r\n      background-color: $card-bg !important;\r\n\r\n      &[type=checkbox]{\r\n        background-image: none;\r\n        \r\n      }\r\n\r\n      &:after{\r\n        position: absolute;\r\n        content: '\\F012C';\r\n        font-family: \"Material Design Icons\";\r\n        top: -4px !important;\r\n        left: 1px;\r\n        font-size: 16px;      \r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// radio\r\n\r\n.form-radio-outline{\r\n  .form-check-input{\r\n    border-width: 2px;\r\n    background-color: $card-bg;\r\n\r\n    &:active{\r\n      filter: none;\r\n    }\r\n\r\n    &:checked{\r\n      background-color: $card-bg !important;\r\n  \r\n      &[type=checkbox]{\r\n        background-image: none;\r\n        \r\n      }\r\n  \r\n      &:after{\r\n        position: absolute;\r\n        content: '\\F0765';\r\n        font-family: \"Material Design Icons\";\r\n        top: 6px!important;\r\n        left: 4px;\r\n        font-size: 6px;    \r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// checkbox color\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n  .form-check-#{$color}{\r\n    .form-check-input{\r\n      &:checked{\r\n        background-color: $value;\r\n        border-color: $value;\r\n      }\r\n    }\r\n  }\r\n\r\n  .form-radio-#{$color}{\r\n    .form-check-input{\r\n      &:checked{\r\n        border-color: $value;\r\n        background-color: $value;\r\n        &:after{\r\n          color: $value;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.form-check,.form-check-input, .form-check-label{\r\n  cursor: pointer;\r\n  margin-bottom: 0;\r\n}\r\n\r\n// Switch sizes\r\n\r\n.form-check{\r\n  position: relative;\r\n  text-align: left /*rtl: right*/;\r\n}\r\n\r\n.form-switch-md{\r\n  padding-left: 2.5rem;\r\n  min-height: 24px;\r\n  line-height: 24px;\r\n  .form-check-input{\r\n    width: 40px;\r\n    height: 20px;\r\n    left: -0.5rem;\r\n    position: relative;\r\n  }\r\n\r\n  .form-check-label{\r\n    vertical-align: middle;\r\n  }\r\n}\r\n\r\n\r\n.form-switch-lg{\r\n  padding-left: 2.75rem;\r\n  min-height: 28px;\r\n  line-height: 28px;\r\n  .form-check-input{\r\n    width: 48px;\r\n    height: 24px;\r\n    left: -0.75rem;\r\n    position: relative;\r\n  }\r\n}\r\n\r\n.input-group-text{\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.custom-control-label::before{\r\n  background-color: $input-bg;\r\n}\r\n","// \r\n// Widgets.scss\r\n// \r\n\r\n.main-chart {\r\n    .chart-border-left {\r\n        border-left: 1.4px solid $border-color;\r\n        padding: 2px 20px;\r\n\r\n        &:last-child {\r\n            margin-right: 0px;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n/* Activity */\r\n\r\n.activity-feed {\r\n    list-style: none;\r\n\r\n    .feed-item {\r\n        position: relative;\r\n        padding-bottom: 27px;\r\n        padding-left: 16px;\r\n        border-left: 2px solid $light;\r\n\r\n        &:after {\r\n            content: \"\";\r\n            display: block;\r\n            position: absolute;\r\n            top: 4px;\r\n            left: -6px;\r\n            width: 10px;\r\n            height: 10px;\r\n            border-radius: 50%;\r\n            border: 2px solid $primary;\r\n            background-color: $card-bg;\r\n        }\r\n\r\n        &:last-child {\r\n            border-color: transparent;\r\n        }\r\n    }\r\n}","// \r\n// _demos.scss\r\n// \r\n\r\n// Demo Only\r\n.button-items {\r\n    margin-left: -8px;\r\n    margin-bottom: -12px;\r\n    \r\n    .btn {\r\n        margin-bottom: 12px;\r\n        margin-left: 8px;\r\n    }\r\n}\r\n\r\n// Lightbox \r\n\r\n.mfp-popup-form {\r\n    max-width: 1140px;\r\n}\r\n\r\n// Modals\r\n\r\n.bs-example-modal {\r\n    position: relative;\r\n    top: auto;\r\n    right: auto;\r\n    bottom: auto;\r\n    left: auto;\r\n    z-index: 1;\r\n    display: block;\r\n  }\r\n\r\n\r\n// Icon demo ( Demo only )\r\n.icon-demo-content {\r\n    text-align: center;\r\n    color: $gray-500;\r\n  \r\n    i{\r\n      display: block;\r\n      width: 40px;\r\n      height: 40px;\r\n      line-height: 36px;\r\n      font-size: 24px;\r\n      margin: 0px auto 16px;\r\n      border: 2px solid $gray-300;\r\n      color: $gray-600;\r\n      border-radius: 4px;\r\n      transition: all 0.4s;\r\n    }\r\n  \r\n    .col-lg-4 {\r\n      margin-top: 24px;\r\n  \r\n      &:hover {\r\n        i {\r\n          color: $white;\r\n          background-color: $primary;\r\n          border-color: $primary;\r\n        }\r\n      }\r\n    }\r\n}\r\n\r\n\r\n// Grid\r\n\r\n.grid-structure {\r\n    .grid-container {\r\n        background-color: $gray-100;\r\n        margin-top: 10px;\r\n        font-size: .8rem;\r\n        font-weight: $font-weight-medium;\r\n        padding: 10px 20px;\r\n    }\r\n}\r\n\r\n\r\n// card radio\r\n\r\n.card-radio{\r\n  background-color: $card-bg;\r\n  border: 2px solid $card-border-color;\r\n  border-radius: $border-radius;\r\n  padding: 1rem;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  display: block;\r\n\r\n  &:hover{\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n.card-radio-label{\r\n  display: block;\r\n}\r\n\r\n\r\n.card-radio-input{\r\n  display: none;\r\n  &:checked + .card-radio {\r\n    border-color: $primary !important;\r\n\r\n    &:before{\r\n      content: '\\e9c3';\r\n      font-family: \"unicons-line\";\r\n      position: absolute;\r\n      top: 5px;\r\n      right: 20px;\r\n      font-size: 22px;\r\n      color: $primary;\r\n    }\r\n  }\r\n}\r\n\r\n.navs-carousel{\r\n  .owl-nav{\r\n      margin-top: 16px;\r\n      button{\r\n          width: 30px;\r\n          height: 30px;\r\n          line-height: 28px !important;\r\n          font-size: 20px !important;\r\n          border-radius: 50% !important;\r\n          background-color: rgba($primary, 0.25) !important;\r\n          color: $primary !important;\r\n          margin: 4px 8px !important;\r\n      }\r\n  }\r\n}\r\n\r\n\r\n\r\n","// \r\n// print.scss\r\n//\r\n\r\n// Used invoice page\r\n@media print {\r\n    .vertical-menu,\r\n    .right-bar,\r\n    .page-title-box,\r\n    .navbar-header,\r\n    .footer {\r\n        display: none !important;\r\n    }\r\n    .card-body,\r\n    .main-content,\r\n    .right-bar,\r\n    .page-content,\r\n    body {\r\n        padding: 0;\r\n        margin: 0;\r\n    }\r\n\r\n    .card{\r\n        border: 0;\r\n    }\r\n}","[data-simplebar] {\r\n  position: relative;\r\n  flex-direction: column;\r\n  flex-wrap: wrap;\r\n  justify-content: flex-start;\r\n  align-content: flex-start;\r\n  align-items: flex-start;\r\n}\r\n\r\n.simplebar-wrapper {\r\n  overflow: hidden;\r\n  width: inherit;\r\n  height: inherit;\r\n  max-width: inherit;\r\n  max-height: inherit;\r\n}\r\n\r\n.simplebar-mask {\r\n  direction: inherit;\r\n  position: absolute;\r\n  overflow: hidden;\r\n  padding: 0;\r\n  margin: 0;\r\n  left: 0;\r\n  top: 0;\r\n  bottom: 0;\r\n  right: 0;\r\n  width: auto !important;\r\n  height: auto !important;\r\n  z-index: 0;\r\n}\r\n\r\n.simplebar-offset {\r\n  direction: inherit !important;\r\n  box-sizing: inherit !important;\r\n  resize: none !important;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0 !important;\r\n  bottom: 0;\r\n  right: 0 !important;\r\n  padding: 0;\r\n  margin: 0;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.simplebar-content-wrapper {\r\n  direction: inherit;\r\n  box-sizing: border-box !important;\r\n  position: relative;\r\n  display: block;\r\n  height: 100%; /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */\r\n  width: auto;\r\n  visibility: visible;\r\n  overflow: auto; /* Scroll on this element otherwise element can't have a padding applied properly */\r\n  max-width: 100%; /* Not required for horizontal scroll to trigger */\r\n  max-height: 100%; /* Needed for vertical scroll to trigger */\r\n  scrollbar-width: none;\r\n  padding: 0px !important;\r\n}\r\n\r\n.simplebar-content-wrapper::-webkit-scrollbar,\r\n.simplebar-hide-scrollbar::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n.simplebar-content:before,\r\n.simplebar-content:after {\r\n  content: ' ';\r\n  display: table;\r\n}\r\n\r\n.simplebar-placeholder {\r\n  max-height: 100%;\r\n  max-width: 100%;\r\n  width: 100%;\r\n  pointer-events: none;\r\n}\r\n\r\n.simplebar-height-auto-observer-wrapper {\r\n  box-sizing: inherit !important;\r\n  height: 100%;\r\n  width: 100%;\r\n  max-width: 1px;\r\n  position: relative;\r\n  float: left;\r\n  max-height: 1px;\r\n  overflow: hidden;\r\n  z-index: -1;\r\n  padding: 0;\r\n  margin: 0;\r\n  pointer-events: none;\r\n  flex-grow: inherit;\r\n  flex-shrink: 0;\r\n  flex-basis: 0;\r\n}\r\n\r\n.simplebar-height-auto-observer {\r\n  box-sizing: inherit;\r\n  display: block;\r\n  opacity: 0;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  height: 1000%;\r\n  width: 1000%;\r\n  min-height: 1px;\r\n  min-width: 1px;\r\n  overflow: hidden;\r\n  pointer-events: none;\r\n  z-index: -1;\r\n}\r\n\r\n.simplebar-track {\r\n  z-index: 1;\r\n  position: absolute;\r\n  right: 0;\r\n  bottom: 0;\r\n  pointer-events: none;\r\n  overflow: hidden;\r\n}\r\n\r\n[data-simplebar].simplebar-dragging .simplebar-content {\r\n  pointer-events: none;\r\n  user-select: none;\r\n  -webkit-user-select: none;\r\n}\r\n\r\n[data-simplebar].simplebar-dragging .simplebar-track {\r\n  pointer-events: all;\r\n}\r\n\r\n.simplebar-scrollbar {\r\n  position: absolute;\r\n  right: 2px;\r\n  width: 6px;\r\n  min-height: 10px;\r\n}\r\n\r\n.simplebar-scrollbar:before {\r\n  position: absolute;\r\n  content: '';\r\n  background: #a2adb7;\r\n  border-radius: 7px;\r\n  left: 0;\r\n  right: 0;\r\n  opacity: 0;\r\n  transition: opacity 0.2s linear;\r\n}\r\n\r\n.simplebar-scrollbar.simplebar-visible:before {\r\n  /* When hovered, remove all transitions from drag handle */\r\n  opacity: 0.5;\r\n  transition: opacity 0s linear;\r\n}\r\n\r\n.simplebar-track.simplebar-vertical {\r\n  top: 0;\r\n  width: 11px;\r\n}\r\n\r\n.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {\r\n  top: 2px;\r\n  bottom: 2px;\r\n}\r\n\r\n.simplebar-track.simplebar-horizontal {\r\n  left: 0;\r\n  height: 11px;\r\n}\r\n\r\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {\r\n  height: 100%;\r\n  left: 2px;\r\n  right: 2px;\r\n}\r\n\r\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar {\r\n  right: auto;\r\n  left: 0;\r\n  top: 2px;\r\n  height: 7px;\r\n  min-height: 0;\r\n  min-width: 10px;\r\n  width: auto;\r\n}\r\n\r\n/* Rtl support */\r\n[data-simplebar-direction='rtl'] .simplebar-track.simplebar-vertical {\r\n  right: auto;\r\n  left: 0;\r\n}\r\n\r\n.hs-dummy-scrollbar-size {\r\n  direction: rtl;\r\n  position: fixed;\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  height: 500px;\r\n  width: 500px;\r\n  overflow-y: hidden;\r\n  overflow-x: scroll;\r\n}\r\n\r\n.simplebar-hide-scrollbar {\r\n  position: fixed;\r\n  left: 0;\r\n  visibility: hidden;\r\n  overflow-y: scroll;\r\n  scrollbar-width: none;\r\n}\r\n\r\n.custom-scroll {\r\n  height: 100%;\r\n}","/* ==============\r\n  Calendar\r\n===================*/\r\n\r\n\r\n.fc td, .fc th{\r\n    border: $table-border-width solid $table-border-color;\r\n}\r\n\r\n\r\n\r\n.fc {\r\n    .fc-toolbar {\r\n        h2 {\r\n            font-size: 16px;\r\n            line-height: 30px;\r\n            text-transform: uppercase;\r\n        }\r\n\r\n        @media (max-width: 767.98px) {\r\n\r\n            .fc-left,\r\n            .fc-right,\r\n            .fc-center {\r\n                float: none;\r\n                display: block;\r\n                text-align: center;\r\n                clear: both;\r\n                margin: 10px 0;\r\n            }\r\n\r\n            >*>* {\r\n                float: none;\r\n            }\r\n\r\n            .fc-today-button {\r\n                display: none;\r\n            }\r\n        }\r\n\r\n        .btn {\r\n            text-transform: capitalize;\r\n        }\r\n\r\n    }\r\n}\r\n\r\n.fc {\r\n    th.fc-widget-header {\r\n        background: $gray-300;\r\n        color: $gray-700;\r\n        line-height: 20px;\r\n        padding: 10px 0;\r\n        text-transform: uppercase;\r\n        font-weight: $font-weight-bold;\r\n    }\r\n}\r\n\r\n.fc-unthemed {\r\n\r\n    .fc-content,\r\n    .fc-divider,\r\n    .fc-list-heading td,\r\n    .fc-list-view,\r\n    .fc-popover,\r\n    .fc-row,\r\n    tbody,\r\n    td,\r\n    th,\r\n    thead {\r\n        border-color: $gray-300;\r\n    }\r\n\r\n    td.fc-today {\r\n        background: lighten($gray-200, 2%);\r\n    }\r\n}\r\n\r\n.fc-button {\r\n    background: $card-bg;\r\n    border-color: $border-color;\r\n    color: $gray-700;\r\n    text-transform: capitalize;\r\n    box-shadow: none;\r\n    padding: 6px 12px !important;\r\n    height: auto !important;\r\n}\r\n\r\n.fc-state-down,\r\n.fc-state-active,\r\n.fc-state-disabled {\r\n    background-color: $primary;\r\n    color: $white;\r\n    text-shadow: none;\r\n}\r\n\r\n.fc-event {\r\n    border-radius: 2px;\r\n    border: none;\r\n    cursor: move;\r\n    font-size: 0.8125rem;\r\n    margin: 5px 7px;\r\n    padding: 5px 5px;\r\n    text-align: center;\r\n}\r\n\r\n.fc-event,\r\n.fc-event-dot {\r\n    background-color: $primary;\r\n}\r\n\r\n.fc-event .fc-content {\r\n    color: $white;\r\n}\r\n\r\n#external-events {\r\n    .external-event {\r\n        text-align: left;\r\n        padding: 8px 16px;\r\n    }\r\n}\r\n\r\n\r\n.fc-day-grid-event.fc-h-event.fc-event.fc-start.fc-end.bg-dark {\r\n    .fc-content{\r\n      color: $light;  \r\n    }\r\n  }\r\n  \r\n\r\n// RTL\r\n[dir=\"rtl\"]{\r\n    .fc-header-toolbar {\r\n        direction: ltr !important;\r\n    }\r\n\r\n    .fc-toolbar>*>:not(:first-child) {\r\n        margin-left: .75em;\r\n    }\r\n}\r\n","//\r\n// session-timeout.scss\r\n//\r\n\r\n#session-timeout-dialog {\r\n    .close {\r\n        display: none;\r\n    }\r\n\r\n    .countdown-holder {\r\n        color: $danger;\r\n        font-weight: $font-weight-medium;\r\n    }\r\n\r\n    .btn-default {\r\n        background-color: $white;\r\n        color: $danger;\r\n        box-shadow: none;\r\n    }\r\n}","\r\n//\r\n// Range slider\r\n//\r\n\r\n.irs {\r\n  font-family: $font-family-base;\r\n}\r\n\r\n.irs--round{\r\n  .irs-bar, .irs-to, .irs-from, .irs-single {\r\n    background: $primary !important;\r\n    font-size: 11px;\r\n  }\r\n  .irs-to, .irs-from, .irs-single{\r\n    &:before{\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  .irs-line{\r\n    background: $gray-300;\r\n    border-color: $gray-300;\r\n  }\r\n  .irs-grid-text{\r\n    font-size: 11px;\r\n    color: $gray-500;\r\n  }\r\n  .irs-min, .irs-max{\r\n    color: $gray-500;\r\n    background: $gray-300;\r\n    font-size: 11px;\r\n  }\r\n\r\n  .irs-handle{\r\n    border: 1px solid $primary;\r\n    width: 6px;\r\n    height: 16px;\r\n    top: 29px;\r\n    background-color: $card-bg !important;\r\n  }\r\n}","\r\n//\r\n//  Sweetalert2\r\n//\r\n\r\n.swal2-container {\r\n  .swal2-title{\r\n    font-size: 24px;\r\n    font-weight: $font-weight-medium;\r\n  }  \r\n}\r\n\r\n.swal2-content{\r\n  font-size: 16px;\r\n}\r\n\r\n.swal2-icon{\r\n  &.swal2-question{\r\n    border-color: $info;\r\n    color: $info;\r\n  }\r\n  &.swal2-success {\r\n    [class^=swal2-success-line]{\r\n      background-color: $success;\r\n    }\r\n\r\n    .swal2-success-ring{\r\n      border-color: rgba($success, 0.3);\r\n    }\r\n  }\r\n  &.swal2-warning{\r\n    border-color: $warning;\r\n    color: $warning;\r\n  }\r\n}\r\n\r\n.swal2-styled{\r\n  &:focus{\r\n    box-shadow: none;\r\n  }\r\n}\r\n\r\n.swal2-progress-steps {\r\n  .swal2-progress-step{\r\n    background: $primary;\r\n    &.swal2-active-progress-step{\r\n      background: $primary;\r\n      &~.swal2-progress-step, &~.swal2-progress-step-line{\r\n        background: rgba($primary, 0.3);\r\n      }\r\n    }\r\n  }\r\n\r\n  .swal2-progress-step-line{\r\n    background: $primary;\r\n  }\r\n}\r\n\r\n.swal2-loader{\r\n  border-color: $primary transparent $primary transparent;\r\n}\r\n","\r\n//\r\n// Rating\r\n//\r\n\r\n.br-wrapper{\r\n  display: inline-block;\r\n}\r\n\r\n.br-theme-fontawesome-stars, .br-theme-css-stars {\r\n  .br-widget {\r\n    a{\r\n      font-weight: 900;\r\n\r\n      &.br-selected{\r\n        &:after{\r\n          color: $warning;\r\n        }\r\n      }\r\n  \r\n    }\r\n  }\r\n}\r\n\r\n.br-theme-fontawesome-stars {\r\n  .br-widget {\r\n    a{\r\n      font-weight: 900;\r\n  \r\n    }\r\n  }\r\n}\r\n\r\n.br-theme-fontawesome-stars, .br-theme-fontawesome-stars-o {\r\n  .br-widget {\r\n    a{\r\n      font-family: 'Font Awesome 5 Free'\r\n    }\r\n  }\r\n}\r\n\r\n.br-theme-fontawesome-stars-o {\r\n  .br-widget a{\r\n\r\n    &.br-selected, &.br-active, &.br-fractional{\r\n      &:after{\r\n        font-weight: 900;\r\n        color: $success;\r\n      }\r\n    }\r\n\r\n    &.br-fractional:after, &:after{\r\n      content: '\\f005';\r\n    }\r\n  }\r\n}\r\n\r\n\r\n.hidden {\r\n  display: none !important;\r\n  visibility: hidden;\r\n}\r\n\r\n\r\n// rating 1to10\r\n\r\n.br-theme-bars-1to10 .br-widget {\r\n  .br-current-rating{\r\n    line-height: inherit;\r\n  }\r\n}","\r\n//\r\n// toastr.scss\r\n//\r\n\r\n\r\n/* =============\r\n   Notification\r\n============= */\r\n#toast-container {\r\n    > div {\r\n        box-shadow: $box-shadow;\r\n        opacity: 1;\r\n        &:hover {\r\n            box-shadow: $box-shadow;\r\n            opacity: 0.9;\r\n        }\r\n    }\r\n\r\n    &.toast-top-full-width, &.toast-bottom-full-width{\r\n        > div{\r\n          min-width: 96%;\r\n          margin: 4px auto;\r\n        }\r\n      }\r\n\r\n}\r\n\r\n\r\n@each $color, $value in $theme-colors {\r\n    .toast-#{$color} {\r\n        border: 2px solid $value !important;\r\n        background-color: rgba(($value), 0.8) !important;\r\n    }\r\n}\r\n\r\n\r\n// for error\r\n\r\n.toast-error {\r\n    background-color: rgba($danger,0.8);\r\n    border: 2px solid $danger;\r\n}\r\n\r\n.toastr-options{\r\n    padding: 24px;\r\n    background-color: lighten($gray-200, 2%);\r\n    margin-bottom: 0;\r\n    border: 1px solid $border-color;\r\n}","\r\n//\r\n// Parsley\r\n//\r\n\r\n.error {\r\n  color: $danger;\r\n}\r\n\r\n.parsley-error {\r\n  border-color: $danger;\r\n}\r\n\r\n.parsley-errors-list {\r\n  display: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  &.filled {\r\n    display: block;\r\n  }\r\n  > li {\r\n    font-size: 12px;\r\n    list-style: none;\r\n    color: $danger;\r\n    margin-top: 5px;\r\n  }\r\n}","\r\n//\r\n// Select 2\r\n//\r\n\r\n.select2-container {\r\n\r\n  .select2-selection--single {\r\n    background-color: $input-bg;\r\n    border: 1px solid $input-border-color;\r\n    height: 38px;\r\n    &:focus{\r\n      outline: none;\r\n    }\r\n\r\n    .select2-selection__rendered {\r\n      line-height: 36px;\r\n      padding-left: 12px;\r\n      color: $input-color;\r\n    }\r\n\r\n    .select2-selection__arrow {\r\n      height: 34px;\r\n      width: 34px;\r\n      right: 3px;\r\n\r\n      b{\r\n        border-color: $gray-500 transparent transparent transparent;\r\n        border-width: 6px 6px 0 6px;\r\n      }\r\n    }\r\n\r\n    .select2-selection__placeholder{\r\n      color: $body-color;\r\n    }\r\n  }\r\n}\r\n\r\n.select2-container--open {\r\n  .select2-selection--single {\r\n\r\n    .select2-selection__arrow {\r\n\r\n      b{\r\n        border-color: transparent transparent $gray-500 transparent !important;\r\n        border-width: 0 6px 6px 6px !important;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.select2-container--default {\r\n  .select2-search--dropdown {\r\n      padding: 10px;\r\n      background-color: $dropdown-bg;\r\n      .select2-search__field {\r\n          border: 1px solid  $input-border-color;\r\n          background-color: $input-bg;\r\n          color: $gray-600;\r\n          outline: none;\r\n      }\r\n  }\r\n  .select2-results__option--highlighted[aria-selected] {\r\n      background-color: $primary;\r\n  }\r\n  .select2-results__option[aria-selected=true] {\r\n      background-color: $dropdown-link-active-bg;\r\n      color: $dropdown-link-active-color;\r\n      &:hover {\r\n          background-color: $primary;\r\n          color: $white;\r\n      }\r\n  }\r\n}\r\n\r\n.select2-results__option {\r\n  padding: 6px 12px;\r\n}\r\n\r\n.select2-dropdown {\r\n  border: 1px solid $dropdown-border-color;\r\n  background-color: $dropdown-bg;\r\n  box-shadow: $box-shadow;\r\n}\r\n\r\n.select2-search {\r\n  input{\r\n    border: 1px solid $gray-300;\r\n  }\r\n}\r\n\r\n.select2-container {\r\n  .select2-selection--multiple {\r\n    min-height: 38px;\r\n    background-color: $input-bg;\r\n    border: 1px solid $input-border-color !important;\r\n  \r\n    .select2-selection__rendered {\r\n      padding: 2px 10px;\r\n    }\r\n    .select2-search__field {\r\n      border: 0;\r\n      color: $input-color;\r\n      &::placeholder{\r\n          color: $input-color;\r\n      }\r\n  }\r\n    .select2-selection__choice {\r\n      background-color: $gray-200;\r\n      border: 1px solid $gray-300;\r\n      border-radius: 1px;\r\n      padding: 0 7px;\r\n    }\r\n  }\r\n}\r\n\r\n.select2-container--default{\r\n  &.select2-container--focus {\r\n    .select2-selection--multiple{\r\n      border-color: $gray-400;\r\n    }\r\n  }\r\n\r\n  .select2-results__group{\r\n    font-weight: $font-weight-semibold;\r\n  }\r\n}\r\n\r\n// ajax select\r\n\r\n.select2-result-repository__avatar{\r\n    float: left;\r\n    width: 60px;\r\n    margin-right: 10px;\r\n  img{\r\n    width: 100%;\r\n    height: auto;\r\n    border-radius: 2px;\r\n  }\r\n}\r\n\r\n.select2-result-repository__statistics{\r\n  margin-top: 7px;\r\n}\r\n\r\n.select2-result-repository__forks, \r\n.select2-result-repository__stargazers, \r\n.select2-result-repository__watchers{\r\n  display: inline-block;\r\n  font-size: 11px;\r\n  margin-right: 1em;\r\n  color: $gray-500;\r\n\r\n  .fa{\r\n    margin-right: 4px;\r\n\r\n    &.fa-flash{\r\n      &::before{\r\n        content: \"\\f0e7\";\r\n        font-family: 'Font Awesome 5 Free';\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.select2-results__option--highlighted{\r\n  .select2-result-repository__forks, \r\n.select2-result-repository__stargazers, \r\n.select2-result-repository__watchers{\r\n  color: rgba($white, 0.8);\r\n}\r\n}\r\n\r\n.select2-result-repository__meta{\r\n  overflow: hidden;\r\n}\r\n\r\n\r\n// templating-select\r\n\r\n.img-flag{\r\n  margin-right: 7px;\r\n  height: 15px;\r\n  width: 18px;\r\n}\r\n\r\n\r\n","//\r\n//  Sweetalert2\r\n//\r\n\r\n/* CSS Switch */\r\ninput[switch] {\r\n  display: none;\r\n  + label {\r\n    font-size: 1em;\r\n    line-height: 1;\r\n    width: 56px;\r\n    height: 24px;\r\n    background-color: $gray-400;\r\n    background-image: none;\r\n    border-radius: 2rem;\r\n    padding: 0.16667rem;\r\n    cursor: pointer;\r\n    display: inline-block;\r\n    text-align: center;\r\n    position: relative;\r\n    font-weight: $font-weight-medium;\r\n    transition: all 0.1s ease-in-out;\r\n    &:before {\r\n      color: $dark;\r\n      content: attr(data-off-label);\r\n      display: block;\r\n      font-family: inherit;\r\n      font-weight: 500;\r\n      font-size: 12px;\r\n      line-height: 21px;\r\n      position: absolute;\r\n      right: 1px;\r\n      margin: 3px;\r\n      top: -2px;\r\n      text-align: center;\r\n      min-width: 1.66667rem;\r\n      overflow: hidden;\r\n      transition: all 0.1s ease-in-out;\r\n    }\r\n\r\n    &:after {\r\n      content: '';\r\n      position: absolute;\r\n      left: 3px;\r\n      background-color: $gray-200;\r\n      box-shadow: none;\r\n      border-radius: 2rem;\r\n      height: 20px;\r\n      width: 20px;\r\n      top: 2px;\r\n      transition: all 0.1s ease-in-out;\r\n    }\r\n  }\r\n\r\n  &:checked + label {\r\n    background-color: $primary;\r\n  }\r\n}\r\n\r\ninput[switch]:checked + label {\r\n  background-color: $primary;\r\n  &:before {\r\n    color: $white;\r\n    content: attr(data-on-label);\r\n    right: auto;\r\n    left: 3px;\r\n  }\r\n\r\n  &:after {\r\n    left: 33px;\r\n    background-color: $gray-200;\r\n  }\r\n}\r\n\r\ninput[switch=\"bool\"] + label {\r\n  background-color: $danger;\r\n}\r\ninput[switch=\"bool\"] + label:before,input[switch=\"bool\"]:checked + label:before,\r\ninput[switch=\"default\"]:checked + label:before{\r\n  color: $white;\r\n}\r\n\r\ninput[switch=\"bool\"]:checked + label {\r\n  background-color: $success;\r\n}\r\n\r\ninput[switch=\"default\"]:checked + label {\r\n  background-color: #a2a2a2;\r\n}\r\n\r\ninput[switch=\"primary\"]:checked + label {\r\n  background-color: $primary;\r\n}\r\n\r\ninput[switch=\"success\"]:checked + label {\r\n  background-color: $success;\r\n}\r\n\r\ninput[switch=\"info\"]:checked + label {\r\n  background-color: $info;\r\n}\r\n\r\ninput[switch=\"warning\"]:checked + label {\r\n  background-color: $warning;\r\n}\r\n\r\ninput[switch=\"danger\"]:checked + label {\r\n  background-color: $danger;\r\n}\r\n\r\ninput[switch=\"dark\"]:checked + label {\r\n  background-color: $dark;\r\n}\r\n\r\n.square-switch{\r\n  margin-right: 7px;\r\n  input[switch]+label, input[switch]+label:after{\r\n    border-radius: 4px;\r\n  }\r\n}","\r\n//\r\n// colorpicker.scss\r\n//\r\n\r\n.sp-container{\r\n  background-color: $dropdown-bg;\r\n  z-index: 999;\r\n  button{\r\n    padding: .25rem .5rem;\r\n      font-size: .71094rem;\r\n      border-radius: .2rem;\r\n      font-weight: 400;\r\n      color: $dark;\r\n  \r\n      &.sp-palette-toggle{\r\n        background-color: $light;\r\n      }\r\n      \r\n      &.sp-choose{\r\n        background-color: $success;\r\n      }\r\n  }\r\n}\r\n\r\n.sp-palette-container{\r\n  border-color: $border-color;\r\n}\r\n\r\n.sp-input{\r\n  background-color: $input-bg;\r\n  border-color: $input-border-color !important;\r\n  color: $input-color;\r\n  &:focus{\r\n    outline: none;\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n[dir=\"rtl\"]{\r\n\r\n  .sp-alpha{\r\n    direction: rtl;\r\n  }\r\n\r\n  .sp-original-input-container {\r\n    .sp-add-on{\r\n      border-top-right-radius: 0!important;\r\n      border-bottom-right-radius: 0!important;\r\n      border-top-left-radius: 4px!important;\r\n      border-bottom-left-radius: 4px!important\r\n    }\r\n  } \r\n\r\n  input.spectrum.with-add-on{\r\n    border: 1px solid $input-border-color;\r\n    border-left: 0;\r\n    border-top-left-radius: 0;\r\n    border-bottom-left-radius: 0;\r\n    border-top-right-radius: $input-border-radius;\r\n    border-bottom-right-radius: $input-border-radius;\r\n\r\n  }\r\n}","\r\n//\r\n// Datepicker\r\n//\r\n\r\n[dir=\"rtl\"]{\r\n  .datepicker {\r\n    right: 0 !important;\r\n    left: auto;\r\n  }\r\n}\r\n\r\n[dir=\"rtl\"]{\r\n  .bootstrap-timepicker-widget{\r\n    right: 0 !important;\r\n    left: auto;\r\n    \r\n  }\r\n\r\n  .timepicker-orient-top{\r\n    top: $input-height !important;\r\n  }\r\n\r\n  .timepicker-orient-bottom{\r\n    top: auto !important;\r\n    bottom: $input-height !important;\r\n  }\r\n}\r\n\r\n.datepicker {\r\n  border: 1px solid $border-color;\r\n  padding: 8px;\r\n  z-index: 999 !important;\r\n  \r\n\r\n  table{\r\n    tr{\r\n      th{\r\n        font-weight: 500;\r\n      }\r\n      td{\r\n        &.active, &.active:hover, .active.disabled, &.active.disabled:hover,\r\n        &.today,  &.today:hover, &.today.disabled, &.today.disabled:hover, \r\n        &.selected, &.selected:hover, &.selected.disabled, &.selected.disabled:hover,\r\n        span.active.active, span.active:hover.active{\r\n          background-color: $primary !important;\r\n          background-image: none;\r\n          box-shadow: none;\r\n          color: $white !important;\r\n        }\r\n\r\n        &.day.focused,\r\n        &.day:hover,\r\n        span.focused,\r\n        span:hover {\r\n            background: $light;\r\n        }\r\n\r\n        &.new,\r\n        &.old,\r\n        span.new,\r\n        span.old {\r\n            color: $gray-500;\r\n            opacity: 0.6;\r\n        }\r\n\r\n        &.range, &.range.disabled, &.range.disabled:hover, &.range:hover{\r\n            background-color: $gray-300;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.table-condensed{\r\n  >thead>tr>th, >tbody>tr>td {\r\n    padding: 7px;\r\n  }\r\n}\r\n\r\n.bootstrap-datepicker-inline{\r\n  .datepicker-inline{\r\n    width: auto !important;\r\n    display: inline-block;\r\n  }\r\n}\r\n\r\n\r\n// DATEPICKER\r\n\r\n.datepicker-container{\r\n  border: 1px solid $border-color;\r\n  box-shadow: none;\r\n  background-color: $dropdown-bg;\r\n\r\n  &.datepicker-inline{\r\n    width: 212px;\r\n  }\r\n}\r\n\r\n.datepicker-panel{\r\n  \r\n  >ul{\r\n    >li{\r\n      background-color: $dropdown-bg;\r\n      border-radius: 4px;\r\n\r\n      &.picked, &.picked:hover{\r\n        background-color: rgba($primary, 0.25);\r\n        color: $primary;\r\n      }\r\n\r\n      &.highlighted, &.highlighted:hover, &:hover{\r\n        background-color: $primary;\r\n        color: $white;\r\n      }\r\n\r\n      \r\n      &.muted, &.muted:hover{\r\n        color: $gray-500;\r\n        opacity: 0.6;\r\n      }\r\n    }\r\n\r\n    \r\n\r\n    &[data-view=week]{\r\n      >li{\r\n        font-weight: $font-weight-medium;\r\n      }\r\n\r\n      >li, >li:hover{\r\n        background-color: $dropdown-bg;\r\n      }\r\n    }\r\n  }\r\n}\r\n","\r\n//\r\n// Bootstrap touchspin\r\n//\r\n\r\n\r\n.bootstrap-touchspin{\r\n    &.input-group{\r\n      &>.input-group-prepend{\r\n        &>.btn, &>.input-group-text{\r\n        border-top-right-radius: 0;\r\n        border-bottom-right-radius: 0;\r\n        }\r\n      }\r\n    }\r\n  \r\n    &.input-group{\r\n      &>.input-group-append{\r\n        &>.btn, &>.input-group-text{\r\n          border-top-left-radius: 0;\r\n          border-bottom-left-radius: 0;\r\n        }\r\n      }\r\n    }\r\n  }","//\r\n// Form repeater.scss\r\n//\r\n\r\n\r\n[type=\"tel\"],\r\n[type=\"url\"],\r\n[type=\"email\"],\r\n[type=\"number\"] {\r\n &::placeholder{\r\n   text-align: left /*rtl: right*/;\r\n }\r\n}","//\r\n// Form editors.scss\r\n//\r\n\r\n\r\n// Tinymce \r\n\r\n.tox-tinymce {\r\n  border: 1px solid $input-border-color !important;\r\n}\r\n\r\n.tox {\r\n  .tox-statusbar {\r\n    border-top: 1px solid $light !important;\r\n  }\r\n    .tox-menubar, .tox-edit-area__iframe, .tox-statusbar{\r\n      background-color: $card-bg !important;\r\n      background: none !important;\r\n    }\r\n    .tox-mbtn{\r\n      color: $gray-700 !important;\r\n        &:hover:not(:disabled):not(.tox-mbtn--active){\r\n            background-color: $light !important;\r\n        }\r\n    }\r\n    .tox-tbtn{\r\n        &:hover{\r\n            background-color: $light !important;\r\n        }\r\n    }\r\n\r\n    .tox-toolbar, .tox-toolbar__overflow, .tox-toolbar__primary{\r\n      background: $light !important;\r\n    }\r\n\r\n    .tox-toolbar__primary{\r\n      border-top-color: $light !important;\r\n    }\r\n\r\n    .tox-tbtn{\r\n      color: $gray-700 !important;\r\n      svg{\r\n        fill: $gray-700 !important;\r\n      }\r\n    }\r\n\r\n    .tox-edit-area__iframe{\r\n      background-color: $card-bg !important;\r\n    }\r\n  \r\n    .tox-statusbar a, .tox-statusbar__path-item, .tox-statusbar__wordcount{\r\n      color: $gray-700 !important;\r\n    }\r\n\r\n    &:not([dir=rtl]) .tox-toolbar__group:not(:last-of-type) {\r\n      border-right: 1px solid darken($light, 5%) !important;\r\n    } \r\n}\r\n\r\n\r\n\r\n// x editable\r\n\r\n.editable-input{\r\n  .form-control{\r\n    display: inline-block;\r\n  }\r\n}\r\n\r\n.editable-buttons{\r\n  margin-left: 7px;\r\n  .editable-cancel{\r\n    margin-left: 7px;\r\n  }\r\n}\r\n\r\n\r\n\r\n// ck-editor\r\n\r\n.ck-editor__editable {\r\n  min-height: 250px !important;\r\n}\r\n\r\n.ck{\r\n  &.ck-reset_all, &.ck-reset_all *{\r\n    color: $gray-700 !important;\r\n  }\r\n\r\n  &.ck-editor__main>.ck-editor__editable:not(.ck-focused){\r\n    border-color: $input-border-color !important;\r\n  }\r\n\r\n  &.ck-toolbar{\r\n    background-color: $light !important;\r\n    border-color: $input-border-color !important;\r\n\r\n    .ck.ck-toolbar__separator{\r\n      background-color: $input-border-color !important;\r\n    }\r\n  }\r\n\r\n  &.ck-tooltip .ck-tooltip__text{\r\n    background-color: $dark !important;\r\n    color: $light !important;\r\n  }\r\n\r\n  &.ck-editor__main>.ck-editor__editable, &.ck-list{\r\n    background-color: $card-bg !important;\r\n  }\r\n\r\n  &.ck-dropdown__panel{\r\n    border-color: $border-color !important;\r\n  }\r\n  \r\n}\r\n\r\n\r\n.ck.ck-button:not(.ck-disabled):hover, a.ck.ck-button:not(.ck-disabled):hover, .ck.ck-button.ck-on, a.ck.ck-button.ck-on{\r\n  background-color: darken($light, 2%) !important;\r\n}\r\n\r\n\r\n\r\n","// x editable\r\n\r\n\r\n.editable-input{\r\n  .form-control{\r\n    display: inline-block;\r\n  }\r\n}\r\n\r\n.editable-buttons{\r\n  margin-left: 7px;\r\n  .editable-cancel{\r\n    margin-left: 7px;\r\n  }\r\n}\r\n","\r\n//\r\n// Form-Upload\r\n//\r\n\r\n/* Dropzone */\r\n.dropzone {\r\n  min-height: 230px;\r\n  border: 2px dashed $gray-400;\r\n  background: $card-bg;\r\n  border-radius: 6px;\r\n\r\n  .dz-message {\r\n    font-size: 24px;\r\n    width: 100%;\r\n  }\r\n}","//\r\n// Form Wizard\r\n//\r\n\r\n.form-wizard-wrapper {\r\n  label {\r\n    font-size: 14px;\r\n    text-align: right;\r\n  }\r\n}\r\n\r\n.wizard{\r\n\r\n  // step\r\n  .steps{\r\n    >ul{\r\n      display: flex;\r\n      flex-wrap: wrap;\r\n      padding-left: 0;\r\n      margin-bottom: 0;\r\n      list-style: none;\r\n\r\n      @media (max-width: 1199.98px) {\r\n        flex-direction: column;\r\n      }\r\n\r\n      > a, > li{\r\n        flex-basis: 0;\r\n        flex-grow: 1;\r\n      }\r\n\r\n      >li{\r\n        width: 100%;\r\n\r\n        a{\r\n          display: block;\r\n          padding: .5rem 1rem;\r\n          color: $gray-700;\r\n          font-weight: $font-weight-medium;\r\n\r\n          background-color: rgba($primary, 0.1);\r\n        }\r\n      }\r\n\r\n      .current-info{\r\n        position: absolute;\r\n        left: -999em;\r\n    }\r\n\r\n    \r\n    }\r\n\r\n    .number {\r\n      display: inline-block;\r\n      width: 38px;\r\n      height: 38px;\r\n      line-height: 34px;\r\n      border: 2px solid $primary;\r\n      color: $primary;\r\n      text-align: center;\r\n      border-radius: 50%;\r\n      margin-right: .5rem;\r\n    }\r\n\r\n    .current {\r\n      a, a:active, a:hover {\r\n        background-color: rgba($primary, 0.2);\r\n        color: $gray-700;\r\n        .number {\r\n          background-color: $primary;\r\n          color: $white;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // content\r\n  >.content {\r\n    background-color: transparent;\r\n    padding: 14px;\r\n    margin-top: 0;\r\n    border-radius: 0;\r\n    min-height: 150px;\r\n    > .title{\r\n      position: absolute;\r\n      left: -999em;\r\n    }\r\n    >.body {\r\n      width: 100%;\r\n      height: 100%;\r\n      padding: 14px 0 0;\r\n      position: static\r\n    }\r\n  }\r\n\r\n  // actions\r\n\r\n  >.actions {\r\n    position: relative;\r\n    display: block;\r\n    text-align: right;\r\n    width: 100%;\r\n    > ul {\r\n        display: block;\r\n        text-align: right;\r\n        padding-left: 0;\r\n          > li{\r\n            display: inline-block;\r\n            margin: 0 0.5em;\r\n\r\n          }\r\n      }\r\n      a, a:active, a:hover {\r\n        background-color: $primary;\r\n        border-radius: 4px;\r\n        padding: 8px 15px;\r\n        color: $white;\r\n      }\r\n\r\n      .disabled {\r\n        a, a:active, a:hover {\r\n          opacity: .65;\r\n          background-color: $primary;\r\n          color: $white;\r\n          cursor: not-allowed;\r\n        }\r\n      }\r\n  }\r\n\r\n  // verticl wixard\r\n  &.vertical-wizard{\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n\r\n    // step\r\n    .steps{\r\n      >ul{\r\n        flex-direction: column;\r\n\r\n        >li{\r\n            width: 100% !important;\r\n        }\r\n        \r\n      }\r\n    }\r\n\r\n    .steps, .content, .actions{\r\n      width: 100%;\r\n    }\r\n\r\n    .steps{\r\n        @media (min-width: 1200px) {\r\n          width: 25%;\r\n      }\r\n    }\r\n\r\n      .content{\r\n        padding: 24px;\r\n        @media (min-width: 1200px) {\r\n          width: 75%;\r\n          padding: 12px 24px;\r\n      }\r\n\r\n      >.body{\r\n        padding: 0;\r\n      }\r\n      \r\n    }\r\n  }\r\n}\r\n","\r\n//\r\n// Responsive Table\r\n//\r\n\r\n.table-rep-plugin {\r\n  .btn-toolbar {\r\n    display: block;\r\n  }\r\n  .table-responsive {\r\n    border: none !important;\r\n  }\r\n  .btn-group{\r\n    .btn-default {\r\n      background-color: $light;\r\n      color: $dark;\r\n      border: 1px solid darken($light, 2%);\r\n      &.btn-primary {\r\n          background-color: $primary;\r\n          border-color: $primary;\r\n          color: $white;\r\n          box-shadow: 0 0 0 2px rgba($primary, .5);\r\n      }\r\n  }\r\n    &.pull-right {\r\n      float: right;\r\n      .dropdown-menu {\r\n        right: 0;\r\n        transform: none !important;\r\n        top: 100% !important;\r\n      }\r\n    }\r\n  }\r\n  tbody {\r\n    th {\r\n      font-size: 14px;\r\n      font-weight: normal;\r\n    }\r\n  }\r\n\r\n  .checkbox-row {\r\n    padding-left: 40px;\r\n    color: $dropdown-color !important;\r\n\r\n    &:hover{\r\n      background-color: lighten($gray-200, 2%) !important;\r\n    }\r\n\r\n    label {\r\n      display: inline-block;\r\n      padding-left: 5px;\r\n      position: relative;\r\n      &::before {\r\n        -o-transition: 0.3s ease-in-out;\r\n        -webkit-transition: 0.3s ease-in-out;\r\n        background-color: $white;\r\n        border-radius: 3px;\r\n        border: 1px solid $gray-300;\r\n        content: \"\";\r\n        display: inline-block;\r\n        height: 17px;\r\n        left: 0;\r\n        margin-left: -20px;\r\n        position: absolute;\r\n        transition: 0.3s ease-in-out;\r\n        width: 17px;\r\n        outline: none !important;\r\n      }\r\n      &::after {\r\n        color: $gray-200;\r\n        display: inline-block;\r\n        font-size: 11px;\r\n        height: 16px;\r\n        left: 0;\r\n        margin-left: -20px;\r\n        padding-left: 3px;\r\n        padding-top: 1px;\r\n        position: absolute;\r\n        top: -1px;\r\n        width: 16px;\r\n      }\r\n    }\r\n    input[type=\"checkbox\"] {\r\n      cursor: pointer;\r\n      opacity: 0;\r\n      z-index: 1;\r\n      outline: none !important;\r\n\r\n      &:disabled + label {\r\n        opacity: 0.65;\r\n      }\r\n    }\r\n    input[type=\"checkbox\"]:focus + label {\r\n      &::before {\r\n        outline-offset: -2px;\r\n        outline: none;\r\n      }\r\n    }\r\n    input[type=\"checkbox\"]:checked + label {\r\n      &::after {\r\n        content: \"\\f00c\";\r\n        font-family: 'Font Awesome 5 Free';\r\n        font-weight: 900;\r\n      }\r\n    }\r\n    input[type=\"checkbox\"]:disabled + label {\r\n      &::before {\r\n        background-color: $gray-100;\r\n        cursor: not-allowed;\r\n      }\r\n    }\r\n    input[type=\"checkbox\"]:checked + label {\r\n      &::before {\r\n        background-color: $primary;\r\n        border-color: $primary;\r\n      }\r\n      &::after {\r\n        color: $white;\r\n      }\r\n    }\r\n  }\r\n\r\n  .fixed-solution {\r\n    .sticky-table-header{\r\n      top: $header-height !important;\r\n      background-color: $primary;\r\n      table{\r\n        color: $white;\r\n      }\r\n    }\r\n  }\r\n\r\n  table.focus-on tbody tr.focused th,\r\n  table.focus-on tbody tr.focused td,\r\n  .sticky-table-header {\r\n      background: $primary;\r\n      border-color: $primary;\r\n      color: $white;\r\n\r\n      table {\r\n          color: $white;\r\n      }\r\n  }\r\n}\r\n\r\nbody[data-layout=\"horizontal\"] {\r\n  @media (min-width: 992px) {\r\n    .fixed-solution {\r\n      .sticky-table-header{\r\n        top: $header-height + 78px !important;;\r\n      }\r\n    }\r\n  }\r\n}","// datatable\r\n\r\n\r\n.table-bordered {\r\n  border: $table-border-width solid $table-border-color;\r\n}\r\n\r\n\r\ndiv.dataTables_wrapper {\r\n  div.dataTables_filter{\r\n    text-align: right;\r\n\r\n    @media (max-width: 767px){\r\n      text-align: center;\r\n    }\r\n\r\n\r\n    input{\r\n      margin-left: 0.5em;\r\n      margin-right: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.datatable{\r\n  td{\r\n    &:focus{\r\n      outline: none;\r\n    }\r\n  }\r\n}\r\n\r\ndiv.table-responsive>div.dataTables_wrapper>div.row>div[class^=\"col-\"]{\r\n  &:first-child{\r\n    padding-left: 0;\r\n  }\r\n\r\n  &:last-child{\r\n    padding-right: 0;\r\n  }\r\n}\r\n\r\n\r\n.table.dataTable {\r\n  thead {\r\n\r\n    .sorting, .sorting_asc, .sorting_desc, .sorting_asc_disabled, .sorting_desc_disabled{\r\n      &:before{\r\n        left: auto;\r\n        right: 1em;\r\n      }\r\n    }\r\n\r\n    .sorting, .sorting_asc, .sorting_desc, .sorting_asc_disabled, .sorting_desc_disabled{\r\n      &:after{\r\n        left: auto;\r\n        right: 0.5em;\r\n      }\r\n    }\r\n\r\n    tr{\r\n      th, td{\r\n        &.sorting_asc, &.sorting_desc, &.sorting{\r\n          padding-left: 12px;\r\n          padding-right: 30px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.table, table{\r\n  &.dataTable{\r\n    &.dtr-inline.collapsed>tbody>tr>td{\r\n      position: relative;\r\n      &.dtr-control{\r\n        padding-left: 30px;\r\n        &:before{\r\n          top: 50%;\r\n          left: 5px;\r\n          height: 14px;\r\n          width: 14px;\r\n          margin-top: -9px;\r\n          display: block;\r\n          position: absolute;\r\n          color: $white;\r\n          border: 2px solid $white;\r\n          border-radius: 14px;\r\n          box-sizing: content-box;\r\n          text-align: center;\r\n          text-indent: 0 !important;\r\n          line-height: 14px;\r\n          content: '+';\r\n          background-color: $primary;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n","\r\n//\r\n// Table editable\r\n//\r\n\r\n.table-edits{\r\n  input, select{\r\n    height: $input-height-sm;\r\n    padding: $input-padding-y-sm $input-padding-x-sm;\r\n    border: 1px solid $input-border-color;\r\n    color: $input-color;\r\n    border-radius: $input-border-radius;\r\n    background-color: $input-bg;\r\n    &:focus{\r\n      outline: none;\r\n      border-color: $input-focus-border-color;\r\n    }\r\n  }\r\n}","\r\n//\r\n// apexcharts.scss\r\n//\r\n.apex-charts {\r\n    min-height: 10px !important;\r\n    text {\r\n        font-family: $font-family-base !important;\r\n        fill: $gray-500;\r\n        font-weight: 400;\r\n    }\r\n    .apexcharts-canvas {\r\n        margin: 0 auto;\r\n    }\r\n}\r\n\r\n.apexcharts-tooltip-title,\r\n.apexcharts-tooltip-text {\r\n    font-family: $font-family-base !important;\r\n}\r\n\r\n.apexcharts-legend-series {\r\n    font-weight: $font-weight-medium;\r\n}\r\n\r\n.apexcharts-gridline {\r\n    pointer-events: none;\r\n    stroke: $apex-grid-color;\r\n}\r\n\r\n.apexcharts-legend-text {\r\n    color: $gray-600 !important;\r\n    font-family: $font-family-base !important;\r\n    font-size: 13px !important;\r\n    font-weight: $font-weight-medium !important;\r\n}\r\n\r\n.apexcharts-pie-label {\r\n    fill: $white !important;\r\n}\r\n\r\n.apexcharts-yaxis,\r\n.apexcharts-xaxis {\r\n    text {\r\n        font-family: $font-family-base !important;\r\n        fill: $gray-500;\r\n    }\r\n}","\r\n\r\n/* Flot chart */\r\n.flot-charts-height {\r\n  height: 320px;\r\n}\r\n\r\n.flotTip {\r\n  padding: 8px 12px;\r\n  background-color: rgba($dark, 0.9);\r\n  z-index: 100;\r\n  color: $gray-100;\r\n  box-shadow: $box-shadow;\r\n  border-radius: 4px;\r\n}\r\n\r\n.legendLabel{\r\n  color: $gray-500;\r\n  padding-right: 5px;\r\n  padding-left: 10px;\r\n}\r\n","//\r\n// sparkline.scss\r\n//\r\n\r\n.jqstooltip {\r\n  box-sizing: content-box;\r\n  width: auto !important;\r\n  height: auto !important;\r\n  background-color: $gray-800 !important;\r\n  box-shadow: $box-shadow-lg;\r\n  padding: 5px 10px !important;\r\n  border-radius: 3px;\r\n  border-color: $gray-900 !important;\r\n}\r\n\r\n.jqsfield {\r\n  color: $gray-200 !important;\r\n  font-size: 12px !important;\r\n  line-height: 18px !important;\r\n  font-family: $font-family-base !important;\r\n  font-weight: $font-weight-medium !important;\r\n}\r\n","\r\n//\r\n// Google map\r\n//\r\n\r\n.gmaps, .gmaps-panaroma {\r\n  height: 300px;\r\n  background: $gray-100;\r\n  border-radius: 3px;\r\n}\r\n\r\n.gmaps-overlay {\r\n  display: block;\r\n  text-align: center;\r\n  color: $white;\r\n  font-size: 16px;\r\n  line-height: 40px;\r\n  background: $primary;\r\n  border-radius: 4px;\r\n  padding: 10px 20px;\r\n}\r\n\r\n.gmaps-overlay_arrow {\r\n  left: 50%;\r\n  margin-left: -16px;\r\n  width: 0;\r\n  height: 0;\r\n  position: absolute;\r\n  &.above {\r\n    bottom: -15px;\r\n    border-left: 16px solid transparent;\r\n    border-right: 16px solid transparent;\r\n    border-top: 16px solid $primary;\r\n  }\r\n  &.below {\r\n    top: -15px;\r\n    border-left: 16px solid transparent;\r\n    border-right: 16px solid transparent;\r\n    border-bottom: 16px solid $primary;\r\n  }\r\n  \r\n}","//\r\n// vector-maps.scss\r\n//\r\n\r\n.jvectormap-label {\r\n    border: none;\r\n    background: $gray-800;\r\n    color: $gray-100;\r\n    font-family: $font-family-base;\r\n    font-size: $font-size-base;\r\n    padding: 5px 8px;\r\n}","//\r\n// leaflet-maps.scss\r\n//\r\n\r\n.leaflet-map {\r\n    height: 300px;\r\n    &.leaflet-container{\r\n        z-index: 99;\r\n    }\r\n}","// \r\n// authentication.scss\r\n//\r\n\r\n\r\n// authentication\r\n\r\n.authentication-bg{\r\n    background-color: #d3d3d387;\r\n    // background-image: url('../../../../assets/images/Background.jpg');\r\n    background-size: cover;\r\n    .auth-logo{\r\n        .logo{\r\n            margin: 0px auto;\r\n        }\r\n    }\r\n\r\n}\r\n\r\n\r\n// signin card title\r\n\r\n.signin-other-title{\r\n    position: relative;\r\n    &:after{\r\n        content: \"\";\r\n        position: absolute;\r\n        width: 100%;\r\n        height: 1px;\r\n        left: 0;\r\n        right: 0;\r\n        background-color: $border-color;\r\n        top: 10px;\r\n    }\r\n\r\n    .title{\r\n        display: inline-block;\r\n        position: relative;\r\n        z-index: 9;\r\n        background-color: $card-bg;\r\n        padding: 2px 16px;\r\n    }\r\n}\r\n\r\n\r\n// auth carousel\r\n\r\n.auth-carousel{\r\n    &.owl-theme {\r\n        .owl-dots {\r\n            .owl-dot {\r\n                span{\r\n                    background-color: $card-bg;\r\n                }\r\n                &.active{\r\n                    span{\r\n                        background-color: $primary;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}","// \r\n// ecommerce.scss\r\n//\r\n\r\n// product\r\n\r\n.search-box{\r\n    .form-control{\r\n        border-radius: 30px;\r\n        padding-left: 40px;\r\n    }\r\n    .search-icon{\r\n        font-size: 16px;    \r\n        position: absolute;\r\n        left: 13px;\r\n        top: 0;\r\n        line-height: 38px;\r\n    }\r\n}\r\n\r\n\r\n.categories-list{\r\n    padding: 4px 0;\r\n    li{\r\n        a{\r\n            display: block;\r\n            padding: 4px 12px;\r\n            color: $body-color;\r\n        }\r\n\r\n        &.active{\r\n            a{\r\n                color: $primary;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// product box\r\n\r\n.product-box{\r\n    border: 1px solid $border-color;\r\n    transition: all 0.4s;\r\n    overflow: hidden;\r\n    margin-top: 20px;\r\n    cursor: pointer;\r\n    \r\n    &:hover{\r\n        box-shadow: $box-shadow;\r\n\r\n        .product-content{\r\n            transform: translateY(-30px);\r\n        }\r\n\r\n        .product-color{\r\n            visibility: visible;\r\n        }\r\n    }\r\n}\r\n\r\n.product-img{\r\n    position: relative;\r\n    \r\n    .product-ribbon{\r\n        position: absolute;\r\n        top: 20px;\r\n        left: 20px;\r\n        padding: 6px 8px;\r\n    }\r\n}\r\n\r\n.product-wishlist{\r\n    position: absolute;\r\n    top: 20px;\r\n    right: 20px;\r\n    z-index: 9;\r\n    a{\r\n        display: inline-block;\r\n        width: 40px;\r\n        height: 40px;\r\n        border: 2px solid $gray-300;\r\n        line-height: 38px;\r\n        border-radius: 50%;\r\n        text-align: center;\r\n        color: $gray-500;\r\n    }\r\n}\r\n\r\n.product-content{\r\n    position: relative;\r\n    transition: all 0.2s;\r\n}\r\n\r\n.product-color{\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    margin: 16px auto 0;\r\n    visibility: hidden;\r\n}\r\n\r\n\r\n// product-detail\r\n\r\n.product-detail{\r\n\r\n    .nav-pills{\r\n        .nav-link{\r\n            margin-bottom: 7px;\r\n            &.active{\r\n                background-color: $gray-300;\r\n            }\r\n\r\n            .tab-img{\r\n                width: 5rem;\r\n            }\r\n\r\n        }\r\n    }\r\n\r\n    .product-img{\r\n        padding: 24px;\r\n    }\r\n}\r\n\r\n.product-desc-list{\r\n    li{\r\n        padding: 2px 0px;\r\n    }\r\n}\r\n\r\n.product-desc-color{\r\n    a{\r\n        display: inline-block;\r\n        text-align: center;\r\n        color: $body-color;\r\n        margin: 4px;\r\n        border: 2px solid $border-color;\r\n        border-radius: 4px;\r\n\r\n        &.active, &:hover{\r\n            color: $primary;\r\n            border-color: $primary !important;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n.product-review-link{\r\n    .list-inline-item{\r\n        a{\r\n            color: $gray-600;\r\n            padding: 4px 8px;\r\n            font-size: 15px;\r\n        }\r\n\r\n    }           \r\n}\r\n\r\n// ecommerce cart\r\n\r\n.product-cart-touchspin{\r\n    border: 1px solid $input-border-color;\r\n    background-color: $input-bg;\r\n    border-radius: $border-radius;\r\n    .form-control{\r\n        border-color: transparent;\r\n        height: 32px\r\n    }\r\n    \r\n    .input-group-btn .btn{\r\n        background-color: transparent !important;\r\n        border-color: transparent !important;\r\n        color: $primary !important;\r\n        font-size: 16px;\r\n        padding: 3px 12px;\r\n        box-shadow: none;\r\n    }\r\n\r\n}\r\n\r\n\r\n// ecommerce checkout\r\n\r\n.shipping-address{\r\n    box-shadow: none;\r\n    &.active{\r\n        border-color: $primary !important;\r\n    }\r\n}","/* ==============\r\n  Email\r\n===================*/\r\n.email-leftbar {\r\n  width: 236px;\r\n  float: left;\r\n  padding: 20px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.email-rightbar {\r\n  margin-left: 260px;\r\n}\r\n\r\n.chat-user-box {\r\n  p.user-title {\r\n    color: $dark;\r\n    font-weight: 500;\r\n  }\r\n  p {\r\n    font-size: 13px;\r\n  }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .email-leftbar {\r\n    float: none;\r\n    width: 100%;\r\n  }\r\n  .email-rightbar {\r\n    margin: 0;\r\n  }\r\n}\r\n\r\n\r\n.mail-list {\r\n  a {\r\n    display: block;\r\n    color: $gray-600;\r\n    line-height: 24px;\r\n    padding: 8px 5px;\r\n    &.active {\r\n      color: $danger;\r\n      font-weight: 500;\r\n    }\r\n  }\r\n}\r\n\r\n.message-list {\r\n  display: block;\r\n  padding-left: 0;\r\n\r\n  li {\r\n    position: relative;\r\n    display: block;\r\n    height: 50px;\r\n    line-height: 50px;\r\n    cursor: default;\r\n    transition-duration: .3s;\r\n\r\n    a{\r\n      color: $gray-600;\r\n    }\r\n\r\n    &:hover {\r\n      background: $gray-300;\r\n      transition-duration: .05s;\r\n    }\r\n\r\n    .col-mail {\r\n      float: left;\r\n      position: relative;\r\n    }\r\n\r\n    .col-mail-1 {\r\n      width: 320px;\r\n\r\n      .star-toggle,\r\n      .checkbox-wrapper-mail,\r\n      .dot {\r\n        display: block;\r\n        float: left;\r\n      }\r\n\r\n      .dot {\r\n        border: 4px solid transparent;\r\n        border-radius: 100px;\r\n        margin: 22px 26px 0;\r\n        height: 0;\r\n        width: 0;\r\n        line-height: 0;\r\n        font-size: 0;\r\n      }\r\n\r\n      .checkbox-wrapper-mail {\r\n        margin: 15px 10px 0 20px;\r\n      }\r\n\r\n      .star-toggle {\r\n        margin-top: 18px;\r\n        margin-left: 5px;\r\n      }\r\n\r\n      .title {\r\n        position: absolute;\r\n        top: 0;\r\n        left: 110px;\r\n        right: 0;\r\n        text-overflow: ellipsis;\r\n        overflow: hidden;\r\n        white-space: nowrap;\r\n        margin-bottom: 0;\r\n      }\r\n    }\r\n\r\n    .col-mail-2 {\r\n      position: absolute;\r\n      top: 0;\r\n      left: 320px;\r\n      right: 0;\r\n      bottom: 0;\r\n\r\n      .subject,\r\n      .date {\r\n        position: absolute;\r\n        top: 0;\r\n      }\r\n\r\n      .subject {\r\n        left: 0;\r\n        right: 200px;\r\n        text-overflow: ellipsis;\r\n        overflow: hidden;\r\n        white-space: nowrap;\r\n      }\r\n\r\n      .date {\r\n        right: 0;\r\n        width: 170px;\r\n        padding-left: 80px;\r\n      }\r\n    }\r\n\r\n    &.active,\r\n    &.active:hover {\r\n      box-shadow: inset 3px 0 0 $primary;\r\n    }\r\n\r\n    \r\n  &.unread  {\r\n    background-color: $gray-300;\r\n    font-weight: 500;\r\n    color: darken($dark,5%);\r\n      a{\r\n        color: darken($dark,5%);\r\n        font-weight: 500;\r\n      }\r\n    }\r\n  }\r\n\r\n\r\n  .checkbox-wrapper-mail {\r\n    cursor: pointer;\r\n    height: 20px;\r\n    width: 20px;\r\n    position: relative;\r\n    display: inline-block;\r\n    box-shadow: inset 0 0 0 1px $gray-400;\r\n    border-radius: 1px;\r\n\r\n    input {\r\n      opacity: 0;\r\n      cursor: pointer;\r\n    }\r\n    input:checked ~ label {\r\n      opacity: 1;\r\n    }\r\n\r\n    label {\r\n      position: absolute;\r\n      height: 20px;\r\n      width: 20px;\r\n      left: 0;\r\n      cursor: pointer;\r\n      opacity: 0;\r\n      margin-bottom: 0;\r\n      transition-duration: .05s;\r\n      top: 0;\r\n      &:before {\r\n        content: \"\\F012C\";\r\n        font-family: \"Material Design Icons\";\r\n        top: 0;\r\n        height: 20px;\r\n        color: darken($dark,5%);\r\n        width: 20px;\r\n        position: absolute;\r\n        margin-top: -16px;\r\n        left: 4px;\r\n        font-size: 13px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 575.98px) { \r\n  .message-list li .col-mail-1 {\r\n      width: 200px;\r\n  }\r\n}","// \r\n// Chat.scss\r\n//\r\n\r\n.chat-leftsidebar{\r\n  @media (min-width: 1200px) {\r\n    min-width: 380px;\r\n  }\r\n\r\n  @media (min-width: 992px) and (max-width: 1199.98px) {\r\n    min-width: 280px;\r\n  }\r\n}\r\n\r\n.chat-noti-dropdown{\r\n  &.active{\r\n    &:before{\r\n      content: \"\";\r\n      position: absolute;\r\n      width: 8px;\r\n      height: 8px;\r\n      background-color: $danger;\r\n      border-radius: 50%;\r\n      right: 0;\r\n    }\r\n  }\r\n\r\n  .btn{\r\n    padding: 6px;\r\n    box-shadow: none;\r\n    font-size: 20px;\r\n  }\r\n}\r\n\r\n.chat-search-box{\r\n  .form-control{\r\n    border: 0;\r\n  }\r\n}\r\n\r\n.chat-list{\r\n  margin: 0;\r\n  li{\r\n\r\n    &.active{\r\n        a{\r\n          background-color: rgba($primary, 0.075);\r\n          border-color: transparent;\r\n        }\r\n    }\r\n    \r\n    a{\r\n      position: relative;\r\n      display: block;\r\n      color: $text-muted;\r\n      transition: all 0.4s;\r\n      padding: 12px;\r\n      border-top: 1px solid $border-color;\r\n      border-radius: 4px;\r\n      overflow: hidden;\r\n      text-overflow: ellipsis;\r\n      white-space: nowrap;\r\n      font-size: 14px;\r\n      font-weight: 500;\r\n\r\n      &:hover{\r\n        background-color: rgba($primary, 0.075);\r\n        border-color: transparent;\r\n      }\r\n    }\r\n\r\n\r\n    .user-img{\r\n      position: relative;\r\n\r\n      .user-status{\r\n        width: 10px;\r\n        height: 10px;\r\n        background-color: $gray-500;\r\n        border-radius: 50%;\r\n        border: 2px solid $card-bg;\r\n        position: absolute;\r\n        right: 0;\r\n        bottom: 0;\r\n\r\n        \r\n      }\r\n\r\n      &.online{\r\n        .user-status{\r\n          background-color: $success;\r\n        }\r\n      }\r\n\r\n      &.away{\r\n        .user-status{\r\n          background-color: $warning;\r\n        }\r\n      }\r\n    }\r\n\r\n    &.unread{\r\n      a{\r\n        font-weight: $font-weight-semibold;\r\n        color: $dark;\r\n      }\r\n    }\r\n\r\n    .unread-message {\r\n      position: absolute;\r\n      display: inline-block;\r\n      right: 16px;\r\n      top: 33px;\r\n    }\r\n    \r\n  \r\n  }\r\n}\r\n\r\n.group-list{\r\n  li{\r\n    a{\r\n      border: 0;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n.user-chat-nav{\r\n  .dropdown{\r\n    .nav-btn{\r\n      height: 36px;\r\n      width: 36px;\r\n      line-height: 36px;\r\n      box-shadow: none;\r\n      padding: 0;\r\n      font-size: 16px;\r\n      border-radius: 50%;\r\n    }\r\n\r\n    .dropdown-menu{\r\n      box-shadow: $box-shadow;\r\n      border: 1px solid $border-color\r\n    }\r\n  }\r\n}\r\n\r\n\r\n.chat-conversation{\r\n   li{\r\n    clear: both;\r\n    \r\n  }\r\n\r\n  .chat-day-title{\r\n    position: relative;\r\n    text-align: center;\r\n    margin-bottom: 24px;\r\n    border: none;\r\n\r\n    .title{\r\n      display: inline-block;\r\n      background-color: $light;\r\n      position: relative;\r\n      z-index: 1;\r\n      padding: 4px 16px;\r\n      border-radius: 30px;\r\n    }\r\n\r\n    &:before{\r\n      content: \"\";\r\n      position: absolute;\r\n      width: 100%;\r\n      height: 1px;\r\n      left: 0;\r\n      right: 0;\r\n      background-color: $border-color;\r\n      top: 16px;\r\n    }\r\n    .badge{\r\n      font-size: 12px;\r\n    }\r\n  }\r\n \r\n\r\n  .conversation-list{\r\n    margin-bottom: 24px;\r\n    position: relative;\r\n\r\n    .ctext-wrap {\r\n      display: flex;\r\n      margin-bottom: 10px;\r\n    }\r\n\r\n    .ctext-wrap-content {\r\n      padding: 12px 20px;\r\n      background-color: rgba($primary,0.1);\r\n      border-radius: 0px 8px 8px 8px;\r\n      color: $text-muted;\r\n      position: relative;\r\n      margin-left: 16px;\r\n\r\n      &:before {\r\n          content: \"\";\r\n          position: absolute;\r\n          border: 5px solid transparent;\r\n          border-right-color: rgba($primary,0.1);\r\n          border-top-color: rgba($primary,0.1);\r\n          left: -10px;\r\n          top: 0;\r\n      }\r\n    }\r\n\r\n  .conversation-name {\r\n    margin-bottom: 4px;\r\n  }\r\n\r\n  .dropdown {\r\n      .dropdown-toggle {\r\n          font-size: 18px;\r\n          padding: 4px;\r\n          color: $gray-600;\r\n\r\n          @media (max-width: 575.98px) {\r\n              display: none;\r\n          }\r\n      }\r\n\r\n  }\r\n\r\n  .chat-time {\r\n      font-size: 12px;\r\n      margin-top: 4px;\r\n      text-align: right;\r\n      color: rgba($white, 0.5);\r\n  }\r\n\r\n\r\n  .message-img {\r\n    border-radius: .2rem;\r\n    position: relative;\r\n\r\n      .message-img-list {\r\n          position: relative;\r\n      }\r\n\r\n      img {\r\n          max-width: 140px;\r\n      }\r\n    }\r\n  }\r\n\r\n  .right {\r\n\r\n    .conversation-list {\r\n        float: right;\r\n        text-align: right;\r\n\r\n        .ctext-wrap {\r\n\r\n            .ctext-wrap-content {\r\n                order: 2;\r\n                background-color: $light;\r\n                text-align: right;\r\n                border-radius: 8px 0px 8px 8px;\r\n                margin-left: 0;\r\n                margin-right: 16px;\r\n\r\n                &:before {\r\n                    border: 5px solid transparent;\r\n                    border-top-color: $light;\r\n                    border-left-color: $light;\r\n                    left: auto;\r\n                    right: -10px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .dropdown {\r\n            order: 1;\r\n        }\r\n      }\r\n  }\r\n}\r\n\r\n.chat-input-section{\r\n  border-top: 1px solid $border-color;\r\n}\r\n\r\n.chat-input{\r\n  border-radius: 30px;\r\n  background-color: $light !important;\r\n  border-color:  $light !important;\r\n}\r\n\r\n\r\n.chat-send{\r\n  @media (max-width: 575.98px) {\r\n    min-width: auto;\r\n  }\r\n}","// \r\n// coming-soon.scss\r\n//\r\n\r\n.counter-number {\r\n    font-size: 32px;\r\n    font-weight: $font-weight-semibold;\r\n    text-align: center;\r\n    display: flex;\r\n    span {\r\n        font-size: 16px;\r\n        font-weight: $font-weight-normal;\r\n        display: block;\r\n        padding-top: 5px;\r\n    }\r\n}\r\n\r\n.coming-box {\r\n    width: 25%;\r\n}\r\n","// \r\n// timeline.scss\r\n//\r\n\r\n/************** Horizontal timeline **************/ \r\n\r\n\r\n.hori-timeline{\r\n    .events{\r\n\r\n        .event-list{\r\n            text-align: center;\r\n            display: block;\r\n\r\n            &::after {\r\n                content: \"\\e858\";\r\n                font-family: \"unicons-line\";\r\n                display: block;\r\n                position: absolute;\r\n                top: 34px;\r\n                left: 0;\r\n                right: 0;\r\n                margin: 0px auto;\r\n                color: $gray-400;\r\n                font-size: 24px;\r\n            }\r\n\r\n            &:before{\r\n                content: \"\";\r\n                display: block;\r\n                position: absolute;\r\n                top: 14px;\r\n                left: 0;\r\n                right: 0;\r\n                width: 100%;\r\n                height: 2px;\r\n                border-radius: 50%;\r\n                background-color: $gray-300;\r\n            }\r\n\r\n            .event-date{\r\n                display: inline-block;\r\n                position: relative;\r\n                border-radius: 4px;\r\n                background-color: rgba($primary, 0.2);\r\n                padding: 2px 12px;\r\n                margin-bottom: 48px;\r\n            }\r\n\r\n        }\r\n    }\r\n}\r\n\r\n\r\n/************** vertical timeline **************/ \r\n\r\n.verti-timeline{\r\n    padding-left: 100px;\r\n    .event-list{\r\n        border-left: 3px dashed $gray-300;\r\n        position: relative;\r\n        padding: 0px 0px 30px 30px;\r\n\r\n        &:after {\r\n            content: \"\";\r\n            display: block;\r\n            position: absolute;\r\n            top: 6px;\r\n            left: -6px;\r\n            width: 10px;\r\n            height: 10px;\r\n            border-radius: 50%;\r\n            border: 2px solid $primary;\r\n            background-color: $card-bg;\r\n        }\r\n\r\n\r\n        .event-date{\r\n            display: inline-block;\r\n            border-radius: 4px;\r\n            background-color: rgba($primary, 0.2);\r\n            color: $primary;\r\n            padding: 2px 12px;\r\n            position: absolute;\r\n            left: -102px;\r\n        }\r\n\r\n        &:last-child{\r\n            padding-bottom: 0;\r\n        }\r\n    }\r\n}","// \r\n// Extras pages.scss\r\n//\r\n\r\n// Faqs\r\n\r\n.faq-nav-tabs{\r\n    .nav-link{\r\n        margin-bottom: 8px;\r\n        background-color: $light;\r\n        padding: 8px 16px;\r\n        .nav-icon{\r\n            font-size: 24px;\r\n            vertical-align: middle;\r\n        }\r\n    }\r\n    \r\n}\r\n\r\n\r\n// pricing\r\n\r\n.pricing-box{\r\n    max-width: 388px;\r\n    margin: 0px auto 20px;\r\n\r\n    .plan-features{\r\n        li{\r\n            padding: 7px 0px;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
